import { jsx, jsxs, Fragment as Fragment$1 } from 'react/jsx-runtime';
import * as React from 'react';
import React__default, { memo, useEffect, useRef, useState, useCallback as useCallback$1, useLayoutEffect as useLayoutEffect$1, useMemo as useMemo$1, useContext, useReducer, isValidElement, createRef, cloneElement, PureComponent, forwardRef, createElement, createContext, Fragment, createFactory, Component, useDebugValue, Children } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Button, ButtonGroup, Card, CardActions, CardContent, Checkbox, Chip as Chip$2, CircularProgress, ClickAwayListener, Collapse as Collapse$1, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl, FormControlLabel, FormHelperText, Grid as Grid$1, IconButton as IconButton$1, ImageList, ImageListItem, Input, InputAdornment, InputLabel, LinearProgress, List, ListItem, Menu as Menu$1, MenuItem, MenuList, Modal, OutlinedInput, Paper as Paper$1, Popover, Popper, Radio, RadioGroup, Select, Slide, Slider, Snackbar as Snackbar$1, Step as Step$1, StepButton, StepLabel, Stepper, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tabs as Tabs$1, TextField, ThemeProvider as ThemeProvider$1, Tooltip as Tooltip$1, useMediaQuery } from '@material-ui/core';
import * as n from '@material-ui/core/styles';
import { withStyles, darken, lighten, alpha, useTheme as useTheme$2, createTheme, createStyles, makeStyles as makeStyles$1, fade, styled } from '@material-ui/core/styles';
import { createSvgIcon, capitalize, unstable_useId, useControlled, useEventCallback, setRef, useIsFocusVisible, useForkRef, ownerWindow, ownerDocument, debounce as debounce$2 } from '@material-ui/core/utils';
import v from '@material-ui/core/InputBase';
import C$1 from '@material-ui/core/TextField';
import w from '@material-ui/core/Checkbox';
import O from '@material-ui/core/Select';
import y$1 from '@material-ui/core/MenuItem';
import E$1 from '@material-ui/core/Badge';
import IconButton from '@material-ui/core/IconButton';
import M from '@material-ui/core/Tooltip';
import x$1 from '@material-ui/core/ClickAwayListener';
import k from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import R from '@material-ui/core/Popper';
import I from '@material-ui/core/NoSsr';
import P from '@material-ui/core/MenuList';
import L from '@material-ui/core/Switch';
import F from '@material-ui/core/Button';
import j from '@material-ui/core/FormControlLabel';
import z from '@material-ui/core/Unstable_TrapFocus';
import T from '@material-ui/core/FormControl';
import H from '@material-ui/core/InputLabel';
import A$1 from '@material-ui/core/ListItemIcon';
import _$1 from '@material-ui/core/CircularProgress';
import G from '@material-ui/core/TablePagination';
import { enUS, bgBG, csCZ, deDE, esES, frFR, itIT, jaJP, nlNL, plPL, ptBR, ruRU, skSK, trTR, ukUA } from '@material-ui/core/locale';
import ReactDOM, { unstable_batchedUpdates, findDOMNode } from 'react-dom';
import ListSubheader from '@material-ui/core/ListSubheader';
import Chip$1 from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid$2 from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';
import InputAdornment$1 from '@material-ui/core/InputAdornment';
import Fade from '@material-ui/core/Fade';
import useMediaQuery$1 from '@material-ui/core/useMediaQuery';
import DialogActions$1 from '@material-ui/core/DialogActions';
import DialogContent$1 from '@material-ui/core/DialogContent';
import Dialog$1 from '@material-ui/core/Dialog';
import Popover$1 from '@material-ui/core/Popover';

function _defineProperty$f(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$h(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$c(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$h(Object(source), true).forEach(function (key) {
        _defineProperty$f(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$h(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray$9(arr, i) {
  return _arrayWithHoles$9(arr) || _iterableToArrayLimit$9(arr, i) || _unsupportedIterableToArray$9(arr, i) || _nonIterableRest$9();
}

function _arrayWithHoles$9(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$9(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$9(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$9(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$9(o, minLen);
}

function _arrayLikeToArray$9(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest$9() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _defineProperty$e(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$g(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$g(Object(source), true).forEach(function (key) {
        _defineProperty$e(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$g(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function compose$3() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduceRight(function (y, f) {
      return f(y);
    }, x);
  };
}

function curry$1(fn) {
  return function curried() {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return args.length >= fn.length ? fn.apply(this, args) : function () {
      for (var _len3 = arguments.length, nextArgs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        nextArgs[_key3] = arguments[_key3];
      }

      return curried.apply(_this, [].concat(args, nextArgs));
    };
  };
}

function isObject$j(value) {
  return {}.toString.call(value).includes('Object');
}

function isEmpty(obj) {
  return !Object.keys(obj).length;
}

function isFunction$9(value) {
  return typeof value === 'function';
}

function hasOwnProperty$q(object, property) {
  return Object.prototype.hasOwnProperty.call(object, property);
}

function validateChanges(initial, changes) {
  if (!isObject$j(changes)) errorHandler$1('changeType');
  if (Object.keys(changes).some(function (field) {
    return !hasOwnProperty$q(initial, field);
  })) errorHandler$1('changeField');
  return changes;
}

function validateSelector(selector) {
  if (!isFunction$9(selector)) errorHandler$1('selectorType');
}

function validateHandler(handler) {
  if (!(isFunction$9(handler) || isObject$j(handler))) errorHandler$1('handlerType');
  if (isObject$j(handler) && Object.values(handler).some(function (_handler) {
    return !isFunction$9(_handler);
  })) errorHandler$1('handlersType');
}

function validateInitial(initial) {
  if (!initial) errorHandler$1('initialIsRequired');
  if (!isObject$j(initial)) errorHandler$1('initialType');
  if (isEmpty(initial)) errorHandler$1('initialContent');
}

function throwError$1(errorMessages, type) {
  throw new Error(errorMessages[type] || errorMessages["default"]);
}

var errorMessages$1 = {
  initialIsRequired: 'initial state is required',
  initialType: 'initial state should be an object',
  initialContent: 'initial state shouldn\'t be an empty object',
  handlerType: 'handler should be an object or a function',
  handlersType: 'all handlers should be a functions',
  selectorType: 'selector should be a function',
  changeType: 'provided value of changes should be an object',
  changeField: 'it seams you want to change a field in the state which is not specified in the "initial" state',
  "default": 'an unknown error accured in `state-local` package'
};
var errorHandler$1 = curry$1(throwError$1)(errorMessages$1);
var validators$1 = {
  changes: validateChanges,
  selector: validateSelector,
  handler: validateHandler,
  initial: validateInitial
};

function create$2(initial) {
  var handler = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  validators$1.initial(initial);
  validators$1.handler(handler);
  var state = {
    current: initial
  };
  var didUpdate = curry$1(didStateUpdate)(state, handler);
  var update = curry$1(updateState)(state);
  var validate = curry$1(validators$1.changes)(initial);
  var getChanges = curry$1(extractChanges)(state);

  function getState() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (state) {
      return state;
    };
    validators$1.selector(selector);
    return selector(state.current);
  }

  function setState(causedChanges) {
    compose$3(didUpdate, update, validate, getChanges)(causedChanges);
  }

  return [getState, setState];
}

function extractChanges(state, causedChanges) {
  return isFunction$9(causedChanges) ? causedChanges(state.current) : causedChanges;
}

function updateState(state, changes) {
  state.current = _objectSpread2$b(_objectSpread2$b({}, state.current), changes);
  return changes;
}

function didStateUpdate(state, handler, changes) {
  isFunction$9(handler) ? handler(state.current) : Object.keys(changes).forEach(function (field) {
    var _handler$field;

    return (_handler$field = handler[field]) === null || _handler$field === void 0 ? void 0 : _handler$field.call(handler, state.current[field]);
  });
  return changes;
}

var index$3 = {
  create: create$2
};

var config$4 = {
  paths: {
    vs: 'https://cdn.jsdelivr.net/npm/monaco-editor@0.28.1/min/vs'
  }
};

function curry(fn) {
  return function curried() {
    var _this = this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return args.length >= fn.length ? fn.apply(this, args) : function () {
      for (var _len2 = arguments.length, nextArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nextArgs[_key2] = arguments[_key2];
      }

      return curried.apply(_this, [].concat(args, nextArgs));
    };
  };
}

function isObject$i(value) {
  return {}.toString.call(value).includes('Object');
}

/**
 * validates the configuration object and informs about deprecation
 * @param {Object} config - the configuration object 
 * @return {Object} config - the validated configuration object
 */

function validateConfig(config) {
  if (!config) errorHandler('configIsRequired');
  if (!isObject$i(config)) errorHandler('configType');

  if (config.urls) {
    informAboutDeprecation();
    return {
      paths: {
        vs: config.urls.monacoBase
      }
    };
  }

  return config;
}
/**
 * logs deprecation message
 */


function informAboutDeprecation() {
  console.warn(errorMessages.deprecation);
}

function throwError(errorMessages, type) {
  throw new Error(errorMessages[type] || errorMessages["default"]);
}

var errorMessages = {
  configIsRequired: 'the configuration object is required',
  configType: 'the configuration object should be an object',
  "default": 'an unknown error accured in `@monaco-editor/loader` package',
  deprecation: "Deprecation warning!\n    You are using deprecated way of configuration.\n\n    Instead of using\n      monaco.config({ urls: { monacoBase: '...' } })\n    use\n      monaco.config({ paths: { vs: '...' } })\n\n    For more please check the link https://github.com/suren-atoyan/monaco-loader#config\n  "
};
var errorHandler = curry(throwError)(errorMessages);
var validators = {
  config: validateConfig
};

var compose$2 = function compose() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (x) {
    return fns.reduceRight(function (y, f) {
      return f(y);
    }, x);
  };
};

function merge$2(target, source) {
  Object.keys(source).forEach(function (key) {
    if (source[key] instanceof Object) {
      if (target[key]) {
        Object.assign(source[key], merge$2(target[key], source[key]));
      }
    }
  });
  return _objectSpread2$c(_objectSpread2$c({}, target), source);
}

// The source (has been changed) is https://github.com/facebook/react/issues/5465#issuecomment-157888325
var CANCELATION_MESSAGE = {
  type: 'cancelation',
  msg: 'operation is manually canceled'
};

function makeCancelable(promise) {
  var hasCanceled_ = false;
  var wrappedPromise = new Promise(function (resolve, reject) {
    promise.then(function (val) {
      return hasCanceled_ ? reject(CANCELATION_MESSAGE) : resolve(val);
    });
    promise["catch"](reject);
  });
  return wrappedPromise.cancel = function () {
    return hasCanceled_ = true;
  }, wrappedPromise;
}

/** the local state of the module */

var _state$create = index$3.create({
  config: config$4,
  isInitialized: false,
  resolve: null,
  reject: null,
  monaco: null
}),
    _state$create2 = _slicedToArray$9(_state$create, 2),
    getState = _state$create2[0],
    setState = _state$create2[1];
/**
 * set the loader configuration
 * @param {Object} config - the configuration object
 */


function config$3(config) {
  setState(function (state) {
    return {
      config: merge$2(state.config, validators.config(config))
    };
  });
}
/**
 * handles the initialization of the monaco-editor
 * @return {Promise} - returns an instance of monaco (with a cancelable promise)
 */


function init() {
  var state = getState(function (_ref) {
    var isInitialized = _ref.isInitialized;
    return {
      isInitialized: isInitialized
    };
  });

  if (!state.isInitialized) {
    if (window.monaco && window.monaco.editor) {
      storeMonacoInstance(window.monaco);
      return makeCancelable(Promise.resolve(window.monaco));
    }

    compose$2(injectScripts, getMonacoLoaderScript)(configureLoader);
    setState({
      isInitialized: true
    });
  }

  return makeCancelable(wrapperPromise);
}
/**
 * injects provided scripts into the document.body
 * @param {Object} script - an HTML script element
 * @return {Object} - the injected HTML script element
 */


function injectScripts(script) {
  return document.body.appendChild(script);
}
/**
 * creates an HTML script element with/without provided src
 * @param {string} [src] - the source path of the script
 * @return {Object} - the created HTML script element
 */


function createScript(src) {
  var script = document.createElement('script');
  return src && (script.src = src), script;
}
/**
 * creates an HTML script element with the monaco loader src
 * @return {Object} - the created HTML script element
 */


function getMonacoLoaderScript(configureLoader) {
  var state = getState(function (_ref2) {
    var config = _ref2.config,
        reject = _ref2.reject;
    return {
      config: config,
      reject: reject
    };
  });
  var loaderScript = createScript("".concat(state.config.paths.vs, "/loader.js"));

  loaderScript.onload = function () {
    return configureLoader();
  };

  loaderScript.onerror = state.reject;
  return loaderScript;
}
/**
 * configures the monaco loader
 */


function configureLoader() {
  var state = getState(function (_ref3) {
    var config = _ref3.config,
        resolve = _ref3.resolve,
        reject = _ref3.reject;
    return {
      config: config,
      resolve: resolve,
      reject: reject
    };
  });
  var require = window.require;

  require.config(state.config);

  require(['vs/editor/editor.main'], function (monaco) {
    storeMonacoInstance(monaco);
    state.resolve(monaco);
  }, function (error) {
    state.reject(error);
  });
}
/**
 * store monaco instance in local state
 */


function storeMonacoInstance(monaco) {
  if (!getState().monaco) {
    setState({
      monaco: monaco
    });
  }
}
/**
 * internal helper function
 * extracts stored monaco instance
 * @return {Object|null} - the monaco instance
 */


function __getMonacoInstance() {
  return getState(function (_ref4) {
    var monaco = _ref4.monaco;
    return monaco;
  });
}

var wrapperPromise = new Promise(function (resolve, reject) {
  return setState({
    resolve: resolve,
    reject: reject
  });
});
var loader$1 = {
  config: config$3,
  init: init,
  __getMonacoInstance: __getMonacoInstance
};

var commonjsGlobal$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

var propTypes$2 = {exports: {}};

var reactIs$3 = {exports: {}};

var reactIs_production_min$2 = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$2;

function requireReactIs_production_min$2 () {
	if (hasRequiredReactIs_production_min$2) return reactIs_production_min$2;
	hasRequiredReactIs_production_min$2 = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min$2.AsyncMode=l;reactIs_production_min$2.ConcurrentMode=m;reactIs_production_min$2.ContextConsumer=k;reactIs_production_min$2.ContextProvider=h;reactIs_production_min$2.Element=c;reactIs_production_min$2.ForwardRef=n;reactIs_production_min$2.Fragment=e;reactIs_production_min$2.Lazy=t;reactIs_production_min$2.Memo=r;reactIs_production_min$2.Portal=d;
	reactIs_production_min$2.Profiler=g;reactIs_production_min$2.StrictMode=f;reactIs_production_min$2.Suspense=p;reactIs_production_min$2.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min$2.isConcurrentMode=A;reactIs_production_min$2.isContextConsumer=function(a){return z(a)===k};reactIs_production_min$2.isContextProvider=function(a){return z(a)===h};reactIs_production_min$2.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min$2.isForwardRef=function(a){return z(a)===n};reactIs_production_min$2.isFragment=function(a){return z(a)===e};reactIs_production_min$2.isLazy=function(a){return z(a)===t};
	reactIs_production_min$2.isMemo=function(a){return z(a)===r};reactIs_production_min$2.isPortal=function(a){return z(a)===d};reactIs_production_min$2.isProfiler=function(a){return z(a)===g};reactIs_production_min$2.isStrictMode=function(a){return z(a)===f};reactIs_production_min$2.isSuspense=function(a){return z(a)===p};
	reactIs_production_min$2.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min$2.typeOf=z;
	return reactIs_production_min$2;
}

var reactIs_development$2 = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$2;

function requireReactIs_development$2 () {
	if (hasRequiredReactIs_development$2) return reactIs_development$2;
	hasRequiredReactIs_development$2 = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$2.AsyncMode = AsyncMode;
	reactIs_development$2.ConcurrentMode = ConcurrentMode;
	reactIs_development$2.ContextConsumer = ContextConsumer;
	reactIs_development$2.ContextProvider = ContextProvider;
	reactIs_development$2.Element = Element;
	reactIs_development$2.ForwardRef = ForwardRef;
	reactIs_development$2.Fragment = Fragment;
	reactIs_development$2.Lazy = Lazy;
	reactIs_development$2.Memo = Memo;
	reactIs_development$2.Portal = Portal;
	reactIs_development$2.Profiler = Profiler;
	reactIs_development$2.StrictMode = StrictMode;
	reactIs_development$2.Suspense = Suspense;
	reactIs_development$2.isAsyncMode = isAsyncMode;
	reactIs_development$2.isConcurrentMode = isConcurrentMode;
	reactIs_development$2.isContextConsumer = isContextConsumer;
	reactIs_development$2.isContextProvider = isContextProvider;
	reactIs_development$2.isElement = isElement;
	reactIs_development$2.isForwardRef = isForwardRef;
	reactIs_development$2.isFragment = isFragment;
	reactIs_development$2.isLazy = isLazy;
	reactIs_development$2.isMemo = isMemo;
	reactIs_development$2.isPortal = isPortal;
	reactIs_development$2.isProfiler = isProfiler;
	reactIs_development$2.isStrictMode = isStrictMode;
	reactIs_development$2.isSuspense = isSuspense;
	reactIs_development$2.isValidElementType = isValidElementType;
	reactIs_development$2.typeOf = typeOf;
	  })();
	}
	return reactIs_development$2;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs$3.exports;
	hasRequiredReactIs = 1;

	if (process.env.NODE_ENV === 'production') {
	  reactIs$3.exports = requireReactIs_production_min$2();
	} else {
	  reactIs$3.exports = requireReactIs_development$2();
	}
	return reactIs$3.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes$2.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes$2.exports = requireFactoryWithThrowingShims()();
}

var propTypesExports = propTypes$2.exports;
var PropTypes = /*@__PURE__*/getDefaultExportFromCjs(propTypesExports);

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

const loadingStyles = {
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center'
};

function Loading({
  content
}) {
  return /*#__PURE__*/React__default.createElement("div", {
    style: loadingStyles
  }, content);
}

const styles$R = {
  wrapper: {
    display: 'flex',
    position: 'relative',
    textAlign: 'initial'
  },
  fullWidth: {
    width: '100%'
  },
  hide: {
    display: 'none'
  }
};

// one of the reasons why we use a separate prop for passing ref instead of using forwardref

function MonacoContainer$1({
  width,
  height,
  isEditorReady,
  loading,
  _ref,
  className,
  wrapperProps
}) {
  return /*#__PURE__*/React__default.createElement("section", _extends$1({
    style: { ...styles$R.wrapper,
      width,
      height
    }
  }, wrapperProps), !isEditorReady && /*#__PURE__*/React__default.createElement(Loading, {
    content: loading
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: _ref,
    style: { ...styles$R.fullWidth,
      ...(!isEditorReady && styles$R.hide)
    },
    className: className
  }));
}

MonacoContainer$1.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  loading: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
  isEditorReady: PropTypes.bool.isRequired,
  className: PropTypes.string,
  wrapperProps: PropTypes.object
};

var MonacoContainer = /*#__PURE__*/memo(MonacoContainer$1);

function useMount(effect) {
  useEffect(effect, []);
}

function useUpdate(effect, deps, applyChanges = true) {
  const isInitialMount = useRef(true);
  useEffect(isInitialMount.current || !applyChanges ? () => {
    isInitialMount.current = false;
  } : effect, deps);
}

function noop$7() {}

function getOrCreateModel(monaco, value, language, path) {
  return getModel(monaco, path) || createModel(monaco, value, language, path);
}

function getModel(monaco, path) {
  return monaco.editor.getModel(createModelUri(monaco, path));
}

function createModel(monaco, value, language, path) {
  return monaco.editor.createModel(value, language, path && createModelUri(monaco, path));
}

function createModelUri(monaco, path) {
  return monaco.Uri.parse(path);
}

function isUndefined(input) {
  return input === undefined;
}

function DiffEditor({
  original,
  modified,
  language,
  originalLanguage,
  modifiedLanguage,

  /* === */
  originalModelPath,
  modifiedModelPath,
  keepCurrentOriginalModel,
  keepCurrentModifiedModel,
  theme,
  loading,
  options,

  /* === */
  height,
  width,
  className,
  wrapperProps,

  /* === */
  beforeMount,
  onMount
}) {
  const [isEditorReady, setIsEditorReady] = useState(false);
  const [isMonacoMounting, setIsMonacoMounting] = useState(true);
  const editorRef = useRef(null);
  const monacoRef = useRef(null);
  const containerRef = useRef(null);
  const onMountRef = useRef(onMount);
  const beforeMountRef = useRef(beforeMount);
  useMount(() => {
    const cancelable = loader$1.init();
    cancelable.then(monaco => (monacoRef.current = monaco) && setIsMonacoMounting(false)).catch(error => (error === null || error === void 0 ? void 0 : error.type) !== 'cancelation' && console.error('Monaco initialization: error:', error));
    return () => editorRef.current ? disposeEditor() : cancelable.cancel();
  });
  useUpdate(() => {
    const modifiedEditor = editorRef.current.getModifiedEditor();

    if (modifiedEditor.getOption(monacoRef.current.editor.EditorOption.readOnly)) {
      modifiedEditor.setValue(modified);
    } else {
      if (modified !== modifiedEditor.getValue()) {
        modifiedEditor.executeEdits('', [{
          range: modifiedEditor.getModel().getFullModelRange(),
          text: modified,
          forceMoveMarkers: true
        }]);
        modifiedEditor.pushUndoStop();
      }
    }
  }, [modified], isEditorReady);
  useUpdate(() => {
    editorRef.current.getModel().original.setValue(original);
  }, [original], isEditorReady);
  useUpdate(() => {
    const {
      original,
      modified
    } = editorRef.current.getModel();
    monacoRef.current.editor.setModelLanguage(original, originalLanguage || language);
    monacoRef.current.editor.setModelLanguage(modified, modifiedLanguage || language);
  }, [language, originalLanguage, modifiedLanguage], isEditorReady);
  useUpdate(() => {
    monacoRef.current.editor.setTheme(theme);
  }, [theme], isEditorReady);
  useUpdate(() => {
    editorRef.current.updateOptions(options);
  }, [options], isEditorReady);
  const setModels = useCallback$1(() => {
    beforeMountRef.current(monacoRef.current);
    const originalModel = getOrCreateModel(monacoRef.current, original, originalLanguage || language, originalModelPath);
    const modifiedModel = getOrCreateModel(monacoRef.current, modified, modifiedLanguage || language, modifiedModelPath);
    editorRef.current.setModel({
      original: originalModel,
      modified: modifiedModel
    });
  }, [language, modified, modifiedLanguage, original, originalLanguage, originalModelPath, modifiedModelPath]);
  const createEditor = useCallback$1(() => {
    editorRef.current = monacoRef.current.editor.createDiffEditor(containerRef.current, {
      automaticLayout: true,
      ...options
    });
    setModels();
    monacoRef.current.editor.setTheme(theme);
    setIsEditorReady(true);
  }, [options, theme, setModels]);
  useEffect(() => {
    if (isEditorReady) {
      onMountRef.current(editorRef.current, monacoRef.current);
    }
  }, [isEditorReady]);
  useEffect(() => {
    !isMonacoMounting && !isEditorReady && createEditor();
  }, [isMonacoMounting, isEditorReady, createEditor]);

  function disposeEditor() {
    const models = editorRef.current.getModel();

    if (!keepCurrentOriginalModel) {
      var _models$original;

      (_models$original = models.original) === null || _models$original === void 0 ? void 0 : _models$original.dispose();
    }

    if (!keepCurrentModifiedModel) {
      var _models$modified;

      (_models$modified = models.modified) === null || _models$modified === void 0 ? void 0 : _models$modified.dispose();
    }

    editorRef.current.dispose();
  }

  return /*#__PURE__*/React__default.createElement(MonacoContainer, {
    width: width,
    height: height,
    isEditorReady: isEditorReady,
    loading: loading,
    _ref: containerRef,
    className: className,
    wrapperProps: wrapperProps
  });
}

DiffEditor.propTypes = {
  original: PropTypes.string,
  modified: PropTypes.string,
  language: PropTypes.string,
  originalLanguage: PropTypes.string,
  modifiedLanguage: PropTypes.string,

  /* === */
  originalModelPath: PropTypes.string,
  modifiedModelPath: PropTypes.string,
  keepCurrentOriginalModel: PropTypes.bool,
  keepCurrentModifiedModel: PropTypes.bool,
  theme: PropTypes.string,
  loading: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  options: PropTypes.object,

  /* === */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  wrapperProps: PropTypes.object,

  /* === */
  beforeMount: PropTypes.func,
  onMount: PropTypes.func
};
DiffEditor.defaultProps = {
  theme: 'light',
  loading: 'Loading...',
  options: {},
  keepCurrentOriginalModel: false,
  keepCurrentModifiedModel: false,

  /* === */
  width: '100%',
  height: '100%',
  wrapperProps: {},

  /* === */
  beforeMount: noop$7,
  onMount: noop$7
};

var index$2 = /*#__PURE__*/memo(DiffEditor);

function usePrevious$2(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}

const viewStates = new Map();

function Editor({
  defaultValue,
  defaultLanguage,
  defaultPath,
  value,
  language,
  path,

  /* === */
  theme,
  line,
  loading,
  options,
  overrideServices,
  saveViewState,
  keepCurrentModel,

  /* === */
  width,
  height,
  className,
  wrapperProps,

  /* === */
  beforeMount,
  onMount,
  onChange,
  onValidate
}) {
  const [isEditorReady, setIsEditorReady] = useState(false);
  const [isMonacoMounting, setIsMonacoMounting] = useState(true);
  const monacoRef = useRef(null);
  const editorRef = useRef(null);
  const containerRef = useRef(null);
  const onMountRef = useRef(onMount);
  const beforeMountRef = useRef(beforeMount);
  const subscriptionRef = useRef(null);
  const valueRef = useRef(value);
  const previousPath = usePrevious$2(path);
  useMount(() => {
    const cancelable = loader$1.init();
    cancelable.then(monaco => (monacoRef.current = monaco) && setIsMonacoMounting(false)).catch(error => (error === null || error === void 0 ? void 0 : error.type) !== 'cancelation' && console.error('Monaco initialization: error:', error));
    return () => editorRef.current ? disposeEditor() : cancelable.cancel();
  });
  useUpdate(() => {
    const model = getOrCreateModel(monacoRef.current, defaultValue || value, defaultLanguage || language, path);

    if (model !== editorRef.current.getModel()) {
      saveViewState && viewStates.set(previousPath, editorRef.current.saveViewState());
      editorRef.current.setModel(model);
      saveViewState && editorRef.current.restoreViewState(viewStates.get(path));
    }
  }, [path], isEditorReady);
  useUpdate(() => {
    editorRef.current.updateOptions(options);
  }, [options], isEditorReady);
  useUpdate(() => {
    if (editorRef.current.getOption(monacoRef.current.editor.EditorOption.readOnly)) {
      editorRef.current.setValue(value);
    } else {
      if (value !== editorRef.current.getValue()) {
        editorRef.current.executeEdits('', [{
          range: editorRef.current.getModel().getFullModelRange(),
          text: value,
          forceMoveMarkers: true
        }]);
        editorRef.current.pushUndoStop();
      }
    }
  }, [value], isEditorReady);
  useUpdate(() => {
    monacoRef.current.editor.setModelLanguage(editorRef.current.getModel(), language);
  }, [language], isEditorReady);
  useUpdate(() => {
    // reason for undefined check: https://github.com/suren-atoyan/monaco-react/pull/188
    if (!isUndefined(line)) {
      editorRef.current.revealLine(line);
    }
  }, [line], isEditorReady);
  useUpdate(() => {
    monacoRef.current.editor.setTheme(theme);
  }, [theme], isEditorReady);
  const createEditor = useCallback$1(() => {
    beforeMountRef.current(monacoRef.current);
    const autoCreatedModelPath = path || defaultPath;
    const defaultModel = getOrCreateModel(monacoRef.current, value || defaultValue, defaultLanguage || language, autoCreatedModelPath);
    editorRef.current = monacoRef.current.editor.create(containerRef.current, {
      model: defaultModel,
      automaticLayout: true,
      ...options
    }, overrideServices);
    saveViewState && editorRef.current.restoreViewState(viewStates.get(autoCreatedModelPath));
    monacoRef.current.editor.setTheme(theme);
    setIsEditorReady(true);
  }, [defaultValue, defaultLanguage, defaultPath, value, language, path, options, overrideServices, saveViewState, theme]);
  useEffect(() => {
    if (isEditorReady) {
      onMountRef.current(editorRef.current, monacoRef.current);
    }
  }, [isEditorReady]);
  useEffect(() => {
    !isMonacoMounting && !isEditorReady && createEditor();
  }, [isMonacoMounting, isEditorReady, createEditor]); // subscription
  // to avoid unnecessary updates (attach - dispose listener) in subscription

  valueRef.current = value;
  useEffect(() => {
    if (isEditorReady && onChange) {
      var _subscriptionRef$curr, _editorRef$current;

      (_subscriptionRef$curr = subscriptionRef.current) === null || _subscriptionRef$curr === void 0 ? void 0 : _subscriptionRef$curr.dispose();
      subscriptionRef.current = (_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 ? void 0 : _editorRef$current.onDidChangeModelContent(event => {
        const editorValue = editorRef.current.getValue();

        if (valueRef.current !== editorValue) {
          onChange(editorValue, event);
        }
      });
    }
  }, [isEditorReady, onChange]); // onValidate

  useEffect(() => {
    if (isEditorReady) {
      const changeMarkersListener = monacoRef.current.editor.onDidChangeMarkers(uris => {
        var _editorRef$current$ge;

        const editorUri = (_editorRef$current$ge = editorRef.current.getModel()) === null || _editorRef$current$ge === void 0 ? void 0 : _editorRef$current$ge.uri;

        if (editorUri) {
          const currentEditorHasMarkerChanges = uris.find(uri => uri.path === editorUri.path);

          if (currentEditorHasMarkerChanges) {
            const markers = monacoRef.current.editor.getModelMarkers({
              resource: editorUri
            });
            onValidate === null || onValidate === void 0 ? void 0 : onValidate(markers);
          }
        }
      });
      return () => {
        changeMarkersListener === null || changeMarkersListener === void 0 ? void 0 : changeMarkersListener.dispose();
      };
    }
  }, [isEditorReady, onValidate]);

  function disposeEditor() {
    var _subscriptionRef$curr2;

    (_subscriptionRef$curr2 = subscriptionRef.current) === null || _subscriptionRef$curr2 === void 0 ? void 0 : _subscriptionRef$curr2.dispose();

    if (keepCurrentModel) {
      saveViewState && viewStates.set(path, editorRef.current.saveViewState());
    } else {
      var _editorRef$current$ge2;

      (_editorRef$current$ge2 = editorRef.current.getModel()) === null || _editorRef$current$ge2 === void 0 ? void 0 : _editorRef$current$ge2.dispose();
    }

    editorRef.current.dispose();
  }

  return /*#__PURE__*/React__default.createElement(MonacoContainer, {
    width: width,
    height: height,
    isEditorReady: isEditorReady,
    loading: loading,
    _ref: containerRef,
    className: className,
    wrapperProps: wrapperProps
  });
}

Editor.propTypes = {
  defaultValue: PropTypes.string,
  defaultPath: PropTypes.string,
  defaultLanguage: PropTypes.string,
  value: PropTypes.string,
  language: PropTypes.string,
  path: PropTypes.string,

  /* === */
  theme: PropTypes.string,
  line: PropTypes.number,
  loading: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  options: PropTypes.object,
  overrideServices: PropTypes.object,
  saveViewState: PropTypes.bool,
  keepCurrentModel: PropTypes.bool,

  /* === */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
  wrapperProps: PropTypes.object,

  /* === */
  beforeMount: PropTypes.func,
  onMount: PropTypes.func,
  onChange: PropTypes.func,
  onValidate: PropTypes.func
};
Editor.defaultProps = {
  theme: 'light',
  loading: 'Loading...',
  options: {},
  overrideServices: {},
  saveViewState: true,
  keepCurrentModel: false,

  /* === */
  width: '100%',
  height: '100%',
  wrapperProps: {},

  /* === */
  beforeMount: noop$7,
  onMount: noop$7,
  onValidate: noop$7
};

var index$1 = /*#__PURE__*/memo(Editor);

const theme = {
    typography: {
        fontFamily: ['Lato'].join(','),
        htmlFontSize: 16,
        button: {
            textTransform: 'none'
        }
    },
    overrides: {
        MuiButton: {
            label: {
                fontSize: '0.813rem'
            }
        }
    },
    palette: {
        primary: {
            main: '#f36a22',
            contrastText: '#fff'
        },
        secondary: {
            main: '#2991f3',
            light: '#b4e8e9',
            contrastText: '#fff'
        }
    }
};

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$4(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function toVal$2(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$2(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx$1 () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$2(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

/**
 * @ignore - internal component.
 */

var SuccessOutlinedIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

/**
 * @ignore - internal component.
 */

var ReportProblemOutlinedIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

/**
 * @ignore - internal component.
 */

var ErrorOutlineIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

/**
 * @ignore - internal component.
 */

var InfoOutlinedIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

/**
 * @ignore - internal component.
 */

var CloseIcon$1 = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

var styles$Q = function styles(theme) {
  var getColor = theme.palette.type === 'light' ? darken : lighten;
  var getBackgroundColor = theme.palette.type === 'light' ? lighten : darken;
  return {
    /* Styles applied to the root element. */
    root: _extends({}, theme.typography.body2, {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: 'transparent',
      display: 'flex',
      padding: '6px 16px'
    }),

    /* Styles applied to the root element if `variant="standard"` and `color="success"`. */
    standardSuccess: {
      color: getColor(theme.palette.success.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.success.main, 0.9),
      '& $icon': {
        color: theme.palette.success.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="info"`. */
    standardInfo: {
      color: getColor(theme.palette.info.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.info.main, 0.9),
      '& $icon': {
        color: theme.palette.info.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="warning"`. */
    standardWarning: {
      color: getColor(theme.palette.warning.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.warning.main, 0.9),
      '& $icon': {
        color: theme.palette.warning.main
      }
    },

    /* Styles applied to the root element if `variant="standard"` and `color="error"`. */
    standardError: {
      color: getColor(theme.palette.error.main, 0.6),
      backgroundColor: getBackgroundColor(theme.palette.error.main, 0.9),
      '& $icon': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="success"`. */
    outlinedSuccess: {
      color: getColor(theme.palette.success.main, 0.6),
      border: "1px solid ".concat(theme.palette.success.main),
      '& $icon': {
        color: theme.palette.success.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="info"`. */
    outlinedInfo: {
      color: getColor(theme.palette.info.main, 0.6),
      border: "1px solid ".concat(theme.palette.info.main),
      '& $icon': {
        color: theme.palette.info.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="warning"`. */
    outlinedWarning: {
      color: getColor(theme.palette.warning.main, 0.6),
      border: "1px solid ".concat(theme.palette.warning.main),
      '& $icon': {
        color: theme.palette.warning.main
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="error"`. */
    outlinedError: {
      color: getColor(theme.palette.error.main, 0.6),
      border: "1px solid ".concat(theme.palette.error.main),
      '& $icon': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the root element if `variant="filled"` and `color="success"`. */
    filledSuccess: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.success.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="info"`. */
    filledInfo: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.info.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="warning"`. */
    filledWarning: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.warning.main
    },

    /* Styles applied to the root element if `variant="filled"` and `color="error"`. */
    filledError: {
      color: '#fff',
      fontWeight: theme.typography.fontWeightMedium,
      backgroundColor: theme.palette.error.main
    },

    /* Styles applied to the icon wrapper element. */
    icon: {
      marginRight: 12,
      padding: '7px 0',
      display: 'flex',
      fontSize: 22,
      opacity: 0.9
    },

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var defaultIconMapping = {
  success: /*#__PURE__*/React.createElement(SuccessOutlinedIcon, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/React.createElement(ReportProblemOutlinedIcon, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/React.createElement(ErrorOutlineIcon, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/React.createElement(InfoOutlinedIcon, {
    fontSize: "inherit"
  })
};

var _ref$1 = /*#__PURE__*/React.createElement(CloseIcon$1, {
  fontSize: "small"
});

var Alert = /*#__PURE__*/React.forwardRef(function Alert(props, ref) {
  var action = props.action,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
      color = props.color,
      icon = props.icon,
      _props$iconMapping = props.iconMapping,
      iconMapping = _props$iconMapping === void 0 ? defaultIconMapping : _props$iconMapping,
      onClose = props.onClose,
      _props$role = props.role,
      role = _props$role === void 0 ? 'alert' : _props$role,
      _props$severity = props.severity,
      severity = _props$severity === void 0 ? 'success' : _props$severity,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties$4(props, ["action", "children", "classes", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant"]);

  return /*#__PURE__*/React.createElement(Paper, _extends({
    role: role,
    square: true,
    elevation: 0,
    className: clsx$1(classes.root, classes["".concat(variant).concat(capitalize(color || severity))], className),
    ref: ref
  }, other), icon !== false ? /*#__PURE__*/React.createElement("div", {
    className: classes.icon
  }, icon || iconMapping[severity] || defaultIconMapping[severity]) : null, /*#__PURE__*/React.createElement("div", {
    className: classes.message
  }, children), action != null ? /*#__PURE__*/React.createElement("div", {
    className: classes.action
  }, action) : null, action == null && onClose ? /*#__PURE__*/React.createElement("div", {
    className: classes.action
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    "aria-label": closeText,
    title: closeText,
    color: "inherit",
    onClick: onClose
  }, _ref$1)) : null);
});
process.env.NODE_ENV !== "production" ? Alert.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: PropTypes.node,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,

  /**
   * The main color for the alert. Unless provided, the value is taken from the `severity` prop.
   */
  color: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   */
  icon: PropTypes.node,

  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: PropTypes.shape({
    error: PropTypes.node,
    info: PropTypes.node,
    success: PropTypes.node,
    warning: PropTypes.node
  }),

  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * The ARIA role attribute of the element.
   */
  role: PropTypes.string,

  /**
   * The severity of the alert. This defines the color and icon used.
   */
  severity: PropTypes.oneOf(['error', 'info', 'success', 'warning']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['filled', 'outlined', 'standard'])
} : void 0;
var Alert$1 = withStyles(styles$Q, {
  name: 'MuiAlert'
})(Alert);

function _defineProperty$d(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/**
 * @ignore - internal component.
 */

var ArrowDropDownIcon$2 = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

function _arrayWithHoles$8(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$8(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray$8(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _unsupportedIterableToArray$8(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$8(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$8(o, minLen);
}

function _nonIterableRest$8() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$8(arr, i) {
  return _arrayWithHoles$8(arr) || _iterableToArrayLimit$8(arr, i) || _unsupportedIterableToArray$8(arr, i) || _nonIterableRest$8();
}

function _typeof$4(obj) {
  "@babel/helpers - typeof";

  return _typeof$4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$4(obj);
}

// Give up on IE 11 support for this feature

function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}

function createFilterOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$ignoreAccents = config.ignoreAccents,
      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
      _config$ignoreCase = config.ignoreCase,
      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
      limit = config.limit,
      _config$matchFrom = config.matchFrom,
      matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
      stringify = config.stringify,
      _config$trim = config.trim,
      trim = _config$trim === void 0 ? false : _config$trim;
  return function (options, _ref) {
    var inputValue = _ref.inputValue,
        getOptionLabel = _ref.getOptionLabel;
    var input = trim ? inputValue.trim() : inputValue;

    if (ignoreCase) {
      input = input.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
    }

    var filteredOptions = options.filter(function (option) {
      var candidate = (stringify || getOptionLabel)(option);

      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
  };
} // To replace with .findIndex() once we stop IE 11 support.

function findIndex$3(array, comp) {
  for (var i = 0; i < array.length; i += 1) {
    if (comp(array[i])) {
      return i;
    }
  }

  return -1;
}

var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.

var pageSize = 5;
function useAutocomplete(props) {
  var _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
      _props$autoHighlight = props.autoHighlight,
      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
      _props$autoSelect = props.autoSelect,
      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
      _props$blurOnSelect = props.blurOnSelect,
      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
      _props$clearOnBlur = props.clearOnBlur,
      clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
      _props$clearOnEscape = props.clearOnEscape,
      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
      _props$componentName = props.componentName,
      componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName,
      _props$debug = props.debug,
      debug = _props$debug === void 0 ? false : _props$debug,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
      _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disableCloseOn = props.disableCloseOnSelect,
      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      _props$filterOptions = props.filterOptions,
      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
      _props$filterSelected = props.filterSelectedOptions,
      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      getOptionDisabled = props.getOptionDisabled,
      _props$getOptionLabel = props.getOptionLabel,
      getOptionLabelProp = _props$getOptionLabel === void 0 ? function (option) {
    return option;
  } : _props$getOptionLabel,
      _props$getOptionSelec = props.getOptionSelected,
      getOptionSelected = _props$getOptionSelec === void 0 ? function (option, value) {
    return option === value;
  } : _props$getOptionSelec,
      groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys,
      handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK,
      idProp = props.id,
      _props$includeInputIn = props.includeInputInList,
      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
      inputValueProp = props.inputValue,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      onChange = props.onChange,
      onClose = props.onClose,
      onHighlightChange = props.onHighlightChange,
      onInputChange = props.onInputChange,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$openOnFocus = props.openOnFocus,
      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
      options = props.options,
      _props$selectOnFocus = props.selectOnFocus,
      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
      valueProp = props.value;
  var id = unstable_useId(idProp);
  var getOptionLabel = getOptionLabelProp;

  if (process.env.NODE_ENV !== 'production') {
    getOptionLabel = function getOptionLabel(option) {
      var optionLabel = getOptionLabelProp(option);

      if (typeof optionLabel !== 'string') {
        var erroneousReturn = optionLabel === undefined ? 'undefined' : "".concat(_typeof$4(optionLabel), " (").concat(optionLabel, ")");
        console.error("Material-UI: The `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(option), "."));
      }

      return optionLabel;
    };
  }

  var ignoreFocus = React.useRef(false);
  var firstFocus = React.useRef(true);
  var inputRef = React.useRef(null);
  var listboxRef = React.useRef(null);

  var _React$useState = React.useState(null),
      anchorEl = _React$useState[0],
      setAnchorEl = _React$useState[1];

  var _React$useState2 = React.useState(-1),
      focusedTag = _React$useState2[0],
      setFocusedTag = _React$useState2[1];

  var defaultHighlighted = autoHighlight ? 0 : -1;
  var highlightedIndexRef = React.useRef(defaultHighlighted);

  var _useControlled = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: componentName
  }),
      _useControlled2 = _slicedToArray$8(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var _useControlled3 = useControlled({
    controlled: inputValueProp,
    default: '',
    name: componentName,
    state: 'inputValue'
  }),
      _useControlled4 = _slicedToArray$8(_useControlled3, 2),
      inputValue = _useControlled4[0],
      setInputValue = _useControlled4[1];

  var _React$useState3 = React.useState(false),
      focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var resetInputValue = useEventCallback(function (event, newValue) {
    var newInputValue;

    if (multiple) {
      newInputValue = '';
    } else if (newValue == null) {
      newInputValue = '';
    } else {
      var optionLabel = getOptionLabel(newValue);
      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
    }

    if (inputValue === newInputValue) {
      return;
    }

    setInputValue(newInputValue);

    if (onInputChange) {
      onInputChange(event, newInputValue, 'reset');
    }
  });
  React.useEffect(function () {
    resetInputValue(null, value);
  }, [value, resetInputValue]);

  var _useControlled5 = useControlled({
    controlled: openProp,
    default: false,
    name: componentName,
    state: 'open'
  }),
      _useControlled6 = _slicedToArray$8(_useControlled5, 2),
      open = _useControlled6[0],
      setOpenState = _useControlled6[1];

  var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
  var popupOpen = open;
  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
    if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
      return value2 !== null && getOptionSelected(option, value2);
    })) {
      return false;
    }

    return true;
  }), // we use the empty string to manipulate `filterOptions` to not filter any options
  // i.e. the filter predicate always returns true
  {
    inputValue: inputValueIsSelectedValue ? '' : inputValue,
    getOptionLabel: getOptionLabel
  }) : [];

  if (process.env.NODE_ENV !== 'production') {
    if (value !== null && !freeSolo && options.length > 0) {
      var missingValue = (multiple ? value : [value]).filter(function (value2) {
        return !options.some(function (option) {
          return getOptionSelected(option, value2);
        });
      });

      if (missingValue.length > 0) {
        console.warn(["Material-UI: The value provided to ".concat(componentName, " is invalid."), "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."), 'You can use the `getOptionSelected` prop to customize the equality test.'].join('\n'));
      }
    }
  }

  var focusTag = useEventCallback(function (tagToFocus) {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
    }
  }); // Ensure the focusedTag is never inconsistent

  React.useEffect(function () {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);

  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute('aria-disabled') === 'true');

      if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) {
        // Move to the next element.
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var setHighlightedIndex = useEventCallback(function (_ref2) {
    var event = _ref2.event,
        index = _ref2.index,
        _ref2$reason = _ref2.reason,
        reason = _ref2$reason === void 0 ? 'auto' : _ref2$reason;
    highlightedIndexRef.current = index; // does the index exist?

    if (index === -1) {
      inputRef.current.removeAttribute('aria-activedescendant');
    } else {
      inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
    }

    if (onHighlightChange) {
      onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
    }

    if (!listboxRef.current) {
      return;
    }

    var prev = listboxRef.current.querySelector('[data-focus]');

    if (prev) {
      prev.removeAttribute('data-focus');
    }

    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"

    if (!listboxNode) {
      return;
    }

    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }

    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));

    if (!option) {
      return;
    }

    option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
    //
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });

    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse') {
      var element = option;
      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      var elementBottom = element.offsetTop + element.offsetHeight;

      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
      }
    }
  });
  var changeHighlightedIndex = useEventCallback(function (_ref3) {
    var event = _ref3.event,
        diff = _ref3.diff,
        _ref3$direction = _ref3.direction,
        direction = _ref3$direction === void 0 ? 'next' : _ref3$direction,
        _ref3$reason = _ref3.reason,
        reason = _ref3$reason === void 0 ? 'auto' : _ref3$reason;

    if (!popupOpen) {
      return;
    }

    var getNextIndex = function getNextIndex() {
      var maxIndex = filteredOptions.length - 1;

      if (diff === 'reset') {
        return defaultHighlighted;
      }

      if (diff === 'start') {
        return 0;
      }

      if (diff === 'end') {
        return maxIndex;
      }

      var newIndex = highlightedIndexRef.current + diff;

      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }

        return maxIndex;
      }

      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }

        return 0;
      }

      return newIndex;
    };

    var nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex({
      index: nextIndex,
      reason: reason,
      event: event
    }); // Sync the content of the input with the highlighted option.

    if (autoComplete && diff !== 'reset') {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        var option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.

        var index = option.toLowerCase().indexOf(inputValue.toLowerCase());

        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  });
  var syncHighlightedIndex = React.useCallback(function () {
    if (!popupOpen) {
      return;
    }

    var valueItem = multiple ? value[0] : value; // The popup is empty, reset

    if (filteredOptions.length === 0 || valueItem == null) {
      changeHighlightedIndex({
        diff: 'reset'
      });
      return;
    }

    if (!listboxRef.current) {
      return;
    } // Synchronize the value with the highlighted index


    if (!filterSelectedOptions && valueItem != null) {
      var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible

      if (multiple && currentOption && findIndex$3(value, function (val) {
        return getOptionSelected(currentOption, val);
      }) !== -1) {
        return;
      }

      var itemIndex = findIndex$3(filteredOptions, function (optionItem) {
        return getOptionSelected(optionItem, valueItem);
      });

      if (itemIndex === -1) {
        changeHighlightedIndex({
          diff: 'reset'
        });
      } else {
        setHighlightedIndex({
          index: itemIndex
        });
      }

      return;
    } // Prevent the highlighted index to leak outside the boundaries.


    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
      setHighlightedIndex({
        index: filteredOptions.length - 1
      });
      return;
    } // Restore the focus to the previous index.


    setHighlightedIndex({
      index: highlightedIndexRef.current
    }); // Ignore filteredOptions (and options, getOptionSelected, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [// Only sync the highlighted index when the option switch between empty and not
  // eslint-disable-next-line react-hooks/exhaustive-deps
  filteredOptions.length === 0, // Don't sync the highlighted index with the value when multiple
  // eslint-disable-next-line react-hooks/exhaustive-deps
  multiple ? false : value, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, popupOpen, inputValue, multiple]);
  var handleListboxRef = useEventCallback(function (node) {
    setRef(listboxRef, node);

    if (!node) {
      return;
    }

    syncHighlightedIndex();
  });
  React.useEffect(function () {
    syncHighlightedIndex();
  }, [syncHighlightedIndex]);

  var handleOpen = function handleOpen(event) {
    if (open) {
      return;
    }

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleClose = function handleClose(event, reason) {
    if (!open) {
      return;
    }

    setOpenState(false);

    if (onClose) {
      onClose(event, reason);
    }
  };

  var handleValue = function handleValue(event, newValue, reason, details) {
    if (value === newValue) {
      return;
    }

    if (onChange) {
      onChange(event, newValue, reason, details);
    }

    setValue(newValue);
  };

  var isTouch = React.useRef(false);

  var selectNewValue = function selectNewValue(event, option) {
    var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-option';
    var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
    var reason = reasonProp;
    var newValue = option;

    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];

      if (process.env.NODE_ENV !== 'production') {
        var matches = newValue.filter(function (val) {
          return getOptionSelected(option, val);
        });

        if (matches.length > 1) {
          console.error(["Material-UI: The `getOptionSelected` method of ".concat(componentName, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")].join('\n'));
        }
      }

      var itemIndex = findIndex$3(newValue, function (valueItem) {
        return getOptionSelected(option, valueItem);
      });

      if (itemIndex === -1) {
        newValue.push(option);
      } else if (origin !== 'freeSolo') {
        newValue.splice(itemIndex, 1);
        reason = 'remove-option';
      }
    }

    resetInputValue(event, newValue);
    handleValue(event, newValue, reason, {
      option: option
    });

    if (!disableCloseOnSelect) {
      handleClose(event, reason);
    }

    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
      inputRef.current.blur();
    }
  };

  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var handleFocusTag = function handleFocusTag(event, direction) {
    if (!multiple) {
      return;
    }

    handleClose(event, 'toggleInput');
    var nextTag = focusedTag;

    if (focusedTag === -1) {
      if (inputValue === '' && direction === 'previous') {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === 'next' ? 1 : -1;

      if (nextTag < 0) {
        nextTag = 0;
      }

      if (nextTag === value.length) {
        nextTag = -1;
      }
    }

    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };

  var handleClear = function handleClear(event) {
    ignoreFocus.current = true;
    setInputValue('');

    if (onInputChange) {
      onInputChange(event, '', 'clear');
    }

    handleValue(event, multiple ? [] : null, 'clear');
  };

  var handleKeyDown = function handleKeyDown(other) {
    return function (event) {
      if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
        setFocusedTag(-1);
        focusTag(-1);
      }

      switch (event.key) {
        case 'Home':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'start',
              direction: 'next',
              reason: 'keyboard',
              event: event
            });
          }

          break;

        case 'End':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'end',
              direction: 'previous',
              reason: 'keyboard',
              event: event
            });
          }

          break;

        case 'PageUp':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: -pageSize,
            direction: 'previous',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'PageDown':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: pageSize,
            direction: 'next',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowDown':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: 1,
            direction: 'next',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowUp':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: -1,
            direction: 'previous',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowLeft':
          handleFocusTag(event, 'previous');
          break;

        case 'ArrowRight':
          handleFocusTag(event, 'next');
          break;

        case 'Enter':
          // Wait until IME is settled.
          if (event.which === 229) {
            break;
          }

          if (highlightedIndexRef.current !== -1 && popupOpen) {
            var option = filteredOptions[highlightedIndexRef.current];
            var disabled = getOptionDisabled ? getOptionDisabled(option) : false; // We don't want to validate the form.

            event.preventDefault();

            if (disabled) {
              return;
            }

            selectNewValue(event, option, 'select-option'); // Move the selection to the end.

            if (autoComplete) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
            if (multiple) {
              // Allow people to add new values before they submit the form.
              event.preventDefault();
            }

            selectNewValue(event, inputValue, 'create-option', 'freeSolo');
          }

          break;

        case 'Escape':
          if (popupOpen) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClose(event, 'escape');
          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClear(event);
          }

          break;

        case 'Backspace':
          if (multiple && inputValue === '' && value.length > 0) {
            var index = focusedTag === -1 ? value.length - 1 : focusedTag;
            var newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'remove-option', {
              option: value[index]
            });
          }

          break;
      }

      if (other.onKeyDown) {
        other.onKeyDown(event);
      }
    };
  };

  var handleFocus = function handleFocus(event) {
    setFocused(true);

    if (openOnFocus && !ignoreFocus.current) {
      handleOpen(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    // Ignore the event when using the scrollbar with IE 11
    if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
      inputRef.current.focus();
      return;
    }

    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;

    if (debug && inputValue !== '') {
      return;
    }

    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
    } else if (autoSelect && freeSolo && inputValue !== '') {
      selectNewValue(event, inputValue, 'blur', 'freeSolo');
    } else if (clearOnBlur) {
      resetInputValue(event, value);
    }

    handleClose(event, 'blur');
  };

  var handleInputChange = function handleInputChange(event) {
    var newValue = event.target.value;

    if (inputValue !== newValue) {
      setInputValue(newValue);

      if (onInputChange) {
        onInputChange(event, newValue, 'input');
      }
    }

    if (newValue === '') {
      if (!disableClearable && !multiple) {
        handleValue(event, null, 'clear');
      }
    } else {
      handleOpen(event);
    }
  };

  var handleOptionMouseOver = function handleOptionMouseOver(event) {
    setHighlightedIndex({
      event: event,
      index: Number(event.currentTarget.getAttribute('data-option-index')),
      reason: 'mouse'
    });
  };

  var handleOptionTouchStart = function handleOptionTouchStart() {
    isTouch.current = true;
  };

  var handleOptionClick = function handleOptionClick(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    selectNewValue(event, filteredOptions[index], 'select-option');
    isTouch.current = false;
  };

  var handleTagDelete = function handleTagDelete(index) {
    return function (event) {
      var newValue = value.slice();
      newValue.splice(index, 1);
      handleValue(event, newValue, 'remove-option', {
        option: value[index]
      });
    };
  };

  var handlePopupIndicator = function handlePopupIndicator(event) {
    if (open) {
      handleClose(event, 'toggleInput');
    } else {
      handleOpen(event);
    }
  }; // Prevent input blur when interacting with the combobox


  var handleMouseDown = function handleMouseDown(event) {
    if (event.target.getAttribute('id') !== id) {
      event.preventDefault();
    }
  }; // Focus the input when interacting with the combobox


  var handleClick = function handleClick() {
    inputRef.current.focus();

    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.select();
    }

    firstFocus.current = false;
  };

  var handleInputMouseDown = function handleInputMouseDown(event) {
    if (inputValue === '' || !open) {
      handlePopupIndicator(event);
    }
  };

  var dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  var groupedOptions = filteredOptions;

  if (groupBy) {
    // used to keep track of key and indexes in the result array
    var indexBy = new Map();
    var warn = false;
    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
      var group = groupBy(option);

      if (acc.length > 0 && acc[acc.length - 1].group === group) {
        acc[acc.length - 1].options.push(option);
      } else {
        if (process.env.NODE_ENV !== 'production') {
          if (indexBy.get(group) && !warn) {
            console.warn("Material-UI: The options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), 'You can solve the issue by sorting the options with the output of `groupBy`.');
            warn = true;
          }

          indexBy.set(group, true);
        }

        acc.push({
          key: index,
          index: index,
          group: group,
          options: [option]
        });
      }

      return acc;
    }, []);
  }

  return {
    getRootProps: function getRootProps() {
      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _extends({
        'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
        role: 'combobox',
        'aria-expanded': popupOpen
      }, other, {
        onKeyDown: handleKeyDown(other),
        onMouseDown: handleMouseDown,
        onClick: handleClick
      });
    },
    getInputLabelProps: function getInputLabelProps() {
      return {
        id: "".concat(id, "-label"),
        htmlFor: id
      };
    },
    getInputProps: function getInputProps() {
      return {
        id: id,
        value: inputValue,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleInputChange,
        onMouseDown: handleInputMouseDown,
        // if open then this is handled imperativeley so don't let react override
        // only have an opinion about this when closed
        'aria-activedescendant': popupOpen ? '' : null,
        'aria-autocomplete': autoComplete ? 'both' : 'list',
        'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
        // Disable browser's suggestion that might overlap with the popup.
        // Handle autocomplete but not autofill.
        autoComplete: 'off',
        ref: inputRef,
        autoCapitalize: 'none',
        spellCheck: 'false'
      };
    },
    getClearProps: function getClearProps() {
      return {
        tabIndex: -1,
        onClick: handleClear
      };
    },
    getPopupIndicatorProps: function getPopupIndicatorProps() {
      return {
        tabIndex: -1,
        onClick: handlePopupIndicator
      };
    },
    getTagProps: function getTagProps(_ref4) {
      var index = _ref4.index;
      return {
        key: index,
        'data-tag-index': index,
        tabIndex: -1,
        onDelete: handleTagDelete(index)
      };
    },
    getListboxProps: function getListboxProps() {
      return {
        role: 'listbox',
        id: "".concat(id, "-popup"),
        'aria-labelledby': "".concat(id, "-label"),
        ref: handleListboxRef,
        onMouseDown: function onMouseDown(event) {
          // Prevent blur
          event.preventDefault();
        }
      };
    },
    getOptionProps: function getOptionProps(_ref5) {
      var index = _ref5.index,
          option = _ref5.option;
      var selected = (multiple ? value : [value]).some(function (value2) {
        return value2 != null && getOptionSelected(option, value2);
      });
      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: index,
        tabIndex: -1,
        role: 'option',
        id: "".concat(id, "-option-").concat(index),
        onMouseOver: handleOptionMouseOver,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        'data-option-index': index,
        'aria-disabled': disabled,
        'aria-selected': selected
      };
    },
    id: id,
    inputValue: inputValue,
    value: value,
    dirty: dirty,
    popupOpen: popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl: anchorEl,
    setAnchorEl: setAnchorEl,
    focusedTag: focusedTag,
    groupedOptions: groupedOptions
  };
}

var styles$P = function styles(theme) {
  var _option;

  return {
    /* Styles applied to the root element. */
    root: {
      '&$focused $clearIndicatorDirty': {
        visibility: 'visible'
      },

      /* Avoid double tap issue on iOS */
      '@media (pointer: fine)': {
        '&:hover $clearIndicatorDirty': {
          visibility: 'visible'
        }
      }
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Pseudo-class applied to the root element if focused. */
    focused: {},

    /* Styles applied to the tag elements, e.g. the chips. */
    tag: {
      margin: 3,
      maxWidth: 'calc(100% - 6px)'
    },

    /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */
    tagSizeSmall: {
      margin: 2,
      maxWidth: 'calc(100% - 4px)'
    },

    /* Styles applied when the popup icon is rendered. */
    hasPopupIcon: {},

    /* Styles applied when the clear icon is rendered. */
    hasClearIcon: {},

    /* Styles applied to the Input element. */
    inputRoot: {
      flexWrap: 'wrap',
      '$hasPopupIcon &, $hasClearIcon &': {
        paddingRight: 26 + 4
      },
      '$hasPopupIcon$hasClearIcon &': {
        paddingRight: 52 + 4
      },
      '& $input': {
        width: 0,
        minWidth: 30
      },
      '&[class*="MuiInput-root"]': {
        paddingBottom: 1,
        '& $input': {
          padding: 4
        },
        '& $input:first-child': {
          padding: '6px 0'
        }
      },
      '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
        '& $input': {
          padding: '4px 4px 5px'
        },
        '& $input:first-child': {
          padding: '3px 0 6px'
        }
      },
      '&[class*="MuiOutlinedInput-root"]': {
        padding: 9,
        '$hasPopupIcon &, $hasClearIcon &': {
          paddingRight: 26 + 4 + 9
        },
        '$hasPopupIcon$hasClearIcon &': {
          paddingRight: 52 + 4 + 9
        },
        '& $input': {
          padding: '9.5px 4px'
        },
        '& $input:first-child': {
          paddingLeft: 6
        },
        '& $endAdornment': {
          right: 9
        }
      },
      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
        padding: 6,
        '& $input': {
          padding: '4.5px 4px'
        }
      },
      '&[class*="MuiFilledInput-root"]': {
        paddingTop: 19,
        paddingLeft: 8,
        '$hasPopupIcon &, $hasClearIcon &': {
          paddingRight: 26 + 4 + 9
        },
        '$hasPopupIcon$hasClearIcon &': {
          paddingRight: 52 + 4 + 9
        },
        '& $input': {
          padding: '9px 4px'
        },
        '& $endAdornment': {
          right: 9
        }
      },
      '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
        paddingBottom: 1,
        '& $input': {
          padding: '4.5px 4px'
        }
      }
    },

    /* Styles applied to the input element. */
    input: {
      flexGrow: 1,
      textOverflow: 'ellipsis',
      opacity: 0
    },

    /* Styles applied to the input element if tag focused. */
    inputFocused: {
      opacity: 1
    },

    /* Styles applied to the endAdornment element. */
    endAdornment: {
      // We use a position absolute to support wrapping tags.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 14px)' // Center vertically

    },

    /* Styles applied to the clear indicator. */
    clearIndicator: {
      marginRight: -2,
      padding: 4,
      visibility: 'hidden'
    },

    /* Styles applied to the clear indicator if the input is dirty. */
    clearIndicatorDirty: {},

    /* Styles applied to the popup indicator. */
    popupIndicator: {
      padding: 2,
      marginRight: -2
    },

    /* Styles applied to the popup indicator if the popup is open. */
    popupIndicatorOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the popper element. */
    popper: {
      zIndex: theme.zIndex.modal
    },

    /* Styles applied to the popper element if `disablePortal={true}`. */
    popperDisablePortal: {
      position: 'absolute'
    },

    /* Styles applied to the `Paper` component. */
    paper: _extends({}, theme.typography.body1, {
      overflow: 'hidden',
      margin: '4px 0'
    }),

    /* Styles applied to the `listbox` component. */
    listbox: {
      listStyle: 'none',
      margin: 0,
      padding: '8px 0',
      maxHeight: '40vh',
      overflow: 'auto'
    },

    /* Styles applied to the loading wrapper. */
    loading: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the no option wrapper. */
    noOptions: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the option elements. */
    option: (_option = {
      minHeight: 48,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      cursor: 'pointer',
      paddingTop: 6,
      boxSizing: 'border-box',
      outline: '0',
      WebkitTapHighlightColor: 'transparent',
      paddingBottom: 6,
      paddingLeft: 16,
      paddingRight: 16
    }, _defineProperty$d(_option, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    }), _defineProperty$d(_option, '&[aria-selected="true"]', {
      backgroundColor: theme.palette.action.selected
    }), _defineProperty$d(_option, '&[data-focus="true"]', {
      backgroundColor: theme.palette.action.hover
    }), _defineProperty$d(_option, '&:active', {
      backgroundColor: theme.palette.action.selected
    }), _defineProperty$d(_option, '&[aria-disabled="true"]', {
      opacity: theme.palette.action.disabledOpacity,
      pointerEvents: 'none'
    }), _option),

    /* Styles applied to the group's label elements. */
    groupLabel: {
      backgroundColor: theme.palette.background.paper,
      top: -8
    },

    /* Styles applied to the group's ul elements. */
    groupUl: {
      padding: 0,
      '& $option': {
        paddingLeft: 24
      }
    }
  };
};

function DisablePortal(props) {
  // eslint-disable-next-line react/prop-types
  props.anchorEl;
      props.open;
      var other = _objectWithoutProperties$4(props, ["anchorEl", "open"]);

  return /*#__PURE__*/React.createElement("div", other);
}

var _ref = /*#__PURE__*/React.createElement(CloseIcon$1, {
  fontSize: "small"
});

var _ref2 = /*#__PURE__*/React.createElement(ArrowDropDownIcon$2, null);

var Autocomplete = /*#__PURE__*/React.forwardRef(function Autocomplete(props, ref) {
  /* eslint-disable no-unused-vars */
  props.autoComplete;
      props.autoHighlight;
      props.autoSelect;
      props.blurOnSelect;
      var ChipProps = props.ChipProps,
      classes = props.classes,
      className = props.className,
      _props$clearOnBlur = props.clearOnBlur;
      _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur;
      props.clearOnEscape;
      var _props$clearText = props.clearText,
      clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
      _props$closeIcon = props.closeIcon,
      closeIcon = _props$closeIcon === void 0 ? _ref : _props$closeIcon,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText;
      props.debug;
      var _props$defaultValue = props.defaultValue;
      _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue;
      var _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab;
      props.disableCloseOnSelect;
      var _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled;
      props.disabledItemsFocusable;
      props.disableListWrap;
      var _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal;
      props.filterOptions;
      props.filterSelectedOptions;
      var _props$forcePopupIcon = props.forcePopupIcon,
      forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$getLimitTagsTe = props.getLimitTagsText,
      getLimitTagsText = _props$getLimitTagsTe === void 0 ? function (more) {
    return "+".concat(more);
  } : _props$getLimitTagsTe;
      props.getOptionDisabled;
      var _props$getOptionLabel = props.getOptionLabel,
      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
    return x;
  } : _props$getOptionLabel;
      props.getOptionSelected;
      var groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys;
      _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK;
      props.id;
      props.includeInputInList;
      props.inputValue;
      var _props$limitTags = props.limitTags,
      limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags,
      _props$ListboxCompone = props.ListboxComponent,
      ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
      ListboxProps = props.ListboxProps,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$loadingText = props.loadingText,
      loadingText = _props$loadingText === void 0 ? 'Loading…' : _props$loadingText,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$noOptionsText = props.noOptionsText,
      noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText;
      props.onChange;
      props.onClose;
      props.onHighlightChange;
      props.onInputChange;
      props.onOpen;
      props.open;
      props.openOnFocus;
      var _props$openText = props.openText,
      openText = _props$openText === void 0 ? 'Open' : _props$openText;
      props.options;
      var _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? Paper : _props$PaperComponent,
      _props$PopperComponen = props.PopperComponent,
      PopperComponentProp = _props$PopperComponen === void 0 ? R : _props$PopperComponen,
      _props$popupIcon = props.popupIcon,
      popupIcon = _props$popupIcon === void 0 ? _ref2 : _props$popupIcon,
      renderGroupProp = props.renderGroup,
      renderInput = props.renderInput,
      renderOptionProp = props.renderOption,
      renderTags = props.renderTags,
      _props$selectOnFocus = props.selectOnFocus;
      _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus;
      var _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size;
      props.value;
      var other = _objectWithoutProperties$4(props, ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "classes", "className", "clearOnBlur", "clearOnEscape", "clearText", "closeIcon", "closeText", "debug", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "getOptionSelected", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"]);
  /* eslint-enable no-unused-vars */


  var PopperComponent = disablePortal ? DisablePortal : PopperComponentProp;

  var _useAutocomplete = useAutocomplete(_extends({}, props, {
    componentName: 'Autocomplete'
  })),
      getRootProps = _useAutocomplete.getRootProps,
      getInputProps = _useAutocomplete.getInputProps,
      getInputLabelProps = _useAutocomplete.getInputLabelProps,
      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
      getClearProps = _useAutocomplete.getClearProps,
      getTagProps = _useAutocomplete.getTagProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getOptionProps = _useAutocomplete.getOptionProps,
      value = _useAutocomplete.value,
      dirty = _useAutocomplete.dirty,
      id = _useAutocomplete.id,
      popupOpen = _useAutocomplete.popupOpen,
      focused = _useAutocomplete.focused,
      focusedTag = _useAutocomplete.focusedTag,
      anchorEl = _useAutocomplete.anchorEl,
      setAnchorEl = _useAutocomplete.setAnchorEl,
      inputValue = _useAutocomplete.inputValue,
      groupedOptions = _useAutocomplete.groupedOptions;

  var startAdornment;

  if (multiple && value.length > 0) {
    var getCustomizedTagProps = function getCustomizedTagProps(params) {
      return _extends({
        className: clsx$1(classes.tag, size === 'small' && classes.tagSizeSmall),
        disabled: disabled
      }, getTagProps(params));
    };

    if (renderTags) {
      startAdornment = renderTags(value, getCustomizedTagProps);
    } else {
      startAdornment = value.map(function (option, index) {
        return /*#__PURE__*/React.createElement(Chip$1, _extends({
          label: getOptionLabel(option),
          size: size
        }, getCustomizedTagProps({
          index: index
        }), ChipProps));
      });
    }
  }

  if (limitTags > -1 && Array.isArray(startAdornment)) {
    var more = startAdornment.length - limitTags;

    if (!focused && more > 0) {
      startAdornment = startAdornment.splice(0, limitTags);
      startAdornment.push( /*#__PURE__*/React.createElement("span", {
        className: classes.tag,
        key: startAdornment.length
      }, getLimitTagsText(more)));
    }
  }

  var defaultRenderGroup = function defaultRenderGroup(params) {
    return /*#__PURE__*/React.createElement("li", {
      key: params.key
    }, /*#__PURE__*/React.createElement(ListSubheader, {
      className: classes.groupLabel,
      component: "div"
    }, params.group), /*#__PURE__*/React.createElement("ul", {
      className: classes.groupUl
    }, params.children));
  };

  var renderGroup = renderGroupProp || defaultRenderGroup;
  var renderOption = renderOptionProp || getOptionLabel;

  var renderListOption = function renderListOption(option, index) {
    var optionProps = getOptionProps({
      option: option,
      index: index
    });
    return /*#__PURE__*/React.createElement("li", _extends({}, optionProps, {
      className: classes.option
    }), renderOption(option, {
      selected: optionProps['aria-selected'],
      inputValue: inputValue
    }));
  };

  var hasClearIcon = !disableClearable && !disabled;
  var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    ref: ref,
    className: clsx$1(classes.root, className, focused && classes.focused, fullWidth && classes.fullWidth, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon)
  }, getRootProps(other)), renderInput({
    id: id,
    disabled: disabled,
    fullWidth: true,
    size: size === 'small' ? 'small' : undefined,
    InputLabelProps: getInputLabelProps(),
    InputProps: {
      ref: setAnchorEl,
      className: classes.inputRoot,
      startAdornment: startAdornment,
      endAdornment: /*#__PURE__*/React.createElement("div", {
        className: classes.endAdornment
      }, hasClearIcon ? /*#__PURE__*/React.createElement(IconButton, _extends({}, getClearProps(), {
        "aria-label": clearText,
        title: clearText,
        className: clsx$1(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
      }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/React.createElement(IconButton, _extends({}, getPopupIndicatorProps(), {
        disabled: disabled,
        "aria-label": popupOpen ? closeText : openText,
        title: popupOpen ? closeText : openText,
        className: clsx$1(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
      }), popupIcon) : null)
    },
    inputProps: _extends({
      className: clsx$1(classes.input, focusedTag === -1 && classes.inputFocused),
      disabled: disabled
    }, getInputProps())
  })), popupOpen && anchorEl ? /*#__PURE__*/React.createElement(PopperComponent, {
    className: clsx$1(classes.popper, disablePortal && classes.popperDisablePortal),
    style: {
      width: anchorEl ? anchorEl.clientWidth : null
    },
    role: "presentation",
    anchorEl: anchorEl,
    open: true
  }, /*#__PURE__*/React.createElement(PaperComponent, {
    className: classes.paper
  }, loading && groupedOptions.length === 0 ? /*#__PURE__*/React.createElement("div", {
    className: classes.loading
  }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/React.createElement("div", {
    className: classes.noOptions
  }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/React.createElement(ListboxComponent, _extends({
    className: classes.listbox
  }, getListboxProps(), ListboxProps), groupedOptions.map(function (option, index) {
    if (groupBy) {
      return renderGroup({
        key: option.key,
        group: option.group,
        children: option.options.map(function (option2, index2) {
          return renderListOption(option2, option.index + index2);
        })
      });
    }

    return renderListOption(option, index);
  })) : null)) : null);
});
process.env.NODE_ENV !== "production" ? Autocomplete.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */
  autoComplete: PropTypes.bool,

  /**
   * If `true`, the first option is automatically highlighted.
   */
  autoHighlight: PropTypes.bool,

  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */
  autoSelect: PropTypes.bool,

  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   */
  blurOnSelect: PropTypes.oneOfType([PropTypes.oneOf(['mouse', 'touch']), PropTypes.bool]),

  /**
   * Props applied to the [`Chip`](/api/chip/) element.
   */
  ChipProps: PropTypes.object,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the input's text will be cleared on blur if no value is selected.
   *
   * Set to `true` if you want to help the user enter a new value.
   * Set to `false` if you want to help the user resume his search.
   */
  clearOnBlur: PropTypes.bool,

  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */
  clearOnEscape: PropTypes.bool,

  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  clearText: PropTypes.string,

  /**
   * The icon to display in place of the default close icon.
   */
  closeIcon: PropTypes.node,

  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,

  /**
   * If `true`, the popup will ignore the blur event if the input is filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */
  debug: PropTypes.bool,

  /**
   * The default input value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the input can't be cleared.
   */
  disableClearable: PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * If `true`, the popup won't close when a value is selected.
   */
  disableCloseOnSelect: PropTypes.bool,

  /**
   * If `true`, the input will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, will allow focus on disabled items.
   */
  disabledItemsFocusable: PropTypes.bool,

  /**
   * If `true`, the list box in the popup will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * A filter function that determines the options that are eligible.
   *
   * @param {T[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {T[]}
   */
  filterOptions: PropTypes.func,

  /**
   * If `true`, hide the selected options from the list box.
   */
  filterSelectedOptions: PropTypes.bool,

  /**
   * Force the visibility display of the popup icon.
   */
  forcePopupIcon: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.bool]),

  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */
  freeSolo: PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   */
  getLimitTagsText: PropTypes.func,

  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {T} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: PropTypes.func,

  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * @param {T} option
   * @returns {string}
   */
  getOptionLabel: PropTypes.func,

  /**
   * Used to determine if an option is selected, considering the current value.
   * Uses strict equality by default.
   *
   * @param {T} option The option to test.
   * @param {T} value The value to test against.
   * @returns {boolean}
   */
  getOptionSelected: PropTypes.func,

  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {T} options The options to group.
   * @returns {string}
   */
  groupBy: PropTypes.func,

  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   */
  handleHomeEndKeys: PropTypes.bool,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * If `true`, the highlight can move to the input.
   */
  includeInputInList: PropTypes.bool,

  /**
   * The input value.
   */
  inputValue: PropTypes.string,

  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   */
  limitTags: PropTypes.number,

  /**
   * The component used to render the listbox.
   */
  ListboxComponent: PropTypes.elementType,

  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: PropTypes.object,

  /**
   * If `true`, the component is in a loading state.
   */
  loading: PropTypes.bool,

  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  loadingText: PropTypes.node,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes
  /* @typescript-to-proptypes-ignore */
  .bool,

  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  noOptionsText: PropTypes.node,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T|T[]} value The new value of the component.
   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"select-option"`, `"blur"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the highlight option changes.
   *
   * @param {object} event The event source of the callback.
   * @param {T} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`.
   */
  onHighlightChange: PropTypes.func,

  /**
   * Callback fired when the input value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control the popup` open state.
   */
  open: PropTypes.bool,

  /**
   * If `true`, the popup will open on input focus.
   */
  openOnFocus: PropTypes.bool,

  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  openText: PropTypes.string,

  /**
   * Array of options.
   */
  options: PropTypes.array.isRequired,

  /**
   * The component used to render the body of the popup.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * The component used to position the popup.
   */
  PopperComponent: PropTypes.elementType,

  /**
   * The icon to display in place of the default popup icon.
   */
  popupIcon: PropTypes.node,

  /**
   * Render the group.
   *
   * @param {any} option The group to render.
   * @returns {ReactNode}
   */
  renderGroup: PropTypes.func,

  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: PropTypes.func.isRequired,

  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {T} option The option to render.
   * @param {object} state The state of the component.
   * @returns {ReactNode}
   */
  renderOption: PropTypes.func,

  /**
   * Render the selected value.
   *
   * @param {T[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @returns {ReactNode}
   */
  renderTags: PropTypes.func,

  /**
   * If `true`, the input's text will be selected on focus.
   * It helps the user clear the selected value.
   */
  selectOnFocus: PropTypes.bool,

  /**
   * The size of the autocomplete.
   */
  size: PropTypes.oneOf(['medium', 'small']),

  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `getOptionSelected` prop.
   */
  value: PropTypes.any
} : void 0;
var Autocomplete$1 = withStyles(styles$P, {
  name: 'MuiAutocomplete'
})(Autocomplete);

function chainPropTypes$1(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

function isPlainObject$6(item) {
  return item && _typeof$4(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends({}, target) : target;

  if (isPlainObject$6(target) && isPlainObject$6(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject$6(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (process.env.NODE_ENV === 'production') {
    return propTypes;
  }

  return _extends({}, propTypes, _defineProperty$d({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

var reactIs$2 = {exports: {}};

var reactIs_production_min$1 = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min$1;

function requireReactIs_production_min$1 () {
	if (hasRequiredReactIs_production_min$1) return reactIs_production_min$1;
	hasRequiredReactIs_production_min$1 = 1;
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden");}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;reactIs_production_min$1.ContextConsumer=h;reactIs_production_min$1.ContextProvider=z;reactIs_production_min$1.Element=A;reactIs_production_min$1.ForwardRef=B;reactIs_production_min$1.Fragment=C;reactIs_production_min$1.Lazy=D;reactIs_production_min$1.Memo=E;reactIs_production_min$1.Portal=F;reactIs_production_min$1.Profiler=G;reactIs_production_min$1.StrictMode=H;
	reactIs_production_min$1.Suspense=I;reactIs_production_min$1.isAsyncMode=function(){return !1};reactIs_production_min$1.isConcurrentMode=function(){return !1};reactIs_production_min$1.isContextConsumer=function(a){return y(a)===h};reactIs_production_min$1.isContextProvider=function(a){return y(a)===g};reactIs_production_min$1.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min$1.isForwardRef=function(a){return y(a)===k};reactIs_production_min$1.isFragment=function(a){return y(a)===d};reactIs_production_min$1.isLazy=function(a){return y(a)===p};reactIs_production_min$1.isMemo=function(a){return y(a)===n};
	reactIs_production_min$1.isPortal=function(a){return y(a)===c};reactIs_production_min$1.isProfiler=function(a){return y(a)===f};reactIs_production_min$1.isStrictMode=function(a){return y(a)===e};reactIs_production_min$1.isSuspense=function(a){return y(a)===l};reactIs_production_min$1.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
	reactIs_production_min$1.typeOf=y;
	return reactIs_production_min$1;
}

var reactIs_development$1 = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development$1;

function requireReactIs_development$1 () {
	if (hasRequiredReactIs_development$1) return reactIs_development$1;
	hasRequiredReactIs_development$1 = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = 0xeac7;
	var REACT_PORTAL_TYPE = 0xeaca;
	var REACT_FRAGMENT_TYPE = 0xeacb;
	var REACT_STRICT_MODE_TYPE = 0xeacc;
	var REACT_PROFILER_TYPE = 0xead2;
	var REACT_PROVIDER_TYPE = 0xeacd;
	var REACT_CONTEXT_TYPE = 0xeace;
	var REACT_FORWARD_REF_TYPE = 0xead0;
	var REACT_SUSPENSE_TYPE = 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = 0xead8;
	var REACT_MEMO_TYPE = 0xead3;
	var REACT_LAZY_TYPE = 0xead4;
	var REACT_BLOCK_TYPE = 0xead9;
	var REACT_SERVER_BLOCK_TYPE = 0xeada;
	var REACT_FUNDAMENTAL_TYPE = 0xead5;
	var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
	var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

	if (typeof Symbol === 'function' && Symbol.for) {
	  var symbolFor = Symbol.for;
	  REACT_ELEMENT_TYPE = symbolFor('react.element');
	  REACT_PORTAL_TYPE = symbolFor('react.portal');
	  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
	  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
	  REACT_PROFILER_TYPE = symbolFor('react.profiler');
	  REACT_PROVIDER_TYPE = symbolFor('react.provider');
	  REACT_CONTEXT_TYPE = symbolFor('react.context');
	  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
	  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
	  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
	  REACT_MEMO_TYPE = symbolFor('react.memo');
	  REACT_LAZY_TYPE = symbolFor('react.lazy');
	  REACT_BLOCK_TYPE = symbolFor('react.block');
	  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
	  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
	  symbolFor('react.scope');
	  symbolFor('react.opaque.id');
	  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
	  symbolFor('react.offscreen');
	  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
	}

	// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

	var enableScopeAPI = false; // Experimental Create Event Handle API.

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development$1.ContextConsumer = ContextConsumer;
	reactIs_development$1.ContextProvider = ContextProvider;
	reactIs_development$1.Element = Element;
	reactIs_development$1.ForwardRef = ForwardRef;
	reactIs_development$1.Fragment = Fragment;
	reactIs_development$1.Lazy = Lazy;
	reactIs_development$1.Memo = Memo;
	reactIs_development$1.Portal = Portal;
	reactIs_development$1.Profiler = Profiler;
	reactIs_development$1.StrictMode = StrictMode;
	reactIs_development$1.Suspense = Suspense;
	reactIs_development$1.isAsyncMode = isAsyncMode;
	reactIs_development$1.isConcurrentMode = isConcurrentMode;
	reactIs_development$1.isContextConsumer = isContextConsumer;
	reactIs_development$1.isContextProvider = isContextProvider;
	reactIs_development$1.isElement = isElement;
	reactIs_development$1.isForwardRef = isForwardRef;
	reactIs_development$1.isFragment = isFragment;
	reactIs_development$1.isLazy = isLazy;
	reactIs_development$1.isMemo = isMemo;
	reactIs_development$1.isPortal = isPortal;
	reactIs_development$1.isProfiler = isProfiler;
	reactIs_development$1.isStrictMode = isStrictMode;
	reactIs_development$1.isSuspense = isSuspense;
	reactIs_development$1.isValidElementType = isValidElementType;
	reactIs_development$1.typeOf = typeOf;
	  })();
	}
	return reactIs_development$1;
}

if (process.env.NODE_ENV === 'production') {
  reactIs$2.exports = requireReactIs_production_min$1();
} else {
  reactIs$2.exports = requireReactIs_development$1();
}

var reactIsExports$1 = reactIs$2.exports;

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName$2(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (_typeof$4(Component) === 'object') {
    switch (Component.$$typeof) {
      case reactIsExports$1.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case reactIsExports$1.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

function _arrayWithoutHoles$3(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$8(arr);
}

function _iterableToArray$4(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread$3() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$3(arr) {
  return _arrayWithoutHoles$3(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$8(arr) || _nonIterableSpread$3();
}

function usePagination() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // keep default values in sync with @default tags in Pagination.propTypes
  var _props$boundaryCount = props.boundaryCount,
      boundaryCount = _props$boundaryCount === void 0 ? 1 : _props$boundaryCount,
      _props$componentName = props.componentName,
      componentName = _props$componentName === void 0 ? 'usePagination' : _props$componentName,
      _props$count = props.count,
      count = _props$count === void 0 ? 1 : _props$count,
      _props$defaultPage = props.defaultPage,
      defaultPage = _props$defaultPage === void 0 ? 1 : _props$defaultPage,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$hideNextButton = props.hideNextButton,
      hideNextButton = _props$hideNextButton === void 0 ? false : _props$hideNextButton,
      _props$hidePrevButton = props.hidePrevButton,
      hidePrevButton = _props$hidePrevButton === void 0 ? false : _props$hidePrevButton,
      handleChange = props.onChange,
      pageProp = props.page,
      _props$showFirstButto = props.showFirstButton,
      showFirstButton = _props$showFirstButto === void 0 ? false : _props$showFirstButto,
      _props$showLastButton = props.showLastButton,
      showLastButton = _props$showLastButton === void 0 ? false : _props$showLastButton,
      _props$siblingCount = props.siblingCount,
      siblingCount = _props$siblingCount === void 0 ? 1 : _props$siblingCount,
      other = _objectWithoutProperties$4(props, ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"]);

  var _useControlled = useControlled({
    controlled: pageProp,
    default: defaultPage,
    name: componentName,
    state: 'page'
  }),
      _useControlled2 = _slicedToArray$8(_useControlled, 2),
      page = _useControlled2[0],
      setPageState = _useControlled2[1];

  var handleClick = function handleClick(event, value) {
    if (!pageProp) {
      setPageState(value);
    }

    if (handleChange) {
      handleChange(event, value);
    }
  }; // https://dev.to/namirsab/comment/2050


  var range = function range(start, end) {
    var length = end - start + 1;
    return Array.from({
      length: length
    }, function (_, i) {
      return start + i;
    });
  };

  var startPages = range(1, Math.min(boundaryCount, count));
  var endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
  var siblingsStart = Math.max(Math.min( // Natural start
  page - siblingCount, // Lower boundary when page is high
  count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
  boundaryCount + 2);
  var siblingsEnd = Math.min(Math.max( // Natural end
  page + siblingCount, // Upper boundary when page is low
  boundaryCount + siblingCount * 2 + 2), // Less than endPages
  endPages[0] - 2); // Basic list of items to render
  // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']

  var itemList = [].concat(_toConsumableArray$3(showFirstButton ? ['first'] : []), _toConsumableArray$3(hidePrevButton ? [] : ['previous']), _toConsumableArray$3(startPages), _toConsumableArray$3(siblingsStart > boundaryCount + 2 ? ['start-ellipsis'] : boundaryCount + 1 < count - boundaryCount ? [boundaryCount + 1] : []), _toConsumableArray$3(range(siblingsStart, siblingsEnd)), _toConsumableArray$3(siblingsEnd < count - boundaryCount - 1 ? ['end-ellipsis'] : count - boundaryCount > boundaryCount ? [count - boundaryCount] : []), _toConsumableArray$3(endPages), _toConsumableArray$3(hideNextButton ? [] : ['next']), _toConsumableArray$3(showLastButton ? ['last'] : [])); // Map the button type to its page number

  var buttonPage = function buttonPage(type) {
    switch (type) {
      case 'first':
        return 1;

      case 'previous':
        return page - 1;

      case 'next':
        return page + 1;

      case 'last':
        return count;

      default:
        return null;
    }
  }; // Convert the basic item list to PaginationItem props objects


  var items = itemList.map(function (item) {
    return typeof item === 'number' ? {
      onClick: function onClick(event) {
        handleClick(event, item);
      },
      type: 'page',
      page: item,
      selected: item === page,
      disabled: disabled,
      'aria-current': item === page ? 'true' : undefined
    } : {
      onClick: function onClick(event) {
        handleClick(event, buttonPage(item));
      },
      type: item,
      page: buttonPage(item),
      selected: false,
      disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
    };
  });
  return _extends({
    items: items
  }, other);
}

/**
 * @ignore - internal component.
 */

var FirstPageIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

/**
 * @ignore - internal component.
 */

var LastPageIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

/**
 * @ignore - internal component.
 */

var NavigateBeforeIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

/**
 * @ignore - internal component.
 */

var NavigateNextIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

var styles$O = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends({}, theme.typography.body2, {
      borderRadius: 32 / 2,
      textAlign: 'center',
      boxSizing: 'border-box',
      minWidth: 32,
      height: 32,
      padding: '0 6px',
      margin: '0 3px',
      color: theme.palette.text.primary
    }),

    /* Styles applied to the root element if `type="page"`. */
    page: {
      transition: theme.transitions.create(['color', 'background-color'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$focusVisible': {
        backgroundColor: theme.palette.action.focus
      },
      '&$selected': {
        backgroundColor: theme.palette.action.selected,
        '&:hover, &$focusVisible': {
          backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.action.selected
          }
        },
        '&$disabled': {
          opacity: 1,
          color: theme.palette.action.disabled,
          backgroundColor: theme.palette.action.selected
        }
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Styles applied applied to the root element if `size="small"`. */
    sizeSmall: {
      minWidth: 26,
      height: 26,
      borderRadius: 26 / 2,
      margin: '0 1px',
      padding: '0 4px',
      '& $icon': {
        fontSize: theme.typography.pxToRem(18)
      }
    },

    /* Styles applied applied to the root element if `size="large"`. */
    sizeLarge: {
      minWidth: 40,
      height: 40,
      borderRadius: 40 / 2,
      padding: '0 10px',
      fontSize: theme.typography.pxToRem(15),
      '& $icon': {
        fontSize: theme.typography.pxToRem(22)
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      '&$selected': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover, &$focusVisible': {
          backgroundColor: theme.palette.primary.dark,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.primary.main
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      '&$selected': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.main,
        '&:hover, &$focusVisible': {
          backgroundColor: theme.palette.secondary.dark,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.secondary.main
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `outlined="true"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$selected': {
        '&$disabled': {
          border: "1px solid ".concat(theme.palette.action.disabledBackground)
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      '&$selected': {
        color: theme.palette.primary.main,
        border: "1px solid ".concat(alpha(theme.palette.primary.main, 0.5)),
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        '&:hover, &$focusVisible': {
          backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      '&$selected': {
        color: theme.palette.secondary.main,
        border: "1px solid ".concat(alpha(theme.palette.secondary.main, 0.5)),
        backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.activatedOpacity),
        '&:hover, &$focusVisible': {
          backgroundColor: alpha(theme.palette.secondary.main, theme.palette.action.activatedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `rounded="true"`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `type="start-ellipsis"` or `type="end-ellipsis"`. */
    ellipsis: {
      height: 'auto',
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element if keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the icon element. */
    icon: {
      fontSize: theme.typography.pxToRem(20),
      margin: '0 -8px'
    }
  };
};
var PaginationItem = /*#__PURE__*/React.forwardRef(function PaginationItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'standard' : _props$color,
      component = props.component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      page = props.page,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'round' : _props$shape,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'page' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties$4(props, ["classes", "className", "color", "component", "disabled", "page", "selected", "shape", "size", "type", "variant"]);

  var theme = useTheme$2();
  var normalizedIcons = theme.direction === 'rtl' ? {
    previous: NavigateNextIcon,
    next: NavigateBeforeIcon,
    last: FirstPageIcon,
    first: LastPageIcon
  } : {
    previous: NavigateBeforeIcon,
    next: NavigateNextIcon,
    first: FirstPageIcon,
    last: LastPageIcon
  };
  var Icon = normalizedIcons[type];
  return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: clsx$1(classes.root, classes.ellipsis, disabled && classes.disabled, size !== 'medium' && classes["size".concat(capitalize(size))])
  }, "\u2026") : /*#__PURE__*/React.createElement(ButtonBase, _extends({
    ref: ref,
    component: component,
    disabled: disabled,
    focusVisibleClassName: classes.focusVisible,
    className: clsx$1(classes.root, classes.page, classes[variant], classes[shape], className, color !== 'standard' && classes["".concat(variant).concat(capitalize(color))], disabled && classes.disabled, selected && classes.selected, size !== 'medium' && classes["size".concat(capitalize(size))])
  }, other), type === 'page' && page, Icon ? /*#__PURE__*/React.createElement(Icon, {
    className: classes.icon
  }) : null);
});
process.env.NODE_ENV !== "production" ? PaginationItem.propTypes = {
  /**
   * @ignore
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The active color.
   */
  color: PropTypes.oneOf(['standard', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the item will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The current page number.
   */
  page: PropTypes.number,

  /**
   * If `true` the pagination item is selected.
   */
  selected: PropTypes.bool,

  /**
   * The shape of the pagination item.
   */
  shape: PropTypes.oneOf(['round', 'rounded']),

  /**
   * The size of the pagination item.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The type of pagination item.
   */
  type: PropTypes.oneOf(['page', 'first', 'last', 'next', 'previous', 'start-ellipsis', 'end-ellipsis']),

  /**
   * The pagination item variant.
   */
  variant: PropTypes.oneOf(['text', 'outlined'])
} : void 0;
var PaginationItem$1 = withStyles(styles$O, {
  name: 'MuiPaginationItem'
})(PaginationItem);

var styles$N = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ul element. */
  ul: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  }
};

function defaultGetAriaLabel(type, page, selected) {
  if (type === 'page') {
    return "".concat(selected ? '' : 'Go to ', "page ").concat(page);
  }

  return "Go to ".concat(type, " page");
}

var Pagination$1 = /*#__PURE__*/React.forwardRef(function Pagination(props, ref) {
  props.boundaryCount;
      var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'standard' : _props$color;
      props.count;
      props.defaultPage;
      props.disabled;
      var _props$getItemAriaLab = props.getItemAriaLabel,
      getItemAriaLabel = _props$getItemAriaLab === void 0 ? defaultGetAriaLabel : _props$getItemAriaLab;
      props.hideNextButton;
      props.hidePrevButton;
      props.onChange;
      props.page;
      var _props$renderItem = props.renderItem,
      renderItem = _props$renderItem === void 0 ? function (item) {
    return /*#__PURE__*/React.createElement(PaginationItem$1, item);
  } : _props$renderItem,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'round' : _props$shape;
      props.showFirstButton;
      props.showLastButton;
      props.siblingCount;
      var _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties$4(props, ["boundaryCount", "classes", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"]);

  var _usePagination = usePagination(_extends({}, props, {
    componentName: 'Pagination'
  })),
      items = _usePagination.items;

  return /*#__PURE__*/React.createElement("nav", _extends({
    "aria-label": "pagination navigation",
    className: clsx$1(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/React.createElement("ul", {
    className: classes.ul
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, renderItem(_extends({}, item, {
      color: color,
      'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
      shape: shape,
      size: size,
      variant: variant
    })));
  })));
}); // @default tags synced with default values from usePagination

process.env.NODE_ENV !== "production" ? Pagination$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: PropTypes.number,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The active color.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'standard']),

  /**
   * The total number of pages.
   * @default 1
   */
  count: PropTypes.number,

  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: PropTypes.number,

  /**
   * If `true`, the pagination component will be disabled.
   * @default false
   */
  disabled: PropTypes.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: PropTypes.func,

  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: PropTypes.bool,

  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: PropTypes.bool,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: PropTypes.func,

  /**
   * The current page.
   */
  page: PropTypes.number,

  /**
   * Render the item.
   *
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   */
  renderItem: PropTypes.func,

  /**
   * The shape of the pagination items.
   */
  shape: PropTypes.oneOf(['round', 'rounded']),

  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: PropTypes.bool,

  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: PropTypes.bool,

  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: PropTypes.number,

  /**
   * The size of the pagination component.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['outlined', 'text'])
} : void 0;
var MuiPagination = withStyles(styles$N, {
  name: 'MuiPagination'
})(Pagination$1);

/**
 * @ignore - internal component.
 */

var Star = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star');

function clamp$1(value, min, max) {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}

function getDecimalPrecision(num) {
  var decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function roundValueToPrecision(value, precision) {
  if (value == null) {
    return value;
  }

  var nearest = Math.round(value / precision) * precision;
  return Number(nearest.toFixed(getDecimalPrecision(precision)));
}

var styles$M = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      position: 'relative',
      fontSize: theme.typography.pxToRem(24),
      color: '#ffb400',
      cursor: 'pointer',
      textAlign: 'left',
      WebkitTapHighlightColor: 'transparent',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '&$focusVisible $iconActive': {
        outline: '1px solid #999'
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      fontSize: theme.typography.pxToRem(30)
    },

    /* Styles applied to the root element if `readOnly={true}`. */
    readOnly: {
      pointerEvents: 'none'
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if keyboard focused. */
    focusVisible: {},

    /* Visually hide an element. */
    visuallyhidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      color: '#000',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1
    },

    /* Styles applied to the pristine label. */
    pristine: {
      'input:focus + &': {
        top: 0,
        bottom: 0,
        position: 'absolute',
        outline: '1px solid #999',
        width: '100%'
      }
    },

    /* Styles applied to the label elements. */
    label: {
      cursor: 'inherit'
    },

    /* Styles applied to the icon wrapping elements. */
    icon: {
      display: 'flex',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      }),
      // Fix mouseLeave issue.
      // https://github.com/facebook/react/issues/4492
      pointerEvents: 'none'
    },

    /* Styles applied to the icon wrapping elements when empty. */
    iconEmpty: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the icon wrapping elements when filled. */
    iconFilled: {},

    /* Styles applied to the icon wrapping elements when hover. */
    iconHover: {},

    /* Styles applied to the icon wrapping elements when focus. */
    iconFocus: {},

    /* Styles applied to the icon wrapping elements when active. */
    iconActive: {
      transform: 'scale(1.2)'
    },

    /* Styles applied to the icon wrapping elements when decimals are necessary. */
    decimal: {
      position: 'relative'
    }
  };
};

function IconContainer(props) {
  props.value;
      var other = _objectWithoutProperties$4(props, ["value"]);

  return /*#__PURE__*/React.createElement("span", other);
}

process.env.NODE_ENV !== "production" ? IconContainer.propTypes = {
  value: PropTypes.number.isRequired
} : void 0;
var defaultIcon$1 = /*#__PURE__*/React.createElement(Star, {
  fontSize: "inherit"
});

function defaultLabelText(value) {
  return "".concat(value, " Star").concat(value !== 1 ? 's' : '');
}

var Rating = /*#__PURE__*/React.forwardRef(function Rating(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? null : _props$defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      emptyIcon = props.emptyIcon,
      _props$emptyLabelText = props.emptyLabelText,
      emptyLabelText = _props$emptyLabelText === void 0 ? 'Empty' : _props$emptyLabelText,
      _props$getLabelText = props.getLabelText,
      getLabelText = _props$getLabelText === void 0 ? defaultLabelText : _props$getLabelText,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? defaultIcon$1 : _props$icon,
      _props$IconContainerC = props.IconContainerComponent,
      IconContainerComponent = _props$IconContainerC === void 0 ? IconContainer : _props$IconContainerC,
      _props$max = props.max,
      max = _props$max === void 0 ? 5 : _props$max,
      nameProp = props.name,
      onChange = props.onChange,
      onChangeActive = props.onChangeActive,
      onMouseLeave = props.onMouseLeave,
      onMouseMove = props.onMouseMove,
      _props$precision = props.precision,
      precision = _props$precision === void 0 ? 1 : _props$precision,
      _props$readOnly = props.readOnly,
      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      valueProp = props.value,
      other = _objectWithoutProperties$4(props, ["classes", "className", "defaultValue", "disabled", "emptyIcon", "emptyLabelText", "getLabelText", "icon", "IconContainerComponent", "max", "name", "onChange", "onChangeActive", "onMouseLeave", "onMouseMove", "precision", "readOnly", "size", "value"]);

  var name = unstable_useId(nameProp);

  var _useControlled = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'Rating'
  }),
      _useControlled2 = _slicedToArray$8(_useControlled, 2),
      valueDerived = _useControlled2[0],
      setValueState = _useControlled2[1];

  var valueRounded = roundValueToPrecision(valueDerived, precision);
  var theme = useTheme$2();

  var _React$useState = React.useState({
    hover: -1,
    focus: -1
  }),
      _React$useState$ = _React$useState[0],
      hover = _React$useState$.hover,
      focus = _React$useState$.focus,
      setState = _React$useState[1];

  var value = valueRounded;

  if (hover !== -1) {
    value = hover;
  }

  if (focus !== -1) {
    value = focus;
  }

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState2 = React.useState(false),
      focusVisible = _React$useState2[0],
      setFocusVisible = _React$useState2[1];

  var rootRef = React.useRef();
  var handleFocusRef = useForkRef(focusVisibleRef, rootRef);
  var handleRef = useForkRef(handleFocusRef, ref);

  var handleMouseMove = function handleMouseMove(event) {
    if (onMouseMove) {
      onMouseMove(event);
    }

    var rootNode = rootRef.current;

    var _rootNode$getBounding = rootNode.getBoundingClientRect(),
        right = _rootNode$getBounding.right,
        left = _rootNode$getBounding.left;

    var _rootNode$firstChild$ = rootNode.firstChild.getBoundingClientRect(),
        width = _rootNode$firstChild$.width;

    var percent;

    if (theme.direction === 'rtl') {
      percent = (right - event.clientX) / (width * max);
    } else {
      percent = (event.clientX - left) / (width * max);
    }

    var newHover = roundValueToPrecision(max * percent + precision / 2, precision);
    newHover = clamp$1(newHover, precision, max);
    setState(function (prev) {
      return prev.hover === newHover && prev.focus === newHover ? prev : {
        hover: newHover,
        focus: newHover
      };
    });
    setFocusVisible(false);

    if (onChangeActive && hover !== newHover) {
      onChangeActive(event, newHover);
    }
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    var newHover = -1;
    setState({
      hover: newHover,
      focus: newHover
    });

    if (onChangeActive && hover !== newHover) {
      onChangeActive(event, newHover);
    }
  };

  var handleChange = function handleChange(event) {
    var newValue = parseFloat(event.target.value);
    setValueState(newValue);

    if (onChange) {
      onChange(event, newValue);
    }
  };

  var handleClear = function handleClear(event) {
    // Ignore keyboard events
    // https://github.com/facebook/react/issues/7407
    if (event.clientX === 0 && event.clientY === 0) {
      return;
    }

    setState({
      hover: -1,
      focus: -1
    });
    setValueState(null);

    if (onChange && parseFloat(event.target.value) === valueRounded) {
      onChange(event, null);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    var newFocus = parseFloat(event.target.value);
    setState(function (prev) {
      return {
        hover: prev.hover,
        focus: newFocus
      };
    });

    if (onChangeActive && focus !== newFocus) {
      onChangeActive(event, newFocus);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (hover !== -1) {
      return;
    }

    if (focusVisible !== false) {
      setFocusVisible(false);
      onBlurVisible();
    }

    var newFocus = -1;
    setState(function (prev) {
      return {
        hover: prev.hover,
        focus: newFocus
      };
    });

    if (onChangeActive && focus !== newFocus) {
      onChangeActive(event, newFocus);
    }
  };

  var item = function item(state, labelProps) {
    var id = "".concat(name, "-").concat(String(state.value).replace('.', '-'));
    var container = /*#__PURE__*/React.createElement(IconContainerComponent, {
      value: state.value,
      className: clsx$1(classes.icon, state.filled ? classes.iconFilled : classes.iconEmpty, state.hover && classes.iconHover, state.focus && classes.iconFocus, state.active && classes.iconActive)
    }, emptyIcon && !state.filled ? emptyIcon : icon);

    if (readOnly) {
      return /*#__PURE__*/React.createElement("span", _extends({
        key: state.value
      }, labelProps), container);
    }

    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: state.value
    }, /*#__PURE__*/React.createElement("label", _extends({
      className: classes.label,
      htmlFor: id
    }, labelProps), container, /*#__PURE__*/React.createElement("span", {
      className: classes.visuallyhidden
    }, getLabelText(state.value))), /*#__PURE__*/React.createElement("input", {
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange,
      onClick: handleClear,
      disabled: disabled,
      value: state.value,
      id: id,
      type: "radio",
      name: name,
      checked: state.checked,
      className: classes.visuallyhidden
    }));
  };

  return /*#__PURE__*/React.createElement("span", _extends({
    ref: handleRef,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
    className: clsx$1(classes.root, className, size !== 'medium' && classes["size".concat(capitalize(size))], disabled && classes.disabled, focusVisible && classes.focusVisible, readOnly && classes.readOnly),
    role: readOnly ? 'img' : null,
    "aria-label": readOnly ? getLabelText(value) : null
  }, other), Array.from(new Array(max)).map(function (_, index) {
    var itemValue = index + 1;

    if (precision < 1) {
      var items = Array.from(new Array(1 / precision));
      return /*#__PURE__*/React.createElement("span", {
        key: itemValue,
        className: clsx$1(classes.decimal, itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1) && classes.iconActive)
      }, items.map(function ($, indexDecimal) {
        var itemDecimalValue = roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
        return item({
          value: itemDecimalValue,
          filled: itemDecimalValue <= value,
          hover: itemDecimalValue <= hover,
          focus: itemDecimalValue <= focus,
          checked: itemDecimalValue === valueRounded
        }, {
          style: items.length - 1 === indexDecimal ? {} : {
            width: itemDecimalValue === value ? "".concat((indexDecimal + 1) * precision * 100, "%") : '0%',
            overflow: 'hidden',
            zIndex: 1,
            position: 'absolute'
          }
        });
      }));
    }

    return item({
      value: itemValue,
      active: itemValue === value && (hover !== -1 || focus !== -1),
      filled: itemValue <= value,
      hover: itemValue <= hover,
      focus: itemValue <= focus,
      checked: itemValue === valueRounded
    });
  }), !readOnly && !disabled && valueRounded == null && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    value: "",
    id: "".concat(name, "-empty"),
    type: "radio",
    name: name,
    defaultChecked: true,
    className: classes.visuallyhidden
  }), /*#__PURE__*/React.createElement("label", {
    className: classes.pristine,
    htmlFor: "".concat(name, "-empty")
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.visuallyhidden
  }, emptyLabelText))));
});
process.env.NODE_ENV !== "production" ? Rating.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.number,

  /**
   * If `true`, the rating will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon to display when empty.
   */
  emptyIcon: PropTypes.node,

  /**
   * The label read when the rating input is empty.
   */
  emptyLabelText: PropTypes.node,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the rating.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   *
   * @param {number} value The rating label's value to format.
   * @returns {string}
   */
  getLabelText: PropTypes.func,

  /**
   * The icon to display.
   */
  icon: PropTypes.node,

  /**
   * The component containing the icon.
   */
  IconContainerComponent: PropTypes.elementType,

  /**
   * Maximum rating.
   */
  max: PropTypes.number,

  /**
   * The name attribute of the radio `input` elements.
   * If `readOnly` is false, the prop is required,
   * this input name`should be unique within the parent form.
   */
  name: chainPropTypes$1(PropTypes.string, function (props) {
    if (!props.readOnly && !props.name) {
      return new Error(['Material-UI: The prop `name` is required (when `readOnly` is false).', 'Additionally, the input name should be unique within the parent form.'].join('\n'));
    }

    return null;
  }),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChange: PropTypes.func,

  /**
   * Callback function that is fired when the hover state changes.
   *
   * @param {object} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChangeActive: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * @ignore
   */
  onMouseMove: PropTypes.func,

  /**
   * The minimum increment value change allowed.
   */
  precision: chainPropTypes$1(PropTypes.number, function (props) {
    if (props.precision < 0.1) {
      return new Error(['Material-UI: The prop `precision` should be above 0.1.', 'A value below this limit has an imperceptible impact.'].join('\n'));
    }

    return null;
  }),

  /**
   * Removes all hover effects and pointer events.
   */
  readOnly: PropTypes.bool,

  /**
   * The size of the rating.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The rating value.
   */
  value: PropTypes.number
} : void 0;
var Rating$1 = withStyles(styles$M, {
  name: 'MuiRating'
})(Rating);

/**
 * @ignore - internal component.
 */

var TreeViewContext = React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  TreeViewContext.displayName = 'TreeViewContext';
}

var TreeViewContext$1 = TreeViewContext;

var styles$L = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      outline: 0,
      WebkitTapHighlightColor: 'transparent',
      '&:focus > $content $label': {
        backgroundColor: theme.palette.action.hover
      },
      '&$selected > $content $label': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
      },
      '&$selected > $content $label:hover, &$selected:focus > $content $label': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element when expanded. */
    expanded: {},

    /* Pseudo-class applied to the root element when selected. */
    selected: {},

    /* Styles applied to the `role="group"` element. */
    group: {
      margin: 0,
      padding: 0,
      marginLeft: 17
    },

    /* Styles applied to the tree node content. */
    content: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer'
    },

    /* Styles applied to the tree node icon and collapse/expand icon. */
    iconContainer: {
      marginRight: 4,
      width: 15,
      display: 'flex',
      flexShrink: 0,
      justifyContent: 'center',
      '& svg': {
        fontSize: 18
      }
    },

    /* Styles applied to the label element. */
    label: {
      width: '100%',
      paddingLeft: 4,
      position: 'relative',
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }
  };
};

var isPrintableCharacter = function isPrintableCharacter(str) {
  return str && str.length === 1 && str.match(/\S/);
};

var TreeItem = /*#__PURE__*/React.forwardRef(function TreeItem(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      collapseIcon = props.collapseIcon,
      endIcon = props.endIcon,
      expandIcon = props.expandIcon,
      iconProp = props.icon,
      label = props.label,
      nodeId = props.nodeId,
      onClick = props.onClick,
      onLabelClick = props.onLabelClick,
      onIconClick = props.onIconClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onMouseDown = props.onMouseDown,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Collapse : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = _objectWithoutProperties$4(props, ["children", "classes", "className", "collapseIcon", "endIcon", "expandIcon", "icon", "label", "nodeId", "onClick", "onLabelClick", "onIconClick", "onFocus", "onKeyDown", "onMouseDown", "TransitionComponent", "TransitionProps"]);

  var _React$useContext = React.useContext(TreeViewContext$1),
      contextIcons = _React$useContext.icons,
      focus = _React$useContext.focus,
      focusFirstNode = _React$useContext.focusFirstNode,
      focusLastNode = _React$useContext.focusLastNode,
      focusNextNode = _React$useContext.focusNextNode,
      focusPreviousNode = _React$useContext.focusPreviousNode,
      focusByFirstCharacter = _React$useContext.focusByFirstCharacter,
      selectNode = _React$useContext.selectNode,
      selectRange = _React$useContext.selectRange,
      selectNextNode = _React$useContext.selectNextNode,
      selectPreviousNode = _React$useContext.selectPreviousNode,
      rangeSelectToFirst = _React$useContext.rangeSelectToFirst,
      rangeSelectToLast = _React$useContext.rangeSelectToLast,
      selectAllNodes = _React$useContext.selectAllNodes,
      expandAllSiblings = _React$useContext.expandAllSiblings,
      toggleExpansion = _React$useContext.toggleExpansion,
      isExpanded = _React$useContext.isExpanded,
      isFocused = _React$useContext.isFocused,
      isSelected = _React$useContext.isSelected,
      isTabbable = _React$useContext.isTabbable,
      multiSelect = _React$useContext.multiSelect,
      getParent = _React$useContext.getParent,
      mapFirstChar = _React$useContext.mapFirstChar,
      addNodeToNodeMap = _React$useContext.addNodeToNodeMap,
      removeNodeFromNodeMap = _React$useContext.removeNodeFromNodeMap;

  var nodeRef = React.useRef(null);
  var contentRef = React.useRef(null);
  var handleRef = useForkRef(nodeRef, ref);
  var icon = iconProp;
  var expandable = Boolean(Array.isArray(children) ? children.length : children);
  var expanded = isExpanded ? isExpanded(nodeId) : false;
  var focused = isFocused ? isFocused(nodeId) : false;
  var tabbable = isTabbable ? isTabbable(nodeId) : false;
  var selected = isSelected ? isSelected(nodeId) : false;
  var icons = contextIcons || {};
  var theme = useTheme$2();

  if (!icon) {
    if (expandable) {
      if (!expanded) {
        icon = expandIcon || icons.defaultExpandIcon;
      } else {
        icon = collapseIcon || icons.defaultCollapseIcon;
      }

      if (!icon) {
        icon = icons.defaultParentIcon;
      }
    } else {
      icon = endIcon || icons.defaultEndIcon;
    }
  }

  var handleClick = function handleClick(event) {
    if (!focused) {
      focus(nodeId);
    }

    var multiple = multiSelect && (event.shiftKey || event.ctrlKey || event.metaKey); // If already expanded and trying to toggle selection don't close

    if (expandable && !event.defaultPrevented && !(multiple && isExpanded(nodeId))) {
      toggleExpansion(event, nodeId);
    }

    if (multiple) {
      if (event.shiftKey) {
        selectRange(event, {
          end: nodeId
        });
      } else {
        selectNode(event, nodeId, true);
      }
    } else {
      selectNode(event, nodeId);
    }

    if (onClick) {
      onClick(event);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    if (event.shiftKey || event.ctrlKey || event.metaKey) {
      event.preventDefault();
    }

    if (onMouseDown) {
      onMouseDown(event);
    }
  };

  var handleNextArrow = function handleNextArrow(event) {
    if (expandable) {
      if (expanded) {
        focusNextNode(nodeId);
      } else {
        toggleExpansion(event);
      }
    }

    return true;
  };

  var handlePreviousArrow = function handlePreviousArrow(event) {
    if (expanded) {
      toggleExpansion(event, nodeId);
      return true;
    }

    var parent = getParent(nodeId);

    if (parent) {
      focus(parent);
      return true;
    }

    return false;
  };

  var handleKeyDown = function handleKeyDown(event) {
    var flag = false;
    var key = event.key;

    if (event.altKey || event.currentTarget !== event.target) {
      return;
    }

    var ctrlPressed = event.ctrlKey || event.metaKey;

    switch (key) {
      case ' ':
        if (nodeRef.current === event.currentTarget) {
          if (multiSelect && event.shiftKey) {
            flag = selectRange(event, {
              end: nodeId
            });
          } else if (multiSelect) {
            flag = selectNode(event, nodeId, true);
          } else {
            flag = selectNode(event, nodeId);
          }
        }

        event.stopPropagation();
        break;

      case 'Enter':
        if (nodeRef.current === event.currentTarget && expandable) {
          toggleExpansion(event);
          flag = true;
        }

        event.stopPropagation();
        break;

      case 'ArrowDown':
        if (multiSelect && event.shiftKey) {
          selectNextNode(event, nodeId);
        }

        focusNextNode(nodeId);
        flag = true;
        break;

      case 'ArrowUp':
        if (multiSelect && event.shiftKey) {
          selectPreviousNode(event, nodeId);
        }

        focusPreviousNode(nodeId);
        flag = true;
        break;

      case 'ArrowRight':
        if (theme.direction === 'rtl') {
          flag = handlePreviousArrow(event);
        } else {
          flag = handleNextArrow(event);
        }

        break;

      case 'ArrowLeft':
        if (theme.direction === 'rtl') {
          flag = handleNextArrow(event);
        } else {
          flag = handlePreviousArrow(event);
        }

        break;

      case 'Home':
        if (multiSelect && ctrlPressed && event.shiftKey) {
          rangeSelectToFirst(event, nodeId);
        }

        focusFirstNode();
        flag = true;
        break;

      case 'End':
        if (multiSelect && ctrlPressed && event.shiftKey) {
          rangeSelectToLast(event, nodeId);
        }

        focusLastNode();
        flag = true;
        break;

      default:
        if (key === '*') {
          expandAllSiblings(event, nodeId);
          flag = true;
        } else if (multiSelect && ctrlPressed && key.toLowerCase() === 'a') {
          flag = selectAllNodes(event);
        } else if (!ctrlPressed && !event.shiftKey && isPrintableCharacter(key)) {
          focusByFirstCharacter(nodeId, key);
          flag = true;
        }

    }

    if (flag) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (!focused && event.currentTarget === event.target) {
      focus(nodeId);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  React.useEffect(function () {
    if (addNodeToNodeMap) {
      var childIds = [];
      React.Children.forEach(children, function (child) {
        if ( /*#__PURE__*/React.isValidElement(child) && child.props.nodeId) {
          childIds.push(child.props.nodeId);
        }
      });
      addNodeToNodeMap(nodeId, childIds);
    }
  }, [children, nodeId, addNodeToNodeMap]);
  React.useEffect(function () {
    if (removeNodeFromNodeMap) {
      return function () {
        removeNodeFromNodeMap(nodeId);
      };
    }

    return undefined;
  }, [nodeId, removeNodeFromNodeMap]);
  React.useEffect(function () {
    if (mapFirstChar && label) {
      mapFirstChar(nodeId, contentRef.current.textContent.substring(0, 1).toLowerCase());
    }
  }, [mapFirstChar, nodeId, label]);
  React.useEffect(function () {
    if (focused) {
      nodeRef.current.focus();
    }
  }, [focused]);
  var ariaSelected;

  if (multiSelect) {
    ariaSelected = selected;
  } else if (selected) {
    // single-selection trees unset aria-selected
    ariaSelected = true;
  }

  return /*#__PURE__*/React.createElement("li", _extends({
    className: clsx$1(classes.root, className, expanded && classes.expanded, selected && classes.selected),
    role: "treeitem",
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    "aria-expanded": expandable ? expanded : null,
    "aria-selected": ariaSelected,
    ref: handleRef,
    tabIndex: tabbable ? 0 : -1
  }, other), /*#__PURE__*/React.createElement("div", {
    className: classes.content,
    onClick: handleClick,
    onMouseDown: handleMouseDown,
    ref: contentRef
  }, /*#__PURE__*/React.createElement("div", {
    onClick: onIconClick,
    className: classes.iconContainer
  }, icon), /*#__PURE__*/React.createElement(Typography, {
    onClick: onLabelClick,
    component: "div",
    className: classes.label
  }, label)), children && /*#__PURE__*/React.createElement(TransitionComponent, _extends({
    unmountOnExit: true,
    className: classes.group,
    in: expanded,
    component: "ul",
    role: "group"
  }, TransitionProps), children));
});
process.env.NODE_ENV !== "production" ? TreeItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon used to collapse the node.
   */
  collapseIcon: PropTypes.node,

  /**
   * The icon displayed next to a end node.
   */
  endIcon: PropTypes.node,

  /**
   * The icon used to expand the node.
   */
  expandIcon: PropTypes.node,

  /**
   * The icon to display next to the tree node's label.
   */
  icon: PropTypes.node,

  /**
   * The tree node label.
   */
  label: PropTypes.node,

  /**
   * The id of the node.
   */
  nodeId: PropTypes.string.isRequired,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * `onClick` handler for the icon container. Call `event.preventDefault()` to prevent `onNodeToggle` from being called.
   */
  onIconClick: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * `onClick` handler for the label container. Call `event.preventDefault()` to prevent `onNodeToggle` from being called.
   */
  onLabelClick: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * The component used for the transition.
   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: PropTypes.object
} : void 0;
var TreeItem$1 = withStyles(styles$L, {
  name: 'MuiTreeItem'
})(TreeItem);

var styles$K = {
  /* Styles applied to the root element. */
  root: {
    padding: 0,
    margin: 0,
    listStyle: 'none'
  }
};

function arrayDiff(arr1, arr2) {
  if (arr1.length !== arr2.length) return true;

  for (var i = 0; i < arr1.length; i += 1) {
    if (arr1[i] !== arr2[i]) return true;
  }

  return false;
}

var findNextFirstChar = function findNextFirstChar(firstChars, startIndex, char) {
  for (var i = startIndex; i < firstChars.length; i += 1) {
    if (char === firstChars[i]) {
      return i;
    }
  }

  return -1;
};

var defaultExpandedDefault = [];
var defaultSelectedDefault = [];
var TreeView = /*#__PURE__*/React.forwardRef(function TreeView(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      defaultCollapseIcon = props.defaultCollapseIcon,
      defaultEndIcon = props.defaultEndIcon,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? defaultExpandedDefault : _props$defaultExpande,
      defaultExpandIcon = props.defaultExpandIcon,
      defaultParentIcon = props.defaultParentIcon,
      _props$defaultSelecte = props.defaultSelected,
      defaultSelected = _props$defaultSelecte === void 0 ? defaultSelectedDefault : _props$defaultSelecte,
      _props$disableSelecti = props.disableSelection,
      disableSelection = _props$disableSelecti === void 0 ? false : _props$disableSelecti,
      _props$multiSelect = props.multiSelect,
      multiSelect = _props$multiSelect === void 0 ? false : _props$multiSelect,
      expandedProp = props.expanded,
      onNodeSelect = props.onNodeSelect,
      onNodeToggle = props.onNodeToggle,
      selectedProp = props.selected,
      other = _objectWithoutProperties$4(props, ["children", "classes", "className", "defaultCollapseIcon", "defaultEndIcon", "defaultExpanded", "defaultExpandIcon", "defaultParentIcon", "defaultSelected", "disableSelection", "multiSelect", "expanded", "onNodeSelect", "onNodeToggle", "selected"]);

  var _React$useState = React.useState(null),
      tabbable = _React$useState[0],
      setTabbable = _React$useState[1];

  var _React$useState2 = React.useState(null),
      focusedNodeId = _React$useState2[0],
      setFocusedNodeId = _React$useState2[1];

  var nodeMap = React.useRef({});
  var firstCharMap = React.useRef({});
  var visibleNodes = React.useRef([]);

  var _useControlled = useControlled({
    controlled: expandedProp,
    default: defaultExpanded,
    name: 'TreeView',
    state: 'expanded'
  }),
      _useControlled2 = _slicedToArray$8(_useControlled, 2),
      expanded = _useControlled2[0],
      setExpandedState = _useControlled2[1];

  var _useControlled3 = useControlled({
    controlled: selectedProp,
    default: defaultSelected,
    name: 'TreeView',
    state: 'selected'
  }),
      _useControlled4 = _slicedToArray$8(_useControlled3, 2),
      selected = _useControlled4[0],
      setSelectedState = _useControlled4[1];
  /*
   * Status Helpers
   */


  var isExpanded = React.useCallback(function (id) {
    return Array.isArray(expanded) ? expanded.indexOf(id) !== -1 : false;
  }, [expanded]);
  var isSelected = React.useCallback(function (id) {
    return Array.isArray(selected) ? selected.indexOf(id) !== -1 : selected === id;
  }, [selected]);

  var isTabbable = function isTabbable(id) {
    return tabbable === id;
  };

  var isFocused = function isFocused(id) {
    return focusedNodeId === id;
  };
  /*
   * Node Helpers
   */


  var getNextNode = function getNextNode(id) {
    var nodeIndex = visibleNodes.current.indexOf(id);

    if (nodeIndex !== -1 && nodeIndex + 1 < visibleNodes.current.length) {
      return visibleNodes.current[nodeIndex + 1];
    }

    return null;
  };

  var getPreviousNode = function getPreviousNode(id) {
    var nodeIndex = visibleNodes.current.indexOf(id);

    if (nodeIndex !== -1 && nodeIndex - 1 >= 0) {
      return visibleNodes.current[nodeIndex - 1];
    }

    return null;
  };

  var getLastNode = function getLastNode() {
    return visibleNodes.current[visibleNodes.current.length - 1];
  };

  var getFirstNode = function getFirstNode() {
    return visibleNodes.current[0];
  };

  var getParent = function getParent(id) {
    return nodeMap.current[id].parent;
  };

  var getNodesInRange = function getNodesInRange(a, b) {
    var aIndex = visibleNodes.current.indexOf(a);
    var bIndex = visibleNodes.current.indexOf(b);
    var start = Math.min(aIndex, bIndex);
    var end = Math.max(aIndex, bIndex);
    return visibleNodes.current.slice(start, end + 1);
  };
  /*
   * Focus Helpers
   */


  var focus = function focus(id) {
    if (id) {
      setTabbable(id);
      setFocusedNodeId(id);
    }
  };

  var focusNextNode = function focusNextNode(id) {
    return focus(getNextNode(id));
  };

  var focusPreviousNode = function focusPreviousNode(id) {
    return focus(getPreviousNode(id));
  };

  var focusFirstNode = function focusFirstNode() {
    return focus(getFirstNode());
  };

  var focusLastNode = function focusLastNode() {
    return focus(getLastNode());
  };

  var focusByFirstCharacter = function focusByFirstCharacter(id, char) {
    var start;
    var index;
    var lowercaseChar = char.toLowerCase();
    var firstCharIds = [];
    var firstChars = []; // This really only works since the ids are strings

    Object.keys(firstCharMap.current).forEach(function (nodeId) {
      var firstChar = firstCharMap.current[nodeId];
      var map = nodeMap.current[nodeId];
      var visible = map.parent ? isExpanded(map.parent) : true;

      if (visible) {
        firstCharIds.push(nodeId);
        firstChars.push(firstChar);
      }
    }); // Get start index for search based on position of currentItem

    start = firstCharIds.indexOf(id) + 1;

    if (start === nodeMap.current.length) {
      start = 0;
    } // Check remaining slots in the menu


    index = findNextFirstChar(firstChars, start, lowercaseChar); // If not found in remaining slots, check from beginning

    if (index === -1) {
      index = findNextFirstChar(firstChars, 0, lowercaseChar);
    } // If match was found...


    if (index > -1) {
      focus(firstCharIds[index]);
    }
  };
  /*
   * Expansion Helpers
   */


  var toggleExpansion = function toggleExpansion(event) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : focusedNodeId;
    var newExpanded;

    if (expanded.indexOf(value) !== -1) {
      newExpanded = expanded.filter(function (id) {
        return id !== value;
      });
      setTabbable(function (oldTabbable) {
        var map = nodeMap.current[oldTabbable];

        if (oldTabbable && (map && map.parent ? map.parent.id : null) === value) {
          return value;
        }

        return oldTabbable;
      });
    } else {
      newExpanded = [value].concat(expanded);
    }

    if (onNodeToggle) {
      onNodeToggle(event, newExpanded);
    }

    setExpandedState(newExpanded);
  };

  var expandAllSiblings = function expandAllSiblings(event, id) {
    var map = nodeMap.current[id];
    var parent = nodeMap.current[map.parent];
    var diff;

    if (parent) {
      diff = parent.children.filter(function (child) {
        return !isExpanded(child);
      });
    } else {
      var topLevelNodes = nodeMap.current[-1].children;
      diff = topLevelNodes.filter(function (node) {
        return !isExpanded(node);
      });
    }

    var newExpanded = expanded.concat(diff);

    if (diff.length > 0) {
      setExpandedState(newExpanded);

      if (onNodeToggle) {
        onNodeToggle(event, newExpanded);
      }
    }
  };
  /*
   * Selection Helpers
   */


  var lastSelectedNode = React.useRef(null);
  var lastSelectionWasRange = React.useRef(false);
  var currentRangeSelection = React.useRef([]);

  var handleRangeArrowSelect = function handleRangeArrowSelect(event, nodes) {
    var base = selected;
    var start = nodes.start,
        next = nodes.next,
        current = nodes.current;

    if (!next || !current) {
      return;
    }

    if (currentRangeSelection.current.indexOf(current) === -1) {
      currentRangeSelection.current = [];
    }

    if (lastSelectionWasRange.current) {
      if (currentRangeSelection.current.indexOf(next) !== -1) {
        base = base.filter(function (id) {
          return id === start || id !== current;
        });
        currentRangeSelection.current = currentRangeSelection.current.filter(function (id) {
          return id === start || id !== current;
        });
      } else {
        base.push(next);
        currentRangeSelection.current.push(next);
      }
    } else {
      base.push(next);
      currentRangeSelection.current.push(current, next);
    }

    if (onNodeSelect) {
      onNodeSelect(event, base);
    }

    setSelectedState(base);
  };

  var handleRangeSelect = function handleRangeSelect(event, nodes) {
    var base = selected;
    var start = nodes.start,
        end = nodes.end; // If last selection was a range selection ignore nodes that were selected.

    if (lastSelectionWasRange.current) {
      base = selected.filter(function (id) {
        return currentRangeSelection.current.indexOf(id) === -1;
      });
    }

    var range = getNodesInRange(start, end);
    currentRangeSelection.current = range;
    var newSelected = base.concat(range);
    newSelected = newSelected.filter(function (id, i) {
      return newSelected.indexOf(id) === i;
    });

    if (onNodeSelect) {
      onNodeSelect(event, newSelected);
    }

    setSelectedState(newSelected);
  };

  var handleMultipleSelect = function handleMultipleSelect(event, value) {
    var newSelected = [];

    if (selected.indexOf(value) !== -1) {
      newSelected = selected.filter(function (id) {
        return id !== value;
      });
    } else {
      newSelected = [value].concat(selected);
    }

    if (onNodeSelect) {
      onNodeSelect(event, newSelected);
    }

    setSelectedState(newSelected);
  };

  var handleSingleSelect = function handleSingleSelect(event, value) {
    var newSelected = multiSelect ? [value] : value;

    if (onNodeSelect) {
      onNodeSelect(event, newSelected);
    }

    setSelectedState(newSelected);
  };

  var selectNode = function selectNode(event, id) {
    var multiple = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (id) {
      if (multiple) {
        handleMultipleSelect(event, id);
      } else {
        handleSingleSelect(event, id);
      }

      lastSelectedNode.current = id;
      lastSelectionWasRange.current = false;
      currentRangeSelection.current = [];
      return true;
    }

    return false;
  };

  var selectRange = function selectRange(event, nodes) {
    var stacked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _nodes$start = nodes.start,
        start = _nodes$start === void 0 ? lastSelectedNode.current : _nodes$start,
        end = nodes.end,
        current = nodes.current;

    if (stacked) {
      handleRangeArrowSelect(event, {
        start: start,
        next: end,
        current: current
      });
    } else {
      handleRangeSelect(event, {
        start: start,
        end: end
      });
    }

    lastSelectionWasRange.current = true;
    return true;
  };

  var rangeSelectToFirst = function rangeSelectToFirst(event, id) {
    if (!lastSelectedNode.current) {
      lastSelectedNode.current = id;
    }

    var start = lastSelectionWasRange.current ? lastSelectedNode.current : id;
    return selectRange(event, {
      start: start,
      end: getFirstNode()
    });
  };

  var rangeSelectToLast = function rangeSelectToLast(event, id) {
    if (!lastSelectedNode.current) {
      lastSelectedNode.current = id;
    }

    var start = lastSelectionWasRange.current ? lastSelectedNode.current : id;
    return selectRange(event, {
      start: start,
      end: getLastNode()
    });
  };

  var selectNextNode = function selectNextNode(event, id) {
    return selectRange(event, {
      end: getNextNode(id),
      current: id
    }, true);
  };

  var selectPreviousNode = function selectPreviousNode(event, id) {
    return selectRange(event, {
      end: getPreviousNode(id),
      current: id
    }, true);
  };

  var selectAllNodes = function selectAllNodes(event) {
    return selectRange(event, {
      start: getFirstNode(),
      end: getLastNode()
    });
  };
  /*
   * Mapping Helpers
   */


  var addNodeToNodeMap = function addNodeToNodeMap(id, childrenIds) {
    var currentMap = nodeMap.current[id];
    nodeMap.current[id] = _extends({}, currentMap, {
      children: childrenIds,
      id: id
    });
    childrenIds.forEach(function (childId) {
      var currentChildMap = nodeMap.current[childId];
      nodeMap.current[childId] = _extends({}, currentChildMap, {
        parent: id,
        id: childId
      });
    });
  };

  var getNodesToRemove = React.useCallback(function (id) {
    var map = nodeMap.current[id];
    var nodes = [];

    if (map) {
      nodes.push(id);

      if (map.children) {
        nodes.concat(map.children);
        map.children.forEach(function (node) {
          nodes.concat(getNodesToRemove(node));
        });
      }
    }

    return nodes;
  }, []);
  var cleanUpFirstCharMap = React.useCallback(function (nodes) {
    var newMap = _extends({}, firstCharMap.current);

    nodes.forEach(function (node) {
      if (newMap[node]) {
        delete newMap[node];
      }
    });
    firstCharMap.current = newMap;
  }, []);
  var removeNodeFromNodeMap = React.useCallback(function (id) {
    var nodes = getNodesToRemove(id);
    cleanUpFirstCharMap(nodes);

    var newMap = _extends({}, nodeMap.current);

    nodes.forEach(function (node) {
      var map = newMap[node];

      if (map) {
        if (map.parent) {
          var parentMap = newMap[map.parent];

          if (parentMap && parentMap.children) {
            var parentChildren = parentMap.children.filter(function (c) {
              return c !== node;
            });
            newMap[map.parent] = _extends({}, parentMap, {
              children: parentChildren
            });
          }
        }

        delete newMap[node];
      }
    });
    nodeMap.current = newMap;
    setFocusedNodeId(function (oldFocusedNodeId) {
      if (oldFocusedNodeId === id) {
        return null;
      }

      return oldFocusedNodeId;
    });
  }, [getNodesToRemove, cleanUpFirstCharMap]);

  var mapFirstChar = function mapFirstChar(id, firstChar) {
    firstCharMap.current[id] = firstChar;
  };

  var prevChildIds = React.useRef([]);

  var _React$useState3 = React.useState(false),
      childrenCalculated = _React$useState3[0],
      setChildrenCalculated = _React$useState3[1];

  React.useEffect(function () {
    var childIds = [];
    React.Children.forEach(children, function (child) {
      if ( /*#__PURE__*/React.isValidElement(child) && child.props.nodeId) {
        childIds.push(child.props.nodeId);
      }
    });

    if (arrayDiff(prevChildIds.current, childIds)) {
      nodeMap.current[-1] = {
        parent: null,
        children: childIds
      };
      childIds.forEach(function (id, index) {
        if (index === 0) {
          setTabbable(id);
        }
      });
      visibleNodes.current = nodeMap.current[-1].children;
      prevChildIds.current = childIds;
      setChildrenCalculated(true);
    }
  }, [children]);
  React.useEffect(function () {
    var buildVisible = function buildVisible(nodes) {
      var list = [];

      for (var i = 0; i < nodes.length; i += 1) {
        var item = nodes[i];
        list.push(item);
        var childs = nodeMap.current[item].children;

        if (isExpanded(item) && childs) {
          list = list.concat(buildVisible(childs));
        }
      }

      return list;
    };

    if (childrenCalculated) {
      visibleNodes.current = buildVisible(nodeMap.current[-1].children);
    }
  }, [expanded, childrenCalculated, isExpanded, children]);

  var noopSelection = function noopSelection() {
    return false;
  };

  return /*#__PURE__*/React.createElement(TreeViewContext$1.Provider, {
    value: {
      icons: {
        defaultCollapseIcon: defaultCollapseIcon,
        defaultExpandIcon: defaultExpandIcon,
        defaultParentIcon: defaultParentIcon,
        defaultEndIcon: defaultEndIcon
      },
      focus: focus,
      focusFirstNode: focusFirstNode,
      focusLastNode: focusLastNode,
      focusNextNode: focusNextNode,
      focusPreviousNode: focusPreviousNode,
      focusByFirstCharacter: focusByFirstCharacter,
      expandAllSiblings: expandAllSiblings,
      toggleExpansion: toggleExpansion,
      isExpanded: isExpanded,
      isFocused: isFocused,
      isSelected: isSelected,
      selectNode: disableSelection ? noopSelection : selectNode,
      selectRange: disableSelection ? noopSelection : selectRange,
      selectNextNode: disableSelection ? noopSelection : selectNextNode,
      selectPreviousNode: disableSelection ? noopSelection : selectPreviousNode,
      rangeSelectToFirst: disableSelection ? noopSelection : rangeSelectToFirst,
      rangeSelectToLast: disableSelection ? noopSelection : rangeSelectToLast,
      selectAllNodes: disableSelection ? noopSelection : selectAllNodes,
      isTabbable: isTabbable,
      multiSelect: multiSelect,
      getParent: getParent,
      mapFirstChar: mapFirstChar,
      addNodeToNodeMap: addNodeToNodeMap,
      removeNodeFromNodeMap: removeNodeFromNodeMap
    }
  }, /*#__PURE__*/React.createElement("ul", _extends({
    role: "tree",
    "aria-multiselectable": multiSelect,
    className: clsx$1(classes.root, className),
    ref: ref
  }, other), children));
});
process.env.NODE_ENV !== "production" ? TreeView.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The default icon used to collapse the node.
   */
  defaultCollapseIcon: PropTypes.node,

  /**
   * The default icon displayed next to a end node. This is applied to all
   * tree nodes and can be overridden by the TreeItem `icon` prop.
   */
  defaultEndIcon: PropTypes.node,

  /**
   * Expanded node ids. (Uncontrolled)
   */
  defaultExpanded: PropTypes.arrayOf(PropTypes.string),

  /**
   * The default icon used to expand the node.
   */
  defaultExpandIcon: PropTypes.node,

  /**
   * The default icon displayed next to a parent node. This is applied to all
   * parent nodes and can be overridden by the TreeItem `icon` prop.
   */
  defaultParentIcon: PropTypes.node,

  /**
   * Selected node ids. (Uncontrolled)
   * When `multiSelect` is true this takes an array of strings; when false (default) a string.
   */
  defaultSelected: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]),

  /**
   * If `true` selection is disabled.
   */
  disableSelection: PropTypes.bool,

  /**
   * Expanded node ids. (Controlled)
   */
  expanded: PropTypes.arrayOf(PropTypes.string),

  /**
   * If true `ctrl` and `shift` will trigger multiselect.
   */
  multiSelect: PropTypes.bool,

  /**
   * Callback fired when tree items are selected/unselected.
   *
   * @param {object} event The event source of the callback
   * @param {(array|string)} value of the selected nodes. When `multiSelect` is true
   * this is an array of strings; when false (default) a string.
   */
  onNodeSelect: PropTypes.func,

  /**
   * Callback fired when tree items are expanded/collapsed.
   *
   * @param {object} event The event source of the callback.
   * @param {array} nodeIds The ids of the expanded nodes.
   */
  onNodeToggle: PropTypes.func,

  /**
   * Selected node ids. (Controlled)
   * When `multiSelect` is true this takes an array of strings; when false (default) a string.
   */
  selected: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string])
} : void 0;
var TreeView$1 = withStyles(styles$K, {
  name: 'MuiTreeView'
})(TreeView);

function toVal$1(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal$1(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function r () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal$1(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function () {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);

var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    if (process.env.NODE_ENV !== 'production') {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: You might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    if (process.env.NODE_ENV === 'production') {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }

    var suffix = "".concat(rule.key, "-").concat(getNextCounterId()); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var isProduction$3 = process.env.NODE_ENV === 'production';
function warning$4(condition, message) {
  if (!isProduction$3) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

var _typeof$3 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser$1 = (typeof window === "undefined" ? "undefined" : _typeof$3(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof$3(document)) === 'object' && document.nodeType === 9;

function _defineProperties$3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$3(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _setPrototypeOf$3(o, p) {
  _setPrototypeOf$3 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$3(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$3(subClass, superClass);
}

function _assertThisInitialized$3(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
    process.env.NODE_ENV !== "production" ? warning$4(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts JSS array value to a CSS string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

function getWhitespaceSymbols(options) {
  if (options && options.format === false) {
    return {
      linebreak: '',
      space: ''
    };
  }

  return {
    linebreak: '\n',
    space: ' '
  };
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */

function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;

  if (options.format === false) {
    indent = -Infinity;
  }

  var _getWhitespaceSymbols = getWhitespaceSymbols(options),
      linebreak = _getWhitespaceSymbols.linebreak,
      space = _getWhitespaceSymbols.space;

  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += linebreak;
            result += indentStr(prop + ":" + space + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += linebreak;
          result += indentStr(_prop + ":" + space + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += linebreak;
      result += indentStr(_prop2 + ":" + space + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "" + linebreak + result + linebreak;
  return indentStr("" + selector + space + "{" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape$1 = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
      process.env.NODE_ENV !== "production" ? warning$4(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized$3(_assertThisInitialized$3(_this)), sheet);
      _this.selectorText = "." + escape$1(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass$3(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (key[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(key, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.isProcessed = false;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {" + linebreak + children + linebreak + "}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.isProcessed = false;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
      process.env.NODE_ENV !== "production" ? warning$4(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape$1(generateId(this, sheet));
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "" + linebreak + children + linebreak;
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp$1 = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp$1, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

      process.env.NODE_ENV !== "production" ? warning$4(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef$1 = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var pluginKeyframesRule = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef$1(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef$1(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    return _BaseStyleRule.apply(this, arguments) || this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += linebreak;
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.isProcessed = false;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.isProcessed = false;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins$1 = [pluginStyleRule, pluginConditionalRule, pluginKeyframesRule, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = _extends({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape$1(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Replace rule.
   * Create a new rule and remove old one instead of overwriting
   * because we want to invoke onCreateRule hook to make plugins work.
   */
  ;

  _proto.replace = function replace(name, decl, ruleOptions) {
    var oldRule = this.get(name);
    var oldIndex = this.index.indexOf(oldRule);

    if (oldRule) {
      this.remove(oldRule);
    }

    var options = ruleOptions;
    if (oldIndex !== -1) options = _extends({}, ruleOptions, {
      index: oldIndex
    });
    return this.add(name, decl, options);
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.get = function get(nameOrSelector) {
    return this.map[nameOrSelector];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0];
      data = arguments.length <= 1 ? undefined : arguments[1];
      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0];
      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.get(name), data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var style = rule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== rule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(rule.style, rule, sheet); // Update and add props.

      for (var prop in rule.style) {
        var nextValue = rule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          rule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = rule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          rule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += linebreak;
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Replace a rule in the current stylesheet.
   */
  ;

  _proto.replaceRule = function replaceRule(nameOrSelector, decl, options) {
    var oldRule = this.rules.get(nameOrSelector);
    if (!oldRule) return this.addRule(nameOrSelector, decl, options);
    var newRule = this.rules.replace(nameOrSelector, decl, options);

    if (newRule) {
      this.options.jss.plugins.onProcessRule(newRule);
    }

    if (this.attached) {
      if (!this.deployed) return newRule; // Don't replace / delete rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (this.renderer) {
        if (!newRule) {
          this.renderer.deleteRule(oldRule);
        } else if (oldRule.renderable) {
          this.renderer.replaceRule(oldRule.renderable, newRule);
        }
      }

      return newRule;
    } // We can't replace rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return newRule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name or selector.
   */
  ;

  _proto.getRule = function getRule(nameOrSelector) {
    return this.rules.get(nameOrSelector);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = {};
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
          process.env.NODE_ENV !== "production" ? warning$4(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access all instances in one place.
 */

var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose$4(_ref, ["attached"]);

    var _getWhitespaceSymbols = getWhitespaceSymbols(options),
        linebreak = _getWhitespaceSymbols.linebreak;

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += linebreak;
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass$3(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns$1 = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns$1] == null) globalThis$1[ns$1] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns$1]++;

var maxRules = 1e10;
/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      process.env.NODE_ENV !== "production" ? warning$4(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */

var memoize$4 = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};
/**
 * Set a style property.
 */


var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};
/**
 * Remove a style property.
 */


var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning$4(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
};
/**
 * Set the selector.
 */


var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead$1 = memoize$4(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead$1();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}
/**
 * Find a node before which we can insert the sheet.
 */


function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


    process.env.NODE_ENV !== "production" ? warning$4(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else process.env.NODE_ENV !== "production" ? warning$4(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead$1().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize$4(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      container.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        container.appendRule(rule);
      }
  } catch (err) {
    process.env.NODE_ENV !== "production" ? warning$4(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules.splice(index, 0, cssRule);
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.9.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser$1 ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins$1.length; i++) {
      this.plugins.use(plugins$1[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = _extends({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, _extends({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = _extends({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

var createJss = function createJss(options) {
  return new Jss(options);
};

/**
* Export a constant indicating if this browser has CSSTOM support.
* https://developers.google.com/web/updates/2018/03/cssom
*/
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */
createJss();

var now$3 = Date.now();
var fnValuesNs = "fnValues" + now$3;
var fnRuleNs = "fnStyle" + ++now$3;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      }

      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};

        if (process.env.NODE_ENV === 'development') {
          for (var prop in styleRule.style) {
            if (typeof styleRule.style[prop] === 'function') {
              process.env.NODE_ENV !== "production" ? warning$4(false, '[JSS] Function values inside function rules are not supported.') : void 0;
              break;
            }
          }
        }
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var functions$1 = functionPlugin;

var at$1 = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at$1;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Replace rule, run plugins.
   */
  ;

  _proto.replaceRule = function replaceRule(name, style, options) {
    var newRule = this.rules.replace(name, style, options);
    if (newRule) this.options.jss.plugins.onProcessRule(newRule);
    return newRule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at$1;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp$1 = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp$1);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at$1] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at$1];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at$1.length) !== at$1) continue;
    var selector = addScope(prop.substr(at$1.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at$1) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (!options.selector && options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        return rule.selector;
      }

      process.env.NODE_ENV !== "production" ? warning$4(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends({}, prevOptions, {
      index: prevOptions.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        var name = styleRule.key + "-" + prop;

        if ('replaceRule' in container) {
          // for backward compatibility
          container.replaceRule(name, style[prop], _extends({}, options, {
            selector: selector
          }));
        } else {
          container.addRule(name, style[prop], _extends({}, options, {
            selector: selector
          }));
        }
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options).addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache$2.hasOwnProperty(name)) {
    return cache$2[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache$2[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/**
 * Convert camel cased property names to dash separated.
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */

function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

// Export javascript style and css style vendor prefixes.
var js$2 = '';
var css$1 = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser$1 && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser$1) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style$1 = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key$1 in jsCssMap) {
    if (key$1 + testProp in style$1) {
      js$2 = key$1;
      css$1 = jsCssMap[key$1];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js$2 === 'Webkit' && 'msHyphens' in style$1) {
    js$2 = 'ms';
    css$1 = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js$2 === 'Webkit' && '-apple-trailing-word' in style$1) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix$3 = {
  js: js$2,
  css: css$1,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix$3.js === 'ms') return key;
  return "@" + prefix$3.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix$3.js === 'ms') return "-webkit-" + prop;
    return prefix$3.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix$3.js === 'Webkit') return prefix$3.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix$3.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix$3.js + pascalize(longhand) in style) {
        return prefix$3.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix$3.vendor === 'apple' && !prefix$3.isTouch) {
      return prefix$3.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix$3.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix$3.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix$3.js === 'Webkit' || prefix$3.js === 'ms' && prefix$3.browser !== 'edge') {
      return prefix$3.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix$3.js === 'Moz' || prefix$3.js === 'ms' || prefix$3.vendor === 'apple') {
      return prefix$3.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix$3.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix$3.css + "column-" + prop : false;
    }

    if (prefix$3.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix$3.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix$3.js + pascalize(newProp) in style ? prefix$3.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix$3.js + pascalized in style) return prefix$3.css + prop; // Try webkit fallback.

    if (prefix$3.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix$3.js === 'ms') {
      return "" + prefix$3.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix$3.js === 'ms') {
      return prefix$3.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix$3.js + pascalize(newProp) in style ? prefix$3.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix$3.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix$3.js + pascalize(newProp) in style ? prefix$3.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix$3.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray$3(p.noPrefill));
  return a;
}, []);

var el$1;
var cache = {};

if (isBrowser$1) {
  el$1 = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1$1)) cache[computed[key$1$1]] = computed[key$1$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el$1) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el$1.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el$1.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el$1.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (isBrowser$1) el$1$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (process.env.NODE_ENV !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix$3.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}

/**
 * Add vendor prefix to a property name when needed.
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

function jssPreset() {
  return {
    plugins: [functions$1(), jssGlobal(), jssNested(), camelCase(), defaultUnit(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = _extends({}, baseClasses);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: The value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName$2(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (process.env.NODE_ENV !== 'production') {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName$2(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: The key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName$2(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var multiKeyStore$1 = multiKeyStore;

var ThemeContext = React__default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ThemeContext.displayName = 'ThemeContext';
}

var ThemeContext$1 = ThemeContext;

function useTheme$1() {
  var theme = React__default.useContext(ThemeContext$1);

  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React__default.useDebugValue(theme);
  }

  return theme;
}

var jss = createJss(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__default.createContext(defaultOptions);

if (process.env.NODE_ENV !== 'production') {
  StylesContext.displayName = 'StylesContext';
}

var injectFirstNode;
function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = _objectWithoutProperties$4(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = React__default.useContext(StylesContext);

  var context = _extends({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (process.env.NODE_ENV !== 'production') {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: You need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: You cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (process.env.NODE_ENV !== 'production') {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: You cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = createJss({
      plugins: jssPreset().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return /*#__PURE__*/React__default.createElement(StylesContext.Provider, {
    value: context
  }, children);
}
process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (process.env.NODE_ENV !== 'production') {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (process.env.NODE_ENV !== 'production') {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: You might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
var noopTheme$1 = noopTheme;

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (process.env.NODE_ENV !== 'production') {
    if (_typeof$4(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: The `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          if (themingEnabled === true && theme === noopTheme$1) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: The `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = _extends({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (process.env.NODE_ENV !== 'production') {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: You are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore$1.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = _extends({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore$1.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        multiKeyStore$1.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update$2(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    multiKeyStore$1.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = React__default.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React__default.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  React__default.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme$1 : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties$4(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme$1() || defaultTheme;

    var stylesOptions = _extends({}, React__default.useContext(StylesContext), stylesOptions2);

    var instance = React__default.useRef();
    var shouldUpdate = React__default.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__default.useEffect(function () {
      if (shouldUpdate.current) {
        update$2(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      React__default.useDebugValue(classes);
    }

    return classes;
  };

  return useStyles;
}

function _classCallCheck$3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var reactIs$1 = requireReactIs();

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs$1.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs$1.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs$1.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$5 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$5(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var hoistStatics = /*@__PURE__*/getDefaultExportFromCjs(hoistNonReactStatics_cjs);

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return () => null;
  }

  return function validate(...args) {
    return propType1(...args) || propType2(...args);
  };
}

var ne;!function(e){e.resize="resize",e.debouncedResize="debouncedResize",e.componentError="componentError",e.unmount="unmount",e.cellModeChange="cellModeChange",e.cellClick="cellClick",e.cellDoubleClick="cellDoubleClick",e.cellMouseDown="cellMouseDown",e.cellMouseUp="cellMouseUp",e.cellOver="cellOver",e.cellOut="cellOut",e.cellEnter="cellEnter",e.cellLeave="cellLeave",e.cellKeyDown="cellKeyDown",e.cellBlur="cellBlur",e.cellFocus="cellFocus",e.cellFocusOut="cellFocusOut",e.cellDragStart="cellDragStart",e.cellDragEnter="cellDragEnter",e.cellDragOver="cellDragOver",e.cellDragEnd="cellDragEnd",e.editCellPropsChange="editCellPropsChange",e.cellEditCommit="cellEditCommit",e.cellEditStart="cellEditStart",e.cellEditStop="cellEditStop",e.cellNavigationKeyDown="cellNavigationKeyDown",e.rowClick="rowClick",e.rowDoubleClick="rowDoubleClick",e.rowOver="rowOver",e.rowOut="rowOut",e.rowEnter="rowEnter",e.rowLeave="rowLeave",e.editRowsModelChange="editRowsModelChange",e.columnHeaderBlur="columnHeaderBlur",e.columnHeaderFocus="columnHeaderFocus",e.columnHeaderNavigationKeyDown="columnHeaderNavigationKeyDown",e.columnHeaderKeyDown="columnHeaderKeyDown",e.columnHeaderClick="columnHeaderClick",e.columnHeaderDoubleClick="columnHeaderDoubleClick",e.columnHeaderOver="columnHeaderOver",e.columnHeaderOut="columnHeaderOut",e.columnHeaderEnter="columnHeaderEnter",e.columnHeaderLeave="columnHeaderLeave",e.columnHeaderDragStart="columnHeaderDragStart",e.columnHeaderDragOver="columnHeaderDragOver",e.columnHeaderDragEnter="columnHeaderDragEnter",e.columnHeaderDragEnd="columnHeaderDragEnd",e.selectionChange="selectionChange",e.pageChange="pageChange",e.pageSizeChange="pageSizeChange",e.rowsScroll="rowsScroll",e.rowsScrollEnd="rowsScrollEnd",e.columnSeparatorMouseDown="columnSeparatorMouseDown",e.columnResize="columnResize",e.columnWidthChange="columnWidthChange",e.columnResizeStart="columnResizeStart",e.columnResizeStop="columnResizeStop",e.columnOrderChange="columnOrderChange",e.rowsUpdate="rowsUpdate",e.rowsSet="rowsSet",e.rowsClear="rowsClear",e.columnsChange="columnsChange",e.sortModelChange="sortModelChange",e.filterModelChange="filterModelChange",e.stateChange="stateChange",e.columnVisibilityChange="columnVisibilityChange",e.viewportRowsChange="viewportRowsChange";}(ne||(ne={}));const oe=React.createContext(void 0);function ae(){const t=React.useContext(oe);if(void 0===t)throw new Error(["Material-UI X: Could not find the data grid context.","It looks like you rendered your component outside of a DataGrid or XGrid parent component.","This can also happen if you are bundling multiple versions of the data grid."].join("\n"));return t}"production"!==process.env.NODE_ENV&&(oe.displayName="GridApiContext");const se=e=>e.columns.all,ce=e=>e.columns.lookup,ue=createSelector(se,ce,((e,t)=>e.map((e=>t[e])))),de=createSelector(ue,(e=>e.filter((e=>null!=e.field&&!e.hide)))),pe=createSelector(de,(e=>{const t=[];return {totalWidth:e.reduce(((e,r)=>(t.push(e),e+r.computedWidth)),0),positions:t}})),me=createSelector(ue,(e=>e.filter((e=>e.filterable)))),fe=createSelector(me,(e=>e.map((e=>e.field)))),ge=createSelector(de,(e=>e.length)),be=createSelector(pe,(e=>e.totalWidth));function Re(e,t){return e===t||e!=e&&t!=t}function Ie(e,t){for(var r=e.length;r--;)if(Re(e[r][0],t))return r;return -1}var Pe=Array.prototype.splice;function Le(e){var t=-1,r=null==e?0:e.length;for(this.clear();++t<r;){var l=e[t];this.set(l[0],l[1]);}}Le.prototype.clear=function(){this.__data__=[],this.size=0;},Le.prototype.delete=function(e){var t=this.__data__,r=Ie(t,e);return !(r<0)&&(r==t.length-1?t.pop():Pe.call(t,r,1),--this.size,!0)},Le.prototype.get=function(e){var t=this.__data__,r=Ie(t,e);return r<0?void 0:t[r][1]},Le.prototype.has=function(e){return Ie(this.__data__,e)>-1},Le.prototype.set=function(e,t){var r=this.__data__,l=Ie(r,e);return l<0?(++this.size,r.push([e,t])):r[l][1]=t,this};var Fe="object"==typeof global&&global&&global.Object===Object&&global,je="object"==typeof self&&self&&self.Object===Object&&self,ze=Fe||je||Function("return this")(),Te=ze.Symbol,He=Object.prototype,Ae=He.hasOwnProperty,_e=He.toString,Ge=Te?Te.toStringTag:void 0;var Ne=Object.prototype.toString;var $e=Te?Te.toStringTag:void 0;function Ve(e){return null==e?void 0===e?"[object Undefined]":"[object Null]":$e&&$e in Object(e)?function(e){var t=Ae.call(e,Ge),r=e[Ge];try{e[Ge]=void 0;var l=!0;}catch(e){}var n=_e.call(e);return l&&(t?e[Ge]=r:delete e[Ge]),n}(e):function(e){return Ne.call(e)}(e)}function Be(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}function We(e){if(!Be(e))return !1;var t=Ve(e);return "[object Function]"==t||"[object GeneratorFunction]"==t||"[object AsyncFunction]"==t||"[object Proxy]"==t}var Ue,Ke=ze["__core-js_shared__"],Ze=(Ue=/[^.]+$/.exec(Ke&&Ke.keys&&Ke.keys.IE_PROTO||""))?"Symbol(src)_1."+Ue:"";var Xe=Function.prototype.toString;function qe(e){if(null!=e){try{return Xe.call(e)}catch(e){}try{return e+""}catch(e){}}return ""}var Ye=/^\[object .+?Constructor\]$/,Je=Function.prototype,Qe=Object.prototype,et=Je.toString,tt=Qe.hasOwnProperty,rt=RegExp("^"+et.call(tt).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");function lt$1(e){return !(!Be(e)||(t=e,Ze&&Ze in t))&&(We(e)?rt:Ye).test(qe(e));var t;}function nt(e,t){var r=function(e,t){return null==e?void 0:e[t]}(e,t);return lt$1(r)?r:void 0}var ot=nt(ze,"Map"),at=nt(Object,"create");var it=Object.prototype.hasOwnProperty;var st=Object.prototype.hasOwnProperty;function ct(e){var t=-1,r=null==e?0:e.length;for(this.clear();++t<r;){var l=e[t];this.set(l[0],l[1]);}}function ut(e,t){var r,l,n=e.__data__;return ("string"==(l=typeof(r=t))||"number"==l||"symbol"==l||"boolean"==l?"__proto__"!==r:null===r)?n["string"==typeof t?"string":"hash"]:n.map}function dt(e){var t=-1,r=null==e?0:e.length;for(this.clear();++t<r;){var l=e[t];this.set(l[0],l[1]);}}ct.prototype.clear=function(){this.__data__=at?at(null):{},this.size=0;},ct.prototype.delete=function(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t},ct.prototype.get=function(e){var t=this.__data__;if(at){var r=t[e];return "__lodash_hash_undefined__"===r?void 0:r}return it.call(t,e)?t[e]:void 0},ct.prototype.has=function(e){var t=this.__data__;return at?void 0!==t[e]:st.call(t,e)},ct.prototype.set=function(e,t){var r=this.__data__;return this.size+=this.has(e)?0:1,r[e]=at&&void 0===t?"__lodash_hash_undefined__":t,this},dt.prototype.clear=function(){this.size=0,this.__data__={hash:new ct,map:new(ot||Le),string:new ct};},dt.prototype.delete=function(e){var t=ut(this,e).delete(e);return this.size-=t?1:0,t},dt.prototype.get=function(e){return ut(this,e).get(e)},dt.prototype.has=function(e){return ut(this,e).has(e)},dt.prototype.set=function(e,t){var r=ut(this,e),l=r.size;return r.set(e,t),this.size+=r.size==l?0:1,this};function pt(e){var t=this.__data__=new Le(e);this.size=t.size;}pt.prototype.clear=function(){this.__data__=new Le,this.size=0;},pt.prototype.delete=function(e){var t=this.__data__,r=t.delete(e);return this.size=t.size,r},pt.prototype.get=function(e){return this.__data__.get(e)},pt.prototype.has=function(e){return this.__data__.has(e)},pt.prototype.set=function(e,t){var r=this.__data__;if(r instanceof Le){var l=r.__data__;if(!ot||l.length<199)return l.push([e,t]),this.size=++r.size,this;r=this.__data__=new dt(l);}return r.set(e,t),this.size=r.size,this};function mt(e){var t=-1,r=null==e?0:e.length;for(this.__data__=new dt;++t<r;)this.add(e[t]);}function ft(e,t){for(var r=-1,l=null==e?0:e.length;++r<l;)if(t(e[r],r,e))return !0;return !1}mt.prototype.add=mt.prototype.push=function(e){return this.__data__.set(e,"__lodash_hash_undefined__"),this},mt.prototype.has=function(e){return this.__data__.has(e)};function gt$1(e,t,r,l,n,o){var a=1&r,i=e.length,s=t.length;if(i!=s&&!(a&&s>i))return !1;var c=o.get(e);if(c&&o.get(t))return c==t;var u=-1,d=!0,p=2&r?new mt:void 0;for(o.set(e,t),o.set(t,e);++u<i;){var m=e[u],f=t[u];if(l)var g=a?l(f,m,u,t,e,o):l(m,f,u,e,t,o);if(void 0!==g){if(g)continue;d=!1;break}if(p){if(!ft(t,(function(e,t){if(a=t,!p.has(a)&&(m===e||n(m,e,r,l,o)))return p.push(t);var a;}))){d=!1;break}}else if(m!==f&&!n(m,f,r,l,o)){d=!1;break}}return o.delete(e),o.delete(t),d}var bt=ze.Uint8Array;function ht(e){var t=-1,r=Array(e.size);return e.forEach((function(e,l){r[++t]=[l,e];})),r}function vt(e){var t=-1,r=Array(e.size);return e.forEach((function(e){r[++t]=e;})),r}var Ct=Te?Te.prototype:void 0,wt=Ct?Ct.valueOf:void 0;var Ot=Array.isArray;var yt=Object.prototype.propertyIsEnumerable,Et=Object.getOwnPropertySymbols,St=Et?function(e){return null==e?[]:(e=Object(e),function(e,t){for(var r=-1,l=null==e?0:e.length,n=0,o=[];++r<l;){var a=e[r];t(a,r,e)&&(o[n++]=a);}return o}(Et(e),(function(t){return yt.call(e,t)})))}:function(){return []};function Mt(e){return null!=e&&"object"==typeof e}function xt(e){return Mt(e)&&"[object Arguments]"==Ve(e)}var kt=Object.prototype,Dt=kt.hasOwnProperty,Rt=kt.propertyIsEnumerable,It=xt(function(){return arguments}())?xt:function(e){return Mt(e)&&Dt.call(e,"callee")&&!Rt.call(e,"callee")};var Pt="object"==typeof exports&&exports&&!exports.nodeType&&exports,Lt=Pt&&"object"==typeof module&&module&&!module.nodeType&&module,Ft=Lt&&Lt.exports===Pt?ze.Buffer:void 0,jt=(Ft?Ft.isBuffer:void 0)||function(){return !1},zt=/^(?:0|[1-9]\d*)$/;function Tt(e,t){var r=typeof e;return !!(t=null==t?9007199254740991:t)&&("number"==r||"symbol"!=r&&zt.test(e))&&e>-1&&e%1==0&&e<t}function Ht(e){return "number"==typeof e&&e>-1&&e%1==0&&e<=9007199254740991}var At={};At["[object Float32Array]"]=At["[object Float64Array]"]=At["[object Int8Array]"]=At["[object Int16Array]"]=At["[object Int32Array]"]=At["[object Uint8Array]"]=At["[object Uint8ClampedArray]"]=At["[object Uint16Array]"]=At["[object Uint32Array]"]=!0,At["[object Arguments]"]=At["[object Array]"]=At["[object ArrayBuffer]"]=At["[object Boolean]"]=At["[object DataView]"]=At["[object Date]"]=At["[object Error]"]=At["[object Function]"]=At["[object Map]"]=At["[object Number]"]=At["[object Object]"]=At["[object RegExp]"]=At["[object Set]"]=At["[object String]"]=At["[object WeakMap]"]=!1;var _t,Gt="object"==typeof exports&&exports&&!exports.nodeType&&exports,Nt=Gt&&"object"==typeof module&&module&&!module.nodeType&&module,$t=Nt&&Nt.exports===Gt&&Fe.process,Vt=function(){try{return $t&&$t.binding&&$t.binding("util")}catch(e){}}(),Bt=Vt&&Vt.isTypedArray,Wt=Bt?(_t=Bt,function(e){return _t(e)}):function(e){return Mt(e)&&Ht(e.length)&&!!At[Ve(e)]},Ut=Object.prototype.hasOwnProperty;function Kt(e,t){var r=Ot(e),l=!r&&It(e),n=!r&&!l&&jt(e),o=!r&&!l&&!n&&Wt(e),a=r||l||n||o,i=a?function(e,t){for(var r=-1,l=Array(e);++r<e;)l[r]=t(r);return l}(e.length,String):[],s=i.length;for(var c in e)!t&&!Ut.call(e,c)||a&&("length"==c||n&&("offset"==c||"parent"==c)||o&&("buffer"==c||"byteLength"==c||"byteOffset"==c)||Tt(c,s))||i.push(c);return i}var Zt=Object.prototype;var Xt=function(e,t){return function(r){return e(t(r))}}(Object.keys,Object),qt=Object.prototype.hasOwnProperty;function Yt(e){if(r=(t=e)&&t.constructor,t!==("function"==typeof r&&r.prototype||Zt))return Xt(e);var t,r,l=[];for(var n in Object(e))qt.call(e,n)&&"constructor"!=n&&l.push(n);return l}function Jt(e){return null!=(t=e)&&Ht(t.length)&&!We(t)?Kt(e):Yt(e);var t;}function Qt(e){return function(e,t,r){var l=t(e);return Ot(e)?l:function(e,t){for(var r=-1,l=t.length,n=e.length;++r<l;)e[n+r]=t[r];return e}(l,r(e))}(e,Jt,St)}var er=Object.prototype.hasOwnProperty;var tr=nt(ze,"DataView"),rr=nt(ze,"Promise"),lr=nt(ze,"Set"),nr=nt(ze,"WeakMap"),or=qe(tr),ar=qe(ot),ir=qe(rr),sr=qe(lr),cr=qe(nr),ur=Ve;(tr&&"[object DataView]"!=ur(new tr(new ArrayBuffer(1)))||ot&&"[object Map]"!=ur(new ot)||rr&&"[object Promise]"!=ur(rr.resolve())||lr&&"[object Set]"!=ur(new lr)||nr&&"[object WeakMap]"!=ur(new nr))&&(ur=function(e){var t=Ve(e),r="[object Object]"==t?e.constructor:void 0,l=r?qe(r):"";if(l)switch(l){case or:return "[object DataView]";case ar:return "[object Map]";case ir:return "[object Promise]";case sr:return "[object Set]";case cr:return "[object WeakMap]"}return t});var dr=ur,pr="[object Object]",mr=Object.prototype.hasOwnProperty;function fr(e,t,r,l,n,o){var a=Ot(e),i=Ot(t),s=a?"[object Array]":dr(e),c=i?"[object Array]":dr(t),u=(s="[object Arguments]"==s?pr:s)==pr,d=(c="[object Arguments]"==c?pr:c)==pr,p=s==c;if(p&&jt(e)){if(!jt(t))return !1;a=!0,u=!1;}if(p&&!u)return o||(o=new pt),a||Wt(e)?gt$1(e,t,r,l,n,o):function(e,t,r,l,n,o,a){switch(r){case"[object DataView]":if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return !1;e=e.buffer,t=t.buffer;case"[object ArrayBuffer]":return !(e.byteLength!=t.byteLength||!o(new bt(e),new bt(t)));case"[object Boolean]":case"[object Date]":case"[object Number]":return Re(+e,+t);case"[object Error]":return e.name==t.name&&e.message==t.message;case"[object RegExp]":case"[object String]":return e==t+"";case"[object Map]":var i=ht;case"[object Set]":var s=1&l;if(i||(i=vt),e.size!=t.size&&!s)return !1;var c=a.get(e);if(c)return c==t;l|=2,a.set(e,t);var u=gt$1(i(e),i(t),l,n,o,a);return a.delete(e),u;case"[object Symbol]":if(wt)return wt.call(e)==wt.call(t)}return !1}(e,t,s,r,l,n,o);if(!(1&r)){var m=u&&mr.call(e,"__wrapped__"),f=d&&mr.call(t,"__wrapped__");if(m||f){var g=m?e.value():e,b=f?t.value():t;return o||(o=new pt),n(g,b,r,l,o)}}return !!p&&(o||(o=new pt),function(e,t,r,l,n,o){var a=1&r,i=Qt(e),s=i.length;if(s!=Qt(t).length&&!a)return !1;for(var c=s;c--;){var u=i[c];if(!(a?u in t:er.call(t,u)))return !1}var d=o.get(e);if(d&&o.get(t))return d==t;var p=!0;o.set(e,t),o.set(t,e);for(var m=a;++c<s;){var f=e[u=i[c]],g=t[u];if(l)var b=a?l(g,f,u,t,e,o):l(f,g,u,e,t,o);if(!(void 0===b?f===g||n(f,g,r,l,o):b)){p=!1;break}m||(m="constructor"==u);}if(p&&!m){var h=e.constructor,v=t.constructor;h==v||!("constructor"in e)||!("constructor"in t)||"function"==typeof h&&h instanceof h&&"function"==typeof v&&v instanceof v||(p=!1);}return o.delete(e),o.delete(t),p}(e,t,r,l,n,o))}function gr(e,t,r,l,n){return e===t||(null==e||null==t||!Mt(e)&&!Mt(t)?e!=e&&t!=t:fr(e,t,r,l,gr,n))}function br(e,t){return gr(e,t)}function hr(e){return useEventCallback(e)}const vr="undefined"!=typeof window?React.useLayoutEffect:React.useEffect;function Cr(e,t,r){const l={};return Object.keys(e).forEach((n=>{l[n]=e[n].reduce(((e,l)=>(l&&(r&&r[l]&&e.push(r[l]),e.push(t(l))),e)),[]).join(" ");})),l}const wr={active:"Mui-active",checked:"Mui-checked",disabled:"Mui-disabled",error:"Mui-error",focused:"Mui-focused",focusVisible:"Mui-focusVisible",required:"Mui-required",expanded:"Mui-expanded",selected:"Mui-selected"};function Or(e,t){return wr[t]||`${e}-${t}`}function yr(e){return "function"==typeof e}function Er(e){return e.type||e.mode}function Sr(){return "fade"in n?"fade"in n&&"alpha"in n?"v4.12":"v4":"v5"}function Mr(e,t){var r,l,o;return (null===(r=n)||void 0===r?void 0:r.alpha)?null===(l=n)||void 0===l?void 0:l.alpha(e,t):null===(o=n)||void 0===o?void 0:o.fade(e,t)}function xr(){var e,t,r;return (null===(e=n)||void 0===e?void 0:e.createTheme)?null===(t=n)||void 0===t?void 0:t.createTheme():null===(r=n)||void 0===r?void 0:r.createMuiTheme()}function kr(){try{const e="__some_random_key_you_are_not_going_to_use__";return window.localStorage.setItem(e,e),window.localStorage.removeItem(e),!0}catch(e){return !1}}function Dr(e){return Or("MuiDataGrid",e)}function Rr(e){return e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g,"\\$&")}const Ir=kr()&&null!=window.localStorage.getItem("DEBUG"),Pr=()=>{},Lr={debug:Pr,info:Pr,warn:Pr,error:Pr},Fr=["debug","info","warn","error"];function jr(e,t,r=console){const l=Fr.indexOf(t);if(-1===l)throw new Error(`Material-UI: Log level ${t} not recognized.`);return Fr.reduce(((t,n,o)=>(t[n]=o>=l?(...t)=>{const[l,...o]=t;r[n](`Material-UI: ${e} - ${l}`,...o);}:Pr,t)),{})}const zr=e=>t=>jr(t,e);let Tr;function Hr(e,t){Tr=Ir?zr("debug"):t.logger?t.logLevel?e=>jr(e,t.logLevel.toString(),t.logger):null:t.logLevel?zr(t.logLevel.toString()):null;}function Ar(t){const{current:r}=React.useRef(Tr?Tr(t):Lr);return r}function _r(t,r,l){const n=Ar("useGridApiMethod"),o=React.useRef(r),[a]=React.useState(Object.keys(r)),i=React.useCallback((()=>{t.current&&a.forEach((e=>{t.current.hasOwnProperty(e)||(n.debug(`Adding ${l}.${e} to apiRef`),t.current[e]=(...t)=>o.current[e](...t));}));}),[a,l,t,n]);React.useEffect((()=>{o.current=r;}),[r]),React.useEffect((()=>{i();}),[i]),i();}const Nr={noRowsLabel:"No rows",noResultsOverlayLabel:"No results found.",errorOverlayDefaultLabel:"An error occurred.",toolbarDensity:"Density",toolbarDensityLabel:"Density",toolbarDensityCompact:"Compact",toolbarDensityStandard:"Standard",toolbarDensityComfortable:"Comfortable",toolbarColumns:"Columns",toolbarColumnsLabel:"Select columns",toolbarFilters:"Filters",toolbarFiltersLabel:"Show filters",toolbarFiltersTooltipHide:"Hide filters",toolbarFiltersTooltipShow:"Show filters",toolbarFiltersTooltipActive:e=>1!==e?`${e} active filters`:`${e} active filter`,toolbarExport:"Export",toolbarExportLabel:"Export",toolbarExportCSV:"Download as CSV",columnsPanelTextFieldLabel:"Find column",columnsPanelTextFieldPlaceholder:"Column title",columnsPanelDragIconLabel:"Reorder column",columnsPanelShowAllButton:"Show all",columnsPanelHideAllButton:"Hide all",filterPanelAddFilter:"Add filter",filterPanelDeleteIconLabel:"Delete",filterPanelOperators:"Operators",filterPanelOperatorAnd:"And",filterPanelOperatorOr:"Or",filterPanelColumns:"Columns",filterPanelInputLabel:"Value",filterPanelInputPlaceholder:"Filter value",filterOperatorContains:"contains",filterOperatorEquals:"equals",filterOperatorStartsWith:"starts with",filterOperatorEndsWith:"ends with",filterOperatorIs:"is",filterOperatorNot:"is not",filterOperatorAfter:"is after",filterOperatorOnOrAfter:"is on or after",filterOperatorBefore:"is before",filterOperatorOnOrBefore:"is on or before",filterOperatorIsEmpty:"is empty",filterOperatorIsNotEmpty:"is not empty",filterValueAny:"any",filterValueTrue:"true",filterValueFalse:"false",columnMenuLabel:"Menu",columnMenuShowColumns:"Show columns",columnMenuFilter:"Filter",columnMenuHideColumn:"Hide",columnMenuUnsort:"Unsort",columnMenuSortAsc:"Sort by ASC",columnMenuSortDesc:"Sort by DESC",columnHeaderFiltersTooltipActive:e=>1!==e?`${e} active filters`:`${e} active filter`,columnHeaderFiltersLabel:"Show filters",columnHeaderSortIconLabel:"Sort",footerRowSelected:e=>1!==e?`${e.toLocaleString()} rows selected`:`${e.toLocaleString()} row selected`,footerTotalRows:"Total Rows:",footerTotalVisibleRows:(e,t)=>`${e.toLocaleString()} of ${t.toLocaleString()}`,checkboxSelectionHeaderName:"Checkbox selection",booleanCellTrueLabel:"true",booleanCellFalseLabel:"false",MuiTablePagination:{}};var $r;!function(e){e.Compact="compact",e.Standard="standard",e.Comfortable="comfortable";}($r||($r={}));const Vr={client:"client",server:"server"},Br={columnBuffer:2,density:$r.Standard,filterMode:Vr.client,headerHeight:56,paginationMode:Vr.client,rowHeight:52,rowsPerPageOptions:[25,50,100],scrollEndThreshold:80,sortingMode:Vr.client,sortingOrder:["asc","desc",null],logger:console,logLevel:"production"===process.env.NODE_ENV?"error":"warn"},Wr=Object.assign(Object.assign({},Br),{localeText:Nr});var Zr;!function(e){e.And="and",e.Or="or";}(Zr||(Zr={}));const Xr=()=>({items:[],linkOperator:Zr.And});const el=()=>({rows:{idRowsLookup:{},allRows:[],totalRowCount:0},editRows:{},pagination:{page:0,pageCount:0,rowCount:0,pageSize:100},options:Wr,isScrolling:!1,columns:{all:[],lookup:{}},columnReorder:{dragCol:""},columnResize:{resizingColumnField:""},rendering:{realScroll:{left:0,top:0},renderContext:null,renderingZoneScroll:{left:0,top:0},virtualPage:0,virtualRowsCount:0},containerSizes:null,scrollBar:{hasScrollX:!1,hasScrollY:!1,scrollBarSize:{x:0,y:0}},viewportSizes:{width:0,height:1},sorting:{sortedRows:[],sortModel:[]},focus:{cell:null,columnHeader:null},tabIndex:{cell:null,columnHeader:null},selection:[],filter:Xr(),columnMenu:{open:!1},preferencePanel:{open:!1},visibleRows:{visibleRowsLookup:{}},density:{value:$r.Standard,rowHeight:52,headerHeight:56}}),tl=t=>{const r=Ar("useGridApi"),[,l]=React.useState();t.current.state||(r.info("Initialising state."),t.current.state=el(),t.current.forceUpdate=l);const n=React.useCallback((()=>t.current.state),[t]),o=React.useCallback((e=>{let r;r=yr(e)?e(t.current.state):e,t.current.state=r,l((()=>r));const n={api:t.current,state:r};t.current.publishEvent(ne.stateChange,n);}),[t]);return _r(t,{getState:n,setState:o},"GridStateApi"),t.current},rl=t=>{tl(t);const r=React.useCallback((()=>t.current.forceUpdate((()=>t.current.state))),[t]),l=React.useCallback((e=>{const r=e(t.current.state);if(t.current.state===r)return !1;const{ignoreSetState:l,postUpdate:n}=t.current.applyControlStateConstraint(r);if(!l&&(t.current.state=r,t.current.publishEvent)){const e={api:t.current,state:r};t.current.publishEvent(ne.stateChange,e);}return n(),!l}),[t]);return [t.current.state,l,r]},ll=(e,t)=>{const[r]=rl(e);return t(r)},nl=e=>e.rendering,ol=createSelector(nl,(e=>e.realScroll)),al=React.memo((function({width:t,height:r}){return t&&r?React.createElement("div",{style:{minWidth:t,maxWidth:t,lineHeight:r-1+"px",minHeight:r,maxHeight:r},className:"MuiDataGrid-cell"}):null})),il=e=>e.options;var sl$1;function cl(t,r,l,n){const o=Ar("useGridApiEventHandler"),{signature:a}=ll(t,il);React.useEffect((()=>{if(l&&r){const e=(e,r,n={})=>{a===sl$1.XGrid&&(n.api=t.current),r.defaultMuiPrevented||l(e,r,n);};return t.current.subscribeEvent(r,e,n)}}),[t,o,r,l,n,a]);}!function(e){e.DataGrid="DataGrid",e.XGrid="XGrid";}(sl$1||(sl$1={}));const ul={isFirst:!0};function dl(e,t,r){cl(e,t,r,ul);}const pl=React.memo((function(t){const{scrollDirection:l}=t,n=React.useRef(null),o=ae(),a=React.useRef(),[i,s]=React.useState(!1),c=React.useRef({left:0,top:0}),u=React.useCallback((e=>{c.current=e;}),[]),d=React.useCallback((e=>{let t;if("left"===l)t=e.clientX-n.current.getBoundingClientRect().right;else {if("right"!==l)throw new Error("wrong dir");t=Math.max(1,e.clientX-n.current.getBoundingClientRect().left);}t=1.5*(t-1)+1,clearTimeout(a.current),a.current=setTimeout((()=>{o.current.scroll({left:c.current.left+t,top:c.current.top});}));}),[l,o]);React.useEffect((()=>()=>{clearTimeout(a.current);}),[]);const p=React.useCallback((()=>{s((e=>!e));}),[]);return cl(o,ne.rowsScroll,u),cl(o,ne.columnHeaderDragStart,p),cl(o,ne.columnHeaderDragEnd,p),i?React.createElement("div",{ref:n,className:r("MuiDataGrid-scrollArea",`MuiDataGrid-scrollArea--${l}`),onDragOver:d}):null})),ml=e=>e.columnReorder,fl=createSelector(ml,(e=>e.dragCol)),gl=e=>e.columnResize,bl=createSelector(gl,(e=>e.resizingColumnField)),hl=e=>e.rows,vl=createSelector(hl,(e=>e&&e.totalRowCount)),Cl=createSelector(hl,(e=>e&&e.idRowsLookup)),wl=createSelector(hl,(e=>e.allRows));createSelector(hl,(e=>e.allRows.map((t=>e.idRowsLookup[t]))));const yl=e=>e.sorting,El=createSelector(yl,wl,((e,t)=>e.sortedRows.length?e.sortedRows:t)),Sl=createSelector(El,Cl,((e,t)=>{const r=new Map;return e.forEach((e=>{r.set(e,t[e]);})),r})),Ml=createSelector(yl,(e=>e.sortModel)),xl=createSelector(Ml,(e=>e.reduce(((t,r,l)=>(t[r.field]={sortDirection:r.sort,sortIndex:e.length>1?l+1:void 0},t)),{}))),kl=e=>e.visibleRows,Dl=createSelector(kl,Sl,((e,t)=>{const r=new Map;return t.forEach(((t,l)=>{!1!==e.visibleRowsLookup[l]&&r.set(l,t);})),r})),Rl=createSelector(Dl,(e=>[...e.entries()])),Il=createSelector(Dl,(e=>[...e.keys()])),Pl=createSelector(kl,vl,((e,t)=>null==e.visibleRows?t:e.visibleRows.length)),Ll=e=>e.filter,Fl=createSelector(Ll,ce,((e,t)=>{var r;return null===(r=e.items)||void 0===r?void 0:r.filter((e=>{var r,l;if(!e.columnField)return !1;const n=t[e.columnField];if(!(null==n?void 0:n.filterOperators)||0===(null===(r=null==n?void 0:n.filterOperators)||void 0===r?void 0:r.length))return !1;const o=n.filterOperators.find((t=>t.value===e.operatorValue));return !!o&&(!o.InputComponent||null!=e.value&&""!==(null===(l=e.value)||void 0===l?void 0:l.toString()))}))})),jl=createSelector(Fl,(e=>e.length)),zl=createSelector(Fl,(e=>e.reduce(((e,t)=>(e[t.columnField]?e[t.columnField].push(t):e[t.columnField]=[t],e)),{}))),Tl=e=>e.focus,Hl=createSelector(Tl,(e=>e.cell)),Al=createSelector(Tl,(e=>e.columnHeader)),_l=e=>e.tabIndex,Gl=createSelector(_l,(e=>e.cell)),Nl=createSelector(_l,(e=>e.columnHeader)),$l=e=>e.density,Vl=createSelector($l,(e=>e.value)),Bl=createSelector($l,(e=>e.rowHeight)),Wl=createSelector($l,(e=>e.headerHeight)),Ul=e=>e.columnMenu,Kl=e=>"Escape"===e,Zl=e=>"Enter"===e,Xl=e=>"Tab"===e,ql=e=>" "===e,Yl=e=>0===e.indexOf("Arrow"),Jl=e=>"Home"===e||"End"===e,Ql=e=>0===e.indexOf("Page"),en=e=>"Delete"===e||"Backspace"===e,tn=/^(\p{L}|\p{M}\p{L}|\p{M}|\p{N}|\p{Z}|\p{S}|\p{P})$/iu,rn=e=>tn.test(e),ln=["Enter","Escape","Tab"],nn=["Enter","Tab"],on=e=>nn.indexOf(e)>-1,an=e=>Jl(e)||Yl(e)||Ql(e)||ql(e),sn=e=>!!e.key,cn=e=>Xl(e)||Kl(e),un=React.createContext(void 0);"production"!==process.env.NODE_ENV&&(un.displayName="GridRootPropsContext");const dn=()=>{const t=React.useContext(un);if(!t)throw new Error("Material-UI: useGridRootProps should only be used inside the DataGrid/XGrid component.");return t},pn=React.forwardRef((function(t,r){var l;const{field:n,id:o,value:a,tabIndex:i,hasFocus:s}=t,u=ae(),d=dn(),p=React.useRef(null),m=useForkRef(p,r),f=t.api.getCellElement(o,n);React.useLayoutEffect((()=>{0===i&&f&&(f.tabIndex=-1);}),[f,i]),React.useLayoutEffect((()=>{if(s&&p.current){p.current.querySelector("input").focus();}}),[s]);const g=React.useCallback((e=>{ql(e.key)&&e.stopPropagation(),an(e.key)&&!e.shiftKey&&u.current.publishEvent(ne.cellNavigationKeyDown,t,e);}),[u,t]),b=null==u?void 0:u.current.components.Checkbox,h=!d.isRowSelectable||d.isRowSelectable(u.current.getRowParams(o));return React.createElement(b,Object.assign({ref:m,tabIndex:i,checked:!!a,onChange:e=>{u.current.selectRow(o,e.target.checked,!0);},onClick:e=>{e.stopPropagation();},className:"MuiDataGrid-checkboxInput",color:"primary",inputProps:{"aria-label":"Select Row checkbox"},onKeyDown:g,disabled:!h},null===(l=null==u?void 0:u.current.componentsProps)||void 0===l?void 0:l.checkbox))})),mn=React.memo(pn),fn=e=>e.pagination,gn=createSelector(fn,Il,((e,t)=>{const r=e.page*e.pageSize,l=r+e.pageSize;return t.slice(r,l)})),bn=e=>e.selection,hn=createSelector(bn,(e=>e.length)),vn=createSelector(bn,Cl,((e,t)=>new Map(e.map((e=>[e,t[e]]))))),Cn=createSelector(bn,(e=>e.reduce(((e,t)=>(e[t]=t,e)),{}))),wn=React.forwardRef((function(t,r){var l;const[,n]=React.useState(!1),o=ae(),a=ll(o,il),i=ll(o,Nl),s=ll(o,hn),c=ll(o,vl),u=s>0&&s!==c,d=s>0&&s===c||u,p=null!==i&&i.field===t.field?0:-1;React.useLayoutEffect((()=>{const e=o.current.getColumnHeaderElement(t.field);0===p&&e&&(e.tabIndex=-1);}),[p,o,t.field]);const m=React.useCallback((e=>{ql(e.key)&&e.stopPropagation(),an(e.key)&&!e.shiftKey&&o.current.publishEvent(ne.columnHeaderNavigationKeyDown,t,e);}),[o,t]),f=React.useCallback((()=>{n((e=>!e));}),[]);React.useEffect((()=>null==o?void 0:o.current.subscribeEvent(ne.selectionChange,f)),[o,f]);const g=null==o?void 0:o.current.components.Checkbox;return React.createElement(g,Object.assign({ref:r,indeterminate:u,checked:d,onChange:e=>{const t=e.target.checked,r=a.checkboxSelectionVisibleOnly?gn(o.current.state):Il(o.current.state);o.current.selectRows(r,t,!e.target.indeterminate);},className:"MuiDataGrid-checkboxInput",color:"primary",inputProps:{"aria-label":"Select All Rows checkbox"},tabIndex:p,onKeyDown:m},null===(l=null==o?void 0:o.current.componentsProps)||void 0===l?void 0:l.checkbox))}));
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function On(e,t){var r={};for(var l in e)Object.prototype.hasOwnProperty.call(e,l)&&t.indexOf(l)<0&&(r[l]=e[l]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(l=Object.getOwnPropertySymbols(e);n<l.length;n++)t.indexOf(l[n])<0&&Object.prototype.propertyIsEnumerable.call(e,l[n])&&(r[l[n]]=e[l[n]]);}return r}function yn(t){const{id:r,value:l,formattedValue:n,api:o,field:a,row:i,colDef:s,cellMode:c,isEditable:u,tabIndex:d,hasFocus:p,getValue:m}=t,f=On(t,["id","value","formattedValue","api","field","row","colDef","cellMode","isEditable","tabIndex","hasFocus","getValue"]),g=React.useRef(),[b,h]=React.useState(l),C=React.useCallback((e=>{const t=e.target.value;h(t),o.setEditCellValue({id:r,field:a,value:t},e);}),[o,a,r]);return React.useEffect((()=>{h(l);}),[l]),vr((()=>{p&&g.current.focus();}),[p]),React.createElement(v,Object.assign({inputRef:g,className:"MuiDataGrid-editInputCell",fullWidth:!0,type:"number"===s.type?s.type:"text",value:b||"",onChange:C},f))}const En=t=>React.createElement(yn,Object.assign({},t)),Sn=(e,t)=>{const r=e.indexOf(t);return t&&-1!==r&&r+1!==e.length?e[r+1]:e[0]},Mn=(e,t)=>null==e&&null!=t?-1:null==t&&null!=e?1:null==e&&null==t?0:null,xn=new Intl.Collator,kn=(e,t)=>{const r=Mn(e,t);return null!==r?r:Number(e)-Number(t)},Dn=(e,t)=>{const r=Mn(e,t);return null!==r?r:e>t?1:e<t?-1:0},Rn=createSvgIcon(React.createElement("path",{d:"M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"}),"ArrowUpward"),In=createSvgIcon(React.createElement("path",{d:"M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"}),"ArrowDownward"),Pn=createSvgIcon(React.createElement("path",{d:"M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"}),"FilterList"),Ln=createSvgIcon(React.createElement("path",{d:"M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"}),"FilterAlt");createSvgIcon(React.createElement("path",{d:"M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"}),"Search");createSvgIcon(React.createElement("path",{d:"M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"}),"Menu");createSvgIcon(React.createElement("path",{d:"M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"}),"CheckCircle");const Tn=createSvgIcon(React.createElement("path",{d:"M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"}),"ColumnIcon"),Hn=createSvgIcon(React.createElement("path",{d:"M11 19V5h2v14z"}),"Separator"),An=createSvgIcon(React.createElement("path",{d:"M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"}),"ViewHeadline"),_n=createSvgIcon(React.createElement("path",{d:"M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"}),"TableRows"),Gn=createSvgIcon(React.createElement("path",{d:"M4 18h17v-6H4v6zM4 5v6h17V5H4z"}),"ViewStream"),Nn=createSvgIcon(React.createElement("path",{d:"M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"}),"TripleDotsVertical"),$n=createSvgIcon(React.createElement("path",{d:"M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"}),"Close"),Vn=createSvgIcon(React.createElement("path",{d:"M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"}),"Add"),Bn=createSvgIcon(React.createElement("path",{d:"M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"}),"Load"),Wn=createSvgIcon(React.createElement("path",{d:"M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"}),"Drag"),Un=createSvgIcon(React.createElement("path",{d:"M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"}),"SaveAlt"),Kn=createSvgIcon(React.createElement("path",{d:"M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"}),"Check"),Zn=({valueOptions:t})=>(t?["",...t]:[""]).map((t=>"object"==typeof t?React.createElement("option",{key:t.value,value:t.value},t.label):React.createElement("option",{key:t,value:t},t)));function qn(t){const{item:r,applyValue:l,type:n,apiRef:o}=t,a=On(t,["item","applyValue","type","apiRef"]),i=React.useRef(),[s,c]=React.useState(r.value||""),[u,p]=React.useState(!1),m=unstable_useId(),f="singleSelect"===n?{select:!0,SelectProps:{native:!0},children:Zn(o.current.getColumn(r.columnField))}:{},g=React.useCallback((e=>{let t=e.target.value;if("singleSelect"===n){const e=o.current.getColumn(r.columnField);t=e.valueOptions.map((e=>"object"==typeof e?e.value:e)).find((e=>String(e)===t));}clearTimeout(i.current),c(t),p(!0),i.current=setTimeout((()=>{l(Object.assign(Object.assign({},r),{value:t})),p(!1);}),500);}),[o,l,r,n]);React.useEffect((()=>()=>{clearTimeout(i.current);}),[]),React.useEffect((()=>{c(r.value||"");}),[r.value]);const b=u?{endAdornment:React.createElement(Bn,null)}:a.InputProps;return React.createElement(C$1,Object.assign({id:m,label:o.current.getLocaleText("filterPanelInputLabel"),placeholder:o.current.getLocaleText("filterPanelInputPlaceholder"),value:s,onChange:g,type:n||"text",variant:"standard",InputProps:b,InputLabelProps:{shrink:!0}},f,a))}const Yn=()=>[{value:"contains",getApplyFilterFn:e=>{if(!e.value)return null;const t=new RegExp(Rr(e.value),"i");return ({value:e})=>t.test(e&&e.toString()||"")},InputComponent:qn},{value:"equals",getApplyFilterFn:e=>{if(!e.value)return null;const t=new Intl.Collator(void 0,{sensitivity:"base",usage:"search"});return ({value:r})=>0===t.compare(e.value,r&&r.toString()||"")},InputComponent:qn},{value:"startsWith",getApplyFilterFn:e=>{if(!e.value)return null;const t=new RegExp(`^${Rr(e.value)}.*$`,"i");return ({value:e})=>t.test(e&&e.toString()||"")},InputComponent:qn},{value:"endsWith",getApplyFilterFn:e=>{if(!e.value)return null;const t=new RegExp(`.*${Rr(e.value)}$`,"i");return ({value:e})=>t.test(e&&e.toString()||"")},InputComponent:qn},{value:"isEmpty",getApplyFilterFn:()=>({value:e})=>""===e||null==e},{value:"isNotEmpty",getApplyFilterFn:()=>({value:e})=>""!==e&&null!=e}],Jn={width:100,minWidth:50,hide:!1,sortable:!0,resizable:!0,filterable:!0,sortComparator:(e,t)=>{const r=Mn(e,t);return null!==r?r:"string"==typeof e?xn.compare(e.toString(),t.toString()):e-t},type:"string",align:"left",filterOperators:Yn(),renderEditCell:En},Qn=React.memo((t=>{const{id:r,value:l,formattedValue:n,api:o,field:a,row:i,colDef:s,cellMode:c,isEditable:u,hasFocus:d,tabIndex:p,getValue:m}=t,f=On(t,["id","value","formattedValue","api","field","row","colDef","cellMode","isEditable","hasFocus","tabIndex","getValue"]),g=React.useMemo((()=>l?o.components.BooleanCellTrueIcon:o.components.BooleanCellFalseIcon),[o.components.BooleanCellFalseIcon,o.components.BooleanCellTrueIcon,l]);return React.createElement(g,Object.assign({fontSize:"small",className:"MuiDataGrid-booleanCell",titleAccess:o.getLocaleText(l?"booleanCellTrueLabel":"booleanCellFalseLabel"),"data-value":Boolean(l)},f))}));function eo(t){const{id:l,value:n,formattedValue:o,api:a,field:i,row:s,colDef:c,cellMode:u,isEditable:p,tabIndex:m,className:f,getValue:g,hasFocus:b}=t,h=On(t,["id","value","formattedValue","api","field","row","colDef","cellMode","isEditable","tabIndex","className","getValue","hasFocus"]),v=React.useRef(null),C=unstable_useId(),[O,y]=React.useState(n),E=React.useCallback((e=>{const t=e.target.checked;y(t),a.setEditCellValue({id:l,field:i,value:t},e);}),[a,i,l]);return React.useEffect((()=>{y(n);}),[n]),vr((()=>{b&&v.current.focus();}),[b]),React.createElement("label",Object.assign({htmlFor:C,className:r("MuiDataGrid-editBooleanCell",f)},h),React.createElement(w,{id:C,inputRef:v,checked:Boolean(O),onChange:E,size:"small"}))}function to$2(t){const{item:r,applyValue:l,apiRef:n}=t,o=On(t,["item","applyValue","apiRef"]),[a,i]=React.useState(r.value||""),s=React.useCallback((e=>{const t=e.target.value;i(t),l(Object.assign(Object.assign({},r),{value:t}));}),[l,r]);return React.useEffect((()=>{i(r.value||"");}),[r.value]),React.createElement(C$1,Object.assign({label:n.current.getLocaleText("filterPanelInputLabel"),value:a,onChange:s,variant:"standard",select:!0,SelectProps:{native:!0},InputLabelProps:{shrink:!0}},o),React.createElement("option",{value:""},n.current.getLocaleText("filterValueAny")),React.createElement("option",{value:"true"},n.current.getLocaleText("filterValueTrue")),React.createElement("option",{value:"false"},n.current.getLocaleText("filterValueFalse")))}const ro=Object.assign(Object.assign({},Jn),{type:"boolean",align:"center",headerAlign:"center",renderCell:t=>React.createElement(Qn,Object.assign({},t)),renderEditCell:t=>React.createElement(eo,Object.assign({},t)),sortComparator:kn,valueFormatter:function({value:e,api:t}){return e?t.getLocaleText("booleanCellTrueLabel"):t.getLocaleText("booleanCellFalseLabel")},filterOperators:[{value:"is",getApplyFilterFn:e=>{if(!e.value)return null;const t="true"===e.value;return ({value:e})=>Boolean(e)===t},InputComponent:to$2}]}),lo=Object.assign(Object.assign({},ro),{field:"__check__",type:"checkboxSelection",width:50,resizable:!1,sortable:!1,filterable:!1,disableColumnMenu:!0,disableReorder:!0,valueGetter:e=>void 0!==Cn(e.api.state)[e.id],renderHeader:t=>React.createElement(wn,Object.assign({},t)),renderCell:t=>React.createElement(mn,Object.assign({},t)),cellClassName:"MuiDataGrid-cellCheckbox",headerClassName:"MuiDataGrid-columnHeaderCheckbox"}),no=()=>[{label:"=",value:"=",getApplyFilterFn:e=>e.value?({value:t})=>Number(t)===e.value:null,InputComponent:qn,InputComponentProps:{type:"number"}},{label:"!=",value:"!=",getApplyFilterFn:e=>e.value?({value:t})=>Number(t)!==e.value:null,InputComponent:qn,InputComponentProps:{type:"number"}},{label:">",value:">",getApplyFilterFn:e=>e.value?({value:t})=>Number(t)>e.value:null,InputComponent:qn,InputComponentProps:{type:"number"}},{label:">=",value:">=",getApplyFilterFn:e=>e.value?({value:t})=>Number(t)>=e.value:null,InputComponent:qn,InputComponentProps:{type:"number"}},{label:"<",value:"<",getApplyFilterFn:e=>e.value?({value:t})=>Number(t)<e.value:null,InputComponent:qn,InputComponentProps:{type:"number"}},{label:"<=",value:"<=",getApplyFilterFn:e=>e.value?({value:t})=>Number(t)<=e.value:null,InputComponent:qn,InputComponentProps:{type:"number"}},{value:"isEmpty",getApplyFilterFn:()=>({value:e})=>null==e},{value:"isNotEmpty",getApplyFilterFn:()=>({value:e})=>null!=e}],oo=Object.assign(Object.assign({},Jn),{type:"number",align:"right",headerAlign:"right",sortComparator:kn,valueParser:e=>Number(e),valueFormatter:({value:e})=>e&&function(e){return "number"==typeof e}(e)&&e.toLocaleString()||e,filterOperators:no()}),ao=/(\d+)-(\d+)-(\d+)/,io=/(\d+)-(\d+)-(\d+)T(\d+):(\d+)/;function so(e,t,r,l){if(!e.value)return null;const[n,o,a,i,s]=e.value.match(r?io:ao).slice(1).map(Number),c=new Date(n,o-1,a,i||0,s||0).getTime();return ({value:e})=>{if(!e)return !1;const n=e instanceof Date?e:new Date(e.toString());if(l)return t(n.getTime(),c);const o=(e instanceof Date?new Date(n):n).setHours(r?n.getHours():0,r?n.getMinutes():0,0,0);return t(o,c)}}const co=e=>[{value:"is",getApplyFilterFn:t=>so(t,((e,t)=>e===t),e),InputComponent:qn,InputComponentProps:{type:e?"datetime-local":"date"}},{value:"not",getApplyFilterFn:t=>so(t,((e,t)=>e!==t),e),InputComponent:qn,InputComponentProps:{type:e?"datetime-local":"date"}},{value:"after",getApplyFilterFn:t=>so(t,((e,t)=>e>t),e),InputComponent:qn,InputComponentProps:{type:e?"datetime-local":"date"}},{value:"onOrAfter",getApplyFilterFn:t=>so(t,((e,t)=>e>=t),e),InputComponent:qn,InputComponentProps:{type:e?"datetime-local":"date"}},{value:"before",getApplyFilterFn:t=>so(t,((e,t)=>e<t),e,!e),InputComponent:qn,InputComponentProps:{type:e?"datetime-local":"date"}},{value:"onOrBefore",getApplyFilterFn:t=>so(t,((e,t)=>e<=t),e),InputComponent:qn,InputComponentProps:{type:e?"datetime-local":"date"}},{value:"isEmpty",getApplyFilterFn:()=>({value:e})=>null==e},{value:"isNotEmpty",getApplyFilterFn:()=>({value:e})=>null!=e}];function uo(t){const{id:r,value:l,formattedValue:n,api:o,field:a,row:i,colDef:s,cellMode:c,isEditable:u,tabIndex:d,hasFocus:p,getValue:m}=t,f=On(t,["id","value","formattedValue","api","field","row","colDef","cellMode","isEditable","tabIndex","hasFocus","getValue"]),g=React.useRef(),[b,h]=React.useState(l),C=React.useCallback((e=>{const t=e.target.value;if(h(t),""===t)return void o.setEditCellValue({id:r,field:a,value:null},e);const[l,n]=t.split("T"),[i,s,c]=l.split("-"),u=new Date;if(u.setFullYear(Number(i)),u.setMonth(Number(s)-1),u.setDate(Number(c)),u.setHours(0,0,0,0),n){const[e,t]=n.split(":");u.setHours(Number(e),Number(t),0,0);}o.setEditCellValue({id:r,field:a,value:u},e);}),[o,a,r]),w="dateTime"===s.type;React.useEffect((()=>{h(l);}),[l]),vr((()=>{p&&g.current.focus();}),[p]);let O=b||"";if(b instanceof Date){const e=b.getTimezoneOffset();O=new Date(b.getTime()-60*e*1e3).toISOString().substr(0,w?16:10);}return React.createElement(v,Object.assign({inputRef:g,fullWidth:!0,className:"MuiDataGrid-editInputCell",type:w?"datetime-local":"date",value:O,onChange:C},f))}const po=t=>React.createElement(uo,Object.assign({},t));function mo({value:e}){return e instanceof Date?e.toLocaleDateString():e}function fo({value:e}){return e instanceof Date?e.toLocaleString():e}const go=Object.assign(Object.assign({},Jn),{type:"date",sortComparator:Dn,valueFormatter:mo,filterOperators:co(),renderEditCell:po}),bo=Object.assign(Object.assign({},Jn),{type:"dateTime",sortComparator:Dn,valueFormatter:fo,filterOperators:co(!0),renderEditCell:po}),ho=t=>"object"==typeof t?React.createElement(y$1,{key:t.value,value:t.value},t.label):React.createElement(y$1,{key:t,value:t},t);function vo(t){var r;const{id:l,value:n,formattedValue:o,api:a,field:i,row:s,colDef:c,cellMode:u,isEditable:d,tabIndex:p,className:m,getValue:f,hasFocus:g}=t,b=On(t,["id","value","formattedValue","api","field","row","colDef","cellMode","isEditable","tabIndex","className","getValue","hasFocus"]),h=React.useRef();return vr((()=>{g&&h.current.querySelector('[role="button"]').focus();}),[g]),React.createElement(O,Object.assign({ref:h,value:n,onChange:e=>{a.setEditCellValue({id:l,field:i,value:e.target.value},e),e.key||(a.commitCellChange({id:l,field:i},e),a.setCellMode(l,i,"view"));},MenuProps:{onClose:(e,t)=>{("backdropClick"===t||Kl(e.key))&&a.setCellMode(l,i,"view");}},fullWidth:!0,open:!0},b),null===(r=c.valueOptions)||void 0===r?void 0:r.map(ho))}const Co=t=>React.createElement(vo,Object.assign({},t)),wo=Object.assign(Object.assign({},Jn),{type:"singleSelect",renderEditCell:Co,filterOperators:[{value:"is",getApplyFilterFn:e=>null==e.value||""===e.value?null:({value:t})=>"object"==typeof t?e.value===t.value:e.value===t,InputComponent:qn,InputComponentProps:{type:"singleSelect"}},{value:"not",getApplyFilterFn:e=>null==e.value||""===e.value?null:({value:t})=>"object"==typeof t?e.value!==t.value:e.value!==t,InputComponent:qn,InputComponentProps:{type:"singleSelect"}}]}),yo=()=>{const e={string:Jn,number:oo,date:go,dateTime:bo,boolean:ro,singleSelect:wo};return e.__default__=Jn,e},Eo=(e,t)=>t?e[t]:e.__default__;const Ro=React.memo((function(t){const{direction:r,index:l}=t,n=ae(),o=n.current.components.ColumnUnsortedIcon;if(null==r&&null===o)return null;const a=React.createElement(IconButton,{tabIndex:-1,"aria-label":n.current.getLocaleText("columnHeaderSortIconLabel"),title:n.current.getLocaleText("columnHeaderSortIconLabel"),size:"small"},function(t,r){let l=t.ColumnUnsortedIcon;return "asc"===r?l=t.ColumnSortedAscendingIcon:"desc"===r&&(l=t.ColumnSortedDescendingIcon),React.createElement(l,{fontSize:"small",className:"MuiDataGrid-sortIcon"})}(n.current.components,r));return React.createElement("div",{className:"MuiDataGrid-iconButtonContainer"},null!=l&&React.createElement(E$1,{badgeContent:l,color:"default"},a),null==l&&a)}));function Io(e,t){return e.closest(`.${t}`)}function Po(e){return null!=e&&e.classList.contains("MuiDataGrid-columnHeader")}function Lo(e){const t=e.getAttribute("data-field"),r=Io(e,"MuiDataGrid-root");if(!r)throw new Error("Material-UI: The root element is not found.");return r.querySelectorAll(`.MuiDataGrid-cell[data-field="${t}"]`)}function Fo(e){return e.replace(/["\\]/g,"\\$&")}function jo(e,t){return e.querySelector(`.MuiDataGrid-row[data-id="${Fo(String(t))}"]`)}const zo=React.forwardRef((function(t,l){const{className:n}=t,o=On(t,["className"]);return React.createElement("div",Object.assign({ref:l,className:r("MuiDataGrid-columnHeaderTitle",n)},o))}));function To(t){const{label:r,description:l,columnWidth:n}=t,o=React.useRef(null),[a,i]=React.useState("");return React.useEffect((()=>{if(!l&&o&&o.current){const t=(e=o.current).scrollHeight>e.clientHeight||e.scrollWidth>e.clientWidth;i(t?r:"");}var e;}),[o,n,l,r]),React.createElement(M,{title:l||a},React.createElement(zo,{ref:o},r))}let Ho=!1;"undefined"!=typeof process&&void 0!==process.env.GRID_EXPERIMENTAL_ENABLED&&kr()&&window.localStorage.getItem("GRID_EXPERIMENTAL_ENABLED")?Ho="true"===window.localStorage.getItem("GRID_EXPERIMENTAL_ENABLED"):"undefined"!=typeof process&&(Ho="true"===process.env.GRID_EXPERIMENTAL_ENABLED);const Ao=Ho,_o=React.memo((function(t){const{resizable:l,resizing:n,height:o}=t,a=On(t,["resizable","resizing","height"]),i=ae(),{showColumnRightBorder:s}=ll(i,il),c=i.current.components.ColumnResizeIcon,u=React.useCallback((e=>{e.preventDefault(),e.stopPropagation();}),[]);return React.createElement("div",Object.assign({className:r("MuiDataGrid-columnSeparator",{"MuiDataGrid-columnSeparator--resizable":l,"Mui-resizing":n}),style:{minHeight:o,opacity:s?0:1}},a,{onClick:u}),React.createElement(c,{className:"MuiDataGrid-iconSeparator"}))})),Go=React.memo((t=>{const{column:l,open:n,columnMenuId:o,columnMenuButtonId:a,iconButtonRef:i}=t,s=ae(),c=s.current.components.ColumnMenuIcon,u=React.useCallback((e=>{e.preventDefault(),e.stopPropagation(),s.current.toggleColumnMenu(l.field);}),[s,l.field]);return React.createElement("div",{className:r("MuiDataGrid-menuIcon",{"MuiDataGrid-menuOpen":n})},React.createElement(IconButton,{ref:i,tabIndex:-1,className:"MuiDataGrid-menuIconButton","aria-label":s.current.getLocaleText("columnMenuLabel"),title:s.current.getLocaleText("columnMenuLabel"),size:"small",onClick:u,"aria-expanded":n?"true":void 0,"aria-haspopup":"true","aria-controls":o,id:a},React.createElement(c,{fontSize:"small"})))})),No=e=>e.preferencePanel;var Vo;function Bo(t){const{counter:r}=t,l=ae(),n=l.current.components.ColumnFilteredIcon,o=React.useCallback((e=>{e.preventDefault(),e.stopPropagation();const{open:t,openedPanelValue:r}=No(l.current.state);t&&r===Vo.filters?l.current.hideFilterPanel():l.current.showFilterPanel();}),[l]);if(!r)return null;const a=React.createElement(IconButton,{onClick:o,color:"default","aria-label":l.current.getLocaleText("columnHeaderFiltersLabel"),size:"small",tabIndex:-1},React.createElement(n,{className:"MuiDataGrid-filterIcon",fontSize:"small"}));return React.createElement(M,{title:l.current.getLocaleText("columnHeaderFiltersTooltipActive")(r),enterDelay:1e3},React.createElement("div",{className:"MuiDataGrid-iconButtonContainer"},r>1&&React.createElement(E$1,{badgeContent:r,color:"default"},a),1===r&&a))}!function(e){e.filters="filters",e.columns="columns";}(Vo||(Vo={}));const Wo=makeStyles((e=>({root:{zIndex:e.zIndex.modal,"& .MuiDataGrid-gridMenuList":{outline:0}}})),{name:"MuiGridMenu",defaultTheme:xr()}),Uo={"bottom-start":"top left","bottom-end":"top right"},Ko=t=>{const{open:r,target:l,onClickAway:n,children:o,position:a}=t,i=On(t,["open","target","onClickAway","children","position"]),s=React.useRef(l),c=React.useRef(r),u=Wo();return React.useEffect((()=>{c.current&&s.current&&s.current.focus(),c.current=r,s.current=l;}),[r,l]),React.createElement(R,Object.assign({className:u.root,open:r,anchorEl:l,transition:!0,placement:a},i),(({TransitionProps:t,placement:r})=>React.createElement(x$1,{onClickAway:n},React.createElement(k,Object.assign({},t,{style:{transformOrigin:Uo[r]}}),React.createElement(Paper,null,o)))))};function Zo({columnMenuId:t,columnMenuButtonId:r,ContentComponent:l,contentComponentProps:n,field:o,open:a,target:i}){const s=ae(),c=null==s?void 0:s.current.getColumn(o),u=React.useCallback((e=>{e.stopPropagation(),null==s||s.current.hideColumnMenu();}),[s]);return i?React.createElement(Ko,{placement:"bottom-"+("right"===c.align?"start":"end"),open:a,target:i,onClickAway:u},React.createElement(l,Object.assign({currentColumn:c,hideMenu:u,open:a,id:t,labelledby:r},n))):null}function Xo(t){var l;const{column:n,columnMenuOpen:o,colIndex:a,headerHeight:i,isDragging:s,isResizing:c,sortDirection:u,sortIndex:p,options:m,filterItemsCounter:f,hasFocus:g,tabIndex:b}=t,h=ae(),v=React.useRef(null),C=unstable_useId(),w=unstable_useId(),O=React.useRef(null),{classes:y,disableColumnReorder:E,showColumnRightBorder:S,disableColumnResize:M,disableColumnMenu:x,disableColumnFilter:k}=m,D=null!=u,R="number"===n.type;let I=null;n.renderHeader&&h.current&&(I=n.renderHeader(h.current.getColumnHeaderParams(n.field)));const P=React.useCallback((e=>t=>h.current.publishEvent(e,h.current.getColumnHeaderParams(n.field),t)),[h,n.field]),L=React.useMemo((()=>({onClick:P(ne.columnHeaderClick),onDoubleClick:P(ne.columnHeaderDoubleClick),onMouseOver:P(ne.columnHeaderOver),onMouseOut:P(ne.columnHeaderOut),onMouseEnter:P(ne.columnHeaderEnter),onMouseLeave:P(ne.columnHeaderLeave),onKeyDown:P(ne.columnHeaderKeyDown),onFocus:P(ne.columnHeaderFocus),onBlur:P(ne.columnHeaderBlur)})),[P]),F=React.useMemo((()=>({onDragStart:P(ne.columnHeaderDragStart),onDragEnter:P(ne.columnHeaderDragEnter),onDragOver:P(ne.columnHeaderDragOver),onDragEnd:P(ne.columnHeaderDragEnd)})),[P]),j=React.useMemo((()=>({onMouseDown:P(ne.columnSeparatorMouseDown)})),[P]),z=[null==y?void 0:y.columnHeader];if(n.headerClassName){const e=yr(n.headerClassName)?n.headerClassName({field:n.field,colDef:n,api:h.current}):n.headerClassName;z.push(e);}const T=r("center"===n.headerAlign&&"MuiDataGrid-columnHeader--alignCenter","right"===n.headerAlign&&"MuiDataGrid-columnHeader--alignRight",{"MuiDataGrid-columnHeader--sortable":n.sortable,"MuiDataGrid-columnHeader--moving":s,"MuiDataGrid-columnHeader--sorted":D,"MuiDataGrid-columnHeader--numeric":R,"MuiDataGrid-withBorder":S},...z),H=n.computedWidth;let A;null!=u&&(A={"aria-sort":"asc"===u?"ascending":"descending"});const _=!x&&!n.disableColumnMenu&&React.createElement(Go,{column:n,columnMenuId:C,columnMenuButtonId:w,open:o,iconButtonRef:O}),G=React.createElement(React.Fragment,null,!k&&React.createElement(Bo,{counter:f}),n.sortable&&!n.hideSortIcons&&React.createElement(Ro,{direction:u,index:p}));return React.useLayoutEffect((()=>{const e=h.current.state.columnMenu;if(g&&!e.open){const e=v.current.querySelector('[tabindex="0"]');e?e.focus():v.current.focus();}})),React.createElement("div",Object.assign({ref:v,className:T,key:n.field,"data-field":n.field,style:{width:H,minWidth:H,maxWidth:H},role:"columnheader",tabIndex:b,"aria-colindex":a+1},A,L),React.createElement("div",Object.assign({className:"MuiDataGrid-columnHeaderDraggableContainer",draggable:!E&&!n.disableReorder},F),React.createElement("div",{className:"MuiDataGrid-columnHeaderTitleContainer"},I||React.createElement(To,{label:n.headerName||n.field,description:n.description,columnWidth:H}),G),_),React.createElement(_o,Object.assign({resizable:!M&&!!n.resizable,resizing:c,height:i},j)),React.createElement(Zo,{columnMenuId:C,columnMenuButtonId:w,field:n.field,open:o,target:O.current,ContentComponent:h.current.components.ColumnMenu,contentComponentProps:null===(l=h.current.componentsProps)||void 0===l?void 0:l.columnMenu}))}function qo(t){const{columns:r}=t,l=ae(),n=ll(l,il),o=ll(l,xl),a=ll(l,zl),i=ll(l,fl),s=ll(l,bl),c=ll(l,Al),u=ll(l,nl).renderContext,d=ll(l,Nl),p=ll(l,Gl),m=ll(l,Wl),f=ll(l,Ul),g=r.map(((t,r)=>{const l=(g=r,null==u?g:g+u.firstColIdx);var g;const b=0===l,h=!(null===d&&null===p),v=null!==d&&d.field===t.field||b&&!h?0:-1,C=null!==c&&c.field===t.field,w=f.open&&f.field===t.field;return React.createElement(Xo,Object.assign({key:t.field},o[t.field],{columnMenuOpen:w,filterItemsCounter:a[t.field]&&a[t.field].length,options:n,headerHeight:m,isDragging:t.field===i,column:t,colIndex:l,isResizing:s===t.field,hasFocus:C,tabIndex:v}))}));return React.createElement(React.Fragment,null,g)}const Yo=e=>e.containerSizes,Jo=e=>e.viewportSizes,Qo=e=>e.scrollBar,ea=createSelector(Yo,(e=>null==e?null:e.dataContainerSizes)),ta=createSelector(Yo,(e=>null==e?0:e.dataContainerSizes.height)),ra=e=>e.scrollBar,la=React.forwardRef((function(t,l){var n;const o=ae(),a=ll(o,de),i=ll(o,Yo),s=ll(o,Wl),c=ll(o,nl).renderContext,{hasScrollX:u}=ll(o,ra),d=ll(o,fl),p=r("MuiDataGrid-columnHeaderWrapper",{scroll:u,"MuiDataGrid-columnHeaderDropZone":d}),m=React.useMemo((()=>null==c?[]:a.slice(c.firstColIdx,c.lastColIdx+1)),[a,c]);return React.createElement(React.Fragment,null,React.createElement(pl,{scrollDirection:"left"}),React.createElement("div",{ref:l,className:p,"aria-rowindex":1,role:"row",style:{minWidth:null===(n=null==i?void 0:i.totalSizes)||void 0===n?void 0:n.width}},React.createElement(al,{width:null==c?void 0:c.leftEmptyWidth,height:s}),React.createElement(qo,{columns:m}),React.createElement(al,{width:null==c?void 0:c.rightEmptyWidth,height:s})),React.createElement(pl,{scrollDirection:"right"}))})),na=React.forwardRef((function(t,l){const{className:n,style:o}=t,a=On(t,["className","style"]),i=ae(),s=ll(i,Wl);return React.createElement("div",Object.assign({ref:l,className:r("MuiDataGrid-columnsContainer",n)},a,{style:Object.assign({minHeight:s,maxHeight:s,lineHeight:`${s}px`},o)}))}));function oa(t){return React.createElement("div",{className:"MuiDataGrid-main"},t.children)}const aa=React.forwardRef((function(t,l){const{className:n,size:o}=t,a=On(t,["className","size"]),i=ae(),{autoHeight:s}=ll(i,il),c=ll(i,Wl),u=ll(i,Bl),d=ll(i,ta);React.useEffect((()=>{i.current.resize();}),[i]);const p=React.useMemo((()=>{if(!s)return o.height;return c+(d<u?2*u:d)}),[s,d,c,u,o.height]);return React.createElement("div",{className:"MuiDataGrid-windowContainer",style:{width:o.width,height:p}},React.createElement("div",Object.assign({ref:l,className:r("MuiDataGrid-window",n)},a,{style:{top:c,overflowY:s?"hidden":"auto"}})))}));function ia(e,t){var r=function(e){var t=e.__resizeTriggers__,r=t.firstElementChild,l=t.lastElementChild,n=r.firstElementChild;l.scrollLeft=l.scrollWidth,l.scrollTop=l.scrollHeight,n.style.width=r.offsetWidth+1+"px",n.style.height=r.offsetHeight+1+"px",r.scrollLeft=r.scrollWidth,r.scrollTop=r.scrollHeight;},l=function(e){if(!(e.target.className.indexOf("contract-trigger")<0&&e.target.className.indexOf("expand-trigger")<0)){var l=this;r(this),this.__resizeRAF__&&t.cancelAnimationFrame(this.__resizeRAF__),this.__resizeRAF__=t.requestAnimationFrame((function(){(function(e){return e.offsetWidth!=e.__resizeLast__.width||e.offsetHeight!=e.__resizeLast__.height})(l)&&(l.__resizeLast__.width=l.offsetWidth,l.__resizeLast__.height=l.offsetHeight,l.__resizeListeners__.forEach((function(t){t.call(l,e);})));}));}},n=!1,o="",a="animationstart",i="Webkit Moz O ms".split(" "),s="webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" "),c=document.createElement("fakeelement");if(void 0!==c.style.animationName&&(n=!0),!1===n)for(var u=0;u<i.length;u++)if(void 0!==c.style[i[u]+"AnimationName"]){o="-"+i[u].toLowerCase()+"-",a=s[u],n=!0;break}var d="resizeanim",p="@"+o+"keyframes "+"resizeanim { from { opacity: 0; } to { opacity: 0; } } ",m=o+"animation: 1ms "+"resizeanim; ";return {addResizeListener:function(n,o){if(!n.__resizeTriggers__){var i=n.ownerDocument,s=t.getComputedStyle(n);s&&"static"==s.position&&(n.style.position="relative"),function(t){if(!t.getElementById("muiDetectElementResize")){var r=(p||"")+".Mui-resizeTriggers { "+(m||"")+'visibility: hidden; opacity: 0; } .Mui-resizeTriggers, .Mui-resizeTriggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .Mui-resizeTriggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',l=t.head||t.getElementsByTagName("head")[0],n=t.createElement("style");n.id="muiDetectElementResize",n.type="text/css",null!=e&&n.setAttribute("nonce",e),n.styleSheet?n.styleSheet.cssText=r:n.appendChild(t.createTextNode(r)),l.appendChild(n);}}(i),n.__resizeLast__={},n.__resizeListeners__=[],(n.__resizeTriggers__=i.createElement("div")).className="Mui-resizeTriggers",n.__resizeTriggers__.innerHTML='<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>',n.appendChild(n.__resizeTriggers__),r(n),n.addEventListener("scroll",l,!0),a&&(n.__resizeTriggers__.__animationListener__=function(e){e.animationName==d&&r(n);},n.__resizeTriggers__.addEventListener(a,n.__resizeTriggers__.__animationListener__));}n.__resizeListeners__.push(o);},removeResizeListener:function(e,t){if(e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t),1),!e.__resizeListeners__.length){e.removeEventListener("scroll",l,!0),e.__resizeTriggers__.__animationListener__&&(e.__resizeTriggers__.removeEventListener(a,e.__resizeTriggers__.__animationListener__),e.__resizeTriggers__.__animationListener__=null);try{e.__resizeTriggers__=!e.removeChild(e.__resizeTriggers__);}catch(e){}}}}}const sa=React.forwardRef((function(t,r){const{children:l,defaultHeight:n=null,defaultWidth:o=null,disableHeight:a=!1,disableWidth:i=!1,nonce:s,onResize:u,style:d}=t,m=On(t,["children","defaultHeight","defaultWidth","disableHeight","disableWidth","nonce","onResize","style"]),[f,g]=React.useState({height:n,width:o}),b=React.useRef(null),h=React.useRef(null),v=hr((()=>{if(h.current){const e=h.current.offsetHeight||0,t=h.current.offsetWidth||0,r=ownerWindow(h.current).getComputedStyle(h.current),l=parseInt(r.paddingLeft,10)||0,n=parseInt(r.paddingRight,10)||0,o=e-(parseInt(r.paddingTop,10)||0)-(parseInt(r.paddingBottom,10)||0),s=t-l-n;(!a&&f.height!==o||!i&&f.width!==s)&&(g({height:o,width:s}),u&&u({height:o,width:s}));}}));vr((()=>{var e;if(h.current=b.current.parentElement,!h)return;const t=ownerWindow(null!==(e=h.current)&&void 0!==e?e:void 0),r=ia(s,t);return r.addResizeListener(h.current,v),v(),()=>{r.removeResizeListener(h.current,v);}}),[s,v]);const C={overflow:"visible"},w={};a||(C.height=0,w.height=f.height),i||(C.width=0,w.width=f.width);const O=useForkRef(b,r);return React.createElement("div",Object.assign({ref:O,style:Object.assign(Object.assign({},C),d)},m),null===f.height&&null===f.width?null:l(w))})),ca=e=>e.editRows;function ua(t){const{className:l}=t,n=On(t,["className"]),o=ae(),a=ll(o,ea),i={minWidth:null==a?void 0:a.width,minHeight:null==a?void 0:a.height};return React.createElement("div",Object.assign({className:r("MuiDataGrid-dataContainer",l),style:i},n))}const da=React.forwardRef((function(t,r){const{height:l,width:n,children:o}=t;return React.createElement("div",{ref:r,className:"MuiDataGrid-renderingZone",style:{maxHeight:l,width:n}},o)}));function pa(t){const{selected:l,id:n,className:o,rowIndex:a,children:i}=t,s=a+2,c=ae(),u=ll(c,Bl),{classes:d,getRowClassName:p}=ll(c,il),m=React.useCallback((e=>t=>{(1!==t.target.nodeType||t.currentTarget.contains(t.target))&&c.current.publishEvent(e,null==c?void 0:c.current.getRowParams(n),t);}),[c,n]),f=React.useMemo((()=>({onClick:m(ne.rowClick),onDoubleClick:m(ne.rowDoubleClick),onMouseOver:m(ne.rowOver),onMouseOut:m(ne.rowOut),onMouseEnter:m(ne.rowEnter),onMouseLeave:m(ne.rowLeave)})),[m]),g={maxHeight:u,minHeight:u},b=yr(p)&&p(c.current.getRowParams(n)),h=r(o,b,null==d?void 0:d.row,{"Mui-selected":l});return React.createElement("div",Object.assign({key:n,"data-id":n,"data-rowindex":a,role:"row",className:h,"aria-rowindex":s,"aria-selected":l,style:g},f),i)}const ma=React.memo((function(t){const{align:l,className:n,children:o,colIndex:a,cellMode:i,field:s,formattedValue:c,hasFocus:u,height:d,isEditable:p,isSelected:g,rowIndex:b,rowId:h,showRightBorder:v,tabIndex:C,value:w,width:O}=t,y=null==c?w:c,E=React.useRef(null),S=ae(),M=r(n,`MuiDataGrid-cell--text${capitalize(l)}`,{"MuiDataGrid-withBorder":v,"MuiDataGrid-cell--editable":p}),x=React.useCallback((e=>t=>{if(t.relatedTarget&&t.currentTarget.contains(t.relatedTarget))return;const r=S.current.getCellParams(h,s||"");S.current.publishEvent(e,r,t);}),[S,s,h]),k=React.useCallback((e=>t=>{const r=S.current.getCellParams(h,s||"");S.current.publishEvent(e,r,t);}),[S,s,h]),D=React.useCallback((e=>t=>{(1!==t.target.nodeType||t.currentTarget.contains(t.target))&&S.current.publishEvent(e,S.current.getCellParams(h,s||""),t);}),[S,s,h]),R=React.useMemo((()=>({onClick:D(ne.cellClick),onDoubleClick:D(ne.cellDoubleClick),onMouseDown:D(ne.cellMouseDown),onMouseUp:k(ne.cellMouseUp),onMouseOver:D(ne.cellOver),onMouseOut:D(ne.cellOut),onMouseEnter:D(ne.cellEnter),onMouseLeave:D(ne.cellLeave),onKeyDown:D(ne.cellKeyDown),onBlur:x(ne.cellBlur),onFocus:D(ne.cellFocus),onDragStart:D(ne.cellDragStart),onDragEnter:D(ne.cellDragEnter),onDragOver:D(ne.cellDragOver)})),[D,x,k]),I={minWidth:O,maxWidth:O,lineHeight:d-1+"px",minHeight:d,maxHeight:d};return React.useLayoutEffect((()=>{if(!u||"edit"===i)return;const e=ownerDocument(S.current.rootElementRef.current);if(E.current&&!E.current.contains(e.activeElement)){const e=E.current.querySelector('[tabindex="0"]');e?e.focus():E.current.focus();}})),React.createElement("div",Object.assign({ref:E,className:M,role:"cell","data-value":w,"data-field":s,"data-rowindex":b,"data-colindex":a,"data-rowselected":g,"data-editable":p,"data-mode":i,"aria-colindex":a+1,style:I,tabIndex:C},R),null!=o?o:null==y?void 0:y.toString())})),fa=React.memo((function(t){const{columns:l,firstColIdx:n,hasScrollX:o,hasScrollY:a,height:i,id:s,getCellClassName:c,lastColIdx:u,rowIndex:d,cellFocus:p,cellTabIndex:m,showCellRightBorder:f,isSelected:g,editRowState:b,cellClassName:h}=t,v=On(t,["columns","firstColIdx","hasScrollX","hasScrollY","height","id","getCellClassName","lastColIdx","rowIndex","cellFocus","cellTabIndex","showCellRightBorder","isSelected","editRowState","cellClassName"]),C=ae(),w=l.slice(n,u+1).map(((e,u)=>{const w=n+u,O=w===l.length-1,y=O?!(O&&o&&!a)&&!t.extendRowFullWidth:f,E=C.current.getCellParams(s,e.field),S=[h];e.cellClassName&&S.push(r(yr(e.cellClassName)?e.cellClassName(E):e.cellClassName));const M=b&&b[e.field];let x=null;if(null==M&&e.renderCell&&(x=e.renderCell(E),S.push("MuiDataGrid-cell--withRenderer")),null!=M&&e.renderEditCell){const t=Object.assign(Object.assign({},E),M);x=e.renderEditCell(t),S.push("MuiDataGrid-cell--editing");}c&&S.push(c(E));return Object.assign({value:E.value,field:e.field,width:e.computedWidth,rowId:s,height:i,showRightBorder:y,formattedValue:E.formattedValue,align:e.align||"left",rowIndex:d,cellMode:E.cellMode,colIndex:w,children:x,isEditable:E.isEditable,isSelected:g,hasFocus:null!==p&&p.id===s&&p.field===e.field,tabIndex:null!==m&&m.id===s&&m.field===e.field&&"view"===E.cellMode?0:-1,className:r(S)},v)}));return React.createElement(React.Fragment,null,w.map((t=>React.createElement(ma,Object.assign({key:t.field},t)))))}));function ga(t){const{height:r,width:l,children:n}=t;return React.createElement("div",{className:"MuiDataGrid-viewport",style:{minWidth:l,maxWidth:l,maxHeight:r}},n)}const ba=React.forwardRef((function(t,r){const l=ae(),n=dn(),o=ll(l,il),a=ll(l,Yo),i=ll(l,Jo),s=ll(l,Qo),c=ll(l,de),u=ll(l,nl),d=ll(l,Hl),p=ll(l,Gl),m=ll(l,Cn),f=ll(l,Rl),g=ll(l,Bl),b=ll(l,ca);return React.createElement(ua,null,React.createElement(ga,Object.assign({},i),React.createElement(da,Object.assign({ref:r},(null==a?void 0:a.renderingZone)||{width:0,height:0}),(()=>{if(null==u.renderContext)return null;return f.slice(u.renderContext.firstRowIdx,u.renderContext.lastRowIdx).map((([t,r],l)=>{var a;return React.createElement(pa,{className:(u.renderContext.firstRowIdx+l)%2==0?"Mui-even":"Mui-odd",key:t,id:t,selected:void 0!==m[t],rowIndex:u.renderContext.firstRowIdx+l},React.createElement(al,{width:u.renderContext.leftEmptyWidth,height:g}),React.createElement(fa,{columns:c,row:r,id:t,height:g,firstColIdx:u.renderContext.firstColIdx,lastColIdx:u.renderContext.lastColIdx,hasScrollX:s.hasScrollX,hasScrollY:s.hasScrollY,showCellRightBorder:!!n.showCellRightBorder,extendRowFullWidth:!n.disableExtendRowFullWidth,rowIndex:u.renderContext.firstRowIdx+l,cellFocus:d,cellTabIndex:p,isSelected:void 0!==m[t],editRowState:b[t],cellClassName:null===(a=o.classes)||void 0===a?void 0:a.cell,getCellClassName:n.getCellClassName}),React.createElement(al,{width:u.renderContext.rightEmptyWidth,height:g}))}))})())))}));function ha(){var t,r,l;const n=ae(),o=dn(),a=ll(n,vl),i=ll(n,Pl),s=!o.loading&&0===a,c=!o.loading&&a>0&&0===i;return s?React.createElement(n.current.components.NoRowsOverlay,Object.assign({},null===(t=o.componentsProps)||void 0===t?void 0:t.noRowsOverlay)):c?React.createElement(n.current.components.NoResultsOverlay,Object.assign({},null===(r=o.componentsProps)||void 0===r?void 0:r.noResultsOverlay)):o.loading?React.createElement(n.current.components.LoadingOverlay,Object.assign({},null===(l=o.componentsProps)||void 0===l?void 0:l.loadingOverlay)):null}function va(t){const{children:r}=t,l=ae(),n=dn(),o=React.useRef(null),a=React.useRef(null),i=React.useRef(null),s=React.useRef(null);l.current.columnHeadersContainerElementRef=a,l.current.columnHeadersElementRef=o,l.current.windowRef=i,l.current.renderingZoneRef=s;const c=React.useCallback((e=>l.current.publishEvent(ne.resize,e)),[l]);return React.createElement(oa,null,React.createElement(ha,null),React.createElement(na,{ref:a},React.createElement(la,{ref:o})),React.createElement(sa,{nonce:n.nonce,disableHeight:n.autoHeight,onResize:c},(t=>React.createElement(aa,{ref:i,size:t},React.createElement(ba,{ref:s})))),r)}class Ca extends React.Component{static getDerivedStateFromError(e){return {hasError:!0,error:e}}componentDidCatch(e,t){this.props.api.current&&(this.logError(e),this.props.api.current.showError({error:e,errorInfo:t}));}logError(e,t){this.props.logger.error(`An unexpected error occurred. Error: ${e&&e.message}. `,e,t);}render(){var e;return this.props.hasError||(null===(e=this.state)||void 0===e?void 0:e.hasError)?this.props.render(this.props.componentProps||this.state):this.props.children}}function wa(t){const{children:r}=t,l=Ar("GridErrorHandler"),n=ae(),o=dn(),[a]=rl(n);return React.createElement(Ca,{hasError:null!=a.error,componentProps:a.error,api:n,logger:l,render:t=>{var r;return React.createElement(oa,null,React.createElement(n.current.components.ErrorOverlay,Object.assign({},t,null===(r=o.componentsProps)||void 0===r?void 0:r.errorOverlay)))}},r)}function Oa(){var t;const r=ae(),l=dn(),n=React.useRef(null);return r.current.footerRef=n,l.hideFooter?null:React.createElement("div",{ref:n},React.createElement(r.current.components.Footer,Object.assign({},null===(t=l.componentsProps)||void 0===t?void 0:t.footer)))}function ya(){var t;const r=ae(),l=dn(),n=React.useRef(null);return r.current.headerRef=n,React.createElement("div",{ref:n},React.createElement(r.current.components.Header,Object.assign({},null===(t=l.componentsProps)||void 0===t?void 0:t.header)))}const Ea=makeStyles((e=>{const t="light"===Er(e.palette)?lighten(Mr(e.palette.divider,1),.88):darken(Mr(e.palette.divider,1),.68),r={root:Object.assign(Object.assign({flex:1,boxSizing:"border-box",position:"relative",border:`1px solid ${t}`,borderRadius:e.shape.borderRadius,color:e.palette.text.primary},e.typography.body2),{outline:"none",height:"100%",display:"flex",flexDirection:"column","& *, & *::before, & *::after":{boxSizing:"inherit"},"&.MuiDataGrid-autoHeight":{height:"auto"},"& .MuiDataGrid-main":{position:"relative",flexGrow:1,display:"flex",flexDirection:"column"},"& .MuiDataGrid-overlay":{display:"flex",position:"absolute",top:0,left:0,right:0,bottom:0,alignSelf:"center",alignItems:"center",justifyContent:"center",backgroundColor:Mr(e.palette.background.default,e.palette.action.disabledOpacity)},"& .MuiDataGrid-toolbarContainer":{display:"flex",alignItems:"center",padding:"4px 4px 0"},"& .MuiDataGrid-columnsContainer":{position:"absolute",top:0,left:0,right:0,overflow:"hidden",display:"flex",flexDirection:"column",borderBottom:`1px solid ${t}`},"& .MuiDataGrid-scrollArea":{position:"absolute",top:0,zIndex:101,width:20,bottom:0},"& .MuiDataGrid-scrollArea--left":{left:0},"& .MuiDataGrid-scrollArea--right":{right:0},"& .MuiDataGrid-columnHeaderWrapper":{display:"flex",width:"100%",alignItems:"center",overflow:"hidden"},"& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell":{WebkitTapHighlightColor:"transparent",lineHeight:null,padding:"0 10px"},"& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within":{outline:`solid ${Mr(e.palette.primary.main,.5)} 1px`,outlineWidth:1,outlineOffset:-1},"& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus":{outline:`solid ${e.palette.primary.main} 1px`},"& .MuiDataGrid-columnHeaderCheckbox, & .MuiDataGrid-cellCheckbox":{padding:0,justifyContent:"center",alignItems:"center"},"& .MuiDataGrid-columnHeader":{position:"relative",display:"flex",alignItems:"center"},"& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted) .MuiDataGrid-sortIcon":{opacity:0,transition:e.transitions.create(["opacity"],{duration:e.transitions.duration.shorter})},"& .MuiDataGrid-columnHeader:not(.MuiDataGrid-columnHeader--sorted):hover .MuiDataGrid-sortIcon":{opacity:.5},"& .MuiDataGrid-columnHeaderTitleContainer":{display:"flex",alignItems:"center",minWidth:0,flex:1,whiteSpace:"nowrap",overflow:"hidden",padding:"0 6px"},"& .MuiDataGrid-sortIcon, & .MuiDataGrid-filterIcon":{fontSize:"inherit"},"& .MuiDataGrid-columnHeader--sortable":{cursor:"pointer"},"& .MuiDataGrid-columnHeader--alignCenter .MuiDataGrid-columnHeaderTitleContainer":{justifyContent:"center"},"& .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderDraggableContainer, & .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer":{flexDirection:"row-reverse"},"& .MuiDataGrid-columnHeader--alignCenter .MuiDataGrid-menuIcon, & .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-menuIcon":{marginRight:"auto",marginLeft:-6},"& .MuiDataGrid-columnHeaderTitle":{textOverflow:"ellipsis",overflow:"hidden",whiteSpace:"nowrap",fontWeight:e.typography.fontWeightMedium},"& .MuiDataGrid-columnHeader--moving":{backgroundColor:e.palette.action.hover},"& .MuiDataGrid-columnSeparator":{position:"absolute",right:-12,zIndex:100,display:"flex",flexDirection:"column",justifyContent:"center",color:t},"& .MuiDataGrid-columnSeparator--resizable":{cursor:"col-resize",touchAction:"none","&:hover":{color:e.palette.text.primary,"@media (hover: none)":{color:t}},"&.Mui-resizing":{color:e.palette.text.primary}},"& .MuiDataGrid-iconSeparator":{color:"inherit"},"& .MuiDataGrid-menuIcon":{visibility:"hidden",fontSize:20,marginRight:-6,display:"flex",alignItems:"center"},"& .MuiDataGrid-columnHeader:hover .MuiDataGrid-menuIcon, .MuiDataGrid-menuOpen":{visibility:"visible"},"& .MuiDataGrid-columnHeaderWrapper.scroll .MuiDataGrid-columnHeader:last-child":{borderRight:"none"},"& .MuiDataGrid-dataContainer":{position:"relative",flexGrow:1,display:"flex",flexDirection:"column"},"& .MuiDataGrid-window":{position:"absolute",bottom:0,left:0,right:0,overflowX:"auto"},"& .MuiDataGrid-viewport":{position:"sticky",top:0,left:0,display:"flex",flexDirection:"column",overflow:"hidden"},"& .MuiDataGrid-row":{display:"flex",width:"fit-content","&:hover":{backgroundColor:e.palette.action.hover,"@media (hover: none)":{backgroundColor:"transparent"}},"&.Mui-selected":{backgroundColor:Mr(e.palette.primary.main,e.palette.action.selectedOpacity),"&:hover":{backgroundColor:Mr(e.palette.primary.main,e.palette.action.selectedOpacity+e.palette.action.hoverOpacity),"@media (hover: none)":{backgroundColor:Mr(e.palette.primary.main,e.palette.action.selectedOpacity)}}}},"& .MuiDataGrid-cell":{display:"block",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",borderBottom:`1px solid ${t}`},"& .MuiDataGrid-cell.MuiDataGrid-cell--editing":{padding:1,display:"flex",boxShadow:e.shadows[2],backgroundColor:e.palette.background.paper,"&:focus-within":{outline:`solid ${e.palette.primary.main} 1px`,outlineOffset:"-1px"}},"& .MuiDataGrid-editInputCell":Object.assign(Object.assign({},e.typography.body2),{padding:"1px 0","& input":{padding:"0 16px",height:"100%"}}),"& .MuiDataGrid-editBooleanCell":{display:"flex",height:"100%",width:"100%",alignItems:"center",justifyContent:"center"},'& .MuiDataGrid-booleanCell[data-value="true"]':{color:e.palette.text.secondary},'& .MuiDataGrid-booleanCell[data-value="false"]':{color:e.palette.text.disabled},"& .MuiDataGrid-columnHeaderWrapper .MuiDataGrid-cell":{borderBottom:"none"},"& .MuiDataGrid-cell--withRenderer":{display:"flex",alignItems:"center"},"& .MuiDataGrid-withBorder":{borderRight:`1px solid ${t}`},"& .MuiDataGrid-cell--textLeft":{textAlign:"left"},"& .MuiDataGrid-cell--textLeft.MuiDataGrid-cell--withRenderer, & .MuiDataGrid-cell--textLeft.MuiDataGrid-cell--editing":{justifyContent:"flex-start"},"& .MuiDataGrid-cell--textRight":{textAlign:"right"},"& .MuiDataGrid-cell--textRight.MuiDataGrid-cell--withRenderer, & .MuiDataGrid-cell--textRight.MuiDataGrid-cell--editing":{justifyContent:"flex-end"},"& .MuiDataGrid-cell--textCenter":{textAlign:"center"},"& .MuiDataGrid-cell--textCenter.MuiDataGrid-cell--withRenderer, & .MuiDataGrid-cell--textCenter.MuiDataGrid-cell--editing":{justifyContent:"center"},"& .MuiDataGrid-rowCount, & .MuiDataGrid-selectedRowCount":{alignItems:"center",display:"flex",margin:e.spacing(0,2)},"& .MuiDataGrid-footerContainer":{display:"flex",justifyContent:"space-between",alignItems:"center",minHeight:52,"& .MuiDataGrid-selectedRowCount":{visibility:"hidden",width:0,height:0,[e.breakpoints.up("sm")]:{visibility:"visible",width:"auto",height:"auto"}}},"& .MuiDataGrid-columnHeaderDropZone .MuiDataGrid-columnHeaderDraggableContainer":{cursor:"move"},"& .MuiDataGrid-columnHeaderDraggableContainer":{display:"flex",width:"100%"},"& .MuiDataGrid-columnHeader--dragging":{background:e.palette.background.paper,padding:"0 12px",borderRadius:e.shape.borderRadius,opacity:e.palette.action.disabledOpacity}})};if("dark"===Er(e.palette)){const e="#202022",t="#585859",l="#838384";r.root=Object.assign(Object.assign({},r.root),{scrollbarColor:`${t} ${e}`,"& *::-webkit-scrollbar":{backgroundColor:e},"& *::-webkit-scrollbar-thumb":{borderRadius:8,backgroundColor:t,minHeight:24,border:`3px solid ${e}`},"& *::-webkit-scrollbar-thumb:focus":{backgroundColor:l},"& *::-webkit-scrollbar-thumb:active":{backgroundColor:l},"& *::-webkit-scrollbar-thumb:hover":{backgroundColor:l},"& *::-webkit-scrollbar-corner":{backgroundColor:e}});}return r}),{name:"MuiDataGrid",defaultTheme:xr()}),Sa=React.forwardRef((function(t,l){var n;const o=Ea(),a=ae(),i=dn(),{children:s,className:u}=t,d=On(t,["children","className"]),p=ll(a,ge),[m]=rl(a),f=ll(a,il),g=React.useRef(null),b=useForkRef(g,l);return a.current.rootElementRef=g,React.createElement(I,null,React.createElement("div",Object.assign({ref:b,className:r(o.root,null===(n=f.classes)||void 0===n?void 0:n.root,i.className,u,{"MuiDataGrid-autoHeight":i.autoHeight}),role:"grid","aria-colcount":p,"aria-rowcount":m.rows.totalRowCount,"aria-multiselectable":!i.disableMultipleSelection,"aria-label":i["aria-label"],"aria-labelledby":i["aria-labelledby"],style:i.style},d),s))})),Ma=React.forwardRef((function(t,l){const{className:n}=t,o=On(t,["className"]);return React.createElement("div",Object.assign({ref:l,className:r("MuiDataGrid-footerContainer",n)},o))})),xa=React.forwardRef((function(t,l){const{className:n,style:o}=t,a=On(t,["className","style"]),i=ae(),s=ll(i,Wl);return React.createElement("div",Object.assign({ref:l,className:r("MuiDataGrid-overlay",n),style:Object.assign({top:s},o)},a))})),ka=React.forwardRef((function(t,l){const{className:n,children:o}=t,a=On(t,["className","children"]);return o?React.createElement("div",Object.assign({ref:l,className:r("MuiDataGrid-toolbarContainer",n)},a),o):null})),Da=t=>{const{onClick:r}=t,l=ae(),n=dn(),o=React.useCallback((e=>{r(e),l.current.showPreferences(Vo.columns);}),[l,r]);return n.disableColumnSelector?null:React.createElement(y$1,{onClick:o},l.current.getLocaleText("columnMenuShowColumns"))},Ra=t=>{const{column:r,onClick:l}=t,n=ae(),o=dn(),a=React.useCallback((e=>{l(e),n.current.showFilterPanel(null==r?void 0:r.field);}),[n,null==r?void 0:r.field,l]);return o.disableColumnFilter||!(null==r?void 0:r.filterable)?null:React.createElement(y$1,{onClick:a},n.current.getLocaleText("columnMenuFilter"))},Ia=React.forwardRef((function(t,l){const{hideMenu:n,currentColumn:o,open:a,id:i,labelledby:s,className:c,children:u}=t,d=On(t,["hideMenu","currentColumn","open","id","labelledby","className","children"]),p=React.useCallback((e=>{Xl(e.key)&&e.preventDefault(),cn(e.key)&&n();}),[n]);return React.createElement(P,Object.assign({id:i,ref:l,className:r("MuiDataGrid-gridMenuList",c),"aria-labelledby":s,onKeyDown:p,autoFocus:a},d),u)})),Pa=t=>{const{column:r,onClick:l}=t,n=ae(),o=dn(),a=React.useRef(),i=React.useCallback((e=>{l(e),a.current=setTimeout((()=>{n.current.setColumnVisibility(null==r?void 0:r.field,!1);}),100);}),[n,null==r?void 0:r.field,l]);return React.useEffect((()=>()=>clearTimeout(a.current)),[]),o.disableColumnSelector?null:React.createElement(y$1,{onClick:i},n.current.getLocaleText("columnMenuHideColumn"))},La=t=>{const{column:r,onClick:l}=t,n=ae(),o=ll(n,Ml),a=React.useMemo((()=>{if(!r)return null;const e=o.find((e=>e.field===r.field));return null==e?void 0:e.sort}),[r,o]),i=React.useCallback((e=>{l(e);const t=e.currentTarget.getAttribute("data-value")||null;null==n||n.current.sortColumn(r,t);}),[n,r,l]);return r&&r.sortable?React.createElement(React.Fragment,null,React.createElement(y$1,{onClick:i,disabled:null==a},n.current.getLocaleText("columnMenuUnsort")),React.createElement(y$1,{onClick:i,"data-value":"asc",disabled:"asc"===a},n.current.getLocaleText("columnMenuSortAsc")),React.createElement(y$1,{onClick:i,"data-value":"desc",disabled:"desc"===a},n.current.getLocaleText("columnMenuSortDesc"))):null},Fa=React.forwardRef((function(t,r){const{hideMenu:l,currentColumn:n}=t;return React.createElement(Ia,Object.assign({ref:r},t),React.createElement(La,{onClick:l,column:n}),React.createElement(Ra,{onClick:l,column:n}),React.createElement(Pa,{onClick:l,column:n}),React.createElement(Da,{onClick:l,column:n}))})),ja=makeStyles((()=>({root:{display:"flex",flexDirection:"column",overflow:"auto",flex:"1 1",maxHeight:400}})),{name:"MuiGridPanelContent"});function za(t){const l=ja(),{className:n}=t,o=On(t,["className"]);return React.createElement("div",Object.assign({className:r(l.root,n)},o))}const Ta=makeStyles((()=>({root:{padding:4,display:"flex",justifyContent:"space-between"}})),{name:"MuiGridPanelFooter"});function Ha(t){const l=Ta(),{className:n}=t,o=On(t,["className"]);return React.createElement("div",Object.assign({className:r(l.root,n)},o))}const Aa=makeStyles((e=>({root:{padding:e.spacing(1)}})),{name:"MuiDataGridPanelHeader",defaultTheme:xr()});function _a(t){const l=Aa(),{className:n}=t,o=On(t,["className"]);return React.createElement("div",Object.assign({className:r(l.root,n)},o))}const Ga=makeStyles((()=>({root:{display:"flex",flexDirection:"column",flex:1,"&:focus":{outline:0}}})),{name:"MuiGridPanelWrapper"}),Na=()=>!0;function $a(t){const l=Ga(),{className:n}=t,o=On(t,["className"]),a=Sr().startsWith("v4")?{getDoc:()=>document}:{};return React.createElement(z,Object.assign({open:!0,disableEnforceFocus:!0,isEnabled:Na},a),React.createElement("div",Object.assign({tabIndex:-1,className:r(l.root,n)},o)))}const Va=makeStyles({container:{padding:"8px 0px 8px 8px"},column:{display:"flex",justifyContent:"space-between",padding:"1px 8px 1px 7px"},switch:{marginRight:4},dragIcon:{justifyContent:"flex-end"}},{name:"MuiDataGridColumnsPanel"});function Ba(){const t=Va(),r=ae(),l=React.useRef(null),n=ll(r,ue),{disableColumnReorder:o}=ll(r,il),[a,i]=React.useState(""),s=React.useCallback((e=>{const{name:t}=e.target,l=r.current.getColumn(t);r.current.setColumnVisibility(t,!!l.hide);}),[r]),c=React.useCallback((e=>{r.current.updateColumns(n.map((t=>(t.hide=e,t))));}),[r,n]),u=React.useCallback((()=>c(!1)),[c]),d=React.useCallback((()=>c(!0)),[c]),p=React.useCallback((e=>{i(e.target.value);}),[]),m=React.useMemo((()=>a?n.filter((e=>e.field.toLowerCase().indexOf(a.toLowerCase())>-1||e.headerName&&e.headerName.toLowerCase().indexOf(a.toLowerCase())>-1)):n),[n,a]);return React.useEffect((()=>{l.current.focus();}),[]),React.createElement($a,null,React.createElement(_a,null,React.createElement(C$1,{label:r.current.getLocaleText("columnsPanelTextFieldLabel"),placeholder:r.current.getLocaleText("columnsPanelTextFieldPlaceholder"),inputRef:l,value:a,onChange:p,variant:"standard",fullWidth:!0})),React.createElement(za,null,React.createElement("div",{className:t.container},m.map((l=>React.createElement("div",{key:l.field,className:t.column},React.createElement(j,{control:React.createElement(L,{className:t.switch,checked:!l.hide,onClick:s,name:l.field,color:"primary",size:"small"}),label:l.headerName||l.field}),!o&&Ao&&React.createElement(IconButton,{draggable:!0,className:t.dragIcon,"aria-label":r.current.getLocaleText("columnsPanelDragIconLabel"),title:r.current.getLocaleText("columnsPanelDragIconLabel"),size:"small",disabled:!0},React.createElement(Wn,null))))))),React.createElement(Ha,null,React.createElement(F,{onClick:d,color:"primary"},r.current.getLocaleText("columnsPanelHideAllButton")),React.createElement(F,{onClick:u,color:"primary"},r.current.getLocaleText("columnsPanelShowAllButton"))))}const Wa=makeStyles((e=>({root:{zIndex:e.zIndex.modal},paper:{backgroundColor:e.palette.background.paper,minWidth:300,maxHeight:450,display:"flex"}})),{name:"MuiGridPanel",defaultTheme:xr()});(function(e,t){const r={};return t.forEach((t=>{r[t]=Or(e,t);})),r})("MuiGridPanel",["root","paper"]);const Ka=React.forwardRef((function(t,l){var n;const{children:o,className:a,open:i}=t,s=On(t,["children","className","open"]),c=Wa(s),u=ae(),d=React.useCallback((()=>{u.current.hidePreferences();}),[u]),p=React.useCallback((e=>{Kl(e.key)&&u.current.hidePreferences();}),[u]),m=null===(n=null==u?void 0:u.current.columnHeadersContainerElementRef)||void 0===n?void 0:n.current;return m?React.createElement(R,Object.assign({ref:l,placement:"bottom-start",className:r(a,c.root),open:i,anchorEl:m,modifiers:"v5"===Sr()?[{name:"flip",enabled:!1}]:{flip:{enabled:!1}}},s),React.createElement(x$1,{onClickAway:d},React.createElement(Paper,{className:c.paper,elevation:8,onKeyDown:p},o))):null})),Za=React.forwardRef((function(t,r){var l,n,o;const a=ae(),i=ll(a,ue),s=dn(),c=ll(a,No),u=c.openedPanelValue===Vo.columns,d=!c.openedPanelValue||!u,p=a.current.components.ColumnsPanel,m=a.current.components.FilterPanel,f=a.current.components.Panel;return React.createElement(f,Object.assign({ref:r,open:i.length>0&&c.open},null===(l=null==a?void 0:a.current.componentsProps)||void 0===l?void 0:l.panel,t),!s.disableColumnSelector&&u&&React.createElement(p,Object.assign({},null===(n=null==a?void 0:a.current.componentsProps)||void 0===n?void 0:n.columnsPanel)),!s.disableColumnFilter&&d&&React.createElement(m,Object.assign({},null===(o=null==a?void 0:a.current.componentsProps)||void 0===o?void 0:o.filterPanel)))})),Xa=makeStyles({root:{display:"flex",justifyContent:"space-around",padding:8},linkOperatorSelect:{minWidth:60},columnSelect:{width:150},operatorSelect:{width:120},filterValueInput:{width:190},closeIcon:{flexShrink:0,justifyContent:"flex-end",marginRight:6,marginBottom:2}},{name:"MuiGridFilterForm"});function qa(t){var r,l;const{item:n,hasMultipleFilters:o,deleteFilter:a,applyFilterChanges:i,multiFilterOperator:s,showMultiFilterOperators:c,disableMultiFilterOperator:u,applyMultiFilterOperatorChanges:p}=t,f=Xa(),g=ae(),b=ll(g,me),h=unstable_useId(),v=unstable_useId(),C=unstable_useId(),w=unstable_useId(),y=unstable_useId(),E=unstable_useId(),M=React.useCallback((()=>n.columnField?g.current.getColumn(n.columnField):null),[g,n]),x=React.useCallback((()=>{var e;const t=M();return n.operatorValue&&t?null===(e=t.filterOperators)||void 0===e?void 0:e.find((e=>e.value===n.operatorValue)):null}),[n,M]),k=React.useCallback((e=>{const t=e.target.value,r=g.current.getColumn(t).filterOperators[0];i(Object.assign(Object.assign({},n),{value:void 0,columnField:t,operatorValue:r.value}));}),[g,i,n]),D=React.useCallback((e=>{const t=e.target.value;i(Object.assign(Object.assign({},n),{operatorValue:t}));}),[i,n]),R=React.useCallback((e=>{const t=e.target.value===Zr.And.toString()?Zr.And:Zr.Or;p(t);}),[p]),I=React.useCallback((()=>{a(n);}),[a,n]),P=x();return React.createElement("div",{className:f.root},React.createElement(T,{variant:"standard",className:f.closeIcon},React.createElement(IconButton,{"aria-label":g.current.getLocaleText("filterPanelDeleteIconLabel"),title:g.current.getLocaleText("filterPanelDeleteIconLabel"),onClick:I,size:"small"},React.createElement($n,{fontSize:"small"}))),React.createElement(T,{variant:"standard",className:f.linkOperatorSelect,style:{display:o?"block":"none",visibility:c?"visible":"hidden"}},React.createElement(H,{htmlFor:h,id:v},g.current.getLocaleText("filterPanelOperators")),React.createElement(O,{labelId:v,id:h,value:s,onChange:R,disabled:!!u,native:!0},React.createElement("option",{key:Zr.And.toString(),value:Zr.And.toString()},g.current.getLocaleText("filterPanelOperatorAnd")),React.createElement("option",{key:Zr.Or.toString(),value:Zr.Or.toString()},g.current.getLocaleText("filterPanelOperatorOr")))),React.createElement(T,{variant:"standard",className:f.columnSelect},React.createElement(H,{htmlFor:C,id:w},g.current.getLocaleText("filterPanelColumns")),React.createElement(O,{labelId:w,id:C,value:n.columnField||"",onChange:k,native:!0},b.map((t=>React.createElement("option",{key:t.field,value:t.field},t.headerName||t.field))))),React.createElement(T,{variant:"standard",className:f.operatorSelect},React.createElement(H,{htmlFor:y,id:E},g.current.getLocaleText("filterPanelOperators")),React.createElement(O,{labelId:E,id:y,value:n.operatorValue,onChange:D,native:!0},null===(l=null===(r=M())||void 0===r?void 0:r.filterOperators)||void 0===l?void 0:l.map((t=>React.createElement("option",{key:t.value,value:t.value},t.label||g.current.getLocaleText(`filterOperator${capitalize(t.value)}`)))))),React.createElement(T,{variant:"standard",className:f.filterValueInput},(null==P?void 0:P.InputComponent)?React.createElement(P.InputComponent,Object.assign({apiRef:g,item:n,applyValue:i},P.InputComponentProps)):null))}function Ya(){const t=ae(),[r]=rl(t),{disableMultipleColumnsFiltering:l}=ll(t,il),n=React.useMemo((()=>r.filter.items.length>1),[r.filter.items.length]),o=React.useCallback((e=>{t.current.upsertFilter(e);}),[t]),a=React.useCallback((e=>{t.current.applyFilterLinkOperator(e);}),[t]),i=React.useCallback((()=>{t.current.upsertFilter({});}),[t]),s=React.useCallback((e=>{t.current.deleteFilter(e);}),[t]);return React.useEffect((()=>{0===r.filter.items.length&&i();}),[i,r.filter.items.length]),React.createElement($a,null,React.createElement(za,null,r.filter.items.map(((t,l)=>React.createElement(qa,{key:null==t.id?l:t.id,item:t,applyFilterChanges:o,deleteFilter:s,hasMultipleFilters:n,showMultiFilterOperators:l>0,multiFilterOperator:r.filter.linkOperator,disableMultiFilterOperator:1!==l,applyMultiFilterOperatorChanges:a})))),!l&&React.createElement(Ha,null,React.createElement(F,{onClick:i,startIcon:React.createElement(Vn,null),color:"primary"},t.current.getLocaleText("filterPanelAddFilter"))))}const Ja=React.forwardRef((function(t,r){const{onClick:l}=t,n=On(t,["onClick"]),o=ae(),a=dn(),i=o.current.components.ColumnSelectorIcon,{open:s,openedPanelValue:c}=ll(o,No);return a.disableColumnSelector?null:React.createElement(F,Object.assign({ref:r,size:"small",color:"primary","aria-label":o.current.getLocaleText("toolbarColumnsLabel"),startIcon:React.createElement(i,null)},n,{onClick:e=>{s&&c===Vo.columns?o.current.hidePreferences():o.current.showPreferences(Vo.columns),null==l||l(e);}}),o.current.getLocaleText("toolbarColumns"))})),Qa=React.forwardRef((function(t,r){const{onClick:l}=t,n=On(t,["onClick"]),o=ae(),a=dn(),i=ll(o,Vl),s=unstable_useId(),c=unstable_useId(),[u,p]=React.useState(null),m=o.current.components.DensityCompactIcon,f=o.current.components.DensityStandardIcon,g=o.current.components.DensityComfortableIcon,b=[{icon:React.createElement(m,null),label:o.current.getLocaleText("toolbarDensityCompact"),value:$r.Compact},{icon:React.createElement(f,null),label:o.current.getLocaleText("toolbarDensityStandard"),value:$r.Standard},{icon:React.createElement(g,null),label:o.current.getLocaleText("toolbarDensityComfortable"),value:$r.Comfortable}],h=React.useCallback((()=>{switch(i){case $r.Compact:return React.createElement(m,null);case $r.Comfortable:return React.createElement(g,null);default:return React.createElement(f,null)}}),[i,m,g,f]),v=()=>p(null);if(a.disableDensitySelector)return null;const C=b.map(((t,r)=>React.createElement(y$1,{key:r,onClick:()=>{return e=t.value,o.current.setDensity(e),void p(null);var e;},selected:t.value===i},React.createElement(A$1,null,t.icon),t.label)));return React.createElement(React.Fragment,null,React.createElement(F,Object.assign({ref:r,color:"primary",size:"small",startIcon:h(),"aria-label":o.current.getLocaleText("toolbarDensityLabel"),"aria-expanded":u?"true":void 0,"aria-haspopup":"menu","aria-labelledby":c,id:s},n,{onClick:e=>{p(e.currentTarget),null==l||l(e);}}),o.current.getLocaleText("toolbarDensity")),React.createElement(Ko,{open:Boolean(u),target:u,onClickAway:v,position:"bottom-start"},React.createElement(P,{id:c,className:"MuiDataGrid-gridMenuList","aria-labelledby":s,onKeyDown:e=>{Xl(e.key)&&e.preventDefault(),cn(e.key)&&v();},autoFocusItem:Boolean(u)},C)))})),ei=makeStyles((e=>({list:{margin:e.spacing(1,1,.5),padding:e.spacing(0,1)}})),{name:"MuiGridToolbarFilterButton",defaultTheme:xr()}),ti=React.forwardRef((function(t,r){const{componentsProps:l={}}=t,n=On(t,["componentsProps"]),o=l.button||{},a=ei(),i=ae(),s=dn(),c=ll(i,jl),u=ll(i,Fl),d=ll(i,ce),p=ll(i,No),f=React.useMemo((()=>{if(p.open)return i.current.getLocaleText("toolbarFiltersTooltipHide");if(0===c)return i.current.getLocaleText("toolbarFiltersTooltipShow");return React.createElement("div",null,i.current.getLocaleText("toolbarFiltersTooltipActive")(c),React.createElement("ul",{className:a.list},u.map(((t,r)=>Object.assign({},d[t.columnField]&&React.createElement("li",{key:r},`${d[t.columnField].headerName||t.columnField}\n                  ${(e=>d[e.columnField].filterOperators.find((t=>t.value===e.operatorValue)).label||i.current.getLocaleText(`filterOperator${capitalize(e.operatorValue)}`).toString())(t)}\n                  ${t.value}`))))))}),[i,p.open,c,u,d,a]);if(s.disableColumnFilter)return null;const g=i.current.components.OpenFilterButtonIcon;return React.createElement(M,Object.assign({title:f,enterDelay:1e3},n),React.createElement(F,Object.assign({ref:r,size:"small",color:"primary","aria-label":i.current.getLocaleText("toolbarFiltersLabel"),startIcon:React.createElement(E$1,{badgeContent:c,color:"primary"},React.createElement(g,null))},o,{onClick:e=>{var t;const{open:r,openedPanelValue:l}=p;r&&l===Vo.filters?i.current.hideFilterPanel():i.current.showFilterPanel(),null===(t=o.onClick)||void 0===t||t.call(o,e);}}),i.current.getLocaleText("toolbarFilters")))})),ri=React.forwardRef((function(t,r){const{csvOptions:l,onClick:n}=t,o=On(t,["csvOptions","onClick"]),a=ae(),i=unstable_useId(),s=unstable_useId(),[c,u]=React.useState(null),p=a.current.components.ExportIcon,m=[];m.push({label:a.current.getLocaleText("toolbarExportCSV"),format:"csv",formatOptions:l});const f=()=>u(null),g=e=>()=>{"csv"===e.format&&a.current.exportDataAsCsv(e.formatOptions),u(null);};return React.createElement(React.Fragment,null,React.createElement(F,Object.assign({ref:r,color:"primary",size:"small",startIcon:React.createElement(p,null),"aria-expanded":c?"true":void 0,"aria-label":a.current.getLocaleText("toolbarExportLabel"),"aria-haspopup":"menu","aria-labelledby":s,id:i},o,{onClick:e=>{u(e.currentTarget),null==n||n(e);}}),a.current.getLocaleText("toolbarExport")),React.createElement(Ko,{open:Boolean(c),target:c,onClickAway:f,position:"bottom-start"},React.createElement(P,{id:s,className:"MuiDataGrid-gridMenuList","aria-labelledby":i,onKeyDown:e=>{Xl(e.key)&&e.preventDefault(),cn(e.key)&&f();},autoFocusItem:Boolean(c)},m.map(((t,r)=>React.createElement(y$1,{key:r,onClick:g(t)},t.label))))))}));React.forwardRef((function(t,r){const l=dn();return l.disableColumnFilter&&l.disableColumnSelector&&l.disableDensitySelector?null:React.createElement(ka,Object.assign({ref:r},t),React.createElement(Ja,null),React.createElement(ti,null),React.createElement(Qa,null),React.createElement(ri,null))}));const ni=React.forwardRef((function(t,l){const{className:n,rowCount:o,visibleRowCount:a}=t,i=On(t,["className","rowCount","visibleRowCount"]),s=ae();if(0===o)return null;const c=a<o?s.current.getLocaleText("footerTotalVisibleRows")(a,o):o.toLocaleString();return React.createElement("div",Object.assign({ref:l,className:r("MuiDataGrid-rowCount",n)},i),s.current.getLocaleText("footerTotalRows")," ",c)})),oi=React.forwardRef((function(t,l){const{className:n,selectedRowCount:o}=t,a=On(t,["className","selectedRowCount"]),i=ae().current.getLocaleText("footerRowSelected")(o);return React.createElement("div",Object.assign({ref:l,className:r("MuiDataGrid-selectedRowCount",n)},a),i)})),ai=React.forwardRef((function(t,r){var l;const n=ae(),o=dn(),a=ll(n,vl),i=ll(n,hn),s=ll(n,fn),c=ll(n,Pl),u=!o.hideFooterSelectedRowCount&&i>0?React.createElement(oi,{selectedRowCount:i}):React.createElement("div",null),d=o.hideFooterRowCount||o.pagination?null:React.createElement(ni,{rowCount:a,visibleRowCount:c}),p=!!o.pagination&&null!=s.pageSize&&!o.hideFooterPagination&&(null==n?void 0:n.current.components.Pagination),m=p&&React.createElement(p,Object.assign({},null===(l=null==n?void 0:n.current.componentsProps)||void 0===l?void 0:l.pagination));return React.createElement(Ma,Object.assign({ref:r},t),u,d,m)})),ii=React.forwardRef((function(t,r){var l,n;const o=ae(),a=null==o?void 0:o.current.components.PreferencesPanel,i=a&&React.createElement(a,Object.assign({},null===(l=null==o?void 0:o.current.componentsProps)||void 0===l?void 0:l.preferencesPanel)),s=null==o?void 0:o.current.components.Toolbar,c=s&&React.createElement(s,Object.assign({},null===(n=null==o?void 0:o.current.componentsProps)||void 0===n?void 0:n.toolbar));return React.createElement("div",Object.assign({ref:r},t),i,c)})),si=React.forwardRef((function(t,r){return React.createElement(xa,Object.assign({ref:r},t),React.createElement(_$1,null))})),ci=React.forwardRef((function(t,r){const l=ae().current.getLocaleText("noRowsLabel");return React.createElement(xa,Object.assign({ref:r},t),l)})),ui=makeStyles((e=>({selectLabel:{display:"none",[e.breakpoints.up("md")]:{display:"block"}},caption:{"&[id]":{display:"none",[e.breakpoints.up("md")]:{display:"block"}}},input:{display:"none",[e.breakpoints.up("md")]:{display:"inline-flex"}}})),{defaultTheme:xr()}),di=React.forwardRef((function(t,r){var l,n,o;const a=ui(),i=ae(),s=dn(),c=ll(i,fn),u=React.useMemo((()=>Math.floor(c.rowCount/(c.pageSize||1))),[c.rowCount,c.pageSize]),d=React.useCallback((e=>{const t=Number(e.target.value);i.current.setPageSize(t);}),[i]),p=React.useCallback(((e,t)=>{i.current.setPage(t);}),[i]);if("production"!==process.env.NODE_ENV){const t=React.useRef(!1);t.current||s.autoPageSize||s.rowsPerPageOptions.includes(null!==(l=s.pageSize)&&void 0!==l?l:c.pageSize)||(console.warn([`Material-UI: The page size \`${null!==(n=s.pageSize)&&void 0!==n?n:c.pageSize}\` is not preset in the \`rowsPerPageOptions\``,"Add it to show the pagination select."].join("\n")),t.current=!0);}return React.createElement(G,Object.assign({ref:r,classes:Object.assign(Object.assign({},"v5"===Sr()?{selectLabel:a.selectLabel}:{caption:a.caption}),{input:a.input}),component:"div",count:c.rowCount,page:c.page<=u?c.page:u,rowsPerPageOptions:(null===(o=s.rowsPerPageOptions)||void 0===o?void 0:o.includes(c.pageSize))?s.rowsPerPageOptions:[],rowsPerPage:c.pageSize},i.current.getLocaleText("MuiTablePagination"),"v4"!==Sr()?{onPageChange:p,onRowsPerPageChange:d}:{onChangePage:p,onChangeRowsPerPage:d},t))}));function pi$2(t,r){const l=Ar("useApi"),n=React.useCallback(((e,l,n={})=>{if(n.defaultMuiPrevented=!1,n&&(e=>void 0!==e.isPropagationStopped)(n)&&n.isPropagationStopped())return;const o=r.signature===sl$1.XGrid?{api:t.current}:{};t.current.emit(e,l,n,o);}),[t,r.signature]),o=React.useCallback(((e,r,n)=>{l.debug(`Binding ${e} event`),t.current.on(e,r,n);const o=t.current;return ()=>{l.debug(`Clearing ${e} event`),o.removeListener(e,r);}}),[t,l]),a=React.useCallback((e=>{t.current.publishEvent(ne.componentError,e);}),[t]);React.useEffect((()=>{l.debug("Initializing grid api.");const e=t.current;return ()=>{l.info("Unmounting Grid component. Clearing all events listeners."),e.emit(ne.unmount),e.removeAllListeners();}}),[l,t]),_r(t,{subscribeEvent:o,publishEvent:n,showError:a},"GridCoreApi");}const mi=t=>{const r=Ar("useGridContainerProps"),[l,n,o]=rl(t),a=React.useRef({width:0,height:0}),i=ll(t,il),s=ll(t,Bl),c=ll(t,be),u=ll(t,Pl),d=ll(t,fn),p=t.current.windowRef,m=React.useCallback((()=>{if(r.debug("Calculating virtual row count."),i.pagination&&(!i.autoPageSize||i.pageSize)){const e=u-d.page*d.pageSize;return e>d.pageSize?d.pageSize:e}return u}),[r,i.autoPageSize,i.pagination,i.pageSize,d.page,d.pageSize,u]),f=React.useCallback((e=>{r.debug("Calculating scrollbar sizes.");let t=c>a.current.width;const l={y:0,x:t?i.scrollbarSize:0};if(0===e)return {hasScrollX:t,hasScrollY:!1,scrollBarSize:l};const n=e*s,o=!i.autoPageSize&&!i.autoHeight&&n+l.x>a.current.height;return l.y=o?i.scrollbarSize:0,t=c+l.y>a.current.width,l.x=t?i.scrollbarSize:0,r.debug(`Scrollbar size on axis x: ${l.x}, y: ${l.y}`),{hasScrollX:t,hasScrollY:o,scrollBarSize:l}}),[r,c,i.autoPageSize,i.autoHeight,s,i.scrollbarSize]),g=React.useCallback(((e,t)=>{if(!(null==p?void 0:p.current))return null;r.debug("Calculating container sizes.");const l=p.current.getBoundingClientRect();a.current={width:l.width,height:l.height},r.debug(`window Size - W: ${a.current.width} H: ${a.current.height} `);return {width:a.current.width-t.scrollBarSize.y,height:i.autoHeight?e*s:a.current.height-t.scrollBarSize.x}}),[r,i.autoHeight,s,p]),b=React.useCallback(((e,t,l)=>{if(!p||!p.current||0===c||Number.isNaN(c))return null;const n=e*s-a.current.height>2*s;if(i.autoPageSize||i.autoHeight||!n){const n=Math.floor(t.height/s),o=l.hasScrollY||e<n?e:n,u=Math.max(o*s+(i.autoHeight?l.scrollBarSize.x:0),1),d={isVirtualized:!1,virtualRowsCount:o,renderingZonePageSize:o,viewportPageSize:o,totalSizes:{width:c,height:u},dataContainerSizes:{width:c,height:u},renderingZoneScrollHeight:u-t.height,renderingZone:{width:c,height:u},windowSizes:a.current,lastPage:1};return r.debug("Fixed container props",d),d}const o=Math.floor(t.height/s),u=o>0?Math.ceil(e/o)-1:0,d=2*o,m=d*s,f=m-t.height;let g=u*f+t.height;const b=e%o;b>0&&(g=g-f+b*s);const h={isVirtualized:n,virtualRowsCount:e,viewportPageSize:o,totalSizes:{width:c,height:g},dataContainerSizes:{width:c,height:g},renderingZonePageSize:d,renderingZone:{width:c,height:m},renderingZoneScrollHeight:f,windowSizes:a.current,lastPage:u};return r.debug("virtualized container props",h),h}),[p,c,s,i.autoPageSize,i.autoHeight,r]),h=React.useCallback(((e,t)=>{let r=!1;n((l=>(r=e(l),r?t(l):l))),r&&o();}),[o,n]),v=React.useCallback((()=>{r.debug("Refreshing container sizes");const e=m(),t=f(e),l=g(e,t);if(!l)return;h((e=>e.scrollBar!==t),(e=>Object.assign(Object.assign({},e),{scrollBar:t}))),h((e=>e.viewportSizes!==l),(e=>Object.assign(Object.assign({},e),{viewportSizes:l})));const n=b(e,l,t);h((e=>!br(e.containerSizes,n)),(e=>Object.assign(Object.assign({},e),{containerSizes:n})));}),[b,f,g,m,r,h]);React.useEffect((()=>{v();}),[l.columns,l.options.hideFooter,v,u]),cl(t,ne.debouncedResize,v);},fi=(t,r,l,n,o)=>{const a=Ar("useNativeEventListener"),[i,s]=React.useState(!1),c=React.useRef(n),u=React.useCallback((e=>c.current&&c.current(e)),[]);React.useEffect((()=>{c.current=n;}),[n]),React.useEffect((()=>{let e;if(e=yr(r)?r():r&&r.current?r.current:null,e&&u&&l&&!i){a.debug(`Binding native ${l} event`),e.addEventListener(l,u,o);const r=e;s(!0);const n=()=>{a.debug(`Clearing native ${l} event`),r.removeEventListener(l,u,o);};t.current.subscribeEvent(ne.unmount,n);}}),[r,u,l,i,a,o,t]);},gi=t=>{const r=Ar("useGridColumnMenu"),[l,n,o]=rl(t),a=React.useCallback((e=>{r.debug("Opening Column Menu"),n((t=>Object.assign(Object.assign({},t),{columnMenu:{open:!0,field:e}}))),t.current.hidePreferences(),o();}),[t,o,r,n]),i=React.useCallback((()=>{r.debug("Hiding Column Menu"),n((e=>Object.assign(Object.assign({},e),{columnMenu:Object.assign(Object.assign({},e.columnMenu),{open:!1,field:void 0})}))),o();}),[o,r,n]),s=React.useCallback((e=>{r.debug("Toggle Column Menu"),l.columnMenu.open&&l.columnMenu.field===e?i():a(e);}),[r,a,i,l]),c=React.useCallback((()=>{n((e=>e.columnMenu.open?Object.assign(Object.assign({},e),{columnMenu:Object.assign(Object.assign({},e.columnMenu),{open:!1})}):e));}),[n]);React.useEffect((()=>{l.isScrolling&&i();}),[l.isScrolling,i]),_r(t,{showColumnMenu:a,hideColumnMenu:i,toggleColumnMenu:s},"ColumnMenuApi"),cl(t,ne.columnResizeStart,c);};function hi(e,t){t=function(e){const t=Object.assign({},e);return Object.keys(e).forEach((r=>{e.hasOwnProperty(r)&&void 0===e[r]&&delete t[r];})),t}(t);return Object.assign(Object.assign({},e),t)}function vi(e,t={},r,l,n){l.debug("Hydrating GridColumns with default definitions");const o=function(e,t){const r=Object.assign(Object.assign({},e),t),l={};return Object.entries(r).forEach((([e,t])=>{t=Object.assign(Object.assign({},r[t.extendType||"__default__"]),t),l[e]=t;})),l}(yo(),t),a=e.map((e=>Object.assign(Object.assign({},Eo(o,e.type)),e)));if(r){const e=Object.assign({},lo);return e.headerName=n("checkboxSelectionHeaderName"),[e,...a]}return a}function Ci(e,t){return e.debug("Building columns lookup"),t.reduce(((e,t)=>(e[t.field]=t,e)),{})}const wi=(e,t)=>{var r,l;const n={all:[...null!==(r=null==t?void 0:t.all)&&void 0!==r?r:[]],lookup:Object.assign({},null!==(l=null==t?void 0:t.lookup)&&void 0!==l?l:{})};return e.forEach((e=>{null==n.lookup[e.field]?(n.lookup[e.field]=e,n.all.push(e.field)):n.lookup[e.field]=Object.assign(Object.assign({},n.lookup[e.field]),e);})),n};function Oi(t,r){const l=Ar("useGridColumns"),[n,o,a]=rl(t),i=ll(t,pe),s=ll(t,ue),c=ll(t,de),u=React.useCallback(((e,r=!0)=>{l.debug("Updating columns state."),o((t=>Object.assign(Object.assign({},t),{columns:e}))),a(),t.current&&r&&t.current.publishEvent(ne.columnsChange,e.all);}),[l,o,a,t]),d=React.useCallback((e=>t.current.state.columns.lookup[e]),[t]),p=React.useCallback((()=>s),[s]),m=React.useCallback((()=>c),[c]),f=React.useCallback((()=>i),[i]),g=React.useCallback(((e,t=!0)=>t?c.findIndex((t=>t.field===e)):s.findIndex((t=>t.field===e))),[s,c]),b=React.useCallback((e=>{const t=g(e);return i.positions[t]}),[i.positions,g]),h=React.useCallback(((e,r)=>{l.debug("updating GridColumns with new state");const n=t.current.state,o=function(e,t){var r,l;let n=0,o=t;const a=[];for(let t=0;t<e.length;t+=1){const i=Object.assign({},e[t]);if(i.hide)i.computedWidth=0;else {const e=null!==(r=i.minWidth)&&void 0!==r?r:Jn.minWidth;if(i.flex&&i.flex>0)n+=i.flex,i.computedWidth=e;else {const t=Math.max(null!==(l=i.width)&&void 0!==l?l:Jn.width,e);i.computedWidth=t,o-=t;}}a.push(i);}if(n&&o>0){const e=n>0?o/n:0;for(let t=0;t<a.length;t+=1){const r=a[t];!r.hide&&r.flex&&r.flex>0&&(a[t].computedWidth=Math.max(e*r.flex,r.computedWidth));}}return a}(e.all.map((t=>e.lookup[t])),n.viewportSizes.width),a={all:o.map((e=>e.field)),lookup:Ci(l,o)};u(a,r);}),[t,l,u]),v=React.useCallback((e=>{const r=wi(e,t.current.state.columns);h(r,!1);}),[t,h]),C=React.useCallback((e=>v([e])),[v]),w=React.useCallback(((e,r)=>{const l=d(e),n=Object.assign(Object.assign({},l),{hide:!r});v([n]),a(),t.current.publishEvent(ne.columnVisibilityChange,{field:e,colDef:n,api:t,isVisible:r});}),[t,a,d,v]),O=React.useCallback(((e,r)=>{const o=n.columns.all.findIndex((t=>t===e));if(o===r)return;l.debug(`Moving column ${e} to index ${r}`);const a={field:e,element:t.current.getColumnHeaderElement(e),colDef:t.current.getColumn(e),targetIndex:r,oldIndex:o,api:t.current};t.current.publishEvent(ne.columnOrderChange,a);const i=[...n.columns.all];i.splice(r,0,i.splice(o,1)[0]),u(Object.assign(Object.assign({},n.columns),{all:i}));}),[t,n.columns,l,u]),y=React.useCallback(((e,r)=>{l.debug(`Updating column ${e} width to ${r}`);const n=t.current.getColumn(e);t.current.updateColumn(Object.assign(Object.assign({},n),{width:r})),t.current.publishEvent(ne.columnWidthChange,{element:t.current.getColumnHeaderElement(e),colDef:n,api:t,width:r});}),[t,l]);_r(t,{getColumn:d,getAllColumns:p,getColumnIndex:g,getColumnPosition:b,getVisibleColumns:m,getColumnsMeta:f,updateColumn:C,updateColumns:v,setColumnVisibility:w,setColumnIndex:O,setColumnWidth:y},"ColApi"),React.useEffect((()=>{if(l.info(`GridColumns have changed, new length ${r.columns.length}`),r.columns.length>0){const e=vi(r.columns,r.columnTypes,!!r.checkboxSelection,l,t.current.getLocaleText),n=wi(e);h(n);}else u({all:[],lookup:{}});}),[l,t,r.columns,r.columnTypes,r.checkboxSelection,u,h]),React.useEffect((()=>{l.debug(`GridColumns gridState.viewportSizes.width, changed ${n.viewportSizes.width}`);const e=ue(t.current.state);t.current.updateColumns(e);}),[t,n.viewportSizes.width,l]),dl(t,ne.columnVisibilityChange,r.onColumnVisibilityChange);}function yi(e,r){const l=React__default.useRef({}),n=React__default.useCallback((e=>{const{stateId:t,stateSelector:r}=e,n=On(e,["stateId","stateSelector"]);l.current[t]=Object.assign(Object.assign({},n),{stateId:t,stateSelector:r||(e=>e[t])});}),[]),o=React__default.useCallback((t=>{let n=!1;const o=[],a=l.current;if(Object.keys(a).forEach((r=>{const l=a[r],i=l.stateSelector(e.current.state),s=l.stateSelector(t);s!==i&&s!==l.propModel&&o.push(l.stateId),void 0!==l.propModel&&s!==l.propModel&&(n=!0);})),o.length>1)throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${o[0]}, therefore, you're not allowed to update ${o.join(", ")} in the same transaction.`);return {ignoreSetState:n,postUpdate:()=>{o.forEach((l=>{const n=a[l],o=a[l].stateSelector(t);if(n.propOnChange){const t=r.signature===sl$1.XGrid?{api:e.current}:{};n.propOnChange(o,t);}e.current.publishEvent(n.changeEvent,o);}));}}}),[e,r.signature]);_r(e,{updateControlState:n,applyControlStateConstraint:o},"controlStateApi");}const Ei=(t,r,l,n)=>{const o=tl(t),[a,i,s]=rl(t),c=React.useCallback((e=>{void 0===a[r]&&(a[r]=n),i((t=>{const n=Object.assign({},t);return n[r]=l(t[r],e),n})),s();}),[s,a,n,l,i,r]),u=React.useRef(c);React.useEffect((()=>{u.current=c;}),[c]);const d=React.useCallback((e=>u.current(e)),[]);return {gridState:a,dispatch:d,gridApi:o}},Si=(t,r)=>{const l=Ar("useGridFilter"),[n,o,a]=rl(t),i=ll(t,fe),s=React.useCallback((()=>{l.debug("clearing filtered rows"),o((e=>Object.assign(Object.assign({},e),{visibleRows:{visibleRowsLookup:{}}})));}),[l,o]),c=React.useCallback(((e,r=Zr.And)=>{if(!e.columnField||!e.operatorValue)return;const n=t.current.getColumn(e.columnField);if(!n)return;const i=n.valueParser?n.valueParser(e.value):e.value,s=Object.assign(Object.assign({},e),{value:i});l.debug(`Filtering column: ${s.columnField} ${s.operatorValue} ${s.value} `);const c=n.filterOperators;if(!(null==c?void 0:c.length))throw new Error(`Material-UI: No filter operators found for column '${n.field}'.`);const u=c.find((e=>e.value===s.operatorValue));if(!u)throw new Error(`Material-UI: No filter operator found for column '${n.field}' and operator value '${s.operatorValue}'.`);const d=u.getApplyFilterFn(s,n);"function"==typeof d&&(o((e=>{const l=Object.assign({},e.visibleRows.visibleRowsLookup);return Sl(e).forEach(((e,n)=>{const o=t.current.getCellParams(n,s.columnField),a=d(o);null==l[n]?l[n]=a:l[n]=r===Zr.And?l[n]&&a:l[n]||a;})),Object.assign(Object.assign({},e),{visibleRows:Object.assign(Object.assign({},e.visibleRows),{visibleRowsLookup:l,visibleRows:Object.entries(l).filter((([,e])=>e)).map((([e])=>e))})})})),a());}),[t,a,l,o]),u=React.useCallback((()=>{if(r.filterMode===Vr.server)return void a();s();const{items:e,linkOperator:l}=t.current.state.filter;e.forEach((e=>{t.current.applyFilter(e,l);})),a();}),[t,s,a,r.filterMode]),d=React.useCallback((e=>{l.debug("Upserting filter"),o((l=>{const n=[...l.filter.items],o=Object.assign({},e),a=n.findIndex((e=>e.id===o.id));if(1===n.length&&br(n[0],{})?n[0]=o:-1===a?n.push(o):n[a]=o,null==o.id&&(o.id=Math.round(1e5*Math.random())),null==o.columnField&&(o.columnField=i[0]),null!=o.columnField&&null==o.operatorValue){const e=t.current.getColumn(o.columnField);o.operatorValue=e&&e.filterOperators[0].value;}r.disableMultipleColumnsFiltering&&n.length>1&&(n.length=1);return Object.assign(Object.assign({},l),{filter:Object.assign(Object.assign({},l.filter),{items:n})})})),u();}),[l,o,t,u,r.disableMultipleColumnsFiltering,i]),p=React.useCallback((e=>{l.debug(`Deleting filter on column ${e.columnField} with value ${e.value}`),o((t=>{const r=[...t.filter.items.filter((t=>t.id!==e.id))];return Object.assign(Object.assign({},t),{filter:Object.assign(Object.assign({},t.filter),{items:r})})})),0===t.current.state.filter.items.length&&t.current.upsertFilter({}),u();}),[t,u,l,o]),m=React.useCallback((e=>{if(l.debug("Displaying filter panel"),e){const r=n.filter.items.length>0?n.filter.items[n.filter.items.length-1]:null;r&&r.columnField===e||t.current.upsertFilter({columnField:e});}t.current.showPreferences(Vo.filters);}),[t,n.filter.items,l]),f=React.useCallback((()=>{l.debug("Hiding filter panel"),null==t||t.current.hidePreferences();}),[t,l]),g=React.useCallback(((e=Zr.And)=>{l.debug("Applying filter link operator"),o((t=>Object.assign(Object.assign({},t),{filter:Object.assign(Object.assign({},t.filter),{linkOperator:e})}))),u();}),[u,l,o]),b=React.useCallback((()=>{s(),l.debug("Clearing filter model"),o((e=>Object.assign(Object.assign({},e),{filter:Xr()})));}),[s,l,o]),h=React.useCallback((e=>{b(),l.debug("Setting filter model"),g(e.linkOperator),e.items.forEach((e=>d(e)));}),[g,b,l,d]),v=React.useCallback((()=>Dl(t.current.state)),[t]);_r(t,{applyFilterLinkOperator:g,applyFilters:u,applyFilter:c,deleteFilter:p,upsertFilter:d,setFilterModel:h,showFilterPanel:m,hideFilterPanel:f,getVisibleRowModels:v},"FilterApi"),React.useEffect((()=>{t.current&&(l.debug("Rows prop changed, applying filters"),s(),t.current.applyFilters());}),[t,s,l,r.rows]);const C=React.useCallback((()=>{l.debug("onColUpdated - GridColumns changed, applying filters");const e=t.current.state.filter,r=fe(t.current.state);l.debug("GridColumns changed, applying filters"),e.items.forEach((e=>{r.find((t=>t===e.columnField))||t.current.deleteFilter(e);})),t.current.applyFilters();}),[t,l]);React.useEffect((()=>{t.current.updateControlState({stateId:"filter",propModel:r.filterModel,propOnChange:r.onFilterModelChange,stateSelector:e=>e.filter,changeEvent:ne.filterModelChange});}),[t,r.filterModel,r.onFilterModelChange]),React.useEffect((()=>{if(void 0!==r.filterModel&&r.filterModel.items.length>1){if(r.filterModel.items.find((e=>null==e.id)))throw new Error("The 'id' field is required on filterModel.items when you use multiple filters.")}const e=t.current.state.filter;void 0!==r.filterModel&&r.filterModel!==e&&(l.debug("filterModel prop changed, applying filters"),o((e=>Object.assign(Object.assign({},e),{filter:r.filterModel||Xr()}))),t.current.applyFilters());}),[t,l,r.filterModel,o]),cl(t,ne.rowsSet,t.current.applyFilters),cl(t,ne.rowsUpdate,t.current.applyFilters),cl(t,ne.columnsChange,C);},Mi=(t,r)=>{const l=Ar("useGridFocus"),[,n,o]=rl(t),a=React.useRef(null),i=React.useCallback(((e,t)=>{n((r=>(l.debug(`Focusing on cell with id=${e} and field=${t}`),Object.assign(Object.assign({},r),{tabIndex:{cell:{id:e,field:t},columnHeader:null},focus:{cell:{id:e,field:t},columnHeader:null}})))),o();}),[o,l,n]),s=React.useCallback(((e,r)=>{const{cell:a}=t.current.state.focus;a&&t.current.publishEvent(ne.cellFocusOut,t.current.getCellParams(a.id,a.field),r),n((t=>(l.debug(`Focusing on column header with colIndex=${e}`),Object.assign(Object.assign({},t),{tabIndex:{columnHeader:{field:e},cell:null},focus:{columnHeader:{field:e},cell:null}})))),o();}),[t,o,l,n]),c=React.useCallback((({id:e,field:r})=>{t.current.setCellFocus(e,r);}),[t]),u=React.useCallback(((e,r)=>{"Enter"===r.key||"Tab"===r.key||an(r.key)||t.current.setCellFocus(e.id,e.field);}),[t]),d=React.useCallback((({field:e},r)=>{r.target===r.currentTarget&&t.current.setColumnHeaderFocus(e,r);}),[t]),p=React.useCallback((()=>{l.debug("Clearing focus"),n((e=>Object.assign(Object.assign({},e),{focus:{cell:null,columnHeader:null}})));}),[l,n]),m=React.useCallback((e=>{a.current=e;}),[]),g=React.useCallback((e=>{const r=a.current;a.current=null;const{cell:l}=t.current.state.focus;if(!l)return void(r&&t.current.setCellFocus(r.id,r.field));if((null==r?void 0:r.id)===l.id&&(null==r?void 0:r.field)===l.field)return;const i=t.current.getCellElement(l.id,l.field);(null==i?void 0:i.contains(e.target))||(t.current.publishEvent(ne.cellFocusOut,t.current.getCellParams(l.id,l.field),e),r?t.current.setCellFocus(r.id,r.field):(n((e=>Object.assign(Object.assign({},e),{focus:{cell:null,columnHeader:null}}))),o()));}),[t,o,n]),b=React.useCallback((e=>{if("view"===e.cellMode)return;const{cell:r}=t.current.state.focus;(null==r?void 0:r.id)===e.id&&(null==r?void 0:r.field)===e.field||t.current.setCellFocus(e.id,e.field);}),[t]);_r(t,{setCellFocus:i,setColumnHeaderFocus:s},"GridFocusApi"),React.useEffect((()=>{const{cell:e}=t.current.state.focus;if(e){t.current.getRow(e.id)||n((e=>Object.assign(Object.assign({},e),{focus:{cell:null,columnHeader:null}})));}}),[t,n,r.rows]),React.useEffect((()=>{const e=ownerDocument(t.current.rootElementRef.current);return e.addEventListener("click",g),()=>{e.removeEventListener("click",g);}}),[t,g]),cl(t,ne.columnHeaderBlur,p),cl(t,ne.cellDoubleClick,c),cl(t,ne.cellMouseUp,m),cl(t,ne.cellKeyDown,u),cl(t,ne.cellModeChange,b),cl(t,ne.columnHeaderFocus,d);},xi=t=>{const r=Ar("useGridKeyboard"),l=React.useCallback(((e,l)=>{const n=Io(l.target,"MuiDataGrid-row"),o=Number(n.getAttribute("data-rowindex"));let a=o;const i=[...t.current.getSelectedRows().keys()];if(i.length>0){const e=i.map((e=>t.current.getRowIndex(e))),r=e.map((e=>Math.abs(o-e))),l=Math.max(...r);a=e[r.indexOf(l)];}t.current.publishEvent(ne.cellNavigationKeyDown,e,l);const s=t.current.state.focus.cell,c=t.current.getRowIndex(s.id),u=Array(Math.abs(c-a)+1).fill(c>a?a:c);r.debug("Selecting rows "),t.current.selectRows(u,!0,!0);}),[r,t]),n=React.useCallback(((e,r)=>{if(1===r.target.nodeType&&(null==(n=r.target)||!n.classList.contains("MuiDataGrid-cell")))return;var n;const o=t.current.getCellParams(e.id,e.field);if(!("edit"===o.cellMode)){if(ql(r.key)&&r.shiftKey)return r.preventDefault(),void t.current.selectRow(o.id);if(!an(r.key)||r.shiftKey)return an(r.key)&&r.shiftKey?(r.preventDefault(),void l(o,r)):void("c"===r.key.toLowerCase()&&(r.ctrlKey||r.metaKey)||"a"===r.key.toLowerCase()&&(r.ctrlKey||r.metaKey)&&(r.preventDefault(),t.current.selectRows(t.current.getAllRowIds(),!0)));t.current.publishEvent(ne.cellNavigationKeyDown,o,r);}}),[t,l]),o=React.useCallback(((e,r)=>{Po(r.target)&&(ql(r.key)&&Po(r.target)&&r.preventDefault(),!an(r.key)||ql(r.key)||r.shiftKey?Zl(r.key)&&(r.ctrlKey||r.metaKey)&&t.current.toggleColumnMenu(e.field):t.current.publishEvent(ne.cellNavigationKeyDown,e,r));}),[t]);cl(t,ne.cellKeyDown,n),cl(t,ne.columnHeaderKeyDown,o);},ki=(t,r)=>{const l=Ar("useGridKeyboardNavigation"),n=ll(t,fn),o=ll(t,vl),a=ll(t,ge),i=ll(t,Yo),s=e=>Zl(e.key)?"ArrowDown":Xl(e.key)?e.shiftKey?"ArrowLeft":"ArrowRight":e.key,c=React.useCallback(((e,c)=>{c.preventDefault();const u=t.current.getColumnIndex(e.field),d=t.current.getRowIndex(e.id),p=s(c),m=c.ctrlKey||c.metaKey||c.shiftKey;let f,g=o;if(r.pagination&&o>n.pageSize&&(g=n.pageSize*(n.page+1)),Yl(p))f=((e,t)=>{if(!Yl(e))throw new Error("Material-UI: The first argument (key) should be an arrow key code.");switch(e){case"ArrowLeft":return Object.assign(Object.assign({},t),{colIndex:t.colIndex-1});case"ArrowRight":return Object.assign(Object.assign({},t),{colIndex:t.colIndex+1});case"ArrowUp":return Object.assign(Object.assign({},t),{rowIndex:t.rowIndex-1});default:return Object.assign(Object.assign({},t),{rowIndex:t.rowIndex+1})}})(p,{colIndex:u,rowIndex:d});else if(Jl(p)){const e="Home"===p?0:a-1;if(m){let t=0;t=0===e?r.pagination?g-n.pageSize:0:g-1,f={colIndex:e,rowIndex:t};}else f={colIndex:e,rowIndex:d};}else {if(!Ql(p)&&!ql(p))throw new Error("Material-UI. Key not mapped to navigation behavior.");f={colIndex:u,rowIndex:d+(p.indexOf("Down")>-1||ql(p)?i.viewportPageSize:-1*i.viewportPageSize)};}if(f.rowIndex<0){const e=t.current.getVisibleColumns()[f.colIndex].field;return void t.current.setColumnHeaderFocus(e,c)}f.rowIndex=f.rowIndex>=g&&g>0?g-1:f.rowIndex,f.colIndex=f.colIndex<=0?0:f.colIndex,f.colIndex=f.colIndex>=a?a-1:f.colIndex,l.debug(`Navigating to next cell row ${f.rowIndex}, col ${f.colIndex}`),t.current.scrollToIndexes(f);const b=t.current.getVisibleColumns()[f.colIndex].field,h=t.current.getRowIdFromRowIndex(f.rowIndex);t.current.setCellFocus(h,b);}),[o,r.pagination,n.pageSize,n.page,a,l,t,i]),u=React.useCallback(((e,r)=>{let n;r.preventDefault();const o=t.current.getColumnIndex(e.field),c=s(r);if(Yl(c))n=((e,t)=>{if(!Yl(e))throw new Error("Material-UI: The first argument (key) should be an arrow key code.");switch(e){case"ArrowLeft":return {colIndex:t.colIndex-1};case"ArrowRight":return {colIndex:t.colIndex+1};case"ArrowDown":return null;default:return Object.assign({},t)}})(c,{colIndex:o});else {if(!Jl(c)){if(Ql(c)){if(c.indexOf("Down")>-1){const e=t.current.getVisibleColumns()[o].field,r=t.current.getRowIdFromRowIndex(i.viewportPageSize-1);t.current.setCellFocus(r,e);}return}throw new Error("Material-UI. Key not mapped to navigation behavior.")}n={colIndex:"Home"===c?0:a-1};}if(!n){const e=t.current.getVisibleColumns()[o].field,r=t.current.getRowIdFromRowIndex(0);return void t.current.setCellFocus(r,e)}n.colIndex=Math.max(0,n.colIndex),n.colIndex=n.colIndex>=a?a-1:n.colIndex,l.debug(`Navigating to next column row ${n.colIndex}`),t.current.scrollToIndexes(n);const u=t.current.getVisibleColumns()[n.colIndex].field;t.current.setColumnHeaderFocus(u,r);}),[t,a,i,l]);cl(t,ne.cellNavigationKeyDown,c),cl(t,ne.columnHeaderNavigationKeyDown,u);};function Di(t,r){const l=Ar("useGridScrollFn"),n=React.useRef();return [React.useCallback((e=>{var o;e.left===(null===(o=n.current)||void 0===o?void 0:o.left)&&e.top===n.current.top||t&&t.current&&(l.debug(`Moving ${t.current.className} to: ${e.left}-${e.top}`),t.current.style.transform=`translate3d(-${e.left}px, -${e.top}px, 0)`,r.current.style.transform=`translate3d(-${e.left}px, 0, 0)`,n.current=e);}),[t,l,r])]}const Ri=(e,t)=>t>0&&e>0?Math.ceil(e/t):0,Ii=e=>e.pageCount?Object.assign(Object.assign({},e),{page:Math.max(Math.min(e.page,e.pageCount-1),0)}):e,Pi=(t,r)=>{const l=Ar("useGridPage"),[,n,o]=rl(t),a=ll(t,Pl),i=React.useCallback((e=>{l.debug(`Setting page to ${e}`),n((t=>Object.assign(Object.assign({},t),{pagination:Ii(Object.assign(Object.assign({},t.pagination),{page:e}))}))),o();}),[n,o,l]);React.useEffect((()=>{t.current.updateControlState({stateId:"page",propModel:r.page,propOnChange:r.onPageChange,stateSelector:e=>e.pagination.page,changeEvent:ne.pageChange});}),[t,r.page,r.onPageChange]),React.useEffect((()=>{n((e=>{const t=void 0!==r.rowCount?r.rowCount:a,l=Ri(t,e.pagination.pageSize),n=null==r.page?e.pagination.page:r.page;return Object.assign(Object.assign({},e),{pagination:Ii(Object.assign(Object.assign({},e.pagination),{page:n,rowCount:t,pageCount:l}))})})),o();}),[n,o,a,r.rowCount,r.page,t]);const s=React.useCallback((e=>{n((t=>{const r=Ri(t.pagination.rowCount,e);return Object.assign(Object.assign({},t),{pagination:Ii(Object.assign(Object.assign({},t.pagination),{pageCount:r,page:t.pagination.page}))})})),o();}),[n,o]);cl(t,ne.pageSizeChange,s);_r(t,{setPage:i},"GridPageApi");},Li=(t,r)=>{const l=Ar("useGridPageSize"),[,n,o]=rl(t),a=ll(t,Pl),i=ll(t,Yo),s=React.useCallback((e=>{l.debug(`Setting page size to ${e}`),n((t=>Object.assign(Object.assign({},t),{pagination:Object.assign(Object.assign({},t.pagination),{pageSize:e})}))),o();}),[n,o,l]);React.useEffect((()=>{t.current.updateControlState({stateId:"pageSize",propModel:r.pageSize,propOnChange:r.onPageSizeChange,stateSelector:e=>e.pagination.pageSize,changeEvent:ne.pageSizeChange});}),[t,r.pageSize,r.onPageSizeChange]),React.useEffect((()=>{const e=null==i?void 0:i.viewportPageSize,l=t.current.state.pagination.pageSize;let a=l;null!=r.pageSize?a=r.pageSize:r.autoPageSize&&(a=null!=e?e:0),a!==l&&(r.autoPageSize&&t.current.publishEvent(ne.pageSizeChange,e),n((e=>Object.assign(Object.assign({},e),{pagination:Object.assign(Object.assign({},e.pagination),{pageSize:a})}))),o());}),[t,n,o,a,r.autoPageSize,r.pageSize,null==i?void 0:i.viewportPageSize]);_r(t,{setPageSize:s},"GridPageSizeApi");},Fi=t=>{const r=Ar("useGridPreferencesPanel"),[,l,n]=rl(t),o=React.useRef(),a=React.useRef(),i=React.useCallback((()=>{r.debug("Hiding Preferences Panel"),l((e=>Object.assign(Object.assign({},e),{preferencePanel:{open:!1}}))),n();}),[n,r,l]),s=React.useCallback((()=>{a.current=setTimeout((()=>clearTimeout(o.current)),0);}),[]),c=React.useCallback((()=>{o.current=setTimeout(i,100);}),[i]);_r(t,{showPreferences:React.useCallback((e=>{r.debug("Opening Preferences Panel"),s(),l((t=>Object.assign(Object.assign({},t),{preferencePanel:Object.assign(Object.assign({},t.preferencePanel),{open:!0,openedPanelValue:e})}))),n();}),[s,n,r,l]),hidePreferences:c},"ColumnMenuApi"),React.useEffect((()=>()=>{clearTimeout(o.current),clearTimeout(a.current);}),[]);};let ji=!1;function zi(t){const r=React.useCallback((e=>({field:e,colDef:t.current.getColumn(e),api:t.current})),[t]),l=React.useCallback((e=>{const r=t.current.getRow(e);if(!r)throw new Error(`No row with id #${e} found`);return {id:e,columns:t.current.getAllColumns(),row:r,api:t.current,getValue:t.current.getCellValue}}),[t]),n=React.useCallback(((e,r)=>{const l=t.current.getRow(e);if(!l)throw new Error(`No row with id #${e} found`);const n=Hl(t.current.state),o=Gl(t.current.state);return {id:e,field:r,row:l,value:l[r],colDef:t.current.getColumn(r),cellMode:t.current.getCellMode(e,r),getValue:t.current.getCellValue,api:t.current,hasFocus:null!==n&&n.field===r&&n.id===e,tabIndex:o&&o.field===r&&o.id===e?0:-1}}),[t]),o=React.useCallback(((e,r)=>{const l=t.current.getColumn(r),n=t.current.getCellValue(e,r),o=t.current.getRow(e);if(!o)throw new Error(`No row with id #${e} found`);const a=Hl(t.current.state),i=Gl(t.current.state),s={id:e,field:r,row:o,colDef:l,cellMode:t.current.getCellMode(e,r),getValue:t.current.getCellValue,api:t.current,hasFocus:null!==a&&a.field===r&&a.id===e,tabIndex:i&&i.field===r&&i.id===e?0:-1,value:n,formattedValue:n};return l.valueFormatter&&(s.formattedValue=l.valueFormatter(s)),s.isEditable=l&&t.current.isCellEditable(s),s}),[t]),a=React.useCallback(((e,r)=>{const l=t.current.getColumn(r);if("production"!==process.env.NODE_ENV&&(l||ji||function(e){console.warn([`Material-UI: You are calling getValue('${e}') but the column \`${e}\` is not defined.`,`Instead, you can access the data from \`params.row.${e}\`.`].join("\n")),ji=!0;}(r)),!l||!l.valueGetter){const l=t.current.getRow(e);if(!l)throw new Error(`No row with id #${e} found`);return l[r]}return l.valueGetter(n(e,r))}),[t,n]),i=React.useCallback((e=>t.current.rootElementRef.current?function(e,t){return e.querySelector(`[role="columnheader"][data-field="${Fo(t)}"]`)}(t.current.rootElementRef.current,e):null),[t]),s=React.useCallback((e=>t.current.rootElementRef.current?jo(t.current.rootElementRef.current,e):null),[t]),c=React.useCallback(((e,r)=>t.current.rootElementRef.current?function(e,{id:t,field:r}){const l=jo(e,t);return l?l.querySelector(`.MuiDataGrid-cell[data-field="${Fo(r)}"]`):null}(t.current.rootElementRef.current,{id:e,field:r}):null),[t]);_r(t,{getCellValue:a,getCellParams:o,getCellElement:c,getRowParams:l,getRowElement:s,getColumnHeaderParams:r,getColumnHeaderElement:i},"GridParamsApi");}function Ti(e,t,r){if(null==e)throw new Error(["Material-UI: The data grid component requires all rows to have a unique id property.",r||"A row was provided without id in the rows prop:",JSON.stringify(t)].join("\n"));return !0}function Hi(e,t,r){const l=t?t(e):e.id;return Ti(l,e,r),l}function Ai(e,t,r){const l=Object.assign(Object.assign({},{idRowsLookup:{},allRows:[],totalRowCount:0}),{totalRowCount:t&&t>e.length?t:e.length});return e.forEach((e=>{const t=Hi(e,r);l.allRows.push(t),l.idRowsLookup[t]=e;})),l}const _i=(t,r)=>{const l=Ar("useGridRows"),[,n,o]=rl(t),a=ll(t,hl),i=React.useRef(),s=React.useCallback((e=>{null==i.current&&(i.current=setTimeout((()=>{l.debug("Updating component"),i.current=null,e&&e(),o();}),100));}),[l,o]),c=React.useRef(a);React.useEffect((()=>()=>clearTimeout(i.current)),[]),React.useEffect((()=>{n((e=>(c.current=Ai(r.rows,r.rowCount,r.getRowId),Object.assign(Object.assign({},e),{rows:c.current}))));}),[r.getRowId,r.rows,r.rowCount,n]);const u=React.useCallback((e=>t.current.getSortedRowIds?t.current.getSortedRowIds().indexOf(e):t.current.state.rows.allRows.indexOf(e)),[t]),d=React.useCallback((e=>t.current.getSortedRowIds?t.current.getSortedRowIds()[e]:t.current.state.rows.allRows[e]),[t]),p=React.useCallback((e=>{var r;return null!==(r=t.current.state.rows.idRowsLookup[e])&&void 0!==r?r:null}),[t]),m=React.useCallback((e=>{l.debug(`updating all rows, new length ${e.length}`),c.current.allRows.length>0&&t.current.publishEvent(ne.rowsClear);const o=[],a=e.reduce(((e,t)=>{const l=Hi(t,r.getRowId);return e[l]=t,o.push(l),e}),{}),i=r.rowCount&&r.rowCount>o.length?r.rowCount:o.length;c.current={idRowsLookup:a,allRows:o,totalRowCount:i},n((e=>Object.assign(Object.assign({},e),{rows:c.current}))),s((()=>t.current.publishEvent(ne.rowsSet)));}),[l,n,s,t,r.getRowId,r.rowCount]),f=React.useCallback((e=>{const l=e.reduce(((e,t)=>{const l=Hi(t,r.getRowId,"A row was provided without id when calling updateRows():");return e[l]=null!=e[l]?Object.assign(Object.assign({},e[l]),t):t,e}),{}),o=[],a=[];let i=null;if(Object.entries(l).forEach((([e,t])=>{if("delete"===t._action)return void a.push(e);const r=p(e);r?(i||(i=Object.assign({},c.current.idRowsLookup)),i[e]=Object.assign(Object.assign({},r),t)):o.push(t);})),i&&(c.current.idRowsLookup=i,n((e=>Object.assign(Object.assign({},e),{rows:Object.assign({},c.current)})))),a.length>0||o.length>0){a.forEach((e=>{delete c.current.idRowsLookup[e];}));const e=[...Object.values(c.current.idRowsLookup),...o];m(e);}s((()=>t.current.publishEvent(ne.rowsUpdate)));}),[t,s,p,r.getRowId,n,m]),g=React.useCallback((()=>new Map(t.current.state.rows.allRows.map((e=>[e,t.current.state.rows.idRowsLookup[e]])))),[t]),b=React.useCallback((()=>t.current.state.rows.totalRowCount),[t]),h=React.useCallback((()=>t.current.state.rows.allRows),[t]);_r(t,{getRowIndex:u,getRowIdFromRowIndex:d,getRow:p,getRowModels:g,getRowsCount:b,getAllRowIds:h,setRows:m,updateRows:f},"GridRowApi");};function Gi(t,r){const l=Ar("useGridEditRows"),[,n,o]=rl(t),a=(e,r)=>{"view"!==e.cellMode&&(t.current.commitCellChange(e,r),t.current.publishEvent(ne.cellEditStop,e,r));},i=hr(((e,t)=>{a(e,t);})),s=hr((e=>{const{cell:r}=t.current.state.focus;if(!r)return;const l=t.current.getCellParams(r.id,r.field);a(l,e);})),c=React.useCallback(((e,r,a)=>{const i="edit"===t.current.getCellMode(e,r);"edit"===a&&i||"view"===a&&!i||(l.debug(`Switching cell id: ${e} field: ${r} to mode: ${a}`),n((l=>{const n=Object.assign({},l.editRows);return n[e]=Object.assign({},n[e]),"edit"===a?n[e][r]={value:t.current.getCellValue(e,r)}:(delete n[e][r],Object.keys(n[e]).length||delete n[e]),Object.assign(Object.assign({},l),{editRows:n})})),o(),t.current.publishEvent(ne.cellModeChange,{id:e,field:r,mode:a,api:t.current}));}),[t,o,l,n]),u=React.useCallback(((e,r)=>{const l=t.current.state.editRows;return l[e]&&l[e][r]?"edit":"view"}),[t]),d=React.useCallback((e=>!!e.colDef.editable&&!!e.colDef.renderEditCell&&(!r.isCellEditable||r.isCellEditable(e))),[r.isCellEditable]),p=React.useCallback(((e,r)=>{const l={id:e.id,field:e.field,props:{value:e.value}};t.current.publishEvent(ne.editCellPropsChange,l,r);}),[t]),m=React.useCallback((e=>{const{id:r,field:a,props:i}=e;l.debug(`Setting cell props on id: ${r} field: ${a}`),n((e=>{const l=t.current.getColumn(a),n=l.valueParser?l.valueParser(i.value,t.current.getCellParams(r,a)):i.value,o=Object.assign({},e.editRows);return o[r]=Object.assign({},e.editRows[r]),o[r][a]=Object.assign(Object.assign({},i),{value:n}),Object.assign(Object.assign({},e),{editRows:o})})),o();}),[t,o,l,n]),f=React.useCallback((e=>{m(e);}),[m]),g=React.useCallback((e=>{l.debug("Setting row model"),n((t=>Object.assign(Object.assign({},t),{editRows:e}))),o();}),[o,l,n]),b=React.useCallback((()=>t.current.state.editRows),[t]),h=React.useCallback(((e,r)=>{const{id:l,field:n}=e,o=t.current.getEditRowsModel();if(!o[l]||!o[l][n])throw new Error(`Cell at id: ${l} and field: ${n} is not in edit mode`);const{error:a,value:i}=o[l][n];if(!a){const l=Object.assign(Object.assign({},e),{value:i});return t.current.publishEvent(ne.cellEditCommit,l,r),!0}return !1}),[t]),v=React.useCallback((e=>{const{id:r,field:n}=e,o=t.current.getEditRowsModel(),{value:a}=o[r][n];l.debug(`Setting cell id: ${r} field: ${n} to value: ${null==a?void 0:a.toString()}`);const i=t.current.getRow(r),s=Object.assign(Object.assign({},i),{[n]:a});t.current.updateRows([s]);}),[t,l]),C=React.useCallback(((e,t)=>{e.isEditable&&(c(e.id,e.field,"edit"),sn(t)&&rn(t.key)&&m({id:e.id,field:e.field,props:{value:""}}));}),[m,c]),w=React.useCallback(((e,t)=>{const r=t.detail>1;e.isEditable&&"view"===e.cellMode&&r&&t.preventDefault();}),[]),O=React.useCallback(((e,r)=>{const{id:l,field:n,cellMode:o,isEditable:a}=e;if(!a)return;const i="edit"===o,s=r.ctrlKey||r.metaKey||r.altKey;var c;if(!i&&(c=r.key,Zl(c)||en(c)||rn(c))&&!s&&t.current.publishEvent(ne.cellEditStart,e,r),!i&&en(r.key)&&(t.current.setEditCellValue({id:l,field:n,value:""}),t.current.commitCellChange({id:l,field:n},r),t.current.publishEvent(ne.cellEditStop,e,r)),i&&on(r.key)){const e={id:l,field:n};if(!t.current.commitCellChange(e,r))return}i&&(e=>ln.indexOf(e)>-1)(r.key)&&t.current.publishEvent(ne.cellEditStop,e,r);}),[t]),y=React.useCallback(((e,r)=>{c(e.id,e.field,"view"),r&&sn(r)&&(on(r.key)?t.current.publishEvent(ne.cellNavigationKeyDown,e,r):("Escape"===r.key||en(r.key))&&t.current.setCellFocus(e.id,e.field));}),[t,c]),E=React.useCallback(((e,r)=>{e.isEditable&&t.current.publishEvent(ne.cellEditStart,e,r);}),[t]);cl(t,ne.cellKeyDown,O),cl(t,ne.cellMouseDown,w),cl(t,ne.cellDoubleClick,E),cl(t,ne.cellFocusOut,i),cl(t,ne.columnHeaderDragStart,s),cl(t,ne.cellEditStart,C),cl(t,ne.cellEditStop,y),cl(t,ne.cellEditCommit,v),cl(t,ne.editCellPropsChange,f),dl(t,ne.cellEditCommit,r.onCellEditCommit),dl(t,ne.editCellPropsChange,r.onEditCellPropsChange),dl(t,ne.cellEditStart,r.onCellEditStart),dl(t,ne.cellEditStop,r.onCellEditStop),_r(t,{setCellMode:c,getCellMode:u,isCellEditable:d,commitCellChange:h,setEditRowsModel:g,getEditRowsModel:b,setEditCellValue:p},"EditRowApi"),React.useEffect((()=>{t.current.updateControlState({stateId:"editRows",propModel:r.editRowsModel,propOnChange:r.onEditRowsModelChange,stateSelector:e=>e.editRows,changeEvent:ne.editRowsModelChange});}),[t,r.editRowsModel,r.onEditRowsModelChange]),React.useEffect((()=>{const e=t.current.state.editRows;void 0!==r.editRowsModel&&r.editRowsModel!==e&&t.current.setEditRowsModel(r.editRowsModel||{});}),[t,r.editRowsModel]);}const Ni=(t,r)=>{const l=Ar("useGridSelection"),[,n,o]=rl(t),a=ll(t,il),i=ll(t,Cl),s=React.useMemo((()=>null==r.selectionModel||Array.isArray(r.selectionModel)?r.selectionModel:[r.selectionModel]),[r.selectionModel]),{checkboxSelection:c,disableMultipleSelection:u,disableSelectionOnClick:d,isRowSelectable:p}=a,m=React.useCallback((()=>vn(t.current.state)),[t]),f=React.useCallback((e=>{const{id:r,allowMultipleOverride:a,isSelected:i,isMultipleKey:s}=e;p&&!p(t.current.getRowParams(r))||(l.debug(`Selecting row ${r}`),n((e=>{let t=Cn(e);if(a||!u&&s||c){(null==i?void 0===t[r]:i)?t[r]=r:delete t[r];}else {const e=null==i?!s||void 0===t[r]:i;t={},e&&(t[r]=r);}return Object.assign(Object.assign({},e),{selection:Object.values(t)})})),o());}),[p,u,t,l,c,o,n]),g=React.useCallback(((e,r=!0,l=!1)=>{const n=t.current.getRow(e);n&&f({id:e,row:n,allowMultipleOverride:l,isSelected:r});}),[t,f]),b=React.useCallback(((e,r=!0,l=!1)=>{const a=p?e.filter((e=>p(t.current.getRowParams(e)))):e;u&&a.length>1&&!c||(n((e=>{const t=l?{}:Cn(e);return a.forEach((e=>{r?t[e]=e:void 0!==t[e]&&delete t[e];})),Object.assign(Object.assign({},e),{selection:Object.values(t)})})),o());}),[p,u,c,n,o,t]),h=React.useCallback((e=>{t.current.state.selection!==e&&n((t=>Object.assign(Object.assign({},t),{selection:e})));}),[n,t]),v=React.useCallback(((e,t)=>{d||f({id:e.id,row:e.row,isMultipleKey:t.metaKey||t.ctrlKey});}),[d,f]);cl(t,ne.rowClick,v);_r(t,{selectRow:g,getSelectedRows:m,selectRows:b,setSelectionModel:h},"GridSelectionApi"),React.useEffect((()=>{t.current.updateControlState({stateId:"selection",propModel:s,propOnChange:r.onSelectionModelChange,stateSelector:bn,changeEvent:ne.selectionChange});}),[t,r.onSelectionModelChange,s]),React.useEffect((()=>{n((e=>{const t=bn(e),r=Cn(e);let l=!1;return t.forEach((e=>{i[e]||(delete r[e],l=!0);})),l?Object.assign(Object.assign({},e),{selection:Object.values(r)}):e})),o();}),[i,t,n,o]),React.useEffect((()=>{void 0!==s&&t.current.setSelectionModel(s);}),[t,s,n]),React.useEffect((()=>{n((e=>{const r=[...e.selection],l=Cn(e);let n=!1;return r.forEach((e=>{!p||p(t.current.getRowParams(e))||(delete l[e],n=!0);})),n?Object.assign(Object.assign({},e),{selection:Object.values(l)}):e})),o();}),[t,n,o,p]);},$i=(t,r)=>{const l=Ar("useGridSorting"),[n,o,a]=rl(t),i=ll(t,vl),s=React.useCallback(((e,t)=>{const r=n.sorting.sortModel.findIndex((t=>t.field===e));let l=[...n.sorting.sortModel];return r>-1?t?l.splice(r,1,t):l.splice(r,1):l=[...n.sorting.sortModel,t],l}),[n.sorting.sortModel]),c=React.useCallback(((e,t)=>{const l=n.sorting.sortModel.find((t=>t.field===e.field));if(l){const e=void 0===t?Sn(r.sortingOrder,l.sort):t;return null==e?void 0:Object.assign(Object.assign({},l),{sort:e})}return {field:e.field,sort:void 0===t?Sn(r.sortingOrder):t}}),[n.sorting.sortModel,r.sortingOrder]),u=React.useCallback(((e,r)=>({id:e,field:r,value:t.current.getCellValue(e,r),api:t.current})),[t]),d=React.useCallback((e=>(t,r)=>e.reduce(((e,l,n)=>{if(0!==e)return e;const{comparator:o}=l,a=t[n],i=r[n];return e=o(a.value,i.value,a,i)}),0)),[]),p=React.useCallback((e=>e.map((e=>{const r=t.current.getColumn(e.field);if(!r)throw new Error(`Error sorting: column with field '${e.field}' not found. `);const l="desc"===e.sort?(e,t,l,n)=>-1*r.sortComparator(e,t,l,n):r.sortComparator;return {field:r.field,comparator:l}}))),[t]),m=React.useCallback((()=>{let e=t.current.getAllRowIds();if(r.sortingMode===Vr.server)return l.debug("Skipping sorting rows as sortingMode = server"),void o((t=>Object.assign(Object.assign({},t),{sorting:Object.assign(Object.assign({},t.sorting),{sortedRows:e})})));const n=t.current.state.sorting.sortModel;if(n.length>0){const t=p(n);l.debug("Sorting rows with ",n),e=e.map((e=>t.map((t=>u(e,t.field))))).sort(d(t)).map((e=>e[0].id));}o((t=>Object.assign(Object.assign({},t),{sorting:Object.assign(Object.assign({},t.sorting),{sortedRows:e})}))),a();}),[t,l,u,o,a,p,d,r.sortingMode]),f=React.useCallback((e=>{o((t=>Object.assign(Object.assign({},t),{sorting:Object.assign(Object.assign({},t.sorting),{sortModel:e})}))),a(),t.current.applySorting();}),[o,a,t]),g=React.useCallback(((e,t,l)=>{if(!e.sortable)return;const n=c(e,t);let o;o=!l||r.disableMultipleColumnsSorting?n?[n]:[]:s(e.field,n),f(o);}),[s,f,c,r.disableMultipleColumnsSorting]),b=React.useCallback((({colDef:e},t)=>{const r=t.shiftKey||t.metaKey||t.ctrlKey;g(e,void 0,r);}),[g]),h=React.useCallback((({colDef:e},t)=>{!Zl(t.key)||t.ctrlKey||t.metaKey||g(e,void 0,t.shiftKey);}),[g]),v=React.useCallback((()=>{o((e=>Object.assign(Object.assign({},e),{sorting:Object.assign(Object.assign({},e.sorting),{sortedRows:[]})})));}),[o]),C=React.useCallback((()=>n.sorting.sortModel),[n.sorting.sortModel]),w=React.useCallback((()=>Object.values(Sl(t.current.state))),[t]),O=React.useCallback((()=>El(t.current.state)),[t]),y=React.useCallback((()=>{o((e=>{const t=e.sorting.sortModel,r=ue(e);let l=t;return t.length>0&&(l=t.reduce(((e,t)=>(r.find((e=>e.field===t.field))&&e.push(t),e)),[])),Object.assign(Object.assign({},e),{sorting:Object.assign(Object.assign({},e.sorting),{sortModel:l})})}));}),[o]);cl(t,ne.columnHeaderClick,b),cl(t,ne.columnHeaderKeyDown,h),cl(t,ne.rowsSet,t.current.applySorting),cl(t,ne.rowsClear,v),cl(t,ne.rowsUpdate,t.current.applySorting),cl(t,ne.columnsChange,y);_r(t,{getSortModel:C,getSortedRows:w,getSortedRowIds:O,setSortModel:f,sortColumn:g,applySorting:m},"GridSortApi"),React.useEffect((()=>{t.current.applySorting();}),[t,r.rows]),React.useEffect((()=>{i>0&&(l.debug("row changed, applying sortModel"),t.current.applySorting());}),[i,t,l]),React.useEffect((()=>{t.current.updateControlState({stateId:"sortModel",propModel:r.sortModel,propOnChange:r.onSortModelChange,stateSelector:e=>e.sorting.sortModel,changeEvent:ne.sortModelChange});}),[t,r.sortModel,r.onSortModelChange]),React.useEffect((()=>{const e=t.current.state.sorting.sortModel;void 0!==r.sortModel&&r.sortModel!==e&&f(r.sortModel);}),[r.sortModel,t,f]);};function Vi(e){const{clientHeight:t,scrollTop:r,offsetHeight:l,offsetTop:n}=e,o=n+l;return o-t>r?o-t:n<r?n:void 0}function Bi(e,t,r=0,l=t.length){if(t.length<=0)return -1;if(r>=l)return r;const n=r+Math.floor((l-r)/2);return e<=t[n]?Bi(e,t,r,n):Bi(e,t,n+1,l)}const Wi=t=>{var r;const l=Ar("useGridVirtualRows"),n=t.current.columnHeadersElementRef,o=t.current.windowRef,a=t.current.renderingZoneRef,[i,s,c]=rl(t),u=ll(t,il),d=ll(t,Bl),p=ll(t,fn),m=ll(t,vl),f=ll(t,de),g=ll(t,pe),b=React.useRef(null),h=React.useRef(null),v=React.useRef(0),[C]=Di(a,n),w=React.useCallback((e=>{let t=!1;return s((r=>{const l=Object.assign(Object.assign({},r.rendering),e);return br(r.rendering,l)?r:(t=!0,Object.assign(Object.assign({},r),{rendering:l}))})),t}),[s]),O=React.useCallback((e=>{if(null==t.current.state.containerSizes)return null;let r=0;u.pagination&&null!=p.pageSize&&"client"===u.paginationMode&&(r=p.pageSize*p.page);const l=e*t.current.state.containerSizes.viewportPageSize+r;let n=l+t.current.state.containerSizes.renderingZonePageSize;const o=t.current.state.containerSizes.virtualRowsCount+r;n>o&&(n=o);return {page:e,firstRowIdx:l,lastRowIdx:n}}),[t,u.pagination,p.pageSize,u.paginationMode,p.page]),y=React.useCallback((()=>{if(null==t.current.state.containerSizes)return null;return Object.assign(Object.assign(Object.assign({},b.current),O(t.current.state.rendering.virtualPage)),{paginationCurrentPage:p.page,pageSize:p.pageSize})}),[b,O,t,p.page,p.pageSize]),E=React.useCallback((()=>{const e=y();w({renderContext:e})&&(l.debug("reRender: trigger rendering"),c());}),[y,l,c,w]),S=React.useCallback((e=>Bi(e,g.positions)),[g.positions]),M=React.useCallback((e=>f.length?f[S(e)]:null),[S,f]),x=React.useCallback(((e,r)=>{var n,o,a,i;if(!e)return !1;h.current=e;const s=e.windowSizes.width;v.current=r,l.debug(`GridColumns from ${null===(n=M(r))||void 0===n?void 0:n.field} to ${null===(o=M(r+s))||void 0===o?void 0:o.field}`);const c=S(r),d=S(r+s),p=(null===(a=null==b?void 0:b.current)||void 0===a?void 0:a.firstColIdx)||0,m=(null===(i=null==b?void 0:b.current)||void 0===i?void 0:i.lastColIdx)||0,C=u.columnBuffer,w=C>1?C-1:C,O=Math.abs(c-w-p),y=Math.abs(d+w-m);l.debug(`Column buffer: ${C}, tolerance: ${w}`),l.debug(`Previous values  => first: ${p}, last: ${m}`),l.debug(`Current displayed values  => first: ${c}, last: ${d}`),l.debug(`Difference with first: ${O} and last: ${y} `);const E=f.length>0?f.length-1:0,x=c-C>=0?c-C:0,k={leftEmptyWidth:g.positions[x],rightEmptyWidth:0,firstColIdx:x,lastColIdx:d+C>=E?E:d+C};return t.current.state.scrollBar.hasScrollX?k.rightEmptyWidth=g.totalWidth-g.positions[k.lastColIdx]-f[k.lastColIdx].computedWidth:u.disableExtendRowFullWidth||(k.rightEmptyWidth=t.current.state.viewportSizes.width-g.totalWidth),br(k,b.current)?(l.debug("No rendering needed on columns"),!1):(b.current=k,l.debug("New columns state to render",k),!0)}),[t,g.positions,g.totalWidth,M,S,l,u.columnBuffer,u.disableExtendRowFullWidth,f]),k=React.useCallback(((e=!1)=>{const r=t.current.state,n=r.containerSizes;if(!o||!o.current||!n)return;const a=r.scrollBar,{scrollLeft:i,scrollTop:s}=o.current;l.debug(`Handling scroll Left: ${i} Top: ${s}`);let c=x(n,i);const u=i,d=r.containerSizes.renderingZoneScrollHeight,m=r.rendering.virtualPage,f=d>0?Math.floor(s/d):0,g=s%d,b={left:a.hasScrollX?u:0,top:n.isVirtualized?g:s};n.isVirtualized&&m!==f?(w({virtualPage:f}),l.debug(`Changing page from ${m} to ${f}`),c=!0):(!n.isVirtualized&&m>0&&(l.debug("Virtualization disabled, setting virtualPage to 0"),w({virtualPage:0})),C(b)),w({renderingZoneScroll:b,realScroll:{left:o.current.scrollLeft,top:o.current.scrollTop}}),t.current.publishEvent(ne.rowsScroll,b);const h=r.rendering.renderContext&&r.rendering.renderContext.paginationCurrentPage!==p.page;(e||c||h)&&E();}),[t,l,p.page,E,C,w,x,o]),D=React.useCallback((e=>{if(0===m||0===f.length)return !1;l.debug(`Scrolling to cell at row ${e.rowIndex}, col: ${e.colIndex} `);const r={};if(null!=e.colIndex&&(r.left=Vi({clientHeight:o.current.clientWidth,scrollTop:o.current.scrollLeft,offsetHeight:f[e.colIndex].computedWidth,offsetTop:g.positions[e.colIndex]})),null!=e.rowIndex){const t=u.pagination?e.rowIndex-p.page*p.pageSize:e.rowIndex;r.top=Vi({clientHeight:o.current.clientHeight,scrollTop:o.current.scrollTop,offsetHeight:d,offsetTop:d*t});}return (void 0!==typeof r.left||void 0!==typeof r.top)&&(t.current.scroll(r),!0)}),[m,f,l,t,u.pagination,p.page,p.pageSize,o,g.positions,d]),R=React.useCallback((()=>{C({left:0,top:0}),w({virtualPage:0}),o&&o.current&&(o.current.scrollTop=0,o.current.scrollLeft=0),w({renderingZoneScroll:{left:0,top:0}});}),[C,w,o]),I=React.useRef(null),P=React.useCallback((()=>{o.current.scrollLeft<0||o.current.scrollTop<0||(I.current||s((e=>Object.assign(Object.assign({},e),{isScrolling:!0}))),clearTimeout(I.current),I.current=setTimeout((()=>{I.current=null,s((e=>Object.assign(Object.assign({},e),{isScrolling:!1}))),c();}),300),t.current.updateViewport&&t.current.updateViewport());}),[o,t,s,c]),L=React.useCallback((e=>{o.current&&null!=e.left&&n.current&&(n.current.scrollLeft=e.left,o.current.scrollLeft=e.left,l.debug(`Scrolling left: ${e.left}`)),o.current&&null!=e.top&&(o.current.scrollTop=e.top,l.debug(`Scrolling top: ${e.top}`)),l.debug("Scrolling, updating container, and viewport");}),[o,n,l]),F=React.useCallback((()=>ol(t.current.state)),[t]),j=React.useCallback((()=>i.containerSizes),[i.containerSizes]),z=React.useCallback((()=>i.rendering.renderContext||void 0),[i.rendering.renderContext]);vr((()=>{a&&a.current&&(l.debug("applying scrollTop ",i.rendering.renderingZoneScroll.top),C(i.rendering.renderingZoneScroll));}));_r(t,{scroll:L,scrollToIndexes:D,getContainerPropsState:j,getRenderContextState:z,getScrollPosition:F,updateViewport:k},"GridVirtualizationApi"),React.useEffect((()=>{var e;(null===(e=i.rendering.renderContext)||void 0===e?void 0:e.paginationCurrentPage)!==p.page&&t.current.updateViewport&&(l.debug(`State paginationState.page changed to ${p.page}. `),t.current.updateViewport(!0),R());}),[t,p.page,null===(r=i.rendering.renderContext)||void 0===r?void 0:r.paginationCurrentPage,l,R]),React.useEffect((()=>(t.current.updateViewport&&(l.debug(`totalRowCount has changed to ${m}, updating viewport.`),t.current.updateViewport(!0)),()=>{clearTimeout(I.current);})),[l,m,i.viewportSizes,i.scrollBar,i.containerSizes,t]);const T=React.useCallback((e=>{e.target.scrollLeft=0,e.target.scrollTop=0;}),[]);fi(t,o,"scroll",P,{passive:!0}),fi(t,(()=>{var e,r,l;return null===(l=null===(r=null===(e=t.current)||void 0===e?void 0:e.renderingZoneRef)||void 0===r?void 0:r.current)||void 0===l?void 0:l.parentElement}),"scroll",T),fi(t,(()=>{var e,r;return null===(r=null===(e=t.current)||void 0===e?void 0:e.columnHeadersContainerElementRef)||void 0===r?void 0:r.current}),"scroll",T);const H=React.useCallback((()=>{l.debug("Clearing previous renderedColRef"),b.current=null;}),[l,b]);cl(t,ne.columnsChange,H),cl(t,ne.debouncedResize,H);};class Ui extends class{constructor(){this.maxListeners=10,this.warnOnce=!1,this.events={};}on(e,t){Array.isArray(this.events[e])||(this.events[e]=[]),this.events[e].push(t),"production"!==process.env.NODE_ENV&&this.events[e].length>this.maxListeners&&!1===this.warnOnce&&(this.warnOnce=!0,console.warn([`Possible EventEmitter memory leak detected. ${this.events[e].length} ${e} listeners added.`,"Use emitter.setMaxListeners() to increase limit."].join("\n")));}removeListener(e,t){if(Array.isArray(this.events[e])){const r=this.events[e].indexOf(t);r>-1&&this.events[e].splice(r,1);}}removeAllListeners(e){e?Array.isArray(this.events[e])&&(this.events[e]=[]):this.events={};}emit(e,...t){if(Array.isArray(this.events[e])){const r=this.events[e].slice(),l=r.length;for(let e=0;e<l;e+=1)r[e].apply(this,t);}}once(e,t){const r=this;this.on(e,(function l(...n){r.removeListener(e,l),t.apply(r,n);}));}}{on(e,t,r){Array.isArray(this.events[e])||(this.events[e]=[]),r&&r.isFirst?this.events[e].splice(0,0,t):this.events[e].push(t),"production"!==process.env.NODE_ENV&&this.events[e].length>this.maxListeners&&!1===this.warnOnce&&(this.warnOnce=!0,console.warn([`Possible EventEmitter memory leak detected. ${this.events[e].length} ${e} listeners added.`,"Use emitter.setMaxListeners() to increase limit."].join("\n")));}}function Ki(...t){const r=t[0],l=React.useRef(new Ui);return React.useImperativeHandle(r,(()=>l.current),[l]),l}let Zi=!1;function Xi(){if("undefined"==typeof document)return Zi;if(!Zi){const e=document.createElement("div");e.style.touchAction="none",document.body.appendChild(e),Zi="none"===window.getComputedStyle(e).touchAction,e.parentElement.removeChild(e);}return Zi}function qi(e,t){if(void 0!==t&&e.changedTouches){for(let r=0;r<e.changedTouches.length;r+=1){const l=e.changedTouches[r];if(l.identifier===t)return {x:l.clientX,y:l.clientY}}return !1}return {x:e.clientX,y:e.clientY}}const Yi=(t,r)=>{const l=Ar("useGridColumnResize"),[,n,o]=rl(t),a=React.useRef(),i=React.useRef(),s=React.useRef(),c=React.useRef(),u=React.useRef(),d=React.useRef(),p=e=>{l.debug(`Updating width to ${e} for col ${a.current.field}`),a.current.computedWidth=e,a.current.width=e,a.current.flex=void 0,i.current.style.width=`${e}px`,i.current.style.minWidth=`${e}px`,i.current.style.maxWidth=`${e}px`,s.current.forEach((t=>{const r=t;r.style.width=`${e}px`,r.style.minWidth=`${e}px`,r.style.maxWidth=`${e}px`;}));},m=hr((e=>{w(),t.current.updateColumn(a.current),clearTimeout(u.current),u.current=setTimeout((()=>{var r;t.current.publishEvent(ne.columnResizeStop,null,e),t.current.publishEvent(ne.columnWidthChange,{element:i.current,colDef:a.current,api:t,width:null===(r=a.current)||void 0===r?void 0:r.computedWidth},e);})),l.debug(`Updating col ${a.current.field} with new width: ${a.current.width}`);})),g=hr((e=>{var r;if(0===e.buttons)return void m(e);let l=c.current+e.clientX-i.current.getBoundingClientRect().left;l=Math.max(null===(r=a.current)||void 0===r?void 0:r.minWidth,l),p(l),t.current.publishEvent(ne.columnResize,{element:i.current,colDef:a.current,api:t,width:l},e);})),b=hr((({colDef:e},r)=>{var n;if(0!==r.button)return;if(!r.currentTarget.classList.contains("MuiDataGrid-columnSeparator--resizable"))return;r.preventDefault(),i.current=Io(r.currentTarget,"MuiDataGrid-columnHeader"),l.debug(`Start Resize on col ${e.field}`),t.current.publishEvent(ne.columnResizeStart,{field:e.field},r),a.current=e,i.current=null===(n=t.current.columnHeadersElementRef)||void 0===n?void 0:n.current.querySelector(`[data-field="${e.field}"]`),s.current=Lo(i.current);const o=ownerDocument(t.current.rootElementRef.current);o.body.style.cursor="col-resize",c.current=a.current.computedWidth-(r.clientX-i.current.getBoundingClientRect().left),o.addEventListener("mousemove",g),o.addEventListener("mouseup",m);})),h=hr((e=>{qi(e,d.current)&&(w(),t.current.updateColumn(a.current),clearTimeout(u.current),u.current=setTimeout((()=>{t.current.publishEvent(ne.columnResizeStop,null,e);})),l.debug(`Updating col ${a.current.field} with new width: ${a.current.width}`));})),v=hr((e=>{var r;const l=qi(e,d.current);if(!l)return;if("mousemove"===e.type&&0===e.buttons)return void h(e);let n=c.current+l.x-i.current.getBoundingClientRect().left;n=Math.max(null===(r=a.current)||void 0===r?void 0:r.minWidth,n),p(n),t.current.publishEvent(ne.columnResize,{element:i.current,colDef:a.current,api:t,width:n},e);})),C=hr((e=>{var r;if(!Io(e.target,"MuiDataGrid-columnSeparator--resizable"))return;Xi()||e.preventDefault();const n=e.changedTouches[0];null!=n&&(d.current=n.identifier),i.current=Io(e.target,"MuiDataGrid-columnHeader");const o=i.current.getAttribute("data-field");const u=t.current.getColumn(o);l.debug(`Start Resize on col ${u.field}`),t.current.publishEvent(ne.columnResizeStart,{field:o},e),a.current=u,i.current=function(e,t){return e.querySelector(`[data-field="${t}"]`)}(null===(r=t.current.columnHeadersElementRef)||void 0===r?void 0:r.current,u.field),s.current=Lo(i.current),c.current=a.current.computedWidth-(n.clientX-i.current.getBoundingClientRect().left);const p=ownerDocument(e.currentTarget);p.addEventListener("touchmove",v),p.addEventListener("touchend",h);})),w=React.useCallback((()=>{const e=ownerDocument(t.current.rootElementRef.current);e.body.style.removeProperty("cursor"),e.removeEventListener("mousemove",g),e.removeEventListener("mouseup",m),e.removeEventListener("touchmove",v),e.removeEventListener("touchend",h);}),[t,g,m,v,h]),O=React.useCallback((({field:e})=>{n((t=>Object.assign(Object.assign({},t),{columnResize:Object.assign(Object.assign({},t.columnResize),{resizingColumnField:e})}))),o();}),[n,o]),y=React.useCallback((()=>{n((e=>Object.assign(Object.assign({},e),{columnResize:Object.assign(Object.assign({},e.columnResize),{resizingColumnField:""})}))),o();}),[n,o]);React.useEffect((()=>()=>{clearTimeout(u.current),w();}),[t,C,w]),fi(t,(()=>{var e,r;return null===(r=null===(e=t.current)||void 0===e?void 0:e.columnHeadersElementRef)||void 0===r?void 0:r.current}),"touchstart",C,{passive:Xi()}),cl(t,ne.columnSeparatorMouseDown,b),cl(t,ne.columnResizeStart,O),cl(t,ne.columnResizeStop,y),dl(t,ne.columnResize,r.onColumnResize),dl(t,ne.columnWidthChange,r.onColumnWidthChange);},Ji=React.memo((function(t){const r=ae(),l=dn(),[n]=l.sortingOrder,o="asc"===n?null==r?void 0:r.current.components.ColumnSortedAscendingIcon:null==r?void 0:r.current.components.ColumnSortedDescendingIcon;return o?React.createElement(o,Object.assign({},t)):null})),Qi=React.forwardRef((function(t,r){const{message:l}=t,n=On(t,["message"]),o=ae().current.getLocaleText("errorOverlayDefaultLabel");return React.createElement(xa,Object.assign({ref:r},n),l||o)})),es=React.forwardRef((function(t,r){const l=ae().current.getLocaleText("noResultsOverlayLabel");return React.createElement(xa,Object.assign({ref:r},t),l)})),ts$1={BooleanCellFalseIcon:$n,BooleanCellTrueIcon:Kn,Checkbox:w,ColumnFilteredIcon:Ln,ColumnMenu:Fa,ColumnMenuIcon:Nn,ColumnResizeIcon:Hn,ColumnSelectorIcon:Tn,ColumnSortedAscendingIcon:Rn,ColumnSortedDescendingIcon:In,ColumnsPanel:Ba,ColumnUnsortedIcon:Ji,DensityComfortableIcon:Gn,DensityCompactIcon:An,DensityStandardIcon:_n,ErrorOverlay:Qi,ExportIcon:Un,FilterPanel:Ya,Footer:ai,Header:ii,LoadingOverlay:si,NoResultsOverlay:es,NoRowsOverlay:ci,OpenFilterButtonIcon:Pn,Pagination:di,Panel:Ka,PreferencesPanel:Za},rs=(t,r)=>{const l=React.useMemo((()=>{var e,t;return {BooleanCellTrueIcon:r.components&&r.components.BooleanCellTrueIcon||ts$1.BooleanCellTrueIcon,BooleanCellFalseIcon:r.components&&r.components.BooleanCellFalseIcon||ts$1.BooleanCellFalseIcon,ColumnFilteredIcon:r.components&&r.components.ColumnFilteredIcon||ts$1.ColumnFilteredIcon,ColumnMenuIcon:r.components&&r.components.ColumnMenuIcon||ts$1.ColumnMenuIcon,ColumnResizeIcon:r.components&&r.components.ColumnResizeIcon||ts$1.ColumnResizeIcon,ColumnSelectorIcon:r.components&&r.components.ColumnSelectorIcon||ts$1.ColumnSelectorIcon,ColumnUnsortedIcon:void 0===(null===(e=r.components)||void 0===e?void 0:e.ColumnUnsortedIcon)?ts$1.ColumnUnsortedIcon:null===(t=r.components)||void 0===t?void 0:t.ColumnUnsortedIcon,ColumnSortedAscendingIcon:r.components&&r.components.ColumnSortedAscendingIcon||ts$1.ColumnSortedAscendingIcon,ColumnSortedDescendingIcon:r.components&&r.components.ColumnSortedDescendingIcon||ts$1.ColumnSortedDescendingIcon,DensityComfortableIcon:r.components&&r.components.DensityComfortableIcon||ts$1.DensityComfortableIcon,DensityCompactIcon:r.components&&r.components.DensityCompactIcon||ts$1.DensityCompactIcon,DensityStandardIcon:r.components&&r.components.DensityStandardIcon||ts$1.DensityStandardIcon,ExportIcon:r.components&&r.components.ExportIcon||ts$1.ExportIcon,OpenFilterButtonIcon:r.components&&r.components.OpenFilterButtonIcon||ts$1.OpenFilterButtonIcon,Checkbox:r.components&&r.components.Checkbox||ts$1.Checkbox,ColumnMenu:r.components&&r.components.ColumnMenu||ts$1.ColumnMenu,ErrorOverlay:r.components&&r.components.ErrorOverlay||ts$1.ErrorOverlay,Footer:r.components&&r.components.Footer||ts$1.Footer,Header:r.components&&r.components.Header||ts$1.Header,Toolbar:r.components&&r.components.Toolbar,PreferencesPanel:r.components&&r.components.PreferencesPanel||ts$1.PreferencesPanel,LoadingOverlay:r.components&&r.components.LoadingOverlay||ts$1.LoadingOverlay,NoResultsOverlay:r.components&&r.components.NoResultsOverlay||ts$1.NoResultsOverlay,NoRowsOverlay:r.components&&r.components.NoRowsOverlay||ts$1.NoRowsOverlay,Pagination:r.components&&r.components.Pagination||ts$1.Pagination,FilterPanel:r.components&&r.components.FilterPanel||ts$1.FilterPanel,ColumnsPanel:r.components&&r.components.ColumnsPanel||ts$1.ColumnsPanel,Panel:r.components&&r.components.Panel||ts$1.Panel}}),[r.components]);t.current.components=l,t.current.componentsProps=r.componentsProps;},ns=(e,t)=>{var r,l;return "v5"===Sr()?{components:{MuiDataGrid:{defaultProps:{localeText:Object.assign(Object.assign({},e),{MuiTablePagination:(null===(r=null==t?void 0:t.components)||void 0===r?void 0:r.MuiTablePagination.defaultProps)||{}})}}}}:{props:{MuiDataGrid:{localeText:Object.assign(Object.assign({},e),{MuiTablePagination:(null===(l=null==t?void 0:t.props)||void 0===l?void 0:l.MuiTablePagination)||{}})}}}};ns({noRowsLabel:"لا توجد صفوف",noResultsOverlayLabel:"لم يتم العثور على نتائج.",errorOverlayDefaultLabel:"حدث خطأ.",toolbarDensity:"كثافة",toolbarDensityLabel:"كثافة",toolbarDensityCompact:"مدمج",toolbarDensityStandard:"المعيار",toolbarDensityComfortable:"مريح",toolbarColumns:"الأعمدة",toolbarColumnsLabel:"حدد الأعمدة",toolbarFilters:"الفلاتر",toolbarFiltersLabel:"اظهر الفلاتر",toolbarFiltersTooltipHide:"إخفاء الفلاتر",toolbarFiltersTooltipShow:"اظهر الفلاتر",toolbarFiltersTooltipActive:e=>`${e} فلاتر نشطة`,toolbarExport:"تصدير",toolbarExportLabel:"تصدير",toolbarExportCSV:"تنزيل كملف CSV",columnsPanelTextFieldLabel:"ايجاد عمود",columnsPanelTextFieldPlaceholder:"عنوان العمود",columnsPanelDragIconLabel:"إعادة ترتيب العمود",columnsPanelShowAllButton:"عرض الكل",columnsPanelHideAllButton:"اخفاء الكل",filterPanelAddFilter:"اضف فلتر",filterPanelDeleteIconLabel:"حذف",filterPanelOperators:"العاملين",filterPanelOperatorAnd:"و",filterPanelOperatorOr:"او",filterPanelColumns:"الأعمدة",filterPanelInputLabel:"قيمة",filterPanelInputPlaceholder:"قيمة التصفية",filterOperatorContains:"يحتوي على",filterOperatorEquals:"يساوي",filterOperatorStartsWith:"يبدأ ب",filterOperatorEndsWith:"ينتهي بـ",filterOperatorIs:"يكون",filterOperatorNot:"ليس",filterOperatorAfter:"يكون بعد",filterOperatorOnOrAfter:"في أو بعد",filterOperatorBefore:"يكون",filterOperatorOnOrBefore:"في أو قبل",filterOperatorIsEmpty:"فارغ",filterOperatorIsNotEmpty:"ليس فارغا",filterValueAny:"أي",filterValueTrue:"صحيح",filterValueFalse:"خاطئة",columnMenuLabel:"القائمة",columnMenuShowColumns:"إظهار الأعمدة",columnMenuFilter:"فلتر",columnMenuHideColumn:"إخفاء",columnMenuUnsort:"غير مرتب",columnMenuSortAsc:"الترتيب حسب ASC",columnMenuSortDesc:"الترتيب حسب DESC",columnHeaderFiltersTooltipActive:e=>`${e} فلاتر نشطة`,columnHeaderFiltersLabel:"اظهر الفلاتر",columnHeaderSortIconLabel:"ترتيب",footerRowSelected:e=>`${e.toLocaleString()} صفوف مختارة`,footerTotalRows:"إجمالي الصفوف:",footerTotalVisibleRows:(e,t)=>`${e.toLocaleString()} من ${t.toLocaleString()}`,checkboxSelectionHeaderName:"تحديد",booleanCellTrueLabel:"صحيح",booleanCellFalseLabel:"خاطئة"},enUS);ns({noRowsLabel:"Няма редове",errorOverlayDefaultLabel:"Възникна грешка.",toolbarDensity:"Гъстота",toolbarDensityLabel:"Гъстота",toolbarDensityCompact:"Компактна",toolbarDensityStandard:"Стандартна",toolbarDensityComfortable:"Комфортна",toolbarColumns:"Колони",toolbarColumnsLabel:"Покажи селектора на колони",toolbarFilters:"Филтри",toolbarFiltersLabel:"Покажи Филтрите",toolbarFiltersTooltipHide:"Скрий Филтрите",toolbarFiltersTooltipShow:"Покажи Филтрите",toolbarFiltersTooltipActive:e=>`${e} активни филтри`,columnsPanelTextFieldLabel:"Намери колона",columnsPanelTextFieldPlaceholder:"Заглавие на колона",columnsPanelDragIconLabel:"Пренареди на колона",columnsPanelShowAllButton:"Покажи Всички",columnsPanelHideAllButton:"Скрий Всички",filterPanelAddFilter:"Добави Филтър",filterPanelDeleteIconLabel:"Изтрий",filterPanelOperators:"Оператори",filterPanelOperatorAnd:"И",filterPanelOperatorOr:"Или",filterPanelColumns:"Колони",filterOperatorContains:"съдържа",filterOperatorEquals:"равно",filterOperatorStartsWith:"започва с",filterOperatorEndsWith:"завършва с",filterOperatorIs:"е",filterOperatorNot:"не е",filterOperatorAfter:"е след",filterOperatorOnOrAfter:"е на или след",filterOperatorBefore:"е преди",filterOperatorOnOrBefore:"е на или преди",filterPanelInputLabel:"Стойност",filterPanelInputPlaceholder:"Стойност на филтъра",columnMenuLabel:"Меню",columnMenuShowColumns:"Покажи колоните",columnMenuFilter:"Филтри",columnMenuHideColumn:"Скрий",columnMenuUnsort:"Отмени сортирането",columnMenuSortAsc:"Сортирай по възходящ ред",columnMenuSortDesc:"Сортирай по низходящ ред",columnHeaderFiltersTooltipActive:e=>`${e} активни филтри`,columnHeaderFiltersLabel:"Покажи Филтрите",columnHeaderSortIconLabel:"Сортирай",footerRowSelected:e=>1!==e?`${e.toLocaleString()} избрани редове`:`${e.toLocaleString()} избран ред`,footerTotalRows:"Общо Rедове:"},bgBG);ns({noRowsLabel:"Žádné záznamy",noResultsOverlayLabel:"Nenašli se žadné výsledky.",errorOverlayDefaultLabel:"Stala sa nepředvídaná chyba.",toolbarDensity:"Hustota",toolbarDensityLabel:"Hustota",toolbarDensityCompact:"Kompaktní",toolbarDensityStandard:"Standartní",toolbarDensityComfortable:"Komfortní",toolbarColumns:"Sloupce",toolbarColumnsLabel:"Vybrat sloupec",toolbarFilters:"Filtry",toolbarFiltersLabel:"Zobrazit filtry",toolbarFiltersTooltipHide:"Skrýt filtry",toolbarFiltersTooltipShow:"Zobrazit filtry",toolbarFiltersTooltipActive:e=>{let t="aktivních filtrů";return e>1&&e<5?t="aktivní filtry":1===e&&(t="aktivní filtr"),`${e} ${t}`},toolbarExport:"Export",toolbarExportLabel:"Export",toolbarExportCSV:"Stáhnout jako CSV",columnsPanelTextFieldLabel:"Najít sloupec",columnsPanelTextFieldPlaceholder:"Název sloupce",columnsPanelDragIconLabel:"Uspořádat sloupce",columnsPanelShowAllButton:"Zobrazit vše",columnsPanelHideAllButton:"Skrýt vše",filterPanelAddFilter:"Přidat filtr",filterPanelDeleteIconLabel:"Odstranit",filterPanelOperators:"Operátory",filterPanelOperatorAnd:"A",filterPanelOperatorOr:"Nebo",filterPanelColumns:"Sloupce",filterPanelInputLabel:"Hodnota",filterPanelInputPlaceholder:"Hodnota filtru",filterOperatorContains:"obsahuje",filterOperatorEquals:"rovná se",filterOperatorStartsWith:"začíná s",filterOperatorEndsWith:"končí na",filterOperatorIs:"je",filterOperatorNot:"není",filterOperatorAfter:"je po",filterOperatorOnOrAfter:"je na nebo po",filterOperatorBefore:"je před",filterOperatorOnOrBefore:"je na nebo dříve",filterValueAny:"jakýkoliv",filterValueTrue:"ano",filterValueFalse:"ne",columnMenuLabel:"Menu",columnMenuShowColumns:"Zobrazit sloupce",columnMenuFilter:"Filtr",columnMenuHideColumn:"Skrýt",columnMenuUnsort:"Zrušit filtry",columnMenuSortAsc:"Seřadit vzestupně",columnMenuSortDesc:"Seřadit sestupně",columnHeaderFiltersTooltipActive:e=>{let t="aktivních filtrů";return e>1&&e<5?t="aktivní filtry":1===e&&(t="aktivní filtr"),`${e} ${t}`},columnHeaderFiltersLabel:"Zobrazit filtry",columnHeaderSortIconLabel:"Filtrovat",footerRowSelected:e=>{let t="vybraných záznamů";return e>1&&e<5?t="vybrané záznamy":1===e&&(t="vybraný záznam"),`${e} ${t}`},footerTotalRows:"Celkem řádků:",checkboxSelectionHeaderName:"Výběr řádku",booleanCellTrueLabel:"ano",booleanCellFalseLabel:"ne"},csCZ);ns({noRowsLabel:"Keine Einträge",noResultsOverlayLabel:"Keine Ergebnisse gefunden.",errorOverlayDefaultLabel:"Ein unerwarteter Fehler ist aufgetreten.",toolbarDensity:"Zeilenhöhe",toolbarDensityLabel:"Zeilenhöhe",toolbarDensityCompact:"Kompakt",toolbarDensityStandard:"Standard",toolbarDensityComfortable:"Breit",toolbarColumns:"Spalten",toolbarColumnsLabel:"Zeige Spaltenauswahl",toolbarFilters:"Filter",toolbarFiltersLabel:"Zeige Filter",toolbarFiltersTooltipHide:"Verberge Filter",toolbarFiltersTooltipShow:"Zeige Filter",toolbarFiltersTooltipActive:e=>1!==e?`${e} aktive Filter`:`${e} aktiver Filter`,toolbarExport:"Exportieren",toolbarExportLabel:"Exportieren",toolbarExportCSV:"Download als CSV",columnsPanelTextFieldLabel:"Finde Spalte",columnsPanelTextFieldPlaceholder:"Spaltenüberschrift",columnsPanelDragIconLabel:"Spalte umsortieren",columnsPanelShowAllButton:"Zeige alle",columnsPanelHideAllButton:"Verberge alle",filterPanelAddFilter:"Filter hinzufügen",filterPanelDeleteIconLabel:"Löschen",filterPanelOperators:"Operatoren",filterPanelOperatorAnd:"Und",filterPanelOperatorOr:"Oder",filterPanelColumns:"Spalten",filterPanelInputLabel:"Wert",filterPanelInputPlaceholder:"Wert filtern",filterOperatorContains:"beinhaltet",filterOperatorEquals:"ist gleich",filterOperatorStartsWith:"beginnt mit",filterOperatorEndsWith:"endet mit",filterOperatorIs:"ist",filterOperatorNot:"ist nicht",filterOperatorOnOrAfter:"ist an oder nach",filterOperatorBefore:"ist vor",filterOperatorOnOrBefore:"ist an oder vor",filterOperatorAfter:"ist nach",filterOperatorIsEmpty:"ist leer",filterOperatorIsNotEmpty:"ist nicht leer",columnMenuLabel:"Menü",columnMenuShowColumns:"Zeige alle Spalten",columnMenuFilter:"Filter",columnMenuHideColumn:"Verbergen",columnMenuUnsort:"Sortierung deaktivieren",columnMenuSortAsc:"Sortiere aufsteigend",columnMenuSortDesc:"Sortiere absteigend",columnHeaderFiltersTooltipActive:e=>1!==e?`${e} aktive Filter`:`${e} aktiver Filter`,columnHeaderFiltersLabel:"Zeige Filter",columnHeaderSortIconLabel:"Sortieren",footerRowSelected:e=>1!==e?`${e.toLocaleString()} Einträge ausgewählt`:`${e.toLocaleString()} Eintrag ausgewählt`,footerTotalRows:"Gesamt:",footerTotalVisibleRows:(e,t)=>`${e.toLocaleString()} von ${t.toLocaleString()}`},deDE);ns({noRowsLabel:"Δεν υπάρχουν καταχωρήσεις",errorOverlayDefaultLabel:"Παρουσιάστηκε απρόβλεπτο σφάλμα.",toolbarDensity:"Ύψος σειράς",toolbarDensityLabel:"Ύψος σειράς",toolbarDensityCompact:"Συμπαγής",toolbarDensityStandard:"Προκαθορισμένο",toolbarDensityComfortable:"Πλατύ",toolbarColumns:"Στήλες",toolbarColumnsLabel:"Επιλέξτε στήλες",toolbarFilters:"Φίλτρα",toolbarFiltersLabel:"Εμφάνιση φίλτρων",toolbarFiltersTooltipHide:"Απόκρυψη φίλτρων",toolbarFiltersTooltipShow:"Εμφάνιση φίλτρων",toolbarFiltersTooltipActive:e=>1!==e?`${e} ενεργά φίλτρα`:`${e} ενεργό φίλτρο`,toolbarExport:"Εξαγωγή",toolbarExportLabel:"Εξαγωγή",toolbarExportCSV:"Λήψη ως CSV",columnsPanelTextFieldLabel:"Εύρεση στήλης",columnsPanelTextFieldPlaceholder:"Επικεφαλίδα στήλης",columnsPanelDragIconLabel:"Αναδιάταξη στήλης",columnsPanelShowAllButton:"Προβολή όλων",columnsPanelHideAllButton:"Απόκρυψη όλων",filterPanelAddFilter:"Προσθήκη φίλτρου",filterPanelDeleteIconLabel:"Διαγραφή",filterPanelOperators:"Τελεστές",filterPanelOperatorAnd:"Καί",filterPanelOperatorOr:"Ή",filterPanelColumns:"Στήλες",filterPanelInputLabel:"Τιμή",filterPanelInputPlaceholder:"Τιμή φίλτρου",filterOperatorContains:"περιέχει",filterOperatorEquals:"ισούται",filterOperatorStartsWith:"ξεκινάει με",filterOperatorEndsWith:"τελειώνει με",filterOperatorIs:"είναι",filterOperatorNot:"δεν είναι",filterOperatorAfter:"είναι μετά",filterOperatorOnOrAfter:"είναι ίσο ή μετά",filterOperatorBefore:"είναι πριν",filterOperatorOnOrBefore:"είναι ίσο ή πριν",columnMenuLabel:"Μενού",columnMenuShowColumns:"Εμφάνιση στηλών",columnMenuFilter:"Φίλτρο",columnMenuHideColumn:"Απόκρυψη",columnMenuUnsort:"Απενεργοποίηση ταξινόμησης",columnMenuSortAsc:"Ταξινόμηση σε αύξουσα σειρά",columnMenuSortDesc:"Ταξινόμηση σε φθίνουσα σειρά",columnHeaderFiltersTooltipActive:e=>1!==e?`${e} ενεργά φίλτρα`:`${e} ενεργό φίλτρο`,columnHeaderFiltersLabel:"Εμφάνιση φίλτρων",columnHeaderSortIconLabel:"Ταξινόμηση",footerRowSelected:e=>1!==e?`${e.toLocaleString()} επιλεγμένες γραμμές`:`${e.toLocaleString()} επιλεγμένη γραμμή`,footerTotalRows:"Σύνολο Γραμμών:"});ns(Nr,enUS);ns({noRowsLabel:"Sin filas",errorOverlayDefaultLabel:"Ha ocurrido un error.",toolbarDensity:"Densidad",toolbarDensityLabel:"Densidad",toolbarDensityCompact:"Compacta",toolbarDensityStandard:"Standard",toolbarDensityComfortable:"Comoda",toolbarColumns:"Columnas",toolbarColumnsLabel:"Seleccionar columnas",toolbarFilters:"Filtros",toolbarFiltersLabel:"Mostrar filtros",toolbarFiltersTooltipHide:"Ocultar filtros",toolbarFiltersTooltipShow:"Mostrar filtros",toolbarFiltersTooltipActive:e=>e>1?`${e} filtros activos`:`${e} filtro activo`,toolbarExport:"Exportar",toolbarExportLabel:"Exportar",toolbarExportCSV:"Descargar como CSV",columnsPanelTextFieldLabel:"Columna de búsqueda",columnsPanelTextFieldPlaceholder:"Título de columna",columnsPanelDragIconLabel:"Reorder columna",columnsPanelShowAllButton:"Mostrar todo",columnsPanelHideAllButton:"Ocultar todo",filterPanelAddFilter:"Agregar filtro",filterPanelDeleteIconLabel:"Borrar",filterPanelOperators:"Operadores",filterPanelOperatorAnd:"Y",filterPanelOperatorOr:"O",filterPanelColumns:"Columnas",filterPanelInputLabel:"Valor",filterPanelInputPlaceholder:"Valor de filtro",filterOperatorContains:"contiene",filterOperatorEquals:"es igual",filterOperatorStartsWith:"comienza con",filterOperatorEndsWith:"termina con",filterOperatorIs:"es",filterOperatorNot:"no es",filterOperatorAfter:"es posterior",filterOperatorOnOrAfter:"es en o posterior",filterOperatorBefore:"es anterior",filterOperatorOnOrBefore:"es en o anterior",filterOperatorIsEmpty:"está vacío",filterOperatorIsNotEmpty:"no esta vacío",columnMenuLabel:"Menú",columnMenuShowColumns:"Mostrar columnas",columnMenuFilter:"Filtro",columnMenuHideColumn:"Ocultar",columnMenuUnsort:"Desordenar",columnMenuSortAsc:"Ordenar ASC",columnMenuSortDesc:"Ordenar DESC",columnHeaderFiltersTooltipActive:e=>e>1?`${e} filtros activos`:`${e} filtro activo`,columnHeaderFiltersLabel:"Mostrar filtros",columnHeaderSortIconLabel:"Ordenar",footerRowSelected:e=>e>1?`${e.toLocaleString()} filas seleccionadas`:`${e.toLocaleString()} fila seleccionada`,footerTotalRows:"Filas Totales:",footerTotalVisibleRows:(e,t)=>`${e.toLocaleString()} de ${t.toLocaleString()}`},esES);ns({noRowsLabel:"Pas de résultats",noResultsOverlayLabel:"Aucun résultat.",errorOverlayDefaultLabel:"Une erreur est apparue.",toolbarDensity:"Densité",toolbarDensityLabel:"Densité",toolbarDensityCompact:"Compact",toolbarDensityStandard:"Standard",toolbarDensityComfortable:"Confortable",toolbarColumns:"Colonnes",toolbarColumnsLabel:"Choisir les colonnes",toolbarFilters:"Filtres",toolbarFiltersLabel:"Afficher les filtres",toolbarFiltersTooltipHide:"Cacher les filtres",toolbarFiltersTooltipShow:"Afficher les filtres",toolbarFiltersTooltipActive:e=>e>1?`${e} filtres actifs`:`${e} filtre actif`,toolbarExport:"Exporter",toolbarExportLabel:"Exporter",toolbarExportCSV:"Télécharger en CSV",columnsPanelTextFieldLabel:"Chercher colonne",columnsPanelTextFieldPlaceholder:"Titre de la colonne",columnsPanelDragIconLabel:"Réorganiser la colonne",columnsPanelShowAllButton:"Tout afficher",columnsPanelHideAllButton:"Tout cacher",filterPanelAddFilter:"Ajouter un filtre",filterPanelDeleteIconLabel:"Supprimer",filterPanelOperators:"Opérateurs",filterPanelOperatorAnd:"Et",filterPanelOperatorOr:"Ou",filterPanelColumns:"Colonnes",filterPanelInputLabel:"Valeur",filterPanelInputPlaceholder:"Filtrer la valeur",filterOperatorContains:"contient",filterOperatorEquals:"égal à",filterOperatorStartsWith:"commence par",filterOperatorEndsWith:"se termine par",filterOperatorIs:"est",filterOperatorNot:"n'est pas",filterOperatorOnOrAfter:"égal ou postérieur",filterOperatorAfter:"postérieur",filterOperatorOnOrBefore:"égal ou antérieur",filterOperatorBefore:"antérieur",filterOperatorIsEmpty:"est vide",filterOperatorIsNotEmpty:"n'est pas vide",columnMenuLabel:"Menu",columnMenuShowColumns:"Afficher les colonnes",columnMenuFilter:"Filtrer",columnMenuHideColumn:"Cacher",columnMenuUnsort:"Annuler le tri",columnMenuSortAsc:"Tri ascendant",columnMenuSortDesc:"Tri descendant",columnHeaderFiltersTooltipActive:e=>e>1?`${e} filtres actifs`:`${e} filtre actif`,columnHeaderFiltersLabel:"Afficher les filtres",columnHeaderSortIconLabel:"Trier",footerRowSelected:e=>e>1?`${e.toLocaleString()} lignes sélectionnées`:`${e.toLocaleString()} ligne sélectionnée`,footerTotalRows:"Lignes totales :",footerTotalVisibleRows:(e,t)=>`${e.toLocaleString()} sur ${t.toLocaleString()}`,checkboxSelectionHeaderName:"Sélection"},frFR);ns({noRowsLabel:"Nessun record",noResultsOverlayLabel:"Nessun record trovato.",errorOverlayDefaultLabel:"Si è verificato un errore.",toolbarDensity:"Densità",toolbarDensityLabel:"Densità",toolbarDensityCompact:"Compact",toolbarDensityStandard:"Standard",toolbarDensityComfortable:"Confortable",toolbarColumns:"Colonne",toolbarColumnsLabel:"Seleziona le colonne",toolbarFilters:"Filtri",toolbarFiltersLabel:"Mostra i filtri",toolbarFiltersTooltipHide:"Nascondi i filtri",toolbarFiltersTooltipShow:"Mostra i filtri",toolbarFiltersTooltipActive:e=>e>1?`${e} filtri attivi`:`${e} filtro attivo`,columnsPanelTextFieldLabel:"Cerca colonna",columnsPanelTextFieldPlaceholder:"Titolo della colonna",columnsPanelDragIconLabel:"Riordina la colonna",columnsPanelShowAllButton:"Mostra tutto",columnsPanelHideAllButton:"Nascondi tutto",filterPanelAddFilter:"Aggiungi un filtro",filterPanelDeleteIconLabel:"Rimuovi",filterPanelOperators:"Operatori",filterPanelOperatorAnd:"E (and)",filterPanelOperatorOr:"O (or)",filterPanelColumns:"Colonne",filterPanelInputLabel:"Valore",filterPanelInputPlaceholder:"Filtra il valore",filterOperatorContains:"contiene",filterOperatorEquals:"uguale a",filterOperatorStartsWith:"comincia per",filterOperatorEndsWith:"termina per",filterOperatorIs:"uguale a",filterOperatorNot:"diversa da",filterOperatorOnOrAfter:"a partire dal",filterOperatorAfter:"dopo il",filterOperatorOnOrBefore:"fino al",filterOperatorBefore:"prima del",filterOperatorIsEmpty:"è vuoto",filterOperatorIsNotEmpty:"non è vuoto",columnMenuLabel:"Menu",columnMenuShowColumns:"Mostra le colonne",columnMenuFilter:"Filtra",columnMenuHideColumn:"Nascondi",columnMenuUnsort:"Annulla l'ordinamento",columnMenuSortAsc:"Ordinamento crescente",columnMenuSortDesc:"Ordinamento decrescente",columnHeaderFiltersTooltipActive:e=>e>1?`${e} filtri attivi`:`${e} filtro attivo`,columnHeaderFiltersLabel:"Mostra i filtri",columnHeaderSortIconLabel:"Ordina",footerRowSelected:e=>e>1?`${e.toLocaleString()} record selezionati`:`${e.toLocaleString()} record selezionato`,footerTotalRows:"Record totali :",footerTotalVisibleRows:(e,t)=>`${e.toLocaleString()} di ${t.toLocaleString()}`,checkboxSelectionHeaderName:"Seleziona"},itIT);ns({noRowsLabel:"行がありません",errorOverlayDefaultLabel:"エラーが発生しました。",toolbarDensity:"行間隔",toolbarDensityLabel:"行間隔",toolbarDensityCompact:"コンパクト",toolbarDensityStandard:"標準",toolbarDensityComfortable:"ひろめ",toolbarColumns:"列一覧",toolbarColumnsLabel:"列選択",toolbarFilters:"フィルター",toolbarFiltersLabel:"フィルター表示",toolbarFiltersTooltipHide:"フィルター非表示",toolbarFiltersTooltipShow:"フィルター表示",toolbarFiltersTooltipActive:e=>`${e}件のフィルターを適用中`,toolbarExport:"エクスポート",toolbarExportLabel:"エクスポート",toolbarExportCSV:"CSVダウンロード",columnsPanelTextFieldLabel:"列検索",columnsPanelTextFieldPlaceholder:"検索クエリを入力...",columnsPanelDragIconLabel:"列並べ替え",columnsPanelShowAllButton:"すべて表示",columnsPanelHideAllButton:"すべて非表示",filterPanelAddFilter:"フィルター追加",filterPanelDeleteIconLabel:"削除",filterPanelOperators:"オペレータ",filterPanelOperatorAnd:"And",filterPanelOperatorOr:"Or",filterPanelColumns:"列",filterPanelInputLabel:"値",filterPanelInputPlaceholder:"値を入力...",filterOperatorContains:"...を含む",filterOperatorEquals:"...に等しい",filterOperatorStartsWith:"...で始まる",filterOperatorEndsWith:"...で終わる",filterOperatorIs:"...である",filterOperatorNot:"...でない",filterOperatorAfter:"...より後ろ",filterOperatorOnOrAfter:"...以降",filterOperatorBefore:"...より前",filterOperatorOnOrBefore:"...以前",columnMenuLabel:"メニュー",columnMenuShowColumns:"列表示",columnMenuFilter:"フィルター",columnMenuHideColumn:"列非表示",columnMenuUnsort:"ソート解除",columnMenuSortAsc:"昇順ソート",columnMenuSortDesc:"降順ソート",columnHeaderFiltersTooltipActive:e=>`${e}件のフィルターを適用中`,columnHeaderFiltersLabel:"フィルター表示",columnHeaderSortIconLabel:"ソート",footerRowSelected:e=>`${e}行を選択中`,footerTotalRows:"総行数:"},jaJP);ns({noRowsLabel:"Geen resultaten.",errorOverlayDefaultLabel:"Er deed zich een fout voor.",toolbarDensity:"Grootte",toolbarDensityLabel:"Grootte",toolbarDensityCompact:"Compact",toolbarDensityStandard:"Normaal",toolbarDensityComfortable:"Breed",toolbarColumns:"Kolommen",toolbarColumnsLabel:"Kies kolommen",toolbarFilters:"Filters",toolbarFiltersLabel:"Toon filters",toolbarFiltersTooltipHide:"Verberg filters",toolbarFiltersTooltipShow:"Toon filters",toolbarFiltersTooltipActive:e=>e>1?`${e} actieve filters`:`${e} filter actief`,columnsPanelTextFieldLabel:"Zoek kolom",columnsPanelTextFieldPlaceholder:"Kolomtitel",columnsPanelDragIconLabel:"Kolom herschikken",columnsPanelShowAllButton:"Alles tonen",columnsPanelHideAllButton:"Alles verbergen",filterPanelAddFilter:"Filter toevoegen",filterPanelDeleteIconLabel:"Verwijderen",filterPanelOperators:"Operatoren",filterPanelOperatorAnd:"En",filterPanelOperatorOr:"Of",filterPanelColumns:"Kolommen",filterPanelInputLabel:"Waarde",filterPanelInputPlaceholder:"Filter waarde",filterOperatorContains:"bevat",filterOperatorEquals:"gelijk aan",filterOperatorStartsWith:"begint met",filterOperatorEndsWith:"eindigt met",filterOperatorIs:"is",filterOperatorNot:"is niet",filterOperatorOnOrAfter:"is gelijk of er voor",filterOperatorAfter:"is voor",filterOperatorOnOrBefore:"is gelijk of er na",filterOperatorBefore:"is na",columnMenuLabel:"Menu",columnMenuShowColumns:"Toon kolommen",columnMenuFilter:"Filteren",columnMenuHideColumn:"Verbergen",columnMenuUnsort:"Annuleer sortering",columnMenuSortAsc:"Oplopend sorteren",columnMenuSortDesc:"Aflopend sorteren",columnHeaderFiltersTooltipActive:e=>e>1?`${e} actieve filters`:`${e} filter actief`,columnHeaderFiltersLabel:"Toon filters",columnHeaderSortIconLabel:"Sorteren",footerRowSelected:e=>e>1?`${e.toLocaleString()} rijen geselecteerd`:`${e.toLocaleString()} rij geselecteerd`,footerTotalRows:"Totaal:"},nlNL);const bs={noRowsLabel:"Brak danych",errorOverlayDefaultLabel:"Wystąpił błąd.",toolbarDensity:"Wysokość rzędu",toolbarDensityLabel:"Wysokość rzędu",toolbarDensityCompact:"Kompakt",toolbarDensityStandard:"Standard",toolbarDensityComfortable:"Komfort",toolbarColumns:"Kolumny",toolbarColumnsLabel:"Zaznacz kolumny",toolbarFilters:"Filtry",toolbarFiltersLabel:"Pokaż filtry",toolbarFiltersTooltipHide:"Ukryj filtry",toolbarFiltersTooltipShow:"Pokaż filtry",toolbarFiltersTooltipActive:e=>`Liczba aktywnych filtrów: ${e}`,toolbarExport:"Eksportuj",toolbarExportLabel:"Eksportuj",toolbarExportCSV:"Pobierz jako plik CSV",columnsPanelTextFieldLabel:"Znajdź kolumnę",columnsPanelTextFieldPlaceholder:"Tytuł kolumny",columnsPanelDragIconLabel:"Zmień kolejność kolumn",columnsPanelShowAllButton:"Pokaż wszystko",columnsPanelHideAllButton:"Ukryj wszystko",filterPanelAddFilter:"Dodaj filtr",filterPanelDeleteIconLabel:"Usuń",filterPanelOperators:"Operator",filterPanelOperatorAnd:"I",filterPanelOperatorOr:"Lub",filterPanelColumns:"Kolumny",filterPanelInputLabel:"Wartość",filterPanelInputPlaceholder:"Filtrowana wartość",filterOperatorContains:"zawiera",filterOperatorEquals:"równa się",filterOperatorStartsWith:"zaczyna się od",filterOperatorEndsWith:"kończy się na",filterOperatorIs:"równa się",filterOperatorNot:"różne",filterOperatorAfter:"większe niż",filterOperatorOnOrAfter:"większe lub równe",filterOperatorBefore:"mniejsze niż",filterOperatorOnOrBefore:"mniejsze lub równe",columnMenuLabel:"Menu",columnMenuShowColumns:"Pokaż wszystkie kolumny",columnMenuFilter:"Filtr",columnMenuHideColumn:"Ukryj",columnMenuUnsort:"Anuluj sortowanie",columnMenuSortAsc:"Sortuj rosnąco",columnMenuSortDesc:"Sortuj malejąco",columnHeaderFiltersTooltipActive:e=>`Liczba aktywnych filtrów: ${e}`,columnHeaderFiltersLabel:"Pokaż filtry",columnHeaderSortIconLabel:"Sortuj",footerRowSelected:e=>`Liczba wybranych wierszy: ${e.toLocaleString()}`,footerTotalRows:"Łączna liczba wierszy:"};ns(bs,plPL);ns({noRowsLabel:"Nenhuma linha",noResultsOverlayLabel:"Nenhum resultado encontrado.",errorOverlayDefaultLabel:"Ocorreu um erro.",toolbarDensity:"Densidade",toolbarDensityLabel:"Densidade",toolbarDensityCompact:"Compacto",toolbarDensityStandard:"Padrão",toolbarDensityComfortable:"Confortável",toolbarColumns:"Colunas",toolbarColumnsLabel:"Exibir seletor de colunas",toolbarFilters:"Filtros",toolbarFiltersLabel:"Exibir filtros",toolbarFiltersTooltipHide:"Ocultar filtros",toolbarFiltersTooltipShow:"Exibir filtros",toolbarFiltersTooltipActive:e=>`${e} ${1!==e?"filtros":"filtro"} ${1!==e?"ativos":"ativo"}`,toolbarExport:"Exportar",toolbarExportLabel:"Exportar",toolbarExportCSV:"Baixar como CSV",columnsPanelTextFieldLabel:"Localizar coluna",columnsPanelTextFieldPlaceholder:"Título da coluna",columnsPanelDragIconLabel:"Reordenar Coluna",columnsPanelShowAllButton:"Mostrar todas",columnsPanelHideAllButton:"Ocultar todas",filterPanelAddFilter:"Adicionar filtro",filterPanelDeleteIconLabel:"Excluir",filterPanelOperators:"Operadores",filterPanelOperatorAnd:"E",filterPanelOperatorOr:"Ou",filterPanelColumns:"Colunas",filterPanelInputLabel:"Valor",filterPanelInputPlaceholder:"Filtrar valor",filterOperatorContains:"contém",filterOperatorEquals:"é igual a",filterOperatorStartsWith:"começa com",filterOperatorEndsWith:"termina com",filterOperatorIs:"é",filterOperatorNot:"não é",filterOperatorOnOrAfter:"em ou após",filterOperatorBefore:"antes de",filterOperatorOnOrBefore:"em ou antes de",filterOperatorAfter:"após",filterOperatorIsEmpty:"está vazio",filterOperatorIsNotEmpty:"não está vazio",columnMenuLabel:"Menu",columnMenuShowColumns:"Exibir colunas",columnMenuFilter:"Filtrar",columnMenuHideColumn:"Ocultar",columnMenuUnsort:"Desfazer ordenação",columnMenuSortAsc:"Ordenar do menor para o maior",columnMenuSortDesc:"Ordenar do maior para o menor",columnHeaderFiltersTooltipActive:e=>`${e} ${1!==e?"filtros":"filtro"} ${1!==e?"ativos":"ativo"}`,columnHeaderFiltersLabel:"Exibir Filtros",columnHeaderSortIconLabel:"Ordenar",footerRowSelected:e=>1!==e?`${e.toLocaleString()} linhas selecionadas`:`${e.toLocaleString()} linha selecionada`,footerTotalRows:"Total de linhas:",footerTotalVisibleRows:(e,t)=>`${e.toLocaleString()} de ${t.toLocaleString()}`,checkboxSelectionHeaderName:"Seleção",booleanCellTrueLabel:"sim",booleanCellFalseLabel:"não"},ptBR);const Cs={noRowsLabel:"Нет строк",errorOverlayDefaultLabel:"Обнаружена ошибка.",toolbarDensity:"Высота строки",toolbarDensityLabel:"Высота строки",toolbarDensityCompact:"Компактная",toolbarDensityStandard:"Стандартная",toolbarDensityComfortable:"Комфортная",toolbarColumns:"Столбцы",toolbarColumnsLabel:"Выделите столбцы",toolbarFilters:"Фильтры",toolbarFiltersLabel:"Показать фильтры",toolbarFiltersTooltipHide:"Скрыть фильтры",toolbarFiltersTooltipShow:"Показать фильтры",toolbarFiltersTooltipActive:e=>{let t="активных фильтров";const r=e%10;return r>1&&r<5?t="активных фильтра":1===r&&(t="активный фильтр"),`${e} ${t}`},toolbarExport:"Экспорт",toolbarExportLabel:"Экспорт",toolbarExportCSV:"Скачать в формате CSV",columnsPanelTextFieldLabel:"Найти столбец",columnsPanelTextFieldPlaceholder:"Заголовок столбца",columnsPanelDragIconLabel:"Изменить порядок столбца",columnsPanelShowAllButton:"Показать все",columnsPanelHideAllButton:"Скрыть все",filterPanelAddFilter:"Добавить фильтр",filterPanelDeleteIconLabel:"Удалить",filterPanelOperators:"Операторы",filterPanelOperatorAnd:"И",filterPanelOperatorOr:"Или",filterPanelColumns:"Столбцы",filterPanelInputLabel:"Значение",filterPanelInputPlaceholder:"Значение фильтра",filterOperatorContains:"содержит",filterOperatorEquals:"равен",filterOperatorStartsWith:"начинается с",filterOperatorEndsWith:"заканчивается на",filterOperatorIs:"равен",filterOperatorNot:"не равен",filterOperatorAfter:"больше чем",filterOperatorOnOrAfter:"больше или равно",filterOperatorBefore:"меньше чем",filterOperatorOnOrBefore:"меньше или равно",filterValueAny:"любой",filterValueTrue:"истина",filterValueFalse:"ложь",columnMenuLabel:"Меню",columnMenuShowColumns:"Показать столбцы",columnMenuFilter:"Фильтр",columnMenuHideColumn:"Скрыть",columnMenuUnsort:"Отменить сортировку",columnMenuSortAsc:"Сортировать по возрастанию",columnMenuSortDesc:"Сортировать по убыванию",columnHeaderFiltersTooltipActive:e=>{let t="активных фильтров";const r=e%10;return r>1&&r<5?t="активных фильтра":1===r&&(t="активный фильтр"),`${e} ${t}`},columnHeaderFiltersLabel:"Показать фильтры",columnHeaderSortIconLabel:"Сортировать",footerRowSelected:e=>{let t="строк выбрано";const r=e%10;return r>1&&r<5?t="строки выбраны":1===r&&(t="строка выбрана"),`${e} ${t}`},footerTotalRows:"Всего строк:",checkboxSelectionHeaderName:"Выбор флажка",booleanCellTrueLabel:"истина",booleanCellFalseLabel:"ложь"};ns(Cs,ruRU);const Os={noRowsLabel:"Žiadne záznamy",noResultsOverlayLabel:"Nenašli sa žadne výsledky.",errorOverlayDefaultLabel:"Stala sa nepredvídaná chyba.",toolbarDensity:"Hustota",toolbarDensityLabel:"Hustota",toolbarDensityCompact:"Kompaktná",toolbarDensityStandard:"Štandartná",toolbarDensityComfortable:"Komfortná",toolbarColumns:"Stĺpce",toolbarColumnsLabel:"Vybrať stĺpce",toolbarFilters:"Filtre",toolbarFiltersLabel:"Zobraziť filtre",toolbarFiltersTooltipHide:"Skryť filtre ",toolbarFiltersTooltipShow:"Zobraziť filtre",toolbarFiltersTooltipActive:e=>{let t="aktívnych filtrov";return e>1&&e<5?t="aktívne filtre":1===e&&(t="aktívny filter"),`${e} ${t}`},toolbarExport:"Export",toolbarExportLabel:"Export",toolbarExportCSV:"Stiahnuť ako CSV",columnsPanelTextFieldLabel:"Nájsť stĺpec",columnsPanelTextFieldPlaceholder:"Názov stĺpca",columnsPanelDragIconLabel:"Usporiadť stĺpce",columnsPanelShowAllButton:"Zobraziť všetko",columnsPanelHideAllButton:"Skryť všetko",filterPanelAddFilter:"Pridať filter",filterPanelDeleteIconLabel:"Odstrániť",filterPanelOperators:"Operátory",filterPanelOperatorAnd:"A",filterPanelOperatorOr:"Alebo",filterPanelColumns:"Stĺpce",filterPanelInputLabel:"Hodnota",filterPanelInputPlaceholder:"Hodnota filtra",filterOperatorContains:"obsahuje",filterOperatorEquals:"rovná sa",filterOperatorStartsWith:"začína s",filterOperatorEndsWith:"končí na",filterOperatorIs:"je",filterOperatorNot:"nie je",filterOperatorAfter:"je po",filterOperatorOnOrAfter:"je na alebo po",filterOperatorBefore:"je pred",filterOperatorOnOrBefore:"je na alebo skôr",filterValueAny:"akýkoľvek",filterValueTrue:"áno",filterValueFalse:"nie",columnMenuLabel:"Menu",columnMenuShowColumns:"Zobraziť stĺpce",columnMenuFilter:"Filter",columnMenuHideColumn:"Skryť",columnMenuUnsort:"Zrušiť filtre",columnMenuSortAsc:"Zoradiť vzostupne",columnMenuSortDesc:"Zoradiť zostupne",columnHeaderFiltersTooltipActive:e=>{let t="aktívnych filtrov";return e>1&&e<5?t="aktívne filtre":1===e&&(t="aktívny filter"),`${e} ${t}`},columnHeaderFiltersLabel:"Zobraziť filtre",columnHeaderSortIconLabel:"Filtrovať",footerRowSelected:e=>{let t="vybraných záznamov";return e>1&&e<5?t="vybrané záznamy":1===e&&(t="vybraný záznam"),`${e} ${t}`},footerTotalRows:"Riadkov spolu:",checkboxSelectionHeaderName:"Výber riadku",booleanCellTrueLabel:"áno",booleanCellFalseLabel:"nie"};ns(Os,skSK);ns({noRowsLabel:"Satır yok",errorOverlayDefaultLabel:"Bir hata oluştu.",toolbarDensity:"Yoğunluk",toolbarDensityLabel:"Yoğunluk",toolbarDensityCompact:"Sıkı",toolbarDensityStandard:"Standart",toolbarDensityComfortable:"Rahat",toolbarColumns:"Sütunlar",toolbarColumnsLabel:"Sütun seç",toolbarFilters:"Filtreler",toolbarFiltersLabel:"Filtreleri göster",toolbarFiltersTooltipHide:"Filtreleri gizle",toolbarFiltersTooltipShow:"Filtreleri göster",toolbarFiltersTooltipActive:e=>`${e} aktif filtre`,toolbarExport:"Dışa aktar",toolbarExportLabel:"Dışa aktar",toolbarExportCSV:"CSV olarak aktar",columnsPanelTextFieldLabel:"Sütun ara",columnsPanelTextFieldPlaceholder:"Sütun adı",columnsPanelDragIconLabel:"Sütunları yeniden sırala",columnsPanelShowAllButton:"Hepsini göster",columnsPanelHideAllButton:"Hepsini gizle",filterPanelAddFilter:"Filtre Ekle",filterPanelDeleteIconLabel:"Kaldır",filterPanelOperators:"Operatör",filterPanelOperatorAnd:"Ve",filterPanelOperatorOr:"Veya",filterPanelColumns:"Sütunlar",filterPanelInputLabel:"Değer",filterPanelInputPlaceholder:"Filtre değeri",filterOperatorContains:"içerir",filterOperatorEquals:"eşittir",filterOperatorStartsWith:"ile başlar",filterOperatorEndsWith:"ile biter",filterOperatorIs:"eşittir",filterOperatorNot:"eşit değildir",filterOperatorAfter:"büyük",filterOperatorOnOrAfter:"büyük eşit",filterOperatorBefore:"küçük",filterOperatorOnOrBefore:"küçük eşit",filterOperatorIsEmpty:"boş",filterOperatorIsNotEmpty:"dolu",columnMenuLabel:"Menü",columnMenuShowColumns:"Sütunları göster",columnMenuFilter:"Filtre uygula",columnMenuHideColumn:"Gizle",columnMenuUnsort:"Sıralama",columnMenuSortAsc:"Sırala - Artan",columnMenuSortDesc:"Sırala - Azalan",columnHeaderFiltersTooltipActive:e=>`${e} filtre aktif`,columnHeaderFiltersLabel:"Filtreleri göster",columnHeaderSortIconLabel:"Sırala",footerRowSelected:e=>`${e.toLocaleString()} satır seçildi`,footerTotalRows:"Toplam Satır:",footerTotalVisibleRows:(e,t)=>`${e.toLocaleString()} / ${t.toLocaleString()}`},trTR);const Ss={noRowsLabel:"Немає рядків",errorOverlayDefaultLabel:"Виявлено помилку.",toolbarDensity:"Висота рядка",toolbarDensityLabel:"Висота рядка",toolbarDensityCompact:"Компактний",toolbarDensityStandard:"Стандартний",toolbarDensityComfortable:"Комфортний",toolbarColumns:"Стовпці",toolbarColumnsLabel:"Виділіть стовпці",toolbarFilters:"Фільтри",toolbarFiltersLabel:"Показати фільтри",toolbarFiltersTooltipHide:"Сховати фільтри",toolbarFiltersTooltipShow:"Показати фільтри",toolbarFiltersTooltipActive:e=>1!==e?`${e} активні фільтри`:`${e} активний фільтр`,toolbarExport:"Експорт",toolbarExportLabel:"Експорт",toolbarExportCSV:"Завантажити у форматі CSV",columnsPanelTextFieldLabel:"Знайти стовпець",columnsPanelTextFieldPlaceholder:"Заголовок стовпця",columnsPanelDragIconLabel:"Змінити порядок стовпця",columnsPanelShowAllButton:"Показати усі",columnsPanelHideAllButton:"Сховати усі",filterPanelAddFilter:"Додати фільтр",filterPanelDeleteIconLabel:"Видалити",filterPanelOperators:"Оператори",filterPanelOperatorAnd:"І",filterPanelOperatorOr:"Або",filterPanelColumns:"Стовпці",filterPanelInputLabel:"Значення",filterPanelInputPlaceholder:"Значення фільтра",filterOperatorContains:"містить",filterOperatorEquals:"дорівнює",filterOperatorStartsWith:"починається з",filterOperatorEndsWith:"закінчується на",filterOperatorIs:"дорівнює",filterOperatorNot:"не",filterOperatorAfter:"більше ніж",filterOperatorOnOrAfter:"більше або дорівнює",filterOperatorBefore:"менше ніж",filterOperatorOnOrBefore:"менше або дорівнює",filterValueAny:"будь-який",filterValueTrue:"правда",filterValueFalse:"помилковий",columnMenuLabel:"Меню",columnMenuShowColumns:"Показати стовпці",columnMenuFilter:"Фільтр",columnMenuHideColumn:"Сховати",columnMenuUnsort:"Скасувати сортування",columnMenuSortAsc:"Сортувати за зростанням",columnMenuSortDesc:"Сортувати за спаданням",columnHeaderFiltersTooltipActive:e=>1!==e?`${e} активні фільтри`:`${e} активний фільтр`,columnHeaderFiltersLabel:"Показати фільтри",columnHeaderSortIconLabel:"Сортувати",footerRowSelected:e=>1!==e?`${e.toLocaleString()} вибрані рядки`:`${e.toLocaleString()} вибраний рядок`,footerTotalRows:"Всього рядків:",checkboxSelectionHeaderName:"Вибір прапорця",booleanCellTrueLabel:"правда",booleanCellFalseLabel:"помилковий"};ns(Ss,ukUA);const ks={apiRef:chainPropTypes(PropTypes.any,(e=>null!=e.apiRef?new Error(["Material-UI: `apiRef` is not a valid prop.","GridApiRef is not available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),checkboxSelectionVisibleOnly:chainPropTypes(PropTypes.bool,(e=>!0===e.checkboxSelectionVisibleOnly?new Error(["Material-UI: `<DataGrid checkboxSelectionVisibleOnly={true} />` is not a valid prop.","Selecting all columns only on the current page is not available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),columns:chainPropTypes(PropTypes.array.isRequired,(e=>e.columns&&e.columns.some((e=>e.resizable))?new Error(["Material-UI: `column.resizable = true` is not a valid prop.","Column resizing is not available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),disableColumnReorder:chainPropTypes(PropTypes.bool,(e=>!1===e.disableColumnReorder?new Error(["Material-UI: `<DataGrid disableColumnReorder={false} />` is not a valid prop.","Column reordering is not available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),disableColumnResize:chainPropTypes(PropTypes.bool,(e=>!1===e.disableColumnResize?new Error(["Material-UI: `<DataGrid disableColumnResize={false} />` is not a valid prop.","Column resizing is not available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),disableMultipleColumnsFiltering:chainPropTypes(PropTypes.bool,(e=>!1===e.disableMultipleColumnsFiltering?new Error(["Material-UI: `<DataGrid disableMultipleColumnsFiltering={false} />` is not a valid prop.","Only single column sorting is available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),disableMultipleColumnsSorting:chainPropTypes(PropTypes.bool,(e=>!1===e.disableMultipleColumnsSorting?new Error(["Material-UI: `<DataGrid disableMultipleColumnsSorting={false} />` is not a valid prop.","Only single column sorting is available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),disableMultipleSelection:chainPropTypes(PropTypes.bool,(e=>!1===e.disableMultipleSelection?new Error(["Material-UI: `<DataGrid disableMultipleSelection={false} />` is not a valid prop.","Only single column selection is available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),filterModel:chainPropTypes(PropTypes.any,(e=>null!=e.filterModel&&e.filterModel.items.length>1?new Error(["Material-UI: `<DataGrid filterModel={model} />` is not a valid prop. `model.items` has more than 1 item.","Only single filter is available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),onRowsScrollEnd:chainPropTypes(PropTypes.any,(e=>null!=e.onRowsScrollEnd?new Error(["Material-UI: `onRowsScrollEnd` is not a valid prop.","onRowsScrollEnd is not available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),onViewportRowsChange:chainPropTypes(PropTypes.any,(e=>null!=e.onViewportRowsChange?new Error(["Material-UI: `onViewportRowsChange` is not a valid prop.","onViewportRowsChange is not available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),pageSize:chainPropTypes(PropTypes.number,(e=>e.pageSize&&e.pageSize>100?new Error([`Material-UI: \`<DataGrid pageSize={${e.pageSize}} />\` is not a valid prop.`,"Only page size below 100 is available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),pagination:e=>!1===e.pagination?new Error(["Material-UI: `<DataGrid pagination={false} />` is not a valid prop.","Infinite scrolling is not available in the MIT version.","","You need to upgrade to the XGrid component to disable the pagination."].join("\n")):null,rows:PropTypes.array.isRequired,scrollEndThreshold:chainPropTypes(PropTypes.number,(e=>e.scrollEndThreshold?new Error([`Material-UI: \`<DataGrid scrollEndThreshold={${e.scrollEndThreshold}} />\` is not a valid prop.`,"scrollEndThreshold is not available in the MIT version.","","You need to upgrade to the XGrid component to unlock this feature."].join("\n")):null)),selectionModel:chainPropTypes(PropTypes.oneOfType([PropTypes.number,PropTypes.string,PropTypes.array]),(e=>!e.checkboxSelection&&Array.isArray(e.selectionModel)&&e.selectionModel.length>1?new Error([`Material-UI: \`<DataGrid selectionModel={${JSON.stringify(e.selectionModel)}} />\` is not a valid prop.`,"selectionModel can only be of 1 item in DataGrid.","","You need to upgrade to the XGrid component to unlock multiple selection."].join("\n")):null))},Ds=({apiRef:t,props:r,children:l})=>React.createElement(un.Provider,{value:r},React.createElement(oe.Provider,{value:t},l)),Rs=(e,t)=>{if("string"==typeof e){const r=e.replace(/"/g,'""');return r.includes(t)?`"${r}"`:r}return e};function Is(e){const{columns:t,rows:r,selectedRowIds:l,getCellParams:n,delimiterCharacter:o,includeHeaders:a=!0}=e;let i=[...r.keys()];l.length&&(i=i.filter((e=>l.includes(e))));const s=i.reduce(((e,r)=>`${e}${function(e,t,r,l){const n=[];return t.forEach((t=>t.field!==lo.field&&n.push(Rs(r(e,t.field).formattedValue,l)))),n}(r,t,n,o).join(o)}\r\n`),"").trim();if(!a)return s;return `${`${t.filter((e=>e.field!==lo.field)).map((e=>Rs(e.headerName||e.field,o))).join(o)}\r\n`}${s}`.trim()}function Ps(e){const t=document.createElement("span");t.style.whiteSpace="pre",t.style.userSelect="all",t.style.opacity="0px",t.textContent=e,document.body.appendChild(t);const r=document.createRange();r.selectNode(t);const l=window.getSelection();l.removeAllRanges(),l.addRange(r);try{document.execCommand("copy");}finally{document.body.removeChild(t);}}const Ls=t=>{const r=Ar("useGridCsvExport"),l=ll(t,de),n=ll(t,ue),o=ll(t,Dl),a=ll(t,bn),i=React.useCallback((e=>{let i;if(r.debug("Get data as CSV"),null==e?void 0:e.fields)i=e.fields.map((e=>n.find((t=>t.field===e)))).filter((e=>!!e));else {i=((null==e?void 0:e.allColumns)?n:l).filter((e=>!e.disableExport));}return Is({columns:i,rows:o,selectedRowIds:a,getCellParams:t.current.getCellParams,delimiterCharacter:(null==e?void 0:e.delimiter)||","})}),[r,l,n,o,a,t]),s=React.useCallback((e=>{r.debug("Export data as CSV");const t=i(e);!function(e,t="csv",r=document.title){const l=`${r}.${t}`;if("download"in HTMLAnchorElement.prototype){const t=URL.createObjectURL(e),r=document.createElement("a");return r.href=t,r.download=l,r.click(),void setTimeout((()=>{URL.revokeObjectURL(t);}))}throw new Error("exportAs not supported")}(new Blob([(null==e?void 0:e.utf8WithBom)?new Uint8Array([239,187,191]):"",t],{type:"text/csv"}),"csv",null==e?void 0:e.fileName);}),[r,i]);_r(t,{getDataAsCsv:i,exportDataAsCsv:s},"GridCsvExportApi");};function Fs(e,t){switch(t.type){case"options::UPDATE":return hi(e,t.payload);default:throw new Error(`Material-UI: Action ${t.type} not found.`)}}const js$1="test"===process.env.NODE_ENV;const zs=(t,r)=>{Hr(0,r),pi$2(t,r),function(t,r){const[,l]=rl(t),n=React.useCallback((e=>{l((t=>Object.assign(Object.assign({},t),{error:e})));}),[l]);React.useEffect((()=>{n(r.error);}),[n,r.error]),cl(t,ne.componentError,n);}(t,r),yi(t,r),function(t,{scrollbarSize:r}){const l=Ar("useGridScrollbarSizeDetector"),[n,o]=React.useState(0),[,a]=rl(t),i=ll(t,ue).length>0,s=React.useCallback((()=>{var e,r;let n=0;(null===(r=null===(e=t.current)||void 0===e?void 0:e.rootElementRef)||void 0===r?void 0:r.current)&&(n=function(e,t){const r=e.createElement("div");r.style.width="99px",r.style.height="99px",r.style.position="absolute",r.style.overflow="scroll",r.className="scrollDiv",t.appendChild(r);const l=r.offsetWidth-r.clientWidth;return t.removeChild(r),l}(ownerDocument(t.current.rootElementRef.current),t.current.rootElementRef.current),l.debug(`Detected scroll bar size ${n}.`)),o(n);}),[t,l]);vr((()=>{i&&null==r&&s();}),[s,i,r]),React.useEffect((()=>{null==r&&a((e=>Object.assign(Object.assign({},e),{options:Object.assign(Object.assign({},e.options),{scrollbarSize:n})})));}),[r,n,a]);}(t,r),function(t,r){const l=Ar("useOptionsProp"),n=React.useMemo((()=>Object.assign(Object.assign({},r),{classes:Cr({root:["root"],columnHeader:["columnHeader"],row:["row"],cell:["cell"]},Dr,r.classes),localeText:Object.assign(Object.assign({},Nr),r.localeText)})),[r]),{gridState:o,dispatch:a}=Ei(t,"options",Fs,Object.assign({},Wr)),i=React.useCallback((e=>{l.debug("updating options state."),a({type:"options::UPDATE",payload:e});}),[a,l]);React.useEffect((()=>{i(n);}),[n,i]),o.options;}(t,r),function(e,t){dl(e,ne.columnHeaderClick,t.onColumnHeaderClick),dl(e,ne.columnHeaderDoubleClick,t.onColumnHeaderDoubleClick),dl(e,ne.columnHeaderOver,t.onColumnHeaderOver),dl(e,ne.columnHeaderOut,t.onColumnHeaderOut),dl(e,ne.columnHeaderEnter,t.onColumnHeaderEnter),dl(e,ne.columnHeaderLeave,t.onColumnHeaderLeave),dl(e,ne.columnOrderChange,t.onColumnOrderChange),dl(e,ne.cellClick,t.onCellClick),dl(e,ne.cellDoubleClick,t.onCellDoubleClick),dl(e,ne.cellOver,t.onCellOver),dl(e,ne.cellOut,t.onCellOut),dl(e,ne.cellEnter,t.onCellEnter),dl(e,ne.cellLeave,t.onCellLeave),dl(e,ne.cellKeyDown,t.onCellKeyDown),dl(e,ne.cellBlur,t.onCellBlur),dl(e,ne.cellFocusOut,t.onCellFocusOut),dl(e,ne.rowDoubleClick,t.onRowDoubleClick),dl(e,ne.rowClick,t.onRowClick),dl(e,ne.rowOver,t.onRowOver),dl(e,ne.rowOut,t.onRowOut),dl(e,ne.rowEnter,t.onRowEnter),dl(e,ne.rowLeave,t.onRowLeave),dl(e,ne.componentError,t.onError),dl(e,ne.stateChange,t.onStateChange);}(t,r),(t=>{const{localeText:r}=ll(t,il);_r(t,{getLocaleText:React.useCallback((e=>{if(null==r[e])throw new Error(`Missing translation for key ${e}.`);return r[e]}),[r])},"LocaleTextApi");})(t),function(t,r){const l=Ar("useResizeContainer"),n=React.useRef(!1),o=React.useCallback((()=>{var e;l.debug("resizing..."),t.current.publishEvent(ne.debouncedResize,{containerSize:null===(e=t.current.state.containerSizes)||void 0===e?void 0:e.windowSizes});}),[t,l]);_r(t,{resize:o},"GridEventsApi");const a=React.useMemo((()=>debounce$2(o,60)),[o]),i=React.useCallback((e=>{const t=/jsdom/.test(window.navigator.userAgent);0!==e.height||n.current||r.autoHeight||t||(l.warn(["The parent of the grid has an empty height.","You need to make sure the container has an intrinsic height.","The grid displays with a height of 0px.","","You can find a solution in the docs:","https://material-ui.com/components/data-grid/layout/"].join("\n")),n.current=!0),0!==e.width||n.current||t||(l.warn(["The parent of the grid has an empty width.","You need to make sure the container has an intrinsic width.","The grid displays with a width of 0px.","","You can find a solution in the docs:","https://material-ui.com/components/data-grid/layout/"].join("\n")),n.current=!0),js$1?o():a();}),[r.autoHeight,a,l,o]);React.useEffect((()=>()=>{l.info("canceling resize..."),a.clear();}),[l,a]),React.useEffect((()=>{l.info("canceling resize..."),a.clear();}),[r.rows,a,l]),cl(t,ne.resize,i),dl(t,ne.debouncedResize,r.onResize);}(t,r),function(e,{rows:t}){"production"!==process.env.NODE_ENV&&Object.freeze(t);}(0,r),Oi(t,r),zi(t),_i(t,r),Gi(t,r),Mi(t,r),xi(t),ki(t,r),Ni(t,r),$i(t,r),gi(t),Fi(t),Si(t,r),mi(t),((t,r)=>{const l=Ar("useDensity"),[,n,o]=rl(t),a=React.useCallback(((e,t,r)=>{switch(e){case $r.Compact:return {value:e,headerHeight:Math.floor(.7*t),rowHeight:Math.floor(.7*r)};case $r.Comfortable:return {value:e,headerHeight:Math.floor(1.3*t),rowHeight:Math.floor(1.3*r)};default:return {value:e,headerHeight:t,rowHeight:r}}}),[]),i=React.useCallback(((e,t=r.headerHeight,i=r.rowHeight)=>{l.debug(`Set grid density to ${e}`),n((r=>Object.assign(Object.assign({},r),{density:Object.assign(Object.assign({},r.density),a(e,t,i))}))),o();}),[l,n,o,a,r.headerHeight,r.rowHeight]);React.useEffect((()=>{i(r.density,r.headerHeight,r.rowHeight);}),[i,r.density,r.rowHeight,r.headerHeight]),_r(t,{setDensity:i},"GridDensityApi");})(t,r),Wi(t),Yi(t,r),Li(t,r),Pi(t,r),Ls(t),((t,r)=>{const l=ll(t,Yo),n=ll(t,de),o=React.useRef(!1),a=ll(t,nl),i=React.useRef(null),s=React.useCallback((e=>{if(!l)return;const a=e.top+l.windowSizes.height+r.scrollEndThreshold;if(a<l.dataContainerSizes.height&&(o.current=!1),a>=l.dataContainerSizes.height&&!o.current){const e={api:t,visibleColumns:n,viewportPageSize:l.viewportPageSize,virtualRowsCount:l.virtualRowsCount};t.current.publishEvent(ne.rowsScrollEnd,e),o.current=!0;}}),[t,r.scrollEndThreshold,n,l]),c=React.useCallback((()=>{const e=t.current.getScrollPosition();s(e);}),[t,s]);React.useEffect((()=>{const e=a.renderContext;if(e){if(!i.current||e.firstRowIdx!==i.current.firstRowIndex||e.lastRowIdx!==i.current.lastRowIndex){const r={firstRowIndex:e.firstRowIdx,lastRowIndex:e.lastRowIdx};t.current.publishEvent(ne.viewportRowsChange,r);}i.current={firstRowIndex:e.firstRowIdx,lastRowIndex:e.lastRowIdx};}}),[t,r.onViewportRowsChange,a]),cl(t,ne.rowsScroll,c),dl(t,ne.rowsScrollEnd,r.onRowsScrollEnd),dl(t,ne.viewportRowsChange,r.onViewportRowsChange);})(t,r),(t=>{const r=ll(t,de),l=React.useCallback(((e=!1)=>{const l=t.current.getSelectedRows(),n=r.filter((e=>e.field!==lo.field));if(0===l.size||0===n.length)return;const o=Is({columns:r,rows:l,selectedRowIds:[],includeHeaders:e,getCellParams:t.current.getCellParams,delimiterCharacter:"\t"});navigator.clipboard?navigator.clipboard.writeText(o).catch((()=>{Ps(o);})):Ps(o);}),[t,r]),n=React.useCallback((e=>{var r;const l=e.ctrlKey||e.metaKey||e.altKey;"c"===e.key.toLowerCase()&&l&&""===(null===(r=window.getSelection())||void 0===r?void 0:r.toString())&&t.current.copySelectedRowsToClipboard(e.altKey);}),[t]);fi(t,t.current.rootElementRef,"keydown",n),_r(t,{copySelectedRowsToClipboard:l},"GridClipboardApi");})(t),rs(t,r),function(t,{state:r}){const[,l,n]=rl(t),o=Ar("useStateProp");React.useEffect((()=>{null!=r&&t.current.state!==r&&(o.debug("Overriding state with props.state"),l((e=>Object.assign(Object.assign({},e),r))),n());}),[t,n,o,r,l]);}(t,r),function(e){const[t]=rl(e),r=Ar("useRenderInfoLog");if(null!=t.rendering.renderContext){const{page:e,firstColIdx:l,lastColIdx:n,firstRowIdx:o,lastRowIdx:a}=t.rendering.renderContext;r.info(`Rendering, page: ${e}, col: ${l}-${n}, row: ${o}-${a}`);}}(t);},Ts={apiRef:void 0,disableColumnResize:!0,disableColumnReorder:!0,disableMultipleColumnsFiltering:!0,disableMultipleColumnsSorting:!0,disableMultipleSelection:!0,pagination:!0,onRowsScrollEnd:void 0,onViewportRowsChange:void 0,checkboxSelectionVisibleOnly:!1,signature:"DataGrid"},Hs=t=>{if(t.pageSize>100)throw new Error("'props.pageSize' cannot exceed 100 in DataGrid.");const r=function({props:t,name:r}){const l=useTheme$2();return React.useMemo((()=>{const e=Object.assign({},t),n=getThemeProps({theme:l,name:r,props:e}),o=n.theme||l,a="rtl"===o.direction;return Object.assign({theme:o,isRtl:a},n)}),[t,r,l])}({props:t,name:"MuiDataGrid"});return React.useMemo((()=>Object.assign(Object.assign({},r),Ts)),[r])},As=React.forwardRef((function(t,r){const l=Hs(t),n=Ki();return zs(n,l),React.createElement(Ds,{apiRef:n,props:l},React.createElement(Sa,{ref:r},React.createElement(wa,null,React.createElement(ya,null),React.createElement(va,null),React.createElement(Oa,null))))}));As.defaultProps=Br;const _s=React.memo(As);_s.propTypes=ks;

var AccessAlarmSharp = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
}), 'AccessAlarmSharp');

var AddIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');

var ArrowBack = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
}), 'ArrowBack');

var ArrowBackIosIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11.67 3.87L9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"
}), 'ArrowBackIos');

var ArrowDownward = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');

var ArrowDropDownIcon$1 = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

var ArrowDropUpIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7 14l5-5 5 5z"
}), 'ArrowDropUp');

var ArrowForwardIos = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"
}), 'ArrowForwardIos');

var ArrowLeftIcon$1 = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14 7l-5 5 5 5V7z"
}), 'ArrowLeft');

var ArrowRightIcon$1 = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 17l5-5-5-5v10z"
}), 'ArrowRight');

var ArrowRightAlt = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16.01 11H4v2h12.01v3L20 12l-3.99-4z"
}), 'ArrowRightAlt');

var ArrowUpward = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');

var CheckIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');

var CheckCircleOutline = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 7.58L10 14.17l-3.59-3.58L5 12l5 5 8-8zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'CheckCircleOutline');

var ChevronRight = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');

var CloseIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

var CreateIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Create');

var CropSquare = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
}), 'CropSquare');

var DeleteOutlineIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"
}), 'DeleteOutline');

var Error$1 = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
}), 'Error');

var ErrorOutlinedIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutlineOutlined');

var ErrorOutlineRoundedIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z"
}), 'ErrorOutlineRounded');

var ExpandLess = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');

var ExpandMore = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

var FiberManualRecordIcon = createSvgIcon( /*#__PURE__*/React.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "8"
}), 'FiberManualRecord');

var Group = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
}), 'Group');

var HelpOutline = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
}), 'HelpOutline');

var HelpOutlineSharpIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
}), 'HelpOutlineSharp');

var HighlightOff = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
}), 'HighlightOff');

var Info = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
}), 'Info');

var KeyboardArrowDown = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDown');

var KeyboardArrowUp = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
}), 'KeyboardArrowUp');

var Language = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
}), 'Language');

var LinkIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
}), 'Link');

var Maximize = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M3 3h18v2H3z"
}), 'Maximize');

var MoreVertOutlinedIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVertOutlined');

var PlayArrow = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M8 5v14l11-7z"
}), 'PlayArrow');

var Replay = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
}), 'Replay');

var SearchIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

var SentimentVeryDissatisfied = createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
  cx: "15.5",
  cy: "9.5",
  r: "1.5"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "8.5",
  cy: "9.5",
  r: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"
})), 'SentimentVeryDissatisfied');

var Timer = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
}), 'Timer');

var Visibility = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), 'Visibility');

var VisibilityOff = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');

var ZoomIn = createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
})), 'ZoomIn');

function ownKeys$f(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$a(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) {
      _defineProperty$d(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$5(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate$1(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate$1(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (process.env.NODE_ENV !== 'production') {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

function createStore$1(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore$1)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject$5(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning$3(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators$1(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose$1() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose$1.apply(void 0, chain)(store.dispatch);
      return _objectSpread2$a(_objectSpread2$a({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (process.env.NODE_ENV !== 'production' && typeof isCrushed.name === 'string' && isCrushed.name !== 'isCrushed') {
  warning$3('You are currently using minified code outside of NODE_ENV === "production". ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or setting mode to production in webpack (https://webpack.js.org/concepts/mode/) ' + 'to ensure you have the correct code for your production build.');
}

var ReactReduxContext = /*#__PURE__*/React__default.createContext(null);

if (process.env.NODE_ENV !== 'production') {
  ReactReduxContext.displayName = 'ReactRedux';
}

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}

// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect$1 : useEffect;

function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = useMemo$1(function () {
    var subscription = createSubscription(store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = useMemo$1(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect$1(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/React__default.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (process.env.NODE_ENV !== 'production') {
  Provider.propTypes = {
    store: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      dispatch: PropTypes.func.isRequired,
      getState: PropTypes.func.isRequired
    }),
    context: PropTypes.object,
    children: PropTypes.any
  };
}

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
	if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden");}
	function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;reactIs_production_min.ContextConsumer=h;reactIs_production_min.ContextProvider=z;reactIs_production_min.Element=A;reactIs_production_min.ForwardRef=B;reactIs_production_min.Fragment=C;reactIs_production_min.Lazy=D;reactIs_production_min.Memo=E;reactIs_production_min.Portal=F;reactIs_production_min.Profiler=G;reactIs_production_min.StrictMode=H;
	reactIs_production_min.Suspense=I;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return y(a)===h};reactIs_production_min.isContextProvider=function(a){return y(a)===g};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};reactIs_production_min.isForwardRef=function(a){return y(a)===k};reactIs_production_min.isFragment=function(a){return y(a)===d};reactIs_production_min.isLazy=function(a){return y(a)===p};reactIs_production_min.isMemo=function(a){return y(a)===n};
	reactIs_production_min.isPortal=function(a){return y(a)===c};reactIs_production_min.isProfiler=function(a){return y(a)===f};reactIs_production_min.isStrictMode=function(a){return y(a)===e};reactIs_production_min.isSuspense=function(a){return y(a)===l};reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
	reactIs_production_min.typeOf=y;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v17.0.2
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;

	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// ATTENTION
	// When adding new symbols to this file,
	// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = 0xeac7;
	var REACT_PORTAL_TYPE = 0xeaca;
	var REACT_FRAGMENT_TYPE = 0xeacb;
	var REACT_STRICT_MODE_TYPE = 0xeacc;
	var REACT_PROFILER_TYPE = 0xead2;
	var REACT_PROVIDER_TYPE = 0xeacd;
	var REACT_CONTEXT_TYPE = 0xeace;
	var REACT_FORWARD_REF_TYPE = 0xead0;
	var REACT_SUSPENSE_TYPE = 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = 0xead8;
	var REACT_MEMO_TYPE = 0xead3;
	var REACT_LAZY_TYPE = 0xead4;
	var REACT_BLOCK_TYPE = 0xead9;
	var REACT_SERVER_BLOCK_TYPE = 0xeada;
	var REACT_FUNDAMENTAL_TYPE = 0xead5;
	var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
	var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

	if (typeof Symbol === 'function' && Symbol.for) {
	  var symbolFor = Symbol.for;
	  REACT_ELEMENT_TYPE = symbolFor('react.element');
	  REACT_PORTAL_TYPE = symbolFor('react.portal');
	  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
	  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
	  REACT_PROFILER_TYPE = symbolFor('react.profiler');
	  REACT_PROVIDER_TYPE = symbolFor('react.provider');
	  REACT_CONTEXT_TYPE = symbolFor('react.context');
	  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
	  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
	  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
	  REACT_MEMO_TYPE = symbolFor('react.memo');
	  REACT_LAZY_TYPE = symbolFor('react.lazy');
	  REACT_BLOCK_TYPE = symbolFor('react.block');
	  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
	  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
	  symbolFor('react.scope');
	  symbolFor('react.opaque.id');
	  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
	  symbolFor('react.offscreen');
	  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
	}

	// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

	var enableScopeAPI = false; // Experimental Create Event Handle API.

	function isValidElementType(type) {
	  if (typeof type === 'string' || typeof type === 'function') {
	    return true;
	  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


	  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
	    return true;
	  }

	  if (typeof type === 'object' && type !== null) {
	    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
	      return true;
	    }
	  }

	  return false;
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	          case REACT_SUSPENSE_LIST_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	}
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false;
	var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isConcurrentMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
	      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
	    }
	  }

	  return false;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

if (process.env.NODE_ENV === 'production') {
  reactIs.exports = requireReactIs_production_min();
} else {
  reactIs.exports = requireReactIs_development();
}

var reactIsExports = reactIs.exports;

var _excluded$2 = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect$1(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = _objectWithoutPropertiesLoose$4(_ref2, _excluded$2);

  if (process.env.NODE_ENV !== 'production') {
    if (renderCountProp !== undefined) {
      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
    }

    if (withRef) {
      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
    }

    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';

    if (storeKey !== 'store') {
      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
    }
  }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (process.env.NODE_ENV !== 'production' && !reactIsExports.isValidElementType(WrappedComponent)) {
      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
    }

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? useMemo$1 : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = useMemo$1(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = _objectWithoutPropertiesLoose$4(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = useMemo$1(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && reactIsExports.isContextConsumer( /*#__PURE__*/React__default.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (process.env.NODE_ENV !== 'production' && !didStoreComeFromProps && !didStoreComeFromContext) {
        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
      } // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = useMemo$1(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = useMemo$1(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = useMemo$1(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return _extends({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = useReducer(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = useRef();
      var lastWrapperProps = useRef(wrapperProps);
      var childPropsFromStoreUpdate = useRef();
      var renderIsScheduled = useRef(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = useMemo$1(function () {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, _extends({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = useMemo$1(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/React__default.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? React__default.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = React__default.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/React__default.createElement(Connect, _extends({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoistStatics(forwarded, WrappedComponent);
    }

    return hoistStatics(Connect, WrappedComponent);
  };
}

function is$2(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual$1(objA, objB) {
  if (is$2(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is$2(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject$4(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning$2(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

function verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject$4(value)) {
    warning$2(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (process.env.NODE_ENV !== 'production') verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
var defaultMapDispatchToPropsFactories = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
var defaultMapStateToPropsFactories = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (process.env.NODE_ENV !== 'production') verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
var defaultMergePropsFactories = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
      warning$2("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

var _excluded$1 = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];
function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose$4(_ref2, _excluded$1);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (process.env.NODE_ENV !== 'production') {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

var _excluded = ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match$2w(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual$1 : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual$1 : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual$1 : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose$4(_ref3, _excluded);

    var initMapStateToProps = match$2w(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match$2w(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match$2w(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
var connect = /*#__PURE__*/createConnect();

// with standard React renderers (ReactDOM, React Native)

setBatch(unstable_batchedUpdates);

function areInputsEqual$2(newInputs, lastInputs) {
  if (newInputs.length !== lastInputs.length) {
    return false;
  }

  for (var i = 0; i < newInputs.length; i++) {
    if (newInputs[i] !== lastInputs[i]) {
      return false;
    }
  }

  return true;
}

function useMemoOne$1(getResult, inputs) {
  var initial = useState(function () {
    return {
      inputs: inputs,
      result: getResult()
    };
  })[0];
  var isFirstRun = useRef(true);
  var committed = useRef(initial);
  var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual$2(inputs, committed.current.inputs));
  var cache = useCache ? committed.current : {
    inputs: inputs,
    result: getResult()
  };
  useEffect(function () {
    isFirstRun.current = false;
    committed.current = cache;
  }, [cache]);
  return cache.result;
}
function useCallbackOne(callback, inputs) {
  return useMemoOne$1(function () {
    return callback;
  }, inputs);
}
var useMemo = useMemoOne$1;
var useCallback = useCallbackOne;

var isProduction$2 = process.env.NODE_ENV === 'production';
var prefix$2 = 'Invariant failed';
function invariant$3(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction$2) {
        throw new Error(prefix$2);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? prefix$2 + ": " + provided : prefix$2;
    throw new Error(value);
}

var getRect = function getRect(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var width = right - left;
  var height = bottom - top;
  var rect = {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: width,
    height: height,
    x: left,
    y: top,
    center: {
      x: (right + left) / 2,
      y: (bottom + top) / 2
    }
  };
  return rect;
};
var expand$1 = function expand(target, expandBy) {
  return {
    top: target.top - expandBy.top,
    left: target.left - expandBy.left,
    bottom: target.bottom + expandBy.bottom,
    right: target.right + expandBy.right
  };
};
var shrink = function shrink(target, shrinkBy) {
  return {
    top: target.top + shrinkBy.top,
    left: target.left + shrinkBy.left,
    bottom: target.bottom - shrinkBy.bottom,
    right: target.right - shrinkBy.right
  };
};

var shift = function shift(target, shiftBy) {
  return {
    top: target.top + shiftBy.y,
    left: target.left + shiftBy.x,
    bottom: target.bottom + shiftBy.y,
    right: target.right + shiftBy.x
  };
};

var noSpacing$1 = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var createBox = function createBox(_ref2) {
  var borderBox = _ref2.borderBox,
      _ref2$margin = _ref2.margin,
      margin = _ref2$margin === void 0 ? noSpacing$1 : _ref2$margin,
      _ref2$border = _ref2.border,
      border = _ref2$border === void 0 ? noSpacing$1 : _ref2$border,
      _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? noSpacing$1 : _ref2$padding;
  var marginBox = getRect(expand$1(borderBox, margin));
  var paddingBox = getRect(shrink(borderBox, border));
  var contentBox = getRect(shrink(paddingBox, padding));
  return {
    marginBox: marginBox,
    borderBox: getRect(borderBox),
    paddingBox: paddingBox,
    contentBox: contentBox,
    margin: margin,
    border: border,
    padding: padding
  };
};

var parse$1 = function parse(raw) {
  var value = raw.slice(0, -2);
  var suffix = raw.slice(-2);

  if (suffix !== 'px') {
    return 0;
  }

  var result = Number(value);
  !!isNaN(result) ? process.env.NODE_ENV !== "production" ? invariant$3(false, "Could not parse value [raw: " + raw + ", without suffix: " + value + "]") : invariant$3(false) : void 0;
  return result;
};

var getWindowScroll$1 = function getWindowScroll() {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
};

var offset = function offset(original, change) {
  var borderBox = original.borderBox,
      border = original.border,
      margin = original.margin,
      padding = original.padding;
  var shifted = shift(borderBox, change);
  return createBox({
    borderBox: shifted,
    border: border,
    margin: margin,
    padding: padding
  });
};
var withScroll = function withScroll(original, scroll) {
  if (scroll === void 0) {
    scroll = getWindowScroll$1();
  }

  return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
  var margin = {
    top: parse$1(styles.marginTop),
    right: parse$1(styles.marginRight),
    bottom: parse$1(styles.marginBottom),
    left: parse$1(styles.marginLeft)
  };
  var padding = {
    top: parse$1(styles.paddingTop),
    right: parse$1(styles.paddingRight),
    bottom: parse$1(styles.paddingBottom),
    left: parse$1(styles.paddingLeft)
  };
  var border = {
    top: parse$1(styles.borderTopWidth),
    right: parse$1(styles.borderRightWidth),
    bottom: parse$1(styles.borderBottomWidth),
    left: parse$1(styles.borderLeftWidth)
  };
  return createBox({
    borderBox: borderBox,
    margin: margin,
    padding: padding,
    border: border
  });
};
var getBox = function getBox(el) {
  var borderBox = el.getBoundingClientRect();
  var styles = window.getComputedStyle(el);
  return calculateBox(borderBox, styles);
};

var safeIsNaN = Number.isNaN ||
    function ponyfill(value) {
        return typeof value === 'number' && value !== value;
    };
function isEqual$5(first, second) {
    if (first === second) {
        return true;
    }
    if (safeIsNaN(first) && safeIsNaN(second)) {
        return true;
    }
    return false;
}
function areInputsEqual$1(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) {
        return false;
    }
    for (var i = 0; i < newInputs.length; i++) {
        if (!isEqual$5(newInputs[i], lastInputs[i])) {
            return false;
        }
    }
    return true;
}

function memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) { isEqual = areInputsEqual$1; }
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            newArgs[_i] = arguments[_i];
        }
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
            return lastResult;
        }
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}

var rafSchd = function rafSchd(fn) {
  var lastArgs = [];
  var frameId = null;

  var wrapperFn = function wrapperFn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    lastArgs = args;

    if (frameId) {
      return;
    }

    frameId = requestAnimationFrame(function () {
      frameId = null;
      fn.apply(void 0, lastArgs);
    });
  };

  wrapperFn.cancel = function () {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
  };

  return wrapperFn;
};

var rafSchd$1 = rafSchd;

var isProduction = process.env.NODE_ENV === 'production';
var spacesAndTabs = /[ \t]{2,}/g;
var lineStartWithSpaces = /^[ \t]*/gm;

var clean = function clean(value) {
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
};

var getDevMessage = function getDevMessage(message) {
  return clean("\n  %creact-beautiful-dnd\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development only message. It will be removed in production builds.\n");
};

var getFormattedMessage = function getFormattedMessage(message) {
  return [getDevMessage(message), 'color: #00C584; font-size: 1.2em; font-weight: bold;', 'line-height: 1.5', 'color: #723874;'];
};
var isDisabledFlag = '__react-beautiful-dnd-disable-dev-warnings';
function log$1(type, message) {
  var _console;

  if (isProduction) {
    return;
  }

  if (typeof window !== 'undefined' && window[isDisabledFlag]) {
    return;
  }

  (_console = console)[type].apply(_console, getFormattedMessage(message));
}
var warning$1 = log$1.bind(null, 'warn');
var error$1 = log$1.bind(null, 'error');

function noop$6() {}

function getOptions(shared, fromBinding) {
  return _extends({}, shared, {}, fromBinding);
}

function bindEvents(el, bindings, sharedOptions) {
  var unbindings = bindings.map(function (binding) {
    var options = getOptions(sharedOptions, binding.options);
    el.addEventListener(binding.eventName, binding.fn, options);
    return function unbind() {
      el.removeEventListener(binding.eventName, binding.fn, options);
    };
  });
  return function unbindAll() {
    unbindings.forEach(function (unbind) {
      unbind();
    });
  };
}

var isProduction$1 = process.env.NODE_ENV === 'production';
var prefix$1 = 'Invariant failed';
function RbdInvariant(message) {
  this.message = message;
}

RbdInvariant.prototype.toString = function toString() {
  return this.message;
};

function invariant$2(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction$1) {
    throw new RbdInvariant(prefix$1);
  } else {
    throw new RbdInvariant(prefix$1 + ": " + (message || ''));
  }
}

var ErrorBoundary = function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);

  function ErrorBoundary() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.callbacks = null;
    _this.unbind = noop$6;

    _this.onWindowError = function (event) {
      var callbacks = _this.getCallbacks();

      if (callbacks.isDragging()) {
        callbacks.tryAbort();
        process.env.NODE_ENV !== "production" ? warning$1("\n        An error was caught by our window 'error' event listener while a drag was occurring.\n        The active drag has been aborted.\n      ") : void 0;
      }

      var err = event.error;

      if (err instanceof RbdInvariant) {
        event.preventDefault();

        if (process.env.NODE_ENV !== 'production') {
          error$1(err.message);
        }
      }
    };

    _this.getCallbacks = function () {
      if (!_this.callbacks) {
        throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
      }

      return _this.callbacks;
    };

    _this.setCallbacks = function (callbacks) {
      _this.callbacks = callbacks;
    };

    return _this;
  }

  var _proto = ErrorBoundary.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.unbind = bindEvents(window, [{
      eventName: 'error',
      fn: this.onWindowError
    }]);
  };

  _proto.componentDidCatch = function componentDidCatch(err) {
    if (err instanceof RbdInvariant) {
      if (process.env.NODE_ENV !== 'production') {
        error$1(err.message);
      }

      this.setState({});
      return;
    }

    throw err;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unbind();
  };

  _proto.render = function render() {
    return this.props.children(this.setCallbacks);
  };

  return ErrorBoundary;
}(React__default.Component);

var dragHandleUsageInstructions = "\n  Press space bar to start a drag.\n  When dragging you can use the arrow keys to move the item around and escape to cancel.\n  Some screen readers may require you to be in focus mode or to use your pass through key\n";

var position = function position(index) {
  return index + 1;
};

var onDragStart = function onDragStart(start) {
  return "\n  You have lifted an item in position " + position(start.source.index) + "\n";
};

var withLocation = function withLocation(source, destination) {
  var isInHomeList = source.droppableId === destination.droppableId;
  var startPosition = position(source.index);
  var endPosition = position(destination.index);

  if (isInHomeList) {
    return "\n      You have moved the item from position " + startPosition + "\n      to position " + endPosition + "\n    ";
  }

  return "\n    You have moved the item from position " + startPosition + "\n    in list " + source.droppableId + "\n    to list " + destination.droppableId + "\n    in position " + endPosition + "\n  ";
};

var withCombine = function withCombine(id, source, combine) {
  var inHomeList = source.droppableId === combine.droppableId;

  if (inHomeList) {
    return "\n      The item " + id + "\n      has been combined with " + combine.draggableId;
  }

  return "\n      The item " + id + "\n      in list " + source.droppableId + "\n      has been combined with " + combine.draggableId + "\n      in list " + combine.droppableId + "\n    ";
};

var onDragUpdate = function onDragUpdate(update) {
  var location = update.destination;

  if (location) {
    return withLocation(update.source, location);
  }

  var combine = update.combine;

  if (combine) {
    return withCombine(update.draggableId, update.source, combine);
  }

  return 'You are over an area that cannot be dropped on';
};

var returnedToStart = function returnedToStart(source) {
  return "\n  The item has returned to its starting position\n  of " + position(source.index) + "\n";
};

var onDragEnd = function onDragEnd(result) {
  if (result.reason === 'CANCEL') {
    return "\n      Movement cancelled.\n      " + returnedToStart(result.source) + "\n    ";
  }

  var location = result.destination;
  var combine = result.combine;

  if (location) {
    return "\n      You have dropped the item.\n      " + withLocation(result.source, location) + "\n    ";
  }

  if (combine) {
    return "\n      You have dropped the item.\n      " + withCombine(result.draggableId, result.source, combine) + "\n    ";
  }

  return "\n    The item has been dropped while not over a drop area.\n    " + returnedToStart(result.source) + "\n  ";
};

var preset = {
  dragHandleUsageInstructions: dragHandleUsageInstructions,
  onDragStart: onDragStart,
  onDragUpdate: onDragUpdate,
  onDragEnd: onDragEnd
};

var origin = {
  x: 0,
  y: 0
};
var add = function add(point1, point2) {
  return {
    x: point1.x + point2.x,
    y: point1.y + point2.y
  };
};
var subtract = function subtract(point1, point2) {
  return {
    x: point1.x - point2.x,
    y: point1.y - point2.y
  };
};
var isEqual$4 = function isEqual(point1, point2) {
  return point1.x === point2.x && point1.y === point2.y;
};
var negate = function negate(point) {
  return {
    x: point.x !== 0 ? -point.x : 0,
    y: point.y !== 0 ? -point.y : 0
  };
};
var patch = function patch(line, value, otherValue) {
  var _ref;

  if (otherValue === void 0) {
    otherValue = 0;
  }

  return _ref = {}, _ref[line] = value, _ref[line === 'x' ? 'y' : 'x'] = otherValue, _ref;
};
var distance = function distance(point1, point2) {
  return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};
var closest$1 = function closest(target, points) {
  return Math.min.apply(Math, points.map(function (point) {
    return distance(target, point);
  }));
};
var apply$2 = function apply(fn) {
  return function (point) {
    return {
      x: fn(point.x),
      y: fn(point.y)
    };
  };
};

var executeClip = (function (frame, subject) {
  var result = getRect({
    top: Math.max(subject.top, frame.top),
    right: Math.min(subject.right, frame.right),
    bottom: Math.min(subject.bottom, frame.bottom),
    left: Math.max(subject.left, frame.left)
  });

  if (result.width <= 0 || result.height <= 0) {
    return null;
  }

  return result;
});

var offsetByPosition = function offsetByPosition(spacing, point) {
  return {
    top: spacing.top + point.y,
    left: spacing.left + point.x,
    bottom: spacing.bottom + point.y,
    right: spacing.right + point.x
  };
};
var getCorners = function getCorners(spacing) {
  return [{
    x: spacing.left,
    y: spacing.top
  }, {
    x: spacing.right,
    y: spacing.top
  }, {
    x: spacing.left,
    y: spacing.bottom
  }, {
    x: spacing.right,
    y: spacing.bottom
  }];
};
var noSpacing = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var scroll = function scroll(target, frame) {
  if (!frame) {
    return target;
  }

  return offsetByPosition(target, frame.scroll.diff.displacement);
};

var increase = function increase(target, axis, withPlaceholder) {
  if (withPlaceholder && withPlaceholder.increasedBy) {
    var _extends2;

    return _extends({}, target, (_extends2 = {}, _extends2[axis.end] = target[axis.end] + withPlaceholder.increasedBy[axis.line], _extends2));
  }

  return target;
};

var clip = function clip(target, frame) {
  if (frame && frame.shouldClipSubject) {
    return executeClip(frame.pageMarginBox, target);
  }

  return getRect(target);
};

var getSubject = (function (_ref) {
  var page = _ref.page,
      withPlaceholder = _ref.withPlaceholder,
      axis = _ref.axis,
      frame = _ref.frame;
  var scrolled = scroll(page.marginBox, frame);
  var increased = increase(scrolled, axis, withPlaceholder);
  var clipped = clip(increased, frame);
  return {
    page: page,
    withPlaceholder: withPlaceholder,
    active: clipped
  };
});

var scrollDroppable = (function (droppable, newScroll) {
  !droppable.frame ? process.env.NODE_ENV !== "production" ? invariant$2(false) : invariant$2(false) : void 0;
  var scrollable = droppable.frame;
  var scrollDiff = subtract(newScroll, scrollable.scroll.initial);
  var scrollDisplacement = negate(scrollDiff);

  var frame = _extends({}, scrollable, {
    scroll: {
      initial: scrollable.scroll.initial,
      current: newScroll,
      diff: {
        value: scrollDiff,
        displacement: scrollDisplacement
      },
      max: scrollable.scroll.max
    }
  });

  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: droppable.subject.withPlaceholder,
    axis: droppable.axis,
    frame: frame
  });

  var result = _extends({}, droppable, {
    frame: frame,
    subject: subject
  });

  return result;
});

function isInteger$1(value) {
  if (Number.isInteger) {
    return Number.isInteger(value);
  }

  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
}
function values$1(map) {
  if (Object.values) {
    return Object.values(map);
  }

  return Object.keys(map).map(function (key) {
    return map[key];
  });
}
function findIndex$2(list, predicate) {
  if (list.findIndex) {
    return list.findIndex(predicate);
  }

  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return i;
    }
  }

  return -1;
}
function find(list, predicate) {
  if (list.find) {
    return list.find(predicate);
  }

  var index = findIndex$2(list, predicate);

  if (index !== -1) {
    return list[index];
  }

  return undefined;
}
function toArray$1(list) {
  return Array.prototype.slice.call(list);
}

var toDroppableMap = memoizeOne(function (droppables) {
  return droppables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDraggableMap = memoizeOne(function (draggables) {
  return draggables.reduce(function (previous, current) {
    previous[current.descriptor.id] = current;
    return previous;
  }, {});
});
var toDroppableList = memoizeOne(function (droppables) {
  return values$1(droppables);
});
var toDraggableList = memoizeOne(function (draggables) {
  return values$1(draggables);
});

var getDraggablesInsideDroppable = memoizeOne(function (droppableId, draggables) {
  var result = toDraggableList(draggables).filter(function (draggable) {
    return droppableId === draggable.descriptor.droppableId;
  }).sort(function (a, b) {
    return a.descriptor.index - b.descriptor.index;
  });
  return result;
});

function tryGetDestination(impact) {
  if (impact.at && impact.at.type === 'REORDER') {
    return impact.at.destination;
  }

  return null;
}
function tryGetCombine(impact) {
  if (impact.at && impact.at.type === 'COMBINE') {
    return impact.at.combine;
  }

  return null;
}

var removeDraggableFromList = memoizeOne(function (remove, list) {
  return list.filter(function (item) {
    return item.descriptor.id !== remove.descriptor.id;
  });
});

var moveToNextCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var location = tryGetDestination(previousImpact);

  if (!location) {
    return null;
  }

  function getImpact(target) {
    var at = {
      type: 'COMBINE',
      combine: {
        draggableId: target,
        droppableId: destination.descriptor.id
      }
    };
    return _extends({}, previousImpact, {
      at: at
    });
  }

  var all = previousImpact.displaced.all;
  var closestId = all.length ? all[0] : null;

  if (isMovingForward) {
    return closestId ? getImpact(closestId) : null;
  }

  var withoutDraggable = removeDraggableFromList(draggable, insideDestination);

  if (!closestId) {
    if (!withoutDraggable.length) {
      return null;
    }

    var last = withoutDraggable[withoutDraggable.length - 1];
    return getImpact(last.descriptor.id);
  }

  var indexOfClosest = findIndex$2(withoutDraggable, function (d) {
    return d.descriptor.id === closestId;
  });
  !(indexOfClosest !== -1) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Could not find displaced item in set') : invariant$2(false) : void 0;
  var proposedIndex = indexOfClosest - 1;

  if (proposedIndex < 0) {
    return null;
  }

  var before = withoutDraggable[proposedIndex];
  return getImpact(before.descriptor.id);
});

var isHomeOf = (function (draggable, destination) {
  return draggable.descriptor.droppableId === destination.descriptor.id;
});

var noDisplacedBy = {
  point: origin,
  value: 0
};
var emptyGroups = {
  invisible: {},
  visible: {},
  all: []
};
var noImpact = {
  displaced: emptyGroups,
  displacedBy: noDisplacedBy,
  at: null
};

var isWithin = (function (lowerBound, upperBound) {
  return function (value) {
    return lowerBound <= value && value <= upperBound;
  };
});

var isPartiallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);

    if (isContained) {
      return true;
    }

    var isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
    var isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
    var isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;

    if (isPartiallyContained) {
      return true;
    }

    var isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
    var isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
    var isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;

    if (isTargetBiggerThanFrame) {
      return true;
    }

    var isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
    return isTargetBiggerOnOneAxis;
  };
});

var isTotallyVisibleThroughFrame = (function (frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function (subject) {
    var isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    return isContained;
  };
});

var vertical = {
  direction: 'vertical',
  line: 'y',
  crossAxisLine: 'x',
  start: 'top',
  end: 'bottom',
  size: 'height',
  crossAxisStart: 'left',
  crossAxisEnd: 'right',
  crossAxisSize: 'width'
};
var horizontal = {
  direction: 'horizontal',
  line: 'x',
  crossAxisLine: 'y',
  start: 'left',
  end: 'right',
  size: 'width',
  crossAxisStart: 'top',
  crossAxisEnd: 'bottom',
  crossAxisSize: 'height'
};

var isTotallyVisibleThroughFrameOnAxis = (function (axis) {
  return function (frame) {
    var isWithinVertical = isWithin(frame.top, frame.bottom);
    var isWithinHorizontal = isWithin(frame.left, frame.right);
    return function (subject) {
      if (axis === vertical) {
        return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
      }

      return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
    };
  };
});

var getDroppableDisplaced = function getDroppableDisplaced(target, destination) {
  var displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
  return offsetByPosition(target, displacement);
};

var isVisibleInDroppable = function isVisibleInDroppable(target, destination, isVisibleThroughFrameFn) {
  if (!destination.subject.active) {
    return false;
  }

  return isVisibleThroughFrameFn(destination.subject.active)(target);
};

var isVisibleInViewport = function isVisibleInViewport(target, viewport, isVisibleThroughFrameFn) {
  return isVisibleThroughFrameFn(viewport)(target);
};

var isVisible = function isVisible(_ref) {
  var toBeDisplaced = _ref.target,
      destination = _ref.destination,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      isVisibleThroughFrameFn = _ref.isVisibleThroughFrameFn;
  var displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
  return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};

var isPartiallyVisible = function isPartiallyVisible(args) {
  return isVisible(_extends({}, args, {
    isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
  }));
};
var isTotallyVisible = function isTotallyVisible(args) {
  return isVisible(_extends({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
  }));
};
var isTotallyVisibleOnAxis = function isTotallyVisibleOnAxis(args) {
  return isVisible(_extends({}, args, {
    isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
  }));
};

var getShouldAnimate = function getShouldAnimate(id, last, forceShouldAnimate) {
  if (typeof forceShouldAnimate === 'boolean') {
    return forceShouldAnimate;
  }

  if (!last) {
    return true;
  }

  var invisible = last.invisible,
      visible = last.visible;

  if (invisible[id]) {
    return false;
  }

  var previous = visible[id];
  return previous ? previous.shouldAnimate : true;
};

function getTarget(draggable, displacedBy) {
  var marginBox = draggable.page.marginBox;
  var expandBy = {
    top: displacedBy.point.y,
    right: 0,
    bottom: 0,
    left: displacedBy.point.x
  };
  return getRect(expand$1(marginBox, expandBy));
}

function getDisplacementGroups(_ref) {
  var afterDragging = _ref.afterDragging,
      destination = _ref.destination,
      displacedBy = _ref.displacedBy,
      viewport = _ref.viewport,
      forceShouldAnimate = _ref.forceShouldAnimate,
      last = _ref.last;
  return afterDragging.reduce(function process(groups, draggable) {
    var target = getTarget(draggable, displacedBy);
    var id = draggable.descriptor.id;
    groups.all.push(id);
    var isVisible = isPartiallyVisible({
      target: target,
      destination: destination,
      viewport: viewport,
      withDroppableDisplacement: true
    });

    if (!isVisible) {
      groups.invisible[draggable.descriptor.id] = true;
      return groups;
    }

    var shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
    var displacement = {
      draggableId: id,
      shouldAnimate: shouldAnimate
    };
    groups.visible[id] = displacement;
    return groups;
  }, {
    all: [],
    visible: {},
    invisible: {}
  });
}

function getIndexOfLastItem(draggables, options) {
  if (!draggables.length) {
    return 0;
  }

  var indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
  return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}

function goAtEnd(_ref) {
  var insideDestination = _ref.insideDestination,
      inHomeList = _ref.inHomeList,
      displacedBy = _ref.displacedBy,
      destination = _ref.destination;
  var newIndex = getIndexOfLastItem(insideDestination, {
    inHomeList: inHomeList
  });
  return {
    displaced: emptyGroups,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: newIndex
      }
    }
  };
}

function calculateReorderImpact(_ref2) {
  var draggable = _ref2.draggable,
      insideDestination = _ref2.insideDestination,
      destination = _ref2.destination,
      viewport = _ref2.viewport,
      displacedBy = _ref2.displacedBy,
      last = _ref2.last,
      index = _ref2.index,
      forceShouldAnimate = _ref2.forceShouldAnimate;
  var inHomeList = isHomeOf(draggable, destination);

  if (index == null) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var match = find(insideDestination, function (item) {
    return item.descriptor.index === index;
  });

  if (!match) {
    return goAtEnd({
      insideDestination: insideDestination,
      inHomeList: inHomeList,
      displacedBy: displacedBy,
      destination: destination
    });
  }

  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var sliceFrom = insideDestination.indexOf(match);
  var impacted = withoutDragging.slice(sliceFrom);
  var displaced = getDisplacementGroups({
    afterDragging: impacted,
    destination: destination,
    displacedBy: displacedBy,
    last: last,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate
  });
  return {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: {
        droppableId: destination.descriptor.id,
        index: index
      }
    }
  };
}

function didStartAfterCritical(draggableId, afterCritical) {
  return Boolean(afterCritical.effected[draggableId]);
}

var fromCombine = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      destination = _ref.destination,
      draggables = _ref.draggables,
      combine = _ref.combine,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var combineId = combine.draggableId;
  var combineWith = draggables[combineId];
  var combineWithIndex = combineWith.descriptor.index;
  var didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);

  if (didCombineWithStartAfterCritical) {
    if (isMovingForward) {
      return combineWithIndex;
    }

    return combineWithIndex - 1;
  }

  if (isMovingForward) {
    return combineWithIndex + 1;
  }

  return combineWithIndex;
});

var fromReorder = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      insideDestination = _ref.insideDestination,
      location = _ref.location;

  if (!insideDestination.length) {
    return null;
  }

  var currentIndex = location.index;
  var proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
  var firstIndex = insideDestination[0].descriptor.index;
  var lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
  var upperBound = isInHomeList ? lastIndex : lastIndex + 1;

  if (proposedIndex < firstIndex) {
    return null;
  }

  if (proposedIndex > upperBound) {
    return null;
  }

  return proposedIndex;
});

var moveToNextIndex = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      isInHomeList = _ref.isInHomeList,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var wasAt = previousImpact.at;
  !wasAt ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot move in direction without previous impact location') : invariant$2(false) : void 0;

  if (wasAt.type === 'REORDER') {
    var _newIndex = fromReorder({
      isMovingForward: isMovingForward,
      isInHomeList: isInHomeList,
      location: wasAt.destination,
      insideDestination: insideDestination
    });

    if (_newIndex == null) {
      return null;
    }

    return calculateReorderImpact({
      draggable: draggable,
      insideDestination: insideDestination,
      destination: destination,
      viewport: viewport,
      last: previousImpact.displaced,
      displacedBy: previousImpact.displacedBy,
      index: _newIndex
    });
  }

  var newIndex = fromCombine({
    isMovingForward: isMovingForward,
    destination: destination,
    displaced: previousImpact.displaced,
    draggables: draggables,
    combine: wasAt.combine,
    afterCritical: afterCritical
  });

  if (newIndex == null) {
    return null;
  }

  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: previousImpact.displaced,
    displacedBy: previousImpact.displacedBy,
    index: newIndex
  });
});

var getCombinedItemDisplacement = (function (_ref) {
  var displaced = _ref.displaced,
      afterCritical = _ref.afterCritical,
      combineWith = _ref.combineWith,
      displacedBy = _ref.displacedBy;
  var isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);

  if (didStartAfterCritical(combineWith, afterCritical)) {
    return isDisplaced ? origin : negate(displacedBy.point);
  }

  return isDisplaced ? displacedBy.point : origin;
});

var whenCombining = (function (_ref) {
  var afterCritical = _ref.afterCritical,
      impact = _ref.impact,
      draggables = _ref.draggables;
  var combine = tryGetCombine(impact);
  !combine ? process.env.NODE_ENV !== "production" ? invariant$2(false) : invariant$2(false) : void 0;
  var combineWith = combine.draggableId;
  var center = draggables[combineWith].page.borderBox.center;
  var displaceBy = getCombinedItemDisplacement({
    displaced: impact.displaced,
    afterCritical: afterCritical,
    combineWith: combineWith,
    displacedBy: impact.displacedBy
  });
  return add(center, displaceBy);
});

var distanceFromStartToBorderBoxCenter = function distanceFromStartToBorderBoxCenter(axis, box) {
  return box.margin[axis.start] + box.borderBox[axis.size] / 2;
};

var distanceFromEndToBorderBoxCenter = function distanceFromEndToBorderBoxCenter(axis, box) {
  return box.margin[axis.end] + box.borderBox[axis.size] / 2;
};

var getCrossAxisBorderBoxCenter = function getCrossAxisBorderBoxCenter(axis, target, isMoving) {
  return target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
};

var goAfter = function goAfter(_ref) {
  var axis = _ref.axis,
      moveRelativeTo = _ref.moveRelativeTo,
      isMoving = _ref.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goBefore = function goBefore(_ref2) {
  var axis = _ref2.axis,
      moveRelativeTo = _ref2.moveRelativeTo,
      isMoving = _ref2.isMoving;
  return patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
};
var goIntoStart = function goIntoStart(_ref3) {
  var axis = _ref3.axis,
      moveInto = _ref3.moveInto,
      isMoving = _ref3.isMoving;
  return patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
};

var whenReordering = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppable = _ref.droppable,
      afterCritical = _ref.afterCritical;
  var insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var draggablePage = draggable.page;
  var axis = droppable.axis;

  if (!insideDestination.length) {
    return goIntoStart({
      axis: axis,
      moveInto: droppable.page,
      isMoving: draggablePage
    });
  }

  var displaced = impact.displaced,
      displacedBy = impact.displacedBy;
  var closestAfter = displaced.all[0];

  if (closestAfter) {
    var closest = draggables[closestAfter];

    if (didStartAfterCritical(closestAfter, afterCritical)) {
      return goBefore({
        axis: axis,
        moveRelativeTo: closest.page,
        isMoving: draggablePage
      });
    }

    var withDisplacement = offset(closest.page, displacedBy.point);
    return goBefore({
      axis: axis,
      moveRelativeTo: withDisplacement,
      isMoving: draggablePage
    });
  }

  var last = insideDestination[insideDestination.length - 1];

  if (last.descriptor.id === draggable.descriptor.id) {
    return draggablePage.borderBox.center;
  }

  if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
    var page = offset(last.page, negate(afterCritical.displacedBy.point));
    return goAfter({
      axis: axis,
      moveRelativeTo: page,
      isMoving: draggablePage
    });
  }

  return goAfter({
    axis: axis,
    moveRelativeTo: last.page,
    isMoving: draggablePage
  });
});

var withDroppableDisplacement = (function (droppable, point) {
  var frame = droppable.frame;

  if (!frame) {
    return point;
  }

  return add(point, frame.scroll.diff.displacement);
});

var getResultWithoutDroppableDisplacement = function getResultWithoutDroppableDisplacement(_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      afterCritical = _ref.afterCritical;
  var original = draggable.page.borderBox.center;
  var at = impact.at;

  if (!droppable) {
    return original;
  }

  if (!at) {
    return original;
  }

  if (at.type === 'REORDER') {
    return whenReordering({
      impact: impact,
      draggable: draggable,
      draggables: draggables,
      droppable: droppable,
      afterCritical: afterCritical
    });
  }

  return whenCombining({
    impact: impact,
    draggables: draggables,
    afterCritical: afterCritical
  });
};

var getPageBorderBoxCenterFromImpact = (function (args) {
  var withoutDisplacement = getResultWithoutDroppableDisplacement(args);
  var droppable = args.droppable;
  var withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
  return withDisplacement;
});

var scrollViewport = (function (viewport, newScroll) {
  var diff = subtract(newScroll, viewport.scroll.initial);
  var displacement = negate(diff);
  var frame = getRect({
    top: newScroll.y,
    bottom: newScroll.y + viewport.frame.height,
    left: newScroll.x,
    right: newScroll.x + viewport.frame.width
  });
  var updated = {
    frame: frame,
    scroll: {
      initial: viewport.scroll.initial,
      max: viewport.scroll.max,
      current: newScroll,
      diff: {
        value: diff,
        displacement: displacement
      }
    }
  };
  return updated;
});

function getDraggables(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

function tryGetVisible(id, groups) {
  for (var i = 0; i < groups.length; i++) {
    var displacement = groups[i].visible[id];

    if (displacement) {
      return displacement;
    }
  }

  return null;
}

var speculativelyIncrease = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      destination = _ref.destination,
      draggables = _ref.draggables,
      maxScrollChange = _ref.maxScrollChange;
  var scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
  var scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
  var last = impact.displaced;
  var withViewportScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: scrolledViewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var withDroppableScroll = getDisplacementGroups({
    afterDragging: getDraggables(last.all, draggables),
    destination: scrolledDroppable,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    last: last,
    forceShouldAnimate: false
  });
  var invisible = {};
  var visible = {};
  var groups = [last, withViewportScroll, withDroppableScroll];
  last.all.forEach(function (id) {
    var displacement = tryGetVisible(id, groups);

    if (displacement) {
      visible[id] = displacement;
      return;
    }

    invisible[id] = true;
  });

  var newImpact = _extends({}, impact, {
    displaced: {
      all: last.all,
      invisible: invisible,
      visible: visible
    }
  });

  return newImpact;
});

var withViewportDisplacement = (function (viewport, point) {
  return add(viewport.scroll.diff.displacement, point);
});

var getClientFromPageBorderBoxCenter = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      draggable = _ref.draggable,
      viewport = _ref.viewport;
  var withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
  var offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
  return add(draggable.client.borderBox.center, offset);
});

var isTotallyVisibleInNewLocation = (function (_ref) {
  var draggable = _ref.draggable,
      destination = _ref.destination,
      newPageBorderBoxCenter = _ref.newPageBorderBoxCenter,
      viewport = _ref.viewport,
      withDroppableDisplacement = _ref.withDroppableDisplacement,
      _ref$onlyOnMainAxis = _ref.onlyOnMainAxis,
      onlyOnMainAxis = _ref$onlyOnMainAxis === void 0 ? false : _ref$onlyOnMainAxis;
  var changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
  var shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
  var args = {
    target: shifted,
    destination: destination,
    withDroppableDisplacement: withDroppableDisplacement,
    viewport: viewport
  };
  return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
});

var moveToNextPlace = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      draggable = _ref.draggable,
      destination = _ref.destination,
      draggables = _ref.draggables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      previousClientSelection = _ref.previousClientSelection,
      afterCritical = _ref.afterCritical;

  if (!destination.isEnabled) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var isInHomeList = isHomeOf(draggable, destination);
  var impact = moveToNextCombine({
    isMovingForward: isMovingForward,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact
  }) || moveToNextIndex({
    isMovingForward: isMovingForward,
    isInHomeList: isInHomeList,
    draggable: draggable,
    draggables: draggables,
    destination: destination,
    insideDestination: insideDestination,
    previousImpact: previousImpact,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
    draggable: draggable,
    destination: destination,
    newPageBorderBoxCenter: pageBorderBoxCenter,
    viewport: viewport.frame,
    withDroppableDisplacement: false,
    onlyOnMainAxis: true
  });

  if (isVisibleInNewLocation) {
    var clientSelection = getClientFromPageBorderBoxCenter({
      pageBorderBoxCenter: pageBorderBoxCenter,
      draggable: draggable,
      viewport: viewport
    });
    return {
      clientSelection: clientSelection,
      impact: impact,
      scrollJumpRequest: null
    };
  }

  var distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
  var cautious = speculativelyIncrease({
    impact: impact,
    viewport: viewport,
    destination: destination,
    draggables: draggables,
    maxScrollChange: distance
  });
  return {
    clientSelection: previousClientSelection,
    impact: cautious,
    scrollJumpRequest: distance
  };
});

var getKnownActive = function getKnownActive(droppable) {
  var rect = droppable.subject.active;
  !rect ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot get clipped area from droppable') : invariant$2(false) : void 0;
  return rect;
};

var getBestCrossAxisDroppable = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      source = _ref.source,
      droppables = _ref.droppables,
      viewport = _ref.viewport;
  var active = source.subject.active;

  if (!active) {
    return null;
  }

  var axis = source.axis;
  var isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
  var candidates = toDroppableList(droppables).filter(function (droppable) {
    return droppable !== source;
  }).filter(function (droppable) {
    return droppable.isEnabled;
  }).filter(function (droppable) {
    return Boolean(droppable.subject.active);
  }).filter(function (droppable) {
    return isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable));
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);

    if (isMovingForward) {
      return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
    }

    return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
  }).filter(function (droppable) {
    var activeOfTarget = getKnownActive(droppable);
    var isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
    return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
  }).sort(function (a, b) {
    var first = getKnownActive(a)[axis.crossAxisStart];
    var second = getKnownActive(b)[axis.crossAxisStart];

    if (isMovingForward) {
      return first - second;
    }

    return second - first;
  }).filter(function (droppable, index, array) {
    return getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart];
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0];
  }

  var contains = candidates.filter(function (droppable) {
    var isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
    return isWithinDroppable(pageBorderBoxCenter[axis.line]);
  });

  if (contains.length === 1) {
    return contains[0];
  }

  if (contains.length > 1) {
    return contains.sort(function (a, b) {
      return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
  }

  return candidates.sort(function (a, b) {
    var first = closest$1(pageBorderBoxCenter, getCorners(getKnownActive(a)));
    var second = closest$1(pageBorderBoxCenter, getCorners(getKnownActive(b)));

    if (first !== second) {
      return first - second;
    }

    return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
  })[0];
});

var getCurrentPageBorderBoxCenter = function getCurrentPageBorderBoxCenter(draggable, afterCritical) {
  var original = draggable.page.borderBox.center;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};
var getCurrentPageBorderBox = function getCurrentPageBorderBox(draggable, afterCritical) {
  var original = draggable.page.borderBox;
  return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};

var getClosestDraggable = (function (_ref) {
  var pageBorderBoxCenter = _ref.pageBorderBoxCenter,
      viewport = _ref.viewport,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;
  var sorted = insideDestination.filter(function (draggable) {
    return isTotallyVisible({
      target: getCurrentPageBorderBox(draggable, afterCritical),
      destination: destination,
      viewport: viewport.frame,
      withDroppableDisplacement: true
    });
  }).sort(function (a, b) {
    var distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
    var distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));

    if (distanceToA < distanceToB) {
      return -1;
    }

    if (distanceToB < distanceToA) {
      return 1;
    }

    return a.descriptor.index - b.descriptor.index;
  });
  return sorted[0] || null;
});

var getDisplacedBy = memoizeOne(function getDisplacedBy(axis, displaceBy) {
  var displacement = displaceBy[axis.line];
  return {
    value: displacement,
    point: patch(axis.line, displacement)
  };
});

var getRequiredGrowthForPlaceholder = function getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables) {
  var axis = droppable.axis;

  if (droppable.descriptor.mode === 'virtual') {
    return patch(axis.line, placeholderSize[axis.line]);
  }

  var availableSpace = droppable.subject.page.contentBox[axis.size];
  var insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
  var spaceUsed = insideDroppable.reduce(function (sum, dimension) {
    return sum + dimension.client.marginBox[axis.size];
  }, 0);
  var requiredSpace = spaceUsed + placeholderSize[axis.line];
  var needsToGrowBy = requiredSpace - availableSpace;

  if (needsToGrowBy <= 0) {
    return null;
  }

  return patch(axis.line, needsToGrowBy);
};

var withMaxScroll = function withMaxScroll(frame, max) {
  return _extends({}, frame, {
    scroll: _extends({}, frame.scroll, {
      max: max
    })
  });
};

var addPlaceholder = function addPlaceholder(droppable, draggable, draggables) {
  var frame = droppable.frame;
  !!isHomeOf(draggable, droppable) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Should not add placeholder space to home list') : invariant$2(false) : void 0;
  !!droppable.subject.withPlaceholder ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot add placeholder size to a subject when it already has one') : invariant$2(false) : void 0;
  var placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
  var requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
  var added = {
    placeholderSize: placeholderSize,
    increasedBy: requiredGrowth,
    oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
  };

  if (!frame) {
    var _subject = getSubject({
      page: droppable.subject.page,
      withPlaceholder: added,
      axis: droppable.axis,
      frame: droppable.frame
    });

    return _extends({}, droppable, {
      subject: _subject
    });
  }

  var maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
  var newFrame = withMaxScroll(frame, maxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    withPlaceholder: added,
    axis: droppable.axis,
    frame: newFrame
  });
  return _extends({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};
var removePlaceholder = function removePlaceholder(droppable) {
  var added = droppable.subject.withPlaceholder;
  !added ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot remove placeholder form subject when there was none') : invariant$2(false) : void 0;
  var frame = droppable.frame;

  if (!frame) {
    var _subject2 = getSubject({
      page: droppable.subject.page,
      axis: droppable.axis,
      frame: null,
      withPlaceholder: null
    });

    return _extends({}, droppable, {
      subject: _subject2
    });
  }

  var oldMaxScroll = added.oldFrameMaxScroll;
  !oldMaxScroll ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Expected droppable with frame to have old max frame scroll when removing placeholder') : invariant$2(false) : void 0;
  var newFrame = withMaxScroll(frame, oldMaxScroll);
  var subject = getSubject({
    page: droppable.subject.page,
    axis: droppable.axis,
    frame: newFrame,
    withPlaceholder: null
  });
  return _extends({}, droppable, {
    subject: subject,
    frame: newFrame
  });
};

var moveToNewDroppable = (function (_ref) {
  var previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      moveRelativeTo = _ref.moveRelativeTo,
      insideDestination = _ref.insideDestination,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      destination = _ref.destination,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;

  if (!moveRelativeTo) {
    if (insideDestination.length) {
      return null;
    }

    var proposed = {
      displaced: emptyGroups,
      displacedBy: noDisplacedBy,
      at: {
        type: 'REORDER',
        destination: {
          droppableId: destination.descriptor.id,
          index: 0
        }
      }
    };
    var proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
      impact: proposed,
      draggable: draggable,
      droppable: destination,
      draggables: draggables,
      afterCritical: afterCritical
    });
    var withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
    var isVisibleInNewLocation = isTotallyVisibleInNewLocation({
      draggable: draggable,
      destination: withPlaceholder,
      newPageBorderBoxCenter: proposedPageBorderBoxCenter,
      viewport: viewport.frame,
      withDroppableDisplacement: false,
      onlyOnMainAxis: true
    });
    return isVisibleInNewLocation ? proposed : null;
  }

  var isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);

  var proposedIndex = function () {
    var relativeTo = moveRelativeTo.descriptor.index;

    if (moveRelativeTo.descriptor.id === draggable.descriptor.id) {
      return relativeTo;
    }

    if (isGoingBeforeTarget) {
      return relativeTo;
    }

    return relativeTo + 1;
  }();

  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    displacedBy: displacedBy,
    last: emptyGroups,
    index: proposedIndex
  });
});

var moveCrossAxis = (function (_ref) {
  var isMovingForward = _ref.isMovingForward,
      previousPageBorderBoxCenter = _ref.previousPageBorderBoxCenter,
      draggable = _ref.draggable,
      isOver = _ref.isOver,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var destination = getBestCrossAxisDroppable({
    isMovingForward: isMovingForward,
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    source: isOver,
    droppables: droppables,
    viewport: viewport
  });

  if (!destination) {
    return null;
  }

  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var moveRelativeTo = getClosestDraggable({
    pageBorderBoxCenter: previousPageBorderBoxCenter,
    viewport: viewport,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  });
  var impact = moveToNewDroppable({
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    destination: destination,
    draggable: draggable,
    draggables: draggables,
    moveRelativeTo: moveRelativeTo,
    insideDestination: insideDestination,
    viewport: viewport,
    afterCritical: afterCritical
  });

  if (!impact) {
    return null;
  }

  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    afterCritical: afterCritical
  });
  var clientSelection = getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
  return {
    clientSelection: clientSelection,
    impact: impact,
    scrollJumpRequest: null
  };
});

var whatIsDraggedOver = (function (impact) {
  var at = impact.at;

  if (!at) {
    return null;
  }

  if (at.type === 'REORDER') {
    return at.destination.droppableId;
  }

  return at.combine.droppableId;
});

var getDroppableOver = function getDroppableOver(impact, droppables) {
  var id = whatIsDraggedOver(impact);
  return id ? droppables[id] : null;
};

var moveInDirection = (function (_ref) {
  var state = _ref.state,
      type = _ref.type;
  var isActuallyOver = getDroppableOver(state.impact, state.dimensions.droppables);
  var isMainAxisMovementAllowed = Boolean(isActuallyOver);
  var home = state.dimensions.droppables[state.critical.droppable.id];
  var isOver = isActuallyOver || home;
  var direction = isOver.axis.direction;
  var isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');

  if (isMovingOnMainAxis && !isMainAxisMovementAllowed) {
    return null;
  }

  var isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
  var _state$dimensions = state.dimensions,
      draggables = _state$dimensions.draggables,
      droppables = _state$dimensions.droppables;
  return isMovingOnMainAxis ? moveToNextPlace({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    destination: isOver,
    draggables: draggables,
    viewport: state.viewport,
    previousClientSelection: state.current.client.selection,
    previousImpact: state.impact,
    afterCritical: state.afterCritical
  }) : moveCrossAxis({
    isMovingForward: isMovingForward,
    previousPageBorderBoxCenter: previousPageBorderBoxCenter,
    draggable: draggable,
    isOver: isOver,
    draggables: draggables,
    droppables: droppables,
    viewport: state.viewport,
    afterCritical: state.afterCritical
  });
});

function isMovementAllowed(state) {
  return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}

function isPositionInFrame(frame) {
  var isWithinVertical = isWithin(frame.top, frame.bottom);
  var isWithinHorizontal = isWithin(frame.left, frame.right);
  return function run(point) {
    return isWithinVertical(point.y) && isWithinHorizontal(point.x);
  };
}

function getHasOverlap(first, second) {
  return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}

function getFurthestAway(_ref) {
  var pageBorderBox = _ref.pageBorderBox,
      draggable = _ref.draggable,
      candidates = _ref.candidates;
  var startCenter = draggable.page.borderBox.center;
  var sorted = candidates.map(function (candidate) {
    var axis = candidate.axis;
    var target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
    return {
      id: candidate.descriptor.id,
      distance: distance(startCenter, target)
    };
  }).sort(function (a, b) {
    return b.distance - a.distance;
  });
  return sorted[0] ? sorted[0].id : null;
}

function getDroppableOver$1(_ref2) {
  var pageBorderBox = _ref2.pageBorderBox,
      draggable = _ref2.draggable,
      droppables = _ref2.droppables;
  var candidates = toDroppableList(droppables).filter(function (item) {
    if (!item.isEnabled) {
      return false;
    }

    var active = item.subject.active;

    if (!active) {
      return false;
    }

    if (!getHasOverlap(pageBorderBox, active)) {
      return false;
    }

    if (isPositionInFrame(active)(pageBorderBox.center)) {
      return true;
    }

    var axis = item.axis;
    var childCenter = active.center[axis.crossAxisLine];
    var crossAxisStart = pageBorderBox[axis.crossAxisStart];
    var crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
    var isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
    var isStartContained = isContained(crossAxisStart);
    var isEndContained = isContained(crossAxisEnd);

    if (!isStartContained && !isEndContained) {
      return true;
    }

    if (isStartContained) {
      return crossAxisStart < childCenter;
    }

    return crossAxisEnd > childCenter;
  });

  if (!candidates.length) {
    return null;
  }

  if (candidates.length === 1) {
    return candidates[0].descriptor.id;
  }

  return getFurthestAway({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    candidates: candidates
  });
}

var offsetRectByPosition = function offsetRectByPosition(rect, point) {
  return getRect(offsetByPosition(rect, point));
};

var withDroppableScroll = (function (droppable, area) {
  var frame = droppable.frame;

  if (!frame) {
    return area;
  }

  return offsetRectByPosition(area, frame.scroll.diff.value);
});

function getIsDisplaced(_ref) {
  var displaced = _ref.displaced,
      id = _ref.id;
  return Boolean(displaced.visible[id] || displaced.invisible[id]);
}

function atIndex(_ref) {
  var draggable = _ref.draggable,
      closest = _ref.closest,
      inHomeList = _ref.inHomeList;

  if (!closest) {
    return null;
  }

  if (!inHomeList) {
    return closest.descriptor.index;
  }

  if (closest.descriptor.index > draggable.descriptor.index) {
    return closest.descriptor.index - 1;
  }

  return closest.descriptor.index;
}

var getReorderImpact = (function (_ref2) {
  var targetRect = _ref2.pageBorderBoxWithDroppableScroll,
      draggable = _ref2.draggable,
      destination = _ref2.destination,
      insideDestination = _ref2.insideDestination,
      last = _ref2.last,
      viewport = _ref2.viewport,
      afterCritical = _ref2.afterCritical;
  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var closest = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childCenter = child.page.borderBox.center[axis.line];
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: last,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd <= childCenter;
      }

      return targetStart < childCenter - displacement;
    }

    if (isDisplaced) {
      return targetEnd <= childCenter + displacement;
    }

    return targetStart < childCenter;
  });
  var newIndex = atIndex({
    draggable: draggable,
    closest: closest,
    inHomeList: isHomeOf(draggable, destination)
  });
  return calculateReorderImpact({
    draggable: draggable,
    insideDestination: insideDestination,
    destination: destination,
    viewport: viewport,
    last: last,
    displacedBy: displacedBy,
    index: newIndex
  });
});

var combineThresholdDivisor = 4;
var getCombineImpact = (function (_ref) {
  var draggable = _ref.draggable,
      targetRect = _ref.pageBorderBoxWithDroppableScroll,
      previousImpact = _ref.previousImpact,
      destination = _ref.destination,
      insideDestination = _ref.insideDestination,
      afterCritical = _ref.afterCritical;

  if (!destination.isCombineEnabled) {
    return null;
  }

  var axis = destination.axis;
  var displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
  var displacement = displacedBy.value;
  var targetStart = targetRect[axis.start];
  var targetEnd = targetRect[axis.end];
  var withoutDragging = removeDraggableFromList(draggable, insideDestination);
  var combineWith = find(withoutDragging, function (child) {
    var id = child.descriptor.id;
    var childRect = child.page.borderBox;
    var childSize = childRect[axis.size];
    var threshold = childSize / combineThresholdDivisor;
    var didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
    var isDisplaced = getIsDisplaced({
      displaced: previousImpact.displaced,
      id: id
    });

    if (didStartAfterCritical$1) {
      if (isDisplaced) {
        return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
      }

      return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
    }

    if (isDisplaced) {
      return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
    }

    return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
  });

  if (!combineWith) {
    return null;
  }

  var impact = {
    displacedBy: displacedBy,
    displaced: previousImpact.displaced,
    at: {
      type: 'COMBINE',
      combine: {
        draggableId: combineWith.descriptor.id,
        droppableId: destination.descriptor.id
      }
    }
  };
  return impact;
});

var getDragImpact = (function (_ref) {
  var pageOffset = _ref.pageOffset,
      draggable = _ref.draggable,
      draggables = _ref.draggables,
      droppables = _ref.droppables,
      previousImpact = _ref.previousImpact,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
  var destinationId = getDroppableOver$1({
    pageBorderBox: pageBorderBox,
    draggable: draggable,
    droppables: droppables
  });

  if (!destinationId) {
    return noImpact;
  }

  var destination = droppables[destinationId];
  var insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
  var pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
  return getCombineImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    previousImpact: previousImpact,
    destination: destination,
    insideDestination: insideDestination,
    afterCritical: afterCritical
  }) || getReorderImpact({
    pageBorderBoxWithDroppableScroll: pageBorderBoxWithDroppableScroll,
    draggable: draggable,
    destination: destination,
    insideDestination: insideDestination,
    last: previousImpact.displaced,
    viewport: viewport,
    afterCritical: afterCritical
  });
});

var patchDroppableMap = (function (droppables, updated) {
  var _extends2;

  return _extends({}, droppables, (_extends2 = {}, _extends2[updated.descriptor.id] = updated, _extends2));
});

var clearUnusedPlaceholder = function clearUnusedPlaceholder(_ref) {
  var previousImpact = _ref.previousImpact,
      impact = _ref.impact,
      droppables = _ref.droppables;
  var last = whatIsDraggedOver(previousImpact);
  var now = whatIsDraggedOver(impact);

  if (!last) {
    return droppables;
  }

  if (last === now) {
    return droppables;
  }

  var lastDroppable = droppables[last];

  if (!lastDroppable.subject.withPlaceholder) {
    return droppables;
  }

  var updated = removePlaceholder(lastDroppable);
  return patchDroppableMap(droppables, updated);
};

var recomputePlaceholders = (function (_ref2) {
  var draggable = _ref2.draggable,
      draggables = _ref2.draggables,
      droppables = _ref2.droppables,
      previousImpact = _ref2.previousImpact,
      impact = _ref2.impact;
  var cleaned = clearUnusedPlaceholder({
    previousImpact: previousImpact,
    impact: impact,
    droppables: droppables
  });
  var isOver = whatIsDraggedOver(impact);

  if (!isOver) {
    return cleaned;
  }

  var droppable = droppables[isOver];

  if (isHomeOf(draggable, droppable)) {
    return cleaned;
  }

  if (droppable.subject.withPlaceholder) {
    return cleaned;
  }

  var patched = addPlaceholder(droppable, draggable, draggables);
  return patchDroppableMap(cleaned, patched);
});

var update$1 = (function (_ref) {
  var state = _ref.state,
      forcedClientSelection = _ref.clientSelection,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport,
      forcedImpact = _ref.impact,
      scrollJumpRequest = _ref.scrollJumpRequest;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var clientSelection = forcedClientSelection || state.current.client.selection;
  var offset = subtract(clientSelection, state.initial.client.selection);
  var client = {
    offset: offset,
    selection: clientSelection,
    borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
  };
  var page = {
    selection: add(client.selection, viewport.scroll.current),
    borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
    offset: add(client.offset, viewport.scroll.diff.value)
  };
  var current = {
    client: client,
    page: page
  };

  if (state.phase === 'COLLECTING') {
    return _extends({
      phase: 'COLLECTING'
    }, state, {
      dimensions: dimensions,
      viewport: viewport,
      current: current
    });
  }

  var draggable = dimensions.draggables[state.critical.draggable.id];
  var newImpact = forcedImpact || getDragImpact({
    pageOffset: page.offset,
    draggable: draggable,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: state.impact,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  var withUpdatedPlaceholders = recomputePlaceholders({
    draggable: draggable,
    impact: newImpact,
    previousImpact: state.impact,
    draggables: dimensions.draggables,
    droppables: dimensions.droppables
  });

  var result = _extends({}, state, {
    current: current,
    dimensions: {
      draggables: dimensions.draggables,
      droppables: withUpdatedPlaceholders
    },
    impact: newImpact,
    viewport: viewport,
    scrollJumpRequest: scrollJumpRequest || null,
    forceShouldAnimate: scrollJumpRequest ? false : null
  });

  return result;
});

function getDraggables$1(ids, draggables) {
  return ids.map(function (id) {
    return draggables[id];
  });
}

var recompute = (function (_ref) {
  var impact = _ref.impact,
      viewport = _ref.viewport,
      draggables = _ref.draggables,
      destination = _ref.destination,
      forceShouldAnimate = _ref.forceShouldAnimate;
  var last = impact.displaced;
  var afterDragging = getDraggables$1(last.all, draggables);
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: destination,
    displacedBy: impact.displacedBy,
    viewport: viewport.frame,
    forceShouldAnimate: forceShouldAnimate,
    last: last
  });
  return _extends({}, impact, {
    displaced: displaced
  });
});

var getClientBorderBoxCenter = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      droppable = _ref.droppable,
      draggables = _ref.draggables,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    droppable: droppable,
    afterCritical: afterCritical
  });
  return getClientFromPageBorderBoxCenter({
    pageBorderBoxCenter: pageBorderBoxCenter,
    draggable: draggable,
    viewport: viewport
  });
});

var refreshSnap = (function (_ref) {
  var state = _ref.state,
      forcedDimensions = _ref.dimensions,
      forcedViewport = _ref.viewport;
  !(state.movementMode === 'SNAP') ? process.env.NODE_ENV !== "production" ? invariant$2(false) : invariant$2(false) : void 0;
  var needsVisibilityCheck = state.impact;
  var viewport = forcedViewport || state.viewport;
  var dimensions = forcedDimensions || state.dimensions;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var draggable = draggables[state.critical.draggable.id];
  var isOver = whatIsDraggedOver(needsVisibilityCheck);
  !isOver ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Must be over a destination in SNAP movement mode') : invariant$2(false) : void 0;
  var destination = droppables[isOver];
  var impact = recompute({
    impact: needsVisibilityCheck,
    viewport: viewport,
    destination: destination,
    draggables: draggables
  });
  var clientSelection = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    droppable: destination,
    draggables: draggables,
    viewport: viewport,
    afterCritical: state.afterCritical
  });
  return update$1({
    impact: impact,
    clientSelection: clientSelection,
    state: state,
    dimensions: dimensions,
    viewport: viewport
  });
});

var getHomeLocation = (function (descriptor) {
  return {
    index: descriptor.index,
    droppableId: descriptor.droppableId
  };
});

var getLiftEffect = (function (_ref) {
  var draggable = _ref.draggable,
      home = _ref.home,
      draggables = _ref.draggables,
      viewport = _ref.viewport;
  var displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
  var insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
  var rawIndex = insideHome.indexOf(draggable);
  !(rawIndex !== -1) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Expected draggable to be inside home list') : invariant$2(false) : void 0;
  var afterDragging = insideHome.slice(rawIndex + 1);
  var effected = afterDragging.reduce(function (previous, item) {
    previous[item.descriptor.id] = true;
    return previous;
  }, {});
  var afterCritical = {
    inVirtualList: home.descriptor.mode === 'virtual',
    displacedBy: displacedBy,
    effected: effected
  };
  var displaced = getDisplacementGroups({
    afterDragging: afterDragging,
    destination: home,
    displacedBy: displacedBy,
    last: null,
    viewport: viewport.frame,
    forceShouldAnimate: false
  });
  var impact = {
    displaced: displaced,
    displacedBy: displacedBy,
    at: {
      type: 'REORDER',
      destination: getHomeLocation(draggable.descriptor)
    }
  };
  return {
    impact: impact,
    afterCritical: afterCritical
  };
});

var patchDimensionMap = (function (dimensions, updated) {
  return {
    draggables: dimensions.draggables,
    droppables: patchDroppableMap(dimensions.droppables, updated)
  };
});

var start$2 = function start(key) {
  if (process.env.NODE_ENV !== 'production') {
    {
      return;
    }
  }
};
var finish = function finish(key) {
  if (process.env.NODE_ENV !== 'production') {
    {
      return;
    }
  }
};

var offsetDraggable = (function (_ref) {
  var draggable = _ref.draggable,
      offset$1 = _ref.offset,
      initialWindowScroll = _ref.initialWindowScroll;
  var client = offset(draggable.client, offset$1);
  var page = withScroll(client, initialWindowScroll);

  var moved = _extends({}, draggable, {
    placeholder: _extends({}, draggable.placeholder, {
      client: client
    }),
    client: client,
    page: page
  });

  return moved;
});

var getFrame = (function (droppable) {
  var frame = droppable.frame;
  !frame ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Expected Droppable to have a frame') : invariant$2(false) : void 0;
  return frame;
});

var adjustAdditionsForScrollChanges = (function (_ref) {
  var additions = _ref.additions,
      updatedDroppables = _ref.updatedDroppables,
      viewport = _ref.viewport;
  var windowScrollChange = viewport.scroll.diff.value;
  return additions.map(function (draggable) {
    var droppableId = draggable.descriptor.droppableId;
    var modified = updatedDroppables[droppableId];
    var frame = getFrame(modified);
    var droppableScrollChange = frame.scroll.diff.value;
    var totalChange = add(windowScrollChange, droppableScrollChange);
    var moved = offsetDraggable({
      draggable: draggable,
      offset: totalChange,
      initialWindowScroll: viewport.scroll.initial
    });
    return moved;
  });
});

var publishWhileDraggingInVirtual = (function (_ref) {
  var state = _ref.state,
      published = _ref.published;
  start$2();
  var withScrollChange = published.modified.map(function (update) {
    var existing = state.dimensions.droppables[update.droppableId];
    var scrolled = scrollDroppable(existing, update.scroll);
    return scrolled;
  });

  var droppables = _extends({}, state.dimensions.droppables, {}, toDroppableMap(withScrollChange));

  var updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
    additions: published.additions,
    updatedDroppables: droppables,
    viewport: state.viewport
  }));

  var draggables = _extends({}, state.dimensions.draggables, {}, updatedAdditions);

  published.removals.forEach(function (id) {
    delete draggables[id];
  });
  var dimensions = {
    droppables: droppables,
    draggables: draggables
  };
  var wasOverId = whatIsDraggedOver(state.impact);
  var wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
  var draggable = dimensions.draggables[state.critical.draggable.id];
  var home = dimensions.droppables[state.critical.droppable.id];

  var _getLiftEffect = getLiftEffect({
    draggable: draggable,
    home: home,
    draggables: draggables,
    viewport: state.viewport
  }),
      onLiftImpact = _getLiftEffect.impact,
      afterCritical = _getLiftEffect.afterCritical;

  var previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
  var impact = getDragImpact({
    pageOffset: state.current.page.offset,
    draggable: dimensions.draggables[state.critical.draggable.id],
    draggables: dimensions.draggables,
    droppables: dimensions.droppables,
    previousImpact: previousImpact,
    viewport: state.viewport,
    afterCritical: afterCritical
  });
  finish();

  var draggingState = _extends({
    phase: 'DRAGGING'
  }, state, {
    phase: 'DRAGGING',
    impact: impact,
    onLiftImpact: onLiftImpact,
    dimensions: dimensions,
    afterCritical: afterCritical,
    forceShouldAnimate: false
  });

  if (state.phase === 'COLLECTING') {
    return draggingState;
  }

  var dropPending = _extends({
    phase: 'DROP_PENDING'
  }, draggingState, {
    phase: 'DROP_PENDING',
    reason: state.reason,
    isWaiting: false
  });

  return dropPending;
});

var isSnapping = function isSnapping(state) {
  return state.movementMode === 'SNAP';
};

var postDroppableChange = function postDroppableChange(state, updated, isEnabledChanging) {
  var dimensions = patchDimensionMap(state.dimensions, updated);

  if (!isSnapping(state) || isEnabledChanging) {
    return update$1({
      state: state,
      dimensions: dimensions
    });
  }

  return refreshSnap({
    state: state,
    dimensions: dimensions
  });
};

function removeScrollJumpRequest(state) {
  if (state.isDragging && state.movementMode === 'SNAP') {
    return _extends({
      phase: 'DRAGGING'
    }, state, {
      scrollJumpRequest: null
    });
  }

  return state;
}

var idle = {
  phase: 'IDLE',
  completed: null,
  shouldFlush: false
};
var reducer = (function (state, action) {
  if (state === void 0) {
    state = idle;
  }

  if (action.type === 'FLUSH') {
    return _extends({}, idle, {
      shouldFlush: true
    });
  }

  if (action.type === 'INITIAL_PUBLISH') {
    !(state.phase === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'INITIAL_PUBLISH must come after a IDLE phase') : invariant$2(false) : void 0;
    var _action$payload = action.payload,
        critical = _action$payload.critical,
        clientSelection = _action$payload.clientSelection,
        viewport = _action$payload.viewport,
        dimensions = _action$payload.dimensions,
        movementMode = _action$payload.movementMode;
    var draggable = dimensions.draggables[critical.draggable.id];
    var home = dimensions.droppables[critical.droppable.id];
    var client = {
      selection: clientSelection,
      borderBoxCenter: draggable.client.borderBox.center,
      offset: origin
    };
    var initial = {
      client: client,
      page: {
        selection: add(client.selection, viewport.scroll.initial),
        borderBoxCenter: add(client.selection, viewport.scroll.initial),
        offset: add(client.selection, viewport.scroll.diff.value)
      }
    };
    var isWindowScrollAllowed = toDroppableList(dimensions.droppables).every(function (item) {
      return !item.isFixedOnPage;
    });

    var _getLiftEffect = getLiftEffect({
      draggable: draggable,
      home: home,
      draggables: dimensions.draggables,
      viewport: viewport
    }),
        impact = _getLiftEffect.impact,
        afterCritical = _getLiftEffect.afterCritical;

    var result = {
      phase: 'DRAGGING',
      isDragging: true,
      critical: critical,
      movementMode: movementMode,
      dimensions: dimensions,
      initial: initial,
      current: initial,
      isWindowScrollAllowed: isWindowScrollAllowed,
      impact: impact,
      afterCritical: afterCritical,
      onLiftImpact: impact,
      viewport: viewport,
      scrollJumpRequest: null,
      forceShouldAnimate: null
    };
    return result;
  }

  if (action.type === 'COLLECTION_STARTING') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Collection cannot start from phase " + state.phase) : invariant$2(false) : void 0;

    var _result = _extends({
      phase: 'COLLECTING'
    }, state, {
      phase: 'COLLECTING'
    });

    return _result;
  }

  if (action.type === 'PUBLISH_WHILE_DRAGGING') {
    !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Unexpected " + action.type + " received in phase " + state.phase) : invariant$2(false) : void 0;
    return publishWhileDraggingInVirtual({
      state: state,
      published: action.payload
    });
  }

  if (action.type === 'MOVE') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$2(false, action.type + " not permitted in phase " + state.phase) : invariant$2(false) : void 0;
    var _clientSelection = action.payload.client;

    if (isEqual$4(_clientSelection, state.current.client.selection)) {
      return state;
    }

    return update$1({
      state: state,
      clientSelection: _clientSelection,
      impact: isSnapping(state) ? state.impact : null
    });
  }

  if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
    if (state.phase === 'DROP_PENDING') {
      return removeScrollJumpRequest(state);
    }

    if (state.phase === 'COLLECTING') {
      return removeScrollJumpRequest(state);
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$2(false, action.type + " not permitted in phase " + state.phase) : invariant$2(false) : void 0;
    var _action$payload2 = action.payload,
        id = _action$payload2.id,
        newScroll = _action$payload2.newScroll;
    var target = state.dimensions.droppables[id];

    if (!target) {
      return state;
    }

    var scrolled = scrollDroppable(target, newScroll);
    return postDroppableChange(state, scrolled, false);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Attempting to move in an unsupported phase " + state.phase) : invariant$2(false) : void 0;
    var _action$payload3 = action.payload,
        _id = _action$payload3.id,
        isEnabled = _action$payload3.isEnabled;
    var _target = state.dimensions.droppables[_id];
    !_target ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find Droppable[id: " + _id + "] to toggle its enabled state") : invariant$2(false) : void 0;
    !(_target.isEnabled !== isEnabled) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Trying to set droppable isEnabled to " + String(isEnabled) + "\n      but it is already " + String(_target.isEnabled)) : invariant$2(false) : void 0;

    var updated = _extends({}, _target, {
      isEnabled: isEnabled
    });

    return postDroppableChange(state, updated, true);
  }

  if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
    if (state.phase === 'DROP_PENDING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Attempting to move in an unsupported phase " + state.phase) : invariant$2(false) : void 0;
    var _action$payload4 = action.payload,
        _id2 = _action$payload4.id,
        isCombineEnabled = _action$payload4.isCombineEnabled;
    var _target2 = state.dimensions.droppables[_id2];
    !_target2 ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find Droppable[id: " + _id2 + "] to toggle its isCombineEnabled state") : invariant$2(false) : void 0;
    !(_target2.isCombineEnabled !== isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Trying to set droppable isCombineEnabled to " + String(isCombineEnabled) + "\n      but it is already " + String(_target2.isCombineEnabled)) : invariant$2(false) : void 0;

    var _updated = _extends({}, _target2, {
      isCombineEnabled: isCombineEnabled
    });

    return postDroppableChange(state, _updated, true);
  }

  if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
    if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') {
      return state;
    }

    !isMovementAllowed(state) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot move by window in phase " + state.phase) : invariant$2(false) : void 0;
    !state.isWindowScrollAllowed ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Window scrolling is currently not supported for fixed lists') : invariant$2(false) : void 0;
    var _newScroll = action.payload.newScroll;

    if (isEqual$4(state.viewport.scroll.current, _newScroll)) {
      return removeScrollJumpRequest(state);
    }

    var _viewport = scrollViewport(state.viewport, _newScroll);

    if (isSnapping(state)) {
      return refreshSnap({
        state: state,
        viewport: _viewport
      });
    }

    return update$1({
      state: state,
      viewport: _viewport
    });
  }

  if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
    if (!isMovementAllowed(state)) {
      return state;
    }

    var maxScroll = action.payload.maxScroll;

    if (isEqual$4(maxScroll, state.viewport.scroll.max)) {
      return state;
    }

    var withMaxScroll = _extends({}, state.viewport, {
      scroll: _extends({}, state.viewport.scroll, {
        max: maxScroll
      })
    });

    return _extends({
      phase: 'DRAGGING'
    }, state, {
      viewport: withMaxScroll
    });
  }

  if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
    if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') {
      return state;
    }

    !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant$2(false, action.type + " received while not in DRAGGING phase") : invariant$2(false) : void 0;

    var _result2 = moveInDirection({
      state: state,
      type: action.type
    });

    if (!_result2) {
      return state;
    }

    return update$1({
      state: state,
      impact: _result2.impact,
      clientSelection: _result2.clientSelection,
      scrollJumpRequest: _result2.scrollJumpRequest
    });
  }

  if (action.type === 'DROP_PENDING') {
    var reason = action.payload.reason;
    !(state.phase === 'COLLECTING') ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Can only move into the DROP_PENDING phase from the COLLECTING phase') : invariant$2(false) : void 0;

    var newState = _extends({
      phase: 'DROP_PENDING'
    }, state, {
      phase: 'DROP_PENDING',
      isWaiting: true,
      reason: reason
    });

    return newState;
  }

  if (action.type === 'DROP_ANIMATE') {
    var _action$payload5 = action.payload,
        completed = _action$payload5.completed,
        dropDuration = _action$payload5.dropDuration,
        newHomeClientOffset = _action$payload5.newHomeClientOffset;
    !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot animate drop from phase " + state.phase) : invariant$2(false) : void 0;
    var _result3 = {
      phase: 'DROP_ANIMATING',
      completed: completed,
      dropDuration: dropDuration,
      newHomeClientOffset: newHomeClientOffset,
      dimensions: state.dimensions
    };
    return _result3;
  }

  if (action.type === 'DROP_COMPLETE') {
    var _completed = action.payload.completed;
    return {
      phase: 'IDLE',
      completed: _completed,
      shouldFlush: false
    };
  }

  return state;
});

var beforeInitialCapture = function beforeInitialCapture(args) {
  return {
    type: 'BEFORE_INITIAL_CAPTURE',
    payload: args
  };
};
var lift = function lift(args) {
  return {
    type: 'LIFT',
    payload: args
  };
};
var initialPublish = function initialPublish(args) {
  return {
    type: 'INITIAL_PUBLISH',
    payload: args
  };
};
var publishWhileDragging = function publishWhileDragging(args) {
  return {
    type: 'PUBLISH_WHILE_DRAGGING',
    payload: args
  };
};
var collectionStarting = function collectionStarting() {
  return {
    type: 'COLLECTION_STARTING',
    payload: null
  };
};
var updateDroppableScroll = function updateDroppableScroll(args) {
  return {
    type: 'UPDATE_DROPPABLE_SCROLL',
    payload: args
  };
};
var updateDroppableIsEnabled = function updateDroppableIsEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_ENABLED',
    payload: args
  };
};
var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(args) {
  return {
    type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
    payload: args
  };
};
var move = function move(args) {
  return {
    type: 'MOVE',
    payload: args
  };
};
var moveByWindowScroll = function moveByWindowScroll(args) {
  return {
    type: 'MOVE_BY_WINDOW_SCROLL',
    payload: args
  };
};
var updateViewportMaxScroll = function updateViewportMaxScroll(args) {
  return {
    type: 'UPDATE_VIEWPORT_MAX_SCROLL',
    payload: args
  };
};
var moveUp = function moveUp() {
  return {
    type: 'MOVE_UP',
    payload: null
  };
};
var moveDown = function moveDown() {
  return {
    type: 'MOVE_DOWN',
    payload: null
  };
};
var moveRight = function moveRight() {
  return {
    type: 'MOVE_RIGHT',
    payload: null
  };
};
var moveLeft = function moveLeft() {
  return {
    type: 'MOVE_LEFT',
    payload: null
  };
};
var flush$1 = function flush() {
  return {
    type: 'FLUSH',
    payload: null
  };
};
var animateDrop = function animateDrop(args) {
  return {
    type: 'DROP_ANIMATE',
    payload: args
  };
};
var completeDrop = function completeDrop(args) {
  return {
    type: 'DROP_COMPLETE',
    payload: args
  };
};
var drop = function drop(args) {
  return {
    type: 'DROP',
    payload: args
  };
};
var dropPending = function dropPending(args) {
  return {
    type: 'DROP_PENDING',
    payload: args
  };
};
var dropAnimationFinished = function dropAnimationFinished() {
  return {
    type: 'DROP_ANIMATION_FINISHED',
    payload: null
  };
};

function checkIndexes(insideDestination) {
  if (insideDestination.length <= 1) {
    return;
  }

  var indexes = insideDestination.map(function (d) {
    return d.descriptor.index;
  });
  var errors = {};

  for (var i = 1; i < indexes.length; i++) {
    var current = indexes[i];
    var previous = indexes[i - 1];

    if (current !== previous + 1) {
      errors[current] = true;
    }
  }

  if (!Object.keys(errors).length) {
    return;
  }

  var formatted = indexes.map(function (index) {
    var hasError = Boolean(errors[index]);
    return hasError ? "[\uD83D\uDD25" + index + "]" : "" + index;
  }).join(', ');
  process.env.NODE_ENV !== "production" ? warning$1("\n    Detected non-consecutive <Draggable /> indexes.\n\n    (This can cause unexpected bugs)\n\n    " + formatted + "\n  ") : void 0;
}

function validateDimensions(critical, dimensions) {
  if (process.env.NODE_ENV !== 'production') {
    var insideDestination = getDraggablesInsideDroppable(critical.droppable.id, dimensions.draggables);
    checkIndexes(insideDestination);
  }
}

var lift$1 = (function (marshal) {
  return function (_ref) {
    var getState = _ref.getState,
        dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type !== 'LIFT') {
          next(action);
          return;
        }

        var _action$payload = action.payload,
            id = _action$payload.id,
            clientSelection = _action$payload.clientSelection,
            movementMode = _action$payload.movementMode;
        var initial = getState();

        if (initial.phase === 'DROP_ANIMATING') {
          dispatch(completeDrop({
            completed: initial.completed
          }));
        }

        !(getState().phase === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Unexpected phase to start a drag') : invariant$2(false) : void 0;
        dispatch(flush$1());
        dispatch(beforeInitialCapture({
          draggableId: id,
          movementMode: movementMode
        }));
        var scrollOptions = {
          shouldPublishImmediately: movementMode === 'SNAP'
        };
        var request = {
          draggableId: id,
          scrollOptions: scrollOptions
        };

        var _marshal$startPublish = marshal.startPublishing(request),
            critical = _marshal$startPublish.critical,
            dimensions = _marshal$startPublish.dimensions,
            viewport = _marshal$startPublish.viewport;

        validateDimensions(critical, dimensions);
        dispatch(initialPublish({
          critical: critical,
          dimensions: dimensions,
          clientSelection: clientSelection,
          movementMode: movementMode,
          viewport: viewport
        }));
      };
    };
  };
});

var style = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          marshal.dragging();
        }

        if (action.type === 'DROP_ANIMATE') {
          marshal.dropping(action.payload.completed.result.reason);
        }

        if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE') {
          marshal.resting();
        }

        next(action);
      };
    };
  };
});

var curves = {
  outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
  drop: 'cubic-bezier(.2,1,.1,1)'
};
var combine = {
  opacity: {
    drop: 0,
    combining: 0.7
  },
  scale: {
    drop: 0.75
  }
};
var timings = {
  outOfTheWay: 0.2,
  minDropTime: 0.33,
  maxDropTime: 0.55
};
var outOfTheWayTiming = timings.outOfTheWay + "s " + curves.outOfTheWay;
var transitions = {
  fluid: "opacity " + outOfTheWayTiming,
  snap: "transform " + outOfTheWayTiming + ", opacity " + outOfTheWayTiming,
  drop: function drop(duration) {
    var timing = duration + "s " + curves.drop;
    return "transform " + timing + ", opacity " + timing;
  },
  outOfTheWay: "transform " + outOfTheWayTiming,
  placeholder: "height " + outOfTheWayTiming + ", width " + outOfTheWayTiming + ", margin " + outOfTheWayTiming
};

var moveTo = function moveTo(offset) {
  return isEqual$4(offset, origin) ? null : "translate(" + offset.x + "px, " + offset.y + "px)";
};

var transforms = {
  moveTo: moveTo,
  drop: function drop(offset, isCombining) {
    var translate = moveTo(offset);

    if (!translate) {
      return null;
    }

    if (!isCombining) {
      return translate;
    }

    return translate + " scale(" + combine.scale.drop + ")";
  }
};

var minDropTime = timings.minDropTime,
    maxDropTime = timings.maxDropTime;
var dropTimeRange = maxDropTime - minDropTime;
var maxDropTimeAtDistance = 1500;
var cancelDropModifier = 0.6;
var getDropDuration = (function (_ref) {
  var current = _ref.current,
      destination = _ref.destination,
      reason = _ref.reason;
  var distance$1 = distance(current, destination);

  if (distance$1 <= 0) {
    return minDropTime;
  }

  if (distance$1 >= maxDropTimeAtDistance) {
    return maxDropTime;
  }

  var percentage = distance$1 / maxDropTimeAtDistance;
  var duration = minDropTime + dropTimeRange * percentage;
  var withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
  return Number(withDuration.toFixed(2));
});

var getNewHomeClientOffset = (function (_ref) {
  var impact = _ref.impact,
      draggable = _ref.draggable,
      dimensions = _ref.dimensions,
      viewport = _ref.viewport,
      afterCritical = _ref.afterCritical;
  var draggables = dimensions.draggables,
      droppables = dimensions.droppables;
  var droppableId = whatIsDraggedOver(impact);
  var destination = droppableId ? droppables[droppableId] : null;
  var home = droppables[draggable.descriptor.droppableId];
  var newClientCenter = getClientBorderBoxCenter({
    impact: impact,
    draggable: draggable,
    draggables: draggables,
    afterCritical: afterCritical,
    droppable: destination || home,
    viewport: viewport
  });
  var offset = subtract(newClientCenter, draggable.client.borderBox.center);
  return offset;
});

var getDropImpact = (function (_ref) {
  var draggables = _ref.draggables,
      reason = _ref.reason,
      lastImpact = _ref.lastImpact,
      home = _ref.home,
      viewport = _ref.viewport,
      onLiftImpact = _ref.onLiftImpact;

  if (!lastImpact.at || reason !== 'DROP') {
    var recomputedHomeImpact = recompute({
      draggables: draggables,
      impact: onLiftImpact,
      destination: home,
      viewport: viewport,
      forceShouldAnimate: true
    });
    return {
      impact: recomputedHomeImpact,
      didDropInsideDroppable: false
    };
  }

  if (lastImpact.at.type === 'REORDER') {
    return {
      impact: lastImpact,
      didDropInsideDroppable: true
    };
  }

  var withoutMovement = _extends({}, lastImpact, {
    displaced: emptyGroups
  });

  return {
    impact: withoutMovement,
    didDropInsideDroppable: true
  };
});

var drop$1 = (function (_ref) {
  var getState = _ref.getState,
      dispatch = _ref.dispatch;
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP') {
        next(action);
        return;
      }

      var state = getState();
      var reason = action.payload.reason;

      if (state.phase === 'COLLECTING') {
        dispatch(dropPending({
          reason: reason
        }));
        return;
      }

      if (state.phase === 'IDLE') {
        return;
      }

      var isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
      !!isWaitingForDrop ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'A DROP action occurred while DROP_PENDING and still waiting') : invariant$2(false) : void 0;
      !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot drop in phase: " + state.phase) : invariant$2(false) : void 0;
      var critical = state.critical;
      var dimensions = state.dimensions;
      var draggable = dimensions.draggables[state.critical.draggable.id];

      var _getDropImpact = getDropImpact({
        reason: reason,
        lastImpact: state.impact,
        afterCritical: state.afterCritical,
        onLiftImpact: state.onLiftImpact,
        home: state.dimensions.droppables[state.critical.droppable.id],
        viewport: state.viewport,
        draggables: state.dimensions.draggables
      }),
          impact = _getDropImpact.impact,
          didDropInsideDroppable = _getDropImpact.didDropInsideDroppable;

      var destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
      var combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
      var source = {
        index: critical.draggable.index,
        droppableId: critical.droppable.id
      };
      var result = {
        draggableId: draggable.descriptor.id,
        type: draggable.descriptor.type,
        source: source,
        reason: reason,
        mode: state.movementMode,
        destination: destination,
        combine: combine
      };
      var newHomeClientOffset = getNewHomeClientOffset({
        impact: impact,
        draggable: draggable,
        dimensions: dimensions,
        viewport: state.viewport,
        afterCritical: state.afterCritical
      });
      var completed = {
        critical: state.critical,
        afterCritical: state.afterCritical,
        result: result,
        impact: impact
      };
      var isAnimationRequired = !isEqual$4(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);

      if (!isAnimationRequired) {
        dispatch(completeDrop({
          completed: completed
        }));
        return;
      }

      var dropDuration = getDropDuration({
        current: state.current.client.offset,
        destination: newHomeClientOffset,
        reason: reason
      });
      var args = {
        newHomeClientOffset: newHomeClientOffset,
        dropDuration: dropDuration,
        completed: completed
      };
      dispatch(animateDrop(args));
    };
  };
});

var getWindowScroll = (function () {
  return {
    x: window.pageXOffset,
    y: window.pageYOffset
  };
});

function getWindowScrollBinding(update) {
  return {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn(event) {
      if (event.target !== window && event.target !== window.document) {
        return;
      }

      update();
    }
  };
}

function getScrollListener(_ref) {
  var onWindowScroll = _ref.onWindowScroll;

  function updateScroll() {
    onWindowScroll(getWindowScroll());
  }

  var scheduled = rafSchd$1(updateScroll);
  var binding = getWindowScrollBinding(scheduled);
  var unbind = noop$6;

  function isActive() {
    return unbind !== noop$6;
  }

  function start() {
    !!isActive() ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot start scroll listener when already active') : invariant$2(false) : void 0;
    unbind = bindEvents(window, [binding]);
  }

  function stop() {
    !isActive() ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot stop scroll listener when not active') : invariant$2(false) : void 0;
    scheduled.cancel();
    unbind();
    unbind = noop$6;
  }

  return {
    start: start,
    stop: stop,
    isActive: isActive
  };
}

var shouldEnd = function shouldEnd(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var scrollListener = (function (store) {
  var listener = getScrollListener({
    onWindowScroll: function onWindowScroll(newScroll) {
      store.dispatch(moveByWindowScroll({
        newScroll: newScroll
      }));
    }
  });
  return function (next) {
    return function (action) {
      if (!listener.isActive() && action.type === 'INITIAL_PUBLISH') {
        listener.start();
      }

      if (listener.isActive() && shouldEnd(action)) {
        listener.stop();
      }

      next(action);
    };
  };
});

var getExpiringAnnounce = (function (announce) {
  var wasCalled = false;
  var isExpired = false;
  var timeoutId = setTimeout(function () {
    isExpired = true;
  });

  var result = function result(message) {
    if (wasCalled) {
      process.env.NODE_ENV !== "production" ? warning$1('Announcement already made. Not making a second announcement') : void 0;
      return;
    }

    if (isExpired) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Announcements cannot be made asynchronously.\n        Default message has already been announced.\n      ") : void 0;
      return;
    }

    wasCalled = true;
    announce(message);
    clearTimeout(timeoutId);
  };

  result.wasCalled = function () {
    return wasCalled;
  };

  return result;
});

var getAsyncMarshal = (function () {
  var entries = [];

  var execute = function execute(timerId) {
    var index = findIndex$2(entries, function (item) {
      return item.timerId === timerId;
    });
    !(index !== -1) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Could not find timer') : invariant$2(false) : void 0;

    var _entries$splice = entries.splice(index, 1),
        entry = _entries$splice[0];

    entry.callback();
  };

  var add = function add(fn) {
    var timerId = setTimeout(function () {
      return execute(timerId);
    });
    var entry = {
      timerId: timerId,
      callback: fn
    };
    entries.push(entry);
  };

  var flush = function flush() {
    if (!entries.length) {
      return;
    }

    var shallow = [].concat(entries);
    entries.length = 0;
    shallow.forEach(function (entry) {
      clearTimeout(entry.timerId);
      entry.callback();
    });
  };

  return {
    add: add,
    flush: flush
  };
});

var areLocationsEqual = function areLocationsEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.droppableId === second.droppableId && first.index === second.index;
};
var isCombineEqual = function isCombineEqual(first, second) {
  if (first == null && second == null) {
    return true;
  }

  if (first == null || second == null) {
    return false;
  }

  return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
var isCriticalEqual = function isCriticalEqual(first, second) {
  if (first === second) {
    return true;
  }

  var isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
  var isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
  return isDraggableEqual && isDroppableEqual;
};

var withTimings = function withTimings(key, fn) {
  start$2();
  fn();
  finish();
};

var getDragStart = function getDragStart(critical, mode) {
  return {
    draggableId: critical.draggable.id,
    type: critical.droppable.type,
    source: {
      droppableId: critical.droppable.id,
      index: critical.draggable.index
    },
    mode: mode
  };
};

var execute = function execute(responder, data, announce, getDefaultMessage) {
  if (!responder) {
    announce(getDefaultMessage(data));
    return;
  }

  var willExpire = getExpiringAnnounce(announce);
  var provided = {
    announce: willExpire
  };
  responder(data, provided);

  if (!willExpire.wasCalled()) {
    announce(getDefaultMessage(data));
  }
};

var getPublisher = (function (getResponders, announce) {
  var asyncMarshal = getAsyncMarshal();
  var dragging = null;

  var beforeCapture = function beforeCapture(draggableId, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot fire onBeforeCapture as a drag start has already been published') : invariant$2(false) : void 0;
    withTimings('onBeforeCapture', function () {
      var fn = getResponders().onBeforeCapture;

      if (fn) {
        var before = {
          draggableId: draggableId,
          mode: mode
        };
        fn(before);
      }
    });
  };

  var beforeStart = function beforeStart(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant$2(false) : void 0;
    withTimings('onBeforeDragStart', function () {
      var fn = getResponders().onBeforeDragStart;

      if (fn) {
        fn(getDragStart(critical, mode));
      }
    });
  };

  var start = function start(critical, mode) {
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot fire onBeforeDragStart as a drag start has already been published') : invariant$2(false) : void 0;
    var data = getDragStart(critical, mode);
    dragging = {
      mode: mode,
      lastCritical: critical,
      lastLocation: data.source,
      lastCombine: null
    };
    asyncMarshal.add(function () {
      withTimings('onDragStart', function () {
        return execute(getResponders().onDragStart, data, announce, preset.onDragStart);
      });
    });
  };

  var update = function update(critical, impact) {
    var location = tryGetDestination(impact);
    var combine = tryGetCombine(impact);
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot fire onDragMove when onDragStart has not been called') : invariant$2(false) : void 0;
    var hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);

    if (hasCriticalChanged) {
      dragging.lastCritical = critical;
    }

    var hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);

    if (hasLocationChanged) {
      dragging.lastLocation = location;
    }

    var hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);

    if (hasGroupingChanged) {
      dragging.lastCombine = combine;
    }

    if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) {
      return;
    }

    var data = _extends({}, getDragStart(critical, dragging.mode), {
      combine: combine,
      destination: location
    });

    asyncMarshal.add(function () {
      withTimings('onDragUpdate', function () {
        return execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate);
      });
    });
  };

  var flush = function flush() {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Can only flush responders while dragging') : invariant$2(false) : void 0;
    asyncMarshal.flush();
  };

  var drop = function drop(result) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot fire onDragEnd when there is no matching onDragStart') : invariant$2(false) : void 0;
    dragging = null;
    withTimings('onDragEnd', function () {
      return execute(getResponders().onDragEnd, result, announce, preset.onDragEnd);
    });
  };

  var abort = function abort() {
    if (!dragging) {
      return;
    }

    var result = _extends({}, getDragStart(dragging.lastCritical, dragging.mode), {
      combine: null,
      destination: null,
      reason: 'CANCEL'
    });

    drop(result);
  };

  return {
    beforeCapture: beforeCapture,
    beforeStart: beforeStart,
    start: start,
    update: update,
    flush: flush,
    drop: drop,
    abort: abort
  };
});

var responders = (function (getResponders, announce) {
  var publisher = getPublisher(getResponders, announce);
  return function (store) {
    return function (next) {
      return function (action) {
        if (action.type === 'BEFORE_INITIAL_CAPTURE') {
          publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          var critical = action.payload.critical;
          publisher.beforeStart(critical, action.payload.movementMode);
          next(action);
          publisher.start(critical, action.payload.movementMode);
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          var result = action.payload.completed.result;
          publisher.flush();
          next(action);
          publisher.drop(result);
          return;
        }

        next(action);

        if (action.type === 'FLUSH') {
          publisher.abort();
          return;
        }

        var state = store.getState();

        if (state.phase === 'DRAGGING') {
          publisher.update(state.critical, state.impact);
        }
      };
    };
  };
});

var dropAnimationFinish = (function (store) {
  return function (next) {
    return function (action) {
      if (action.type !== 'DROP_ANIMATION_FINISHED') {
        next(action);
        return;
      }

      var state = store.getState();
      !(state.phase === 'DROP_ANIMATING') ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot finish a drop animating when no drop is occurring') : invariant$2(false) : void 0;
      store.dispatch(completeDrop({
        completed: state.completed
      }));
    };
  };
});

var dropAnimationFlushOnScroll = (function (store) {
  var unbind = null;
  var frameId = null;

  function clear() {
    if (frameId) {
      cancelAnimationFrame(frameId);
      frameId = null;
    }

    if (unbind) {
      unbind();
      unbind = null;
    }
  }

  return function (next) {
    return function (action) {
      if (action.type === 'FLUSH' || action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATION_FINISHED') {
        clear();
      }

      next(action);

      if (action.type !== 'DROP_ANIMATE') {
        return;
      }

      var binding = {
        eventName: 'scroll',
        options: {
          capture: true,
          passive: false,
          once: true
        },
        fn: function flushDropAnimation() {
          var state = store.getState();

          if (state.phase === 'DROP_ANIMATING') {
            store.dispatch(dropAnimationFinished());
          }
        }
      };
      frameId = requestAnimationFrame(function () {
        frameId = null;
        unbind = bindEvents(window, [binding]);
      });
    };
  };
});

var dimensionMarshalStopper = (function (marshal) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'DROP_COMPLETE' || action.type === 'FLUSH' || action.type === 'DROP_ANIMATE') {
          marshal.stopPublishing();
        }

        next(action);
      };
    };
  };
});

var focus = (function (marshal) {
  var isWatching = false;
  return function () {
    return function (next) {
      return function (action) {
        if (action.type === 'INITIAL_PUBLISH') {
          isWatching = true;
          marshal.tryRecordFocus(action.payload.critical.draggable.id);
          next(action);
          marshal.tryRestoreFocusRecorded();
          return;
        }

        next(action);

        if (!isWatching) {
          return;
        }

        if (action.type === 'FLUSH') {
          isWatching = false;
          marshal.tryRestoreFocusRecorded();
          return;
        }

        if (action.type === 'DROP_COMPLETE') {
          isWatching = false;
          var result = action.payload.completed.result;

          if (result.combine) {
            marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
          }

          marshal.tryRestoreFocusRecorded();
        }
      };
    };
  };
});

var shouldStop = function shouldStop(action) {
  return action.type === 'DROP_COMPLETE' || action.type === 'DROP_ANIMATE' || action.type === 'FLUSH';
};

var autoScroll = (function (autoScroller) {
  return function (store) {
    return function (next) {
      return function (action) {
        if (shouldStop(action)) {
          autoScroller.stop();
          next(action);
          return;
        }

        if (action.type === 'INITIAL_PUBLISH') {
          next(action);
          var state = store.getState();
          !(state.phase === 'DRAGGING') ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Expected phase to be DRAGGING after INITIAL_PUBLISH') : invariant$2(false) : void 0;
          autoScroller.start(state);
          return;
        }

        next(action);
        autoScroller.scroll(store.getState());
      };
    };
  };
});

var pendingDrop = (function (store) {
  return function (next) {
    return function (action) {
      next(action);

      if (action.type !== 'PUBLISH_WHILE_DRAGGING') {
        return;
      }

      var postActionState = store.getState();

      if (postActionState.phase !== 'DROP_PENDING') {
        return;
      }

      if (postActionState.isWaiting) {
        return;
      }

      store.dispatch(drop({
        reason: postActionState.reason
      }));
    };
  };
});

var composeEnhancers = process.env.NODE_ENV !== 'production' && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: 'react-beautiful-dnd'
}) : compose$1;
var createStore = (function (_ref) {
  var dimensionMarshal = _ref.dimensionMarshal,
      focusMarshal = _ref.focusMarshal,
      styleMarshal = _ref.styleMarshal,
      getResponders = _ref.getResponders,
      announce = _ref.announce,
      autoScroller = _ref.autoScroller;
  return createStore$1(reducer, composeEnhancers(applyMiddleware(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift$1(dimensionMarshal), drop$1, dropAnimationFinish, dropAnimationFlushOnScroll, pendingDrop, autoScroll(autoScroller), scrollListener, focus(focusMarshal), responders(getResponders, announce))));
});

var clean$1 = function clean() {
  return {
    additions: {},
    removals: {},
    modified: {}
  };
};
function createPublisher(_ref) {
  var registry = _ref.registry,
      callbacks = _ref.callbacks;
  var staging = clean$1();
  var frameId = null;

  var collect = function collect() {
    if (frameId) {
      return;
    }

    callbacks.collectionStarting();
    frameId = requestAnimationFrame(function () {
      frameId = null;
      start$2();
      var _staging = staging,
          additions = _staging.additions,
          removals = _staging.removals,
          modified = _staging.modified;
      var added = Object.keys(additions).map(function (id) {
        return registry.draggable.getById(id).getDimension(origin);
      }).sort(function (a, b) {
        return a.descriptor.index - b.descriptor.index;
      });
      var updated = Object.keys(modified).map(function (id) {
        var entry = registry.droppable.getById(id);
        var scroll = entry.callbacks.getScrollWhileDragging();
        return {
          droppableId: id,
          scroll: scroll
        };
      });
      var result = {
        additions: added,
        removals: Object.keys(removals),
        modified: updated
      };
      staging = clean$1();
      finish();
      callbacks.publish(result);
    });
  };

  var add = function add(entry) {
    var id = entry.descriptor.id;
    staging.additions[id] = entry;
    staging.modified[entry.descriptor.droppableId] = true;

    if (staging.removals[id]) {
      delete staging.removals[id];
    }

    collect();
  };

  var remove = function remove(entry) {
    var descriptor = entry.descriptor;
    staging.removals[descriptor.id] = true;
    staging.modified[descriptor.droppableId] = true;

    if (staging.additions[descriptor.id]) {
      delete staging.additions[descriptor.id];
    }

    collect();
  };

  var stop = function stop() {
    if (!frameId) {
      return;
    }

    cancelAnimationFrame(frameId);
    frameId = null;
    staging = clean$1();
  };

  return {
    add: add,
    remove: remove,
    stop: stop
  };
}

var getMaxScroll = (function (_ref) {
  var scrollHeight = _ref.scrollHeight,
      scrollWidth = _ref.scrollWidth,
      height = _ref.height,
      width = _ref.width;
  var maxScroll = subtract({
    x: scrollWidth,
    y: scrollHeight
  }, {
    x: width,
    y: height
  });
  var adjustedMaxScroll = {
    x: Math.max(0, maxScroll.x),
    y: Math.max(0, maxScroll.y)
  };
  return adjustedMaxScroll;
});

var getDocumentElement = (function () {
  var doc = document.documentElement;
  !doc ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot find document.documentElement') : invariant$2(false) : void 0;
  return doc;
});

var getMaxWindowScroll = (function () {
  var doc = getDocumentElement();
  var maxScroll = getMaxScroll({
    scrollHeight: doc.scrollHeight,
    scrollWidth: doc.scrollWidth,
    width: doc.clientWidth,
    height: doc.clientHeight
  });
  return maxScroll;
});

var getViewport = (function () {
  var scroll = getWindowScroll();
  var maxScroll = getMaxWindowScroll();
  var top = scroll.y;
  var left = scroll.x;
  var doc = getDocumentElement();
  var width = doc.clientWidth;
  var height = doc.clientHeight;
  var right = left + width;
  var bottom = top + height;
  var frame = getRect({
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });
  var viewport = {
    frame: frame,
    scroll: {
      initial: scroll,
      current: scroll,
      max: maxScroll,
      diff: {
        value: origin,
        displacement: origin
      }
    }
  };
  return viewport;
});

var getInitialPublish = (function (_ref) {
  var critical = _ref.critical,
      scrollOptions = _ref.scrollOptions,
      registry = _ref.registry;
  start$2();
  var viewport = getViewport();
  var windowScroll = viewport.scroll.current;
  var home = critical.droppable;
  var droppables = registry.droppable.getAllByType(home.type).map(function (entry) {
    return entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions);
  });
  var draggables = registry.draggable.getAllByType(critical.draggable.type).map(function (entry) {
    return entry.getDimension(windowScroll);
  });
  var dimensions = {
    draggables: toDraggableMap(draggables),
    droppables: toDroppableMap(droppables)
  };
  finish();
  var result = {
    dimensions: dimensions,
    critical: critical,
    viewport: viewport
  };
  return result;
});

function shouldPublishUpdate(registry, dragging, entry) {
  if (entry.descriptor.id === dragging.id) {
    return false;
  }

  if (entry.descriptor.type !== dragging.type) {
    return false;
  }

  var home = registry.droppable.getById(entry.descriptor.droppableId);

  if (home.descriptor.mode !== 'virtual') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      You are attempting to add or remove a Draggable [id: " + entry.descriptor.id + "]\n      while a drag is occurring. This is only supported for virtual lists.\n\n      See https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/patterns/virtual-lists.md\n    ") : void 0;
    return false;
  }

  return true;
}

var createDimensionMarshal = (function (registry, callbacks) {
  var collection = null;
  var publisher = createPublisher({
    callbacks: {
      publish: callbacks.publishWhileDragging,
      collectionStarting: callbacks.collectionStarting
    },
    registry: registry
  });

  var updateDroppableIsEnabled = function updateDroppableIsEnabled(id, isEnabled) {
    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot update is enabled flag of Droppable " + id + " as it is not registered") : invariant$2(false) : void 0;

    if (!collection) {
      return;
    }

    callbacks.updateDroppableIsEnabled({
      id: id,
      isEnabled: isEnabled
    });
  };

  var updateDroppableIsCombineEnabled = function updateDroppableIsCombineEnabled(id, isCombineEnabled) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot update isCombineEnabled flag of Droppable " + id + " as it is not registered") : invariant$2(false) : void 0;
    callbacks.updateDroppableIsCombineEnabled({
      id: id,
      isCombineEnabled: isCombineEnabled
    });
  };

  var updateDroppableScroll = function updateDroppableScroll(id, newScroll) {
    if (!collection) {
      return;
    }

    !registry.droppable.exists(id) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot update the scroll on Droppable " + id + " as it is not registered") : invariant$2(false) : void 0;
    callbacks.updateDroppableScroll({
      id: id,
      newScroll: newScroll
    });
  };

  var scrollDroppable = function scrollDroppable(id, change) {
    if (!collection) {
      return;
    }

    registry.droppable.getById(id).callbacks.scroll(change);
  };

  var stopPublishing = function stopPublishing() {
    if (!collection) {
      return;
    }

    publisher.stop();
    var home = collection.critical.droppable;
    registry.droppable.getAllByType(home.type).forEach(function (entry) {
      return entry.callbacks.dragStopped();
    });
    collection.unsubscribe();
    collection = null;
  };

  var subscriber = function subscriber(event) {
    !collection ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Should only be subscribed when a collection is occurring') : invariant$2(false) : void 0;
    var dragging = collection.critical.draggable;

    if (event.type === 'ADDITION') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.add(event.value);
      }
    }

    if (event.type === 'REMOVAL') {
      if (shouldPublishUpdate(registry, dragging, event.value)) {
        publisher.remove(event.value);
      }
    }
  };

  var startPublishing = function startPublishing(request) {
    !!collection ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot start capturing critical dimensions as there is already a collection') : invariant$2(false) : void 0;
    var entry = registry.draggable.getById(request.draggableId);
    var home = registry.droppable.getById(entry.descriptor.droppableId);
    var critical = {
      draggable: entry.descriptor,
      droppable: home.descriptor
    };
    var unsubscribe = registry.subscribe(subscriber);
    collection = {
      critical: critical,
      unsubscribe: unsubscribe
    };
    return getInitialPublish({
      critical: critical,
      registry: registry,
      scrollOptions: request.scrollOptions
    });
  };

  var marshal = {
    updateDroppableIsEnabled: updateDroppableIsEnabled,
    updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
    scrollDroppable: scrollDroppable,
    updateDroppableScroll: updateDroppableScroll,
    startPublishing: startPublishing,
    stopPublishing: stopPublishing
  };
  return marshal;
});

var canStartDrag = (function (state, id) {
  if (state.phase === 'IDLE') {
    return true;
  }

  if (state.phase !== 'DROP_ANIMATING') {
    return false;
  }

  if (state.completed.result.draggableId === id) {
    return false;
  }

  return state.completed.result.reason === 'DROP';
});

var scrollWindow = (function (change) {
  window.scrollBy(change.x, change.y);
});

var getScrollableDroppables = memoizeOne(function (droppables) {
  return toDroppableList(droppables).filter(function (droppable) {
    if (!droppable.isEnabled) {
      return false;
    }

    if (!droppable.frame) {
      return false;
    }

    return true;
  });
});

var getScrollableDroppableOver = function getScrollableDroppableOver(target, droppables) {
  var maybe = find(getScrollableDroppables(droppables), function (droppable) {
    !droppable.frame ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Invalid result') : invariant$2(false) : void 0;
    return isPositionInFrame(droppable.frame.pageMarginBox)(target);
  });
  return maybe;
};

var getBestScrollableDroppable = (function (_ref) {
  var center = _ref.center,
      destination = _ref.destination,
      droppables = _ref.droppables;

  if (destination) {
    var _dimension = droppables[destination];

    if (!_dimension.frame) {
      return null;
    }

    return _dimension;
  }

  var dimension = getScrollableDroppableOver(center, droppables);
  return dimension;
});

var config$2 = {
  startFromPercentage: 0.25,
  maxScrollAtPercentage: 0.05,
  maxPixelScroll: 28,
  ease: function ease(percentage) {
    return Math.pow(percentage, 2);
  },
  durationDampening: {
    stopDampeningAt: 1200,
    accelerateAt: 360
  }
};

var getDistanceThresholds = (function (container, axis) {
  var startScrollingFrom = container[axis.size] * config$2.startFromPercentage;
  var maxScrollValueAt = container[axis.size] * config$2.maxScrollAtPercentage;
  var thresholds = {
    startScrollingFrom: startScrollingFrom,
    maxScrollValueAt: maxScrollValueAt
  };
  return thresholds;
});

var getPercentage = (function (_ref) {
  var startOfRange = _ref.startOfRange,
      endOfRange = _ref.endOfRange,
      current = _ref.current;
  var range = endOfRange - startOfRange;

  if (range === 0) {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Detected distance range of 0 in the fluid auto scroller\n      This is unexpected and would cause a divide by 0 issue.\n      Not allowing an auto scroll\n    ") : void 0;
    return 0;
  }

  var currentInRange = current - startOfRange;
  var percentage = currentInRange / range;
  return percentage;
});

var minScroll = 1;

var getValueFromDistance = (function (distanceToEdge, thresholds) {
  if (distanceToEdge > thresholds.startScrollingFrom) {
    return 0;
  }

  if (distanceToEdge <= thresholds.maxScrollValueAt) {
    return config$2.maxPixelScroll;
  }

  if (distanceToEdge === thresholds.startScrollingFrom) {
    return minScroll;
  }

  var percentageFromMaxScrollValueAt = getPercentage({
    startOfRange: thresholds.maxScrollValueAt,
    endOfRange: thresholds.startScrollingFrom,
    current: distanceToEdge
  });
  var percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
  var scroll = config$2.maxPixelScroll * config$2.ease(percentageFromStartScrollingFrom);
  return Math.ceil(scroll);
});

var accelerateAt = config$2.durationDampening.accelerateAt;
var stopAt = config$2.durationDampening.stopDampeningAt;
var dampenValueByTime = (function (proposedScroll, dragStartTime) {
  var startOfRange = dragStartTime;
  var endOfRange = stopAt;
  var now = Date.now();
  var runTime = now - startOfRange;

  if (runTime >= stopAt) {
    return proposedScroll;
  }

  if (runTime < accelerateAt) {
    return minScroll;
  }

  var betweenAccelerateAtAndStopAtPercentage = getPercentage({
    startOfRange: accelerateAt,
    endOfRange: endOfRange,
    current: runTime
  });
  var scroll = proposedScroll * config$2.ease(betweenAccelerateAtAndStopAtPercentage);
  return Math.ceil(scroll);
});

var getValue$4 = (function (_ref) {
  var distanceToEdge = _ref.distanceToEdge,
      thresholds = _ref.thresholds,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getValueFromDistance(distanceToEdge, thresholds);

  if (scroll === 0) {
    return 0;
  }

  if (!shouldUseTimeDampening) {
    return scroll;
  }

  return Math.max(dampenValueByTime(scroll, dragStartTime), minScroll);
});

var getScrollOnAxis = (function (_ref) {
  var container = _ref.container,
      distanceToEdges = _ref.distanceToEdges,
      dragStartTime = _ref.dragStartTime,
      axis = _ref.axis,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var thresholds = getDistanceThresholds(container, axis);
  var isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];

  if (isCloserToEnd) {
    return getValue$4({
      distanceToEdge: distanceToEdges[axis.end],
      thresholds: thresholds,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  }

  return -1 * getValue$4({
    distanceToEdge: distanceToEdges[axis.start],
    thresholds: thresholds,
    dragStartTime: dragStartTime,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
});

var adjustForSizeLimits = (function (_ref) {
  var container = _ref.container,
      subject = _ref.subject,
      proposedScroll = _ref.proposedScroll;
  var isTooBigVertically = subject.height > container.height;
  var isTooBigHorizontally = subject.width > container.width;

  if (!isTooBigHorizontally && !isTooBigVertically) {
    return proposedScroll;
  }

  if (isTooBigHorizontally && isTooBigVertically) {
    return null;
  }

  return {
    x: isTooBigHorizontally ? 0 : proposedScroll.x,
    y: isTooBigVertically ? 0 : proposedScroll.y
  };
});

var clean$2 = apply$2(function (value) {
  return value === 0 ? 0 : value;
});
var getScroll = (function (_ref) {
  var dragStartTime = _ref.dragStartTime,
      container = _ref.container,
      subject = _ref.subject,
      center = _ref.center,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var distanceToEdges = {
    top: center.y - container.top,
    right: container.right - center.x,
    bottom: container.bottom - center.y,
    left: center.x - container.left
  };
  var y = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: vertical,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var x = getScrollOnAxis({
    container: container,
    distanceToEdges: distanceToEdges,
    dragStartTime: dragStartTime,
    axis: horizontal,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  var required = clean$2({
    x: x,
    y: y
  });

  if (isEqual$4(required, origin)) {
    return null;
  }

  var limited = adjustForSizeLimits({
    container: container,
    subject: subject,
    proposedScroll: required
  });

  if (!limited) {
    return null;
  }

  return isEqual$4(limited, origin) ? null : limited;
});

var smallestSigned = apply$2(function (value) {
  if (value === 0) {
    return 0;
  }

  return value > 0 ? 1 : -1;
});
var getOverlap = function () {
  var getRemainder = function getRemainder(target, max) {
    if (target < 0) {
      return target;
    }

    if (target > max) {
      return target - max;
    }

    return 0;
  };

  return function (_ref) {
    var current = _ref.current,
        max = _ref.max,
        change = _ref.change;
    var targetScroll = add(current, change);
    var overlap = {
      x: getRemainder(targetScroll.x, max.x),
      y: getRemainder(targetScroll.y, max.y)
    };

    if (isEqual$4(overlap, origin)) {
      return null;
    }

    return overlap;
  };
}();
var canPartiallyScroll = function canPartiallyScroll(_ref2) {
  var rawMax = _ref2.max,
      current = _ref2.current,
      change = _ref2.change;
  var max = {
    x: Math.max(current.x, rawMax.x),
    y: Math.max(current.y, rawMax.y)
  };
  var smallestChange = smallestSigned(change);
  var overlap = getOverlap({
    max: max,
    current: current,
    change: smallestChange
  });

  if (!overlap) {
    return true;
  }

  if (smallestChange.x !== 0 && overlap.x === 0) {
    return true;
  }

  if (smallestChange.y !== 0 && overlap.y === 0) {
    return true;
  }

  return false;
};
var canScrollWindow = function canScrollWindow(viewport, change) {
  return canPartiallyScroll({
    current: viewport.scroll.current,
    max: viewport.scroll.max,
    change: change
  });
};
var getWindowOverlap = function getWindowOverlap(viewport, change) {
  if (!canScrollWindow(viewport, change)) {
    return null;
  }

  var max = viewport.scroll.max;
  var current = viewport.scroll.current;
  return getOverlap({
    current: current,
    max: max,
    change: change
  });
};
var canScrollDroppable = function canScrollDroppable(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return false;
  }

  return canPartiallyScroll({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};
var getDroppableOverlap = function getDroppableOverlap(droppable, change) {
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  if (!canScrollDroppable(droppable, change)) {
    return null;
  }

  return getOverlap({
    current: frame.scroll.current,
    max: frame.scroll.max,
    change: change
  });
};

var getWindowScrollChange = (function (_ref) {
  var viewport = _ref.viewport,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: viewport.frame,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
});

var getDroppableScrollChange = (function (_ref) {
  var droppable = _ref.droppable,
      subject = _ref.subject,
      center = _ref.center,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening;
  var frame = droppable.frame;

  if (!frame) {
    return null;
  }

  var scroll = getScroll({
    dragStartTime: dragStartTime,
    container: frame.pageMarginBox,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });
  return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
});

var scroll$1 = (function (_ref) {
  var state = _ref.state,
      dragStartTime = _ref.dragStartTime,
      shouldUseTimeDampening = _ref.shouldUseTimeDampening,
      scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var center = state.current.page.borderBoxCenter;
  var draggable = state.dimensions.draggables[state.critical.draggable.id];
  var subject = draggable.page.marginBox;

  if (state.isWindowScrollAllowed) {
    var viewport = state.viewport;

    var _change = getWindowScrollChange({
      dragStartTime: dragStartTime,
      viewport: viewport,
      subject: subject,
      center: center,
      shouldUseTimeDampening: shouldUseTimeDampening
    });

    if (_change) {
      scrollWindow(_change);
      return;
    }
  }

  var droppable = getBestScrollableDroppable({
    center: center,
    destination: whatIsDraggedOver(state.impact),
    droppables: state.dimensions.droppables
  });

  if (!droppable) {
    return;
  }

  var change = getDroppableScrollChange({
    dragStartTime: dragStartTime,
    droppable: droppable,
    subject: subject,
    center: center,
    shouldUseTimeDampening: shouldUseTimeDampening
  });

  if (change) {
    scrollDroppable(droppable.descriptor.id, change);
  }
});

var createFluidScroller = (function (_ref) {
  var scrollWindow = _ref.scrollWindow,
      scrollDroppable = _ref.scrollDroppable;
  var scheduleWindowScroll = rafSchd$1(scrollWindow);
  var scheduleDroppableScroll = rafSchd$1(scrollDroppable);
  var dragging = null;

  var tryScroll = function tryScroll(state) {
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot fluid scroll if not dragging') : invariant$2(false) : void 0;
    var _dragging = dragging,
        shouldUseTimeDampening = _dragging.shouldUseTimeDampening,
        dragStartTime = _dragging.dragStartTime;
    scroll$1({
      state: state,
      scrollWindow: scheduleWindowScroll,
      scrollDroppable: scheduleDroppableScroll,
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: shouldUseTimeDampening
    });
  };

  var start$1 = function start$1(state) {
    start$2();
    !!dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot start auto scrolling when already started') : invariant$2(false) : void 0;
    var dragStartTime = Date.now();
    var wasScrollNeeded = false;

    var fakeScrollCallback = function fakeScrollCallback() {
      wasScrollNeeded = true;
    };

    scroll$1({
      state: state,
      dragStartTime: 0,
      shouldUseTimeDampening: false,
      scrollWindow: fakeScrollCallback,
      scrollDroppable: fakeScrollCallback
    });
    dragging = {
      dragStartTime: dragStartTime,
      shouldUseTimeDampening: wasScrollNeeded
    };
    finish();

    if (wasScrollNeeded) {
      tryScroll(state);
    }
  };

  var stop = function stop() {
    if (!dragging) {
      return;
    }

    scheduleWindowScroll.cancel();
    scheduleDroppableScroll.cancel();
    dragging = null;
  };

  return {
    start: start$1,
    stop: stop,
    scroll: tryScroll
  };
});

var createJumpScroller = (function (_ref) {
  var move = _ref.move,
      scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow;

  var moveByOffset = function moveByOffset(state, offset) {
    var client = add(state.current.client.selection, offset);
    move({
      client: client
    });
  };

  var scrollDroppableAsMuchAsItCan = function scrollDroppableAsMuchAsItCan(droppable, change) {
    if (!canScrollDroppable(droppable, change)) {
      return change;
    }

    var overlap = getDroppableOverlap(droppable, change);

    if (!overlap) {
      scrollDroppable(droppable.descriptor.id, change);
      return null;
    }

    var whatTheDroppableCanScroll = subtract(change, overlap);
    scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
    var remainder = subtract(change, whatTheDroppableCanScroll);
    return remainder;
  };

  var scrollWindowAsMuchAsItCan = function scrollWindowAsMuchAsItCan(isWindowScrollAllowed, viewport, change) {
    if (!isWindowScrollAllowed) {
      return change;
    }

    if (!canScrollWindow(viewport, change)) {
      return change;
    }

    var overlap = getWindowOverlap(viewport, change);

    if (!overlap) {
      scrollWindow(change);
      return null;
    }

    var whatTheWindowCanScroll = subtract(change, overlap);
    scrollWindow(whatTheWindowCanScroll);
    var remainder = subtract(change, whatTheWindowCanScroll);
    return remainder;
  };

  var jumpScroller = function jumpScroller(state) {
    var request = state.scrollJumpRequest;

    if (!request) {
      return;
    }

    var destination = whatIsDraggedOver(state.impact);
    !destination ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot perform a jump scroll when there is no destination') : invariant$2(false) : void 0;
    var droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);

    if (!droppableRemainder) {
      return;
    }

    var viewport = state.viewport;
    var windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);

    if (!windowRemainder) {
      return;
    }

    moveByOffset(state, windowRemainder);
  };

  return jumpScroller;
});

var createAutoScroller = (function (_ref) {
  var scrollDroppable = _ref.scrollDroppable,
      scrollWindow = _ref.scrollWindow,
      move = _ref.move;
  var fluidScroller = createFluidScroller({
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });
  var jumpScroll = createJumpScroller({
    move: move,
    scrollWindow: scrollWindow,
    scrollDroppable: scrollDroppable
  });

  var scroll = function scroll(state) {
    if (state.phase !== 'DRAGGING') {
      return;
    }

    if (state.movementMode === 'FLUID') {
      fluidScroller.scroll(state);
      return;
    }

    if (!state.scrollJumpRequest) {
      return;
    }

    jumpScroll(state);
  };

  var scroller = {
    scroll: scroll,
    start: fluidScroller.start,
    stop: fluidScroller.stop
  };
  return scroller;
});

var prefix$1$1 = 'data-rbd';
var dragHandle = function () {
  var base = prefix$1$1 + "-drag-handle";
  return {
    base: base,
    draggableId: base + "-draggable-id",
    contextId: base + "-context-id"
  };
}();
var draggable = function () {
  var base = prefix$1$1 + "-draggable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var droppable = function () {
  var base = prefix$1$1 + "-droppable";
  return {
    base: base,
    contextId: base + "-context-id",
    id: base + "-id"
  };
}();
var scrollContainer = {
  contextId: prefix$1$1 + "-scroll-container-context-id"
};

var makeGetSelector = function makeGetSelector(context) {
  return function (attribute) {
    return "[" + attribute + "=\"" + context + "\"]";
  };
};

var getStyles = function getStyles(rules, property) {
  return rules.map(function (rule) {
    var value = rule.styles[property];

    if (!value) {
      return '';
    }

    return rule.selector + " { " + value + " }";
  }).join(' ');
};

var noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (function (contextId) {
  var getSelector = makeGetSelector(contextId);

  var dragHandle$1 = function () {
    var grabCursor = "\n      cursor: -webkit-grab;\n      cursor: grab;\n    ";
    return {
      selector: getSelector(dragHandle.contextId),
      styles: {
        always: "\n          -webkit-touch-callout: none;\n          -webkit-tap-highlight-color: rgba(0,0,0,0);\n          touch-action: manipulation;\n        ",
        resting: grabCursor,
        dragging: noPointerEvents,
        dropAnimating: grabCursor
      }
    };
  }();

  var draggable$1 = function () {
    var transition = "\n      transition: " + transitions.outOfTheWay + ";\n    ";
    return {
      selector: getSelector(draggable.contextId),
      styles: {
        dragging: transition,
        dropAnimating: transition,
        userCancel: transition
      }
    };
  }();

  var droppable$1 = {
    selector: getSelector(droppable.contextId),
    styles: {
      always: "overflow-anchor: none;"
    }
  };
  var body = {
    selector: 'body',
    styles: {
      dragging: "\n        cursor: grabbing;\n        cursor: -webkit-grabbing;\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n        overflow-anchor: none;\n      "
    }
  };
  var rules = [draggable$1, dragHandle$1, droppable$1, body];
  return {
    always: getStyles(rules, 'always'),
    resting: getStyles(rules, 'resting'),
    dragging: getStyles(rules, 'dragging'),
    dropAnimating: getStyles(rules, 'dropAnimating'),
    userCancel: getStyles(rules, 'userCancel')
  };
});

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? useLayoutEffect$1 : useEffect;

var getHead = function getHead() {
  var head = document.querySelector('head');
  !head ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot find the head to append a style to') : invariant$2(false) : void 0;
  return head;
};

var createStyleEl = function createStyleEl(nonce) {
  var el = document.createElement('style');

  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  el.type = 'text/css';
  return el;
};

function useStyleMarshal(contextId, nonce) {
  var styles = useMemo(function () {
    return getStyles$1(contextId);
  }, [contextId]);
  var alwaysRef = useRef(null);
  var dynamicRef = useRef(null);
  var setDynamicStyle = useCallback(memoizeOne(function (proposed) {
    var el = dynamicRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot set dynamic style element if it is not set') : invariant$2(false) : void 0;
    el.textContent = proposed;
  }), []);
  var setAlwaysStyle = useCallback(function (proposed) {
    var el = alwaysRef.current;
    !el ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot set dynamic style element if it is not set') : invariant$2(false) : void 0;
    el.textContent = proposed;
  }, []);
  useIsomorphicLayoutEffect(function () {
    !(!alwaysRef.current && !dynamicRef.current) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'style elements already mounted') : invariant$2(false) : void 0;
    var always = createStyleEl(nonce);
    var dynamic = createStyleEl(nonce);
    alwaysRef.current = always;
    dynamicRef.current = dynamic;
    always.setAttribute(prefix$1$1 + "-always", contextId);
    dynamic.setAttribute(prefix$1$1 + "-dynamic", contextId);
    getHead().appendChild(always);
    getHead().appendChild(dynamic);
    setAlwaysStyle(styles.always);
    setDynamicStyle(styles.resting);
    return function () {
      var remove = function remove(ref) {
        var current = ref.current;
        !current ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot unmount ref as it is not set') : invariant$2(false) : void 0;
        getHead().removeChild(current);
        ref.current = null;
      };

      remove(alwaysRef);
      remove(dynamicRef);
    };
  }, [nonce, setAlwaysStyle, setDynamicStyle, styles.always, styles.resting, contextId]);
  var dragging = useCallback(function () {
    return setDynamicStyle(styles.dragging);
  }, [setDynamicStyle, styles.dragging]);
  var dropping = useCallback(function (reason) {
    if (reason === 'DROP') {
      setDynamicStyle(styles.dropAnimating);
      return;
    }

    setDynamicStyle(styles.userCancel);
  }, [setDynamicStyle, styles.dropAnimating, styles.userCancel]);
  var resting = useCallback(function () {
    if (!dynamicRef.current) {
      return;
    }

    setDynamicStyle(styles.resting);
  }, [setDynamicStyle, styles.resting]);
  var marshal = useMemo(function () {
    return {
      dragging: dragging,
      dropping: dropping,
      resting: resting
    };
  }, [dragging, dropping, resting]);
  return marshal;
}

var getWindowFromEl = (function (el) {
  return el && el.ownerDocument ? el.ownerDocument.defaultView : window;
});

function isHtmlElement(el) {
  return el instanceof getWindowFromEl(el).HTMLElement;
}

function findDragHandle(contextId, draggableId) {
  var selector = "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
  var possible = toArray$1(document.querySelectorAll(selector));

  if (!possible.length) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find any drag handles in the context \"" + contextId + "\"") : void 0;
    return null;
  }

  var handle = find(possible, function (el) {
    return el.getAttribute(dragHandle.draggableId) === draggableId;
  });

  if (!handle) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find drag handle with id \"" + draggableId + "\" as no handle with a matching id was found") : void 0;
    return null;
  }

  if (!isHtmlElement(handle)) {
    process.env.NODE_ENV !== "production" ? warning$1('drag handle needs to be a HTMLElement') : void 0;
    return null;
  }

  return handle;
}

function useFocusMarshal(contextId) {
  var entriesRef = useRef({});
  var recordRef = useRef(null);
  var restoreFocusFrameRef = useRef(null);
  var isMountedRef = useRef(false);
  var register = useCallback(function register(id, focus) {
    var entry = {
      id: id,
      focus: focus
    };
    entriesRef.current[id] = entry;
    return function unregister() {
      var entries = entriesRef.current;
      var current = entries[id];

      if (current !== entry) {
        delete entries[id];
      }
    };
  }, []);
  var tryGiveFocus = useCallback(function tryGiveFocus(tryGiveFocusTo) {
    var handle = findDragHandle(contextId, tryGiveFocusTo);

    if (handle && handle !== document.activeElement) {
      handle.focus();
    }
  }, [contextId]);
  var tryShiftRecord = useCallback(function tryShiftRecord(previous, redirectTo) {
    if (recordRef.current === previous) {
      recordRef.current = redirectTo;
    }
  }, []);
  var tryRestoreFocusRecorded = useCallback(function tryRestoreFocusRecorded() {
    if (restoreFocusFrameRef.current) {
      return;
    }

    if (!isMountedRef.current) {
      return;
    }

    restoreFocusFrameRef.current = requestAnimationFrame(function () {
      restoreFocusFrameRef.current = null;
      var record = recordRef.current;

      if (record) {
        tryGiveFocus(record);
      }
    });
  }, [tryGiveFocus]);
  var tryRecordFocus = useCallback(function tryRecordFocus(id) {
    recordRef.current = null;
    var focused = document.activeElement;

    if (!focused) {
      return;
    }

    if (focused.getAttribute(dragHandle.draggableId) !== id) {
      return;
    }

    recordRef.current = id;
  }, []);
  useIsomorphicLayoutEffect(function () {
    isMountedRef.current = true;
    return function clearFrameOnUnmount() {
      isMountedRef.current = false;
      var frameId = restoreFocusFrameRef.current;

      if (frameId) {
        cancelAnimationFrame(frameId);
      }
    };
  }, []);
  var marshal = useMemo(function () {
    return {
      register: register,
      tryRecordFocus: tryRecordFocus,
      tryRestoreFocusRecorded: tryRestoreFocusRecorded,
      tryShiftRecord: tryShiftRecord
    };
  }, [register, tryRecordFocus, tryRestoreFocusRecorded, tryShiftRecord]);
  return marshal;
}

function createRegistry() {
  var entries = {
    draggables: {},
    droppables: {}
  };
  var subscribers = [];

  function subscribe(cb) {
    subscribers.push(cb);
    return function unsubscribe() {
      var index = subscribers.indexOf(cb);

      if (index === -1) {
        return;
      }

      subscribers.splice(index, 1);
    };
  }

  function notify(event) {
    if (subscribers.length) {
      subscribers.forEach(function (cb) {
        return cb(event);
      });
    }
  }

  function findDraggableById(id) {
    return entries.draggables[id] || null;
  }

  function getDraggableById(id) {
    var entry = findDraggableById(id);
    !entry ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find draggable entry with id [" + id + "]") : invariant$2(false) : void 0;
    return entry;
  }

  var draggableAPI = {
    register: function register(entry) {
      entries.draggables[entry.descriptor.id] = entry;
      notify({
        type: 'ADDITION',
        value: entry
      });
    },
    update: function update(entry, last) {
      var current = entries.draggables[last.descriptor.id];

      if (!current) {
        return;
      }

      if (current.uniqueId !== entry.uniqueId) {
        return;
      }

      delete entries.draggables[last.descriptor.id];
      entries.draggables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var draggableId = entry.descriptor.id;
      var current = findDraggableById(draggableId);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.draggables[draggableId];
      notify({
        type: 'REMOVAL',
        value: entry
      });
    },
    getById: getDraggableById,
    findById: findDraggableById,
    exists: function exists(id) {
      return Boolean(findDraggableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values$1(entries.draggables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function findDroppableById(id) {
    return entries.droppables[id] || null;
  }

  function getDroppableById(id) {
    var entry = findDroppableById(id);
    !entry ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot find droppable entry with id [" + id + "]") : invariant$2(false) : void 0;
    return entry;
  }

  var droppableAPI = {
    register: function register(entry) {
      entries.droppables[entry.descriptor.id] = entry;
    },
    unregister: function unregister(entry) {
      var current = findDroppableById(entry.descriptor.id);

      if (!current) {
        return;
      }

      if (entry.uniqueId !== current.uniqueId) {
        return;
      }

      delete entries.droppables[entry.descriptor.id];
    },
    getById: getDroppableById,
    findById: findDroppableById,
    exists: function exists(id) {
      return Boolean(findDroppableById(id));
    },
    getAllByType: function getAllByType(type) {
      return values$1(entries.droppables).filter(function (entry) {
        return entry.descriptor.type === type;
      });
    }
  };

  function clean() {
    entries.draggables = {};
    entries.droppables = {};
    subscribers.length = 0;
  }

  return {
    draggable: draggableAPI,
    droppable: droppableAPI,
    subscribe: subscribe,
    clean: clean
  };
}

function useRegistry() {
  var registry = useMemo(createRegistry, []);
  useEffect(function () {
    return function unmount() {
      requestAnimationFrame(registry.clean);
    };
  }, [registry]);
  return registry;
}

var StoreContext = React__default.createContext(null);

var getBodyElement = (function () {
  var body = document.body;
  !body ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot find document.body') : invariant$2(false) : void 0;
  return body;
});

var visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  margin: '-1px',
  border: '0',
  padding: '0',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  'clip-path': 'inset(100%)'
};

var getId = function getId(contextId) {
  return "rbd-announcement-" + contextId;
};
function useAnnouncer(contextId) {
  var id = useMemo(function () {
    return getId(contextId);
  }, [contextId]);
  var ref = useRef(null);
  useEffect(function setup() {
    var el = document.createElement('div');
    ref.current = el;
    el.id = id;
    el.setAttribute('aria-live', 'assertive');
    el.setAttribute('aria-atomic', 'true');

    _extends(el.style, visuallyHidden);

    getBodyElement().appendChild(el);
    return function cleanup() {
      setTimeout(function remove() {
        var body = getBodyElement();

        if (body.contains(el)) {
          body.removeChild(el);
        }

        if (el === ref.current) {
          ref.current = null;
        }
      });
    };
  }, [id]);
  var announce = useCallback(function (message) {
    var el = ref.current;

    if (el) {
      el.textContent = message;
      return;
    }

    process.env.NODE_ENV !== "production" ? warning$1("\n      A screen reader message was trying to be announced but it was unable to do so.\n      This can occur if you unmount your <DragDropContext /> in your onDragEnd.\n      Consider calling provided.announce() before the unmount so that the instruction will\n      not be lost for users relying on a screen reader.\n\n      Message not passed to screen reader:\n\n      \"" + message + "\"\n    ") : void 0;
  }, []);
  return announce;
}

var count = 0;
var defaults$1 = {
  separator: '::'
};
function useUniqueId(prefix, options) {
  if (options === void 0) {
    options = defaults$1;
  }

  return useMemo(function () {
    return "" + prefix + options.separator + count++;
  }, [options.separator, prefix]);
}

function getElementId(_ref) {
  var contextId = _ref.contextId,
      uniqueId = _ref.uniqueId;
  return "rbd-hidden-text-" + contextId + "-" + uniqueId;
}
function useHiddenTextElement(_ref2) {
  var contextId = _ref2.contextId,
      text = _ref2.text;
  var uniqueId = useUniqueId('hidden-text', {
    separator: '-'
  });
  var id = useMemo(function () {
    return getElementId({
      contextId: contextId,
      uniqueId: uniqueId
    });
  }, [uniqueId, contextId]);
  useEffect(function mount() {
    var el = document.createElement('div');
    el.id = id;
    el.textContent = text;
    el.style.display = 'none';
    getBodyElement().appendChild(el);
    return function unmount() {
      var body = getBodyElement();

      if (body.contains(el)) {
        body.removeChild(el);
      }
    };
  }, [id, text]);
  return id;
}

var AppContext = React__default.createContext(null);

var peerDependencies = {
	react: "^16.8.5 || ^17.0.0",
	"react-dom": "^16.8.5 || ^17.0.0"
};

var semver = /(\d+)\.(\d+)\.(\d+)/;

var getVersion = function getVersion(value) {
  var result = semver.exec(value);
  !(result != null) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Unable to parse React version " + value) : invariant$2(false) : void 0;
  var major = Number(result[1]);
  var minor = Number(result[2]);
  var patch = Number(result[3]);
  return {
    major: major,
    minor: minor,
    patch: patch,
    raw: value
  };
};

var isSatisfied = function isSatisfied(expected, actual) {
  if (actual.major > expected.major) {
    return true;
  }

  if (actual.major < expected.major) {
    return false;
  }

  if (actual.minor > expected.minor) {
    return true;
  }

  if (actual.minor < expected.minor) {
    return false;
  }

  return actual.patch >= expected.patch;
};

var checkReactVersion = (function (peerDepValue, actualValue) {
  var peerDep = getVersion(peerDepValue);
  var actual = getVersion(actualValue);

  if (isSatisfied(peerDep, actual)) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    React version: [" + actual.raw + "]\n    does not satisfy expected peer dependency version: [" + peerDep.raw + "]\n\n    This can result in run time bugs, and even fatal crashes\n  ") : void 0;
});

var suffix$1 = "\n  We expect a html5 doctype: <!doctype html>\n  This is to ensure consistent browser layout and measurement\n\n  More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/doctype.md\n";
var checkDoctype = (function (doc) {
  var doctype = doc.doctype;

  if (!doctype) {
    process.env.NODE_ENV !== "production" ? warning$1("\n      No <!doctype html> found.\n\n      " + suffix$1 + "\n    ") : void 0;
    return;
  }

  if (doctype.name.toLowerCase() !== 'html') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Unexpected <!doctype> found: (" + doctype.name + ")\n\n      " + suffix$1 + "\n    ") : void 0;
  }

  if (doctype.publicId !== '') {
    process.env.NODE_ENV !== "production" ? warning$1("\n      Unexpected <!doctype> publicId found: (" + doctype.publicId + ")\n      A html5 doctype does not have a publicId\n\n      " + suffix$1 + "\n    ") : void 0;
  }
});

function useDev(useHook) {
  if (process.env.NODE_ENV !== 'production') {
    useHook();
  }
}

function useDevSetupWarning(fn, inputs) {
  useDev(function () {
    useEffect(function () {
      try {
        fn();
      } catch (e) {
        error$1("\n          A setup problem was encountered.\n\n          > " + e.message + "\n        ");
      }
    }, inputs);
  });
}

function useStartupValidation() {
  useDevSetupWarning(function () {
    checkReactVersion(peerDependencies.react, React__default.version);
    checkDoctype(document);
  }, []);
}

function usePrevious$1(current) {
  var ref = useRef(current);
  useEffect(function () {
    ref.current = current;
  });
  return ref;
}

function create$1() {
  var lock = null;

  function isClaimed() {
    return Boolean(lock);
  }

  function isActive(value) {
    return value === lock;
  }

  function claim(abandon) {
    !!lock ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot claim lock as it is already claimed') : invariant$2(false) : void 0;
    var newLock = {
      abandon: abandon
    };
    lock = newLock;
    return newLock;
  }

  function release() {
    !lock ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot release lock when there is no lock') : invariant$2(false) : void 0;
    lock = null;
  }

  function tryAbandon() {
    if (lock) {
      lock.abandon();
      release();
    }
  }

  return {
    isClaimed: isClaimed,
    isActive: isActive,
    claim: claim,
    release: release,
    tryAbandon: tryAbandon
  };
}

var tab = 9;
var enter = 13;
var escape = 27;
var space = 32;
var pageUp = 33;
var pageDown = 34;
var end = 35;
var home = 36;
var arrowLeft = 37;
var arrowUp = 38;
var arrowRight$1 = 39;
var arrowDown = 40;

var _preventedKeys;
var preventedKeys = (_preventedKeys = {}, _preventedKeys[enter] = true, _preventedKeys[tab] = true, _preventedKeys);
var preventStandardKeyEvents = (function (event) {
  if (preventedKeys[event.keyCode]) {
    event.preventDefault();
  }
});

var supportedEventName = function () {
  var base = 'visibilitychange';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, "ms" + base, "webkit" + base, "moz" + base, "o" + base];
  var supported = find(candidates, function (eventName) {
    return "on" + eventName in document;
  });
  return supported || base;
}();

var primaryButton = 0;
var sloppyClickThreshold = 5;

function isSloppyClickThresholdExceeded(original, current) {
  return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}

var idle$1 = {
  type: 'IDLE'
};

function getCaptureBindings(_ref) {
  var cancel = _ref.cancel,
      completed = _ref.completed,
      getPhase = _ref.getPhase,
      setPhase = _ref.setPhase;
  return [{
    eventName: 'mousemove',
    fn: function fn(event) {
      var button = event.button,
          clientX = event.clientX,
          clientY = event.clientY;

      if (button !== primaryButton) {
        return;
      }

      var point = {
        x: clientX,
        y: clientY
      };
      var phase = getPhase();

      if (phase.type === 'DRAGGING') {
        event.preventDefault();
        phase.actions.move(point);
        return;
      }

      !(phase.type === 'PENDING') ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot be IDLE') : invariant$2(false) : void 0;
      var pending = phase.point;

      if (!isSloppyClickThresholdExceeded(pending, point)) {
        return;
      }

      event.preventDefault();
      var actions = phase.actions.fluidLift(point);
      setPhase({
        type: 'DRAGGING',
        actions: actions
      });
    }
  }, {
    eventName: 'mouseup',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'mousedown',
    fn: function fn(event) {
      if (getPhase().type === 'DRAGGING') {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        cancel();
        return;
      }

      if (event.keyCode === escape) {
        event.preventDefault();
        cancel();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'scroll',
    options: {
      passive: true,
      capture: false
    },
    fn: function fn() {
      if (getPhase().type === 'PENDING') {
        cancel();
      }
    }
  }, {
    eventName: 'webkitmouseforcedown',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Unexpected phase') : invariant$2(false) : void 0;

      if (phase.actions.shouldRespectForcePress()) {
        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useMouseSensor(api) {
  var phaseRef = useRef(idle$1);
  var unbindEventsRef = useRef(noop$6);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'mousedown',
      fn: function onMouseDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.button !== primaryButton) {
          return;
        }

        if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        event.preventDefault();
        var point = {
          x: event.clientX,
          y: event.clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var preventForcePressBinding = useMemo(function () {
    return {
      eventName: 'webkitmouseforcewillbegin',
      fn: function fn(event) {
        if (event.defaultPrevented) {
          return;
        }

        var id = api.findClosestDraggableId(event);

        if (!id) {
          return;
        }

        var options = api.findOptionsForDraggable(id);

        if (!options) {
          return;
        }

        if (options.shouldRespectForcePress) {
          return;
        }

        if (!api.canGetLock(id)) {
          return;
        }

        event.preventDefault();
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [preventForcePressBinding, startCaptureBinding], options);
  }, [preventForcePressBinding, startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    phaseRef.current = idle$1;
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var bindings = getCaptureBindings({
      cancel: cancel,
      completed: stop,
      getPhase: function getPhase() {
        return phaseRef.current;
      },
      setPhase: function setPhase(phase) {
        phaseRef.current = phase;
      }
    });
    unbindEventsRef.current = bindEvents(window, bindings, options);
  }, [cancel, stop]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(phaseRef.current.type === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Expected to move from IDLE to PENDING drag') : invariant$2(false) : void 0;
    phaseRef.current = {
      type: 'PENDING',
      point: point,
      actions: actions
    };
    bindCapturingEvents();
  }, [bindCapturingEvents]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var _scrollJumpKeys;

function noop$1$1() {}

var scrollJumpKeys = (_scrollJumpKeys = {}, _scrollJumpKeys[pageDown] = true, _scrollJumpKeys[pageUp] = true, _scrollJumpKeys[home] = true, _scrollJumpKeys[end] = true, _scrollJumpKeys);

function getDraggingBindings(actions, stop) {
  function cancel() {
    stop();
    actions.cancel();
  }

  function drop() {
    stop();
    actions.drop();
  }

  return [{
    eventName: 'keydown',
    fn: function fn(event) {
      if (event.keyCode === escape) {
        event.preventDefault();
        cancel();
        return;
      }

      if (event.keyCode === space) {
        event.preventDefault();
        drop();
        return;
      }

      if (event.keyCode === arrowDown) {
        event.preventDefault();
        actions.moveDown();
        return;
      }

      if (event.keyCode === arrowUp) {
        event.preventDefault();
        actions.moveUp();
        return;
      }

      if (event.keyCode === arrowRight$1) {
        event.preventDefault();
        actions.moveRight();
        return;
      }

      if (event.keyCode === arrowLeft) {
        event.preventDefault();
        actions.moveLeft();
        return;
      }

      if (scrollJumpKeys[event.keyCode]) {
        event.preventDefault();
        return;
      }

      preventStandardKeyEvents(event);
    }
  }, {
    eventName: 'mousedown',
    fn: cancel
  }, {
    eventName: 'mouseup',
    fn: cancel
  }, {
    eventName: 'click',
    fn: cancel
  }, {
    eventName: 'touchstart',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'wheel',
    fn: cancel,
    options: {
      passive: true
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useKeyboardSensor(api) {
  var unbindEventsRef = useRef(noop$1$1);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'keydown',
      fn: function onKeyDown(event) {
        if (event.defaultPrevented) {
          return;
        }

        if (event.keyCode !== space) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var preDrag = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!preDrag) {
          return;
        }

        event.preventDefault();
        var isCapturing = true;
        var actions = preDrag.snapLift();
        unbindEventsRef.current();

        function stop() {
          !isCapturing ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot stop capturing a keyboard drag when not capturing') : invariant$2(false) : void 0;
          isCapturing = false;
          unbindEventsRef.current();
          listenForCapture();
        }

        unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
          capture: true,
          passive: false
        });
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function tryStartCapture() {
    var options = {
      passive: false,
      capture: true
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
    };
  }, [listenForCapture]);
}

var idle$2 = {
  type: 'IDLE'
};
var timeForLongPress = 120;
var forcePressThreshold = 0.15;

function getWindowBindings(_ref) {
  var cancel = _ref.cancel,
      getPhase = _ref.getPhase;
  return [{
    eventName: 'orientationchange',
    fn: cancel
  }, {
    eventName: 'resize',
    fn: cancel
  }, {
    eventName: 'contextmenu',
    fn: function fn(event) {
      event.preventDefault();
    }
  }, {
    eventName: 'keydown',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      if (event.keyCode === escape) {
        event.preventDefault();
      }

      cancel();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function getHandleBindings(_ref2) {
  var cancel = _ref2.cancel,
      completed = _ref2.completed,
      getPhase = _ref2.getPhase;
  return [{
    eventName: 'touchmove',
    options: {
      capture: false
    },
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      phase.hasMoved = true;
      var _event$touches$ = event.touches[0],
          clientX = _event$touches$.clientX,
          clientY = _event$touches$.clientY;
      var point = {
        x: clientX,
        y: clientY
      };
      event.preventDefault();
      phase.actions.move(point);
    }
  }, {
    eventName: 'touchend',
    fn: function fn(event) {
      var phase = getPhase();

      if (phase.type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      phase.actions.drop({
        shouldBlockNextClick: true
      });
      completed();
    }
  }, {
    eventName: 'touchcancel',
    fn: function fn(event) {
      if (getPhase().type !== 'DRAGGING') {
        cancel();
        return;
      }

      event.preventDefault();
      cancel();
    }
  }, {
    eventName: 'touchforcechange',
    fn: function fn(event) {
      var phase = getPhase();
      !(phase.type !== 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$2(false) : invariant$2(false) : void 0;
      var touch = event.touches[0];

      if (!touch) {
        return;
      }

      var isForcePress = touch.force >= forcePressThreshold;

      if (!isForcePress) {
        return;
      }

      var shouldRespect = phase.actions.shouldRespectForcePress();

      if (phase.type === 'PENDING') {
        if (shouldRespect) {
          cancel();
        }

        return;
      }

      if (shouldRespect) {
        if (phase.hasMoved) {
          event.preventDefault();
          return;
        }

        cancel();
        return;
      }

      event.preventDefault();
    }
  }, {
    eventName: supportedEventName,
    fn: cancel
  }];
}

function useTouchSensor(api) {
  var phaseRef = useRef(idle$2);
  var unbindEventsRef = useRef(noop$6);
  var getPhase = useCallback(function getPhase() {
    return phaseRef.current;
  }, []);
  var setPhase = useCallback(function setPhase(phase) {
    phaseRef.current = phase;
  }, []);
  var startCaptureBinding = useMemo(function () {
    return {
      eventName: 'touchstart',
      fn: function onTouchStart(event) {
        if (event.defaultPrevented) {
          return;
        }

        var draggableId = api.findClosestDraggableId(event);

        if (!draggableId) {
          return;
        }

        var actions = api.tryGetLock(draggableId, stop, {
          sourceEvent: event
        });

        if (!actions) {
          return;
        }

        var touch = event.touches[0];
        var clientX = touch.clientX,
            clientY = touch.clientY;
        var point = {
          x: clientX,
          y: clientY
        };
        unbindEventsRef.current();
        startPendingDrag(actions, point);
      }
    };
  }, [api]);
  var listenForCapture = useCallback(function listenForCapture() {
    var options = {
      capture: true,
      passive: false
    };
    unbindEventsRef.current = bindEvents(window, [startCaptureBinding], options);
  }, [startCaptureBinding]);
  var stop = useCallback(function () {
    var current = phaseRef.current;

    if (current.type === 'IDLE') {
      return;
    }

    if (current.type === 'PENDING') {
      clearTimeout(current.longPressTimerId);
    }

    setPhase(idle$2);
    unbindEventsRef.current();
    listenForCapture();
  }, [listenForCapture, setPhase]);
  var cancel = useCallback(function () {
    var phase = phaseRef.current;
    stop();

    if (phase.type === 'DRAGGING') {
      phase.actions.cancel({
        shouldBlockNextClick: true
      });
    }

    if (phase.type === 'PENDING') {
      phase.actions.abort();
    }
  }, [stop]);
  var bindCapturingEvents = useCallback(function bindCapturingEvents() {
    var options = {
      capture: true,
      passive: false
    };
    var args = {
      cancel: cancel,
      completed: stop,
      getPhase: getPhase
    };
    var unbindTarget = bindEvents(window, getHandleBindings(args), options);
    var unbindWindow = bindEvents(window, getWindowBindings(args), options);

    unbindEventsRef.current = function unbindAll() {
      unbindTarget();
      unbindWindow();
    };
  }, [cancel, getPhase, stop]);
  var startDragging = useCallback(function startDragging() {
    var phase = getPhase();
    !(phase.type === 'PENDING') ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot start dragging from phase " + phase.type) : invariant$2(false) : void 0;
    var actions = phase.actions.fluidLift(phase.point);
    setPhase({
      type: 'DRAGGING',
      actions: actions,
      hasMoved: false
    });
  }, [getPhase, setPhase]);
  var startPendingDrag = useCallback(function startPendingDrag(actions, point) {
    !(getPhase().type === 'IDLE') ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Expected to move from IDLE to PENDING drag') : invariant$2(false) : void 0;
    var longPressTimerId = setTimeout(startDragging, timeForLongPress);
    setPhase({
      type: 'PENDING',
      point: point,
      actions: actions,
      longPressTimerId: longPressTimerId
    });
    bindCapturingEvents();
  }, [bindCapturingEvents, getPhase, setPhase, startDragging]);
  useIsomorphicLayoutEffect(function mount() {
    listenForCapture();
    return function unmount() {
      unbindEventsRef.current();
      var phase = getPhase();

      if (phase.type === 'PENDING') {
        clearTimeout(phase.longPressTimerId);
        setPhase(idle$2);
      }
    };
  }, [getPhase, listenForCapture, setPhase]);
  useIsomorphicLayoutEffect(function webkitHack() {
    var unbind = bindEvents(window, [{
      eventName: 'touchmove',
      fn: function fn() {},
      options: {
        capture: false,
        passive: false
      }
    }]);
    return unbind;
  }, []);
}

function useValidateSensorHooks(sensorHooks) {
  useDev(function () {
    var previousRef = usePrevious$1(sensorHooks);
    useDevSetupWarning(function () {
      !(previousRef.current.length === sensorHooks.length) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot change the amount of sensor hooks after mounting') : invariant$2(false) : void 0;
    });
  });
}

var interactiveTagNames = {
  input: true,
  button: true,
  textarea: true,
  select: true,
  option: true,
  optgroup: true,
  video: true,
  audio: true
};

function isAnInteractiveElement(parent, current) {
  if (current == null) {
    return false;
  }

  var hasAnInteractiveTag = Boolean(interactiveTagNames[current.tagName.toLowerCase()]);

  if (hasAnInteractiveTag) {
    return true;
  }

  var attribute = current.getAttribute('contenteditable');

  if (attribute === 'true' || attribute === '') {
    return true;
  }

  if (current === parent) {
    return false;
  }

  return isAnInteractiveElement(parent, current.parentElement);
}

function isEventInInteractiveElement(draggable, event) {
  var target = event.target;

  if (!isHtmlElement(target)) {
    return false;
  }

  return isAnInteractiveElement(draggable, target);
}

var getBorderBoxCenterPosition = (function (el) {
  return getRect(el.getBoundingClientRect()).center;
});

function isElement(el) {
  return el instanceof getWindowFromEl(el).Element;
}

var supportedMatchesName = function () {
  var base = 'matches';

  if (typeof document === 'undefined') {
    return base;
  }

  var candidates = [base, 'msMatchesSelector', 'webkitMatchesSelector'];
  var value = find(candidates, function (name) {
    return name in Element.prototype;
  });
  return value || base;
}();

function closestPonyfill(el, selector) {
  if (el == null) {
    return null;
  }

  if (el[supportedMatchesName](selector)) {
    return el;
  }

  return closestPonyfill(el.parentElement, selector);
}

function closest$1$1(el, selector) {
  if (el.closest) {
    return el.closest(selector);
  }

  return closestPonyfill(el, selector);
}

function getSelector(contextId) {
  return "[" + dragHandle.contextId + "=\"" + contextId + "\"]";
}

function findClosestDragHandleFromEvent(contextId, event) {
  var target = event.target;

  if (!isElement(target)) {
    process.env.NODE_ENV !== "production" ? warning$1('event.target must be a Element') : void 0;
    return null;
  }

  var selector = getSelector(contextId);
  var handle = closest$1$1(target, selector);

  if (!handle) {
    return null;
  }

  if (!isHtmlElement(handle)) {
    process.env.NODE_ENV !== "production" ? warning$1('drag handle must be a HTMLElement') : void 0;
    return null;
  }

  return handle;
}

function tryGetClosestDraggableIdFromEvent(contextId, event) {
  var handle = findClosestDragHandleFromEvent(contextId, event);

  if (!handle) {
    return null;
  }

  return handle.getAttribute(dragHandle.draggableId);
}

function findDraggable(contextId, draggableId) {
  var selector = "[" + draggable.contextId + "=\"" + contextId + "\"]";
  var possible = toArray$1(document.querySelectorAll(selector));
  var draggable$1 = find(possible, function (el) {
    return el.getAttribute(draggable.id) === draggableId;
  });

  if (!draggable$1) {
    return null;
  }

  if (!isHtmlElement(draggable$1)) {
    process.env.NODE_ENV !== "production" ? warning$1('Draggable element is not a HTMLElement') : void 0;
    return null;
  }

  return draggable$1;
}

function preventDefault(event) {
  event.preventDefault();
}

function _isActive(_ref) {
  var expected = _ref.expected,
      phase = _ref.phase,
      isLockActive = _ref.isLockActive,
      shouldWarn = _ref.shouldWarn;

  if (!isLockActive()) {
    if (shouldWarn) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Cannot perform action.\n        The sensor no longer has an action lock.\n\n        Tips:\n\n        - Throw away your action handlers when forceStop() is called\n        - Check actions.isActive() if you really need to\n      ") : void 0;
    }

    return false;
  }

  if (expected !== phase) {
    if (shouldWarn) {
      process.env.NODE_ENV !== "production" ? warning$1("\n        Cannot perform action.\n        The actions you used belong to an outdated phase\n\n        Current phase: " + expected + "\n        You called an action from outdated phase: " + phase + "\n\n        Tips:\n\n        - Do not use preDragActions actions after calling preDragActions.lift()\n      ") : void 0;
    }

    return false;
  }

  return true;
}

function canStart(_ref2) {
  var lockAPI = _ref2.lockAPI,
      store = _ref2.store,
      registry = _ref2.registry,
      draggableId = _ref2.draggableId;

  if (lockAPI.isClaimed()) {
    return false;
  }

  var entry = registry.draggable.findById(draggableId);

  if (!entry) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find draggable with id: " + draggableId) : void 0;
    return false;
  }

  if (!entry.options.isEnabled) {
    return false;
  }

  if (!canStartDrag(store.getState(), draggableId)) {
    return false;
  }

  return true;
}

function tryStart(_ref3) {
  var lockAPI = _ref3.lockAPI,
      contextId = _ref3.contextId,
      store = _ref3.store,
      registry = _ref3.registry,
      draggableId = _ref3.draggableId,
      forceSensorStop = _ref3.forceSensorStop,
      sourceEvent = _ref3.sourceEvent;
  var shouldStart = canStart({
    lockAPI: lockAPI,
    store: store,
    registry: registry,
    draggableId: draggableId
  });

  if (!shouldStart) {
    return null;
  }

  var entry = registry.draggable.getById(draggableId);
  var el = findDraggable(contextId, entry.descriptor.id);

  if (!el) {
    process.env.NODE_ENV !== "production" ? warning$1("Unable to find draggable element with id: " + draggableId) : void 0;
    return null;
  }

  if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) {
    return null;
  }

  var lock = lockAPI.claim(forceSensorStop || noop$6);
  var phase = 'PRE_DRAG';

  function getShouldRespectForcePress() {
    return entry.options.shouldRespectForcePress;
  }

  function isLockActive() {
    return lockAPI.isActive(lock);
  }

  function tryDispatch(expected, getAction) {
    if (_isActive({
      expected: expected,
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    })) {
      store.dispatch(getAction());
    }
  }

  var tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');

  function lift$1(args) {
    function completed() {
      lockAPI.release();
      phase = 'COMPLETED';
    }

    if (phase !== 'PRE_DRAG') {
      completed();
      !(phase === 'PRE_DRAG') ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Cannot lift in phase " + phase) : invariant$2(false) : void 0;
    }

    store.dispatch(lift(args.liftActionArgs));
    phase = 'DRAGGING';

    function finish(reason, options) {
      if (options === void 0) {
        options = {
          shouldBlockNextClick: false
        };
      }

      args.cleanup();

      if (options.shouldBlockNextClick) {
        var unbind = bindEvents(window, [{
          eventName: 'click',
          fn: preventDefault,
          options: {
            once: true,
            passive: false,
            capture: true
          }
        }]);
        setTimeout(unbind);
      }

      completed();
      store.dispatch(drop({
        reason: reason
      }));
    }

    return _extends({
      isActive: function isActive() {
        return _isActive({
          expected: 'DRAGGING',
          phase: phase,
          isLockActive: isLockActive,
          shouldWarn: false
        });
      },
      shouldRespectForcePress: getShouldRespectForcePress,
      drop: function drop(options) {
        return finish('DROP', options);
      },
      cancel: function cancel(options) {
        return finish('CANCEL', options);
      }
    }, args.actions);
  }

  function fluidLift(clientSelection) {
    var move$1 = rafSchd$1(function (client) {
      tryDispatchWhenDragging(function () {
        return move({
          client: client
        });
      });
    });
    var api = lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: clientSelection,
        movementMode: 'FLUID'
      },
      cleanup: function cleanup() {
        return move$1.cancel();
      },
      actions: {
        move: move$1
      }
    });
    return _extends({}, api, {
      move: move$1
    });
  }

  function snapLift() {
    var actions = {
      moveUp: function moveUp$1() {
        return tryDispatchWhenDragging(moveUp);
      },
      moveRight: function moveRight$1() {
        return tryDispatchWhenDragging(moveRight);
      },
      moveDown: function moveDown$1() {
        return tryDispatchWhenDragging(moveDown);
      },
      moveLeft: function moveLeft$1() {
        return tryDispatchWhenDragging(moveLeft);
      }
    };
    return lift$1({
      liftActionArgs: {
        id: draggableId,
        clientSelection: getBorderBoxCenterPosition(el),
        movementMode: 'SNAP'
      },
      cleanup: noop$6,
      actions: actions
    });
  }

  function abortPreDrag() {
    var shouldRelease = _isActive({
      expected: 'PRE_DRAG',
      phase: phase,
      isLockActive: isLockActive,
      shouldWarn: true
    });

    if (shouldRelease) {
      lockAPI.release();
    }
  }

  var preDrag = {
    isActive: function isActive() {
      return _isActive({
        expected: 'PRE_DRAG',
        phase: phase,
        isLockActive: isLockActive,
        shouldWarn: false
      });
    },
    shouldRespectForcePress: getShouldRespectForcePress,
    fluidLift: fluidLift,
    snapLift: snapLift,
    abort: abortPreDrag
  };
  return preDrag;
}

var defaultSensors = [useMouseSensor, useKeyboardSensor, useTouchSensor];
function useSensorMarshal(_ref4) {
  var contextId = _ref4.contextId,
      store = _ref4.store,
      registry = _ref4.registry,
      customSensors = _ref4.customSensors,
      enableDefaultSensors = _ref4.enableDefaultSensors;
  var useSensors = [].concat(enableDefaultSensors ? defaultSensors : [], customSensors || []);
  var lockAPI = useState(function () {
    return create$1();
  })[0];
  var tryAbandonLock = useCallback(function tryAbandonLock(previous, current) {
    if (previous.isDragging && !current.isDragging) {
      lockAPI.tryAbandon();
    }
  }, [lockAPI]);
  useIsomorphicLayoutEffect(function listenToStore() {
    var previous = store.getState();
    var unsubscribe = store.subscribe(function () {
      var current = store.getState();
      tryAbandonLock(previous, current);
      previous = current;
    });
    return unsubscribe;
  }, [lockAPI, store, tryAbandonLock]);
  useIsomorphicLayoutEffect(function () {
    return lockAPI.tryAbandon;
  }, [lockAPI.tryAbandon]);
  var canGetLock = useCallback(function (draggableId) {
    return canStart({
      lockAPI: lockAPI,
      registry: registry,
      store: store,
      draggableId: draggableId
    });
  }, [lockAPI, registry, store]);
  var tryGetLock = useCallback(function (draggableId, forceStop, options) {
    return tryStart({
      lockAPI: lockAPI,
      registry: registry,
      contextId: contextId,
      store: store,
      draggableId: draggableId,
      forceSensorStop: forceStop,
      sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
    });
  }, [contextId, lockAPI, registry, store]);
  var findClosestDraggableId = useCallback(function (event) {
    return tryGetClosestDraggableIdFromEvent(contextId, event);
  }, [contextId]);
  var findOptionsForDraggable = useCallback(function (id) {
    var entry = registry.draggable.findById(id);
    return entry ? entry.options : null;
  }, [registry.draggable]);
  var tryReleaseLock = useCallback(function tryReleaseLock() {
    if (!lockAPI.isClaimed()) {
      return;
    }

    lockAPI.tryAbandon();

    if (store.getState().phase !== 'IDLE') {
      store.dispatch(flush$1());
    }
  }, [lockAPI, store]);
  var isLockClaimed = useCallback(lockAPI.isClaimed, [lockAPI]);
  var api = useMemo(function () {
    return {
      canGetLock: canGetLock,
      tryGetLock: tryGetLock,
      findClosestDraggableId: findClosestDraggableId,
      findOptionsForDraggable: findOptionsForDraggable,
      tryReleaseLock: tryReleaseLock,
      isLockClaimed: isLockClaimed
    };
  }, [canGetLock, tryGetLock, findClosestDraggableId, findOptionsForDraggable, tryReleaseLock, isLockClaimed]);
  useValidateSensorHooks(useSensors);

  for (var i = 0; i < useSensors.length; i++) {
    useSensors[i](api);
  }
}

var createResponders = function createResponders(props) {
  return {
    onBeforeCapture: props.onBeforeCapture,
    onBeforeDragStart: props.onBeforeDragStart,
    onDragStart: props.onDragStart,
    onDragEnd: props.onDragEnd,
    onDragUpdate: props.onDragUpdate
  };
};

function getStore(lazyRef) {
  !lazyRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Could not find store from lazy ref') : invariant$2(false) : void 0;
  return lazyRef.current;
}

function App(props) {
  var contextId = props.contextId,
      setCallbacks = props.setCallbacks,
      sensors = props.sensors,
      nonce = props.nonce,
      dragHandleUsageInstructions = props.dragHandleUsageInstructions;
  var lazyStoreRef = useRef(null);
  useStartupValidation();
  var lastPropsRef = usePrevious$1(props);
  var getResponders = useCallback(function () {
    return createResponders(lastPropsRef.current);
  }, [lastPropsRef]);
  var announce = useAnnouncer(contextId);
  var dragHandleUsageInstructionsId = useHiddenTextElement({
    contextId: contextId,
    text: dragHandleUsageInstructions
  });
  var styleMarshal = useStyleMarshal(contextId, nonce);
  var lazyDispatch = useCallback(function (action) {
    getStore(lazyStoreRef).dispatch(action);
  }, []);
  var marshalCallbacks = useMemo(function () {
    return bindActionCreators$1({
      publishWhileDragging: publishWhileDragging,
      updateDroppableScroll: updateDroppableScroll,
      updateDroppableIsEnabled: updateDroppableIsEnabled,
      updateDroppableIsCombineEnabled: updateDroppableIsCombineEnabled,
      collectionStarting: collectionStarting
    }, lazyDispatch);
  }, [lazyDispatch]);
  var registry = useRegistry();
  var dimensionMarshal = useMemo(function () {
    return createDimensionMarshal(registry, marshalCallbacks);
  }, [registry, marshalCallbacks]);
  var autoScroller = useMemo(function () {
    return createAutoScroller(_extends({
      scrollWindow: scrollWindow,
      scrollDroppable: dimensionMarshal.scrollDroppable
    }, bindActionCreators$1({
      move: move
    }, lazyDispatch)));
  }, [dimensionMarshal.scrollDroppable, lazyDispatch]);
  var focusMarshal = useFocusMarshal(contextId);
  var store = useMemo(function () {
    return createStore({
      announce: announce,
      autoScroller: autoScroller,
      dimensionMarshal: dimensionMarshal,
      focusMarshal: focusMarshal,
      getResponders: getResponders,
      styleMarshal: styleMarshal
    });
  }, [announce, autoScroller, dimensionMarshal, focusMarshal, getResponders, styleMarshal]);

  if (process.env.NODE_ENV !== 'production') {
    if (lazyStoreRef.current && lazyStoreRef.current !== store) {
      process.env.NODE_ENV !== "production" ? warning$1('unexpected store change') : void 0;
    }
  }

  lazyStoreRef.current = store;
  var tryResetStore = useCallback(function () {
    var current = getStore(lazyStoreRef);
    var state = current.getState();

    if (state.phase !== 'IDLE') {
      current.dispatch(flush$1());
    }
  }, []);
  var isDragging = useCallback(function () {
    var state = getStore(lazyStoreRef).getState();
    return state.isDragging || state.phase === 'DROP_ANIMATING';
  }, []);
  var appCallbacks = useMemo(function () {
    return {
      isDragging: isDragging,
      tryAbort: tryResetStore
    };
  }, [isDragging, tryResetStore]);
  setCallbacks(appCallbacks);
  var getCanLift = useCallback(function (id) {
    return canStartDrag(getStore(lazyStoreRef).getState(), id);
  }, []);
  var getIsMovementAllowed = useCallback(function () {
    return isMovementAllowed(getStore(lazyStoreRef).getState());
  }, []);
  var appContext = useMemo(function () {
    return {
      marshal: dimensionMarshal,
      focus: focusMarshal,
      contextId: contextId,
      canLift: getCanLift,
      isMovementAllowed: getIsMovementAllowed,
      dragHandleUsageInstructionsId: dragHandleUsageInstructionsId,
      registry: registry
    };
  }, [contextId, dimensionMarshal, dragHandleUsageInstructionsId, focusMarshal, getCanLift, getIsMovementAllowed, registry]);
  useSensorMarshal({
    contextId: contextId,
    store: store,
    registry: registry,
    customSensors: sensors,
    enableDefaultSensors: props.enableDefaultSensors !== false
  });
  useEffect(function () {
    return tryResetStore;
  }, [tryResetStore]);
  return React__default.createElement(AppContext.Provider, {
    value: appContext
  }, React__default.createElement(Provider, {
    context: StoreContext,
    store: store
  }, props.children));
}

var count$1 = 0;
function useInstanceCount() {
  return useMemo(function () {
    return "" + count$1++;
  }, []);
}
function DragDropContext(props) {
  var contextId = useInstanceCount();
  var dragHandleUsageInstructions = props.dragHandleUsageInstructions || preset.dragHandleUsageInstructions;
  return React__default.createElement(ErrorBoundary, null, function (setCallbacks) {
    return React__default.createElement(App, {
      nonce: props.nonce,
      contextId: contextId,
      setCallbacks: setCallbacks,
      dragHandleUsageInstructions: dragHandleUsageInstructions,
      enableDefaultSensors: props.enableDefaultSensors,
      sensors: props.sensors,
      onBeforeCapture: props.onBeforeCapture,
      onBeforeDragStart: props.onBeforeDragStart,
      onDragStart: props.onDragStart,
      onDragUpdate: props.onDragUpdate,
      onDragEnd: props.onDragEnd
    }, props.children);
  });
}

var isEqual$1$1 = function isEqual(base) {
  return function (value) {
    return base === value;
  };
};

var isScroll = isEqual$1$1('scroll');
var isAuto = isEqual$1$1('auto');
var isVisible$1 = isEqual$1$1('visible');

var isEither = function isEither(overflow, fn) {
  return fn(overflow.overflowX) || fn(overflow.overflowY);
};

var isBoth = function isBoth(overflow, fn) {
  return fn(overflow.overflowX) && fn(overflow.overflowY);
};

var isElementScrollable = function isElementScrollable(el) {
  var style = window.getComputedStyle(el);
  var overflow = {
    overflowX: style.overflowX,
    overflowY: style.overflowY
  };
  return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};

var isBodyScrollable = function isBodyScrollable() {
  if (process.env.NODE_ENV === 'production') {
    return false;
  }

  var body = getBodyElement();
  var html = document.documentElement;
  !html ? process.env.NODE_ENV !== "production" ? invariant$2(false) : invariant$2(false) : void 0;

  if (!isElementScrollable(body)) {
    return false;
  }

  var htmlStyle = window.getComputedStyle(html);
  var htmlOverflow = {
    overflowX: htmlStyle.overflowX,
    overflowY: htmlStyle.overflowY
  };

  if (isBoth(htmlOverflow, isVisible$1)) {
    return false;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    We have detected that your <body> element might be a scroll container.\n    We have found no reliable way of detecting whether the <body> element is a scroll container.\n    Under most circumstances a <body> scroll bar will be on the <html> element (document.documentElement)\n\n    Because we cannot determine if the <body> is a scroll container, and generally it is not one,\n    we will be treating the <body> as *not* a scroll container\n\n    More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-detect-scroll-containers.md\n  ") : void 0;
  return false;
};

var getClosestScrollable = function getClosestScrollable(el) {
  if (el == null) {
    return null;
  }

  if (el === document.body) {
    return isBodyScrollable() ? el : null;
  }

  if (el === document.documentElement) {
    return null;
  }

  if (!isElementScrollable(el)) {
    return getClosestScrollable(el.parentElement);
  }

  return el;
};

var checkForNestedScrollContainers = (function (scrollable) {
  if (!scrollable) {
    return;
  }

  var anotherScrollParent = getClosestScrollable(scrollable.parentElement);

  if (!anotherScrollParent) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n    Droppable: unsupported nested scroll container detected.\n    A Droppable can only have one scroll parent (which can be itself)\n    Nested scroll containers are currently not supported.\n\n    We hope to support nested scroll containers soon: https://github.com/atlassian/react-beautiful-dnd/issues/131\n  ") : void 0;
});

var getScroll$1 = (function (el) {
  return {
    x: el.scrollLeft,
    y: el.scrollTop
  };
});

var getIsFixed = function getIsFixed(el) {
  if (!el) {
    return false;
  }

  var style = window.getComputedStyle(el);

  if (style.position === 'fixed') {
    return true;
  }

  return getIsFixed(el.parentElement);
};

var getEnv = (function (start) {
  var closestScrollable = getClosestScrollable(start);
  var isFixedOnPage = getIsFixed(start);
  return {
    closestScrollable: closestScrollable,
    isFixedOnPage: isFixedOnPage
  };
});

var getDroppableDimension = (function (_ref) {
  var descriptor = _ref.descriptor,
      isEnabled = _ref.isEnabled,
      isCombineEnabled = _ref.isCombineEnabled,
      isFixedOnPage = _ref.isFixedOnPage,
      direction = _ref.direction,
      client = _ref.client,
      page = _ref.page,
      closest = _ref.closest;

  var frame = function () {
    if (!closest) {
      return null;
    }

    var scrollSize = closest.scrollSize,
        frameClient = closest.client;
    var maxScroll = getMaxScroll({
      scrollHeight: scrollSize.scrollHeight,
      scrollWidth: scrollSize.scrollWidth,
      height: frameClient.paddingBox.height,
      width: frameClient.paddingBox.width
    });
    return {
      pageMarginBox: closest.page.marginBox,
      frameClient: frameClient,
      scrollSize: scrollSize,
      shouldClipSubject: closest.shouldClipSubject,
      scroll: {
        initial: closest.scroll,
        current: closest.scroll,
        max: maxScroll,
        diff: {
          value: origin,
          displacement: origin
        }
      }
    };
  }();

  var axis = direction === 'vertical' ? vertical : horizontal;
  var subject = getSubject({
    page: page,
    withPlaceholder: null,
    axis: axis,
    frame: frame
  });
  var dimension = {
    descriptor: descriptor,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: isFixedOnPage,
    axis: axis,
    isEnabled: isEnabled,
    client: client,
    page: page,
    frame: frame,
    subject: subject
  };
  return dimension;
});

var getClient = function getClient(targetRef, closestScrollable) {
  var base = getBox(targetRef);

  if (!closestScrollable) {
    return base;
  }

  if (targetRef !== closestScrollable) {
    return base;
  }

  var top = base.paddingBox.top - closestScrollable.scrollTop;
  var left = base.paddingBox.left - closestScrollable.scrollLeft;
  var bottom = top + closestScrollable.scrollHeight;
  var right = left + closestScrollable.scrollWidth;
  var paddingBox = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  var borderBox = expand$1(paddingBox, base.border);
  var client = createBox({
    borderBox: borderBox,
    margin: base.margin,
    border: base.border,
    padding: base.padding
  });
  return client;
};

var getDimension = (function (_ref) {
  var ref = _ref.ref,
      descriptor = _ref.descriptor,
      env = _ref.env,
      windowScroll = _ref.windowScroll,
      direction = _ref.direction,
      isDropDisabled = _ref.isDropDisabled,
      isCombineEnabled = _ref.isCombineEnabled,
      shouldClipSubject = _ref.shouldClipSubject;
  var closestScrollable = env.closestScrollable;
  var client = getClient(ref, closestScrollable);
  var page = withScroll(client, windowScroll);

  var closest = function () {
    if (!closestScrollable) {
      return null;
    }

    var frameClient = getBox(closestScrollable);
    var scrollSize = {
      scrollHeight: closestScrollable.scrollHeight,
      scrollWidth: closestScrollable.scrollWidth
    };
    return {
      client: frameClient,
      page: withScroll(frameClient, windowScroll),
      scroll: getScroll$1(closestScrollable),
      scrollSize: scrollSize,
      shouldClipSubject: shouldClipSubject
    };
  }();

  var dimension = getDroppableDimension({
    descriptor: descriptor,
    isEnabled: !isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    isFixedOnPage: env.isFixedOnPage,
    direction: direction,
    client: client,
    page: page,
    closest: closest
  });
  return dimension;
});

var immediate = {
  passive: false
};
var delayed = {
  passive: true
};
var getListenerOptions = (function (options) {
  return options.shouldPublishImmediately ? immediate : delayed;
});

function useRequiredContext(Context) {
  var result = useContext(Context);
  !result ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Could not find required context') : invariant$2(false) : void 0;
  return result;
}

var getClosestScrollableFromDrag = function getClosestScrollableFromDrag(dragging) {
  return dragging && dragging.env.closestScrollable || null;
};

function useDroppablePublisher(args) {
  var whileDraggingRef = useRef(null);
  var appContext = useRequiredContext(AppContext);
  var uniqueId = useUniqueId('droppable');
  var registry = appContext.registry,
      marshal = appContext.marshal;
  var previousRef = usePrevious$1(args);
  var descriptor = useMemo(function () {
    return {
      id: args.droppableId,
      type: args.type,
      mode: args.mode
    };
  }, [args.droppableId, args.mode, args.type]);
  var publishedDescriptorRef = useRef(descriptor);
  var memoizedUpdateScroll = useMemo(function () {
    return memoizeOne(function (x, y) {
      !whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Can only update scroll when dragging') : invariant$2(false) : void 0;
      var scroll = {
        x: x,
        y: y
      };
      marshal.updateDroppableScroll(descriptor.id, scroll);
    });
  }, [descriptor.id, marshal]);
  var getClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;

    if (!dragging || !dragging.env.closestScrollable) {
      return origin;
    }

    return getScroll$1(dragging.env.closestScrollable);
  }, []);
  var updateScroll = useCallback(function () {
    var scroll = getClosestScroll();
    memoizedUpdateScroll(scroll.x, scroll.y);
  }, [getClosestScroll, memoizedUpdateScroll]);
  var scheduleScrollUpdate = useMemo(function () {
    return rafSchd$1(updateScroll);
  }, [updateScroll]);
  var onClosestScroll = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Could not find scroll options while scrolling') : invariant$2(false) : void 0;
    var options = dragging.scrollOptions;

    if (options.shouldPublishImmediately) {
      updateScroll();
      return;
    }

    scheduleScrollUpdate();
  }, [scheduleScrollUpdate, updateScroll]);
  var getDimensionAndWatchScroll = useCallback(function (windowScroll, options) {
    !!whileDraggingRef.current ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot collect a droppable while a drag is occurring') : invariant$2(false) : void 0;
    var previous = previousRef.current;
    var ref = previous.getDroppableRef();
    !ref ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot collect without a droppable ref') : invariant$2(false) : void 0;
    var env = getEnv(ref);
    var dragging = {
      ref: ref,
      descriptor: descriptor,
      env: env,
      scrollOptions: options
    };
    whileDraggingRef.current = dragging;
    var dimension = getDimension({
      ref: ref,
      descriptor: descriptor,
      env: env,
      windowScroll: windowScroll,
      direction: previous.direction,
      isDropDisabled: previous.isDropDisabled,
      isCombineEnabled: previous.isCombineEnabled,
      shouldClipSubject: !previous.ignoreContainerClipping
    });
    var scrollable = env.closestScrollable;

    if (scrollable) {
      scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
      scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));

      if (process.env.NODE_ENV !== 'production') {
        checkForNestedScrollContainers(scrollable);
      }
    }

    return dimension;
  }, [appContext.contextId, descriptor, onClosestScroll, previousRef]);
  var getScrollWhileDragging = useCallback(function () {
    var dragging = whileDraggingRef.current;
    var closest = getClosestScrollableFromDrag(dragging);
    !(dragging && closest) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Can only recollect Droppable client for Droppables that have a scroll container') : invariant$2(false) : void 0;
    return getScroll$1(closest);
  }, []);
  var dragStopped = useCallback(function () {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot stop drag when no active drag') : invariant$2(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    whileDraggingRef.current = null;

    if (!closest) {
      return;
    }

    scheduleScrollUpdate.cancel();
    closest.removeAttribute(scrollContainer.contextId);
    closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
  }, [onClosestScroll, scheduleScrollUpdate]);
  var scroll = useCallback(function (change) {
    var dragging = whileDraggingRef.current;
    !dragging ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot scroll when there is no drag') : invariant$2(false) : void 0;
    var closest = getClosestScrollableFromDrag(dragging);
    !closest ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot scroll a droppable with no closest scrollable') : invariant$2(false) : void 0;
    closest.scrollTop += change.y;
    closest.scrollLeft += change.x;
  }, []);
  var callbacks = useMemo(function () {
    return {
      getDimensionAndWatchScroll: getDimensionAndWatchScroll,
      getScrollWhileDragging: getScrollWhileDragging,
      dragStopped: dragStopped,
      scroll: scroll
    };
  }, [dragStopped, getDimensionAndWatchScroll, getScrollWhileDragging, scroll]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      callbacks: callbacks
    };
  }, [callbacks, descriptor, uniqueId]);
  useIsomorphicLayoutEffect(function () {
    publishedDescriptorRef.current = entry.descriptor;
    registry.droppable.register(entry);
    return function () {
      if (whileDraggingRef.current) {
        process.env.NODE_ENV !== "production" ? warning$1('Unsupported: changing the droppableId or type of a Droppable during a drag') : void 0;
        dragStopped();
      }

      registry.droppable.unregister(entry);
    };
  }, [callbacks, descriptor, dragStopped, entry, marshal, registry.droppable]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
  }, [args.isDropDisabled, marshal]);
  useIsomorphicLayoutEffect(function () {
    if (!whileDraggingRef.current) {
      return;
    }

    marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
  }, [args.isCombineEnabled, marshal]);
}

function noop$2$1() {}

var empty = {
  width: 0,
  height: 0,
  margin: noSpacing
};

var getSize = function getSize(_ref) {
  var isAnimatingOpenOnMount = _ref.isAnimatingOpenOnMount,
      placeholder = _ref.placeholder,
      animate = _ref.animate;

  if (isAnimatingOpenOnMount) {
    return empty;
  }

  if (animate === 'close') {
    return empty;
  }

  return {
    height: placeholder.client.borderBox.height,
    width: placeholder.client.borderBox.width,
    margin: placeholder.client.margin
  };
};

var getStyle = function getStyle(_ref2) {
  var isAnimatingOpenOnMount = _ref2.isAnimatingOpenOnMount,
      placeholder = _ref2.placeholder,
      animate = _ref2.animate;
  var size = getSize({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    placeholder: placeholder,
    animate: animate
  });
  return {
    display: placeholder.display,
    boxSizing: 'border-box',
    width: size.width,
    height: size.height,
    marginTop: size.margin.top,
    marginRight: size.margin.right,
    marginBottom: size.margin.bottom,
    marginLeft: size.margin.left,
    flexShrink: '0',
    flexGrow: '0',
    pointerEvents: 'none',
    transition: animate !== 'none' ? transitions.placeholder : null
  };
};

function Placeholder(props) {
  var animateOpenTimerRef = useRef(null);
  var tryClearAnimateOpenTimer = useCallback(function () {
    if (!animateOpenTimerRef.current) {
      return;
    }

    clearTimeout(animateOpenTimerRef.current);
    animateOpenTimerRef.current = null;
  }, []);
  var animate = props.animate,
      onTransitionEnd = props.onTransitionEnd,
      onClose = props.onClose,
      contextId = props.contextId;

  var _useState = useState(props.animate === 'open'),
      isAnimatingOpenOnMount = _useState[0],
      setIsAnimatingOpenOnMount = _useState[1];

  useEffect(function () {
    if (!isAnimatingOpenOnMount) {
      return noop$2$1;
    }

    if (animate !== 'open') {
      tryClearAnimateOpenTimer();
      setIsAnimatingOpenOnMount(false);
      return noop$2$1;
    }

    if (animateOpenTimerRef.current) {
      return noop$2$1;
    }

    animateOpenTimerRef.current = setTimeout(function () {
      animateOpenTimerRef.current = null;
      setIsAnimatingOpenOnMount(false);
    });
    return tryClearAnimateOpenTimer;
  }, [animate, isAnimatingOpenOnMount, tryClearAnimateOpenTimer]);
  var onSizeChangeEnd = useCallback(function (event) {
    if (event.propertyName !== 'height') {
      return;
    }

    onTransitionEnd();

    if (animate === 'close') {
      onClose();
    }
  }, [animate, onClose, onTransitionEnd]);
  var style = getStyle({
    isAnimatingOpenOnMount: isAnimatingOpenOnMount,
    animate: props.animate,
    placeholder: props.placeholder
  });
  return React__default.createElement(props.placeholder.tagName, {
    style: style,
    'data-rbd-placeholder-context-id': contextId,
    onTransitionEnd: onSizeChangeEnd,
    ref: props.innerRef
  });
}

var Placeholder$1 = React__default.memo(Placeholder);

var DroppableContext = React__default.createContext(null);

function checkIsValidInnerRef(el) {
  !(el && isHtmlElement(el)) ? process.env.NODE_ENV !== "production" ? invariant$2(false, "\n    provided.innerRef has not been provided with a HTMLElement.\n\n    You can find a guide on using the innerRef callback functions at:\n    https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/using-inner-ref.md\n  ") : invariant$2(false) : void 0;
}

function isBoolean(value) {
  return typeof value === 'boolean';
}

function runChecks(args, checks) {
  checks.forEach(function (check) {
    return check(args);
  });
}

var shared = [function required(_ref) {
  var props = _ref.props;
  !props.droppableId ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'A Droppable requires a droppableId prop') : invariant$2(false) : void 0;
  !(typeof props.droppableId === 'string') ? process.env.NODE_ENV !== "production" ? invariant$2(false, "A Droppable requires a [string] droppableId. Provided: [" + typeof props.droppableId + "]") : invariant$2(false) : void 0;
}, function _boolean(_ref2) {
  var props = _ref2.props;
  !isBoolean(props.isDropDisabled) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'isDropDisabled must be a boolean') : invariant$2(false) : void 0;
  !isBoolean(props.isCombineEnabled) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'isCombineEnabled must be a boolean') : invariant$2(false) : void 0;
  !isBoolean(props.ignoreContainerClipping) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'ignoreContainerClipping must be a boolean') : invariant$2(false) : void 0;
}, function ref(_ref3) {
  var getDroppableRef = _ref3.getDroppableRef;
  checkIsValidInnerRef(getDroppableRef());
}];
var standard = [function placeholder(_ref4) {
  var props = _ref4.props,
      getPlaceholderRef = _ref4.getPlaceholderRef;

  if (!props.placeholder) {
    return;
  }

  var ref = getPlaceholderRef();

  if (ref) {
    return;
  }

  process.env.NODE_ENV !== "production" ? warning$1("\n      Droppable setup issue [droppableId: \"" + props.droppableId + "\"]:\n      DroppableProvided > placeholder could not be found.\n\n      Please be sure to add the {provided.placeholder} React Node as a child of your Droppable.\n      More information: https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/api/droppable.md\n    ") : void 0;
}];
var virtual = [function hasClone(_ref5) {
  var props = _ref5.props;
  !props.renderClone ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Must provide a clone render function (renderClone) for virtual lists') : invariant$2(false) : void 0;
}, function hasNoPlaceholder(_ref6) {
  var getPlaceholderRef = _ref6.getPlaceholderRef;
  !!getPlaceholderRef() ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Expected virtual list to not have a placeholder') : invariant$2(false) : void 0;
}];
function useValidation(args) {
  useDevSetupWarning(function () {
    runChecks(args, shared);

    if (args.props.mode === 'standard') {
      runChecks(args, standard);
    }

    if (args.props.mode === 'virtual') {
      runChecks(args, virtual);
    }
  });
}

var AnimateInOut = function (_React$PureComponent) {
  _inheritsLoose(AnimateInOut, _React$PureComponent);

  function AnimateInOut() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;
    _this.state = {
      isVisible: Boolean(_this.props.on),
      data: _this.props.on,
      animate: _this.props.shouldAnimate && _this.props.on ? 'open' : 'none'
    };

    _this.onClose = function () {
      if (_this.state.animate !== 'close') {
        return;
      }

      _this.setState({
        isVisible: false
      });
    };

    return _this;
  }

  AnimateInOut.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (!props.shouldAnimate) {
      return {
        isVisible: Boolean(props.on),
        data: props.on,
        animate: 'none'
      };
    }

    if (props.on) {
      return {
        isVisible: true,
        data: props.on,
        animate: 'open'
      };
    }

    if (state.isVisible) {
      return {
        isVisible: true,
        data: state.data,
        animate: 'close'
      };
    }

    return {
      isVisible: false,
      animate: 'close',
      data: null
    };
  };

  var _proto = AnimateInOut.prototype;

  _proto.render = function render() {
    if (!this.state.isVisible) {
      return null;
    }

    var provided = {
      onClose: this.onClose,
      data: this.state.data,
      animate: this.state.animate
    };
    return this.props.children(provided);
  };

  return AnimateInOut;
}(React__default.PureComponent);

var zIndexOptions = {
  dragging: 5000,
  dropAnimating: 4500
};

var getDraggingTransition = function getDraggingTransition(shouldAnimateDragMovement, dropping) {
  if (dropping) {
    return transitions.drop(dropping.duration);
  }

  if (shouldAnimateDragMovement) {
    return transitions.snap;
  }

  return transitions.fluid;
};

var getDraggingOpacity = function getDraggingOpacity(isCombining, isDropAnimating) {
  if (!isCombining) {
    return null;
  }

  return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};

var getShouldDraggingAnimate = function getShouldDraggingAnimate(dragging) {
  if (dragging.forceShouldAnimate != null) {
    return dragging.forceShouldAnimate;
  }

  return dragging.mode === 'SNAP';
};

function getDraggingStyle(dragging) {
  var dimension = dragging.dimension;
  var box = dimension.client;
  var offset = dragging.offset,
      combineWith = dragging.combineWith,
      dropping = dragging.dropping;
  var isCombining = Boolean(combineWith);
  var shouldAnimate = getShouldDraggingAnimate(dragging);
  var isDropAnimating = Boolean(dropping);
  var transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
  var style = {
    position: 'fixed',
    top: box.marginBox.top,
    left: box.marginBox.left,
    boxSizing: 'border-box',
    width: box.borderBox.width,
    height: box.borderBox.height,
    transition: getDraggingTransition(shouldAnimate, dropping),
    transform: transform,
    opacity: getDraggingOpacity(isCombining, isDropAnimating),
    zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
    pointerEvents: 'none'
  };
  return style;
}

function getSecondaryStyle(secondary) {
  return {
    transform: transforms.moveTo(secondary.offset),
    transition: secondary.shouldAnimateDisplacement ? null : 'none'
  };
}

function getStyle$1(mapped) {
  return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}

function getDimension$1(descriptor, el, windowScroll) {
  if (windowScroll === void 0) {
    windowScroll = origin;
  }

  var computedStyles = window.getComputedStyle(el);
  var borderBox = el.getBoundingClientRect();
  var client = calculateBox(borderBox, computedStyles);
  var page = withScroll(client, windowScroll);
  var placeholder = {
    client: client,
    tagName: el.tagName.toLowerCase(),
    display: computedStyles.display
  };
  var displaceBy = {
    x: client.marginBox.width,
    y: client.marginBox.height
  };
  var dimension = {
    descriptor: descriptor,
    placeholder: placeholder,
    displaceBy: displaceBy,
    client: client,
    page: page
  };
  return dimension;
}

function useDraggablePublisher(args) {
  var uniqueId = useUniqueId('draggable');
  var descriptor = args.descriptor,
      registry = args.registry,
      getDraggableRef = args.getDraggableRef,
      canDragInteractiveElements = args.canDragInteractiveElements,
      shouldRespectForcePress = args.shouldRespectForcePress,
      isEnabled = args.isEnabled;
  var options = useMemo(function () {
    return {
      canDragInteractiveElements: canDragInteractiveElements,
      shouldRespectForcePress: shouldRespectForcePress,
      isEnabled: isEnabled
    };
  }, [canDragInteractiveElements, isEnabled, shouldRespectForcePress]);
  var getDimension = useCallback(function (windowScroll) {
    var el = getDraggableRef();
    !el ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Cannot get dimension when no ref is set') : invariant$2(false) : void 0;
    return getDimension$1(descriptor, el, windowScroll);
  }, [descriptor, getDraggableRef]);
  var entry = useMemo(function () {
    return {
      uniqueId: uniqueId,
      descriptor: descriptor,
      options: options,
      getDimension: getDimension
    };
  }, [descriptor, getDimension, options, uniqueId]);
  var publishedRef = useRef(entry);
  var isFirstPublishRef = useRef(true);
  useIsomorphicLayoutEffect(function () {
    registry.draggable.register(publishedRef.current);
    return function () {
      return registry.draggable.unregister(publishedRef.current);
    };
  }, [registry.draggable]);
  useIsomorphicLayoutEffect(function () {
    if (isFirstPublishRef.current) {
      isFirstPublishRef.current = false;
      return;
    }

    var last = publishedRef.current;
    publishedRef.current = entry;
    registry.draggable.update(entry, last);
  }, [entry, registry.draggable]);
}

function useValidation$1(props, contextId, getRef) {
  useDevSetupWarning(function () {
    function prefix(id) {
      return "Draggable[id: " + id + "]: ";
    }

    var id = props.draggableId;
    !id ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Draggable requires a draggableId') : invariant$2(false) : void 0;
    !(typeof id === 'string') ? process.env.NODE_ENV !== "production" ? invariant$2(false, "Draggable requires a [string] draggableId.\n      Provided: [type: " + typeof id + "] (value: " + id + ")") : invariant$2(false) : void 0;
    !isInteger$1(props.index) ? process.env.NODE_ENV !== "production" ? invariant$2(false, prefix(id) + " requires an integer index prop") : invariant$2(false) : void 0;

    if (props.mapped.type === 'DRAGGING') {
      return;
    }

    checkIsValidInnerRef(getRef());

    if (props.isEnabled) {
      !findDragHandle(contextId, id) ? process.env.NODE_ENV !== "production" ? invariant$2(false, prefix(id) + " Unable to find drag handle") : invariant$2(false) : void 0;
    }
  });
}
function useClonePropValidation(isClone) {
  useDev(function () {
    var initialRef = useRef(isClone);
    useDevSetupWarning(function () {
      !(isClone === initialRef.current) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Draggable isClone prop value changed during component life') : invariant$2(false) : void 0;
    }, [isClone]);
  });
}

function preventHtml5Dnd(event) {
  event.preventDefault();
}

function Draggable(props) {
  var ref = useRef(null);
  var setRef = useCallback(function (el) {
    ref.current = el;
  }, []);
  var getRef = useCallback(function () {
    return ref.current;
  }, []);

  var _useRequiredContext = useRequiredContext(AppContext),
      contextId = _useRequiredContext.contextId,
      dragHandleUsageInstructionsId = _useRequiredContext.dragHandleUsageInstructionsId,
      registry = _useRequiredContext.registry;

  var _useRequiredContext2 = useRequiredContext(DroppableContext),
      type = _useRequiredContext2.type,
      droppableId = _useRequiredContext2.droppableId;

  var descriptor = useMemo(function () {
    return {
      id: props.draggableId,
      index: props.index,
      type: type,
      droppableId: droppableId
    };
  }, [props.draggableId, props.index, type, droppableId]);
  var children = props.children,
      draggableId = props.draggableId,
      isEnabled = props.isEnabled,
      shouldRespectForcePress = props.shouldRespectForcePress,
      canDragInteractiveElements = props.canDragInteractiveElements,
      isClone = props.isClone,
      mapped = props.mapped,
      dropAnimationFinishedAction = props.dropAnimationFinished;
  useValidation$1(props, contextId, getRef);
  useClonePropValidation(isClone);

  if (!isClone) {
    var forPublisher = useMemo(function () {
      return {
        descriptor: descriptor,
        registry: registry,
        getDraggableRef: getRef,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress,
        isEnabled: isEnabled
      };
    }, [descriptor, registry, getRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled]);
    useDraggablePublisher(forPublisher);
  }

  var dragHandleProps = useMemo(function () {
    return isEnabled ? {
      tabIndex: 0,
      role: 'button',
      'aria-describedby': dragHandleUsageInstructionsId,
      'data-rbd-drag-handle-draggable-id': draggableId,
      'data-rbd-drag-handle-context-id': contextId,
      draggable: false,
      onDragStart: preventHtml5Dnd
    } : null;
  }, [contextId, dragHandleUsageInstructionsId, draggableId, isEnabled]);
  var onMoveEnd = useCallback(function (event) {
    if (mapped.type !== 'DRAGGING') {
      return;
    }

    if (!mapped.dropping) {
      return;
    }

    if (event.propertyName !== 'transform') {
      return;
    }

    dropAnimationFinishedAction();
  }, [dropAnimationFinishedAction, mapped]);
  var provided = useMemo(function () {
    var style = getStyle$1(mapped);
    var onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : null;
    var result = {
      innerRef: setRef,
      draggableProps: {
        'data-rbd-draggable-context-id': contextId,
        'data-rbd-draggable-id': draggableId,
        style: style,
        onTransitionEnd: onTransitionEnd
      },
      dragHandleProps: dragHandleProps
    };
    return result;
  }, [contextId, dragHandleProps, draggableId, mapped, onMoveEnd, setRef]);
  var rubric = useMemo(function () {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  }, [descriptor.droppableId, descriptor.id, descriptor.index, descriptor.type]);
  return children(provided, mapped.snapshot, rubric);
}

var isStrictEqual = (function (a, b) {
  return a === b;
});

var whatIsDraggedOverFromResult = (function (result) {
  var combine = result.combine,
      destination = result.destination;

  if (destination) {
    return destination.droppableId;
  }

  if (combine) {
    return combine.droppableId;
  }

  return null;
});

var getCombineWithFromResult = function getCombineWithFromResult(result) {
  return result.combine ? result.combine.draggableId : null;
};

var getCombineWithFromImpact = function getCombineWithFromImpact(impact) {
  return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};

function getDraggableSelector() {
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoizeOne(function (mode, isClone, draggingOver, combineWith, dropping) {
    return {
      isDragging: true,
      isClone: isClone,
      isDropAnimating: Boolean(dropping),
      dropAnimation: dropping,
      mode: mode,
      draggingOver: draggingOver,
      combineWith: combineWith,
      combineTargetFor: null
    };
  });
  var getMemoizedProps = memoizeOne(function (offset, mode, dimension, isClone, draggingOver, combineWith, forceShouldAnimate) {
    return {
      mapped: {
        type: 'DRAGGING',
        dropping: null,
        draggingOver: draggingOver,
        combineWith: combineWith,
        mode: mode,
        offset: offset,
        dimension: dimension,
        forceShouldAnimate: forceShouldAnimate,
        snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
      }
    };
  });

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id !== ownProps.draggableId) {
        return null;
      }

      var offset = state.current.client.offset;
      var dimension = state.dimensions.draggables[ownProps.draggableId];
      var draggingOver = whatIsDraggedOver(state.impact);
      var combineWith = getCombineWithFromImpact(state.impact);
      var forceShouldAnimate = state.forceShouldAnimate;
      return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId !== ownProps.draggableId) {
        return null;
      }

      var isClone = ownProps.isClone;
      var _dimension = state.dimensions.draggables[ownProps.draggableId];
      var result = completed.result;
      var mode = result.mode;

      var _draggingOver = whatIsDraggedOverFromResult(result);

      var _combineWith = getCombineWithFromResult(result);

      var duration = state.dropDuration;
      var dropping = {
        duration: duration,
        curve: curves.drop,
        moveTo: state.newHomeClientOffset,
        opacity: _combineWith ? combine.opacity.drop : null,
        scale: _combineWith ? combine.scale.drop : null
      };
      return {
        mapped: {
          type: 'DRAGGING',
          offset: state.newHomeClientOffset,
          dimension: _dimension,
          dropping: dropping,
          draggingOver: _draggingOver,
          combineWith: _combineWith,
          mode: mode,
          forceShouldAnimate: null,
          snapshot: getMemoizedSnapshot(mode, isClone, _draggingOver, _combineWith, dropping)
        }
      };
    }

    return null;
  };

  return selector;
}

function getSecondarySnapshot(combineTargetFor) {
  return {
    isDragging: false,
    isDropAnimating: false,
    isClone: false,
    dropAnimation: null,
    mode: null,
    draggingOver: null,
    combineTargetFor: combineTargetFor,
    combineWith: null
  };
}

var atRest = {
  mapped: {
    type: 'SECONDARY',
    offset: origin,
    combineTargetFor: null,
    shouldAnimateDisplacement: true,
    snapshot: getSecondarySnapshot(null)
  }
};

function getSecondarySelector() {
  var memoizedOffset = memoizeOne(function (x, y) {
    return {
      x: x,
      y: y
    };
  });
  var getMemoizedSnapshot = memoizeOne(getSecondarySnapshot);
  var getMemoizedProps = memoizeOne(function (offset, combineTargetFor, shouldAnimateDisplacement) {
    if (combineTargetFor === void 0) {
      combineTargetFor = null;
    }

    return {
      mapped: {
        type: 'SECONDARY',
        offset: offset,
        combineTargetFor: combineTargetFor,
        shouldAnimateDisplacement: shouldAnimateDisplacement,
        snapshot: getMemoizedSnapshot(combineTargetFor)
      }
    };
  });

  var getFallback = function getFallback(combineTargetFor) {
    return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
  };

  var getProps = function getProps(ownId, draggingId, impact, afterCritical) {
    var visualDisplacement = impact.displaced.visible[ownId];
    var isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
    var combine = tryGetCombine(impact);
    var combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;

    if (!visualDisplacement) {
      if (!isAfterCriticalInVirtualList) {
        return getFallback(combineTargetFor);
      }

      if (impact.displaced.invisible[ownId]) {
        return null;
      }

      var change = negate(afterCritical.displacedBy.point);

      var _offset = memoizedOffset(change.x, change.y);

      return getMemoizedProps(_offset, combineTargetFor, true);
    }

    if (isAfterCriticalInVirtualList) {
      return getFallback(combineTargetFor);
    }

    var displaceBy = impact.displacedBy.point;
    var offset = memoizedOffset(displaceBy.x, displaceBy.y);
    return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
  };

  var selector = function selector(state, ownProps) {
    if (state.isDragging) {
      if (state.critical.draggable.id === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (completed.result.draggableId === ownProps.draggableId) {
        return null;
      }

      return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
    }

    return null;
  };

  return selector;
}

var makeMapStateToProps = function makeMapStateToProps() {
  var draggingSelector = getDraggableSelector();
  var secondarySelector = getSecondarySelector();

  var selector = function selector(state, ownProps) {
    return draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
  };

  return selector;
};
var mapDispatchToProps = {
  dropAnimationFinished: dropAnimationFinished
};
var ConnectedDraggable = connect(makeMapStateToProps, mapDispatchToProps, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Draggable);

function PrivateDraggable(props) {
  var droppableContext = useRequiredContext(DroppableContext);
  var isUsingCloneFor = droppableContext.isUsingCloneFor;

  if (isUsingCloneFor === props.draggableId && !props.isClone) {
    return null;
  }

  return React__default.createElement(ConnectedDraggable, props);
}
function PublicDraggable(props) {
  var isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
  var canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
  var shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
  return React__default.createElement(PrivateDraggable, _extends({}, props, {
    isClone: false,
    isEnabled: isEnabled,
    canDragInteractiveElements: canDragInteractiveElements,
    shouldRespectForcePress: shouldRespectForcePress
  }));
}

function Droppable(props) {
  var appContext = useContext(AppContext);
  !appContext ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'Could not find app context') : invariant$2(false) : void 0;
  var contextId = appContext.contextId,
      isMovementAllowed = appContext.isMovementAllowed;
  var droppableRef = useRef(null);
  var placeholderRef = useRef(null);
  var children = props.children,
      droppableId = props.droppableId,
      type = props.type,
      mode = props.mode,
      direction = props.direction,
      ignoreContainerClipping = props.ignoreContainerClipping,
      isDropDisabled = props.isDropDisabled,
      isCombineEnabled = props.isCombineEnabled,
      snapshot = props.snapshot,
      useClone = props.useClone,
      updateViewportMaxScroll = props.updateViewportMaxScroll,
      getContainerForClone = props.getContainerForClone;
  var getDroppableRef = useCallback(function () {
    return droppableRef.current;
  }, []);
  var setDroppableRef = useCallback(function (value) {
    droppableRef.current = value;
  }, []);
  var getPlaceholderRef = useCallback(function () {
    return placeholderRef.current;
  }, []);
  var setPlaceholderRef = useCallback(function (value) {
    placeholderRef.current = value;
  }, []);
  useValidation({
    props: props,
    getDroppableRef: getDroppableRef,
    getPlaceholderRef: getPlaceholderRef
  });
  var onPlaceholderTransitionEnd = useCallback(function () {
    if (isMovementAllowed()) {
      updateViewportMaxScroll({
        maxScroll: getMaxWindowScroll()
      });
    }
  }, [isMovementAllowed, updateViewportMaxScroll]);
  useDroppablePublisher({
    droppableId: droppableId,
    type: type,
    mode: mode,
    direction: direction,
    isDropDisabled: isDropDisabled,
    isCombineEnabled: isCombineEnabled,
    ignoreContainerClipping: ignoreContainerClipping,
    getDroppableRef: getDroppableRef
  });
  var placeholder = React__default.createElement(AnimateInOut, {
    on: props.placeholder,
    shouldAnimate: props.shouldAnimatePlaceholder
  }, function (_ref) {
    var onClose = _ref.onClose,
        data = _ref.data,
        animate = _ref.animate;
    return React__default.createElement(Placeholder$1, {
      placeholder: data,
      onClose: onClose,
      innerRef: setPlaceholderRef,
      animate: animate,
      contextId: contextId,
      onTransitionEnd: onPlaceholderTransitionEnd
    });
  });
  var provided = useMemo(function () {
    return {
      innerRef: setDroppableRef,
      placeholder: placeholder,
      droppableProps: {
        'data-rbd-droppable-id': droppableId,
        'data-rbd-droppable-context-id': contextId
      }
    };
  }, [contextId, droppableId, placeholder, setDroppableRef]);
  var isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
  var droppableContext = useMemo(function () {
    return {
      droppableId: droppableId,
      type: type,
      isUsingCloneFor: isUsingCloneFor
    };
  }, [droppableId, isUsingCloneFor, type]);

  function getClone() {
    if (!useClone) {
      return null;
    }

    var dragging = useClone.dragging,
        render = useClone.render;
    var node = React__default.createElement(PrivateDraggable, {
      draggableId: dragging.draggableId,
      index: dragging.source.index,
      isClone: true,
      isEnabled: true,
      shouldRespectForcePress: false,
      canDragInteractiveElements: true
    }, function (draggableProvided, draggableSnapshot) {
      return render(draggableProvided, draggableSnapshot, dragging);
    });
    return ReactDOM.createPortal(node, getContainerForClone());
  }

  return React__default.createElement(DroppableContext.Provider, {
    value: droppableContext
  }, children(provided, snapshot), getClone());
}

var isMatchingType = function isMatchingType(type, critical) {
  return type === critical.droppable.type;
};

var getDraggable = function getDraggable(critical, dimensions) {
  return dimensions.draggables[critical.draggable.id];
};

var makeMapStateToProps$1 = function makeMapStateToProps() {
  var idleWithAnimation = {
    placeholder: null,
    shouldAnimatePlaceholder: true,
    snapshot: {
      isDraggingOver: false,
      draggingOverWith: null,
      draggingFromThisWith: null,
      isUsingPlaceholder: false
    },
    useClone: null
  };

  var idleWithoutAnimation = _extends({}, idleWithAnimation, {
    shouldAnimatePlaceholder: false
  });

  var getDraggableRubric = memoizeOne(function (descriptor) {
    return {
      draggableId: descriptor.id,
      type: descriptor.type,
      source: {
        index: descriptor.index,
        droppableId: descriptor.droppableId
      }
    };
  });
  var getMapProps = memoizeOne(function (id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone) {
    var draggableId = dragging.descriptor.id;
    var isHome = dragging.descriptor.droppableId === id;

    if (isHome) {
      var useClone = renderClone ? {
        render: renderClone,
        dragging: getDraggableRubric(dragging.descriptor)
      } : null;
      var _snapshot = {
        isDraggingOver: isDraggingOverForConsumer,
        draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
        draggingFromThisWith: draggableId,
        isUsingPlaceholder: true
      };
      return {
        placeholder: dragging.placeholder,
        shouldAnimatePlaceholder: false,
        snapshot: _snapshot,
        useClone: useClone
      };
    }

    if (!isEnabled) {
      return idleWithoutAnimation;
    }

    if (!isDraggingOverForImpact) {
      return idleWithAnimation;
    }

    var snapshot = {
      isDraggingOver: isDraggingOverForConsumer,
      draggingOverWith: draggableId,
      draggingFromThisWith: null,
      isUsingPlaceholder: true
    };
    return {
      placeholder: dragging.placeholder,
      shouldAnimatePlaceholder: true,
      snapshot: snapshot,
      useClone: null
    };
  });

  var selector = function selector(state, ownProps) {
    var id = ownProps.droppableId;
    var type = ownProps.type;
    var isEnabled = !ownProps.isDropDisabled;
    var renderClone = ownProps.renderClone;

    if (state.isDragging) {
      var critical = state.critical;

      if (!isMatchingType(type, critical)) {
        return idleWithoutAnimation;
      }

      var dragging = getDraggable(critical, state.dimensions);
      var isDraggingOver = whatIsDraggedOver(state.impact) === id;
      return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
    }

    if (state.phase === 'DROP_ANIMATING') {
      var completed = state.completed;

      if (!isMatchingType(type, completed.critical)) {
        return idleWithoutAnimation;
      }

      var _dragging = getDraggable(completed.critical, state.dimensions);

      return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, _dragging, renderClone);
    }

    if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
      var _completed = state.completed;

      if (!isMatchingType(type, _completed.critical)) {
        return idleWithoutAnimation;
      }

      var wasOver = whatIsDraggedOver(_completed.impact) === id;
      var wasCombining = Boolean(_completed.impact.at && _completed.impact.at.type === 'COMBINE');
      var isHome = _completed.critical.droppable.id === id;

      if (wasOver) {
        return wasCombining ? idleWithAnimation : idleWithoutAnimation;
      }

      if (isHome) {
        return idleWithAnimation;
      }

      return idleWithoutAnimation;
    }

    return idleWithoutAnimation;
  };

  return selector;
};
var mapDispatchToProps$1 = {
  updateViewportMaxScroll: updateViewportMaxScroll
};

function getBody() {
  !document.body ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'document.body is not ready') : invariant$2(false) : void 0;
  return document.body;
}

var defaultProps$5 = {
  mode: 'standard',
  type: 'DEFAULT',
  direction: 'vertical',
  isDropDisabled: false,
  isCombineEnabled: false,
  ignoreContainerClipping: false,
  renderClone: null,
  getContainerForClone: getBody
};
var ConnectedDroppable = connect(makeMapStateToProps$1, mapDispatchToProps$1, null, {
  context: StoreContext,
  pure: true,
  areStatePropsEqual: isStrictEqual
})(Droppable);
ConnectedDroppable.defaultProps = defaultProps$5;

var uiLibraryImports = /*#__PURE__*/Object.freeze({
  __proto__: null,
  AccessAlarmSharp: AccessAlarmSharp,
  Accordion: Accordion,
  AccordionDetails: AccordionDetails,
  AccordionSummary: AccordionSummary,
  AddIcon: AddIcon,
  Alert: Alert$1,
  ArrowBack: ArrowBack,
  ArrowBackIosIcon: ArrowBackIosIcon,
  ArrowDownwardIcon: ArrowDownward,
  ArrowDropDownIcon: ArrowDropDownIcon$1,
  ArrowDropUpIcon: ArrowDropUpIcon,
  ArrowForwardIosIcon: ArrowForwardIos,
  ArrowLeftIcon: ArrowLeftIcon$1,
  ArrowRightAltIcon: ArrowRightAlt,
  ArrowRightIcon: ArrowRightIcon$1,
  ArrowUpwardIcon: ArrowUpward,
  Autocomplete: Autocomplete$1,
  Avatar: Avatar,
  Box: Box,
  Button: Button,
  ButtonGroup: ButtonGroup,
  Card: Card,
  CardActions: CardActions,
  CardContent: CardContent,
  CheckCircleOutlineIcon: CheckCircleOutline,
  CheckIcon: CheckIcon,
  Checkbox: Checkbox,
  ChevronRight: ChevronRight,
  Chip: Chip$2,
  CircularProgress: CircularProgress,
  ClickAwayListener: ClickAwayListener,
  CloseIcon: CloseIcon,
  Collapse: Collapse$1,
  CreateIcon: CreateIcon,
  CropSquareIcon: CropSquare,
  DataGrid: _s,
  DeleteOutlineIcon: DeleteOutlineIcon,
  Dialog: Dialog,
  DialogActions: DialogActions,
  DialogContent: DialogContent,
  DialogContentText: DialogContentText,
  DialogTitle: DialogTitle,
  Divider: Divider,
  DotIcon: FiberManualRecordIcon,
  DragDropContext: DragDropContext,
  Draggable: PublicDraggable,
  Droppable: ConnectedDroppable,
  ErrorIcon: Error$1,
  ErrorOutlineRoundedIcon: ErrorOutlineRoundedIcon,
  ErrorOutlinedIcon: ErrorOutlinedIcon,
  ExpandLess: ExpandLess,
  ExpandMore: ExpandMore,
  FiberManualRecordIcon: FiberManualRecordIcon,
  FormControl: FormControl,
  FormControlLabel: FormControlLabel,
  FormHelperText: FormHelperText,
  Grid: Grid$1,
  GroupIcon: Group,
  HelpOutlineIcon: HelpOutline,
  HelpOutlineSharpIcon: HelpOutlineSharpIcon,
  HighlightOffIconIcon: HighlightOff,
  IconButton: IconButton$1,
  ImageList: ImageList,
  ImageListItem: ImageListItem,
  InfoIcon: Info,
  Input: Input,
  InputAdornment: InputAdornment,
  InputLabel: InputLabel,
  KeyboardArrowDownIcon: KeyboardArrowDown,
  KeyboardArrowUpIcon: KeyboardArrowUp,
  LanguageIcon: Language,
  LinearProgress: LinearProgress,
  LinkIcon: LinkIcon,
  List: List,
  ListItem: ListItem,
  MaximizeIcon: Maximize,
  Menu: Menu$1,
  MenuItem: MenuItem,
  MenuList: MenuList,
  Modal: Modal,
  MoreVertOutlinedIcon: MoreVertOutlinedIcon,
  OutlinedInput: OutlinedInput,
  Pagination: MuiPagination,
  Paper: Paper$1,
  PlayArrowIcon: PlayArrow,
  Popover: Popover,
  Popper: Popper,
  Radio: Radio,
  RadioGroup: RadioGroup,
  ReplayIcon: Replay,
  SearchIcon: SearchIcon,
  Select: Select,
  SentimentVeryDissatisfied: SentimentVeryDissatisfied,
  Slide: Slide,
  Slider: Slider,
  Snackbar: Snackbar$1,
  Step: Step$1,
  StepButton: StepButton,
  StepLabel: StepLabel,
  Stepper: Stepper,
  Switch: Switch,
  Tab: Tab,
  Table: Table,
  TableBody: TableBody,
  TableCell: TableCell,
  TableContainer: TableContainer,
  TableHead: TableHead,
  TablePagination: TablePagination,
  TableRow: TableRow,
  Tabs: Tabs$1,
  TextField: TextField,
  ThemeProvider: ThemeProvider$1,
  TimerIcon: Timer,
  Tooltip: Tooltip$1,
  TreeItem: TreeItem$1,
  TreeView: TreeView$1,
  VisibilityIcon: Visibility,
  VisibilityOffIcon: VisibilityOff,
  ZoomInIcon: ZoomIn,
  createMuiTheme: createTheme,
  createStyles: createStyles,
  makeStyles: makeStyles$1,
  useMediaQuery: useMediaQuery,
  useTheme: useTheme$2,
  withStyles: withStyles
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var CheckboxTypesName;
(function (CheckboxTypesName) {
    CheckboxTypesName["unSelected"] = "unSelected";
    CheckboxTypesName["selected"] = "selected";
    CheckboxTypesName["selectedDefault"] = "selectedDefault";
    CheckboxTypesName["indeterminate"] = "indeterminate";
    CheckboxTypesName["disabledAndSelected"] = "disabledAndSelected";
    CheckboxTypesName["disabled"] = "disabled";
})(CheckboxTypesName || (CheckboxTypesName = {}));
var CheckboxColor;
(function (CheckboxColor) {
    CheckboxColor["primary"] = "primary";
    CheckboxColor["secondary"] = "secondary";
    CheckboxColor["default"] = "default";
})(CheckboxColor || (CheckboxColor = {}));
const CheckboxType = {
    unSelected: { checked: false },
    selected: { color: CheckboxColor.primary, checked: true },
    selectedDefault: { color: CheckboxColor.default, checked: true },
    indeterminate: { indeterminate: true, checked: true, color: CheckboxColor.default },
    disabledAndSelected: { disabled: true, checked: true, onChange: () => undefined },
    disabled: { disabled: true }
};

const CheckboxContainer = (props) => {
    const { type = 'unSelected', disabled } = props, rest = __rest$1(props, ["type", "disabled"]);
    const auxiliaryProps = Object.assign({}, CheckboxType[type]);
    return jsx(Checkbox, Object.assign({}, auxiliaryProps, rest), void 0);
};

var classnames = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}()); 
} (classnames));

var classnamesExports = classnames.exports;
var classNames = /*@__PURE__*/getDefaultExportFromCjs(classnamesExports);

const CardContainer = (props) => {
    const { children, actions, className, contentClassName, dataTestId } = props, rest = __rest$1(props, ["children", "actions", "className", "contentClassName", "dataTestId"]);
    const useStyles = makeStyles$1(() => ({
        root: {
            width: '100%',
            height: '100%'
        },
        content: {
            height: actions ? '85%' : '100%'
        }
    }));
    const classes = useStyles();
    return (jsxs(Card, Object.assign({ className: classNames(classes.root, className), "data-testid": dataTestId }, rest, { children: [jsx(CardContent, Object.assign({ className: classNames(classes.content, contentClassName) }, { children: children }), void 0), actions && jsx(CardActions, { children: actions }, void 0)] }), void 0));
};

var TooltipPlacement;
(function (TooltipPlacement) {
    TooltipPlacement[TooltipPlacement["top"] = 0] = "top";
    TooltipPlacement[TooltipPlacement["bottom-end"] = 1] = "bottom-end";
    TooltipPlacement[TooltipPlacement["bottom-start"] = 2] = "bottom-start";
    TooltipPlacement[TooltipPlacement["bottom"] = 3] = "bottom";
    TooltipPlacement[TooltipPlacement["left-end"] = 4] = "left-end";
    TooltipPlacement[TooltipPlacement["left-start"] = 5] = "left-start";
    TooltipPlacement[TooltipPlacement["left"] = 6] = "left";
    TooltipPlacement[TooltipPlacement["right-end"] = 7] = "right-end";
    TooltipPlacement[TooltipPlacement["right-start"] = 8] = "right-start";
    TooltipPlacement[TooltipPlacement["right"] = 9] = "right";
    TooltipPlacement[TooltipPlacement["top-end"] = 10] = "top-end";
    TooltipPlacement[TooltipPlacement["top-start"] = 11] = "top-start";
})(TooltipPlacement || (TooltipPlacement = {}));
var TooltipTypesName;
(function (TooltipTypesName) {
    TooltipTypesName[TooltipTypesName["primary"] = 0] = "primary";
    TooltipTypesName[TooltipTypesName["main"] = 1] = "main";
})(TooltipTypesName || (TooltipTypesName = {}));
const tooltipType = {
    primary: {
        backgroundColor: '#070019 !important',
        color: '#e1e1e1cc !important',
        fontSize: '0.825rem !important',
        border: '1px solid #c26991e6'
    },
    main: {
        backgroundColor: '#716596 !important',
        color: '#F2EFF8E5 !important',
        fontSize: '0.8125rem !important',
        border: '1px solid #F2EFF8',
        padding: '0.375rem 0.5rem'
    }
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$1z = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.tooltip-text{align-items:center;color:#6b6874;display:flex;font-size:1rem;justify-content:center;line-height:1.4rem}";
styleInject(css_248z$1z);

const TooltipContainer = (props) => {
    const { hasBorder, hasDefaultStyle, title, titleClassName, children, dataTestid, unsetMaxWidth, isTooltipHidden, borderColor, backgroundColor, maxWidth, minWidth, extraclasses = {}, type = 'main' } = props, rest = __rest$1(props, ["hasBorder", "hasDefaultStyle", "title", "titleClassName", "children", "dataTestid", "unsetMaxWidth", "isTooltipHidden", "borderColor", "backgroundColor", "maxWidth", "minWidth", "extraclasses", "type"]);
    const tooltipBorderColor = borderColor || '#95939B';
    const typeProps = tooltipType[type];
    let useStyles;
    useStyles = makeStyles$1(() => ({
        tooltip: Object.assign({ maxWidth: unsetMaxWidth ? 'unset' : undefined, border: `1px solid ${tooltipBorderColor}` }, (backgroundColor && { backgroundColor: `${backgroundColor} !important` })),
        arrow: {
            '&::before': Object.assign({ border: `1px solid ${tooltipBorderColor}` }, (backgroundColor && { backgroundColor }))
        }
    }));
    if (type === 'primary') {
        useStyles = makeStyles$1(() => ({
            tooltip: Object.assign(Object.assign(Object.assign({}, typeProps), { margin: 0, zIndex: 8, maxWidth: maxWidth ? `${maxWidth} !important` : '', minWidth: minWidth ? `${minWidth} !important` : '' }), extraclasses),
            tooltipPlacementTop: {
                margin: '6px 0'
            },
            tooltipPlacementBottom: {
                margin: '6px 0'
            },
            tooltipPlacementRight: {
                margin: '0 6px'
            },
            tooltipPlacementLeft: {
                margin: '0 6px'
            },
            arrow: {
                '&::before': {
                    border: typeProps.border,
                    backgroundColor: typeProps.backgroundColor
                }
            }
        }));
    }
    const classes = useStyles();
    const renderTitle = () => {
        if (title === '')
            return '';
        if (!hasDefaultStyle)
            return jsx("div", Object.assign({ className: titleClassName }, { children: title }), void 0);
        return (jsx("div", Object.assign({ "data-testid": dataTestid, className: classNames('tooltip-text', titleClassName) }, { children: title }), void 0));
    };
    if (isTooltipHidden)
        return children;
    if (type === 'primary') {
        return (jsx(Tooltip$1, Object.assign({ "data-testid": dataTestid, classes: {
                arrow: classes.arrow,
                tooltip: classes.tooltip,
                tooltipPlacementBottom: classes.tooltipPlacementBottom,
                tooltipPlacementLeft: classes.tooltipPlacementLeft,
                tooltipPlacementTop: classes.tooltipPlacementTop,
                tooltipPlacementRight: classes.tooltipPlacementRight
            }, arrow: true, placement: "top" }, rest, { title: renderTitle() }, { children: children }), void 0));
    }
    return (jsx(Tooltip$1, Object.assign({ "data-testid": dataTestid, classes: hasBorder ? { arrow: classes.arrow, tooltip: classes.tooltip } : {}, arrow: true, placement: "top" }, rest, { title: renderTitle() }, { children: children }), void 0));
};

const SimpleLoader = (props) => {
    const { dataTestid, color = 'inherit', size = '1rem' } = props, rest = __rest$1(props, ["dataTestid", "color", "size"]);
    return jsx(CircularProgress, Object.assign({}, rest, { color: color, size: size, "data-testid": dataTestid }), void 0);
};

var img$w = "data:image/png;base64,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";

var img$v = "data:image/png;base64,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";

var img$u = "data:image/png;base64,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";

var img$t = "data:image/png;base64,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";

var img$s = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAA5hSURBVHgBrVl5VJTXFb93YFgHGFEUBGVwCagx4AJoPQngFrV1SdvTJs0xYk7a7GrTpjU9J1Fzcupp+o+xzXJ62hPI4knauGWpW4yosQIGxbiwKDjIDKAsDgwoi3yv973vve/7ZlyqSV/OZJhv/d37fvd3f++J8D1HVtYaJ8DgMpsNMhGYS2OQCUwbAsCcjDEQH9DcTGP0GTyJjJUMMKisri5yw/cYCN9hcLAhIbgCkS1zhNryHHY7JkVFcJCMP5OAEnYmr2biw/SBXr+fdfcPoK+vt4TBYHF19ZYi+A7jroBzwKGhsJpuW5MUFe4cHxcDtb4uiLaHsHNXugRgkFmWYPW/mSaPAYx3xrCYMDuOjIqGrxoboauv102niqprt2y4Gyx3DDw7+8U8xMEihz3U9bMxo+DvVeclKE4F+a0D5D9QgeYv0NigEZB5LQMHBVwwKgW/aWkBj9/P6bS+tu6fxXeC538Cz89f47x2LXQdvWjN4xlp8I+qOplJjUlgqHFeEGj+PA6e02Zd7jSYNnwY1FzxwQsHj0BTd494HhPXGbMh6MOPrc2ZDhvLykHTtE3Xtesb3O4dvu8MnKjhCg8P3b5wVGJWU881ONHWIV5KD9cvkBRQgSjgWxYUwD3OOOM531xqhSf2fQUSKco/UAWhafosZcQPAf7ZWlPrpjP5Fy5sa7gVNtstQc/goO0HpgwbknW4uRVOtHYwk78gpxtMPoMETwesoPmYPiLByK7MNqoZs9ZDVVsbbK89BzmJianItJK0tEWpdwV8BgfN7AeIg67m7qvQ1T8AgrdgZlcTL+ZZNriMIuP0+eZya8Dzajp8PEKU4GVtgAGYnwOTOtDU40cqYBdooSWuxAWum2EMCT7AOT0wYD86ZZjT1T84CM3XrnFKMFlY4gUgQYJBNSMgAaiCqDGNsjwsMoJochl+f/gI+Pv7BR0MsHoBi2lLckTj7NRRpDB94tPZ2wcJUZE4YehQp/dqd74Tkz/29bp7bwt8xIgHNi4anbjgUNNl6B4Y4HxmMfYQvDc+DrsH+qGPgmGaFqTXigZ6EP7+PvhXbZ0A+vJ/yhiBRnVeUUPVx2OTJuLfFjwIc10uWDF5Mnb29eHJy5eRZJLu68OFY8eOONvZEdHpr9sDt6JKTs5vVtAT19T6/KBekjcyAbcuyIM3H8iB4jmzgGs36EXIgqZbfGuG2hiB4A26rouioNfySZMCEvf8tGmG8nT29kKT388vW52SsiD/lsARYf3qe8exc51+pcmw+r4MiLGHivMjo6Pglez7LAqiA5aElZk0M2s9r4l4zJrQi1OD2PAwuNlQclnq8cDq7Fy0adq7Tme+8wbgOTm/XZcYGenadKpW8VjcnRQVGfDApKgomXG9wpipEnopiNeZnVLTdID6DPAaAT0YBqLYq9rbA56/rbZGJQ2VXdhUfpTFRES4HFFha26ScVZIBak6oFGMx1s7Ah5c4m0B/YGa1GE90/I/FIAUalnIzDgguihThbxs/D2wvaYGXiopoe9qWHvgK/jj11+DdfaUAq28L4tHukplXRRndvYLhSQ/Kxq6e1AUn6CfPs0Hmy5BfEQ4+KlQP7/QCCMdkXCqtZ0KcAAkAlRt3Gj/sgayE0fgsZYW9Vtdr8/wyCTMGDIE3jt9Cs62tbH97gtY1doGut+BQDuBgGWeRpYcGxfZrw1e6uyuKxXktdlsK+5PHIZfNHiN7qd4RooArx6rVOohMvWrSenw6YUGaKZANf0gqqyraxgzdJ9TRfAedZ0X3TE9Ph7+crxCvI/TSD1fB62BjJLOoXgKXYWTEhLA29W5lC7chLzZRNnC6seRWpxoa0dNSp3Rzk0Dxcz2zmDJmNFY3XFFeBGVTQdZx+UT0mHJuDE40hEtgq/u6BA8fut4JXj9XYyOY3ZSkqCIeiYYKiU7qmXGRVjSrCXHxkJXbx/z+vzxodevY2Z0dAhRoQ81zdrOWVA7BzSnmuHOOjf7Rfp4JLfIjjVfgqVj0/DF7CkQExaoEhmUWf6Zk5oK758+LTj714oKCGpEljoxZ1xegCjnIi4snJYAgF3RvctsdLSAlAPPXfGLSeFRa8yMwAKWPwElh4VKbKmuYeRDcFPB/fjqrNwbQPOh2n8snXt26lTKut9o7SZokMok36MOoE1i1ml2tr2NZ53HlWWjCzJlETBllFBqtHqYKhTdFTKdRnqOcOf5eg4ebjY+rXfDK0fKAo69NHMmBWi3zCgoyliViFMaZcb0OGQa9RnAVBvlNk0WFQp66TeAZboUeKZmT8kZP/Z05mS0Zvp4q6nLO8/XwdSEeKi2aHVseLho7ZZMG9kHnd8ggQaAlnmVQVHG6epUMJofGZ7IcHg7bwYc+/kS+HB+HiRFR4JSCtk4jBngdEknSeOj+eo1WL7/CGworxS/+cKhzOuFJWPHwNO7/w2LP97Ci1Oceyg9XeVQeBaRHN2U80SLItzy0E+x/rk18PnDj0KKI0YkFJTEMIizWby0COb1WdPFyoWPe4bEwfrcqWBUvrhSMzomf1V6vBOaaZHxzMEyYNQD3smfKe7d33AREikJOUmJ8P7ipdDZ1wuPbP8E/OT+UmJi9WQoNeDc1PksEvLOosUwIzlF/Jw4LAFen/egwXXQ4TtDmeEn9EwGLwK4PX1y8gQ5d2pKwZBJPhxhoaANXgef3pTEseJT33Lnp3BRcYaTryfLSp8Yosvz03PAaF5Bg4O1Dh4EGjZDqAxy4Hxt51T+ouJyO2V8qHET1+l3Tp5hTLVgiyXl8JeOGwtcs98umAm/PnAICnfthtdmzYRGXwfMJqvKB8805zZNv8h2VVsrbD5Wai1QyoZejBwUB5orM84Hv16fczQ4b6MJ7zSdBMCGsgpW6+sUf1eQlPGFrukbdJ5rymDR147z58W1I6Oj4eMfLYTNswtga3UVTE8cTiCFBYbX587XuSooAnC2tRWUB5HDoAkfv9u/V4Dlo8zrgSe/+Cx4ceymjANVE0tVSuGlonpk136zCSnzBGa9o3J5NN47fYYtnzjBUJaMofFQ2ngRVuXmBky1Gpzjm8vLpA8xUTOh24Ls0NjVBT/86EMrUCaXhspOu6k4aXvMGr6yo8zwGWpKA1o+04uLexncWFoaQNQ/zZ0HP8mYCDcbbxwrA093l5I7MKtO2inLkyxZRmaJkT4nbTAIlc09PTg+LlafPt4dNbFPonitOhCaeqgbIVWg5U0tuL+hQRiy4AxbM/1lfT15jV7D7hopBF0HUcFXabZ+0QkqWubp6uK6WGKDkIgd3LLyiteLTu+OzHR5ANZOKlZsZnEmRUezZ6dOgef27oOHtm0T5snacGiHigqxHB54vwie3PWZKNJV2bnMylmDNaibTISACFAWAL8XOc6QcFulOJY5+YkDeclJ+Qc8XuMpTK5cmFmYyvLq30QTB/F67Ywc2Hj0qHBtFBBKTgkEz02bTqDLGDCLoaL/zx/DlSiGFX9biab7Q4WVmWDNrsl1/scZE+CTqjMlnuZ9BWIFRPh21l7xGVrNQakFAZpUQ1BLLulq1uZmw5sVxwVoAGNvBGSnVc2Bz568R8/m3vo6ONbkJSATlZUwk26htkEVYlEMrU2/dNcD2qCYHxTAbfbrRZ7ubh9vNNLvMItHMXyJxswu++yULHzzxAnZxoOAMmWOpMcxXAeoBQWcaWtlZU0etjpnBr58fx5W/vJpOPTY41CYOUXJtTUQNi9tLE+Qu9G7r8gAXllZxFcDb3xQVQN6L1AdzXRwtGrBrUsXQ+mjj0DRooUUfQOtRrpAt8CCAihdJoCxogG92EHudDFgFglEuh950a4ksJz7KeRRKAjuTYxIldmiIHllFauAjMVyaBhsonWk+6nMew0TpaadLxbemFMgNJq36xxawcxJHQ1ShOSCVmzLWd1eoHWVQVguEKAmJNxoiXNIlWSwIsBXKBgK0u1p2rv+BuA868gGV75V+S3LHjFcabh4B3eAyQ5H4MMJPIAmaaSWe2oPkRkvlsNQEbTZUFhnPSrRGYOHOsavmEC+5dXDB5kNbeut1wRsCJ2u/qCE6LWZt28HmX2QMsjlTWm0Gt5uv8Wbg9mU5P6KtTOC2UB0R8iYtKko7MG7J0+IPUNOm9cOHyQJ7VLFgNxwEYjNbu/uYuv7b9gfz8oqdPZd7T8wfcTwLP6Apu5u0UXnjB4Fa2fOEJkvb26CZ/bs0ZsJAARt1pPUOdif584XZukseY6nyGt4pBcHs+eAvlEOBoVAt9xixrgn596Gsu+2hfVPcbtLfLcFzkdGxsMu2rehbWZ7agz9w5RYJ6qmowpQX8qpjgpqd4DThgwVWq1pKU39ozu2Kum74d0WDRd/J8fEMGo0VLj9F2wazna37HYHY7zp/nh19UduDMECmroGnmEGAU7OUrhg2TYWWxoC/M38NOjssG5TW58mvvmH6zWpCwftvhXoWwJX4G32kILyJq972fjxtNIZIgFrFvsi90WkiijDHFxwwsYav0xBV6oho+DUwnlpYxjdX0mgC24Fmo8QuM1oazvti3WmF9e2d0S0Xu3J/cMPfoCHLl40VER2RIaWbQY+AeVNHsHvBPonQR7E6j27xJ65VRLRsijggxoRbKNCPdPetjnkav9Kd9uXLbfDhnCHY6xrcSFtXKwj6rhySQr3XqgT+9dGi1CEYvr+AagznCIkgSowHbcmOwDgKgLMVYVo6aatwJVuz+6SO8Fzx8DVcKUsWkd3FVLRps51jUGPv1NIGamH1PIA06FMlGGcuC5TwGzi8OG0ydnKLcMV2rzcbAvt3RSsHP9X4GqMSl5QaAONdnnD83g3VcsyPkxrAiA7kfGTyyIVHoG/VkIzsdNm7yu6G8DfG7ga4l/F7FoWqWE+1W0mQ1ua2KtRL0DwEcU6acuskqrCzSCkMqSnd4fbd/dgreO/gIzFJLxkqwwAAAAASUVORK5CYII=";

var img$r = "data:image/png;base64,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";

var img$q = "data:image/png;base64,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";

var img$p = "data:image/png;base64,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";

var img$o = "data:image/png;base64,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";

var img$n = "data:image/png;base64,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";

var img$m = "data:image/png;base64,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";

var img$l = "data:image/png;base64,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";

var img$k = "data:image/png;base64,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";

var img$j = "data:image/png;base64,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";

var img$i = "data:image/png;base64,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";

var img$h = "data:image/png;base64,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";

var img$g = "data:image/png;base64,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";

var img$f = "data:image/png;base64,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";

var img$e = "data:image/png;base64,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";

var img$d = "data:image/png;base64,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";

var img$c = "data:image/png;base64,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";

var img$b = "data:image/png;base64,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";

var img$a = "data:image/png;base64,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";

var img$9 = "data:image/png;base64,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";

var img$8 = "data:image/png;base64,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";

var img$7 = "data:image/png;base64,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";

var img$6 = "data:image/png;base64,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";

var img$5 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAfCAYAAAD9cg1AAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAALrSURBVHgB5VZRVtpQEJ0ZUkjAc6QrkO6ArkB2oP60xX5Id+AO1BWoKxC/0P5IVyCuoLgCcQWNp8UAmpnOAIEEsQT603N6f5K892bumzf3TQZhDkTOir2eW4Ql4Lo9H/GLPzuOQdAoPQOU4oMO4Z4AboPwA6QAIm7oo/7Mcp7wA9BxGKBmDpnlZmoBG8B8m3erlTQEj72LJhKUSH1FY0S4qT7PHRT0WeS24FUnk93+5TaC7ENKIMA6P/FpobDbjMaC3sU1ivjkONTSEDfjBsTsj8NOR0BYZMLE+QtiWSNoUTb7oW17+Bk0KrH5DiwBZn6LIU8INK8VPQF/be1zm4Y7YD51MngQLXBd1xaXTE1pCCzaQmHQmRAS1BhGCaexwxMRLEdRIO74InLf7WZLi5zbbgWgHUnU8keAm8RQnxCYQxI5UjWdTXeNTVVCZRGBbUyT3B6TqZLkWIRPPa/amRCMovh0omHd9J+8ayNRBTTRoa1FBCrPLdP/0CaDV+r8W97dPYnmKb64kKvWQpVsb+B9h3GiZ5KfwGDwtaz6KGGY8c3GbNV5Qt40a2QkYAkivNPQi/HkzyIUvkIEn97ItR3LyDYJmmfo5aqHwPLOdgQClaB/+YKkPxpTpWmCmd/HjyUOhAWwxKnsDlUZoqRHNiZEx/rxkM/29ucVuKUIInT7jbpd/WHQqvt87uNOGjuCtGDoINK63o+iaCFMa5aeYEWkJiAriFrStfq2KZMsjn8N03vQv7izd5Gr4mP/8sef7kccc5NsytEtT6SpWi+z6IUCiOp9ZfxsTYxUYVF5iMOB+SiZk3AsS8XNzHzim1S24ah6dtISgFXTNa9ahxTQv9fea3P/jor+X4KETH8FjRqagoY9zqivSeNE/3yW5JauvweSdiE3bV8SBNbLWEwc6sIVoDd8Q1gw3rC9kGkYynlaec7CToBw2t29INDu4MEujZaFA1gB2s8WtZ+9fZXAywW1ZbvqOLTZGnbZ8bHfXadlOK9rVdwAAAAASUVORK5CYII=";

var img$4 = "data:image/png;base64,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";

var img$3 = "data:image/png;base64,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";

var img$2 = "data:image/png;base64,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";

var img$1 = "data:image/png;base64,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";

var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARAAAABLCAYAAAC4NNiVAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAB2HSURBVHgB7V1rbxzndX5mZu83y1oqETepScrSUrQpO7UEBHbTWgEaBymkBLk0qPOlBQq03/Jj+j0f8iUuisaBk7RJ3KCxC8NKW8sBIiW8ySJpyVyp4sryzt5mdmbenjO7Y62oXe4MObOcJecBFlzudXbmfZ/3nOec9xwJIYb4gcjXZZyPxYCUjqvS30sqfETtHTGvKCgrMlZSX5RW4RH3lkU+I/BydkH6OcYEcVsUpc9LVYwZWyti6gkLM/Rbr7p9T42OVaj46hML0o9wwGgsifNNHfUTz0sr2CfEv4tk87NYNHWUFAlbW/dx/cxfSRqOICRMAO4RkRxLY9GQkLSA1eyr0hZ8hE0kaSISBStqCpUTZ90TlbokLrZbWD3xgr/HNAxMWl6Oz8/vzcRQzp52RyD262W83LTw9kEc7yAwiQhAzy1I17AHNN4XJQict/9p4Wr2S+O55mHGRBBIP9r/LMogq4Fuq6lvebcadkPtf4lIEihbMtSYgY30n0obo97DEyUpcLGwIP0MY0KNrIHCvLSNMYKtCaWNWbcEoq6JizRZtfwa3pdCtDq3l2j8EFIL7sYOWxt6GWdEByWzg+rW7aNrbQzCxBGIg9obYj5uYdqKQ82YWJW+4d8qZ5OChpKsYJasEh4sG+mF4WTSXBIv0oms7PYaP9FYFqXs2fGufuzCZMiFOebChakviXNWDDlDRl00kU+nIAwDUpw+5vY6Kgc9Afn65gWmdyMRdhXVjzEv0++gfyuVdaxGxPE4JpZAHDTeECWyGMopBSJWoNXuS/6ayzaZgMhEYMak85UAVnYShfiDSLRkXMosSK9jDODvq8RQKI3JCqktieLdddRLZSyOskAEna8GnYtcWXpt53N0LktpgSLoJLZoNT9x9uBcAD6HKp3DfkuOrY32HKYlBWd0DQ0ljo3s2chN2Q0TTyAO7r0h8rkEztPFT9BEv559xf8L75AJ+cFFhcxzOnsVZ4Dt17/2CnYpCmMSUx3dpXFDnN+NQNZoAp6cw6W2hDdH6R6OFaBK3jSnIMDHXZrDooihqBuoVCNrwzUODYE4uPeOyD+ho9yRSSEnUTT15/7qJP1gM/fBPeSNNKpTOSRaKl75aB2vj2Pw8QqKTUjj0BfYfZkuo9b8AOd2I5DmmniRXJVqYcH9OWd3TBdIPDkm92/ndwsFizBoIghcyz4jVRDBEw4dgThgIuEVjqwRFkb3FKb1Al7FinMok4WS8BLq3A/GZYWwC4MGuW9P4njq6cHnsf2BKOs6pog83oVHsDUSI6tuHCTiWBs0LkrkomxtrUai6H5waAnEAa/UzY/xHEVtpilUu5L6QrBEUl8Tr2RNXJHGYJbzxHtwE3rQE4B1jSaQl5NIpOcen+T8vKpQJOrM3iNR/Fv4b1DuDFsbHII1JZCXi/cibcMfyDjkkJ6VdIrXv9c08ZZiodj4H3GZrRMEBAo1XKsJvIQxgCdb6RSJkgFCCBJsJSSZPOoa9EGvacXxFY3OL/YBhzjYQoBPYFGUtan6qniVyGN6ax1vFs5KP43II8KeweSh/k5cbF0TF8VyMETCYV17xRsDWIex9ZCA4PwOdlFYC3nseRJWOWwLn8BuGfYJPmZyuy7zrbEhphEhgt9gk1klEmlcp0Hm82TnCU0r3yU/V9PdECRZOROaieLeDsLtTVRfra29nrO1nrVBt8sPlsWFcZ37o4ro/PbAk4IHXo2IxMlS9OlzS5zmjjGAJ3lQF/Rej5yaG+LF/sfZequticsHPZBsErsmXmLtKbI2ggG7gqI3xpyb81wMRxxTJEI250gMUqCREjlHk96eMLKE1f34ypwkRa7MDJv3QeeGcCSmZyn4LqZSeNr+TM4k7X+8ruA86x4HEcFw0ss7AqUOhY3v3cLVKJLiH+zNgj1tLUPX/8bvUT8zJNp3pAmELY5GDLOSieuWwIbQUcg/L607CWO8qikG9I6M63vZe5JZkK40VsUl+ryNoJOltDoCsQTURpc44gKf6izszgjOJF0YbwIYW0PJDmYbKeQ6Haxur+PtiDj2D7Ym2y0UNR1SsgDRTEPLzrpbPA99GHcY6r8X54wW6se+2CMMDaXCgK3e/FwqhhmJVru4hK2EgU0vIVpns91digAEPdj93iPDEZgbv4DEx82b4/JnpLd4sLH1wfcxBrC5PDWH6XgMZa2NeiqPdRrcUcLXPtB4R5QUgRzFs5PIQhgm7mf3uJv8SBIIWx79KdSt34lZNztv2U2gd9gRBy8uDvuPNRUXnliQfoUAwSu0n/tL+muP1G6IlzQD1zIKLm6tBU+GTsJXJ4Yi19y4s4q1yNrwDnt/j4RpIaMk4tCEAp2Io7pVQ9WP83nkCGQnefCq3SRL3auLQdGHsgLwbdXN1vDaspgnK2Y6vxDcys0Wg7r66Aax/aA/07W11hWE6yauBumO8fUwBc4rCthpuhpZG97ARbi0k0QYTZTIvhCkExnkj9+8YeF+EAR8pAiEc0Ayx5Hr3/PQWiLrYx8p1D0imafbyigiuX9NPJeMIR5kqvt+3RhHQGNSTeaQcAikuS5etSxczz3tvyBsi6KLJIqSG8nm9L2buBZZG6Mh/omuVRbFTBzHNbIwDHpMTqKelrF+Ix0MYezEkSIQ9Y9iMf+MdN35389t8bUPiEhM8G1Xi4QFSHSAoEjEqxXCk1d9Djne61Inu6Lxf1AHDTy3ldAc3YTvjxrANlmVsSgEipaJzbs3sRERx3DY1kUW01YHU3zOFAsUCEMVJipbDXJJvj/+c3ekCIRL0vWLRUHsJXFclZyEq8PEViabmEUrxxnpCgKAGytEcM5EDLodogtg0vaSzvK5J5Awm8hLMSRiSWjWx6hbku2HzwiKEiOO9yI35XHY5NpBMabgeKeNzxHBJmjMVEl72042UPG7PvBecaQJhC2QbVKig/Dpe65Nvkli66DPZ33BJEGWQpFX/J7Ag4rlfPocV9oia2PcJREZLIyeOIVzMRllKYHfRMTRhW0FGsgn8zhptcm6sEjDsFAXBoVTLVwblzuyF3xKIHxxD7v5yCHInVbBoMf8BO8hMXXkM0QkO7+HV+m0ghcra/vLZ7DrldaR3Lr5UFnfWb2dXYvmCqb6XzNu1D8Q5yQLs+OI4oQVNlmkiSwSRBYWpiwaG1ycSjdQTxjYJh0jKVvIEYFsxhVMJy6NpzTEXvGIBcIkcuwUElPz0NiPzgto5B0nKncg5SherLSQzGSgSmfDYT55xSA/flxVztm1obiC0HZU4HJIpGXiitfjcK7XIDfMcc9Ok77R3EEuBwHWfiwF+fzcePJHwgAnQUuWkTM1FIRph6Q1XUM9HsNHdYH7J3aU4Gy8KUokitYaTcxlZZprXxt/oSUv8OzC1P6bVrsOkrqCRIo/wECCTC1dMruZimaDIn3k4+Zj9ONDtsoMsrLG2WfFdi0UzDGR9FftclogZCy87Zac+T05EtJ2iyCxFnLQxGEfBwvHBLcV3ScNdj0UCjrTgptoGZgVMmk7pG4qMpFFC3W63tv5DukWHur1il+SRkVE42ex8CDguwYi3ugVn7GQkAWZYoAOC/NGGxuShIRiQDXJXKObnteIZL5/8CTDZuU4yY4nf5xCvxSMWXGsDscScVOMyA15hAWNzR55zBwO8rCLK5GLYXZQUBIgrdwWg3VBgjTpF3USprfzZGXu10rnxYZr2SDkCFxEbb8uyrqJqcJfd0vdObFrMuu4+HGexLQEE4shQaIJJOiM6Uq2RzJkyRS+Pn6xb1ywCwvHMZ3sdAecHYJdxgUagNeGDUBnn07h7P47rAUNtjxogCUzp72XOQwD+jeVUWRthlywWbIsaLiiRuPzPpMFPcU1YMfeKTAsCJRA+AJoDXzlVhb/4daMtlOYP6EQZwLxhoKCTCTTiSFPglKNB6OVhBojP9Lo4L4ZJyumFT5XySvseh4pCCcqwWJjzUBlUH4KPxdEMpffqN8S57gKWO4p6U1MCGyB8xSRBIVPKew8TYJvktwRLUYkIcexrRHRc3uLKFflIQIlkMa/igumBbXwXf9WSyaY0zkcB2kwDQMFiwhGSGTJCKiJJHKkbNfJgqlxRiN9t164MDkWDO9lydBfzuHo7Xh9pE0ER3TUzsG3QXCD5m3xokTHOqiGaljg9IHpGCjFkpixIyAmWYNEFnIH1TA0wQo7AiMQ1kLaFs6nvzle1V28Qz5qCjlZIWtFsVXvImkNuiUhSeEyrqi7TVZNlZOZwiAwDoKzP4fIJK/EkeNK6LZQNyGuC4N/g5LGC6mZ8TUeHwWHMEizmLbIqiXxn28VZLrWxSQQc9gQGIG0fiIu1mVcPREiFdm2Xiis2a6RpSJhit0j0mFYi5FsckGXXFISqmEJVZNVMp/ptlecuChGe1NcuvUH9+6r32DS1UhjsnTSMRSUTBNVWkyqsTy2xtWU67AjEAKxrQ+ZrI/LkxPzt7WXWRy3EiiKFgqces2aSzyOjwwSzA66krdTRu70KTquCVkpWQchHSExrggMNx0nM/Ok3sEUrQjTlsmF07DV7ObeRJXYA0AgBMLWB104NfHNyQ/d2d3LuJ8riWpmt0G0SprLRobcn4MSbz8lk6+RTPmL8XSn2ws4qtS4ie+Q6Psj+Ayb8ClCEsvgOO/ipWvEOliOQiRVzcQmRfA2IpckeARCIPrPxfkO2YqZMoUjJyCW7QV27VGNVHodJS4IKdrQzRi2jh2Q2xN0Kv5+wWIqp2Vnn9qfBcCE8XkWPLnRec+l4wplSdK77PwL0jHurmAzEj3HC99rorb/TZQ/MbA61YHWXLWrdx2q7MOe78w3O5PUTupK4LjawLnWmohz8WFS8zcMye4+H/jEbiftPIXQEoioY5PFVLrrmkDscOrTyCfTOGlpmKIoSZ4sijqF7beVDjYoYnLcaCApZaBXVqKCygcJ3wmEQ2GOcKr/ROCwo0cSfNvk/3v7U4oUBjynLnUbPgmePDLuH8QO2IMGa0ckpr4wbLNmvyuiE1nQuco3FLLxNNRJw9i6vYY11n1UEkPJRckTieS2rkflDcMC3wkk1tdawBKkF0xISq5f6A3sLfStuNyvRJiYJkJZ5P8TnJRk4o4fhKJp4S/JQLrERulZLJLIuZmIkVAtMEU3u0kV70SVk9i2DKh31h4SA2tPFIo/XipjUZOgRu5JOOHr4OOdhJ+QJlDqpZ+LfxEJzcJs6m+CbWg9abCLM7cxzXuEQKHFRBbbRnNvkR67MBBpAGHWQVhM1W7hot4grSKBbSRRHRRGZdJgS8TQkZRlbN9exp2INMINXwmk9Qsxm96x/Zj3wqS+FRHIIDTXxIsN03Z91BiXqCOBkFdkk8PHZMHUXeoonKHKyWaYQNhp/GmKcDWRJK1kfeuP4S2eE+Fx+OrCWPrj3dsp3lg9CsWK9gJJwVbaQDG3YFseTBQbznN2EyUilMYNYUccrAS0GK3gg5LczA7qjQ9Fab+RjnGBj5X3yXBtWBLNKlt/wPVofLgDW/XSd8MjCfhKIHoCj3WJl74lVcWP7Z6lUfm6HUi1UKnLmBv0XG9PzCNp63adUYr4aB+KGQqTS6w38Ugic18XFFYmvWk7rHoTh5tbMZzj3iRookK/7VDWBgkaN3KHuAzpvTcGd4nnzNSom/dgDGvA7bXrPU/QMJ9j1kHq6+KriLAvsAUSpussw18M9Ne5qtLpyuPWSQQ7xKsPedwzIYTZDZAkSef+w1yOAIccQU5wdl/CdJ19JZAHcQw1n7kMPRcTQoRHYPWFvfshx6BNz6GMQ4TCKWklFsc0h/ZxiBH0BOf+MAgJfCWQ04XdrYwwlC8MG1JDrDbTpNCsghkcMqhNXKkn8WfiCLm0jfdsDfBQwlcRlYvGRhEXbxCpwVZbKo6aKfCC6/OZmwwXkcPSjQ2xzB3pmjeIRGIkjxjQKZJkE0oyi5rW8ifJLizIXpAqtd+IqcKXD18msu+ZqBF5eIOlDSaQpAK1Ts/03JiRJQzVO5OhztsFrLulGwdG5eyar+TmqGvdrN2YQbrJmPYVBQkmD+7NTL8tke9A91KhPcw4Up3pwgjO9xhUq4InUkrG94SErcIZ6WcuPsf2i8M60exq5nG8zDVW0h286aF9RSkpMMv1WRQDGr2/klpHZZLr4NpV8yzksn8x+Z35IgI5YOy2HV9dFf8gk0q1tYofurHsWutiNow1SO2OdBJmzQTeZZZrabj40Qp+7tVaZZLkjN1YDLP8P5vPHWMyNyraPYI+QOFubHAz813fSyJqWHrj+u7CRPAPJKKqlomCWzcmbLCr8i/iZVNHNfv0QyuqtiyunzyDyzSJfuol8a1v5/MG/+/sfFYsTNfXxAtEJnqcK8kZqDp1bw+y8NNu6P3u7cZ/iWk6T/e9HGOYmDKyQA4Yu1kgzVXxbSHjOImpd/Im3uLHVC4OLR4KpjLd5946JpGNYiIflj0xD5bFXDyOZ80krgzaOFf7QJTjNPHTZ6S34TN4s2JcRZ5C5EURQ9Ew7IEuybzzl04hk0tHRv3uB95X/yBw7w3BvXJLha+5K5gdpkBFRCAuYRdkPvVw4nL3Pec+V07Xe+togl7BzbSd50wDSTLfk0JAU9LdnA+rgzwPZN4KQpOsC/pHJGgFjUPwblTOD4nTCsofG9ehW/ReqYNZ0kT0Jhdsose97sAdV/Wy9ofiFdvqGFEEmltXEAHmiUTewhjg1B6RE4hzoSJuCUIWXlJWutflIMnFrUtzj9yXEyFxXxgTTSB2LkFh+KRGL9PAlB8+zpOZK7HTL5diCoQ9iAwyi7k8Ia3gQoEu95K72Bxms9h5r9yXs2Hy/d4300TXKGLSyaQgMjHo23XoPMHZ1PRT1GysictNskT28pmsj9BkKZKeEtjGNYeg1GXxnTs38TM33xOmvrlsuSh1JDXWWQzkWbgVveufTKPGxbWDdom4ol/SIJH4G4OvcZj0D0bgneloZbWnmdog01vq3qe/OSf/Uo4hb6/EdDMtmswx1OM0sds00engEnThVK5yRmZ8QolBMwRkmrBxnvCK0p3Q/H7+AKVvUhMz6FbS7ssreGdahlYVfpwn9aBu9pMAEiNfzT0tvQaPcBpSTaWQa7Yh+V1hnideQkPRcaP4Mbo2xfisdMXN+yeh+TY3YX9AbhENryIvOlx2gctX0iKzxRaLnyJu4w27wZg6iEQmgkBY7eZJdqzPZM80kc9koHIXcqXaXdvJ9EvQqqbLRBLM1kwKLYpxp62H70vyat4ms1uHlEnQZKbVGX2r+o0GTeYoQ9UVmkQgGY8E0t/NzmlY5YdVxJ/V0ZBM5RC/1VctzOn3a5i4IFl4yy1ZPSAS4UVkGInwYvRgDtPHQtSzh8HngRa3nMLWb6f7mMz9Z0wilX10RRSviyItovn0Nx+Nqh0pCySCv1DXxMW2iatuCWAnYVD0Y96PznYclq2sYHWYFcckkonjZXYTs6dG57A4GEYi9SVxjttqWDI2SFspURhXkIuxmV4IZ9tMsUSTv03WtIWiQyrkLmuGRi5Qzb0LxOIqiefT/QW5Ig0kwp7B1gQLrP39cofBTtyiVbHfAvCrMXf7pphPndqdiLgOLFmaXxcdvOvmeD99H5GIRFZu5ox0hX+vaaLctLB2oo/4WAz97DxmuLUG72ZmV5e1CpqwlU4S22FMprMF3AIJuGS1yxZynSbJcXSfG8VzW4pOhyyWrz9usdgk0iIS6ZUFFT8URelvw9NVLyKQCQLX1Kgt48tPLEi/GvVansDZ2UczHd2WPmwtidndVnf+nFsuihxzyUZLwnxlFa950ZzYEolZKFPcddWtLmJP0Gco5N3CHLnTcdFGh4T0jYPuKOgG4teiSCSZJLItcpEoJlB28g2FLJY4quT201M4F38W1/Bb0gYjCyTCXsErNIVxd23VyOnf2KF11MisjqeQv72ECmtbHYo25EjutHNKSLFTOsiRL5/naumKjCJpLT/e5fPzHRK5SyOEQw5NtjN4lULPqxmXgmrf8V7WpL1FnBh2I6qzOElazBwH2CQ6Z6o0WQ20bR1Eo2hQkjTGJpKGjFlZwrX0q+Fx3SICmTDwpKzJw62QQa4LY5RV0Q830R63egrrF1IcL5Ir8rqXSAWTYEqgnF/wJ0eEI0WGihJpLEUuWE0hvsqk9BjuR+MHoqRku1FMjjR2dHJ9/vHo9RuKsA9wFqctLA56jib2oMfZ7YBLcLRnVFUtL5/3yar4XmNVXIJHsBXSWB5cJnM/4JAsl5J8sCwuBPH54wRrIo3XRKn1mpjlv1w+FBEijALXTBXLjw6W1k0xc2/58QHEVsvH62IWLsGTfdDnPPL9Q4hqEJhsajfE37EVBA/gY6CJ/u0gSwTSd8wzUXkhxDCD3R7OIxG/FNO1n4opRIgwCEwK9TXxijPR+e+9IaspTw4vk7C2Ji6PIhB+3svqzSs+WzZeyxl+TKTDYiwCBp+7xpI4z5bdqN8+SdgiEmEi4VokXEYAPiPSQAKGvYfmAuLb9yFNkWC5TeJjxoLgjFDnNckM8nEBrdPdKJczE1BlvZuJa2fYSlBbOvSE1E3A+4T+TtPrVa5CpuKluowr9P7iiSGaBLs8BQ+b7JiYahbeHyWSah+KxeRT0nW4AE/QrIIZ3svjNeOUhWMKQ+hewsF7hV2HReA8b1vIkPg7iTrJMNhjcQYCHyN5o+ZPNna0nT8A9LaZ2ystZ/RKn5Hq2AfsxKw07AZTJEbmC0QuNKrzchtnJAXVpIlycUF6d9j7rbqTzuQOnFvxhBhdIrHTcL8ATd1EtTmHad4dy7/HSzSECae1Jl5miyfosGzvuN7i++ymkeU0zaJramHyuyv2EYZvvYMiC2SCwOncjXmUOU+gY0AiVljhtPHdcjtYd7i9joqX1aaX8bp6YsRk5VwTsqTqo8iAJz6Fh8t0vNU07L1Ns16jK+z6NON45ROB35bGXDzIdtUEpnmv1a31qMl3PyICCTHYkvmT+W5ldgqFJjQN+WYTd9SPsMWDuH+fy7DPYA3hSY8p370cjKsnXKz2rBkMcy3s5K45LLJF47yGV3UlhRpaKGUXvLkyDomYRCIHUYHMtgQ7mCcyEZnE4XJv9orIhQkJ7PTsp5FPxHBckN4hU6zfsFBV26ik45jVG7R8r+N9Z/XjVXEUeTBS8A5FoQliuXutlRjc14aPj0sq3Fp5tHxA3sS61qLfQ/rOsHqww8BVvIhE3uQ8mNpt8d6gQkVBoneu37OJvYSZxlWK3EioZF+YjJ7EQSCyQMYMdkMqT9uiqa0xcA9cne4bJC6SXlLtJwgTXXF1ZwIYh2/d1Bph8fTuineTm6Mwmsu6IxxOvruOq/wdNgk+19Vq7v4e9V0223EIeCspcJHe++ZeXAKOzBhprI6bRHai9TsxaxiYjcdJJ/nC5OskXhERyB7xqaKN7srYL5z2g0Ip3fCp1X2t1iWKgQq4XUOUXBZOKR+Wrs7kcVfD1MnnpXWMgNfoiwMKZ15uukwj5+9gSa7gUWRsL4mynkdVaWN2r3VAxhmdGQUOk2ZiKHPEzLYMD0nbhlGICCQEYPJ5qowzRgfJT2RsDhMJbZL6HGZPPD86hby3D6W0lyrttVVxSbPwtlsCMcnl8qqz9ARYicLWRSLZ6l6jK3YxIlJnveopQYGJJE+Cq9lB3tZJjgiRRDgAsJvCORecUu0m0avmIVvSa9bnI8e1NDqRrP+Y+HfsJfnq494x8jnYT7apfR5JzA1T13pG+9d0bv5TnOe/OKSIRNQxo9/a0AT06hredqMBOFvo4RKdxN5bXZoeXstfkiLrobc3x5MrcczCFrsyqokrn5nDRXpoZJmCQWDrhQhMLZ3GV8jFezss0ZHUX3bdOq7p0fiVOK8YUMna2pzkplg7EbkwY8KnIc0YilIH17LPuO9K5rUUod0ekgRKurhqWxqdz7ETXrbSOzVGvOz2feS7ekLv1Bw4YSu/Xz2Dw8SkIWlPhrBaGRPJVBK5pobPkXi+Mqxw8iQhIpCAwZNfCCxaBup18om9JkGxaMop616iDU54lEnLmZgcbtU6qNMKqI/KofBCIOKmmJFOSZs9ksOJPWgZDgnxXhQ/0seZlBIk7IY5e7T9uijLEkXZZPq9E0wk/w+ilbJNC0kP5QAAAABJRU5ErkJggg==";

const pngImages = {
    tournamentsEmptyState: img$w,
    codebashingHeader: img$v,
    badgeAllInOne: img$u,
    certifiedEarn: img$t,
    classicalEarn: img$s,
    embeddedEarn: img$r,
    shareEarn: img$q,
    godEarn: img$p,
    mobileEarn: img$o,
    streakEarn: img$n,
    webbedEarn: img$m,
    multilanguageEarn: img$l,
    badgeNotEarnAllInOne: img$k,
    certifiedNotEarn: img$j,
    classicalNotEarn: img$i,
    embeddedNotEarn: img$h,
    shareNotEarn: img$g,
    mobileNotEarn: img$e,
    godNotEarn: img$f,
    streakNotEarn: img$d,
    webbedNotEarn: img$c,
    multilanguageNotEarn: img$b,
    showThem: img$a,
    stillGotThis: img$9,
    clear: img$8,
    noAssignedLessons: img$7,
    primaryCourse: img$6,
    trophy: img$5,
    emptyState: img$4,
    keys: img$3,
    authKeys: img$2,
    authKeysUnlocked: img$1,
    errorBoxBG: img
};

/* loaded by smart-asset */
var golbet = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var medal = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var zoomIn = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNNDkxLjMxOCAwSDMzNC40MzljLTExLjQyMyAwLTIwLjY4MiA5LjI2LTIwLjY4MiAyMC42ODIgMCAxMS40MjIgOS4yNTkgMjAuNjgyIDIwLjY4MiAyMC42ODJoMTM2LjE5N3YxMzYuMTk3YzAgMTEuNDIyIDkuMjU5IDIwLjY4MiAyMC42ODIgMjAuNjgyIDExLjQyMyAwIDIwLjY4Mi05LjI2IDIwLjY4Mi0yMC42ODJWMjAuNjgyQzUxMiA5LjI2IDUwMi43NDEgMCA0OTEuMzE4IDB6TTE3Ny41NjEgNDcwLjYzNkg0MS4zNjVWMzM0LjQzOWMwLTExLjQyMy05LjI2LTIwLjY4Mi0yMC42ODItMjAuNjgyQzkuMjYgMzEzLjc1NyAwIDMyMy4wMTYgMCAzMzQuNDM5djE1Ni44NzlDMCA1MDIuNzQxIDkuMjYgNTEyIDIwLjY4MiA1MTJoMTU2Ljg3OWMxMS40MjIgMCAyMC42ODItOS4yNTkgMjAuNjgyLTIwLjY4Mi4wMDEtMTEuNDIzLTkuMjYtMjAuNjgyLTIwLjY4Mi0yMC42ODJ6Ii8+CiAgICA8cGF0aCBmaWxsPSIjRkZGIiBkPSJNNTA1Ljk0MyA2LjA1OGMtOC4wNzctOC4wNzctMjEuMTcyLTguMDc3LTI5LjI0OSAwTDI5My42NjkgMTg5LjA4M2MtOC4wNzYgOC4wNzctOC4wNzYgMjEuMTcyIDAgMjkuMjQ5YTIwLjYyIDIwLjYyIDAgMCAwIDE0LjYyNSA2LjA1OCAyMC42MiAyMC42MiAwIDAgMCAxNC42MjUtNi4wNThMNTA1Ljk0MyAzNS4zMDdjOC4wNzYtOC4wNzcgOC4wNzYtMjEuMTcyIDAtMjkuMjQ5ek0yMTguMzMyIDI5My42NjljLTguMDc2LTguMDc3LTIxLjE3Mi04LjA3Ny0yOS4yNDkgMEw2LjA1OCA0NzYuNjkzYy04LjA3NyA4LjA3Ny04LjA3NyAyMS4xNzIgMCAyOS4yNDlBMjAuNjExIDIwLjYxMSAwIDAgMCAyMC42ODIgNTEyYTIwLjYxOCAyMC42MTggMCAwIDAgMTQuNjI1LTYuMDU4bDE4My4wMjUtMTgzLjAyNWM4LjA3Ny04LjA3NiA4LjA3Ny0yMS4xNzEgMC0yOS4yNDh6Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var questionIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTIgMTguOTE0MUMxMi42NDcyIDE4LjkxNDEgMTMuMTcxOSAxOC4zODk0IDEzLjE3MTkgMTcuNzQyMkMxMy4xNzE5IDE3LjA5NSAxMi42NDcyIDE2LjU3MDMgMTIgMTYuNTcwM0MxMS4zNTI4IDE2LjU3MDMgMTAuODI4MSAxNy4wOTUgMTAuODI4MSAxNy43NDIyQzEwLjgyODEgMTguMzg5NCAxMS4zNTI4IDE4LjkxNDEgMTIgMTguOTE0MVoiIGZpbGw9IiM5NTkzOUIiLz4KICAgIDxwYXRoIGQ9Ik0xMiAwQzUuMzY3OTQgMCAwIDUuMzY3MDUgMCAxMkMwIDE4LjYzMjEgNS4zNjcwNSAyNCAxMiAyNEMxOC42MzIxIDI0IDI0IDE4LjYzMyAyNCAxMkMyNCA1LjM2Nzk0IDE4LjYzMyAwIDEyIDBaTTEyIDIyLjEyNUM2LjQwNDIgMjIuMTI1IDEuODc1IDE3LjU5NjUgMS44NzUgMTJDMS44NzUgNi40MDQyIDYuNDAzNDUgMS44NzUgMTIgMS44NzVDMTcuNTk1OCAxLjg3NSAyMi4xMjUgNi40MDM0NSAyMi4xMjUgMTJDMjIuMTI1IDE3LjU5NTggMTcuNTk2NSAyMi4xMjUgMTIgMjIuMTI1WiIgZmlsbD0iIzk1OTM5QiIvPgogICAgPHBhdGggZD0iTTEyIDYuMDIzNDRDOS45MzIyNSA2LjAyMzQ0IDguMjUgNy43MDU2OSA4LjI1IDkuNzczNDRDOC4yNSAxMC4yOTEyIDguNjY5NzIgMTAuNzEwOSA5LjE4NzUgMTAuNzEwOUM5LjcwNTI4IDEwLjcxMDkgMTAuMTI1IDEwLjI5MTIgMTAuMTI1IDkuNzczNDRDMTAuMTI1IDguNzM5NTYgMTAuOTY2MSA3Ljg5ODQ0IDEyIDcuODk4NDRDMTMuMDMzOSA3Ljg5ODQ0IDEzLjg3NSA4LjczOTU2IDEzLjg3NSA5Ljc3MzQ0QzEzLjg3NSAxMC44MDczIDEzLjAzMzkgMTEuNjQ4NCAxMiAxMS42NDg0QzExLjQ4MjIgMTEuNjQ4NCAxMS4wNjI1IDEyLjA2ODIgMTEuMDYyNSAxMi41ODU5VjE0LjkyOTdDMTEuMDYyNSAxNS40NDc1IDExLjQ4MjIgMTUuODY3MiAxMiAxNS44NjcyQzEyLjUxNzggMTUuODY3MiAxMi45Mzc1IDE1LjQ0NzUgMTIuOTM3NSAxNC45Mjk3VjEzLjQwNDhDMTQuNTUzMSAxMi45ODc1IDE1Ljc1IDExLjUxNzYgMTUuNzUgOS43NzM0NEMxNS43NSA3LjcwNTY5IDE0LjA2NzcgNi4wMjM0NCAxMiA2LjAyMzQ0WiIgZmlsbD0iIzk1OTM5QiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var rectangle = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjEyIiBoZWlnaHQ9IjEyIiByeD0iMiIgZmlsbD0iIzFBQzA0QyIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var download = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTQgMTZDNCAxOC4yMDkxIDUuNzkwODYgMjAgOCAyMEwxNiAyMEMxOC4yMDkxIDIwIDIwIDE4LjIwOTEgMjAgMTZMMjAgMTNDMjAgMTIuNDQ3NyAxOS41NTIzIDEyIDE5IDEyQzE4LjQ0NzcgMTIgMTggMTIuNDQ3NyAxOCAxM0wxOCAxNkMxOCAxNy4xMDQ2IDE3LjEwNDYgMTggMTYgMThMOCAxOEM2Ljg5NTQzIDE4IDYgMTcuMTA0NiA2IDE2TDYgMTNDNiAxMi40NDc3IDUuNTUyMjggMTIgNSAxMkM0LjQ0NzcxIDEyIDQgMTIuNDQ3NyA0IDEzTDQgMTZaTTE1LjcwNzEgMTEuNzA3MUMxNi4wOTc2IDExLjMxNjYgMTYuMDk3NiAxMC42ODM0IDE1LjcwNzEgMTAuMjkyOUMxNS4zMTY2IDkuOTAyMzcgMTQuNjgzNCA5LjkwMjM3IDE0LjI5MjkgMTAuMjkyOUwxMyAxMS41ODU4TDEzIDUuNUMxMyA0Ljk0NzcyIDEyLjU1MjMgNC41IDEyIDQuNUMxMS40NDc3IDQuNSAxMSA0Ljk0NzcyIDExIDUuNUwxMSAxMS41ODU4TDkuNzA3MTEgMTAuMjkyOUM5LjMxNjU4IDkuOTAyMzcgOC42ODM0MiA5LjkwMjM3IDguMjkyODkgMTAuMjkyOUM3LjkwMjM3IDEwLjY4MzQgNy45MDIzNyAxMS4zMTY2IDguMjkyODkgMTEuNzA3MUwxMS4yOTI5IDE0LjcwNzFDMTEuNjgzNCAxNS4wOTc2IDEyLjMxNjYgMTUuMDk3NiAxMi43MDcxIDE0LjcwNzFMMTUuNzA3MSAxMS43MDcxWiIgZmlsbD0iIzIxNDJFQiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var filterNoResults = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var adminDashboardEmptyState = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQxIiBoZWlnaHQ9IjE0MSIgdmlld0JveD0iMCAwIDE0MSAxNDEiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03MC41IDE0MUMxMDkuNDM2IDE0MSAxNDEgMTA5LjQzNiAxNDEgNzAuNUMxNDEgMzEuNTYzOSAxMDkuNDM2IDAgNzAuNSAwQzMxLjU2MzkgMCAwIDMxLjU2MzkgMCA3MC41QzAgMTA5LjQzNiAzMS41NjM5IDE0MSA3MC41IDE0MVoiIGZpbGw9IiNGNkY2RjYiLz4KPG1hc2sgaWQ9ImFkbWluRGFzaGJvYXJkRW1wdHlTdGF0ZSIgbWFzay10eXBlPSJhbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjE0MSIgaGVpZ2h0PSIxNDEiPgo8cGF0aCBkPSJNNzAuNSAxNDFDMTA5LjQzNiAxNDEgMTQxIDEwOS40MzYgMTQxIDcwLjVDMTQxIDMxLjU2MzkgMTA5LjQzNiAwIDcwLjUgMEMzMS41NjM5IDAgMCAzMS41NjM5IDAgNzAuNUMwIDEwOS40MzYgMzEuNTYzOSAxNDEgNzAuNSAxNDFaIiBmaWxsPSIjRUJFQkVCIi8+CjwvbWFzaz4KPGcgbWFzaz0idXJsKCNhZG1pbkRhc2hib2FyZEVtcHR5U3RhdGUpIj4KPHBhdGggZD0iTTI5LjAxMzYgMTU5LjE5M0gxMi40Mjk3Vjk3LjM3OTZMMjkuMDEzNiA4MC4zNTI4VjE1OS4xOTNaIiBmaWxsPSIjRjJGOUZGIi8+CjxwYXRoIGQ9Ik00NS42MDk4IDE1OS4xOTNIMjkuMDE1NlY4MC4zNTI4TDQ1LjYwOTggOTAuOTEwOVYxNTkuMTkzWiIgZmlsbD0iI0I4RDFFNiIvPgo8cGF0aCBkPSJNMTIuNDMwMSAxNTkuMTkzSC00LjE2NDA2VjEwOC41NzZMMTIuNDMwMSA5Ny4zNzk2VjE1OS4xOTNaIiBmaWxsPSIjQjhEMUU2Ii8+CjxwYXRoIGQ9Ik02Mi4xOTMzIDE1OS4xOTNINDUuNjA5NFY5MC45MTFMNjIuMTkzMyA2OS4xNTYyVjE1OS4xOTNaIiBmaWxsPSIjRjJGOUZGIi8+CjxwYXRoIGQ9Ik03OC43ODU2IDE1OS4xOTNINjIuMTkxNFY2OS4xNTYyTDc4Ljc4NTYgNzQuNzQ5NVYxNTkuMTkzWiIgZmlsbD0iI0I4RDFFNiIvPgo8cGF0aCBkPSJNOTUuMzY5MSAxNTkuMTkzSDc4Ljc4NTJWNzQuNzQ5NUw5NS4zNjkxIDczLjg5NDVWMTU5LjE5M1oiIGZpbGw9IiNGMkY5RkYiLz4KPHBhdGggZD0iTTExMS45NjUgMTU5LjE5M0g5NS4zNzExVjczLjg5NDVMMTExLjk2NSA2Ni4xMzgyVjE1OS4xOTNaIiBmaWxsPSIjQjhEMUU2Ii8+CjxwYXRoIGQ9Ik0xMjguNTQ5IDE1OS4xOTNIMTExLjk2NVY2Ni4xMzgxTDEyOC41NDkgNDMuMDg1NFYxNTkuMTkzWiIgZmlsbD0iI0YyRjlGRiIvPgo8cGF0aCBkPSJNMTQ1LjE0MSAxNTkuMTkzSDEyOC41NDdWNDMuMDg1NEwxNDUuMTQxIDQ2LjA5MzJWMTU5LjE5M1oiIGZpbGw9IiNCOEQxRTYiLz4KPHBhdGggZD0iTS0zLjg5Nzk2IDEwOC45NzhMLTQuNDMzNTkgMTA4LjE3NUwxMi4xMDkxIDk2Ljk5ODZMMjguOTQwMiA3OS43MzQ4TDQ1LjQ4MjkgOTAuMjYyTDYyLjAxNTMgNjguNTc5M0w3OC44NDY0IDc0LjI2NTJMOTUuMjU1MiA3My40MTAzTDExMS42NDMgNjUuNzQ2N0wxMjguMzMgNDIuNTQ5OEwxNDUuMjIzIDQ1LjYxOTRMMTQ1LjA0OCA0Ni41NzczTDEyOC43NjMgNDMuNjEwOEwxMTIuMjgyIDY2LjUxOTJMMTEyLjE2OSA2Ni41NzA3TDk1LjQ5MjEgNzQuMzY4Mkw5NS4zOTk0IDc0LjM3ODVMNzguNzEyNSA3NS4yNDM4TDYyLjM2NTUgNjkuNzIyN0w0NS43MTk4IDkxLjU1OTlMMjkuMDg0NCA4MC45NzA5TDEyLjczNzQgOTcuNzUwNUwtMy44OTc5NiAxMDguOTc4WiIgZmlsbD0iI0YzNkEyMiIvPgo8cGF0aCBkPSJNMTUuMDA0OSA5Ny4zNzk2QzE1LjAwNDkgOTguODAxMSAxMy44NTEyIDk5Ljk2NTEgMTIuNDE5NCA5OS45NjUxQzEwLjk4NzYgOTkuOTY1MSA5LjgzMzk4IDk4LjgwMTEgOS44MzM5OCA5Ny4zNzk2QzkuODMzOTggOTUuOTQ3OSAxMC45ODc2IDk0Ljc5NDIgMTIuNDE5NCA5NC43OTQyQzEzLjg1MTIgOTQuNzk0MiAxNS4wMDQ5IDk1Ljk0NzkgMTUuMDA0OSA5Ny4zNzk2WiIgZmlsbD0iIzJBNDQ1RSIvPgo8cGF0aCBkPSJNMTMuODEwNCA5Ny4zNzk2QzEzLjgxMDQgOTguMTQxOCAxMy4xOTI0IDk4Ljc3MDIgMTIuNDE5OSA5OC43NzAyQzExLjY1NzYgOTguNzcwMiAxMS4wMjkzIDk4LjE1MjEgMTEuMDI5MyA5Ny4zNzk2QzExLjAyOTMgOTYuNjA3IDExLjY0NzMgOTUuOTg5IDEyLjQxOTkgOTUuOTg5QzEzLjE5MjQgOTUuOTg5IDEzLjgxMDQgOTYuNjA3IDEzLjgxMDQgOTcuMzc5NloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zMS42MDA2IDgwLjM1MjhDMzEuNjAwNiA4MS43ODQ2IDMwLjQ0NjkgODIuOTM4MiAyOS4wMTUxIDgyLjkzODJDMjcuNTgzNCA4Mi45MzgyIDI2LjQyOTcgODEuNzg0NiAyNi40Mjk3IDgwLjM1MjhDMjYuNDI5NyA3OC45MjEgMjcuNTgzNCA3Ny43NjczIDI5LjAxNTEgNzcuNzY3M0MzMC40NDY5IDc3Ljc2NzMgMzEuNjAwNiA3OC45MjEgMzEuNjAwNiA4MC4zNTI4WiIgZmlsbD0iIzJBNDQ1RSIvPgo8cGF0aCBkPSJNMzAuNDA2MiA4MC4zNTI3QzMwLjQwNjIgODEuMTI1MyAyOS43ODgxIDgxLjc0MzMgMjkuMDE1NiA4MS43NDMzQzI4LjI0MyA4MS43NDMzIDI3LjYyNSA4MS4xMjUzIDI3LjYyNSA4MC4zNTI3QzI3LjYyNSA3OS41OTA1IDI4LjI0MyA3OC45NjIyIDI5LjAxNTYgNzguOTYyMkMyOS43ODgxIDc4Ljk2MjIgMzAuNDA2MiA3OS41OTA1IDMwLjQwNjIgODAuMzUyN1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik00OC4xOTQzIDkwLjkxMDlDNDguMTk0MyA5Mi4zNDI3IDQ3LjA0MDcgOTMuNDk2MyA0NS42MDg5IDkzLjQ5NjNDNDQuMTc3MSA5My40OTYzIDQzLjAyMzQgOTIuMzQyNyA0My4wMjM0IDkwLjkxMDlDNDMuMDIzNCA4OS40ODk0IDQ0LjE3NzEgODguMzI1NCA0NS42MDg5IDg4LjMyNTRDNDcuMDMwNCA4OC4zMjU0IDQ4LjE5NDMgODkuNDc5MSA0OC4xOTQzIDkwLjkxMDlaIiBmaWxsPSIjMkE0NDVFIi8+CjxwYXRoIGQ9Ik00Ni45ODgyIDkwLjkxMDhDNDYuOTg4MiA5MS42ODM0IDQ2LjM3MDEgOTIuMzAxNCA0NS41OTc2IDkyLjMwMTRDNDQuODM1NCA5Mi4zMDE0IDQ0LjIwNyA5MS42NzMxIDQ0LjIwNyA5MC45MTA4QzQ0LjIwNyA5MC4xNDg2IDQ0LjgyNTEgODkuNTIwMyA0NS41OTc2IDg5LjUyMDNDNDYuMzcwMSA4OS41MjAzIDQ2Ljk4ODIgOTAuMTQ4NiA0Ni45ODgyIDkwLjkxMDhaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNNjQuNzc2NCA2OS4xNTYyQzY0Ljc3NjQgNzAuNTg4IDYzLjYyMjcgNzEuNzQxNyA2Mi4xOTA5IDcxLjc0MTdDNjAuNzU5MSA3MS43NDE3IDU5LjYwNTUgNzAuNTg4IDU5LjYwNTUgNjkuMTU2MkM1OS42MDU1IDY3LjcyNDUgNjAuNzU5MSA2Ni41NzA4IDYyLjE5MDkgNjYuNTcwOEM2My42MjI3IDY2LjU3MDggNjQuNzc2NCA2Ny43MjQ1IDY0Ljc3NjQgNjkuMTU2MloiIGZpbGw9IiMyQTQ0NUUiLz4KPHBhdGggZD0iTTYzLjU4MTkgNjkuMTU2MkM2My41ODE5IDY5LjkxODQgNjIuOTYzOSA3MC41NDY4IDYyLjE5MTQgNzAuNTQ2OEM2MS40MTg4IDcwLjU0NjggNjAuODAwOCA2OS45Mjg3IDYwLjgwMDggNjkuMTU2MkM2MC44MDA4IDY4LjM4MzcgNjEuNDE4OCA2Ny43NjU2IDYyLjE5MTQgNjcuNzY1NkM2Mi45NjM5IDY3Ljc2NTYgNjMuNTgxOSA2OC4zODM3IDYzLjU4MTkgNjkuMTU2MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik04MS4zNzAxIDc0Ljc0OTNDODEuMzcwMSA3Ni4xNzA3IDgwLjIxNjQgNzcuMzM0NyA3OC43ODQ3IDc3LjMzNDdDNzcuMzUyOSA3Ny4zMzQ3IDc2LjE5OTIgNzYuMTgxIDc2LjE5OTIgNzQuNzQ5M0M3Ni4xOTkyIDczLjMxNzUgNzcuMzUyOSA3Mi4xNjM4IDc4Ljc4NDcgNzIuMTYzOEM4MC4yMDYxIDcyLjE2MzggODEuMzcwMSA3My4zMjc4IDgxLjM3MDEgNzQuNzQ5M1oiIGZpbGw9IiMyQTQ0NUUiLz4KPHBhdGggZD0iTTgwLjE3NTcgNzQuNzQ5MkM4MC4xNzU3IDc1LjUxMTUgNzkuNTU3NiA3Ni4xMzk4IDc4Ljc4NTEgNzYuMTM5OEM3OC4wMjI5IDc2LjEzOTggNzcuMzk0NSA3NS41MjE4IDc3LjM5NDUgNzQuNzQ5MkM3Ny4zOTQ1IDczLjk3NjcgNzguMDEyNiA3My4zNTg2IDc4Ljc4NTEgNzMuMzU4NkM3OS41NDczIDczLjM1ODYgODAuMTc1NyA3My45ODcgODAuMTc1NyA3NC43NDkyWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTk3Ljk1NiA3My44OTQ1Qzk3Ljk1NiA3NS4zMjYzIDk2LjgwMjQgNzYuNDggOTUuMzcwNiA3Ni40OEM5My45Mzg4IDc2LjQ4IDkyLjc4NTIgNzUuMzI2MyA5Mi43ODUyIDczLjg5NDVDOTIuNzg1MiA3Mi40NjI3IDkzLjkzODggNzEuMzA5MSA5NS4zNzA2IDcxLjMwOTFDOTYuODAyNCA3MS4zMDkxIDk3Ljk1NiA3Mi40NjI3IDk3Ljk1NiA3My44OTQ1WiIgZmlsbD0iIzJBNDQ1RSIvPgo8cGF0aCBkPSJNOTYuNzYxNiA3My44OTQyQzk2Ljc2MTYgNzQuNjY2OCA5Ni4xNDM2IDc1LjI4NDggOTUuMzcxIDc1LjI4NDhDOTQuNTk4NSA3NS4yODQ4IDkzLjk4MDUgNzQuNjY2OCA5My45ODA1IDczLjg5NDJDOTMuOTgwNSA3My4xMjE3IDk0LjU5ODUgNzIuNTAzNyA5NS4zNzEgNzIuNTAzN0M5Ni4xNDM2IDcyLjUwMzcgOTYuNzYxNiA3My4xMjE3IDk2Ljc2MTYgNzMuODk0MloiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMTQuNTUgNjYuMTM4MkMxMTQuNTUgNjcuNTcgMTEzLjM5NiA2OC43MjM2IDExMS45NjQgNjguNzIzNkMxMTAuNTMzIDY4LjcyMzYgMTA5LjM3OSA2Ny41NyAxMDkuMzc5IDY2LjEzODJDMTA5LjM3OSA2NC43MDY0IDExMC41MzMgNjMuNTUyNyAxMTEuOTY0IDYzLjU1MjdDMTEzLjM4NiA2My41NTI3IDExNC41NSA2NC43MDY0IDExNC41NSA2Ni4xMzgyWiIgZmlsbD0iIzJBNDQ1RSIvPgo8cGF0aCBkPSJNMTEzLjM1NSA2Ni4xMzc5QzExMy4zNTUgNjYuOTEwNCAxMTIuNzM3IDY3LjUyODUgMTExLjk2NSA2Ny41Mjg1QzExMS4xOTIgNjcuNTI4NSAxMTAuNTc0IDY2LjkxMDQgMTEwLjU3NCA2Ni4xMzc5QzExMC41NzQgNjUuMzY1NCAxMTEuMTkyIDY0Ljc0NzMgMTExLjk2NSA2NC43NDczQzExMi43MjcgNjQuNzQ3MyAxMTMuMzU1IDY1LjM2NTQgMTEzLjM1NSA2Ni4xMzc5WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEzMS4xMzIgNDMuMDg1NEMxMzEuMTMyIDQ0LjUxNzIgMTI5Ljk3OCA0NS42NzA5IDEyOC41NDYgNDUuNjcwOUMxMjcuMTE1IDQ1LjY3MDkgMTI1Ljk2MSA0NC41MTcyIDEyNS45NjEgNDMuMDg1NEMxMjUuOTYxIDQxLjY1MzcgMTI3LjExNSA0MC41IDEyOC41NDYgNDAuNUMxMjkuOTc4IDQwLjUgMTMxLjEzMiA0MS42NTM3IDEzMS4xMzIgNDMuMDg1NFoiIGZpbGw9IiMyQTQ0NUUiLz4KPHBhdGggZD0iTTEyOS45MzcgNDMuMDg1NEMxMjkuOTM3IDQzLjg0NzYgMTI5LjMxOSA0NC40NzYgMTI4LjU0NyA0NC40NzZDMTI3Ljc3NCA0NC40NzYgMTI3LjE1NiA0My44NTc5IDEyNy4xNTYgNDMuMDg1NEMxMjcuMTU2IDQyLjMxMjkgMTI3Ljc3NCA0MS42OTQ4IDEyOC41NDcgNDEuNjk0OEMxMjkuMzE5IDQxLjY5NDggMTI5LjkzNyA0Mi4zMTI5IDEyOS45MzcgNDMuMDg1NFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xMDYuNSA0NS43NUMxMDguNTcxIDQ1Ljc1IDExMC4yNSA0NC4wNzExIDExMC4yNSA0MkMxMTAuMjUgMzkuOTI4OSAxMDguNTcxIDM4LjI1IDEwNi41IDM4LjI1QzEwNC40MjkgMzguMjUgMTAyLjc1IDM5LjkyODkgMTAyLjc1IDQyQzEwMi43NSA0NC4wNzExIDEwNC40MjkgNDUuNzUgMTA2LjUgNDUuNzVaIiBmaWxsPSIjRUNGMEY1Ii8+CjxwYXRoIGQ9Ik0xMTUuNSAzNi43NUMxMTguMzk5IDM2Ljc1IDEyMC43NSAzNC4zOTk1IDEyMC43NSAzMS41QzEyMC43NSAyOC42MDA1IDExOC4zOTkgMjYuMjUgMTE1LjUgMjYuMjVDMTEyLjYwMSAyNi4yNSAxMTAuMjUgMjguNjAwNSAxMTAuMjUgMzEuNUMxMTAuMjUgMzQuMzk5NSAxMTIuNjAxIDM2Ljc1IDExNS41IDM2Ljc1WiIgZmlsbD0iI0VDRjBGNSIvPgo8cGF0aCBkPSJNMTAyLjc1IDMwLjc1QzEwMy41NzggMzAuNzUgMTA0LjI1IDMwLjA3ODQgMTA0LjI1IDI5LjI1QzEwNC4yNSAyOC40MjE2IDEwMy41NzggMjcuNzUgMTAyLjc1IDI3Ljc1QzEwMS45MjIgMjcuNzUgMTAxLjI1IDI4LjQyMTYgMTAxLjI1IDI5LjI1QzEwMS4yNSAzMC4wNzg0IDEwMS45MjIgMzAuNzUgMTAyLjc1IDMwLjc1WiIgZmlsbD0iI0VDRjBGNSIvPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var teamLeaderboard = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var userLeaderboard = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var edit = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjcwNzEwNyAyLjA2MjQyQzAuMzE2NTgyIDIuNDUyOTUgMC4zMTY1ODIgMy4wODYxMSAwLjcwNzEwNyAzLjQ3NjY0TDEwLjYwNjYgMTMuMzc2MUwxMy40MzUgMTAuNTQ3N0wzLjUzNTUzIDAuNjQ4MjExQzMuMTQ1MDEgMC4yNTc2ODcgMi41MTE4NCAwLjI1NzY4NyAyLjEyMTMyIDAuNjQ4MjExTDAuNzA3MTA3IDIuMDYyNDJaTTE0LjEwODkgMTEuMjg4TDExLjM0NjkgMTQuMDVDMTEuNDI5NiAxNC4wOTI5IDExLjUxODMgMTQuMTI0MiAxMS42MTA2IDE0LjE0MjZMMTQuMTEzOCAxNC42NDMzQzE0LjQ2MzcgMTQuNzEzMiAxNC43NzIxIDE0LjQwNDggMTQuNzAyMiAxNC4wNTQ5TDE0LjIwMTUgMTEuNTUxN0MxNC4xODMxIDExLjQ1OTQgMTQuMTUxOCAxMS4zNzA3IDE0LjEwODkgMTEuMjg4WiIgZmlsbD0iIzZCNjg3NCIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var editLeft = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNC45MjY3IDMuODMyNThDMTQuMjc1OSAzLjE4MTcgMTMuMjIwNiAzLjE4MTcgMTIuNTY5NyAzLjgzMjU4TDQuMjYwNCAxMi4xNDE5TDIuOTk0NSAxNi4zNjE2QzIuNzg0NzMgMTcuMDYwOCAzLjQzNjY3IDE3LjcxMjcgNC4xMzU5MSAxNy41MDNMOC4zNTU1OCAxNi4yMzcxTDE2LjY2NDkgNy45Mjc3NUMxNy4zMTU4IDcuMjc2ODggMTcuMzE1OCA2LjIyMTYxIDE2LjY2NDkgNS41NzA3M0wxNC45MjY3IDMuODMyNThaTTQuOTkxMTEgMTUuNTA2M0w1LjczNjA0IDEzLjAyMzNMMTEuNDU2OSA3LjMwMjQxTDEzLjE5NSA5LjA0MDU3TDcuNDc0MTkgMTQuNzYxNEw0Ljk5MTExIDE1LjUwNjNaTTE0LjM3MzYgNy44NjIwNkwxNS40ODY0IDYuNzQ5MjRMMTMuNzQ4MiA1LjAxMTA5TDEyLjYzNTQgNi4xMjM5TDE0LjM3MzYgNy44NjIwNloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var file = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAxNSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yIDUuNzY5NTNINVYyLjc2OTUzSDEzVjE4Ljc2OTVIMlY1Ljc2OTUzWk00IDAuNzY5NTMxTDAgNC43Njk1M1YyMC43Njk1SDE1VjAuNzY5NTMxSDRaIiBmaWxsPSIjNkI2ODc0Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var trash = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxNyAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAwLjExNTIzNEMxMC41NTIzIDAuMTE1MjM0IDExIDAuNTYyOTUgMTEgMS4xMTUyM0gxNkMxNi41NTIzIDEuMTE1MjMgMTcgMS41NjI5NSAxNyAyLjExNTIzQzE3IDIuNjY3NTIgMTYuNTUyMyAzLjExNTIzIDE2IDMuMTE1MjNIMUMwLjQ0NzcxNSAzLjExNTIzIDAgMi42Njc1MiAwIDIuMTE1MjNDMCAxLjU2Mjk1IDAuNDQ3NzE1IDEuMTE1MjMgMSAxLjExNTIzSDZDNiAwLjU2Mjk1IDYuNDQ3NzIgMC4xMTUyMzQgNyAwLjExNTIzNEgxMFpNNCAxNS4xMTUyVjQuMTE1MjNIMlYxNS4xMTUyQzIgMTYuNzcyMSAzLjM0MzE1IDE4LjExNTIgNSAxOC4xMTUySDEyQzEzLjY1NjkgMTguMTE1MiAxNSAxNi43NzIxIDE1IDE1LjExNTJWNC4xMTUyM0gxM1YxNS4xMTUyQzEzIDE1LjY2NzUgMTIuNTUyMyAxNi4xMTUyIDEyIDE2LjExNTJINUM0LjQ0NzcyIDE2LjExNTIgNCAxNS42Njc1IDQgMTUuMTE1MloiIGZpbGw9IiM2QjY4NzQiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var time$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOSAxMkMxOSAxNS44NjYgMTUuODY2IDE5IDEyIDE5QzguMTM0MDEgMTkgNSAxNS44NjYgNSAxMkM1IDguMTM0MDEgOC4xMzQwMSA1IDEyIDVDMTUuODY2IDUgMTkgOC4xMzQwMSAxOSAxMlpNMjEgMTJDMjEgMTYuOTcwNiAxNi45NzA2IDIxIDEyIDIxQzcuMDI5NDQgMjEgMyAxNi45NzA2IDMgMTJDMyA3LjAyOTQ0IDcuMDI5NDQgMyAxMiAzQzE2Ljk3MDYgMyAyMSA3LjAyOTQ0IDIxIDEyWk0xMyA5QzEzIDguNDQ3NzIgMTIuNTUyMyA4IDEyIDhDMTEuNDQ3NyA4IDExIDguNDQ3NzIgMTEgOVYxMkMxMSAxMi4yNjUyIDExLjEwNTQgMTIuNTE5NiAxMS4yOTI5IDEyLjcwNzFMMTQuMjkyOSAxNS43MDcxQzE0LjY4MzQgMTYuMDk3NiAxNS4zMTY2IDE2LjA5NzYgMTUuNzA3MSAxNS43MDcxQzE2LjA5NzYgMTUuMzE2NiAxNi4wOTc2IDE0LjY4MzQgMTUuNzA3MSAxNC4yOTI5TDEzIDExLjU4NThWOVoiIGZpbGw9IiM1NjUzNjAiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var carbonUndo = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjUgOEg2LjM2MTI1TDkuMDUxNSA1LjMxMDVMOCA0LjI1TDMuNSA4Ljc1TDggMTMuMjVMOS4wNTE1IDEyLjE4ODhMNi4zNjM1IDkuNUgxNS41QzE2LjY5MzUgOS41IDE3LjgzODEgOS45NzQxMSAxOC42ODIgMTAuODE4QzE5LjUyNTkgMTEuNjYxOSAyMCAxMi44MDY1IDIwIDE0QzIwIDE1LjE5MzUgMTkuNTI1OSAxNi4zMzgxIDE4LjY4MiAxNy4xODJDMTcuODM4MSAxOC4wMjU5IDE2LjY5MzUgMTguNSAxNS41IDE4LjVIOS41VjIwSDE1LjVDMTcuMDkxMyAyMCAxOC42MTc0IDE5LjM2NzkgMTkuNzQyNiAxOC4yNDI2QzIwLjg2NzkgMTcuMTE3NCAyMS41IDE1LjU5MTMgMjEuNSAxNEMyMS41IDEyLjQwODcgMjAuODY3OSAxMC44ODI2IDE5Ljc0MjYgOS43NTczNkMxOC42MTc0IDguNjMyMTQgMTcuMDkxMyA4IDE1LjUgOFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var courseCardIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjQ5ODkgMTUuMTI1NUwxNC4zNDc3IDExLjA5ODZMMTQuOTAyNSAxOC4zNTE3TDE2LjU3NTEgMTYuNTk5OEwxOC44MjYzIDIwLjQ5OThMMTkuNjExMSAyMC4wNDhMMjAuMzk1OCAxOS41ODgzTDE4LjE0NDYgMTUuNjg4M0wyMC40OTg5IDE1LjEyNTVaIiBzdHJva2U9IiM2QjY4NzQiIHN0cm9rZS13aWR0aD0iMC44NTM2NTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi45Mjk2IDE0Ljc4NEMxMi4zMDMzIDE0LjkxMDggMTEuNTgyIDE0Ljk4MjIgMTAuNzQ5NyAxNC45ODIyQzUuODk4NDggMTQuOTgyMiA0LjgxMjUgMTIuNDM3NyA0LjgxMjUgMTIuNDM3N1Y3LjQ4MzQiIHN0cm9rZT0iIzZCNjg3NCIgc3Ryb2tlLXdpZHRoPSIwLjg1MzY1NyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE2LjY4NzUgNy43NzczNFYxMC41NTE3IiBzdHJva2U9IiM2QjY4NzQiIHN0cm9rZS13aWR0aD0iMC44NTM2NTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00LjgxMjggNy40ODQxNEwxIDUuNjYwOTdMMTAuNzUgMUwyMC41IDUuNjYwOTdMMTAuNzUgMTAuMzIxOUw0LjgxMjggNy40ODQxNFoiIHN0cm9rZT0iIzZCNjg3NCIgc3Ryb2tlLXdpZHRoPSIwLjg1MzY1NyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuNjk3MjcgNi40Njk3M1YxMy43MTQ4IiBzdHJva2U9IiM2QjY4NzQiIHN0cm9rZS13aWR0aD0iMC44NTM2NTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xLjQxOTkyIDE0Ljk4MzFDMS40MTk5MiAxNS42ODg2IDEuOTkwNjUgMTYuMjUxNCAyLjY4ODIxIDE2LjI1MTRDMy4zOTM3IDE2LjI1MTQgMy45NTY1MSAxNS42ODA3IDMuOTU2NTEgMTQuOTgzMUMzLjk1NjUxIDE0LjI3NzYgMy4zODU3NyAxMy43MTQ4IDIuNjg4MjEgMTMuNzE0OEMxLjk5MDY1IDEzLjcxNDggMS40MTk5MiAxNC4yODU2IDEuNDE5OTIgMTQuOTgzMVoiIHN0cm9rZT0iIzZCNjg3NCIgc3Ryb2tlLXdpZHRoPSIwLjg1MzY1NyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var lessonSmallIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var lessonsList = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var publish = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00Ljg5NDc0IDUuODQyMTFDNC44OTQ3NCA1LjMxODg5IDUuMzE4ODkgNC44OTQ3NCA1Ljg0MjExIDQuODk0NzRIMTJWM0g1Ljg0MjExQzQuMjcyNDUgMyAzIDQuMjcyNDUgMyA1Ljg0MjExVjE4LjE1NzlDMyAxOS43Mjc1IDQuMjcyNDUgMjEgNS44NDIxMSAyMUgxOC4xNTc5QzE5LjcyNzUgMjEgMjEgMTkuNzI3NSAyMSAxOC4xNTc5VjEySDE5LjEwNTNWMTguMTU3OUMxOS4xMDUzIDE4LjY4MTEgMTguNjgxMSAxOS4xMDUzIDE4LjE1NzkgMTkuMTA1M0g1Ljg0MjExQzUuMzE4ODkgMTkuMTA1MyA0Ljg5NDc0IDE4LjY4MTEgNC44OTQ3NCAxOC4xNTc5VjUuODQyMTFaTTE0IDVIMTcuNTg1OEwxMC4yOTI5IDEyLjI5MjlMMTEuNzA3MSAxMy43MDcxTDE5IDYuNDE0MjFWMTBIMjFWNFYzSDIwSDE0VjVaIiBmaWxsPSIjRjM2QTIyIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var missingFile = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzMiIGhlaWdodD0iMzgiIHZpZXdCb3g9IjAgMCAzMyAzOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02IDIwLjc2OTVIOVYxNy43Njk1SDE3VjMzLjc2OTVINlYyMC43Njk1Wk04IDE1Ljc2OTVMNCAxOS43Njk1VjM1Ljc2OTVIMTlWMTUuNzY5NUg4WiIgZmlsbD0iIzZCNjg3NCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIxIDJDMjYuNTIyOCAyIDMxIDYuNDc3MTUgMzEgMTJDMzEgMTcuNTIyOCAyNi41MjI4IDIyIDIxIDIyQzE1LjQ3NzIgMjIgMTEgMTcuNTIyOCAxMSAxMkMxMSA2LjQ3NzE1IDE1LjQ3NzIgMiAyMSAyWk0yMS45Nzc0IDEzLjcyOTRMMjIuMTg1MSA2LjA5MDkxSDE5LjgxNDdMMjAuMDI3OCAxMy43Mjk0SDIxLjk3NzRaTTIwLjA5NzEgMTYuNzY1NkMyMC4zNDkyIDE3LjAxNDIgMjAuNjUxIDE3LjEzODUgMjEuMDAyNiAxNy4xMzg1QzIxLjM0MzUgMTcuMTM4NSAyMS42NCAxNy4wMTQyIDIxLjg5MjIgMTYuNzY1NkMyMi4xNDc4IDE2LjUxNyAyMi4yNzc1IDE2LjIxNTIgMjIuMjgxIDE1Ljg2MDFDMjIuMjc3NSAxNS41MTIxIDIyLjE0NzggMTUuMjEzOCAyMS44OTIyIDE0Ljk2NTJDMjEuNjQgMTQuNzE2NiAyMS4zNDM1IDE0LjU5MjMgMjEuMDAyNiAxNC41OTIzQzIwLjY1MSAxNC41OTIzIDIwLjM0OTIgMTQuNzE2NiAyMC4wOTcxIDE0Ljk2NTJDMTkuODQ0OSAxNS4yMTM4IDE5LjcyMDYgMTUuNTEyMSAxOS43MjQyIDE1Ljg2MDFDMTkuNzIwNiAxNi4yMTUyIDE5Ljg0NDkgMTYuNTE3IDIwLjA5NzEgMTYuNzY1NloiIGZpbGw9IiNGMTYwNUQiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var emptyStateContentManagement = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var linkedCourses = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAxOSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjU4NjggMS41NDY4OEgxLjg4NTg0QzEuNjU3NzYgMS41NDY4OCAxLjQ3MjY2IDEuNzQ4NTEgMS40NzI2NiAxLjk5NzI1VjYuMDU0NzFDMS40NzI2NiA2LjMwMzQ0IDEuNjU3NzYgNi41MDUwOCAxLjg4NTg0IDYuNTA1MDhIMTcuNTg2OEMxNy44MTQ5IDYuNTA1MDggMTggNi4zMDM0NCAxOCA2LjA1NDcxVjEuOTk3MjVDMTggMS43NDg5MiAxNy44MTQ5IDEuNTQ2ODggMTcuNTg2OCAxLjU0Njg4WiIgc3Ryb2tlPSIjNkI2ODc0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTcuNTg2OCAxNS4xMTYySDEuODg1ODRDMS42NTc3NiAxNS4xMTYyIDEuNDcyNjYgMTUuMzE3OCAxLjQ3MjY2IDE1LjU2NjZWMTkuNjI0QzEuNDcyNjYgMTkuODcyOCAxLjY1Nzc2IDIwLjA3NDQgMS44ODU4NCAyMC4wNzQ0SDE3LjU4NjhDMTcuODE0OSAyMC4wNzQ0IDE4IDE5Ljg3MjggMTggMTkuNjI0VjE1LjU2NjZDMTggMTUuMzE3OCAxNy44MTQ5IDE1LjExNjIgMTcuNTg2OCAxNS4xMTYyWiIgc3Ryb2tlPSIjNkI2ODc0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS42MDU0NyA2LjUwNDg4VjEwLjgxMzdMMTMuODY5MSAxMC44MTc4VjE0LjYxNTgiIHN0cm9rZT0iIzZCNjg3NCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy4yNTM5MSAxNy41OTQ3SDEyLjIxMjEiIHN0cm9rZT0iIzZCNjg3NCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNy4yNTM5MSA0LjAyNjM3SDEyLjIxMjEiIHN0cm9rZT0iIzZCNjg3NCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var defaultIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIHZpZXdCb3g9IjAgMCA3MiA3MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEyNjdfMjIxNjMpIj4KPHBhdGggZD0iTTAgMzZDMCAxNi4xMTc4IDE2LjExNzggMCAzNiAwQzU1Ljg4MjMgMCA3MiAxNi4xMTc4IDcyIDM2QzcyIDU1Ljg4MjMgNTUuODgyMyA3MiAzNiA3MkMxNi4xMTc4IDcyIDAgNTUuODgyMyAwIDM2WiIgZmlsbD0iIzZCNjg3NCIvPgo8cGF0aCBkPSJNNDUuMDAzNiA0MS45NzI3QzQyLjM0OTggNDMuNzg4MyAzOS4yMDkzIDQ0Ljc1OTggMzUuOTkzOSA0NC43NTk4QzMyLjc3ODQgNDQuNzU5OCAyOS42MzggNDMuNzg4MyAyNi45ODQyIDQxLjk3MjdDMTguNDQ4MyA0My43OTE0IDEyIDUxLjQxMyAxMiA2MC40NzA3VjYzLjk4N0MxMiA2My45ODcgMjUuNTE0OSA3NS45OTc5IDM1Ljk5MzkgNzZDNDYuNDc3IDc2LjAwMjEgNTkuOTk5NyA2My45ODcgNTkuOTk5NyA2My45ODdWNjAuNDcwN0M1OS45OTM3IDUxLjQxMyA1My41Mzk0IDQzLjc5MTQgNDUuMDAzNiA0MS45NzI3WiIgZmlsbD0iIzk1OTM5QiIvPgo8cGF0aCBkPSJNMzUuOTk0MiA0MS41NjA3QzQzLjA1MjYgNDEuNTYwNyA0OC43NzQ1IDM1LjgzODcgNDguNzc0NSAyOC43ODAzQzQ4Ljc3NDUgMjEuNzIxOSA0My4wNTI2IDE2IDM1Ljk5NDIgMTZDMjguOTM1OCAxNiAyMy4yMTM5IDIxLjcyMTkgMjMuMjEzOSAyOC43ODAzQzIzLjIxMzkgMzUuODM4NyAyOC45MzU4IDQxLjU2MDcgMzUuOTk0MiA0MS41NjA3WiIgZmlsbD0iIzk1OTM5QiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEyNjdfMjIxNjMiPgo8cGF0aCBkPSJNMCAzNkMwIDE2LjExNzggMTYuMTE3OCAwIDM2IDBDNTUuODgyMyAwIDcyIDE2LjExNzggNzIgMzZDNzIgNTUuODgyMyA1NS44ODIzIDcyIDM2IDcyQzE2LjExNzggNzIgMCA1NS44ODIzIDAgMzZaIiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var iconWithCamera = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var homeIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyNCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjk5OTcgNC44MDg1OUwzLjQzOTkzIDExLjg2NThDMy40Mzk1NSAxMS44ODA5IDMuNDM3MTcgMTEuODk1OSAzLjQzMjg2IDExLjkxMDNDMy40MjkwNCAxMS45MjQ5IDMuNDI2NjcgMTEuOTM5OCAzLjQyNTc4IDExLjk1NDhWMTkuMTAwMkMzLjQyNTc4IDE5LjM1ODEgMy41MTkyMSAxOS41ODExIDMuNzA4NTMgMTkuNzY5M0MzLjg5Nzg1IDE5Ljk1NzUgNC4xMTk4OCAyMC4wNTMgNC4zNzc3NCAyMC4wNTNIMTAuMDk0N1YxNC4zMzYxSDEzLjkwNjFWMjAuMDUzMkgxOS42MjIyQzE5Ljg4MDIgMjAuMDUzMiAyMC4xMDMzIDE5Ljk1OSAyMC4yOTE0IDE5Ljc3MDVDMjAuNDgwNCAxOS41ODIzIDIwLjU3NSAxOS4zNTgzIDIwLjU3NSAxOS4xMDA0VjExLjk1NDhDMjAuNTc1IDExLjkxNDggMjAuNTY5NSAxMS44ODUyIDIwLjU1OTkgMTEuODY1OEwxMS45OTk3IDQuODA4NTlaIiBmaWxsPSIjNTI1MjVCIi8+CjxwYXRoIGQ9Ik0yMy44MzM4IDEwLjI1NjlMMjAuNTczOSA3LjU0NzU0VjEuNDczNjVDMjAuNTczOSAxLjMzNDU3IDIwLjUyOTMgMS4yMjAzNyAyMC40NCAxLjEzMTA0QzIwLjM1MDggMS4wNDE3IDIwLjIzNjYgMC45OTcyMTQgMjAuMDk3NCAwLjk5NzU3SDE3LjIzOThDMTcuMTAwNyAwLjk5NzU3IDE2Ljk4NjUgMS4wNDIwNiAxNi44OTcyIDEuMTMxMDRDMTYuODA3OSAxLjIyMDAyIDE2Ljc2MzMgMS4zMzQyMiAxNi43NjM0IDEuNDczNjVWNC4zNzY1NkwxMy4xMzE0IDEuMzQwMThDMTIuODEzOCAxLjA4MjE0IDEyLjQzNjcgMC45NTMxMjUgMTIuMDAwMiAwLjk1MzEyNUMxMS41NjMgMC45NTMxMjUgMTEuMTg2IDEuMDgyMTQgMTAuODY5IDEuMzQwMThMMC4xNjQ5MDkgMTAuMjU3MUMwLjA2NTgzMTUgMTAuMzM2NiAwLjAxMTM5OTMgMTAuNDQzMSAwLjAwMTYxMTczIDEwLjU3NjZDLTAuMDA4MTc1ODcgMTAuNzEwMiAwLjAyNjYxNDcgMTAuODI3MSAwLjEwNTk4MyAxMC45MjczTDEuMDI4NTEgMTIuMDI4NEMxLjEwNzk5IDEyLjExNzcgMS4yMTIzNiAxMi4xNzMgMS4zNDA2OSAxMi4xOTI2QzEuNDYwMzYgMTIuMjAyNCAxLjU3OTY2IDEyLjE2NzYgMS42OTg1OCAxMi4wODgyTDExLjk5OTUgMy40OTgwOEwyMi4zMDEyIDEyLjA4NzhDMjIuMzgwNSAxMi4xNTc0IDIyLjQ4NDkgMTIuMTkyMSAyMi42MTM0IDEyLjE5MjFIMjIuNjU4OUMyMi43ODczIDEyLjE3MjUgMjIuODkxIDEyLjExNzIgMjIuOTcxMSAxMi4wMjc5TDIzLjg5NDUgMTAuOTI2MUMyMy45NzMxIDEwLjgyNzIgMjQuMDA4NyAxMC43MTAzIDIzLjk5OCAxMC41NzY0QzIzLjk4NzMgMTAuNDQyNiAyMy45MzI5IDEwLjMzNjIgMjMuODMzOCAxMC4yNTY5WiIgZmlsbD0iIzUyNTI1QiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var learnIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var playIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var testIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjczNSAxNy42MjkxTDE1LjMwNjkgMTEuMTk1TDE1LjIzNDQgMTEuMTMwOUMxNS4yMDc5IDExLjE2MjkgMTUuMTc4NiAxMS4xOTUgMTUuMTQ4IDExLjIyNTdMMTMuOTg5NCAxMi4zODQyQzE0LjE0ODMgMTIuNzQyNSAxMy45ODk0IDEzLjE0NTQgMTMuODUgMTMuNDk5NkMxMy43NjUgMTMuNzE1NyAxMy42Njc0IDEzLjk2MjQgMTMuNjg5NyAxNC4xMDMyQzEzLjcxMiAxNC4yNDQgMTMuODgwNyAxNC40NTYgMTQuMDI4NSAxNC42Mzg2QzE0LjI3NjYgMTQuOTQzOSAxNC41NTY4IDE1LjI4OTcgMTQuNDkyNyAxNS42ODk4QzE0LjQyODYgMTYuMDg5OSAxNC4wNTYzIDE2LjMyNDEgMTMuNzI3MyAxNi41MzYxQzEzLjUxODIgMTYuNjc1NSAxMy4zMDA3IDE2LjgxNDkgMTMuMjMyNCAxNi45NDMyQzEzLjE2NDEgMTcuMDcxNCAxMy4xODM2IDE3LjMyNjYgMTMuMTk2MSAxNy41NTUyQzEzLjE5NjEgMTcuNTY3NyAxMy4xOTYxIDE3LjU4MDMgMTMuMTk2MSAxNy41OTI4TDE3LjYyMTIgMjIuNzIzNEMxNy42OTEyIDIyLjgwNDcgMTcuNzc3MSAyMi44NzA3IDE3Ljg3MzcgMjIuOTE3M0MxNy45NzAzIDIyLjk2MzkgMTguMDc1NSAyMi45OSAxOC4xODI3IDIyLjk5NDFDMTguMjg5OSAyMi45OTgyIDE4LjM5NjggMjIuOTggMTguNDk2NiAyMi45NDA5QzE4LjU5NjUgMjIuOTAxNyAxOC42ODcyIDIyLjg0MjQgMTguNzYzMSAyMi43NjY2TDIyLjc2NDMgMTguNzY1M0MyMi44Mzk5IDE4LjY5MDQgMjIuODk5NCAxOC42MDA3IDIyLjkzOSAxOC41MDJDMjIuOTc4NyAxOC40MDMyIDIyLjk5NzggMTguMjk3MyAyMi45OTUgMTguMTkwOUMyMi45OTIzIDE4LjA4NDUgMjIuOTY3OCAxNy45Nzk3IDIyLjkyMzEgMTcuODgzMUMyMi44Nzg0IDE3Ljc4NjUgMjIuODE0NCAxNy43MDAxIDIyLjczNSAxNy42MjkxWiIgZmlsbD0iIzUyNTI1QiIvPgo8cGF0aCBkPSJNNi4zODIzOSAxMC42ODg4QzYuNjExMDMgMTAuNzAyNyA2Ljg3MDM1IDEwLjcxOTUgNi45OTMwMyAxMC42NTY3QzcuMTE1NzIgMTAuNTk0IDcuMjcxODcgMTAuMzc3OSA3LjQwNDMxIDEwLjE2NDZDNy42MTc2MiA5LjgzNjk1IDcuODU4ODEgOS40Njc0OSA4LjI1NDc2IDkuNDA0NzVDOC42NTA3IDkuMzQyMDIgOC45OTkyNCA5LjYyNTAzIDkuMzAzMTcgOS44NzQ1OUM5LjQ4NDQxIDEwLjAyMzggOS42OTA3NSAxMC4xOTI1IDkuODM1NzQgMTAuMjE2MkM5Ljk4MDc0IDEwLjIzOTkgMTAuMjIzMyAxMC4xNDM3IDEwLjQ0MDggMTAuMDZDMTAuODEwMyA5LjkyMDYgMTEuMjI4NSA5Ljc1NDY5IDExLjU5MzggOS45NDI5QzExLjYxMDUgOS45NTEyNyAxMS42MjQ1IDkuOTY4IDExLjY0MjYgOS45NzkxNUwxMi43NzA1IDguODQ5ODdDMTIuODAxMSA4LjgxOTIgMTIuODMzMiA4Ljc5MTMyIDEyLjg2NTMgOC43NjM0NEwxMi44MDExIDguNjkwOTRMNi4zNjk4NCAxLjI2OTc3QzYuMjk5NzIgMS4xODg2MyA2LjIxMzYgMS4xMjI4MyA2LjExNjg4IDEuMDc2NDlDNi4wMjAxNiAxLjAzMDE2IDUuOTE0OTIgMS4wMDQyOCA1LjgwNzc1IDEuMDAwNDlDNS43MDA1NyAwLjk5NjY5MyA1LjU5Mzc2IDEuMDE1MDYgNS40OTQwMSAxLjA1NDQ0QzUuMzk0MjUgMS4wOTM4MiA1LjMwMzcgMS4xNTMzNiA1LjIyODAxIDEuMjI5MzRMMS4yMjgxNCA1LjIyOTIyQzEuMTUyMzkgNS4zMDUyMiAxLjA5MzEgNS4zOTU5OSAxLjA1Mzk0IDUuNDk1ODlDMS4wMTQ3OCA1LjU5NTggMC45OTY2IDUuNzAyNjkgMS4wMDA1MiA1LjgwOTkyQzEuMDA0NDUgNS45MTcxNSAxLjAzMDM5IDYuMDIyNDIgMS4wNzY3NSA2LjExOTJDMS4xMjMxIDYuMjE1OTcgMS4xODg4NyA2LjMwMjE3IDEuMjY5OTYgNi4zNzI0NEw2LjI2OTQ2IDEwLjY4MzJMNi4zODIzOSAxMC42ODg4WiIgZmlsbD0iIzUyNTI1QiIvPgo8cGF0aCBkPSJNMTIuNzEgMTQuMTczNkMxMi43MTgzIDE0LjAxNTUgMTIuNzU5MSAxMy44NjA3IDEyLjgyOTkgMTMuNzE5MUMxMi45NCAxMy40NDAyIDEzLjA2MjcgMTMuMTI4IDEyLjkyMzMgMTIuODUzM0MxMi44OTc0IDEyLjgwMTUgMTIuODYzIDEyLjc1NDMgMTIuODIxNSAxMi43MTM5QzEyLjc4NjEgMTIuNjc4MyAxMi43NDYzIDEyLjY0NzMgMTIuNzAzIDEyLjYyMTlMMTQuOTAzIDEwLjQ2MzdDMTQuMzY5MiAxMC4wOTgzIDEzLjg5NTUgOS42NTE4OCAxMy40OTkxIDkuMTQwNjJMMTEuMzQ2NSAxMS4yNTI4QzExLjMyNDUgMTEuMjE2OCAxMS4yOTg4IDExLjE4MzIgMTEuMjY5OCAxMS4xNTI0QzExLjIyODggMTEuMTExMSAxMS4xODE4IDExLjA3NjQgMTEuMTMwNCAxMS4wNDkyQzEwLjg1MTYgMTAuOTA5OCAxMC41NDA3IDExLjAyOTcgMTAuMjYzMiAxMS4xMzcxQzEwLjEyMTUgMTEuMjA3NSA5Ljk2Njc4IDExLjI0NzggOS44MDg3MyAxMS4yNTU2QzkuNjU4NTggMTEuMTk4MSA5LjUyMTkgMTEuMTEwMyA5LjQwNzIxIDEwLjk5NzdDOS4xNzg1NiAxMC44MTA4IDguOTIwNjQgMTAuNTk3NSA4LjYxOTUgMTAuNjQ0OUM4LjMxODM2IDEwLjY5MjMgOC4xMzk5MSAxMC45Njk4IDcuOTc5NTggMTEuMjE2NUM3LjkwNDA5IDExLjM2MDUgNy43OTg1MyAxMS40ODY1IDcuNjcwMDcgMTEuNTg2QzcuNTIwMTMgMTEuNjI2MyA3LjM2MzQzIDExLjYzNDggNy4yMDk5OSAxMS42MTExQzYuOTEwMjUgMTEuNTkzIDYuNTcxNDYgMTEuNTcyMSA2LjM0OTc5IDExLjc5MjNDNi4xMjgxMiAxMi4wMTI2IDYuMTQ2MjQgMTIuMzUgNi4xNjI5NyAxMi42NTI1QzYuMTg0NDcgMTIuODA2MiA2LjE3NDk5IDEyLjk2MjcgNi4xMzUwOSAxMy4xMTI2QzYuMDM0MTcgMTMuMjQwMSA1LjkwNzI4IDEzLjM0NDcgNS43NjI4NSAxMy40MTkzQzUuNTE2MDggMTMuNTc4MyA1LjIzNTg1IDEzLjc1ODEgNS4xODg0NSAxNC4wNTY1QzUuMTQxMDUgMTQuMzU0OCA1LjM1MDE3IDE0LjYxNDEgNS41MzY5OSAxNC44NDdDNS42NDg2MiAxNC45NjE3IDUuNzM1MDUgMTUuMDk4NCA1Ljc5MDczIDE1LjI0ODVDNS43ODI1NiAxNS40MDY2IDUuNzQxNzMgMTUuNTYxNCA1LjY3MDgzIDE1LjcwM0M1LjU2MjA5IDE1Ljk4MTggNS40MzggMTYuMjk0MSA1LjU3NzQyIDE2LjU3MDJDNS42MDQxNyAxNi42MjE1IDUuNjM4NDggMTYuNjY4NSA1LjY3OTIgMTYuNzA5NkM1Ljg2MTkxIDE2Ljg1NzEgNi4wNzkzMSAxNi45NTU1IDYuMzEwNzYgMTYuOTk1NEM2LjQ3NDQ2IDE3LjAyMzggNi42MzAzIDE3LjA4NjUgNi43NjgwNCAxNy4xNzk0QzYuODYxMzEgMTcuMzE3MiA2LjkyMzE4IDE3LjQ3MzggNi45NDkyOSAxNy42MzgxQzcuMDEwNjMgMTcuODcwOSA3LjA3MzM3IDE4LjExMjEgNy4yMjgxMiAxOC4yNzFDNy4yNjg4NiAxOC4zMTIyIDcuMzE1OTMgMTguMzQ2NiA3LjM2NzU0IDE4LjM3MjhDNy42NDYzNyAxOC41MTIyIDcuOTU1ODcgMTguMzkyMyA4LjIzMzMxIDE4LjI4NUM4LjM3NTUgMTguMjE0NyA4LjUzMDc2IDE4LjE3NDggOC42ODkyMSAxOC4xNjc5QzguODM4ODggMTguMjI0OCA4Ljk3NTEyIDE4LjMxMjIgOS4wODkzMyAxOC40MjQ0QzkuMzE3OTggMTguNjEyNiA5LjU3NzI5IDE4LjgyNDUgOS44Nzg0NCAxOC43Nzg1QzEwLjE3OTYgMTguNzMyNSAxMC4zNTggMTguNDUyMyAxMC41MTg0IDE4LjIwNjlDMTAuNTkzNSAxOC4wNjI4IDEwLjY5ODUgMTcuOTM2MyAxMC44MjY1IDE3LjgzNjFDMTAuOTc2NiAxNy43OTY3IDExLjEzMzEgMTcuNzg4MiAxMS4yODY1IDE3LjgxMUMxMS41ODYzIDE3LjgzMDUgMTEuOTI1MSAxNy44NSAxMi4xNDgxIDE3LjYyOTdDMTIuMzcxMiAxNy40MDk0IDEyLjM1MTcgMTcuMDcyMSAxMi4zMzUgMTYuNzY5NUMxMi4zMTI1IDE2LjYxNiAxMi4zMjE1IDE2LjQ1OTQgMTIuMzYxNSAxNi4zMDk0QzEyLjQ2MjcgMTYuMTgyMyAxMi41ODk1IDE2LjA3NzggMTIuNzMzNyAxNi4wMDI3QzEyLjk4MTkgMTUuODQzOCAxMy4yNjIxIDE1LjY2MzkgMTMuMzA5NSAxNS4zNjdDMTMuMzU2OSAxNS4wNyAxMy4xNDY0IDE0LjgwOTMgMTIuOTYwOSAxNC41NzY1QzEyLjg1MDcgMTQuNDYwNyAxMi43NjUzIDE0LjMyMzYgMTIuNzEgMTQuMTczNlpNMTAuNjgyOSAxNi4zMzA0QzEwLjM4MDIgMTYuNjMxNCA5Ljk5NTEyIDE2LjgzNTkgOS41NzYyNCAxNi45MTgxQzkuMTU3MzYgMTcuMDAwMiA4LjcyMzUyIDE2Ljk1NjMgOC4zMjk1OSAxNi43OTE5QzcuOTM1NjcgMTYuNjI3NSA3LjU5OTM0IDE2LjM1IDcuMzYzMTUgMTUuOTk0NEM3LjEyNjk3IDE1LjYzODggNy4wMDE1MyAxNS4yMjEyIDcuMDAyNyAxNC43OTQzQzcuMDAzODcgMTQuMzY3NSA3LjEzMTYgMTMuOTUwNiA3LjM2OTczIDEzLjU5NjNDNy42MDc4NiAxMy4yNDIgNy45NDU3IDEyLjk2NjMgOC4zNDA1MiAxMi44MDQxQzguNzM1MzUgMTIuNjQxOCA5LjE2OTQyIDEyLjYwMDMgOS41ODc4NCAxMi42ODQ3QzEwLjAwNjMgMTIuNzY5MiAxMC4zOTAzIDEyLjk3NTggMTAuNjkxMiAxMy4yNzg1QzExLjA5NDggMTMuNjg0NCAxMS4zMjA2IDE0LjIzMzkgMTEuMzE5IDE0LjgwNjJDMTEuMzE3NSAxNS4zNzg1IDExLjA4ODYgMTUuOTI2NyAxMC42ODI5IDE2LjMzMDRaIiBmaWxsPSIjNTI1MjVCIi8+CjxwYXRoIGQ9Ik03LjE0NjM4IDE4LjgzNThDNy4wNTM2NiAxOC43ODc5IDYuOTY4OTkgMTguNzI1OCA2Ljg5NTQzIDE4LjY1MTdDNi42NTQyNCAxOC40MDkyIDYuNTY5MTkgMTguMDgyOSA2LjQ5OTQ4IDE3LjgxNTJDNi40NzkxMyAxNy43Mjk1IDYuNDU0NDcgMTcuNjQ0OCA2LjQyNTU5IDE3LjU2MTVDNi4zNjI4NSAxNy41MzY0IDYuMjQ3MTQgMTcuNTA1NyA2LjE3MzI1IDE3LjQ4NjJDNS45MTExNCAxNy40MTUxIDUuNTg0OTEgMTcuMzI3MyA1LjMzNjc1IDE3LjA4NDdDNS4yNjI3MiAxNy4wMTE1IDUuMjAxMDQgMTYuOTI2NyA1LjE1NDExIDE2LjgzMzdDNS4wMzU2OCAxNi41ODk1IDUuMDEwNCAxNi4zMTA0IDUuMDgzMDEgMTYuMDQ4OEwxLjcyMTY2IDE5LjM5NDhDMS42ODg1OCAxOS40MjcgMS42NjU2OCAxOS40NjgzIDEuNjU1ODIgMTkuNTEzNEMxLjY0NTk3IDE5LjU1ODUgMS42NDk1OCAxOS42MDU1IDEuNjY2MjEgMTkuNjQ4NkMxLjY4Mjg1IDE5LjY5MTYgMS43MTE3NyAxOS43Mjg5IDEuNzQ5MzkgMTkuNzU1NkMxLjc4NzAxIDE5Ljc4MjQgMS44MzE2NiAxOS43OTc1IDEuODc3ODEgMTkuNzk5MUw0LjA3MjIzIDE5Ljg5ODFMNC4xNTg2NyAyMi4wOTI2QzQuMTYwMzggMjIuMTM4NiA0LjE3NTQ5IDIyLjE4MzIgNC4yMDIxNiAyMi4yMjA4QzQuMjI4ODMgMjIuMjU4NSA0LjI2NTg5IDIyLjI4NzUgNC4zMDg4MSAyMi4zMDQzQzQuMzUxNzIgMjIuMzIxMiA0LjM5ODYzIDIyLjMyNTIgNC40NDM3OCAyMi4zMTU4QzQuNDg4OTIgMjIuMzA2NCA0LjUzMDM1IDIyLjI4NDEgNC41NjI5OCAyMi4yNTE1TDcuOTI1NzIgMTguOTA1NUM3LjY2MzI0IDE4Ljk3NiA3LjM4NDE0IDE4Ljk0OTggNy4xMzk0MSAxOC44MzE2TDcuMTQ2MzggMTguODM1OFoiIGZpbGw9IiM1MjUyNUIiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var notification = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var newNotification = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var logout = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTggNEM1Ljc5MDg2IDQgNCA1Ljc5MDg2IDQgOFYxNkM0IDE4LjIwOTEgNS43OTA4NiAyMCA4IDIwSDExQzExLjU1MjMgMjAgMTIgMTkuNTUyMyAxMiAxOUMxMiAxOC40NDc3IDExLjU1MjMgMTggMTEgMThIOEM2Ljg5NTQzIDE4IDYgMTcuMTA0NiA2IDE2VjhDNiA2Ljg5NTQzIDYuODk1NDMgNiA4IDZIMTFDMTEuNTUyMyA2IDEyIDUuNTUyMjggMTIgNUMxMiA0LjQ0NzcyIDExLjU1MjMgNCAxMSA0SDhaTTE2LjIwNzEgOC4yOTI4OUMxNS44MTY2IDcuOTAyMzcgMTUuMTgzNCA3LjkwMjM3IDE0Ljc5MjkgOC4yOTI4OUMxNC40MDI0IDguNjgzNDIgMTQuNDAyNCA5LjMxNjU4IDE0Ljc5MjkgOS43MDcxMUwxNi4wODU4IDExSDEwQzkuNDQ3NzIgMTEgOSAxMS40NDc3IDkgMTJDOSAxMi41NTIzIDkuNDQ3NzIgMTMgMTAgMTNIMTYuMDg1OEwxNC43OTI5IDE0LjI5MjlDMTQuNDAyNCAxNC42ODM0IDE0LjQwMjQgMTUuMzE2NiAxNC43OTI5IDE1LjcwNzFDMTUuMTgzNCAxNi4wOTc2IDE1LjgxNjYgMTYuMDk3NiAxNi4yMDcxIDE1LjcwNzFMMTkuMjA3MSAxMi43MDcxQzE5LjU5NzYgMTIuMzE2NiAxOS41OTc2IDExLjY4MzQgMTkuMjA3MSAxMS4yOTI5TDE2LjIwNzEgOC4yOTI4OVoiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var downArrowIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE2IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUuNzA3MSAwLjI5Mjg5M0MxNi4wOTc2IDAuNjgzNDE3IDE2LjA5NzYgMS4zMTY1OCAxNS43MDcxIDEuNzA3MTFMOC43MDcxMSA4LjcwNzExQzguNTE5NTcgOC44OTQ2NCA4LjI2NTIyIDkgOCA5QzcuNzM0NzggOSA3LjQ4MDQzIDguODk0NjQgNy4yOTI4OSA4LjcwNzExTDAuMjkyODkzIDEuNzA3MTFDLTAuMDk3NjMxNSAxLjMxNjU4IC0wLjA5NzYzMTUgMC42ODM0MTcgMC4yOTI4OTMgMC4yOTI4OTNDMC42ODM0MTcgLTAuMDk3NjMxMSAxLjMxNjU4IC0wLjA5NzYzMTEgMS43MDcxMSAwLjI5Mjg5M0w4IDYuNTg1NzlMMTQuMjkyOSAwLjI5Mjg5M0MxNC42ODM0IC0wLjA5NzYzMTEgMTUuMzE2NiAtMC4wOTc2MzExIDE1LjcwNzEgMC4yOTI4OTNaIiBmaWxsPSIjNkI2ODc0Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var admin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjkzNTEgM0MxNi4xNDI1IDMgMTQuNjg5NSA0LjQ1MjM1IDE0LjY4OTUgNi4yNDU1MUMxNC42ODk1IDYuMjkzODIgMTQuNjkwNyA2LjM0MTcxIDE0LjY5MjkgNi4zODkzMUMxNS41MzY1IDcuMDI1ODQgMTYuMDk0MiA3Ljk3MDAzIDE2LjI0NDUgOS4wMTYwNUMxNi43NTM0IDkuMzI3MzEgMTcuMzM4NiA5LjQ5MTU2IDE3LjkzNTEgOS40OTA1OUMxOS43Mjc1IDkuNDkwNTkgMjEuMTgwNiA4LjAzODIzIDIxLjE4MDYgNi4yNDQ5M0MyMS4xODA2IDQuNDUxNjQgMTkuNzI4IDMgMTcuOTM1MSAzWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEyLjI5ODIgMTIuODA5NEMxNC4wOTA3IDEyLjgwOTQgMTUuNTQzOCAxMS4zNTYzIDE1LjU0MzggOS41NjM4N0MxNS41NDM4IDcuNzcxNDIgMTQuMDkwNyA2LjMxODM2IDEyLjI5ODIgNi4zMTgzNkMxMC41MDU4IDYuMzE4MzYgOS4wNTI3MyA3Ljc3MTQyIDkuMDUyNzMgOS41NjM4N0M5LjA1MjczIDExLjM1NjMgMTAuNTA1OCAxMi44MDk0IDEyLjI5ODIgMTIuODA5NFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik04LjkyIDIxLjIyMDRDOS43OTIxNCAyMS40MzYxIDEyLjIzNTEgMjEuOTUgMTUuMjc4MiAyMS4zMTE0QzE2LjE0MjUgMjEuMTI5NiAxNi45ODg1IDIwLjg2OTYgMTcuODA1NyAyMC41MzQ2VjE3LjMzMDFDMTcuODA1NyAxNC45NzU0IDE1Ljg3ODggMTMuMDQ4OCAxMy41MjQ0IDEzLjA0ODhIMTEuMDY1NUM4LjcxMDc4IDEzLjA0ODggNi43ODQxOCAxNC45NzU3IDYuNzg0MTggMTcuMzMwMVYyMC41MDI5QzcuNDc1NDYgMjAuNzk5NiA4LjE4OTc2IDIxLjAzOTYgOC45MiAyMS4yMjA0WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTguMzA5MTQgOS4wMzQxN0M4LjM4MjQgOC41MDcgOC41NjAwMiA3Ljk5OTcxIDguODMxNjEgNy41NDE5OEM5LjEwMzIgNy4wODQyNCA5LjQ2MzMyIDYuNjg1MjUgOS44OTA5MiA2LjM2ODMxQzkuODkyNSA2LjMyNzQ3IDkuODkzNSA2LjI4NjY0IDkuODkzNSA2LjI0NTUxQzkuODkzNSA0LjQ1MzA3IDguNDQxMTUgMyA2LjY0Nzg1IDNDNC44NTQ1NSAzIDMuNDAyMzQgNC40NTIzNSAzLjQwMjM0IDYuMjQ1NTFDMy40MDIzNCA4LjAzODY2IDQuODU1NDIgOS40OTA1OSA2LjY0Nzg1IDkuNDkwNTlDNy4yMzI3MiA5LjQ5MTYgNy44MDY4OSA5LjMzMzg2IDguMzA5MTQgOS4wMzQxN1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik01Ljk4NTMxIDE3LjA0OTZDNS45ODUzMSAxNC45MDExIDcuNDg5NDQgMTMuMDc1NiA5LjUzMTIyIDEyLjUwNTZDOS4xNDc0NyAxMi4xNDUzIDguODM4NjggMTEuNzEyOCA4LjYyMjYxIDExLjIzMjlDOC40MDY1MyAxMC43NTMgOC4yODc0MiAxMC4yMzUxIDguMjcyMTMgOS43MDg5OEg1LjM2OTcyQzMuMTI5NzggOS43MDg5OCAxLjI2OTc2IDExLjQxNzMgMS4wMjcwMyAxMy41OTUzSDFWMTQuMDc4M1YxNy4zNjk0QzIuNjM2ODcgMTcuODM5OSA0LjMwMiAxOC4yMDU5IDUuOTg1MzEgMTguNDY1MVYxNy4wNDk2WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTIzLjE1NjYgMTMuNTk1M0MyMi45MTQxIDExLjQxNzMgMjEuMDU0MSA5LjcwODk4IDE4LjgxMzkgOS43MDg5OEgxNi4yODNDMTYuMjY3OCAxMC4yMzM2IDE2LjE0OTMgMTAuNzUwMSAxNS45MzQ0IDExLjIyOUMxNS43MTk0IDExLjcwNzggMTUuNDEyMiAxMi4xMzk2IDE1LjAzMDMgMTIuNDk5N0MxNy4wODI4IDEzLjA2MzIgMTguNTk2NSAxNC44OTQgMTguNTk2NSAxNy4wNDk4VjE4LjQwMTVDMjAuMTQ0MyAxOC4xNDcyIDIxLjY3NiAxNy44MDI1IDIzLjE4MzYgMTcuMzY5MVYxNC4wNzg2VjEzLjU5NTRMMjMuMTU2NiAxMy41OTUzWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var difficulty = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNyAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS45NTUgNy40ODk1OEMyNS45NTUgNi42NjI1OSAyNi42MjU0IDUuOTkyMTkgMjcuNDUyNCA1Ljk5MjE5QzI4LjI3OTQgNS45OTIxOSAyOC45NDk4IDYuNjYyNTkgMjguOTQ5OCA3LjQ4OTU4VjI4LjQ1MzFDMjkuNzc2NiAyOC40NTMzIDMwLjQ0NjkgMjkuMTIzNiAzMC40NDY5IDI5Ljk1MDVDMzAuNDQ2OSAzMC43Nzc1IDI5Ljc3NjUgMzEuNDQ3OSAyOC45NDk1IDMxLjQ0NzlIMjcuNDU0OEMyNy40NTQgMzEuNDQ3OSAyNy40NTMyIDMxLjQ0NzkgMjcuNDUyNCAzMS40NDc5QzI3LjQ1MTYgMzEuNDQ3OSAyNy40NTA4IDMxLjQ0NzkgMjcuNDUgMzEuNDQ3OUgyMS40NjQ5QzIxLjQ2NDEgMzEuNDQ3OSAyMS40NjMzIDMxLjQ0NzkgMjEuNDYyNSAzMS40NDc5QzIxLjQ2MTcgMzEuNDQ3OSAyMS40NjA5IDMxLjQ0NzkgMjEuNDYwMSAzMS40NDc5SDE1LjQ3NUMxNS40NzQyIDMxLjQ0NzkgMTUuNDczNCAzMS40NDc5IDE1LjQ3MjYgMzEuNDQ3OUMxNS40NzE4IDMxLjQ0NzkgMTUuNDcxIDMxLjQ0NzkgMTUuNDcwMiAzMS40NDc5SDkuNDgzNjRINy45ODU5MkM3LjE1ODkzIDMxLjQ0NzkgNi40ODg1MyAzMC43Nzc1IDYuNDg4NTMgMjkuOTUwNUM2LjQ4ODUzIDI5LjEyMzUgNy4xNTg5MyAyOC40NTMxIDcuOTg1OTIgMjguNDUzMUg3Ljk4NjI1VjIwLjk2NjFDNy45ODYyNSAyMC4xMzkyIDguNjU2NjUgMTkuNDY4OCA5LjQ4MzY0IDE5LjQ2ODhDMTAuMzEwNiAxOS40Njg4IDEwLjk4MSAyMC4xMzkyIDEwLjk4MSAyMC45NjYxVjI4LjQ1MzFIMTMuOTc1MlYxNi40NzRDMTMuOTc1MiAxNS42NDcgMTQuNjQ1NiAxNC45NzY2IDE1LjQ3MjYgMTQuOTc2NkMxNi4yOTk2IDE0Ljk3NjYgMTYuOTcgMTUuNjQ3IDE2Ljk3IDE2LjQ3NFYyOC40NTMxSDE5Ljk2NTFWMTEuOTgxOEMxOS45NjUxIDExLjE1NDggMjAuNjM1NSAxMC40ODQ0IDIxLjQ2MjUgMTAuNDg0NEMyMi4yODk1IDEwLjQ4NDQgMjIuOTU5OSAxMS4xNTQ4IDIyLjk1OTkgMTEuOTgxOFYyOC40NTMxSDI1Ljk1NVY3LjQ4OTU4WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var pending = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNyAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOSAxOEMyOSAyMy43OTkgMjQuMjk5IDI4LjUgMTguNSAyOC41QzEyLjcwMSAyOC41IDggMjMuNzk5IDggMThDOCAxMi4yMDEgMTIuNzAxIDcuNSAxOC41IDcuNUMyNC4yOTkgNy41IDI5IDEyLjIwMSAyOSAxOFpNMzIgMThDMzIgMjUuNDU1OCAyNS45NTU4IDMxLjUgMTguNSAzMS41QzExLjA0NDIgMzEuNSA1IDI1LjQ1NTggNSAxOEM1IDEwLjU0NDIgMTEuMDQ0MiA0LjUgMTguNSA0LjVDMjUuOTU1OCA0LjUgMzIgMTAuNTQ0MiAzMiAxOFpNMjAgMTMuNUMyMCAxMi42NzE2IDE5LjMyODQgMTIgMTguNSAxMkMxNy42NzE2IDEyIDE3IDEyLjY3MTYgMTcgMTMuNVYxOEMxNyAxOC4zOTc4IDE3LjE1OCAxOC43Nzk0IDE3LjQzOTMgMTkuMDYwN0wyMS45MzkzIDIzLjU2MDdDMjIuNTI1MSAyNC4xNDY0IDIzLjQ3NDkgMjQuMTQ2NCAyNC4wNjA3IDIzLjU2MDdDMjQuNjQ2NCAyMi45NzQ5IDI0LjY0NjQgMjIuMDI1MSAyNC4wNjA3IDIxLjQzOTNMMjAgMTcuMzc4N1YxMy41WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var challengeDefaultIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var lessonDefaultIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var templateCardClock = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOSAxMkMxOSAxNS44NjYgMTUuODY2IDE5IDEyIDE5QzguMTM0MDEgMTkgNSAxNS44NjYgNSAxMkM1IDguMTM0MDEgOC4xMzQwMSA1IDEyIDVDMTUuODY2IDUgMTkgOC4xMzQwMSAxOSAxMlpNMjEgMTJDMjEgMTYuOTcwNiAxNi45NzA2IDIxIDEyIDIxQzcuMDI5NDQgMjEgMyAxNi45NzA2IDMgMTJDMyA3LjAyOTQ0IDcuMDI5NDQgMyAxMiAzQzE2Ljk3MDYgMyAyMSA3LjAyOTQ0IDIxIDEyWk0xMyA5QzEzIDguNDQ3NzIgMTIuNTUyMyA4IDEyIDhDMTEuNDQ3NyA4IDExIDguNDQ3NzIgMTEgOVYxMkMxMSAxMi4yNjUyIDExLjEwNTQgMTIuNTE5NiAxMS4yOTI5IDEyLjcwNzFMMTQuMjkyOSAxNS43MDcxQzE0LjY4MzQgMTYuMDk3NiAxNS4zMTY2IDE2LjA5NzYgMTUuNzA3MSAxNS43MDcxQzE2LjA5NzYgMTUuMzE2NiAxNi4wOTc2IDE0LjY4MzQgMTUuNzA3MSAxNC4yOTI5TDEzIDExLjU4NThWOVoiIGZpbGw9IiM5NTkzOUIiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var templateCardTeamMembers = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS43NSA3LjVDMTEuNzUgOC44ODA3MSAxMC42MzA3IDEwIDkuMjUgMTBDNy44NjkyOSAxMCA2Ljc1IDguODgwNzEgNi43NSA3LjVDNi43NSA2LjExOTI5IDcuODY5MjkgNSA5LjI1IDVDMTAuNjMwNyA1IDExLjc1IDYuMTE5MjkgMTEuNzUgNy41Wk0xMi4zNzczIDEwLjczNTdDMTMuMjIzNyA5LjkxNzUgMTMuNzUgOC43NzAyMSAxMy43NSA3LjVDMTMuNzUgNS4wMTQ3MiAxMS43MzUzIDMgOS4yNSAzQzYuNzY0NzIgMyA0Ljc1IDUuMDE0NzIgNC43NSA3LjVDNC43NSA4Ljc3MDIxIDUuMjc2MjcgOS45MTc0OSA2LjEyMjY3IDEwLjczNTdDMy44MjY1NyAxMS44ODQyIDIuMjUgMTQuMjU4IDIuMjUgMTdWMjBINC4yNVYxN0M0LjI1IDE0LjIzODYgNi40ODg1OCAxMiA5LjI1IDEyQzEyLjAxMTQgMTIgMTQuMjUgMTQuMjM4NiAxNC4yNSAxN1YyMEgxNi4yNVYxN0MxNi4yNSAxNC4yNTggMTQuNjczNCAxMS44ODQyIDEyLjM3NzMgMTAuNzM1N1pNMTguMDAwNyAxNi45OTk5VjE5Ljk5OTlIMjAuMDAwN1YxNi45OTk5QzIwLjAwMDcgMTQuMTIzNiAxOC4yNjU5IDExLjY1MjQgMTUuNzg1NSAxMC41NzU3QzE2LjUzOTIgOS43NzExMiAxNy4wMDA3IDguNjg5NDIgMTcuMDAwNyA3LjQ5OTkyQzE3LjAwMDcgNS4yNjk5MSAxNS4zNzg2IDMuNDE4NzYgMTMuMjUgMy4wNjIwMUMxNC4zMzYgNC4yMjM3MSAxNS4wMDA3IDUuNzg0MTkgMTUuMDAwNyA3LjQ5OTkyQzE1LjAwMDcgOC4zNDk1IDE0LjgzNzEgOS4xNjE5MyAxNC41NDAxIDkuOTA2NTZDMTYuNjQ1IDExLjU1MjUgMTguMDAwNyAxNC4xMTY1IDE4LjAwMDcgMTYuOTk5OVpNMjEuMDAwOCAxOS45OTk5VjE2Ljk5OTlDMjEuMDAwOCAxNC4xMTY1IDE5LjY0NSAxMS41NTI1IDE3LjU0MDEgOS45MDY1NkMxNy44MzcxIDkuMTYxOTMgMTguMDAwOCA4LjM0OTUgMTguMDAwOCA3LjQ5OTkyQzE4LjAwMDggNS43ODQxOSAxNy4zMzYgNC4yMjM3MSAxNi4yNSAzLjA2MjAxQzE4LjM3ODcgMy40MTg3NiAyMC4wMDA4IDUuMjY5OTEgMjAuMDAwOCA3LjQ5OTkyQzIwLjAwMDggOC42ODk0MiAxOS41MzkyIDkuNzcxMTIgMTguNzg1NSAxMC41NzU3QzIxLjI2NTkgMTEuNjUyNCAyMy4wMDA4IDE0LjEyMzYgMjMuMDAwOCAxNi45OTk5VjE5Ljk5OTlIMjEuMDAwOFoiIGZpbGw9IiM5NTkzOUIiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var templateCardClose = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iNCIgeT0iMTguNSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIiIHJ4PSIxIiB0cmFuc2Zvcm09InJvdGF0ZSgtNDUgNCAxOC41KSIgZmlsbD0iIzU2NTM2MCIvPgo8cmVjdCB4PSIxOC4xNDA2IiB5PSIxOS45MTQyIiB3aWR0aD0iMjAiIGhlaWdodD0iMiIgcng9IjEiIHRyYW5zZm9ybT0icm90YXRlKC0xMzUgMTguMTQwNiAxOS45MTQyKSIgZmlsbD0iIzU2NTM2MCIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var templateCardArrow = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var check = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzYiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA3NiA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbHRlcj0idXJsKCNmaWx0ZXIwX2JfNTYyN182NjU4KSI+CiAgICAgICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICAgIGQ9Ik00NS42MjA4IDE2LjMzMzZDNDYuMTExNiAxNi43OTIyIDQ2LjEyODEgMTcuNTUxOCA0NS42NTc4IDE4LjAzMDNMMzYuMjIxOSAyNy42MzAzQzM1Ljk5MjkgMjcuODYzMyAzNS42Nzc0IDI3Ljk5NjUgMzUuMzQ2NCAyNy45OTk5QzM1LjAxNTUgMjguMDAzNCAzNC42OTcxIDI3Ljg3NjcgMzQuNDYzIDI3LjY0ODVMMzAuMzYwNSAyMy42NDg1QzI5Ljg3OTggMjMuMTc5OSAyOS44Nzk4IDIyLjQyMDEgMzAuMzYwNSAyMS45NTE1QzMwLjg0MTEgMjEuNDgyOCAzMS42MjA0IDIxLjQ4MjggMzIuMTAxMSAyMS45NTE1TDM1LjMxNDYgMjUuMDg0N0w0My44ODA2IDE2LjM2OTdDNDQuMzUwOSAxNS44OTEyIDQ1LjEzIDE1Ljg3NTEgNDUuNjIwOCAxNi4zMzM2WiIKICAgICAgICAgICAgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC41IiAvPgogICAgPC9nPgogICAgPGRlZnM+CiAgICAgICAgPGZpbHRlciBpZD0iZmlsdGVyMF9iXzU2MjdfNjY1OCIgeD0iLTIwIiB5PSItMjAiIHdpZHRoPSIxMTYiIGhlaWdodD0iODQiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIKICAgICAgICAgICAgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KICAgICAgICAgICAgPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIC8+CiAgICAgICAgICAgIDxmZUdhdXNzaWFuQmx1ciBpbj0iQmFja2dyb3VuZEltYWdlIiBzdGREZXZpYXRpb249IjEwIiAvPgogICAgICAgICAgICA8ZmVDb21wb3NpdGUgaW4yPSJTb3VyY2VBbHBoYSIgb3BlcmF0b3I9ImluIiByZXN1bHQ9ImVmZmVjdDFfYmFja2dyb3VuZEJsdXJfNTYyN182NjU4IiAvPgogICAgICAgICAgICA8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfYmFja2dyb3VuZEJsdXJfNTYyN182NjU4IiByZXN1bHQ9InNoYXBlIiAvPgogICAgICAgIDwvZmlsdGVyPgogICAgPC9kZWZzPgo8L3N2Zz4=";

/* loaded by smart-asset */
var done = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi4zNTA4IDYuNjExMzNDMTYuNzU5OCA2Ljk5MzQ1IDE2Ljc3MzYgNy42MjY0OCAxNi4zODE3IDguMDI1MjJMOC41MTg0NCAxNi4wMjUyQzguMzI3NjEgMTYuMjE5NCA4LjA2NDYzIDE2LjMzMDQgNy43ODg4NSAxNi4zMzMzQzcuNTEzMDcgMTYuMzM2MSA3LjI0NzcyIDE2LjIzMDYgNy4wNTI3IDE2LjA0MDRMMy42MzM5IDEyLjcwNzFDMy4yMzMzNiAxMi4zMTY2IDMuMjMzMzYgMTEuNjgzNCAzLjYzMzkgMTEuMjkyOUM0LjAzNDQ0IDEwLjkwMjMgNC42ODM4NCAxMC45MDIzIDUuMDg0MzcgMTEuMjkyOUw3Ljc2MjM1IDEzLjkwMzlMMTQuOTAwNyA2LjY0MTQxQzE1LjI5MjYgNi4yNDI2NyAxNS45NDE5IDYuMjI5MiAxNi4zNTA4IDYuNjExMzNaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var error = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzYiIGhlaWdodD0iNDQiIHZpZXdCb3g9IjAgMCA3NiA0NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00NSAyMkM0NSAxOC4xMzQgNDEuODY2IDE1IDM4IDE1QzM0LjEzNCAxNSAzMSAxOC4xMzQgMzEgMjJDMzEgMjUuODY2IDM0LjEzNCAyOSAzOCAyOUM0MS44NjYgMjkgNDUgMjUuODY2IDQ1IDIyWk0zOCAzMUM0Mi45NzA2IDMxIDQ3IDI2Ljk3MDYgNDcgMjJDNDcgMTcuMDI5NCA0Mi45NzA2IDEzIDM4IDEzQzMzLjAyOTQgMTMgMjkgMTcuMDI5NCAyOSAyMkMyOSAyNi45NzA2IDMzLjAyOTQgMzEgMzggMzFaTTM5IDE3TDM5IDI0TDM3IDI0TDM3IDE3TDM5IDE3Wk0zOCAyNUMzNy40NDc3IDI1IDM3IDI1LjQ0NzcgMzcgMjZDMzcgMjYuNTUyMyAzNy40NDc3IDI3IDM4IDI3QzM4LjU1MjMgMjcgMzkgMjYuNTUyMyAzOSAyNkMzOSAyNS40NDc3IDM4LjU1MjMgMjUgMzggMjVaIiBmaWxsPSIjRkY3MzYwIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var users = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxOCAxNyIgZmlsbD0ibm9uZSIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNSA3QzcuODgwNzEgNyA5IDUuODgwNzEgOSA0LjVDOSAzLjExOTI5IDcuODgwNzEgMiA2LjUgMkM1LjExOTI5IDIgNCAzLjExOTI5IDQgNC41QzQgNS44ODA3MSA1LjExOTI5IDcgNi41IDdaTTExIDQuNUMxMSA1LjY4OTUgMTAuNTM4NSA2Ljc3MTIgOS43ODQ3NCA3LjU3NTgyQzEyLjI2NTIgOC42NTI1IDE0IDExLjEyMzYgMTQgMTRWMTdIMTJWMTRDMTIgMTEuMjM4NiA5Ljc2MTQyIDkgNyA5QzQuMjM4NTggOSAyIDExLjIzODYgMiAxNFYxN0gwVjE0QzAgMTEuMzg1NyAxLjQzMzE2IDkuMTA2MSAzLjU1NjY4IDcuOTA0MDRDMi42MDMyMiA3LjA3ODkgMiA1Ljg1OTkgMiA0LjVDMiAyLjAxNDcyIDQuMDE0NzIgMCA2LjUgMEM4Ljk4NTI4IDAgMTEgMi4wMTQ3MiAxMSA0LjVaTTE2IDE3VjE0QzE2IDExLjExNjYgMTQuNjQ0MyA4LjU1MjYyIDEyLjUzOTQgNi45MDY2M0MxMi44MzY0IDYuMTYyIDEzIDUuMzQ5NTcgMTMgNC41QzEzIDIuNzg0MjYgMTIuMzM1MyAxLjIyMzc5IDExLjI0OTMgMC4wNjIwODhDMTMuMzc3OSAwLjQxODgzMyAxNSAyLjI2OTk4IDE1IDQuNUMxNSA1LjY4OTUgMTQuNTM4NSA2Ljc3MTIgMTMuNzg0OCA3LjU3NTgxQzE2LjI2NTIgOC42NTI0OSAxOCAxMS4xMjM2IDE4IDE0VjE3SDE2WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var errorIcon = "LLzXvaMn.svg";

/* loaded by smart-asset */
var plus = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyNSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS41IDEuNzQ4MDVDMTAuOTQ3NyAxLjc0ODA1IDEwLjUgMi4xOTU3NiAxMC41IDIuNzQ4MDVWOC43MzgwOUgzLjVDMi45NDc3MiA4LjczODA5IDIuNSA5LjE4NTggMi41IDkuNzM4MDlWMTAuMzU5NEMyLjUgMTAuOTExNiAyLjk0NzcxIDExLjM1OTQgMy41IDExLjM1OTRIMTAuNVYxNy4zNDk0QzEwLjUgMTcuOTAxNyAxMC45NDc3IDE4LjM0OTQgMTEuNSAxOC4zNDk0SDEyLjVDMTMuMDUyMyAxOC4zNDk0IDEzLjUgMTcuOTAxNyAxMy41IDE3LjM0OTRWMTEuMzU5NEgyMC41QzIxLjA1MjMgMTEuMzU5NCAyMS41IDEwLjkxMTYgMjEuNSAxMC4zNTk0VjkuNzM4MDlDMjEuNSA5LjE4NTggMjEuMDUyMyA4LjczODA5IDIwLjUgOC43MzgwOUgxMy41VjIuNzQ4MDVDMTMuNSAyLjE5NTc2IDEzLjA1MjMgMS43NDgwNSAxMi41IDEuNzQ4MDVIMTEuNVoiIGZpbGw9IiM5NTkzOUIiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var cancel = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0id2hpdGUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMuODM4MiAxNS4yOTI3QzE0LjIyODcgMTUuNjgzMyAxNC44NjE4IDE1LjY4MzMgMTUuMjUyNCAxNS4yOTI3TDE1LjI5MjcgMTUuMjUyNEMxNS42ODMyIDE0Ljg2MTkgMTUuNjgzMiAxNC4yMjg3IDE1LjI5MjcgMTMuODM4Mkw5LjQ1NDM4IDcuOTk5ODZMMTUuMjkyNyAyLjE2MTUyQzE1LjY4MzIgMS43NzA5OSAxNS42ODMyIDEuMTM3ODMgMTUuMjkyNyAwLjc0NzMwMkwxNS4yNTI0IDAuNzA2OTcyQzE0Ljg2MTggMC4zMTY0NDcgMTQuMjI4NyAwLjMxNjQ0NyAxMy44MzgyIDAuNzA2OTcyTDcuOTk5ODQgNi41NDUzMUwyLjE2MTUgMC43MDY5NTZDMS43NzA5NyAwLjMxNjQzMSAxLjEzNzgxIDAuMzE2NDMyIDAuNzQ3Mjg1IDAuNzA2OTU2TDAuNzA2OTU2IDAuNzQ3Mjg2QzAuMzE2NDMyIDEuMTM3ODEgMC4zMTY0MzEgMS43NzA5OCAwLjcwNjk1NSAyLjE2MTVMNi41NDUyOSA3Ljk5OTg2TDAuNzA2OTU3IDEzLjgzODJDMC4zMTY0MzQgMTQuMjI4NyAwLjMxNjQzNCAxNC44NjE5IDAuNzA2OTU4IDE1LjI1MjRMMC43NDcyODcgMTUuMjkyOEMxLjEzNzgxIDE1LjY4MzMgMS43NzA5NyAxNS42ODMzIDIuMTYxNSAxNS4yOTI4TDcuOTk5ODQgOS40NTQ0TDEzLjgzODIgMTUuMjkyN1oiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var arrowRight = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0id2hpdGUiIG9wYWNpdHk9IjAuNyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi43OTI5IDUuNzkyODlDMTMuMTgzNCA1LjQwMjM3IDEzLjgxNjYgNS40MDIzNyAxNC4yMDcxIDUuNzkyODlMMTkuNzA3MSAxMS4yOTI5QzIwLjA5NzYgMTEuNjgzNCAyMC4wOTc2IDEyLjMxNjYgMTkuNzA3MSAxMi43MDcxTDE0LjIwNzEgMTguMjA3MUMxMy44MTY2IDE4LjU5NzYgMTMuMTgzNCAxOC41OTc2IDEyLjc5MjkgMTguMjA3MUMxMi40MDI0IDE3LjgxNjYgMTIuNDAyNCAxNy4xODM0IDEyLjc5MjkgMTYuNzkyOUwxNi41ODU4IDEzSDVDNC40NDc3MiAxMyA0IDEyLjU1MjMgNCAxMkM0IDExLjQ0NzcgNC40NDc3MiAxMSA1IDExSDE2LjU4NThMMTIuNzkyOSA3LjIwNzExQzEyLjQwMjQgNi44MTY1OCAxMi40MDI0IDYuMTgzNDIgMTIuNzkyOSA1Ljc5Mjg5WiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var noNotificationsIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTgiIGhlaWdodD0iNzkiIHZpZXdCb3g9IjAgMCA1OCA3OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC43Ij4KPHBhdGggZD0iTTMwLjMxMDcgMTMuODI4M1YyNy45NDYxTDE1IDIzLjM1MjlWMTMuODI4M0MxNSA5LjYwMDQyIDE4LjQyNzQgNi4xNzMgMjIuNjU1MyA2LjE3M0MyNi44ODMzIDYuMTczIDMwLjMxMDcgOS42MDA0MSAzMC4zMTA3IDEzLjgyODNaIiBzdHJva2U9IndoaXRlIi8+CjxwYXRoIGQ9Ik0yMS44NDM4IDYuMkw0NC42NjcyIDEuNjM0NzVDNDYuODA1OSAxLjIwNjk2IDQ5LjAyMTIgMS4zNzc5IDUxLjA2ODkgMi4xMjg3NEw1Mi41MTc4IDIuNjU5OTlDNTMuMDg1MiAyLjg2ODA0IDUzLjYxNTEgMy4xNjY2MiA1NC4wODcgMy41NDQxNFYzLjU0NDE0QzU1LjkyNzYgNS4wMTY2MiA1Ni45OTkxIDcuMjQ1OTQgNTYuOTk5MSA5LjYwMzA3VjE5LjczNzlMMzAuODExNCAyOC4wMjc1IiBzdHJva2U9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNC44NjI3IDIzLjE1MzlMMzAuNjczNCAxOC40NDIiIHN0cm9rZT0id2hpdGUiLz4KPGxpbmUgeDE9IjQ0LjcyMjciIHkxPSIyMy45MDYyIiB4Mj0iNDQuNzIyNyIgeTI9Ijc4LjkwNjIiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTE1LjI5MSAyM0wxMC42NDU1IDI4LjM4NzVMOS44NjkyMiAyOS4yODc4QzcuODYxOTIgMzEuNjE1NyA4LjQ3MzU3IDM1LjE5MzYgMTEuMTA5NCAzNi43NzUxVjM2Ljc3NTFWMzYuNzc1MUMxNy43NjczIDQwLjc2OTggMjUuNjQ4MyAzNS43OTExIDI5LjgyMTEgMjkuMjQzM0wzMC43MzkyIDI3LjgwMjYiIHN0cm9rZT0id2hpdGUiLz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var replace = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMTQuNSAzTDEyLjUgMUg0LjVDMy45Njk1NyAxIDMuNDYwODYgMS4yMTA3MSAzLjA4NTc5IDEuNTg1NzlDMi43MTA3MSAxLjk2MDg2IDIuNSAyLjQ2OTU3IDIuNSAzVjE1QzIuNSAxNS41MzA0IDIuNzEwNzEgMTYuMDM5MSAzLjA4NTc5IDE2LjQxNDJDMy40NjA4NiAxNi43ODkzIDMuOTY5NTcgMTcgNC41IDE3SDExLjVWMTlMMTUuNSAxNkwxMS41IDEzVjE1SDQuNVYzSDE0LjVaTTIxLjUgMTBWMjFDMjEuNSAyMS41MzA0IDIxLjI4OTMgMjIuMDM5MSAyMC45MTQyIDIyLjQxNDJDMjAuNTM5MSAyMi43ODkzIDIwLjAzMDQgMjMgMTkuNSAyM0g4LjVDNy45Njk1NyAyMyA3LjQ2MDg2IDIyLjc4OTMgNy4wODU3OSAyMi40MTQyQzYuNzEwNzEgMjIuMDM5MSA2LjUgMjEuNTMwNCA2LjUgMjFWMTlIOC41VjIxSDE5LjVWMTJIMTQuNVY3SDguNVYxM0g2LjVWN0M2LjUgNi40Njk1NyA2LjcxMDcxIDUuOTYwODYgNy4wODU3OSA1LjU4NTc5QzcuNDYwODYgNS4yMTA3MSA3Ljk2OTU3IDUgOC41IDVIMTYuNUwyMS41IDEwWiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var deleteIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEzLjY0NzEgMkMxNC4xOTkzIDIgMTQuNjQ3MSAyLjQ0NzcyIDE0LjY0NzEgM1YzLjExMTExSDIwQzIwLjU1MjMgMy4xMTExMSAyMSAzLjU1ODgzIDIxIDQuMTExMTFWNC4zMzMzM0MyMSA0Ljg4NTYyIDIwLjU1MjMgNS4zMzMzMyAyMCA1LjMzMzMzSDRDMy40NDc3MiA1LjMzMzMzIDMgNC44ODU2MiAzIDQuMzMzMzNWNC4xMTExMUMzIDMuNTU4ODMgMy40NDc3MiAzLjExMTExIDQgMy4xMTExMUg5LjM1Mjk0VjNDOS4zNTI5NCAyLjQ0NzcyIDkuODAwNjYgMiAxMC4zNTI5IDJIMTMuNjQ3MVpNNy4zMjY5MiAxOC42NjY3VjYuNDQ0NDRINS4yNVYxOC42NjY3QzUuMjUgMjAuNTA3NiA2LjY0NDgxIDIyIDguMzY1MzkgMjJIMTUuNjM0NkMxNy4zNTUyIDIyIDE4Ljc1IDIwLjUwNzYgMTguNzUgMTguNjY2N1Y2LjQ0NDQ0SDE2LjY3MzFWMTguNjY2N0MxNi42NzMxIDE5LjI4MDMgMTYuMjA4MSAxOS43Nzc4IDE1LjYzNDYgMTkuNzc3OEg4LjM2NTM5QzcuNzkxODYgMTkuNzc3OCA3LjMyNjkyIDE5LjI4MDMgNy4zMjY5MiAxOC42NjY3WiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var account = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNCAxNyIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkgNC41QzkgNS44ODA3MSA3Ljg4MDcxIDcgNi41IDdDNS4xMTkyOSA3IDQgNS44ODA3MSA0IDQuNUM0IDMuMTE5MjkgNS4xMTkyOSAyIDYuNSAyQzcuODgwNzEgMiA5IDMuMTE5MjkgOSA0LjVaTTkuNzg0NzQgNy41NzU4MkMxMC41Mzg1IDYuNzcxMiAxMSA1LjY4OTUgMTEgNC41QzExIDIuMDE0NzIgOC45ODUyOCAwIDYuNSAwQzQuMDE0NzIgMCAyIDIuMDE0NzIgMiA0LjVDMiA1Ljg1OTkgMi42MDMyMiA3LjA3ODkgMy41NTY2OCA3LjkwNDA0QzEuNDMzMTYgOS4xMDYxIDAgMTEuMzg1NyAwIDE0VjE3SDJWMTRDMiAxMS4yMzg2IDQuMjM4NTggOSA3IDlDOS43NjE0MiA5IDEyIDExLjIzODYgMTIgMTRWMTdIMTRWMTRDMTQgMTEuMTIzNiAxMi4yNjUyIDguNjUyNSA5Ljc4NDc0IDcuNTc1ODJaIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var retake = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNSAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljg2NDkgMC40NDgzOEM5LjE3NzMyIDAuNzYwOCA5LjE3NzMyIDEuMjY3MzMgOC44NjQ5IDEuNTc5NzVMNy44MjMwMiAyLjYyMTY0QzExLjQyODIgMi43OTA2NSAxNC4yOTkyIDUuNzY3MDcgMTQuMjk5MiA5LjQxNDA3QzE0LjI5OTIgMTMuMTY5NiAxMS4yNTQ4IDE2LjIxNDEgNy40OTkyMiAxNi4yMTQxQzMuNzQzNjggMTYuMjE0MSAwLjY5OTIxOSAxMy4xNjk2IDAuNjk5MjE5IDkuNDE0MDdDMC42OTkyMTkgOC45NzIyNCAxLjA1NzM5IDguNjE0MDcgMS40OTkyMiA4LjYxNDA3QzEuOTQxMDUgOC42MTQwNyAyLjI5OTIyIDguOTcyMjQgMi4yOTkyMiA5LjQxNDA3QzIuMjk5MjIgMTIuMjg1OSA0LjYyNzM0IDE0LjYxNDEgNy40OTkyMiAxNC42MTQxQzEwLjM3MTEgMTQuNjE0MSAxMi42OTkyIDEyLjI4NTkgMTIuNjk5MiA5LjQxNDA3QzEyLjY5OTIgNi42NTcyNSAxMC41NTM5IDQuNDAxNSA3Ljg0MTY5IDQuMjI1MTZMOC44NjQ5IDUuMjQ4MzhDOS4xNzczMiA1LjU2MDggOS4xNzczMiA2LjA2NzMzIDguODY0OSA2LjM3OTc1QzguNTUyNDggNi42OTIxNyA4LjA0NTk1IDYuNjkyMTcgNy43MzM1MyA2LjM3OTc1TDUuMzMzNTMgMy45Nzk3NUM1LjAyMTExIDMuNjY3MzMgNS4wMjExMSAzLjE2MDggNS4zMzM1MyAyLjg0ODM4TDcuNzMzNTMgMC40NDgzOEM4LjA0NTk1IDAuMTM1OTYxIDguNTUyNDggMC4xMzU5NjEgOC44NjQ5IDAuNDQ4MzhaIiBmaWxsPSIjRkVGRUZGIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var assessmentIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC41IiBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjk4Nl8xMDYwOCkiPgo8ZyBmaWx0ZXI9InVybCgjZmlsdGVyMF9kXzI5ODZfMTA2MDgpIj4KPHJlY3QgeD0iMTkuNjY1IiB5PSIxMi41MzkxIiB3aWR0aD0iMTIuNDc0IiBoZWlnaHQ9IjIuMzUwMTgiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuOCIgc2hhcGUtcmVuZGVyaW5nPSJjcmlzcEVkZ2VzIi8+CjxyZWN0IHg9IjE5Ljg1MDYiIHk9IjEyLjcyNDYiIHdpZHRoPSIxMi4xMDI5IiBoZWlnaHQ9IjEuOTc5MDQiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjgiIHN0cm9rZS13aWR0aD0iMC4zNzExMzQiIHN0cm9rZS1taXRlcmxpbWl0PSIxNiIgc2hhcGUtcmVuZGVyaW5nPSJjcmlzcEVkZ2VzIi8+CjwvZz4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjFfZF8yOTg2XzEwNjA4KSI+CjxyZWN0IHg9Ii02LjUiIHk9IjguMDE5NTMiIHdpZHRoPSIxMi42NTQ4IiBoZWlnaHQ9IjEuODA3ODMiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuOCIgc2hhcGUtcmVuZGVyaW5nPSJjcmlzcEVkZ2VzIi8+CjxyZWN0IHg9Ii02LjMxNDQzIiB5PSI4LjIwNTEiIHdpZHRoPSIxMi4yODM3IiBoZWlnaHQ9IjEuNDM2NjkiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS1vcGFjaXR5PSIwLjgiIHN0cm9rZS13aWR0aD0iMC4zNzExMzQiIHN0cm9rZS1taXRlcmxpbWl0PSIxNiIgc2hhcGUtcmVuZGVyaW5nPSJjcmlzcEVkZ2VzIi8+CjwvZz4KPHBhdGggZD0iTTE4LjI2MzIgMy41SDcuNTY1MzhDNy4xNjAwNiAzLjUgNi43NzEzMyAzLjcyNDA3IDYuNDg0NzMgNC4xMjI5MUM2LjE5ODEyIDQuNTIxNzYgNi4wMzcxMSA1LjA2MjcxIDYuMDM3MTEgNS42MjY3NlYxNi4yNjA1QzYuMDM3MTEgMTYuODI0NiA2LjE5ODEyIDE3LjM2NTUgNi40ODQ3MyAxNy43NjQ0QzYuNzcxMzMgMTguMTYzMiA3LjE2MDA2IDE4LjM4NzMgNy41NjUzOCAxOC4zODczSDEwLjAwMTRDMTAuNzY1NiAxOC4zODczIDExLjM4NiAxOS4yNDk3IDExLjM4NiAyMC4zMTQxQzExLjM4NiAyMS4xNzMzIDEyLjEzMTggMjEuNjAzIDEyLjU2ODIgMjAuOTk1OEwxMy45OTQ4IDE5LjAxMDRDMTQuMjgxMyAxOC42MTE2IDE0LjY3IDE4LjM4NzQgMTUuMDc1MyAxOC4zODczSDE4LjI2MzJDMTguNjY4NiAxOC4zODczIDE5LjA1NzMgMTguMTYzMiAxOS4zNDM5IDE3Ljc2NDRDMTkuNjMwNSAxNy4zNjU1IDE5Ljc5MTUgMTYuODI0NiAxOS43OTE1IDE2LjI2MDVWNS42MjY3NkMxOS43OTE1IDUuMDYyNzEgMTkuNjMwNSA0LjUyMTc2IDE5LjM0MzkgNC4xMjI5MUMxOS4wNTczIDMuNzI0MDcgMTguNjY4NiAzLjUgMTguMjYzMiAzLjVWMy41WiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLW9wYWNpdHk9IjAuOCIgc3Ryb2tlLXdpZHRoPSIwLjc0MjI2OCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi44NDMzIDEyLjYyNDVDMTIuNjc2NCAxMi42MjQ1IDEyLjUzNTYgMTIuNTY0NSAxMi40MjEgMTIuNDQ0NUMxMi4zMDYxIDEyLjMyNDQgMTIuMjU1NiAxMi4xODMxIDEyLjI2OTUgMTIuMDIwN0MxMi4yOTA0IDExLjcyNDEgMTIuMzU5OSAxMS40NjYzIDEyLjQ3ODEgMTEuMjQ3M0MxMi41OTY0IDExLjAyODQgMTIuNzg0MiAxMC44MDI0IDEzLjA0MTUgMTAuNTY5M0MxMy4zMjY3IDEwLjMxNTEgMTMuNTQ0IDEwLjA5NDMgMTMuNjkzNCA5LjkwN0MxMy44NDMxIDkuNzE5OTkgMTMuOTE3OSA5LjUwNjQxIDEzLjkxNzkgOS4yNjYyOEMxMy45MTc5IDguOTc2NzIgMTMuODIyMyA4LjczNjU5IDEzLjYzMTIgOC41NDU5QzEzLjQzOTggOC4zNTUyMSAxMy4xNzM3IDguMjU5ODYgMTIuODMyOSA4LjI1OTg2QzEyLjYxMDMgOC4yNTk4NiAxMi40MjA4IDguMzA3NDcgMTIuMjY0NSA4LjQwMjY3QzEyLjEwNzggOC40OTgxNiAxMS45ODA4IDguNjE2NTIgMTEuODgzNSA4Ljc1Nzc4QzExLjc4NjEgOC44OTkwMyAxMS42NjYyIDguOTk0MzcgMTEuNTIzNyA5LjA0MzgxQzExLjM4MSA5LjA5MzI1IDExLjI0MzYgOS4wODk3MiAxMS4xMTE0IDkuMDMzMjJDMTAuOTUxNSA4Ljk2MjU5IDEwLjg0MiA4Ljg0NjA2IDEwLjc4MyA4LjY4MzYyQzEwLjcyMzcgOC41MjExOCAxMC43MzU4IDguMzY5MzMgMTAuODE5MyA4LjIyODA4QzExLjAyMSA3LjkxMDI2IDExLjI5MjMgNy42NDU0MiAxMS42MzMxIDcuNDMzNTRDMTEuOTczOSA3LjIyMTY2IDEyLjM3MzggNy4xMTU3MiAxMi44MzI5IDcuMTE1NzJDMTMuNTYzMiA3LjExNTcyIDE0LjEyNDkgNy4zMjIzNyAxNC41MTggNy43MzU2OEMxNC45MTA4IDguMTQ4NyAxNS4xMDcyIDguNjQ0NzggMTUuMTA3MiA5LjIyMzkxQzE1LjEwNzIgOS41NzcwNCAxNS4wMzI1IDkuODc5MDMgMTQuODgzMSAxMC4xMjk5QzE0LjczMzUgMTAuMzgwNSAxNC40OTg3IDEwLjY2NDcgMTQuMTc4NyAxMC45ODI1QzEzLjk0MjIgMTEuMjA4NSAxMy43NzUzIDExLjM5MjEgMTMuNjc3OSAxMS41MzM0QzEzLjU4MDYgMTEuNjc0NiAxMy41MTQ1IDExLjgzNzEgMTMuNDc5NyAxMi4wMjA3QzEzLjQ1MTkgMTIuMTk3MyAxMy4zNzg5IDEyLjM0MiAxMy4yNjA2IDEyLjQ1NUMxMy4xNDI0IDEyLjU2OCAxMy4wMDMzIDEyLjYyNDUgMTIuODQzMyAxMi42MjQ1Wk0xMi44MzI5IDE1LjE2NzFDMTIuNjAzMyAxNS4xNjcxIDEyLjQwNjkgMTUuMDg0MiAxMi4yNDM2IDE0LjkxODNDMTIuMDggMTQuNzUyMiAxMS45OTgyIDE0LjU1MjYgMTEuOTk4MiAxNC4zMTk2QzExLjk5ODIgMTQuMDg2NSAxMi4wOCAxMy44ODY5IDEyLjI0MzYgMTMuNzIwOEMxMi40MDY5IDEzLjU1NSAxMi42MDMzIDEzLjQ3MjEgMTIuODMyOSAxMy40NzIxQzEzLjA2MjQgMTMuNDcyMSAxMy4yNTg5IDEzLjU1NSAxMy40MjI1IDEzLjcyMDhDMTMuNTg1OCAxMy44ODY5IDEzLjY2NzUgMTQuMDg2NSAxMy42Njc1IDE0LjMxOTZDMTMuNjY3NSAxNC41NTI2IDEzLjU4NTggMTQuNzUyMiAxMy40MjI1IDE0LjkxODNDMTMuMjU4OSAxNS4wODQyIDEzLjA2MjQgMTUuMTY3MSAxMi44MzI5IDE1LjE2NzFaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjgiLz4KPC9nPgo8ZGVmcz4KPGZpbHRlciBpZD0iZmlsdGVyMF9kXzI5ODZfMTA2MDgiIHg9IjQuODE5NjgiIHk9IjguODI3NzIiIHdpZHRoPSI0Mi4xNjQ0IiBoZWlnaHQ9IjMyLjA0MDkiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeT0iMTEuMTM0Ii8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjcuNDIyNjgiLz4KPGZlQ29tcG9zaXRlIGluMj0iaGFyZEFscGhhIiBvcGVyYXRvcj0ib3V0Ii8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAuOTI1NDkgMCAwIDAgMCAwLjU0OTAyIDAgMCAwIDAgMC43MDk4MDQgMCAwIDAgMC4yNSAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93XzI5ODZfMTA2MDgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfMjk4Nl8xMDYwOCIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPGZpbHRlciBpZD0iZmlsdGVyMV9kXzI5ODZfMTA2MDgiIHg9Ii0yMS4zNDU0IiB5PSI0LjMwODE5IiB3aWR0aD0iNDIuMzQ2IiBoZWlnaHQ9IjMxLjQ5ODUiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeT0iMTEuMTM0Ii8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjcuNDIyNjgiLz4KPGZlQ29tcG9zaXRlIGluMj0iaGFyZEFscGhhIiBvcGVyYXRvcj0ib3V0Ii8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAuOTI1NDkgMCAwIDAgMCAwLjU0OTAyIDAgMCAwIDAgMC43MDk4MDQgMCAwIDAgMC4yNSAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0iZWZmZWN0MV9kcm9wU2hhZG93XzI5ODZfMTA2MDgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2Ryb3BTaGFkb3dfMjk4Nl8xMDYwOCIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yOTg2XzEwNjA4Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var rightArrowIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC43Ij4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljg2MzIzIDIuNTI4NjRDOC4xMjM1OCAyLjI2ODI5IDguNTQ1NjkgMi4yNjgyOSA4LjgwNjA0IDIuNTI4NjRMMTMuNDcyNyA3LjE5NTNDMTMuNTk3NyA3LjMyMDMzIDEzLjY2OCA3LjQ4OTkgMTMuNjY4IDcuNjY2NzFDMTMuNjY4IDcuODQzNTIgMTMuNTk3NyA4LjAxMzA5IDEzLjQ3MjcgOC4xMzgxMUw4LjgwNjA0IDEyLjgwNDhDOC41NDU2OSAxMy4wNjUxIDguMTIzNTggMTMuMDY1MSA3Ljg2MzIzIDEyLjgwNDhDNy42MDI4OCAxMi41NDQ0IDcuNjAyODggMTIuMTIyMyA3Ljg2MzIzIDExLjg2MkwxMi4wNTg1IDcuNjY2NzFMNy44NjMyMyAzLjQ3MTQ1QzcuNjAyODggMy4yMTExIDcuNjAyODggMi43ODg5OSA3Ljg2MzIzIDIuNTI4NjRaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjgiLz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var expand = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMyAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC43IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEuMTY1NTggMC40OTgyNDVDMC42MTIzMzggMS4wNTE0OSAwLjYxMjMzOCAxLjk0ODQ3IDEuMTY1NTggMi41MDE3MUw4LjY2Mzg1IDkuOTk5OThMMS4xNjU1OCAxNy40OTgyQzAuNjEyMzM5IDE4LjA1MTUgMC42MTIzMzggMTguOTQ4NSAxLjE2NTU4IDE5LjUwMTdDMS43MTg4MiAyMC4wNTUgMi42MTU4MSAyMC4wNTUgMy4xNjkwNSAxOS41MDE3TDExLjY2OTEgMTEuMDAxN0MxMi4yMjIzIDEwLjQ0ODUgMTIuMjIyMyA5LjU1MTQ5IDExLjY2OTEgOC45OTgyNUwzLjE2OTA1IDAuNDk4MjQ1QzIuNjE1ODEgLTAuMDU0OTk3NyAxLjcxODgyIC0wLjA1NDk5NzcgMS4xNjU1OCAwLjQ5ODI0NVoiIGZpbGw9IiNGRUZFRkYiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var unExpand = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMyAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC43IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjgzNTQgMC40OTgyNDVDMTIuMzg4NiAxLjA1MTQ5IDEyLjM4ODYgMS45NDg0NyAxMS44MzU0IDIuNTAxNzFMNC4zMzcxMyA5Ljk5OTk4TDExLjgzNTQgMTcuNDk4MkMxMi4zODg2IDE4LjA1MTUgMTIuMzg4NiAxOC45NDg1IDExLjgzNTQgMTkuNTAxN0MxMS4yODIyIDIwLjA1NSAxMC4zODUyIDIwLjA1NSA5LjgzMTkzIDE5LjUwMTdMMS4zMzE5MyAxMS4wMDE3QzAuNzc4NjgyIDEwLjQ0ODUgMC43Nzg2ODEgOS41NTE0OSAxLjMzMTkyIDguOTk4MjVMOS44MzE5MyAwLjQ5ODI0NUMxMC4zODUyIC0wLjA1NDk5NzcgMTEuMjgyMiAtMC4wNTQ5OTc3IDExLjgzNTQgMC40OTgyNDVaIiBmaWxsPSIjRkVGRUZGIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var doneBlue = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43NjU3IDAuODM0MjlDMTYuMDc4MSAxLjE0NjcxIDE2LjA3ODEgMS42NTMyNCAxNS43NjU3IDEuOTY1NjZMNi4wNDg1MyAxMS42ODI4QzUuNTc5OSAxMi4xNTE0IDQuODIwMSAxMi4xNTE0IDQuMzUxNDcgMTEuNjgyOEwwLjIzNDMxNSA3LjU2NTY2Qy0wLjA3ODEwNDkgNy4yNTMyNCAtMC4wNzgxMDQ5IDYuNzQ2NzEgMC4yMzQzMTUgNi40MzQyOUMwLjU0NjczNCA2LjEyMTg3IDEuMDUzMjcgNi4xMjE4NyAxLjM2NTY5IDYuNDM0MjlMNS4yIDEwLjI2ODZMMTQuNjM0MyAwLjgzNDI5QzE0Ljk0NjcgMC41MjE4NzEgMTUuNDUzMyAwLjUyMTg3MSAxNS43NjU3IDAuODM0MjlaIiBmaWxsPSIjMTA5Q0YxIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var dot = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMCAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iNSIgY3k9IjUiIHI9IjUiIGZpbGw9IiNGMTc5QUUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var reTakeAction = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var devCoin = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var barChart = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAyNCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMyIgeT0iMTMiIHdpZHRoPSI2IiBoZWlnaHQ9IjE0IiBmaWxsPSIjRkI4NkI2IiBzdHJva2U9IndoaXRlIi8+CjxyZWN0IHg9IjkiIHk9IjkiIHdpZHRoPSI2IiBoZWlnaHQ9IjE4IiBmaWxsPSIjRkI4NkI2IiBzdHJva2U9IndoaXRlIi8+CjxyZWN0IHg9IjE1IiB5PSIxNiIgd2lkdGg9IjYiIGhlaWdodD0iMTEiIGZpbGw9IiNGQjg2QjYiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTExLjYzMjggMC41TDEyLjQxODYgMi45MTg0NEgxNC45NjE1TDEyLjkwNDMgNC40MTMxMkwxMy42OTAxIDYuODMxNTZMMTEuNjMyOCA1LjMzNjg4TDkuNTc1NTYgNi44MzE1NkwxMC4zNjE0IDQuNDEzMTJMOC4zMDQxMSAyLjkxODQ0SDEwLjg0N0wxMS42MzI4IDAuNVoiIGZpbGw9IiNGN0Y5QTgiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var lessonIconLearningPanel = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var courseIconLearningPanel = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZD0iTTIxLjQ5ODkgMTYuMTI1NUwxNS4zNDc3IDEyLjA5ODZMMTUuOTAyNSAxOS4zNTE3TDE3LjU3NTEgMTcuNTk5OEwxOS44MjYzIDIxLjQ5OThMMjAuNjExMSAyMS4wNDhMMjEuMzk1OCAyMC41ODgzTDE5LjE0NDYgMTYuNjg4M0wyMS40OTg5IDE2LjEyNTVaIiBzdHJva2U9IiM4NkQxRkIiIHN0cm9rZS13aWR0aD0iMC44NTM2NTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy45Mjk2IDE1Ljc4NEMxMy4zMDMzIDE1LjkxMDggMTIuNTgyIDE1Ljk4MjIgMTEuNzQ5NyAxNS45ODIyQzYuODk4NDggMTUuOTgyMiA1LjgxMjUgMTMuNDM3NyA1LjgxMjUgMTMuNDM3N1Y4LjQ4MzQiIHN0cm9rZT0iIzg2RDFGQiIgc3Ryb2tlLXdpZHRoPSIwLjg1MzY1NyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE3LjY4NzUgOC43NzczNFYxMS41NTE3IiBzdHJva2U9IiM4NkQxRkIiIHN0cm9rZS13aWR0aD0iMC44NTM2NTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01LjgxMjggOC40ODQxNEwyIDYuNjYwOTdMMTEuNzUgMkwyMS41IDYuNjYwOTdMMTEuNzUgMTEuMzIxOUw1LjgxMjggOC40ODQxNFoiIHN0cm9rZT0iIzg2RDFGQiIgc3Ryb2tlLXdpZHRoPSIwLjg1MzY1NyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMuNjk3MjcgNy40Njk3M1YxNC43MTQ4IiBzdHJva2U9IiM4NkQxRkIiIHN0cm9rZS13aWR0aD0iMC44NTM2NTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjQxOTkyIDE1Ljk4MzFDMi40MTk5MiAxNi42ODg2IDIuOTkwNjUgMTcuMjUxNCAzLjY4ODIxIDE3LjI1MTRDNC4zOTM3IDE3LjI1MTQgNC45NTY1MSAxNi42ODA3IDQuOTU2NTEgMTUuOTgzMUM0Ljk1NjUxIDE1LjI3NzYgNC4zODU3NyAxNC43MTQ4IDMuNjg4MjEgMTQuNzE0OEMyLjk5MDY1IDE0LjcxNDggMi40MTk5MiAxNS4yODU2IDIuNDE5OTIgMTUuOTgzMVoiIHN0cm9rZT0iIzg2RDFGQiIgc3Ryb2tlLXdpZHRoPSIwLjg1MzY1NyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var tournamentIconLearningPanel = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var assessmentIconLearningPanel = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var challengeIconLearningPanel = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC43Ij4KPHBhdGggZD0iTTE0LjMyMzggNC4xMDYyOUgxMy41NTMxVjQuMDYxMjdIMTQuMDcwOEgxNC4yNzY5TDE0LjMwOSA0LjA5MjFMMTQuMzIzOCA0LjEwNjI5WiIgZmlsbD0iIzg2RkJCQyIgc3Ryb2tlPSIjODZGQkJDIiBzdHJva2Utd2lkdGg9IjAuNyIvPgo8bWFzayBpZD0icGF0aC0yLWluc2lkZS0xXzMwODJfNzM3MjgiIGZpbGw9IndoaXRlIj4KPHBhdGggZD0iTTEyLjIwNzcgMi41SDExLjk2MDlWNS45NDY2NUgxMi4yMDc3VjIuNVoiLz4KPC9tYXNrPgo8cGF0aCBkPSJNMTEuOTYwOSAyLjVWMS44SDExLjI2MDlWMi41SDExLjk2MDlaTTEyLjIwNzcgMi41SDEyLjkwNzdWMS44SDEyLjIwNzdWMi41Wk0xMi4yMDc3IDUuOTQ2NjVWNi42NDY2NUgxMi45MDc3VjUuOTQ2NjVIMTIuMjA3N1pNMTEuOTYwOSA1Ljk0NjY1SDExLjI2MDlWNi42NDY2NUgxMS45NjA5VjUuOTQ2NjVaTTExLjk2MDkgMy4ySDEyLjIwNzdWMS44SDExLjk2MDlWMy4yWk0xMS41MDc3IDIuNVY1Ljk0NjY1SDEyLjkwNzdWMi41SDExLjUwNzdaTTEyLjIwNzcgNS4yNDY2NUgxMS45NjA5VjYuNjQ2NjVIMTIuMjA3N1Y1LjI0NjY1Wk0xMi42NjA5IDUuOTQ2NjVWMi41SDExLjI2MDlWNS45NDY2NUgxMi42NjA5WiIgZmlsbD0iIzg2RkJCQyIgbWFzaz0idXJsKCNwYXRoLTItaW5zaWRlLTFfMzA4Ml83MzcyOCkiLz4KPHBhdGggZD0iTTEyLjA4NTkgNS41ODM5OEwzLjI1OTgxIDIwLjg3MTJDMy4xNDQzNCAyMS4wNzEyIDMuMjg4NjggMjEuMzIxMiAzLjUxOTYyIDIxLjMyMTJIMjAuNjUyMUMyMC44ODMgMjEuMzIxMiAyMS4wMjczIDIxLjA3MTIgMjAuOTExOSAyMC44NzEyTDEyLjA4NTkgNS41ODM5OFoiIHN0cm9rZT0iIzg2RkJCQyIgc3Ryb2tlLXdpZHRoPSIwLjg1Ii8+CjxwYXRoIGQ9Ik0xMi4wODMgNS41ODM5OEw3LjU0Mjk3IDEzLjQ1MjZMMTAuNjU1NiAxMS43Njk2TDEyLjA4MyAxMy40NjE0TDEzLjE5MzMgMTEuNzY5NkwxNS40OTY0IDExLjQ5MTJMMTIuMDgzIDUuNTgzOThaIiBzdHJva2U9IiM4NkZCQkMiIHN0cm9rZS13aWR0aD0iMC44NSIvPgo8cGF0aCBkPSJNMTIuMDg0IDUuNTgzOThMMTMuMTk0MiAxMS43Njk2TDE1LjUyMDQgMTEuNTA1M0wxMi4wODQgNS41ODM5OFoiIHN0cm9rZT0iIzg2RkJCQyIgc3Ryb2tlLXdpZHRoPSIwLjg1Ii8+CjxwYXRoIGQ9Ik0xMi41NTcgMy40ODkyOVYyLjk1NTcxSDEzLjg0ODRWMy40ODkyOUgxMi41NTdaIiBmaWxsPSIjODZGQkJDIiBzdHJva2U9IiM4NkZCQkMiIHN0cm9rZS13aWR0aD0iMC43Ii8+CjxwYXRoIGQ9Ik0xMy40NDkzIDExLjUwNTFMMTUuMDAwMyAyMC45OTk4IiBzdHJva2U9IiM4NkZCQkMiIHN0cm9rZS13aWR0aD0iMC44NSIvPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var menu = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var primaryEmptyAssessment = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var primaryEmptyLesson = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var primaryEmptyCourse = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZD0iTTQ2LjI2ODQgMzMuOTU0MkwzMi4xNzE5IDI0LjcyNjFMMzMuNDQzNSA0MS4zNDc2TDM3LjI3NjQgMzcuMzMzTDQyLjQzNTUgNDYuMjcwNUw0NC4yMzM5IDQ1LjIzNTFMNDYuMDMyMiA0NC4xODE1TDQwLjg3MzIgMzUuMjQ0TDQ2LjI2ODQgMzMuOTU0MloiIHN0cm9rZT0iI0YxNzhBRSIgc3Ryb2tlLXdpZHRoPSIxLjk1NjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yOC45MjE5IDMzLjE3MTdDMjcuNDg2OCAzMy40NjI0IDI1LjgzMzggMzMuNjI1OCAyMy45MjY0IDMzLjYyNThDMTIuODA5IDMzLjYyNTggMTAuMzIwMyAyNy43OTQ3IDEwLjMyMDMgMjcuNzk0N1YxNi40NDEyIiBzdHJva2U9IiNGMTc4QUUiIHN0cm9rZS13aWR0aD0iMS45NTYzIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMzcuNTM1MiAxNy4xMTQ3VjIzLjQ3MjciIHN0cm9rZT0iI0YxNzhBRSIgc3Ryb2tlLXdpZHRoPSIxLjk1NjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMC4zMjE3IDE2LjQ0MjlMMS41ODM5OCAxMi4yNjQ4TDIzLjkyNzcgMS41ODMzN0w0Ni4yNzE0IDEyLjI2NDhMMjMuOTI3NyAyMi45NDYyTDEwLjMyMTcgMTYuNDQyOVoiIHN0cm9rZT0iI0YxNzhBRSIgc3Ryb2tlLXdpZHRoPSIxLjk1NjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik01LjQ2ODc1IDE0LjExODJWMzAuNzIxNiIgc3Ryb2tlPSIjRjE3OEFFIiBzdHJva2Utd2lkdGg9IjEuOTU2MyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuNTUwNzggMzMuNjI4MUMyLjU1MDc4IDM1LjI0NDggMy44NTg3MSAzNi41MzQ2IDUuNDU3MjggMzYuNTM0NkM3LjA3NDAyIDM2LjUzNDYgOC4zNjM3OCAzNS4yMjY2IDguMzYzNzggMzMuNjI4MUM4LjM2Mzc4IDMyLjAxMTMgNy4wNTU4NiAzMC43MjE2IDUuNDU3MjggMzAuNzIxNkMzLjg1ODcxIDMwLjcyMTYgMi41NTA3OCAzMi4wMjk1IDIuNTUwNzggMzMuNjI4MVoiIHN0cm9rZT0iI0YxNzhBRSIgc3Ryb2tlLXdpZHRoPSIxLjk1NjMiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var primaryEmptyChallenge = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOSAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjMyMzggMS42MDYyOUgxMC41NTMxVjEuNTYxMjdIMTEuMDcwOEgxMS4yNzY5TDExLjMwOSAxLjU5MjFMMTEuMzIzOCAxLjYwNjI5WiIgZmlsbD0iI0YxNzhBRSIgc3Ryb2tlPSIjRjE3OEFFIiBzdHJva2Utd2lkdGg9IjAuNyIvPgo8bWFzayBpZD0icGF0aC0yLWluc2lkZS0xXzMwMTBfODY1NDAiIGZpbGw9IndoaXRlIj4KPHBhdGggZD0iTTkuMjA3NjcgMEg4Ljk2MDk0VjMuNDQ2NjVIOS4yMDc2N1YwWiIvPgo8L21hc2s+CjxwYXRoIGQ9Ik04Ljk2MDk0IDBWLTAuN0g4LjI2MDk0VjBIOC45NjA5NFpNOS4yMDc2NyAwSDkuOTA3NjdWLTAuN0g5LjIwNzY3VjBaTTkuMjA3NjcgMy40NDY2NVY0LjE0NjY1SDkuOTA3NjdWMy40NDY2NUg5LjIwNzY3Wk04Ljk2MDk0IDMuNDQ2NjVIOC4yNjA5NFY0LjE0NjY1SDguOTYwOTRWMy40NDY2NVpNOC45NjA5NCAwLjdIOS4yMDc2N1YtMC43SDguOTYwOTRWMC43Wk04LjUwNzY3IDBWMy40NDY2NUg5LjkwNzY3VjBIOC41MDc2N1pNOS4yMDc2NyAyLjc0NjY1SDguOTYwOTRWNC4xNDY2NUg5LjIwNzY3VjIuNzQ2NjVaTTkuNjYwOTQgMy40NDY2NVYwSDguMjYwOTRWMy40NDY2NUg5LjY2MDk0WiIgZmlsbD0iI0YxNzhBRSIgbWFzaz0idXJsKCNwYXRoLTItaW5zaWRlLTFfMzAxMF84NjU0MCkiLz4KPHBhdGggZD0iTTE3LjU2NTUgMTguNDcxMkgwLjYwNjIxOEw5LjA4NTg3IDMuNzgzOTlMMTcuNTY1NSAxOC40NzEyWiIgc3Ryb2tlPSIjRjE3OEFFIiBzdHJva2Utd2lkdGg9IjAuNyIvPgo8cGF0aCBkPSJNNy45MjMxIDkuMDQzODlMNy43Mzk1MyA4LjgyNjMzTDcuNDg5MTMgOC45NjE3Mkw1LjQ2Mzk0IDEwLjA1NjdMOS4wODMyNyAzLjc4MzkzTDExLjkyODIgOC43MDczN0wxMC4xNTEzIDguOTIyMTJMOS45ODk4OCA4Ljk0MTYzTDkuOTAwNjcgOS4wNzc1Nkw5LjA0NzkxIDEwLjM3N0w3LjkyMzEgOS4wNDM4OVoiIHN0cm9rZT0iI0YxNzhBRSIgc3Ryb2tlLXdpZHRoPSIwLjciLz4KPHBhdGggZD0iTTEwLjQ4MDcgOC44ODQ3OEw5Ljc3OTk4IDQuOTgwNTJMMTEuOTQ5IDguNzE3OTNMMTAuNDgwNyA4Ljg4NDc4WiIgc3Ryb2tlPSIjRjE3OEFFIiBzdHJva2Utd2lkdGg9IjAuNyIvPgo8cGF0aCBkPSJNOS41NTcwMyAwLjk4OTI5M1YwLjQ1NTcxM0gxMC44NDg0VjAuOTg5MjkzSDkuNTU3MDNaIiBmaWxsPSIjRjE3OEFFIiBzdHJva2U9IiNGMTc4QUUiIHN0cm9rZS13aWR0aD0iMC43Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var primaryEmptyTournament = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAyOSAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZD0iTTI3LjI3MDQgMzMuOTU0NEwxMy4xNzM4IDI0LjcyNjJMMTQuNDQ1NCA0MS4zNDc4TDE4LjI3ODQgMzcuMzMzMkwyMy40Mzc1IDQ2LjI3MDhMMjUuMjM1OSA0NS4yMzUzTDI3LjAzNDMgNDQuMTgxN0wyMS44NzUyIDM1LjI0NDJMMjcuMjcwNCAzMy45NTQ0WiIgc3Ryb2tlPSIjRjE3OEFFIiBzdHJva2Utd2lkdGg9IjEuOTU2MzEiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05LjkyMzk4IDMzLjE3MjVDOC40ODg4OSAzMy40NjMyIDYuODM1ODEgMzMuNjI2NyA0LjkyODQgMzMuNjI2N0MtNi4xODkwMiAzMy42MjY3IC04LjY3NzczIDI3Ljc5NTUgLTguNjc3NzMgMjcuNzk1NVYxNi40NDE5IiBzdHJva2U9IiNGMTc4QUUiIHN0cm9rZS13aWR0aD0iMS45NTYzMSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE4LjUyOTMgMTcuMTE1MlYyMy40NzMyIiBzdHJva2U9IiNGMTc4QUUiIHN0cm9rZS13aWR0aD0iMS45NTYzMSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTS04LjY4MDI1IDE2LjQ0MzNMLTE3LjQxOCAxMi4yNjUyTDQuOTI1ODggMS41ODM3NEwyNy4yNjk3IDEyLjI2NTJMNC45MjU4OCAyMi45NDY2TC04LjY4MDI1IDE2LjQ0MzNaIiBzdHJva2U9IiNGMTc4QUUiIHN0cm9rZS13aWR0aD0iMS45NTYzMSIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var courseBannerIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzciIHZpZXdCb3g9IjAgMCAzNyAzNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZD0iTTM1LjYyNCAyNi4yMTk4TDI0Ljg1OTQgMTkuMTcyOUwyNS44MzA0IDMxLjg2NTdMMjguNzU3NCAyOC44TDMyLjY5NyAzNS42MjVMMzQuMDcwMyAzNC44MzQzTDM1LjQ0MzcgMzQuMDI5N0wzMS41MDQgMjcuMjA0N0wzNS42MjQgMjYuMjE5OFoiIHN0cm9rZT0iIzg2RDFGQiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjIuMzc2NyAyNS42MjE4QzIxLjI4MDkgMjUuODQzNyAyMC4wMTg1IDI1Ljk2ODYgMTguNTYyIDI1Ljk2ODZDMTAuMDcyMyAyNS45Njg2IDguMTcxODggMjEuNTE1NyA4LjE3MTg4IDIxLjUxNTdWMTIuODQ1NyIgc3Ryb2tlPSIjODZEMUZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yOC45NTMxIDEzLjM2MDRWMTguMjE1NSIgc3Ryb2tlPSIjODZEMUZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04LjE3MjQgMTIuODQ3MkwxLjUgOS42NTY3TDE4LjU2MjUgMS41TDM1LjYyNSA5LjY1NjdMMTguNTYyNSAxNy44MTM0TDguMTcyNCAxMi44NDcyWiIgc3Ryb2tlPSIjODZEMUZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00LjQ2ODc1IDExLjA3MjNWMjMuNzUxMiIgc3Ryb2tlPSIjODZEMUZCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjIzNDM4IDI1Ljk3MDVDMi4yMzQzOCAyNy4yMDUxIDMuMjMzMTUgMjguMTkgNC40NTM4OSAyOC4xOUM1LjY4ODQ5IDI4LjE5IDYuNjczNCAyNy4xOTEyIDYuNjczNCAyNS45NzA1QzYuNjczNCAyNC43MzU5IDUuNjc0NjIgMjMuNzUxIDQuNDUzODkgMjMuNzUxQzMuMjMzMTUgMjMuNzUxIDIuMjM0MzggMjQuNzQ5OCAyLjIzNDM4IDI1Ljk3MDVaIiBzdHJva2U9IiM4NkQxRkIiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var rate = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjMiIHZpZXdCb3g9IjAgMCAyNiAyMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjkwOTggNC41NjkwOUwxNC44NzI1IDEwLjU3MjJMMjEuNDk3MyAxMS41MzQ5TDE2LjcwMzUgMTYuMjA3NkwxNy44MzUyIDIyLjgwNTdMMTEuOTA5OCAxOS42OTA1TDUuOTg0MzYgMjIuODA1N0w3LjExNjA1IDE2LjIwNzZMMi4zMjIyNyAxMS41MzQ5TDguOTQ3MDYgMTAuNTcyMkwxMS45MDk4IDQuNTY5MDlaIiBmaWxsPSIjRjlDNDQxIi8+CjxwYXRoIGQ9Ik0yMi43MDY4IDAuMTk0MjE0TDIzLjIyNTEgMy4yMDU3NUwyNS45OTk3IDQuNDg2MUwyMy4yOTU3IDUuOTA5NThMMjIuOTM1NCA4Ljk0NDA3TDIwLjc0NiA2LjgxMjM0TDE3Ljc0ODggNy40MDc0TDE5LjA5OTYgNC42NjY0TDE3LjYwNzQgMS45OTk2OEwyMC42MzE3IDIuNDM3MzlMMjIuNzA2OCAwLjE5NDIxNFoiIGZpbGw9IiNGOUM0NDEiLz4KPHBhdGggZD0iTTEuOTM0NzYgMy4zMjIyN0wyLjk4NzEyIDQuNjExNjJMNC42NDU4NyA0LjQ3NTdMMy43NDQ3OSA1Ljg3NDk5TDQuMzg2NjcgNy40MTA1N0wyLjc3NzQxIDYuOTg1OTlMMS41MTUzNCA4LjA3MDk2TDEuNDIxODYgNi40MDkyOEwwIDUuNTQ0MjJMMS41NTE0OCA0Ljk0MTg0TDEuOTM0NzYgMy4zMjIyN1oiIGZpbGw9IiNGOUM0NDEiLz4KPHBhdGggZD0iTTIzLjU3MTcgMTYuMzgwN0wyMy44MzE2IDE4LjAyNDdMMjUuMzMzIDE4Ljc0MjZMMjMuODQ5OSAxOS40OTc3TDIzLjYzMTEgMjEuMTQ3NUwyMi40NTQ3IDE5Ljk3MDNMMjAuODE3OSAyMC4yNzJMMjEuNTc0IDE4Ljc4OTRMMjAuNzgxMiAxNy4zMjZMMjIuNDI1IDE3LjU4NjlMMjMuNTcxNyAxNi4zODA3WiIgZmlsbD0iI0Y5QzQ0MSIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var share = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var back = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjIwNzExIDEzLjIwNzFDNi44MTY1OCAxMy41OTc2IDYuMTgzNDIgMTMuNTk3NiA1Ljc5Mjg5IDEzLjIwNzFMMC4yOTI4OTQgNy43MDcxMUMtMC4wOTc2MzA5IDcuMzE2NTggLTAuMDk3NjMwOSA2LjY4MzQyIDAuMjkyODk0IDYuMjkyODlMNS43OTI4OSAwLjc5Mjg5M0M2LjE4MzQyIDAuNDAyMzY4IDYuODE2NTggMC40MDIzNjggNy4yMDcxMSAwLjc5Mjg5M0M3LjU5NzYzIDEuMTgzNDIgNy41OTc2MyAxLjgxNjU4IDcuMjA3MTEgMi4yMDcxMUwzLjQxNDIxIDZMMTUgNkMxNS41NTIzIDYgMTYgNi40NDc3MiAxNiA3QzE2IDcuNTUyMjggMTUuNTUyMyA4IDE1IDhMMy40MTQyMSA4TDcuMjA3MTEgMTEuNzkyOUM3LjU5NzYzIDEyLjE4MzQgNy41OTc2MyAxMi44MTY2IDcuMjA3MTEgMTMuMjA3MVoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var contentCoin = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var contentLine = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl80MzMwXzQ1MTA2KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzQzMzBfNDUxMDYiIHgxPSIzMC42NDQ2IiB5MT0iLTE0Ny40OTMiIHgyPSIxMTUuNDk2IiB5Mj0iLTc4LjU3ODUiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agb2Zmc2V0PSIwLjUxNTYyNSIgc3RvcC1jb2xvcj0iIzRENTE5RCIvPgo8c3RvcCBvZmZzZXQ9IjAuOTIxODc1IiBzdG9wLWNvbG9yPSIjMUUxQTQ2Ii8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var contentLineDone = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43NjU3IDAuODM0MjlDMTYuMDc4MSAxLjE0NjcxIDE2LjA3ODEgMS42NTMyNCAxNS43NjU3IDEuOTY1NjZMNi4wNDg1MyAxMS42ODI4QzUuNTc5OSAxMi4xNTE0IDQuODIwMSAxMi4xNTE0IDQuMzUxNDcgMTEuNjgyOEwwLjIzNDMxNSA3LjU2NTY2Qy0wLjA3ODEwNDkgNy4yNTMyNCAtMC4wNzgxMDQ5IDYuNzQ2NzEgMC4yMzQzMTUgNi40MzQyOUMwLjU0NjczNCA2LjEyMTg3IDEuMDUzMjcgNi4xMjE4NyAxLjM2NTY5IDYuNDM0MjlMNS4yIDEwLjI2ODZMMTQuNjM0MyAwLjgzNDI5QzE0Ljk0NjcgMC41MjE4NzEgMTUuNDUzMyAwLjUyMTg3MSAxNS43NjU3IDAuODM0MjlaIiBmaWxsPSIjMTA5Q0YxIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var exitIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjI5Mjg5MyAwLjI5Mjg5M0MwLjY4MzQxNyAtMC4wOTc2MzExIDEuMzE2NTggLTAuMDk3NjMxMSAxLjcwNzExIDAuMjkyODkzTDggNi41ODU3OUwxNC4yOTI5IDAuMjkyODkzQzE0LjY4MzQgLTAuMDk3NjMxMSAxNS4zMTY2IC0wLjA5NzYzMTEgMTUuNzA3MSAwLjI5Mjg5M0MxNi4wOTc2IDAuNjgzNDE3IDE2LjA5NzYgMS4zMTY1OCAxNS43MDcxIDEuNzA3MTFMOS40MTQyMSA4TDE1LjcwNzEgMTQuMjkyOUMxNi4wOTc2IDE0LjY4MzQgMTYuMDk3NiAxNS4zMTY2IDE1LjcwNzEgMTUuNzA3MUMxNS4zMTY2IDE2LjA5NzYgMTQuNjgzNCAxNi4wOTc2IDE0LjI5MjkgMTUuNzA3MUw4IDkuNDE0MjFMMS43MDcxMSAxNS43MDcxQzEuMzE2NTggMTYuMDk3NiAwLjY4MzQxNyAxNi4wOTc2IDAuMjkyODkzIDE1LjcwNzFDLTAuMDk3NjMxMSAxNS4zMTY2IC0wLjA5NzYzMTEgMTQuNjgzNCAwLjI5Mjg5MyAxNC4yOTI5TDYuNTg1NzkgOEwwLjI5Mjg5MyAxLjcwNzExQy0wLjA5NzYzMTEgMS4zMTY1OCAtMC4wOTc2MzExIDAuNjgzNDE3IDAuMjkyODkzIDAuMjkyODkzWiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC44Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var senderIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNSAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjUgMTIuNVY1SDEyLjVIMi41VjEyLjVWMjBIMTIuNSIgc3Ryb2tlPSIjOTU5MzlCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjIuNSAxNy41SDE1LjUiIHN0cm9rZT0iIzk1OTM5QiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIwIDE1TDIyLjUgMTcuNUwyMCAyMCIgc3Ryb2tlPSIjOTU5MzlCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMi41IDVMMTIuNSAxMi41TDIyLjUgNSIgc3Ryb2tlPSIjOTU5MzlCIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var searchIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi44IDYuMzk5OThDMTIuOCAyLjg2NTM3IDkuOTM0NTkgMCA2LjM5OTk4IDBDMi44NjUzNyAwIDAgMi44NjUzNyAwIDYuMzk5OThDMCA5LjkzNDU5IDIuODY1MzcgMTIuOCA2LjM5OTk4IDEyLjhDNy44Nzg5NSAxMi44IDkuMjQwNzYgMTIuMjk4MyAxMC4zMjQ1IDExLjQ1NThMMTQuNjM0MyAxNS43NjU2QzE0Ljk0NjcgMTYuMDc4MSAxNS40NTMzIDE2LjA3ODEgMTUuNzY1NyAxNS43NjU2QzE2LjA3ODEgMTUuNDUzMiAxNi4wNzgxIDE0Ljk0NjcgMTUuNzY1NyAxNC42MzQzTDExLjQ1NTkgMTAuMzI0NEMxMi4yOTgzIDkuMjQwNzEgMTIuOCA3Ljg3ODkzIDEyLjggNi4zOTk5OFpNMTEuMiA2LjM5OTk4QzExLjIgOS4wNTA5MyA5LjA1MDkzIDExLjIgNi4zOTk5OCAxMS4yQzMuNzQ5MDIgMTEuMiAxLjU5OTk5IDkuMDUwOTMgMS41OTk5OSA2LjM5OTk4QzEuNTk5OTkgMy43NDkwMiAzLjc0OTAyIDEuNTk5OTkgNi4zOTk5OCAxLjU5OTk5QzkuMDUwOTMgMS41OTk5OSAxMS4yIDMuNzQ5MDIgMTEuMiA2LjM5OTk4WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC44Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var teamCoins = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var defaultProfilePicture = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNzIiIHZpZXdCb3g9IjAgMCA3MiA3MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfMjMpIj4KPHJlY3Qgd2lkdGg9IjcyIiBoZWlnaHQ9IjcyIiByeD0iMzYiIGZpbGw9IiMxNDE2MjYiLz4KPHBhdGggZD0iTTQ1LjAwMzYgNDEuOTcyN0M0Mi4zNDk4IDQzLjc4ODMgMzkuMjA5MyA0NC43NTk4IDM1Ljk5MzkgNDQuNzU5OEMzMi43Nzg0IDQ0Ljc1OTggMjkuNjM4IDQzLjc4ODMgMjYuOTg0MiA0MS45NzI3QzE4LjQ0ODMgNDMuNzkxNCAxMiA1MS40MTMgMTIgNjAuNDcwN1Y2My45ODdDMTIgNjMuOTg3IDI1LjUxNDkgNzUuOTk3OSAzNS45OTM5IDc2QzQ2LjQ3NyA3Ni4wMDIxIDU5Ljk5OTcgNjMuOTg3IDU5Ljk5OTcgNjMuOTg3VjYwLjQ3MDdDNTkuOTkzNyA1MS40MTMgNTMuNTM5NCA0My43OTE0IDQ1LjAwMzYgNDEuOTcyN1oiIGZpbGw9IiM5NTkzOUIiLz4KPHBhdGggZD0iTTM1Ljk5NDIgNDEuNTYwN0M0My4wNTI2IDQxLjU2MDcgNDguNzc0NSAzNS44Mzg3IDQ4Ljc3NDUgMjguNzgwM0M0OC43NzQ1IDIxLjcyMTkgNDMuMDUyNiAxNiAzNS45OTQyIDE2QzI4LjkzNTggMTYgMjMuMjEzOSAyMS43MjE5IDIzLjIxMzkgMjguNzgwM0MyMy4yMTM5IDM1LjgzODcgMjguOTM1OCA0MS41NjA3IDM1Ljk5NDIgNDEuNTYwN1oiIGZpbGw9IiM5NTkzOUIiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xXzIzIj4KPHJlY3Qgd2lkdGg9IjcyIiBoZWlnaHQ9IjcyIiByeD0iMzYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var pinkPlus = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiByeD0iMTAiIGZpbGw9IiNGMTc4QUUiLz4KPHBhdGggZD0iTTE1LjU5OTYgOS4xOTk2MUgxMC43OTk2VjQuMzk5NjFDMTAuNzk5NiA0LjE4NzQ0IDEwLjcxNTMgMy45ODM5NSAxMC41NjUzIDMuODMzOTJDMTAuNDE1MyAzLjY4MzkgMTAuMjExOCAzLjU5OTYxIDkuOTk5NjEgMy41OTk2MUM5Ljc4NzQ0IDMuNTk5NjEgOS41ODM5NSAzLjY4MzkgOS40MzM5MiAzLjgzMzkyQzkuMjgzOSAzLjk4Mzk1IDkuMTk5NjEgNC4xODc0NCA5LjE5OTYxIDQuMzk5NjFWOS4xOTk2MUg0LjM5OTYxQzQuMTg3NDQgOS4xOTk2MSAzLjk4Mzk1IDkuMjgzOSAzLjgzMzkyIDkuNDMzOTJDMy42ODM5IDkuNTgzOTUgMy41OTk2MSA5Ljc4NzQ0IDMuNTk5NjEgOS45OTk2MUMzLjU5OTYxIDEwLjIxMTggMy42ODM5IDEwLjQxNTMgMy44MzM5MiAxMC41NjUzQzMuOTgzOTUgMTAuNzE1MyA0LjE4NzQ0IDEwLjc5OTYgNC4zOTk2MSAxMC43OTk2SDkuMTk5NjFWMTUuNTk5NkM5LjE5OTYxIDE1LjgxMTggOS4yODM5IDE2LjAxNTMgOS40MzM5MiAxNi4xNjUzQzkuNTgzOTUgMTYuMzE1MyA5Ljc4NzQ0IDE2LjM5OTYgOS45OTk2MSAxNi4zOTk2QzEwLjIxMTggMTYuMzk5NiAxMC40MTUzIDE2LjMxNTMgMTAuNTY1MyAxNi4xNjUzQzEwLjcxNTMgMTYuMDE1MyAxMC43OTk2IDE1LjgxMTggMTAuNzk5NiAxNS41OTk2VjEwLjc5OTZIMTUuNTk5NkMxNS44MTE4IDEwLjc5OTYgMTYuMDE1MyAxMC43MTUzIDE2LjE2NTMgMTAuNTY1M0MxNi4zMTUzIDEwLjQxNTMgMTYuMzk5NiAxMC4yMTE4IDE2LjM5OTYgOS45OTk2MUMxNi4zOTk2IDkuNzg3NDQgMTYuMzE1MyA5LjU4Mzk1IDE2LjE2NTMgOS40MzM5MkMxNi4wMTUzIDkuMjgzOSAxNS44MTE4IDkuMTk5NjEgMTUuNTk5NiA5LjE5OTYxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var camera = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var coffee = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var strongEmptyState = "blhPMTio.svg";

/* loaded by smart-asset */
var fairEmptyState = "UoDqnLxG.svg";

/* loaded by smart-asset */
var poorEmptyState = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var retakeChallenge = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var correct = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxNiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS42MjA4IDAuMzMzNjE2QzE2LjExMTYgMC43OTIxNyAxNi4xMjgxIDEuNTUxOCAxNS42NTc4IDIuMDMwMjlMNi4yMjE5MyAxMS42MzAzQzUuOTkyOTQgMTEuODYzMyA1LjY3NzM2IDExLjk5NjUgNS4zNDY0MiAxMS45OTk5QzUuMDE1NDggMTIuMDAzNCA0LjY5NzA3IDExLjg3NjcgNC40NjMwNSAxMS42NDg1TDAuMzYwNDg0IDcuNjQ4NTNDLTAuMTIwMTYxIDcuMTc5OSAtMC4xMjAxNjEgNi40MjAxIDAuMzYwNDg0IDUuOTUxNDdDMC44NDExMjkgNS40ODI4NCAxLjYyMDQxIDUuNDgyODQgMi4xMDEwNSA1Ljk1MTQ3TDUuMzE0NjIgOS4wODQ3TDEzLjg4MDYgMC4zNjk3MTVDMTQuMzUwOSAtMC4xMDg3NzYgMTUuMTMgLTAuMTI0OTM5IDE1LjYyMDggMC4zMzM2MTZaIiBmaWxsPSIjNERCQjQwIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var incorrect = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wLjI5Mjg5MyAwLjI5Mjg5M0MwLjY4MzQxNyAtMC4wOTc2MzExIDEuMzE2NTggLTAuMDk3NjMxMSAxLjcwNzExIDAuMjkyODkzTDggNi41ODU3OUwxNC4yOTI5IDAuMjkyODkzQzE0LjY4MzQgLTAuMDk3NjMxMSAxNS4zMTY2IC0wLjA5NzYzMTEgMTUuNzA3MSAwLjI5Mjg5M0MxNi4wOTc2IDAuNjgzNDE3IDE2LjA5NzYgMS4zMTY1OCAxNS43MDcxIDEuNzA3MTFMOS40MTQyMSA4TDE1LjcwNzEgMTQuMjkyOUMxNi4wOTc2IDE0LjY4MzQgMTYuMDk3NiAxNS4zMTY2IDE1LjcwNzEgMTUuNzA3MUMxNS4zMTY2IDE2LjA5NzYgMTQuNjgzNCAxNi4wOTc2IDE0LjI5MjkgMTUuNzA3MUw4IDkuNDE0MjFMMS43MDcxMSAxNS43MDcxQzEuMzE2NTggMTYuMDk3NiAwLjY4MzQxNyAxNi4wOTc2IDAuMjkyODkzIDE1LjcwNzFDLTAuMDk3NjMxMSAxNS4zMTY2IC0wLjA5NzYzMTEgMTQuNjgzNCAwLjI5Mjg5MyAxNC4yOTI5TDYuNTg1NzkgOEwwLjI5Mjg5MyAxLjcwNzExQy0wLjA5NzYzMTEgMS4zMTY1OCAtMC4wOTc2MzExIDAuNjgzNDE3IDAuMjkyODkzIDAuMjkyODkzWiIgZmlsbD0iI0Y4Nzg4RiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTAuMjkyODkzIDAuMjkyODkzQzAuNjgzNDE3IC0wLjA5NzYzMTEgMS4zMTY1OCAtMC4wOTc2MzExIDEuNzA3MTEgMC4yOTI4OTNMOCA2LjU4NTc5TDE0LjI5MjkgMC4yOTI4OTNDMTQuNjgzNCAtMC4wOTc2MzExIDE1LjMxNjYgLTAuMDk3NjMxMSAxNS43MDcxIDAuMjkyODkzQzE2LjA5NzYgMC42ODM0MTcgMTYuMDk3NiAxLjMxNjU4IDE1LjcwNzEgMS43MDcxMUw5LjQxNDIxIDhMMTUuNzA3MSAxNC4yOTI5QzE2LjA5NzYgMTQuNjgzNCAxNi4wOTc2IDE1LjMxNjYgMTUuNzA3MSAxNS43MDcxQzE1LjMxNjYgMTYuMDk3NiAxNC42ODM0IDE2LjA5NzYgMTQuMjkyOSAxNS43MDcxTDggOS40MTQyMUwxLjcwNzExIDE1LjcwNzFDMS4zMTY1OCAxNi4wOTc2IDAuNjgzNDE3IDE2LjA5NzYgMC4yOTI4OTMgMTUuNzA3MUMtMC4wOTc2MzExIDE1LjMxNjYgLTAuMDk3NjMxMSAxNC42ODM0IDAuMjkyODkzIDE0LjI5MjlMNi41ODU3OSA4TDAuMjkyODkzIDEuNzA3MTFDLTAuMDk3NjMxMSAxLjMxNjU4IC0wLjA5NzYzMTEgMC42ODM0MTcgMC4yOTI4OTMgMC4yOTI4OTNaIiBmaWxsPSIjQTAwOTA5IiBmaWxsLW9wYWNpdHk9IjAuNSIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var checkmarx = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var adminPanel = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE3LjAwMDkgMTYuNjE5OUMxNy42MTk0IDE2LjYxOTkgMTguMTIwOSAxNi4xMTg0IDE4LjEyMDkgMTUuNDk5OUMxOC4xMjA5IDE0Ljg4MTMgMTcuNjE5NCAxNC4zNzk5IDE3LjAwMDkgMTQuMzc5OUMxNi4zODIzIDE0LjM3OTkgMTUuODgwOSAxNC44ODEzIDE1Ljg4MDkgMTUuNDk5OUMxNS44ODA5IDE2LjExODQgMTYuMzgyMyAxNi42MTk5IDE3LjAwMDkgMTYuNjE5OVoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2Ljk5OTggMTcuNUMxNi4yNjk4IDE3LjUgMTQuODA5OCAxNy44NiAxNC43NTk4IDE4LjU4QzE1LjI1OTggMTkuMjkgMTYuMDc5OCAxOS43NSAxNi45OTk4IDE5Ljc1QzE3LjkxOTggMTkuNzUgMTguNzM5OCAxOS4yOSAxOS4yMzk4IDE4LjU4QzE5LjE4OTggMTcuODYgMTcuNzI5OCAxNy41IDE2Ljk5OTggMTcuNVoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE4IDExLjA5VjYuMjdMMTAuNSAzTDMgNi4yN1YxMS4xOEMzIDE1LjcyIDYuMiAxOS45NyAxMC41IDIxQzExLjA1IDIwLjg3IDExLjU4IDIwLjY4IDEyLjEgMjAuNDVDMTIuNjUxMSAyMS4yMzgxIDEzLjM4NDQgMjEuODgxNSAxNC4yMzc1IDIyLjMyNTVDMTUuMDkwNiAyMi43Njk0IDE2LjAzODMgMjMuMDAwOCAxNyAyM0MyMC4zMSAyMyAyMyAyMC4zMSAyMyAxN0MyMyAxNC4wMyAyMC44NCAxMS41NyAxOCAxMS4wOVpNMTEgMTdDMTEgMTcuNTYgMTEuMDggMTguMTEgMTEuMjMgMTguNjJDMTAuOTkgMTguNzMgMTAuNzUgMTguODQgMTAuNSAxOC45MkM3LjMzIDE3LjkyIDUgMTQuNjggNSAxMS4xOFY3LjU4TDEwLjUgNS4xOEwxNiA3LjU4VjExLjA5QzEzLjE2IDExLjU3IDExIDE0LjAzIDExIDE3Wk0xNyAyMUMxNC43OSAyMSAxMyAxOS4yMSAxMyAxN0MxMyAxNC43OSAxNC43OSAxMyAxNyAxM0MxOS4yMSAxMyAyMSAxNC43OSAyMSAxN0MyMSAxOS4yMSAxOS4yMSAyMSAxNyAyMVoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var courseBannerIconBig = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODIiIGhlaWdodD0iODMiIHZpZXdCb3g9IjAgMCA4MiA4MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC44Ij4KPHBhdGggZD0iTTczLjQ1NjEgNTkuMDExN0w1Mi40Mzk1IDQ1LjI1MzRMNTQuMzM1MyA3MC4wMzQ2TDYwLjA0OTkgNjQuMDQ5Mkw2Ny43NDE1IDc3LjM3NDJMNzAuNDIyOCA3NS44MzA1TDczLjEwNCA3NC4yNTk3TDY1LjQxMjQgNjAuOTM0N0w3My40NTYxIDU5LjAxMTdaIiBzdHJva2U9IiM4NkQxRkIiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTQ3LjU5MjcgNTcuODQ1NkM0NS40NTMxIDU4LjI3ODkgNDIuOTg4NSA1OC41MjI3IDQwLjE0NDggNTguNTIyN0MyMy41Njk4IDU4LjUyMjcgMTkuODU5NCA0OS44Mjg5IDE5Ljg1OTQgNDkuODI4OVYzMi45MDE5IiBzdHJva2U9IiM4NkQxRkIiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTYwLjQzMzYgMzMuOTA2MlY0My4zODU0IiBzdHJva2U9IiM4NkQxRkIiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE5Ljg2MSAzMi45MDQyTDYuODMzOTggMjYuNjc1TDQwLjE0NjUgMTAuNzVMNzMuNDU4OSAyNi42NzVMNDAuMTQ2NSA0Mi42TDE5Ljg2MSAzMi45MDQyWiIgc3Ryb2tlPSIjODZEMUZCIiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMi42MzM4IDI5LjQzOFY1NC4xOTIxIiBzdHJva2U9IiM4NkQxRkIiIHN0cm9rZS13aWR0aD0iNCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTguMjY4NTUgNTguNTI1N0M4LjI2ODU1IDYwLjkzNjEgMTAuMjE4NiA2Mi44NTkgMTIuNjAxOSA2Mi44NTlDMTUuMDEyMyA2Mi44NTkgMTYuOTM1MiA2MC45MDkgMTYuOTM1MiA1OC41MjU3QzE2LjkzNTIgNTYuMTE1MyAxNC45ODUyIDU0LjE5MjQgMTIuNjAxOSA1NC4xOTI0QzEwLjIxODYgNTQuMTkyNCA4LjI2ODU1IDU2LjE0MjQgOC4yNjg1NSA1OC41MjU3WiIgc3Ryb2tlPSIjODZEMUZCIiBzdHJva2Utd2lkdGg9IjQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var settings = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var openInNewTab = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy45IDIuNTAwMDVDMTQuMjMxNCAyLjUwMDA1IDE0LjUgMi43Njg2OCAxNC41IDMuMTAwMDVWNi40OTQxNUMxNC41IDYuODI1NTIgMTQuMjMxNCA3LjA5NDE1IDEzLjkgNy4wOTQxNUMxMy41Njg2IDcuMDk0MTUgMTMuMyA2LjgyNTUyIDEzLjMgNi40OTQxNVY0LjU0ODU3TDkuMjMzMTEgOC42MTU0NkM4Ljk5ODggOC44NDk3OCA4LjYxODkgOC44NDk3OCA4LjM4NDU5IDguNjE1NDZDOC4xNTAyNyA4LjM4MTE1IDguMTUwMjcgOC4wMDEyNSA4LjM4NDU5IDcuNzY2OTRMMTIuNDUxNSAzLjcwMDA1TDEwLjUwNTkgMy43MDAwNUMxMC4xNzQ1IDMuNzAwMDUgOS45MDU5IDMuNDMxNDIgOS45MDU5IDMuMTAwMDVDOS45MDU5IDIuNzY4NjggMTAuMTc0NSAyLjUwMDA1IDEwLjUwNTkgMi41MDAwNUwxMy45IDIuNTAwMDVaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPHBhdGggZD0iTTcuMjk5OTkgMi41SDQuMjk5OTlDMy4zMDU4OSAyLjUgMi41IDMuMzA1ODggMi41IDQuMjk5OTlWMTIuN0MyLjUgMTMuNjk0MSAzLjMwNTg4IDE0LjUgNC4yOTk5OSAxNC41SDEyLjdDMTMuNjk0MSAxNC41IDE0LjUgMTMuNjk0MSAxNC41IDEyLjdWOS42OTk5OEgxMy4zVjEyLjdDMTMuMyAxMy4wMzEzIDEzLjAzMTMgMTMuMyAxMi43IDEzLjNINC4yOTk5OUMzLjk2ODYyIDEzLjMgMy43IDEzLjAzMTMgMy43IDEyLjdWNC4yOTk5OUMzLjcgMy45Njg2MiAzLjk2ODYyIDMuNyA0LjI5OTk5IDMuN0g3LjI5OTk5VjIuNVoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var people = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjUgNUMxMy4yMzQ5IDUgMTMuOTM5NiA1LjMwNTE3IDE0LjQ1OTMgNS44NDgzOEMxNC45Nzg5IDYuMzkxNTkgMTUuMjcwOCA3LjEyODM0IDE1LjI3MDggNy44OTY1NUMxNS4yNzA4IDguNjY0NzcgMTQuOTc4OSA5LjQwMTUxIDE0LjQ1OTMgOS45NDQ3MkMxMy45Mzk2IDEwLjQ4NzkgMTMuMjM0OSAxMC43OTMxIDEyLjUgMTAuNzkzMUMxMS43NjUxIDEwLjc5MzEgMTEuMDYwNCAxMC40ODc5IDEwLjU0MDcgOS45NDQ3MkMxMC4wMjExIDkuNDAxNTEgOS43MjkxNyA4LjY2NDc3IDkuNzI5MTcgNy44OTY1NUM5LjcyOTE3IDcuMTI4MzQgMTAuMDIxMSA2LjM5MTU5IDEwLjU0MDcgNS44NDgzOEMxMS4wNjA0IDUuMzA1MTcgMTEuNzY1MSA1IDEyLjUgNVpNNi45NTgzMyA3LjA2ODk3QzcuNDAxNjcgNy4wNjg5NyA3LjgxMzMzIDcuMTkzMSA4LjE2OTU4IDcuNDE2NTVDOC4wNTA4MyA4LjYgOC4zODMzMyA5Ljc3NTE3IDkuMDY0MTcgMTAuNjkzOEM4LjY2ODMzIDExLjQ4ODMgNy44NzY2NyAxMi4wMzQ1IDYuOTU4MzMgMTIuMDM0NUM2LjMyODQ0IDEyLjAzNDUgNS43MjQzNSAxMS43NzI5IDUuMjc4OTUgMTEuMzA3M0M0LjgzMzU2IDEwLjg0MTcgNC41ODMzMyAxMC4yMTAyIDQuNTgzMzMgOS41NTE3MkM0LjU4MzMzIDguODkzMjYgNC44MzM1NiA4LjI2MTc2IDUuMjc4OTUgNy43OTYxNUM1LjcyNDM1IDcuMzMwNTQgNi4zMjg0NCA3LjA2ODk3IDYuOTU4MzMgNy4wNjg5N1pNMTguMDQxNyA3LjA2ODk3QzE4LjY3MTYgNy4wNjg5NyAxOS4yNzU2IDcuMzMwNTQgMTkuNzIxIDcuNzk2MTVDMjAuMTY2NCA4LjI2MTc2IDIwLjQxNjcgOC44OTMyNiAyMC40MTY3IDkuNTUxNzJDMjAuNDE2NyAxMC4yMTAyIDIwLjE2NjQgMTAuODQxNyAxOS43MjEgMTEuMzA3M0MxOS4yNzU2IDExLjc3MjkgMTguNjcxNiAxMi4wMzQ1IDE4LjA0MTcgMTIuMDM0NUMxNy4xMjMzIDEyLjAzNDUgMTYuMzMxNyAxMS40ODgzIDE1LjkzNTggMTAuNjkzOEMxNi42MjYxIDkuNzYyMjggMTYuOTQ2NCA4LjU4ODU4IDE2LjgzMDQgNy40MTY1NUMxNy4xODY3IDcuMTkzMSAxNy41OTgzIDcuMDY4OTcgMTguMDQxNyA3LjA2ODk3Wk03LjM1NDE3IDE1LjU1MTdDNy4zNTQxNyAxMy44Mzg2IDkuNjU3OTIgMTIuNDQ4MyAxMi41IDEyLjQ0ODNDMTUuMzQyMSAxMi40NDgzIDE3LjY0NTggMTMuODM4NiAxNy42NDU4IDE1LjU1MTdWMTdINy4zNTQxN1YxNS41NTE3Wk0zIDE3VjE1Ljc1ODZDMyAxNC42MDgzIDQuNDk2MjUgMTMuNjQgNi41MjI5MiAxMy4zNTg2QzYuMDU1ODMgMTMuOTIxNCA1Ljc3MDgzIDE0LjY5OTMgNS43NzA4MyAxNS41NTE3VjE3SDNaTTIyIDE3SDE5LjIyOTJWMTUuNTUxN0MxOS4yMjkyIDE0LjY5OTMgMTguOTQ0MiAxMy45MjE0IDE4LjQ3NzEgMTMuMzU4NkMyMC41MDM3IDEzLjY0IDIyIDE0LjYwODMgMjIgMTUuNzU4NlYxN1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var rounds = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjUgNi41QzYuOTggNi41IDIuNSA4Ljc0IDIuNSAxMS41QzIuNSAxMy43NCA1LjQ0IDE1LjYzIDkuNSAxNi4yN1YxOC4yOUM5LjUgMTguNzQgMTAuMDQgMTguOTYgMTAuMzUgMTguNjRMMTMuMTQgMTUuODVDMTMuMzQgMTUuNjUgMTMuMzQgMTUuMzQgMTMuMTQgMTUuMTRMMTAuMzUgMTIuMzVDMTAuMjc5NSAxMi4yODA5IDEwLjE5MDEgMTIuMjM0MiAxMC4wOTMxIDEyLjIxNThDOS45OTYxNiAxMi4xOTc0IDkuODk1ODkgMTIuMjA4MiA5LjgwNDk5IDEyLjI0NjdDOS43MTQxIDEyLjI4NTIgOS42MzY2MyAxMi4zNDk3IDkuNTgyMzUgMTIuNDMyMkM5LjUyODA3IDEyLjUxNDYgOS40OTk0MiAxMi42MTEzIDkuNSAxMi43MVYxNC4yM0M2LjM1IDEzLjY3IDQuNSAxMi4zMyA0LjUgMTEuNUM0LjUgMTAuNDQgNy41NCA4LjUgMTIuNSA4LjVDMTcuNDYgOC41IDIwLjUgMTAuNDQgMjAuNSAxMS41QzIwLjUgMTIuMTYgMTkuMyAxMy4xOCAxNy4xOCAxMy44NEMxNi43NyAxMy45NyAxNi41IDE0LjM1IDE2LjUgMTQuNzhDMTYuNSAxNS40NSAxNy4xNSAxNS45NCAxNy43OCAxNS43NEMyMC42MSAxNC44NiAyMi41IDEzLjI5IDIyLjUgMTEuNUMyMi41IDguNzQgMTguMDIgNi41IDEyLjUgNi41WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var tournamentIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjQ5OTIgMTEuMjg4NUwxMy40OTk0IDExLjI4ODVDMTMuNDk5MyAxMS4yODg1IDEzLjUyMzggMTEuMjczMyAxMy41Njg0IDExLjI0MjNDMTMuNjEyOCAxMS4yMTEzIDEzLjY3NzEgMTEuMTY0NSAxMy43NTY3IDExLjEwMTJDMTMuOTE2IDEwLjk3NDYgMTQuMTM2NiAxMC43ODIyIDE0LjM4MjUgMTAuNTE4MkwxNC40MTkxIDEwLjU1MjNMMTQuMzgyNSAxMC41MTgyTDE0LjQwMzMgMTAuNDk1OUwxNC40MTIxIDEwLjQ4NjRMMTQuNDI0NSAxMC40ODI0TDE0LjQ1MzkgMTAuNDcyOUMxNi42MjU5IDkuNzcxNDkgMTcuODczOSA4LjMzMjggMTcuOTI0NCA4LjI3Mzg0TDE3LjkyNDYgOC4yNzM1NUMxOS45Mjc0IDUuOTczMDcgMTkuOTUgMy4zODY1NSAxOS45NSAzLjI4MTQ3QzE5Ljk1IDMuMTgwNDMgMTkuODY4MSAzLjA5ODUyIDE5Ljc2NyAzLjA5ODUySDE2LjY3OTFIMTYuNjI2NEwxNi42MjkxIDMuMDQ1ODdMMTYuNjQxNCAyLjgxMzIxQzE2LjY0OSAyLjY3MDE1IDE2LjUzNTEgMi41NSAxNi4zOTE4IDIuNTVIOC42MDgxOUM4LjQ2NDk2IDIuNTUgOC4zNTEwMSAyLjY3MDEgOC4zNTg1MyAyLjgxMzE0TDguMzcwNzggMy4wNDU4OUw4LjM3MzU1IDMuMDk4NTJIOC4zMjA4NUg1LjIzMzA3QzUuMTMxOTYgMy4wOTg1MiA1LjA1IDMuMTgwNDggNS4wNSAzLjI4MTU5QzUuMDUgMy4zODY2NiA1LjA3MjY0IDUuOTczMjkgNy4wNzU5NCA4LjI3NDIzTDcuMDc2MjEgOC4yNzQ1NEM3LjEyNjE2IDguMzMyODcgOC4zNzY1NSA5Ljc3MjM4IDEwLjU0NjEgMTAuNDczQzEwLjU0NjEgMTAuNDczIDEwLjU0NjEgMTAuNDczIDEwLjU0NjEgMTAuNDczTDEwLjU3NTUgMTAuNDgyNUwxMC41ODc5IDEwLjQ4NjVMMTAuNTk2OCAxMC40OTZMMTAuNjE3NSAxMC41MTgzTDEzLjQ5OTIgMTEuMjg4NVpNMTMuNDk5MiAxMS4yODg1TDEzLjQ0NDUgMTEuMzIyMUwxMy40MjA2IDExLjMzNjhWMTEuMzY0N1YxMi45MzM2VjEyLjk0NDVMMTMuNDI1MiAxMi45NTQ1TDE0LjE1MDUgMTQuNTM1OUwxNC4xNjM4IDE0LjU2NUgxNC4xOTU5SDE2LjI2MDJDMTYuMzk4MyAxNC41NjUgMTYuNTEwMiAxNC42NzY5IDE2LjUxMDIgMTQuODE1VjE5LjE2ODRWMTkuMjE4NEgxNi41NjAySDE3LjgzOUMxNy45NzcxIDE5LjIxODQgMTguMDg5IDE5LjMzMDMgMTguMDg5IDE5LjQ2ODRWMjEuMkMxOC4wODkgMjEuMzM4MSAxNy45NzcgMjEuNDUgMTcuODM5IDIxLjQ1SDcuMTYwODZDNy4wMjI3OSAyMS40NSA2LjkxMDg2IDIxLjMzODEgNi45MTA4NiAyMS4yVjE5LjQ2ODRDNi45MTA4NiAxOS4zMzAzIDcuMDIyNzkgMTkuMjE4NCA3LjE2MDg2IDE5LjIxODRIOC40Mzk3OUg4LjQ4OTc5VjE5LjE2ODRWMTQuODE1MUM4LjQ4OTc5IDE0LjY3NzEgOC42MDE3MiAxNC41NjUxIDguNzM5NzkgMTQuNTY1MUgxMC44MDQzSDEwLjgzNjNMMTAuODQ5NyAxNC41MzZMMTEuNTc0OCAxMi45NTQ2TDExLjU3OTMgMTIuOTQ0NlYxMi45MzM3VjExLjM2NDhWMTEuMzM2N0wxMS41NTU0IDExLjMyMjFMMTEuNTAwNCAxMS4yODg1TDExLjUwMDEgMTEuMjg4NE0xMy40OTkyIDExLjI4ODVMMTEuNTAwMSAxMS4yODg0TTExLjUwMDEgMTEuMjg4NEwxMS41MDAxIDExLjI4ODRNMTEuNTAwMSAxMS4yODg0TDExLjUwMDEgMTEuMjg4NE03LjU1MDkxIDcuODk0NzVMNy41NTA4NSA3Ljg5NDY3QzYuMjA0OTMgNi4zNDg2NiA1LjgxNzg0IDQuNjQyMTggNS43MDY3OSAzLjc2MjY5TDcuNTUwOTEgNy44OTQ3NVpNNy41NTA5MSA3Ljg5NDc1QzcuNTU5MzggNy45MDQ0NCA4LjIxNzggOC42NTM1NSA5LjM1NTk5IDkuMjk4MTlMOS43MTQyNSA5LjUwMTI1TDkuODY3NDcgOS41ODgxTDkuNzgyNzMgOS40MzM3TDkuNTg4MTMgOS4wNzkxQzkuMDA0ODYgOC4wMTYyOCA4LjY1MDk2IDYuNzg5ODIgOC41MzcxNiA1LjQzMzE2TDguNDE3MTIgMy42MjUzNUw4LjQxNDAyIDMuNTc4NjdNNy41NTA5MSA3Ljg5NDc1TDguNDE0MDIgMy41Nzg2N004LjQxNDAyIDMuNTc4NjdIOC4zNjcyM004LjQxNDAyIDMuNTc4NjdIOC4zNjcyM004LjM2NzIzIDMuNTc4NjdINS44NjkwNEM1Ljc3MDU5IDMuNTc4NjcgNS42OTQ0NiAzLjY2NTAyIDUuNzA2NzkgMy43NjI2OUw4LjM2NzIzIDMuNTc4NjdaTTExLjUwMDEgMTEuMjg4NEMxMS40OTg2IDExLjI4NzQgMTEuNDAxMiAxMS4yMjY5IDExLjI0MzEgMTEuMTAxMk0xMS41MDAxIDExLjI4ODRMMTEuMjQzMSAxMS4xMDEyTTExLjI0MzEgMTEuMTAxMkMxMS4wODM5IDEwLjk3NDYgMTAuODYzNCAxMC43ODIxIDEwLjYxNzUgMTAuNTE4M0wxMS4yNDMxIDExLjEwMTJaTTE2LjYzMjggMy41Nzg0OEgxNi41ODZMMTYuNTgyOSAzLjYyNTE2TDE2LjQ2MjcgNS40MzQ0NEMxNi40NjI3IDUuNDM0NTkgMTYuNDYyNyA1LjQzNDczIDE2LjQ2MjYgNS40MzQ4N0MxNi4zNDkgNi43ODk0IDE1Ljk5NTMgOC4wMTU4MyAxNS40MTIxIDkuMDc4OTVMMTUuMjE3NiA5LjQzMzQ4TDE1LjEzMyA5LjU4Nzc2TDE1LjI4NjEgOS41MDEwM0wxNS42NDQyIDkuMjk4MTlDMTYuNzc0MSA4LjY1ODE2IDE3LjQyIDcuOTI3OTkgMTcuNDQ4OSA3Ljg5NDkzTDE3LjQ0OSA3Ljg5NDg3QzE4Ljc5NiA2LjM0Nzc4IDE5LjE4MjMgNC42NDE3NSAxOS4yOTI5IDMuNzYyNEMxOS4zMDUyIDMuNjY0NzYgMTkuMjI5MSAzLjU3ODQ4IDE5LjEzMDcgMy41Nzg0OEgxNi42MzI4Wk0xNy40OTg3IDE5LjgzNlYxOS43ODZIMTcuNDQ4N0g3LjU1MTI2SDcuNTAxMjZWMTkuODM2VjIwLjgzMjRWMjAuODgyNEg3LjU1MTI2SDE3LjQ0ODdIMTcuNDk4N1YyMC44MzI0VjE5LjgzNlpNMTUuODY5OSAxOS4yMTg0SDE1LjkxOTlWMTkuMTY4NFYxNS40ODI1QzE1LjkxOTkgMTUuMjg5MiAxNS43NjMyIDE1LjEzMjUgMTUuNTY5OSAxNS4xMzI1SDkuNDMwMThDOS4yMzY4OCAxNS4xMzI1IDkuMDgwMTggMTUuMjg5MiA5LjA4MDE4IDE1LjQ4MjVWMTkuMTY4NFYxOS4yMTg0SDkuMTMwMThIMTUuODY5OVpNMTIuOTIzMiAxMy4yNjY4TDEyLjkyMzIgMTMuMjY2OEMxMi44NjE4IDEzLjEzMjkgMTIuODMwMyAxMi45ODgzIDEyLjgzMDMgMTIuODQyVjExLjQwMjlDMTIuODMwMyAxMS4zMDYzIDEyLjg1MTUgMTEuMjEwNyAxMi44OTI0IDExLjEyMjRDMTIuOTMyNCAxMS4wMzYyIDEyLjk5MTQgMTAuOTU4NSAxMy4wNjQzIDEwLjg5NDZDMTMuNTQxOCAxMC42NTg3IDEzLjkzNTMgMTAuMzE5OCAxNC4yNTg3IDkuOTM3MDZMMTQuMjc3MSA5LjkzMTFMMTQuMjg2NiA5LjkxMzczTDE0LjMwMTkgOS44ODU3NkMxNC44NDM5IDkuMjI1MTkgMTUuMTg0IDguNDQxODkgMTUuMzg4NiA3LjgyNDk3QzE1LjQ5MTIgNy41MTU2NiAxNS41NTk5IDcuMjQ3NDkgMTUuNjAzMSA3LjA1NjVDMTUuNjI0NiA2Ljk2MSAxNS42Mzk4IDYuODg0NzUgMTUuNjQ5NiA2LjgzMjI3QzE1LjY1NDUgNi44MDYwMyAxNS42NTggNi43ODU3MyAxNS42NjA0IDYuNzcxOTJMMTUuNjYzIDYuNzU2MTZMMTUuNjYzNiA2Ljc1MjQyQzE1Ljc2NTcgNi4zMDQ5NCAxNS44MzU4IDUuODUxMTkgMTUuODczNiA1LjM5NDRMMTUuODczNiA1LjM5MzU5TDE1Ljk5MjUgMy42MDU0NkwxNS45OTI1IDMuNjA1NDRMMTYuMDAwMSAzLjQ5MDg1QzE2LjAxMzYgMy4yODg4MSAxNS44NTM0IDMuMTE3NSAxNS42NTA5IDMuMTE3NUg5LjM0ODY0QzkuMTQ2MjEgMy4xMTc1IDguOTg1OTkgMy4yODg3MSA4Ljk5OTQgMy40OTA3TDkuMTI1NjUgNS4zOTE0Nkw5LjEyNTY0IDUuMzkxNDZMOS4xMjU3MSA1LjM5MjI3QzkuMTYzNTIgNS44NDk3OSA5LjIzMzc4IDYuMzA0MjYgOS4zMzU5OCA2Ljc1MjQ2TDkuMzM2NTggNi43NTYyMUw5LjMzOTE5IDYuNzcxOThDOS4zNDE1NCA2Ljc4NTc5IDkuMzQ1MSA2LjgwNjExIDkuMzUgNi44MzIzN0M5LjM1OTgxIDYuODg0ODggOS4zNzUgNi45NjExNyA5LjM5NjYgNy4wNTY3M0M5LjQzOTc4IDcuMjQ3ODMgOS41MDg2MSA3LjUxNjE1IDkuNjExMzEgNy44MjU2MkM5LjgxNjEyIDguNDQyODMgMTAuMTU2NSA5LjIyNjQ0IDEwLjY5OSA5Ljg4NzA2TDEwLjcxMzcgOS45MTM5NkwxMC43MjMyIDkuOTMxMTlMMTAuNzQwOSA5LjkzNzA3QzExLjA2NDQgMTAuMzE5OSAxMS40NTc5IDEwLjY1ODkgMTEuOTM1NCAxMC44OTQ4QzEyLjAwNzEgMTAuOTU3NiAxMi4wNjQ4IDExLjAzMzggMTIuMTA0OSAxMS4xMTg3QzEyLjE0NTkgMTEuMjA1NCAxMi4xNjc3IDExLjI5OTQgMTIuMTY5IDExLjM5NDZMMTIuMTY5NCAxMS40Mjg5VjExLjQyOTJWMTIuODQyNUMxMi4xNjk0IDEyLjk4ODcgMTIuMTM3OCAxMy4xMzMzIDEyLjA3NjUgMTMuMjY3MUwxMS41MTk1IDE0LjQ4MThMMTEuNDg3IDE0LjU1MjdIMTEuNTY0OUgxMy40MzVIMTMuNTEzTDEzLjQ4MDUgMTQuNDgxOEwxMi45MjMyIDEzLjI2NjhaIiBmaWxsPSIjRjdGOUE4IiBzdHJva2U9IiNGN0Y5QTgiIHN0cm9rZS13aWR0aD0iMC4xIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var lessonTagline = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var tournamentResultsIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var tournamentBannerIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var clock = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNSA1LjMyMjQ2QzguOTQxODMgNS4zMjI0NiA5LjMgNS42ODA2MyA5LjMgNi4xMjI0NlY4LjE5MTA5TDExLjQ2NTcgMTAuMzU2OEMxMS43NzgxIDEwLjY2OTIgMTEuNzc4MSAxMS4xNzU3IDExLjQ2NTcgMTEuNDg4MUMxMS4xNTMzIDExLjgwMDYgMTAuNjQ2NyAxMS44MDA2IDEwLjMzNDMgMTEuNDg4MUw3LjkzNDMxIDkuMDg4MTVDNy43ODQyOSA4LjkzODEyIDcuNyA4LjczNDYzIDcuNyA4LjUyMjQ2VjYuMTIyNDZDNy43IDUuNjgwNjMgOC4wNTgxNyA1LjMyMjQ2IDguNSA1LjMyMjQ2WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjUgMTQuOTIyNUMxMi4wMzQ2IDE0LjkyMjUgMTQuOSAxMi4wNTcxIDE0LjkgOC41MjI0NkMxNC45IDQuOTg3ODQgMTIuMDM0NiAyLjEyMjQ2IDguNSAyLjEyMjQ2QzQuOTY1MzggMi4xMjI0NiAyLjEgNC45ODc4NCAyLjEgOC41MjI0NkMyLjEgMTIuMDU3MSA0Ljk2NTM4IDE0LjkyMjUgOC41IDE0LjkyMjVaTTguNSAxNi41MjI1QzEyLjkxODMgMTYuNTIyNSAxNi41IDEyLjk0MDcgMTYuNSA4LjUyMjQ2QzE2LjUgNC4xMDQxOCAxMi45MTgzIDAuNTIyNDYxIDguNSAwLjUyMjQ2MUM0LjA4MTcyIDAuNTIyNDYxIDAuNSA0LjEwNDE4IDAuNSA4LjUyMjQ2QzAuNSAxMi45NDA3IDQuMDgxNzIgMTYuNTIyNSA4LjUgMTYuNTIyNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var fullLeaderboard = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjYyNSAyLjg3NUg1LjkzNzVDNS42MjI4NCAyLjg3NTk0IDUuMzIxMzQgMy4wMDEzNSA1LjA5ODg1IDMuMjIzODVDNC44NzYzNSAzLjQ0NjM0IDQuNzUwOTQgMy43NDc4NCA0Ljc1IDQuMDYyNVYxMi4zNzVDNC43NTA5NCAxMi42ODk3IDQuODc2MzUgMTIuOTkxMiA1LjA5ODg1IDEzLjIxMzdDNS4zMjEzNCAxMy40MzYxIDUuNjIyODQgMTMuNTYxNiA1LjkzNzUgMTMuNTYyNUgxNi42MjVDMTYuOTM5NyAxMy41NjE2IDE3LjI0MTIgMTMuNDM2MSAxNy40NjM3IDEzLjIxMzdDMTcuNjg2MSAxMi45OTEyIDE3LjgxMTYgMTIuNjg5NyAxNy44MTI1IDEyLjM3NVY0LjA2MjVDMTcuODExNiAzLjc0Nzg0IDE3LjY4NjEgMy40NDYzNCAxNy40NjM3IDMuMjIzODVDMTcuMjQxMiAzLjAwMTM1IDE2LjkzOTcgMi44NzU5NCAxNi42MjUgMi44NzVaTTE2LjYyNSAxMi4zNzVINS45Mzc1VjQuMDYyNUgxNi42MjVWMTIuMzc1WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+CjxwYXRoIGQ9Ik0xMC42ODc1IDE1LjkzNzVIMi4zNzVWMTBIMy41NjI1VjguODEyNUgyLjM3NUMyLjA2MDM0IDguODEzNDQgMS43NTg4NCA4LjkzODg1IDEuNTM2MzUgOS4xNjEzNUMxLjMxMzg1IDkuMzgzODQgMS4xODg0NCA5LjY4NTM0IDEuMTg3NSAxMFYxNS45Mzc1QzEuMTg4NDQgMTYuMjUyMiAxLjMxMzg1IDE2LjU1MzcgMS41MzYzNSAxNi43NzYyQzEuNzU4ODQgMTYuOTk4NiAyLjA2MDM0IDE3LjEyNDEgMi4zNzUgMTcuMTI1SDEwLjY4NzVDMTEuMDAyMiAxNy4xMjQxIDExLjMwMzcgMTYuOTk4NiAxMS41MjYyIDE2Ljc3NjJDMTEuNzQ4NiAxNi41NTM3IDExLjg3NDEgMTYuMjUyMiAxMS44NzUgMTUuOTM3NVYxNC43NUgxMC42ODc1VjE1LjkzNzVaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var playNextLesson = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjg5NTcgNS4zMTk0OUMxMi4xMTY1IDYuMTA3MjUgMTIuMTE2NSA3Ljg5Mjc1IDEwLjg5NTcgOC42ODA1MUwzLjgzNDM5IDEzLjIzN0MyLjUwMzUzIDE0LjA5NTcgMC43NDk5OTkgMTMuMTQwMyAwLjc0OTk5OSAxMS41NTY1TDAuNzUgMi40NDM1NEMwLjc1IDAuODU5NjcyIDIuNTAzNTMgLTAuMDk1NzMyNyAzLjgzNDM5IDAuNzYzMDMyTDEwLjg5NTcgNS4zMTk0OVoiIGZpbGw9IiNGMTc4QUUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var primaryCourseClose = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjk5OTggMC4xNTI4MzJWMi4xNzI4M0MxNS4zODk4IDIuNzEyODMgMTguNDk5OCA2LjcwMjgzIDE3Ljk1OTggMTEuMDkyOEMxNy40OTk4IDE0LjczMjggMTQuNjM5OCAxNy42MjI4IDEwLjk5OTggMTguMDUyOFYyMC4wNTI4QzE2LjQ5OTggMTkuNTAyOCAyMC40OTk4IDE0LjYyMjggMTkuOTQ5OCA5LjEyMjgzQzE5LjQ5OTggNC4zNzI4MyAxNS43Mjk4IDAuNjIyODMyIDEwLjk5OTggMC4xNTI4MzJaTTguOTk5OCAwLjE4MjgzMkM3LjA0OTggMC4zNzI4MzIgNS4xODk4MSAxLjEyMjgzIDMuNjY5OCAyLjM4MjgzTDUuMDk5OCAzLjg2MjgzQzYuMjE5OCAyLjk2MjgzIDcuNTY5OCAyLjM4MjgzIDguOTk5OCAyLjE4MjgzVjAuMTgyODMyWk0yLjI1OTggMy43OTI4M0MxLjAwOTQ2IDUuMzEwMTggMC4yNDAwMDcgNy4xNjU5MiAwLjA0OTgwNDcgOS4xMjI4M0gyLjA0OThDMi4yMzk4IDcuNzAyODMgMi43OTk4IDYuMzUyODMgMy42ODk4IDUuMjIyODNMMi4yNTk4IDMuNzkyODNaTTEzLjQ5OTggNi42MjI4M0w4LjYxOTggMTEuNTAyOEw2LjQ5OTggOS4zODI4M0w1LjQzOTgxIDEwLjQ0MjhMOC42MTk4IDEzLjYyMjhMMTQuNTU5OCA3LjY4MjgzTDEzLjQ5OTggNi42MjI4M1pNMC4wNTk4MDQ3IDExLjEyMjhDMC4yNTk4MDUgMTMuMDgyOCAxLjAyOTggMTQuOTMyOCAyLjI2OTggMTYuNDUyOEwzLjY4OTggMTUuMDIyOEMyLjgwNjczIDEzLjg5MjQgMi4yNDM3NiAxMi41NDU0IDIuMDU5OCAxMS4xMjI4SDAuMDU5ODA0N1pNNS4wOTk4IDE2LjQ5MjhMMy42Njk4IDE3Ljg2MjhDNS4xODQ1OCAxOS4xMjU1IDcuMDM5MDcgMTkuOTExOSA4Ljk5OTggMjAuMTIyOFYxOC4xMjI4QzcuNTc3MjEgMTcuOTM4OSA2LjIzMDIxIDE3LjM3NTkgNS4wOTk4IDE2LjQ5MjhaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var cbLogo = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var calendar$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiB2aWV3Qm94PSIwIDAgMzEgMzYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy44MTI1IDIuNjI0ODRDNy44MTI1IDEuNjgxMzUgOC41NzczNSAwLjkxNjUwNCA5LjUyMDgzIDAuOTE2NTA0QzEwLjQ2NDMgMC45MTY1MDQgMTEuMjI5MiAxLjY4MTM1IDExLjIyOTIgMi42MjQ4NFY2LjA0MTVIMTkuNzcwOFYyLjYyNDg0QzE5Ljc3MDggMS42ODEzNSAyMC41MzU3IDAuOTE2NTA0IDIxLjQ3OTIgMC45MTY1MDRDMjIuNDIyNyAwLjkxNjUwNCAyMy4xODc1IDEuNjgxMzUgMjMuMTg3NSAyLjYyNDg0VjYuMDQxNUgyOS4xNjY3QzMwLjExMDIgNi4wNDE1IDMwLjg3NSA2LjgwNjM1IDMwLjg3NSA3Ljc0OTg0VjMzLjM3NDhDMzAuODc1IDM0LjMxODMgMzAuMTEwMiAzNS4wODMyIDI5LjE2NjcgMzUuMDgzMkgxLjgzMzMzQzAuODg5ODQ4IDM1LjA4MzIgMC4xMjUgMzQuMzE4MyAwLjEyNSAzMy4zNzQ4VjcuNzQ5ODRDMC4xMjUgNi44MDYzNSAwLjg4OTg0NyA2LjA0MTUgMS44MzMzMyA2LjA0MTVINy44MTI1VjIuNjI0ODRaTTE5Ljc3MDggOS40NTgxN1YxMS4xNjY1QzE5Ljc3MDggMTIuMTEgMjAuNTM1NyAxMi44NzQ4IDIxLjQ3OTIgMTIuODc0OEMyMi40MjI3IDEyLjg3NDggMjMuMTg3NSAxMi4xMSAyMy4xODc1IDExLjE2NjVWOS40NTgxN0gyNy40NTgzVjMxLjY2NjVIMy41NDE2N1Y5LjQ1ODE3SDcuODEyNVYxMS4xNjY1QzcuODEyNSAxMi4xMSA4LjU3NzM1IDEyLjg3NDggOS41MjA4MyAxMi44NzQ4QzEwLjQ2NDMgMTIuODc0OCAxMS4yMjkyIDEyLjExIDExLjIyOTIgMTEuMTY2NVY5LjQ1ODE3SDE5Ljc3MDhaIiBmaWxsPSJjdXJyZW50Q29sb3IiIC8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var leftLinedArrow = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE0IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjY0NjQ0IDMuNjQ2NDVDMC40NTExNzggMy44NDE3MSAwLjQ1MTE3OCA0LjE1ODI5IDAuNjQ2NDQgNC4zNTM1NUwzLjgyODQyIDcuNTM1NTRDNC4wMjM2OCA3LjczMDggNC4zNDAyNyA3LjczMDggNC41MzU1MyA3LjUzNTU0QzQuNzMwNzkgNy4zNDAyNyA0LjczMDc5IDcuMDIzNjkgNC41MzU1MyA2LjgyODQzTDEuNzA3MSA0TDQuNTM1NTMgMS4xNzE1N0M0LjczMDc5IDAuOTc2MzA5IDQuNzMwNzkgMC42NTk3MjYgNC41MzU1MyAwLjQ2NDQ2NEM0LjM0MDI3IDAuMjY5MjAyIDQuMDIzNjggMC4yNjkyMDIgMy44Mjg0MiAwLjQ2NDQ2NEwwLjY0NjQ0IDMuNjQ2NDVaTTE0IDMuNUwwLjk5OTk5MyAzLjVWNC41TDE0IDQuNVYzLjVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var rightLinedArrow = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDE0IDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMy4zNTM2IDMuNjQ2NDVDMTMuNTQ4OCAzLjg0MTcxIDEzLjU0ODggNC4xNTgyOSAxMy4zNTM2IDQuMzUzNTVMMTAuMTcxNiA3LjUzNTU0QzkuOTc2MzIgNy43MzA4IDkuNjU5NzMgNy43MzA4IDkuNDY0NDcgNy41MzU1NEM5LjI2OTIxIDcuMzQwMjcgOS4yNjkyMSA3LjAyMzY5IDkuNDY0NDcgNi44Mjg0M0wxMi4yOTI5IDRMOS40NjQ0NyAxLjE3MTU3QzkuMjY5MjEgMC45NzYzMDkgOS4yNjkyMSAwLjY1OTcyNiA5LjQ2NDQ3IDAuNDY0NDY0QzkuNjU5NzMgMC4yNjkyMDIgOS45NzYzMiAwLjI2OTIwMiAxMC4xNzE2IDAuNDY0NDY0TDEzLjM1MzYgMy42NDY0NVpNMCAzLjVMMTMgMy41VjQuNUwwIDQuNUwwIDMuNVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var tournamentSmallIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var popup = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjYyNSAyLjg3NUg1LjkzNzVDNS42MjI4NCAyLjg3NTk0IDUuMzIxMzQgMy4wMDEzNSA1LjA5ODg1IDMuMjIzODVDNC44NzYzNSAzLjQ0NjM0IDQuNzUwOTQgMy43NDc4NCA0Ljc1IDQuMDYyNVYxMi4zNzVDNC43NTA5NCAxMi42ODk3IDQuODc2MzUgMTIuOTkxMiA1LjA5ODg1IDEzLjIxMzdDNS4zMjEzNCAxMy40MzYxIDUuNjIyODQgMTMuNTYxNiA1LjkzNzUgMTMuNTYyNUgxNi42MjVDMTYuOTM5NyAxMy41NjE2IDE3LjI0MTIgMTMuNDM2MSAxNy40NjM3IDEzLjIxMzdDMTcuNjg2MSAxMi45OTEyIDE3LjgxMTYgMTIuNjg5NyAxNy44MTI1IDEyLjM3NVY0LjA2MjVDMTcuODExNiAzLjc0Nzg0IDE3LjY4NjEgMy40NDYzNCAxNy40NjM3IDMuMjIzODVDMTcuMjQxMiAzLjAwMTM1IDE2LjkzOTcgMi44NzU5NCAxNi42MjUgMi44NzVaTTE2LjYyNSAxMi4zNzVINS45Mzc1VjQuMDYyNUgxNi42MjVWMTIuMzc1WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+CjxwYXRoIGQ9Ik0xMC42ODc1IDE1LjkzNzVIMi4zNzVWMTBIMy41NjI1VjguODEyNUgyLjM3NUMyLjA2MDM0IDguODEzNDQgMS43NTg4NCA4LjkzODg1IDEuNTM2MzUgOS4xNjEzNUMxLjMxMzg1IDkuMzgzODQgMS4xODg0NCA5LjY4NTM0IDEuMTg3NSAxMFYxNS45Mzc1QzEuMTg4NDQgMTYuMjUyMiAxLjMxMzg1IDE2LjU1MzcgMS41MzYzNSAxNi43NzYyQzEuNzU4ODQgMTYuOTk4NiAyLjA2MDM0IDE3LjEyNDEgMi4zNzUgMTcuMTI1SDEwLjY4NzVDMTEuMDAyMiAxNy4xMjQxIDExLjMwMzcgMTYuOTk4NiAxMS41MjYyIDE2Ljc3NjJDMTEuNzQ4NiAxNi41NTM3IDExLjg3NDEgMTYuMjUyMiAxMS44NzUgMTUuOTM3NVYxNC43NUgxMC42ODc1VjE1LjkzNzVaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var userSelection = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var path$1 = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var info = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var videoLearningPanel = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var devCoinShadow = "UxLwHrBh.svg";

/* loaded by smart-asset */
var blueCheck = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43NjU3IDIuNDU4OTJDMTYuMDc4MSAyLjc3MTM0IDE2LjA3ODEgMy4yNzc4OCAxNS43NjU3IDMuNTkwMjlMNi4wNDg1MyAxMy4zMDc1QzUuNTc5OSAxMy43NzYxIDQuODIwMSAxMy43NzYxIDQuMzUxNDcgMTMuMzA3NUwwLjIzNDMxNSA5LjE5MDI5Qy0wLjA3ODEwNDkgOC44Nzc4OCAtMC4wNzgxMDQ5IDguMzcxMzQgMC4yMzQzMTUgOC4wNTg5MkMwLjU0NjczNCA3Ljc0NjUgMS4wNTMyNyA3Ljc0NjUgMS4zNjU2OSA4LjA1ODkyTDUuMiAxMS44OTMyTDE0LjYzNDMgMi40NTg5MkMxNC45NDY3IDIuMTQ2NSAxNS40NTMzIDIuMTQ2NSAxNS43NjU3IDIuNDU4OTJaIiBmaWxsPSIjMTA5Q0YxIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var skillTree = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var language = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAyMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02Ljc0MzcyIDAuMjUxMDUxQzcuMDg1NDMgMC41ODU3ODcgNy4wODU0MyAxLjEyODUgNi43NDM3MiAxLjQ2MzIzTDIuMTEyNDQgNkw2Ljc0MzcyIDEwLjUzNjhDNy4wODU0MyAxMC44NzE1IDcuMDg1NDMgMTEuNDE0MiA2Ljc0MzcyIDExLjc0ODlDNi40MDIwMSAxMi4wODM3IDUuODQ3OTkgMTIuMDgzNyA1LjUwNjI4IDExLjc0ODlMMC4yNTYyODIgNi42MDYwOUMtMC4wODU0MjY4IDYuMjcxMzYgLTAuMDg1NDI3NiA1LjcyODY0IDAuMjU2MjgxIDUuMzkzOTFMNS41MDYyOCAwLjI1MTA1MUM1Ljg0Nzk5IC0wLjA4MzY4MzggNi40MDIwMSAtMC4wODM2ODM4IDYuNzQzNzIgMC4yNTEwNTFaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE1LjI1NjMgMC4yNTEwNTFDMTQuOTE0NiAwLjU4NTc4NyAxNC45MTQ2IDEuMTI4NSAxNS4yNTYzIDEuNDYzMjNMMTkuODg3NiA2TDE1LjI1NjMgMTAuNTM2OEMxNC45MTQ2IDEwLjg3MTUgMTQuOTE0NiAxMS40MTQyIDE1LjI1NjMgMTEuNzQ4OUMxNS41OTggMTIuMDgzNyAxNi4xNTIgMTIuMDgzNyAxNi40OTM3IDExLjc0ODlMMjEuNzQzNyA2LjYwNjA5QzIyLjA4NTQgNi4yNzEzNiAyMi4wODU0IDUuNzI4NjQgMjEuNzQzNyA1LjM5MzkxTDE2LjQ5MzcgMC4yNTEwNTFDMTYuMTUyIC0wLjA4MzY4MzggMTUuNTk4IC0wLjA4MzY4MzggMTUuMjU2MyAwLjI1MTA1MVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var editLanguages = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjUyMTA4IDEwLjk2MzRDNC42MjgwMyAxMC45MzQzIDQuNzI1NTEgMTAuODc3NyA0LjgwMzg5IDEwLjc5OTNMMTEuNDQwMyA0LjE2MjkxQzEyLjE4NjYgMy40MTY2NiAxMi4xODY2IDIuMjA2NzQgMTEuNDQwMyAxLjQ2MDQ5TDEwLjUzOTUgMC41NTk2ODlDOS43OTMyNiAtMC4xODY1NjIgOC41ODMzNSAtMC4xODY1NjMgNy44MzcwOSAwLjU1OTY4N0wxLjIwMDY3IDcuMTk2MTFDMS4xMjIyOSA3LjI3NDQ5IDEuMDY1NzIgNy4zNzE5NyAxLjAzNjU1IDcuNDc4OTJMMC4wMjMxNDc2IDExLjE5NDdDLTAuMTA2NTMyIDExLjY3MDIgMC4zMjk3NzIgMTIuMTA2NSAwLjgwNTI2NiAxMS45NzY5TDQuNTIxMDggMTAuOTYzNFpNMS41NDU0OCAxMC40NTQ1TDIuMjIxMDkgNy45NzczMUw3LjM4Njc4IDIuODExNjFMOS4xODgzOSA0LjYxMzIyTDQuMDIyNyA5Ljc3ODkxTDEuNTQ1NDggMTAuNDU0NVpNMTAuNTM5NSAzLjI2MjFDMTAuNzg4MyAzLjAxMzM1IDEwLjc4ODMgMi42MTAwNSAxMC41Mzk1IDIuMzYxM0w5LjYzODcgMS40NjA0OUM5LjM4OTk1IDEuMjExNzQgOC45ODY2NSAxLjIxMTc0IDguNzM3OSAxLjQ2MDQ5TDguMjQyNTUgMS45NTU4NUwxMC4wNDQyIDMuNzU3NDVMMTAuNTM5NSAzLjI2MjFaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var pathThin = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var key = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjU3OTUyIDEzLjEzMTlDNi40MjA2NSAxNC45NzMgOS4yMjAzMiAxNS4yNzE0IDExLjM3MjEgMTQuMDI3TDExLjI4NDYgMTQuMTgwMUwxMy40MDU5IDE0Ljg4NzJMMTQuMTEzIDE3LjAwODVMMTYuMjM0NCAxNy43MTU3TDE2Ljk0MTQgMTkuODM3TDE5LjA2MjggMjAuNTQ0MUwyMC4yNDEzIDIwLjMwODRMMTMuNDA1OSAxMy40NzNMMTQuMTEzIDEyLjc2NTlMMjAuOTQ4NCAxOS42MDEzTDIxLjE4NDEgMTguNDIyOEwxMy44NDQzIDExLjA4M0MxNC41Njk3IDkuMDkxNjUgMTQuMTMzNiA2Ljc3MjY0IDEyLjUzNjIgNS4xNzUyM0MxMC4zMzkgMi45NzgwNSA2Ljc3NjcgMi45NzgwNSA0LjU3OTUyIDUuMTc1MjNDMi4zODIzNSA3LjM3MjQgMi4zODIzNSAxMC45MzQ3IDQuNTc5NTIgMTMuMTMxOVpNNS41MDA2OCA5LjAyODA3QzYuMzEwMjQgOS44Mzc2MyA3LjYyMjggOS44Mzc2MyA4LjQzMjM3IDkuMDI4MDdDOS4yNDE5MyA4LjIxODUgOS4yNDE5MyA2LjkwNTk0IDguNDMyMzcgNi4wOTYzOEM3LjYyMjgxIDUuMjg2ODEgNi4zMTAyNCA1LjI4NjgxIDUuNTAwNjggNi4wOTYzOEM0LjY5MTExIDYuOTA1OTQgNC42OTExMSA4LjIxODUgNS41MDA2OCA5LjAyODA3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var chevronDown = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjI3OTI1IDYuMzU5MzJDNC41Mzk2IDYuMDk4OTggNC45NjE3MSA2LjA5ODk4IDUuMjIyMDYgNi4zNTkzMkw4Ljc1MDY1IDkuODg3OTJMMTIuMjc5MiA2LjM1OTMyQzEyLjUzOTYgNi4wOTg5OCAxMi45NjE3IDYuMDk4OTggMTMuMjIyMSA2LjM1OTMyQzEzLjQ4MjQgNi42MTk2NyAxMy40ODI0IDcuMDQxNzggMTMuMjIyMSA3LjMwMjEzTDkuMjIyMDYgMTEuMzAyMUM4Ljk2MTcxIDExLjU2MjUgOC41Mzk2IDExLjU2MjUgOC4yNzkyNSAxMS4zMDIxTDQuMjc5MjUgNy4zMDIxM0M0LjAxODkgNy4wNDE3OCA0LjAxODkgNi42MTk2NyA0LjI3OTI1IDYuMzU5MzJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var chevronUp = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzI2MjNfNjQxMzQpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMi45NzIxIDEwLjQzMDFDMTIuNzExNyAxMC42OTA0IDEyLjI4OTYgMTAuNjkwNCAxMi4wMjkyIDEwLjQzMDFMOC41MDA2NSA2LjkwMTQ3TDQuOTcyMDYgMTAuNDMwMUM0LjcxMTcxIDEwLjY5MDQgNC4yODk2IDEwLjY5MDQgNC4wMjkyNSAxMC40MzAxQzMuNzY4OSAxMC4xNjk3IDMuNzY4OSA5Ljc0NzYgNC4wMjkyNSA5LjQ4NzI1TDguMDI5MjUgNS40ODcyNUM4LjI4OTYgNS4yMjY5MSA4LjcxMTcxIDUuMjI2OSA4Ljk3MjA2IDUuNDg3MjVMMTIuOTcyMSA5LjQ4NzI2QzEzLjIzMjQgOS43NDc2IDEzLjIzMjQgMTAuMTY5NyAxMi45NzIxIDEwLjQzMDFaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzI2MjNfNjQxMzQiPgo8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUgMC42MjUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var linkedInShare = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var linkedIn = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjY2NjcgMkg1LjMzMzMzQzMuNDkyNjcgMiAyIDMuNDkyNjcgMiA1LjMzMzMzVjE0LjY2NjdDMiAxNi41MDczIDMuNDkyNjcgMTggNS4zMzMzMyAxOEgxNC42NjY3QzE2LjUwOCAxOCAxOCAxNi41MDczIDE4IDE0LjY2NjdWNS4zMzMzM0MxOCAzLjQ5MjY3IDE2LjUwOCAyIDE0LjY2NjcgMlpNNy4zMzMzMyAxNC42NjY3SDUuMzMzMzNWNy4zMzMzM0g3LjMzMzMzVjE0LjY2NjdaTTYuMzMzMzMgNi40ODhDNS42ODkzMyA2LjQ4OCA1LjE2NjY3IDUuOTYxMzMgNS4xNjY2NyA1LjMxMkM1LjE2NjY3IDQuNjYyNjcgNS42ODkzMyA0LjEzNiA2LjMzMzMzIDQuMTM2QzYuOTc3MzMgNC4xMzYgNy41IDQuNjYyNjcgNy41IDUuMzEyQzcuNSA1Ljk2MTMzIDYuOTc4IDYuNDg4IDYuMzMzMzMgNi40ODhaTTE1LjMzMzMgMTQuNjY2N0gxMy4zMzMzVjEwLjkzMDdDMTMuMzMzMyA4LjY4NTMzIDEwLjY2NjcgOC44NTUzMyAxMC42NjY3IDEwLjkzMDdWMTQuNjY2N0g4LjY2NjY3VjcuMzMzMzNIMTAuNjY2N1Y4LjUxQzExLjU5NzMgNi43ODYgMTUuMzMzMyA2LjY1ODY3IDE1LjMzMzMgMTAuMTYwN1YxNC42NjY3WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGQ9Ik0xNS4zMzMzIDE0LjY2NjdIMTMuMzMzM1YxMC45MzA3QzEzLjMzMzMgOC42ODUzMyAxMC42NjY3IDguODU1MzMgMTAuNjY2NyAxMC45MzA3VjE0LjY2NjdIOC42NjY2N1Y3LjMzMzMzSDEwLjY2NjdWOC41MUMxMS41OTczIDYuNzg2IDE1LjMzMzMgNi42NTg2NyAxNS4zMzMzIDEwLjE2MDdWMTQuNjY2N1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik03LjMzMzMzIDE0LjY2NjdINS4zMzMzM1Y3LjMzMzMzSDcuMzMzMzNWMTQuNjY2N1oiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik02LjMzMzMzIDYuNDg4QzUuNjg5MzMgNi40ODggNS4xNjY2NyA1Ljk2MTMzIDUuMTY2NjcgNS4zMTJDNS4xNjY2NyA0LjY2MjY3IDUuNjg5MzMgNC4xMzYgNi4zMzMzMyA0LjEzNkM2Ljk3NzMzIDQuMTM2IDcuNSA0LjY2MjY3IDcuNSA1LjMxMkM3LjUgNS45NjEzMyA2Ljk3OCA2LjQ4OCA2LjMzMzMzIDYuNDg4WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var sso = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var support = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMSAyMEMxMSAxOC44OTU0IDExLjg5NTQgMTggMTMgMThDMTMuOTAxOCAxOCAxNC42NjQzIDE4LjU5NjkgMTQuOTEzOCAxOS40MTcyQzE2LjI0MDYgMTkuMjk3OCAxNy41MTUzIDE5LjA0MiAxOC41NTUyIDE4LjYwMkMxOS4xNjg4IDE4LjM0MjQgMTkuNjg0NyAxOC4wMjc1IDIwLjA4MjEgMTcuNjQ3OEwxOS4yMjcxIDE3Ljc0NTVDMTguMDQwMyAxNy44ODExIDE3IDE2Ljk1MjkgMTcgMTUuNzU4NFYxMi4yNDE2QzE3IDExLjA0NzEgMTguMDQwMyAxMC4xMTg5IDE5LjIyNzEgMTAuMjU0NkwxOS44NjEyIDEwLjMyNzFDMTkuMTY1OSA2LjU1NjAyIDE1LjkzNzYgNCAxMiA0QzguMDYyMzcgNCA0LjgzNDExIDYuNTU2MDIgNC4xMzg3NyAxMC4zMjcxTDQuNzcyODYgMTAuMjU0NkM1Ljk1OTY4IDEwLjExODkgNyAxMS4wNDcxIDcgMTIuMjQxNlYxNS43NTg0QzcgMTYuOTUyOSA1Ljk1OTcxIDE3Ljg4MTEgNC43NzI5MSAxNy43NDU1TDMuNzczMTkgMTcuNjMxMkMyLjc2Mjk0IDE3LjUxNTggMi4wMDAxMiAxNi42NjA3IDIuMDAwMjggMTUuNjQzOEwyIDExLjg2OTZDMiA2LjA5NTc4IDYuNTEyNjMgMiAxMiAyQzE3LjQ4NzQgMiAyMiA2LjA5NTc4IDIyIDExLjg2OTZMMjEuOTk5NyAxNS41NTI0QzIxLjk5ODIgMTUuNjgxNyAyMS45OTEzIDE1LjgwNzkgMjEuOTc5MiAxNS45MzExQzIxLjgwNDMgMTcuNzA5NyAyMC41NDUzIDE4Ljg0NTggMTguOTQ0OCAxOS41MjNDMTcuNzcyOSAyMC4wMTg4IDE2LjM3MjkgMjAuMjkzMyAxNC45NTY0IDIwLjQxNzRDMTQuNzY0NCAyMS4zMjE2IDEzLjk2MTQgMjIgMTMgMjJDMTEuODk1NCAyMiAxMSAyMS4xMDQ2IDExIDIwWk0xOSAxMi4yNDE2TDE5Ljk5OTIgMTIuMzU1OUwxOS45OTk3IDE1LjY0NDJMMTkgMTUuNzU4NFYxMi4yNDE2Wk01IDEyLjI0MTZMNC4wMDA4IDEyLjM1NTlMNC4wMDAyOCAxNS42NDQyTDUgMTUuNzU4NEw1IDEyLjI0MTZaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var quest = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var google = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var github = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var upDownExpand = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var close = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkNsb3NlIj4KPHBhdGggaWQ9IlZlY3RvciAxNTUgKFN0cm9rZSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS44MzU4OCAxLjgzNDQxQzIuMTQ4MyAxLjUyMTk5IDIuNjU0ODMgMS41MjE5OSAyLjk2NzI1IDEuODM0NDFMOC4wMDE1NiA2Ljg2ODczTDEzLjAzNTkgMS44MzQ0MUMxMy4zNDgzIDEuNTIxOTkgMTMuODU0OCAxLjUyMTk5IDE0LjE2NzIgMS44MzQ0MUMxNC40Nzk3IDIuMTQ2ODMgMTQuNDc5NyAyLjY1MzM2IDE0LjE2NzIgMi45NjU3OEw5LjEzMjkzIDguMDAwMUwxNC4xNjcyIDEzLjAzNDRDMTQuNDc5NyAxMy4zNDY4IDE0LjQ3OTcgMTMuODUzNCAxNC4xNjcyIDE0LjE2NThDMTMuODU0OCAxNC40NzgyIDEzLjM0ODMgMTQuNDc4MiAxMy4wMzU5IDE0LjE2NThMOC4wMDE1NiA5LjEzMTQ3TDIuOTY3MjUgMTQuMTY1OEMyLjY1NDgzIDE0LjQ3ODIgMi4xNDgzIDE0LjQ3ODIgMS44MzU4OCAxNC4xNjU4QzEuNTIzNDYgMTMuODUzNCAxLjUyMzQ2IDEzLjM0NjggMS44MzU4OCAxMy4wMzQ0TDYuODcwMTkgOC4wMDAxTDEuODM1ODggMi45NjU3OEMxLjUyMzQ2IDIuNjUzMzYgMS41MjM0NiAyLjE0NjgzIDEuODM1ODggMS44MzQ0MVoiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var progress = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTExLjQ0MjIgMC4wMTQ4OTI2VjIuMDM0ODlDMTUuODMyMiAyLjU3NDg5IDE4Ljk0MjIgNi41NjQ4OSAxOC40MDIyIDEwLjk1NDlDMTcuOTQyMiAxNC41OTQ5IDE1LjA4MjIgMTcuNDg0OSAxMS40NDIyIDE3LjkxNDlWMTkuOTE0OUMxNi45NDIyIDE5LjM2NDkgMjAuOTQyMiAxNC40ODQ5IDIwLjM5MjIgOC45ODQ4OUMxOS45NDIyIDQuMjM0ODkgMTYuMTcyMiAwLjQ4NDg5MyAxMS40NDIyIDAuMDE0ODkyNlpNOS40NDIxOSAwLjA0NDg5MjVDNy40OTIxOSAwLjIzNDg5MyA1LjYzMjE5IDAuOTg0ODkzIDQuMTEyMTkgMi4yNDQ4OUw1LjU0MjE5IDMuNzI0ODlDNi42NjIxOSAyLjgyNDg5IDguMDEyMTkgMi4yNDQ4OSA5LjQ0MjE5IDIuMDQ0ODlWMC4wNDQ4OTI1Wk0yLjcwMjE5IDMuNjU0ODlDMS40NTE4NCA1LjE3MjI0IDAuNjgyMzg5IDcuMDI3OTggMC40OTIxODggOC45ODQ4OUgyLjQ5MjE5QzIuNjgyMTkgNy41NjQ4OSAzLjI0MjE5IDYuMjE0ODkgNC4xMzIxOSA1LjA4NDg5TDIuNzAyMTkgMy42NTQ4OVpNMTMuOTQyMiA2LjQ4NDg5TDkuMDYyMTkgMTEuMzY0OUw2Ljk0MjE5IDkuMjQ0ODlMNS44ODIxOSAxMC4zMDQ5TDkuMDYyMTkgMTMuNDg0OUwxNS4wMDIyIDcuNTQ0ODlMMTMuOTQyMiA2LjQ4NDg5Wk0wLjUwMjE4NyAxMC45ODQ5QzAuNzAyMTg3IDEyLjk0NDkgMS40NzIxOSAxNC43OTQ5IDIuNzEyMTkgMTYuMzE0OUw0LjEzMjE5IDE0Ljg4NDlDMy4yNDkxMiAxMy43NTQ1IDIuNjg2MTQgMTIuNDA3NSAyLjUwMjE5IDEwLjk4NDlIMC41MDIxODdaTTUuNTQyMTkgMTYuMzU0OUw0LjExMjE5IDE3LjcyNDlDNS42MjY5NyAxOC45ODc2IDcuNDgxNDYgMTkuNzczOSA5LjQ0MjE5IDE5Ljk4NDlWMTcuOTg0OUM4LjAxOTU5IDE3LjgwMDkgNi42NzI1OSAxNy4yMzggNS41NDIxOSAxNi4zNTQ5WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var unExpandIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var assignedContentIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var careerJourneyIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var monthlyVideosIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var recentlyAddedIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var otherAreTakingIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var leaderboardRank = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var timeWhite = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjYwMTYgNy4zMjI3MUMxMS4wNDM0IDcuMzIyNzEgMTEuNDAxNiA3LjY4MDg4IDExLjQwMTYgOC4xMjI3VjEwLjE5MTNMMTMuNTY3MiAxMi4zNTdDMTMuODc5NyAxMi42Njk0IDEzLjg3OTcgMTMuMTc2IDEzLjU2NzIgMTMuNDg4NEMxMy4yNTQ4IDEzLjgwMDggMTIuNzQ4MyAxMy44MDA4IDEyLjQzNTkgMTMuNDg4NEwxMC4wMzU5IDExLjA4ODRDOS44ODU4NSAxMC45Mzg0IDkuODAxNTYgMTAuNzM0OSA5LjgwMTU2IDEwLjUyMjdWOC4xMjI3QzkuODAxNTYgNy42ODA4OCAxMC4xNTk3IDcuMzIyNzEgMTAuNjAxNiA3LjMyMjcxWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC42MDE2IDE2LjkyMjdDMTQuMTM2MiAxNi45MjI3IDE3LjAwMTYgMTQuMDU3MyAxNy4wMDE2IDEwLjUyMjdDMTcuMDAxNiA2Ljk4ODA4IDE0LjEzNjIgNC4xMjI3MSAxMC42MDE2IDQuMTIyNzFDNy4wNjY5NCA0LjEyMjcxIDQuMjAxNTYgNi45ODgwOCA0LjIwMTU2IDEwLjUyMjdDNC4yMDE1NiAxNC4wNTczIDcuMDY2OTQgMTYuOTIyNyAxMC42MDE2IDE2LjkyMjdaTTEwLjYwMTYgMTguNTIyN0MxNS4wMTk4IDE4LjUyMjcgMTguNjAxNiAxNC45NDEgMTguNjAxNiAxMC41MjI3QzE4LjYwMTYgNi4xMDQ0MyAxNS4wMTk4IDIuNTIyNzEgMTAuNjAxNiAyLjUyMjcxQzYuMTgzMjggMi41MjI3MSAyLjYwMTU2IDYuMTA0NDMgMi42MDE1NiAxMC41MjI3QzIuNjAxNTYgMTQuOTQxIDYuMTgzMjggMTguNTIyNyAxMC42MDE2IDE4LjUyMjdaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var resume = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjYuMDE3ODEiIGN5PSI3LjA1NzQ2IiByPSI1LjM3NTYzIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjAuNyIgLz4KICAgIDxwYXRoCiAgICAgICAgZD0iTTguNTAzMjYgMTEuNTAzNkM5LjQ5OTY4IDEwLjkzMjEgMTAuMjc3OSAxMC4wNDU3IDEwLjcxNTUgOC45ODM2MkMxMS4xNTMxIDcuOTIxNTcgMTEuMjI1MyA2Ljc0NDE5IDEwLjkyMDcgNS42MzY2NUMxMC42MTYgNC41MjkxIDkuOTUxOTUgMy41NTQyMiA5LjAzMjc5IDIuODY1MzFDOC4xMTM2MyAyLjE3NjQxIDYuOTkxNTYgMS44MTI1NiA1Ljg0MzAzIDEuODMwOTkiCiAgICAgICAgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIC8+Cjwvc3ZnPgogICAg";

/* loaded by smart-asset */
var lessonBannerIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var chevronRight = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC4yOTI4OTMgMC4yOTI4OTNDMC42ODM0MTcgLTAuMDk3NjMxMSAxLjMxNjU4IC0wLjA5NzYzMTEgMS43MDcxMSAwLjI5Mjg5M0w4LjcwNzExIDcuMjkyODlDOC44OTQ2NCA3LjQ4MDQzIDkgNy43MzQ3OCA5IDhDOSA4LjI2NTIyIDguODk0NjQgOC41MTk1NyA4LjcwNzExIDguNzA3MTFMMS43MDcxMSAxNS43MDcxQzEuMzE2NTggMTYuMDk3NiAwLjY4MzQxNyAxNi4wOTc2IDAuMjkyODkzIDE1LjcwNzFDLTAuMDk3NjMxMSAxNS4zMTY2IC0wLjA5NzYzMTEgMTQuNjgzNCAwLjI5Mjg5MyAxNC4yOTI5TDYuNTg1NzkgOEwwLjI5Mjg5MyAxLjcwNzExQy0wLjA5NzYzMTEgMS4zMTY1OCAtMC4wOTc2MzExIDAuNjgzNDE3IDAuMjkyODkzIDAuMjkyODkzWiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var chevronLeft = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDkgMTYiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC43MDcxMSAwLjI5Mjg5M0M4LjMxNjU4IC0wLjA5NzYzMTEgNy42ODM0MiAtMC4wOTc2MzExIDcuMjkyODkgMC4yOTI4OTNMMC4yOTI4OTMgNy4yOTI4OUMwLjEwNTM1NyA3LjQ4MDQzIDAgNy43MzQ3OCAwIDhDMCA4LjI2NTIyIDAuMTA1MzU3IDguNTE5NTcgMC4yOTI4OTMgOC43MDcxMUw3LjI5Mjg5IDE1LjcwNzFDNy42ODM0MiAxNi4wOTc2IDguMzE2NTggMTYuMDk3NiA4LjcwNzExIDE1LjcwNzFDOS4wOTc2MyAxNS4zMTY2IDkuMDk3NjMgMTQuNjgzNCA4LjcwNzExIDE0LjI5MjlMMi40MTQyMSA4TDguNzA3MTEgMS43MDcxMUM5LjA5NzYzIDEuMzE2NTggOS4wOTc2MyAwLjY4MzQxNyA4LjcwNzExIDAuMjkyODkzWiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var arrowLeftPagination = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkFycm93LWxlZnQiPgo8cGF0aCBpZD0iVmVjdG9yIDQ1IChTdHJva2UpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuMzY2MDggMTMuNDY1OUM3LjA1MzY2IDEzLjc3ODMgNi41NDcxMiAxMy43NzgzIDYuMjM0NyAxMy40NjU5TDEuODM0NzEgOS4wNjU4OEMxLjUyMjI5IDguNzUzNDYgMS41MjIyOSA4LjI0NjkzIDEuODM0NzEgNy45MzQ1MUw2LjIzNDcxIDMuNTM0NTFDNi41NDcxMyAzLjIyMjA5IDcuMDUzNjYgMy4yMjIwOSA3LjM2NjA4IDMuNTM0NTFDNy42Nzg1IDMuODQ2OTMgNy42Nzg1IDQuMzUzNDYgNy4zNjYwOCA0LjY2NTg4TDQuMzMxNzYgNy43MDAxOUwxMy42MDA0IDcuNzAwMkMxNC4wNDIyIDcuNzAwMiAxNC40MDA0IDguMDU4MzcgMTQuNDAwNCA4LjUwMDJDMTQuNDAwNCA4Ljk0MjAyIDE0LjA0MjIgOS4zMDAyIDEzLjYwMDQgOS4zMDAyTDQuMzMxNzYgOS4zMDAxOUw3LjM2NjA4IDEyLjMzNDVDNy42Nzg1IDEyLjY0NjkgNy42Nzg1IDEzLjE1MzUgNy4zNjYwOCAxMy40NjU5WiIgZmlsbD0iIzYyNjI2MiIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var arrowRightPagination = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkFycm93LWxlZnQiPgo8cGF0aCBpZD0iVmVjdG9yIDQ1IChTdHJva2UpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguNjMzOTIgMy41MzQxMkM4Ljk0NjM0IDMuMjIxNyA5LjQ1Mjg4IDMuMjIxNyA5Ljc2NTI5IDMuNTM0MTJMMTQuMTY1MyA3LjkzNDEyQzE0LjQ3NzcgOC4yNDY1NCAxNC40Nzc3IDguNzUzMDcgMTQuMTY1MyA5LjA2NTQ5TDkuNzY1MjkgMTMuNDY1NUM5LjQ1Mjg3IDEzLjc3NzkgOC45NDYzNCAxMy43Nzc5IDguNjMzOTIgMTMuNDY1NUM4LjMyMTUgMTMuMTUzMSA4LjMyMTUgMTIuNjQ2NSA4LjYzMzkyIDEyLjMzNDFMMTEuNjY4MiA5LjI5OTgxTDIuMzk5NjEgOS4yOTk4QzEuOTU3NzggOS4yOTk4IDEuNTk5NjEgOC45NDE2MyAxLjU5OTYxIDguNDk5OEMxLjU5OTYxIDguMDU3OTggMS45NTc3OCA3LjY5OTggMi4zOTk2MSA3LjY5OThMMTEuNjY4MiA3LjY5OTgxTDguNjMzOTIgNC42NjU0OUM4LjMyMTUgNC4zNTMwNyA4LjMyMTUgMy44NDY1NCA4LjYzMzkyIDMuNTM0MTJaIiBmaWxsPSIjNjI2MjYyIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var plusIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlBsdXMiPgo8cGF0aCBpZD0iVmVjdG9yIiBkPSJNMTMuNTk5NiA3LjE5OTYxSDguNzk5NjFWMi4zOTk2MUM4Ljc5OTYxIDIuMTg3NDQgOC43MTUzMiAxLjk4Mzk1IDguNTY1MjkgMS44MzM5MkM4LjQxNTI3IDEuNjgzOSA4LjIxMTc4IDEuNTk5NjEgNy45OTk2MSAxLjU5OTYxQzcuNzg3NDQgMS41OTk2MSA3LjU4Mzk1IDEuNjgzOSA3LjQzMzkyIDEuODMzOTJDNy4yODM5IDEuOTgzOTUgNy4xOTk2MSAyLjE4NzQ0IDcuMTk5NjEgMi4zOTk2MVY3LjE5OTYxSDIuMzk5NjFDMi4xODc0NCA3LjE5OTYxIDEuOTgzOTUgNy4yODM5IDEuODMzOTIgNy40MzM5MkMxLjY4MzkgNy41ODM5NSAxLjU5OTYxIDcuNzg3NDQgMS41OTk2MSA3Ljk5OTYxQzEuNTk5NjEgOC4yMTE3OCAxLjY4MzkgOC40MTUyNyAxLjgzMzkyIDguNTY1MjlDMS45ODM5NSA4LjcxNTMyIDIuMTg3NDQgOC43OTk2MSAyLjM5OTYxIDguNzk5NjFINy4xOTk2MVYxMy41OTk2QzcuMTk5NjEgMTMuODExOCA3LjI4MzkgMTQuMDE1MyA3LjQzMzkyIDE0LjE2NTNDNy41ODM5NSAxNC4zMTUzIDcuNzg3NDQgMTQuMzk5NiA3Ljk5OTYxIDE0LjM5OTZDOC4yMTE3OCAxNC4zOTk2IDguNDE1MjcgMTQuMzE1MyA4LjU2NTI5IDE0LjE2NTNDOC43MTUzMiAxNC4wMTUzIDguNzk5NjEgMTMuODExOCA4Ljc5OTYxIDEzLjU5OTZWOC43OTk2MUgxMy41OTk2QzEzLjgxMTggOC43OTk2MSAxNC4wMTUzIDguNzE1MzIgMTQuMTY1MyA4LjU2NTI5QzE0LjMxNTMgOC40MTUyNyAxNC4zOTk2IDguMjExNzggMTQuMzk5NiA3Ljk5OTYxQzE0LjM5OTYgNy43ODc0NCAxNC4zMTUzIDcuNTgzOTUgMTQuMTY1MyA3LjQzMzkyQzE0LjAxNTMgNy4yODM5IDEzLjgxMTggNy4xOTk2MSAxMy41OTk2IDcuMTk5NjFaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var chevronRightWhite = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljg4NDcgMTYuMDg5NEM3LjU1OTI3IDE1Ljc2NCA3LjU1OTI3IDE1LjIzNjMgNy44ODQ3IDE0LjkxMDlMMTIuMjk1NCAxMC41MDAyTDcuODg0NyA2LjA4OTQyQzcuNTU5MjcgNS43NjM5OCA3LjU1OTI3IDUuMjM2MzQgNy44ODQ3IDQuOTEwOTFDOC4yMTAxNCA0LjU4NTQ3IDguNzM3NzggNC41ODU0NyA5LjA2MzIxIDQuOTEwOTFMMTQuMDYzMiA5LjkxMDkxQzE0LjM4ODcgMTAuMjM2MyAxNC4zODg3IDEwLjc2NCAxNC4wNjMyIDExLjA4OTRMOS4wNjMyMSAxNi4wODk0QzguNzM3NzggMTYuNDE0OSA4LjIxMDE0IDE2LjQxNDkgNy44ODQ3IDE2LjA4OTRaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var usersIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjI1MDggNy4xMTg2MkMxMC44NzggNi43NTU0MSAxMS4zIDYuMDc2OTkgMTEuMyA1LjNDMTEuMyA0LjUyMzEgMTAuODc4MSAzLjg0NDc0IDEwLjI1MSAzLjQ4MTVDOS45MzQ5OCAyLjg4MzA5IDkuNDY3OSAyLjM3Njc5IDguOTAwNSAyLjAxMzQxQzguOTk5MTQgMi4wMDQ1MyA5LjA5OTA0IDIgOS4yIDJDMTEuMDIyNSAyIDEyLjUgMy40Nzc0NiAxMi41IDUuM0MxMi41IDYuMzQ4MjMgMTIuMDExMyA3LjI4MjMyIDExLjI0OTIgNy44ODY4QzEyLjg3NTIgOC43MDM2IDE0IDEwLjQ2MjIgMTQgMTIuNVYxMy40QzE0IDEzLjczMTQgMTMuNzQ3MiAxNCAxMy40MzUzIDE0QzEzLjEyMzQgMTQgMTIuODcwNiAxMy43MzE0IDEyLjg3MDYgMTMuNFYxMi41QzEyLjg3MDYgMTEuMTQ5NyAxMi4yMjQ3IDkuOTU5NzMgMTEuMjQzNCA5LjI1OTdDMTAuODYwNyA4LjY3NTg3IDEwLjM3NjkgOC4xNzAyMyA5LjgxNjkxIDcuNzcxNTdDOS45ODIzIDcuNTY5ODcgMTAuMTI3OSA3LjM1MTIyIDEwLjI1MDggNy4xMTg2MloiIGZpbGw9IiM2MjYyNjIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljg0OTIyIDcuODg2OEM5LjYxMTI2IDcuMjgyMzIgMTAuMSA2LjM0ODIzIDEwLjEgNS4zQzEwLjEgMy40Nzc0NiA4LjYyMjU0IDIgNi44IDJDNC45Nzc0NiAyIDMuNSAzLjQ3NzQ2IDMuNSA1LjNDMy41IDYuMzQ4MjMgMy45ODg3NCA3LjI4MjMyIDQuNzUwNzggNy44ODY4QzMuMTI0ODMgOC43MDM2IDIgMTAuNDYyMiAyIDEyLjVWMTMuNEMyIDEzLjczMTQgMi4yNTI4MyAxNCAyLjU2NDcxIDE0QzIuODc2NTggMTQgMy4xMjk0MSAxMy43MzE0IDMuMTI5NDEgMTMuNFYxMi41QzMuMTI5NDEgMTAuMzQ2MSA0Ljc3Mjc5IDguNiA2LjggOC42QzguODI3MjEgOC42IDEwLjQ3MDYgMTAuMzQ2MSAxMC40NzA2IDEyLjVWMTMuNEMxMC40NzA2IDEzLjczMTQgMTAuNzIzNCAxNCAxMS4wMzUzIDE0QzExLjM0NzIgMTQgMTEuNiAxMy43MzE0IDExLjYgMTMuNFYxMi41QzExLjYgMTAuNDYyMiAxMC40NzUyIDguNzAzNiA4Ljg0OTIyIDcuODg2OFpNNi44IDcuNEM3Ljk1OTggNy40IDguOSA2LjQ1OTggOC45IDUuM0M4LjkgNC4xNDAyIDcuOTU5OCAzLjIgNi44IDMuMkM1LjY0MDIgMy4yIDQuNyA0LjE0MDIgNC43IDUuM0M0LjcgNi40NTk4IDUuNjQwMiA3LjQgNi44IDcuNFoiIGZpbGw9IiM2MjYyNjIiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var grayInfoIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjMzMzMzIDguNTUyNzNDMy4zMzMzMyAxMS4xMzAxIDUuNDIyNjcgMTMuMjE5NCA4IDEzLjIxOTRDMTAuNTc3MyAxMy4yMTk0IDEyLjY2NjcgMTEuMTMwMSAxMi42NjY3IDguNTUyNzNDMTIuNjY2NyA1Ljk3NTQxIDEwLjU3NzMgMy44ODYwNyA4IDMuODg2MDdDNS40MjI2NyAzLjg4NjA3IDMuMzMzMzMgNS45NzU0MSAzLjMzMzMzIDguNTUyNzNaTTggMi41NTI3M0M0LjY4NjI5IDIuNTUyNzMgMiA1LjIzOTAzIDIgOC41NTI3M0MyIDExLjg2NjQgNC42ODYyOSAxNC41NTI3IDggMTQuNTUyN0MxMS4zMTM3IDE0LjU1MjcgMTQgMTEuODY2NCAxNCA4LjU1MjczQzE0IDUuMjM5MDMgMTEuMzEzNyAyLjU1MjczIDggMi41NTI3M1oiIGZpbGw9IiM2MjYyNjIiIGZpbGwtb3BhY2l0eT0iMC41Ii8+CjxwYXRoIGQ9Ik04LjAwMDM1IDExLjg4MTNDNy42MTEyNyAxMS44ODEzIDcuMjk5MTggMTEuNTU5NyA3LjMxMDg3IDExLjE3MDhMNy4zOTY1NyA4LjMyMDY4QzcuNDA2MzYgNy45OTQ4OCA3LjY3MzMgNy43MzU4NSA3Ljk5OTI1IDcuNzM1ODVDOC4zMjUwMiA3LjczNTg1IDguNTkxODggNy45OTQ2MSA4LjYwMTkyIDguMzIwMjJMOC42ODk4MSAxMS4xNzAyQzguNzAxODEgMTEuNTU5MyA4LjM4OTY0IDExLjg4MTMgOC4wMDAzNSAxMS44ODEzWk03Ljk5OTAyIDUuMjUyNzNDOC4yMDk5NiA1LjI1MjczIDguMzkxMDcgNS4zMjczMSA4LjU0MjM1IDUuNDc2NDZDOC42OTM2MyA1LjYyNTYgOC43NjgyIDUuODA2NzEgOC43NjYwNyA2LjAxOTc4QzguNzY4MiA2LjIyODU5IDguNjkzNjMgNi40MDc1NiA4LjU0MjM1IDYuNTU2NzFDOC4zOTEwNyA2LjcwNTg2IDguMjA5OTYgNi43ODA0MyA3Ljk5OTAyIDYuNzgwNDNDNy43OTQ0OCA2Ljc4MDQzIDcuNjE2NTcgNi43MDU4NiA3LjQ2NTI5IDYuNTU2NzFDNy4zMTE4OCA2LjQwNzU2IDcuMjM0MTEgNi4yMjg1OSA3LjIzMTk4IDYuMDE5NzhDNy4yMzQxMSA1LjgwNjcxIDcuMzExODggNS42MjU2IDcuNDY1MjkgNS40NzY0NkM3LjYxNjU3IDUuMzI3MzEgNy43OTQ0OCA1LjI1MjczIDcuOTk5MDIgNS4yNTI3M1oiIGZpbGw9IiM2MjYyNjIiIGZpbGwtb3BhY2l0eT0iMC41Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var customCourse = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var grayClose = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImNsb3NlMiI+CjxwYXRoIGlkPSJVbmlvbiIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy44Mzk4IDE5LjI5MjdDMTguMjMwMyAxOS42ODMzIDE4Ljg2MzUgMTkuNjgzMyAxOS4yNTQgMTkuMjkyN0wxOS4yOTQzIDE5LjI1MjRDMTkuNjg0OCAxOC44NjE5IDE5LjY4NDggMTguMjI4NyAxOS4yOTQzIDE3LjgzODJMMTMuNDU1MiAxMS45OTkxTDE5LjI5MjcgNi4xNjE2MUMxOS42ODMyIDUuNzcxMDggMTkuNjgzMiA1LjEzNzkyIDE5LjI5MjcgNC43NDczOUwxOS4yNTI0IDQuNzA3MDZDMTguODYxOCA0LjMxNjU0IDE4LjIyODcgNC4zMTY1NCAxNy44MzgyIDQuNzA3MDZMMTIuMDAwNyAxMC41NDQ1TDYuMTYzMTEgNC43MDY5NkM1Ljc3MjU4IDQuMzE2NDMgNS4xMzk0MiA0LjMxNjQzIDQuNzQ4OSA0LjcwNjk2TDQuNzA4NTcgNC43NDcyOUM0LjMxODA0IDUuMTM3ODEgNC4zMTgwNCA1Ljc3MDk4IDQuNzA4NTcgNi4xNjE1TDEwLjU0NjEgMTEuOTk5MUw0LjcwNjk2IDE3LjgzODNDNC4zMTY0MyAxOC4yMjg4IDQuMzE2NDMgMTguODYyIDQuNzA2OTYgMTkuMjUyNUw0Ljc0NzI4IDE5LjI5MjhDNS4xMzc4MSAxOS42ODM0IDUuNzcwOTcgMTkuNjgzNCA2LjE2MTUgMTkuMjkyOEwxMi4wMDA3IDEzLjQ1MzZMMTcuODM5OCAxOS4yOTI3WiIgZmlsbD0iI0JEQkVDNiIvPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var filter$2 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIuNSA1LjNDMi41IDQuODU4MTcgMi44NTgxNyA0LjUgMy4zIDQuNUgxNy43QzE4LjE0MTggNC41IDE4LjUgNC44NTgxNyAxOC41IDUuM0MxOC41IDUuNzQxODMgMTguMTQxOCA2LjEgMTcuNyA2LjFIMy4zQzIuODU4MTcgNi4xIDIuNSA1Ljc0MTgzIDIuNSA1LjNaTTQuOSAxMC41QzQuOSAxMC4wNTgyIDUuMjU4MTcgOS43IDUuNyA5LjdIMTUuM0MxNS43NDE4IDkuNyAxNi4xIDEwLjA1ODIgMTYuMSAxMC41QzE2LjEgMTAuOTQxOCAxNS43NDE4IDExLjMgMTUuMyAxMS4zSDUuN0M1LjI1ODE3IDExLjMgNC45IDEwLjk0MTggNC45IDEwLjVaTTcuMyAxNS43QzcuMyAxNS4yNTgyIDcuNjU4MTcgMTQuOSA4LjEgMTQuOUgxMi45QzEzLjM0MTggMTQuOSAxMy43IDE1LjI1ODIgMTMuNyAxNS43QzEzLjcgMTYuMTQxOCAxMy4zNDE4IDE2LjUgMTIuOSAxNi41SDguMUM3LjY1ODE3IDE2LjUgNy4zIDE2LjE0MTggNy4zIDE1LjdaIiAvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var buttonIconCourse = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var buttonIconLesson = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Imxlc3NvbiBpY29uIj4KPGcgaWQ9Ikdyb3VwIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTEyLjI1ODUgMTUuMjE0MkgxMS45MjJDMTEuNjEyNCAxNS4yMTQyIDExLjMzNjUgMTUuNDA5MyAxMS4yNDIzIDE1LjcwNTRMMTEuMjA4NiAxNS43OTk2QzExLjEwNzcgMTYuMDk1NyAxMC44Mzg1IDE2LjI5MDkgMTAuNTI5IDE2LjI5MDlIOS40MDUxMkM5LjA5NTU2IDE2LjI5MDkgOC44MTk2NSAxNi4wOTU3IDguNzI1NDMgMTUuNzk5Nkw4LjY5MTc5IDE1LjcwNTRDOC41OTA4NCAxNS40MDkzIDguMzIxNjYgMTUuMjE0MiA4LjAxMjEgMTUuMjE0MkgyLjM5OTY0QzIuMTk3NzUgMTUuMjE0MiAyLjA0Mjk3IDE1LjA1MjYgMi4wNDI5NyAxNC44NTc1VjIuOTE5OTJINy45NzEzTDkuODk5NjQgMy45MTk5MiIgc3Ryb2tlPSIjNzE2NTk2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBpZD0iVmVjdG9yXzIiIGQ9Ik0xMC4wMTk1IDMuOTIwNzJMMTEuOTQ3OSAyLjkxNjAyTDE3Ljg3NjIgMi45MjA3MlYxMi4zMzQ3IiBzdHJva2U9IiM3MTY1OTYiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGlkPSJWZWN0b3JfMyIgZD0iTTkuOTY0ODQgNS42Njk5MlYxNC4zMDQiIHN0cm9rZT0iIzcxNjU5NiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl80IiBkPSJNNC41IDYuNTc0MjJINy4zODAyNiIgc3Ryb2tlPSIjNzE2NTk2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBpZD0iVmVjdG9yXzUiIGQ9Ik00LjUgOC4zNzg5MUg3LjM4MDI2IiBzdHJva2U9IiM3MTY1OTYiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGlkPSJWZWN0b3JfNiIgZD0iTTQuNSAxMC4xNzU4SDcuMzgwMjYiIHN0cm9rZT0iIzcxNjU5NiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl83IiBkPSJNMTIuMzk4NCA2LjU3NDIySDE1LjI3ODciIHN0cm9rZT0iIzcxNjU5NiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl84IiBkPSJNMTIuMzk4NCA4LjM3Njk1SDE1LjI3ODciIHN0cm9rZT0iIzcxNjU5NiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggaWQ9IlZlY3Rvcl85IiBkPSJNMTguNTk3MSAxNC42MDkyTDEzLjM3NSAxMS4xOTczTDEzLjg0NjEgMTcuMzU0OEwxNS4yNjYgMTUuODYwOUwxNy4xNzcyIDE5LjE3MThMMTcuODQzNCAxOC43ODgyTDE4LjUwOTcgMTguNDA0NkwxNi41OTg1IDE1LjA5MzdMMTguNTk3MSAxNC42MDkyWiIgc3Ryb2tlPSIjNzE2NTk2IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var buttonIconLearningPath = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InBoOnBhdGgtdGhpbiIgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfYl8xMTI5XzYxMTk0KSI+CjxnIGlkPSJHcm91cCAxMTUyNTg5MCI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0xNS4xNTE1IDEyLjc0MDNDMTQuNjkyMSAxMi43NDAzIDE0LjI0ODEgMTIuOTA1OSAxMy45MDA5IDEzLjIwNjZDMTMuNTUzNyAxMy41MDczIDEzLjMyNjQgMTMuOTIzMSAxMy4yNjA4IDE0LjM3NzhINi40MTgxMUM1Ljc2NjY3IDE0LjM3NzggNS4xNDE5MSAxNC4xMTkgNC42ODEyNyAxMy42NTgzQzQuMjIwNjMgMTMuMTk3NyAzLjk2MTg1IDEyLjU3MjkgMy45NjE4NSAxMS45MjE1QzMuOTYxODUgMTEuMjcwMSA0LjIyMDYzIDEwLjY0NTMgNC42ODEyNyAxMC4xODQ3QzUuMTQxOTEgOS43MjQwMyA1Ljc2NjY3IDkuNDY1MjQgNi40MTgxMSA5LjQ2NTI0SDEyLjk2ODFDMTMuNjE5NiA5LjQ2NTI0IDE0LjI0NDMgOS4yMDY0NiAxNC43MDUgOC43NDU4MkMxNS4xNjU2IDguMjg1MTkgMTUuNDI0NCA3LjY2MDQzIDE1LjQyNDQgNy4wMDg5OUMxNS40MjQ0IDYuMzU3NTUgMTUuMTY1NiA1LjczMjc5IDE0LjcwNSA1LjI3MjE1QzE0LjI0NDMgNC44MTE1MiAxMy42MTk2IDQuNTUyNzMgMTIuOTY4MSA0LjU1MjczSDYuNDE4MTFDNi4zNDU3MiA0LjU1MjczIDYuMjc2MzEgNC41ODE0OSA2LjIyNTEyIDQuNjMyNjdDNi4xNzM5NCA0LjY4Mzg1IDYuMTQ1MTkgNC43NTMyNyA2LjE0NTE5IDQuODI1NjVDNi4xNDUxOSA0Ljg5ODAzIDYuMTczOTQgNC45Njc0NSA2LjIyNTEyIDUuMDE4NjNDNi4yNzYzMSA1LjA2OTgyIDYuMzQ1NzIgNS4wOTg1NyA2LjQxODExIDUuMDk4NTdIMTIuOTY4MUMxMy40NzQ4IDUuMDk4NTcgMTMuOTYwNyA1LjI5OTg0IDE0LjMxOSA1LjY1ODEyQzE0LjY3NzMgNi4wMTYzOSAxNC44Nzg1IDYuNTAyMzEgMTQuODc4NSA3LjAwODk5QzE0Ljg3ODUgNy41MTU2NiAxNC42NzczIDguMDAxNTkgMTQuMzE5IDguMzU5ODZDMTMuOTYwNyA4LjcxODEzIDEzLjQ3NDggOC45MTk0MSAxMi45NjgxIDguOTE5NDFINi40MTgxMUM1LjYyMTkgOC45MTk0MSA0Ljg1ODMxIDkuMjM1NyA0LjI5NTMxIDkuNzk4N0MzLjczMjMxIDEwLjM2MTcgMy40MTYwMiAxMS4xMjUzIDMuNDE2MDIgMTEuOTIxNUMzLjQxNjAyIDEyLjcxNzcgMy43MzIzMSAxMy40ODEzIDQuMjk1MzEgMTQuMDQ0M0M0Ljg1ODMxIDE0LjYwNzMgNS42MjE5IDE0LjkyMzYgNi40MTgxMSAxNC45MjM2SDEzLjI2MDhDMTMuMzEzMSAxNS4yODYgMTMuNDY4NSAxNS42MjU4IDEzLjcwODUgMTUuOTAyNEMxMy45NDg0IDE2LjE3OTEgMTQuMjYyOCAxNi4zODA5IDE0LjYxNDIgMTYuNDgzOUMxNC45NjU2IDE2LjU4NyAxNS4zMzkyIDE2LjU4NjggMTUuNjkwNiAxNi40ODM1QzE2LjA0MTkgMTYuMzgwMiAxNi4zNTYxIDE2LjE3ODEgMTYuNTk1OSAxNS45MDEzQzE2LjgzNTYgMTUuNjI0NCAxNi45OTA3IDE1LjI4NDUgMTcuMDQyNyAxNC45MjJDMTcuMDk0NyAxNC41NTk2IDE3LjA0MTUgMTQuMTg5OCAxNi44ODkzIDEzLjg1NjdDMTYuNzM3MSAxMy41MjM2IDE2LjQ5MjMgMTMuMjQxMyAxNi4xODQyIDEzLjA0MzRDMTUuODc2MiAxMi44NDU0IDE1LjUxNzcgMTIuNzQwMiAxNS4xNTE1IDEyLjc0MDNaTTE1LjE1MTUgMTYuMDE1M0MxNC44ODE2IDE2LjAxNTMgMTQuNjE3NyAxNS45MzUyIDE0LjM5MzMgMTUuNzg1M0MxNC4xNjg5IDE1LjYzNTMgMTMuOTk0IDE1LjQyMjIgMTMuODkwNyAxNS4xNzI5QzEzLjc4NzUgMTQuOTIzNSAxMy43NjA0IDE0LjY0OTIgMTMuODEzMSAxNC4zODQ1QzEzLjg2NTcgMTQuMTE5OCAxMy45OTU3IDEzLjg3NjYgMTQuMTg2NiAxMy42ODU4QzE0LjM3NzQgMTMuNDk0OSAxNC42MjA1IDEzLjM2NSAxNC44ODUyIDEzLjMxMjNDMTUuMTQ5OSAxMy4yNTk3IDE1LjQyNDMgMTMuMjg2NyAxNS42NzM3IDEzLjM5QzE1LjkyMyAxMy40OTMyIDE2LjEzNjEgMTMuNjY4MSAxNi4yODYxIDEzLjg5MjVDMTYuNDM2IDE0LjExNyAxNi41MTYgMTQuMzgwOCAxNi41MTYgMTQuNjUwN0MxNi41MTYgMTUuMDEyNiAxNi4zNzIzIDE1LjM1OTcgMTYuMTE2NCAxNS42MTU2QzE1Ljg2MDUgMTUuODcxNSAxNS41MTM0IDE2LjAxNTMgMTUuMTUxNSAxNi4wMTUzWiIgZmlsbD0iIzcxNjU5NiIgc3Ryb2tlPSIjNzE2NTk2Ii8+CjxjaXJjbGUgaWQ9IkVsbGlwc2UgMzEwIiBjeD0iNi4wODQ2NCIgY3k9IjQuNTgyNjgiIHI9IjEuNjY2NjciIGZpbGw9IiM3MTY1OTYiLz4KPGNpcmNsZSBpZD0iRWxsaXBzZSAzMTEiIGN4PSIxMC40NDk5IiBjeT0iOC45NDk4NyIgcj0iMS42NjY2NyIgZmlsbD0iIzcxNjU5NiIvPgo8L2c+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfYl8xMTI5XzYxMTk0IiB4PSItMjEuNSIgeT0iLTIyIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlR2F1c3NpYW5CbHVyIGluPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHN0ZERldmlhdGlvbj0iMTEiLz4KPGZlQ29tcG9zaXRlIGluMj0iU291cmNlQWxwaGEiIG9wZXJhdG9yPSJpbiIgcmVzdWx0PSJlZmZlY3QxX2JhY2tncm91bmRCbHVyXzExMjlfNjExOTQiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJlZmZlY3QxX2JhY2tncm91bmRCbHVyXzExMjlfNjExOTQiIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjwvZGVmcz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var assign$2 = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var unAssign = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var warning = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var noSearchResults = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var adminIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var team = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var checkbox = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMS4zMzIwMyIgeT0iMC44MzM5ODQiIHdpZHRoPSIxMi4zMzMzIiBoZWlnaHQ9IjEyLjMzMzMiIHJ4PSIxLjUiIHN0cm9rZT0iIzcxNjU5NiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var expandAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIDExNTI3NzEwIj4KPHBhdGggaWQ9IlZlY3RvciA0NiAoU3Ryb2tlKSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjEzMjc1IDUuODMzOTJDMy40NDUxNyA1LjUyMTUgMy45NTE3IDUuNTIxNSA0LjI2NDEyIDUuODMzOTJMOC40OTg0NCAxMC4wNjgyTDEyLjczMjggNS44MzM5MkMxMy4wNDUyIDUuNTIxNSAxMy41NTE3IDUuNTIxNSAxMy44NjQxIDUuODMzOTJDMTQuMTc2NSA2LjE0NjM0IDE0LjE3NjUgNi42NTI4OCAxMy44NjQxIDYuOTY1MjlMOS4wNjQxMiAxMS43NjUzQzguNzUxNyAxMi4wNzc3IDguMjQ1MTcgMTIuMDc3NyA3LjkzMjc1IDExLjc2NTNMMy4xMzI3NSA2Ljk2NTI5QzIuODIwMzMgNi42NTI4OCAyLjgyMDMzIDYuMTQ2MzQgMy4xMzI3NSA1LjgzMzkyWiIgZmlsbD0iIzYyNjI2MiIvPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var unExpandAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIDExNTI3NzEwIj4KPHBhdGggaWQ9IlZlY3RvciA0NiAoU3Ryb2tlKSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjEzMjc1IDExLjc2NTdDMy40NDUxNyAxMi4wNzgxIDMuOTUxNyAxMi4wNzgxIDQuMjY0MTIgMTEuNzY1N0w4LjQ5ODQ0IDcuNTMxMzdMMTIuNzMyOCAxMS43NjU3QzEzLjA0NTIgMTIuMDc4MSAxMy41NTE3IDEyLjA3ODEgMTMuODY0MSAxMS43NjU3QzE0LjE3NjUgMTEuNDUzMyAxNC4xNzY1IDEwLjk0NjcgMTMuODY0MSAxMC42MzQzTDkuMDY0MTIgNS44MzQzMUM4Ljc1MTcgNS41MjE4OSA4LjI0NTE3IDUuNTIxODkgNy45MzI3NSA1LjgzNDMxTDMuMTMyNzUgMTAuNjM0M0MyLjgyMDMzIDEwLjk0NjcgMi44MjAzMyAxMS40NTMzIDMuMTMyNzUgMTEuNzY1N1oiIGZpbGw9IiM2MjYyNjIiLz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var customCourseIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var editAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjAyODExIDE2LjYxNzlDOC4xNzA3IDE2LjU3OSA4LjMwMDY4IDE2LjUwMzYgOC40MDUxOSAxNi4zOTkxTDE3LjI1MzcgNy41NTA1NEMxOC4yNDg4IDYuNTU1NTQgMTguMjQ4OCA0Ljk0MjMyIDE3LjI1MzcgMy45NDczMkwxNi4wNTI3IDIuNzQ2MjVDMTUuMDU3NyAxLjc1MTI1IDEzLjQ0NDUgMS43NTEyNSAxMi40NDk1IDIuNzQ2MjVMMy42MDA4OSAxMS41OTQ4QzMuNDk2MzggMTEuNjk5MyAzLjQyMDk2IDExLjgyOTMgMy4zODIwNyAxMS45NzE5TDIuMDMwODYgMTYuOTI2M0MxLjg1Nzk2IDE3LjU2MDMgMi40Mzk3IDE4LjE0MiAzLjA3MzY5IDE3Ljk2OTFMOC4wMjgxMSAxNi42MTc5Wk00LjA2MDY0IDE1LjkzOTRMNC45NjE0NSAxMi42MzY0TDExLjg0OSA1Ljc0ODgxTDE0LjI1MTIgOC4xNTA5Nkw3LjM2MzU5IDE1LjAzODZMNC4wNjA2NCAxNS45Mzk0Wk0xNi4wNTI3IDYuMzQ5NDdDMTYuMzg0MyA2LjAxNzggMTYuMzg0MyA1LjQ4MDA2IDE2LjA1MjcgNS4xNDg0TDE0Ljg1MTYgMy45NDczMkMxNC41MTk5IDMuNjE1NjYgMTMuOTgyMiAzLjYxNTY2IDEzLjY1MDUgMy45NDczMkwxMi45OTAxIDQuNjA3NzlMMTUuMzkyMiA3LjAwOTk0TDE2LjA1MjcgNi4zNDk0N1oiIGZpbGw9IiM3MTY1OTYiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var trashAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjAwMDc4IDMuMlYxMy42QzQuMDAwNzggMTQuMDQxOCA0LjM1ODk1IDE0LjQgNC44MDA3OCAxNC40SDExLjIwMDhDMTEuNjQyNiAxNC40IDEyLjAwMDggMTQuMDQxOCAxMi4wMDA4IDEzLjZWMy4ySDEzLjYwMDhWMTMuNkMxMy42MDA4IDE0LjkyNTUgMTIuNTI2MyAxNiAxMS4yMDA4IDE2SDQuODAwNzhDMy40NzUzIDE2IDIuNDAwNzggMTQuOTI1NSAyLjQwMDc4IDEzLjZWMy4ySDQuMDAwNzhaIiBmaWxsPSIjNzE2NTk2Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi40MDA3OCAwQzUuOTU4OTUgMCA1LjYwMDc4IDAuMzU4MTcyIDUuNjAwNzggMC44SDEuNjAwNzhDMS4xNTg5NSAwLjggMC44MDA3ODEgMS4xNTgxNyAwLjgwMDc4MSAxLjZDMC44MDA3ODEgMi4wNDE4MyAxLjE1ODk1IDIuNCAxLjYwMDc4IDIuNEgxNC40MDA4QzE0Ljg0MjYgMi40IDE1LjIwMDggMi4wNDE4MyAxNS4yMDA4IDEuNkMxNS4yMDA4IDEuMTU4MTcgMTQuODQyNiAwLjggMTQuNDAwOCAwLjhIMTAuNDAwOEMxMC40MDA4IDAuMzU4MTcyIDEwLjA0MjYgMCA5LjYwMDc4IDBINi40MDA3OFoiIGZpbGw9IiM3MTY1OTYiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var trashLight = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01Ljk5Njg3IDUuMlYxNS42QzUuOTk2ODcgMTYuMDQxOCA2LjM1NTA1IDE2LjQgNi43OTY4NyAxNi40SDEzLjE5NjlDMTMuNjM4NyAxNi40IDEzLjk5NjkgMTYuMDQxOCAxMy45OTY5IDE1LjZWNS4ySDE1LjU5NjlWMTUuNkMxNS41OTY5IDE2LjkyNTUgMTQuNTIyNCAxOCAxMy4xOTY5IDE4SDYuNzk2ODdDNS40NzEzOSAxOCA0LjM5Njg3IDE2LjkyNTUgNC4zOTY4NyAxNS42VjUuMkg1Ljk5Njg3WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC4zOTY4NyAyQzcuOTU1MDUgMiA3LjU5Njg3IDIuMzU4MTcgNy41OTY4NyAyLjhIMy41OTY4N0MzLjE1NTA1IDIuOCAyLjc5Njg4IDMuMTU4MTcgMi43OTY4OCAzLjZDMi43OTY4OCA0LjA0MTgzIDMuMTU1MDUgNC40IDMuNTk2ODggNC40SDE2LjM5NjlDMTYuODM4NyA0LjQgMTcuMTk2OSA0LjA0MTgzIDE3LjE5NjkgMy42QzE3LjE5NjkgMy4xNTgxNyAxNi44Mzg3IDIuOCAxNi4zOTY5IDIuOEgxMi4zOTY5QzEyLjM5NjkgMi4zNTgxNyAxMi4wMzg3IDIgMTEuNTk2OSAySDguMzk2ODdaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var filterAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0wIDIuOEMwIDIuMzU4MTcgMC4zNTgxNzIgMiAwLjggMkgxNS4yQzE1LjY0MTggMiAxNiAyLjM1ODE3IDE2IDIuOEMxNiAzLjI0MTgzIDE1LjY0MTggMy42IDE1LjIgMy42SDAuOEMwLjM1ODE3MiAzLjYgMCAzLjI0MTgzIDAgMi44Wk0yLjQgOEMyLjQgNy41NTgxNyAyLjc1ODE3IDcuMiAzLjIgNy4ySDEyLjhDMTMuMjQxOCA3LjIgMTMuNiA3LjU1ODE3IDEzLjYgOEMxMy42IDguNDQxODMgMTMuMjQxOCA4LjggMTIuOCA4LjhIMy4yQzIuNzU4MTcgOC44IDIuNCA4LjQ0MTgzIDIuNCA4Wk00LjggMTMuMkM0LjggMTIuNzU4MiA1LjE1ODE3IDEyLjQgNS42IDEyLjRIMTAuNEMxMC44NDE4IDEyLjQgMTEuMiAxMi43NTgyIDExLjIgMTMuMkMxMS4yIDEzLjY0MTggMTAuODQxOCAxNCAxMC40IDE0SDUuNkM1LjE1ODE3IDE0IDQuOCAxMy42NDE4IDQuOCAxMy4yWiIgZmlsbD0iI0E1ODhEMiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var assignContentMenuIcon = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEwIDBDOC4zNDMxNSAwIDcgMS4zNDMxNSA3IDNIMy41QzIuOTQ3NzIgMyAyLjUgMy40NDc3MiAyLjUgNFYxOUMyLjUgMTkuNTUyMyAyLjk0NzcyIDIwIDMuNSAyMEgxMy41QzEyLjAxOTQgMjAgMTAuNzI2NyAxOS4xOTU2IDEwLjAzNTEgMThINC41VjVIN0gxM0gxNS41VjEyLjUzNTFDMTYuNjk1NiAxMy4yMjY3IDE3LjUgMTQuNTE5NCAxNy41IDE2VjRDMTcuNSAzLjQ0NzcyIDE3LjA1MjMgMyAxNi41IDNIMTNDMTMgMS4zNDMxNSAxMS42NTY5IDAgMTAgMFpNMTAgMkMxMC41NTIzIDIgMTEgMi40NDc3MiAxMSAzSDlDOSAyLjQ0NzcyIDkuNDQ3NzIgMiAxMCAyWk0xMy4zNjQ5IDEyLjAwMjJDMTMuNDUwOCAxMS44NTQ2IDEzLjUgMTEuNjgzMSAxMy41IDExLjVDMTMuNSAxMC45NDc3IDEzLjA1MjMgMTAuNSAxMi41IDEwLjVINy41QzYuOTQ3NzIgMTAuNSA2LjUgMTAuOTQ3NyA2LjUgMTEuNUM2LjUgMTIuMDUyMyA2Ljk0NzcyIDEyLjUgNy41IDEyLjVIMTEuNTYyQzEyLjA5OTIgMTIuMjAxOSAxMi43MTIzIDEyLjAyMzkgMTMuMzY0OSAxMi4wMDIyWk05Ljc5MDc2IDE0LjVINy41QzYuOTQ3NzIgMTQuNSA2LjUgMTQuOTQ3NyA2LjUgMTUuNUM2LjUgMTYuMDUyMyA2Ljk0NzcyIDE2LjUgNy41IDE2LjVIOS41MzA5NUM5LjUxMDUyIDE2LjMzNjIgOS41IDE2LjE2OTMgOS41IDE2QzkuNSAxNS40Njk2IDkuNjAzMjUgMTQuOTYzMiA5Ljc5MDc2IDE0LjVaTTYuNSA3LjVDNi41IDYuOTQ3NzIgNi45NDc3MiA2LjUgNy41IDYuNUgxMi41QzEzLjA1MjMgNi41IDEzLjUgNi45NDc3MiAxMy41IDcuNUMxMy41IDguMDUyMjggMTMuMDUyMyA4LjUgMTIuNSA4LjVINy41QzYuOTQ3NzIgOC41IDYuNSA4LjA1MjI4IDYuNSA3LjVaTTEyLjUgMTRDMTIuNSAxMy40NDc3IDEyLjk0NzcgMTMgMTMuNSAxM0MxNC4wNTIzIDEzIDE0LjUgMTMuNDQ3NyAxNC41IDE0VjE1SDE1LjVDMTYuMDUyMyAxNSAxNi41IDE1LjQ0NzcgMTYuNSAxNkMxNi41IDE2LjU1MjMgMTYuMDUyMyAxNyAxNS41IDE3SDE0LjVWMThDMTQuNSAxOC41NTIzIDE0LjA1MjMgMTkgMTMuNSAxOUMxMi45NDc3IDE5IDEyLjUgMTguNTUyMyAxMi41IDE4VjE3SDExLjVDMTAuOTQ3NyAxNyAxMC41IDE2LjU1MjMgMTAuNSAxNkMxMC41IDE1LjQ0NzcgMTAuOTQ3NyAxNSAxMS41IDE1SDEyLjVWMTRaIiBmaWxsPSIjNjI2MjYyIi8+Cjwvc3ZnPg==";

/* loaded by smart-asset */
var activityFeedMenuIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var rightChevronDark = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjgzMzkyIDEzLjM2NzJDNS41MjE1IDEzLjA1NDggNS41MjE1IDEyLjU0ODMgNS44MzM5MiAxMi4yMzU5TDEwLjA2ODIgOC4wMDE1Nkw1LjgzMzkyIDMuNzY3MjVDNS41MjE1IDMuNDU0ODMgNS41MjE1IDIuOTQ4MyA1LjgzMzkyIDIuNjM1ODhDNi4xNDYzNCAyLjMyMzQ2IDYuNjUyODggMi4zMjM0NiA2Ljk2NTI5IDIuNjM1ODhMMTEuNzY1MyA3LjQzNTg4QzEyLjA3NzcgNy43NDgzIDEyLjA3NzcgOC4yNTQ4MyAxMS43NjUzIDguNTY3MjVMNi45NjUyOSAxMy4zNjcyQzYuNjUyODggMTMuNjc5NyA2LjE0NjM0IDEzLjY3OTcgNS44MzM5MiAxMy4zNjcyWiIgZmlsbD0iIzYyNjI2MiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var filterAdminGray = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yIDQuOEMyIDQuMzU4MTcgMi4zNTgxNyA0IDIuOCA0SDE3LjJDMTcuNjQxOCA0IDE4IDQuMzU4MTcgMTggNC44QzE4IDUuMjQxODMgMTcuNjQxOCA1LjYgMTcuMiA1LjZIMi44QzIuMzU4MTcgNS42IDIgNS4yNDE4MyAyIDQuOFpNNC40IDEwQzQuNCA5LjU1ODE3IDQuNzU4MTcgOS4yIDUuMiA5LjJIMTQuOEMxNS4yNDE4IDkuMiAxNS42IDkuNTU4MTcgMTUuNiAxMEMxNS42IDEwLjQ0MTggMTUuMjQxOCAxMC44IDE0LjggMTAuOEg1LjJDNC43NTgxNyAxMC44IDQuNCAxMC40NDE4IDQuNCAxMFpNNi44IDE1LjJDNi44IDE0Ljc1ODIgNy4xNTgxNyAxNC40IDcuNiAxNC40SDEyLjRDMTIuODQxOCAxNC40IDEzLjIgMTQuNzU4MiAxMy4yIDE1LjJDMTMuMiAxNS42NDE4IDEyLjg0MTggMTYgMTIuNCAxNkg3LjZDNy4xNTgxNyAxNiA2LjggMTUuNjQxOCA2LjggMTUuMloiIGZpbGw9IiM2MjYyNjIiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var successIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjEwIiBmaWxsPSIjNjJEMzgyIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTcuNTEyNCA1LjkwMDc4QzE3Ljc4MDEgNi4xNjg1NCAxNy43ODAxIDYuNjAyNjggMTcuNTEyNCA2Ljg3MDQ0TDkuMTg0MDMgMTUuMTk4OEM4Ljc4MjM4IDE1LjYwMDQgOC4xMzExOCAxNS42MDA0IDcuNzI5NTMgMTUuMTk4OEw0LjIwMDgyIDExLjY3MDFDMy45MzMwNiAxMS40MDIzIDMuOTMzMDYgMTAuOTY4MiA0LjIwMDgyIDEwLjcwMDRDNC40Njg1OSAxMC40MzI2IDQuOTAyNzMgMTAuNDMyNiA1LjE3MDQ5IDEwLjcwMDRMOC40NTY3OCAxMy45ODY3TDE2LjU0MjcgNS45MDA3OEMxNi44MTA1IDUuNjMzMDEgMTcuMjQ0NiA1LjYzMzAxIDE3LjUxMjQgNS45MDA3OFoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var errorNotificationIcon = "IpChZnpx.svg";

/* loaded by smart-asset */
var closeIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIDExNTI3Mjg0Ij4KPG1hc2sgaWQ9InBhdGgtMS1pbnNpZGUtMV8yNTc3XzgzMDAxIiBmaWxsPSJ3aGl0ZSI+CjxwYXRoIGQ9Ik0wIDBINjBWNjBIMFYwWiIvPgo8L21hc2s+CjxwYXRoIGQ9Ik0wIDBINjBWNjBIMFYwWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTAgMUg2MFYtMUgwVjFaTTYwIDU5SDBWNjFINjBWNTlaIiBmaWxsPSIjNjI2MjYyIiBmaWxsLW9wYWNpdHk9IjAuMjUiIG1hc2s9InVybCgjcGF0aC0xLWluc2lkZS0xXzI1NzdfODMwMDEpIi8+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0zNi44MzYyIDM3LjIwMjlIMzAuNzEzNEMyNi41MzU5IDM3LjIwMjkgMjMuMTM0NiAzMy45NjQzIDIzLjEzNDYgMjkuOTgzQzIzLjEzNDYgMjUuOTMxOSAyNi4zOTcgMjIuNzU5IDMwLjU2MTIgMjIuNzU5SDM2LjgzNDFDMzcuMzQwNyAyMi43NTkgMzcuODI2NSAyMi45NTc1IDM4LjE4NDggMjMuMzEwN0MzOC41NDMgMjMuNjY0IDM4Ljc0NDIgMjQuMTQzMSAzOC43NDQyIDI0LjY0MjdDMzguNzQ0MiAyNS4xNDIzIDM4LjU0MyAyNS42MjE0IDM4LjE4NDggMjUuOTc0N0MzNy44MjY1IDI2LjMyNzkgMzcuMzQwNyAyNi41MjY0IDM2LjgzNDEgMjYuNTI2NEgzMC41NjEyQzI4LjUzOTQgMjYuNTI2NCAyNi45NTQ5IDI4LjA0NDcgMjYuOTU0OSAyOS45ODNDMjYuOTU0OSAzMS44ODY4IDI4LjYzOTEgMzMuNDM1NiAzMC43MTEzIDMzLjQzNTZIMzYuODM0MUMzNy4zNDA3IDMzLjQzNTYgMzcuODI2NSAzMy42MzQgMzguMTg0OCAzMy45ODczQzM4LjU0MyAzNC4zNDA1IDM4Ljc0NDIgMzQuODE5NyAzOC43NDQyIDM1LjMxOTJDMzguNzQ0MiAzNS44MTg4IDM4LjU0MyAzNi4yOTggMzguMTg0OCAzNi42NTEyQzM3LjgyNjUgMzcuMDA0NSAzNy4zNDA3IDM3LjIwMjkgMzYuODM0MSAzNy4yMDI5TTM5Ljg4NDYgMzAuMDA1OUM0MS4wNjYxIDI5LjMzOTYgNDEuOTkxMiAyOC4zMDcgNDIuNTE2MyAyNy4wNjg3QzQzLjA0MTMgMjUuODMwMyA0My4xMzY4IDI0LjQ1NTcgNDIuNzg3OCAyMy4xNTgzQzQyLjQzODkgMjEuODYxIDQxLjY2NTIgMjAuNzEzNyA0MC41ODY4IDE5Ljg5NDdDMzkuNTA4NSAxOS4wNzU3IDM4LjE4NiAxOC42MzEgMzYuODI0OSAxOC42Mjk3SDMxLjAyNjRDMzAuOTMwMyAxOC42Mjk3IDMwLjgzNDggMTguNjI5NyAzMC43Mzk0IDE4LjYzNjZMMjguNDIzNiAxNkwyNy4wNTk0IDE5LjA5ODlMMjMuOTQ0NCAxNy4xMTE0TDIzLjY0ODkgMjAuNDE4NkwxOS45OTM1IDE5LjI2NDNMMjAuNzU3IDIyLjM2MjVMMTQuODM3MSAyMC45MjFMMTguNDM1IDI1LjA4NjNMMTAuMDY0NSAyNS4xMTg4TDE2LjgxNiAyOC4yNTNMNiAzMC4wNTc4TDE2Ljg4NTUgMzEuNzcwNUwxMC45MDg3IDM0Ljc3ODhMMTguNTQwOSAzNC44OTc4TDE1Ljk5NDMgMzguMjcxNEwyMC43NzgxIDM3LjU1MDNMMTkuOTk0MiA0MC43MzM2TDIzLjY0ODkgMzkuNTc3M0wyMy45NDQ0IDQyLjg4NTJMMjcuMDU2NiA0MC45MDExTDI4LjQyMDggNDRMMzAuNzMyNCA0MS4zNzAzQzMwLjgyOTkgNDEuMzc1MiAzMC45MjgyIDQxLjM3NzkgMzEuMDI2NCA0MS4zNzc5SDM2LjgyNzFDMzguMTg4OCA0MS4zNzc0IDM5LjUxMjIgNDAuOTMzIDQwLjU5MTMgNDAuMTEzOUM0MS42NzA0IDM5LjI5NDkgNDIuNDQ0NyAzOC4xNDcgNDIuNzkzNyAzNi44NDlDNDMuMTQyNyAzNS41NTEgNDMuMDQ2OSAzNC4xNzU2IDQyLjUyMTIgMzIuOTM2OUM0MS45OTU0IDMxLjY5ODIgNDEuMDY5MiAzMC42NjU1IDM5Ljg4NjcgMjkuOTk5NyIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzI1NzdfODMwMDEpIi8+CjwvZz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhcl8yNTc3XzgzMDAxIiB4MT0iMzcuNDk1OSIgeTE9Ii05OC43MTY5IiB4Mj0iMTA0Ljc1NyIgeTI9Ii0yNi41MyIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBvZmZzZXQ9IjAuNTE1NjI1IiBzdG9wLWNvbG9yPSIjNEQ1MTlEIi8+CjxzdG9wIG9mZnNldD0iMC45MjE4NzUiIHN0b3AtY29sb3I9IiMxRTFBNDYiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";

/* loaded by smart-asset */
var backToOldUi = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var adminExpand = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var warningYellow = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var customLesson = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var start$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMyAxNiIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTExLjk2MTUgNy4wMjU5MkwxLjcyNzQ1IDAuNjY5ODI3QzEuNTU0OTEgMC41NjI1NiAxLjM1NzI5IDAuNTA0MDAxIDEuMTU1MDEgMC41MDAxOThDMC45NTI3MTkgMC40OTYzOTUgMC43NTMxIDAuNTQ3NDg1IDAuNTc2NzY1IDAuNjQ4MTkzQzAuNDAyMTA5IDAuNzQ3MzM2IDAuMjU2NjE1IDAuODkxOTIyIDAuMTU1MjQ2IDEuMDY3MDhDMC4wNTM4Nzc0IDEuMjQyMjQgMC4wMDAyOTE4MzMgMS40NDE2NSAwIDEuNjQ0OFYxNC4zNTU1QzAuMDAxMzE2MDIgMTQuNjYwMyAwLjEyMTc3IDE0Ljk1MiAwLjMzNDg4MSAxNS4xNjY2QzAuNTQ3OTkzIDE1LjM4MTIgMC44MzYzMjEgMTUuNTAxMSAxLjEzNjQ4IDE1LjVDMS4zNDU5OSAxNS40OTk5IDEuNTUxNDMgMTUuNDQxMyAxLjczMDI5IDE1LjMzMDVMMTEuOTYxNSA4Ljk3NDQzQzEyLjEyNTkgOC44NzI2NiAxMi4yNjE4IDguNzI5NjYgMTIuMzU2MiA4LjU1OTE3QzEyLjQ1MDUgOC4zODg2OCAxMi41IDguMTk2NDMgMTIuNSA4LjAwMDlDMTIuNSA3LjgwNTM2IDEyLjQ1MDUgNy42MTMxMSAxMi4zNTYyIDcuNDQyNjJDMTIuMjYxOCA3LjI3MjEzIDEyLjEyNTkgNy4xMjkxMyAxMS45NjE1IDcuMDI3MzZWNy4wMjU5MlpNMS4xMzY0OCAxNC4zNDE4VjEuNjU0MThMMTEuMzUyNyA4LjAwMDE4TDEuMTM2NDggMTQuMzQxOFoiCiAgICAvPgo8L3N2Zz4KICAgIA==";

/* loaded by smart-asset */
var complete = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNTMxXzE3KSI+CiAgICAgICAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgICAgIGQ9Ik0xNS4xNjg0IDIuMzA4N0MxNS40NTY4IDIuNTk3MDggMTUuNDU2OCAzLjA2NDY1IDE1LjE2ODQgMy4zNTMwNEw2LjE5ODc0IDEyLjMyMjdDNS43NjYxNSAxMi43NTUzIDUuMDY0OCAxMi43NTUzIDQuNjMyMjIgMTIuMzIyN0wwLjgzMTc2OSA4LjUyMjI3QzAuNTQzMzgyIDguMjMzODggMC41NDMzODIgNy43NjYzMiAwLjgzMTc2OSA3LjQ3NzkzQzEuMTIwMTYgNy4xODk1NCAxLjU4NzcyIDcuMTg5NTQgMS44NzYxMSA3LjQ3NzkzTDUuNDE1NDggMTEuMDE3M0wxNC4xMjQxIDIuMzA4N0MxNC40MTI1IDIuMDIwMzEgMTQuODggMi4wMjAzMSAxNS4xNjg0IDIuMzA4N1oiCiAgICAgICAgLz4KICAgIDwvZz4KICAgIDxkZWZzPgogICAgICAgIDxjbGlwUGF0aCBpZD0iY2xpcDBfMjUzMV8xNyI+CiAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIxNC43NjkyIiBoZWlnaHQ9IjE0Ljc2OTIiCiAgICAgICAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjYxNTQ3OSAwLjYxNTQ3OSkiIC8+CiAgICAgICAgPC9jbGlwUGF0aD4KICAgIDwvZGVmcz4KPC9zdmc+CiAgICA=";

/* loaded by smart-asset */
var logIn = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxOSAyMCIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgIGQ9Ik0yLjA3NjkgNC4wOTI0QzIuMDc2OSAzLjI3NjcyIDIuNzM4MTUgMi42MTU0OCAzLjU1MzgzIDIuNjE1NDhINi41MDc2N0M2LjkxNTUxIDIuNjE1NDggNy4yNDYxNCAyLjk0NjEgNy4yNDYxNCAzLjM1Mzk0QzcuMjQ2MTQgMy43NjE3OCA2LjkxNTUxIDQuMDkyNCA2LjUwNzY3IDQuMDkyNEgzLjU1MzgzVjE1LjkwNzhINi41MDc2N0M2LjkxNTUxIDE1LjkwNzggNy4yNDYxNCAxNi4yMzg0IDcuMjQ2MTQgMTYuNjQ2MkM3LjI0NjE0IDE3LjA1NDEgNi45MTU1MSAxNy4zODQ3IDYuNTA3NjcgMTcuMzg0N0gzLjU1MzgzQzIuNzM4MTQgMTcuMzg0NyAyLjA3NjkgMTYuNzIzNSAyLjA3NjkgMTUuOTA3OFY0LjA5MjRaIgogICAgLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgIGQ9Ik0xMS44OTMyIDUuNzg1NjJDMTIuMTgxNiA1LjQ5NzIzIDEyLjY0OTEgNS40OTcyMyAxMi45Mzc1IDUuNzg1NjJMMTYuNjI5OCA5LjQ3NzkyQzE2LjkxODIgOS43NjYzMSAxNi45MTgyIDEwLjIzMzkgMTYuNjI5OCAxMC41MjIzTDEyLjkzNzUgMTQuMjE0NkMxMi42NDkxIDE0LjUwMyAxMi4xODE2IDE0LjUwMyAxMS44OTMyIDE0LjIxNDZDMTEuNjA0OCAxMy45MjYyIDExLjYwNDggMTMuNDU4NiAxMS44OTMyIDEzLjE3MDJMMTQuMzI0OSAxMC43Mzg2SDYuNTA3NjdDNi4wOTk4MyAxMC43Mzg2IDUuNzY5MjEgMTAuNDA3OSA1Ljc2OTIxIDEwLjAwMDFDNS43NjkyMSA5LjU5MjI1IDYuMDk5ODMgOS4yNjE2MyA2LjUwNzY3IDkuMjYxNjNIMTQuMzI0OUwxMS44OTMyIDYuODI5OTZDMTEuNjA0OCA2LjU0MTU3IDExLjYwNDggNi4wNzQgMTEuODkzMiA1Ljc4NTYyWiIKICAgIC8+Cjwvc3ZnPgogICAg";

/* loaded by smart-asset */
var logOut = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgIGQ9Ik0xNy40NjE0IDQuMDkyNEMxNy40NjE0IDMuMjc2NzIgMTYuODAwMiAyLjYxNTQ4IDE1Ljk4NDUgMi42MTU0OEgxMy4wMzA3QzEyLjYyMjggMi42MTU0OCAxMi4yOTIyIDIuOTQ2MSAxMi4yOTIyIDMuMzUzOTRDMTIuMjkyMiAzLjc2MTc4IDEyLjYyMjggNC4wOTI0IDEzLjAzMDcgNC4wOTI0SDE1Ljk4NDVWMTUuOTA3OEgxMy4wMzA3QzEyLjYyMjggMTUuOTA3OCAxMi4yOTIyIDE2LjIzODQgMTIuMjkyMiAxNi42NDYyQzEyLjI5MjIgMTcuMDU0MSAxMi42MjI4IDE3LjM4NDcgMTMuMDMwNyAxNy4zODQ3SDE1Ljk4NDVDMTYuODAwMiAxNy4zODQ3IDE3LjQ2MTQgMTYuNzIzNSAxNy40NjE0IDE1LjkwNzhWNC4wOTI0WiIKICAgIC8+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgICAgICBkPSJNNy42NDUxMyA1Ljc4NTYyQzcuMzU2NzUgNS40OTcyMyA2Ljg4OTE4IDUuNDk3MjMgNi42MDA3OSA1Ljc4NTYyTDIuOTA4NDggOS40Nzc5MkMyLjYyMDEgOS43NjYzMSAyLjYyMDEgMTAuMjMzOSAyLjkwODQ5IDEwLjUyMjNMNi42MDA3OSAxNC4yMTQ2QzYuODg5MTggMTQuNTAzIDcuMzU2NzUgMTQuNTAzIDcuNjQ1MTMgMTQuMjE0NkM3LjkzMzUyIDEzLjkyNjIgNy45MzM1MiAxMy40NTg2IDcuNjQ1MTMgMTMuMTcwMkw1LjIxMzQ2IDEwLjczODZIMTMuMDMwN0MxMy40Mzg1IDEwLjczODYgMTMuNzY5MSAxMC40MDc5IDEzLjc2OTEgMTAuMDAwMUMxMy43NjkxIDkuNTkyMjUgMTMuNDM4NSA5LjI2MTYzIDEzLjAzMDcgOS4yNjE2M0g1LjIxMzQ2TDcuNjQ1MTMgNi44Mjk5NkM3LjkzMzUyIDYuNTQxNTcgNy45MzM1MiA2LjA3NCA3LjY0NTEzIDUuNzg1NjJaIgogICAgLz4KPC9zdmc+CiAgICA=";

/* loaded by smart-asset */
var deleteEvent = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgIGQ9Ik00LjAwMDA1IDMuMlYxMy42QzQuMDAwMDUgMTQuMDQxOCA0LjM1ODIyIDE0LjQgNC44MDAwNSAxNC40SDExLjJDMTEuNjQxOSAxNC40IDEyIDE0LjA0MTggMTIgMTMuNlYzLjJIMTMuNlYxMy42QzEzLjYgMTQuOTI1NSAxMi41MjU1IDE2IDExLjIgMTZINC44MDAwNUMzLjQ3NDU3IDE2IDIuNDAwMDUgMTQuOTI1NSAyLjQwMDA1IDEzLjZWMy4ySDQuMDAwMDVaIgogICAgLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgIGQ9Ik02LjQwMDA1IDBDNS45NTgyMiAwIDUuNjAwMDUgMC4zNTgxNzIgNS42MDAwNSAwLjhIMS42MDAwNUMxLjE1ODIyIDAuOCAwLjgwMDA0OSAxLjE1ODE3IDAuODAwMDQ5IDEuNkMwLjgwMDA0OSAyLjA0MTgzIDEuMTU4MjIgMi40IDEuNjAwMDUgMi40SDE0LjRDMTQuODQxOSAyLjQgMTUuMiAyLjA0MTgzIDE1LjIgMS42QzE1LjIgMS4xNTgxNyAxNC44NDE5IDAuOCAxNC40IDAuOEgxMC40QzEwLjQgMC4zNTgxNzIgMTAuMDQxOSAwIDkuNjAwMDUgMEg2LjQwMDA1WiIKICAgIC8+Cjwvc3ZnPgogICAg";

/* loaded by smart-asset */
var invite = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTE1LjM0NjEgMy45Mzg1OUMxNS4zNDYxIDMuMTI2MjkgMTQuNjgxNSAyLjQ2MTY3IDEzLjg2OTIgMi40NjE2N0gyLjA1MzgzQzEuMjQxNTIgMi40NjE2NyAwLjU3NjkwNCAzLjEyNjI5IDAuNTc2OTA0IDMuOTM4NTlWMTIuMDYxN0MwLjU3NjkwNCAxMi44NzQgMS4yNDE1MiAxMy41Mzg2IDIuMDUzODMgMTMuNTM4NkgxMy44NjkyQzE0LjY4MTUgMTMuNTM4NiAxNS4zNDYxIDEyLjg3NCAxNS4zNDYxIDEyLjA2MTdWMy45Mzg1OVpNMTMuODY5MiAzLjkzODU5TDcuOTYxNTIgNy42MzA5TDIuMDUzODMgMy45Mzg1OUgxMy44NjkyWk0xMy44NjkyIDEyLjA2MTdIMi4wNTM4M1Y1LjQxNTUyTDcuOTYxNTIgOS4xMDc4MkwxMy44NjkyIDUuNDE1NTJWMTIuMDYxN1oiCiAgICAvPgo8L3N2Zz4KICAgIA==";

/* loaded by smart-asset */
var create = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTEzLjE2OTIgNy45NjkyNkg4LjczODQ0VjMuMTY5MjZDOC43Mzg0NCAyLjk1NzA5IDguNjYwNjQgMi43NTM2MSA4LjUyMjE1IDIuNjAzNThDOC4zODM2NiAyLjQ1MzU1IDguMTk1ODMgMi4zNjkyNiA3Ljk5OTk4IDIuMzY5MjZDNy44MDQxMyAyLjM2OTI2IDcuNjE2MjkgMi40NTM1NSA3LjQ3NzgxIDIuNjAzNThDNy4zMzkzMiAyLjc1MzYxIDcuMjYxNTIgMi45NTcwOSA3LjI2MTUyIDMuMTY5MjZWNy45NjkyNkgyLjgzMDc1QzIuNjM0ODkgNy45NjkyNiAyLjQ0NzA2IDguMDUzNTUgMi4zMDg1OCA4LjIwMzU4QzIuMTcwMDkgOC4zNTM2MSAyLjA5MjI5IDguNTU3MDkgMi4wOTIyOSA4Ljc2OTI2QzIuMDkyMjkgOC45ODE0NCAyLjE3MDA5IDkuMTg0OTIgMi4zMDg1OCA5LjMzNDk1QzIuNDQ3MDYgOS40ODQ5OCAyLjYzNDg5IDkuNTY5MjYgMi44MzA3NSA5LjU2OTI2SDcuMjYxNTJWMTQuMzY5M0M3LjI2MTUyIDE0LjU4MTQgNy4zMzkzMiAxNC43ODQ5IDcuNDc3ODEgMTQuOTM0OUM3LjYxNjI5IDE1LjA4NSA3LjgwNDEzIDE1LjE2OTMgNy45OTk5OCAxNS4xNjkzQzguMTk1ODMgMTUuMTY5MyA4LjM4MzY2IDE1LjA4NSA4LjUyMjE1IDE0LjkzNDlDOC42NjA2NCAxNC43ODQ5IDguNzM4NDQgMTQuNTgxNCA4LjczODQ0IDE0LjM2OTNWOS41NjkyNkgxMy4xNjkyQzEzLjM2NTEgOS41NjkyNiAxMy41NTI5IDkuNDg0OTggMTMuNjkxNCA5LjMzNDk1QzEzLjgyOTkgOS4xODQ5MiAxMy45MDc3IDguOTgxNDQgMTMuOTA3NyA4Ljc2OTI2QzEzLjkwNzcgOC41NTcwOSAxMy44Mjk5IDguMzUzNjEgMTMuNjkxNCA4LjIwMzU4QzEzLjU1MjkgOC4wNTM1NSAxMy4zNjUxIDcuOTY5MjYgMTMuMTY5MiA3Ljk2OTI2WiIKICAgICAgICAgLz4KPC9zdmc+CiAgICA=";

/* loaded by smart-asset */
var upload = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTguNzAwMjMgMTQuMDMwN0M4LjcwMDIzIDE0LjQzODUgOC4zNjk2MSAxNC43NjkyIDcuOTYxNzYgMTQuNzY5MkM3LjU1MzkyIDE0Ljc2OTIgNy4yMjMzIDE0LjQzODUgNy4yMjMzIDE0LjAzMDdWNi4yMTM1MUw0LjQyMjQgOS4wMTQ0MUM0LjEzNDAxIDkuMzAyOCAzLjY2NjQ0IDkuMzAyOCAzLjM3ODA1IDkuMDE0NDFDMy4wODk2NyA4LjcyNjAzIDMuMDg5NjcgOC4yNTg0NiAzLjM3ODA1IDcuOTcwMDdMNy4xNzg1MSA0LjE2OTYyQzcuNjExMDkgMy43MzcwNCA4LjMxMjQ0IDMuNzM3MDQgOC43NDUwMiA0LjE2OTYyTDEyLjU0NTUgNy45NzAwN0MxMi44MzM5IDguMjU4NDYgMTIuODMzOSA4LjcyNjAzIDEyLjU0NTUgOS4wMTQ0MUMxMi4yNTcxIDkuMzAyOCAxMS43ODk1IDkuMzAyOCAxMS41MDExIDkuMDE0NDFMOC43MDAyMyA2LjIxMzUxVjE0LjAzMDdaIgogICAgLz4KICAgIDxwYXRoCiAgICAgICAgZD0iTTIuMDU0MDcgNS45MDc2M0MyLjA1NDA3IDYuMzE1NDcgMS43MjM0NSA2LjY0NjA5IDEuMzE1NjEgNi42NDYwOUMwLjkwNzc2OSA2LjY0NjA5IDAuNTc3MTQ4IDYuMzE1NDcgMC41NzcxNDggNS45MDc2M1YxLjQ3Njg2QzAuNTc3MTQ4IDAuNjYxMTc2IDEuMjM4MzkgLTYuNTgwMzVlLTA1IDIuMDU0MDcgLTYuNTgwMzVlLTA1SDEzLjg2OTVDMTQuNjg1MSAtNi41ODAzNWUtMDUgMTUuMzQ2NCAwLjY2MTE3NSAxNS4zNDY0IDEuNDc2ODZWNS45MDc2M0MxNS4zNDY0IDYuMzE1NDcgMTUuMDE1OCA2LjY0NjA5IDE0LjYwNzkgNi42NDYwOUMxNC4yMDAxIDYuNjQ2MDkgMTMuODY5NSA2LjMxNTQ3IDEzLjg2OTUgNS45MDc2M1YxLjQ3Njg2SDIuMDU0MDdWNS45MDc2M1oiCiAgICAvPgo8L3N2Zz4KICAgIA==";

/* loaded by smart-asset */
var lock = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8yNTMxXzQ2MzMpIj4KICAgICAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgICAgICAgICAgZD0iTTMuMTk5OTggNy43MDc3N0gyLjgzMDc1QzIuNDIyOTEgNy43MDc3NyAyLjA5MjI5IDguMDM4MzkgMi4wOTIyOSA4LjQ0NjIzVjE0LjcyMzJDMi4wOTIyOSAxNS4xMzEgMi40MjI5MSAxNS40NjE2IDIuODMwNzUgMTUuNDYxNkgxMy4xNjkyQzEzLjU3NyAxNS40NjE2IDEzLjkwNzcgMTUuMTMxIDEzLjkwNzcgMTQuNzIzMlY4LjQ0NjIzQzEzLjkwNzcgOC4wMzgzOSAxMy41NzcgNy43MDc3NyAxMy4xNjkyIDcuNzA3NzdIMTIuOFY1LjQ5MjM4QzEyLjggMi44NDE0MiAxMC42NTA5IDAuNjkyMzgzIDcuOTk5OTggMC42OTIzODNDNS4zNDkwMSAwLjY5MjM4MyAzLjE5OTk4IDIuODQxNDIgMy4xOTk5OCA1LjQ5MjM4VjcuNzA3NzdaTTQuNjc2OSA3LjcwNzc3SDExLjMyMzFWNS40OTIzOEMxMS4zMjMxIDMuNjU3MSA5LjgzNTI2IDIuMTY5MzEgNy45OTk5OCAyLjE2OTMxQzYuMTY0NjkgMi4xNjkzMSA0LjY3NjkgMy42NTcxIDQuNjc2OSA1LjQ5MjM4VjcuNzA3NzdaIgogICAgICAgIC8+CiAgICA8L2c+CiAgICA8ZGVmcz4KICAgICAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzI1MzFfNDYzMyI+CiAgICAgICAgICAgIDxyZWN0IHdpZHRoPSIxNC43NjkyIiBoZWlnaHQ9IjE0Ljc2OTIiCiAgICAgICAgICAgICAgICB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjYxNTIzNCAwLjY5MjM4MykiIC8+CiAgICAgICAgPC9jbGlwUGF0aD4KICAgIDwvZGVmcz4KPC9zdmc+CiAgICA=";

/* loaded by smart-asset */
var register = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxNiAxOCIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTEzLjUwMjEgNy45NTgyOUMxMy43MjM0IDcuOTU4MjkgMTMuOTI5IDcuOTk4OTggMTQuMTE4NyA4LjA4MDM2QzE0LjMwODQgOC4xNjE3NCAxNC40NzcxIDguMjc1NjggMTQuNjI0NyA4LjQyMjE2QzE0Ljc3MjIgOC41Njg2NCAxNC44ODI5IDguNzM5NTQgMTQuOTU2NyA4LjkzNDg1QzE1LjAzMDUgOS4xMzAxNyAxNS4wNzI2IDkuMzQxNzYgMTUuMDgzMiA5LjU2OTYyQzE1LjA4MzIgOS43ODEyMSAxNS4wNDM2IDkuOTg3MzcgMTQuOTY0NiAxMC4xODgxQzE0Ljg4NTUgMTAuMzg4OCAxNC43NzIyIDEwLjU2NTIgMTQuNjI0NyAxMC43MTcxTDguOTU2NCAxNi41NjgzTDUuOTc2MDMgMTcuMzMzM0w2LjcxOTE1IDE0LjI2NTNMMTIuMzg3NCA4LjQyMjE2QzEyLjUzNSA4LjI3MDI1IDEyLjcwNjIgOC4xNTYzMiAxMi45MDEzIDguMDgwMzZDMTMuMDk2MyA4LjAwNDQxIDEzLjI5NjUgNy45NjM3MiAxMy41MDIxIDcuOTU4MjlaTTEzLjkwNTMgOS45ODQ2NkMxNC4wMTU5IDkuODcwNzMgMTQuMDcxMyA5LjczMjM4IDE0LjA3MTMgOS41Njk2MkMxNC4wNzEzIDkuNDAxNDMgMTQuMDE4NiA5LjI2NTggMTMuOTEzMiA5LjE2MjcyQzEzLjgwNzcgOS4wNTk2NCAxMy42NzA3IDkuMDA1MzggMTMuNTAyMSA4Ljk5OTk2QzEzLjQyODMgOC45OTk5NiAxMy4zNTcxIDkuMDEwODEgMTMuMjg4NiA5LjAzMjUxQzEzLjIyMDEgOS4wNTQyMSAxMy4xNTk1IDkuMDk0OSAxMy4xMDY4IDkuMTU0NThMNy42MzYxOCAxNC44MDI0TDcuMzY3NCAxNS45MDFMOC40MzQ2NCAxNS42MjQzTDEzLjkwNTMgOS45ODQ2NlpNMy45NTIyMiA3Ljk1ODI5SDIuOTQwMzFWNi45MTY2M0gzLjk1MjIyVjcuOTU4MjlaTTExLjAzNTYgNy45NTgyOUg0Ljk2NDEyVjYuOTE2NjNIMTEuMDM1NlY3Ljk1ODI5Wk0yLjk0MDMxIDEwLjA0MTZIMy45NTIyMlYxMS4wODMzSDIuOTQwMzFWMTAuMDQxNlpNMy45NTIyMiA0LjgzMzI5SDIuOTQwMzFWMy43OTE2M0gzLjk1MjIyVjQuODMzMjlaTTExLjAzNTYgNC44MzMyOUg0Ljk2NDEyVjMuNzkxNjNIMTEuMDM1NlY0LjgzMzI5Wk0xLjkyODQxIDE0LjIwODNINS40MzA1NUw1LjE3NzU3IDE1LjI1SDAuOTE2NTA0VjAuNjY2NjI2SDEzLjA1OTRWNi43MTMxOEMxMi43MDYyIDYuNzY3NDMgMTIuMzY4OSA2Ljg4Njc5IDEyLjA0NzUgNy4wNzEyNVYxLjcwODI5SDEuOTI4NDFWMTQuMjA4M1pNNC45NjQxMiAxMC4wNDE2SDkuMDI3NTVMOC4wMTU2NSAxMS4wODMzSDQuOTY0MTJWMTAuMDQxNloiCiAgICAvPgo8L3N2Zz4KICAgIA==";

/* loaded by smart-asset */
var activate = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTE2LjkxNjUgNi40OTk5NkgxMi43NDk4TDE0LjI5OTggNC45NDk5NkMxMy42Nzc1IDQuMTM1MjQgMTIuODc1NCAzLjQ3NTI0IDExLjk1NjEgMy4wMjEzN0MxMS4wMzY4IDIuNTY3NSAxMC4wMjUxIDIuMzMyMDIgOC45OTk4NCAyLjMzMzI5QzUuMzE2NSAyLjMzMzI5IDIuMzMzMTcgNS4zMTY2MyAyLjMzMzE3IDguOTk5OTZDMi4zMzMxNyAxMC41MjUgMi44NDE1IDExLjkxNjYgMy42OTk4NCAxMy4wNDE2QzQuNzE2NSAxMS44NzUgNi42MjQ4NCAxMS4wODMzIDguOTk5ODQgMTEuMDgzM0MxMS4zNzQ4IDExLjA4MzMgMTMuMjkxNSAxMS44NzUgMTQuMjk5OCAxMy4wNDE2QzE1LjE4ODkgMTEuODgyMSAxNS42Njk0IDEwLjQ2MTEgMTUuNjY2NSA4Ljk5OTk2SDE3LjMzMzJDMTcuMzMzMiAxMy41ODMzIDEzLjU4MzIgMTcuMzMzMyA4Ljk5OTg0IDE3LjMzMzNDNC40MTY1IDE3LjMzMzMgMC42NjY1MDQgMTMuNTgzMyAwLjY2NjUwNCA4Ljk5OTk2QzAuNjY2NTA0IDQuNDE2NjMgNC40MTY1IDAuNjY2NjI2IDguOTk5ODQgMC42NjY2MjZDMTEuNjE2NSAwLjY2NjYyNiAxMy45NTgyIDEuODc0OTYgMTUuNDgzMiAzLjc2NjYzTDE2LjkxNjUgMi4zMzMyOVY2LjQ5OTk2Wk04Ljk5OTg0IDE1LjY2NjZDMTAuNTgzMiAxNS42NjY2IDEyLjAzMzIgMTUuMTE2NiAxMy4xNjY1IDE0LjJDMTIuNjMzMiAxMy4zNTgzIDExLjA0MTUgMTIuNzUgOC45OTk4NCAxMi43NUM2Ljk1ODE3IDEyLjc1IDUuMzY2NSAxMy4zNTgzIDQuODMzMTcgMTQuMkM1Ljk2NjUgMTUuMTE2NiA3LjQxNjUgMTUuNjY2NiA4Ljk5OTg0IDE1LjY2NjZaTTguOTk5ODQgMy45OTk5NkMxMC42MDgyIDMuOTk5OTYgMTEuOTE2NSA1LjMwODI5IDExLjkxNjUgNi45MTY2M0MxMS45MTY1IDguNTI0OTYgMTAuNjA4MiA5LjgzMzI5IDguOTk5ODQgOS44MzMyOUM3LjM5MTUgOS44MzMyOSA2LjA4MzE3IDguNTI0OTYgNi4wODMxNyA2LjkxNjYzQzYuMDgzMTcgNS4zMDgyOSA3LjM5MTUgMy45OTk5NiA4Ljk5OTg0IDMuOTk5OTZaTTguOTk5ODQgNS42NjY2M0M4LjMwODE3IDUuNjY2NjMgNy43NDk4NCA2LjIyNDk2IDcuNzQ5ODQgNi45MTY2M0M3Ljc0OTg0IDcuNjA4MjkgOC4zMDgxNyA4LjE2NjYzIDguOTk5ODQgOC4xNjY2M0M5LjY5MTUgOC4xNjY2MyAxMC4yNDk4IDcuNjA4MjkgMTAuMjQ5OCA2LjkxNjYzQzEwLjI0OTggNi4yMjQ5NiA5LjY5MTUgNS42NjY2MyA4Ljk5OTg0IDUuNjY2NjNaIgogICAgLz4KPC9zdmc+";

/* loaded by smart-asset */
var deactivate = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTIuMDgzNSA3LjQ5OTk2SDYuMjUwMTZMNC43MDAxNiA1Ljk0OTk2QzUuMzIyNTQgNS4xMzUyNCA2LjEyNDYzIDQuNDc1MjQgNy4wNDM5NCA0LjAyMTM3QzcuOTYzMjQgMy41Njc1IDguOTc0OTMgMy4zMzIwMiAxMC4wMDAyIDMuMzMzMjlDMTMuNjgzNSAzLjMzMzI5IDE2LjY2NjggNi4zMTY2MyAxNi42NjY4IDkuOTk5OTZDMTYuNjY2OCAxMS41MjUgMTYuMTU4NSAxMi45MTY2IDE1LjMwMDIgMTQuMDQxNkMxNC4yODM1IDEyLjg3NSAxMi4zNzUyIDEyLjA4MzMgMTAuMDAwMiAxMi4wODMzQzcuNjI1MTYgMTIuMDgzMyA1LjcwODUgMTIuODc1IDQuNzAwMTYgMTQuMDQxNkMzLjgxMTEyIDEyLjg4MjEgMy4zMzA2IDExLjQ2MTEgMy4zMzM1IDkuOTk5OTZIMS42NjY4M0MxLjY2NjgzIDE0LjU4MzMgNS40MTY4MyAxOC4zMzMzIDEwLjAwMDIgMTguMzMzM0MxNC41ODM1IDE4LjMzMzMgMTguMzMzNSAxNC41ODMzIDE4LjMzMzUgOS45OTk5NkMxOC4zMzM1IDUuNDE2NjMgMTQuNTgzNSAxLjY2NjYzIDEwLjAwMDIgMS42NjY2M0M3LjM4MzUgMS42NjY2MyA1LjA0MTgzIDIuODc0OTYgMy41MTY4MyA0Ljc2NjYzTDIuMDgzNSAzLjMzMzI5VjcuNDk5OTZaTTEwLjAwMDIgMTYuNjY2NkM4LjQxNjgzIDE2LjY2NjYgNi45NjY4MyAxNi4xMTY2IDUuODMzNSAxNS4yQzYuMzY2ODMgMTQuMzU4MyA3Ljk1ODUgMTMuNzUgMTAuMDAwMiAxMy43NUMxMi4wNDE4IDEzLjc1IDEzLjYzMzUgMTQuMzU4MyAxNC4xNjY4IDE1LjJDMTMuMDMzNSAxNi4xMTY2IDExLjU4MzUgMTYuNjY2NiAxMC4wMDAyIDE2LjY2NjZaTTEwLjAwMDIgNC45OTk5NkM4LjM5MTgzIDQuOTk5OTYgNy4wODM1IDYuMzA4MjkgNy4wODM1IDcuOTE2NjNDNy4wODM1IDkuNTI0OTYgOC4zOTE4MyAxMC44MzMzIDEwLjAwMDIgMTAuODMzM0MxMS42MDg1IDEwLjgzMzMgMTIuOTE2OCA5LjUyNDk2IDEyLjkxNjggNy45MTY2M0MxMi45MTY4IDYuMzA4MjkgMTEuNjA4NSA0Ljk5OTk2IDEwLjAwMDIgNC45OTk5NlpNMTAuMDAwMiA2LjY2NjYzQzEwLjY5MTggNi42NjY2MyAxMS4yNTAyIDcuMjI0OTYgMTEuMjUwMiA3LjkxNjYzQzExLjI1MDIgOC42MDgyOSAxMC42OTE4IDkuMTY2NjMgMTAuMDAwMiA5LjE2NjYzQzkuMzA4NSA5LjE2NjYzIDguNzUwMTYgOC42MDgyOSA4Ljc1MDE2IDcuOTE2NjNDOC43NTAxNiA3LjIyNDk2IDkuMzA4NSA2LjY2NjYzIDEwLjAwMDIgNi42NjY2M1oiCiAgICAvPgo8L3N2Zz4=";

/* loaded by smart-asset */
var assessment = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var course = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNzE2NTk2IgogICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTE3Ljk5OTMgMTMuNTkwMkwxMi45NTIxIDEwLjI4NjFMMTMuNDA3NCAxNi4yMzc0TDE0Ljc3OTggMTQuOEwxNi42MjcgMThMMTcuMjcwOSAxNy42MjkzTDE3LjkxNDggMTcuMjUyTDE2LjA2NzYgMTQuMDUyTDE3Ljk5OTMgMTMuNTkwMloiCiAgICAgICAgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CiAgICA8cGF0aAogICAgICAgIGQ9Ik0xMS43ODg5IDEzLjMwOTlDMTEuMjc1IDEzLjQxMzkgMTAuNjgzMiAxMy40NzI1IDEwLjAwMDIgMTMuNDcyNUM2LjAxOTczIDEzLjQ3MjUgNS4xMjg2NiAxMS4zODQ2IDUuMTI4NjYgMTEuMzg0NlY3LjMxOTU4IgogICAgICAgIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgogICAgPHBhdGggZD0iTTE0Ljg3MTggNy41NjEwNFY5LjgzNzQ3IiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIgogICAgICAgIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KICAgIDxwYXRoIGQ9Ik01LjEyODQ4IDcuMzIwMzZMMiA1LjgyNDQyTDEwLjAwMDEgMkwxOC4wMDAxIDUuODI0NDJMMTAuMDAwMSA5LjY0ODgzTDUuMTI4NDggNy4zMjAzNloiCiAgICAgICAgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogICAgICAgIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CiAgICA8cGF0aCBkPSJNMy4zOTI4MiA2LjQ4ODA0VjEyLjQzMjgiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiCiAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgogICAgPHBhdGgKICAgICAgICBkPSJNMi4zNDQ3MyAxMy40NzMzQzIuMzQ0NzMgMTQuMDUyMSAyLjgxMzAyIDE0LjUxMzkgMy4zODUzOCAxNC41MTM5QzMuOTY0MjUgMTQuNTEzOSA0LjQyNjA0IDE0LjA0NTYgNC40MjYwNCAxMy40NzMzQzQuNDI2MDQgMTIuODk0NCAzLjk1Nzc1IDEyLjQzMjYgMy4zODUzOCAxMi40MzI2QzIuODEzMDIgMTIuNDMyNiAyLjM0NDczIDEyLjkwMDkgMi4zNDQ3MyAxMy40NzMzWiIKICAgICAgICBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiCiAgICAgICAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4KPC9zdmc+CiAgICA=";

/* loaded by smart-asset */
var usersEvent = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTExLjUwMSA2LjgyNDgzQzEyLjMzNzQgNi4zNDA1NSAxMi45IDUuNDM1OTggMTIuOSA0LjRDMTIuOSAzLjM2NDE0IDEyLjMzNzUgMi40NTk2NiAxMS41MDEzIDEuOTc1MzRDMTEuMDggMS4xNzc0NSAxMC40NTcyIDAuNTAyMzkgOS43MDA2NiAwLjAxNzg3NzdDOS44MzIxOSAwLjAwNjA0NDc3IDkuOTY1MzkgMCAxMC4xIDBDMTIuNTMwMSAwIDE0LjUgMS45Njk5NSAxNC41IDQuNEMxNC41IDUuNzk3NjUgMTMuODQ4MyA3LjA0MzA5IDEyLjgzMjMgNy44NDkwN0MxNS4wMDAyIDguOTM4MTMgMTYuNSAxMS4yODMgMTYuNSAxNFYxNS4yQzE2LjUgMTUuNjQxOCAxNi4xNjI5IDE2IDE1Ljc0NzEgMTZDMTUuMzMxMiAxNiAxNC45OTQxIDE1LjY0MTggMTQuOTk0MSAxNS4yVjE0QzE0Ljk5NDEgMTIuMTk5NiAxNC4xMzMgMTAuNjEzIDEyLjgyNDUgOS42Nzk2QzEyLjMxNDMgOC45MDExNyAxMS42NjkyIDguMjI2OTggMTAuOTIyNSA3LjY5NTQyQzExLjE0MzEgNy40MjY0OSAxMS4zMzcyIDcuMTM0OTYgMTEuNTAxIDYuODI0ODNaIgogICAgLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgIGQ9Ik05LjYzMjMgNy44NDkwN0MxMC42NDgzIDcuMDQzMDkgMTEuMyA1Ljc5NzY1IDExLjMgNC40QzExLjMgMS45Njk5NSA5LjMzMDA1IDAgNi45IDBDNC40Njk5NSAwIDIuNSAxLjk2OTk1IDIuNSA0LjRDMi41IDUuNzk3NjUgMy4xNTE2NSA3LjA0MzA5IDQuMTY3NyA3Ljg0OTA3QzEuOTk5NzcgOC45MzgxMyAwLjUgMTEuMjgzIDAuNSAxNFYxNS4yQzAuNSAxNS42NDE4IDAuODM3MTAzIDE2IDEuMjUyOTQgMTZDMS42Njg3OCAxNiAyLjAwNTg4IDE1LjY0MTggMi4wMDU4OCAxNS4yVjE0QzIuMDA1ODggMTEuMTI4MSA0LjE5NzA1IDguOCA2LjkgOC44QzkuNjAyOTUgOC44IDExLjc5NDEgMTEuMTI4MSAxMS43OTQxIDE0VjE1LjJDMTEuNzk0MSAxNS42NDE4IDEyLjEzMTIgMTYgMTIuNTQ3MSAxNkMxMi45NjI5IDE2IDEzLjMgMTUuNjQxOCAxMy4zIDE1LjJWMTRDMTMuMyAxMS4yODMgMTEuODAwMiA4LjkzODEzIDkuNjMyMyA3Ljg0OTA3Wk02LjkgNy4yQzguNDQ2NCA3LjIgOS43IDUuOTQ2NCA5LjcgNC40QzkuNyAyLjg1MzYgOC40NDY0IDEuNiA2LjkgMS42QzUuMzUzNiAxLjYgNC4xIDIuODUzNiA0LjEgNC40QzQuMSA1Ljk0NjQgNS4zNTM2IDcuMiA2LjkgNy4yWiIKICAgIC8+Cjwvc3ZnPgogICAg";

/* loaded by smart-asset */
var learningPath = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var lesson = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var setPrimaryCourse = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var skillTreeEvent = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjkiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyOSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xMy43OTIyIDEzLjQ5NDZMMTMuNzkyMiA2LjY0OTA0IiBzdHJva2U9IiM3MTY1OTYiIHN0cm9rZS13aWR0aD0iMS4yNjIxNCIgLz4KICAgIDxwYXRoIGQ9Ik04Ljc4ODA5IDE4LjUzMzlMNC4zNTg3NCAxNC4xMDQ2IiBzdHJva2U9IiM3MTY1OTYiIHN0cm9rZS13aWR0aD0iMS4yNjIxNCIgLz4KICAgIDxwYXRoIGQ9Ik0xOS4xOTYzIDE4LjUzM0wyMy42Mjc2IDE0LjEwMTYiIHN0cm9rZT0iIzcxNjU5NiIgc3Ryb2tlLXdpZHRoPSIxLjI2MjE0IiAvPgogICAgPHBhdGgKICAgICAgICBkPSJNNy40NDcwMiAxOC42MDE2QzcuNDQ3MDIgMTguNjAxNiA3Ljk0NjQ2IDExLjU4MTUgMTMuOTI3MSAxMS41ODE1QzE5LjkwNzcgMTEuNTgxNSAyMC40MDcxIDE4LjYwMTYgMjAuNDA3MSAxOC42MDE2IgogICAgICAgIHN0cm9rZT0iIzcxNjU5NiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgLz4KICAgIDxjaXJjbGUgY3g9IjIuMTYwMDEiIGN5PSIyLjE2MDAxIiByPSIyLjE2MDAxIiB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAxNy45ODU2IDE5LjM5MDQpIgogICAgICAgIGZpbGw9IiM3MTY1OTYiIC8+CiAgICA8Y2lyY2xlIGN4PSIyLjE2MDAxIiBjeT0iMi4xNjAwMSIgcj0iMi4xNjAwMSIgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgNS41MjAwMiAxOS41KSIKICAgICAgICBmaWxsPSIjNzE2NTk2IiAvPgogICAgPGNpcmNsZSBjeD0iMi4xNjAwMSIgY3k9IjIuMTYwMDEiIHI9IjEuNTI4OTUiIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIC0xIDExLjY3MTEgMTMuOTA1NSkiCiAgICAgICAgZmlsbD0iIzcxNjU5NiIgc3Ryb2tlPSIjNzE2NTk2IiBzdHJva2Utd2lkdGg9IjEuMjYyMTQiIC8+CiAgICA8Y2lyY2xlIGN4PSIzIiBjeT0iMTIiIHI9IjIuMzY4OTMiIHN0cm9rZT0iIzcxNjU5NiIgc3Ryb2tlLXdpZHRoPSIxLjI2MjE0IiAvPgogICAgPGNpcmNsZSBjeD0iMTQiIGN5PSI0IiByPSIyLjM2ODkzIiBzdHJva2U9IiM3MTY1OTYiIHN0cm9rZS13aWR0aD0iMS4yNjIxNCIgLz4KICAgIDxjaXJjbGUgY3g9IjI1LjUiIGN5PSIxMiIgcj0iMi4zNjg5MyIgc3Ryb2tlPSIjNzE2NTk2IiBzdHJva2Utd2lkdGg9IjEuMjYyMTQiIC8+Cjwvc3ZnPgogICAg";

/* loaded by smart-asset */
var user = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0iIzcxNjU5NiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgIGQ9Ik0xMS4zMDAxIDQuNEMxMS4zMDAxIDUuOTQ2NCAxMC4wNDY1IDcuMiA4LjUwMDEgNy4yQzYuOTUzNyA3LjIgNS43MDAxIDUuOTQ2NCA1LjcwMDEgNC40QzUuNzAwMSAyLjg1MzYgNi45NTM3IDEuNiA4LjUwMDEgMS42QzEwLjA0NjUgMS42IDExLjMwMDEgMi44NTM2IDExLjMwMDEgNC40Wk0xMS4yMzI0IDcuODQ5MDdDMTIuMjQ4NCA3LjA0MzA5IDEyLjkwMDEgNS43OTc2NSAxMi45MDAxIDQuNEMxMi45MDAxIDEuOTY5OTUgMTAuOTMwMiAwIDguNTAwMSAwQzYuMDcwMDQgMCA0LjEwMDEgMS45Njk5NSA0LjEwMDEgNC40QzQuMTAwMSA1Ljc5NzY1IDQuNzUxNzUgNy4wNDMwOSA1Ljc2NzggNy44NDkwN0MzLjU5OTg3IDguOTM4MTMgMi4xMDAxIDExLjI4MyAyLjEwMDEgMTRWMTUuMkMyLjEwMDEgMTUuNjQxOCAyLjQzNzIgMTYgMi44NTMwNCAxNkMzLjI2ODg4IDE2IDMuNjA1OTggMTUuNjQxOCAzLjYwNTk4IDE1LjJWMTRDMy42MDU5OCAxMS4xMjgxIDUuNzk3MTUgOC44IDguNTAwMSA4LjhDMTEuMjAzIDguOCAxMy4zOTQyIDExLjEyODEgMTMuMzk0MiAxNFYxNS4yQzEzLjM5NDIgMTUuNjQxOCAxMy43MzEzIDE2IDE0LjE0NzIgMTZDMTQuNTYzIDE2IDE0LjkwMDEgMTUuNjQxOCAxNC45MDAxIDE1LjJWMTRDMTQuOTAwMSAxMS4yODMgMTMuNDAwMyA4LjkzODEzIDExLjIzMjQgNy44NDkwN1oiCiAgICAvPgo8L3N2Zz4KICAgIA==";

/* loaded by smart-asset */
var videoTutorial = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var adminWarning = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var surveyYes = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkNoZWNrIj4KPHBhdGggaWQ9IlZlY3RvciAxNTQgKFN0cm9rZSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuODI0MyAxLjg3NTY5QzEyLjA1ODYgMi4xMSAxMi4wNTg2IDIuNDg5OSAxMS44MjQzIDIuNzI0MjJMNC41MzY0IDEwLjAxMjFDNC4xODQ5MiAxMC4zNjM2IDMuNjE1MDggMTAuMzYzNiAzLjI2MzYgMTAuMDEyMUwwLjE3NTczNiA2LjkyNDIyQy0wLjA1ODU3ODcgNi42ODk5IC0wLjA1ODU3ODcgNi4zMSAwLjE3NTczNiA2LjA3NTY5QzAuNDEwMDUxIDUuODQxMzcgMC43ODk5NSA1Ljg0MTM3IDEuMDI0MjYgNi4wNzU2OUwzLjkgOC45NTE0MkwxMC45NzU3IDEuODc1NjlDMTEuMjEwMSAxLjY0MTM3IDExLjU4OTkgMS42NDEzNyAxMS44MjQzIDEuODc1NjlaIiBmaWxsPSIjNzE2NTk2Ii8+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var surveyNo = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMiAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkNsb3NlIj4KPHBhdGggaWQ9IlZlY3RvciAxNTUgKFN0cm9rZSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMS4zNzU5MyAxLjg3NTY5QzEuNjEwMjUgMS42NDEzNyAxLjk5MDE0IDEuNjQxMzcgMi4yMjQ0NiAxLjg3NTY5TDYuMDAwMiA1LjY1MTQyTDkuNzc1OTMgMS44NzU2OUMxMC4wMTAyIDEuNjQxMzcgMTAuMzkwMSAxLjY0MTM3IDEwLjYyNDUgMS44NzU2OUMxMC44NTg4IDIuMTEgMTAuODU4OCAyLjQ4OTkgMTAuNjI0NSAyLjcyNDIyTDYuODQ4NzIgNi40OTk5NUwxMC42MjQ1IDEwLjI3NTdDMTAuODU4OCAxMC41MSAxMC44NTg4IDEwLjg4OTkgMTAuNjI0NSAxMS4xMjQyQzEwLjM5MDEgMTEuMzU4NSAxMC4wMTAyIDExLjM1ODUgOS43NzU5MyAxMS4xMjQyTDYuMDAwMiA3LjM0ODQ4TDIuMjI0NDYgMTEuMTI0MkMxLjk5MDE0IDExLjM1ODUgMS42MTAyNSAxMS4zNTg1IDEuMzc1OTMgMTEuMTI0MkMxLjE0MTYyIDEwLjg4OTkgMS4xNDE2MiAxMC41MSAxLjM3NTkzIDEwLjI3NTdMNS4xNTE2NyA2LjQ5OTk1TDEuMzc1OTMgMi43MjQyMkMxLjE0MTYyIDIuNDg5OSAxLjE0MTYyIDIuMTEgMS4zNzU5MyAxLjg3NTY5WiIgZmlsbD0iIzk2NjU3MSIvPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var surveyMaybe = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var heart = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzIiIGhlaWdodD0iNjkiIHZpZXdCb3g9IjAgMCA3MiA2OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfYmRkXzM3MzlfMjg2NjcpIj4KPHBhdGggZD0iTTMwLjQ1OCAyNEMyOS4xODA3IDIzLjk5OTkgMjcuOTMyMSAyNC4zNzg2IDI2Ljg3MDEgMjUuMDg4MkMyNS44MDgxIDI1Ljc5NzcgMjQuOTgwNCAyNi44MDYzIDI0LjQ5MTYgMjcuOTg2M0MyNC4wMDI4IDI5LjE2NjQgMjMuODc0OSAzMC40NjQ4IDI0LjEyNDEgMzEuNzE3NUMyNC4zNzMzIDMyLjk3MDIgMjQuOTg4NCAzNC4xMjA5IDI1Ljg5MTYgMzUuMDI0TDM1LjQzNCA0NC41NjY0QzM1LjUwODMgNDQuNjQwOSAzNS41OTY2IDQ0LjcgMzUuNjkzOCA0NC43NDAzQzM1Ljc5MSA0NC43ODA3IDM1Ljg5NTIgNDQuODAxNCAzNi4wMDA0IDQ0LjgwMTRDMzYuMTA1NiA0NC44MDE0IDM2LjIwOTggNDQuNzgwNyAzNi4zMDcgNDQuNzQwM0MzNi40MDQyIDQ0LjcgMzYuNDkyNSA0NC42NDA5IDM2LjU2NjggNDQuNTY2NEw0Ni4xMDkyIDM1LjAyMjRDNDcuMjg3NSAzMy44MDQ5IDQ3Ljk0IDMyLjE3MyA0Ny45MjYyIDMwLjQ3ODdDNDcuOTEyMyAyOC43ODQ0IDQ3LjIzMzEgMjcuMTYzNSA0Ni4wMzUgMjUuOTY1NEM0NC44MzY5IDI0Ljc2NzMgNDMuMjE2IDI0LjA4ODEgNDEuNTIxNyAyNC4wNzQyQzM5LjgyNzQgMjQuMDYwMyAzOC4xOTU1IDI0LjcxMjkgMzYuOTc4IDI1Ljg5MTJMMzYuMDAwNCAyNi44NjcyTDM1LjAyNDQgMjUuODkxMkMzNC40MjQ1IDI1LjI5MTQgMzMuNzEyMyAyNC44MTU2IDMyLjkyODUgMjQuNDkxMUMzMi4xNDQ3IDI0LjE2NjYgMzEuMzA2MyAyMy45OTk3IDMwLjQ1OCAyNFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0zMC40NTggMjRDMjkuMTgwNyAyMy45OTk5IDI3LjkzMjEgMjQuMzc4NiAyNi44NzAxIDI1LjA4ODJDMjUuODA4MSAyNS43OTc3IDI0Ljk4MDQgMjYuODA2MyAyNC40OTE2IDI3Ljk4NjNDMjQuMDAyOCAyOS4xNjY0IDIzLjg3NDkgMzAuNDY0OCAyNC4xMjQxIDMxLjcxNzVDMjQuMzczMyAzMi45NzAyIDI0Ljk4ODQgMzQuMTIwOSAyNS44OTE2IDM1LjAyNEwzNS40MzQgNDQuNTY2NEMzNS41MDgzIDQ0LjY0MDkgMzUuNTk2NiA0NC43IDM1LjY5MzggNDQuNzQwM0MzNS43OTEgNDQuNzgwNyAzNS44OTUyIDQ0LjgwMTQgMzYuMDAwNCA0NC44MDE0QzM2LjEwNTYgNDQuODAxNCAzNi4yMDk4IDQ0Ljc4MDcgMzYuMzA3IDQ0Ljc0MDNDMzYuNDA0MiA0NC43IDM2LjQ5MjUgNDQuNjQwOSAzNi41NjY4IDQ0LjU2NjRMNDYuMTA5MiAzNS4wMjI0QzQ3LjI4NzUgMzMuODA0OSA0Ny45NCAzMi4xNzMgNDcuOTI2MiAzMC40Nzg3QzQ3LjkxMjMgMjguNzg0NCA0Ny4yMzMxIDI3LjE2MzUgNDYuMDM1IDI1Ljk2NTRDNDQuODM2OSAyNC43NjczIDQzLjIxNiAyNC4wODgxIDQxLjUyMTcgMjQuMDc0MkMzOS44Mjc0IDI0LjA2MDMgMzguMTk1NSAyNC43MTI5IDM2Ljk3OCAyNS44OTEyTDM2LjAwMDQgMjYuODY3MkwzNS4wMjQ0IDI1Ljg5MTJDMzQuNDI0NSAyNS4yOTE0IDMzLjcxMjMgMjQuODE1NiAzMi45Mjg1IDI0LjQ5MTFDMzIuMTQ0NyAyNC4xNjY2IDMxLjMwNjMgMjMuOTk5NyAzMC40NTggMjRaIiBmaWxsPSIjRTJEOEY3Ii8+CjxwYXRoIGQ9Ik0zMC40NTc5IDI0LjVMMzAuNDU4MSAyNC41QzMxLjI0MDYgMjQuNDk5OCAzMi4wMTQxIDI0LjY1MzcgMzIuNzM3MyAyNC45NTMxQzMzLjQ2MDQgMjUuMjUyNSAzNC4xMTc0IDI1LjY5MTQgMzQuNjcwOCAyNi4yNDQ4TDM1LjY0NjggMjcuMjIwOEwzNi4wMDAxIDI3LjU3NEwzNi4zNTM2IDI3LjIyMUwzNy4zMjg0IDI2LjI0NzlDMzguNDUxNCAyNS4xNjI1IDM5Ljk1NTcgMjQuNTYxNCA0MS41MTc2IDI0LjU3NDJDNDMuMDgwNyAyNC41ODcgNDQuNTc2MSAyNS4yMTM2IDQ1LjY4MTQgMjYuMzE4OUM0Ni43ODY3IDI3LjQyNDMgNDcuNDEzNCAyOC45MTk3IDQ3LjQyNjIgMzAuNDgyOEM0Ny40MzkgMzIuMDQ0NiA0Ni44MzggMzMuNTQ4OCA0NS43NTI3IDM0LjY3MThMMzYuMjEzMiA0NC4yMTI5TDM2LjIxMjggNDQuMjEzM0MzNi4xODQ5IDQ0LjI0MTIgMzYuMTUxOCA0NC4yNjM0IDM2LjExNTQgNDQuMjc4NUMzNi4wNzg5IDQ0LjI5MzYgMzYuMDM5OCA0NC4zMDE0IDM2LjAwMDQgNDQuMzAxNEMzNS45NjA5IDQ0LjMwMTQgMzUuOTIxOCA0NC4yOTM2IDM1Ljg4NTQgNDQuMjc4NUMzNS44NDkgNDQuMjYzNCAzNS44MTU4IDQ0LjI0MTIgMzUuNzg4IDQ0LjIxMzNMMzUuNzg3NSA0NC4yMTI4TDI2LjI0NTEgMzQuNjcwNEwyNi4yNDUxIDM0LjY3MDRDMjUuNDExOSAzMy44MzcyIDI0Ljg0NDQgMzIuNzc1NyAyNC42MTQ1IDMxLjYyQzI0LjM4NDYgMzAuNDY0MyAyNC41MDI2IDI5LjI2NjMgMjQuOTUzNSAyOC4xNzc3QzI1LjQwNDUgMjcuMDg5IDI2LjE2ODEgMjYuMTU4NiAyNy4xNDc5IDI1LjUwMzlDMjguMTI3NyAyNC44NDkzIDI5LjI3OTYgMjQuNDk5OSAzMC40NTc5IDI0LjVaIiBzdHJva2U9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfYmRkXzM3MzlfMjg2NjciIHg9IjAiIHk9IjAiIHdpZHRoPSI3MS45MjYzIiBoZWlnaHQ9IjY4LjgwMTQiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlR2F1c3NpYW5CbHVyIGluPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHN0ZERldmlhdGlvbj0iMTEiLz4KPGZlQ29tcG9zaXRlIGluMj0iU291cmNlQWxwaGEiIG9wZXJhdG9yPSJpbiIgcmVzdWx0PSJlZmZlY3QxX2JhY2tncm91bmRCbHVyXzM3MzlfMjg2NjciLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeD0iOCIgZHk9IjgiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iOCIvPgo8ZmVDb21wb3NpdGUgaW4yPSJoYXJkQWxwaGEiIG9wZXJhdG9yPSJvdXQiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMC44NzA1ODggMCAwIDAgMCAwLjg3MDU4OCAwIDAgMCAwIDAuOTYwNzg0IDAgMCAwIDAuNyAwIi8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW4yPSJlZmZlY3QxX2JhY2tncm91bmRCbHVyXzM3MzlfMjg2NjciIHJlc3VsdD0iZWZmZWN0Ml9kcm9wU2hhZG93XzM3MzlfMjg2NjciLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldCBkeD0iLTgiIGR5PSItOCIvPgo8ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSI4Ii8+CjxmZUNvbXBvc2l0ZSBpbjI9ImhhcmRBbHBoYSIgb3BlcmF0b3I9Im91dCIvPgo8ZmVDb2xvck1hdHJpeCB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAxIDAgMCAwIDAgMSAwIDAgMCAwIDEgMCAwIDAgMC43IDAiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbjI9ImVmZmVjdDJfZHJvcFNoYWRvd18zNzM5XzI4NjY3IiByZXN1bHQ9ImVmZmVjdDNfZHJvcFNoYWRvd18zNzM5XzI4NjY3Ii8+CjxmZUJsZW5kIG1vZGU9Im5vcm1hbCIgaW49IlNvdXJjZUdyYXBoaWMiIGluMj0iZWZmZWN0M19kcm9wU2hhZG93XzM3MzlfMjg2NjciIHJlc3VsdD0ic2hhcGUiLz4KPC9maWx0ZXI+CjwvZGVmcz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var infiniteScroll = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var searchIconGray = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNCAxMEMxNCAxMi4yMDkxIDEyLjIwOTEgMTQgMTAgMTRDNy43OTA4NiAxNCA2IDEyLjIwOTEgNiAxMEM2IDcuNzkwODYgNy43OTA4NiA2IDEwIDZDMTIuMjA5MSA2IDE0IDcuNzkwODYgMTQgMTBaTTEzLjUxODkgMTQuODYwM0MxMi41MzA0IDE1LjU3NzMgMTEuMzE0NiAxNiAxMCAxNkM2LjY4NjI5IDE2IDQgMTMuMzEzNyA0IDEwQzQgNi42ODYyOSA2LjY4NjI5IDQgMTAgNEMxMy4zMTM3IDQgMTYgNi42ODYyOSAxNiAxMEMxNiAxMS4zMTQ2IDE1LjU3NzIgMTIuNTMwNCAxNC44NjAzIDEzLjUxODlDMTQuOTU0NSAxMy41NjU5IDE1LjA0MjggMTMuNjI4NiAxNS4xMjEzIDEzLjcwNzFMMTguNjU2OSAxNy4yNDI2QzE5LjA0NzQgMTcuNjMzMiAxOS4wNDc0IDE4LjI2NjMgMTguNjU2OSAxOC42NTY5QzE4LjI2NjMgMTkuMDQ3NCAxNy42MzMyIDE5LjA0NzQgMTcuMjQyNiAxOC42NTY5TDEzLjcwNzEgMTUuMTIxM0MxMy42Mjg2IDE1LjA0MjggMTMuNTY1OSAxNC45NTQ1IDEzLjUxODkgMTQuODYwM1oiIGZpbGw9IiM2MjYyNjIiIGZpbGwtb3BhY2l0eT0iMC41Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var heartNowShadow = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var whiteCheck = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkNoZWNrIj4KPHBhdGggaWQ9IlZlY3RvciAxNTQgKFN0cm9rZSkiIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTUuNzY1NyAyLjMzNDQxQzE2LjA3ODEgMi42NDY4MyAxNi4wNzgxIDMuMTUzMzYgMTUuNzY1NyAzLjQ2NTc4TDYuMDQ4NTMgMTMuMTgyOUM1LjU3OTkgMTMuNjUxNiA0LjgyMDEgMTMuNjUxNiA0LjM1MTQ3IDEzLjE4MjlMMC4yMzQzMTUgOS4wNjU3OEMtMC4wNzgxMDQ5IDguNzUzMzYgLTAuMDc4MTA0OSA4LjI0NjgzIDAuMjM0MzE1IDcuOTM0NDFDMC41NDY3MzQgNy42MjE5OSAxLjA1MzI3IDcuNjIxOTkgMS4zNjU2OSA3LjkzNDQxTDUuMiAxMS43Njg3TDE0LjYzNDMgMi4zMzQ0MUMxNC45NDY3IDIuMDIxOTkgMTUuNDUzMyAyLjAyMTk5IDE1Ljc2NTcgMi4zMzQ0MVoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var downloadHub = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNiAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNDkzMjcgOS40MzMwM0MzLjY1NTExIDkuNDMzMDMgMi44NTEyOSA5LjExNDU1IDIuMjU4NjMgOC41NDc2NUMxLjY2NTk2IDcuOTgwNzYgMS4zMzMwMSA3LjIxMTg4IDEuMzMzMDEgNi40MTAxN0MxLjMzMzAxIDUuNjA4NDYgMS42NjU5NiA0LjgzOTU5IDIuMjU4NjMgNC4yNzI2OUMyLjg1MTI5IDMuNzA1OCAzLjY1NTExIDMuMzg3MzIgNC40OTMyNyAzLjM4NzMyQzQuNjkxMjIgMi41MDU0NCA1LjI3MDMyIDEuNzMwNDUgNi4xMDMxNiAxLjIzMjg0QzYuNTE1NTUgMC45ODY0NDcgNi45Nzc4MSAwLjgxNTU3MiA3LjQ2MzU3IDAuNzI5OTY4QzcuOTQ5MzMgMC42NDQzNjQgOC40NDkwNyAwLjY0NTcwOCA4LjkzNDI1IDAuNzMzOTIzQzkuNDE5NDMgMC44MjIxMzggOS44ODA1NiAwLjk5NTQ5NiAxMC4yOTEzIDEuMjQ0MUMxMC43MDIgMS40OTI3IDExLjA1NDMgMS44MTE2OCAxMS4zMjgxIDIuMTgyODNDMTEuNjAxOSAyLjU1Mzk3IDExLjc5MTcgMi45NzAwMiAxMS44ODY5IDMuNDA3MkMxMS45ODIgMy44NDQzOCAxMS45ODA1IDQuMjk0MTUgMTEuODgyNSA0LjczMDgxSDEyLjU1NDJDMTMuMTc3OCA0LjczMDgxIDEzLjc3NTggNC45Nzg1MSAxNC4yMTY3IDUuNDE5NDNDMTQuNjU3NiA1Ljg2MDM1IDE0LjkwNTMgNi40NTgzNyAxNC45MDUzIDcuMDgxOTJDMTQuOTA1MyA3LjcwNTQ3IDE0LjY1NzYgOC4zMDM0OSAxNC4yMTY3IDguNzQ0NEMxMy43NzU4IDkuMTg1MzIgMTMuMTc3OCA5LjQzMzAzIDEyLjU1NDIgOS40MzMwM0gxMS44ODI1IiBzdHJva2U9IndoaXRlIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTYuMTcyODUgMTAuNzc2NUw4LjE4ODA5IDEyLjc5MTdNOC4xODgwOSAxMi43OTE3TDEwLjIwMzMgMTAuNzc2NU04LjE4ODA5IDEyLjc5MTdWNi43NDYwNCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var newIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBpZD0iRWxsaXBzZSA3MTYiIGN4PSI2IiBjeT0iNiIgcj0iNiIgZmlsbD0iI0ZCODZCNiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var errorIconAdmin = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var greenCheck = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43NjU3IDMuODM0MjlDMTguMDc4MSA0LjE0NjcxIDE4LjA3ODEgNC42NTMyNCAxNy43NjU3IDQuOTY1NjZMOC4wNDg1MyAxNC42ODI4QzcuNTc5OSAxNS4xNTE0IDYuODIwMSAxNS4xNTE0IDYuMzUxNDcgMTQuNjgyOEwyLjIzNDMxIDEwLjU2NTdDMS45MjE5IDEwLjI1MzIgMS45MjE5IDkuNzQ2NzEgMi4yMzQzMSA5LjQzNDI5QzIuNTQ2NzMgOS4xMjE4NyAzLjA1MzI3IDkuMTIxODcgMy4zNjU2OSA5LjQzNDI5TDcuMiAxMy4yNjg2TDE2LjYzNDMgMy44MzQyOUMxNi45NDY3IDMuNTIxODcgMTcuNDUzMyAzLjUyMTg3IDE3Ljc2NTcgMy44MzQyOVoiIGZpbGw9IiM2MkQzODIiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var KebabMenuAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IktlYmFiIG1lbnUiPgo8cGF0aCBpZD0iVW5pb24iIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOS41OTk5IDMuMTk5OThDOS41OTk5IDQuMDgzNjMgOC44ODM1NiA0Ljc5OTk4IDcuOTk5OSA0Ljc5OTk4QzcuMTE2MjUgNC43OTk5OCA2LjM5OTkgNC4wODM2MyA2LjM5OTkgMy4xOTk5OEM2LjM5OTkgMi4zMTYzMiA3LjExNjI1IDEuNTk5OTggNy45OTk5IDEuNTk5OThDOC44ODM1NiAxLjU5OTk4IDkuNTk5OSAyLjMxNjMyIDkuNTk5OSAzLjE5OTk4Wk05LjU5OTkgNy45OTk5OEM5LjU5OTkgOC44ODM2MyA4Ljg4MzU2IDkuNTk5OTggNy45OTk5IDkuNTk5OThDNy4xMTYyNSA5LjU5OTk4IDYuMzk5OSA4Ljg4MzYzIDYuMzk5OSA3Ljk5OTk4QzYuMzk5OSA3LjExNjMyIDcuMTE2MjUgNi4zOTk5OCA3Ljk5OTkgNi4zOTk5OEM4Ljg4MzU2IDYuMzk5OTggOS41OTk5IDcuMTE2MzIgOS41OTk5IDcuOTk5OThaTTcuOTk5OSAxNC40QzguODgzNTYgMTQuNCA5LjU5OTkgMTMuNjgzNiA5LjU5OTkgMTIuOEM5LjU5OTkgMTEuOTE2MyA4Ljg4MzU2IDExLjIgNy45OTk5IDExLjJDNy4xMTYyNSAxMS4yIDYuMzk5OSAxMS45MTYzIDYuMzk5OSAxMi44QzYuMzk5OSAxMy42ODM2IDcuMTE2MjUgMTQuNCA3Ljk5OTkgMTQuNFoiIGZpbGw9IiM3MTY1OTYiIGZpbGwtb3BhY2l0eT0iMC43Ii8+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var saveAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yLjggMThIMTcuMkMxNy42NDE4IDE4IDE4IDE3LjY0MTggMTggMTcuMlY2LjMzMTM3QzE4IDYuMTE5MiAxNy45MTU3IDUuOTE1NzEgMTcuNzY1NyA1Ljc2NTY5TDE0LjIzNDMgMi4yMzQzMUMxNC4wODQzIDIuMDg0MjkgMTMuODgwOCAyIDEzLjY2ODYgMkgxMy4ySDYuOEgyLjhDMi4zNTgxNyAyIDIgMi4zNTgxNyAyIDIuOFYxNy4yQzIgMTcuNjQxOCAyLjM1ODE3IDE4IDIuOCAxOFpNMTYuNCAxNi40VjYuNjYyNzRMMTQgNC4yNjI3NFY2LjhDMTQgNy4yNDE4MyAxMy42NDE4IDcuNiAxMy4yIDcuNkg2LjhDNi4zNTgxNyA3LjYgNiA3LjI0MTgzIDYgNi44VjMuNkgzLjZWMTYuNEgxNi40Wk03LjYgMy42VjZIMTIuNFYzLjZINy42WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTIuOCAxMkMxMi44IDEzLjU0NjQgMTEuNTQ2NCAxNC44IDEwIDE0LjhDOC40NTM2IDE0LjggNy4yIDEzLjU0NjQgNy4yIDEyQzcuMiAxMC40NTM2IDguNDUzNiA5LjIgMTAgOS4yQzExLjU0NjQgOS4yIDEyLjggMTAuNDUzNiAxMi44IDEyWk0xMCAxMy4yQzEwLjY2MjcgMTMuMiAxMS4yIDEyLjY2MjcgMTEuMiAxMkMxMS4yIDExLjMzNzMgMTAuNjYyNyAxMC44IDEwIDEwLjhDOS4zMzcyNiAxMC44IDguOCAxMS4zMzczIDguOCAxMkM4LjggMTIuNjYyNyA5LjMzNzI2IDEzLjIgMTAgMTMuMloiIGZpbGw9IndoaXRlIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var dateIconAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDNIMTBWNUgxNFYzSDE2VjVIMTlDMTkuNTUyMyA1IDIwIDUuNDQ3NzIgMjAgNlYxOUMyMCAxOS41NTIzIDE5LjU1MjMgMjAgMTkgMjBINUM0LjQ0NzcyIDIwIDQgMTkuNTUyMyA0IDE5VjZDNCA1LjQ0NzcyIDQuNDQ3NzIgNSA1IDVIOFYzWk0xNCA3VjlIMTZWN0gxOFYxOEg2VjdIOFY5SDEwVjdIMTRaIiBmaWxsPSIjNjI2MjYyIiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var sortIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var EditIconAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjAyODExIDE3LjExNzlDOC4xNzA3IDE3LjA3OSA4LjMwMDY4IDE3LjAwMzYgOC40MDUxOSAxNi44OTkxTDE3LjI1MzcgOC4wNTA1NEMxOC4yNDg4IDcuMDU1NTQgMTguMjQ4OCA1LjQ0MjMyIDE3LjI1MzcgNC40NDczMkwxNi4wNTI3IDMuMjQ2MjVDMTUuMDU3NyAyLjI1MTI1IDEzLjQ0NDUgMi4yNTEyNSAxMi40NDk1IDMuMjQ2MjVMMy42MDA4OSAxMi4wOTQ4QzMuNDk2MzggMTIuMTk5MyAzLjQyMDk2IDEyLjMyOTMgMy4zODIwNyAxMi40NzE5TDIuMDMwODYgMTcuNDI2M0MxLjg1Nzk2IDE4LjA2MDMgMi40Mzk3IDE4LjY0MiAzLjA3MzY5IDE4LjQ2OTFMOC4wMjgxMSAxNy4xMTc5Wk00LjA2MDY0IDE2LjQzOTRMNC45NjE0NSAxMy4xMzY0TDExLjg0OSA2LjI0ODgxTDE0LjI1MTIgOC42NTA5Nkw3LjM2MzU5IDE1LjUzODZMNC4wNjA2NCAxNi40Mzk0Wk0xNi4wNTI3IDYuODQ5NDdDMTYuMzg0MyA2LjUxNzggMTYuMzg0MyA1Ljk4MDA2IDE2LjA1MjcgNS42NDg0TDE0Ljg1MTYgNC40NDczMkMxNC41MTk5IDQuMTE1NjYgMTMuOTgyMiA0LjExNTY2IDEzLjY1MDUgNC40NDczMkwxMi45OTAxIDUuMTA3NzlMMTUuMzkyMiA3LjUwOTk0TDE2LjA1MjcgNi44NDk0N1oiIGZpbGw9IiM3MTY1OTYiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var TrashIconAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjAwMDc4IDUuN1YxNi4xQzYuMDAwNzggMTYuNTQxOCA2LjM1ODk1IDE2LjkgNi44MDA3OCAxNi45SDEzLjIwMDhDMTMuNjQyNiAxNi45IDE0LjAwMDggMTYuNTQxOCAxNC4wMDA4IDE2LjFWNS43SDE1LjYwMDhWMTYuMUMxNS42MDA4IDE3LjQyNTUgMTQuNTI2MyAxOC41IDEzLjIwMDggMTguNUg2LjgwMDc4QzUuNDc1MyAxOC41IDQuNDAwNzggMTcuNDI1NSA0LjQwMDc4IDE2LjFWNS43SDYuMDAwNzhaIiBmaWxsPSIjNzE2NTk2Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNOC40MDA3OCAyLjVDNy45NTg5NSAyLjUgNy42MDA3OCAyLjg1ODE3IDcuNjAwNzggMy4zSDMuNjAwNzhDMy4xNTg5NSAzLjMgMi44MDA3OCAzLjY1ODE3IDIuODAwNzggNC4xQzIuODAwNzggNC41NDE4MyAzLjE1ODk1IDQuOSAzLjYwMDc4IDQuOUgxNi40MDA4QzE2Ljg0MjYgNC45IDE3LjIwMDggNC41NDE4MyAxNy4yMDA4IDQuMUMxNy4yMDA4IDMuNjU4MTcgMTYuODQyNiAzLjMgMTYuNDAwOCAzLjNIMTIuNDAwOEMxMi40MDA4IDIuODU4MTcgMTIuMDQyNiAyLjUgMTEuNjAwOCAyLjVIOC40MDA3OFoiIGZpbGw9IiM3MTY1OTYiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var table = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoCiAgICAgICAgZD0iTTMgOC44MzMzM0gxOE04LjgzMzMzIDNWMThNMyA0LjY2NjY3QzMgNC4yMjQ2NCAzLjE3NTU5IDMuODAwNzIgMy40ODgxNiAzLjQ4ODE2QzMuODAwNzIgMy4xNzU1OSA0LjIyNDY0IDMgNC42NjY2NyAzSDE2LjMzMzNDMTYuNzc1NCAzIDE3LjE5OTMgMy4xNzU1OSAxNy41MTE4IDMuNDg4MTZDMTcuODI0NCAzLjgwMDcyIDE4IDQuMjI0NjQgMTggNC42NjY2N1YxNi4zMzMzQzE4IDE2Ljc3NTQgMTcuODI0NCAxNy4xOTkzIDE3LjUxMTggMTcuNTExOEMxNy4xOTkzIDE3LjgyNDQgMTYuNzc1NCAxOCAxNi4zMzMzIDE4SDQuNjY2NjdDNC4yMjQ2NCAxOCAzLjgwMDcyIDE3LjgyNDQgMy40ODgxNiAxNy41MTE4QzMuMTc1NTkgMTcuMTk5MyAzIDE2Ljc3NTQgMyAxNi4zMzMzVjQuNjY2NjdaIgogICAgICAgIHN0cm9rZT0iIzYyNjI2MiIgc3Ryb2tlLW9wYWNpdHk9IjAuNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIKICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIiAvPgo8L3N2Zz4=";

/* loaded by smart-asset */
var exportIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8zODAyXzQ4MCkiPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik05LjMgMTEuMDM0M0M5LjMgMTEuNDc2MSA4Ljk0MTgzIDExLjgzNDMgOC41IDExLjgzNDNDOC4wNTgxNyAxMS44MzQzIDcuNyAxMS40NzYxIDcuNyAxMS4wMzQzVjIuNTY1NjlMNC42NjU2OSA1LjZDNC4zNTMyNyA1LjkxMjQyIDMuODQ2NzMgNS45MTI0MiAzLjUzNDMxIDUuNkMzLjIyMTkgNS4yODc1OCAzLjIyMTkgNC43ODEwNSAzLjUzNDMxIDQuNDY4NjNMNy42NTE0NyAwLjM1MTQ3MkM4LjEyMDEgLTAuMTE3MTU2IDguODc5OSAtMC4xMTcxNTggOS4zNDg1MyAwLjM1MTQ3MkwxMy40NjU3IDQuNDY4NjNDMTMuNzc4MSA0Ljc4MTA1IDEzLjc3ODEgNS4yODc1OCAxMy40NjU3IDUuNkMxMy4xNTMzIDUuOTEyNDIgMTIuNjQ2NyA1LjkxMjQyIDEyLjMzNDMgNS42TDkuMyAyLjU2NTY5VjExLjAzNDNaIgogICAgICAgICAgICBmaWxsPSJ3aGl0ZSIgLz4KICAgICAgICA8cGF0aAogICAgICAgICAgICBkPSJNMi4xIDkuNkMyLjEgOS4xNTgxNyAxLjc0MTgzIDguOCAxLjMgOC44QzAuODU4MTcyIDguOCAwLjUgOS4xNTgxNyAwLjUgOS42VjE0LjRDMC41IDE1LjI4MzcgMS4yMTYzNCAxNiAyLjEgMTZIMTQuOUMxNS43ODM3IDE2IDE2LjUgMTUuMjgzNyAxNi41IDE0LjRWOS42QzE2LjUgOS4xNTgxNyAxNi4xNDE4IDguOCAxNS43IDguOEMxNS4yNTgyIDguOCAxNC45IDkuMTU4MTcgMTQuOSA5LjZWMTQuNEgyLjFWOS42WiIKICAgICAgICAgICAgZmlsbD0id2hpdGUiIC8+CiAgICA8L2c+CiAgICA8ZGVmcz4KICAgICAgICA8Y2xpcFBhdGggaWQ9ImNsaXAwXzM4MDJfNDgwIj4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41KSIgLz4KICAgICAgICA8L2NsaXBQYXRoPgogICAgPC9kZWZzPgo8L3N2Zz4KICAgIA==";

/* loaded by smart-asset */
var kebab = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS42MDA0IDUuMjAwMUMxMS42MDA0IDYuMDgzNzUgMTAuODg0IDYuODAwMSAxMC4wMDA0IDYuODAwMUM5LjExNjc0IDYuODAwMSA4LjQwMDM5IDYuMDgzNzUgOC40MDAzOSA1LjIwMDFDOC40MDAzOSA0LjMxNjQ0IDkuMTE2NzQgMy42MDAxIDEwLjAwMDQgMy42MDAxQzEwLjg4NCAzLjYwMDEgMTEuNjAwNCA0LjMxNjQ0IDExLjYwMDQgNS4yMDAxWk0xMS42MDA0IDEwLjAwMDFDMTEuNjAwNCAxMC44ODM4IDEwLjg4NCAxMS42MDAxIDEwLjAwMDQgMTEuNjAwMUM5LjExNjc0IDExLjYwMDEgOC40MDAzOSAxMC44ODM4IDguNDAwMzkgMTAuMDAwMUM4LjQwMDM5IDkuMTE2NDQgOS4xMTY3NCA4LjQwMDEgMTAuMDAwNCA4LjQwMDFDMTAuODg0IDguNDAwMSAxMS42MDA0IDkuMTE2NDQgMTEuNjAwNCAxMC4wMDAxWk0xMC4wMDA0IDE2LjQwMDFDMTAuODg0IDE2LjQwMDEgMTEuNjAwNCAxNS42ODM4IDExLjYwMDQgMTQuODAwMUMxMS42MDA0IDEzLjkxNjQgMTAuODg0IDEzLjIwMDEgMTAuMDAwNCAxMy4yMDAxQzkuMTE2NzQgMTMuMjAwMSA4LjQwMDM5IDEzLjkxNjQgOC40MDAzOSAxNC44MDAxQzguNDAwMzkgMTUuNjgzOCA5LjExNjc0IDE2LjQwMDEgMTAuMDAwNCAxNi40MDAxWiIgZmlsbD0iIzcxNjU5NiIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var DownloadAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjggMi44QzEwLjggMi4zNTgxNyAxMC40NDE4IDIgMTAgMkM5LjU1ODE3IDIgOS4yIDIuMzU4MTcgOS4yIDIuOFYxMS4yNjg2TDYuMTY1NjkgOC4yMzQzMUM1Ljg1MzI3IDcuOTIxOSA1LjM0NjczIDcuOTIxOSA1LjAzNDMxIDguMjM0MzFDNC43MjE5IDguNTQ2NzMgNC43MjE5IDkuMDUzMjcgNS4wMzQzMSA5LjM2NTY5TDkuMTUxNDcgMTMuNDgyOEM5LjYyMDEgMTMuOTUxNSAxMC4zNzk5IDEzLjk1MTUgMTAuODQ4NSAxMy40ODI4TDE0Ljk2NTcgOS4zNjU2OUMxNS4yNzgxIDkuMDUzMjcgMTUuMjc4MSA4LjU0NjczIDE0Ljk2NTcgOC4yMzQzMUMxNC42NTMzIDcuOTIxOSAxNC4xNDY3IDcuOTIxOSAxMy44MzQzIDguMjM0MzFMMTAuOCAxMS4yNjg2VjIuOFoiIGZpbGw9IiM3MTY1OTYiIGZpbGwtb3BhY2l0eT0iMC43Ii8+CjxwYXRoIGQ9Ik0zLjYgMTEuNkMzLjYgMTEuMTU4MiAzLjI0MTgzIDEwLjggMi44IDEwLjhDMi4zNTgxNyAxMC44IDIgMTEuMTU4MiAyIDExLjZWMTYuNEMyIDE3LjI4MzcgMi43MTYzNCAxOCAzLjYgMThIMTYuNEMxNy4yODM3IDE4IDE4IDE3LjI4MzcgMTggMTYuNFYxMS42QzE4IDExLjE1ODIgMTcuNjQxOCAxMC44IDE3LjIgMTAuOEMxNi43NTgyIDEwLjggMTYuNCAxMS4xNTgyIDE2LjQgMTEuNlYxNi40SDMuNlYxMS42WiIgZmlsbD0iIzcxNjU5NiIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var downloadIconAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjggMi44QzEwLjggMi4zNTgxNyAxMC40NDE4IDIgMTAgMkM5LjU1ODE3IDIgOS4yIDIuMzU4MTcgOS4yIDIuOFYxMS4yNjg2TDYuMTY1NjkgOC4yMzQzMUM1Ljg1MzI3IDcuOTIxOSA1LjM0NjczIDcuOTIxOSA1LjAzNDMxIDguMjM0MzFDNC43MjE5IDguNTQ2NzMgNC43MjE5IDkuMDUzMjcgNS4wMzQzMSA5LjM2NTY5TDkuMTUxNDcgMTMuNDgyOEM5LjYyMDEgMTMuOTUxNSAxMC4zNzk5IDEzLjk1MTUgMTAuODQ4NSAxMy40ODI4TDE0Ljk2NTcgOS4zNjU2OUMxNS4yNzgxIDkuMDUzMjcgMTUuMjc4MSA4LjU0NjczIDE0Ljk2NTcgOC4yMzQzMUMxNC42NTMzIDcuOTIxOSAxNC4xNDY3IDcuOTIxOSAxMy44MzQzIDguMjM0MzFMMTAuOCAxMS4yNjg2VjIuOFoiIGZpbGw9IiM3MTY1OTYiIGZpbGwtb3BhY2l0eT0iMC43Ii8+CjxwYXRoIGQ9Ik0zLjYgMTEuNkMzLjYgMTEuMTU4MiAzLjI0MTgzIDEwLjggMi44IDEwLjhDMi4zNTgxNyAxMC44IDIgMTEuMTU4MiAyIDExLjZWMTYuNEMyIDE3LjI4MzcgMi43MTYzNCAxOCAzLjYgMThIMTYuNEMxNy4yODM3IDE4IDE4IDE3LjI4MzcgMTggMTYuNFYxMS42QzE4IDExLjE1ODIgMTcuNjQxOCAxMC44IDE3LjIgMTAuOEMxNi43NTgyIDEwLjggMTYuNCAxMS4xNTgyIDE2LjQgMTEuNlYxNi40SDMuNlYxMS42WiIgZmlsbD0iIzcxNjU5NiIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var failedToDelete = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var retry = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlJlc2V0Ij4KPHBhdGggaWQ9IkVsbGlwc2UgMjQxIChTdHJva2UpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkuMzY1ODggMC4yMzQzMTVDOS42NzgzIDAuNTQ2NzM0IDkuNjc4MyAxLjA1MzI3IDkuMzY1ODggMS4zNjU2OUw4LjMyMzk5IDIuNDA3NTdDMTEuOTI5MiAyLjU3NjU4IDE0LjgwMDIgNS41NTMwMSAxNC44MDAyIDkuMkMxNC44MDAyIDEyLjk1NTUgMTEuNzU1NyAxNiA4LjAwMDIgMTZDNC4yNDQ2NiAxNiAxLjIwMDIgMTIuOTU1NSAxLjIwMDIgOS4yQzEuMjAwMiA4Ljc1ODE3IDEuNTU4MzcgOC40IDIuMDAwMiA4LjRDMi40NDIwMiA4LjQgMi44MDAyIDguNzU4MTcgMi44MDAyIDkuMkMyLjgwMDIgMTIuMDcxOSA1LjEyODMxIDE0LjQgOC4wMDAyIDE0LjRDMTAuODcyMSAxNC40IDEzLjIwMDIgMTIuMDcxOSAxMy4yMDAyIDkuMkMxMy4yMDAyIDYuNDQzMTkgMTEuMDU0OSA0LjE4NzQzIDguMzQyNjYgNC4wMTExTDkuMzY1ODggNS4wMzQzMUM5LjY3ODMgNS4zNDY3MyA5LjY3ODMgNS44NTMyNyA5LjM2NTg4IDYuMTY1NjlDOS4wNTM0NiA2LjQ3ODExIDguNTQ2OTMgNi40NzgxMSA4LjIzNDUxIDYuMTY1NjlMNS44MzQ1MSAzLjc2NTY5QzUuNTIyMDkgMy40NTMyNyA1LjUyMjA5IDIuOTQ2NzMgNS44MzQ1MSAyLjYzNDMxTDguMjM0NTEgMC4yMzQzMTVDOC41NDY5MyAtMC4wNzgxMDQ5IDkuMDUzNDYgLTAuMDc4MTA0OSA5LjM2NTg4IDAuMjM0MzE1WiIgZmlsbD0iIzcxNjU5NiIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var spinner = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var calendarAdmin = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var retryPink = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS44NjU5IDIuMjM0MzFDMTIuMTc4MyAyLjU0NjczIDEyLjE3ODMgMy4wNTMyNyAxMS44NjU5IDMuMzY1NjlMMTAuODI0IDQuNDA3NTdDMTQuNDI5MiA0LjU3NjU4IDE3LjMwMDIgNy41NTMwMSAxNy4zMDAyIDExLjJDMTcuMzAwMiAxNC45NTU1IDE0LjI1NTcgMTggMTAuNTAwMiAxOEM2Ljc0NDY2IDE4IDMuNzAwMiAxNC45NTU1IDMuNzAwMiAxMS4yQzMuNzAwMiAxMC43NTgyIDQuMDU4MzcgMTAuNCA0LjUwMDIgMTAuNEM0Ljk0MjAyIDEwLjQgNS4zMDAyIDEwLjc1ODIgNS4zMDAyIDExLjJDNS4zMDAyIDE0LjA3MTkgNy42MjgzMSAxNi40IDEwLjUwMDIgMTYuNEMxMy4zNzIxIDE2LjQgMTUuNzAwMiAxNC4wNzE5IDE1LjcwMDIgMTEuMkMxNS43MDAyIDguNDQzMTkgMTMuNTU0OSA2LjE4NzQzIDEwLjg0MjcgNi4wMTExTDExLjg2NTkgNy4wMzQzMUMxMi4xNzgzIDcuMzQ2NzMgMTIuMTc4MyA3Ljg1MzI3IDExLjg2NTkgOC4xNjU2OUMxMS41NTM1IDguNDc4MTEgMTEuMDQ2OSA4LjQ3ODExIDEwLjczNDUgOC4xNjU2OUw4LjMzNDUxIDUuNzY1NjlDOC4wMjIwOSA1LjQ1MzI3IDguMDIyMDkgNC45NDY3MyA4LjMzNDUxIDQuNjM0MzFMMTAuNzM0NSAyLjIzNDMxQzExLjA0NjkgMS45MjE5IDExLjU1MzUgMS45MjE5IDExLjg2NTkgMi4yMzQzMVoiIGZpbGw9IiNGMTc4QUUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var revertPink = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjI2NTY5IDMuNDM0MjdDNi41NzgxMSAzLjc0NjY5IDYuNTc4MTEgNC4yNTMyMiA2LjI2NTY5IDQuNTY1NjRMNS4yMzEzNyA1LjU5OTk1SDEyLjlDMTUuOTkyOCA1LjU5OTk1IDE4LjUgOC4xMDcxNiAxOC41IDExLjJDMTguNSAxNC4yOTI3IDE1Ljk5MjggMTYuOCAxMi45IDE2LjhIMTEuM0MxMC44NTgyIDE2LjggMTAuNSAxNi40NDE4IDEwLjUgMTZDMTAuNSAxNS41NTgxIDEwLjg1ODIgMTUuMiAxMS4zIDE1LjJIMTIuOUMxNS4xMDkxIDE1LjIgMTYuOSAxMy40MDkxIDE2LjkgMTEuMkMxNi45IDguOTkwODEgMTUuMTA5MSA3LjE5OTk1IDEyLjkgNy4xOTk5NUg1LjIzMTM3TDYuMjY1NjkgOC4yMzQyN0M2LjU3ODExIDguNTQ2NjkgNi41NzgxMSA5LjA1MzIyIDYuMjY1NjkgOS4zNjU2NEM1Ljk1MzI3IDkuNjc4MDYgNS40NDY3MyA5LjY3ODA2IDUuMTM0MzEgOS4zNjU2NEwyLjczNDMxIDYuOTY1NjRDMi40MjE5IDYuNjUzMjIgMi40MjE4OSA2LjE0NjY5IDIuNzM0MzEgNS44MzQyN0w1LjEzNDMxIDMuNDM0MjdDNS40NDY3MyAzLjEyMTg1IDUuOTUzMjcgMy4xMjE4NSA2LjI2NTY5IDMuNDM0MjdaIiBmaWxsPSIjRjE3OEFFIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var asterisk = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var send = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuMTA1MzIgMTAuMzEwNkw2LjIzNjA0IDEwLjAwMDJMNi4xMDUzMiA5LjY4OTcxTDMuNTE5MzUgMy41NDgwM0wxNi44ODk2IDkuNDY5MTRDMTcuMDc4MiA5LjU1MjY2IDE3LjE5OTggOS43Mzk1NCAxNy4xOTk4IDkuOTQ1ODFDMTcuMTk5OCAxMC4xNTEgMTcuMDc5NSAxMC4zMzcgMTYuODkyNCAxMC40MjEyTDMuNTI2MiAxNi40MzZMNi4xMDUzMiAxMC4zMTA2WiIgc3Ryb2tlPSIjNzE2NTk2IiBzdHJva2Utd2lkdGg9IjEuNjAwMDMiLz4KPHJlY3QgeD0iNS44MzM1IiB5PSI5LjE2Njk5IiB3aWR0aD0iNSIgaGVpZ2h0PSIxLjY2NjY3IiByeD0iMC44MzMzMzMiIGZpbGw9IiM3MTY1OTYiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var inviteUsers = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMjAgNC41QzIwIDMuNCAxOS4xIDIuNSAxOCAyLjVIMkMwLjkgMi41IDAgMy40IDAgNC41VjE1LjVDMCAxNi42IDAuOSAxNy41IDIgMTcuNUgxOEMxOS4xIDE3LjUgMjAgMTYuNiAyMCAxNS41VjQuNVpNMTggNC41TDEwIDkuNUwyIDQuNUgxOFpNMTggMTUuNUgyVjYuNUwxMCAxMS41TDE4IDYuNVYxNS41WiIgZmlsbD0iIzYyNjI2MiIvPgo8L3N2Zz4=";

/* loaded by smart-asset */
var bell = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzQyMTJfNTIwMTUpIj4KPHBhdGggZD0iTTUuNjI5NDggMTUuMjMzOEw4LjY4MjM0IDE2LjU3MjFDOC4zMTQzIDE3LjQxMTcgNy4zMjYyOCAxNy43OTc0IDYuNDg2NzQgMTcuNDI5NEM1LjY0NzIxIDE3LjA2MTQgNS4yNjE0NCAxNi4wNzMzIDUuNjI5NDggMTUuMjMzOFpNMTQuNjk0IDE3LjM4NzhMMTQuMzU5NCAxOC4xNTFMMC42MjE1NDkgMTIuMTI4NUwwLjk1NjEzMiAxMS4zNjUzTDMuMTUxNzMgMTAuNTA4TDUuMTU5MjMgNS45Mjg3NEM2LjE5NjQ0IDMuNTYyNzcgOC42MjYyNCAyLjE3MTI1IDExLjIxNyAyLjQ4ODFMMTEuMzE3NCAyLjI1OTE0QzExLjY4NTQgMS40MTk2IDEyLjY3MzQgMS4wMzM4MyAxMy41MTMgMS40MDE4N0MxNC4zNTI1IDEuNzY5OTEgMTQuNzM4MyAyLjc1NzkzIDE0LjM3MDMgMy41OTc0N0wxNC4yNjk5IDMuODI2NDNDMTYuMjU4NCA1LjUxNzA4IDE2Ljg4MTUgOC4yNDY5MyAxNS44NDQzIDEwLjYxMjlMMTMuODM2OCAxNS4xOTIyTDE0LjY5NCAxNy4zODc4Wk0xNC4zMTc4IDkuOTQzNzNDMTUuMjU0NyA3LjgwNjczIDE0LjMxMTcgNS4zOTE1NyAxMi4xNzQ3IDQuNDU0NzRDMTAuMDM3NyAzLjUxNzkgNy42MjI0OSA0LjQ2MDkgNi42ODU2NiA2LjU5NzlMNC4zNDM1OCAxMS45NDA0TDExLjk3NTcgMTUuMjg2MkwxNC4zMTc4IDkuOTQzNzNaIiBmaWxsPSIjNzE2NTk2Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNDIxMl81MjAxNSI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";

/* loaded by smart-asset */
var trashWhite = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjk5OTggMy4yVjEzLjZDMy45OTk4IDE0LjA0MTggNC4zNTc5OCAxNC40IDQuNzk5OCAxNC40SDExLjE5OThDMTEuNjQxNiAxNC40IDExLjk5OTggMTQuMDQxOCAxMS45OTk4IDEzLjZWMy4ySDEzLjU5OThWMTMuNkMxMy41OTk4IDE0LjkyNTUgMTIuNTI1MyAxNiAxMS4xOTk4IDE2SDQuNzk5OEMzLjQ3NDMyIDE2IDIuMzk5OCAxNC45MjU1IDIuMzk5OCAxMy42VjMuMkgzLjk5OThaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjkiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjM5OTggMEM1Ljk1Nzk4IDAgNS41OTk4IDAuMzU4MTcyIDUuNTk5OCAwLjhIMS41OTk4QzEuMTU3OTggMC44IDAuNzk5ODA1IDEuMTU4MTcgMC43OTk4MDUgMS42QzAuNzk5ODA1IDIuMDQxODMgMS4xNTc5OCAyLjQgMS41OTk4IDIuNEgxNC4zOTk4QzE0Ljg0MTYgMi40IDE1LjE5OTggMi4wNDE4MyAxNS4xOTk4IDEuNkMxNS4xOTk4IDEuMTU4MTcgMTQuODQxNiAwLjggMTQuMzk5OCAwLjhIMTAuMzk5OEMxMC4zOTk4IDAuMzU4MTcyIDEwLjA0MTYgMCA5LjU5OTggMEg2LjM5OThaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjkiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var adminChevron = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIDExNTI3NzEwIj4KPHBhdGggaWQ9IlZlY3RvciA0NiAoU3Ryb2tlKSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjQxMDU4IDYuNzQ0MDhDMy43MzYwMiA2LjQxODY0IDQuMjYzNjYgNi40MTg2NCA0LjU4OTA5IDYuNzQ0MDhMOC45OTk4NCAxMS4xNTQ4TDEzLjQxMDYgNi43NDQwOEMxMy43MzYgNi40MTg2NCAxNC4yNjM3IDYuNDE4NjQgMTQuNTg5MSA2Ljc0NDA4QzE0LjkxNDUgNy4wNjk1MSAxNC45MTQ1IDcuNTk3MTUgMTQuNTg5MSA3LjkyMjU5TDkuNTg5MDkgMTIuOTIyNkM5LjI2MzY2IDEzLjI0OCA4LjczNjAyIDEzLjI0OCA4LjQxMDU4IDEyLjkyMjZMMy40MTA1OCA3LjkyMjU5QzMuMDg1MTQgNy41OTcxNSAzLjA4NTE0IDcuMDY5NTEgMy40MTA1OCA2Ljc0NDA4WiIgZmlsbD0iIzYyNjI2MiIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var warningTriangle = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var uploadAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkRvd25sb2FkIj4KPGcgaWQ9IlVuaW9uIj4KPHBhdGggZD0iTTguOCAxNS4yQzguOCAxNS42NDE4IDguNDQxODMgMTYgOCAxNkM3LjU1ODE3IDE2IDcuMiAxNS42NDE4IDcuMiAxNS4yVjYuNzMxMzdMNC4xNjU2OSA5Ljc2NTY5QzMuODUzMjcgMTAuMDc4MSAzLjM0NjczIDEwLjA3ODEgMy4wMzQzMSA5Ljc2NTY5QzIuNzIxOSA5LjQ1MzI3IDIuNzIxOSA4Ljk0NjczIDMuMDM0MzEgOC42MzQzMUw3LjE1MTQ3IDQuNTE3MTZDNy42MjAxIDQuMDQ4NTMgOC4zNzk5IDQuMDQ4NTMgOC44NDg1MyA0LjUxNzE2TDEyLjk2NTcgOC42MzQzMUMxMy4yNzgxIDguOTQ2NzMgMTMuMjc4MSA5LjQ1MzI3IDEyLjk2NTcgOS43NjU2OUMxMi42NTMzIDEwLjA3ODEgMTIuMTQ2NyAxMC4wNzgxIDExLjgzNDMgOS43NjU2OUw4LjggNi43MzEzN1YxNS4yWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTEuNiA2LjRDMS42IDYuODQxODMgMS4yNDE4MyA3LjIgMC44IDcuMkMwLjM1ODE3MiA3LjIgMCA2Ljg0MTgzIDAgNi40VjEuNkMwIDAuNzE2MzQ1IDAuNzE2MzQ0IDAgMS42IDBIMTQuNEMxNS4yODM3IDAgMTYgMC43MTYzNDQgMTYgMS42VjYuNEMxNiA2Ljg0MTgzIDE1LjY0MTggNy4yIDE1LjIgNy4yQzE0Ljc1ODIgNy4yIDE0LjQgNi44NDE4MyAxNC40IDYuNFYxLjZIMS42VjYuNFoiIGZpbGw9IndoaXRlIi8+CjwvZz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var pinkCheck = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkNoZWNrIiBjbGlwLXBhdGg9InVybCgjY2xpcDBfNDY5Nl8xMDk1OCkiPgo8cGF0aCBpZD0iVmVjdG9yIDE1NCAoU3Ryb2tlKSIgZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOS4zMTkyIDMuMTAxNDlDMTkuNjk0MSAzLjQ3NjM5IDE5LjY5NDEgNC4wODQyMyAxOS4zMTkyIDQuNDU5MTRMNy42NTg2MiAxNi4xMTk3QzcuMDk2MjcgMTYuNjgyMSA2LjE4NDUxIDE2LjY4MjEgNS42MjIxNiAxNi4xMTk3TDAuNjgxNTY4IDExLjE3OTFDMC4zMDY2NjUgMTAuODA0MiAwLjMwNjY2NSAxMC4xOTY0IDAuNjgxNTY4IDkuODIxNDlDMS4wNTY0NyA5LjQ0NjU5IDEuNjY0MzEgOS40NDY1OSAyLjAzOTIxIDkuODIxNDlMNi42NDAzOSAxNC40MjI3TDE3Ljk2MTYgMy4xMDE0OUMxOC4zMzY1IDIuNzI2NTkgMTguOTQ0MyAyLjcyNjU5IDE5LjMxOTIgMy4xMDE0OVoiIGZpbGw9IiNGQjg2QjYiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF80Njk2XzEwOTU4Ij4KPHJlY3Qgd2lkdGg9IjE5LjIiIGhlaWdodD0iMTkuMiIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAuNDAwMzkxIDAuOTAwMzkxKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var alertIconAdmin = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var alertIconPurpleAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNiAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS4xOTk4IDcuNDk5OEMxNS4xOTk4IDExLjQ3NjMgMTEuOTc2MyAxNC42OTk4IDcuOTk5OCAxNC42OTk4QzQuMDIzMzUgMTQuNjk5OCAwLjc5OTgwNSAxMS40NzYzIDAuNzk5ODA1IDcuNDk5OEMwLjc5OTgwNSAzLjUyMzM1IDQuMDIzMzUgMC4yOTk4MDUgNy45OTk4IDAuMjk5ODA1QzExLjk3NjMgMC4yOTk4MDUgMTUuMTk5OCAzLjUyMzM1IDE1LjE5OTggNy40OTk4Wk04LjAwMDgyIDMuNDQ5OEM3LjMyMTcxIDMuNDQ5OCA2Ljc5NjI4IDQuMDQ1MDEgNi44ODA1MSA0LjcxODg4TDcuMjgyMDMgNy45MzEwNkM3LjI5NDU1IDguMDMxMjMgNy4zMjcxNSA4LjEyNDQ5IDcuMzc1NDYgOC4yMDcwMUM3LjM4MTc5IDguMjE3ODEgNy4zODgzOCA4LjIyODQzIDcuMzk1MjQgOC4yMzg4NkM3LjQyODU3IDguMjg5NTUgNy40NjgwNCA4LjMzNTY4IDcuNTEyNTMgOC4zNzYyOEM3LjYxMDM0IDguNDY1NTMgNy43MzI0MyA4LjUyOCA3Ljg2NjkxIDguNTUzMkM3LjkxMDM4IDguNTYxMzQgNy45NTUxNiA4LjU2NTU5IDguMDAwODIgOC41NjU1OUM4LjI2NTE5IDguNTY1NTkgOC40OTk2MiA4LjQyMzEzIDguNjI2MTcgOC4yMDcwMkM4LjYzMDc4IDguMTk5MTUgOC42MzUyNCA4LjE5MTE5IDguNjM5NTYgOC4xODMxM0M4LjY4MDUzIDguMTA2NjUgOC43MDgyOCA4LjAyMTY4IDguNzE5NjEgNy45MzEwNkw5LjEyMTE0IDQuNzE4ODdDOS4yMDUzNyA0LjA0NTAxIDguNjc5OTMgMy40NDk4IDguMDAwODIgMy40NDk4Wk05LjA2NjU5IDEwLjQ4NTFDOS4wNjY1OSAxMS4wNzM3IDguNTg5NDIgMTEuNTUwOSA4LjAwMDggMTEuNTUwOUM3LjQxMjE4IDExLjU1MDkgNi45MzUwMSAxMS4wNzM3IDYuOTM1MDEgMTAuNDg1MUM2LjkzNTAxIDEwLjE4NTIgNy4wNTg5IDkuOTE0MjEgNy4yNTgzIDkuNzIwNTRDNy4yNzkwMiA5LjcwMDQxIDcuMzAwNTYgOS42ODExMSA3LjMyMjg2IDkuNjYyNzFDNy41MDcwOSA5LjUxMDY3IDcuNzQzMjggOS40MTkzNCA4LjAwMDggOS40MTkzNEM4LjA4OTI1IDkuNDE5MzQgOC4xNzUxOSA5LjQzMDEyIDguMjU3MzggOS40NTA0M0M4LjQwOTg5IDkuNDg4MTIgOC41NDk0NSA5LjU1ODY1IDguNjY4MTQgOS42NTQwOUM4LjY5NDI0IDkuNjc1MDcgOC43MTkzMiA5LjY5NzI1IDguNzQzMzEgOS43MjA1NUM4Ljc0NzA0IDkuNzI0MTcgOC43NTA3NSA5LjcyNzgyIDguNzU0NDMgOS43MzE1QzguOTQ3MyA5LjkyNDM3IDkuMDY2NTkgMTAuMTkwOCA5LjA2NjU5IDEwLjQ4NTFaIiBmaWxsPSIjNzE2NTk2Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi44ODA1MSA0LjcxODg4QzYuNzk2MjggNC4wNDUwMSA3LjMyMTcxIDMuNDQ5OCA4LjAwMDgyIDMuNDQ5OEM4LjY3OTkzIDMuNDQ5OCA5LjIwNTM3IDQuMDQ1MDEgOS4xMjExNCA0LjcxODg3TDguNzE5NjEgNy45MzEwNkM4LjcwODI4IDguMDIxNjggOC42ODA1MyA4LjEwNjY1IDguNjM5NTYgOC4xODMxM0M4LjYzNTI0IDguMTkxMTkgOC42MzA3OCA4LjE5OTE1IDguNjI2MTcgOC4yMDcwMkM4LjQ5OTYyIDguNDIzMTMgOC4yNjUxOSA4LjU2NTU5IDguMDAwODIgOC41NjU1OUM3Ljk1NTE2IDguNTY1NTkgNy45MTAzOCA4LjU2MTM0IDcuODY2OTEgOC41NTMyQzcuNzMyNDMgOC41MjggNy42MTAzNCA4LjQ2NTUzIDcuNTEyNTMgOC4zNzYyOEM3LjQ2ODA0IDguMzM1NjggNy40Mjg1NyA4LjI4OTU1IDcuMzk1MjQgOC4yMzg4NkM3LjM4ODM4IDguMjI4NDMgNy4zODE3OSA4LjIxNzgxIDcuMzc1NDYgOC4yMDcwMUM3LjMyNzE1IDguMTI0NDkgNy4yOTQ1NSA4LjAzMTIzIDcuMjgyMDMgNy45MzEwNkw2Ljg4MDUxIDQuNzE4ODhaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNOC4wMDA4IDExLjU1MDlDOC41ODk0MiAxMS41NTA5IDkuMDY2NTkgMTEuMDczNyA5LjA2NjU5IDEwLjQ4NTFDOS4wNjY1OSAxMC4xOTA4IDguOTQ3MyA5LjkyNDM3IDguNzU0NDMgOS43MzE1TDguNzQzMzEgOS43MjA1NUM4LjcxOTMyIDkuNjk3MjUgOC42OTQyNCA5LjY3NTA3IDguNjY4MTQgOS42NTQwOUM4LjU0OTQ1IDkuNTU4NjUgOC40MDk4OSA5LjQ4ODEyIDguMjU3MzggOS40NTA0M0M4LjE3NTE5IDkuNDMwMTIgOC4wODkyNSA5LjQxOTM0IDguMDAwOCA5LjQxOTM0QzcuNzQzMjggOS40MTkzNCA3LjUwNzA5IDkuNTEwNjcgNy4zMjI4NiA5LjY2MjcxQzcuMzAwNTYgOS42ODExMSA3LjI3OTAyIDkuNzAwNDEgNy4yNTgzIDkuNzIwNTRDNy4wNTg5IDkuOTE0MjEgNi45MzUwMSAxMC4xODUyIDYuOTM1MDEgMTAuNDg1MUM2LjkzNTAxIDExLjA3MzcgNy40MTIxOCAxMS41NTA5IDguMDAwOCAxMS41NTA5WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var contentManagement = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var license = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkxpY2Vuc2UiPgo8cGF0aCBpZD0iVmVjdG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuNjQ2NjIgMy42MDMyNUM2LjgzOTU1IDUuMDA5OTggNi4yMzEzNyA2LjQwODM1IDUuMDUwNSA3LjI3MzEzQzYuMjMxMzcgOC4xMzc5IDYuODM5NTYgOS41MzYyOCA2LjY0NjYyIDEwLjk0M0M4LjEyMzY4IDEwLjc1OTMgOS41OTE5OCAxMS4zMzg1IDEwLjUgMTIuNDYzMUMxMS40MDggMTEuMzM4NSAxMi44NzYzIDEwLjc1OTMgMTQuMzUzNCAxMC45NDNDMTQuMTYwNCA5LjUzNjI4IDE0Ljc2ODYgOC4xMzc5IDE1Ljk0OTUgNy4yNzMxMkMxNC43Njg2IDYuNDA4MzUgMTQuMTYwNCA1LjAwOTk3IDE0LjM1MzQgMy42MDMyNUMxMi44NzYzIDMuNzg3IDExLjQwOCAzLjIwNzc3IDEwLjUgMi4wODMxNEM5LjU5MTk4IDMuMjA3NzcgOC4xMjM2OCAzLjc4NyA2LjY0NjYyIDMuNjAzMjVaTTEyLjE1NjEgMC44NTMyODlDMTEuMzI0NSAtMC4xOTEzMzEgOS42NzU1MyAtMC4xOTEzMzEgOC44NDM4NCAwLjg1MzI4OUM4LjM5MDA0IDEuNDIzMjcgNy42NDg2NSAxLjcxNTc0IDYuOTA0NTggMS42MTgzQzUuNTQwOSAxLjQzOTc0IDQuMzc0OTMgMi41NTAxOCA0LjU2MjQzIDMuODQ4OTNDNC42NjQ3MyA0LjU1NzU3IDQuMzU3NjQgNS4yNjM2NSAzLjc1OTE2IDUuNjk1ODRDMi42NjIzMSA2LjQ4NzkyIDIuNjYyMzEgOC4wNTgzMyAzLjc1OTE2IDguODUwNDFDNC4zNTc2NCA5LjI4MjYgNC42NjQ3MyA5Ljk4ODY4IDQuNTYyNDMgMTAuNjk3M0M0LjQ2MTkgMTEuMzkzNyA0Ljc1MDQ3IDEyLjAzNTkgNS4yNDk5OSAxMi40NTQzVjE4LjQ1MTZDNS4yNDk5OSAxOS41NzU2IDYuNTAwMjcgMjAuMzAwMyA3LjU0ODYxIDE5Ljc4MzlMMTAuNjMwNyAxOC4yNjU1TDEzLjQxMDYgMTkuNzM1MkMxNC40NjAzIDIwLjI5MDIgMTUuNzUgMTkuNTY3MiAxNS43NSAxOC40MjM3VjEyLjQ1NDNDMTYuMjQ5NSAxMi4wMzU5IDE2LjUzODEgMTEuMzkzNyAxNi40Mzc2IDEwLjY5NzNDMTYuMzM1MiA5Ljk4ODY4IDE2LjY0MjMgOS4yODI2IDE3LjI0MDggOC44NTA0MUMxOC4zMzc3IDguMDU4MzMgMTguMzM3NyA2LjQ4NzkyIDE3LjI0MDggNS42OTU4NEMxNi42NDIzIDUuMjYzNjUgMTYuMzM1MiA0LjU1NzU3IDE2LjQzNzYgMy44NDg5M0MxNi42MjUgMi41NTAxOCAxNS40NTkxIDEuNDM5NzQgMTQuMDk1NCAxLjYxODNDMTMuMzUxMyAxLjcxNTc0IDEyLjYwOTkgMS40MjMyNyAxMi4xNTYxIDAuODUzMjg5Wk03LjM0OTk5IDEyLjkxNTVWMTcuNjNMOS42NjU5MSAxNi40ODkxQzEwLjI5MDQgMTYuMTgxNCAxMS4wMzUyIDE2LjE5MTggMTEuNjUgMTYuNTE2OUwxMy42NSAxNy41NzQzVjEyLjkxNTVDMTMuMDY1MyAxMi45NTkxIDEyLjUxODkgMTMuMjM3NCAxMi4xNTYxIDEzLjY5M0MxMS4zMjQ1IDE0LjczNzYgOS42NzU1MyAxNC43Mzc2IDguODQzODQgMTMuNjkzQzguNDgxMTIgMTMuMjM3NCA3LjkzNDY4IDEyLjk1OTEgNy4zNDk5OSAxMi45MTU1WiIgZmlsbD0iIzcxNjU5NiIvPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var uploadImage = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var unpublishCourse = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImZsdWVudDp0ZXh0LWNoYW5nZS1yZWplY3QtMjQtZmlsbGVkIj4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTE0LjU4MzIgMTAuMDAwM0MxNS43OTg4IDEwLjAwMDMgMTYuOTY0NiAxMC40ODMyIDE3LjgyNDEgMTEuMzQyOEMxOC42ODM3IDEyLjIwMjMgMTkuMTY2NiAxMy4zNjgxIDE5LjE2NjYgMTQuNTgzN0MxOS4xNjY2IDE1Ljc5OTIgMTguNjgzNyAxNi45NjUgMTcuODI0MSAxNy44MjQ2QzE2Ljk2NDYgMTguNjg0MSAxNS43OTg4IDE5LjE2NyAxNC41ODMyIDE5LjE2N0MxMy4zNjc2IDE5LjE2NyAxMi4yMDE5IDE4LjY4NDEgMTEuMzQyMyAxNy44MjQ2QzEwLjQ4MjggMTYuOTY1IDkuOTk5ODkgMTUuNzk5MiA5Ljk5OTg5IDE0LjU4MzdDOS45OTk4OSAxMy4zNjgxIDEwLjQ4MjggMTIuMjAyMyAxMS4zNDIzIDExLjM0MjhDMTIuMjAxOSAxMC40ODMyIDEzLjM2NzYgMTAuMDAwMyAxNC41ODMyIDEwLjAwMDNaTTEyLjUxOTkgMTIuNTIwM0MxMi40NDE4IDEyLjU5ODUgMTIuMzk3OSAxMi43MDQ0IDEyLjM5NzkgMTIuODE0OUMxMi4zOTc5IDEyLjkyNTQgMTIuNDQxOCAxMy4wMzE0IDEyLjUxOTkgMTMuMTA5NUwxMy45OTQxIDE0LjU4NDVMMTIuNTIxNiAxNi4wNTYyQzEyLjQ4MjggMTYuMDk0OCAxMi40NTIxIDE2LjE0MDggMTIuNDMxMSAxNi4xOTEzQzEyLjQxMDEgMTYuMjQxOSAxMi4zOTkzIDE2LjI5NjEgMTIuMzk5MiAxNi4zNTA5QzEyLjM5OTIgMTYuNDA1NiAxMi40MDk5IDE2LjQ1OTggMTIuNDMwOSAxNi41MTA0QzEyLjQ1MTggMTYuNTYxIDEyLjQ4MjUgMTYuNjA3IDEyLjUyMTEgMTYuNjQ1N0MxMi41NTk4IDE2LjY4NDUgMTIuNjA1OCAxNi43MTUyIDEyLjY1NjMgMTYuNzM2MkMxMi43MDY5IDE2Ljc1NzIgMTIuNzYxMSAxNi43NjggMTIuODE1OCAxNi43NjgxQzEyLjg3MDYgMTYuNzY4MSAxMi45MjQ4IDE2Ljc1NzQgMTIuOTc1NCAxNi43MzY0QzEzLjAyNiAxNi43MTU1IDEzLjA3MiAxNi42ODQ4IDEzLjExMDcgMTYuNjQ2MkwxNC41ODMyIDE1LjE3MzdMMTYuMDU4MiAxNi42NDc4QzE2LjA5NjcgMTYuNjg3NiAxNi4xNDI2IDE2LjcxOTQgMTYuMTkzNSAxNi43NDEyQzE2LjI0NDMgMTYuNzYzIDE2LjI5OSAxNi43NzQ1IDE2LjM1NDMgMTYuNzc1QzE2LjQwOTYgMTYuNzc1NSAxNi40NjQ1IDE2Ljc2NSAxNi41MTU3IDE2Ljc0NEMxNi41NjY5IDE2LjcyMzEgMTYuNjEzNCAxNi42OTIxIDE2LjY1MjYgMTYuNjUzQzE2LjY5MTcgMTYuNjEzOSAxNi43MjI2IDE2LjU2NzMgMTYuNzQzNiAxNi41MTYxQzE2Ljc2NDUgMTYuNDY0OSAxNi43NzUxIDE2LjQxMDEgMTYuNzc0NiAxNi4zNTQ3QzE2Ljc3NDEgMTYuMjk5NCAxNi43NjI2IDE2LjI0NDcgMTYuNzQwOCAxNi4xOTM5QzE2LjcxODkgMTYuMTQzMSAxNi42ODcyIDE2LjA5NzEgMTYuNjQ3NCAxNi4wNTg3TDE1LjE3MzIgMTQuNTgzN0wxNi42NDkxIDEzLjEwODdDMTYuNzI1IDEzLjAzMDEgMTYuNzY3IDEyLjkyNDggMTYuNzY2IDEyLjgxNTZDMTYuNzY1MSAxMi43MDYzIDE2LjcyMTIgMTIuNjAxOCAxNi42NDQgMTIuNTI0NkMxNi41NjY3IDEyLjQ0NzMgMTYuNDYyMiAxMi40MDM1IDE2LjM1MyAxMi40MDI1QzE2LjI0MzcgMTIuNDAxNiAxNi4xMzg1IDEyLjQ0MzYgMTYuMDU5OSAxMi41MTk1TDE0LjU4NDEgMTMuOTk0NUwxMy4xMDkxIDEyLjUxOTVDMTMuMDMwOSAxMi40NDE0IDEyLjkyNSAxMi4zOTc1IDEyLjgxNDUgMTIuMzk3NUMxMi43MDQgMTIuMzk3NSAxMi41OTggMTIuNDQxNCAxMi41MTk5IDEyLjUxOTVNOS4xODIzOSAxNC4xNjdIMi40OTk4OUwyLjQwMjM5IDE0LjE3MjhDMi4xOTE0OCAxNC4xOTc5IDEuOTk4MSAxNC4zMDI2IDEuODYxNzggMTQuNDY1NUMxLjcyNTQ1IDE0LjYyODMgMS42NTY0NyAxNC44MzcxIDEuNjY4OTEgMTUuMDQ5MkMxLjY4MTM2IDE1LjI2MTIgMS43NzQzIDE1LjQ2MDUgMS45Mjg3NSAxNS42MDYzQzIuMDgzMiAxNS43NTIxIDIuMjg3NDkgMTUuODMzNCAyLjQ5OTg5IDE1LjgzMzdIOS4zMTE1NkM5LjE4Mjc4IDE1LjI4ODEgOS4xMzkyMSAxNC43MjU5IDkuMTgyMzkgMTQuMTY3Wk05LjU4MjM5IDEyLjUwMDNIMi40OTk4OUMyLjI4NzQ5IDEyLjUwMDEgMi4wODMyIDEyLjQxODggMS45Mjg3NSAxMi4yNzNDMS43NzQzIDEyLjEyNzEgMS42ODEzNiAxMS45Mjc5IDEuNjY4OTEgMTEuNzE1OEMxLjY1NjQ3IDExLjUwMzggMS43MjU0NSAxMS4yOTUgMS44NjE3OCAxMS4xMzIxQzEuOTk4MSAxMC45NjkzIDIuMTkxNDggMTAuODY0NiAyLjQwMjM5IDEwLjgzOTVMMi40OTk4OSAxMC44MzM3SDEwLjY3NDlDMTAuMjEwMyAxMS4zMTY3IDkuODQwNDMgMTEuODgxOCA5LjU4MjM5IDEyLjUwMDNaTTIuNDk5ODkgOS4xNjY5OUMyLjI4NzQ5IDkuMTY2NzYgMi4wODMyIDkuMDg1NDMgMS45Mjg3NSA4LjkzOTYyQzEuNzc0MyA4Ljc5MzgxIDEuNjgxMzYgOC41OTQ1MyAxLjY2ODkxIDguMzgyNUMxLjY1NjQ3IDguMTcwNDYgMS43MjU0NSA3Ljk2MTY4IDEuODYxNzggNy43OTg4QzEuOTk4MSA3LjYzNTkyIDIuMTkxNDggNy41MzEyNSAyLjQwMjM5IDcuNTA2MTZMMi40OTk4OSA3LjUwMDMzSDE3LjQ5OTlDMTcuNzEyMyA3LjUwMDU2IDE3LjkxNjYgNy41ODE4OSAxOC4wNzEgNy43Mjc3QzE4LjIyNTUgNy44NzM1MSAxOC4zMTg0IDguMDcyNzkgMTguMzMwOSA4LjI4NDgyQzE4LjM0MzMgOC40OTY4NiAxOC4yNzQzIDguNzA1NjQgMTguMTM4IDguODY4NTJDMTguMDAxNyA5LjAzMTQgMTcuODA4MyA5LjEzNjA3IDE3LjU5NzQgOS4xNjExNkwxNy40OTk5IDkuMTY2OTlIMi40OTk4OVpNMTcuNDk5OSA0LjE2Njk5SDIuNDk5ODlMMi40MDIzOSA0LjE3MjgzQzIuMTkxNDggNC4xOTc5MSAxLjk5ODEgNC4zMDI1OSAxLjg2MTc4IDQuNDY1NDdDMS43MjU0NSA0LjYyODM0IDEuNjU2NDcgNC44MzcxMyAxLjY2ODkxIDUuMDQ5MTZDMS42ODEzNiA1LjI2MTIgMS43NzQzIDUuNDYwNDggMS45Mjg3NSA1LjYwNjI5QzIuMDgzMiA1Ljc1MjA5IDIuMjg3NDkgNS44MzM0MiAyLjQ5OTg5IDUuODMzNjZIMTcuNDk5OUwxNy41OTc0IDUuODI3ODNDMTcuODA4MyA1LjgwMjc0IDE4LjAwMTcgNS42OTgwNiAxOC4xMzggNS41MzUxOUMxOC4yNzQzIDUuMzcyMzEgMTguMzQzMyA1LjE2MzUyIDE4LjMzMDkgNC45NTE0OUMxOC4zMTg0IDQuNzM5NDUgMTguMjI1NSA0LjU0MDE3IDE4LjA3MSA0LjM5NDM3QzE3LjkxNjYgNC4yNDg1NiAxNy43MTIzIDQuMTY3MjMgMTcuNDk5OSA0LjE2Njk5WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L3N2Zz4K";

/* loaded by smart-asset */
var publishedCourse = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var sort = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlNvcnQgLSBUYWJsZSI+CjxwYXRoIGlkPSJVbmlvbiIgZD0iTTUuNjAzMzkgMTMuODAxNkM1LjgwMzU1IDE0LjA2MTcgNi4xOTU3IDE0LjA2MTcgNi4zOTU4NSAxMy44MDE2TDguMzk1MjkgMTEuMjAzOEM4LjY0ODM1IDEwLjg3NSA4LjQxMzk2IDEwLjM5ODkgNy45OTkwNiAxMC4zOTg5SDYuNDk4MDNMNi40OTgwMyAyLjQ5ODNDNi40OTgwMyAyLjIyMzEgNi4yNzQ5MyAyIDUuOTk5NzMgMkM1LjcyNDUyIDIgNS41MDE0MiAyLjIyMzEgNS41MDE0MiAyLjQ5ODNMNS41MDE0MiAxMC4zOTg5SDQuMDAwMTlDMy41ODUyOSAxMC4zOTg5IDMuMzUwOSAxMC44NzUgMy42MDM5NiAxMS4yMDM4TDUuNjAzMzkgMTMuODAxNloiIGZpbGw9IiM3MTY1OTYiIGZpbGwtb3BhY2l0eT0iMC43Ii8+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var courseDeletionUsersIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjI1MDggNy4xMTg2MkMxMC44NzggNi43NTU0MSAxMS4zIDYuMDc2OTkgMTEuMyA1LjNDMTEuMyA0LjUyMzEgMTAuODc4MSAzLjg0NDc0IDEwLjI1MSAzLjQ4MTVDOS45MzQ5OCAyLjg4MzA5IDkuNDY3OSAyLjM3Njc5IDguOTAwNSAyLjAxMzQxQzguOTk5MTQgMi4wMDQ1MyA5LjA5OTA0IDIgOS4yIDJDMTEuMDIyNSAyIDEyLjUgMy40Nzc0NiAxMi41IDUuM0MxMi41IDYuMzQ4MjMgMTIuMDExMyA3LjI4MjMyIDExLjI0OTIgNy44ODY4QzEyLjg3NTIgOC43MDM2IDE0IDEwLjQ2MjIgMTQgMTIuNVYxMy40QzE0IDEzLjczMTQgMTMuNzQ3MiAxNCAxMy40MzUzIDE0QzEzLjEyMzQgMTQgMTIuODcwNiAxMy43MzE0IDEyLjg3MDYgMTMuNFYxMi41QzEyLjg3MDYgMTEuMTQ5NyAxMi4yMjQ3IDkuOTU5NzMgMTEuMjQzNCA5LjI1OTdDMTAuODYwNyA4LjY3NTg3IDEwLjM3NjkgOC4xNzAyMyA5LjgxNjkxIDcuNzcxNTdDOS45ODIzIDcuNTY5ODcgMTAuMTI3OSA3LjM1MTIyIDEwLjI1MDggNy4xMTg2MloiIGZpbGw9IiNGMTc4QUUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04Ljg0OTIyIDcuODg2OEM5LjYxMTI2IDcuMjgyMzIgMTAuMSA2LjM0ODIzIDEwLjEgNS4zQzEwLjEgMy40Nzc0NiA4LjYyMjU0IDIgNi44IDJDNC45Nzc0NiAyIDMuNSAzLjQ3NzQ2IDMuNSA1LjNDMy41IDYuMzQ4MjMgMy45ODg3NCA3LjI4MjMyIDQuNzUwNzggNy44ODY4QzMuMTI0ODMgOC43MDM2IDIgMTAuNDYyMiAyIDEyLjVWMTMuNEMyIDEzLjczMTQgMi4yNTI4MyAxNCAyLjU2NDcxIDE0QzIuODc2NTggMTQgMy4xMjk0MSAxMy43MzE0IDMuMTI5NDEgMTMuNFYxMi41QzMuMTI5NDEgMTAuMzQ2MSA0Ljc3Mjc5IDguNiA2LjggOC42QzguODI3MjEgOC42IDEwLjQ3MDYgMTAuMzQ2MSAxMC40NzA2IDEyLjVWMTMuNEMxMC40NzA2IDEzLjczMTQgMTAuNzIzNCAxNCAxMS4wMzUzIDE0QzExLjM0NzIgMTQgMTEuNiAxMy43MzE0IDExLjYgMTMuNFYxMi41QzExLjYgMTAuNDYyMiAxMC40NzUyIDguNzAzNiA4Ljg0OTIyIDcuODg2OFpNNi44IDcuNEM3Ljk1OTggNy40IDguOSA2LjQ1OTggOC45IDUuM0M4LjkgNC4xNDAyIDcuOTU5OCAzLjIgNi44IDMuMkM1LjY0MDIgMy4yIDQuNyA0LjE0MDIgNC43IDUuM0M0LjcgNi40NTk4IDUuNjQwMiA3LjQgNi44IDcuNFoiIGZpbGw9IiNGMTc4QUUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var uploadScorm = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var questionMark = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDEyLjhDMTAuNjUxIDEyLjggMTIuOCAxMC42NTEgMTIuOCA4QzEyLjggNS4zNDkwMyAxMC42NTEgMy4yIDggMy4yQzUuMzQ5MDMgMy4yIDMuMiA1LjM0OTAzIDMuMiA4QzMuMiAxMC42NTEgNS4zNDkwMyAxMi44IDggMTIuOFpNOCAxNEMxMS4zMTM3IDE0IDE0IDExLjMxMzcgMTQgOEMxNCA0LjY4NjI5IDExLjMxMzcgMiA4IDJDNC42ODYyOSAyIDIgNC42ODYyOSAyIDhDMiAxMS4zMTM3IDQuNjg2MjkgMTQgOCAxNFoiIGZpbGw9IiM3MTY1OTYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04IDUuOUM3LjU2NTI4IDUuOSA3LjIwMTM1IDYuMjA4ODEgNy4xMTgwMSA2LjYxOTM2QzcuMDUyMDkgNi45NDQxMSA2LjczNTM5IDcuMTUzOTMgNi40MTA2NCA3LjA4ODAxQzYuMDg1ODkgNy4wMjIwOSA1Ljg3NjA3IDYuNzA1MzkgNS45NDE5OSA2LjM4MDY0QzYuMTM2NjIgNS40MjE4NSA2Ljk4MzM0IDQuNyA4IDQuN0M5LjE1OTc5IDQuNyAxMC4xIDUuNjQwMiAxMC4xIDYuOEMxMC4xIDcuNzUxNzQgOS40NjczOSA4LjU1NDU1IDguNiA4LjgxMjg3VjguOUM4LjYgOS4yMzEzNyA4LjMzMTM3IDkuNSA4IDkuNUM3LjY2ODYyIDkuNSA3LjM5OTk5IDkuMjMxMzcgNy4zOTk5OSA4LjlWOC42QzcuMzk5OTkgOC4wODAxNSA3LjgxMDE0IDcuNzU2NjkgOC4xNzk0OSA3LjY4MjIyQzguNTkwNjEgNy41OTkzMyA4LjkgNy4yMzUxMiA4LjkgNi44QzguOSA2LjMwMjk0IDguNDk3MDUgNS45IDggNS45WiIgZmlsbD0iIzcxNjU5NiIvPgo8cGF0aCBkPSJNOC42IDEwLjdDOC42IDExLjAzMTQgOC4zMzEzNyAxMS4zIDggMTEuM0M3LjY2ODYzIDExLjMgNy40IDExLjAzMTQgNy40IDEwLjdDNy40IDEwLjM2ODYgNy42Njg2MyAxMC4xIDggMTAuMUM4LjMzMTM3IDEwLjEgOC42IDEwLjM2ODYgOC42IDEwLjdaIiBmaWxsPSIjNzE2NTk2Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var zipFile = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03LjA4Mjg0IDIuMTE3MTZDNy4xNTc4NiAyLjA0MjE0IDcuMjU5NiAyIDcuMzY1NjkgMkgxNS42QzE1LjgyMDkgMiAxNiAyLjE3OTA5IDE2IDIuNFYxNy42QzE2IDE3LjgyMDkgMTUuODIwOSAxOCAxNS42IDE4SDQuNEM0LjE3OTA5IDE4IDQgMTcuODIwOSA0IDE3LjZWNS4zNjU2OUM0IDUuMjU5NiA0LjA0MjE0IDUuMTU3ODYgNC4xMTcxNiA1LjA4Mjg0TDcuMDgyODQgMi4xMTcxNlpNNS42IDZINy42QzcuODIwOTEgNiA4IDUuODIwOTEgOCA1LjZWMy42SDguOFY1LjJIMTAuNFY2LjhIOC44VjguNEgxMC40VjEwSDguOFYxMS42SDEwLjRWMTBIMTJWOC40SDEwLjRWNi44SDEyVjUuMkgxMC40VjMuNkgxNC40VjE2LjRINS42VjZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var publishedIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var unpublishedIcon = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var changeTo = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var linkIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOSAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjE5MTEgMS44NTQ0OUgzLjQxNTM2QzMuMjQ0MyAxLjg1NDQ5IDMuMTA1NDcgMi4wMDU3MiAzLjEwNTQ3IDIuMTkyMjdWNS4yMzUzN0MzLjEwNTQ3IDUuNDIxOTIgMy4yNDQzIDUuNTczMTQgMy40MTUzNiA1LjU3MzE0SDE1LjE5MTFDMTUuMzYyMSA1LjU3MzE0IDE1LjUwMSA1LjQyMTkyIDE1LjUwMSA1LjIzNTM3VjIuMTkyMjdDMTUuNTAxIDIuMDA2MDMgMTUuMzYyMSAxLjg1NDQ5IDE1LjE5MTEgMS44NTQ0OVoiIHN0cm9rZT0iIzYyNjI2MiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTUuMTkxMSAxMi4wMzEySDMuNDE1MzZDMy4yNDQzIDEyLjAzMTIgMy4xMDU0NyAxMi4xODI1IDMuMTA1NDcgMTIuMzY5VjE1LjQxMjFDMy4xMDU0NyAxNS41OTg3IDMuMjQ0MyAxNS43NDk5IDMuNDE1MzYgMTUuNzQ5OUgxNS4xOTExQzE1LjM2MjEgMTUuNzQ5OSAxNS41MDEgMTUuNTk4NyAxNS41MDEgMTUuNDEyMVYxMi4zNjlDMTUuNTAxIDEyLjE4MjUgMTUuMzYyMSAxMi4wMzEyIDE1LjE5MTEgMTIuMDMxMloiIHN0cm9rZT0iIzYyNjI2MiIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNi4yMDMxMiA1LjU3MzI0VjguODA0ODJMMTIuNDAwOSA4LjgwNzkyVjExLjY1NjQiIHN0cm9rZT0iIzYyNjI2MiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik03LjQ0MTQxIDEzLjg5MDZIMTEuMTYwMSIgc3Ryb2tlPSIjNjI2MjYyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuNDQxNDEgMy43MTM4N0gxMS4xNjAxIiBzdHJva2U9IiM2MjYyNjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var certificate = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var certificateIconLearningPanel = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var chevronNoBackground = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgdmlld0JveD0iMCAwIDEyIDgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMC40MTAwOTMgMC43NDQwNzhDMC43MzU1MyAwLjQxODY0MSAxLjI2MzE3IDAuNDE4NjQxIDEuNTg4NiAwLjc0NDA3OEw1Ljk5OTM1IDUuMTU0ODJMMTAuNDEwMSAwLjc0NDA3OEMxMC43MzU1IDAuNDE4NjQxIDExLjI2MzIgMC40MTg2NDEgMTEuNTg4NiAwLjc0NDA3OEMxMS45MTQgMS4wNjk1MSAxMS45MTQgMS41OTcxNSAxMS41ODg2IDEuOTIyNTlMNi41ODg2IDYuOTIyNTlDNi4yNjMxNyA3LjI0ODAzIDUuNzM1NTMgNy4yNDgwMyA1LjQxMDA5IDYuOTIyNTlMMC40MTAwOTMgMS45MjI1OUMwLjA4NDY1NjQgMS41OTcxNSAwLjA4NDY1NjQgMS4wNjk1MSAwLjQxMDA5MyAwLjc0NDA3OFoiIGZpbGw9IiM3MTY1OTYiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var smallZipFile = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjA4Mjg0IDAuNjE3MTU3QzUuMTU3ODYgMC41NDIxNDMgNS4yNTk2IDAuNSA1LjM2NTY5IDAuNUgxMy42QzEzLjgyMDkgMC41IDE0IDAuNjc5MDg2IDE0IDAuOVYxNi4xQzE0IDE2LjMyMDkgMTMuODIwOSAxNi41IDEzLjYgMTYuNUgyLjRDMi4xNzkwOSAxNi41IDIgMTYuMzIwOSAyIDE2LjFWMy44NjU2OUMyIDMuNzU5NiAyLjA0MjE0IDMuNjU3ODYgMi4xMTcxNiAzLjU4Mjg0TDUuMDgyODQgMC42MTcxNTdaTTMuNiA0LjVINS42QzUuODIwOTEgNC41IDYgNC4zMjA5MSA2IDQuMVYyLjFINi44VjMuN0g4LjRWNS4zSDYuOFY2LjlIOC40VjguNUg2LjhWMTAuMUg4LjRWOC41SDEwVjYuOUg4LjRWNS4zSDEwVjMuN0g4LjRWMi4xSDEyLjRWMTQuOUgzLjZWNC41WiIgZmlsbD0iIzcxNjU5NiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var closeRed = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy4zMzk4IDE5Ljc5MjdDMTcuNzMwMyAyMC4xODMzIDE4LjM2MzUgMjAuMTgzMyAxOC43NTQgMTkuNzkyN0wxOC43OTQzIDE5Ljc1MjRDMTkuMTg0OCAxOS4zNjE5IDE5LjE4NDggMTguNzI4NyAxOC43OTQzIDE4LjMzODJMMTIuOTU1MiAxMi40OTkxTDE4Ljc5MjcgNi42NjE2MUMxOS4xODMyIDYuMjcxMDggMTkuMTgzMiA1LjYzNzkyIDE4Ljc5MjcgNS4yNDczOUwxOC43NTI0IDUuMjA3MDZDMTguMzYxOCA0LjgxNjU0IDE3LjcyODcgNC44MTY1NCAxNy4zMzgyIDUuMjA3MDZMMTEuNTAwNyAxMS4wNDQ1TDUuNjYzMTEgNS4yMDY5NkM1LjI3MjU4IDQuODE2NDMgNC42Mzk0MiA0LjgxNjQzIDQuMjQ4OSA1LjIwNjk2TDQuMjA4NTcgNS4yNDcyOUMzLjgxODA0IDUuNjM3ODEgMy44MTgwNCA2LjI3MDk4IDQuMjA4NTcgNi42NjE1TDEwLjA0NjEgMTIuNDk5MUw0LjIwNjk2IDE4LjMzODNDMy44MTY0MyAxOC43Mjg4IDMuODE2NDMgMTkuMzYyIDQuMjA2OTYgMTkuNzUyNUw0LjI0NzI4IDE5Ljc5MjhDNC42Mzc4MSAyMC4xODM0IDUuMjcwOTcgMjAuMTgzNCA1LjY2MTUgMTkuNzkyOEwxMS41MDA3IDEzLjk1MzZMMTcuMzM5OCAxOS43OTI3WiIgZmlsbD0iI0ZGNjU5MyIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var trashGrey = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlRyYXNoIj4KPGcgaWQ9IlZlY3RvciI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNC41MDA3OCAzLjdWMTQuMUM0LjUwMDc4IDE0LjU0MTggNC44NTg5NSAxNC45IDUuMzAwNzggMTQuOUgxMS43MDA4QzEyLjE0MjYgMTQuOSAxMi41MDA4IDE0LjU0MTggMTIuNTAwOCAxNC4xVjMuN0gxNC4xMDA4VjE0LjFDMTQuMTAwOCAxNS40MjU1IDEzLjAyNjMgMTYuNSAxMS43MDA4IDE2LjVINS4zMDA3OEMzLjk3NTMgMTYuNSAyLjkwMDc4IDE1LjQyNTUgMi45MDA3OCAxNC4xVjMuN0g0LjUwMDc4WiIgZmlsbD0iIzYyNjI2MiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTYuOTAwNzggMC41QzYuNDU4OTUgMC41IDYuMTAwNzggMC44NTgxNzIgNi4xMDA3OCAxLjNIMi4xMDA3OEMxLjY1ODk1IDEuMyAxLjMwMDc4IDEuNjU4MTcgMS4zMDA3OCAyLjFDMS4zMDA3OCAyLjU0MTgzIDEuNjU4OTUgMi45IDIuMTAwNzggMi45SDE0LjkwMDhDMTUuMzQyNiAyLjkgMTUuNzAwOCAyLjU0MTgzIDE1LjcwMDggMi4xQzE1LjcwMDggMS42NTgxNyAxNS4zNDI2IDEuMyAxNC45MDA4IDEuM0gxMC45MDA4QzEwLjkwMDggMC44NTgxNzIgMTAuNTQyNiAwLjUgMTAuMTAwOCAwLjVINi45MDA3OFoiIGZpbGw9IiM2MjYyNjIiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var replaceGrey = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNyAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlJlcGxhY2UiPgo8ZyBpZD0iVmVjdG9yIj4KPHBhdGggZD0iTTEwLjA5OTYgMi4xSDMuNjk5NjFWMTAuMUg4LjQ5OTYxVjguOThDOC40OTk2MSA4Ljc4MjIzIDguNzI1MzkgOC42NjkzNCA4Ljg4MzYxIDguNzg4TDExLjQ0MzYgMTAuNzA4QzExLjU3MTYgMTAuODA0IDExLjU3MTYgMTAuOTk2IDExLjQ0MzYgMTEuMDkyTDguODgzNjEgMTMuMDEyQzguNzI1MzkgMTMuMTMwNyA4LjQ5OTYxIDEzLjAxNzggOC40OTk2MSAxMi44MlYxMS43SDIuODk5NjFDMi40NTc3OCAxMS43IDIuMDk5NjEgMTEuMzQxOCAyLjA5OTYxIDEwLjlWMS4zQzIuMDk5NjEgMC44NTgxNzMgMi40NTc3OCAwLjUgMi44OTk2MSAwLjVIOC4zMzM5MkM4LjQ0MDAxIDAuNSA4LjU0MTc1IDAuNTQyMTQzIDguNjE2NzcgMC42MTcxNTdMMTAuMDk5NiAyLjFaIiBmaWxsPSIjNjI2MjYyIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTEuMjk5NiA3LjdIMTMuMjk5NlYxNC45SDYuODk5NjFWMTMuM0g1LjI5OTYxVjE1LjdDNS4yOTk2MSAxNi4xNDE4IDUuNjU3NzggMTYuNSA2LjA5OTYxIDE2LjVIMTQuMDk5NkMxNC41NDE0IDE2LjUgMTQuODk5NiAxNi4xNDE4IDE0Ljg5OTYgMTUuN1Y3LjIzMTM3QzE0Ljg5OTYgNy4wMTkyIDE0LjgxNTMgNi44MTU3MSAxNC42NjUzIDYuNjY1NjlMMTEuOTMzOSAzLjkzNDMxQzExLjc4MzkgMy43ODQyOSAxMS41ODA0IDMuNyAxMS4zNjgyIDMuN0g2LjA5OTYxQzUuNjU3NzggMy43IDUuMjk5NjEgNC4wNTgxNyA1LjI5OTYxIDQuNVY4LjVINi44OTk2MVY1LjNIMTAuODk5NlY3LjNDMTAuODk5NiA3LjUyMDkxIDExLjA3ODcgNy43IDExLjI5OTYgNy43WiIgZmlsbD0iIzYyNjI2MiIvPgo8L2c+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var checkAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNy43NjU3IDMuODMzOTJDMTguMDc4MSA0LjE0NjM0IDE4LjA3ODEgNC42NTI4OCAxNy43NjU3IDQuOTY1MjlMOC4wNDg1MyAxNC42ODI1QzcuNTc5OSAxNS4xNTExIDYuODIwMSAxNS4xNTExIDYuMzUxNDcgMTQuNjgyNUwyLjIzNDMxIDEwLjU2NTNDMS45MjE5IDEwLjI1MjkgMS45MjE5IDkuNzQ2MzQgMi4yMzQzMSA5LjQzMzkyQzIuNTQ2NzMgOS4xMjE1IDMuMDUzMjcgOS4xMjE1IDMuMzY1NjkgOS40MzM5Mkw3LjIgMTMuMjY4MkwxNi42MzQzIDMuODMzOTJDMTYuOTQ2NyAzLjUyMTUgMTcuNDUzMyAzLjUyMTUgMTcuNzY1NyAzLjgzMzkyWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var questionMarkAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik05Ljk2Nzc1IDUuNTQ1NDVDOS4wMjk1NCA1LjU0NTQ1IDguMjQ0MDkgNi4yMDA1IDguMDY0MjMgNy4wNzEzN0M3LjkyMTk2IDcuNzYwMjMgNy4yMzg0NiA4LjIwNTMgNi41Mzc1OCA4LjA2NTQ3QzUuODM2NyA3LjkyNTY0IDUuMzgzODYgNy4yNTM4NSA1LjUyNjE0IDYuNTY1QzUuOTQ2MTggNC41MzExOSA3Ljc3MzU4IDMgOS45Njc3NSAzQzEyLjQ3MDggMyAxNC41IDQuOTk0MzcgMTQuNSA3LjQ1NDU1QzE0LjUgOS40NzMzOCAxMy4xMzQ3IDExLjE3NjMgMTEuMjYyNyAxMS43MjQzVjExLjkwOTFDMTEuMjYyNyAxMi42MTIgMTAuNjgyOSAxMy4xODE4IDkuOTY3NzUgMTMuMTgxOEM5LjI1MjU4IDEzLjE4MTggOC42NzI4MiAxMi42MTIgOC42NzI4MiAxMS45MDkxVjExLjI3MjdDOC42NzI4MiAxMC4xNyA5LjU1ODAxIDkuNDgzODggMTAuMzU1MSA5LjMyNTkyQzExLjI0MjQgOS4xNTAwOSAxMS45MTAxIDguMzc3NTQgMTEuOTEwMSA3LjQ1NDU1QzExLjkxMDEgNi40MDAxOCAxMS4wNDA1IDUuNTQ1NDUgOS45Njc3NSA1LjU0NTQ1WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTExLjI2MjcgMTUuNzI3M0MxMS4yNjI3IDE2LjQzMDIgMTAuNjgyOSAxNyA5Ljk2Nzc2IDE3QzkuMjUyNTkgMTcgOC42NzI4MyAxNi40MzAyIDguNjcyODMgMTUuNzI3M0M4LjY3MjgzIDE1LjAyNDQgOS4yNTI1OSAxNC40NTQ1IDkuOTY3NzYgMTQuNDU0NUMxMC42ODI5IDE0LjQ1NDUgMTEuMjYyNyAxNS4wMjQ0IDExLjI2MjcgMTUuNzI3M1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var mistake = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var maybeMistake = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var sortReversedActive = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNjAzMzkgMi4xOTg0QzUuODAzNTUgMS45MzgzNSA2LjE5NTcgMS45MzgzNSA2LjM5NTg1IDIuMTk4MzlMOC4zOTUyOSA0Ljc5NjE4QzguNjQ4MzUgNS4xMjQ5NyA4LjQxMzk2IDUuNjAxMTQgNy45OTkwNiA1LjYwMTE0SDYuNDk4MDNMNi40OTgwMyAxMy41MDE3QzYuNDk4MDMgMTMuNzc2OSA2LjI3NDkzIDE0IDUuOTk5NzMgMTRDNS43MjQ1MiAxNCA1LjUwMTQyIDEzLjc3NjkgNS41MDE0MiAxMy41MDE3TDUuNTAxNDIgNS42MDExNEg0LjAwMDE5QzMuNTg1MjkgNS42MDExNCAzLjM1MDkgNS4xMjQ5NyAzLjYwMzk2IDQuNzk2MThMNS42MDMzOSAyLjE5ODRaIiBmaWxsPSIjRjE3OEFFIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var sortActive = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNjAzMzkgMTMuODAxNkM1LjgwMzU1IDE0LjA2MTcgNi4xOTU3IDE0LjA2MTcgNi4zOTU4NSAxMy44MDE2TDguMzk1MjkgMTEuMjAzOEM4LjY0ODM1IDEwLjg3NSA4LjQxMzk2IDEwLjM5ODkgNy45OTkwNiAxMC4zOTg5SDYuNDk4MDNMNi40OTgwMyAyLjQ5ODNDNi40OTgwMyAyLjIyMzEgNi4yNzQ5MyAyIDUuOTk5NzMgMkM1LjcyNDUyIDIgNS41MDE0MiAyLjIyMzEgNS41MDE0MiAyLjQ5ODNMNS41MDE0MiAxMC4zOTg5SDQuMDAwMTlDMy41ODUyOSAxMC4zOTg5IDMuMzUwOSAxMC44NzUgMy42MDM5NiAxMS4yMDM4TDUuNjAzMzkgMTMuODAxNloiIGZpbGw9IiNGMTc4QUUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var sortActiveHover = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNjAzMzkgMTMuODAxNkM1LjgwMzU1IDE0LjA2MTcgNi4xOTU3IDE0LjA2MTcgNi4zOTU4NSAxMy44MDE2TDguMzk1MjkgMTEuMjAzOEM4LjY0ODM1IDEwLjg3NSA4LjQxMzk2IDEwLjM5ODkgNy45OTkwNiAxMC4zOTg5SDYuNDk4MDNMNi40OTgwMyAyLjQ5ODNDNi40OTgwMyAyLjIyMzEgNi4yNzQ5MyAyIDUuOTk5NzMgMkM1LjcyNDUyIDIgNS41MDE0MiAyLjIyMzEgNS41MDE0MiAyLjQ5ODNMNS41MDE0MiAxMC4zOTg5SDQuMDAwMTlDMy41ODUyOSAxMC4zOTg5IDMuMzUwOSAxMC44NzUgMy42MDM5NiAxMS4yMDM4TDUuNjAzMzkgMTMuODAxNloiIGZpbGw9IiNGMTc4QUUiLz4KPHBhdGggZD0iTTUuNjAzMzkgMTMuODAxNkM1LjgwMzU1IDE0LjA2MTcgNi4xOTU3IDE0LjA2MTcgNi4zOTU4NSAxMy44MDE2TDguMzk1MjkgMTEuMjAzOEM4LjY0ODM1IDEwLjg3NSA4LjQxMzk2IDEwLjM5ODkgNy45OTkwNiAxMC4zOTg5SDYuNDk4MDNMNi40OTgwMyAyLjQ5ODNDNi40OTgwMyAyLjIyMzEgNi4yNzQ5MyAyIDUuOTk5NzMgMkM1LjcyNDUyIDIgNS41MDE0MiAyLjIyMzEgNS41MDE0MiAyLjQ5ODNMNS41MDE0MiAxMC4zOTg5SDQuMDAwMTlDMy41ODUyOSAxMC4zOTg5IDMuMzUwOSAxMC44NzUgMy42MDM5NiAxMS4yMDM4TDUuNjAzMzkgMTMuODAxNloiIGZpbGw9ImJsYWNrIiBmaWxsLW9wYWNpdHk9IjAuMiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var sortReversedActiveHover = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxMiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNjAzMzkgMi4xOTg0QzUuODAzNTUgMS45MzgzNSA2LjE5NTcgMS45MzgzNSA2LjM5NTg1IDIuMTk4MzlMOC4zOTUyOSA0Ljc5NjE4QzguNjQ4MzUgNS4xMjQ5NyA4LjQxMzk2IDUuNjAxMTQgNy45OTkwNiA1LjYwMTE0SDYuNDk4MDNMNi40OTgwMyAxMy41MDE3QzYuNDk4MDMgMTMuNzc2OSA2LjI3NDkzIDE0IDUuOTk5NzMgMTRDNS43MjQ1MiAxNCA1LjUwMTQyIDEzLjc3NjkgNS41MDE0MiAxMy41MDE3TDUuNTAxNDIgNS42MDExNEg0LjAwMDE5QzMuNTg1MjkgNS42MDExNCAzLjM1MDkgNS4xMjQ5NyAzLjYwMzk2IDQuNzk2MThMNS42MDMzOSAyLjE5ODRaIiBmaWxsPSIjRjE3OEFFIi8+CjxwYXRoIGQ9Ik01LjYwMzM5IDIuMTk4NEM1LjgwMzU1IDEuOTM4MzUgNi4xOTU3IDEuOTM4MzUgNi4zOTU4NSAyLjE5ODM5TDguMzk1MjkgNC43OTYxOEM4LjY0ODM1IDUuMTI0OTcgOC40MTM5NiA1LjYwMTE0IDcuOTk5MDYgNS42MDExNEg2LjQ5ODAzTDYuNDk4MDMgMTMuNTAxN0M2LjQ5ODAzIDEzLjc3NjkgNi4yNzQ5MyAxNCA1Ljk5OTczIDE0QzUuNzI0NTIgMTQgNS41MDE0MiAxMy43NzY5IDUuNTAxNDIgMTMuNTAxN0w1LjUwMTQyIDUuNjAxMTRINC4wMDAxOUMzLjU4NTI5IDUuNjAxMTQgMy4zNTA5IDUuMTI0OTcgMy42MDM5NiA0Ljc5NjE4TDUuNjAzMzkgMi4xOTg0WiIgZmlsbD0iYmxhY2siIGZpbGwtb3BhY2l0eT0iMC4yIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var cms = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var sl = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var leanIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9ImdhbWUtaWNvbnM6ZmVhdGhlciI+CjxwYXRoIGlkPSJWZWN0b3IiIGQ9Ik0yMi4wNjQ0IDEuMjIzNjNMMTcuMjU5NyAyLjYyMDk4TDE5LjIwNSAxLjMwNDI2QzE3Ljk3NjkgMS41ODE3NiAxNi40MjUzIDIuMTI0NTcgMTQuNDc1MyAzLjAwMDY2TDExLjI5MjUgNi4zMTg5NEwxMi40MjIyIDQuMDAwOThDMTEuMzMgNC42MDg0OCAxMC4xNzIyIDUuNDA0ODggOS4wNTY1NiA2LjMzNzdMOC4zMTU5NCA5LjM1MTc2TDguMTU2NTYgNy4xMjA1MUM3LjA1NSA4LjEzMzAxIDYuMDE5MDYgOS4yNTgwMSA1LjE2MTI1IDEwLjQ0MzlDNC4yNTk4NCAxMS42ODYxIDMuNTU1MzEgMTIuOTk4NiAzLjIwMjM0IDE0LjMwNjRMMS44ODQyMiAxMy40MjUyQzIuMDAyMzQgMTQuNTM2MSAyLjM2NzUgMTUuNTAxOCAyLjk2NjU2IDE2LjM4NzdMMS4zOTA2MiAxNS45MDQ5QzEuNzQ4NzUgMTcuMDA2NCAyLjMzNDIyIDE3LjcxODkgMy4zMjQyMiAxOC4yOTU1QzIuNzY5NjkgMTkuODU2NCAyLjUwOTUzIDIxLjQ4NzcgMi4yMzAxNiAyMy4xMTQzTDMuMDkyNjYgMjMuMjU5NkM0LjA5Mjk3IDEzLjI4OTMgMTEuMTUxOSA2LjkzMzAxIDE3LjUzMTYgNC4xMTY3NkwxNy44NTUgNC45MzE0NEMxMi4xNTAzIDcuNDg2MTMgNy43MTU5NCAxMS43OTg2IDUuMzk1NjMgMTguMDE0M0M2LjI0NDA2IDE4LjAxODkgNy4wNzM3NSAxNy45MTU4IDcuODQyNSAxNy43MTg5TDguMDcyMTkgMTQuODY0M0w4LjY4NjI1IDE3LjQ2NThDOS4xOTcxOSAxNy4yNzgzIDkuNjY1OTQgMTcuMDUzMyAxMC4wODMxIDE2Ljc5MDhMOS4xMTI4MSAxNC43NTE4TDEwLjY1MDMgMTYuMzgzQzExLjAyNTMgMTYuMDgzIDExLjMzNDcgMTUuNzQ1NSAxMS41NjkxIDE1LjM3NTJDMTIuOTk0MSAxMy4xNDg2IDE0LjQ4NDcgMTAuOTM2MSAxNy40MTkxIDkuMDg0NTdMMTUuMjc2OSA4LjMyNTE5TDE4LjU2MjggOC40MjM2M0MxOS4wOTcyIDguMTUxNzYgMTkuNjU5NyA3LjgxODk0IDIwLjA4NjMgNy41MDQ4OEwxNy43NTY2IDcuMzE3MzhMMjEuMjU4MSA2LjQ5MjM4QzIxLjUzIDYuMjIwNTEgMjEuNzgzMSA1LjkzNDU3IDIyLjAxMjggNS42NDg2M0MyMi44MjM4IDQuNjIwMiAyMy4zNzIyIDMuNTQ5NTcgMjMuMjQwOSAyLjU3NTk4QzIzLjE4IDIuMDg4OTUgMjIuODg5NCAxLjYzMDk4IDIyLjQxNTkgMS4zNzQ1N0MyMi4yOTg4IDEuMzEzNjMgMjIuMTcyMiAxLjI1OTczIDIyLjA2NDQgMS4yMjM2M1oiIGZpbGw9IndoaXRlIi8+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var unit$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjMiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAyMyAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuOTk1MzEgMS4wMDUyN0M1Ljk5NTMxIDAuNDUzMzEyIDUuNTQ3ODYgMC4wMDU4NTkzOCA0Ljk5NTkgMC4wMDU4NTkzOEgyQzAuODk1NDMxIDAuMDA1ODU5MzggMCAwLjkwMTI5IDAgMi4wMDU4NlYxMi45OTQxQzAgMTQuMDk4NyAwLjg5NTQzIDE0Ljk5NDEgMiAxNC45OTQxSDQuOTk1OUM1LjU0Nzg2IDE0Ljk5NDEgNS45OTUzMSAxNC41NDY3IDUuOTk1MzEgMTMuOTk0N0M1Ljk5NTMxIDEzLjQ0MjggNS41NDc4NiAxMi45OTUzIDQuOTk1OSAxMi45OTUzSDQuMDY4MjVIMi4xNDExOFYyLjAwNDY5SDQuOTk1OUM1LjU0Nzg2IDIuMDA0NjkgNS45OTUzMSAxLjU1NzIzIDUuOTk1MzEgMS4wMDUyN1oiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjUuOTk2MDkiIHk9IjUuNSIgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjEiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjEyLjk5NjEiIHk9IjUuNSIgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjEiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xNi45OTQ5IDEuMDA1MjdDMTYuOTk0OSAwLjQ1MzMxMiAxNy40NDI0IDAuMDA1ODU5MzggMTcuOTk0MyAwLjAwNTg1OTM4SDIwLjk5MDJDMjIuMDk0OCAwLjAwNTg1OTM4IDIyLjk5MDIgMC45MDEyOSAyMi45OTAyIDIuMDA1ODZWMTIuOTk0MUMyMi45OTAyIDE0LjA5ODcgMjIuMDk0OCAxNC45OTQxIDIwLjk5MDIgMTQuOTk0MUgxNy45OTQzQzE3LjQ0MjQgMTQuOTk0MSAxNi45OTQ5IDE0LjU0NjcgMTYuOTk0OSAxMy45OTQ3QzE2Ljk5NDkgMTMuNDQyOCAxNy40NDI0IDEyLjk5NTMgMTcuOTk0MyAxMi45OTUzSDE4LjkyMkgyMC44NDkxVjIuMDA0NjlIMTcuOTk0M0MxNy40NDI0IDIuMDA0NjkgMTYuOTk0OSAxLjU1NzIzIDE2Ljk5NDkgMS4wMDUyN1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var endUnit = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyNiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE2LjQzMzMgMS43MDM0NUMxNi40MzMzIDAuOTAzOTY5IDE3LjA4MTQgMC4yNTU4NTkgMTcuODgwOSAwLjI1NTg1OUgyMi4yMjAzQzIzLjgyMDIgMC4yNTU4NTkgMjUuMTE3MiAxLjU1Mjg0IDI1LjExNzIgMy4xNTI3NVYxOS4wNjg2QzI1LjExNzIgMjAuNjY4NSAyMy44MjAyIDIxLjk2NTUgMjIuMjIwMyAyMS45NjU1SDE3Ljg4MDlDMTcuMDgxNCAyMS45NjU1IDE2LjQzMzMgMjEuMzE3NCAxNi40MzMzIDIwLjUxNzlDMTYuNDMzMyAxOS43MTg0IDE3LjA4MTQgMTkuMDcwMyAxNy44ODA5IDE5LjA3MDNIMTkuMjI0NkgyMi4wMTU4VjMuMTUxMDVIMTcuODgwOUMxNy4wODE0IDMuMTUxMDUgMTYuNDMzMyAyLjUwMjk0IDE2LjQzMzMgMS43MDM0NVoiIGZpbGw9IiM3MTY1OTYiLz4KPHJlY3Qgd2lkdGg9IjUuNzkzNzciIGhlaWdodD0iNS43OTM3NyIgcng9IjEuNDQ4NDQiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDE2LjQzMzYgOC4yMTM4NykiIGZpbGw9IiM3MTY1OTYiLz4KPHJlY3Qgd2lkdGg9IjUuNzkzNzciIGhlaWdodD0iNS43OTM3NyIgcng9IjEuNDQ4NDQiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDYuMjk0OTIgOC4yMTM4NykiIGZpbGw9IiM3MTY1OTYiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var startUnit = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuOTk1MzEgMS41MDUyN0M1Ljk5NTMxIDAuOTUzMzEyIDUuNTQ3ODYgMC41MDU4NTkgNC45OTU5IDAuNTA1ODU5SDJDMC44OTU0MzEgMC41MDU4NTkgMCAxLjQwMTI5IDAgMi41MDU4NlYxMy40OTQxQzAgMTQuNTk4NyAwLjg5NTQzIDE1LjQ5NDEgMiAxNS40OTQxSDQuOTk1OUM1LjU0Nzg2IDE1LjQ5NDEgNS45OTUzMSAxNS4wNDY3IDUuOTk1MzEgMTQuNDk0N0M1Ljk5NTMxIDEzLjk0MjggNS41NDc4NiAxMy40OTUzIDQuOTk1OSAxMy40OTUzSDQuMDY4MjVIMi4xNDExOFYyLjUwNDY5SDQuOTk1OUM1LjU0Nzg2IDIuNTA0NjkgNS45OTUzMSAyLjA1NzIzIDUuOTk1MzEgMS41MDUyN1oiIGZpbGw9IiM3MTY1OTYiLz4KPHJlY3QgeD0iNS45OTYwOSIgeT0iNiIgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjEiIGZpbGw9IiM3MTY1OTYiLz4KPHJlY3QgeD0iMTIuOTk2MSIgeT0iNiIgd2lkdGg9IjQiIGhlaWdodD0iNCIgcng9IjEiIGZpbGw9IiM3MTY1OTYiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var exportAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE5XzM0OSkiPgo8cGF0aCBkPSJNMTEgMTMuNzkyOUMxMSAxNC4zNDUyIDEwLjU1MjMgMTQuNzkyOSAxMCAxNC43OTI5QzkuNDQ3NzEgMTQuNzkyOSA5IDE0LjM0NTIgOSAxMy43OTI5VjMuMjA3MTFMNS4yMDcxMSA3QzQuODE2NTggNy4zOTA1MiA0LjE4MzQyIDcuMzkwNTIgMy43OTI4OSA3QzMuNDAyMzcgNi42MDk0OCAzLjQwMjM3IDUuOTc2MzEgMy43OTI4OSA1LjU4NTc5TDguOTM5MzQgMC40MzkzMzlDOS41MjUxMyAtMC4xNDY0NDYgMTAuNDc0OSAtMC4xNDY0NDcgMTEuMDYwNyAwLjQzOTMzOUwxNi4yMDcxIDUuNTg1NzlDMTYuNTk3NiA1Ljk3NjMxIDE2LjU5NzYgNi42MDk0OCAxNi4yMDcxIDdDMTUuODE2NiA3LjM5MDUyIDE1LjE4MzQgNy4zOTA1MiAxNC43OTI5IDdMMTEgMy4yMDcxMVYxMy43OTI5WiIgZmlsbD0iIzcxNjU5NiIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPHBhdGggZD0iTTIgMTJDMiAxMS40NDc3IDEuNTUyMjggMTEgMSAxMUMwLjQ0NzcxNSAxMSAwIDExLjQ0NzcgMCAxMlYxOEMwIDE5LjEwNDYgMC44OTU0MzEgMjAgMiAyMEgxOEMxOS4xMDQ2IDIwIDIwIDE5LjEwNDYgMjAgMThWMTJDMjAgMTEuNDQ3NyAxOS41NTIzIDExIDE5IDExQzE4LjQ0NzcgMTEgMTggMTEuNDQ3NyAxOCAxMlYxOEgyVjEyWiIgZmlsbD0iIzcxNjU5NiIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xOV8zNDkiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var apiManagement = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIiBmaWxsPSJub25lIj4KICA8cGF0aCBkPSJNMTAgMTIuMzkwM0w3LjYwOTY2IDkuOTk5OTlMMTAgNy42MDk2NUwxMi4zOTAzIDkuOTk5OTlMMTAgMTIuMzkwM1pNNy40NjAyNiA1Ljc4MjI0TDUuNDM4MDQgMy43NjEyTDguNjQxMDkgMC41NTgxNDVDOC44MzQ3MSAwLjM2NDUyNyA5LjA0OTg0IDAuMjIzMDk5IDkuMjg2NDggMC4xMzM4NTlDOS41MjMxMyAwLjA0NDYxOTcgOS43NjA5NyAwIDEwIDBDMTAuMjM5IDAgMTAuNDc2NSAwLjA0NDIyMTQgMTAuNzEyMyAwLjEzMjY2NEMxMC45NDgyIDAuMjIxMTA3IDExLjE2MzMgMC4zNjIxMzcgMTEuMzU3NyAwLjU1NTc1NUwxNC41NjIgMy43NTg4MUwxMi41Mzk3IDUuNzgyMjRMMTAgMy4yNDI1TDcuNDYwMjYgNS43ODIyNFpNMy43NjAwMiAxNC41NjJMMC41NTY5NiAxMS4zNTg5QzAuMzYzMzQyIDExLjE2NTMgMC4yMjE5MTQgMTAuOTUwMiAwLjEzMjY3NSAxMC43MTM1QzAuMDQzNDM1MiAxMC40NzY5IC0wLjAwMDc4NjIwMyAxMC4yMzkgMS4wNTc2N2UtMDUgOS45OTk5OUMwLjAwMDgwNzM1NyA5Ljc2MDk2IDAuMDQ1MDI4NyA5LjUyMzUyIDAuMTMyNjc1IDkuMjg3NjdDMC4yMjAzMiA5LjA1MTgyIDAuMzYxMzUxIDguODM2NjkgMC41NTU3NjUgOC42NDIyOEwzLjc1ODgyIDUuNDM4MDNMNS43ODIyNCA3LjQ2MDI2TDMuMjQyNTEgOS45OTk5OUw1Ljc4MjI0IDEyLjUzOTdMMy43NjAwMiAxNC41NjJaTTE2LjI0IDE0LjU2MkwxNC4yMTc4IDEyLjUzOTdMMTYuNzU3NSA5Ljk5OTk5TDE0LjIxNzggNy40NjAyNkwxNi4yNCA1LjQzODAzTDE5LjQ0MyA4LjY0MTA4QzE5LjYzNjcgOC44MzQ3IDE5Ljc3ODEgOS4wNDk4MyAxOS44NjczIDkuMjg2NDhDMTkuOTU2NiA5LjUyMzEyIDIwLjAwMDggOS43NjA5NiAyMCA5Ljk5OTk5QzE5Ljk5OTIgMTAuMjM5IDE5Ljk1NSAxMC40NzY1IDE5Ljg2NzMgMTAuNzEyM0MxOS43Nzk3IDEwLjk0ODIgMTkuNjM4NiAxMS4xNjMzIDE5LjQ0NDIgMTEuMzU3N0wxNi4yNCAxNC41NjJaTTguNjQxMDkgMTkuNDQ0Mkw1LjQzODA0IDE2LjI0MTJMNy40NjAyNiAxNC4yMTc4TDEwIDE2Ljc1NzVMMTIuNTM5NyAxNC4yMTc4TDE0LjU2MiAxNi4yNEwxMS4zNTg5IDE5LjQ0M0MxMS4xNjUzIDE5LjYzNjcgMTAuOTUwMiAxOS43NzgxIDEwLjcxMzUgMTkuODY3M0MxMC40NzY5IDE5Ljk1NjYgMTAuMjM5IDIwLjAwMDggMTAgMjBDOS43NjA5NyAxOS45OTkyIDkuNTIzNTMgMTkuOTU1IDkuMjg3NjggMTkuODY3M0M5LjA1MTgzIDE5Ljc3OTcgOC44MzY3IDE5LjYzODYgOC42NDIyOSAxOS40NDQyIiBmaWxsPSIjNjI2MjYyIi8+Cjwvc3ZnPg==";

/* loaded by smart-asset */
var purpleCheck = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS43NjU3IDIuMzM0MjlDMTYuMDc4MSAyLjY0NjcxIDE2LjA3ODEgMy4xNTMyNCAxNS43NjU3IDMuNDY1NjZMNi4wNDg1MyAxMy4xODI4QzUuNTc5OSAxMy42NTE0IDQuODIwMSAxMy42NTE0IDQuMzUxNDcgMTMuMTgyOEwwLjIzNDMxNSA5LjA2NTY2Qy0wLjA3ODEwNDkgOC43NTMyNCAtMC4wNzgxMDQ5IDguMjQ2NzEgMC4yMzQzMTUgNy45MzQyOUMwLjU0NjczNCA3LjYyMTg3IDEuMDUzMjcgNy42MjE4NyAxLjM2NTY5IDcuOTM0MjlMNS4yIDExLjc2ODZMMTQuNjM0MyAyLjMzNDI5QzE0Ljk0NjcgMi4wMjE4NyAxNS40NTMzIDIuMDIxODcgMTUuNzY1NyAyLjMzNDI5WiIgZmlsbD0iIzcxNjU5NiIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var visibilityAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjAyMTUgOC41MDEzOEMxMC4wMjE1IDkuNjIwNzcgOS4xMTA1OCAxMC41MzE3IDcuOTkxMTkgMTAuNTMxN0M2Ljg3MTggMTAuNTMxNyA1Ljk2MDg2IDkuNjIwNzcgNS45NjA4NiA4LjUwMTM4QzUuOTYwODYgNy4zODE5OSA2Ljg3MTggNi40NzEwNCA3Ljk5MTE5IDYuNDcxMDRDOS4xMTA1OCA2LjQ3MTA0IDEwLjAyMTUgNy4zODE5OSAxMC4wMjE1IDguNTAxMzhaTTE1Ljg4MTkgNy44MzE3OEMxNi4wMzI3IDguMDU3NjMgMTYuMDM5IDguMzQyODggMTUuOTAxMiA4LjU3Njk0QzE1LjE0OTYgOS44NTM4NyAxMi40MTIyIDEzLjkxNTYgOC4wMDEzNCAxMy45MTU2QzMuOTI1OTUgMTMuOTE1NiAwLjk2Njg4MiA5Ljg5MzU0IDAuMTE4MjQ0IDguNTk1OUMtMC4wNDEzMTEyIDguMzUxOTIgLTAuMDM5OTc1MyA4LjA0NTIzIDAuMTI1Nzk4IDcuODA1NDNDMC45NTI3NjkgNi42MDkyMSAzLjc0ODcyIDMuMDg3MTYgOC4wMDEzNCAzLjA4NzE2QzEyLjM1NjQgMy4wODcxNiAxNS4xMDA0IDYuNjYxODggMTUuODgxOSA3LjgzMTc4Wk0xMS4zNzUxIDguNTAxMzhDMTEuMzc1MSA2LjYzNTUgOS44NTcwNiA1LjExNzQ5IDcuOTkxMTkgNS4xMTc0OUM2LjEyNTMxIDUuMTE3NDkgNC42MDczIDYuNjM1NSA0LjYwNzMgOC41MDEzOEM0LjYwNzMgMTAuMzY3MyA2LjEyNTMxIDExLjg4NTMgNy45OTExOSAxMS44ODUzQzkuODU3MDYgMTEuODg1MyAxMS4zNzUxIDEwLjM2NzMgMTEuMzc1MSA4LjUwMTM4WiIgZmlsbD0iIzcxNjU5NiIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var copyAdmin = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMTY2NjcgMTguODMzM0MzLjcwODMzIDE4LjgzMzMgMy4zMTU4MyAxOC42NyAyLjk4OTE3IDE4LjM0MzNDMi42NjI1IDE4LjAxNjYgMi40OTk0NSAxNy42MjQ0IDIuNSAxNy4xNjY2VjUuNDk5OTZINC4xNjY2N1YxNy4xNjY2SDEzLjMzMzNWMTguODMzM0g0LjE2NjY3Wk03LjUgMTUuNUM3LjA0MTY3IDE1LjUgNi42NDkxNyAxNS4zMzY2IDYuMzIyNSAxNS4wMUM1Ljk5NTgzIDE0LjY4MzMgNS44MzI3OCAxNC4yOTExIDUuODMzMzMgMTMuODMzM1YzLjgzMzI5QzUuODMzMzMgMy4zNzQ5NiA1Ljk5NjY3IDIuOTgyNDYgNi4zMjMzMyAyLjY1NTc5QzYuNjUgMi4zMjkxMyA3LjA0MjIyIDIuMTY2MDcgNy41IDIuMTY2NjNIMTVDMTUuNDU4MyAyLjE2NjYzIDE1Ljg1MDggMi4zMjk5NiAxNi4xNzc1IDIuNjU2NjNDMTYuNTA0MiAyLjk4MzI5IDE2LjY2NzIgMy4zNzU1MiAxNi42NjY3IDMuODMzMjlWMTMuODMzM0MxNi42NjY3IDE0LjI5MTYgMTYuNTAzMyAxNC42ODQxIDE2LjE3NjcgMTUuMDEwOEMxNS44NSAxNS4zMzc1IDE1LjQ1NzggMTUuNTAwNSAxNSAxNS41SDcuNVpNNy41IDEzLjgzMzNIMTVWMy44MzMyOUg3LjVWMTMuODMzM1oiIGZpbGw9IiM3MTY1OTYiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var adminArrowLeft = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxMyAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjAyNDI1IDMuMTk5NjZDNS43ODk5NCAyLjk2NTM1IDUuNDEwMDQgMi45NjUzNSA1LjE3NTcyIDMuMTk5NjZMMS44NzU3MiA2LjQ5OTY2QzEuNjQxNDEgNi43MzM5OCAxLjY0MTQxIDcuMTEzODggMS44NzU3MiA3LjM0ODE5TDUuMTc1NzIgMTAuNjQ4MkM1LjQxMDA0IDEwLjg4MjUgNS43ODk5NCAxMC44ODI1IDYuMDI0MjUgMTAuNjQ4MkM2LjI1ODU3IDEwLjQxMzkgNi4yNTg1NyAxMC4wMzQgNi4wMjQyNSA5Ljc5OTY2TDMuNzQ4NTIgNy41MjM5M0gxMC43QzExLjAzMTQgNy41MjM5MyAxMS4zIDcuMjU1MyAxMS4zIDYuOTIzOTNDMTEuMyA2LjU5MjU2IDExLjAzMTQgNi4zMjM5MyAxMC43IDYuMzIzOTNIMy43NDg1Mkw2LjAyNDI1IDQuMDQ4MTlDNi4yNTg1NyAzLjgxMzg4IDYuMjU4NTcgMy40MzM5OCA2LjAyNDI1IDMuMTk5NjZaIiBmaWxsPSIjNzE2NTk2IiBmaWxsLW9wYWNpdHk9IjAuNyIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var trashPink = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjUwMDA1IDUuN1YxNi4xQzYuNTAwMDUgMTYuNTQxOCA2Ljg1ODIyIDE2LjkgNy4zMDAwNSAxNi45SDEzLjdDMTQuMTQxOSAxNi45IDE0LjUgMTYuNTQxOCAxNC41IDE2LjFWNS43SDE2LjFWMTYuMUMxNi4xIDE3LjQyNTUgMTUuMDI1NSAxOC41IDEzLjcgMTguNUg3LjMwMDA1QzUuOTc0NTcgMTguNSA0LjkwMDA1IDE3LjQyNTUgNC45MDAwNSAxNi4xVjUuN0g2LjUwMDA1WiIgZmlsbD0iI0YxNzhBRSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTguOTAwMDUgMi41QzguNDU4MjIgMi41IDguMTAwMDUgMi44NTgxNyA4LjEwMDA1IDMuM0g0LjEwMDA1QzMuNjU4MjIgMy4zIDMuMzAwMDUgMy42NTgxNyAzLjMwMDA1IDQuMUMzLjMwMDA1IDQuNTQxODMgMy42NTgyMiA0LjkgNC4xMDAwNSA0LjlIMTYuOUMxNy4zNDE5IDQuOSAxNy43IDQuNTQxODMgMTcuNyA0LjFDMTcuNyAzLjY1ODE3IDE3LjM0MTkgMy4zIDE2LjkgMy4zSDEyLjlDMTIuOSAyLjg1ODE3IDEyLjU0MTkgMi41IDEyLjEgMi41SDguOTAwMDVaIiBmaWxsPSIjRjE3OEFFIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var plusButton = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjExLjY0OTkiIGhlaWdodD0iMTEuNjQ5OSIgcng9IjUuODI0OTciIGZpbGw9IiNGMTc4QUUiLz4KPHBhdGggZD0iTTkuMDg2ODkgNS4zNTg5N0g2LjI5MDlWMi41NjI5OEM2LjI5MDkgMi40MzkzOSA2LjI0MTgxIDIuMzIwODYgNi4xNTQ0MSAyLjIzMzQ3QzYuMDY3MDIgMi4xNDYwOCA1Ljk0ODQ5IDIuMDk2OTggNS44MjQ5IDIuMDk2OThDNS43MDEzMSAyLjA5Njk4IDUuNTgyNzkgMi4xNDYwOCA1LjQ5NTM5IDIuMjMzNDdDNS40MDggMi4zMjA4NiA1LjM1ODkxIDIuNDM5MzkgNS4zNTg5MSAyLjU2Mjk4VjUuMzU4OTdIMi41NjI5MkMyLjQzOTMzIDUuMzU4OTcgMi4zMjA4IDUuNDA4MDYgMi4yMzM0MSA1LjQ5NTQ2QzIuMTQ2MDIgNS41ODI4NSAyLjA5NjkyIDUuNzAxMzcgMi4wOTY5MiA1LjgyNDk3QzIuMDk2OTIgNS45NDg1NiAyLjE0NjAyIDYuMDY3MDggMi4yMzM0MSA2LjE1NDQ3QzIuMzIwOCA2LjI0MTg3IDIuNDM5MzMgNi4yOTA5NiAyLjU2MjkyIDYuMjkwOTZINS4zNTg5MVY5LjA4Njk1QzUuMzU4OTEgOS4yMTA1NCA1LjQwOCA5LjMyOTA3IDUuNDk1MzkgOS40MTY0NkM1LjU4Mjc5IDkuNTAzODUgNS43MDEzMSA5LjU1Mjk1IDUuODI0OSA5LjU1Mjk1QzUuOTQ4NDkgOS41NTI5NSA2LjA2NzAyIDkuNTAzODUgNi4xNTQ0MSA5LjQxNjQ2QzYuMjQxODEgOS4zMjkwNyA2LjI5MDkgOS4yMTA1NCA2LjI5MDkgOS4wODY5NVY2LjI5MDk2SDkuMDg2ODlDOS4yMTA0OCA2LjI5MDk2IDkuMzI5MDEgNi4yNDE4NyA5LjQxNjQgNi4xNTQ0N0M5LjUwMzc5IDYuMDY3MDggOS41NTI4OCA1Ljk0ODU2IDkuNTUyODggNS44MjQ5N0M5LjU1Mjg4IDUuNzAxMzcgOS41MDM3OSA1LjU4Mjg1IDkuNDE2NCA1LjQ5NTQ2QzkuMzI5MDEgNS40MDgwNiA5LjIxMDQ4IDUuMzU4OTcgOS4wODY4OSA1LjM1ODk3WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var trashButton = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjExLjY1IiBoZWlnaHQ9IjExLjY1IiByeD0iNS44MjUiIGZpbGw9IiNGMTc4QUUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjI1MDEgMy45VjguNDVDNC4yNTAxIDguNjQzMyA0LjQwNjggOC44IDQuNjAwMSA4LjhINy40MDAxQzcuNTkzNCA4LjggNy43NTAxIDguNjQzMyA3Ljc1MDEgOC40NVYzLjlIOC40NTAxVjguNDVDOC40NTAxIDkuMDI5OSA3Ljk4IDkuNSA3LjQwMDEgOS41SDQuNjAwMUM0LjAyMDIgOS41IDMuNTUwMSA5LjAyOTkgMy41NTAxIDguNDVWMy45SDQuMjUwMVoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNS4zMDAxIDIuNUM1LjEwNjggMi41IDQuOTUwMSAyLjY1NjcgNC45NTAxIDIuODVIMy4yMDAxQzMuMDA2OCAyLjg1IDIuODUwMSAzLjAwNjcgMi44NTAxIDMuMkMyLjg1MDEgMy4zOTMzIDMuMDA2OCAzLjU1IDMuMjAwMSAzLjU1SDguODAwMUM4Ljk5MzQgMy41NSA5LjE1MDEgMy4zOTMzIDkuMTUwMSAzLjJDOS4xNTAxIDMuMDA2NyA4Ljk5MzQgMi44NSA4LjgwMDEgMi44NUg3LjA1MDFDNy4wNTAxIDIuNjU2NyA2Ljg5MzQgMi41IDYuNzAwMSAyLjVINS4zMDAxWiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var cameraPurple = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var alertTriangle = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMy41MTUxIDMuMTI1NjFDMTIuMDAwOCAwLjMzODAzOSA3Ljk5OTUyIDAuMzM4MDAyIDYuNDg1MjYgMy4xMjU1NkwwLjUyODgzNSAxNC4wOTA2Qy0wLjkxOTAyMiAxNi43NTU5IDEuMDEwNTEgMjAgNC4wNDM3MSAyMEgxNS45NTY0QzE4Ljk4OTUgMjAgMjAuOTE5MSAxNi43NTYgMTkuNDcxMyAxNC4wOTA3TDEzLjUxNTEgMy4xMjU2MVpNMTAgNS41QzkuMDk3ODkgNS41IDguMzk5OTEgNi4yOTA2NiA4LjUxMTggNy4xODU4TDkuMDQ1MTggMTEuNDUyOEM5LjA2MTgxIDExLjU4NTkgOS4xMDUxIDExLjcwOTcgOS4xNjkyOSAxMS44MTk0QzkuMTc3NyAxMS44MzM3IDkuMTg2NDUgMTEuODQ3OCA5LjE5NTU2IDExLjg2MTdDOS4yMzk4MyAxMS45MjkgOS4yOTIyNiAxMS45OTAzIDkuMzUxMzYgMTIuMDQ0MkM5LjQ4MTI5IDEyLjE2MjggOS42NDM0NyAxMi4yNDU4IDkuODIyMTEgMTIuMjc5MkM5Ljg3OTg2IDEyLjI5IDkuOTM5MzQgMTIuMjk1NyAxMCAxMi4yOTU3QzEwLjM1MTIgMTIuMjk1NyAxMC42NjI2IDEyLjEwNjQgMTAuODMwNyAxMS44MTk0QzEwLjgzNjggMTEuODA4OSAxMC44NDI3IDExLjc5ODMgMTAuODQ4NSAxMS43ODc2QzEwLjkwMjkgMTEuNjg2IDEwLjkzOTggMTEuNTczMiAxMC45NTQ4IDExLjQ1MjhMMTEuNDg4MiA3LjE4NThDMTEuNjAwMSA2LjI5MDY2IDEwLjkwMjEgNS41IDEwIDUuNVpNOS45OTk5NyAxNi4yNjEzQzkuMjE4MDYgMTYuMjYxMyA4LjU4NDIgMTUuNjI3NSA4LjU4NDIgMTQuODQ1NkM4LjU4NDIgMTQuNDQ3MSA4Ljc0ODc4IDE0LjA4NzIgOS4wMTM2NSAxMy44Mjk5QzkuMDQxMTggMTMuODAzMiA5LjA2OTc5IDEzLjc3NzUgOS4wOTk0MSAxMy43NTMxQzkuMzQ0MTQgMTMuNTUxMSA5LjY1Nzg4IDEzLjQyOTggOS45OTk5NyAxMy40Mjk4QzEwLjExNzUgMTMuNDI5OCAxMC4yMzE2IDEzLjQ0NDEgMTAuMzQwOCAxMy40NzExQzEwLjU0MzQgMTMuNTIxMiAxMC43Mjg4IDEzLjYxNDggMTAuODg2NSAxMy43NDE2QzEwLjkyMTEgMTMuNzY5NSAxMC45NTQ0IDEzLjc5OSAxMC45ODYzIDEzLjgyOTlMMTEuMDAxMSAxMy44NDQ1QzExLjI1NzMgMTQuMTAwNyAxMS40MTU3IDE0LjQ1NDYgMTEuNDE1NyAxNC44NDU2QzExLjQxNTcgMTUuNjI3NSAxMC43ODE5IDE2LjI2MTMgOS45OTk5NyAxNi4yNjEzWiIgZmlsbD0iI0YxNzhBRSIvPgo8L3N2Zz4K";

/* loaded by smart-asset */
var adminCheck = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkNoZWNrIiBjbGlwLXBhdGg9InVybCgjY2xpcDBfMzc1XzM2NjQ5KSI+CjxwYXRoIGlkPSJWZWN0b3IgMTU0IChTdHJva2UpIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE2LjMwNTIgNC4yNjg5OUMxNi42MTE5IDQuNTUwMTcgMTYuNjExOSA1LjAwNjA0IDE2LjMwNTIgNS4yODcyMkw2Ljc2NDczIDE0LjAzMjdDNi4zMDQ2MiAxNC40NTQ0IDUuNTU4NjMgMTQuNDU0NCA1LjA5ODUzIDE0LjAzMjdMMS4wNTYyMyAxMC4zMjcyQzAuNzQ5NDg3IDEwLjA0NiAwLjc0OTQ4NyA5LjU5MDE3IDEuMDU2MjMgOS4zMDg5OUMxLjM2Mjk3IDkuMDI3ODEgMS44NjAyOSA5LjAyNzgxIDIuMTY3MDMgOS4zMDg5OUw1LjkzMTYzIDEyLjc1OTlMMTUuMTk0NCA0LjI2ODk5QzE1LjUwMTEgMy45ODc4MSAxNS45OTg1IDMuOTg3ODEgMTYuMzA1MiA0LjI2ODk5WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8zNzVfMzY2NDkiPgo8cmVjdCB3aWR0aD0iMTUuNzA5MSIgaGVpZ2h0PSIxNC40IiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC44MjYxNzIgMC45ODE5MzQpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var tagging = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var vulnerabilityFix = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDMiIHZpZXdCb3g9IjAgMCA0MiA0MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IkZyYW1lIDExNTI5MzMyIj4KPGcgaWQ9Ikdyb3VwIDExNTI0OTI3Ij4KPHBhdGggaWQ9IlZlY3RvciIgZD0iTTMuNSA5LjQ1NzI0VjEzLjI1NTdMMzYuOTI2NSAxMy4yNTU3VjkuNDU3MjRMMy41IDkuNDU3MjRaIiBmaWxsPSIjREQ0OTRGIi8+CjxwYXRoIGlkPSJWZWN0b3JfMiIgZD0iTTMuNSAzMy43Njc1VjM2LjgwNjNIMzYuOTI2NVYzMy43Njc1SDMuNVoiIGZpbGw9IiNERDQ5NEYiLz4KPHBhdGggaWQ9IlZlY3Rvcl8zIiBkPSJNMTguNjEzMSAyMC4yMDA3TDI0LjEwMDggNi40MDE5MUwyMi45NzA0IDQuNzA2MDlMMjAuOTg0IDUuMTYyMzZMMTUuNDk2MyAxOC45NjEyTDE2LjEyMjUgMTguNTAxMkwxNi4wMzQ0IDE4LjkzODhMMTYuNzM4MSAxOC41NzQxTDE2Ljg0MzggMTkuNDk3MUwxNy4wNTQ2IDE5LjU4MDlMMTcuNTgzNyAxOC43MTdMMTcuODQ1NiAxOS44OTU1TDE4LjQ2NzMgMTkuMzA0OEwxOC4zNjUxIDIwLjEwMjFMMTguNjEzMSAyMC4yMDA3WiIgZmlsbD0iI0RENDk0RiIvPgo8cGF0aCBpZD0iVmVjdG9yXzQiIGQ9Ik0xNy4xMTE3IDIwLjc3MTlMMTkuNjAyMSAzOS4xMzk0TDIyLjkyNiAzOC42ODg4TDIwLjQzNTUgMjAuMzIxM0wyMC40MzgyIDIxLjU4NDJMMjAuMTUxMyAyMC4zNTk4TDE5Ljk5NzUgMjAuODYwMkwxOS42NzY1IDIwLjQyNDJMMTkuMTc4OSAyMC4xNzJMMTkuMDkwMiAyMC41MDM3TDE5LjAzMjYgMjEuNDcwNUwxOC42Njc1IDIwLjU2MUwxOC40NTcxIDIwLjU4OTVMMTguMzU4NSAyMS4yNDAyTDE3Ljg5MjkgMjAuMzQ2NEwxNy42NTg0IDIwLjY5NzhMMTcuNjE1NyAyMS40MjI5TDE3LjExMTcgMjAuNzcxOVoiIGZpbGw9IiNERDQ5NEYiLz4KPGcgaWQ9Ikdyb3VwIDExNTI0OTI5Ij4KPHBhdGggaWQ9IlZlY3Rvcl81IiBkPSJNMTEuOTY2OCAzOC41ODJIOS4zMDI0OFY1LjUyMjAzTDEwLjYzNDcgNC42NDA1MkwxMS45NjY4IDUuNTIyMDNWMzguNTgyWiIgZmlsbD0iI0RENDk0RiIgc3Ryb2tlPSIjREQ0OTRGIiBzdHJva2Utd2lkdGg9IjAuODM1NjYzIi8+CjwvZz4KPGcgaWQ9Ikdyb3VwIDExNTI0OTI4Ij4KPHBhdGggaWQ9IlZlY3Rvcl82IiBkPSJNMzEuNTg0MiAzOC41ODJIMjguOTE5OFY1LjUyMjAzTDMwLjI1MiA0LjY0MDUyTDMxLjU4NDIgNS41MjIwM1YzOC41ODJaIiBmaWxsPSIjREQ0OTRGIiBzdHJva2U9IiNERDQ5NEYiIHN0cm9rZS13aWR0aD0iMC44MzU2NjMiLz4KPC9nPgo8L2c+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var errorBox = "EdmGqKFH.svg";

/* loaded by smart-asset */
var copyAdminWhite = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuNjY2NjcgMTguMzMzM0M0LjIwODMzIDE4LjMzMzMgMy44MTU4MyAxOC4xNyAzLjQ4OTE3IDE3Ljg0MzNDMy4xNjI1IDE3LjUxNjYgMi45OTk0NSAxNy4xMjQ0IDMgMTYuNjY2NlY0Ljk5OTk2SDQuNjY2NjdWMTYuNjY2NkgxMy44MzMzVjE4LjMzMzNINC42NjY2N1pNOCAxNUM3LjU0MTY3IDE1IDcuMTQ5MTcgMTQuODM2NiA2LjgyMjUgMTQuNTFDNi40OTU4MyAxNC4xODMzIDYuMzMyNzggMTMuNzkxMSA2LjMzMzMzIDEzLjMzMzNWMy4zMzMyOUM2LjMzMzMzIDIuODc0OTYgNi40OTY2NyAyLjQ4MjQ2IDYuODIzMzMgMi4xNTU3OUM3LjE1IDEuODI5MTMgNy41NDIyMiAxLjY2NjA3IDggMS42NjY2M0gxNS41QzE1Ljk1ODMgMS42NjY2MyAxNi4zNTA4IDEuODI5OTYgMTYuNjc3NSAyLjE1NjYzQzE3LjAwNDIgMi40ODMyOSAxNy4xNjcyIDIuODc1NTIgMTcuMTY2NyAzLjMzMzI5VjEzLjMzMzNDMTcuMTY2NyAxMy43OTE2IDE3LjAwMzMgMTQuMTg0MSAxNi42NzY3IDE0LjUxMDhDMTYuMzUgMTQuODM3NSAxNS45NTc4IDE1LjAwMDUgMTUuNSAxNUg4Wk04IDEzLjMzMzNIMTUuNVYzLjMzMzI5SDhWMTMuMzMzM1oiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var downloadAdminWhite = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMSAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjMgMi44QzExLjMgMi4zNTgxNyAxMC45NDE4IDIgMTAuNSAyQzEwLjA1ODIgMiA5LjcgMi4zNTgxNyA5LjcgMi44VjExLjI2ODZMNi42NjU2OSA4LjIzNDMxQzYuMzUzMjcgNy45MjE5IDUuODQ2NzMgNy45MjE5IDUuNTM0MzEgOC4yMzQzMUM1LjIyMTkgOC41NDY3MyA1LjIyMTkgOS4wNTMyNyA1LjUzNDMxIDkuMzY1NjlMOS42NTE0NyAxMy40ODI4QzEwLjEyMDEgMTMuOTUxNSAxMC44Nzk5IDEzLjk1MTUgMTEuMzQ4NSAxMy40ODI4TDE1LjQ2NTcgOS4zNjU2OUMxNS43NzgxIDkuMDUzMjcgMTUuNzc4MSA4LjU0NjczIDE1LjQ2NTcgOC4yMzQzMUMxNS4xNTMzIDcuOTIxOSAxNC42NDY3IDcuOTIxOSAxNC4zMzQzIDguMjM0MzFMMTEuMyAxMS4yNjg2VjIuOFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik00LjEgMTEuNkM0LjEgMTEuMTU4MiAzLjc0MTgzIDEwLjggMy4zIDEwLjhDMi44NTgxNyAxMC44IDIuNSAxMS4xNTgyIDIuNSAxMS42VjE2LjRDMi41IDE3LjI4MzcgMy4yMTYzNCAxOCA0LjEgMThIMTYuOUMxNy43ODM3IDE4IDE4LjUgMTcuMjgzNyAxOC41IDE2LjRWMTEuNkMxOC41IDExLjE1ODIgMTguMTQxOCAxMC44IDE3LjcgMTAuOEMxNy4yNTgyIDEwLjggMTYuOSAxMS4xNTgyIDE2LjkgMTEuNlYxNi40SDQuMVYxMS42WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var vulnerabilityMed = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzciIGhlaWdodD0iMzciIHZpZXdCb3g9IjAgMCAzNyAzNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlZ1bG5lcmFiaWxpdHktbWVkIj4KPGcgaWQ9IlZlY3RvciI+CjxwYXRoIGQ9Ik00LjgxNzAyIDUuNDc5OTJDOS4yMTM4MyA1LjE1MzY0IDEzLjU0NSAzLjY0NDk0IDE3LjMzNDQgMC45NTM4M0MxOC4wMzAxIDAuNDU5ODQ4IDE4Ljk2OTEgMC40NTk4NDggMTkuNjY0NyAwLjk1MzgzQzIzLjQ1NDIgMy42NDQ5NCAyNy43ODU0IDUuMTUzNjQgMzIuMTgyMiA1LjQ3OTkyQzMzLjE4NjggNS41NTQ0OCAzNC4wMDYgNi4zNzU2OCAzMy45OTMyIDcuMzgzMDNDMzMuNjk4NSAzMC41MTA5IDI3Ljc0MzcgMzIuODc5NyAxOS4yMzkyIDM2LjI2MjhMMTkuMTc4NyAzNi4yODY4QzE4Ljc0MzUgMzYuNDYgMTguMjU1NyAzNi40NiAxNy44MjA1IDM2LjI4NjhMMTcuNzU5OSAzNi4yNjI4QzkuMjU1NTIgMzIuODc5NyAzLjMwMDcyIDMwLjUxMDkgMy4wMDYwMSA3LjM4MzAzQzIuOTkzMTcgNi4zNzU2OCAzLjgxMjM0IDUuNTU0NDggNC44MTcwMiA1LjQ3OTkyWiIgZmlsbD0iI0Y5QUU0RCIvPgo8cGF0aCBkPSJNMTAuNDk5NSAxMS4wMTk4SDE0LjMwNDVMMTguMzIzMiAyMC44MjQ1SDE4LjQ5NDNMMjIuNTEzIDExLjAxOThIMjYuMzE4VjI1LjYxMjhIMjMuMzI1M1YxNi4xMTQ1SDIzLjIwNDJMMTkuNDI3NyAyNS41NDE1SDE3LjM4OThMMTMuNjEzMyAxNi4wNzg5SDEzLjQ5MjJWMjUuNjEyOEgxMC40OTk1VjExLjAxOThaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+CjwvZz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var vulnerabilityHigh = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTQuMzYzNDIgNC43MzI5OEM2LjgxNzQ1IDQuNTUwODYgOS4yMzQ4MyAzLjcwODggMTEuMzQ5OSAyLjIwNjc4QzExLjczODEgMS45MzEwNyAxMi4yNjIzIDEuOTMxMDcgMTIuNjUwNSAyLjIwNjc4QzE0Ljc2NTYgMy43MDg4IDE3LjE4MyA0LjU1MDg2IDE5LjYzNyA0LjczMjk4QzIwLjE5NzcgNC43NzQ1OSAyMC42NTUgNS4yMzI5MyAyMC42NDc4IDUuNzk1MThDMjAuNDgzMyAxOC43MDM3IDE3LjE1OTcgMjAuMDI1OSAxMi40MTMgMjEuOTE0MUwxMi4zNzkzIDIxLjkyNzVDMTIuMTM2MyAyMi4wMjQyIDExLjg2NDEgMjIuMDI0MiAxMS42MjEyIDIxLjkyNzVMMTEuNTg3NCAyMS45MTQxQzYuODQwNzIgMjAuMDI1OSAzLjUxNzExIDE4LjcwMzcgMy4zNTI2MiA1Ljc5NTE4QzMuMzQ1NDYgNS4yMzI5MyAzLjgwMjY3IDQuNzc0NTkgNC4zNjM0MiA0LjczMjk4WiIgZmlsbD0iI0Y4Nzg4RiIvPgo8cGF0aCBkPSJNOC41MzAyNiAxNS45Njk5VjcuODI1MDFIMTAuMjUyM1YxMS4xODU2SDEzLjc0ODFWNy44MjUwMUgxNS40NjYyVjE1Ljk2OTlIMTMuNzQ4MVYxMi42MDU0SDEwLjI1MjNWMTUuOTY5OUg4LjUzMDI2WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var vulnerabilityLow = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9IlZ1bG5lcmFiaWxpdHktbG93Ij4KPGcgaWQ9IlZlY3RvciI+CjxwYXRoIGQ9Ik0yLjM2MzQyIDIuNzMyOThDNC44MTc0NSAyLjU1MDg2IDcuMjM0ODMgMS43MDg4IDkuMzQ5ODkgMC4yMDY3ODNDOS43MzgxMyAtMC4wNjg5Mjc3IDEwLjI2MjMgLTAuMDY4OTI3NyAxMC42NTA1IDAuMjA2NzgzQzEyLjc2NTYgMS43MDg4IDE1LjE4MyAyLjU1MDg2IDE3LjYzNyAyLjczMjk4QzE4LjE5NzcgMi43NzQ1OSAxOC42NTUgMy4yMzI5MyAxOC42NDc4IDMuNzk1MThDMTguNDgzMyAxNi43MDM3IDE1LjE1OTcgMTguMDI1OSAxMC40MTMgMTkuOTE0MUwxMC4zNzkzIDE5LjkyNzVDMTAuMTM2MyAyMC4wMjQyIDkuODY0MDYgMjAuMDI0MiA5LjYyMTE1IDE5LjkyNzVMOS41ODczNyAxOS45MTQxQzQuODQwNzIgMTguMDI1OSAxLjUxNzExIDE2LjcwMzcgMS4zNTI2MiAzLjc5NTE4QzEuMzQ1NDYgMy4yMzI5MyAxLjgwMjY3IDIuNzc0NTkgMi4zNjM0MiAyLjczMjk4WiIgZmlsbD0iI0JEQkVDNiIvPgo8cGF0aCBkPSJNNy41MzA5OCAxMy45Njk5VjUuODI1MDFIOS4yNTMwMlYxMi41NTAxSDEyLjc0NDhWMTMuOTY5OUg3LjUzMDk4WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L2c+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var cbGold = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var lockCircled = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var revertGray = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjE4OTkgMS45ODcwN0M0LjQ3MTA4IDIuMjY4MjQgNC40NzEwOCAyLjcyNDEyIDQuMTg5OSAzLjAwNTNMMy4yNTkwMiAzLjkzNjE4SDEwLjE2MDhDMTIuOTQ0MyAzLjkzNjE4IDE1LjIwMDggNi4xOTI2NyAxNS4yMDA4IDguOTc2MThDMTUuMjAwOCAxMS43NTk3IDEyLjk0NDMgMTQuMDE2MiAxMC4xNjA4IDE0LjAxNjJIOC43MjA3OEM4LjMyMzE0IDE0LjAxNjIgOC4wMDA3OCAxMy42OTM4IDguMDAwNzggMTMuMjk2MkM4LjAwMDc4IDEyLjg5ODUgOC4zMjMxNCAxMi41NzYyIDguNzIwNzggMTIuNTc2MkgxMC4xNjA4QzEyLjE0OSAxMi41NzYyIDEzLjc2MDggMTAuOTY0NCAxMy43NjA4IDguOTc2MThDMTMuNzYwOCA2Ljk4Nzk2IDEyLjE0OSA1LjM3NjE4IDEwLjE2MDggNS4zNzYxOEgzLjI1OTAyTDQuMTg5OSA2LjMwNzA3QzQuNDcxMDggNi41ODgyNCA0LjQ3MTA4IDcuMDQ0MTIgNC4xODk5IDcuMzI1M0MzLjkwODcyIDcuNjA2NDggMy40NTI4NCA3LjYwNjQ4IDMuMTcxNjYgNy4zMjUzTDEuMDExNjYgNS4xNjUzQzAuNzMwNDg3IDQuODg0MTIgMC43MzA0ODcgNC40MjgyNSAxLjAxMTY2IDQuMTQ3MDdMMy4xNzE2NiAxLjk4NzA3QzMuNDUyODQgMS43MDU4OSAzLjkwODcyIDEuNzA1ODkgNC4xODk5IDEuOTg3MDdaIiBmaWxsPSJ3aGl0ZSIgZmlsbC1vcGFjaXR5PSIwLjciLz4KPC9zdmc+Cg==";

/* loaded by smart-asset */
var arrowBack = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAxOCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS40Njk3IDQuMTE1ODhDMTEuMTc2OCA0LjQwODc3IDExLjE3NjggNC44ODM2NSAxMS40Njk3IDUuMTc2NTRMMTQuNjg5MyA4LjM5NjIxTDExLjQ2OTcgMTEuNjE1OUMxMS4xNzY4IDExLjkwODggMTEuMTc2OCAxMi4zODM2IDExLjQ2OTcgMTIuNjc2NUMxMS43NjI2IDEyLjk2OTQgMTIuMjM3NCAxMi45Njk0IDEyLjUzMDMgMTIuNjc2NUwxNi4yODAzIDguOTI2NTRDMTYuNTczMiA4LjYzMzY1IDE2LjU3MzIgOC4xNTg3NyAxNi4yODAzIDcuODY1ODhMMTIuNTMwMyA0LjExNTg4QzEyLjIzNzQgMy44MjI5OSAxMS43NjI2IDMuODIyOTkgMTEuNDY5NyA0LjExNTg4WiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuNjI1IDguMzk2MjFDMTQuNjI1IDcuOTgyIDE0LjI4OTIgNy42NDYyMSAxMy44NzUgNy42NDYyMUg5Ljc1QzUuMTkzNTQgNy42NDYyMSAxLjUgMTEuMzM5NyAxLjUgMTUuODk2MlYxNi42NDYyQzEuNSAxNy4wNjA0IDEuODM1NzkgMTcuMzk2MiAyLjI1IDE3LjM5NjJDMi42NjQyMSAxNy4zOTYyIDMgMTcuMDYwNCAzIDE2LjY0NjJWMTUuODk2MkMzIDEyLjE2ODIgNi4wMjE5NiA5LjE0NjIxIDkuNzUgOS4xNDYyMUgxMy44NzVDMTQuMjg5MiA5LjE0NjIxIDE0LjYyNSA4LjgxMDQyIDE0LjYyNSA4LjM5NjIxWiIgZmlsbD0id2hpdGUiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";

/* loaded by smart-asset */
var infoBlue = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var loader = "data:image/svg+xml;base64,77u/PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHZpZXdCb3g9JzAgMCAyMDAgMjAwJz48cmFkaWFsR3JhZGllbnQgaWQ9J2EyJyBjeD0nLjY2JyBmeD0nLjY2JyBjeT0nLjMxMjUnIGZ5PScuMzEyNScgZ3JhZGllbnRUcmFuc2Zvcm09J3NjYWxlKDEuNSknPjxzdG9wIG9mZnNldD0nMCcgc3RvcC1jb2xvcj0nI0YxNzhBRSc+PC9zdG9wPjxzdG9wIG9mZnNldD0nLjMnIHN0b3AtY29sb3I9JyNGMTc4QUUnIHN0b3Atb3BhY2l0eT0nLjknPjwvc3RvcD48c3RvcCBvZmZzZXQ9Jy42JyBzdG9wLWNvbG9yPScjRjE3OEFFJyBzdG9wLW9wYWNpdHk9Jy42Jz48L3N0b3A+PHN0b3Agb2Zmc2V0PScuOCcgc3RvcC1jb2xvcj0nI0YxNzhBRScgc3RvcC1vcGFjaXR5PScuMyc+PC9zdG9wPjxzdG9wIG9mZnNldD0nMScgc3RvcC1jb2xvcj0nI0YxNzhBRScgc3RvcC1vcGFjaXR5PScwJz48L3N0b3A+PC9yYWRpYWxHcmFkaWVudD48Y2lyY2xlIHRyYW5zZm9ybS1vcmlnaW49J2NlbnRlcicgZmlsbD0nbm9uZScgc3Ryb2tlPSd1cmwoI2EyKScgc3Ryb2tlLXdpZHRoPScxNScgc3Ryb2tlLWxpbmVjYXA9J3JvdW5kJyBzdHJva2UtZGFzaGFycmF5PScyMDAgMTAwMCcgc3Ryb2tlLWRhc2hvZmZzZXQ9JzAnIGN4PScxMDAnIGN5PScxMDAnIHI9JzcwJz48YW5pbWF0ZVRyYW5zZm9ybSB0eXBlPSdyb3RhdGUnIGF0dHJpYnV0ZU5hbWU9J3RyYW5zZm9ybScgY2FsY01vZGU9J3NwbGluZScgZHVyPScyJyB2YWx1ZXM9JzM2MDswJyBrZXlUaW1lcz0nMDsxJyBrZXlTcGxpbmVzPScwIDAgMSAxJyByZXBlYXRDb3VudD0naW5kZWZpbml0ZSc+PC9hbmltYXRlVHJhbnNmb3JtPjwvY2lyY2xlPjxjaXJjbGUgdHJhbnNmb3JtLW9yaWdpbj0nY2VudGVyJyBmaWxsPSdub25lJyBvcGFjaXR5PScuMicgc3Ryb2tlPScjRjE3OEFFJyBzdHJva2Utd2lkdGg9JzE1JyBzdHJva2UtbGluZWNhcD0ncm91bmQnIGN4PScxMDAnIGN5PScxMDAnIHI9JzcwJz48L2NpcmNsZT48L3N2Zz4=";

/* loaded by smart-asset */
var scrollDown = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNSAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InBhamFtYXM6c2Nyb2xsLWRvd24iPgo8cGF0aCBpZD0iVmVjdG9yIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTkuNTc2ODkgMTIuMjVDOS41NzY4OSAxMi43MTQxIDkuMzkyNTIgMTMuMTU5MiA5LjA2NDMzIDEzLjQ4NzRDOC43MzYxNCAxMy44MTU2IDguMjkxMDIgMTQgNy44MjY4OSAxNEM3LjM2Mjc2IDE0IDYuOTE3NjQgMTMuODE1NiA2LjU4OTQ2IDEzLjQ4NzRDNi4yNjEyNyAxMy4xNTkyIDYuMDc2ODkgMTIuNzE0MSA2LjA3Njg5IDEyLjI1QzYuMDc2ODkgMTEuNzg1OSA2LjI2MTI3IDExLjM0MDggNi41ODk0NiAxMS4wMTI2QzYuOTE3NjQgMTAuNjg0NCA3LjM2Mjc2IDEwLjUgNy44MjY4OSAxMC41QzguMjkxMDIgMTAuNSA4LjczNjE0IDEwLjY4NDQgOS4wNjQzMyAxMS4wMTI2QzkuMzkyNTIgMTEuMzQwOCA5LjU3Njg5IDExLjc4NTkgOS41NzY4OSAxMi4yNVpNMTEuMTM0NCA0LjUxNDEyQzExLjAxMTMgNC4zOTEyMyAxMC44NDQ1IDQuMzIyMiAxMC42NzA2IDQuMzIyMkMxMC40OTY3IDQuMzIyMiAxMC4zMjk5IDQuMzkxMjMgMTAuMjA2OSA0LjUxNDEyTDguNDgzMTQgNi4yMzc4N1YwLjY1NjI1QzguNDgzMTQgMC40ODIyMDIgOC40MTQgMC4zMTUyODIgOC4yOTA5MyAwLjE5MjIxMUM4LjE2Nzg2IDAuMDY5MTQwNCA4LjAwMDk0IDAgNy44MjY4OSAwQzcuNjUyODQgMCA3LjQ4NTkyIDAuMDY5MTQwNCA3LjM2Mjg1IDAuMTkyMjExQzcuMjM5NzggMC4zMTUyODIgNy4xNzA2NCAwLjQ4MjIwMiA3LjE3MDY0IDAuNjU2MjVWNi4yMzc4N0w1LjQ0Njg5IDQuNTE0MTJDNS4zMjI0OSA0LjM5ODIgNS4xNTc5NSA0LjMzNTEgNC45ODc5MyA0LjMzODFDNC44MTc5MiA0LjM0MTEgNC42NTU3MSA0LjQwOTk3IDQuNTM1NDcgNC41MzAyMUM0LjQxNTI0IDQuNjUwNDQgNC4zNDYzNiA0LjgxMjY1IDQuMzQzMzYgNC45ODI2N0M0LjM0MDM2IDUuMTUyNjggNC40MDM0NyA1LjMxNzIyIDQuNTE5MzkgNS40NDE2Mkw3LjM2MzE0IDguMjg1MzdMNy44MjY4OSA4Ljc1TDguMjkwNjQgOC4yODYyNUwxMS4xMzQ0IDUuNDQyNUMxMS4xOTU0IDUuMzgxNTYgMTEuMjQzOCA1LjMwOTE5IDExLjI3NjggNS4yMjk1NUMxMS4zMDk4IDUuMTQ5OSAxMS4zMjY4IDUuMDY0NTMgMTEuMzI2OCA0Ljk3ODMxQzExLjMyNjggNC44OTIxIDExLjMwOTggNC44MDY3MyAxMS4yNzY4IDQuNzI3MDhDMTEuMjQzOCA0LjY0NzQzIDExLjE5NTQgNC41NzUwNyAxMS4xMzQ0IDQuNTE0MTJaIiBmaWxsPSJ3aGl0ZSIvPgo8L2c+Cjwvc3ZnPgo=";

const svgImages = {
    replaceGrey,
    trashGrey,
    golbet,
    medal,
    zoomIn,
    questionIcon,
    rectangle,
    download,
    filterNoResults,
    adminDashboardEmptyState,
    teamLeaderboard,
    userLeaderboard,
    edit,
    editLeft,
    file,
    trash,
    time: time$1,
    carbonUndo,
    courseCardIcon,
    lessonsList,
    publish,
    missingFile,
    emptyStateContentManagement,
    linkedCourses,
    defaultIcon,
    iconWithCamera,
    homeIcon,
    learnIcon,
    testIcon,
    playIcon,
    notification,
    newNotification,
    logout,
    downArrowIcon,
    admin,
    difficulty,
    pending,
    challengeDefaultIcon,
    lessonDefaultIcon,
    templateCardClock,
    templateCardTeamMembers,
    templateCardClose,
    templateCardArrow,
    check,
    done,
    error,
    users,
    errorIcon,
    plus,
    cancel,
    arrowRight,
    noNotificationsIcon,
    replace,
    deleteIcon,
    account,
    retake,
    lessonSmallIcon,
    assessmentIcon,
    rightArrowIcon,
    expand,
    unExpand,
    doneBlue,
    dot,
    reTakeAction,
    devCoin,
    barChart,
    lessonIconLearningPanel,
    courseIconLearningPanel,
    tournamentIconLearningPanel,
    assessmentIconLearningPanel,
    challengeIconLearningPanel,
    menu,
    primaryEmptyAssessment,
    primaryEmptyCourse,
    primaryEmptyLesson,
    primaryEmptyTournament,
    primaryEmptyChallenge,
    courseBannerIcon,
    courseBannerIconBig,
    rate,
    share,
    back,
    contentCoin,
    contentLine,
    contentLineDone,
    exitIcon,
    senderIcon,
    searchIcon,
    teamCoins,
    defaultProfilePicture,
    pinkPlus,
    camera,
    coffee,
    strongEmptyState,
    fairEmptyState,
    poorEmptyState,
    retakeChallenge,
    correct,
    incorrect,
    checkmarx,
    adminPanel,
    settings,
    openInNewTab,
    people,
    rounds,
    tournamentIcon,
    lessonTagline,
    tournamentResultsIcon,
    tournamentBannerIcon,
    clock,
    fullLeaderboard,
    playNextLesson,
    primaryCourseClose,
    cbLogo,
    calendar: calendar$1,
    leftLinedArrow,
    rightLinedArrow,
    tournamentSmallIcon,
    popup,
    userSelection,
    path: path$1,
    info,
    videoLearningPanel,
    devCoinShadow,
    blueCheck,
    skillTree,
    language,
    editLanguages,
    pathThin,
    key,
    chevronDown,
    chevronUp,
    linkedInShare,
    linkedIn,
    support,
    sso,
    quest,
    google,
    github,
    upDownExpand,
    close,
    progress,
    unExpandIcon,
    assignedContentIcon,
    careerJourneyIcon,
    monthlyVideosIcon,
    recentlyAddedIcon,
    otherAreTakingIcon,
    leaderboardRank,
    timeWhite,
    resume,
    lessonBannerIcon,
    chevronRight,
    chevronLeft,
    chevronRightWhite,
    arrowLeftPagination,
    arrowRightPagination,
    plusIcon,
    usersIcon,
    grayInfoIcon,
    customCourse,
    grayClose,
    filter: filter$2,
    buttonIconCourse,
    buttonIconLesson,
    buttonIconLearningPath,
    assign: assign$2,
    unAssign,
    warning,
    noSearchResults,
    team,
    checkbox,
    expandAdmin,
    unExpandAdmin,
    adminIcon,
    customCourseIcon,
    editAdmin,
    trashAdmin,
    trashLight,
    filterAdmin,
    assignContentMenuIcon,
    activityFeedMenuIcon,
    rightChevronDark,
    filterAdminGray,
    successIcon,
    errorNotificationIcon,
    closeIcon,
    backToOldUi,
    adminExpand,
    warningYellow,
    customLesson,
    start: start$1,
    complete,
    logIn,
    logOut,
    deleteEvent,
    invite,
    create,
    upload,
    lock,
    register,
    activate,
    deactivate,
    assessment,
    course,
    usersEvent,
    learningPath,
    lesson,
    setPrimaryCourse,
    skillTreeEvent,
    user,
    videoTutorial,
    adminWarning,
    surveyYes,
    surveyNo,
    surveyMaybe,
    heart,
    infiniteScroll,
    searchIconGray,
    heartNowShadow,
    whiteCheck,
    downloadHub,
    newIcon,
    errorIconAdmin,
    greenCheck,
    KebabMenuAdmin,
    saveAdmin,
    dateIconAdmin,
    sortIcon,
    EditIconAdmin,
    TrashIconAdmin,
    table,
    exportIcon,
    DownloadAdmin,
    kebab,
    retry,
    calendarAdmin,
    downloadIconAdmin,
    failedToDelete,
    retryPink,
    revertPink,
    spinner,
    asterisk,
    send,
    inviteUsers,
    bell,
    trashWhite,
    adminChevron,
    warningTriangle,
    uploadAdmin,
    pinkCheck,
    alertIconAdmin,
    alertIconPurpleAdmin,
    contentManagement,
    license,
    uploadImage,
    unpublishCourse,
    publishedCourse,
    sort,
    courseDeletionUsersIcon,
    uploadScorm,
    questionMark,
    zipFile,
    publishedIcon,
    unpublishedIcon,
    changeTo,
    linkIcon,
    certificate,
    certificateIconLearningPanel,
    chevronNoBackground,
    smallZipFile,
    closeRed,
    checkAdmin,
    questionMarkAdmin,
    mistake,
    maybeMistake,
    sortActive,
    sortActiveHover,
    sortReversedActive,
    sortReversedActiveHover,
    cms,
    sl,
    leanIcon,
    unit: unit$1,
    endUnit,
    startUnit,
    exportAdmin,
    apiManagement,
    purpleCheck,
    visibilityAdmin,
    copyAdmin,
    adminArrowLeft,
    trashPink,
    plusButton,
    trashButton,
    cameraPurple,
    alertTriangle,
    adminCheck,
    tagging,
    vulnerabilityFix,
    errorBox,
    copyAdminWhite,
    downloadAdminWhite,
    vulnerabilityMed,
    cbGold,
    lockCircled,
    revertGray,
    vulnerabilityHigh,
    vulnerabilityLow,
    arrowBack,
    infoBlue,
    loader,
    scrollDown
};

const DynamicSvg = (props) => {
    const { fullPath, getDefaultImage, onClick, dataTestid, toolTipText = '' } = props, rest = __rest$1(props, ["fullPath", "getDefaultImage", "onClick", "dataTestid", "toolTipText"]);
    const [content, setContent] = useState('');
    const [src, setSrc] = useState(fullPath || getDefaultImage || '');
    useEffect(() => {
        let isMounted = true;
        fetch(src)
            .then(res => res.text())
            .catch(() => undefined)
            .then((c) => __awaiter(void 0, void 0, void 0, function* () {
            c.includes('svg')
                ? isMounted && setContent(c)
                : isMounted && getDefaultImage && setSrc(getDefaultImage);
        }))
            .catch(() => undefined);
        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fullPath, src]);
    return (jsx(TooltipContainer, Object.assign({ hasBorder: true, hasDefaultStyle: true, unsetMaxWidth: true, placement: "top-start", title: toolTipText, dataTestid: "avatar-tooltip" }, { children: jsx("div", Object.assign({ "data-testid": dataTestid, dangerouslySetInnerHTML: { __html: content }, onClick: (_e) => onClick === null || onClick === void 0 ? void 0 : onClick() }, rest), void 0) }), void 0));
};

const Icon = (_a) => {
    var { name = '', src = '', onClick, tooltipText, isPng = false } = _a, rest = __rest$1(_a, ["name", "src", "onClick", "tooltipText", "isPng"]);
    let url = src;
    if (name) {
        url = isPng ? pngImages[name] : svgImages[name];
    }
    if (isPng && url)
        return jsx("img", Object.assign({ src: url }, rest), void 0);
    return (jsx("div", Object.assign({ title: tooltipText, style: onClick ? { cursor: 'pointer' } : {} }, { children: jsx(DynamicSvg, Object.assign({ fullPath: url, onClick: (_) => onClick === null || onClick === void 0 ? void 0 : onClick() }, rest), void 0) }), void 0));
};

var ButtonTypesName;
(function (ButtonTypesName) {
    ButtonTypesName[ButtonTypesName["primaryFlat"] = 0] = "primaryFlat";
    ButtonTypesName[ButtonTypesName["primary"] = 1] = "primary";
    ButtonTypesName[ButtonTypesName["secondaryFlat"] = 2] = "secondaryFlat";
    ButtonTypesName[ButtonTypesName["secondary"] = 3] = "secondary";
    ButtonTypesName[ButtonTypesName["pink"] = 4] = "pink";
    ButtonTypesName[ButtonTypesName["green"] = 5] = "green";
    ButtonTypesName[ButtonTypesName["textFlat"] = 6] = "textFlat";
    ButtonTypesName[ButtonTypesName["disabledText"] = 7] = "disabledText";
    ButtonTypesName[ButtonTypesName["primaryDisabled"] = 8] = "primaryDisabled";
    ButtonTypesName[ButtonTypesName["disabled"] = 9] = "disabled";
    ButtonTypesName[ButtonTypesName["disabledOutlinedFlat"] = 10] = "disabledOutlinedFlat";
    ButtonTypesName[ButtonTypesName["outlinedFlat"] = 11] = "outlinedFlat";
    ButtonTypesName[ButtonTypesName["outlinedFlatGray"] = 12] = "outlinedFlatGray";
    ButtonTypesName[ButtonTypesName["outlinedFlatWhite"] = 13] = "outlinedFlatWhite";
    ButtonTypesName[ButtonTypesName["outlinedFlatWhiteDisabled"] = 14] = "outlinedFlatWhiteDisabled";
    ButtonTypesName[ButtonTypesName["gradient"] = 15] = "gradient";
    ButtonTypesName[ButtonTypesName["learningPanel"] = 16] = "learningPanel";
    ButtonTypesName[ButtonTypesName["learningPanelAdmin"] = 17] = "learningPanelAdmin";
    ButtonTypesName[ButtonTypesName["gradientDisable"] = 18] = "gradientDisable";
    ButtonTypesName[ButtonTypesName["bigGradient"] = 19] = "bigGradient";
    ButtonTypesName[ButtonTypesName["bigGradientDisable"] = 20] = "bigGradientDisable";
    ButtonTypesName[ButtonTypesName["flatGray"] = 21] = "flatGray";
    ButtonTypesName[ButtonTypesName["flatGrayActive"] = 22] = "flatGrayActive";
    ButtonTypesName[ButtonTypesName["flatGrayOpacity"] = 23] = "flatGrayOpacity";
    ButtonTypesName[ButtonTypesName["rosePurple"] = 24] = "rosePurple";
    ButtonTypesName[ButtonTypesName["rosePurpleDisabled"] = 25] = "rosePurpleDisabled";
    ButtonTypesName[ButtonTypesName["linearGradientGray"] = 26] = "linearGradientGray";
    ButtonTypesName[ButtonTypesName["transparentStyle"] = 27] = "transparentStyle";
    ButtonTypesName[ButtonTypesName["flatFullGray"] = 28] = "flatFullGray";
    ButtonTypesName[ButtonTypesName["gradientDisableSameColor"] = 29] = "gradientDisableSameColor";
    ButtonTypesName[ButtonTypesName["gradientNoBorder"] = 30] = "gradientNoBorder";
    ButtonTypesName[ButtonTypesName["gradientNoBorderDisabled"] = 31] = "gradientNoBorderDisabled";
    ButtonTypesName[ButtonTypesName["purpleStatic"] = 32] = "purpleStatic";
    ButtonTypesName[ButtonTypesName["purple"] = 33] = "purple";
    ButtonTypesName[ButtonTypesName["learningPanelAdminDisabled"] = 34] = "learningPanelAdminDisabled";
    ButtonTypesName[ButtonTypesName["learningPanelAdminNoBg"] = 35] = "learningPanelAdminNoBg";
    ButtonTypesName[ButtonTypesName["learningPanelAdminActionButton"] = 36] = "learningPanelAdminActionButton";
    ButtonTypesName[ButtonTypesName["learningPanelAdminActionButtonDisabled"] = 37] = "learningPanelAdminActionButtonDisabled";
    ButtonTypesName[ButtonTypesName["learningPanelAdminActionButtonDisabledBg"] = 38] = "learningPanelAdminActionButtonDisabledBg";
    ButtonTypesName[ButtonTypesName["learningPanelAdminLinearClickedButton"] = 39] = "learningPanelAdminLinearClickedButton";
    ButtonTypesName[ButtonTypesName["learningPanelAdminActionButtonIcon"] = 40] = "learningPanelAdminActionButtonIcon";
    ButtonTypesName[ButtonTypesName["learningPanelAdminPurpleDarkButton"] = 41] = "learningPanelAdminPurpleDarkButton";
    ButtonTypesName[ButtonTypesName["learningPanelAdminPurpleDarkButtonDisabled"] = 42] = "learningPanelAdminPurpleDarkButtonDisabled";
    ButtonTypesName[ButtonTypesName["learningPanelAdminCancel"] = 43] = "learningPanelAdminCancel";
    ButtonTypesName[ButtonTypesName["learningPanelAdminPink"] = 44] = "learningPanelAdminPink";
    ButtonTypesName[ButtonTypesName["learningPanelAdminPinkActive"] = 45] = "learningPanelAdminPinkActive";
    ButtonTypesName[ButtonTypesName["learningPanelAdminPurpleButtonIcon"] = 46] = "learningPanelAdminPurpleButtonIcon";
    ButtonTypesName[ButtonTypesName["learningPanelAdminLightPurple"] = 47] = "learningPanelAdminLightPurple";
    ButtonTypesName[ButtonTypesName["learningPanelAdminOnlyText"] = 48] = "learningPanelAdminOnlyText";
    ButtonTypesName[ButtonTypesName["learningPanelAdminOnlyTextBold"] = 49] = "learningPanelAdminOnlyTextBold";
    ButtonTypesName[ButtonTypesName["learningPanelAdminCredentialCardAction"] = 50] = "learningPanelAdminCredentialCardAction";
    ButtonTypesName[ButtonTypesName["learningPanelAdminActionButtonIconSelected"] = 51] = "learningPanelAdminActionButtonIconSelected";
    ButtonTypesName[ButtonTypesName["learningPanelAdminActionMenuButton"] = 52] = "learningPanelAdminActionMenuButton";
    ButtonTypesName[ButtonTypesName["learningPanelFlatGray"] = 53] = "learningPanelFlatGray";
})(ButtonTypesName || (ButtonTypesName = {}));
var ButtonColor;
(function (ButtonColor) {
    ButtonColor["inherit"] = "inherit";
    ButtonColor["primary"] = "primary";
    ButtonColor["secondary"] = "secondary";
    ButtonColor["default"] = "default";
})(ButtonColor || (ButtonColor = {}));
var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant["text"] = "text";
    ButtonVariant["outlined"] = "outlined";
    ButtonVariant["contained"] = "contained";
})(ButtonVariant || (ButtonVariant = {}));
const primaryStyle = {
    variant: ButtonVariant.contained,
    color: ButtonColor.primary
};
const secondaryStyle = {
    variant: ButtonVariant.contained,
    color: ButtonColor.secondary
};
const pinkStyle = {
    variant: ButtonVariant.contained,
    className: classNames('class-bg-colour-pink', 'class-font-colour-white')
};
const greenStyle = {
    variant: ButtonVariant.contained,
    className: classNames('class-bg-colour-green', 'class-font-colour-white')
};
const disabledStyle = {
    variant: ButtonVariant.contained,
    disabled: true
};
const outlinedPrimary = {
    variant: ButtonVariant.outlined,
    color: ButtonColor.primary
};
const bigGradientStyle = {
    variant: ButtonVariant.contained,
    className: 'big-button-gradient',
    wrapperClass: 'gradient-wrapper'
};
const learningPanel = {
    variant: ButtonVariant.contained,
    className: 'learning-panel-button'
};
const bigGradientDisableStyle = {
    variant: ButtonVariant.contained,
    className: 'big-button-gradient-disable',
    wrapperClass: 'gradient-wrapper'
};
const transparentStyle = {
    variant: ButtonVariant.contained,
    className: 'transparent-panel-button'
};
const gradientDisableSameColorStyle = {
    variant: ButtonVariant.contained,
    className: 'button-gradient-disable-same-color',
    wrapperClass: 'gradient-wrapper'
};
const buttonType = {
    primaryFlat: Object.assign(Object.assign({}, primaryStyle), { flat: true }),
    primary: Object.assign(Object.assign({}, primaryStyle), { flat: false }),
    secondaryFlat: Object.assign(Object.assign({}, secondaryStyle), { flat: true }),
    secondary: Object.assign(Object.assign({}, secondaryStyle), { flat: false }),
    pink: Object.assign(Object.assign({}, pinkStyle), { flat: false }),
    green: Object.assign(Object.assign({}, greenStyle), { flat: false }),
    textFlat: { variant: ButtonVariant.text, flat: true },
    disabledText: Object.assign(Object.assign({}, disabledStyle), { variant: ButtonVariant.text, flat: true }),
    primaryDisabled: Object.assign(Object.assign(Object.assign({}, primaryStyle), disabledStyle), { className: 'class-bg-colour-primary', style: { opacity: 0.5 }, flat: false }),
    disabled: Object.assign(Object.assign({}, disabledStyle), { flat: false }),
    disabledOutlinedFlat: Object.assign(Object.assign({}, disabledStyle), { variant: ButtonVariant.outlined, className: classNames('class-border-colour-light-gray', 'class-font-colour-light-gray'), flat: true }),
    outlinedFlat: Object.assign(Object.assign({}, outlinedPrimary), { flat: true }),
    outlinedFlatGray: Object.assign(Object.assign({}, outlinedPrimary), { flat: true, className: 'outlinedFlatGray' }),
    outlinedFlatWhite: Object.assign(Object.assign({}, outlinedPrimary), { flat: true, className: 'outlinedFlatWhite' }),
    outlinedFlatWhiteDisabled: Object.assign(Object.assign({}, outlinedPrimary), { flat: true, className: 'outlinedFlatWhiteDisabled', disabled: true }),
    gradient: Object.assign(Object.assign({}, bigGradientStyle), { className: 'button-gradient' }),
    gradientDisableSameColor: Object.assign(Object.assign({}, gradientDisableSameColorStyle), { disabled: true }),
    gradientDisable: Object.assign(Object.assign({}, bigGradientDisableStyle), { className: 'button-gradient-disable', disabled: true }),
    bigGradient: Object.assign({}, bigGradientStyle),
    bigGradientDisable: Object.assign(Object.assign({}, bigGradientDisableStyle), { disabled: true }),
    linearGradientGray: { className: 'linear-gradient-gray' },
    learningPanel: Object.assign({}, learningPanel),
    gradientNoBorder: { className: 'gradient-no-border' },
    gradientNoBorderDisabled: { className: 'gradient-no-border-disabled', disabled: true },
    flatGray: {
        flat: true,
        className: 'flat-gray'
    },
    rosePurple: {
        className: 'rose-purple'
    },
    rosePurpleDisabled: {
        className: 'rose-purple-disabled',
        disabled: true
    },
    flatGrayOpacity: { flat: true, className: 'flat-gray-opacity' },
    transparentStyle: Object.assign({}, transparentStyle),
    flatFullGray: {
        flat: true,
        className: 'flat-full-gray'
    },
    purpleStatic: { className: 'purple-static' },
    purple: { className: 'purple' },
    learningPanelAdmin: { className: 'learning-panel-admin-button' },
    learningPanelAdminDisabled: { className: 'learning-panel-admin-button-disabled', disabled: true },
    learningPanelAdminNoBg: { className: 'learning-panel-admin-button-not-bg' },
    learningPanelAdminActionButton: { className: 'learning-panel-admin-action-button' },
    learningPanelAdminActionButtonIcon: { className: 'learning-panel-admin-action-button-icon' },
    learningPanelAdminActionButtonIconSelected: { className: 'learning-panel-admin-action-button-icon-selected' },
    learningPanelAdminActionButtonDisabled: {
        className: 'learning-panel-admin-action-button-disabled',
        disabled: true
    },
    learningPanelAdminActionButtonDisabledBg: {
        className: 'learning-panel-admin-action-button-disabled-bg',
        disabled: true
    },
    learningPanelAdminPurpleButtonIcon: { className: 'learning-panel-admin-action-purple' },
    learningPanelAdminLinearClickedButton: { className: 'learning-panel-admin-linear-clicked' },
    learningPanelAdminPurpleDarkButton: { className: 'learning-panel-admin-action-purple-dark' },
    learningPanelAdminPurpleDarkButtonDisabled: {
        className: 'learning-panel-admin-action-purple-dark-disabled',
        disabled: true
    },
    learningPanelAdminCancel: { className: 'learning-panel-admin-cancel' },
    learningPanelAdminPink: { className: 'learning-panel-admin-pink' },
    learningPanelAdminPinkActive: { className: 'learning-panel-admin-pink-active' },
    learningPanelAdminLightPurple: { className: 'learning-panel-admin-light-purple' },
    learningPanelAdminOnlyText: { className: 'learning-panel-admin-only-text' },
    learningPanelAdminOnlyTextBold: { className: 'learning-panel-admin-only-text-bold' },
    learningPanelAdminCredentialCardAction: { className: 'learning-panel-admin-credential-card-action' },
    learningPanelAdminActionMenuButton: { className: 'learning-panel-admin-action-menu-button' },
    learningPanelFlatGray: { className: 'learning-panel-flat-gray' }
};

var css_248z$1y = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.clicked-text,.input-title,.normal-text{color:#fff;font-size:.8125rem;opacity:.7}.input-title{font-weight:500;opacity:1!important}.page-title{color:hsla(0,0%,100%,.7);font-weight:700}.button-text{color:hsla(0,0%,100%,.7)!important;font-weight:600!important}.button-text,.retake-text{font-size:1.125rem!important}.retake-text{color:#fff!important;font-weight:700!important}.title-text{color:hsla(0,0%,100%,.7)!important;font-size:1.125rem!important;font-weight:400!important}.sub-title{color:#fff;opacity:.7}.date-title,.sub-title{font-size:1rem;font-weight:400}.date-title{color:hsla(0,0%,100%,.5)}.page-title{color:#fff;font-size:1.5rem;font-weight:500;opacity:.7}.notification-content{color:#fff;font-size:1rem;font-weight:600;opacity:.9}.clicked-text{font-weight:500}.clicked-text:hover{opacity:1!important}.clicked-text:focus{opacity:.5!important}.class-ellipsis{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.button-component-wrapper .class-bg-colour-primary{background-color:#f36a22!important}.button-component-wrapper .class-no-shadow{box-shadow:none!important}.button-component-wrapper .class-hover-pointer{cursor:pointer}.button-component-wrapper .button-loader-icon{font-size:3rem}.button-component-wrapper .MuiButton-root{border-radius:6.5px!important}.button-component-wrapper .outlinedFlatGray{background-color:#44424c;border:1px solid #dad8dc;box-shadow:0 4px 4px hsla(0,0%,44%,.15);color:#fff}.button-component-wrapper .outlinedFlatWhite,.button-component-wrapper .outlinedFlatWhiteDisabled{background-color:#fff;border:1px solid #dad8dc;box-shadow:0 4px 4px hsla(0,0%,44%,.15);color:#565360}.button-component-wrapper .outlinedFlatWhiteDisabled{color:#565360!important;opacity:.6}.button-component-wrapper .outlinedFlatWhiteDisabled svg{height:.9rem}.inner-icon{margin-right:1rem}.inner-icon svg{display:flex}.gradient-wrapper{height:100%;width:100%}.gradient-wrapper .MuiButton-root{border-radius:4px!important}.big-button-gradient,.big-button-gradient-disable,.button-base,.button-gradient,.button-gradient-disable,.button-gradient-disable-same-color{border-radius:4px!important;color:hsla(0,0%,100%,.8)!important;font-weight:700!important}.big-button-gradient-disable .MuiButton-label,.big-button-gradient .MuiButton-label,.button-base .MuiButton-label,.button-gradient-disable-same-color .MuiButton-label,.button-gradient-disable .MuiButton-label,.button-gradient .MuiButton-label{text-transform:none!important}.big-button-gradient,.button-gradient{background:linear-gradient(108.7deg,rgba(251,134,182,.92) 4.47%,rgba(27,44,127,.92) 102.73%)!important;outline:2px solid hsla(0,0%,100%,.2)!important}.big-button-gradient:focus,.button-gradient:focus{background:linear-gradient(108.7deg,rgba(251,134,182,.55) 4.47%,rgba(27,44,127,.55) 102.73%)!important;color:#fff!important;outline:2px solid hsla(0,0%,100%,.4)!important}.big-button-gradient:hover,.button-gradient:hover{color:#fff!important}.button-gradient-disable{background-color:#48336a!important;outline:1px solid hsla(0,0%,100%,.2)!important}.button-gradient-disable span{opacity:.5}.button-gradient-disable-same-color{background:linear-gradient(108.7deg,rgba(251,134,182,.5) 4.47%,rgba(27,44,127,.5) 102.73%)!important;color:hsla(0,0%,100%,.5)!important;outline:1px solid hsla(0,0%,100%,.2)!important}.button-gradient-disable-same-color:hover{color:hsla(0,0%,100%,.5)!important}.learning-panel-button{background-color:hsla(0,0%,100%,.15)!important;border-radius:8px;color:hsla(0,0%,100%,.7)!important}.learning-panel-admin-button,.learning-panel-admin-button-disabled,.learning-panel-admin-button-not-bg{backdrop-filter:blur(11px)!important;background:#eae4f8!important;border:1px solid #fff!important;border-radius:8px!important;box-shadow:8px 8px 16px 0 rgba(222,222,245,.7),-8px -8px 16px 0 hsla(0,0%,100%,.7)!important;color:rgba(98,98,98,.8)!important;font-size:.9375rem!important;min-width:6.25rem!important;padding:4px,6px,4px,6px!important}.learning-panel-admin-button-disabled:focus,.learning-panel-admin-button-disabled:hover,.learning-panel-admin-button-not-bg:focus,.learning-panel-admin-button-not-bg:hover,.learning-panel-admin-button:focus,.learning-panel-admin-button:hover{background:#baa7d8!important;border:1px solid #fff!important;color:#fff!important}.learning-panel-admin-button-disabled .MuiButton-label,.learning-panel-admin-button-not-bg .MuiButton-label,.learning-panel-admin-button .MuiButton-label{text-transform:none!important}.learning-panel-admin-button-disabled{color:rgba(98,98,98,.2)!important;opacity:.8!important}.learning-panel-admin-button-not-bg{background:transparent!important;box-shadow:none!important;color:rgba(113,101,150,.6)!important}.learning-panel-admin-button-not-bg:focus,.learning-panel-admin-button-not-bg:hover{background:transparent!important;color:#716596!important}.learning-panel-admin-button-not-bg .MuiButton-label{text-transform:none!important}.big-button-gradient,.big-button-gradient-disable,.big-button-gradient-style{border:none!important;font-size:1.25rem!important;height:3.25rem!important;width:22.43rem!important}.big-button-gradient-disable{background:linear-gradient(108.7deg,rgba(251,134,182,.5) 4.47%,rgba(27,44,127,.5) 102.73%)!important;outline:1px solid hsla(0,0%,100%,.2)!important}.big-button-gradient-disable,.big-button-gradient-disable:hover,.flat-gray,.flat-gray-opacity{color:hsla(0,0%,100%,.5)!important}.flat-gray,.flat-gray-opacity{border:2px solid hsla(0,0%,100%,.5)!important;border-radius:4px!important;font-size:.8125rem!important;font-weight:700!important}.flat-gray-opacity svg,.flat-gray svg{fill:hsla(0,0%,100%,.5)!important;stroke:hsla(0,0%,100%,.5)!important}.flat-gray-opacity:focus,.flat-gray-opacity:hover,.flat-gray:focus,.flat-gray:hover{background:hsla(0,0%,100%,.3)!important;border:2px solid hsla(0,0%,100%,.5)}.flat-gray-opacity .MuiButton-label,.flat-gray .MuiButton-label{text-transform:none!important}.flat-gray-opacity{background:hsla(0,0%,100%,.3)!important;color:#fff!important}.flat-gray-opacity svg{fill:#fff!important;stroke:#fff!important}.rose-purple,.rose-purple-disabled{background-color:#a44b91!important;border:2px solid #ec8cb5!important;border-radius:4px!important;color:#fff!important;cursor:pointer;font-size:.8125rem!important;font-weight:700!important;height:2.75rem!important;margin-left:.5rem!important;width:76px!important}.rose-purple-disabled{background-color:#89407a!important;border:1px solid rgba(236,140,181,.5)!important}.linear-gradient-gray,.rose-purple-disabled .MuiButton-label{color:hsla(0,0%,100%,.5)!important}.linear-gradient-gray{background:linear-gradient(123.57deg,#ab8594 -28.65%,#1c2341 100.22%);font-family:Inter!important;font-weight:700!important;height:2.6rem!important;width:6rem!important}.transparent-panel-button{background:transparent!important;border:1px solid #fff!important;border-radius:5px!important;color:#fff!important}.transparent-panel-button:hover{background:hsla(0,0%,100%,.3)!important}.gradient-no-border{background:linear-gradient(101.26deg,rgba(251,134,182,.85) 18.02%,rgba(27,44,127,.85) 114.09%);border-radius:8px;color:hsla(0,0%,100%,.9)!important}.gradient-no-border:hover{background:linear-gradient(101.26deg,#fb86b6 18.02%,#1b2c7f 114.09%);color:#fff!important}.gradient-no-border:active{background:linear-gradient(101.26deg,rgba(251,134,182,.55) 18.02%,rgba(27,44,127,.55) 114.09%);color:#fff!important}.gradient-no-border .MuiButton-label{text-transform:none!important}.gradient-no-border svg{display:flex!important}.gradient-no-border-disabled{background:linear-gradient(101.26deg,rgba(251,134,182,.5) 18.02%,rgba(27,44,127,.5) 114.09%);border-radius:8px;color:hsla(0,0%,100%,.6)!important;text-transform:none!important}.flat-full-gray{background:hsla(0,0%,100%,.2)!important;border-radius:8px!important;color:#fff!important;font-size:.8125rem!important;width:unset!important}.flat-full-gray svg{fill:#fff!important;stroke:#fff!important}.assigned-content-button-wrapper .MuiButton-label{font-size:1rem!important;text-transform:none!important}.assigned-content-button-wrapper .primary-common,.assigned-content-button-wrapper .purple,.assigned-content-button-wrapper .purple-static{align-items:center!important;border-radius:.75rem!important;color:#fff!important;display:flex!important;font-style:normal!important;font-weight:700!important;gap:.625rem!important;height:min-content!important;justify-content:center!important;letter-spacing:-.02rem!important;line-height:120%!important}.assigned-content-button-wrapper .purple-static{background-color:#614890!important;border:2px solid #fff!important;padding:2.625rem!important}.assigned-content-button-wrapper .purple{backdrop-filter:blur(11px);background-color:rgba(186,167,216,.349)!important;border:1px solid #fff!important;box-shadow:8px 8px 16px 0 rgba(222,222,245,.698),-8px -8px 16px 0 hsla(0,0%,100%,.7);padding:2rem!important}.assigned-content-button-wrapper .purple:hover{animation-duration:.3s;animation-iteration-count:1;animation-name:bounce;animation-timing-function:ease;background-color:#e2d8f7!important;transform-origin:bottom}@keyframes bounce{0%{transform:translateY(0)}50%{transform:translateY(12px)}to{transform:translateY(0)}}.learning-panel-admin-action-button,.learning-panel-admin-action-button-disabled,.learning-panel-admin-action-button-icon,.learning-panel-admin-action-button-icon-selected,.learning-panel-admin-action-purple,.learning-panel-admin-action-purple-dark,.learning-panel-admin-action-purple-dark-disabled,.learning-panel-admin-linear-clicked{backdrop-filter:blur(11px)!important;background:#fff!important;border:1px solid rgba(226,216,247,.4)!important;border-radius:.5rem!important;box-shadow:8px 8px 16px 0 rgba(222,222,245,.7),-8px -8px 16px 0 hsla(0,0%,100%,.7)!important;color:#716596!important;font-weight:400!important}.learning-panel-admin-action-button-disabled .MuiButton-label,.learning-panel-admin-action-button-icon-selected .MuiButton-label,.learning-panel-admin-action-button-icon .MuiButton-label,.learning-panel-admin-action-button .MuiButton-label,.learning-panel-admin-action-purple-dark-disabled .MuiButton-label,.learning-panel-admin-action-purple-dark .MuiButton-label,.learning-panel-admin-action-purple .MuiButton-label,.learning-panel-admin-linear-clicked .MuiButton-label{font-size:.8125rem!important;text-transform:none!important}.learning-panel-admin-action-button-disabled .MuiButtonBase-root,.learning-panel-admin-action-button-icon-selected .MuiButtonBase-root,.learning-panel-admin-action-button-icon .MuiButtonBase-root,.learning-panel-admin-action-button .MuiButtonBase-root,.learning-panel-admin-action-purple-dark-disabled .MuiButtonBase-root,.learning-panel-admin-action-purple-dark .MuiButtonBase-root,.learning-panel-admin-action-purple .MuiButtonBase-root,.learning-panel-admin-linear-clicked .MuiButtonBase-root{width:unset!important}.learning-panel-admin-action-button-disabled .MuiButton-startIcon,.learning-panel-admin-action-button-icon-selected .MuiButton-startIcon,.learning-panel-admin-action-button-icon .MuiButton-startIcon,.learning-panel-admin-action-button .MuiButton-startIcon,.learning-panel-admin-action-purple-dark-disabled .MuiButton-startIcon,.learning-panel-admin-action-purple-dark .MuiButton-startIcon,.learning-panel-admin-action-purple .MuiButton-startIcon,.learning-panel-admin-linear-clicked .MuiButton-startIcon{margin-left:0!important;margin-right:.2rem!important}.learning-panel-admin-action-button-disabled .MuiButton-endIcon,.learning-panel-admin-action-button-icon-selected .MuiButton-endIcon,.learning-panel-admin-action-button-icon .MuiButton-endIcon,.learning-panel-admin-action-button .MuiButton-endIcon,.learning-panel-admin-action-purple-dark-disabled .MuiButton-endIcon,.learning-panel-admin-action-purple-dark .MuiButton-endIcon,.learning-panel-admin-action-purple .MuiButton-endIcon,.learning-panel-admin-linear-clicked .MuiButton-endIcon{margin-right:0!important}.learning-panel-admin-action-button-disabled svg,.learning-panel-admin-action-button-icon-selected svg,.learning-panel-admin-action-button-icon svg,.learning-panel-admin-action-button svg,.learning-panel-admin-action-purple-dark-disabled svg,.learning-panel-admin-action-purple-dark svg,.learning-panel-admin-action-purple svg,.learning-panel-admin-linear-clicked svg{display:flex!important;height:1rem!important;width:1rem!important}.learning-panel-admin-action-button-disabled:hover,.learning-panel-admin-action-button-icon-selected:hover,.learning-panel-admin-action-button-icon:hover,.learning-panel-admin-action-button:hover,.learning-panel-admin-action-purple-dark-disabled:hover,.learning-panel-admin-action-purple-dark:hover,.learning-panel-admin-action-purple:hover,.learning-panel-admin-linear-clicked:hover{background:linear-gradient(83deg,rgba(226,216,247,.4) 2.82%,rgba(242,125,177,.05) 52.7%,rgba(226,216,247,.4) 94.71%)!important}.learning-panel-admin-action-button-disabled:active,.learning-panel-admin-action-button-icon-selected:active,.learning-panel-admin-action-button-icon:active,.learning-panel-admin-action-button:active,.learning-panel-admin-action-purple-dark-disabled:active,.learning-panel-admin-action-purple-dark:active,.learning-panel-admin-action-purple:active,.learning-panel-admin-linear-clicked:active{background:#ebebff!important}.learning-panel-admin-action-purple-dark,.learning-panel-admin-action-purple-dark-disabled{background:#716596!important;color:#fff!important}.learning-panel-admin-action-purple-dark-disabled:hover,.learning-panel-admin-action-purple-dark:hover{background:#5a5178!important}.learning-panel-admin-action-purple-dark-disabled svg,.learning-panel-admin-action-purple-dark svg{color:#fff!important;display:flex!important}.learning-panel-admin-action-purple-dark-disabled{background:#d4d1e0!important;color:#fff!important}.learning-panel-admin-linear-clicked{background:linear-gradient(83deg,rgba(226,216,247,.4) 2.82%,rgba(242,125,177,.05) 52.7%,rgba(226,216,247,.4) 94.71%)!important}.learning-panel-admin-action-button-disabled,.learning-panel-admin-action-button-disabled-bg{backdrop-filter:blur(11px)!important;background:#fff;border:1px solid var(--linear-light,#fff)!important;border-radius:8px!important;box-shadow:8px 8px 16px 0 rgba(222,222,245,.7),-8px -8px 16px 0 hsla(0,0%,100%,.7)!important;color:#716596!important;cursor:not-allowed!important;font-weight:400!important;font-weight:500!important;opacity:.3!important}.learning-panel-admin-action-button-disabled-bg .MuiButton-label,.learning-panel-admin-action-button-disabled .MuiButton-label{font-size:.8125rem!important;text-transform:none!important}.learning-panel-admin-action-button-disabled-bg .MuiButtonBase-root,.learning-panel-admin-action-button-disabled .MuiButtonBase-root{width:unset!important}.learning-panel-admin-action-button-disabled-bg .MuiButton-startIcon,.learning-panel-admin-action-button-disabled .MuiButton-startIcon{margin-left:0!important;margin-right:0!important}.learning-panel-admin-action-button-disabled-bg svg,.learning-panel-admin-action-button-disabled svg{display:flex;height:1rem!important}.learning-panel-admin-action-button-disabled-bg{background:#716596!important;color:#fff!important}.learning-panel-admin-action-button-icon,.learning-panel-admin-action-button-icon-selected{min-width:1rem!important}.learning-panel-admin-action-button-icon-selected .MuiButton-startIcon,.learning-panel-admin-action-button-icon .MuiButton-startIcon{margin-left:0!important;margin-right:0!important}.learning-panel-admin-action-button-icon-selected{border:1px solid #fb86b6!important}.learning-panel-admin-cancel{background:transparent!important;border:none!important}.learning-panel-admin-cancel .MuiButton-label{color:#626262!important;font-size:.75rem!important;font-style:normal!important;font-weight:400!important;line-height:144%!important;text-align:center!important;text-transform:none!important}.learning-panel-admin-cancel:active,.learning-panel-admin-cancel:hover{background:transparent!important}.learning-panel-admin-pink,.learning-panel-admin-pink-active{backdrop-filter:blur(11px)!important;background:rgba(251,134,182,.1)!important;border:1px solid rgba(251,134,182,.5)!important;border-radius:8px!important;height:unset!important;padding:6px 10px!important;width:unset!important}.learning-panel-admin-pink-active .MuiButton-label,.learning-panel-admin-pink .MuiButton-label{color:hsla(0,0%,100%,.9)!important;font-size:.875rem!important;font-style:normal!important;font-weight:400!important;line-height:144%!important;text-align:center!important;text-transform:none!important;width:max-content!important}.learning-panel-admin-pink-active:hover,.learning-panel-admin-pink:hover{background:rgba(251,134,182,.3)!important}.learning-panel-admin-pink-active:active,.learning-panel-admin-pink:active{background:#fb86b6}.learning-panel-admin-pink-active,.learning-panel-admin-pink-active:hover{background:#fb86b6!important}.learning-panel-admin-pink-active:active{background:#fb86b6}.learning-panel-admin-light-purple{align-items:center;backdrop-filter:blur(11px);background:#fff!important;border:1px solid #fff;border-radius:.5rem;box-shadow:8px 8px 16px 0 rgba(222,222,245,.7),-8px -8px 16px 0 hsla(0,0%,100%,.7);display:flex;gap:.25rem;justify-content:center;padding:.375rem .625rem}.learning-panel-admin-light-purple:active,.learning-panel-admin-light-purple:hover{background:#eae4f8!important}.learning-panel-admin-only-text-bold{color:rgba(113,101,150,.8)!important;font-size:.9375rem!important;font-style:normal!important;font-weight:600!important;line-height:140%!important;text-transform:none!important}.learning-panel-admin-only-text-bold:hover{background:none!important;font-weight:800!important}.learning-panel-admin-only-text-bold:active{background:none!important}.learning-panel-admin-only-text{color:rgba(113,101,150,.8)!important;font-size:.9375rem!important;font-style:normal!important;font-weight:400!important;line-height:140%!important;text-transform:none!important}.learning-panel-admin-only-text:active,.learning-panel-admin-only-text:hover{background:none!important}.learning-panel-admin-credential-card-action{align-items:center;backdrop-filter:blur(11px);background:linear-gradient(129deg,rgba(18,18,22,.08) -25.34%,#fdfdfd 62.35%);border:1px solid #fff;border-radius:.25rem;box-shadow:-8px -8px 16px 0 hsla(0,0%,100%,.7),8px 8px 16px 0 rgba(222,222,245,.7);color:rgba(98,98,98,.7)!important;display:flex;font-size:.8125rem!important;font-style:normal!important;font-weight:400!important;justify-content:center;letter-spacing:-.00406rem!important;line-height:140%!important;min-width:min-content!important;padding:.125rem .375rem!important;text-transform:none!important}.learning-panel-admin-credential-card-action:active,.learning-panel-admin-credential-card-action:hover{background:none!important}.learning-panel-admin-action-menu-button{align-items:center;align-self:stretch;background:none!important;color:#626262;display:flex;font-size:.9375rem!important;font-style:normal!important;font-weight:400!important;gap:.625rem;letter-spacing:-.00469rem!important;line-height:140%!important;padding-bottom:.3125rem;text-transform:none!important}.learning-panel-admin-action-menu-button:hover{background:linear-gradient(83deg,rgba(226,216,247,.4) 2.82%,rgba(242,125,177,.05) 52.7%,rgba(226,216,247,.4) 94.71%),#fff!important;border-radius:.375rem}.learning-panel-admin-action-menu-button:active{background:none!important}.learning-panel-flat-gray{align-items:center;border:1px solid hsla(0,0%,100%,.5)!important;border-radius:.5rem!important;color:hsla(0,0%,100%,.7)!important;display:inline-flex;font-size:1rem!important;font-style:normal!important;font-weight:400!important;gap:.1875rem;line-height:140%!important;padding:.375rem .5rem;text-align:center;text-transform:none!important}.learning-panel-flat-gray:hover{background:hsla(0,0%,100%,.2);border:1px solid hsla(0,0%,100%,.5);color:hsla(0,0%,100%,.9)}.learning-panel-flat-gray:active{background:rgba(155,160,251,.2);border:1px solid hsla(0,0%,100%,.5)}";
styleInject(css_248z$1y);

var css_248z$1x = ".extraLoader-module_extra-loader__BZgse{animation:extraLoader-module_loader__h3YYH 1s linear infinite;aspect-ratio:1;background:radial-gradient(farthest-side,#fff 94%,transparent) top/4px 4px no-repeat,conic-gradient(transparent 10%,#fff);border-radius:50%;-webkit-mask:radial-gradient(farthest-side,transparent calc(100% - 4px),#000 0);width:19px}@keyframes extraLoader-module_loader__h3YYH{to{transform:rotate(1turn)}}";
var styles$J = {"extra-loader":"extraLoader-module_extra-loader__BZgse","loader":"extraLoader-module_loader__h3YYH"};
styleInject(css_248z$1x);

const ExtraLoader = () => {
    return jsx("div", { className: styles$J['extra-loader'] }, void 0);
};

const ButtonContainer = (props) => {
    const { text = '', type, onClick, dataTestid, id, isLoading, startIcon, title, className, wrapperClassName, toolTipText = '', lowerCase, innerIconName, style, extraLoader } = props, rest = __rest$1(props, ["text", "type", "onClick", "dataTestid", "id", "isLoading", "startIcon", "title", "className", "wrapperClassName", "toolTipText", "lowerCase", "innerIconName", "style", "extraLoader"]);
    const auxiliaryProps = Object.assign({}, buttonType[type || 'primary']);
    const { disabled } = auxiliaryProps;
    const { flat, wrapperClass } = auxiliaryProps, auxiliaryPropsRest = __rest$1(auxiliaryProps, ["flat", "wrapperClass"]);
    const buttonClassNames = classNames('class-width-height-100', auxiliaryPropsRest === null || auxiliaryPropsRest === void 0 ? void 0 : auxiliaryPropsRest.className, {
        'class-no-shadow': flat,
        'class-hover-pointer': !disabled,
        'class-disabled': disabled,
        'class-bg-colour-disabled': disabled && !className
    }, className);
    return (jsx(TooltipContainer, Object.assign({ hasBorder: true, hasDefaultStyle: true, unsetMaxWidth: true, title: toolTipText, dataTestid: "button-tooltip" }, { children: jsx("span", Object.assign({ className: classNames('button-component-wrapper', wrapperClassName, wrapperClass) }, { children: jsxs(Button, Object.assign({ "data-testid": dataTestid, id: id, onClick: (e) => onClick === null || onClick === void 0 ? void 0 : onClick(e) }, rest, auxiliaryPropsRest, { className: buttonClassNames, style: style, startIcon: isLoading ? (jsx(SimpleLoader, { dataTestid: "button-loader-icon" }, void 0)) : extraLoader ? (jsx(ExtraLoader, {}, void 0)) : (startIcon) }, { children: [innerIconName && jsx(Icon, { name: innerIconName, className: "inner-icon" }, void 0), lowerCase ? text : text.toLocaleUpperCase()] }), void 0) }), void 0) }), void 0));
};

var css_248z$1w = ".class-underline{text-decoration:underline}.class-hover-pointer:hover{cursor:pointer}";
styleInject(css_248z$1w);

const Label = ({ text, onClick, dataTestId }) => {
    return (jsx("h3", Object.assign({ "data-testid": dataTestId, title: text, className: classNames('class-underline', 'class-hover-pointer'), onClick: (_) => onClick() }, { children: text }), void 0));
};

var ChipTypesName;
(function (ChipTypesName) {
    ChipTypesName[ChipTypesName["removable"] = 0] = "removable";
    ChipTypesName[ChipTypesName["selected"] = 1] = "selected";
    ChipTypesName[ChipTypesName["unSelected"] = 2] = "unSelected";
    ChipTypesName[ChipTypesName["onTableOrDashboard"] = 3] = "onTableOrDashboard";
    ChipTypesName[ChipTypesName["ellipse"] = 4] = "ellipse";
})(ChipTypesName || (ChipTypesName = {}));
var ChipColor;
(function (ChipColor) {
    ChipColor["primary"] = "primary";
})(ChipColor || (ChipColor = {}));
var ChipVariant;
(function (ChipVariant) {
    ChipVariant["outlined"] = "outlined";
})(ChipVariant || (ChipVariant = {}));
const chipType = {
    removable: { variant: ChipVariant.outlined, onDelete: () => undefined, className: 'square-chip' },
    selected: { color: ChipColor.primary, className: 'square-chip' },
    unSelected: { variant: ChipVariant.outlined, className: 'square-chip' },
    onTableOrDashboard: { className: 'square-chip' },
    ellipse: { className: 'ellipse-chip' }
};

const ChipContainer = (props) => {
    const { type = 'removable', dataTestid = 'chip' } = props, rest = __rest$1(props, ["type", "dataTestid"]);
    const auxiliaryProps = Object.assign({}, chipType[type]);
    return (jsx(Chip$2, Object.assign({ "data-testid": dataTestid }, auxiliaryProps, rest, { className: classNames(auxiliaryProps.className, rest.className) }), void 0));
};

const DividerContainer = (props) => {
    const { orientation = 'horizontal', variant = 'fullWidth', dataTestid, color } = props, rest = __rest$1(props, ["orientation", "variant", "dataTestid", "color"]);
    const useStyles = makeStyles$1(() => ({
        divider: {
            background: color
        }
    }));
    const classes = useStyles();
    return (jsx(Divider, Object.assign({ orientation: orientation, variant: variant, "data-testid": dataTestid, classes: { root: classes.divider } }, rest), void 0));
};
var Orientation;
(function (Orientation) {
    Orientation[Orientation["vertical"] = 0] = "vertical";
    Orientation[Orientation["horizontal"] = 1] = "horizontal";
})(Orientation || (Orientation = {}));
var Variant;
(function (Variant) {
    Variant[Variant["fullWidth"] = 0] = "fullWidth";
    Variant[Variant["inset"] = 1] = "inset";
    Variant[Variant["middle"] = 2] = "middle";
})(Variant || (Variant = {}));

/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends$2(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$3$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1$2 = isObject$3$1;/** Detect free variable `global` from Node.js. */

var freeGlobal$1$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal$2 = freeGlobal$1$1;var freeGlobal$4 = _freeGlobal$2;

/** Detect free variable `self`. */
var freeSelf$2 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$2$1 = freeGlobal$4 || freeSelf$2 || Function('return this')();

var _root$2 = root$2$1;var root$1$1 = _root$2;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root$1$1.Date.now();
};

var now_1 = now$1;/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;var root$j = _root$2;

/** Built-in value references. */
var Symbol$2$1 = root$j.Symbol;

var _Symbol$2 = Symbol$2$1;var Symbol$1$1 = _Symbol$2;

/** Used for built-in method references. */
var objectProto$1$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$p = objectProto$1$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1$1 = objectProto$1$1.toString;

/** Built-in value references. */
var symToStringTag$1$1 = Symbol$1$1 ? Symbol$1$1.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1$1(value) {
  var isOwn = hasOwnProperty$p.call(value, symToStringTag$1$1),
      tag = value[symToStringTag$1$1];

  try {
    value[symToStringTag$1$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1$1] = tag;
    } else {
      delete value[symToStringTag$1$1];
    }
  }
  return result;
}

var _getRawTag$2 = getRawTag$1$1;/** Used for built-in method references. */

var objectProto$t = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$4 = objectProto$t.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1$1(value) {
  return nativeObjectToString$4.call(value);
}

var _objectToString$2 = objectToString$1$1;var Symbol$c = _Symbol$2,
    getRawTag$4 = _getRawTag$2,
    objectToString$4 = _objectToString$2;

/** `Object#toString` result references. */
var nullTag$2 = '[object Null]',
    undefinedTag$2 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$4 = Symbol$c ? Symbol$c.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$1$1(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$2 : nullTag$2;
  }
  return (symToStringTag$4 && symToStringTag$4 in Object(value))
    ? getRawTag$4(value)
    : objectToString$4(value);
}

var _baseGetTag$2 = baseGetTag$1$1;/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$1$1(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1$2 = isObjectLike$1$1;var baseGetTag$e = _baseGetTag$2,
    isObjectLike$i = isObjectLike_1$2;

/** `Object#toString` result references. */
var symbolTag$6 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$i(value) && baseGetTag$e(value) == symbolTag$6);
}

var isSymbol_1$1 = isSymbol$1$1;var baseTrim = _baseTrim,
    isObject$2$1 = isObject_1$2,
    isSymbol$5 = isSymbol_1$1;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$5(value)) {
    return NAN;
  }
  if (isObject$2$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber$1;var isObject$1$1 = isObject_1$2,
    now$2 = now_1,
    toNumber = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber(wait) || 0;
  if (isObject$1$1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$2();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$2());
  }

  function debounced() {
    var time = now$2(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce$1;var debounce = debounce_1,
    isObject$h = isObject_1$2;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  if (isObject$h(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle$1;var patchResizeHandler = function (resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch (refreshMode) {
        case 'debounce':
            return debounce_1(resizeCallback, refreshRate, refreshOptions);
        case 'throttle':
            return throttle_1(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var isFunction$8 = function (fn) { return typeof fn === 'function'; };
var isSSR = function () { return typeof window === 'undefined'; };
var isDOMElement = function (element) { return element instanceof Element || element instanceof HTMLDocument; };
var createNotifier = function (onResize, setSize, handleWidth, handleHeight) {
    return function (_a) {
        var width = _a.width, height = _a.height;
        setSize(function (prev) {
            if (prev.width === width && prev.height === height) {
                // skip if dimensions haven't changed
                return prev;
            }
            if ((prev.width === width && !handleHeight) || (prev.height === height && !handleWidth)) {
                // process `handleHeight/handleWidth` props
                return prev;
            }
            if (onResize && isFunction$8(onResize)) {
                onResize(width, height);
            }
            return { width: width, height: height };
        });
    };
};var ResizeDetector = /** @class */ (function (_super) {
    __extends$2(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function () {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function () {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if (isSSR()) {
                return;
            }
            if (targetRef && targetRef.current) {
                _this.targetRef.current = targetRef.current;
            }
            var element = _this.getElement();
            if (!element) {
                // can't find element to observe
                return;
            }
            if (_this.observableElement && _this.observableElement === element) {
                // element is already observed
                return;
            }
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function () {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if (isSSR())
                return null;
            // in case we pass a querySelector
            if (querySelector)
                return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && isDOMElement(targetDomEl))
                return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && isDOMElement(_this.targetRef.current))
                return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = findDOMNode(_this);
            if (!currentElement)
                return null;
            var renderType = _this.getRenderType();
            switch (renderType) {
                case 'renderProp':
                    return currentElement;
                case 'childFunction':
                    return currentElement;
                case 'child':
                    return currentElement;
                case 'childArray':
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function (entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight)
                return;
            var notifyResize = createNotifier(onResize, _this.setState.bind(_this), handleWidth, handleHeight);
            entries.forEach(function (entry) {
                var _a = (entry && entry.contentRect) || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !isSSR();
                if (shouldSetSize) {
                    notifyResize({ width: width, height: height });
                }
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function () {
            var _a = _this.props, render = _a.render, children = _a.children;
            if (isFunction$8(render)) {
                // DEPRECATED. Use `Child Function Pattern` instead
                return 'renderProp';
            }
            if (isFunction$8(children)) {
                return 'childFunction';
            }
            if (isValidElement(children)) {
                return 'child';
            }
            if (Array.isArray(children)) {
                // DEPRECATED. Wrap children with a single parent
                return 'childArray';
            }
            // DEPRECATED. Use `Child Function Pattern` instead
            return 'parent';
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = createRef();
        _this.observableElement = null;
        if (isSSR()) {
            return _this;
        }
        _this.resizeHandler = patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function () {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function () {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function () {
        if (isSSR()) {
            return;
        }
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function () {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? 'div' : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = { width: width, height: height, targetRef: this.targetRef };
        var renderType = this.getRenderType();
        var typedChildren;
        switch (renderType) {
            case 'renderProp':
                return render && render(childProps);
            case 'childFunction':
                typedChildren = children;
                return typedChildren(childProps);
            case 'child':
                // @TODO bug prone logic
                typedChildren = children;
                if (typedChildren.type && typeof typedChildren.type === 'string') {
                    // child is a native DOM elements such as div, span etc
                    childProps.targetRef; var nativeProps = __rest(childProps, ["targetRef"]);
                    return cloneElement(typedChildren, nativeProps);
                }
                // class or functional component otherwise
                return cloneElement(typedChildren, childProps);
            case 'childArray':
                typedChildren = children;
                return typedChildren.map(function (el) { return !!el && cloneElement(el, childProps); });
            default:
                return React.createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}(PureComponent));

var __extends$1 = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
var styles$I = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize',
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize',
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize',
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize',
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize',
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize',
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize',
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize',
    },
};
var Resizer = /** @class */ (function (_super) {
    __extends$1(Resizer, _super);
    function Resizer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMouseDown = function (e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        _this.onTouchStart = function (e) {
            _this.props.onResizeStart(e, _this.props.direction);
        };
        return _this;
    }
    Resizer.prototype.render = function () {
        return (React.createElement("div", { className: this.props.className || '', style: __assign$1(__assign$1({ position: 'absolute', userSelect: 'none' }, styles$I[this.props.direction]), (this.props.replaceStyles || {})), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children));
    };
    return Resizer;
}(React.PureComponent));

var src = {exports: {}};

//
// Main
//

function memoize$2 (fn, options) {
  var cache = options && options.cache
    ? options.cache
    : cacheDefault;

  var serializer = options && options.serializer
    ? options.serializer
    : serializerDefault;

  var strategy = options && options.strategy
    ? options.strategy
    : strategyDefault;

  return strategy(fn, {
    cache: cache,
    serializer: serializer
  })
}

//
// Strategy
//

function isPrimitive (value) {
  return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
}

function monadic (fn, cache, serializer, arg) {
  var cacheKey = isPrimitive(arg) ? arg : serializer(arg);

  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.call(this, arg);
    cache.set(cacheKey, computedValue);
  }

  return computedValue
}

function variadic (fn, cache, serializer) {
  var args = Array.prototype.slice.call(arguments, 3);
  var cacheKey = serializer(args);

  var computedValue = cache.get(cacheKey);
  if (typeof computedValue === 'undefined') {
    computedValue = fn.apply(this, args);
    cache.set(cacheKey, computedValue);
  }

  return computedValue
}

function assemble (fn, context, strategy, cache, serialize) {
  return strategy.bind(
    context,
    fn,
    cache,
    serialize
  )
}

function strategyDefault (fn, options) {
  var strategy = fn.length === 1 ? monadic : variadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyVariadic (fn, options) {
  var strategy = variadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

function strategyMonadic (fn, options) {
  var strategy = monadic;

  return assemble(
    fn,
    this,
    strategy,
    options.cache.create(),
    options.serializer
  )
}

//
// Serializer
//

function serializerDefault () {
  return JSON.stringify(arguments)
}

//
// Cache
//

function ObjectWithoutPrototypeCache () {
  this.cache = Object.create(null);
}

ObjectWithoutPrototypeCache.prototype.has = function (key) {
  return (key in this.cache)
};

ObjectWithoutPrototypeCache.prototype.get = function (key) {
  return this.cache[key]
};

ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
  this.cache[key] = value;
};

var cacheDefault = {
  create: function create () {
    return new ObjectWithoutPrototypeCache()
  }
};

//
// API
//

src.exports = memoize$2;
src.exports.strategies = {
  variadic: strategyVariadic,
  monadic: strategyMonadic
};

var srcExports = src.exports;
var memoize$3 = /*@__PURE__*/getDefaultExportFromCjs(srcExports);

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto',
};
var clamp = memoize$3(function (n, min, max) { return Math.max(Math.min(n, max), min); });
var snap = memoize$3(function (n, size) { return Math.round(n / size) * size; });
var hasDirection = memoize$3(function (dir, target) {
    return new RegExp(dir, 'i').test(target);
});
// INFO: In case of window is a Proxy and does not porxy Events correctly, use isTouchEvent & isMouseEvent to distinguish event type instead of `instanceof`.
var isTouchEvent$1 = function (event) {
    return Boolean(event.touches && event.touches.length);
};
var isMouseEvent = function (event) {
    return Boolean((event.clientX || event.clientX === 0) &&
        (event.clientY || event.clientY === 0));
};
var findClosestSnap = memoize$3(function (n, snapArray, snapGap) {
    if (snapGap === void 0) { snapGap = 0; }
    var closestGapIndex = snapArray.reduce(function (prev, curr, index) { return (Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev); }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var endsWith = memoize$3(function (str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var getStringSize = memoize$3(function (n) {
    n = n.toString();
    if (n === 'auto') {
        return n;
    }
    if (endsWith(n, 'px')) {
        return n;
    }
    if (endsWith(n, '%')) {
        return n;
    }
    if (endsWith(n, 'vh')) {
        return n;
    }
    if (endsWith(n, 'vw')) {
        return n;
    }
    if (endsWith(n, 'vmax')) {
        return n;
    }
    if (endsWith(n, 'vmin')) {
        return n;
    }
    return n + "px";
});
var getPixelSize = function (size, parentSize, innerWidth, innerHeight) {
    if (size && typeof size === 'string') {
        if (endsWith(size, 'px')) {
            return Number(size.replace('px', ''));
        }
        if (endsWith(size, '%')) {
            var ratio = Number(size.replace('%', '')) / 100;
            return parentSize * ratio;
        }
        if (endsWith(size, 'vw')) {
            var ratio = Number(size.replace('vw', '')) / 100;
            return innerWidth * ratio;
        }
        if (endsWith(size, 'vh')) {
            var ratio = Number(size.replace('vh', '')) / 100;
            return innerHeight * ratio;
        }
    }
    return size;
};
var calculateNewMax = memoize$3(function (parentSize, innerWidth, innerHeight, maxWidth, maxHeight, minWidth, minHeight) {
    maxWidth = getPixelSize(maxWidth, parentSize.width, innerWidth, innerHeight);
    maxHeight = getPixelSize(maxHeight, parentSize.height, innerWidth, innerHeight);
    minWidth = getPixelSize(minWidth, parentSize.width, innerWidth, innerHeight);
    minHeight = getPixelSize(minHeight, parentSize.height, innerWidth, innerHeight);
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight),
    };
});
var definedProps = [
    'as',
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'boundsByDirection',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap',
];
// HACK: This class is used to calculate % size.
var baseClassName = '__resizable_base__';
var Resizable = /** @class */ (function (_super) {
    __extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableRight = 0;
        _this.resizableTop = 0;
        _this.resizableBottom = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.appendBase = function () {
            if (!_this.resizable || !_this.window) {
                return null;
            }
            var parent = _this.parentNode;
            if (!parent) {
                return null;
            }
            var element = _this.window.document.createElement('div');
            element.style.width = '100%';
            element.style.height = '100%';
            element.style.position = 'absolute';
            element.style.transform = 'scale(0, 0)';
            element.style.left = '0';
            element.style.flex = '0';
            if (element.classList) {
                element.classList.add(baseClassName);
            }
            else {
                element.className += baseClassName;
            }
            parent.appendChild(element);
            return element;
        };
        _this.removeBase = function (base) {
            var parent = _this.parentNode;
            if (!parent) {
                return;
            }
            parent.removeChild(base);
        };
        _this.ref = function (c) {
            if (c) {
                _this.resizable = c;
            }
        };
        _this.state = {
            isResizing: false,
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined'
                ? 'auto'
                : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined'
                ? 'auto'
                : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
            },
            backgroundStyle: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: 'auto',
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0',
            },
            flexBasis: undefined,
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function () {
            if (!this.resizable) {
                return null;
            }
            return this.resizable.parentNode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "window", {
        get: function () {
            if (!this.resizable) {
                return null;
            }
            if (!this.resizable.ownerDocument) {
                return null;
            }
            return this.resizable.ownerDocument.defaultView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function () {
            return this.props.size || this.props.defaultSize || DEFAULT_SIZE;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function () {
            var width = 0;
            var height = 0;
            if (this.resizable && this.window) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') {
                    this.resizable.style.position = 'relative';
                }
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return { width: width, height: height };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function () {
            var _this = this;
            var size = this.props.size;
            var getSize = function (key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') {
                    return 'auto';
                }
                if (_this.propsSize && _this.propsSize[key] && endsWith(_this.propsSize[key].toString(), '%')) {
                    if (endsWith(_this.state[key].toString(), '%')) {
                        return _this.state[key].toString();
                    }
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = (value / parentSize[key]) * 100;
                    return percent + "%";
                }
                return getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing
                ? getStringSize(size.width)
                : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing
                ? getStringSize(size.height)
                : getSize('height');
            return { width: width, height: height };
        },
        enumerable: false,
        configurable: true
    });
    Resizable.prototype.getParentSize = function () {
        if (!this.parentNode) {
            if (!this.window) {
                return { width: 0, height: 0 };
            }
            return { width: this.window.innerWidth, height: this.window.innerHeight };
        }
        var base = this.appendBase();
        if (!base) {
            return { width: 0, height: 0 };
        }
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
            // HACK: Use relative to get parent padding size
        }
        base.style.position = 'relative';
        base.style.minWidth = '100%';
        var size = {
            width: base.offsetWidth,
            height: base.offsetHeight,
        };
        if (wrapChanged) {
            this.parentNode.style.flexWrap = wrap;
        }
        this.removeBase(base);
        return size;
    };
    Resizable.prototype.bindEvents = function () {
        if (this.window) {
            this.window.addEventListener('mouseup', this.onMouseUp);
            this.window.addEventListener('mousemove', this.onMouseMove);
            this.window.addEventListener('mouseleave', this.onMouseUp);
            this.window.addEventListener('touchmove', this.onMouseMove, {
                capture: true,
                passive: false,
            });
            this.window.addEventListener('touchend', this.onMouseUp);
        }
    };
    Resizable.prototype.unbindEvents = function () {
        if (this.window) {
            this.window.removeEventListener('mouseup', this.onMouseUp);
            this.window.removeEventListener('mousemove', this.onMouseMove);
            this.window.removeEventListener('mouseleave', this.onMouseUp);
            this.window.removeEventListener('touchmove', this.onMouseMove, true);
            this.window.removeEventListener('touchend', this.onMouseUp);
        }
    };
    Resizable.prototype.componentDidMount = function () {
        if (!this.resizable || !this.window) {
            return;
        }
        var computedStyle = this.window.getComputedStyle(this.resizable);
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height,
            flexBasis: computedStyle.flexBasis !== 'auto' ? computedStyle.flexBasis : undefined,
        });
    };
    Resizable.prototype.componentWillUnmount = function () {
        if (this.window) {
            this.unbindEvents();
        }
    };
    Resizable.prototype.createSizeForCssProperty = function (newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' &&
            this.state.original[kind] === newSize &&
            (typeof propsSize === 'undefined' || propsSize === 'auto')
            ? 'auto'
            : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function (maxWidth, maxHeight) {
        var boundsByDirection = this.props.boundsByDirection;
        var direction = this.state.direction;
        var widthByDirection = boundsByDirection && hasDirection('left', direction);
        var heightByDirection = boundsByDirection && hasDirection('top', direction);
        var boundWidth;
        var boundHeight;
        if (this.props.bounds === 'parent') {
            var parent_1 = this.parentNode;
            if (parent_1) {
                boundWidth = widthByDirection
                    ? this.resizableRight - this.parentLeft
                    : parent_1.offsetWidth + (this.parentLeft - this.resizableLeft);
                boundHeight = heightByDirection
                    ? this.resizableBottom - this.parentTop
                    : parent_1.offsetHeight + (this.parentTop - this.resizableTop);
            }
        }
        else if (this.props.bounds === 'window') {
            if (this.window) {
                boundWidth = widthByDirection ? this.resizableRight : this.window.innerWidth - this.resizableLeft;
                boundHeight = heightByDirection ? this.resizableBottom : this.window.innerHeight - this.resizableTop;
            }
        }
        else if (this.props.bounds) {
            boundWidth = widthByDirection
                ? this.resizableRight - this.targetLeft
                : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            boundHeight = heightByDirection
                ? this.resizableBottom - this.targetTop
                : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
        }
        if (boundWidth && Number.isFinite(boundWidth)) {
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
        }
        if (boundHeight && Number.isFinite(boundHeight)) {
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return { maxWidth: maxWidth, maxHeight: maxHeight };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function (clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (hasDirection('right', direction)) {
            newWidth = original.width + ((clientX - original.x) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
            }
        }
        if (hasDirection('left', direction)) {
            newWidth = original.width - ((clientX - original.x) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
            }
        }
        if (hasDirection('bottom', direction)) {
            newHeight = original.height + ((clientY - original.y) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
            }
        }
        if (hasDirection('top', direction)) {
            newHeight = original.height - ((clientY - original.y) * resizeRatio) / scale;
            if (lockAspectRatio) {
                newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
            }
        }
        return { newWidth: newWidth, newHeight: newHeight };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function (newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        }
        else {
            newWidth = clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return { newWidth: newWidth, newHeight: newHeight };
    };
    Resizable.prototype.setBoundingClientRect = function () {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2) {
                var parentRect = parent_2.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds && typeof this.props.bounds !== 'string') {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top, right = _a.right, bottom = _a.bottom;
            this.resizableLeft = left;
            this.resizableRight = right;
            this.resizableTop = top_1;
            this.resizableBottom = bottom;
        }
    };
    Resizable.prototype.onResizeStart = function (event, direction) {
        if (!this.resizable || !this.window) {
            return;
        }
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent && isMouseEvent(event.nativeEvent)) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
        }
        else if (event.nativeEvent && isTouchEvent$1(event.nativeEvent)) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) {
                    return;
                }
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) {
                this.setState({ height: this.props.size.height });
            }
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) {
                this.setState({ width: this.props.size.width });
            }
        }
        // For lockAspectRatio case
        this.ratio =
            typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var flexBasis;
        var computedStyle = this.window.getComputedStyle(this.resizable);
        if (computedStyle.flexBasis !== 'auto') {
            var parent_3 = this.parentNode;
            if (parent_3) {
                var dir = this.window.getComputedStyle(parent_3).flexDirection;
                this.flexDir = dir.startsWith('row') ? 'row' : 'column';
                flexBasis = computedStyle.flexBasis;
            }
        }
        // For boundary
        this.setBoundingClientRect();
        this.bindEvents();
        var state = {
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height,
            },
            isResizing: true,
            backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(event.target).cursor || 'auto' }),
            direction: direction,
            flexBasis: flexBasis,
        };
        this.setState(state);
    };
    Resizable.prototype.onMouseMove = function (event) {
        if (!this.state.isResizing || !this.resizable || !this.window) {
            return;
        }
        if (this.window.TouchEvent && isTouchEvent$1(event)) {
            try {
                event.preventDefault();
                event.stopPropagation();
            }
            catch (e) {
                // Ignore on fail
            }
        }
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = isTouchEvent$1(event) ? event.touches[0].clientX : event.clientX;
        var clientY = isTouchEvent$1(event) ? event.touches[0].clientY : event.clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = calculateNewMax(parentSize, this.window.innerWidth, this.window.innerHeight, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, { width: boundaryMax.maxWidth, height: boundaryMax.maxHeight }, { width: minWidth, height: minHeight });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = snap(newWidth, this.props.grid[0]);
            var newGridHeight = snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) {
            newWidth = findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        }
        if (this.props.snap && this.props.snap.y) {
            newHeight = findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        }
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height,
        };
        if (width && typeof width === 'string') {
            if (endsWith(width, '%')) {
                var percent = (newWidth / parentSize.width) * 100;
                newWidth = percent + "%";
            }
            else if (endsWith(width, 'vw')) {
                var vw = (newWidth / this.window.innerWidth) * 100;
                newWidth = vw + "vw";
            }
            else if (endsWith(width, 'vh')) {
                var vh = (newWidth / this.window.innerHeight) * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if (endsWith(height, '%')) {
                var percent = (newHeight / parentSize.height) * 100;
                newHeight = percent + "%";
            }
            else if (endsWith(height, 'vw')) {
                var vw = (newHeight / this.window.innerWidth) * 100;
                newHeight = vw + "vw";
            }
            else if (endsWith(height, 'vh')) {
                var vh = (newHeight / this.window.innerHeight) * 100;
                newHeight = vh + "vh";
            }
        }
        var newState = {
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height'),
        };
        if (this.flexDir === 'row') {
            newState.flexBasis = newState.width;
        }
        else if (this.flexDir === 'column') {
            newState.flexBasis = newState.height;
        }
        this.setState(newState);
        if (this.props.onResize) {
            this.props.onResize(event, direction, this.resizable, delta);
        }
    };
    Resizable.prototype.onMouseUp = function (event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) {
            return;
        }
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height,
        };
        if (this.props.onResizeStop) {
            this.props.onResizeStop(event, direction, this.resizable, delta);
        }
        if (this.props.size) {
            this.setState(this.props.size);
        }
        this.unbindEvents();
        this.setState({
            isResizing: false,
            backgroundStyle: __assign(__assign({}, this.state.backgroundStyle), { cursor: 'auto' }),
        });
    };
    Resizable.prototype.updateSize = function (size) {
        this.setState({ width: size.width, height: size.height });
    };
    Resizable.prototype.renderResizer = function () {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) {
            return null;
        }
        var resizers = Object.keys(enable).map(function (dir) {
            if (enable[dir] !== false) {
                return (React.createElement(Resizer, { key: dir, direction: dir, onResizeStart: _this.onResizeStart, replaceStyles: handleStyles && handleStyles[dir], className: handleClasses && handleClasses[dir] }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null));
            }
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return (React.createElement("div", { className: handleWrapperClass, style: handleWrapperStyle }, resizers));
    };
    Resizable.prototype.render = function () {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function (acc, key) {
            if (definedProps.indexOf(key) !== -1) {
                return acc;
            }
            acc[key] = _this.props[key];
            return acc;
        }, {});
        var style = __assign(__assign(__assign({ position: 'relative', userSelect: this.state.isResizing ? 'none' : 'auto' }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: 'border-box', flexShrink: 0 });
        if (this.state.flexBasis) {
            style.flexBasis = this.state.flexBasis;
        }
        var Wrapper = this.props.as || 'div';
        return (React.createElement(Wrapper, __assign({ ref: this.ref, style: style, className: this.props.className }, extendsProps),
            this.state.isResizing && React.createElement("div", { style: this.state.backgroundStyle }),
            this.props.children,
            this.renderResizer()));
    };
    Resizable.defaultProps = {
        as: 'div',
        onResizeStart: function () { },
        onResize: function () { },
        onResizeStop: function () { },
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true,
        },
        style: {},
        grid: [1, 1],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0,
    };
    return Resizable;
}(React.PureComponent));

const useStyles$j = makeStyles$1(() => ({
    resizer: {
        width: '1px !important',
        right: '0px !important',
        backgroundColor: 'rgba(255, 255, 255, 0.4)',
        transition: 'backgroundColor 0.3s',
        '&:hover, &:active': {
            width: '3px !important',
            backgroundColor: '#1d9bd1'
        }
    }
}));
const RightResizeable = ({ children, defaultSize, minWidth, maxWidth }) => {
    const classes = useStyles$j();
    return (jsx(Resizable, Object.assign({ handleClasses: { right: classes.resizer }, defaultSize: defaultSize, enable: {
            top: false,
            right: true,
            bottom: false,
            left: false,
            topRight: false,
            bottomRight: false,
            bottomLeft: false,
            topLeft: false
        }, maxWidth: maxWidth, minWidth: minWidth }, { children: children }), void 0));
};

var css_248z$1v = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.progress-text{align-items:center;display:flex}.progress-text .text{color:#d8d8d8;font-size:.825rem}.progress-text .circular{margin-left:1rem}";
styleInject(css_248z$1v);

const ProgressText = (props) => {
    const { text } = props;
    return (jsxs("div", Object.assign({ className: "progress-text" }, { children: [jsx("span", Object.assign({ className: "text" }, { children: text }), void 0), jsx(CircularProgress, { className: "circular", "data-testid": "progress-text-circular-progress" }, void 0)] }), void 0));
};

var Motion$1 = {exports: {}};

var mapToZero$1 = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports['default'] = mapToZero;

	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}

	module.exports = exports['default']; 
} (mapToZero$1, mapToZero$1.exports));

var mapToZeroExports$1 = mapToZero$1.exports;

var stripStyle$1 = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports['default'] = stripStyle;

	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}

	module.exports = exports['default']; 
} (stripStyle$1, stripStyle$1.exports));

var stripStyleExports$1 = stripStyle$1.exports;

var stepper$1 = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports["default"] = stepper;

	var reusedTuple = [0, 0];

	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2

	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);

	  // Damping, in kg / s
	  var Fdamper = -b * v;

	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;

	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;

	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }

	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}

	module.exports = exports["default"];
	// array reference around. 
} (stepper$1, stepper$1.exports));

var stepperExports$1 = stepper$1.exports;

var performanceNow$1 = {exports: {}};

// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    performanceNow$1.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    performanceNow$1.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    performanceNow$1.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    performanceNow$1.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(commonjsGlobal$1);

var performanceNowExports$1 = performanceNow$1.exports;

var raf$2 = {exports: {}};

var performanceNow = {exports: {}};

// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    performanceNow.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    performanceNow.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    performanceNow.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    performanceNow.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(commonjsGlobal$1);



var performanceNowExports = performanceNow.exports;

var now = performanceNowExports
  , root$i = typeof window === 'undefined' ? commonjsGlobal$1 : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf$1 = root$i['request' + suffix]
  , caf = root$i['cancel' + suffix] || root$i['cancelRequest' + suffix];

for(var i = 0; !raf$1 && i < vendors.length; i++) {
  raf$1 = root$i[vendors[i] + 'Request' + suffix];
  caf = root$i[vendors[i] + 'Cancel' + suffix]
      || root$i[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if(!raf$1 || !caf) {
  var last$3 = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60;

  raf$1 = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last$3));
      last$3 = next + _now;
      setTimeout(function() {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last$3);
            } catch(e) {
              setTimeout(function() { throw e }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id
  };

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

raf$2.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf$1.call(root$i, fn)
};
raf$2.exports.cancel = function() {
  caf.apply(root$i, arguments);
};
raf$2.exports.polyfill = function(object) {
  if (!object) {
    object = root$i;
  }
  object.requestAnimationFrame = raf$1;
  object.cancelAnimationFrame = caf;
};

var rafExports = raf$2.exports;

var shouldStopAnimation$1 = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;

	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }

	    if (currentVelocity[key] !== 0) {
	      return false;
	    }

	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }

	  return true;
	}

	module.exports = exports['default']; 
} (shouldStopAnimation$1, shouldStopAnimation$1.exports));

var shouldStopAnimationExports$1 = shouldStopAnimation$1.exports;

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _mapToZero = mapToZeroExports$1;

	var _mapToZero2 = _interopRequireDefault(_mapToZero);

	var _stripStyle = stripStyleExports$1;

	var _stripStyle2 = _interopRequireDefault(_stripStyle);

	var _stepper3 = stepperExports$1;

	var _stepper4 = _interopRequireDefault(_stepper3);

	var _performanceNow = performanceNowExports$1;

	var _performanceNow2 = _interopRequireDefault(_performanceNow);

	var _raf = rafExports;

	var _raf2 = _interopRequireDefault(_raf);

	var _shouldStopAnimation = shouldStopAnimationExports$1;

	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

	var _react = React__default;

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = propTypesExports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var msPerFrame = 1000 / 60;

	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);

	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);

	  function Motion(props) {
	    var _this = this;

	    _classCallCheck(this, Motion);

	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;

	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;

	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }

	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }

	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }

	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };

	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }

	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }

	        _this.wasAnimating = true;

	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }

	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }

	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};

	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }

	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }

	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];

	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }

	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });

	        _this.unreadPropStyle = null;

	        _this.startAnimationIfNecessary();
	      });
	    };

	    this.state = this.defaultState();
	  }

	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;

	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };

	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400

	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };

	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }

	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };

	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };

	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };

	  return Motion;
	})(_react2['default'].Component);

	exports['default'] = Motion;
	module.exports = exports['default'];

	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config) 
} (Motion$1, Motion$1.exports));

var MotionExports$1 = Motion$1.exports;

var StaggeredMotion$1 = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _mapToZero = mapToZeroExports$1;

	var _mapToZero2 = _interopRequireDefault(_mapToZero);

	var _stripStyle = stripStyleExports$1;

	var _stripStyle2 = _interopRequireDefault(_stripStyle);

	var _stepper3 = stepperExports$1;

	var _stepper4 = _interopRequireDefault(_stepper3);

	var _performanceNow = performanceNowExports$1;

	var _performanceNow2 = _interopRequireDefault(_performanceNow);

	var _raf = rafExports;

	var _raf2 = _interopRequireDefault(_raf);

	var _shouldStopAnimation = shouldStopAnimationExports$1;

	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

	var _react = React__default;

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = propTypesExports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var msPerFrame = 1000 / 60;

	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}

	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);

	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);

	  function StaggeredMotion(props) {
	    var _this = this;

	    _classCallCheck(this, StaggeredMotion);

	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;

	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;

	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;

	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }

	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }

	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };

	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }

	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }

	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }

	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];

	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};

	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }

	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }

	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];

	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }

	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }

	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });

	        _this.unreadPropStyles = null;

	        _this.startAnimationIfNecessary();
	      });
	    };

	    this.state = this.defaultState();
	  }

	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;

	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };

	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };

	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }

	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };

	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };

	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };

	  return StaggeredMotion;
	})(_react2['default'].Component);

	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config) 
} (StaggeredMotion$1, StaggeredMotion$1.exports));

var StaggeredMotionExports$1 = StaggeredMotion$1.exports;

var TransitionMotion$2 = {exports: {}};

var mergeDiff$1 = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports['default'] = mergeDiff;

	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster

	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }

	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }

	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];

	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev

	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }

	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}

	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care 
} (mergeDiff$1, mergeDiff$1.exports));

var mergeDiffExports$1 = mergeDiff$1.exports;

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _mapToZero = mapToZeroExports$1;

	var _mapToZero2 = _interopRequireDefault(_mapToZero);

	var _stripStyle = stripStyleExports$1;

	var _stripStyle2 = _interopRequireDefault(_stripStyle);

	var _stepper3 = stepperExports$1;

	var _stepper4 = _interopRequireDefault(_stepper3);

	var _mergeDiff = mergeDiffExports$1;

	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

	var _performanceNow = performanceNowExports$1;

	var _performanceNow2 = _interopRequireDefault(_performanceNow);

	var _raf = rafExports;

	var _raf2 = _interopRequireDefault(_raf);

	var _shouldStopAnimation = shouldStopAnimationExports$1;

	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

	var _react = React__default;

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = propTypesExports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var msPerFrame = 1000 / 60;

	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}

	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }

	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }

	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }

	  return true;
	}

	// core key merging logic

	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key

	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });

	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;

	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }

	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}

	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);

	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);

	  function TransitionMotion(props) {
	    var _this = this;

	    _classCallCheck(this, TransitionMotion);

	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;

	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];

	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;

	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }

	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }

	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };

	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }

	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }

	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }

	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }

	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }

	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];

	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};

	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }

	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }

	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];

	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }

	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }

	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });

	        _this.unreadPropStyles = null;

	        _this.startAnimationIfNecessary();
	      });
	    };

	    this.state = this.defaultState();
	  }

	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;

	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });

	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);

	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really

	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };

	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)

	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };

	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }

	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }

	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };

	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };

	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };

	  return TransitionMotion;
	})(_react2['default'].Component);

	exports['default'] = TransitionMotion;
	module.exports = exports['default'];

	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function

	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400 
} (TransitionMotion$2, TransitionMotion$2.exports));

var TransitionMotionExports$1 = TransitionMotion$2.exports;

var spring$2 = {exports: {}};

var presets$1 = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"]; 
} (presets$1, presets$1.exports));

var presetsExports$1 = presets$1.exports;

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	exports['default'] = spring;

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var _presets = presetsExports$1;

	var _presets2 = _interopRequireDefault(_presets);

	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});

	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}

	module.exports = exports['default']; 
} (spring$2, spring$2.exports));

var springExports$1 = spring$2.exports;

var reorderKeys$1 = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports['default'] = reorderKeys;

	var hasWarned = false;

	function reorderKeys() {
	  if (process.env.NODE_ENV === 'development') {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}

	module.exports = exports['default']; 
} (reorderKeys$1, reorderKeys$1.exports));

var reorderKeysExports$1 = reorderKeys$1.exports;

function _interopRequire$1(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion$1 = MotionExports$1;

_interopRequire$1(_Motion$1);

var _StaggeredMotion$1 = StaggeredMotionExports$1;

_interopRequire$1(_StaggeredMotion$1);

var _TransitionMotion$1 = TransitionMotionExports$1;

var TransitionMotion$1 = _interopRequire$1(_TransitionMotion$1);

var _spring$1 = springExports$1;

var spring$1 = _interopRequire$1(_spring$1);

var _presets$1 = presetsExports$1;

_interopRequire$1(_presets$1);

var _stripStyle$1 = stripStyleExports$1;

_interopRequire$1(_stripStyle$1);

// deprecated, dummy warning function

var _reorderKeys$1 = reorderKeysExports$1;

_interopRequire$1(_reorderKeys$1);

let updateQueue = makeQueue();
const raf = (fn) => schedule(fn, updateQueue);
let writeQueue = makeQueue();
raf.write = (fn) => schedule(fn, writeQueue);
let onStartQueue = makeQueue();
raf.onStart = (fn) => schedule(fn, onStartQueue);
let onFrameQueue = makeQueue();
raf.onFrame = (fn) => schedule(fn, onFrameQueue);
let onFinishQueue = makeQueue();
raf.onFinish = (fn) => schedule(fn, onFinishQueue);
let timeouts = [];
raf.setTimeout = (handler, ms) => {
  let time = raf.now() + ms;
  let cancel = () => {
    let i = timeouts.findIndex((t) => t.cancel == cancel);
    if (~i)
      timeouts.splice(i, 1);
    __raf.count -= ~i ? 1 : 0;
  };
  let timeout = {time, handler, cancel};
  timeouts.splice(findTimeout(time), 0, timeout);
  __raf.count += 1;
  start();
  return timeout;
};
let findTimeout = (time) => ~(~timeouts.findIndex((t) => t.time > time) || ~timeouts.length);
raf.cancel = (fn) => {
  updateQueue.delete(fn);
  writeQueue.delete(fn);
};
raf.sync = (fn) => {
  sync = true;
  raf.batchedUpdates(fn);
  sync = false;
};
raf.throttle = (fn) => {
  let lastArgs;
  function queuedFn() {
    try {
      fn(...lastArgs);
    } finally {
      lastArgs = null;
    }
  }
  function throttled(...args) {
    lastArgs = args;
    raf.onStart(queuedFn);
  }
  throttled.handler = fn;
  throttled.cancel = () => {
    onStartQueue.delete(queuedFn);
    lastArgs = null;
  };
  return throttled;
};
let nativeRaf = typeof window != "undefined" ? window.requestAnimationFrame : () => {
};
raf.use = (impl) => nativeRaf = impl;
raf.now = typeof performance != "undefined" ? () => performance.now() : Date.now;
raf.batchedUpdates = (fn) => fn();
raf.catch = console.error;
let ts = -1;
let sync = false;
function schedule(fn, queue) {
  if (sync) {
    queue.delete(fn);
    fn(0);
  } else {
    queue.add(fn);
    start();
  }
}
function start() {
  if (ts < 0) {
    ts = 0;
    nativeRaf(loop);
  }
}
function loop() {
  if (~ts) {
    nativeRaf(loop);
    raf.batchedUpdates(update);
  }
}
function update() {
  let prevTs = ts;
  ts = raf.now();
  let count = findTimeout(ts);
  if (count) {
    eachSafely(timeouts.splice(0, count), (t) => t.handler());
    __raf.count -= count;
  }
  onStartQueue.flush();
  updateQueue.flush(prevTs ? Math.min(64, ts - prevTs) : 16.667);
  onFrameQueue.flush();
  writeQueue.flush();
  onFinishQueue.flush();
}
function makeQueue() {
  let next = new Set();
  let current = next;
  return {
    add(fn) {
      __raf.count += current == next && !next.has(fn) ? 1 : 0;
      next.add(fn);
    },
    delete(fn) {
      __raf.count -= current == next && next.has(fn) ? 1 : 0;
      return next.delete(fn);
    },
    flush(arg) {
      if (current.size) {
        next = new Set();
        __raf.count -= current.size;
        eachSafely(current, (fn) => fn(arg) && next.add(fn));
        __raf.count += next.size;
        current = next;
      }
    }
  };
}
function eachSafely(values, each) {
  values.forEach((value) => {
    try {
      each(value);
    } catch (e) {
      raf.catch(e);
    }
  });
}
const __raf = {
  count: 0,
  clear() {
    ts = -1;
    timeouts = [];
    onStartQueue = makeQueue();
    updateQueue = makeQueue();
    onFrameQueue = makeQueue();
    writeQueue = makeQueue();
    onFinishQueue = makeQueue();
    __raf.count = 0;
  }
};

function noop$5() {
}
const defineHidden = (obj, key, value) => Object.defineProperty(obj, key, {value, writable: true, configurable: true});
const is$1 = {
  arr: Array.isArray,
  obj: (a) => !!a && a.constructor.name === "Object",
  fun: (a) => typeof a === "function",
  str: (a) => typeof a === "string",
  num: (a) => typeof a === "number",
  und: (a) => a === void 0
};
function isEqual$3(a, b) {
  if (is$1.arr(a)) {
    if (!is$1.arr(b) || a.length !== b.length)
      return false;
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i])
        return false;
    }
    return true;
  }
  return a === b;
}
const each = (obj, fn) => obj.forEach(fn);
function eachProp(obj, fn, ctx) {
  for (const key in obj) {
    fn.call(ctx, obj[key], key);
  }
}
const toArray = (a) => is$1.und(a) ? [] : is$1.arr(a) ? a : [a];
function flush(queue, iterator) {
  if (queue.size) {
    const items = Array.from(queue);
    queue.clear();
    each(items, iterator);
  }
}
const flushCalls = (queue, ...args) => flush(queue, (fn) => fn(...args));

let createStringInterpolator;
let to$1;
let colors$1 = null;
let skipAnimation = false;
let willAdvance = noop$5;
const assign$1 = (globals) => {
  if (globals.to)
    to$1 = globals.to;
  if (globals.now)
    raf.now = globals.now;
  if (globals.colors !== void 0)
    colors$1 = globals.colors;
  if (globals.skipAnimation != null)
    skipAnimation = globals.skipAnimation;
  if (globals.createStringInterpolator)
    createStringInterpolator = globals.createStringInterpolator;
  if (globals.requestAnimationFrame)
    raf.use(globals.requestAnimationFrame);
  if (globals.batchedUpdates)
    raf.batchedUpdates = globals.batchedUpdates;
  if (globals.willAdvance)
    willAdvance = globals.willAdvance;
};

var globals = /*#__PURE__*/Object.freeze({
  __proto__: null,
  get createStringInterpolator () { return createStringInterpolator; },
  get to () { return to$1; },
  get colors () { return colors$1; },
  get skipAnimation () { return skipAnimation; },
  get willAdvance () { return willAdvance; },
  assign: assign$1
});

const startQueue = new Set();
let currentFrame = [];
let prevFrame = [];
let priority = 0;
const frameLoop = {
  get idle() {
    return !startQueue.size && !currentFrame.length;
  },
  start(animation) {
    if (priority > animation.priority) {
      startQueue.add(animation);
      raf.onStart(flushStartQueue);
    } else {
      startSafely(animation);
      raf(advance);
    }
  },
  advance,
  sort(animation) {
    if (priority) {
      raf.onFrame(() => frameLoop.sort(animation));
    } else {
      const prevIndex = currentFrame.indexOf(animation);
      if (~prevIndex) {
        currentFrame.splice(prevIndex, 1);
        startUnsafely(animation);
      }
    }
  },
  clear() {
    currentFrame = [];
    startQueue.clear();
  }
};
function flushStartQueue() {
  startQueue.forEach(startSafely);
  startQueue.clear();
  raf(advance);
}
function startSafely(animation) {
  if (!currentFrame.includes(animation))
    startUnsafely(animation);
}
function startUnsafely(animation) {
  currentFrame.splice(findIndex$1(currentFrame, (other) => other.priority > animation.priority), 0, animation);
}
function advance(dt) {
  const nextFrame = prevFrame;
  for (let i = 0; i < currentFrame.length; i++) {
    const animation = currentFrame[i];
    priority = animation.priority;
    if (!animation.idle) {
      willAdvance(animation);
      animation.advance(dt);
      if (!animation.idle) {
        nextFrame.push(animation);
      }
    }
  }
  priority = 0;
  prevFrame = currentFrame;
  prevFrame.length = 0;
  currentFrame = nextFrame;
  return currentFrame.length > 0;
}
function findIndex$1(arr, test) {
  const index = arr.findIndex(test);
  return index < 0 ? arr.length : index;
}

const colors$1$1 = {
  transparent: 0,
  aliceblue: 4042850303,
  antiquewhite: 4209760255,
  aqua: 16777215,
  aquamarine: 2147472639,
  azure: 4043309055,
  beige: 4126530815,
  bisque: 4293182719,
  black: 255,
  blanchedalmond: 4293643775,
  blue: 65535,
  blueviolet: 2318131967,
  brown: 2771004159,
  burlywood: 3736635391,
  burntsienna: 3934150143,
  cadetblue: 1604231423,
  chartreuse: 2147418367,
  chocolate: 3530104575,
  coral: 4286533887,
  cornflowerblue: 1687547391,
  cornsilk: 4294499583,
  crimson: 3692313855,
  cyan: 16777215,
  darkblue: 35839,
  darkcyan: 9145343,
  darkgoldenrod: 3095792639,
  darkgray: 2846468607,
  darkgreen: 6553855,
  darkgrey: 2846468607,
  darkkhaki: 3182914559,
  darkmagenta: 2332068863,
  darkolivegreen: 1433087999,
  darkorange: 4287365375,
  darkorchid: 2570243327,
  darkred: 2332033279,
  darksalmon: 3918953215,
  darkseagreen: 2411499519,
  darkslateblue: 1211993087,
  darkslategray: 793726975,
  darkslategrey: 793726975,
  darkturquoise: 13554175,
  darkviolet: 2483082239,
  deeppink: 4279538687,
  deepskyblue: 12582911,
  dimgray: 1768516095,
  dimgrey: 1768516095,
  dodgerblue: 512819199,
  firebrick: 2988581631,
  floralwhite: 4294635775,
  forestgreen: 579543807,
  fuchsia: 4278255615,
  gainsboro: 3705462015,
  ghostwhite: 4177068031,
  gold: 4292280575,
  goldenrod: 3668254975,
  gray: 2155905279,
  green: 8388863,
  greenyellow: 2919182335,
  grey: 2155905279,
  honeydew: 4043305215,
  hotpink: 4285117695,
  indianred: 3445382399,
  indigo: 1258324735,
  ivory: 4294963455,
  khaki: 4041641215,
  lavender: 3873897215,
  lavenderblush: 4293981695,
  lawngreen: 2096890111,
  lemonchiffon: 4294626815,
  lightblue: 2916673279,
  lightcoral: 4034953471,
  lightcyan: 3774873599,
  lightgoldenrodyellow: 4210742015,
  lightgray: 3553874943,
  lightgreen: 2431553791,
  lightgrey: 3553874943,
  lightpink: 4290167295,
  lightsalmon: 4288707327,
  lightseagreen: 548580095,
  lightskyblue: 2278488831,
  lightslategray: 2005441023,
  lightslategrey: 2005441023,
  lightsteelblue: 2965692159,
  lightyellow: 4294959359,
  lime: 16711935,
  limegreen: 852308735,
  linen: 4210091775,
  magenta: 4278255615,
  maroon: 2147483903,
  mediumaquamarine: 1724754687,
  mediumblue: 52735,
  mediumorchid: 3126187007,
  mediumpurple: 2473647103,
  mediumseagreen: 1018393087,
  mediumslateblue: 2070474495,
  mediumspringgreen: 16423679,
  mediumturquoise: 1221709055,
  mediumvioletred: 3340076543,
  midnightblue: 421097727,
  mintcream: 4127193855,
  mistyrose: 4293190143,
  moccasin: 4293178879,
  navajowhite: 4292783615,
  navy: 33023,
  oldlace: 4260751103,
  olive: 2155872511,
  olivedrab: 1804477439,
  orange: 4289003775,
  orangered: 4282712319,
  orchid: 3664828159,
  palegoldenrod: 4008225535,
  palegreen: 2566625535,
  paleturquoise: 2951671551,
  palevioletred: 3681588223,
  papayawhip: 4293907967,
  peachpuff: 4292524543,
  peru: 3448061951,
  pink: 4290825215,
  plum: 3718307327,
  powderblue: 2967529215,
  purple: 2147516671,
  rebeccapurple: 1714657791,
  red: 4278190335,
  rosybrown: 3163525119,
  royalblue: 1097458175,
  saddlebrown: 2336560127,
  salmon: 4202722047,
  sandybrown: 4104413439,
  seagreen: 780883967,
  seashell: 4294307583,
  sienna: 2689740287,
  silver: 3233857791,
  skyblue: 2278484991,
  slateblue: 1784335871,
  slategray: 1887473919,
  slategrey: 1887473919,
  snow: 4294638335,
  springgreen: 16744447,
  steelblue: 1182971135,
  tan: 3535047935,
  teal: 8421631,
  thistle: 3636451583,
  tomato: 4284696575,
  turquoise: 1088475391,
  violet: 4001558271,
  wheat: 4125012991,
  white: 4294967295,
  whitesmoke: 4126537215,
  yellow: 4294902015,
  yellowgreen: 2597139199
};

const NUMBER = "[-+]?\\d*\\.?\\d+";
const PERCENTAGE = NUMBER + "%";
function call(...parts) {
  return "\\(\\s*(" + parts.join(")\\s*,\\s*(") + ")\\s*\\)";
}
const rgb$2 = new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER));
const rgba$1 = new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER));
const hsl$1 = new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE));
const hsla$1 = new RegExp("hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER));
const hex3 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex4 = /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/;
const hex6 = /^#([0-9a-fA-F]{6})$/;
const hex8 = /^#([0-9a-fA-F]{8})$/;

function normalizeColor(color) {
  let match;
  if (typeof color === "number") {
    return color >>> 0 === color && color >= 0 && color <= 4294967295 ? color : null;
  }
  if (match = hex6.exec(color))
    return parseInt(match[1] + "ff", 16) >>> 0;
  if (colors$1 && colors$1[color] !== void 0) {
    return colors$1[color];
  }
  if (match = rgb$2.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 255) >>> 0;
  }
  if (match = rgba$1.exec(color)) {
    return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
  }
  if (match = hex3.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
  }
  if (match = hex8.exec(color))
    return parseInt(match[1], 16) >>> 0;
  if (match = hex4.exec(color)) {
    return parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
  }
  if (match = hsl$1.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 255) >>> 0;
  }
  if (match = hsla$1.exec(color)) {
    return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
  }
  return null;
}
function hue2rgb(p, q, t) {
  if (t < 0)
    t += 1;
  if (t > 1)
    t -= 1;
  if (t < 1 / 6)
    return p + (q - p) * 6 * t;
  if (t < 1 / 2)
    return q;
  if (t < 2 / 3)
    return p + (q - p) * (2 / 3 - t) * 6;
  return p;
}
function hslToRgb(h, s, l) {
  const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  const p = 2 * l - q;
  const r = hue2rgb(p, q, h + 1 / 3);
  const g = hue2rgb(p, q, h);
  const b = hue2rgb(p, q, h - 1 / 3);
  return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
}
function parse255(str) {
  const int = parseInt(str, 10);
  if (int < 0)
    return 0;
  if (int > 255)
    return 255;
  return int;
}
function parse360(str) {
  const int = parseFloat(str);
  return (int % 360 + 360) % 360 / 360;
}
function parse1(str) {
  const num = parseFloat(str);
  if (num < 0)
    return 0;
  if (num > 1)
    return 255;
  return Math.round(num * 255);
}
function parsePercentage(str) {
  const int = parseFloat(str);
  if (int < 0)
    return 0;
  if (int > 100)
    return 1;
  return int / 100;
}

function colorToRgba(input) {
  let int32Color = normalizeColor(input);
  if (int32Color === null)
    return input;
  int32Color = int32Color || 0;
  let r = (int32Color & 4278190080) >>> 24;
  let g = (int32Color & 16711680) >>> 16;
  let b = (int32Color & 65280) >>> 8;
  let a = (int32Color & 255) / 255;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

const createInterpolator = (range, output, extrapolate) => {
  if (is$1.fun(range)) {
    return range;
  }
  if (is$1.arr(range)) {
    return createInterpolator({
      range,
      output,
      extrapolate
    });
  }
  if (is$1.str(range.output[0])) {
    return createStringInterpolator(range);
  }
  const config = range;
  const outputRange = config.output;
  const inputRange = config.range || [0, 1];
  const extrapolateLeft = config.extrapolateLeft || config.extrapolate || "extend";
  const extrapolateRight = config.extrapolateRight || config.extrapolate || "extend";
  const easing = config.easing || ((t) => t);
  return (input) => {
    const range2 = findRange(input, inputRange);
    return interpolate$1(input, inputRange[range2], inputRange[range2 + 1], outputRange[range2], outputRange[range2 + 1], easing, extrapolateLeft, extrapolateRight, config.map);
  };
};
function interpolate$1(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight, map) {
  let result = map ? map(input) : input;
  if (result < inputMin) {
    if (extrapolateLeft === "identity")
      return result;
    else if (extrapolateLeft === "clamp")
      result = inputMin;
  }
  if (result > inputMax) {
    if (extrapolateRight === "identity")
      return result;
    else if (extrapolateRight === "clamp")
      result = inputMax;
  }
  if (outputMin === outputMax)
    return outputMin;
  if (inputMin === inputMax)
    return input <= inputMin ? outputMin : outputMax;
  if (inputMin === -Infinity)
    result = -result;
  else if (inputMax === Infinity)
    result = result - inputMin;
  else
    result = (result - inputMin) / (inputMax - inputMin);
  result = easing(result);
  if (outputMin === -Infinity)
    result = -result;
  else if (outputMax === Infinity)
    result = result + outputMin;
  else
    result = result * (outputMax - outputMin) + outputMin;
  return result;
}
function findRange(input, inputRange) {
  for (var i = 1; i < inputRange.length - 1; ++i)
    if (inputRange[i] >= input)
      break;
  return i - 1;
}

const $get = Symbol.for("FluidValue.get");
const $observers = Symbol.for("FluidValue.observers");
const hasFluidValue = (arg) => Boolean(arg && arg[$get]);
const getFluidValue = (arg) => arg && arg[$get] ? arg[$get]() : arg;
const getFluidObservers = (target) => target[$observers] || null;
function callFluidObserver(observer, event) {
  if (observer.eventObserved) {
    observer.eventObserved(event);
  } else {
    observer(event);
  }
}
function callFluidObservers(target, event) {
  let observers = target[$observers];
  if (observers) {
    observers.forEach((observer) => {
      callFluidObserver(observer, event);
    });
  }
}
class FluidValue {
  constructor(get) {
    if (!get && !(get = this.get)) {
      throw Error("Unknown getter");
    }
    setFluidGetter(this, get);
  }
}
const setFluidGetter = (target, get) => setHidden(target, $get, get);
function addFluidObserver(target, observer) {
  if (target[$get]) {
    let observers = target[$observers];
    if (!observers) {
      setHidden(target, $observers, observers = new Set());
    }
    if (!observers.has(observer)) {
      observers.add(observer);
      if (target.observerAdded) {
        target.observerAdded(observers.size, observer);
      }
    }
  }
  return observer;
}
function removeFluidObserver(target, observer) {
  let observers = target[$observers];
  if (observers && observers.has(observer)) {
    const count = observers.size - 1;
    if (count) {
      observers.delete(observer);
    } else {
      target[$observers] = null;
    }
    if (target.observerRemoved) {
      target.observerRemoved(count, observer);
    }
  }
}
const setHidden = (target, key, value) => Object.defineProperty(target, key, {
  value,
  writable: true,
  configurable: true
});

const numberRegex = /[+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
const colorRegex = /(#(?:[0-9a-f]{2}){2,4}|(#[0-9a-f]{3})|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
let namedColorRegex;
const rgbaRegex = /rgba\(([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+), ([0-9\.-]+)\)/gi;
const rgbaRound = (_, p1, p2, p3, p4) => `rgba(${Math.round(p1)}, ${Math.round(p2)}, ${Math.round(p3)}, ${p4})`;
const createStringInterpolator$1 = (config) => {
  if (!namedColorRegex)
    namedColorRegex = colors$1 ? new RegExp(`(${Object.keys(colors$1).join("|")})`, "g") : /^\b$/;
  const output = config.output.map((value) => getFluidValue(value).replace(colorRegex, colorToRgba).replace(namedColorRegex, colorToRgba));
  const keyframes = output.map((value) => value.match(numberRegex).map(Number));
  const outputRanges = keyframes[0].map((_, i) => keyframes.map((values) => {
    if (!(i in values)) {
      throw Error('The arity of each "output" value must be equal');
    }
    return values[i];
  }));
  const interpolators = outputRanges.map((output2) => createInterpolator({...config, output: output2}));
  return (input) => {
    let i = 0;
    return output[0].replace(numberRegex, () => String(interpolators[i++](input))).replace(rgbaRegex, rgbaRound);
  };
};

const prefix = "react-spring: ";
const once = (fn) => {
  const func = fn;
  let called = false;
  if (typeof func != "function") {
    throw new TypeError(`${prefix}once requires a function parameter`);
  }
  return (...args) => {
    if (!called) {
      func(...args);
      called = true;
    }
  };
};
const warnInterpolate = once(console.warn);
function deprecateInterpolate() {
  warnInterpolate(`${prefix}The "interpolate" function is deprecated in v9 (use "to" instead)`);
}
const warnDirectCall = once(console.warn);
function deprecateDirectCall() {
  warnDirectCall(`${prefix}Directly calling start instead of using the api object is deprecated in v9 (use ".start" instead)`);
}

function isAnimatedString(value) {
  return is$1.str(value) && (value[0] == "#" || /\d/.test(value) || value in (colors$1 || {}));
}

const useOnce = (effect) => useEffect(effect, emptyDeps);
const emptyDeps = [];

function useForceUpdate() {
  const update = useState()[1];
  const mounted = useState(makeMountedRef)[0];
  useOnce(mounted.unmount);
  return () => {
    if (mounted.current) {
      update({});
    }
  };
}
function makeMountedRef() {
  const mounted = {
    current: true,
    unmount: () => () => {
      mounted.current = false;
    }
  };
  return mounted;
}

function useMemoOne(getResult, inputs) {
  const [initial] = useState(() => ({
    inputs,
    result: getResult()
  }));
  const committed = useRef();
  const prevCache = committed.current;
  let cache = prevCache;
  if (cache) {
    const useCache = Boolean(inputs && cache.inputs && areInputsEqual(inputs, cache.inputs));
    if (!useCache) {
      cache = {
        inputs,
        result: getResult()
      };
    }
  } else {
    cache = initial;
  }
  useEffect(() => {
    committed.current = cache;
    if (prevCache == initial) {
      initial.inputs = initial.result = void 0;
    }
  }, [cache]);
  return cache.result;
}
function areInputsEqual(next, prev) {
  if (next.length !== prev.length) {
    return false;
  }
  for (let i = 0; i < next.length; i++) {
    if (next[i] !== prev[i]) {
      return false;
    }
  }
  return true;
}

function usePrev(value) {
  const prevRef = useRef();
  useEffect(() => {
    prevRef.current = value;
  });
  return prevRef.current;
}

const useLayoutEffect = typeof window !== "undefined" && window.document && window.document.createElement ? useLayoutEffect$1 : useEffect;

const $node = Symbol.for("Animated:node");
const isAnimated = (value) => !!value && value[$node] === value;
const getAnimated = (owner) => owner && owner[$node];
const setAnimated = (owner, node) => defineHidden(owner, $node, node);
const getPayload = (owner) => owner && owner[$node] && owner[$node].getPayload();
class Animated {
  constructor() {
    setAnimated(this, this);
  }
  getPayload() {
    return this.payload || [];
  }
}

class AnimatedValue extends Animated {
  constructor(_value) {
    super();
    this._value = _value;
    this.done = true;
    this.durationProgress = 0;
    if (is$1.num(this._value)) {
      this.lastPosition = this._value;
    }
  }
  static create(value) {
    return new AnimatedValue(value);
  }
  getPayload() {
    return [this];
  }
  getValue() {
    return this._value;
  }
  setValue(value, step) {
    if (is$1.num(value)) {
      this.lastPosition = value;
      if (step) {
        value = Math.round(value / step) * step;
        if (this.done) {
          this.lastPosition = value;
        }
      }
    }
    if (this._value === value) {
      return false;
    }
    this._value = value;
    return true;
  }
  reset() {
    const {done} = this;
    this.done = false;
    if (is$1.num(this._value)) {
      this.elapsedTime = 0;
      this.durationProgress = 0;
      this.lastPosition = this._value;
      if (done)
        this.lastVelocity = null;
      this.v0 = null;
    }
  }
}

class AnimatedString extends AnimatedValue {
  constructor(value) {
    super(0);
    this._string = null;
    this._toString = createInterpolator({
      output: [value, value]
    });
  }
  static create(value) {
    return new AnimatedString(value);
  }
  getValue() {
    let value = this._string;
    return value == null ? this._string = this._toString(this._value) : value;
  }
  setValue(value) {
    if (is$1.str(value)) {
      if (value == this._string) {
        return false;
      }
      this._string = value;
      this._value = 1;
    } else if (super.setValue(value)) {
      this._string = null;
    } else {
      return false;
    }
    return true;
  }
  reset(goal) {
    if (goal) {
      this._toString = createInterpolator({
        output: [this.getValue(), goal]
      });
    }
    this._value = 0;
    super.reset();
  }
}

const TreeContext = {dependencies: null};

class AnimatedObject extends Animated {
  constructor(source) {
    super();
    this.source = source;
    this.setValue(source);
  }
  getValue(animated) {
    const values = {};
    eachProp(this.source, (source, key) => {
      if (isAnimated(source)) {
        values[key] = source.getValue(animated);
      } else if (hasFluidValue(source)) {
        values[key] = getFluidValue(source);
      } else if (!animated) {
        values[key] = source;
      }
    });
    return values;
  }
  setValue(source) {
    this.source = source;
    this.payload = this._makePayload(source);
  }
  reset() {
    if (this.payload) {
      each(this.payload, (node) => node.reset());
    }
  }
  _makePayload(source) {
    if (source) {
      const payload = new Set();
      eachProp(source, this._addToPayload, payload);
      return Array.from(payload);
    }
  }
  _addToPayload(source) {
    if (TreeContext.dependencies && hasFluidValue(source)) {
      TreeContext.dependencies.add(source);
    }
    const payload = getPayload(source);
    if (payload) {
      each(payload, (node) => this.add(node));
    }
  }
}

class AnimatedArray extends AnimatedObject {
  constructor(source) {
    super(source);
  }
  static create(source) {
    return new AnimatedArray(source);
  }
  getValue() {
    return this.source.map((node) => node.getValue());
  }
  setValue(source) {
    const payload = this.getPayload();
    if (source.length == payload.length) {
      return payload.some((node, i) => node.setValue(source[i]));
    }
    super.setValue(source.map(makeAnimated));
    return true;
  }
}
function makeAnimated(value) {
  const nodeType = isAnimatedString(value) ? AnimatedString : AnimatedValue;
  return nodeType.create(value);
}

function getAnimatedType(value) {
  const parentNode = getAnimated(value);
  return parentNode ? parentNode.constructor : is$1.arr(value) ? AnimatedArray : isAnimatedString(value) ? AnimatedString : AnimatedValue;
}

const withAnimated = (Component, host) => {
  const hasInstance = !is$1.fun(Component) || Component.prototype && Component.prototype.isReactComponent;
  return forwardRef((givenProps, givenRef) => {
    const instanceRef = useRef(null);
    const ref = hasInstance && useCallback$1((value) => {
      instanceRef.current = updateRef(givenRef, value);
    }, [givenRef]);
    const [props, deps] = getAnimatedState(givenProps, host);
    const forceUpdate = useForceUpdate();
    const callback = () => {
      const instance = instanceRef.current;
      if (hasInstance && !instance) {
        return;
      }
      const didUpdate = instance ? host.applyAnimatedValues(instance, props.getValue(true)) : false;
      if (didUpdate === false) {
        forceUpdate();
      }
    };
    const observer = new PropsObserver(callback, deps);
    const observerRef = useRef();
    useLayoutEffect(() => {
      const lastObserver = observerRef.current;
      observerRef.current = observer;
      each(deps, (dep) => addFluidObserver(dep, observer));
      if (lastObserver) {
        each(lastObserver.deps, (dep) => removeFluidObserver(dep, lastObserver));
        raf.cancel(lastObserver.update);
      }
    });
    useEffect(callback, []);
    useOnce(() => () => {
      const observer2 = observerRef.current;
      each(observer2.deps, (dep) => removeFluidObserver(dep, observer2));
    });
    const usedProps = host.getComponentProps(props.getValue());
    return /* @__PURE__ */ createElement(Component, {
      ...usedProps,
      ref
    });
  });
};
class PropsObserver {
  constructor(update, deps) {
    this.update = update;
    this.deps = deps;
  }
  eventObserved(event) {
    if (event.type == "change") {
      raf.write(this.update);
    }
  }
}
function getAnimatedState(props, host) {
  const dependencies = new Set();
  TreeContext.dependencies = dependencies;
  if (props.style)
    props = {
      ...props,
      style: host.createAnimatedStyle(props.style)
    };
  props = new AnimatedObject(props);
  TreeContext.dependencies = null;
  return [props, dependencies];
}
function updateRef(ref, value) {
  if (ref) {
    if (is$1.fun(ref))
      ref(value);
    else
      ref.current = value;
  }
  return value;
}

const cacheKey = Symbol.for("AnimatedComponent");
const createHost = (components, {
  applyAnimatedValues = () => false,
  createAnimatedStyle = (style) => new AnimatedObject(style),
  getComponentProps = (props) => props
} = {}) => {
  const hostConfig = {
    applyAnimatedValues,
    createAnimatedStyle,
    getComponentProps
  };
  const animated = (Component) => {
    const displayName = getDisplayName$1(Component) || "Anonymous";
    if (is$1.str(Component)) {
      Component = animated[Component] || (animated[Component] = withAnimated(Component, hostConfig));
    } else {
      Component = Component[cacheKey] || (Component[cacheKey] = withAnimated(Component, hostConfig));
    }
    Component.displayName = `Animated(${displayName})`;
    return Component;
  };
  eachProp(components, (Component, key) => {
    if (is$1.arr(components)) {
      key = getDisplayName$1(Component);
    }
    animated[key] = animated(Component);
  });
  return {
    animated
  };
};
const getDisplayName$1 = (arg) => is$1.str(arg) ? arg : arg && is$1.str(arg.displayName) ? arg.displayName : is$1.fun(arg) && arg.name || null;

function callProp(value, ...args) {
  return is$1.fun(value) ? value(...args) : value;
}
const matchProp = (value, key) => value === true || !!(key && value && (is$1.fun(value) ? value(key) : toArray(value).includes(key)));
const resolveProp = (prop, key) => is$1.obj(prop) ? key && prop[key] : prop;
const getDefaultProp = (props, key) => props.default === true ? props[key] : props.default ? props.default[key] : void 0;
const noopTransform = (value) => value;
const getDefaultProps = (props, transform = noopTransform) => {
  let keys = DEFAULT_PROPS;
  if (props.default && props.default !== true) {
    props = props.default;
    keys = Object.keys(props);
  }
  const defaults = {};
  for (const key of keys) {
    const value = transform(props[key], key);
    if (!is$1.und(value)) {
      defaults[key] = value;
    }
  }
  return defaults;
};
const DEFAULT_PROPS = [
  "config",
  "onProps",
  "onStart",
  "onChange",
  "onPause",
  "onResume",
  "onRest"
];
const RESERVED_PROPS = {
  config: 1,
  from: 1,
  to: 1,
  ref: 1,
  loop: 1,
  reset: 1,
  pause: 1,
  cancel: 1,
  reverse: 1,
  immediate: 1,
  default: 1,
  delay: 1,
  onProps: 1,
  onStart: 1,
  onChange: 1,
  onPause: 1,
  onResume: 1,
  onRest: 1,
  onResolve: 1,
  items: 1,
  trail: 1,
  sort: 1,
  expires: 1,
  initial: 1,
  enter: 1,
  update: 1,
  leave: 1,
  children: 1,
  onDestroyed: 1,
  keys: 1,
  callId: 1,
  parentId: 1
};
function getForwardProps(props) {
  const forward = {};
  let count = 0;
  eachProp(props, (value, prop) => {
    if (!RESERVED_PROPS[prop]) {
      forward[prop] = value;
      count++;
    }
  });
  if (count) {
    return forward;
  }
}
function inferTo(props) {
  const to = getForwardProps(props);
  if (to) {
    const out = {to};
    eachProp(props, (val, key) => key in to || (out[key] = val));
    return out;
  }
  return {...props};
}
function computeGoal(value) {
  value = getFluidValue(value);
  return is$1.arr(value) ? value.map(computeGoal) : isAnimatedString(value) ? globals.createStringInterpolator({
    range: [0, 1],
    output: [value, value]
  })(1) : value;
}
function hasProps(props) {
  for (const _ in props)
    return true;
  return false;
}
function isAsyncTo(to) {
  return is$1.fun(to) || is$1.arr(to) && is$1.obj(to[0]);
}
function detachRefs(ctrl, ref) {
  var _a;
  (_a = ctrl.ref) == null ? void 0 : _a.delete(ctrl);
  ref == null ? void 0 : ref.delete(ctrl);
}
function replaceRef(ctrl, ref) {
  var _a;
  if (ref && ctrl.ref !== ref) {
    (_a = ctrl.ref) == null ? void 0 : _a.delete(ctrl);
    ref.add(ctrl);
    ctrl.ref = ref;
  }
}

const config$1 = {
  default: {tension: 170, friction: 26},
  gentle: {tension: 120, friction: 14},
  wobbly: {tension: 180, friction: 12},
  stiff: {tension: 210, friction: 20},
  slow: {tension: 280, friction: 60},
  molasses: {tension: 280, friction: 120}
};

const linear$2 = (t) => t;
const defaults = {
  ...config$1.default,
  mass: 1,
  damping: 1,
  easing: linear$2,
  clamp: false
};
class AnimationConfig {
  constructor() {
    this.velocity = 0;
    Object.assign(this, defaults);
  }
}
function mergeConfig(config, newConfig, defaultConfig) {
  if (defaultConfig) {
    defaultConfig = {...defaultConfig};
    sanitizeConfig(defaultConfig, newConfig);
    newConfig = {...defaultConfig, ...newConfig};
  }
  sanitizeConfig(config, newConfig);
  Object.assign(config, newConfig);
  for (const key in defaults) {
    if (config[key] == null) {
      config[key] = defaults[key];
    }
  }
  let {mass, frequency, damping} = config;
  if (!is$1.und(frequency)) {
    if (frequency < 0.01)
      frequency = 0.01;
    if (damping < 0)
      damping = 0;
    config.tension = Math.pow(2 * Math.PI / frequency, 2) * mass;
    config.friction = 4 * Math.PI * damping * mass / frequency;
  }
  return config;
}
function sanitizeConfig(config, props) {
  if (!is$1.und(props.decay)) {
    config.duration = void 0;
  } else {
    const isTensionConfig = !is$1.und(props.tension) || !is$1.und(props.friction);
    if (isTensionConfig || !is$1.und(props.frequency) || !is$1.und(props.damping) || !is$1.und(props.mass)) {
      config.duration = void 0;
      config.decay = void 0;
    }
    if (isTensionConfig) {
      config.frequency = void 0;
    }
  }
}

const emptyArray = [];
class Animation {
  constructor() {
    this.changed = false;
    this.values = emptyArray;
    this.toValues = null;
    this.fromValues = emptyArray;
    this.config = new AnimationConfig();
    this.immediate = false;
  }
}

function scheduleProps(callId, {key, props, defaultProps, state, actions}) {
  return new Promise((resolve, reject) => {
    var _a;
    let delay;
    let timeout;
    let cancel = matchProp((_a = props.cancel) != null ? _a : defaultProps == null ? void 0 : defaultProps.cancel, key);
    if (cancel) {
      onStart();
    } else {
      if (!is$1.und(props.pause)) {
        state.paused = matchProp(props.pause, key);
      }
      let pause = defaultProps == null ? void 0 : defaultProps.pause;
      if (pause !== true) {
        pause = state.paused || matchProp(pause, key);
      }
      delay = callProp(props.delay || 0, key);
      if (pause) {
        state.resumeQueue.add(onResume);
        actions.pause();
      } else {
        actions.resume();
        onResume();
      }
    }
    function onPause() {
      state.resumeQueue.add(onResume);
      state.timeouts.delete(timeout);
      timeout.cancel();
      delay = timeout.time - raf.now();
    }
    function onResume() {
      if (delay > 0) {
        timeout = raf.setTimeout(onStart, delay);
        state.pauseQueue.add(onPause);
        state.timeouts.add(timeout);
      } else {
        onStart();
      }
    }
    function onStart() {
      state.pauseQueue.delete(onPause);
      state.timeouts.delete(timeout);
      if (callId <= (state.cancelId || 0)) {
        cancel = true;
      }
      try {
        actions.start({...props, callId, cancel}, resolve);
      } catch (err) {
        reject(err);
      }
    }
  });
}

const getCombinedResult = (target, results) => results.length == 1 ? results[0] : results.some((result) => result.cancelled) ? getCancelledResult(target.get()) : results.every((result) => result.noop) ? getNoopResult(target.get()) : getFinishedResult(target.get(), results.every((result) => result.finished));
const getNoopResult = (value) => ({
  value,
  noop: true,
  finished: true,
  cancelled: false
});
const getFinishedResult = (value, finished, cancelled = false) => ({
  value,
  finished,
  cancelled
});
const getCancelledResult = (value) => ({
  value,
  cancelled: true,
  finished: false
});

function runAsync(to, props, state, target) {
  const {callId, parentId, onRest} = props;
  const {asyncTo: prevTo, promise: prevPromise} = state;
  if (!parentId && to === prevTo && !props.reset) {
    return prevPromise;
  }
  return state.promise = (async () => {
    state.asyncId = callId;
    state.asyncTo = to;
    const defaultProps = getDefaultProps(props, (value, key) => key === "onRest" ? void 0 : value);
    let preventBail;
    let bail;
    const bailPromise = new Promise((resolve, reject) => (preventBail = resolve, bail = reject));
    const bailIfEnded = (bailSignal) => {
      const bailResult = callId <= (state.cancelId || 0) && getCancelledResult(target) || callId !== state.asyncId && getFinishedResult(target, false);
      if (bailResult) {
        bailSignal.result = bailResult;
        bail(bailSignal);
        throw bailSignal;
      }
    };
    const animate = (arg1, arg2) => {
      const bailSignal = new BailSignal();
      const skipAnimationSignal = new SkipAniamtionSignal();
      return (async () => {
        if (globals.skipAnimation) {
          stopAsync(state);
          skipAnimationSignal.result = getFinishedResult(target, false);
          bail(skipAnimationSignal);
          throw skipAnimationSignal;
        }
        bailIfEnded(bailSignal);
        const props2 = is$1.obj(arg1) ? {...arg1} : {...arg2, to: arg1};
        props2.parentId = callId;
        eachProp(defaultProps, (value, key) => {
          if (is$1.und(props2[key])) {
            props2[key] = value;
          }
        });
        const result2 = await target.start(props2);
        bailIfEnded(bailSignal);
        if (state.paused) {
          await new Promise((resume) => {
            state.resumeQueue.add(resume);
          });
        }
        return result2;
      })();
    };
    let result;
    if (globals.skipAnimation) {
      stopAsync(state);
      return getFinishedResult(target, false);
    }
    try {
      let animating;
      if (is$1.arr(to)) {
        animating = (async (queue) => {
          for (const props2 of queue) {
            await animate(props2);
          }
        })(to);
      } else {
        animating = Promise.resolve(to(animate, target.stop.bind(target)));
      }
      await Promise.all([animating.then(preventBail), bailPromise]);
      result = getFinishedResult(target.get(), true, false);
    } catch (err) {
      if (err instanceof BailSignal) {
        result = err.result;
      } else if (err instanceof SkipAniamtionSignal) {
        result = err.result;
      } else {
        throw err;
      }
    } finally {
      if (callId == state.asyncId) {
        state.asyncId = parentId;
        state.asyncTo = parentId ? prevTo : void 0;
        state.promise = parentId ? prevPromise : void 0;
      }
    }
    if (is$1.fun(onRest)) {
      raf.batchedUpdates(() => {
        onRest(result, target, target.item);
      });
    }
    return result;
  })();
}
function stopAsync(state, cancelId) {
  flush(state.timeouts, (t) => t.cancel());
  state.pauseQueue.clear();
  state.resumeQueue.clear();
  state.asyncId = state.asyncTo = state.promise = void 0;
  if (cancelId)
    state.cancelId = cancelId;
}
class BailSignal extends Error {
  constructor() {
    super("An async animation has been interrupted. You see this error because you forgot to use `await` or `.catch(...)` on its returned promise.");
  }
}
class SkipAniamtionSignal extends Error {
  constructor() {
    super("SkipAnimationSignal");
  }
}

const isFrameValue = (value) => value instanceof FrameValue;
let nextId = 1;
class FrameValue extends FluidValue {
  constructor() {
    super(...arguments);
    this.id = nextId++;
    this._priority = 0;
  }
  get priority() {
    return this._priority;
  }
  set priority(priority) {
    if (this._priority != priority) {
      this._priority = priority;
      this._onPriorityChange(priority);
    }
  }
  get() {
    const node = getAnimated(this);
    return node && node.getValue();
  }
  to(...args) {
    return globals.to(this, args);
  }
  interpolate(...args) {
    deprecateInterpolate();
    return globals.to(this, args);
  }
  toJSON() {
    return this.get();
  }
  observerAdded(count) {
    if (count == 1)
      this._attach();
  }
  observerRemoved(count) {
    if (count == 0)
      this._detach();
  }
  _attach() {
  }
  _detach() {
  }
  _onChange(value, idle = false) {
    callFluidObservers(this, {
      type: "change",
      parent: this,
      value,
      idle
    });
  }
  _onPriorityChange(priority) {
    if (!this.idle) {
      frameLoop.sort(this);
    }
    callFluidObservers(this, {
      type: "priority",
      parent: this,
      priority
    });
  }
}

const $P = Symbol.for("SpringPhase");
const HAS_ANIMATED = 1;
const IS_ANIMATING = 2;
const IS_PAUSED = 4;
const hasAnimated = (target) => (target[$P] & HAS_ANIMATED) > 0;
const isAnimating = (target) => (target[$P] & IS_ANIMATING) > 0;
const isPaused = (target) => (target[$P] & IS_PAUSED) > 0;
const setActiveBit = (target, active) => active ? target[$P] |= IS_ANIMATING | HAS_ANIMATED : target[$P] &= ~IS_ANIMATING;
const setPausedBit = (target, paused) => paused ? target[$P] |= IS_PAUSED : target[$P] &= ~IS_PAUSED;

class SpringValue extends FrameValue {
  constructor(arg1, arg2) {
    super();
    this.animation = new Animation();
    this.defaultProps = {};
    this._state = {
      paused: false,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    this._pendingCalls = new Set();
    this._lastCallId = 0;
    this._lastToId = 0;
    this._memoizedDuration = 0;
    if (!is$1.und(arg1) || !is$1.und(arg2)) {
      const props = is$1.obj(arg1) ? {...arg1} : {...arg2, from: arg1};
      if (is$1.und(props.default)) {
        props.default = true;
      }
      this.start(props);
    }
  }
  get idle() {
    return !(isAnimating(this) || this._state.asyncTo) || isPaused(this);
  }
  get goal() {
    return getFluidValue(this.animation.to);
  }
  get velocity() {
    const node = getAnimated(this);
    return node instanceof AnimatedValue ? node.lastVelocity || 0 : node.getPayload().map((node2) => node2.lastVelocity || 0);
  }
  get hasAnimated() {
    return hasAnimated(this);
  }
  get isAnimating() {
    return isAnimating(this);
  }
  get isPaused() {
    return isPaused(this);
  }
  advance(dt) {
    let idle = true;
    let changed = false;
    const anim = this.animation;
    let {config, toValues} = anim;
    const payload = getPayload(anim.to);
    if (!payload && hasFluidValue(anim.to)) {
      toValues = toArray(getFluidValue(anim.to));
    }
    anim.values.forEach((node2, i) => {
      if (node2.done)
        return;
      const to = node2.constructor == AnimatedString ? 1 : payload ? payload[i].lastPosition : toValues[i];
      let finished = anim.immediate;
      let position = to;
      if (!finished) {
        position = node2.lastPosition;
        if (config.tension <= 0) {
          node2.done = true;
          return;
        }
        let elapsed = node2.elapsedTime += dt;
        const from = anim.fromValues[i];
        const v0 = node2.v0 != null ? node2.v0 : node2.v0 = is$1.arr(config.velocity) ? config.velocity[i] : config.velocity;
        let velocity;
        if (!is$1.und(config.duration)) {
          let p = 1;
          if (config.duration > 0) {
            if (this._memoizedDuration !== config.duration) {
              this._memoizedDuration = config.duration;
              if (node2.durationProgress > 0) {
                node2.elapsedTime = config.duration * node2.durationProgress;
                elapsed = node2.elapsedTime += dt;
              }
            }
            p = (config.progress || 0) + elapsed / this._memoizedDuration;
            p = p > 1 ? 1 : p < 0 ? 0 : p;
            node2.durationProgress = p;
          }
          position = from + config.easing(p) * (to - from);
          velocity = (position - node2.lastPosition) / dt;
          finished = p == 1;
        } else if (config.decay) {
          const decay = config.decay === true ? 0.998 : config.decay;
          const e = Math.exp(-(1 - decay) * elapsed);
          position = from + v0 / (1 - decay) * (1 - e);
          finished = Math.abs(node2.lastPosition - position) < 0.1;
          velocity = v0 * e;
        } else {
          velocity = node2.lastVelocity == null ? v0 : node2.lastVelocity;
          const precision = config.precision || (from == to ? 5e-3 : Math.min(1, Math.abs(to - from) * 1e-3));
          const restVelocity = config.restVelocity || precision / 10;
          const bounceFactor = config.clamp ? 0 : config.bounce;
          const canBounce = !is$1.und(bounceFactor);
          const isGrowing = from == to ? node2.v0 > 0 : from < to;
          let isMoving;
          let isBouncing = false;
          const step = 1;
          const numSteps = Math.ceil(dt / step);
          for (let n = 0; n < numSteps; ++n) {
            isMoving = Math.abs(velocity) > restVelocity;
            if (!isMoving) {
              finished = Math.abs(to - position) <= precision;
              if (finished) {
                break;
              }
            }
            if (canBounce) {
              isBouncing = position == to || position > to == isGrowing;
              if (isBouncing) {
                velocity = -velocity * bounceFactor;
                position = to;
              }
            }
            const springForce = -config.tension * 1e-6 * (position - to);
            const dampingForce = -config.friction * 1e-3 * velocity;
            const acceleration = (springForce + dampingForce) / config.mass;
            velocity = velocity + acceleration * step;
            position = position + velocity * step;
          }
        }
        node2.lastVelocity = velocity;
        if (Number.isNaN(position)) {
          console.warn(`Got NaN while animating:`, this);
          finished = true;
        }
      }
      if (payload && !payload[i].done) {
        finished = false;
      }
      if (finished) {
        node2.done = true;
      } else {
        idle = false;
      }
      if (node2.setValue(position, config.round)) {
        changed = true;
      }
    });
    const node = getAnimated(this);
    if (idle) {
      const value = getFluidValue(anim.to);
      if (node.setValue(value) || changed) {
        this._onChange(value);
      }
      this._stop();
    } else if (changed) {
      this._onChange(node.getValue());
    }
  }
  set(value) {
    raf.batchedUpdates(() => {
      this._stop();
      this._focus(value);
      this._set(value);
    });
    return this;
  }
  pause() {
    this._update({pause: true});
  }
  resume() {
    this._update({pause: false});
  }
  finish() {
    if (isAnimating(this)) {
      const {to, config} = this.animation;
      raf.batchedUpdates(() => {
        this._onStart();
        if (!config.decay) {
          this._set(to, false);
        }
        this._stop();
      });
    }
    return this;
  }
  update(props) {
    const queue = this.queue || (this.queue = []);
    queue.push(props);
    return this;
  }
  start(to, arg2) {
    let queue;
    if (!is$1.und(to)) {
      queue = [is$1.obj(to) ? to : {...arg2, to}];
    } else {
      queue = this.queue || [];
      this.queue = [];
    }
    return Promise.all(queue.map((props) => this._update(props))).then((results) => getCombinedResult(this, results));
  }
  stop(cancel) {
    const {to} = this.animation;
    this._focus(this.get());
    stopAsync(this._state, cancel && this._lastCallId);
    raf.batchedUpdates(() => this._stop(to, cancel));
    return this;
  }
  reset() {
    this._update({reset: true});
  }
  eventObserved(event) {
    if (event.type == "change") {
      this._start();
    } else if (event.type == "priority") {
      this.priority = event.priority + 1;
    }
  }
  _prepareNode(props) {
    const key = this.key || "";
    let {to, from} = props;
    to = is$1.obj(to) ? to[key] : to;
    if (to == null || isAsyncTo(to)) {
      to = void 0;
    }
    from = is$1.obj(from) ? from[key] : from;
    if (from == null) {
      from = void 0;
    }
    const range = {to, from};
    if (!hasAnimated(this)) {
      if (props.reverse)
        [to, from] = [from, to];
      from = getFluidValue(from);
      if (!is$1.und(from)) {
        this._set(from);
      } else if (!getAnimated(this)) {
        this._set(to);
      }
    }
    return range;
  }
  _update({...props}, isLoop) {
    const {key, defaultProps} = this;
    if (props.default)
      Object.assign(defaultProps, getDefaultProps(props, (value, prop) => /^on/.test(prop) ? resolveProp(value, key) : value));
    mergeActiveFn(this, props, "onProps");
    sendEvent(this, "onProps", props, this);
    const range = this._prepareNode(props);
    if (Object.isFrozen(this)) {
      throw Error("Cannot animate a `SpringValue` object that is frozen. Did you forget to pass your component to `animated(...)` before animating its props?");
    }
    const state = this._state;
    return scheduleProps(++this._lastCallId, {
      key,
      props,
      defaultProps,
      state,
      actions: {
        pause: () => {
          if (!isPaused(this)) {
            setPausedBit(this, true);
            flushCalls(state.pauseQueue);
            sendEvent(this, "onPause", getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        resume: () => {
          if (isPaused(this)) {
            setPausedBit(this, false);
            if (isAnimating(this)) {
              this._resume();
            }
            flushCalls(state.resumeQueue);
            sendEvent(this, "onResume", getFinishedResult(this, checkFinished(this, this.animation.to)), this);
          }
        },
        start: this._merge.bind(this, range)
      }
    }).then((result) => {
      if (props.loop && result.finished && !(isLoop && result.noop)) {
        const nextProps = createLoopUpdate(props);
        if (nextProps) {
          return this._update(nextProps, true);
        }
      }
      return result;
    });
  }
  _merge(range, props, resolve) {
    if (props.cancel) {
      this.stop(true);
      return resolve(getCancelledResult(this));
    }
    const hasToProp = !is$1.und(range.to);
    const hasFromProp = !is$1.und(range.from);
    if (hasToProp || hasFromProp) {
      if (props.callId > this._lastToId) {
        this._lastToId = props.callId;
      } else {
        return resolve(getCancelledResult(this));
      }
    }
    const {key, defaultProps, animation: anim} = this;
    const {to: prevTo, from: prevFrom} = anim;
    let {to = prevTo, from = prevFrom} = range;
    if (hasFromProp && !hasToProp && (!props.default || is$1.und(to))) {
      to = from;
    }
    if (props.reverse)
      [to, from] = [from, to];
    const hasFromChanged = !isEqual$3(from, prevFrom);
    if (hasFromChanged) {
      anim.from = from;
    }
    from = getFluidValue(from);
    const hasToChanged = !isEqual$3(to, prevTo);
    if (hasToChanged) {
      this._focus(to);
    }
    const hasAsyncTo = isAsyncTo(props.to);
    const {config} = anim;
    const {decay, velocity} = config;
    if (hasToProp || hasFromProp) {
      config.velocity = 0;
    }
    if (props.config && !hasAsyncTo) {
      mergeConfig(config, callProp(props.config, key), props.config !== defaultProps.config ? callProp(defaultProps.config, key) : void 0);
    }
    let node = getAnimated(this);
    if (!node || is$1.und(to)) {
      return resolve(getFinishedResult(this, true));
    }
    const reset = is$1.und(props.reset) ? hasFromProp && !props.default : !is$1.und(from) && matchProp(props.reset, key);
    const value = reset ? from : this.get();
    const goal = computeGoal(to);
    const isAnimatable = is$1.num(goal) || is$1.arr(goal) || isAnimatedString(goal);
    const immediate = !hasAsyncTo && (!isAnimatable || matchProp(defaultProps.immediate || props.immediate, key));
    if (hasToChanged) {
      const nodeType = getAnimatedType(to);
      if (nodeType !== node.constructor) {
        if (immediate) {
          node = this._set(goal);
        } else
          throw Error(`Cannot animate between ${node.constructor.name} and ${nodeType.name}, as the "to" prop suggests`);
      }
    }
    const goalType = node.constructor;
    let started = hasFluidValue(to);
    let finished = false;
    if (!started) {
      const hasValueChanged = reset || !hasAnimated(this) && hasFromChanged;
      if (hasToChanged || hasValueChanged) {
        finished = isEqual$3(computeGoal(value), goal);
        started = !finished;
      }
      if (!isEqual$3(config.decay, decay) || !isEqual$3(config.velocity, velocity)) {
        started = true;
      }
    }
    if (finished && isAnimating(this)) {
      if (anim.changed && !reset) {
        started = true;
      } else if (!started) {
        this._stop(prevTo);
      }
    }
    if (!hasAsyncTo) {
      if (started || hasFluidValue(prevTo)) {
        anim.values = node.getPayload();
        anim.toValues = hasFluidValue(to) ? null : goalType == AnimatedString ? [1] : toArray(goal);
      }
      if (anim.immediate != immediate) {
        anim.immediate = immediate;
        if (!immediate && !reset) {
          this._set(prevTo);
        }
      }
      if (started) {
        const {onRest} = anim;
        each(ACTIVE_EVENTS, (type) => mergeActiveFn(this, props, type));
        const result = getFinishedResult(this, checkFinished(this, prevTo));
        flushCalls(this._pendingCalls, result);
        this._pendingCalls.add(resolve);
        if (anim.changed)
          raf.batchedUpdates(() => {
            var _a;
            anim.changed = !reset;
            onRest == null ? void 0 : onRest(result, this);
            if (reset) {
              callProp(defaultProps.onRest, result);
            } else {
              (_a = anim.onStart) == null ? void 0 : _a.call(anim, result, this);
            }
          });
      }
    }
    if (reset) {
      this._set(value);
    }
    if (hasAsyncTo) {
      resolve(runAsync(props.to, props, this._state, this));
    } else if (started) {
      this._start();
    } else if (isAnimating(this) && !hasToChanged) {
      this._pendingCalls.add(resolve);
    } else {
      resolve(getNoopResult(value));
    }
  }
  _focus(value) {
    const anim = this.animation;
    if (value !== anim.to) {
      if (getFluidObservers(this)) {
        this._detach();
      }
      anim.to = value;
      if (getFluidObservers(this)) {
        this._attach();
      }
    }
  }
  _attach() {
    let priority = 0;
    const {to} = this.animation;
    if (hasFluidValue(to)) {
      addFluidObserver(to, this);
      if (isFrameValue(to)) {
        priority = to.priority + 1;
      }
    }
    this.priority = priority;
  }
  _detach() {
    const {to} = this.animation;
    if (hasFluidValue(to)) {
      removeFluidObserver(to, this);
    }
  }
  _set(arg, idle = true) {
    const value = getFluidValue(arg);
    if (!is$1.und(value)) {
      const oldNode = getAnimated(this);
      if (!oldNode || !isEqual$3(value, oldNode.getValue())) {
        const nodeType = getAnimatedType(value);
        if (!oldNode || oldNode.constructor != nodeType) {
          setAnimated(this, nodeType.create(value));
        } else {
          oldNode.setValue(value);
        }
        if (oldNode) {
          raf.batchedUpdates(() => {
            this._onChange(value, idle);
          });
        }
      }
    }
    return getAnimated(this);
  }
  _onStart() {
    const anim = this.animation;
    if (!anim.changed) {
      anim.changed = true;
      sendEvent(this, "onStart", getFinishedResult(this, checkFinished(this, anim.to)), this);
    }
  }
  _onChange(value, idle) {
    if (!idle) {
      this._onStart();
      callProp(this.animation.onChange, value, this);
    }
    callProp(this.defaultProps.onChange, value, this);
    super._onChange(value, idle);
  }
  _start() {
    const anim = this.animation;
    getAnimated(this).reset(getFluidValue(anim.to));
    if (!anim.immediate) {
      anim.fromValues = anim.values.map((node) => node.lastPosition);
    }
    if (!isAnimating(this)) {
      setActiveBit(this, true);
      if (!isPaused(this)) {
        this._resume();
      }
    }
  }
  _resume() {
    if (globals.skipAnimation) {
      this.finish();
    } else {
      frameLoop.start(this);
    }
  }
  _stop(goal, cancel) {
    if (isAnimating(this)) {
      setActiveBit(this, false);
      const anim = this.animation;
      each(anim.values, (node) => {
        node.done = true;
      });
      if (anim.toValues) {
        anim.onChange = anim.onPause = anim.onResume = void 0;
      }
      callFluidObservers(this, {
        type: "idle",
        parent: this
      });
      const result = cancel ? getCancelledResult(this.get()) : getFinishedResult(this.get(), checkFinished(this, goal != null ? goal : anim.to));
      flushCalls(this._pendingCalls, result);
      if (anim.changed) {
        anim.changed = false;
        sendEvent(this, "onRest", result, this);
      }
    }
  }
}
function checkFinished(target, to) {
  const goal = computeGoal(to);
  const value = computeGoal(target.get());
  return isEqual$3(value, goal);
}
function createLoopUpdate(props, loop = props.loop, to = props.to) {
  let loopRet = callProp(loop);
  if (loopRet) {
    const overrides = loopRet !== true && inferTo(loopRet);
    const reverse = (overrides || props).reverse;
    const reset = !overrides || overrides.reset;
    return createUpdate({
      ...props,
      loop,
      default: false,
      pause: void 0,
      to: !reverse || isAsyncTo(to) ? to : void 0,
      from: reset ? props.from : void 0,
      reset,
      ...overrides
    });
  }
}
function createUpdate(props) {
  const {to, from} = props = inferTo(props);
  const keys = new Set();
  if (is$1.obj(to))
    findDefined(to, keys);
  if (is$1.obj(from))
    findDefined(from, keys);
  props.keys = keys.size ? Array.from(keys) : null;
  return props;
}
function declareUpdate(props) {
  const update = createUpdate(props);
  if (is$1.und(update.default)) {
    update.default = getDefaultProps(update);
  }
  return update;
}
function findDefined(values, keys) {
  eachProp(values, (value, key) => value != null && keys.add(key));
}
const ACTIVE_EVENTS = [
  "onStart",
  "onRest",
  "onChange",
  "onPause",
  "onResume"
];
function mergeActiveFn(target, props, type) {
  target.animation[type] = props[type] !== getDefaultProp(props, type) ? resolveProp(props[type], target.key) : void 0;
}
function sendEvent(target, type, ...args) {
  var _a, _b, _c, _d;
  (_b = (_a = target.animation)[type]) == null ? void 0 : _b.call(_a, ...args);
  (_d = (_c = target.defaultProps)[type]) == null ? void 0 : _d.call(_c, ...args);
}

const BATCHED_EVENTS = ["onStart", "onChange", "onRest"];
let nextId$1 = 1;
class Controller {
  constructor(props, flush2) {
    this.id = nextId$1++;
    this.springs = {};
    this.queue = [];
    this._lastAsyncId = 0;
    this._active = new Set();
    this._changed = new Set();
    this._started = false;
    this._state = {
      paused: false,
      pauseQueue: new Set(),
      resumeQueue: new Set(),
      timeouts: new Set()
    };
    this._events = {
      onStart: new Map(),
      onChange: new Map(),
      onRest: new Map()
    };
    this._onFrame = this._onFrame.bind(this);
    if (flush2) {
      this._flush = flush2;
    }
    if (props) {
      this.start({default: true, ...props});
    }
  }
  get idle() {
    return !this._state.asyncTo && Object.values(this.springs).every((spring) => spring.idle);
  }
  get item() {
    return this._item;
  }
  set item(item) {
    this._item = item;
  }
  get() {
    const values = {};
    this.each((spring, key) => values[key] = spring.get());
    return values;
  }
  set(values) {
    for (const key in values) {
      const value = values[key];
      if (!is$1.und(value)) {
        this.springs[key].set(value);
      }
    }
  }
  update(props) {
    if (props) {
      this.queue.push(createUpdate(props));
    }
    return this;
  }
  start(props) {
    let {queue} = this;
    if (props) {
      queue = toArray(props).map(createUpdate);
    } else {
      this.queue = [];
    }
    if (this._flush) {
      return this._flush(this, queue);
    }
    prepareKeys(this, queue);
    return flushUpdateQueue(this, queue);
  }
  stop(arg, keys) {
    if (arg !== !!arg) {
      keys = arg;
    }
    if (keys) {
      const springs = this.springs;
      each(toArray(keys), (key) => springs[key].stop(!!arg));
    } else {
      stopAsync(this._state, this._lastAsyncId);
      this.each((spring) => spring.stop(!!arg));
    }
    return this;
  }
  pause(keys) {
    if (is$1.und(keys)) {
      this.start({pause: true});
    } else {
      const springs = this.springs;
      each(toArray(keys), (key) => springs[key].pause());
    }
    return this;
  }
  resume(keys) {
    if (is$1.und(keys)) {
      this.start({pause: false});
    } else {
      const springs = this.springs;
      each(toArray(keys), (key) => springs[key].resume());
    }
    return this;
  }
  each(iterator) {
    eachProp(this.springs, iterator);
  }
  _onFrame() {
    const {onStart, onChange, onRest} = this._events;
    const active = this._active.size > 0;
    const changed = this._changed.size > 0;
    if (active && !this._started || changed && !this._started) {
      this._started = true;
      flush(onStart, ([onStart2, result]) => {
        result.value = this.get();
        onStart2(result, this, this._item);
      });
    }
    const idle = !active && this._started;
    const values = changed || idle && onRest.size ? this.get() : null;
    if (changed && onChange.size) {
      flush(onChange, ([onChange2, result]) => {
        result.value = values;
        onChange2(result, this, this._item);
      });
    }
    if (idle) {
      this._started = false;
      flush(onRest, ([onRest2, result]) => {
        result.value = values;
        onRest2(result, this, this._item);
      });
    }
  }
  eventObserved(event) {
    if (event.type == "change") {
      this._changed.add(event.parent);
      if (!event.idle) {
        this._active.add(event.parent);
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else
      return;
    raf.onFrame(this._onFrame);
  }
}
function flushUpdateQueue(ctrl, queue) {
  return Promise.all(queue.map((props) => flushUpdate(ctrl, props))).then((results) => getCombinedResult(ctrl, results));
}
async function flushUpdate(ctrl, props, isLoop) {
  const {keys, to, from, loop, onRest, onResolve} = props;
  const defaults = is$1.obj(props.default) && props.default;
  if (loop) {
    props.loop = false;
  }
  if (to === false)
    props.to = null;
  if (from === false)
    props.from = null;
  const asyncTo = is$1.arr(to) || is$1.fun(to) ? to : void 0;
  if (asyncTo) {
    props.to = void 0;
    props.onRest = void 0;
    if (defaults) {
      defaults.onRest = void 0;
    }
  } else {
    each(BATCHED_EVENTS, (key) => {
      const handler = props[key];
      if (is$1.fun(handler)) {
        const queue = ctrl["_events"][key];
        props[key] = ({finished, cancelled}) => {
          const result2 = queue.get(handler);
          if (result2) {
            if (!finished)
              result2.finished = false;
            if (cancelled)
              result2.cancelled = true;
          } else {
            queue.set(handler, {
              value: null,
              finished: finished || false,
              cancelled: cancelled || false
            });
          }
        };
        if (defaults) {
          defaults[key] = props[key];
        }
      }
    });
  }
  const state = ctrl["_state"];
  if (props.pause === !state.paused) {
    state.paused = props.pause;
    flushCalls(props.pause ? state.pauseQueue : state.resumeQueue);
  } else if (state.paused) {
    props.pause = true;
  }
  const promises = (keys || Object.keys(ctrl.springs)).map((key) => ctrl.springs[key].start(props));
  const cancel = props.cancel === true || getDefaultProp(props, "cancel") === true;
  if (asyncTo || cancel && state.asyncId) {
    promises.push(scheduleProps(++ctrl["_lastAsyncId"], {
      props,
      state,
      actions: {
        pause: noop$5,
        resume: noop$5,
        start(props2, resolve) {
          if (cancel) {
            stopAsync(state, ctrl["_lastAsyncId"]);
            resolve(getCancelledResult(ctrl));
          } else {
            props2.onRest = onRest;
            resolve(runAsync(asyncTo, props2, state, ctrl));
          }
        }
      }
    }));
  }
  if (state.paused) {
    await new Promise((resume) => {
      state.resumeQueue.add(resume);
    });
  }
  const result = getCombinedResult(ctrl, await Promise.all(promises));
  if (loop && result.finished && !(isLoop && result.noop)) {
    const nextProps = createLoopUpdate(props, loop, to);
    if (nextProps) {
      prepareKeys(ctrl, [nextProps]);
      return flushUpdate(ctrl, nextProps, true);
    }
  }
  if (onResolve) {
    raf.batchedUpdates(() => onResolve(result, ctrl, ctrl.item));
  }
  return result;
}
function getSprings(ctrl, props) {
  const springs = {...ctrl.springs};
  if (props) {
    each(toArray(props), (props2) => {
      if (is$1.und(props2.keys)) {
        props2 = createUpdate(props2);
      }
      if (!is$1.obj(props2.to)) {
        props2 = {...props2, to: void 0};
      }
      prepareSprings(springs, props2, (key) => {
        return createSpring(key);
      });
    });
  }
  return springs;
}
function setSprings(ctrl, springs) {
  eachProp(springs, (spring, key) => {
    if (!ctrl.springs[key]) {
      ctrl.springs[key] = spring;
      addFluidObserver(spring, ctrl);
    }
  });
}
function createSpring(key, observer) {
  const spring = new SpringValue();
  spring.key = key;
  if (observer) {
    addFluidObserver(spring, observer);
  }
  return spring;
}
function prepareSprings(springs, props, create) {
  if (props.keys) {
    each(props.keys, (key) => {
      const spring = springs[key] || (springs[key] = create(key));
      spring["_prepareNode"](props);
    });
  }
}
function prepareKeys(ctrl, queue) {
  each(queue, (props) => {
    prepareSprings(ctrl.springs, props, (key) => {
      return createSpring(key, ctrl);
    });
  });
}

const SpringContext = ({
  children,
  ...props
}) => {
  const inherited = useContext(ctx);
  const pause = props.pause || !!inherited.pause, immediate = props.immediate || !!inherited.immediate;
  props = useMemoOne(() => ({pause, immediate}), [pause, immediate]);
  const {Provider} = ctx;
  return /* @__PURE__ */ createElement(Provider, {
    value: props
  }, children);
};
const ctx = makeContext(SpringContext, {});
SpringContext.Provider = ctx.Provider;
SpringContext.Consumer = ctx.Consumer;
function makeContext(target, init) {
  Object.assign(target, createContext(init));
  target.Provider._context = target;
  target.Consumer._context = target;
  return target;
}

class SpringRef extends Function {
  constructor() {
    super("return arguments.callee._call.apply(arguments.callee, arguments)");
    this.current = [];
  }
  _call(props) {
    deprecateDirectCall();
    this.start(props);
  }
  set(values) {
    each(this.current, (ctrl) => ctrl.set(values));
  }
  start(props) {
    const results = [];
    each(this.current, (ctrl, i) => {
      if (is$1.und(props)) {
        results.push(ctrl.start());
      } else {
        const update = this._getProps(props, ctrl, i);
        if (update) {
          results.push(ctrl.start(update));
        }
      }
    });
    return results;
  }
  update(props) {
    each(this.current, (ctrl, i) => ctrl.update(this._getProps(props, ctrl, i)));
    return this;
  }
  add(ctrl) {
    if (!this.current.includes(ctrl)) {
      this.current.push(ctrl);
    }
  }
  delete(ctrl) {
    const i = this.current.indexOf(ctrl);
    if (~i)
      this.current.splice(i, 1);
  }
  _getProps(arg, ctrl, index) {
    return is$1.fun(arg) ? arg(index, ctrl) : arg;
  }
}
each(["stop", "pause", "resume"], (key) => {
  SpringRef.prototype[key] = function() {
    each(this.current, (ctrl) => ctrl[key](...arguments));
    return this;
  };
});

function useSprings(length, props, deps) {
  const propsFn = is$1.fun(props) && props;
  if (propsFn && !deps)
    deps = [];
  const ref = useMemo$1(() => propsFn || arguments.length == 3 ? new SpringRef() : void 0, []);
  const layoutId = useRef(0);
  const forceUpdate = useForceUpdate();
  const state = useMemo$1(() => ({
    ctrls: [],
    queue: [],
    flush(ctrl, updates2) {
      const springs2 = getSprings(ctrl, updates2);
      const canFlushSync = layoutId.current > 0 && !state.queue.length && !Object.keys(springs2).some((key) => !ctrl.springs[key]);
      return canFlushSync ? flushUpdateQueue(ctrl, updates2) : new Promise((resolve) => {
        setSprings(ctrl, springs2);
        state.queue.push(() => {
          resolve(flushUpdateQueue(ctrl, updates2));
        });
        forceUpdate();
      });
    }
  }), []);
  const ctrls = [...state.ctrls];
  const updates = [];
  const prevLength = usePrev(length) || 0;
  const oldCtrls = ctrls.slice(length, prevLength);
  useMemo$1(() => {
    ctrls.length = length;
    declareUpdates(prevLength, length);
  }, [length]);
  useMemo$1(() => {
    declareUpdates(0, Math.min(prevLength, length));
  }, deps);
  function declareUpdates(startIndex, endIndex) {
    for (let i = startIndex; i < endIndex; i++) {
      const ctrl = ctrls[i] || (ctrls[i] = new Controller(null, state.flush));
      const update = propsFn ? propsFn(i, ctrl) : props[i];
      if (update) {
        updates[i] = declareUpdate(update);
      }
    }
  }
  const springs = ctrls.map((ctrl, i) => getSprings(ctrl, updates[i]));
  const context = useContext(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  useLayoutEffect(() => {
    layoutId.current++;
    state.ctrls = ctrls;
    const {queue} = state;
    if (queue.length) {
      state.queue = [];
      each(queue, (cb) => cb());
    }
    each(oldCtrls, (ctrl) => {
      detachRefs(ctrl, ref);
      ctrl.stop(true);
    });
    each(ctrls, (ctrl, i) => {
      const values2 = springs[i];
      setSprings(ctrl, values2);
      ref == null ? void 0 : ref.add(ctrl);
      if (hasContext) {
        ctrl.start({default: context});
      }
      const update = updates[i];
      if (update) {
        replaceRef(ctrl, update.ref);
        if (ctrl.ref) {
          ctrl.queue.push(update);
        } else {
          ctrl.start(update);
        }
      }
    });
  });
  useOnce(() => () => {
    each(state.ctrls, (ctrl) => ctrl.stop(true));
  });
  const values = springs.map((x) => ({...x}));
  return ref ? [values, ref] : values;
}

function useSpring(props, deps) {
  const isFn = is$1.fun(props);
  const [[values], ref] = useSprings(1, isFn ? props : [props], isFn ? deps || [] : deps);
  return isFn || arguments.length == 2 ? [values, ref] : values;
}

const MOUNT = "mount";
const ENTER = "enter";
const UPDATE = "update";
const LEAVE = "leave";

function useTransition(data, props, deps) {
  const {reset, sort, trail = 0, expires = true, onDestroyed} = props;
  const ref = useMemo$1(() => arguments.length == 3 ? new SpringRef() : void 0, []);
  const items = toArray(data);
  const transitions = [];
  const usedTransitions = useRef(null);
  const prevTransitions = reset ? null : usedTransitions.current;
  useLayoutEffect(() => {
    usedTransitions.current = transitions;
  });
  useOnce(() => () => each(usedTransitions.current, (t) => {
    if (t.expired) {
      clearTimeout(t.expirationId);
    }
    detachRefs(t.ctrl, ref);
    t.ctrl.stop(true);
  }));
  const keys = getKeys(items, props, prevTransitions);
  const expired = reset && usedTransitions.current || [];
  useLayoutEffect(() => each(expired, ({ctrl, item, key}) => {
    detachRefs(ctrl, ref);
    callProp(onDestroyed, item, key);
  }));
  const reused = [];
  if (prevTransitions)
    each(prevTransitions, (t, i) => {
      if (t.expired) {
        clearTimeout(t.expirationId);
        expired.push(t);
      } else {
        i = reused[i] = keys.indexOf(t.key);
        if (~i)
          transitions[i] = t;
      }
    });
  each(items, (item, i) => {
    if (!transitions[i]) {
      transitions[i] = {
        key: keys[i],
        item,
        phase: MOUNT,
        ctrl: new Controller()
      };
      transitions[i].ctrl.item = item;
    }
  });
  if (reused.length) {
    let i = -1;
    each(reused, (keyIndex, prevIndex) => {
      const t = prevTransitions[prevIndex];
      if (~keyIndex) {
        i = transitions.indexOf(t);
        transitions[i] = {...t, item: items[keyIndex]};
      } else if (props.leave) {
        transitions.splice(++i, 0, t);
      }
    });
  }
  if (is$1.fun(sort)) {
    transitions.sort((a, b) => sort(a.item, b.item));
  }
  let delay = -trail;
  const forceUpdate = useForceUpdate();
  const defaultProps = getDefaultProps(props);
  const changes = new Map();
  each(transitions, (t, i) => {
    const key = t.key;
    const prevPhase = t.phase;
    let to;
    let phase;
    if (prevPhase == MOUNT) {
      to = props.enter;
      phase = ENTER;
    } else {
      const isLeave = keys.indexOf(key) < 0;
      if (prevPhase != LEAVE) {
        if (isLeave) {
          to = props.leave;
          phase = LEAVE;
        } else if (to = props.update) {
          phase = UPDATE;
        } else
          return;
      } else if (!isLeave) {
        to = props.enter;
        phase = ENTER;
      } else
        return;
    }
    to = callProp(to, t.item, i);
    to = is$1.obj(to) ? inferTo(to) : {to};
    if (!to.config) {
      const config = props.config || defaultProps.config;
      to.config = callProp(config, t.item, i, phase);
    }
    const payload = {
      ...defaultProps,
      delay: delay += trail,
      reset: false,
      ...to
    };
    if (phase == ENTER && is$1.und(payload.from)) {
      const from = is$1.und(props.initial) || prevTransitions ? props.from : props.initial;
      payload.from = callProp(from, t.item, i);
    }
    const {onResolve} = payload;
    payload.onResolve = (result) => {
      callProp(onResolve, result);
      const transitions2 = usedTransitions.current;
      const t2 = transitions2.find((t3) => t3.key === key);
      if (!t2)
        return;
      if (result.cancelled && t2.phase != UPDATE) {
        return;
      }
      if (t2.ctrl.idle) {
        const idle = transitions2.every((t3) => t3.ctrl.idle);
        if (t2.phase == LEAVE) {
          const expiry = callProp(expires, t2.item);
          if (expiry !== false) {
            const expiryMs = expiry === true ? 0 : expiry;
            t2.expired = true;
            if (!idle && expiryMs > 0) {
              if (expiryMs <= 2147483647)
                t2.expirationId = setTimeout(forceUpdate, expiryMs);
              return;
            }
          }
        }
        if (idle && transitions2.some((t3) => t3.expired)) {
          forceUpdate();
        }
      }
    };
    const springs = getSprings(t.ctrl, payload);
    changes.set(t, {phase, springs, payload});
  });
  const context = useContext(SpringContext);
  const prevContext = usePrev(context);
  const hasContext = context !== prevContext && hasProps(context);
  useLayoutEffect(() => {
    if (hasContext)
      each(transitions, (t) => {
        t.ctrl.start({default: context});
      });
  }, [context]);
  useLayoutEffect(() => {
    each(changes, ({phase, springs, payload}, t) => {
      const {ctrl} = t;
      t.phase = phase;
      ref == null ? void 0 : ref.add(ctrl);
      replaceRef(ctrl, payload.ref);
      setSprings(ctrl, springs);
      if (hasContext && phase == ENTER) {
        ctrl.start({default: context});
      }
      ctrl[ctrl.ref ? "update" : "start"](payload);
    });
  }, reset ? void 0 : deps);
  const renderTransitions = (render) => /* @__PURE__ */ createElement(Fragment, null, transitions.map((t, i) => {
    const {springs} = changes.get(t) || t.ctrl;
    const elem = render({...springs}, t.item, t, i);
    return elem && elem.type ? /* @__PURE__ */ createElement(elem.type, {
      ...elem.props,
      key: is$1.str(t.key) || is$1.num(t.key) ? t.key : t.ctrl.id,
      ref: elem.ref
    }) : elem;
  }));
  return ref ? [renderTransitions, ref] : renderTransitions;
}
let nextKey = 1;
function getKeys(items, {key, keys = key}, prevTransitions) {
  if (keys === null) {
    const reused = new Set();
    return items.map((item) => {
      const t = prevTransitions && prevTransitions.find((t2) => t2.item === item && t2.phase !== LEAVE && !reused.has(t2));
      if (t) {
        reused.add(t);
        return t.key;
      }
      return nextKey++;
    });
  }
  return is$1.und(keys) ? items : is$1.fun(keys) ? items.map(keys) : toArray(keys);
}

class Interpolation extends FrameValue {
  constructor(source, args) {
    super();
    this.source = source;
    this.idle = true;
    this._active = new Set();
    this.calc = createInterpolator(...args);
    const value = this._get();
    const nodeType = getAnimatedType(value);
    setAnimated(this, nodeType.create(value));
  }
  advance(_dt) {
    const value = this._get();
    const oldValue = this.get();
    if (!isEqual$3(value, oldValue)) {
      getAnimated(this).setValue(value);
      this._onChange(value, this.idle);
    }
    if (!this.idle && checkIdle(this._active)) {
      becomeIdle(this);
    }
  }
  _get() {
    const inputs = is$1.arr(this.source) ? this.source.map(getFluidValue) : toArray(getFluidValue(this.source));
    return this.calc(...inputs);
  }
  _start() {
    if (this.idle && !checkIdle(this._active)) {
      this.idle = false;
      each(getPayload(this), (node) => {
        node.done = false;
      });
      if (globals.skipAnimation) {
        raf.batchedUpdates(() => this.advance());
        becomeIdle(this);
      } else {
        frameLoop.start(this);
      }
    }
  }
  _attach() {
    let priority = 1;
    each(toArray(this.source), (source) => {
      if (hasFluidValue(source)) {
        addFluidObserver(source, this);
      }
      if (isFrameValue(source)) {
        if (!source.idle) {
          this._active.add(source);
        }
        priority = Math.max(priority, source.priority + 1);
      }
    });
    this.priority = priority;
    this._start();
  }
  _detach() {
    each(toArray(this.source), (source) => {
      if (hasFluidValue(source)) {
        removeFluidObserver(source, this);
      }
    });
    this._active.clear();
    becomeIdle(this);
  }
  eventObserved(event) {
    if (event.type == "change") {
      if (event.idle) {
        this.advance();
      } else {
        this._active.add(event.parent);
        this._start();
      }
    } else if (event.type == "idle") {
      this._active.delete(event.parent);
    } else if (event.type == "priority") {
      this.priority = toArray(this.source).reduce((highest, parent) => Math.max(highest, (isFrameValue(parent) ? parent.priority : 0) + 1), 0);
    }
  }
}
function isIdle(source) {
  return source.idle !== false;
}
function checkIdle(active) {
  return !active.size || Array.from(active).every(isIdle);
}
function becomeIdle(self) {
  if (!self.idle) {
    self.idle = true;
    each(getPayload(self), (node) => {
      node.done = true;
    });
    callFluidObservers(self, {
      type: "idle",
      parent: self
    });
  }
}

const to = (source, ...args) => new Interpolation(source, args);

globals.assign({
  createStringInterpolator: createStringInterpolator$1,
  to: (source, args) => new Interpolation(source, args)
});

const isCustomPropRE = /^--/;
function dangerousStyleValue(name, value) {
  if (value == null || typeof value === "boolean" || value === "")
    return "";
  if (typeof value === "number" && value !== 0 && !isCustomPropRE.test(name) && !(isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]))
    return value + "px";
  return ("" + value).trim();
}
const attributeCache = {};
function applyAnimatedValues(instance, props) {
  if (!instance.nodeType || !instance.setAttribute) {
    return false;
  }
  const isFilterElement = instance.nodeName === "filter" || instance.parentNode && instance.parentNode.nodeName === "filter";
  const {style, children, scrollTop, scrollLeft, ...attributes} = props;
  const values = Object.values(attributes);
  const names = Object.keys(attributes).map((name) => isFilterElement || instance.hasAttribute(name) ? name : attributeCache[name] || (attributeCache[name] = name.replace(/([A-Z])/g, (n) => "-" + n.toLowerCase())));
  if (children !== void 0) {
    instance.textContent = children;
  }
  for (let name in style) {
    if (style.hasOwnProperty(name)) {
      const value = dangerousStyleValue(name, style[name]);
      if (name === "float")
        name = "cssFloat";
      else if (isCustomPropRE.test(name)) {
        instance.style.setProperty(name, value);
      } else {
        instance.style[name] = value;
      }
    }
  }
  names.forEach((name, i) => {
    instance.setAttribute(name, values[i]);
  });
  if (scrollTop !== void 0) {
    instance.scrollTop = scrollTop;
  }
  if (scrollLeft !== void 0) {
    instance.scrollLeft = scrollLeft;
  }
}
let isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};
const prefixKey = (prefix, key) => prefix + key.charAt(0).toUpperCase() + key.substring(1);
const prefixes$2 = ["Webkit", "Ms", "Moz", "O"];
isUnitlessNumber = Object.keys(isUnitlessNumber).reduce((acc, prop) => {
  prefixes$2.forEach((prefix) => acc[prefixKey(prefix, prop)] = acc[prop]);
  return acc;
}, isUnitlessNumber);

const domTransforms = /^(matrix|translate|scale|rotate|skew)/;
const pxTransforms = /^(translate)/;
const degTransforms = /^(rotate|skew)/;
const addUnit = (value, unit) => is$1.num(value) && value !== 0 ? value + unit : value;
const isValueIdentity = (value, id) => is$1.arr(value) ? value.every((v) => isValueIdentity(v, id)) : is$1.num(value) ? value === id : parseFloat(value) === id;
class AnimatedStyle extends AnimatedObject {
  constructor({x, y, z, ...style}) {
    const inputs = [];
    const transforms = [];
    if (x || y || z) {
      inputs.push([x || 0, y || 0, z || 0]);
      transforms.push((xyz) => [
        `translate3d(${xyz.map((v) => addUnit(v, "px")).join(",")})`,
        isValueIdentity(xyz, 0)
      ]);
    }
    eachProp(style, (value, key) => {
      if (key === "transform") {
        inputs.push([value || ""]);
        transforms.push((transform) => [transform, transform === ""]);
      } else if (domTransforms.test(key)) {
        delete style[key];
        if (is$1.und(value))
          return;
        const unit = pxTransforms.test(key) ? "px" : degTransforms.test(key) ? "deg" : "";
        inputs.push(toArray(value));
        transforms.push(key === "rotate3d" ? ([x2, y2, z2, deg]) => [
          `rotate3d(${x2},${y2},${z2},${addUnit(deg, unit)})`,
          isValueIdentity(deg, 0)
        ] : (input) => [
          `${key}(${input.map((v) => addUnit(v, unit)).join(",")})`,
          isValueIdentity(input, key.startsWith("scale") ? 1 : 0)
        ]);
      }
    });
    if (inputs.length) {
      style.transform = new FluidTransform(inputs, transforms);
    }
    super(style);
  }
}
class FluidTransform extends FluidValue {
  constructor(inputs, transforms) {
    super();
    this.inputs = inputs;
    this.transforms = transforms;
    this._value = null;
  }
  get() {
    return this._value || (this._value = this._get());
  }
  _get() {
    let transform = "";
    let identity = true;
    each(this.inputs, (input, i) => {
      const arg1 = getFluidValue(input[0]);
      const [t, id] = this.transforms[i](is$1.arr(arg1) ? arg1 : input.map(getFluidValue));
      transform += " " + t;
      identity = identity && id;
    });
    return identity ? "none" : transform;
  }
  observerAdded(count) {
    if (count == 1)
      each(this.inputs, (input) => each(input, (value) => hasFluidValue(value) && addFluidObserver(value, this)));
  }
  observerRemoved(count) {
    if (count == 0)
      each(this.inputs, (input) => each(input, (value) => hasFluidValue(value) && removeFluidObserver(value, this)));
  }
  eventObserved(event) {
    if (event.type == "change") {
      this._value = null;
    }
    callFluidObservers(this, event);
  }
}

const primitives = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
];

globals.assign({
  batchedUpdates: unstable_batchedUpdates,
  createStringInterpolator: createStringInterpolator$1,
  colors: colors$1$1
});
const host = createHost(primitives, {
  applyAnimatedValues: applyAnimatedValues,
  createAnimatedStyle: (style) => new AnimatedStyle(style),
  getComponentProps: ({scrollTop, scrollLeft, ...props}) => props
});
const animated = host.animated;

function _defineProperty$c(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$e(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$9(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$e(Object(source), true).forEach(function (key) {
        _defineProperty$c(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$e(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

function _arrayWithHoles$7(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$7(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray$7(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray$7(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$7(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$7(o, minLen);
}

function _nonIterableRest$7() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$7(arr, i) {
  return _arrayWithHoles$7(arr) || _iterableToArrayLimit$7(arr, i) || _unsupportedIterableToArray$7(arr, i) || _nonIterableRest$7();
}

var TOOLTIP_OFFSET = 14;
var tooltipStyle = {
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 10,
  top: 0,
  left: 0
};

var translate$2 = function translate(x, y) {
  return "translate(".concat(x, "px, ").concat(y, "px)");
};

var TooltipWrapper = memo(function (_ref) {
  var _animatedProps$transf;

  var position = _ref.position,
      anchor = _ref.anchor,
      children = _ref.children;
  var theme = useTheme();

  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;

  var _useMeasure = useMeasure(),
      _useMeasure2 = _slicedToArray$7(_useMeasure, 2),
      measureRef = _useMeasure2[0],
      bounds = _useMeasure2[1];

  var previousPosition = useRef(false);
  var to = undefined;
  var immediate = false;
  var hasDimension = bounds.width > 0 && bounds.height > 0;
  var x = Math.round(position[0]);
  var y = Math.round(position[1]);

  if (hasDimension) {
    if (anchor === 'top') {
      x -= bounds.width / 2;
      y -= bounds.height + TOOLTIP_OFFSET;
    } else if (anchor === 'right') {
      x += TOOLTIP_OFFSET;
      y -= bounds.height / 2;
    } else if (anchor === 'bottom') {
      x -= bounds.width / 2;
      y += TOOLTIP_OFFSET;
    } else if (anchor === 'left') {
      x -= bounds.width + TOOLTIP_OFFSET;
      y -= bounds.height / 2;
    } else if (anchor === 'center') {
      x -= bounds.width / 2;
      y -= bounds.height / 2;
    }

    to = {
      transform: translate$2(x, y)
    };

    if (!previousPosition.current) {
      immediate = true;
    }

    previousPosition.current = [x, y];
  }

  var animatedProps = useSpring({
    to: to,
    config: springConfig,
    immediate: !animate || immediate
  });

  var style = _objectSpread2$9(_objectSpread2$9(_objectSpread2$9({}, tooltipStyle), theme.tooltip), {}, {
    transform: (_animatedProps$transf = animatedProps.transform) !== null && _animatedProps$transf !== void 0 ? _animatedProps$transf : translate$2(x, y)
  });

  return React__default.createElement(animated.div, {
    ref: measureRef,
    style: style
  }, children);
});
TooltipWrapper.displayName = 'TooltipWrapper';

var Chip = memo(function (_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 12 : _ref$size,
      color = _ref.color,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  return React__default.createElement("span", {
    style: _objectSpread2$9({
      display: 'block',
      width: size,
      height: size,
      background: color
    }, style)
  });
});

var BasicTooltip = memo(function (_ref) {
  var id = _ref.id,
      _value = _ref.value,
      format = _ref.format,
      _ref$enableChip = _ref.enableChip,
      enableChip = _ref$enableChip === void 0 ? false : _ref$enableChip,
      color = _ref.color,
      renderContent = _ref.renderContent;
  var theme = useTheme();
  var formatValue = useValueFormatter(format);
  var content;

  if (typeof renderContent === 'function') {
    content = renderContent();
  } else {
    var value = _value;

    if (formatValue !== undefined && value !== undefined) {
      value = formatValue(value);
    }

    content = React__default.createElement("div", {
      style: theme.tooltip.basic
    }, enableChip && React__default.createElement(Chip, {
      color: color,
      style: theme.tooltip.chip
    }), value !== undefined ? React__default.createElement("span", null, id, ": ", React__default.createElement("strong", null, "".concat(value))) : id);
  }

  return React__default.createElement("div", {
    style: theme.tooltip.container
  }, content);
});

var tableStyle = {
  width: '100%',
  borderCollapse: 'collapse'
};
var TableTooltip = memo(function (_ref) {
  var title = _ref.title,
      _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? [] : _ref$rows,
      renderContent = _ref.renderContent;
  var theme = useTheme();
  if (!rows.length) return null;
  var content;

  if (typeof renderContent === 'function') {
    content = renderContent();
  } else {
    content = React__default.createElement("div", null, title && title, React__default.createElement("table", {
      style: _objectSpread2$9(_objectSpread2$9({}, tableStyle), theme.tooltip.table)
    }, React__default.createElement("tbody", null, rows.map(function (row, i) {
      return React__default.createElement("tr", {
        key: i
      }, row.map(function (column, j) {
        return React__default.createElement("td", {
          key: j,
          style: theme.tooltip.tableCell
        }, column);
      }));
    }))));
  }

  return React__default.createElement("div", {
    style: theme.tooltip.container
  }, content);
});
TableTooltip.displayName = 'TableTooltip';

var CrosshairLine = memo(function (_ref) {
  var x0 = _ref.x0,
      x1 = _ref.x1,
      y0 = _ref.y0,
      y1 = _ref.y1;
  var theme = useTheme();

  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;

  var style = useMemo$1(function () {
    return _objectSpread2$9(_objectSpread2$9({}, theme.crosshair.line), {}, {
      pointerEvents: 'none'
    });
  }, [theme.crosshair.line]);
  var animatedProps = useSpring({
    x1: x0,
    x2: x1,
    y1: y0,
    y2: y1,
    config: springConfig,
    immediate: !animate
  });
  return React__default.createElement(animated.line, Object.assign({}, animatedProps, {
    fill: "none",
    style: style
  }));
});
CrosshairLine.displayName = 'CrosshairLine';

var Crosshair = memo(function (_ref) {
  var width = _ref.width,
      height = _ref.height,
      type = _ref.type,
      x = _ref.x,
      y = _ref.y;
  var xLine;
  var yLine;

  if (type === 'cross') {
    xLine = {
      x0: x,
      x1: x,
      y0: 0,
      y1: height
    };
    yLine = {
      x0: 0,
      x1: width,
      y0: y,
      y1: y
    };
  } else if (type === 'top-left') {
    xLine = {
      x0: x,
      x1: x,
      y0: 0,
      y1: y
    };
    yLine = {
      x0: 0,
      x1: x,
      y0: y,
      y1: y
    };
  } else if (type === 'top') {
    xLine = {
      x0: x,
      x1: x,
      y0: 0,
      y1: y
    };
  } else if (type === 'top-right') {
    xLine = {
      x0: x,
      x1: x,
      y0: 0,
      y1: y
    };
    yLine = {
      x0: x,
      x1: width,
      y0: y,
      y1: y
    };
  } else if (type === 'right') {
    yLine = {
      x0: x,
      x1: width,
      y0: y,
      y1: y
    };
  } else if (type === 'bottom-right') {
    xLine = {
      x0: x,
      x1: x,
      y0: y,
      y1: height
    };
    yLine = {
      x0: x,
      x1: width,
      y0: y,
      y1: y
    };
  } else if (type === 'bottom') {
    xLine = {
      x0: x,
      x1: x,
      y0: y,
      y1: height
    };
  } else if (type === 'bottom-left') {
    xLine = {
      x0: x,
      x1: x,
      y0: y,
      y1: height
    };
    yLine = {
      x0: 0,
      x1: x,
      y0: y,
      y1: y
    };
  } else if (type === 'left') {
    yLine = {
      x0: 0,
      x1: x,
      y0: y,
      y1: y
    };
  } else if (type === 'x') {
    xLine = {
      x0: x,
      x1: x,
      y0: 0,
      y1: height
    };
  } else if (type === 'y') {
    yLine = {
      x0: 0,
      x1: width,
      y0: y,
      y1: y
    };
  }

  return React__default.createElement(React__default.Fragment, null, xLine && React__default.createElement(CrosshairLine, {
    x0: xLine.x0,
    x1: xLine.x1,
    y0: xLine.y0,
    y1: xLine.y1
  }), yLine && React__default.createElement(CrosshairLine, {
    x0: yLine.x0,
    x1: yLine.x1,
    y0: yLine.y0,
    y1: yLine.y1
  }));
});
Crosshair.displayName = 'Crosshair';

var defaultActions = {
  showTooltipAt: function showTooltipAt() {},
  showTooltipFromEvent: function showTooltipFromEvent() {},
  hideTooltip: function hideTooltip() {}
};
var TooltipActionsContext = createContext(defaultActions);
var hiddenTooltipState = {
  isVisible: false,
  position: [null, null],
  content: null,
  anchor: null
};
var TooltipStateContext = createContext(hiddenTooltipState);

var useTooltipHandlers = function useTooltipHandlers(container) {
  var _useState = useState(hiddenTooltipState),
      _useState2 = _slicedToArray$7(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var showTooltipAt = useCallback$1(function (content, _ref) {
    var _ref2 = _slicedToArray$7(_ref, 2),
        x = _ref2[0],
        y = _ref2[1];

    var anchor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'top';
    setState({
      isVisible: true,
      position: [x, y],
      anchor: anchor,
      content: content
    });
  }, [setState]);
  var showTooltipFromEvent = useCallback$1(function (content, event) {
    var anchor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'top';
    var bounds = container.current.getBoundingClientRect();
    var x = event.clientX - bounds.left;
    var y = event.clientY - bounds.top;

    if (anchor === 'left' || anchor === 'right') {
      if (x < bounds.width / 2) anchor = 'right';else anchor = 'left';
    }

    setState({
      isVisible: true,
      position: [x, y],
      anchor: anchor,
      content: content
    });
  }, [container, setState]);
  var hideTooltip = useCallback$1(function () {
    setState(hiddenTooltipState);
  }, [setState]);
  var actions = useMemo$1(function () {
    return {
      showTooltipAt: showTooltipAt,
      showTooltipFromEvent: showTooltipFromEvent,
      hideTooltip: hideTooltip
    };
  }, [showTooltipAt, showTooltipFromEvent, hideTooltip]);
  return {
    actions: actions,
    state: state
  };
};
var useTooltip = function useTooltip() {
  var context = useContext(TooltipActionsContext);

  if (context === undefined) {
    throw new Error('useTooltip must be used within a TooltipProvider');
  }

  return context;
};
var useTooltipState = function useTooltipState() {
  var context = useContext(TooltipStateContext);

  if (context === undefined) {
    throw new Error('useTooltipState must be used within a TooltipProvider');
  }

  return context;
};

var isVisibleTooltipState = function isVisibleTooltipState(state) {
  return state.isVisible === true;
};
var Tooltip = function Tooltip() {
  var state = useTooltipState();

  if (!isVisibleTooltipState(state)) {
    return null;
  }

  return React__default.createElement(TooltipWrapper, {
    position: state.position,
    anchor: state.anchor
  }, state.content);
};

var TooltipProvider = function TooltipProvider(_ref) {
  var container = _ref.container,
      children = _ref.children;

  var _useTooltipHandlers = useTooltipHandlers(container),
      actions = _useTooltipHandlers.actions,
      state = _useTooltipHandlers.state;

  return React__default.createElement(TooltipActionsContext.Provider, {
    value: actions
  }, React__default.createElement(TooltipStateContext.Provider, {
    value: state
  }, children));
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$3() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear$1 = listCacheClear$3;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$8(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1$1 = eq$8;

var eq$7 = eq_1$1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$9(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$7(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf$1 = assocIndexOf$9;

var assocIndexOf$8 = _assocIndexOf$1;

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$3(key) {
  var data = this.__data__,
      index = assocIndexOf$8(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete$1 = listCacheDelete$3;

var assocIndexOf$7 = _assocIndexOf$1;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$3(key) {
  var data = this.__data__,
      index = assocIndexOf$7(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet$1 = listCacheGet$3;

var assocIndexOf$6 = _assocIndexOf$1;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$3(key) {
  return assocIndexOf$6(this.__data__, key) > -1;
}

var _listCacheHas$1 = listCacheHas$3;

var assocIndexOf$5 = _assocIndexOf$1;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$3(key, value) {
  var data = this.__data__,
      index = assocIndexOf$5(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet$1 = listCacheSet$3;

var listCacheClear$2 = _listCacheClear$1,
    listCacheDelete$2 = _listCacheDelete$1,
    listCacheGet$2 = _listCacheGet$1,
    listCacheHas$2 = _listCacheHas$1,
    listCacheSet$2 = _listCacheSet$1;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$9(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$9.prototype.clear = listCacheClear$2;
ListCache$9.prototype['delete'] = listCacheDelete$2;
ListCache$9.prototype.get = listCacheGet$2;
ListCache$9.prototype.has = listCacheHas$2;
ListCache$9.prototype.set = listCacheSet$2;

var _ListCache$1 = ListCache$9;

var ListCache$8 = _ListCache$1;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$3() {
  this.__data__ = new ListCache$8;
  this.size = 0;
}

var _stackClear$1 = stackClear$3;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$3(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete$1 = stackDelete$3;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$3(key) {
  return this.__data__.get(key);
}

var _stackGet$1 = stackGet$3;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$3(key) {
  return this.__data__.has(key);
}

var _stackHas$1 = stackHas$3;

/** Detect free variable `global` from Node.js. */

var freeGlobal$3 = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

var _freeGlobal$1 = freeGlobal$3;

var freeGlobal$2 = _freeGlobal$1;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$h = freeGlobal$2 || freeSelf$1 || Function('return this')();

var _root$1 = root$h;

var root$g = _root$1;

/** Built-in value references. */
var Symbol$b = root$g.Symbol;

var _Symbol$1 = Symbol$b;

var Symbol$a = _Symbol$1;

/** Used for built-in method references. */
var objectProto$s = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$o = objectProto$s.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$3 = objectProto$s.toString;

/** Built-in value references. */
var symToStringTag$3 = Symbol$a ? Symbol$a.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$3(value) {
  var isOwn = hasOwnProperty$o.call(value, symToStringTag$3),
      tag = value[symToStringTag$3];

  try {
    value[symToStringTag$3] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$3.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag;
    } else {
      delete value[symToStringTag$3];
    }
  }
  return result;
}

var _getRawTag$1 = getRawTag$3;

/** Used for built-in method references. */

var objectProto$r = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$r.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$3(value) {
  return nativeObjectToString$2.call(value);
}

var _objectToString$1 = objectToString$3;

var Symbol$9 = _Symbol$1,
    getRawTag$2 = _getRawTag$1,
    objectToString$2 = _objectToString$1;

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
    undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = Symbol$9 ? Symbol$9.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$d(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return (symToStringTag$2 && symToStringTag$2 in Object(value))
    ? getRawTag$2(value)
    : objectToString$2(value);
}

var _baseGetTag$1 = baseGetTag$d;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$g(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1$1 = isObject$g;

var baseGetTag$c = _baseGetTag$1,
    isObject$f = isObject_1$1;

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
    funcTag$5 = '[object Function]',
    genTag$3 = '[object GeneratorFunction]',
    proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$6(value) {
  if (!isObject$f(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$c(value);
  return tag == funcTag$5 || tag == genTag$3 || tag == asyncTag$1 || tag == proxyTag$1;
}

var isFunction_1$1 = isFunction$6;

var isFunction$7 = /*@__PURE__*/getDefaultExportFromCjs(isFunction_1$1);

var root$f = _root$1;

/** Used to detect overreaching core-js shims. */
var coreJsData$3 = root$f['__core-js_shared__'];

var _coreJsData$1 = coreJsData$3;

var coreJsData$2 = _coreJsData$1;

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = (function() {
  var uid = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$3(func) {
  return !!maskSrcKey$1 && (maskSrcKey$1 in func);
}

var _isMasked$1 = isMasked$3;

/** Used for built-in method references. */

var funcProto$4 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$4 = funcProto$4.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$5(func) {
  if (func != null) {
    try {
      return funcToString$4.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource$1 = toSource$5;

var isFunction$5 = isFunction_1$1,
    isMasked$2 = _isMasked$1,
    isObject$e = isObject_1$1,
    toSource$4 = _toSource$1;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$3 = Function.prototype,
    objectProto$q = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$3 = funcProto$3.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$n = objectProto$q.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' +
  funcToString$3.call(hasOwnProperty$n).replace(reRegExpChar$1, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$3(value) {
  if (!isObject$e(value) || isMasked$2(value)) {
    return false;
  }
  var pattern = isFunction$5(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$4(value));
}

var _baseIsNative$1 = baseIsNative$3;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$3(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue$1 = getValue$3;

var baseIsNative$2 = _baseIsNative$1,
    getValue$2 = _getValue$1;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$f(object, key) {
  var value = getValue$2(object, key);
  return baseIsNative$2(value) ? value : undefined;
}

var _getNative$1 = getNative$f;

var getNative$e = _getNative$1,
    root$e = _root$1;

/* Built-in method references that are verified to be native. */
var Map$8 = getNative$e(root$e, 'Map');

var _Map$1 = Map$8;

var getNative$d = _getNative$1;

/* Built-in method references that are verified to be native. */
var nativeCreate$9 = getNative$d(Object, 'create');

var _nativeCreate$1 = nativeCreate$9;

var nativeCreate$8 = _nativeCreate$1;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$3() {
  this.__data__ = nativeCreate$8 ? nativeCreate$8(null) : {};
  this.size = 0;
}

var _hashClear$1 = hashClear$3;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$3(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete$1 = hashDelete$3;

var nativeCreate$7 = _nativeCreate$1;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$p = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$m = objectProto$p.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$3(key) {
  var data = this.__data__;
  if (nativeCreate$7) {
    var result = data[key];
    return result === HASH_UNDEFINED$4 ? undefined : result;
  }
  return hasOwnProperty$m.call(data, key) ? data[key] : undefined;
}

var _hashGet$1 = hashGet$3;

var nativeCreate$6 = _nativeCreate$1;

/** Used for built-in method references. */
var objectProto$o = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$l = objectProto$o.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$3(key) {
  var data = this.__data__;
  return nativeCreate$6 ? (data[key] !== undefined) : hasOwnProperty$l.call(data, key);
}

var _hashHas$1 = hashHas$3;

var nativeCreate$5 = _nativeCreate$1;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$3(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate$5 && value === undefined) ? HASH_UNDEFINED$3 : value;
  return this;
}

var _hashSet$1 = hashSet$3;

var hashClear$2 = _hashClear$1,
    hashDelete$2 = _hashDelete$1,
    hashGet$2 = _hashGet$1,
    hashHas$2 = _hashHas$1,
    hashSet$2 = _hashSet$1;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$3.prototype.clear = hashClear$2;
Hash$3.prototype['delete'] = hashDelete$2;
Hash$3.prototype.get = hashGet$2;
Hash$3.prototype.has = hashHas$2;
Hash$3.prototype.set = hashSet$2;

var _Hash$1 = Hash$3;

var Hash$2 = _Hash$1,
    ListCache$7 = _ListCache$1,
    Map$7 = _Map$1;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$3() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$2,
    'map': new (Map$7 || ListCache$7),
    'string': new Hash$2
  };
}

var _mapCacheClear$1 = mapCacheClear$3;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$3(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable$1 = isKeyable$3;

var isKeyable$2 = _isKeyable$1;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$9(map, key) {
  var data = map.__data__;
  return isKeyable$2(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData$1 = getMapData$9;

var getMapData$8 = _getMapData$1;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$3(key) {
  var result = getMapData$8(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete$1 = mapCacheDelete$3;

var getMapData$7 = _getMapData$1;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$3(key) {
  return getMapData$7(this, key).get(key);
}

var _mapCacheGet$1 = mapCacheGet$3;

var getMapData$6 = _getMapData$1;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$3(key) {
  return getMapData$6(this, key).has(key);
}

var _mapCacheHas$1 = mapCacheHas$3;

var getMapData$5 = _getMapData$1;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$3(key, value) {
  var data = getMapData$5(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet$1 = mapCacheSet$3;

var mapCacheClear$2 = _mapCacheClear$1,
    mapCacheDelete$2 = _mapCacheDelete$1,
    mapCacheGet$2 = _mapCacheGet$1,
    mapCacheHas$2 = _mapCacheHas$1,
    mapCacheSet$2 = _mapCacheSet$1;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$5(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$5.prototype.clear = mapCacheClear$2;
MapCache$5.prototype['delete'] = mapCacheDelete$2;
MapCache$5.prototype.get = mapCacheGet$2;
MapCache$5.prototype.has = mapCacheHas$2;
MapCache$5.prototype.set = mapCacheSet$2;

var _MapCache$1 = MapCache$5;

var ListCache$6 = _ListCache$1,
    Map$6 = _Map$1,
    MapCache$4 = _MapCache$1;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$3 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$3(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$6) {
    var pairs = data.__data__;
    if (!Map$6 || (pairs.length < LARGE_ARRAY_SIZE$3 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$4(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet$1 = stackSet$3;

var ListCache$5 = _ListCache$1,
    stackClear$2 = _stackClear$1,
    stackDelete$2 = _stackDelete$1,
    stackGet$2 = _stackGet$1,
    stackHas$2 = _stackHas$1,
    stackSet$2 = _stackSet$1;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$6(entries) {
  var data = this.__data__ = new ListCache$5(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$6.prototype.clear = stackClear$2;
Stack$6.prototype['delete'] = stackDelete$2;
Stack$6.prototype.get = stackGet$2;
Stack$6.prototype.has = stackHas$2;
Stack$6.prototype.set = stackSet$2;

var _Stack$1 = Stack$6;

var getNative$c = _getNative$1;

var defineProperty$4 = (function() {
  try {
    var func = getNative$c(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$b = defineProperty$4;

var defineProperty$3 = _defineProperty$b;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$6(object, key, value) {
  if (key == '__proto__' && defineProperty$3) {
    defineProperty$3(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue$1 = baseAssignValue$6;

var baseAssignValue$5 = _baseAssignValue$1,
    eq$6 = eq_1$1;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue$2(object, key, value) {
  if ((value !== undefined && !eq$6(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$5(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue$2;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$2 = createBaseFor();

var _baseFor = baseFor$2;

var _cloneBuffer$1 = {exports: {}};

_cloneBuffer$1.exports;

(function (module, exports) {
	var root = _root$1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	module.exports = cloneBuffer; 
} (_cloneBuffer$1, _cloneBuffer$1.exports));

var _cloneBufferExports$1 = _cloneBuffer$1.exports;

var root$d = _root$1;

/** Built-in value references. */
var Uint8Array$5 = root$d.Uint8Array;

var _Uint8Array$1 = Uint8Array$5;

var Uint8Array$4 = _Uint8Array$1;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$7(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$4(result).set(new Uint8Array$4(arrayBuffer));
  return result;
}

var _cloneArrayBuffer$1 = cloneArrayBuffer$7;

var cloneArrayBuffer$6 = _cloneArrayBuffer$1;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$4(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$6(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray$1 = cloneTypedArray$4;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$4(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray$1 = copyArray$4;

var isObject$d = isObject_1$1;

/** Built-in value references. */
var objectCreate$1 = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$3 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$d(proto)) {
      return {};
    }
    if (objectCreate$1) {
      return objectCreate$1(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate$1 = baseCreate$3;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$5(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg$1 = overArg$5;

var overArg$4 = _overArg$1;

/** Built-in value references. */
var getPrototype$6 = overArg$4(Object.getPrototypeOf, Object);

var _getPrototype$1 = getPrototype$6;

/** Used for built-in method references. */

var objectProto$n = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$7(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$n;

  return value === proto;
}

var _isPrototype$1 = isPrototype$7;

var baseCreate$2 = _baseCreate$1,
    getPrototype$5 = _getPrototype$1,
    isPrototype$6 = _isPrototype$1;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$4(object) {
  return (typeof object.constructor == 'function' && !isPrototype$6(object))
    ? baseCreate$2(getPrototype$5(object))
    : {};
}

var _initCloneObject$1 = initCloneObject$4;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$h(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1$1 = isObjectLike$h;

var baseGetTag$b = _baseGetTag$1,
    isObjectLike$g = isObjectLike_1$1;

/** `Object#toString` result references. */
var argsTag$6 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$3(value) {
  return isObjectLike$g(value) && baseGetTag$b(value) == argsTag$6;
}

var _baseIsArguments$1 = baseIsArguments$3;

var baseIsArguments$2 = _baseIsArguments$1,
    isObjectLike$f = isObjectLike_1$1;

/** Used for built-in method references. */
var objectProto$m = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$k = objectProto$m.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$3 = objectProto$m.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$6 = baseIsArguments$2(function() { return arguments; }()) ? baseIsArguments$2 : function(value) {
  return isObjectLike$f(value) && hasOwnProperty$k.call(value, 'callee') &&
    !propertyIsEnumerable$3.call(value, 'callee');
};

var isArguments_1$1 = isArguments$6;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$j = Array.isArray;

var isArray_1$1 = isArray$j;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$3 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$6(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$3;
}

var isLength_1$1 = isLength$6;

var isFunction$4 = isFunction_1$1,
    isLength$5 = isLength_1$1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$9(value) {
  return value != null && isLength$5(value.length) && !isFunction$4(value);
}

var isArrayLike_1$1 = isArrayLike$9;

var isArrayLike$8 = isArrayLike_1$1,
    isObjectLike$e = isObjectLike_1$1;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject$2(value) {
  return isObjectLike$e(value) && isArrayLike$8(value);
}

var isArrayLikeObject_1 = isArrayLikeObject$2;

var isBuffer$7 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse$1() {
  return false;
}

var stubFalse_1$1 = stubFalse$1;

isBuffer$7.exports;

(function (module, exports) {
	var root = _root$1,
	    stubFalse = stubFalse_1$1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer; 
} (isBuffer$7, isBuffer$7.exports));

var isBufferExports$1 = isBuffer$7.exports;

var baseGetTag$a = _baseGetTag$1,
    getPrototype$4 = _getPrototype$1,
    isObjectLike$d = isObjectLike_1$1;

/** `Object#toString` result references. */
var objectTag$7 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$l = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$j = objectProto$l.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$2(value) {
  if (!isObjectLike$d(value) || baseGetTag$a(value) != objectTag$7) {
    return false;
  }
  var proto = getPrototype$4(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$j.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$2;

var isPlainObject$3 = /*@__PURE__*/getDefaultExportFromCjs(isPlainObject_1);

var baseGetTag$9 = _baseGetTag$1,
    isLength$4 = isLength_1$1,
    isObjectLike$c = isObjectLike_1$1;

/** `Object#toString` result references. */
var argsTag$5 = '[object Arguments]',
    arrayTag$4 = '[object Array]',
    boolTag$6 = '[object Boolean]',
    dateTag$6 = '[object Date]',
    errorTag$4 = '[object Error]',
    funcTag$4 = '[object Function]',
    mapTag$a = '[object Map]',
    numberTag$7 = '[object Number]',
    objectTag$6 = '[object Object]',
    regexpTag$6 = '[object RegExp]',
    setTag$a = '[object Set]',
    stringTag$7 = '[object String]',
    weakMapTag$5 = '[object WeakMap]';

var arrayBufferTag$6 = '[object ArrayBuffer]',
    dataViewTag$8 = '[object DataView]',
    float32Tag$5 = '[object Float32Array]',
    float64Tag$5 = '[object Float64Array]',
    int8Tag$5 = '[object Int8Array]',
    int16Tag$5 = '[object Int16Array]',
    int32Tag$5 = '[object Int32Array]',
    uint8Tag$5 = '[object Uint8Array]',
    uint8ClampedTag$5 = '[object Uint8ClampedArray]',
    uint16Tag$5 = '[object Uint16Array]',
    uint32Tag$5 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$5] = typedArrayTags$1[float64Tag$5] =
typedArrayTags$1[int8Tag$5] = typedArrayTags$1[int16Tag$5] =
typedArrayTags$1[int32Tag$5] = typedArrayTags$1[uint8Tag$5] =
typedArrayTags$1[uint8ClampedTag$5] = typedArrayTags$1[uint16Tag$5] =
typedArrayTags$1[uint32Tag$5] = true;
typedArrayTags$1[argsTag$5] = typedArrayTags$1[arrayTag$4] =
typedArrayTags$1[arrayBufferTag$6] = typedArrayTags$1[boolTag$6] =
typedArrayTags$1[dataViewTag$8] = typedArrayTags$1[dateTag$6] =
typedArrayTags$1[errorTag$4] = typedArrayTags$1[funcTag$4] =
typedArrayTags$1[mapTag$a] = typedArrayTags$1[numberTag$7] =
typedArrayTags$1[objectTag$6] = typedArrayTags$1[regexpTag$6] =
typedArrayTags$1[setTag$a] = typedArrayTags$1[stringTag$7] =
typedArrayTags$1[weakMapTag$5] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$3(value) {
  return isObjectLike$c(value) &&
    isLength$4(value.length) && !!typedArrayTags$1[baseGetTag$9(value)];
}

var _baseIsTypedArray$1 = baseIsTypedArray$3;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$9(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary$1 = baseUnary$9;

var _nodeUtil$1 = {exports: {}};

_nodeUtil$1.exports;

(function (module, exports) {
	var freeGlobal = _freeGlobal$1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil; 
} (_nodeUtil$1, _nodeUtil$1.exports));

var _nodeUtilExports$1 = _nodeUtil$1.exports;

var baseIsTypedArray$2 = _baseIsTypedArray$1,
    baseUnary$8 = _baseUnary$1,
    nodeUtil$6 = _nodeUtilExports$1;

/* Node.js helper references. */
var nodeIsTypedArray$1 = nodeUtil$6 && nodeUtil$6.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$5 = nodeIsTypedArray$1 ? baseUnary$8(nodeIsTypedArray$1) : baseIsTypedArray$2;

var isTypedArray_1$1 = isTypedArray$5;

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function safeGet$2(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet$2;

var baseAssignValue$4 = _baseAssignValue$1,
    eq$5 = eq_1$1;

/** Used for built-in method references. */
var objectProto$k = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$i = objectProto$k.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$6(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$i.call(object, key) && eq$5(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$4(object, key, value);
  }
}

var _assignValue$1 = assignValue$6;

var assignValue$5 = _assignValue$1,
    baseAssignValue$3 = _baseAssignValue$1;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$b(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue$3(object, key, newValue);
    } else {
      assignValue$5(object, key, newValue);
    }
  }
  return object;
}

var _copyObject$1 = copyObject$b;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$3(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes$1 = baseTimes$3;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$2 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$6(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$2 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint$1.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex$1 = isIndex$6;

var baseTimes$2 = _baseTimes$1,
    isArguments$5 = isArguments_1$1,
    isArray$i = isArray_1$1,
    isBuffer$6 = isBufferExports$1,
    isIndex$5 = _isIndex$1,
    isTypedArray$4 = isTypedArray_1$1;

/** Used for built-in method references. */
var objectProto$j = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$h = objectProto$j.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$5(value, inherited) {
  var isArr = isArray$i(value),
      isArg = !isArr && isArguments$5(value),
      isBuff = !isArr && !isArg && isBuffer$6(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$4(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes$2(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$h.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$5(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys$1 = arrayLikeKeys$5;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$3(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn$1 = nativeKeysIn$3;

var isObject$c = isObject_1$1,
    isPrototype$5 = _isPrototype$1,
    nativeKeysIn$2 = _nativeKeysIn$1;

/** Used for built-in method references. */
var objectProto$i = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$g = objectProto$i.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$3(object) {
  if (!isObject$c(object)) {
    return nativeKeysIn$2(object);
  }
  var isProto = isPrototype$5(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$g.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn$1 = baseKeysIn$3;

var arrayLikeKeys$4 = _arrayLikeKeys$1,
    baseKeysIn$2 = _baseKeysIn$1,
    isArrayLike$7 = isArrayLike_1$1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$9(object) {
  return isArrayLike$7(object) ? arrayLikeKeys$4(object, true) : baseKeysIn$2(object);
}

var keysIn_1$1 = keysIn$9;

var copyObject$a = _copyObject$1,
    keysIn$8 = keysIn_1$1;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject$1(value) {
  return copyObject$a(value, keysIn$8(value));
}

var toPlainObject_1 = toPlainObject$1;

var assignMergeValue$1 = _assignMergeValue,
    cloneBuffer$2 = _cloneBufferExports$1,
    cloneTypedArray$3 = _cloneTypedArray$1,
    copyArray$3 = _copyArray$1,
    initCloneObject$3 = _initCloneObject$1,
    isArguments$4 = isArguments_1$1,
    isArray$h = isArray_1$1,
    isArrayLikeObject$1 = isArrayLikeObject_1,
    isBuffer$5 = isBufferExports$1,
    isFunction$3 = isFunction_1$1,
    isObject$b = isObject_1$1,
    isPlainObject$1 = isPlainObject_1,
    isTypedArray$3 = isTypedArray_1$1,
    safeGet$1 = _safeGet,
    toPlainObject = toPlainObject_1;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep$1(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet$1(object, key),
      srcValue = safeGet$1(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue$1(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray$h(srcValue),
        isBuff = !isArr && isBuffer$5(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray$3(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$h(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject$1(objValue)) {
        newValue = copyArray$3(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer$2(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray$3(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject$1(srcValue) || isArguments$4(srcValue)) {
      newValue = objValue;
      if (isArguments$4(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject$b(objValue) || isFunction$3(objValue)) {
        newValue = initCloneObject$3(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue$1(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep$1;

var Stack$5 = _Stack$1,
    assignMergeValue = _assignMergeValue,
    baseFor$1 = _baseFor,
    baseMergeDeep = _baseMergeDeep,
    isObject$a = isObject_1$1,
    keysIn$7 = keysIn_1$1,
    safeGet = _safeGet;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge$1(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor$1(source, function(srcValue, key) {
    stack || (stack = new Stack$5);
    if (isObject$a(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge$1, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn$7);
}

var _baseMerge = baseMerge$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$8(value) {
  return value;
}

var identity_1 = identity$8;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$1;

var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$2(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$2;

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$3(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$3;

var constant$2 = constant_1,
    defineProperty$2 = _defineProperty$b,
    identity$7 = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty$2 ? identity$7 : function(func, string) {
  return defineProperty$2(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant$2(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString$1;

/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;

var baseSetToString = _baseSetToString,
    shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut(baseSetToString);

var _setToString = setToString$2;

var identity$6 = identity_1,
    overRest$1 = _overRest,
    setToString$1 = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$3(func, start) {
  return setToString$1(overRest$1(func, start, identity$6), func + '');
}

var _baseRest = baseRest$3;

var eq$4 = eq_1$1,
    isArrayLike$6 = isArrayLike_1$1,
    isIndex$4 = _isIndex$1,
    isObject$9 = isObject_1$1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$2(value, index, object) {
  if (!isObject$9(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike$6(object) && isIndex$4(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq$4(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall$2;

var baseRest$2 = _baseRest,
    isIterateeCall$1 = _isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner$1(assigner) {
  return baseRest$2(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall$1(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner$1;

var baseMerge = _baseMerge,
    createAssigner = _createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

var merge_1 = merge;

var merge$1 = /*@__PURE__*/getDefaultExportFromCjs(merge_1);

var baseGetTag$8 = _baseGetTag$1,
    isObjectLike$b = isObjectLike_1$1;

/** `Object#toString` result references. */
var symbolTag$5 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$4(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$b(value) && baseGetTag$8(value) == symbolTag$5);
}

var isSymbol_1 = isSymbol$4;

var isArray$g = isArray_1$1,
    isSymbol$3 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$g(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

var MapCache$3 = _MapCache$1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache$3);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache$3;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$4(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$4;

var Symbol$8 = _Symbol$1,
    arrayMap$3 = _arrayMap,
    isArray$f = isArray_1$1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = Symbol$8 ? Symbol$8.prototype : undefined,
    symbolToString = symbolProto$3 ? symbolProto$3.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$f(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$3(value, baseToString$1) + '';
  }
  if (isSymbol$2(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$2(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$2;

var isArray$e = isArray_1$1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString$1 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$6(value, object) {
  if (isArray$e(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString$1(value));
}

var _castPath = castPath$6;

var isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$6(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _toKey = toKey$6;

var castPath$5 = _castPath,
    toKey$5 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$5(object, path) {
  path = castPath$5(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$5(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$5;

var baseGet$4 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$4(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

var _get = /*@__PURE__*/getDefaultExportFromCjs(get_1);

var assignValue$4 = _assignValue$1,
    castPath$4 = _castPath,
    isIndex$3 = _isIndex$1,
    isObject$8 = isObject_1$1,
    toKey$4 = _toKey;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$2(object, path, value, customizer) {
  if (!isObject$8(object)) {
    return object;
  }
  path = castPath$4(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey$4(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$8(objValue)
          ? objValue
          : (isIndex$3(path[index + 1]) ? [] : {});
      }
    }
    assignValue$4(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet$2;

var baseSet$1 = _baseSet;

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet$1(object, path, value);
}

var set_1 = set;

var set$1 = /*@__PURE__*/getDefaultExportFromCjs(set_1);

function define(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
}

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}

function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex = /^#([0-9a-f]{3,8})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

define(Color, color, {
  copy: function(channels) {
    return Object.assign(new this.constructor, this, channels);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: color_formatHex, // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});

function color_formatHex() {
  return this.rgb().formatHex();
}

function color_formatHsl() {
  return hslConvert(this).formatHsl();
}

function color_formatRgb() {
  return this.rgb().formatRgb();
}

function color(format) {
  var m, l;
  format = (format + "").trim().toLowerCase();
  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
      : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
      : l === 4 ? rgba((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
      : null) // invalid hex
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb$1(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

define(Rgb, rgb$1, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (-0.5 <= this.r && this.r < 255.5)
        && (-0.5 <= this.g && this.g < 255.5)
        && (-0.5 <= this.b && this.b < 255.5)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));

function rgb_formatHex() {
  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
}

function rgb_formatRgb() {
  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
  return (a === 1 ? "rgb(" : "rgba(")
      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
      + (a === 1 ? ")" : ", " + a + ")");
}

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Hsl, hsl, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "hsl(" : "hsla(")
        + (this.h || 0) + ", "
        + (this.s || 0) * 100 + "%, "
        + (this.l || 0) * 100 + "%"
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}

const radians = Math.PI / 180;
const degrees = 180 / Math.PI;

var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * degrees - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix$1(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

define(Cubehelix, cubehelix$1, extend(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * radians,
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new Rgb(
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));

function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

function basis$1(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
}

var constant$1 = x => () => x;

function linear$1(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear$1(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant$1(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : constant$1(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear$1(a, d) : constant$1(isNaN(a) ? b : a);
}

var rgb = (function rgbGamma(y) {
  var color = gamma(y);

  function rgb(start, end) {
    var r = color((start = rgb$1(start)).r, (end = rgb$1(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1);

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = rgb$1(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(basis$1);

function numberArray(a, b) {
  if (!b) b = [];
  var n = a ? Math.min(b.length, a.length) : 0,
      c = b.slice(),
      i;
  return function(t) {
    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
    return c;
  };
}

function isNumberArray(x) {
  return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

function genericArray(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = interpolate(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
}

function date$1(a, b) {
  var d = new Date;
  return a = +a, b = +b, function(t) {
    return d.setTime(a * (1 - t) + b * t), d;
  };
}

function interpolateNumber(a, b) {
  return a = +a, b = +b, function(t) {
    return a * (1 - t) + b * t;
  };
}

function object(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = interpolate(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
}

var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

function interpolateString(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: interpolateNumber(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
}

function interpolate(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? constant$1(b)
      : (t === "number" ? interpolateNumber
      : t === "string" ? ((c = color(b)) ? (b = c, rgb) : interpolateString)
      : b instanceof color ? rgb
      : b instanceof Date ? date$1
      : isNumberArray(b) ? numberArray
      : Array.isArray(b) ? genericArray
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
      : interpolateNumber)(a, b);
}

function interpolateRound(a, b) {
  return a = +a, b = +b, function(t) {
    return Math.round(a * (1 - t) + b * t);
  };
}

function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = cubehelix$1(start)).h, (end = cubehelix$1(end)).h),
          s = nogamma(start.s, end.s),
          l = nogamma(start.l, end.l),
          opacity = nogamma(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

cubehelix(hue);
var cubehelixLong = cubehelix(nogamma);

var baseGetTag$7 = _baseGetTag$1,
    isArray$d = isArray_1$1,
    isObjectLike$a = isObjectLike_1$1;

/** `Object#toString` result references. */
var stringTag$6 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray$d(value) && isObjectLike$a(value) && baseGetTag$7(value) == stringTag$6);
}

var isString_1 = isString;

var _isString = /*@__PURE__*/getDefaultExportFromCjs(isString_1);

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last$1;

var last$2 = /*@__PURE__*/getDefaultExportFromCjs(last_1);

function ascending(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

function bisector(f) {
  let delta = f;
  let compare = f;

  if (f.length === 1) {
    delta = (d, x) => f(d) - x;
    compare = ascendingComparator(f);
  }

  function left(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) < 0) lo = mid + 1;
      else hi = mid;
    }
    return lo;
  }

  function right(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    while (lo < hi) {
      const mid = (lo + hi) >>> 1;
      if (compare(a[mid], x) > 0) hi = mid;
      else lo = mid + 1;
    }
    return lo;
  }

  function center(a, x, lo, hi) {
    if (lo == null) lo = 0;
    if (hi == null) hi = a.length;
    const i = left(a, x, lo, hi - 1);
    return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
  }

  return {left, center, right};
}

function ascendingComparator(f) {
  return (d, x) => ascending(f(d), x);
}

function number$2(x) {
  return x === null ? NaN : +x;
}

const ascendingBisect = bisector(ascending);
const bisectRight = ascendingBisect.right;
bisector(number$2).center;
var bisect = bisectRight;

var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

function ticks(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    let r0 = Math.round(start / step), r1 = Math.round(stop / step);
    if (r0 * step < start) ++r0;
    if (r1 * step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) * step;
  } else {
    step = -step;
    let r0 = Math.round(start * step), r1 = Math.round(stop * step);
    if (r0 / step < start) ++r0;
    if (r1 / step > stop) --r1;
    ticks = new Array(n = r1 - r0 + 1);
    while (++i < n) ticks[i] = (r0 + i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
}

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}

function sequence(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
}

function initRange(domain, range) {
  switch (arguments.length) {
    case 0: break;
    case 1: this.range(domain); break;
    default: this.range(range).domain(domain); break;
  }
  return this;
}

const implicit = Symbol("implicit");

function ordinal() {
  var index = new Map(),
      domain = [],
      range = [],
      unknown = implicit;

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = new Map();
    for (const value of _) {
      const key = value + "";
      if (index.has(key)) continue;
      index.set(key, domain.push(value));
    }
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal(domain, range).unknown(unknown);
  };

  initRange.apply(scale, arguments);

  return scale;
}

function band() {
  var scale = ordinal().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      r0 = 0,
      r1 = 1,
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = r1 < r0,
        start = reverse ? r1 : r0,
        stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = sequence(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };

  scale.rangeRound = function(_) {
    return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band(domain(), [r0, r1])
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return initRange.apply(rescale(), arguments);
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point$4() {
  return pointish(band.apply(null, arguments).paddingInner(1));
}

function constants$1(x) {
  return function() {
    return x;
  };
}

function number$1(x) {
  return +x;
}

var unit = [0, 1];

function identity$5(x) {
  return x;
}

function normalize(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : constants$1(isNaN(b) ? NaN : 0.5);
}

function clamper(a, b) {
  var t;
  if (a > b) t = a, a = b, b = t;
  return function(x) { return Math.max(a, Math.min(b, x)); };
}

// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
  else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, interpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = normalize(domain[i], domain[i + 1]);
    r[i] = interpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = bisect(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp())
      .unknown(source.unknown());
}

function transformer() {
  var domain = unit,
      range = unit,
      interpolate$1 = interpolate,
      transform,
      untransform,
      unknown,
      clamp = identity$5,
      piecewise,
      output,
      input;

  function rescale() {
    var n = Math.min(domain.length, range.length);
    if (clamp !== identity$5) clamp = clamper(domain[0], domain[n - 1]);
    piecewise = n > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate$1)))(transform(clamp(x)));
  }

  scale.invert = function(y) {
    return clamp(untransform((input || (input = piecewise(range, domain.map(transform), interpolateNumber)))(y)));
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = Array.from(_, number$1), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = Array.from(_), interpolate$1 = interpolateRound, rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = _ ? true : identity$5, rescale()) : clamp !== identity$5;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate$1 = _, rescale()) : interpolate$1;
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}

function continuous() {
  return transformer()(identity$5, identity$5);
}

function formatDecimal$1(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts$1(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent$1(x) {
  return x = formatDecimalParts$1(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup$1(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals$1(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re$1 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier$1(specifier) {
  if (!(match = re$1.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier$1({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier$1.prototype = FormatSpecifier$1.prototype; // instanceof

function FormatSpecifier$1(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier$1.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim$1(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent$1;

function formatPrefixAuto$1(x, p) {
  var d = formatDecimalParts$1(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent$1 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts$1(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded$1(x, p) {
  var d = formatDecimalParts$1(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes$1 = {
  "%": (x, p) => (x * 100).toFixed(p),
  "b": (x) => Math.round(x).toString(2),
  "c": (x) => x + "",
  "d": formatDecimal$1,
  "e": (x, p) => x.toExponential(p),
  "f": (x, p) => x.toFixed(p),
  "g": (x, p) => x.toPrecision(p),
  "o": (x) => Math.round(x).toString(8),
  "p": (x, p) => formatRounded$1(x * 100, p),
  "r": formatRounded$1,
  "s": formatPrefixAuto$1,
  "X": (x) => Math.round(x).toString(16).toUpperCase(),
  "x": (x) => Math.round(x).toString(16)
};

function identity$4(x) {
  return x;
}

var map$1 = Array.prototype.map,
    prefixes$1 = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

function formatLocale$5(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$4 : formatGroup$1(map$1.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity$4 : formatNumerals$1(map$1.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "−" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier$1(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes$1[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes$1[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim$1(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes$1[8 + prefixExponent$1 / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier$1(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes$1[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale$2U;
var format$2;
var formatPrefix;

defaultLocale$6({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale$6(definition) {
  locale$2U = formatLocale$5(definition);
  format$2 = locale$2U.format;
  formatPrefix = locale$2U.formatPrefix;
  return locale$2U;
}

function precisionFixed(step) {
  return Math.max(0, -exponent$1(Math.abs(step)));
}

function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent$1(value) / 3))) * 3 - exponent$1(Math.abs(step)));
}

function precisionRound(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, exponent$1(max) - exponent$1(step)) + 1;
}

function tickFormat(start, stop, count, specifier) {
  var step = tickStep(start, stop, count),
      precision;
  specifier = formatSpecifier$1(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format$2(specifier);
}

function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    var d = domain();
    return tickFormat(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain();
    var i0 = 0;
    var i1 = d.length - 1;
    var start = d[i0];
    var stop = d[i1];
    var prestep;
    var step;
    var maxIter = 10;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count);
      if (step === prestep) {
        d[i0] = start;
        d[i1] = stop;
        return domain(d);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = continuous();

  scale.copy = function() {
    return copy(scale, linear());
  };

  initRange.apply(scale, arguments);

  return linearish(scale);
}

function nice(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
}

function transformLog(x) {
  return Math.log(x);
}

function transformExp(x) {
  return Math.exp(x);
}

function transformLogn(x) {
  return -Math.log(-x);
}

function transformExpn(x) {
  return -Math.exp(-x);
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function loggish(transform) {
  var scale = transform(transformLog, transformExp),
      domain = scale.domain,
      base = 10,
      logs,
      pows;

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) {
      logs = reflect(logs), pows = reflect(pows);
      transform(transformLogn, transformExpn);
    } else {
      transform(transformLog, transformExp);
    }
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.floor(i), j = Math.ceil(j);
      if (u > 0) for (; i <= j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i <= j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
      if (z.length * 2 < n) z = ticks(u, v, n);
    } else {
      z = ticks(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = format$2(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(nice(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  return scale;
}

function log() {
  var scale = loggish(transformer()).domain([1, 10]);

  scale.copy = function() {
    return copy(scale, log()).base(scale.base());
  };

  initRange.apply(scale, arguments);

  return scale;
}

function transformSymlog(c) {
  return function(x) {
    return Math.sign(x) * Math.log1p(Math.abs(x / c));
  };
}

function transformSymexp(c) {
  return function(x) {
    return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
  };
}

function symlogish(transform) {
  var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));

  scale.constant = function(_) {
    return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
  };

  return linearish(scale);
}

function symlog() {
  var scale = symlogish(transformer());

  scale.copy = function() {
    return copy(scale, symlog()).constant(scale.constant());
  };

  return initRange.apply(scale, arguments);
}

var t0$2 = new Date,
    t1$2 = new Date;

function newInterval$2(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval$2(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0$2.setTime(+start), t1$2.setTime(+end);
      floori(t0$2), floori(t1$2);
      return Math.floor(count(t0$2, t1$2));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond$1 = newInterval$2(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond$1.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond$1;
  return newInterval$2(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

var millisecond$2 = millisecond$1;
millisecond$1.range;

const durationSecond$2 = 1000;
const durationMinute$2 = durationSecond$2 * 60;
const durationHour$2 = durationMinute$2 * 60;
const durationDay$2 = durationHour$2 * 24;
const durationWeek$2 = durationDay$2 * 7;
const durationMonth = durationDay$2 * 30;
const durationYear = durationDay$2 * 365;

var second$1 = newInterval$2(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * durationSecond$2);
}, function(start, end) {
  return (end - start) / durationSecond$2;
}, function(date) {
  return date.getUTCSeconds();
});

var utcSecond$1 = second$1;
second$1.range;

var minute$1 = newInterval$2(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond$2);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$2);
}, function(start, end) {
  return (end - start) / durationMinute$2;
}, function(date) {
  return date.getMinutes();
});

var timeMinute$1 = minute$1;
minute$1.range;

var hour$1 = newInterval$2(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond$2 - date.getMinutes() * durationMinute$2);
}, function(date, step) {
  date.setTime(+date + step * durationHour$2);
}, function(start, end) {
  return (end - start) / durationHour$2;
}, function(date) {
  return date.getHours();
});

var timeHour$1 = hour$1;
hour$1.range;

var day$2 = newInterval$2(
  date => date.setHours(0, 0, 0, 0),
  (date, step) => date.setDate(date.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$2) / durationDay$2,
  date => date.getDate() - 1
);

var timeDay$2 = day$2;
day$2.range;

function weekday$2(i) {
  return newInterval$2(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$2) / durationWeek$2;
  });
}

var sunday$2 = weekday$2(0);
var monday$2 = weekday$2(1);
var tuesday$2 = weekday$2(2);
var wednesday$2 = weekday$2(3);
var thursday$2 = weekday$2(4);
var friday$2 = weekday$2(5);
var saturday$2 = weekday$2(6);

sunday$2.range;
monday$2.range;
tuesday$2.range;
wednesday$2.range;
thursday$2.range;
friday$2.range;
saturday$2.range;

var month$1 = newInterval$2(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var timeMonth$1 = month$1;
month$1.range;

var year$2 = newInterval$2(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year$2.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval$2(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var timeYear$2 = year$2;
year$2.range;

var utcMinute$2 = newInterval$2(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute$2);
}, function(start, end) {
  return (end - start) / durationMinute$2;
}, function(date) {
  return date.getUTCMinutes();
});

var utcMinute$3 = utcMinute$2;
utcMinute$2.range;

var utcHour$2 = newInterval$2(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour$2);
}, function(start, end) {
  return (end - start) / durationHour$2;
}, function(date) {
  return date.getUTCHours();
});

var utcHour$3 = utcHour$2;
utcHour$2.range;

var utcDay$4 = newInterval$2(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay$2;
}, function(date) {
  return date.getUTCDate() - 1;
});

var utcDay$5 = utcDay$4;
utcDay$4.range;

function utcWeekday$2(i) {
  return newInterval$2(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek$2;
  });
}

var utcSunday$2 = utcWeekday$2(0);
var utcMonday$2 = utcWeekday$2(1);
var utcTuesday$2 = utcWeekday$2(2);
var utcWednesday$2 = utcWeekday$2(3);
var utcThursday$2 = utcWeekday$2(4);
var utcFriday$2 = utcWeekday$2(5);
var utcSaturday$2 = utcWeekday$2(6);

utcSunday$2.range;
utcMonday$2.range;
utcTuesday$2.range;
utcWednesday$2.range;
utcThursday$2.range;
utcFriday$2.range;
utcSaturday$2.range;

var utcMonth$2 = newInterval$2(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

var utcMonth$3 = utcMonth$2;
utcMonth$2.range;

var utcYear$4 = newInterval$2(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear$4.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval$2(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

var utcYear$5 = utcYear$4;
utcYear$4.range;

function ticker(year, month, week, day, hour, minute) {

  const tickIntervals = [
    [utcSecond$1,  1,      durationSecond$2],
    [utcSecond$1,  5,  5 * durationSecond$2],
    [utcSecond$1, 15, 15 * durationSecond$2],
    [utcSecond$1, 30, 30 * durationSecond$2],
    [minute,  1,      durationMinute$2],
    [minute,  5,  5 * durationMinute$2],
    [minute, 15, 15 * durationMinute$2],
    [minute, 30, 30 * durationMinute$2],
    [  hour,  1,      durationHour$2  ],
    [  hour,  3,  3 * durationHour$2  ],
    [  hour,  6,  6 * durationHour$2  ],
    [  hour, 12, 12 * durationHour$2  ],
    [   day,  1,      durationDay$2   ],
    [   day,  2,  2 * durationDay$2   ],
    [  week,  1,      durationWeek$2  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function ticks(start, stop, count) {
    const reverse = stop < start;
    if (reverse) [start, stop] = [stop, start];
    const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
    const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
    return reverse ? ticks.reverse() : ticks;
  }

  function tickInterval(start, stop, count) {
    const target = Math.abs(stop - start) / count;
    const i = bisector(([,, step]) => step).right(tickIntervals, target);
    if (i === tickIntervals.length) return year.every(tickStep(start / durationYear, stop / durationYear, count));
    if (i === 0) return millisecond$2.every(Math.max(tickStep(start, stop, count), 1));
    const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
    return t.every(step);
  }

  return [ticks, tickInterval];
}

const [utcTicks, utcTickInterval] = ticker(utcYear$5, utcMonth$3, utcSunday$2, utcDay$5, utcHour$3, utcMinute$3);
const [timeTicks, timeTickInterval] = ticker(timeYear$2, timeMonth$1, sunday$2, timeDay$2, timeHour$1, timeMinute$1);

var t0$1 = new Date,
    t1$1 = new Date;

function newInterval$1(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval$1(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0$1.setTime(+start), t1$1.setTime(+end);
      floori(t0$1), floori(t1$1);
      return Math.floor(count(t0$1, t1$1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

const durationSecond$1 = 1000;
const durationMinute$1 = durationSecond$1 * 60;
const durationHour$1 = durationMinute$1 * 60;
const durationDay$1 = durationHour$1 * 24;
const durationWeek$1 = durationDay$1 * 7;

var day$1 = newInterval$1(
  date => date.setHours(0, 0, 0, 0),
  (date, step) => date.setDate(date.getDate() + step),
  (start, end) => (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationDay$1,
  date => date.getDate() - 1
);

var timeDay$1 = day$1;
day$1.range;

function weekday$1(i) {
  return newInterval$1(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute$1) / durationWeek$1;
  });
}

var sunday$1 = weekday$1(0);
var monday$1 = weekday$1(1);
var tuesday$1 = weekday$1(2);
var wednesday$1 = weekday$1(3);
var thursday$1 = weekday$1(4);
var friday$1 = weekday$1(5);
var saturday$1 = weekday$1(6);

sunday$1.range;
monday$1.range;
tuesday$1.range;
wednesday$1.range;
thursday$1.range;
friday$1.range;
saturday$1.range;

var year$1 = newInterval$1(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year$1.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval$1(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var timeYear$1 = year$1;
year$1.range;

var utcDay$2 = newInterval$1(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay$1;
}, function(date) {
  return date.getUTCDate() - 1;
});

var utcDay$3 = utcDay$2;
utcDay$2.range;

function utcWeekday$1(i) {
  return newInterval$1(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek$1;
  });
}

var utcSunday$1 = utcWeekday$1(0);
var utcMonday$1 = utcWeekday$1(1);
var utcTuesday$1 = utcWeekday$1(2);
var utcWednesday$1 = utcWeekday$1(3);
var utcThursday$1 = utcWeekday$1(4);
var utcFriday$1 = utcWeekday$1(5);
var utcSaturday$1 = utcWeekday$1(6);

utcSunday$1.range;
utcMonday$1.range;
utcTuesday$1.range;
utcWednesday$1.range;
utcThursday$1.range;
utcFriday$1.range;
utcSaturday$1.range;

var utcYear$2 = newInterval$1(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear$2.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval$1(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

var utcYear$3 = utcYear$2;
utcYear$2.range;

function localDate$3(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate$3(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate$3(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale$4(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe$3(locale_periods),
      periodLookup = formatLookup$3(locale_periods),
      weekdayRe = formatRe$3(locale_weekdays),
      weekdayLookup = formatLookup$3(locale_weekdays),
      shortWeekdayRe = formatRe$3(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup$3(locale_shortWeekdays),
      monthRe = formatRe$3(locale_months),
      monthLookup = formatLookup$3(locale_months),
      shortMonthRe = formatRe$3(locale_shortMonths),
      shortMonthLookup = formatLookup$3(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth$3,
    "e": formatDayOfMonth$3,
    "f": formatMicroseconds$3,
    "g": formatYearISO$3,
    "G": formatFullYearISO$3,
    "H": formatHour24$3,
    "I": formatHour12$3,
    "j": formatDayOfYear$3,
    "L": formatMilliseconds$3,
    "m": formatMonthNumber$3,
    "M": formatMinutes$3,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp$3,
    "s": formatUnixTimestampSeconds$3,
    "S": formatSeconds$3,
    "u": formatWeekdayNumberMonday$3,
    "U": formatWeekNumberSunday$3,
    "V": formatWeekNumberISO$3,
    "w": formatWeekdayNumberSunday$3,
    "W": formatWeekNumberMonday$3,
    "x": null,
    "X": null,
    "y": formatYear$3,
    "Y": formatFullYear$3,
    "Z": formatZone$3,
    "%": formatLiteralPercent$3
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth$3,
    "e": formatUTCDayOfMonth$3,
    "f": formatUTCMicroseconds$3,
    "g": formatUTCYearISO$3,
    "G": formatUTCFullYearISO$3,
    "H": formatUTCHour24$3,
    "I": formatUTCHour12$3,
    "j": formatUTCDayOfYear$3,
    "L": formatUTCMilliseconds$3,
    "m": formatUTCMonthNumber$3,
    "M": formatUTCMinutes$3,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp$3,
    "s": formatUnixTimestampSeconds$3,
    "S": formatUTCSeconds$3,
    "u": formatUTCWeekdayNumberMonday$3,
    "U": formatUTCWeekNumberSunday$3,
    "V": formatUTCWeekNumberISO$3,
    "w": formatUTCWeekdayNumberSunday$3,
    "W": formatUTCWeekNumberMonday$3,
    "x": null,
    "X": null,
    "y": formatUTCYear$3,
    "Y": formatUTCFullYear$3,
    "Z": formatUTCZone$3,
    "%": formatLiteralPercent$3
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth$3,
    "e": parseDayOfMonth$3,
    "f": parseMicroseconds$3,
    "g": parseYear$4,
    "G": parseFullYear$3,
    "H": parseHour24$3,
    "I": parseHour24$3,
    "j": parseDayOfYear$3,
    "L": parseMilliseconds$3,
    "m": parseMonthNumber$3,
    "M": parseMinutes$3,
    "p": parsePeriod,
    "q": parseQuarter$3,
    "Q": parseUnixTimestamp$3,
    "s": parseUnixTimestampSeconds$3,
    "S": parseSeconds$3,
    "u": parseWeekdayNumberMonday$3,
    "U": parseWeekNumberSunday$3,
    "V": parseWeekNumberISO$3,
    "w": parseWeekdayNumberSunday$3,
    "W": parseWeekNumberMonday$3,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear$4,
    "Y": parseFullYear$3,
    "Z": parseZone$3,
    "%": parseLiteralPercent$3
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads$3[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate$3(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate$3(newDate$3(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday$1.ceil(week) : utcMonday$1(week);
          week = utcDay$3.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate$3(newDate$3(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? monday$1.ceil(week) : monday$1(week);
          week = timeDay$1.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate$3(newDate$3(d.y, 0, 1)).getUTCDay() : localDate$3(newDate$3(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate$3(d);
      }

      // Otherwise, all fields are in local time.
      return localDate$3(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads$3 ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads$3 = {"-": "", "_": " ", "0": "0"},
    numberRe$3 = /^\s*\d+/, // note: ignores next directive
    percentRe$3 = /^%/,
    requoteRe$3 = /[\\^$*+?|[\]().{}]/g;

function pad$3(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote$3(s) {
  return s.replace(requoteRe$3, "\\$&");
}

function formatRe$3(names) {
  return new RegExp("^(?:" + names.map(requote$3).join("|") + ")", "i");
}

function formatLookup$3(names) {
  return new Map(names.map((name, i) => [name.toLowerCase(), i]));
}

function parseWeekdayNumberSunday$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear$4(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone$3(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent$3(d, string, i) {
  var n = percentRe$3.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds$3(d, string, i) {
  var n = numberRe$3.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth$3(d, p) {
  return pad$3(d.getDate(), p, 2);
}

function formatHour24$3(d, p) {
  return pad$3(d.getHours(), p, 2);
}

function formatHour12$3(d, p) {
  return pad$3(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear$3(d, p) {
  return pad$3(1 + timeDay$1.count(timeYear$1(d), d), p, 3);
}

function formatMilliseconds$3(d, p) {
  return pad$3(d.getMilliseconds(), p, 3);
}

function formatMicroseconds$3(d, p) {
  return formatMilliseconds$3(d, p) + "000";
}

function formatMonthNumber$3(d, p) {
  return pad$3(d.getMonth() + 1, p, 2);
}

function formatMinutes$3(d, p) {
  return pad$3(d.getMinutes(), p, 2);
}

function formatSeconds$3(d, p) {
  return pad$3(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday$3(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday$3(d, p) {
  return pad$3(sunday$1.count(timeYear$1(d) - 1, d), p, 2);
}

function dISO$3(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? thursday$1(d) : thursday$1.ceil(d);
}

function formatWeekNumberISO$3(d, p) {
  d = dISO$3(d);
  return pad$3(thursday$1.count(timeYear$1(d), d) + (timeYear$1(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday$3(d) {
  return d.getDay();
}

function formatWeekNumberMonday$3(d, p) {
  return pad$3(monday$1.count(timeYear$1(d) - 1, d), p, 2);
}

function formatYear$3(d, p) {
  return pad$3(d.getFullYear() % 100, p, 2);
}

function formatYearISO$3(d, p) {
  d = dISO$3(d);
  return pad$3(d.getFullYear() % 100, p, 2);
}

function formatFullYear$3(d, p) {
  return pad$3(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO$3(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? thursday$1(d) : thursday$1.ceil(d);
  return pad$3(d.getFullYear() % 10000, p, 4);
}

function formatZone$3(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad$3(z / 60 | 0, "0", 2)
      + pad$3(z % 60, "0", 2);
}

function formatUTCDayOfMonth$3(d, p) {
  return pad$3(d.getUTCDate(), p, 2);
}

function formatUTCHour24$3(d, p) {
  return pad$3(d.getUTCHours(), p, 2);
}

function formatUTCHour12$3(d, p) {
  return pad$3(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear$3(d, p) {
  return pad$3(1 + utcDay$3.count(utcYear$3(d), d), p, 3);
}

function formatUTCMilliseconds$3(d, p) {
  return pad$3(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds$3(d, p) {
  return formatUTCMilliseconds$3(d, p) + "000";
}

function formatUTCMonthNumber$3(d, p) {
  return pad$3(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes$3(d, p) {
  return pad$3(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds$3(d, p) {
  return pad$3(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday$3(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday$3(d, p) {
  return pad$3(utcSunday$1.count(utcYear$3(d) - 1, d), p, 2);
}

function UTCdISO$3(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday$1(d) : utcThursday$1.ceil(d);
}

function formatUTCWeekNumberISO$3(d, p) {
  d = UTCdISO$3(d);
  return pad$3(utcThursday$1.count(utcYear$3(d), d) + (utcYear$3(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday$3(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday$3(d, p) {
  return pad$3(utcMonday$1.count(utcYear$3(d) - 1, d), p, 2);
}

function formatUTCYear$3(d, p) {
  return pad$3(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO$3(d, p) {
  d = UTCdISO$3(d);
  return pad$3(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear$3(d, p) {
  return pad$3(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO$3(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday$1(d) : utcThursday$1.ceil(d);
  return pad$3(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone$3() {
  return "+0000";
}

function formatLiteralPercent$3() {
  return "%";
}

function formatUnixTimestamp$3(d) {
  return +d;
}

function formatUnixTimestampSeconds$3(d) {
  return Math.floor(+d / 1000);
}

var locale$2T;
var timeFormat$2;
var utcFormat;

defaultLocale$5({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$5(definition) {
  locale$2T = formatLocale$4(definition);
  timeFormat$2 = locale$2T.format;
  locale$2T.parse;
  utcFormat = locale$2T.utcFormat;
  locale$2T.utcParse;
  return locale$2T;
}

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
  var scale = continuous(),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval) {
    var d = domain();
    return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval) {
    var d = domain();
    if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
    return interval ? domain(nice(d, interval)) : scale;
  };

  scale.copy = function() {
    return copy(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
  };

  return scale;
}

function time() {
  return initRange.apply(calendar(timeTicks, timeTickInterval, timeYear$2, timeMonth$1, sunday$2, timeDay$2, timeHour$1, timeMinute$1, utcSecond$1, timeFormat$2).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]), arguments);
}

function utcTime() {
  return initRange.apply(calendar(utcTicks, utcTickInterval, utcYear$5, utcMonth$3, utcSunday$2, utcDay$5, utcHour$3, utcMinute$3, utcSecond$1, utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]), arguments);
}

function colors(specifier) {
  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
  return colors;
}

var schemeCategory10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");

var schemeAccent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");

var schemeDark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");

var schemePaired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");

var schemePastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");

var schemePastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");

var schemeSet1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");

var schemeSet2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");

var schemeSet3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");

var ramp$1 = scheme => rgbBasis(scheme[scheme.length - 1]);

var scheme$q = new Array(3).concat(
  "d8b365f5f5f55ab4ac",
  "a6611adfc27d80cdc1018571",
  "a6611adfc27df5f5f580cdc1018571",
  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
).map(colors);

var interpolateBrBG = ramp$1(scheme$q);

var scheme$p = new Array(3).concat(
  "af8dc3f7f7f77fbf7b",
  "7b3294c2a5cfa6dba0008837",
  "7b3294c2a5cff7f7f7a6dba0008837",
  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
).map(colors);

var interpolatePRGn = ramp$1(scheme$p);

var scheme$o = new Array(3).concat(
  "e9a3c9f7f7f7a1d76a",
  "d01c8bf1b6dab8e1864dac26",
  "d01c8bf1b6daf7f7f7b8e1864dac26",
  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
).map(colors);

var interpolatePiYG = ramp$1(scheme$o);

var scheme$n = new Array(3).concat(
  "998ec3f7f7f7f1a340",
  "5e3c99b2abd2fdb863e66101",
  "5e3c99b2abd2f7f7f7fdb863e66101",
  "542788998ec3d8daebfee0b6f1a340b35806",
  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
).map(colors);

var interpolatePuOr = ramp$1(scheme$n);

var scheme$m = new Array(3).concat(
  "ef8a62f7f7f767a9cf",
  "ca0020f4a58292c5de0571b0",
  "ca0020f4a582f7f7f792c5de0571b0",
  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
).map(colors);

var interpolateRdBu = ramp$1(scheme$m);

var scheme$l = new Array(3).concat(
  "ef8a62ffffff999999",
  "ca0020f4a582bababa404040",
  "ca0020f4a582ffffffbababa404040",
  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
).map(colors);

var interpolateRdGy = ramp$1(scheme$l);

var scheme$k = new Array(3).concat(
  "fc8d59ffffbf91bfdb",
  "d7191cfdae61abd9e92c7bb6",
  "d7191cfdae61ffffbfabd9e92c7bb6",
  "d73027fc8d59fee090e0f3f891bfdb4575b4",
  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
).map(colors);

var interpolateRdYlBu = ramp$1(scheme$k);

var scheme$j = new Array(3).concat(
  "fc8d59ffffbf91cf60",
  "d7191cfdae61a6d96a1a9641",
  "d7191cfdae61ffffbfa6d96a1a9641",
  "d73027fc8d59fee08bd9ef8b91cf601a9850",
  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
).map(colors);

var interpolateRdYlGn = ramp$1(scheme$j);

var scheme$i = new Array(3).concat(
  "fc8d59ffffbf99d594",
  "d7191cfdae61abdda42b83ba",
  "d7191cfdae61ffffbfabdda42b83ba",
  "d53e4ffc8d59fee08be6f59899d5943288bd",
  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
).map(colors);

var interpolateSpectral = ramp$1(scheme$i);

var scheme$h = new Array(3).concat(
  "e5f5f999d8c92ca25f",
  "edf8fbb2e2e266c2a4238b45",
  "edf8fbb2e2e266c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a42ca25f006d2c",
  "edf8fbccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
).map(colors);

var interpolateBuGn = ramp$1(scheme$h);

var scheme$g = new Array(3).concat(
  "e0ecf49ebcda8856a7",
  "edf8fbb3cde38c96c688419d",
  "edf8fbb3cde38c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
).map(colors);

var interpolateBuPu = ramp$1(scheme$g);

var scheme$f = new Array(3).concat(
  "e0f3dba8ddb543a2ca",
  "f0f9e8bae4bc7bccc42b8cbe",
  "f0f9e8bae4bc7bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
).map(colors);

var interpolateGnBu = ramp$1(scheme$f);

var scheme$e = new Array(3).concat(
  "fee8c8fdbb84e34a33",
  "fef0d9fdcc8afc8d59d7301f",
  "fef0d9fdcc8afc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
).map(colors);

var interpolateOrRd = ramp$1(scheme$e);

var scheme$d = new Array(3).concat(
  "ece2f0a6bddb1c9099",
  "f6eff7bdc9e167a9cf02818a",
  "f6eff7bdc9e167a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
).map(colors);

var interpolatePuBuGn = ramp$1(scheme$d);

var scheme$c = new Array(3).concat(
  "ece7f2a6bddb2b8cbe",
  "f1eef6bdc9e174a9cf0570b0",
  "f1eef6bdc9e174a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
).map(colors);

var interpolatePuBu = ramp$1(scheme$c);

var scheme$b = new Array(3).concat(
  "e7e1efc994c7dd1c77",
  "f1eef6d7b5d8df65b0ce1256",
  "f1eef6d7b5d8df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0dd1c77980043",
  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
).map(colors);

var interpolatePuRd = ramp$1(scheme$b);

var scheme$a = new Array(3).concat(
  "fde0ddfa9fb5c51b8a",
  "feebe2fbb4b9f768a1ae017e",
  "feebe2fbb4b9f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
).map(colors);

var interpolateRdPu = ramp$1(scheme$a);

var scheme$9 = new Array(3).concat(
  "edf8b17fcdbb2c7fb8",
  "ffffcca1dab441b6c4225ea8",
  "ffffcca1dab441b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
).map(colors);

var interpolateYlGnBu = ramp$1(scheme$9);

var scheme$8 = new Array(3).concat(
  "f7fcb9addd8e31a354",
  "ffffccc2e69978c679238443",
  "ffffccc2e69978c67931a354006837",
  "ffffccd9f0a3addd8e78c67931a354006837",
  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
).map(colors);

var interpolateYlGn = ramp$1(scheme$8);

var scheme$7 = new Array(3).concat(
  "fff7bcfec44fd95f0e",
  "ffffd4fed98efe9929cc4c02",
  "ffffd4fed98efe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929d95f0e993404",
  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
).map(colors);

var interpolateYlOrBr = ramp$1(scheme$7);

var scheme$6 = new Array(3).concat(
  "ffeda0feb24cf03b20",
  "ffffb2fecc5cfd8d3ce31a1c",
  "ffffb2fecc5cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
).map(colors);

var interpolateYlOrRd = ramp$1(scheme$6);

var scheme$5 = new Array(3).concat(
  "deebf79ecae13182bd",
  "eff3ffbdd7e76baed62171b5",
  "eff3ffbdd7e76baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed63182bd08519c",
  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
).map(colors);

var interpolateBlues = ramp$1(scheme$5);

var scheme$4 = new Array(3).concat(
  "e5f5e0a1d99b31a354",
  "edf8e9bae4b374c476238b45",
  "edf8e9bae4b374c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
).map(colors);

var interpolateGreens = ramp$1(scheme$4);

var scheme$3 = new Array(3).concat(
  "f0f0f0bdbdbd636363",
  "f7f7f7cccccc969696525252",
  "f7f7f7cccccc969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696636363252525",
  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
).map(colors);

var interpolateGreys = ramp$1(scheme$3);

var scheme$2 = new Array(3).concat(
  "efedf5bcbddc756bb1",
  "f2f0f7cbc9e29e9ac86a51a3",
  "f2f0f7cbc9e29e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
).map(colors);

var interpolatePurples = ramp$1(scheme$2);

var scheme$1 = new Array(3).concat(
  "fee0d2fc9272de2d26",
  "fee5d9fcae91fb6a4acb181d",
  "fee5d9fcae91fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
).map(colors);

var interpolateReds = ramp$1(scheme$1);

var scheme = new Array(3).concat(
  "fee6cefdae6be6550d",
  "feeddefdbe85fd8d3cd94701",
  "feeddefdbe85fd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
).map(colors);

var interpolateOranges = ramp$1(scheme);

function interpolateCividis(t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb("
      + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67)))))))
      + ")";
}

var interpolateCubehelixDefault = cubehelixLong(cubehelix$1(300, 0.5, 0.0), cubehelix$1(-240, 0.5, 1.0));

var warm = cubehelixLong(cubehelix$1(-100, 0.75, 0.35), cubehelix$1(80, 1.50, 0.8));

var cool = cubehelixLong(cubehelix$1(260, 0.75, 0.35), cubehelix$1(80, 1.50, 0.8));

var c$1 = cubehelix$1();

function interpolateRainbow(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  c$1.h = 360 * t - 100;
  c$1.s = 1.5 - 1.5 * ts;
  c$1.l = 0.8 - 0.9 * ts;
  return c$1 + "";
}

var c = rgb$1(),
    pi_1_3 = Math.PI / 3,
    pi_2_3 = Math.PI * 2 / 3;

function interpolateSinebow(t) {
  var x;
  t = (0.5 - t) * Math.PI;
  c.r = 255 * (x = Math.sin(t)) * x;
  c.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
  c.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
  return c + "";
}

function interpolateTurbo(t) {
  t = Math.max(0, Math.min(1, t));
  return "rgb("
      + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", "
      + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66)))))))
      + ")";
}

function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

var interpolateViridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));

var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache$2 = _MapCache$1,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$3(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$2;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$3.prototype.add = SetCache$3.prototype.push = setCacheAdd;
SetCache$3.prototype.has = setCacheHas;

var _SetCache = SetCache$3;

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$1(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$1;

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;

var baseFindIndex = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$1(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$1;

var baseIndexOf = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$3(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes$3;

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludesWith$2(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith$2;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$3(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$3;

var SetCache$2 = _SetCache,
    arrayIncludes$2 = _arrayIncludes,
    arrayIncludesWith$1 = _arrayIncludesWith,
    arrayMap$2 = _arrayMap,
    baseUnary$7 = _baseUnary$1,
    cacheHas$2 = _cacheHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$2 = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference$1(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes$2,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap$2(values, baseUnary$7(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith$1;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE$2) {
    includes = cacheHas$2;
    isCommon = false;
    values = new SetCache$2(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

var _baseDifference = baseDifference$1;

var baseDifference = _baseDifference,
    baseRest$1 = _baseRest,
    isArrayLikeObject = isArrayLikeObject_1;

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest$1(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

var without_1 = without;

var without$1 = /*@__PURE__*/getDefaultExportFromCjs(without_1);

var pi$1 = Math.PI,
    tau$1 = 2 * pi$1,
    epsilon$1 = 1e-6,
    tauEpsilon = tau$1 - epsilon$1;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon$1));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi$1 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r, ccw = !!ccw;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau$1 + tau$1;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon$1) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi$1)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

function constant(x) {
  return function constant() {
    return x;
  };
}

var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = y32 * x10 - x32 * y10;
  if (t * t < epsilon) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

function arc() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = constant(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - halfPi,
        a1 = endAngle.apply(this, arguments) - halfPi,
        da = abs(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = path();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > epsilon)) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > tau - epsilon) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)),
          rc = min(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > epsilon) {
        var p0 = asin(rp / r0 * sin(ap)),
            p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * cos(a01),
          y01 = r1 * sin(a01),
          x10 = r0 * cos(a10),
          y10 = r0 * sin(a10);

      // Apply rounded corners?
      if (rc > epsilon) {
        var x11 = r1 * cos(a11),
            y11 = r1 * sin(a11),
            x00 = r0 * cos(a00),
            y00 = r0 * sin(a00),
            oc;

        // Restrict the corner radius according to the sector angle.
        if (da < pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
          var ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2),
              lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = min(rc, (r0 - lc) / (kc - 1));
          rc1 = min(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > epsilon)) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos(a) * r, sin(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
}

function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

function curveLinear(context) {
  return new Linear(context);
}

function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}

function line() {
  var x$1 = x,
      y$1 = y,
      defined = constant(true),
      context = null,
      curve = curveLinear,
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = path());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x$1(d, i, data), +y$1(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x$1 = typeof _ === "function" ? _ : constant(+_), line) : x$1;
  };

  line.y = function(_) {
    return arguments.length ? (y$1 = typeof _ === "function" ? _ : constant(+_), line) : y$1;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
}

function descending(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

function identity$3(d) {
  return d;
}

function pie() {
  var value = identity$3,
      sortValues = descending,
      sort = null,
      startAngle = constant(0),
      endAngle = constant(tau),
      padAngle = constant(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant(+_), pie) : padAngle;
  };

  return pie;
}

var slice$1 = Array.prototype.slice;

function noop$4() {}

function point$3(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point$3(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function curveBasis(context) {
  return new Basis(context);
}

function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: noop$4,
  areaEnd: noop$4,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function curveBasisClosed(context) {
  return new BasisClosed(context);
}

function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: point$3(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

function curveBasisOpen(context) {
  return new BasisOpen(context);
}

function Bundle(context, beta) {
  this._basis = new Basis(context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

var curveBundle = (function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85);

function point$2(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point$2(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var curveCardinal = (function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: noop$4,
  areaEnd: noop$4,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var curveCardinalClosed = (function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$2(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var curveCardinalOpen = (function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0);

function point$1(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > epsilon) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > epsilon) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point$1(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var curveCatmullRom = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: noop$4,
  areaEnd: noop$4,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: point$1(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var curveCatmullRomClosed = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: point$1(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

var curveCatmullRomOpen = (function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5);

function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: noop$4,
  areaEnd: noop$4,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

function curveLinearClosed(context) {
  return new LinearClosed(context);
}

function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
};

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}

function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

function curveNatural(context) {
  return new Natural(context);
}

function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

function curveStep(context) {
  return new Step(context, 0.5);
}

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}

function stackOffsetNone(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
}

function stackOrderNone(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
}

function stackValue(d, key) {
  return d[key];
}

function stack() {
  var keys = constant([]),
      order = stackOrderNone,
      offset = stackOffsetNone,
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : constant(slice$1.call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : constant(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? stackOrderNone : typeof _ === "function" ? _ : constant(slice$1.call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? stackOffsetNone : _, stack) : offset;
  };

  return stack;
}

function stackOffsetExpand(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  stackOffsetNone(series, order);
}

function stackOffsetDiverging(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = 0, d[1] = dy;
      }
    }
  }
}

function stackOffsetSilhouette(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  stackOffsetNone(series, order);
}

function stackOffsetWiggle(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  stackOffsetNone(series, order);
}

function appearance(series) {
  var peaks = series.map(peak);
  return stackOrderNone(series).sort(function(a, b) { return peaks[a] - peaks[b]; });
}

function peak(series) {
  var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
  while (++i < n) if ((vi = +series[i][1]) > vj) vj = vi, j = i;
  return j;
}

function stackOrderAscending(series) {
  var sums = series.map(sum);
  return stackOrderNone(series).sort(function(a, b) { return sums[a] - sums[b]; });
}

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}

function stackOrderDescending(series) {
  return stackOrderAscending(series).reverse();
}

function stackOrderInsideOut(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(sum),
      order = appearance(series),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
}

function stackOrderReverse(series) {
  return stackOrderNone(series).reverse();
}

function treemapDice(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (x1 - x0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k;
  }
}

function treemapSlice(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      node,
      i = -1,
      n = nodes.length,
      k = parent.value && (y1 - y0) / parent.value;

  while (++i < n) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k;
  }
}

var phi = (1 + Math.sqrt(5)) / 2;

function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [],
      nodes = parent.children,
      row,
      nodeValue,
      i0 = 0,
      i1 = 0,
      n = nodes.length,
      dx, dy,
      value = parent.value,
      sumValue,
      minValue,
      maxValue,
      newRatio,
      minRatio,
      alpha,
      beta;

  while (i0 < n) {
    dx = x1 - x0, dy = y1 - y0;

    // Find the next non-empty node.
    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);

    // Keep adding nodes while the aspect ratio maintains or improves.
    for (; i1 < n; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
      minRatio = newRatio;
    }

    // Position and record the row orientation.
    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }

  return rows;
}

var treemapSquarify = (function custom(ratio) {

  function squarify(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }

  squarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return squarify;
})(phi);

function treemapBinary(parent, x0, y0, x1, y1) {
  var nodes = parent.children,
      i, n = nodes.length,
      sum, sums = new Array(n + 1);

  for (sums[0] = sum = i = 0; i < n; ++i) {
    sums[i + 1] = sum += nodes[i].value;
  }

  partition(0, n, parent.value, x0, y0, x1, y1);

  function partition(i, j, value, x0, y0, x1, y1) {
    if (i >= j - 1) {
      var node = nodes[i];
      node.x0 = x0, node.y0 = y0;
      node.x1 = x1, node.y1 = y1;
      return;
    }

    var valueOffset = sums[i],
        valueTarget = (value / 2) + valueOffset,
        k = i + 1,
        hi = j - 1;

    while (k < hi) {
      var mid = k + hi >>> 1;
      if (sums[mid] < valueTarget) k = mid + 1;
      else hi = mid;
    }

    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;

    var valueLeft = sums[k] - valueOffset,
        valueRight = value - valueLeft;

    if ((x1 - x0) > (y1 - y0)) {
      var xk = (x0 * valueRight + x1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, xk, y1);
      partition(k, j, valueRight, xk, y0, x1, y1);
    } else {
      var yk = (y0 * valueRight + y1 * valueLeft) / value;
      partition(i, k, valueLeft, x0, y0, x1, yk);
      partition(k, j, valueRight, x0, yk, x1, y1);
    }
  }
}

function treemapSliceDice(parent, x0, y0, x1, y1) {
  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
}

var treemapResquarify = (function custom(ratio) {

  function resquarify(parent, x0, y0, x1, y1) {
    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
      var rows,
          row,
          nodes,
          i,
          j = -1,
          n,
          m = rows.length,
          value = parent.value;

      while (++j < m) {
        row = rows[j], nodes = row.children;
        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
        value -= row.value;
      }
    } else {
      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
      rows.ratio = ratio;
    }
  }

  resquarify.ratio = function(x) {
    return custom((x = +x) > 1 ? x : 1);
  };

  return resquarify;
})(phi);

function formatDecimal(x) {
  return Math.abs(x = Math.round(x)) >= 1e21
      ? x.toLocaleString("en").replace(/,/g, "")
      : x.toString(10);
}

// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
}

function exponent(x) {
  return x = formatDecimalParts(Math.abs(x)), x ? x[1] : NaN;
}

function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
}

function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}

// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  return new FormatSpecifier({
    fill: match[1],
    align: match[2],
    sign: match[3],
    symbol: match[4],
    zero: match[5],
    width: match[6],
    comma: match[7],
    precision: match[8] && match[8].slice(1),
    trim: match[9],
    type: match[10]
  });
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
  this.align = specifier.align === undefined ? ">" : specifier.align + "";
  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === undefined ? undefined : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === undefined ? "" : specifier.type + "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};

// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function formatTrim(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

var prefixExponent;

function formatPrefixAuto(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + formatDecimalParts(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

function formatRounded(x, p) {
  var d = formatDecimalParts(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

var formatTypes = {
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": formatDecimal,
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return formatRounded(x * 100, p); },
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
};

function identity$2(x) {
  return x;
}

var map = Array.prototype.map,
    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

function formatLocale$3(locale) {
  var group = locale.grouping === undefined || locale.thousands === undefined ? identity$2 : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
      numerals = locale.numerals === undefined ? identity$2 : formatNumerals(map.call(locale.numerals, String)),
      percent = locale.percent === undefined ? "%" : locale.percent + "",
      minus = locale.minus === undefined ? "-" : locale.minus + "",
      nan = locale.nan === undefined ? "NaN" : locale.nan + "";

  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = formatTypes[type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision === undefined ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Determine the sign. -0 is not less than 0, but 1 / -0 is!
        var valueNegative = value < 0 || 1 / value < 0;

        // Perform the initial formatting.
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = formatTrim(value);

        // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
        if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
}

var locale$2S;
var format$1;

defaultLocale$4({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""],
  minus: "-"
});

function defaultLocale$4(definition) {
  locale$2S = formatLocale$3(definition);
  format$1 = locale$2S.format;
  locale$2S.formatPrefix;
  return locale$2S;
}

var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
  }

  interval.floor = function(date) {
    return floori(date = new Date(+date)), date;
  };

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}

var millisecond = newInterval(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return newInterval(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

var utcMillisecond = millisecond;
millisecond.range;

var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;

var second = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds());
}, function(date, step) {
  date.setTime(+date + step * durationSecond);
}, function(start, end) {
  return (end - start) / durationSecond;
}, function(date) {
  return date.getUTCSeconds();
});

var utcSecond = second;
second.range;

var minute = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getMinutes();
});

var timeMinute = minute;
minute.range;

var hour = newInterval(function(date) {
  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getHours();
});

var timeHour = hour;
hour.range;

var day = newInterval(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
}, function(date) {
  return date.getDate() - 1;
});

var timeDay = day;
day.range;

function weekday(i) {
  return newInterval(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

sunday.range;
monday.range;
tuesday.range;
wednesday.range;
thursday.range;
friday.range;
saturday.range;

var month = newInterval(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

var timeMonth = month;
month.range;

var year = newInterval(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

var timeYear = year;
year.range;

var utcMinute = newInterval(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationMinute);
}, function(start, end) {
  return (end - start) / durationMinute;
}, function(date) {
  return date.getUTCMinutes();
});

var utcMinute$1 = utcMinute;
utcMinute.range;

var utcHour = newInterval(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * durationHour);
}, function(start, end) {
  return (end - start) / durationHour;
}, function(date) {
  return date.getUTCHours();
});

var utcHour$1 = utcHour;
utcHour.range;

var utcDay = newInterval(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / durationDay;
}, function(date) {
  return date.getUTCDate() - 1;
});

var utcDay$1 = utcDay;
utcDay.range;

function utcWeekday(i) {
  return newInterval(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / durationWeek;
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

utcSunday.range;
utcMonday.range;
utcTuesday.range;
utcWednesday.range;
utcThursday.range;
utcFriday.range;
utcSaturday.range;

var utcMonth = newInterval(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

var utcMonth$1 = utcMonth;
utcMonth.range;

var utcYear = newInterval(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

var utcYear$1 = utcYear;
utcYear.range;

function localDate$2(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate$2(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate$2(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale$2(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe$2(locale_periods),
      periodLookup = formatLookup$2(locale_periods),
      weekdayRe = formatRe$2(locale_weekdays),
      weekdayLookup = formatLookup$2(locale_weekdays),
      shortWeekdayRe = formatRe$2(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup$2(locale_shortWeekdays),
      monthRe = formatRe$2(locale_months),
      monthLookup = formatLookup$2(locale_months),
      shortMonthRe = formatRe$2(locale_shortMonths),
      shortMonthLookup = formatLookup$2(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth$2,
    "e": formatDayOfMonth$2,
    "f": formatMicroseconds$2,
    "g": formatYearISO$2,
    "G": formatFullYearISO$2,
    "H": formatHour24$2,
    "I": formatHour12$2,
    "j": formatDayOfYear$2,
    "L": formatMilliseconds$2,
    "m": formatMonthNumber$2,
    "M": formatMinutes$2,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp$2,
    "s": formatUnixTimestampSeconds$2,
    "S": formatSeconds$2,
    "u": formatWeekdayNumberMonday$2,
    "U": formatWeekNumberSunday$2,
    "V": formatWeekNumberISO$2,
    "w": formatWeekdayNumberSunday$2,
    "W": formatWeekNumberMonday$2,
    "x": null,
    "X": null,
    "y": formatYear$2,
    "Y": formatFullYear$2,
    "Z": formatZone$2,
    "%": formatLiteralPercent$2
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth$2,
    "e": formatUTCDayOfMonth$2,
    "f": formatUTCMicroseconds$2,
    "g": formatUTCYearISO$2,
    "G": formatUTCFullYearISO$2,
    "H": formatUTCHour24$2,
    "I": formatUTCHour12$2,
    "j": formatUTCDayOfYear$2,
    "L": formatUTCMilliseconds$2,
    "m": formatUTCMonthNumber$2,
    "M": formatUTCMinutes$2,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp$2,
    "s": formatUnixTimestampSeconds$2,
    "S": formatUTCSeconds$2,
    "u": formatUTCWeekdayNumberMonday$2,
    "U": formatUTCWeekNumberSunday$2,
    "V": formatUTCWeekNumberISO$2,
    "w": formatUTCWeekdayNumberSunday$2,
    "W": formatUTCWeekNumberMonday$2,
    "x": null,
    "X": null,
    "y": formatUTCYear$2,
    "Y": formatUTCFullYear$2,
    "Z": formatUTCZone$2,
    "%": formatLiteralPercent$2
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth$2,
    "e": parseDayOfMonth$2,
    "f": parseMicroseconds$2,
    "g": parseYear$3,
    "G": parseFullYear$2,
    "H": parseHour24$2,
    "I": parseHour24$2,
    "j": parseDayOfYear$2,
    "L": parseMilliseconds$2,
    "m": parseMonthNumber$2,
    "M": parseMinutes$2,
    "p": parsePeriod,
    "q": parseQuarter$2,
    "Q": parseUnixTimestamp$2,
    "s": parseUnixTimestampSeconds$2,
    "S": parseSeconds$2,
    "u": parseWeekdayNumberMonday$2,
    "U": parseWeekNumberSunday$2,
    "V": parseWeekNumberISO$2,
    "w": parseWeekdayNumberSunday$2,
    "W": parseWeekNumberMonday$2,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear$3,
    "Y": parseFullYear$2,
    "Z": parseZone$2,
    "%": parseLiteralPercent$2
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads$2[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate$2(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate$2(newDate$2(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay$1.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate$2(newDate$2(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? monday.ceil(week) : monday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate$2(newDate$2(d.y, 0, 1)).getUTCDay() : localDate$2(newDate$2(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate$2(d);
      }

      // Otherwise, all fields are in local time.
      return localDate$2(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads$2 ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads$2 = {"-": "", "_": " ", "0": "0"},
    numberRe$2 = /^\s*\d+/, // note: ignores next directive
    percentRe$2 = /^%/,
    requoteRe$2 = /[\\^$*+?|[\]().{}]/g;

function pad$2(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote$2(s) {
  return s.replace(requoteRe$2, "\\$&");
}

function formatRe$2(names) {
  return new RegExp("^(?:" + names.map(requote$2).join("|") + ")", "i");
}

function formatLookup$2(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear$3(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone$2(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent$2(d, string, i) {
  var n = percentRe$2.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds$2(d, string, i) {
  var n = numberRe$2.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth$2(d, p) {
  return pad$2(d.getDate(), p, 2);
}

function formatHour24$2(d, p) {
  return pad$2(d.getHours(), p, 2);
}

function formatHour12$2(d, p) {
  return pad$2(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear$2(d, p) {
  return pad$2(1 + timeDay.count(timeYear(d), d), p, 3);
}

function formatMilliseconds$2(d, p) {
  return pad$2(d.getMilliseconds(), p, 3);
}

function formatMicroseconds$2(d, p) {
  return formatMilliseconds$2(d, p) + "000";
}

function formatMonthNumber$2(d, p) {
  return pad$2(d.getMonth() + 1, p, 2);
}

function formatMinutes$2(d, p) {
  return pad$2(d.getMinutes(), p, 2);
}

function formatSeconds$2(d, p) {
  return pad$2(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday$2(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday$2(d, p) {
  return pad$2(sunday.count(timeYear(d) - 1, d), p, 2);
}

function dISO$2(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
}

function formatWeekNumberISO$2(d, p) {
  d = dISO$2(d);
  return pad$2(thursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday$2(d) {
  return d.getDay();
}

function formatWeekNumberMonday$2(d, p) {
  return pad$2(monday.count(timeYear(d) - 1, d), p, 2);
}

function formatYear$2(d, p) {
  return pad$2(d.getFullYear() % 100, p, 2);
}

function formatYearISO$2(d, p) {
  d = dISO$2(d);
  return pad$2(d.getFullYear() % 100, p, 2);
}

function formatFullYear$2(d, p) {
  return pad$2(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO$2(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
  return pad$2(d.getFullYear() % 10000, p, 4);
}

function formatZone$2(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad$2(z / 60 | 0, "0", 2)
      + pad$2(z % 60, "0", 2);
}

function formatUTCDayOfMonth$2(d, p) {
  return pad$2(d.getUTCDate(), p, 2);
}

function formatUTCHour24$2(d, p) {
  return pad$2(d.getUTCHours(), p, 2);
}

function formatUTCHour12$2(d, p) {
  return pad$2(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear$2(d, p) {
  return pad$2(1 + utcDay$1.count(utcYear$1(d), d), p, 3);
}

function formatUTCMilliseconds$2(d, p) {
  return pad$2(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds$2(d, p) {
  return formatUTCMilliseconds$2(d, p) + "000";
}

function formatUTCMonthNumber$2(d, p) {
  return pad$2(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes$2(d, p) {
  return pad$2(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds$2(d, p) {
  return pad$2(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday$2(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday$2(d, p) {
  return pad$2(utcSunday.count(utcYear$1(d) - 1, d), p, 2);
}

function UTCdISO$2(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO$2(d, p) {
  d = UTCdISO$2(d);
  return pad$2(utcThursday.count(utcYear$1(d), d) + (utcYear$1(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday$2(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday$2(d, p) {
  return pad$2(utcMonday.count(utcYear$1(d) - 1, d), p, 2);
}

function formatUTCYear$2(d, p) {
  return pad$2(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO$2(d, p) {
  d = UTCdISO$2(d);
  return pad$2(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear$2(d, p) {
  return pad$2(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO$2(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad$2(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone$2() {
  return "+0000";
}

function formatLiteralPercent$2() {
  return "%";
}

function formatUnixTimestamp$2(d) {
  return +d;
}

function formatUnixTimestampSeconds$2(d) {
  return Math.floor(+d / 1000);
}

var locale$2R;
var timeFormat$1;

defaultLocale$3({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$3(definition) {
  locale$2R = formatLocale$2(definition);
  timeFormat$1 = locale$2R.format;
  locale$2R.parse;
  locale$2R.utcFormat;
  locale$2R.utcParse;
  return locale$2R;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}

var getDisplayName = function getDisplayName(component) {
  if (typeof component === 'string') {
    return component;
  }

  if (!component) {
    return undefined;
  }

  return component.displayName || component.name || 'Component';
};

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    BaseComponent[key] = value;
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var hasOwnProperty$f = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  }

  return x !== x && y !== y;
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty$f.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$2(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$2(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf$2(o, p) {
  _setPrototypeOf$2 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$2(o, p);
}

function _inherits$3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$2(subClass, superClass);
}

function _getPrototypeOf$3(o) {
  _getPrototypeOf$3 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$3(o);
}

function _isNativeReflectConstruct$3() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _typeof$2(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof$2(obj);
}

function _assertThisInitialized$2(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _possibleConstructorReturn$3(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized$2(self);
}

function _createSuper$3(Derived) {
  return function () {
    var Super = _getPrototypeOf$3(Derived),
        result;
    if (_isNativeReflectConstruct$3()) {
      var NewTarget = _getPrototypeOf$3(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$3(this, result);
  };
}

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return "".concat(hocName, "(").concat(getDisplayName(BaseComponent), ")");
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var ShouldUpdate = function (_Component) {
      _inherits$3(ShouldUpdate, _Component);

      var _super = _createSuper$3(ShouldUpdate);

      function ShouldUpdate() {
        _classCallCheck$2(this, ShouldUpdate);

        return _super.apply(this, arguments);
      }

      _createClass$2(ShouldUpdate, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps) {
          return test(this.props, nextProps);
        }
      }, {
        key: "render",
        value: function render() {
          return factory(this.props);
        }
      }]);

      return ShouldUpdate;
    }(Component);

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }

    return ShouldUpdate;
  };
};

var pure = function pure(component) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !shallowEqual(props, nextProps);
  });

  if (process.env.NODE_ENV !== 'production') {
    return setDisplayName(wrapDisplayName(component, 'pure'))(hoc(component));
  }

  return hoc(component);
};

var compose = function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  }, function (arg) {
    return arg;
  });
};

function _defineProperty$a(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$d(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$8(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$d(Object(source), true).forEach(function (key) {
        _defineProperty$a(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$d(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

var pick$2 = function pick(obj, keys) {
  var result = {};

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];

    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }

  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !shallowEqual(pick$2(props, shouldMapOrKeys), pick$2(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      _inherits$3(WithPropsOnChange, _Component);

      var _super = _createSuper$3(WithPropsOnChange);

      function WithPropsOnChange() {
        var _this;

        _classCallCheck$2(this, WithPropsOnChange);

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _super.call.apply(_super, [this].concat(args));
        _this.state = {
          computedProps: propsMapper(_this.props),
          prevProps: _this.props
        };
        return _this;
      }

      _createClass$2(WithPropsOnChange, [{
        key: "render",
        value: function render() {
          return factory(_objectSpread2$8(_objectSpread2$8({}, this.props), this.state.computedProps));
        }
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(nextProps, prevState) {
          if (shouldMap(prevState.prevProps, nextProps)) {
            return {
              computedProps: propsMapper(nextProps),
              prevProps: nextProps
            };
          }

          return {
            prevProps: nextProps
          };
        }
      }]);

      return WithPropsOnChange;
    }(Component);

    polyfill(WithPropsOnChange);

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }

    return WithPropsOnChange;
  };
};

var defaultProps$4 = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = createFactory(BaseComponent);

    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };

    DefaultProps.defaultProps = props;

    if (process.env.NODE_ENV !== 'production') {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }

    return DefaultProps;
  };
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

var SetCache$1 = _SetCache,
    arraySome = _arraySome,
    cacheHas$1 = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache$1 : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas$1(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$3(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$3;

var Symbol$7 = _Symbol$1,
    Uint8Array$3 = _Uint8Array$1,
    eq$3 = eq_1$1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray$2 = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$5 = '[object Boolean]',
    dateTag$5 = '[object Date]',
    errorTag$3 = '[object Error]',
    mapTag$9 = '[object Map]',
    numberTag$6 = '[object Number]',
    regexpTag$5 = '[object RegExp]',
    setTag$9 = '[object Set]',
    stringTag$5 = '[object String]',
    symbolTag$4 = '[object Symbol]';

var arrayBufferTag$5 = '[object ArrayBuffer]',
    dataViewTag$7 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$7 ? Symbol$7.prototype : undefined,
    symbolValueOf$2 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$7:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$5:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$3(object), new Uint8Array$3(other))) {
        return false;
      }
      return true;

    case boolTag$5:
    case dateTag$5:
    case numberTag$6:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$3(+object, +other);

    case errorTag$3:
      return object.name == other.name && object.message == other.message;

    case regexpTag$5:
    case stringTag$5:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$9:
      var convert = mapToArray;

    case setTag$9:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray$2);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$4:
      if (symbolValueOf$2) {
        return symbolValueOf$2.call(object) == symbolValueOf$2.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$6(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush$1 = arrayPush$6;

var arrayPush$5 = _arrayPush$1,
    isArray$c = isArray_1$1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$5(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$c(object) ? result : arrayPush$5(result, symbolsFunc(object));
}

var _baseGetAllKeys$1 = baseGetAllKeys$5;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$4(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter$1 = arrayFilter$4;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$5() {
  return [];
}

var stubArray_1$1 = stubArray$5;

var arrayFilter$3 = _arrayFilter$1,
    stubArray$4 = stubArray_1$1;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$2 = objectProto$h.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$3 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$7 = !nativeGetSymbols$3 ? stubArray$4 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$3(nativeGetSymbols$3(object), function(symbol) {
    return propertyIsEnumerable$2.call(object, symbol);
  });
};

var _getSymbols$1 = getSymbols$7;

var overArg$3 = _overArg$1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$3 = overArg$3(Object.keys, Object);

var _nativeKeys$1 = nativeKeys$3;

var isPrototype$4 = _isPrototype$1,
    nativeKeys$2 = _nativeKeys$1;

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$g.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$3(object) {
  if (!isPrototype$4(object)) {
    return nativeKeys$2(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$e.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys$1 = baseKeys$3;

var arrayLikeKeys$3 = _arrayLikeKeys$1,
    baseKeys$2 = _baseKeys$1,
    isArrayLike$5 = isArrayLike_1$1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$9(object) {
  return isArrayLike$5(object) ? arrayLikeKeys$3(object) : baseKeys$2(object);
}

var keys_1$1 = keys$9;

var baseGetAllKeys$4 = _baseGetAllKeys$1,
    getSymbols$6 = _getSymbols$1,
    keys$8 = keys_1$1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$4(object) {
  return baseGetAllKeys$4(object, keys$8, getSymbols$6);
}

var _getAllKeys$1 = getAllKeys$4;

var getAllKeys$3 = _getAllKeys$1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$f.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys$3(object),
      objLength = objProps.length,
      othProps = getAllKeys$3(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$d.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$b = _getNative$1,
    root$c = _root$1;

/* Built-in method references that are verified to be native. */
var DataView$4 = getNative$b(root$c, 'DataView');

var _DataView$1 = DataView$4;

var getNative$a = _getNative$1,
    root$b = _root$1;

/* Built-in method references that are verified to be native. */
var Promise$4 = getNative$a(root$b, 'Promise');

var _Promise$1 = Promise$4;

var getNative$9 = _getNative$1,
    root$a = _root$1;

/* Built-in method references that are verified to be native. */
var Set$5 = getNative$9(root$a, 'Set');

var _Set$1 = Set$5;

var getNative$8 = _getNative$1,
    root$9 = _root$1;

/* Built-in method references that are verified to be native. */
var WeakMap$4 = getNative$8(root$9, 'WeakMap');

var _WeakMap$1 = WeakMap$4;

var DataView$3 = _DataView$1,
    Map$5 = _Map$1,
    Promise$3 = _Promise$1,
    Set$4 = _Set$1,
    WeakMap$3 = _WeakMap$1,
    baseGetTag$6 = _baseGetTag$1,
    toSource$3 = _toSource$1;

/** `Object#toString` result references. */
var mapTag$8 = '[object Map]',
    objectTag$5 = '[object Object]',
    promiseTag$1 = '[object Promise]',
    setTag$8 = '[object Set]',
    weakMapTag$4 = '[object WeakMap]';

var dataViewTag$6 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString$1 = toSource$3(DataView$3),
    mapCtorString$1 = toSource$3(Map$5),
    promiseCtorString$1 = toSource$3(Promise$3),
    setCtorString$1 = toSource$3(Set$4),
    weakMapCtorString$1 = toSource$3(WeakMap$3);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$8 = baseGetTag$6;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$3 && getTag$8(new DataView$3(new ArrayBuffer(1))) != dataViewTag$6) ||
    (Map$5 && getTag$8(new Map$5) != mapTag$8) ||
    (Promise$3 && getTag$8(Promise$3.resolve()) != promiseTag$1) ||
    (Set$4 && getTag$8(new Set$4) != setTag$8) ||
    (WeakMap$3 && getTag$8(new WeakMap$3) != weakMapTag$4)) {
  getTag$8 = function(value) {
    var result = baseGetTag$6(value),
        Ctor = result == objectTag$5 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$3(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1: return dataViewTag$6;
        case mapCtorString$1: return mapTag$8;
        case promiseCtorString$1: return promiseTag$1;
        case setCtorString$1: return setTag$8;
        case weakMapCtorString$1: return weakMapTag$4;
      }
    }
    return result;
  };
}

var _getTag$1 = getTag$8;

var Stack$4 = _Stack$1,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag$7 = _getTag$1,
    isArray$b = isArray_1$1,
    isBuffer$4 = isBufferExports$1,
    isTypedArray$2 = isTypedArray_1$1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag$4 = '[object Arguments]',
    arrayTag$3 = '[object Array]',
    objectTag$4 = '[object Object]';

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$e.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$b(object),
      othIsArr = isArray$b(other),
      objTag = objIsArr ? arrayTag$3 : getTag$7(object),
      othTag = othIsArr ? arrayTag$3 : getTag$7(other);

  objTag = objTag == argsTag$4 ? objectTag$4 : objTag;
  othTag = othTag == argsTag$4 ? objectTag$4 : othTag;

  var objIsObj = objTag == objectTag$4,
      othIsObj = othTag == objectTag$4,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$4(object)) {
    if (!isBuffer$4(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$4);
    return (objIsArr || isTypedArray$2(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$c.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$c.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$4);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$4);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$9 = isObjectLike_1$1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$9(value) && !isObjectLike$9(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

var _baseIsEqual = baseIsEqual$3;

var baseIsEqual$2 = _baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual$1(value, other) {
  return baseIsEqual$2(value, other);
}

var isEqual_1 = isEqual$1;

var isEqual$2 = /*@__PURE__*/getDefaultExportFromCjs(isEqual_1);

var baseGet$3 = _baseGet,
    baseSet = _baseSet,
    castPath$3 = _castPath;

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$1(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet$3(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath$3(path, object), value);
    }
  }
  return result;
}

var _basePickBy = basePickBy$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var castPath$2 = _castPath,
    isArguments$3 = isArguments_1$1,
    isArray$a = isArray_1$1,
    isIndex$2 = _isIndex$1,
    isLength$3 = isLength_1$1,
    toKey$3 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$2(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$3(length) && isIndex$2(key, length) &&
    (isArray$a(object) || isArguments$3(object));
}

var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$2(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$2;

var basePickBy = _basePickBy,
    hasIn$1 = hasIn_1;

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick$1(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn$1(object, path);
  });
}

var _basePick = basePick$1;

var Symbol$6 = _Symbol$1,
    isArguments$2 = isArguments_1$1,
    isArray$9 = isArray_1$1;

/** Built-in value references. */
var spreadableSymbol = Symbol$6 ? Symbol$6.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$9(value) || isArguments$2(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;

var arrayPush$4 = _arrayPush$1,
    isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$2(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$2(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$4(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$2;

var baseFlatten$1 = _baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$2(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$1(array, 1) : [];
}

var flatten_1 = flatten$2;

var flatten$1 = flatten_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$2(func) {
  return setToString(overRest(func, undefined, flatten$1), func + '');
}

var _flatRest = flatRest$2;

var basePick = _basePick,
    flatRest$1 = _flatRest;

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest$1(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

var pick_1 = pick;

var pick$1 = /*@__PURE__*/getDefaultExportFromCjs(pick_1);

function _defineProperty$9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$c(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$c(Object(source), true).forEach(function (key) {
        _defineProperty$9(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$c(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

var textProps = {
  fill: PropTypes.string,
  fontSize: PropTypes.number,
  fontFamily: PropTypes.string
};
var axisThemePropType = PropTypes.shape({
  domain: PropTypes.shape({
    line: PropTypes.shape({
      stroke: PropTypes.string.isRequired,
      strokeWidth: PropTypes.number.isRequired,
      strokeDasharray: PropTypes.string
    }).isRequired
  }).isRequired,
  ticks: PropTypes.shape({
    line: PropTypes.shape({
      stroke: PropTypes.string.isRequired,
      strokeWidth: PropTypes.number.isRequired,
      strokeDasharray: PropTypes.string
    }).isRequired,
    text: PropTypes.shape(_objectSpread2$7({}, textProps)).isRequired
  }).isRequired,
  legend: PropTypes.shape({
    text: PropTypes.shape(_objectSpread2$7({}, textProps)).isRequired
  }).isRequired
});
var gridThemePropType = PropTypes.shape({
  line: PropTypes.shape({
    stroke: PropTypes.string.isRequired,
    strokeWidth: PropTypes.number.isRequired,
    strokeDasharray: PropTypes.string
  }).isRequired
});
var legendsThemePropType = PropTypes.shape({
  text: PropTypes.shape(_objectSpread2$7({}, textProps)).isRequired
});
var labelsThemePropType = PropTypes.shape({
  text: PropTypes.shape(_objectSpread2$7({}, textProps)).isRequired
});
var dotsThemePropType = PropTypes.shape({
  text: PropTypes.shape(_objectSpread2$7({}, textProps)).isRequired
});
var markersThemePropType = PropTypes.shape({
  text: PropTypes.shape(_objectSpread2$7({}, textProps)).isRequired
});
var crosshairPropType = PropTypes.shape({
  line: PropTypes.shape({
    stroke: PropTypes.string.isRequired,
    strokeWidth: PropTypes.number.isRequired,
    strokeDasharray: PropTypes.string
  }).isRequired
});
var annotationsPropType = PropTypes.shape({
  text: PropTypes.shape(_objectSpread2$7(_objectSpread2$7({}, textProps), {}, {
    outlineWidth: PropTypes.number.isRequired,
    outlineColor: PropTypes.string.isRequired
  })).isRequired,
  link: PropTypes.shape({
    stroke: PropTypes.string.isRequired,
    strokeWidth: PropTypes.number.isRequired,
    outlineWidth: PropTypes.number.isRequired,
    outlineColor: PropTypes.string.isRequired
  }).isRequired,
  outline: PropTypes.shape({
    stroke: PropTypes.string.isRequired,
    strokeWidth: PropTypes.number.isRequired,
    outlineWidth: PropTypes.number.isRequired,
    outlineColor: PropTypes.string.isRequired
  }).isRequired,
  symbol: PropTypes.shape({
    fill: PropTypes.string.isRequired,
    outlineWidth: PropTypes.number.isRequired,
    outlineColor: PropTypes.string.isRequired
  }).isRequired
});
PropTypes.shape({
  background: PropTypes.string.isRequired,
  fontFamily: PropTypes.string.isRequired,
  fontSize: PropTypes.number.isRequired,
  textColor: PropTypes.string.isRequired,
  axis: axisThemePropType.isRequired,
  grid: gridThemePropType.isRequired,
  legends: legendsThemePropType.isRequired,
  labels: labelsThemePropType.isRequired,
  dots: dotsThemePropType.isRequired,
  markers: markersThemePropType,
  crosshair: crosshairPropType.isRequired,
  annotations: annotationsPropType.isRequired
});

var defaultTheme = {
  background: 'transparent',
  fontFamily: 'sans-serif',
  fontSize: 11,
  textColor: '#333333',
  axis: {
    domain: {
      line: {
        stroke: 'transparent',
        strokeWidth: 1
      }
    },
    ticks: {
      line: {
        stroke: '#777777',
        strokeWidth: 1
      },
      text: {}
    },
    legend: {
      text: {
        fontSize: 12
      }
    }
  },
  grid: {
    line: {
      stroke: '#dddddd',
      strokeWidth: 1
    }
  },
  legends: {
    text: {}
  },
  labels: {
    text: {}
  },
  markers: {
    lineColor: '#000000',
    lineStrokeWidth: 1,
    text: {}
  },
  dots: {
    text: {}
  },
  tooltip: {
    container: {
      background: 'white',
      color: 'inherit',
      fontSize: 'inherit',
      borderRadius: '2px',
      boxShadow: '0 1px 2px rgba(0, 0, 0, 0.25)',
      padding: '5px 9px'
    },
    basic: {
      whiteSpace: 'pre',
      display: 'flex',
      alignItems: 'center'
    },
    chip: {
      marginRight: 7
    },
    table: {},
    tableCell: {
      padding: '3px 5px'
    },
    tableCellValue: {
      fontWeight: 'bold'
    }
  },
  crosshair: {
    line: {
      stroke: '#000000',
      strokeWidth: 1,
      strokeOpacity: 0.75,
      strokeDasharray: '6 6'
    }
  },
  annotations: {
    text: {
      fontSize: 13,
      outlineWidth: 2,
      outlineColor: '#ffffff'
    },
    link: {
      stroke: '#000000',
      strokeWidth: 1,
      outlineWidth: 2,
      outlineColor: '#ffffff'
    },
    outline: {
      fill: 'none',
      stroke: '#000000',
      strokeWidth: 2,
      outlineWidth: 2,
      outlineColor: '#ffffff'
    },
    symbol: {
      fill: '#000000',
      outlineWidth: 2,
      outlineColor: '#ffffff'
    }
  }
};

var fontProps = ['axis.ticks.text', 'axis.legend.text', 'legends.text', 'labels.text', 'dots.text', 'markers.text', 'annotations.text'];
var extendDefaultTheme = function extendDefaultTheme(defaultTheme, customTheme) {
  var theme = merge$1({}, defaultTheme, customTheme);
  fontProps.forEach(function (prop) {
    if (_get(theme, "".concat(prop, ".fontFamily")) === undefined) {
      set$1(theme, "".concat(prop, ".fontFamily"), theme.fontFamily);
    }
    if (_get(theme, "".concat(prop, ".fontSize")) === undefined) {
      set$1(theme, "".concat(prop, ".fontSize"), theme.fontSize);
    }
    if (_get(theme, "".concat(prop, ".fill")) === undefined) {
      set$1(theme, "".concat(prop, ".fill"), theme.textColor);
    }
  });
  return theme;
};

var motionConfigContext = createContext();
var MotionConfigProvider = function MotionConfigProvider(_ref) {
  var children = _ref.children,
      animate = _ref.animate,
      stiffness = _ref.stiffness,
      damping = _ref.damping,
      config$1$1 = _ref.config;
  var value = useMemo$1(function () {
    var reactSpringConfig = _isString(config$1$1) ? config$1[config$1$1] : config$1$1;
    return {
      animate: animate,
      springConfig: {
        stiffness: stiffness,
        damping: damping
      },
      config: reactSpringConfig
    };
  }, [animate, stiffness, damping, config$1$1]);
  return React__default.createElement(motionConfigContext.Provider, {
    value: value
  }, children);
};
var motionPropTypes = {
  animate: PropTypes.bool,
  motionStiffness: PropTypes.number,
  motionDamping: PropTypes.number,
  motionConfig: PropTypes.oneOfType([PropTypes.oneOf(Object.keys(config$1)), PropTypes.shape({
    mass: PropTypes.number,
    tension: PropTypes.number,
    friction: PropTypes.number,
    clamp: PropTypes.bool,
    precision: PropTypes.number,
    velocity: PropTypes.number,
    duration: PropTypes.number,
    easing: PropTypes.func
  })])
};
var motionDefaultProps = {
  animate: true,
  stiffness: 90,
  damping: 15,
  config: 'default'
};
MotionConfigProvider.defaultProps = motionDefaultProps;

var useMotionConfig = function useMotionConfig() {
  return useContext(motionConfigContext);
};

var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};
var useAnimatedPath = function useAnimatedPath(path) {
  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;
  var previousPath = usePrevious(path);
  var interpolator = useMemo$1(function () {
    return interpolateString(previousPath, path);
  }, [previousPath, path]);
  var _useSpring = useSpring({
    from: {
      value: 0
    },
    to: {
      value: 1
    },
    reset: true,
    config: springConfig,
    immediate: !animate
  }),
      value = _useSpring.value;
  return to(value, interpolator);
};

var quantizeColorScales = {
  nivo: ['#d76445', '#f47560', '#e8c1a0', '#97e3d5', '#61cdbb', '#00b0a7'],
  BrBG: last$2(scheme$q),
  PRGn: last$2(scheme$p),
  PiYG: last$2(scheme$o),
  PuOr: last$2(scheme$n),
  RdBu: last$2(scheme$m),
  RdGy: last$2(scheme$l),
  RdYlBu: last$2(scheme$k),
  RdYlGn: last$2(scheme$j),
  spectral: last$2(scheme$i),
  blues: last$2(scheme$5),
  greens: last$2(scheme$4),
  greys: last$2(scheme$3),
  oranges: last$2(scheme),
  purples: last$2(scheme$2),
  reds: last$2(scheme$1),
  BuGn: last$2(scheme$h),
  BuPu: last$2(scheme$g),
  GnBu: last$2(scheme$f),
  OrRd: last$2(scheme$e),
  PuBuGn: last$2(scheme$d),
  PuBu: last$2(scheme$c),
  PuRd: last$2(scheme$b),
  RdPu: last$2(scheme$a),
  YlGnBu: last$2(scheme$9),
  YlGn: last$2(scheme$8),
  YlOrBr: last$2(scheme$7),
  YlOrRd: last$2(scheme$6)
};
var quantizeColorScalesKeys = Object.keys(quantizeColorScales);

({
  nivo: ['#e8c1a0', '#f47560', '#f1e15b', '#e8a838', '#61cdbb', '#97e3d5'],
  category10: schemeCategory10,
  accent: schemeAccent,
  dark2: schemeDark2,
  paired: schemePaired,
  pastel1: schemePastel1,
  pastel2: schemePastel2,
  set1: schemeSet1,
  set2: schemeSet2,
  set3: schemeSet3,
  brown_blueGreen: last$2(scheme$q),
  purpleRed_green: last$2(scheme$p),
  pink_yellowGreen: last$2(scheme$o),
  purple_orange: last$2(scheme$n),
  red_blue: last$2(scheme$m),
  red_grey: last$2(scheme$l),
  red_yellow_blue: last$2(scheme$k),
  red_yellow_green: last$2(scheme$j),
  spectral: last$2(scheme$i),
  blues: last$2(scheme$5),
  greens: last$2(scheme$4),
  greys: last$2(scheme$3),
  oranges: last$2(scheme),
  purples: last$2(scheme$2),
  reds: last$2(scheme$1),
  blue_green: last$2(scheme$h),
  blue_purple: last$2(scheme$g),
  green_blue: last$2(scheme$f),
  orange_red: last$2(scheme$e),
  purple_blue_green: last$2(scheme$d),
  purple_blue: last$2(scheme$c),
  purple_red: last$2(scheme$b),
  red_purple: last$2(scheme$a),
  yellow_green_blue: last$2(scheme$9),
  yellow_green: last$2(scheme$8),
  yellow_orange_brown: last$2(scheme$7),
  yellow_orange_red: last$2(scheme$6)
});

PropTypes.oneOfType([PropTypes.oneOf(quantizeColorScalesKeys), PropTypes.func, PropTypes.arrayOf(PropTypes.string)]);

var curvePropMapping = {
  basis: curveBasis,
  basisClosed: curveBasisClosed,
  basisOpen: curveBasisOpen,
  bundle: curveBundle,
  cardinal: curveCardinal,
  cardinalClosed: curveCardinalClosed,
  cardinalOpen: curveCardinalOpen,
  catmullRom: curveCatmullRom,
  catmullRomClosed: curveCatmullRomClosed,
  catmullRomOpen: curveCatmullRomOpen,
  linear: curveLinear,
  linearClosed: curveLinearClosed,
  monotoneX: monotoneX,
  monotoneY: monotoneY,
  natural: curveNatural,
  step: curveStep,
  stepAfter: stepAfter,
  stepBefore: stepBefore
};
var curvePropKeys = Object.keys(curvePropMapping);
PropTypes.oneOf(curvePropKeys);
var closedCurvePropKeys = curvePropKeys.filter(function (c) {
  return c.endsWith('Closed');
});
PropTypes.oneOf(closedCurvePropKeys);
var areaCurvePropKeys = without$1(curvePropKeys, 'bundle', 'basisClosed', 'basisOpen', 'cardinalClosed', 'cardinalOpen', 'catmullRomClosed', 'catmullRomOpen', 'linearClosed');
PropTypes.oneOf(areaCurvePropKeys);
var lineCurvePropKeys = without$1(curvePropKeys, 'bundle', 'basisClosed', 'basisOpen', 'cardinalClosed', 'cardinalOpen', 'catmullRomClosed', 'catmullRomOpen', 'linearClosed');
PropTypes.oneOf(lineCurvePropKeys);

var defsPropTypes = {
  defs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired
  })).isRequired,
  fill: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    match: PropTypes.oneOfType([PropTypes.oneOf(['*']), PropTypes.object, PropTypes.func]).isRequired
  })).isRequired
};

var stackOrderPropMapping = {
  ascending: stackOrderAscending,
  descending: stackOrderDescending,
  insideOut: stackOrderInsideOut,
  none: stackOrderNone,
  reverse: stackOrderReverse
};
var stackOrderPropKeys = Object.keys(stackOrderPropMapping);
PropTypes.oneOf(stackOrderPropKeys);
var stackOffsetPropMapping = {
  expand: stackOffsetExpand,
  diverging: stackOffsetDiverging,
  none: stackOffsetNone,
  silhouette: stackOffsetSilhouette,
  wiggle: stackOffsetWiggle
};
var stackOffsetPropKeys = Object.keys(stackOffsetPropMapping);
PropTypes.oneOf(stackOffsetPropKeys);

var treeMapTilePropMapping = {
  binary: treemapBinary,
  dice: treemapDice,
  slice: treemapSlice,
  sliceDice: treemapSliceDice,
  squarify: treemapSquarify,
  resquarify: treemapResquarify
};
var treeMapTilePropKeys = Object.keys(treeMapTilePropMapping);
PropTypes.oneOf(treeMapTilePropKeys);

var marginPropType = PropTypes.shape({
  top: PropTypes.number,
  right: PropTypes.number,
  bottom: PropTypes.number,
  left: PropTypes.number
}).isRequired;
var blendModes = ['normal', 'multiply', 'screen', 'overlay', 'darken', 'lighten', 'color-dodge', 'color-burn', 'hard-light', 'soft-light', 'difference', 'exclusion', 'hue', 'saturation', 'color', 'luminosity'];
PropTypes.oneOf(blendModes);

var defaultAnimate = true;
var defaultMotionStiffness = 90;
var defaultMotionDamping = 15;
ordinal(schemeSet3);
var defaultMargin = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};

var useDimensions = function useDimensions(width, height) {
  var partialMargin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return useMemo$1(function () {
    var margin = _objectSpread2$7(_objectSpread2$7({}, defaultMargin), partialMargin);
    return {
      margin: margin,
      innerWidth: width - margin.left - margin.right,
      innerHeight: height - margin.top - margin.bottom,
      outerWidth: width,
      outerHeight: height
    };
  }, [width, height, partialMargin.top, partialMargin.right, partialMargin.bottom, partialMargin.left]);
};

function _arrayWithHoles$6(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$6(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray$6(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray$6(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
}

function _nonIterableRest$6() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$6(arr, i) {
  return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$6();
}

var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return  (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    return Function('return this')();
})();
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();
var trailingTimeout = 2;
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
var ResizeObserverController =  (function () {
    function ResizeObserverController() {
        this.connected_ = false;
        this.mutationEventsAdded_ = false;
        this.mutationsObserver_ = null;
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        if (!this.connected_) {
            this.connect_();
        }
    };
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        if (~index) {
            observers.splice(index, 1);
        }
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        if (changesDetected) {
            this.refresh();
        }
    };
    ResizeObserverController.prototype.updateObservers_ = function () {
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    ResizeObserverController.prototype.connect_ = function () {
        if (!isBrowser || this.connected_) {
            return;
        }
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    ResizeObserverController.prototype.disconnect_ = function () {
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});
var getWindowOf = (function (target) {
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    return ownerGlobal || global$1;
});
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
    return parseFloat(value) || 0;
}
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    var width = toFloat(styles.width), height = toFloat(styles.height);
    if (styles.boxSizing === 'border-box') {
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    if (!isDocumentElement(target)) {
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = (function () {
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}
var ResizeObservation =  (function () {
    function ResizeObservation(target) {
        this.broadcastWidth = 0;
        this.broadcastHeight = 0;
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());
var ResizeObserverEntry =  (function () {
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());
var ResizeObserverSPI =  (function () {
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        this.activeObservations_ = [];
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        this.controller_.refresh();
    };
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    ResizeObserverSPI.prototype.broadcastActive = function () {
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
var ResizeObserver$1 =  (function () {
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});
var index = (function () {
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver$1;
})();

var useMeasure = function useMeasure() {
  var measureRef = useRef(null);
  var _useState = useState({
    left: 0,
    top: 0,
    width: 0,
    height: 0
  }),
      _useState2 = _slicedToArray$6(_useState, 2),
      bounds = _useState2[0],
      setBounds = _useState2[1];
  var _useState3 = useState(function () {
    return new index(function (_ref) {
      var _ref2 = _slicedToArray$6(_ref, 1),
          entry = _ref2[0];
      return setBounds(entry.contentRect);
    });
  }),
      _useState4 = _slicedToArray$6(_useState3, 1),
      observer = _useState4[0];
  useEffect(function () {
    if (measureRef.current) {
      observer.observe(measureRef.current);
    }
    return function () {
      return observer.disconnect();
    };
  }, []);
  return [measureRef, bounds];
};

var usePartialTheme = function usePartialTheme(partialTheme) {
  return useMemo$1(function () {
    return extendDefaultTheme(defaultTheme, partialTheme);
  }, [partialTheme]);
};

var getValueFormatter = function getValueFormatter(format$1$1) {
  if (typeof format$1$1 === 'function') return format$1$1;
  if (typeof format$1$1 === 'string') {
    if (format$1$1.indexOf('time:') === 0) {
      return timeFormat$1(format$1$1.slice('5'));
    }
    return format$1(format$1$1);
  }
  return function (v) {
    return "".concat(v);
  };
};
var useValueFormatter = function useValueFormatter(format) {
  return useMemo$1(function () {
    return getValueFormatter(format);
  }, [format]);
};

var themeContext = createContext();
var defaultPartialTheme = {};
var ThemeProvider = function ThemeProvider(_ref) {
  var _ref$theme = _ref.theme,
      partialTheme = _ref$theme === void 0 ? defaultPartialTheme : _ref$theme,
      children = _ref.children;
  var theme = usePartialTheme(partialTheme);
  return React__default.createElement(themeContext.Provider, {
    value: theme
  }, children);
};
var useTheme = function useTheme() {
  return useContext(themeContext);
};

var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var children = _ref.children,
      condition = _ref.condition,
      wrapper = _ref.wrapper;
  if (!condition) return children;
  return cloneElement(wrapper, {}, children);
};

var containerStyle = {
  position: 'relative'
};
var Container = function Container(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      _ref$renderWrapper = _ref.renderWrapper,
      renderWrapper = _ref$renderWrapper === void 0 ? true : _ref$renderWrapper,
      _ref$isInteractive = _ref.isInteractive,
      isInteractive = _ref$isInteractive === void 0 ? true : _ref$isInteractive,
      animate = _ref.animate,
      motionStiffness = _ref.motionStiffness,
      motionDamping = _ref.motionDamping,
      motionConfig = _ref.motionConfig;
  var container = useRef(null);
  return React__default.createElement(ThemeProvider, {
    theme: theme
  }, React__default.createElement(MotionConfigProvider, {
    animate: animate,
    stiffness: motionStiffness,
    damping: motionDamping,
    config: motionConfig
  }, React__default.createElement(TooltipProvider, {
    container: container
  }, React__default.createElement(ConditionalWrapper, {
    condition: renderWrapper,
    wrapper: React__default.createElement("div", {
      style: containerStyle,
      ref: container
    })
  }, children, isInteractive && React__default.createElement(Tooltip, null)))));
};

var noop$3 = (function () {});

var containerStyle$1 = {
  position: 'relative'
};
var LegacyContainer = function LegacyContainer(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      _ref$isInteractive = _ref.isInteractive,
      isInteractive = _ref$isInteractive === void 0 ? true : _ref$isInteractive,
      _ref$renderWrapper = _ref.renderWrapper,
      renderWrapper = _ref$renderWrapper === void 0 ? true : _ref$renderWrapper,
      animate = _ref.animate,
      motionStiffness = _ref.motionStiffness,
      motionDamping = _ref.motionDamping,
      motionConfig = _ref.motionConfig;
  var container = useRef(null);
  var _useTooltipHandlers = useTooltipHandlers(container),
      tooltipActions = _useTooltipHandlers.actions,
      tooltipState = _useTooltipHandlers.state;
  var showTooltip = useCallback$1(function (content, event) {
    return tooltipActions.showTooltipFromEvent(content, event);
  }, [tooltipActions.showTooltipFromEvent]);
  var handlers = useMemo$1(function () {
    return {
      showTooltip: isInteractive ? showTooltip : noop$3,
      hideTooltip: isInteractive ? tooltipActions.hideTooltip : noop$3
    };
  }, [tooltipActions.hideTooltip, isInteractive, showTooltip]);
  return React__default.createElement(ThemeProvider, {
    theme: theme
  }, React__default.createElement(MotionConfigProvider, {
    animate: animate,
    stiffness: motionStiffness,
    damping: motionDamping,
    config: motionConfig
  }, React__default.createElement(TooltipActionsContext.Provider, {
    value: tooltipActions
  }, React__default.createElement(TooltipStateContext.Provider, {
    value: tooltipState
  }, React__default.createElement(ConditionalWrapper, {
    condition: renderWrapper,
    wrapper: React__default.createElement("div", {
      style: containerStyle$1,
      ref: container
    })
  }, children(handlers), isInteractive && React__default.createElement(Tooltip, null))))));
};

var ResponsiveWrapper$1 = function ResponsiveWrapper(_ref) {
  var children = _ref.children;
  var _useMeasure = useMeasure(),
      _useMeasure2 = _slicedToArray$6(_useMeasure, 2),
      measureRef = _useMeasure2[0],
      bounds = _useMeasure2[1];
  var shouldRender = bounds.width > 0 && bounds.height > 0;
  return React__default.createElement("div", {
    ref: measureRef,
    style: {
      width: '100%',
      height: '100%'
    }
  }, shouldRender && children({
    width: bounds.width,
    height: bounds.height
  }));
};

var LinearGradient = function LinearGradient(_ref) {
  var id = _ref.id,
      colors = _ref.colors;
  return React__default.createElement("linearGradient", {
    id: id,
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 1
  }, colors.map(function (_ref2) {
    var offset = _ref2.offset,
        color = _ref2.color,
        opacity = _ref2.opacity;
    return React__default.createElement("stop", {
      key: offset,
      offset: "".concat(offset, "%"),
      stopColor: color,
      stopOpacity: opacity !== undefined ? opacity : 1
    });
  }));
};

var gradientTypes = {
  linearGradient: LinearGradient
};

var PatternDots = memo(function (_ref) {
  var id = _ref.id,
      background = _ref.background,
      color = _ref.color,
      size = _ref.size,
      padding = _ref.padding,
      stagger = _ref.stagger;
  var fullSize = size + padding;
  var radius = size / 2;
  var halfPadding = padding / 2;
  if (stagger === true) {
    fullSize = size * 2 + padding * 2;
  }
  return React__default.createElement("pattern", {
    id: id,
    width: fullSize,
    height: fullSize,
    patternUnits: "userSpaceOnUse"
  }, React__default.createElement("rect", {
    width: fullSize,
    height: fullSize,
    fill: background
  }), React__default.createElement("circle", {
    cx: halfPadding + radius,
    cy: halfPadding + radius,
    r: radius,
    fill: color
  }), stagger && React__default.createElement("circle", {
    cx: padding * 1.5 + size + radius,
    cy: padding * 1.5 + size + radius,
    r: radius,
    fill: color
  }));
});
PatternDots.displayName = 'PatternDots';
PatternDots.defaultProps = {
  color: '#000000',
  background: '#ffffff',
  size: 4,
  padding: 4,
  stagger: false
};
var degreesToRadians = function degreesToRadians(degrees) {
  return degrees * Math.PI / 180;
};
var radiansToDegrees = function radiansToDegrees(radians) {
  return 180 * radians / Math.PI;
};
var midAngle = function midAngle(arc) {
  return arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
};
var positionFromAngle = function positionFromAngle(angle, distance) {
  return {
    x: Math.cos(angle) * distance,
    y: Math.sin(angle) * distance
  };
};
var absoluteAngleDegrees = function absoluteAngleDegrees(angle) {
  var absAngle = angle % 360;
  if (absAngle < 0) {
    absAngle += 360;
  }
  return absAngle;
};

var textPropsByEngine = {
  svg: {
    align: {
      left: 'start',
      center: 'middle',
      right: 'end',
      start: 'start',
      middle: 'middle',
      end: 'end'
    },
    baseline: {
      top: 'text-before-edge',
      center: 'central',
      bottom: 'alphabetic'
    }
  },
  canvas: {
    align: {
      left: 'left',
      center: 'center',
      right: 'right',
      start: 'left',
      middle: 'center',
      end: 'right'
    },
    baseline: {
      top: 'top',
      center: 'middle',
      bottom: 'bottom'
    }
  }
};

var PatternLines = memo(function (_ref) {
  var id = _ref.id,
      _spacing = _ref.spacing,
      _rotation = _ref.rotation,
      background = _ref.background,
      color = _ref.color,
      lineWidth = _ref.lineWidth;
  var rotation = Math.round(_rotation) % 360;
  var spacing = Math.abs(_spacing);
  if (rotation > 180) rotation = rotation - 360;else if (rotation > 90) rotation = rotation - 180;else if (rotation < -180) rotation = rotation + 360;else if (rotation < -90) rotation = rotation + 180;
  var width = spacing;
  var height = spacing;
  var path;
  if (rotation === 0) {
    path = "\n                M 0 0 L ".concat(width, " 0\n                M 0 ").concat(height, " L ").concat(width, " ").concat(height, "\n            ");
  } else if (rotation === 90) {
    path = "\n                M 0 0 L 0 ".concat(height, "\n                M ").concat(width, " 0 L ").concat(width, " ").concat(height, "\n            ");
  } else {
    width = Math.abs(spacing / Math.sin(degreesToRadians(rotation)));
    height = spacing / Math.sin(degreesToRadians(90 - rotation));
    if (rotation > 0) {
      path = "\n                    M 0 ".concat(-height, " L ").concat(width * 2, " ").concat(height, "\n                    M ").concat(-width, " ").concat(-height, " L ").concat(width, " ").concat(height, "\n                    M ").concat(-width, " 0 L ").concat(width, " ").concat(height * 2, "\n                ");
    } else {
      path = "\n                    M ".concat(-width, " ").concat(height, " L ").concat(width, " ").concat(-height, "\n                    M ").concat(-width, " ").concat(height * 2, " L ").concat(width * 2, " ").concat(-height, "\n                    M 0 ").concat(height * 2, " L ").concat(width * 2, " 0\n                ");
    }
  }
  return React__default.createElement("pattern", {
    id: id,
    width: width,
    height: height,
    patternUnits: "userSpaceOnUse"
  }, React__default.createElement("rect", {
    width: width,
    height: height,
    fill: background,
    stroke: "rgba(255, 0, 0, 0.1)",
    strokeWidth: 0
  }), React__default.createElement("path", {
    d: path,
    strokeWidth: lineWidth,
    stroke: color,
    strokeLinecap: "square"
  }));
});
PatternLines.displayName = 'PatternLines';
PatternLines.defaultProps = {
  spacing: 5,
  rotation: 0,
  color: '#000000',
  background: '#ffffff',
  lineWidth: 2
};

var PatternSquares = memo(function (_ref) {
  var id = _ref.id,
      background = _ref.background,
      color = _ref.color,
      size = _ref.size,
      padding = _ref.padding,
      stagger = _ref.stagger;
  var fullSize = size + padding;
  var halfPadding = padding / 2;
  if (stagger === true) {
    fullSize = size * 2 + padding * 2;
  }
  return React__default.createElement("pattern", {
    id: id,
    width: fullSize,
    height: fullSize,
    patternUnits: "userSpaceOnUse"
  }, React__default.createElement("rect", {
    width: fullSize,
    height: fullSize,
    fill: background
  }), React__default.createElement("rect", {
    x: halfPadding,
    y: halfPadding,
    width: size,
    height: size,
    fill: color
  }), stagger && React__default.createElement("rect", {
    x: padding * 1.5 + size,
    y: padding * 1.5 + size,
    width: size,
    height: size,
    fill: color
  }));
});
PatternSquares.displayName = 'PatternSquares';
PatternSquares.defaultProps = {
  color: '#000000',
  background: '#ffffff',
  size: 4,
  padding: 4,
  stagger: false
};

var patternTypes = {
  patternDots: PatternDots,
  patternLines: PatternLines,
  patternSquares: PatternSquares
};

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$3(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var defsMapping = _objectSpread2$7(_objectSpread2$7({}, gradientTypes), patternTypes);
var Defs = function Defs(_ref) {
  var definitions = _ref.defs;
  if (!definitions || definitions.length < 1) return null;
  return React__default.createElement("defs", null, definitions.map(function (_ref2) {
    var type = _ref2.type,
        def = _objectWithoutProperties$3(_ref2, ["type"]);
    if (defsMapping[type]) return React__default.createElement(defsMapping[type], _objectSpread2$7({
      key: def.id
    }, def));
    return null;
  }));
};
var Defs$1 = memo(Defs);

var SvgWrapper = function SvgWrapper(_ref) {
  var width = _ref.width,
      height = _ref.height,
      margin = _ref.margin,
      defs = _ref.defs,
      children = _ref.children,
      role = _ref.role;
  var theme = useTheme();
  return React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    role: role,
    width: width,
    height: height
  }, React__default.createElement(Defs$1, {
    defs: defs
  }), React__default.createElement("rect", {
    width: width,
    height: height,
    fill: theme.background
  }), React__default.createElement("g", {
    transform: "translate(".concat(margin.left, ",").concat(margin.top, ")")
  }, children));
};

var DotsItemSymbol = function DotsItemSymbol(_ref) {
  var size = _ref.size,
      color = _ref.color,
      borderWidth = _ref.borderWidth,
      borderColor = _ref.borderColor;
  return React__default.createElement("circle", {
    r: size / 2,
    fill: color,
    stroke: borderColor,
    strokeWidth: borderWidth,
    style: {
      pointerEvents: 'none'
    }
  });
};
var DotsItemSymbol$1 = memo(DotsItemSymbol);

var DotsItem = function DotsItem(_ref) {
  var x = _ref.x,
      y = _ref.y,
      symbol = _ref.symbol,
      size = _ref.size,
      datum = _ref.datum,
      color = _ref.color,
      borderWidth = _ref.borderWidth,
      borderColor = _ref.borderColor,
      label = _ref.label,
      labelTextAnchor = _ref.labelTextAnchor,
      labelYOffset = _ref.labelYOffset,
      theme = _ref.theme;
  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;
  var animatedProps = useSpring({
    transform: "translate(".concat(x, ", ").concat(y, ")"),
    config: springConfig,
    immediate: !animate
  });
  return React__default.createElement(animated.g, {
    transform: animatedProps.transform,
    style: {
      pointerEvents: 'none'
    }
  }, React__default.createElement(symbol, {
    size: size,
    color: color,
    datum: datum,
    borderWidth: borderWidth,
    borderColor: borderColor
  }), label && React__default.createElement("text", {
    textAnchor: labelTextAnchor,
    y: labelYOffset,
    style: theme.dots.text
  }, label));
};
var DotsItemDefaultProps = {
  symbol: DotsItemSymbol$1,
  labelTextAnchor: 'middle',
  labelYOffset: -12
};
DotsItem.defaultProps = DotsItemDefaultProps;
memo(DotsItem);

var computeLabel = function computeLabel(_ref) {
  var axis = _ref.axis,
      width = _ref.width,
      height = _ref.height,
      position = _ref.position,
      offsetX = _ref.offsetX,
      offsetY = _ref.offsetY,
      orientation = _ref.orientation;
  var x = 0;
  var y = 0;
  var rotation = orientation === 'vertical' ? -90 : 0;
  var textAnchor = 'start';
  if (axis === 'x') {
    switch (position) {
      case 'top-left':
        x = -offsetX;
        y = offsetY;
        textAnchor = 'end';
        break;
      case 'top':
        y = -offsetY;
        if (orientation === 'horizontal') {
          textAnchor = 'middle';
        } else {
          textAnchor = 'start';
        }
        break;
      case 'top-right':
        x = offsetX;
        y = offsetY;
        if (orientation === 'horizontal') {
          textAnchor = 'start';
        } else {
          textAnchor = 'end';
        }
        break;
      case 'right':
        x = offsetX;
        y = height / 2;
        if (orientation === 'horizontal') {
          textAnchor = 'start';
        } else {
          textAnchor = 'middle';
        }
        break;
      case 'bottom-right':
        x = offsetX;
        y = height - offsetY;
        textAnchor = 'start';
        break;
      case 'bottom':
        y = height + offsetY;
        if (orientation === 'horizontal') {
          textAnchor = 'middle';
        } else {
          textAnchor = 'end';
        }
        break;
      case 'bottom-left':
        y = height - offsetY;
        x = -offsetX;
        if (orientation === 'horizontal') {
          textAnchor = 'end';
        } else {
          textAnchor = 'start';
        }
        break;
      case 'left':
        x = -offsetX;
        y = height / 2;
        if (orientation === 'horizontal') {
          textAnchor = 'end';
        } else {
          textAnchor = 'middle';
        }
        break;
    }
  } else {
    switch (position) {
      case 'top-left':
        x = offsetX;
        y = -offsetY;
        textAnchor = 'start';
        break;
      case 'top':
        x = width / 2;
        y = -offsetY;
        if (orientation === 'horizontal') {
          textAnchor = 'middle';
        } else {
          textAnchor = 'start';
        }
        break;
      case 'top-right':
        x = width - offsetX;
        y = -offsetY;
        if (orientation === 'horizontal') {
          textAnchor = 'end';
        } else {
          textAnchor = 'start';
        }
        break;
      case 'right':
        x = width + offsetX;
        if (orientation === 'horizontal') {
          textAnchor = 'start';
        } else {
          textAnchor = 'middle';
        }
        break;
      case 'bottom-right':
        x = width - offsetX;
        y = offsetY;
        textAnchor = 'end';
        break;
      case 'bottom':
        x = width / 2;
        y = offsetY;
        if (orientation === 'horizontal') {
          textAnchor = 'middle';
        } else {
          textAnchor = 'end';
        }
        break;
      case 'bottom-left':
        x = offsetX;
        y = offsetY;
        if (orientation === 'horizontal') {
          textAnchor = 'start';
        } else {
          textAnchor = 'end';
        }
        break;
      case 'left':
        x = -offsetX;
        if (orientation === 'horizontal') {
          textAnchor = 'end';
        } else {
          textAnchor = 'middle';
        }
        break;
    }
  }
  return {
    x: x,
    y: y,
    rotation: rotation,
    textAnchor: textAnchor
  };
};
var CartesianMarkersItem = function CartesianMarkersItem(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      axis = _ref2.axis,
      scale = _ref2.scale,
      value = _ref2.value,
      lineStyle = _ref2.lineStyle,
      textStyle = _ref2.textStyle,
      legend = _ref2.legend,
      legendPosition = _ref2.legendPosition,
      legendOffsetX = _ref2.legendOffsetX,
      legendOffsetY = _ref2.legendOffsetY,
      legendOrientation = _ref2.legendOrientation;
  var theme = useTheme();
  var x = 0;
  var x2 = 0;
  var y = 0;
  var y2 = 0;
  if (axis === 'y') {
    y = scale(value);
    x2 = width;
  } else {
    x = scale(value);
    y2 = height;
  }
  var legendNode = null;
  if (legend) {
    var legendProps = computeLabel({
      axis: axis,
      width: width,
      height: height,
      position: legendPosition,
      offsetX: legendOffsetX,
      offsetY: legendOffsetY,
      orientation: legendOrientation
    });
    legendNode = React__default.createElement("text", {
      transform: "translate(".concat(legendProps.x, ", ").concat(legendProps.y, ") rotate(").concat(legendProps.rotation, ")"),
      textAnchor: legendProps.textAnchor,
      dominantBaseline: "central",
      style: textStyle
    }, legend);
  }
  return React__default.createElement("g", {
    transform: "translate(".concat(x, ", ").concat(y, ")")
  }, React__default.createElement("line", {
    x1: 0,
    x2: x2,
    y1: 0,
    y2: y2,
    stroke: theme.markers.lineColor,
    strokeWidth: theme.markers.lineStrokeWidth,
    style: lineStyle
  }), legendNode);
};
CartesianMarkersItem.defaultProps = {
  legendPosition: 'top-right',
  legendOffsetX: 14,
  legendOffsetY: 14,
  legendOrientation: 'horizontal'
};
var CartesianMarkersItem$1 = memo(CartesianMarkersItem);

var CartesianMarkers = function CartesianMarkers(_ref) {
  var markers = _ref.markers,
      width = _ref.width,
      height = _ref.height,
      xScale = _ref.xScale,
      yScale = _ref.yScale;
  if (!markers || markers.length === 0) return null;
  return markers.map(function (marker, i) {
    return React__default.createElement(CartesianMarkersItem$1, Object.assign({
      key: i
    }, marker, {
      width: width,
      height: height,
      scale: marker.axis === 'y' ? yScale : xScale
    }));
  });
};
var CartesianMarkers$1 = memo(CartesianMarkers);

var withDimensions = (function () {
  return compose(defaultProps$4({
    margin: defaultMargin
  }), setPropTypes({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    margin: marginPropType
  }), withPropsOnChange(function (props, nextProps) {
    return props.width !== nextProps.width || props.height !== nextProps.height || !isEqual$2(props.margin, nextProps.margin);
  }, function (props) {
    var margin = Object.assign({}, defaultMargin, props.margin);
    return {
      margin: margin,
      width: props.width - margin.left - margin.right,
      height: props.height - margin.top - margin.bottom,
      outerWidth: props.width,
      outerHeight: props.height
    };
  }));
});

var getLabelGenerator = function getLabelGenerator(_label, labelFormat) {
  var getRawLabel = isFunction$7(_label) ? _label : function (d) {
    return _get(d, _label);
  };
  var formatter;
  if (labelFormat) {
    formatter = isFunction$7(labelFormat) ? labelFormat : format$1(labelFormat);
  }
  if (formatter) return function (d) {
    return formatter(getRawLabel(d));
  };
  return getRawLabel;
};
var getPropertyAccessor = function getPropertyAccessor(accessor) {
  return isFunction$7(accessor) ? accessor : function (d) {
    return _get(d, accessor);
  };
};
var usePropertyAccessor = function usePropertyAccessor(accessor) {
  return useMemo$1(function () {
    return getPropertyAccessor(accessor);
  }, [accessor]);
};

var withMotion = (function () {
  return compose(setPropTypes(motionPropTypes), defaultProps$4({
    animate: defaultAnimate,
    motionDamping: defaultMotionDamping,
    motionStiffness: defaultMotionStiffness
  }));
});

var withTheme = (function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$srcKey = _ref.srcKey,
      srcKey = _ref$srcKey === void 0 ? 'theme' : _ref$srcKey,
      _ref$destKey = _ref.destKey,
      destKey = _ref$destKey === void 0 ? 'theme' : _ref$destKey;
  return compose(setPropTypes(_defineProperty$9({}, srcKey, PropTypes.object)), withPropsOnChange([srcKey], function (props) {
    return _defineProperty$9({}, destKey, extendDefaultTheme(defaultTheme, props[srcKey]));
  }));
});
var isCursorInRect = function isCursorInRect(x, y, width, height, cursorX, cursorY) {
  return x <= cursorX && cursorX <= x + width && y <= cursorY && cursorY <= y + height;
};

var getRelativeCursor = function getRelativeCursor(el, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  var bounds = el.getBoundingClientRect();
  return [clientX - bounds.left, clientY - bounds.top];
};

function _arrayWithoutHoles$2(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$6(arr);
}

function _iterableToArray$3(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _nonIterableSpread$2() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$2(arr) {
  return _arrayWithoutHoles$2(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$6(arr) || _nonIterableSpread$2();
}

var gradientKeys = Object.keys(gradientTypes);
var patternKeys = Object.keys(patternTypes);
var isMatchingDef = function isMatchingDef(predicate, node, dataKey) {
  if (predicate === '*') {
    return true;
  } else if (isFunction$7(predicate)) {
    return predicate(node);
  } else if (isPlainObject$3(predicate)) {
    var data = dataKey ? _get(node, dataKey) : node;
    return isEqual$2(pick$1(data, Object.keys(predicate)), predicate);
  }
  return false;
};
var bindDefs = function bindDefs(defs, nodes, rules) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      dataKey = _ref.dataKey,
      _ref$colorKey = _ref.colorKey,
      colorKey = _ref$colorKey === void 0 ? 'color' : _ref$colorKey,
      _ref$targetKey = _ref.targetKey,
      targetKey = _ref$targetKey === void 0 ? 'fill' : _ref$targetKey;
  var boundDefs = [];
  var generatedIds = {};
  if (defs.length && nodes.length) {
    boundDefs = _toConsumableArray$2(defs);
    nodes.forEach(function (node) {
      var _loop = function _loop(i) {
        var _rules$i = rules[i],
            id = _rules$i.id,
            match = _rules$i.match;
        if (isMatchingDef(match, node, dataKey)) {
          var def = defs.find(function (_ref2) {
            var defId = _ref2.id;
            return defId === id;
          });
          if (def) {
            if (patternKeys.includes(def.type)) {
              if (def.background === 'inherit' || def.color === 'inherit') {
                var nodeColor = _get(node, colorKey);
                var background = def.background;
                var color = def.color;
                var inheritedId = id;
                if (def.background === 'inherit') {
                  inheritedId = "".concat(inheritedId, ".bg.").concat(nodeColor);
                  background = nodeColor;
                }
                if (def.color === 'inherit') {
                  inheritedId = "".concat(inheritedId, ".fg.").concat(nodeColor);
                  color = nodeColor;
                }
                set$1(node, targetKey, "url(#".concat(inheritedId, ")"));
                if (!generatedIds[inheritedId]) {
                  boundDefs.push(_objectSpread2$7(_objectSpread2$7({}, def), {}, {
                    id: inheritedId,
                    background: background,
                    color: color
                  }));
                  generatedIds[inheritedId] = 1;
                }
              } else {
                set$1(node, targetKey, "url(#".concat(id, ")"));
              }
            } else if (gradientKeys.includes(def.type)) {
              var allColors = def.colors.map(function (_ref3) {
                var color = _ref3.color;
                return color;
              });
              if (allColors.includes('inherit')) {
                var _nodeColor = _get(node, colorKey);
                var _inheritedId = id;
                var inheritedDef = _objectSpread2$7(_objectSpread2$7({}, def), {}, {
                  colors: def.colors.map(function (colorStop, i) {
                    if (colorStop.color !== 'inherit') return colorStop;
                    _inheritedId = "".concat(_inheritedId, ".").concat(i, ".").concat(_nodeColor);
                    return _objectSpread2$7(_objectSpread2$7({}, colorStop), {}, {
                      color: colorStop.color === 'inherit' ? _nodeColor : colorStop.color
                    });
                  })
                });
                inheritedDef.id = _inheritedId;
                set$1(node, targetKey, "url(#".concat(_inheritedId, ")"));
                if (!generatedIds[_inheritedId]) {
                  boundDefs.push(inheritedDef);
                  generatedIds[_inheritedId] = 1;
                }
              } else {
                set$1(node, targetKey, "url(#".concat(id, ")"));
              }
            }
          }
          return "break";
        }
      };
      for (var i = 0; i < rules.length; i++) {
        var _ret = _loop(i);
        if (_ret === "break") break;
      }
    });
  }
  return boundDefs;
};

function localDate$1(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate$1(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate$1(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale$1(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe$1(locale_periods),
      periodLookup = formatLookup$1(locale_periods),
      weekdayRe = formatRe$1(locale_weekdays),
      weekdayLookup = formatLookup$1(locale_weekdays),
      shortWeekdayRe = formatRe$1(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup$1(locale_shortWeekdays),
      monthRe = formatRe$1(locale_months),
      monthLookup = formatLookup$1(locale_months),
      shortMonthRe = formatRe$1(locale_shortMonths),
      shortMonthLookup = formatLookup$1(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth$1,
    "e": formatDayOfMonth$1,
    "f": formatMicroseconds$1,
    "g": formatYearISO$1,
    "G": formatFullYearISO$1,
    "H": formatHour24$1,
    "I": formatHour12$1,
    "j": formatDayOfYear$1,
    "L": formatMilliseconds$1,
    "m": formatMonthNumber$1,
    "M": formatMinutes$1,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp$1,
    "s": formatUnixTimestampSeconds$1,
    "S": formatSeconds$1,
    "u": formatWeekdayNumberMonday$1,
    "U": formatWeekNumberSunday$1,
    "V": formatWeekNumberISO$1,
    "w": formatWeekdayNumberSunday$1,
    "W": formatWeekNumberMonday$1,
    "x": null,
    "X": null,
    "y": formatYear$1,
    "Y": formatFullYear$1,
    "Z": formatZone$1,
    "%": formatLiteralPercent$1
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth$1,
    "e": formatUTCDayOfMonth$1,
    "f": formatUTCMicroseconds$1,
    "g": formatUTCYearISO$1,
    "G": formatUTCFullYearISO$1,
    "H": formatUTCHour24$1,
    "I": formatUTCHour12$1,
    "j": formatUTCDayOfYear$1,
    "L": formatUTCMilliseconds$1,
    "m": formatUTCMonthNumber$1,
    "M": formatUTCMinutes$1,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp$1,
    "s": formatUnixTimestampSeconds$1,
    "S": formatUTCSeconds$1,
    "u": formatUTCWeekdayNumberMonday$1,
    "U": formatUTCWeekNumberSunday$1,
    "V": formatUTCWeekNumberISO$1,
    "w": formatUTCWeekdayNumberSunday$1,
    "W": formatUTCWeekNumberMonday$1,
    "x": null,
    "X": null,
    "y": formatUTCYear$1,
    "Y": formatUTCFullYear$1,
    "Z": formatUTCZone$1,
    "%": formatLiteralPercent$1
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth$1,
    "e": parseDayOfMonth$1,
    "f": parseMicroseconds$1,
    "g": parseYear$2,
    "G": parseFullYear$1,
    "H": parseHour24$1,
    "I": parseHour24$1,
    "j": parseDayOfYear$1,
    "L": parseMilliseconds$1,
    "m": parseMonthNumber$1,
    "M": parseMinutes$1,
    "p": parsePeriod,
    "q": parseQuarter$1,
    "Q": parseUnixTimestamp$1,
    "s": parseUnixTimestampSeconds$1,
    "S": parseSeconds$1,
    "u": parseWeekdayNumberMonday$1,
    "U": parseWeekNumberSunday$1,
    "V": parseWeekNumberISO$1,
    "w": parseWeekdayNumberSunday$1,
    "W": parseWeekNumberMonday$1,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear$2,
    "Y": parseFullYear$1,
    "Z": parseZone$1,
    "%": parseLiteralPercent$1
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads$1[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate$1(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate$1(newDate$1(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay$1.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate$1(newDate$1(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? monday.ceil(week) : monday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate$1(newDate$1(d.y, 0, 1)).getUTCDay() : localDate$1(newDate$1(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate$1(d);
      }

      // Otherwise, all fields are in local time.
      return localDate$1(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads$1 ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads$1 = {"-": "", "_": " ", "0": "0"},
    numberRe$1 = /^\s*\d+/, // note: ignores next directive
    percentRe$1 = /^%/,
    requoteRe$1 = /[\\^$*+?|[\]().{}]/g;

function pad$1(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote$1(s) {
  return s.replace(requoteRe$1, "\\$&");
}

function formatRe$1(names) {
  return new RegExp("^(?:" + names.map(requote$1).join("|") + ")", "i");
}

function formatLookup$1(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear$2(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone$1(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent$1(d, string, i) {
  var n = percentRe$1.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds$1(d, string, i) {
  var n = numberRe$1.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth$1(d, p) {
  return pad$1(d.getDate(), p, 2);
}

function formatHour24$1(d, p) {
  return pad$1(d.getHours(), p, 2);
}

function formatHour12$1(d, p) {
  return pad$1(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear$1(d, p) {
  return pad$1(1 + timeDay.count(timeYear(d), d), p, 3);
}

function formatMilliseconds$1(d, p) {
  return pad$1(d.getMilliseconds(), p, 3);
}

function formatMicroseconds$1(d, p) {
  return formatMilliseconds$1(d, p) + "000";
}

function formatMonthNumber$1(d, p) {
  return pad$1(d.getMonth() + 1, p, 2);
}

function formatMinutes$1(d, p) {
  return pad$1(d.getMinutes(), p, 2);
}

function formatSeconds$1(d, p) {
  return pad$1(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday$1(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday$1(d, p) {
  return pad$1(sunday.count(timeYear(d) - 1, d), p, 2);
}

function dISO$1(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
}

function formatWeekNumberISO$1(d, p) {
  d = dISO$1(d);
  return pad$1(thursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday$1(d) {
  return d.getDay();
}

function formatWeekNumberMonday$1(d, p) {
  return pad$1(monday.count(timeYear(d) - 1, d), p, 2);
}

function formatYear$1(d, p) {
  return pad$1(d.getFullYear() % 100, p, 2);
}

function formatYearISO$1(d, p) {
  d = dISO$1(d);
  return pad$1(d.getFullYear() % 100, p, 2);
}

function formatFullYear$1(d, p) {
  return pad$1(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO$1(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
  return pad$1(d.getFullYear() % 10000, p, 4);
}

function formatZone$1(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad$1(z / 60 | 0, "0", 2)
      + pad$1(z % 60, "0", 2);
}

function formatUTCDayOfMonth$1(d, p) {
  return pad$1(d.getUTCDate(), p, 2);
}

function formatUTCHour24$1(d, p) {
  return pad$1(d.getUTCHours(), p, 2);
}

function formatUTCHour12$1(d, p) {
  return pad$1(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear$1(d, p) {
  return pad$1(1 + utcDay$1.count(utcYear$1(d), d), p, 3);
}

function formatUTCMilliseconds$1(d, p) {
  return pad$1(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds$1(d, p) {
  return formatUTCMilliseconds$1(d, p) + "000";
}

function formatUTCMonthNumber$1(d, p) {
  return pad$1(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes$1(d, p) {
  return pad$1(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds$1(d, p) {
  return pad$1(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday$1(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday$1(d, p) {
  return pad$1(utcSunday.count(utcYear$1(d) - 1, d), p, 2);
}

function UTCdISO$1(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO$1(d, p) {
  d = UTCdISO$1(d);
  return pad$1(utcThursday.count(utcYear$1(d), d) + (utcYear$1(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday$1(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday$1(d, p) {
  return pad$1(utcMonday.count(utcYear$1(d) - 1, d), p, 2);
}

function formatUTCYear$1(d, p) {
  return pad$1(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO$1(d, p) {
  d = UTCdISO$1(d);
  return pad$1(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear$1(d, p) {
  return pad$1(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO$1(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad$1(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone$1() {
  return "+0000";
}

function formatLiteralPercent$1() {
  return "%";
}

function formatUnixTimestamp$1(d) {
  return +d;
}

function formatUnixTimestampSeconds$1(d) {
  return Math.floor(+d / 1000);
}

var locale$2Q;
var timeFormat;

defaultLocale$2({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$2(definition) {
  locale$2Q = formatLocale$1(definition);
  timeFormat = locale$2Q.format;
  locale$2Q.parse;
  locale$2Q.utcFormat;
  locale$2Q.utcParse;
  return locale$2Q;
}

function _defineProperty$8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$b(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$b(Object(source), true).forEach(function (key) {
        _defineProperty$8(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$b(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

var centerScale = function centerScale(scale) {
  var bandwidth = scale.bandwidth();
  if (bandwidth === 0) return scale;
  var offset = bandwidth / 2;

  if (scale.round()) {
    offset = Math.round(offset);
  }

  return function (d) {
    var _scale;

    return ((_scale = scale(d)) !== null && _scale !== void 0 ? _scale : 0) + offset;
  };
};
var timeByType = {
  millisecond: [utcMillisecond, utcMillisecond],
  second: [utcSecond, utcSecond],
  minute: [timeMinute, utcMinute$1],
  hour: [timeHour, utcHour$1],
  day: [timeDay, utcDay$1],
  week: [sunday, utcSunday],
  sunday: [sunday, utcSunday],
  monday: [monday, utcMonday],
  tuesday: [tuesday, utcTuesday],
  wednesday: [wednesday, utcWednesday],
  thursday: [thursday, utcThursday],
  friday: [friday, utcFriday],
  saturday: [saturday, utcSaturday],
  month: [timeMonth, utcMonth$1],
  year: [timeYear, utcYear$1]
};
var timeTypes = Object.keys(timeByType);
var timeIntervalRegexp = new RegExp("^every\\s*(\\d+)?\\s*(".concat(timeTypes.join('|'), ")s?$"), 'i');

var isInteger = function isInteger(value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

var isArray$8 = function isArray(value) {
  return Array.isArray(value);
};

var getScaleTicks = function getScaleTicks(scale, spec) {
  if (Array.isArray(spec)) {
    return spec;
  }

  if ('ticks' in scale) {
    if (spec === undefined) {
      return scale.ticks();
    }

    if (isInteger(spec)) {
      return scale.ticks(spec);
    }

    if (typeof spec === 'string' && 'useUTC' in scale) {
      var matches = spec.match(timeIntervalRegexp);

      if (matches) {
        var timeType = timeByType[matches[2]][scale.useUTC ? 1 : 0];

        if (matches[1] === undefined) {
          return scale.ticks(timeType);
        }

        var interval = timeType.every(Number(matches[1]));

        if (interval) {
          return scale.ticks(interval);
        }
      }

      throw new Error("Invalid tickValues: ".concat(spec));
    }
  }

  return scale.domain();
};
var computeCartesianTicks = function computeCartesianTicks(_ref) {
  var axis = _ref.axis,
      scale = _ref.scale,
      ticksPosition = _ref.ticksPosition,
      tickValues = _ref.tickValues,
      tickSize = _ref.tickSize,
      tickPadding = _ref.tickPadding,
      tickRotation = _ref.tickRotation,
      _ref$engine = _ref.engine,
      engine = _ref$engine === void 0 ? 'svg' : _ref$engine;
  var values = getScaleTicks(scale, tickValues);
  var textProps = textPropsByEngine[engine];
  var position = 'bandwidth' in scale ? centerScale(scale) : scale;
  var line = {
    lineX: 0,
    lineY: 0
  };
  var text = {
    textX: 0,
    textY: 0
  };
  var isRTL = typeof document === 'object' ? document.dir === 'rtl' : false;
  var translate;
  var textAlign = textProps.align.center;
  var textBaseline = textProps.baseline.center;

  if (axis === 'x') {
    translate = function translate(d) {
      var _position;

      return {
        x: (_position = position(d)) !== null && _position !== void 0 ? _position : 0,
        y: 0
      };
    };

    line.lineY = tickSize * (ticksPosition === 'after' ? 1 : -1);
    text.textY = (tickSize + tickPadding) * (ticksPosition === 'after' ? 1 : -1);

    if (ticksPosition === 'after') {
      textBaseline = textProps.baseline.top;
    } else {
      textBaseline = textProps.baseline.bottom;
    }

    if (tickRotation === 0) {
      textAlign = textProps.align.center;
    } else if (ticksPosition === 'after' && tickRotation < 0 || ticksPosition === 'before' && tickRotation > 0) {
      textAlign = textProps.align[isRTL ? 'left' : 'right'];
      textBaseline = textProps.baseline.center;
    } else if (ticksPosition === 'after' && tickRotation > 0 || ticksPosition === 'before' && tickRotation < 0) {
      textAlign = textProps.align[isRTL ? 'right' : 'left'];
      textBaseline = textProps.baseline.center;
    }
  } else {
    translate = function translate(d) {
      var _position2;

      return {
        x: 0,
        y: (_position2 = position(d)) !== null && _position2 !== void 0 ? _position2 : 0
      };
    };

    line.lineX = tickSize * (ticksPosition === 'after' ? 1 : -1);
    text.textX = (tickSize + tickPadding) * (ticksPosition === 'after' ? 1 : -1);

    if (ticksPosition === 'after') {
      textAlign = textProps.align.left;
    } else {
      textAlign = textProps.align.right;
    }
  }

  var ticks = values.map(function (value) {
    return _objectSpread2$6(_objectSpread2$6(_objectSpread2$6({
      key: typeof value === 'number' || typeof value === 'string' ? value : "".concat(value),
      value: value
    }, translate(value)), line), text);
  });
  return {
    ticks: ticks,
    textAlign: textAlign,
    textBaseline: textBaseline
  };
};
var getFormatter = function getFormatter(format$1$1, scale) {
  if (typeof format$1$1 === 'undefined' || typeof format$1$1 === 'function') return format$1$1;

  if (scale.type === 'time') {
    var formatter = timeFormat(format$1$1);
    return function (d) {
      return formatter(d instanceof Date ? d : new Date(d));
    };
  }

  return format$1(format$1$1);
};
var computeGridLines = function computeGridLines(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      scale = _ref2.scale,
      axis = _ref2.axis,
      _values = _ref2.values;
  var lineValues = isArray$8(_values) ? _values : undefined;
  var lineCount = isInteger(_values) ? _values : undefined;
  var values = lineValues || getScaleTicks(scale, lineCount);
  var position = 'bandwidth' in scale ? centerScale(scale) : scale;
  var lines = axis === 'x' ? values.map(function (value) {
    var _position3, _position4;

    return {
      key: "".concat(value),
      x1: (_position3 = position(value)) !== null && _position3 !== void 0 ? _position3 : 0,
      x2: (_position4 = position(value)) !== null && _position4 !== void 0 ? _position4 : 0,
      y1: 0,
      y2: height
    };
  }) : values.map(function (value) {
    var _position5, _position6;

    return {
      key: "".concat(value),
      x1: 0,
      x2: width,
      y1: (_position5 = position(value)) !== null && _position5 !== void 0 ? _position5 : 0,
      y2: (_position6 = position(value)) !== null && _position6 !== void 0 ? _position6 : 0
    };
  });
  return lines;
};

var AxisTick = function AxisTick(_ref) {
  var _format;

  var _value = _ref.value,
      format = _ref.format,
      lineX = _ref.lineX,
      lineY = _ref.lineY,
      _onClick = _ref.onClick,
      textBaseline = _ref.textBaseline,
      textAnchor = _ref.textAnchor,
      animatedProps = _ref.animatedProps;
  var theme = useTheme();
  var value = (_format = format === null || format === void 0 ? void 0 : format(_value)) !== null && _format !== void 0 ? _format : _value;
  var props = useMemo$1(function () {
    var style = {
      opacity: animatedProps.opacity
    };

    if (!_onClick) {
      return {
        style: style
      };
    }

    return {
      style: _objectSpread2$6(_objectSpread2$6({}, style), {}, {
        cursor: 'pointer'
      }),
      onClick: function onClick(event) {
        return _onClick(event, value);
      }
    };
  }, [animatedProps.opacity, _onClick, value]);
  return React__default.createElement(animated.g, Object.assign({
    transform: animatedProps.transform
  }, props), React__default.createElement("line", {
    x1: 0,
    x2: lineX,
    y1: 0,
    y2: lineY,
    style: theme.axis.ticks.line
  }), React__default.createElement(animated.text, {
    dominantBaseline: textBaseline,
    textAnchor: textAnchor,
    transform: animatedProps.textTransform,
    style: theme.axis.ticks.text
  }, value));
};

var Axis = function Axis(_ref) {
  var axis = _ref.axis,
      scale = _ref.scale,
      _ref$x = _ref.x,
      x = _ref$x === void 0 ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === void 0 ? 0 : _ref$y,
      length = _ref.length,
      ticksPosition = _ref.ticksPosition,
      tickValues = _ref.tickValues,
      _ref$tickSize = _ref.tickSize,
      tickSize = _ref$tickSize === void 0 ? 5 : _ref$tickSize,
      _ref$tickPadding = _ref.tickPadding,
      tickPadding = _ref$tickPadding === void 0 ? 5 : _ref$tickPadding,
      _ref$tickRotation = _ref.tickRotation,
      tickRotation = _ref$tickRotation === void 0 ? 0 : _ref$tickRotation,
      format = _ref.format,
      _ref$renderTick = _ref.renderTick,
      renderTick = _ref$renderTick === void 0 ? AxisTick : _ref$renderTick,
      legend = _ref.legend,
      _ref$legendPosition = _ref.legendPosition,
      legendPosition = _ref$legendPosition === void 0 ? 'end' : _ref$legendPosition,
      _ref$legendOffset = _ref.legendOffset,
      legendOffset = _ref$legendOffset === void 0 ? 0 : _ref$legendOffset,
      onClick = _ref.onClick,
      ariaHidden = _ref.ariaHidden;
  var theme = useTheme();
  var formatValue = useMemo$1(function () {
    return getFormatter(format, scale);
  }, [format, scale]);

  var _computeCartesianTick = computeCartesianTicks({
    axis: axis,
    scale: scale,
    ticksPosition: ticksPosition,
    tickValues: tickValues,
    tickSize: tickSize,
    tickPadding: tickPadding,
    tickRotation: tickRotation
  }),
      ticks = _computeCartesianTick.ticks,
      textAlign = _computeCartesianTick.textAlign,
      textBaseline = _computeCartesianTick.textBaseline;

  var legendNode = null;

  if (legend !== undefined) {
    var legendX = 0;
    var legendY = 0;
    var legendRotation = 0;
    var textAnchor;

    if (axis === 'y') {
      legendRotation = -90;
      legendX = legendOffset;

      if (legendPosition === 'start') {
        textAnchor = 'start';
        legendY = length;
      } else if (legendPosition === 'middle') {
        textAnchor = 'middle';
        legendY = length / 2;
      } else if (legendPosition === 'end') {
        textAnchor = 'end';
      }
    } else {
      legendY = legendOffset;

      if (legendPosition === 'start') {
        textAnchor = 'start';
      } else if (legendPosition === 'middle') {
        textAnchor = 'middle';
        legendX = length / 2;
      } else if (legendPosition === 'end') {
        textAnchor = 'end';
        legendX = length;
      }
    }

    legendNode = React__default.createElement("text", {
      transform: "translate(".concat(legendX, ", ").concat(legendY, ") rotate(").concat(legendRotation, ")"),
      textAnchor: textAnchor,
      style: _objectSpread2$6({
        dominantBaseline: 'central'
      }, theme.axis.legend.text)
    }, legend);
  }

  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;

  var animatedProps = useSpring({
    transform: "translate(".concat(x, ",").concat(y, ")"),
    lineX2: axis === 'x' ? length : 0,
    lineY2: axis === 'x' ? 0 : length,
    config: springConfig,
    immediate: !animate
  });
  var transition = useTransition(ticks, {
    keys: function keys(tick) {
      return tick.key;
    },
    initial: function initial(tick) {
      return {
        opacity: 1,
        transform: "translate(".concat(tick.x, ",").concat(tick.y, ")"),
        textTransform: "translate(".concat(tick.textX, ",").concat(tick.textY, ") rotate(").concat(tickRotation, ")")
      };
    },
    from: function from(tick) {
      return {
        opacity: 0,
        transform: "translate(".concat(tick.x, ",").concat(tick.y, ")"),
        textTransform: "translate(".concat(tick.textX, ",").concat(tick.textY, ") rotate(").concat(tickRotation, ")")
      };
    },
    enter: function enter(tick) {
      return {
        opacity: 1,
        transform: "translate(".concat(tick.x, ",").concat(tick.y, ")"),
        textTransform: "translate(".concat(tick.textX, ",").concat(tick.textY, ") rotate(").concat(tickRotation, ")")
      };
    },
    update: function update(tick) {
      return {
        opacity: 1,
        transform: "translate(".concat(tick.x, ",").concat(tick.y, ")"),
        textTransform: "translate(".concat(tick.textX, ",").concat(tick.textY, ") rotate(").concat(tickRotation, ")")
      };
    },
    leave: {
      opacity: 0
    },
    config: springConfig,
    immediate: !animate
  });
  return React__default.createElement(animated.g, {
    transform: animatedProps.transform,
    "aria-hidden": ariaHidden
  }, transition(function (transitionProps, tick, _state, tickIndex) {
    return React__default.createElement(renderTick, _objectSpread2$6(_objectSpread2$6({
      tickIndex: tickIndex,
      format: formatValue,
      rotate: tickRotation,
      textBaseline: textBaseline,
      textAnchor: textAlign,
      animatedProps: transitionProps
    }, tick), onClick ? {
      onClick: onClick
    } : {}));
  }), React__default.createElement(animated.line, {
    style: theme.axis.domain.line,
    x1: 0,
    x2: animatedProps.lineX2,
    y1: 0,
    y2: animatedProps.lineY2
  }), legendNode);
};

var axisPropTypes = {
  ticksPosition: PropTypes.oneOf(['before', 'after']),
  tickValues: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.instanceOf(Date)])), PropTypes.string]),
  tickSize: PropTypes.number,
  tickPadding: PropTypes.number,
  tickRotation: PropTypes.number,
  format: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  renderTick: PropTypes.func,
  legend: PropTypes.node,
  legendPosition: PropTypes.oneOf(['start', 'middle', 'end']),
  legendOffset: PropTypes.number,
  ariaHidden: PropTypes.bool
};
var axisPropType = PropTypes.shape(axisPropTypes);
var positions$1 = ['top', 'right', 'bottom', 'left'];

var Axes = function Axes(_ref) {
  var xScale = _ref.xScale,
      yScale = _ref.yScale,
      width = _ref.width,
      height = _ref.height,
      top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  var axes = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  return React__default.createElement(React__default.Fragment, null, positions$1.map(function (position) {
    var axis = axes[position];
    if (!axis) return null;
    var isXAxis = position === 'top' || position === 'bottom';
    var ticksPosition = position === 'top' || position === 'left' ? 'before' : 'after';
    return React__default.createElement(Axis, Object.assign({
      key: position
    }, axis, {
      axis: isXAxis ? 'x' : 'y',
      x: position === 'right' ? width : 0,
      y: position === 'bottom' ? height : 0,
      scale: isXAxis ? xScale : yScale,
      length: isXAxis ? width : height,
      ticksPosition: ticksPosition
    }));
  }));
};

var GridLine = function GridLine(_ref) {
  var animatedProps = _ref.animatedProps;
  var theme = useTheme();
  return React__default.createElement(animated.line, Object.assign({}, animatedProps, theme.grid.line));
};

var GridLines = function GridLines(_ref) {
  var lines = _ref.lines;

  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;

  var transition = useTransition(lines, {
    keys: function keys(line) {
      return line.key;
    },
    initial: function initial(line) {
      return {
        opacity: 1,
        x1: line.x1,
        x2: line.x2,
        y1: line.y1,
        y2: line.y2
      };
    },
    from: function from(line) {
      return {
        opacity: 0,
        x1: line.x1,
        x2: line.x2,
        y1: line.y1,
        y2: line.y2
      };
    },
    enter: function enter(line) {
      return {
        opacity: 1,
        x1: line.x1,
        x2: line.x2,
        y1: line.y1,
        y2: line.y2
      };
    },
    update: function update(line) {
      return {
        opacity: 1,
        x1: line.x1,
        x2: line.x2,
        y1: line.y1,
        y2: line.y2
      };
    },
    leave: {
      opacity: 0
    },
    config: springConfig,
    immediate: !animate
  });
  return React__default.createElement("g", null, transition(function (animatedProps, line) {
    return React__default.createElement(GridLine, Object.assign({}, line, {
      key: line.key,
      animatedProps: animatedProps
    }));
  }));
};

var Grid = function Grid(_ref) {
  var width = _ref.width,
      height = _ref.height,
      xScale = _ref.xScale,
      yScale = _ref.yScale,
      xValues = _ref.xValues,
      yValues = _ref.yValues;
  var xLines = useMemo$1(function () {
    if (!xScale) return false;
    return computeGridLines({
      width: width,
      height: height,
      scale: xScale,
      axis: 'x',
      values: xValues
    });
  }, [xScale, xValues, width, height]);
  var yLines = useMemo$1(function () {
    if (!yScale) return false;
    return computeGridLines({
      width: width,
      height: height,
      scale: yScale,
      axis: 'y',
      values: yValues
    });
  }, [height, width, yScale, yValues]);
  return React__default.createElement(React__default.Fragment, null, xLines && React__default.createElement(GridLines, {
    lines: xLines
  }), yLines && React__default.createElement(GridLines, {
    lines: yLines
  }));
};

var renderAxisToCanvas = function renderAxisToCanvas(ctx, _ref) {
  var _theme$axis$domain$li;

  var axis = _ref.axis,
      scale = _ref.scale,
      _ref$x = _ref.x,
      x = _ref$x === void 0 ? 0 : _ref$x,
      _ref$y = _ref.y,
      y = _ref$y === void 0 ? 0 : _ref$y,
      length = _ref.length,
      ticksPosition = _ref.ticksPosition,
      tickValues = _ref.tickValues,
      _ref$tickSize = _ref.tickSize,
      tickSize = _ref$tickSize === void 0 ? 5 : _ref$tickSize,
      _ref$tickPadding = _ref.tickPadding,
      tickPadding = _ref$tickPadding === void 0 ? 5 : _ref$tickPadding,
      _ref$tickRotation = _ref.tickRotation,
      tickRotation = _ref$tickRotation === void 0 ? 0 : _ref$tickRotation,
      _format = _ref.format,
      legend = _ref.legend,
      _ref$legendPosition = _ref.legendPosition,
      legendPosition = _ref$legendPosition === void 0 ? 'end' : _ref$legendPosition,
      _ref$legendOffset = _ref.legendOffset,
      legendOffset = _ref$legendOffset === void 0 ? 0 : _ref$legendOffset,
      theme = _ref.theme;

  var _computeCartesianTick = computeCartesianTicks({
    axis: axis,
    scale: scale,
    ticksPosition: ticksPosition,
    tickValues: tickValues,
    tickSize: tickSize,
    tickPadding: tickPadding,
    tickRotation: tickRotation,
    engine: 'canvas'
  }),
      ticks = _computeCartesianTick.ticks,
      textAlign = _computeCartesianTick.textAlign,
      textBaseline = _computeCartesianTick.textBaseline;

  ctx.save();
  ctx.translate(x, y);
  ctx.textAlign = textAlign;
  ctx.textBaseline = textBaseline;
  ctx.font = "".concat(theme.axis.ticks.text.fontSize, "px ").concat(theme.axis.ticks.text.fontFamily);

  if (((_theme$axis$domain$li = theme.axis.domain.line.strokeWidth) !== null && _theme$axis$domain$li !== void 0 ? _theme$axis$domain$li : 0) > 0) {
    ctx.lineWidth = Number(theme.axis.domain.line.strokeWidth);
    ctx.lineCap = 'square';

    if (theme.axis.domain.line.stroke) {
      ctx.strokeStyle = theme.axis.domain.line.stroke;
    }

    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(axis === 'x' ? length : 0, axis === 'x' ? 0 : length);
    ctx.stroke();
  }

  var format = typeof _format === 'function' ? _format : function (value) {
    return "".concat(value);
  };
  ticks.forEach(function (tick) {
    var _theme$axis$ticks$lin;

    if (((_theme$axis$ticks$lin = theme.axis.ticks.line.strokeWidth) !== null && _theme$axis$ticks$lin !== void 0 ? _theme$axis$ticks$lin : 0) > 0) {
      ctx.lineWidth = Number(theme.axis.ticks.line.strokeWidth);
      ctx.lineCap = 'square';

      if (theme.axis.ticks.line.stroke) {
        ctx.strokeStyle = theme.axis.ticks.line.stroke;
      }

      ctx.beginPath();
      ctx.moveTo(tick.x, tick.y);
      ctx.lineTo(tick.x + tick.lineX, tick.y + tick.lineY);
      ctx.stroke();
    }

    var value = format(tick.value);
    ctx.save();
    ctx.translate(tick.x + tick.textX, tick.y + tick.textY);
    ctx.rotate(degreesToRadians(tickRotation));

    if (theme.axis.ticks.text.fill) {
      ctx.fillStyle = theme.axis.ticks.text.fill;
    }

    ctx.fillText(String(value), 0, 0);
    ctx.restore();
  });

  if (legend !== undefined) {
    var legendX = 0;
    var legendY = 0;
    var legendRotation = 0;
    var _textAlign = 'center';

    if (axis === 'y') {
      legendRotation = -90;
      legendX = legendOffset;

      if (legendPosition === 'start') {
        _textAlign = 'start';
        legendY = length;
      } else if (legendPosition === 'middle') {
        _textAlign = 'center';
        legendY = length / 2;
      } else if (legendPosition === 'end') {
        _textAlign = 'end';
      }
    } else {
      legendY = legendOffset;

      if (legendPosition === 'start') {
        _textAlign = 'start';
      } else if (legendPosition === 'middle') {
        _textAlign = 'center';
        legendX = length / 2;
      } else if (legendPosition === 'end') {
        _textAlign = 'end';
        legendX = length;
      }
    }

    ctx.translate(legendX, legendY);
    ctx.rotate(degreesToRadians(legendRotation));
    ctx.font = "".concat(theme.axis.legend.text.fontWeight ? "".concat(theme.axis.legend.text.fontWeight, " ") : '').concat(theme.axis.legend.text.fontSize, "px ").concat(theme.axis.legend.text.fontFamily);

    if (theme.axis.legend.text.fill) {
      ctx.fillStyle = theme.axis.legend.text.fill;
    }

    ctx.textAlign = _textAlign;
    ctx.textBaseline = 'middle';
    ctx.fillText(legend, 0, 0);
  }

  ctx.restore();
};
var renderAxesToCanvas = function renderAxesToCanvas(ctx, _ref2) {
  var xScale = _ref2.xScale,
      yScale = _ref2.yScale,
      width = _ref2.width,
      height = _ref2.height,
      top = _ref2.top,
      right = _ref2.right,
      bottom = _ref2.bottom,
      left = _ref2.left,
      theme = _ref2.theme;
  var axes = {
    top: top,
    right: right,
    bottom: bottom,
    left: left
  };
  positions$1.forEach(function (position) {
    var axis = axes[position];
    if (!axis) return null;
    var isXAxis = position === 'top' || position === 'bottom';
    var ticksPosition = position === 'top' || position === 'left' ? 'before' : 'after';
    var scale = isXAxis ? xScale : yScale;
    var format = getFormatter(axis.format, scale);
    renderAxisToCanvas(ctx, _objectSpread2$6(_objectSpread2$6({}, axis), {}, {
      axis: isXAxis ? 'x' : 'y',
      x: position === 'right' ? width : 0,
      y: position === 'bottom' ? height : 0,
      scale: scale,
      format: format,
      length: isXAxis ? width : height,
      ticksPosition: ticksPosition,
      theme: theme
    }));
  });
};
var renderGridLinesToCanvas = function renderGridLinesToCanvas(ctx, _ref3) {
  var width = _ref3.width,
      height = _ref3.height,
      scale = _ref3.scale,
      axis = _ref3.axis,
      values = _ref3.values;
  var lines = computeGridLines({
    width: width,
    height: height,
    scale: scale,
    axis: axis,
    values: values
  });
  lines.forEach(function (line) {
    ctx.beginPath();
    ctx.moveTo(line.x1, line.y1);
    ctx.lineTo(line.x2, line.y2);
    ctx.stroke();
  });
};

var baseGetTag$5 = _baseGetTag$1,
    isObjectLike$8 = isObjectLike_1$1;

/** `Object#toString` result references. */
var numberTag$5 = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike$8(value) && baseGetTag$5(value) == numberTag$5);
}

var isNumber_1 = isNumber;

var isNumber$1 = /*@__PURE__*/getDefaultExportFromCjs(isNumber_1);

function _defineProperty$7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$a(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$a(Object(source), true).forEach(function (key) {
        _defineProperty$7(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$a(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

function _arrayWithHoles$5(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$5(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray$5(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray$5(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen);
}

function _nonIterableRest$5() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$5(arr, i) {
  return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$5();
}

var DIRECTION_ROW = 'row';
var DIRECTION_COLUMN = 'column';
var ANCHOR_TOP = 'top';
var ANCHOR_TOP_RIGHT = 'top-right';
var ANCHOR_RIGHT = 'right';
var ANCHOR_BOTTOM_RIGHT = 'bottom-right';
var ANCHOR_BOTTOM = 'bottom';
var ANCHOR_BOTTOM_LEFT = 'bottom-left';
var ANCHOR_LEFT = 'left';
var ANCHOR_TOP_LEFT = 'top-left';
var ANCHOR_CENTER = 'center';
var DIRECTION_LEFT_TO_RIGHT = 'left-to-right';
var DIRECTION_RIGHT_TO_LEFT = 'right-to-left';
var DIRECTION_TOP_TO_BOTTOM = 'top-to-bottom';
var DIRECTION_BOTTOM_TO_TOP = 'bottom-to-top';

var legendEffectPropType = PropTypes.shape({
  on: PropTypes.oneOfType([PropTypes.oneOf(['hover'])]).isRequired,
  style: PropTypes.shape({
    itemTextColor: PropTypes.string,
    itemBackground: PropTypes.string,
    itemOpacity: PropTypes.number,
    symbolSize: PropTypes.number,
    symbolBorderWidth: PropTypes.number,
    symbolBorderColor: PropTypes.string
  }).isRequired
});
var symbolPropTypes = {
  symbolShape: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  symbolSize: PropTypes.number,
  symbolSpacing: PropTypes.number,
  symbolBorderWidth: PropTypes.number,
  symbolBorderColor: PropTypes.string
};
var interactivityPropTypes = {
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func
};
var datumPropType = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  color: PropTypes.string.isRequired,
  fill: PropTypes.string
});
var LegendPropShape = _objectSpread2$5(_objectSpread2$5(_objectSpread2$5({
  data: PropTypes.arrayOf(datumPropType),
  anchor: PropTypes.oneOf([ANCHOR_TOP, ANCHOR_TOP_RIGHT, ANCHOR_RIGHT, ANCHOR_BOTTOM_RIGHT, ANCHOR_BOTTOM, ANCHOR_BOTTOM_LEFT, ANCHOR_LEFT, ANCHOR_TOP_LEFT, ANCHOR_CENTER]).isRequired,
  translateX: PropTypes.number,
  translateY: PropTypes.number,
  direction: PropTypes.oneOf([DIRECTION_ROW, DIRECTION_COLUMN]).isRequired,
  itemsSpacing: PropTypes.number,
  itemWidth: PropTypes.number.isRequired,
  itemHeight: PropTypes.number.isRequired,
  itemDirection: PropTypes.oneOf([DIRECTION_LEFT_TO_RIGHT, DIRECTION_RIGHT_TO_LEFT, DIRECTION_TOP_TO_BOTTOM, DIRECTION_BOTTOM_TO_TOP]),
  itemTextColor: PropTypes.string,
  itemBackground: PropTypes.string,
  itemOpacity: PropTypes.number
}, symbolPropTypes), interactivityPropTypes), {}, {
  effects: PropTypes.arrayOf(legendEffectPropType)
});

var zeroPadding = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0
};
var computeDimensions = function computeDimensions(_ref) {
  var direction = _ref.direction,
      itemsSpacing = _ref.itemsSpacing,
      _padding = _ref.padding,
      itemCount = _ref.itemCount,
      itemWidth = _ref.itemWidth,
      itemHeight = _ref.itemHeight;
  var padding;
  if (isNumber$1(_padding)) {
    padding = {
      top: _padding,
      right: _padding,
      bottom: _padding,
      left: _padding
    };
  } else if (isPlainObject$3(_padding)) {
    padding = _objectSpread2$5(_objectSpread2$5({}, zeroPadding), _padding);
  } else {
    throw new TypeError("Invalid property padding, must be one of: number, object");
  }
  var horizontalPadding = padding.left + padding.right;
  var verticalPadding = padding.top + padding.bottom;
  var width = itemWidth + horizontalPadding;
  var height = itemHeight + verticalPadding;
  var spacing = (itemCount - 1) * itemsSpacing;
  if (direction === DIRECTION_ROW) {
    width = itemWidth * itemCount + spacing + horizontalPadding;
  } else if (direction === DIRECTION_COLUMN) {
    height = itemHeight * itemCount + spacing + verticalPadding;
  }
  return {
    width: width,
    height: height,
    padding: padding
  };
};
var computePositionFromAnchor = function computePositionFromAnchor(_ref2) {
  var anchor = _ref2.anchor,
      translateX = _ref2.translateX,
      translateY = _ref2.translateY,
      containerWidth = _ref2.containerWidth,
      containerHeight = _ref2.containerHeight,
      width = _ref2.width,
      height = _ref2.height;
  var x = translateX;
  var y = translateY;
  switch (anchor) {
    case ANCHOR_TOP:
      x += (containerWidth - width) / 2;
      break;
    case ANCHOR_TOP_RIGHT:
      x += containerWidth - width;
      break;
    case ANCHOR_RIGHT:
      x += containerWidth - width;
      y += (containerHeight - height) / 2;
      break;
    case ANCHOR_BOTTOM_RIGHT:
      x += containerWidth - width;
      y += containerHeight - height;
      break;
    case ANCHOR_BOTTOM:
      x += (containerWidth - width) / 2;
      y += containerHeight - height;
      break;
    case ANCHOR_BOTTOM_LEFT:
      y += containerHeight - height;
      break;
    case ANCHOR_LEFT:
      y += (containerHeight - height) / 2;
      break;
    case ANCHOR_CENTER:
      x += (containerWidth - width) / 2;
      y += (containerHeight - height) / 2;
      break;
  }
  return {
    x: x,
    y: y
  };
};
var computeItemLayout = function computeItemLayout(_ref3) {
  var direction = _ref3.direction,
      justify = _ref3.justify,
      symbolSize = _ref3.symbolSize,
      symbolSpacing = _ref3.symbolSpacing,
      width = _ref3.width,
      height = _ref3.height;
  var symbolX;
  var symbolY;
  var labelX;
  var labelY;
  var labelAnchor;
  var labelAlignment;
  switch (direction) {
    case DIRECTION_LEFT_TO_RIGHT:
      symbolX = 0;
      symbolY = (height - symbolSize) / 2;
      labelY = height / 2;
      labelAlignment = 'central';
      if (justify === true) {
        labelX = width;
        labelAnchor = 'end';
      } else {
        labelX = symbolSize + symbolSpacing;
        labelAnchor = 'start';
      }
      break;
    case DIRECTION_RIGHT_TO_LEFT:
      symbolX = width - symbolSize;
      symbolY = (height - symbolSize) / 2;
      labelY = height / 2;
      labelAlignment = 'central';
      if (justify === true) {
        labelX = 0;
        labelAnchor = 'start';
      } else {
        labelX = width - symbolSize - symbolSpacing;
        labelAnchor = 'end';
      }
      break;
    case DIRECTION_TOP_TO_BOTTOM:
      symbolX = (width - symbolSize) / 2;
      symbolY = 0;
      labelX = width / 2;
      labelAnchor = 'middle';
      if (justify === true) {
        labelY = height;
        labelAlignment = 'alphabetic';
      } else {
        labelY = symbolSize + symbolSpacing;
        labelAlignment = 'text-before-edge';
      }
      break;
    case DIRECTION_BOTTOM_TO_TOP:
      symbolX = (width - symbolSize) / 2;
      symbolY = height - symbolSize;
      labelX = width / 2;
      labelAnchor = 'middle';
      if (justify === true) {
        labelY = 0;
        labelAlignment = 'text-before-edge';
      } else {
        labelY = height - symbolSize - symbolSpacing;
        labelAlignment = 'alphabetic';
      }
      break;
  }
  return {
    symbolX: symbolX,
    symbolY: symbolY,
    labelX: labelX,
    labelY: labelY,
    labelAnchor: labelAnchor,
    labelAlignment: labelAlignment
  };
};

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}

function _inherits$2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$2(o) {
  _getPrototypeOf$2 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$2(o);
}

function _isNativeReflectConstruct$2() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _typeof$1(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof$1(obj);
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _possibleConstructorReturn$2(self, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized$1(self);
}

function _createSuper$2(Derived) {
  return function () {
    var Super = _getPrototypeOf$2(Derived),
        result;
    if (_isNativeReflectConstruct$2()) {
      var NewTarget = _getPrototypeOf$2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$2(this, result);
  };
}

({
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  size: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  borderWidth: PropTypes.number.isRequired,
  borderColor: PropTypes.string.isRequired
});
var symbolDefaultProps = {
  borderWidth: 0,
  borderColor: 'transparent'
};

var SymbolCircle = function (_PureComponent) {
  _inherits$2(SymbolCircle, _PureComponent);
  var _super = _createSuper$2(SymbolCircle);
  function SymbolCircle() {
    _classCallCheck$1(this, SymbolCircle);
    return _super.apply(this, arguments);
  }
  _createClass$1(SymbolCircle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          size = _this$props.size,
          fill = _this$props.fill,
          borderWidth = _this$props.borderWidth,
          borderColor = _this$props.borderColor;
      return React__default.createElement("circle", {
        r: size / 2,
        cx: x + size / 2,
        cy: y + size / 2,
        fill: fill,
        strokeWidth: borderWidth,
        stroke: borderColor,
        style: {
          pointerEvents: 'none'
        }
      });
    }
  }]);
  return SymbolCircle;
}(PureComponent);
SymbolCircle.defaultProps = _objectSpread2$5({}, symbolDefaultProps);

var SymbolDiamond = function (_PureComponent) {
  _inherits$2(SymbolDiamond, _PureComponent);
  var _super = _createSuper$2(SymbolDiamond);
  function SymbolDiamond() {
    _classCallCheck$1(this, SymbolDiamond);
    return _super.apply(this, arguments);
  }
  _createClass$1(SymbolDiamond, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          size = _this$props.size,
          fill = _this$props.fill,
          borderWidth = _this$props.borderWidth,
          borderColor = _this$props.borderColor;
      return React__default.createElement("g", {
        transform: "translate(".concat(x, ",").concat(y, ")")
      }, React__default.createElement("path", {
        d: "\n                    M".concat(size / 2, " 0\n                    L").concat(size * 0.8, " ").concat(size / 2, "\n                    L").concat(size / 2, " ").concat(size, "\n                    L").concat(size * 0.2, " ").concat(size / 2, "\n                    L").concat(size / 2, " 0\n                "),
        fill: fill,
        strokeWidth: borderWidth,
        stroke: borderColor,
        style: {
          pointerEvents: 'none'
        }
      }));
    }
  }]);
  return SymbolDiamond;
}(PureComponent);
SymbolDiamond.defaultProps = _objectSpread2$5({}, symbolDefaultProps);

var SymbolSquare = function (_PureComponent) {
  _inherits$2(SymbolSquare, _PureComponent);
  var _super = _createSuper$2(SymbolSquare);
  function SymbolSquare() {
    _classCallCheck$1(this, SymbolSquare);
    return _super.apply(this, arguments);
  }
  _createClass$1(SymbolSquare, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          size = _this$props.size,
          fill = _this$props.fill,
          borderWidth = _this$props.borderWidth,
          borderColor = _this$props.borderColor;
      return React__default.createElement("rect", {
        x: x,
        y: y,
        fill: fill,
        strokeWidth: borderWidth,
        stroke: borderColor,
        width: size,
        height: size,
        style: {
          pointerEvents: 'none'
        }
      });
    }
  }]);
  return SymbolSquare;
}(PureComponent);
SymbolSquare.defaultProps = _objectSpread2$5({}, symbolDefaultProps);

var SymbolTriangle = function (_PureComponent) {
  _inherits$2(SymbolTriangle, _PureComponent);
  var _super = _createSuper$2(SymbolTriangle);
  function SymbolTriangle() {
    _classCallCheck$1(this, SymbolTriangle);
    return _super.apply(this, arguments);
  }
  _createClass$1(SymbolTriangle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          x = _this$props.x,
          y = _this$props.y,
          size = _this$props.size,
          fill = _this$props.fill,
          borderWidth = _this$props.borderWidth,
          borderColor = _this$props.borderColor;
      return React__default.createElement("g", {
        transform: "translate(".concat(x, ",").concat(y, ")")
      }, React__default.createElement("path", {
        d: "\n                M".concat(size / 2, " 0\n                L").concat(size, " ").concat(size, "\n                L0 ").concat(size, "\n                L").concat(size / 2, " 0\n            "),
        fill: fill,
        strokeWidth: borderWidth,
        stroke: borderColor,
        style: {
          pointerEvents: 'none'
        }
      }));
    }
  }]);
  return SymbolTriangle;
}(PureComponent);
SymbolTriangle.defaultProps = _objectSpread2$5({}, symbolDefaultProps);

var symbolByShape = {
  circle: SymbolCircle,
  diamond: SymbolDiamond,
  square: SymbolSquare,
  triangle: SymbolTriangle
};
var LegendSvgItem = function LegendSvgItem(_ref) {
  var x = _ref.x,
      y = _ref.y,
      width = _ref.width,
      height = _ref.height,
      data = _ref.data,
      direction = _ref.direction,
      justify = _ref.justify,
      textColor = _ref.textColor,
      background = _ref.background,
      opacity = _ref.opacity,
      symbolShape = _ref.symbolShape,
      symbolSize = _ref.symbolSize,
      symbolSpacing = _ref.symbolSpacing,
      symbolBorderWidth = _ref.symbolBorderWidth,
      symbolBorderColor = _ref.symbolBorderColor,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      effects = _ref.effects;
  var _useState = useState({}),
      _useState2 = _slicedToArray$5(_useState, 2),
      style = _useState2[0],
      setStyle = _useState2[1];
  var theme = useTheme();
  var handleClick = useCallback$1(function (event) {
    return onClick && onClick(data, event);
  }, [onClick, data]);
  var handleMouseEnter = useCallback$1(function (event) {
    if (effects.length > 0) {
      var applyEffects = effects.filter(function (_ref2) {
        var on = _ref2.on;
        return on === 'hover';
      });
      var _style = applyEffects.reduce(function (acc, effect) {
        return _objectSpread2$5(_objectSpread2$5({}, acc), effect.style);
      }, {});
      setStyle(_style);
    }
    if (onMouseEnter === undefined) return;
    onMouseEnter(data, event);
  }, [onMouseEnter, data, effects]);
  var handleMouseLeave = useCallback$1(function (event) {
    if (effects.length > 0) {
      var applyEffects = effects.filter(function (_ref3) {
        var on = _ref3.on;
        return on !== 'hover';
      });
      var _style2 = applyEffects.reduce(function (acc, effect) {
        return _objectSpread2$5(_objectSpread2$5({}, acc), effect.style);
      }, {});
      setStyle(_style2);
    }
    if (onMouseLeave === undefined) return;
    onMouseLeave(data, event);
  }, [onMouseLeave, data, effects]);
  var _computeItemLayout = computeItemLayout({
    direction: direction,
    justify: justify,
    symbolSize: style.symbolSize || symbolSize,
    symbolSpacing: symbolSpacing,
    width: width,
    height: height
  }),
      symbolX = _computeItemLayout.symbolX,
      symbolY = _computeItemLayout.symbolY,
      labelX = _computeItemLayout.labelX,
      labelY = _computeItemLayout.labelY,
      labelAnchor = _computeItemLayout.labelAnchor,
      labelAlignment = _computeItemLayout.labelAlignment;
  var isInteractive = [onClick, onMouseEnter, onMouseLeave].some(function (handler) {
    return handler !== undefined;
  });
  var Symbol;
  if (isFunction$7(symbolShape)) {
    Symbol = symbolShape;
  } else {
    Symbol = symbolByShape[symbolShape];
  }
  return React__default.createElement("g", {
    transform: "translate(".concat(x, ",").concat(y, ")"),
    style: {
      opacity: style.itemOpacity !== undefined ? style.itemOpacity : opacity
    }
  }, React__default.createElement("rect", {
    width: width,
    height: height,
    fill: style.itemBackground || background,
    style: {
      cursor: isInteractive ? 'pointer' : 'auto'
    },
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }), React__default.createElement(Symbol, {
    id: data.id,
    x: symbolX,
    y: symbolY,
    size: style.symbolSize || symbolSize,
    fill: data.fill || data.color,
    borderWidth: style.symbolBorderWidth !== undefined ? style.symbolBorderWidth : symbolBorderWidth,
    borderColor: style.symbolBorderColor || symbolBorderColor
  }), React__default.createElement("text", {
    textAnchor: labelAnchor,
    style: _objectSpread2$5(_objectSpread2$5({}, theme.legends.text), {}, {
      fill: style.itemTextColor || theme.legends.text.fill || textColor,
      dominantBaseline: labelAlignment,
      pointerEvents: 'none',
      userSelect: 'none'
    }),
    x: labelX,
    y: labelY
  }, data.label));
};
LegendSvgItem.displayName = 'LegendSvgItem';
LegendSvgItem.defaultProps = {
  direction: 'left-to-right',
  justify: false,
  textColor: 'black',
  background: 'transparent',
  opacity: 1,
  symbolShape: 'square',
  symbolSize: 16,
  symbolSpacing: 8,
  symbolBorderWidth: 0,
  symbolBorderColor: 'transparent',
  effects: []
};

var LegendSvg = function LegendSvg(_ref) {
  var data = _ref.data,
      x = _ref.x,
      y = _ref.y,
      direction = _ref.direction,
      _padding = _ref.padding,
      justify = _ref.justify,
      effects = _ref.effects,
      itemWidth = _ref.itemWidth,
      itemHeight = _ref.itemHeight,
      itemDirection = _ref.itemDirection,
      itemsSpacing = _ref.itemsSpacing,
      itemTextColor = _ref.itemTextColor,
      itemBackground = _ref.itemBackground,
      itemOpacity = _ref.itemOpacity,
      symbolShape = _ref.symbolShape,
      symbolSize = _ref.symbolSize,
      symbolSpacing = _ref.symbolSpacing,
      symbolBorderWidth = _ref.symbolBorderWidth,
      symbolBorderColor = _ref.symbolBorderColor,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave;
  var _computeDimensions = computeDimensions({
    itemCount: data.length,
    itemWidth: itemWidth,
    itemHeight: itemHeight,
    itemsSpacing: itemsSpacing,
    direction: direction,
    padding: _padding
  }),
      padding = _computeDimensions.padding;
  var xStep = 0;
  var yStep = 0;
  if (direction === 'row') {
    xStep = itemWidth + itemsSpacing;
  } else if (direction === 'column') {
    yStep = itemHeight + itemsSpacing;
  }
  return React__default.createElement("g", {
    transform: "translate(".concat(x, ",").concat(y, ")")
  }, data.map(function (data, i) {
    return React__default.createElement(LegendSvgItem, {
      key: i,
      data: data,
      x: i * xStep + padding.left,
      y: i * yStep + padding.top,
      width: itemWidth,
      height: itemHeight,
      direction: itemDirection,
      justify: justify,
      effects: effects,
      textColor: itemTextColor,
      background: itemBackground,
      opacity: itemOpacity,
      symbolShape: symbolShape,
      symbolSize: symbolSize,
      symbolSpacing: symbolSpacing,
      symbolBorderWidth: symbolBorderWidth,
      symbolBorderColor: symbolBorderColor,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    });
  }));
};
LegendSvg.defaultProps = {
  padding: 0,
  justify: false,
  itemsSpacing: 0,
  itemDirection: 'left-to-right',
  itemTextColor: 'black',
  itemBackground: 'transparent',
  itemOpacity: 1
};

var BoxLegendSvg = function BoxLegendSvg(_ref) {
  var data = _ref.data,
      containerWidth = _ref.containerWidth,
      containerHeight = _ref.containerHeight,
      translateX = _ref.translateX,
      translateY = _ref.translateY,
      anchor = _ref.anchor,
      direction = _ref.direction,
      padding = _ref.padding,
      justify = _ref.justify,
      itemsSpacing = _ref.itemsSpacing,
      itemWidth = _ref.itemWidth,
      itemHeight = _ref.itemHeight,
      itemDirection = _ref.itemDirection,
      itemTextColor = _ref.itemTextColor,
      itemBackground = _ref.itemBackground,
      itemOpacity = _ref.itemOpacity,
      symbolShape = _ref.symbolShape,
      symbolSize = _ref.symbolSize,
      symbolSpacing = _ref.symbolSpacing,
      symbolBorderWidth = _ref.symbolBorderWidth,
      symbolBorderColor = _ref.symbolBorderColor,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      effects = _ref.effects;
  var _computeDimensions = computeDimensions({
    itemCount: data.length,
    itemsSpacing: itemsSpacing,
    itemWidth: itemWidth,
    itemHeight: itemHeight,
    direction: direction,
    padding: padding
  }),
      width = _computeDimensions.width,
      height = _computeDimensions.height;
  var _computePositionFromA = computePositionFromAnchor({
    anchor: anchor,
    translateX: translateX,
    translateY: translateY,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    width: width,
    height: height
  }),
      x = _computePositionFromA.x,
      y = _computePositionFromA.y;
  return React__default.createElement(LegendSvg, {
    data: data,
    x: x,
    y: y,
    direction: direction,
    padding: padding,
    justify: justify,
    effects: effects,
    itemsSpacing: itemsSpacing,
    itemWidth: itemWidth,
    itemHeight: itemHeight,
    itemDirection: itemDirection,
    itemTextColor: itemTextColor,
    itemBackground: itemBackground,
    itemOpacity: itemOpacity,
    symbolShape: symbolShape,
    symbolSize: symbolSize,
    symbolSpacing: symbolSpacing,
    symbolBorderWidth: symbolBorderWidth,
    symbolBorderColor: symbolBorderColor,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  });
};
BoxLegendSvg.defaultProps = {
  translateX: 0,
  translateY: 0,
  itemsSpacing: LegendSvg.defaultProps.itemsSpacing,
  padding: LegendSvg.defaultProps.padding
};

var textPropsMapping = {
  align: {
    start: 'left',
    middle: 'center',
    end: 'right'
  },
  baseline: {
    hanging: 'top',
    middle: 'middle',
    central: 'middle',
    baseline: 'bottom'
  }
};
var renderLegendToCanvas = function renderLegendToCanvas(ctx, _ref) {
  var data = _ref.data,
      containerWidth = _ref.containerWidth,
      containerHeight = _ref.containerHeight,
      _ref$translateX = _ref.translateX,
      translateX = _ref$translateX === void 0 ? BoxLegendSvg.defaultProps.translateX : _ref$translateX,
      _ref$translateY = _ref.translateY,
      translateY = _ref$translateY === void 0 ? BoxLegendSvg.defaultProps.translateY : _ref$translateY,
      anchor = _ref.anchor,
      direction = _ref.direction,
      _ref$padding = _ref.padding,
      _padding = _ref$padding === void 0 ? LegendSvg.defaultProps.padding : _ref$padding,
      _ref$justify = _ref.justify,
      justify = _ref$justify === void 0 ? LegendSvgItem.defaultProps.justify : _ref$justify,
      _ref$itemsSpacing = _ref.itemsSpacing,
      itemsSpacing = _ref$itemsSpacing === void 0 ? LegendSvg.defaultProps.itemsSpacing : _ref$itemsSpacing,
      itemWidth = _ref.itemWidth,
      itemHeight = _ref.itemHeight,
      _ref$itemDirection = _ref.itemDirection,
      itemDirection = _ref$itemDirection === void 0 ? LegendSvgItem.defaultProps.direction : _ref$itemDirection,
      _ref$itemTextColor = _ref.itemTextColor,
      itemTextColor = _ref$itemTextColor === void 0 ? LegendSvg.defaultProps.textColor : _ref$itemTextColor,
      _ref$symbolSize = _ref.symbolSize,
      symbolSize = _ref$symbolSize === void 0 ? LegendSvgItem.defaultProps.symbolSize : _ref$symbolSize,
      _ref$symbolSpacing = _ref.symbolSpacing,
      symbolSpacing = _ref$symbolSpacing === void 0 ? LegendSvgItem.defaultProps.symbolSpacing : _ref$symbolSpacing,
      theme = _ref.theme;
  var _computeDimensions = computeDimensions({
    itemCount: data.length,
    itemWidth: itemWidth,
    itemHeight: itemHeight,
    itemsSpacing: itemsSpacing,
    direction: direction,
    padding: _padding
  }),
      width = _computeDimensions.width,
      height = _computeDimensions.height,
      padding = _computeDimensions.padding;
  var _computePositionFromA = computePositionFromAnchor({
    anchor: anchor,
    translateX: translateX,
    translateY: translateY,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    width: width,
    height: height
  }),
      x = _computePositionFromA.x,
      y = _computePositionFromA.y;
  var xStep = 0;
  var yStep = 0;
  if (direction === DIRECTION_ROW) {
    xStep = itemWidth + itemsSpacing;
  } else if (direction === DIRECTION_COLUMN) {
    yStep = itemHeight + itemsSpacing;
  }
  ctx.save();
  ctx.translate(x, y);
  ctx.font = "".concat(theme.legends.text.fontSize, "px ").concat(theme.legends.text.fontFamily || 'sans-serif');
  data.forEach(function (d, i) {
    var itemX = i * xStep + padding.left;
    var itemY = i * yStep + padding.top;
    var _computeItemLayout = computeItemLayout({
      direction: itemDirection,
      justify: justify,
      symbolSize: symbolSize,
      symbolSpacing: symbolSpacing,
      width: itemWidth,
      height: itemHeight
    }),
        symbolX = _computeItemLayout.symbolX,
        symbolY = _computeItemLayout.symbolY,
        labelX = _computeItemLayout.labelX,
        labelY = _computeItemLayout.labelY,
        labelAnchor = _computeItemLayout.labelAnchor,
        labelAlignment = _computeItemLayout.labelAlignment;
    ctx.fillStyle = d.color;
    ctx.fillRect(itemX + symbolX, itemY + symbolY, symbolSize, symbolSize);
    ctx.textAlign = textPropsMapping.align[labelAnchor];
    ctx.textBaseline = textPropsMapping.baseline[labelAlignment];
    ctx.fillStyle = itemTextColor || theme.legends.text.fill;
    ctx.fillText(d.label, itemX + labelX, itemY + labelY);
  });
  ctx.restore();
};

function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newDate(y, m, d) {
  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "g": formatYearISO,
    "G": formatFullYearISO,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "q": formatQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "g": formatUTCYearISO,
    "G": formatUTCFullYearISO,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "q": formatUTCQuarter,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "g": parseYear$1,
    "G": parseFullYear,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "q": parseQuarter,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear$1,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, Z) {
    return function(string) {
      var d = newDate(1900, undefined, 1),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);
      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));

      // If this is utcParse, never use the local timezone.
      if (Z && !("Z" in d)) d.Z = 0;

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // If the month was not specified, inherit from the quarter.
      if (d.m === undefined) d.m = "q" in d ? d.q : 0;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? utcMonday.ceil(week) : utcMonday(week);
          week = utcDay$1.offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
          week = day > 4 || day === 0 ? monday.ceil(week) : monday(week);
          week = timeDay.offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return localDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatQuarter(d) {
    return 1 + ~~(d.getMonth() / 3);
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  function formatUTCQuarter(d) {
    return 1 + ~~(d.getUTCMonth() / 3);
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", false);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier += "", true);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear$1(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseQuarter(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.s = +n[0], i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + timeDay.count(timeYear(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(sunday.count(timeYear(d) - 1, d), p, 2);
}

function dISO(d) {
  var day = d.getDay();
  return (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
}

function formatWeekNumberISO(d, p) {
  d = dISO(d);
  return pad(thursday.count(timeYear(d), d) + (timeYear(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(monday.count(timeYear(d) - 1, d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatYearISO(d, p) {
  d = dISO(d);
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatFullYearISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? thursday(d) : thursday.ceil(d);
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + utcDay$1.count(utcYear$1(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(utcSunday.count(utcYear$1(d) - 1, d), p, 2);
}

function UTCdISO(d) {
  var day = d.getUTCDay();
  return (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
}

function formatUTCWeekNumberISO(d, p) {
  d = UTCdISO(d);
  return pad(utcThursday.count(utcYear$1(d), d) + (utcYear$1(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(utcMonday.count(utcYear$1(d) - 1, d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCYearISO(d, p) {
  d = UTCdISO(d);
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCFullYearISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? utcThursday(d) : utcThursday.ceil(d);
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}

var locale$2P;
var timeParse;
var utcParse;

defaultLocale$1({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale$1(definition) {
  locale$2P = formatLocale(definition);
  locale$2P.format;
  timeParse = locale$2P.parse;
  locale$2P.utcFormat;
  utcParse = locale$2P.utcParse;
  return locale$2P;
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */

function noop$2() {
  // No operation performed.
}

var noop_1 = noop$2;

var Set$3 = _Set$1,
    noop$1 = noop_1,
    setToArray$1 = _setToArray;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet$1 = !(Set$3 && (1 / setToArray$1(new Set$3([,-0]))[1]) == INFINITY) ? noop$1 : function(values) {
  return new Set$3(values);
};

var _createSet = createSet$1;

var SetCache = _SetCache,
    arrayIncludes$1 = _arrayIncludes,
    arrayIncludesWith = _arrayIncludesWith,
    cacheHas = _cacheHas,
    createSet = _createSet,
    setToArray = _setToArray;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq$1(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes$1,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE$1) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseUniq = baseUniq$1;

var Stack$3 = _Stack$1,
    baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$3;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$7 = isObject_1$1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$7(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$7 = keys_1$1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$7(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var baseIsEqual = _baseIsEqual,
    get = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$2 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet$2 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$2(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey$1 = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity$1 = identity_1,
    isArray$7 = isArray_1$1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$3(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$1;
  }
  if (typeof value == 'object') {
    return isArray$7(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$3;

var baseIteratee$2 = _baseIteratee,
    baseUniq = _baseUniq;

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee$2(iteratee)) : [];
}

var uniqBy_1 = uniqBy;

var _uniqBy = /*@__PURE__*/getDefaultExportFromCjs(uniqBy_1);

var baseFor = _baseFor,
    keys$6 = keys_1$1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$1(object, iteratee) {
  return object && baseFor(object, iteratee, keys$6);
}

var _baseForOwn = baseForOwn$1;

var isArrayLike$4 = isArrayLike_1$1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$4(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$1;

var baseForOwn = _baseForOwn,
    createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$2 = createBaseEach(baseForOwn);

var _baseEach = baseEach$2;

var baseEach$1 = _baseEach,
    isArrayLike$3 = isArrayLike_1$1;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap$1(collection, iteratee) {
  var index = -1,
      result = isArrayLike$3(collection) ? Array(collection.length) : [];

  baseEach$1(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$1;

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */

function baseSortBy$1(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

var _baseSortBy = baseSortBy$1;

var isSymbol = isSymbol_1;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

var _compareAscending = compareAscending$1;

var compareAscending = _compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple$1(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

var _compareMultiple = compareMultiple$1;

var arrayMap$1 = _arrayMap,
    baseGet$1 = _baseGet,
    baseIteratee$1 = _baseIteratee,
    baseMap = _baseMap,
    baseSortBy = _baseSortBy,
    baseUnary$6 = _baseUnary$1,
    compareMultiple = _compareMultiple,
    identity = identity_1,
    isArray$6 = isArray_1$1;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap$1(iteratees, function(iteratee) {
      if (isArray$6(iteratee)) {
        return function(value) {
          return baseGet$1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap$1(iteratees, baseUnary$6(baseIteratee$1));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap$1(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy$1;

var baseFlatten = _baseFlatten,
    baseOrderBy = _baseOrderBy,
    baseRest = _baseRest,
    isIterateeCall = _isIterateeCall;

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

var nodeUtil$5 = _nodeUtilExports$1;

/* Node.js helper references. */
nodeUtil$5 && nodeUtil$5.isDate;

var linearScale = function linearScale(_ref, xy, width, height) {
  var axis = _ref.axis,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 0 : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 'auto' : _ref$max,
      _ref$stacked = _ref.stacked,
      stacked = _ref$stacked === void 0 ? false : _ref$stacked,
      _ref$reverse = _ref.reverse,
      reverse = _ref$reverse === void 0 ? false : _ref$reverse,
      _ref$clamp = _ref.clamp,
      clamp = _ref$clamp === void 0 ? false : _ref$clamp,
      _ref$nice = _ref.nice,
      nice = _ref$nice === void 0 ? false : _ref$nice;
  var values = xy[axis];
  var size = axis === 'x' ? width : height;
  var minValue = min;
  if (min === 'auto') {
    minValue = stacked === true ? values.minStacked : values.min;
  }
  var maxValue = max;
  if (max === 'auto') {
    maxValue = stacked === true ? values.maxStacked : values.max;
  }
  var scale = linear().rangeRound(axis === 'x' ? [0, size] : [size, 0]);
  if (reverse === true) scale.domain([maxValue, minValue]);else scale.domain([minValue, maxValue]);
  if (nice === true) scale.nice();else if (typeof nice === 'number') scale.nice(nice);
  scale.type = 'linear';
  scale.stacked = stacked;
  scale.clamp(clamp);
  return scale;
};
var linearScalePropTypes = {
  type: PropTypes.oneOf(['linear']).isRequired,
  min: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]),
  stacked: PropTypes.bool,
  reverse: PropTypes.bool,
  clamp: PropTypes.bool,
  nice: PropTypes.oneOfType([PropTypes.number, PropTypes.bool])
};

var logScale = function logScale(_ref, xy, width, height) {
  var axis = _ref.axis,
      _ref$base = _ref.base,
      base = _ref$base === void 0 ? 10 : _ref$base,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 'auto' : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 'auto' : _ref$max;
  var values = xy[axis];
  var size = axis === 'x' ? width : height;
  var hasZero = values.all.some(function (v) {
    return v === 0;
  });
  var sign;
  var hasMixedSign = false;
  values.all.filter(function (v) {
    return v != null;
  }).forEach(function (v) {
    if (hasMixedSign === true) return;
    if (sign === undefined) {
      sign = Math.sign(v);
    } else if (Math.sign(v) !== sign) {
      hasMixedSign = true;
    }
  });
  if (hasZero || hasMixedSign) {
    throw new Error(["a log scale domain must be strictly-positive or strictly-negative,", "and must not include or cross zero."].join('\n'));
  }
  var minValue = min;
  if (min === 'auto') {
    minValue = values.min;
  }
  var maxValue = max;
  if (max === 'auto') {
    maxValue = values.max;
  }
  var scale = log().domain([minValue, maxValue]).rangeRound(axis === 'x' ? [0, size] : [size, 0]).base(base).nice();
  scale.type = 'log';
  return scale;
};
var logScalePropTypes = {
  type: PropTypes.oneOf(['log']).isRequired,
  base: PropTypes.number,
  min: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number])
};

var symlogScale = function symlogScale(_ref, xy, width, height) {
  var axis = _ref.axis,
      _ref$constant = _ref.constant,
      constant = _ref$constant === void 0 ? 1 : _ref$constant,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 'auto' : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 'auto' : _ref$max;
  var values = xy[axis];
  var size = axis === 'x' ? width : height;
  var minValue = min;
  if (min === 'auto') {
    minValue = values.min;
  }
  var maxValue = max;
  if (max === 'auto') {
    maxValue = values.max;
  }
  var scale = symlog().domain([minValue, maxValue]).constant(constant).rangeRound(axis === 'x' ? [0, size] : [size, 0]).nice();
  scale.type = 'symlog';
  return scale;
};
var symLogScalePropTypes = {
  type: PropTypes.oneOf(['symlog']).isRequired,
  constant: PropTypes.number,
  min: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.oneOf(['auto']), PropTypes.number])
};

var pointScale = function pointScale(_ref, xy, width, height) {
  var axis = _ref.axis;
  var values = xy[axis];
  var size = axis === 'x' ? width : height;
  var scale = point$4().range([0, size]).domain(values.all);
  scale.type = 'point';
  return scale;
};
var pointScalePropTypes = {
  type: PropTypes.oneOf(['point']).isRequired
};

function _defineProperty$6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var _precisionCutOffsByTy;
var TIME_PRECISION_MILLISECOND = 'millisecond';
var TIME_PRECISION_SECOND = 'second';
var TIME_PRECISION_MINUTE = 'minute';
var TIME_PRECISION_HOUR = 'hour';
var TIME_PRECISION_DAY = 'day';
var TIME_PRECISION_MONTH = 'month';
var TIME_PRECISION_YEAR = 'year';
var timePrecisions = [TIME_PRECISION_MILLISECOND, TIME_PRECISION_SECOND, TIME_PRECISION_MINUTE, TIME_PRECISION_HOUR, TIME_PRECISION_DAY, TIME_PRECISION_MONTH, TIME_PRECISION_YEAR];
var precisionCutOffs = [function (date) {
  return date.setMilliseconds(0);
}, function (date) {
  return date.setSeconds(0);
}, function (date) {
  return date.setMinutes(0);
}, function (date) {
  return date.setHours(0);
}, function (date) {
  return date.setDate(1);
}, function (date) {
  return date.setMonth(0);
}];
var precisionCutOffsByType = (_precisionCutOffsByTy = {}, _defineProperty$6(_precisionCutOffsByTy, TIME_PRECISION_MILLISECOND, []), _defineProperty$6(_precisionCutOffsByTy, TIME_PRECISION_SECOND, precisionCutOffs.slice(0, 1)), _defineProperty$6(_precisionCutOffsByTy, TIME_PRECISION_MINUTE, precisionCutOffs.slice(0, 2)), _defineProperty$6(_precisionCutOffsByTy, TIME_PRECISION_HOUR, precisionCutOffs.slice(0, 3)), _defineProperty$6(_precisionCutOffsByTy, TIME_PRECISION_DAY, precisionCutOffs.slice(0, 4)), _defineProperty$6(_precisionCutOffsByTy, TIME_PRECISION_MONTH, precisionCutOffs.slice(0, 5)), _defineProperty$6(_precisionCutOffsByTy, TIME_PRECISION_YEAR, precisionCutOffs.slice(0, 6)), _precisionCutOffsByTy);
var createPrecisionMethod = function createPrecisionMethod(precision) {
  return function (date) {
    precisionCutOffsByType[precision].forEach(function (cutOff) {
      cutOff(date);
    });
    return date;
  };
};
var createDateNormalizer = function createDateNormalizer(_ref) {
  var _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'native' : _ref$format,
      _ref$precision = _ref.precision,
      precision = _ref$precision === void 0 ? 'millisecond' : _ref$precision,
      _ref$useUTC = _ref.useUTC,
      useUTC = _ref$useUTC === void 0 ? true : _ref$useUTC;
  var precisionFn = createPrecisionMethod(precision);
  if (format === 'native') return function (v) {
    return precisionFn(v);
  };
  var parseTime = useUTC ? utcParse(format) : timeParse(format);
  return function (v) {
    return precisionFn(parseTime(v));
  };
};

var timeScale = function timeScale(_ref, xy, width, height) {
  var axis = _ref.axis,
      _ref$format = _ref.format,
      format = _ref$format === void 0 ? 'native' : _ref$format,
      _ref$precision = _ref.precision,
      precision = _ref$precision === void 0 ? TIME_PRECISION_MILLISECOND : _ref$precision,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? 'auto' : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? 'auto' : _ref$max,
      _ref$useUTC = _ref.useUTC,
      useUTC = _ref$useUTC === void 0 ? true : _ref$useUTC,
      _ref$nice = _ref.nice,
      nice = _ref$nice === void 0 ? false : _ref$nice;
  var values = xy[axis];
  var size = axis === 'x' ? width : height;
  var normalize = createDateNormalizer({
    format: format,
    precision: precision,
    useUTC: useUTC
  });
  var minValue = min;
  if (min === 'auto') {
    minValue = values.min;
  } else if (format !== 'native') {
    minValue = normalize(min);
  }
  var maxValue = max;
  if (max === 'auto') {
    maxValue = values.max;
  } else if (format !== 'native') {
    maxValue = normalize(max);
  }
  var scale = useUTC ? utcTime() : time();
  scale.domain([minValue, maxValue]).range([0, size]);
  if (nice === true) scale.nice();else if (typeof nice === 'object' || typeof nice === 'number') scale.nice(nice);
  scale.type = 'time';
  scale.useUTC = useUTC;
  return scale;
};
var timeScalePropTypes = {
  type: PropTypes.oneOf(['time']).isRequired,
  format: PropTypes.string,
  precision: PropTypes.oneOf(timePrecisions),
  nice: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.object])
};

var bandScalePropTypes = {
  type: PropTypes.oneOf(['band']).isRequired,
  round: PropTypes.bool
};
var computeScale = function computeScale(spec, xy, width, height) {
  if (spec.type === 'linear') return linearScale(spec, xy, width, height);else if (spec.type === 'point') return pointScale(spec, xy, width, height);else if (spec.type === 'time') return timeScale(spec, xy, width, height);else if (spec.type === 'log') return logScale(spec, xy, width, height);else if (spec.type === 'symlog') return symlogScale(spec, xy, width, height);
};

var scalePropType = PropTypes.oneOfType([PropTypes.shape(linearScalePropTypes), PropTypes.shape(pointScalePropTypes), PropTypes.shape(timeScalePropTypes), PropTypes.shape(logScalePropTypes), PropTypes.shape(symLogScalePropTypes), PropTypes.shape(bandScalePropTypes)]);

var Motion = {exports: {}};

var mapToZero = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports['default'] = mapToZero;

	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}

	module.exports = exports['default']; 
} (mapToZero, mapToZero.exports));

var mapToZeroExports = mapToZero.exports;

var stripStyle = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports['default'] = stripStyle;

	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}

	module.exports = exports['default']; 
} (stripStyle, stripStyle.exports));

var stripStyleExports = stripStyle.exports;

var stepper = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports["default"] = stepper;

	var reusedTuple = [0, 0];

	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2

	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);

	  // Damping, in kg / s
	  var Fdamper = -b * v;

	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;

	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;

	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }

	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}

	module.exports = exports["default"];
	// array reference around. 
} (stepper, stepper.exports));

var stepperExports = stepper.exports;

var shouldStopAnimation = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;

	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }

	    if (currentVelocity[key] !== 0) {
	      return false;
	    }

	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }

	  return true;
	}

	module.exports = exports['default']; 
} (shouldStopAnimation, shouldStopAnimation.exports));

var shouldStopAnimationExports = shouldStopAnimation.exports;

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _mapToZero = mapToZeroExports;

	var _mapToZero2 = _interopRequireDefault(_mapToZero);

	var _stripStyle = stripStyleExports;

	var _stripStyle2 = _interopRequireDefault(_stripStyle);

	var _stepper3 = stepperExports;

	var _stepper4 = _interopRequireDefault(_stepper3);

	var _performanceNow = performanceNowExports$1;

	var _performanceNow2 = _interopRequireDefault(_performanceNow);

	var _raf = rafExports;

	var _raf2 = _interopRequireDefault(_raf);

	var _shouldStopAnimation = shouldStopAnimationExports;

	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

	var _react = React__default;

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = propTypesExports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var msPerFrame = 1000 / 60;

	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);

	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);

	  function Motion(props) {
	    var _this = this;

	    _classCallCheck(this, Motion);

	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;

	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;

	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }

	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }

	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }

	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };

	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }

	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }

	        _this.wasAnimating = true;

	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }

	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }

	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};

	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }

	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }

	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];

	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }

	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });

	        _this.unreadPropStyle = null;

	        _this.startAnimationIfNecessary();
	      });
	    };

	    this.state = this.defaultState();
	  }

	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;

	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };

	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400

	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };

	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }

	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };

	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };

	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };

	  return Motion;
	})(_react2['default'].Component);

	exports['default'] = Motion;
	module.exports = exports['default'];

	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config) 
} (Motion, Motion.exports));

var MotionExports = Motion.exports;

var StaggeredMotion = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _mapToZero = mapToZeroExports;

	var _mapToZero2 = _interopRequireDefault(_mapToZero);

	var _stripStyle = stripStyleExports;

	var _stripStyle2 = _interopRequireDefault(_stripStyle);

	var _stepper3 = stepperExports;

	var _stepper4 = _interopRequireDefault(_stepper3);

	var _performanceNow = performanceNowExports$1;

	var _performanceNow2 = _interopRequireDefault(_performanceNow);

	var _raf = rafExports;

	var _raf2 = _interopRequireDefault(_raf);

	var _shouldStopAnimation = shouldStopAnimationExports;

	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

	var _react = React__default;

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = propTypesExports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var msPerFrame = 1000 / 60;

	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}

	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);

	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);

	  function StaggeredMotion(props) {
	    var _this = this;

	    _classCallCheck(this, StaggeredMotion);

	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;

	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;

	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;

	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }

	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }

	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };

	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }

	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }

	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }

	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];

	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};

	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }

	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }

	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];

	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }

	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }

	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });

	        _this.unreadPropStyles = null;

	        _this.startAnimationIfNecessary();
	      });
	    };

	    this.state = this.defaultState();
	  }

	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;

	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };

	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };

	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }

	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };

	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };

	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };

	  return StaggeredMotion;
	})(_react2['default'].Component);

	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];

	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config) 
} (StaggeredMotion, StaggeredMotion.exports));

var StaggeredMotionExports = StaggeredMotion.exports;

var TransitionMotion = {exports: {}};

var mergeDiff = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports['default'] = mergeDiff;

	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster

	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }

	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }

	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];

	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev

	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }

	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}

	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care 
} (mergeDiff, mergeDiff.exports));

var mergeDiffExports = mergeDiff.exports;

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

	var _mapToZero = mapToZeroExports;

	var _mapToZero2 = _interopRequireDefault(_mapToZero);

	var _stripStyle = stripStyleExports;

	var _stripStyle2 = _interopRequireDefault(_stripStyle);

	var _stepper3 = stepperExports;

	var _stepper4 = _interopRequireDefault(_stepper3);

	var _mergeDiff = mergeDiffExports;

	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

	var _performanceNow = performanceNowExports$1;

	var _performanceNow2 = _interopRequireDefault(_performanceNow);

	var _raf = rafExports;

	var _raf2 = _interopRequireDefault(_raf);

	var _shouldStopAnimation = shouldStopAnimationExports;

	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

	var _react = React__default;

	var _react2 = _interopRequireDefault(_react);

	var _propTypes = propTypesExports;

	var _propTypes2 = _interopRequireDefault(_propTypes);

	var msPerFrame = 1000 / 60;

	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}

	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }

	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }

	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }

	  return true;
	}

	// core key merging logic

	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key

	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });

	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;

	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }

	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}

	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);

	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);

	  function TransitionMotion(props) {
	    var _this = this;

	    _classCallCheck(this, TransitionMotion);

	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;

	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];

	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;

	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }

	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }

	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };

	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }

	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }

	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }

	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }

	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }

	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];

	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};

	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }

	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }

	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];

	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }

	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }

	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });

	        _this.unreadPropStyles = null;

	        _this.startAnimationIfNecessary();
	      });
	    };

	    this.state = this.defaultState();
	  }

	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;

	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });

	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);

	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really

	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };

	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)

	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };

	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }

	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }

	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };

	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };

	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };

	  return TransitionMotion;
	})(_react2['default'].Component);

	exports['default'] = TransitionMotion;
	module.exports = exports['default'];

	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function

	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives

	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400 
} (TransitionMotion, TransitionMotion.exports));

var TransitionMotionExports = TransitionMotion.exports;

var spring = {exports: {}};

var presets = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"]; 
} (presets, presets.exports));

var presetsExports = presets.exports;

(function (module, exports) {

	exports.__esModule = true;

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	exports['default'] = spring;

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

	var _presets = presetsExports;

	var _presets2 = _interopRequireDefault(_presets);

	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});

	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}

	module.exports = exports['default']; 
} (spring, spring.exports));

var springExports = spring.exports;

var reorderKeys = {exports: {}};

(function (module, exports) {

	exports.__esModule = true;
	exports['default'] = reorderKeys;

	var hasWarned = false;

	function reorderKeys() {
	  if (process.env.NODE_ENV === 'development') {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}

	module.exports = exports['default']; 
} (reorderKeys, reorderKeys.exports));

var reorderKeysExports = reorderKeys.exports;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = MotionExports;

_interopRequire(_Motion);

var _StaggeredMotion = StaggeredMotionExports;

_interopRequire(_StaggeredMotion);

var _TransitionMotion = TransitionMotionExports;

_interopRequire(_TransitionMotion);

var _spring = springExports;

_interopRequire(_spring);

var _presets = presetsExports;

_interopRequire(_presets);

var _stripStyle = stripStyleExports;

_interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = reorderKeysExports;

_interopRequire(_reorderKeys);

function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$9(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$9(Object(source), true).forEach(function (key) {
        _defineProperty$5(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$9(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

var categoricalColorSchemes = {
  nivo: ['#e8c1a0', '#f47560', '#f1e15b', '#e8a838', '#61cdbb', '#97e3d5'],
  category10: schemeCategory10,
  accent: schemeAccent,
  dark2: schemeDark2,
  paired: schemePaired,
  pastel1: schemePastel1,
  pastel2: schemePastel2,
  set1: schemeSet1,
  set2: schemeSet2,
  set3: schemeSet3
};
var categoricalColorSchemeIds = Object.keys(categoricalColorSchemes);

var divergingColorSchemes = {
  brown_blueGreen: scheme$q,
  purpleRed_green: scheme$p,
  pink_yellowGreen: scheme$o,
  purple_orange: scheme$n,
  red_blue: scheme$m,
  red_grey: scheme$l,
  red_yellow_blue: scheme$k,
  red_yellow_green: scheme$j,
  spectral: scheme$i
};
var divergingColorSchemeIds = Object.keys(divergingColorSchemes);
var divergingColorInterpolators = {
  brown_blueGreen: interpolateBrBG,
  purpleRed_green: interpolatePRGn,
  pink_yellowGreen: interpolatePiYG,
  purple_orange: interpolatePuOr,
  red_blue: interpolateRdBu,
  red_grey: interpolateRdGy,
  red_yellow_blue: interpolateRdYlBu,
  red_yellow_green: interpolateRdYlGn,
  spectral: interpolateSpectral
};

var sequentialColorSchemes = {
  blues: scheme$5,
  greens: scheme$4,
  greys: scheme$3,
  oranges: scheme,
  purples: scheme$2,
  reds: scheme$1,
  blue_green: scheme$h,
  blue_purple: scheme$g,
  green_blue: scheme$f,
  orange_red: scheme$e,
  purple_blue_green: scheme$d,
  purple_blue: scheme$c,
  purple_red: scheme$b,
  red_purple: scheme$a,
  yellow_green_blue: scheme$9,
  yellow_green: scheme$8,
  yellow_orange_brown: scheme$7,
  yellow_orange_red: scheme$6
};
var sequentialColorSchemeIds = Object.keys(sequentialColorSchemes);
var sequentialColorInterpolators = {
  blues: interpolateBlues,
  greens: interpolateGreens,
  greys: interpolateGreys,
  oranges: interpolateOranges,
  purples: interpolatePurples,
  reds: interpolateReds,
  turbo: interpolateTurbo,
  viridis: interpolateViridis,
  inferno: inferno,
  magma: magma,
  plasma: plasma,
  cividis: interpolateCividis,
  warm: warm,
  cool: cool,
  cubehelixDefault: interpolateCubehelixDefault,
  blue_green: interpolateBuGn,
  blue_purple: interpolateBuPu,
  green_blue: interpolateGnBu,
  orange_red: interpolateOrRd,
  purple_blue_green: interpolatePuBuGn,
  purple_blue: interpolatePuBu,
  purple_red: interpolatePuRd,
  red_purple: interpolateRdPu,
  yellow_green_blue: interpolateYlGnBu,
  yellow_green: interpolateYlGn,
  yellow_orange_brown: interpolateYlOrBr,
  yellow_orange_red: interpolateYlOrRd
};

var colorSchemes = _objectSpread2$4(_objectSpread2$4(_objectSpread2$4({}, categoricalColorSchemes), divergingColorSchemes), sequentialColorSchemes);
var colorSchemeIds = Object.keys(colorSchemes);
var isCategoricalColorScheme = function isCategoricalColorScheme(scheme) {
  return categoricalColorSchemeIds.includes(scheme);
};
var isDivergingColorScheme = function isDivergingColorScheme(scheme) {
  return divergingColorSchemeIds.includes(scheme);
};
var isSequentialColorScheme = function isSequentialColorScheme(scheme) {
  return sequentialColorSchemeIds.includes(scheme);
};

var cyclicalColorInterpolators = {
  rainbow: interpolateRainbow,
  sinebow: interpolateSinebow
};

_objectSpread2$4(_objectSpread2$4(_objectSpread2$4({}, divergingColorInterpolators), sequentialColorInterpolators), cyclicalColorInterpolators);

function _arrayWithHoles$4(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$4(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray$4(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen);
}

function _nonIterableRest$4() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$4(arr, i) {
  return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$4();
}

function _createForOfIteratorHelper(o) {
  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (o = _unsupportedIterableToArray$4(o))) {
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var it,
      normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

var isInheritedColorConfigFromTheme = function isInheritedColorConfigFromTheme(config) {
  return config.theme !== undefined;
};

var isInheritedColorConfigFromContext = function isInheritedColorConfigFromContext(config) {
  return config.from !== undefined;
};

var getInheritedColorGenerator = function getInheritedColorGenerator(config, theme) {
  if (typeof config === 'function') {
    return function (datum) {
      return config(datum);
    };
  }

  if (isPlainObject$3(config)) {
    if (isInheritedColorConfigFromTheme(config)) {
      if (theme === undefined) {
        throw new Error("Unable to use color from theme as no theme was provided");
      }

      var themeColor = _get(theme, config.theme);

      if (themeColor === undefined) {
        throw new Error("Color from theme is undefined at path: '".concat(config.theme, "'"));
      }

      return function () {
        return themeColor;
      };
    }

    if (isInheritedColorConfigFromContext(config)) {
      var getColor = function getColor(d) {
        return _get(d, config.from);
      };

      if (Array.isArray(config.modifiers)) {
        var modifiers = [];

        var _iterator = _createForOfIteratorHelper(config.modifiers),
            _step;

        try {
          var _loop = function _loop() {
            var modifier = _step.value;

            var _modifier = _slicedToArray$4(modifier, 2),
                modifierType = _modifier[0],
                amount = _modifier[1];

            if (modifierType === 'brighter') {
              modifiers.push(function (color) {
                return color.brighter(amount);
              });
            } else if (modifierType === 'darker') {
              modifiers.push(function (color) {
                return color.darker(amount);
              });
            } else if (modifierType === 'opacity') {
              modifiers.push(function (color) {
                color.opacity = amount;
                return color;
              });
            } else {
              throw new Error("Invalid color modifier: '".concat(modifierType, "', must be one of: 'brighter', 'darker', 'opacity'"));
            }
          };

          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (modifiers.length === 0) return getColor;
        return function (datum) {
          return modifiers.reduce(function (color, modify) {
            return modify(color);
          }, rgb$1(getColor(datum))).toString();
        };
      }

      return getColor;
    }

    throw new Error("Invalid color spec, you should either specify 'theme' or 'from' when using a config object");
  }

  return function () {
    return config;
  };
};
var useInheritedColor = function useInheritedColor(config, theme) {
  return useMemo$1(function () {
    return getInheritedColorGenerator(config, theme);
  }, [config, theme]);
};

var isOrdinalColorScaleConfigScheme = function isOrdinalColorScaleConfigScheme(config) {
  return config.scheme !== undefined;
};

var isOrdinalColorScaleConfigDatumProperty = function isOrdinalColorScaleConfigDatumProperty(config) {
  return config.datum !== undefined;
};

var getOrdinalColorScale = function getOrdinalColorScale(config, identity) {
  if (typeof config === 'function') {
    return config;
  }

  var getIdentity = typeof identity === 'function' ? identity : function (datum) {
    return _get(datum, identity);
  };

  if (Array.isArray(config)) {
    var scale = ordinal(config);

    var generator = function generator(datum) {
      return scale(getIdentity(datum));
    };

    generator.scale = scale;
    return generator;
  }

  if (isPlainObject$3(config)) {
    if (isOrdinalColorScaleConfigDatumProperty(config)) {
      return function (datum) {
        return _get(datum, config.datum);
      };
    }

    if (isOrdinalColorScaleConfigScheme(config)) {
      if (isCategoricalColorScheme(config.scheme)) {
        var _scale = ordinal(colorSchemes[config.scheme]);

        var _generator = function _generator(datum) {
          return _scale(getIdentity(datum));
        };

        _generator.scale = _scale;
        return _generator;
      }

      if (isDivergingColorScheme(config.scheme)) {
        if (config.size !== undefined && (config.size < 3 || config.size > 11)) {
          throw new Error("Invalid size '".concat(config.size, "' for diverging color scheme '").concat(config.scheme, "', must be between 3~11"));
        }

        var _scale2 = ordinal(colorSchemes[config.scheme][config.size || 11]);

        var _generator2 = function _generator2(d) {
          return _scale2(getIdentity(d));
        };

        _generator2.scale = _scale2;
        return _generator2;
      }

      if (isSequentialColorScheme(config.scheme)) {
        if (config.size !== undefined && (config.size < 3 || config.size > 9)) {
          throw new Error("Invalid size '".concat(config.size, "' for sequential color scheme '").concat(config.scheme, "', must be between 3~9"));
        }

        var _scale3 = ordinal(colorSchemes[config.scheme][config.size || 9]);

        var _generator3 = function _generator3(d) {
          return _scale3(getIdentity(d));
        };

        _generator3.scale = _scale3;
        return _generator3;
      }
    }

    throw new Error("Invalid colors, when using an object, you should either pass a 'datum' or a 'scheme' property");
  }

  return function () {
    return config;
  };
};
var useOrdinalColorScale = function useOrdinalColorScale(config, identity) {
  return useMemo$1(function () {
    return getOrdinalColorScale(config, identity);
  }, [config, identity]);
};

var ordinalColorsPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.string), PropTypes.shape({
  scheme: PropTypes.oneOf(colorSchemeIds).isRequired,
  size: PropTypes.number
}), PropTypes.shape({
  datum: PropTypes.string.isRequired
}), PropTypes.string]);
var colorPropertyAccessorPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
var inheritedColorPropType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
  theme: PropTypes.string.isRequired
}), PropTypes.shape({
  from: PropTypes.string.isRequired,
  modifiers: PropTypes.arrayOf(PropTypes.array)
})]);

var baseEach = _baseEach;

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter$1(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

var _baseFilter = baseFilter$1;

var arrayFilter$2 = _arrayFilter$1,
    baseFilter = _baseFilter,
    baseIteratee = _baseIteratee,
    isArray$5 = isArray_1$1;

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray$5(collection) ? arrayFilter$2 : baseFilter;
  return func(collection, baseIteratee(predicate));
}

var filter_1 = filter;

var filter$1 = /*@__PURE__*/getDefaultExportFromCjs(filter_1);

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$3(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach$1 = arrayEach$3;

var copyObject$9 = _copyObject$1,
    keys$5 = keys_1$1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$3(object, source) {
  return object && copyObject$9(source, keys$5(source), object);
}

var _baseAssign$1 = baseAssign$3;

var copyObject$8 = _copyObject$1,
    keysIn$6 = keysIn_1$1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$3(object, source) {
  return object && copyObject$8(source, keysIn$6(source), object);
}

var _baseAssignIn$1 = baseAssignIn$3;

var copyObject$7 = _copyObject$1,
    getSymbols$5 = _getSymbols$1;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$3(source, object) {
  return copyObject$7(source, getSymbols$5(source), object);
}

var _copySymbols$1 = copySymbols$3;

var arrayPush$3 = _arrayPush$1,
    getPrototype$3 = _getPrototype$1,
    getSymbols$4 = _getSymbols$1,
    stubArray$3 = stubArray_1$1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$5 = !nativeGetSymbols$2 ? stubArray$3 : function(object) {
  var result = [];
  while (object) {
    arrayPush$3(result, getSymbols$4(object));
    object = getPrototype$3(object);
  }
  return result;
};

var _getSymbolsIn$1 = getSymbolsIn$5;

var copyObject$6 = _copyObject$1,
    getSymbolsIn$4 = _getSymbolsIn$1;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$3(source, object) {
  return copyObject$6(source, getSymbolsIn$4(source), object);
}

var _copySymbolsIn$1 = copySymbolsIn$3;

var baseGetAllKeys$3 = _baseGetAllKeys$1,
    getSymbolsIn$3 = _getSymbolsIn$1,
    keysIn$5 = keysIn_1$1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$4(object) {
  return baseGetAllKeys$3(object, keysIn$5, getSymbolsIn$3);
}

var _getAllKeysIn$1 = getAllKeysIn$4;

/** Used for built-in method references. */

var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$d.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$3(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$b.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray$1 = initCloneArray$3;

var cloneArrayBuffer$5 = _cloneArrayBuffer$1;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$3(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$5(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView$1 = cloneDataView$3;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags$1 = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$3(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags$1.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp$1 = cloneRegExp$3;

var Symbol$5 = _Symbol$1;

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$5 ? Symbol$5.prototype : undefined,
    symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$3(symbol) {
  return symbolValueOf$1 ? Object(symbolValueOf$1.call(symbol)) : {};
}

var _cloneSymbol$1 = cloneSymbol$3;

var cloneArrayBuffer$4 = _cloneArrayBuffer$1,
    cloneDataView$2 = _cloneDataView$1,
    cloneRegExp$2 = _cloneRegExp$1,
    cloneSymbol$2 = _cloneSymbol$1,
    cloneTypedArray$2 = _cloneTypedArray$1;

/** `Object#toString` result references. */
var boolTag$4 = '[object Boolean]',
    dateTag$4 = '[object Date]',
    mapTag$7 = '[object Map]',
    numberTag$4 = '[object Number]',
    regexpTag$4 = '[object RegExp]',
    setTag$7 = '[object Set]',
    stringTag$4 = '[object String]',
    symbolTag$3 = '[object Symbol]';

var arrayBufferTag$4 = '[object ArrayBuffer]',
    dataViewTag$5 = '[object DataView]',
    float32Tag$4 = '[object Float32Array]',
    float64Tag$4 = '[object Float64Array]',
    int8Tag$4 = '[object Int8Array]',
    int16Tag$4 = '[object Int16Array]',
    int32Tag$4 = '[object Int32Array]',
    uint8Tag$4 = '[object Uint8Array]',
    uint8ClampedTag$4 = '[object Uint8ClampedArray]',
    uint16Tag$4 = '[object Uint16Array]',
    uint32Tag$4 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$3(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$4:
      return cloneArrayBuffer$4(object);

    case boolTag$4:
    case dateTag$4:
      return new Ctor(+object);

    case dataViewTag$5:
      return cloneDataView$2(object, isDeep);

    case float32Tag$4: case float64Tag$4:
    case int8Tag$4: case int16Tag$4: case int32Tag$4:
    case uint8Tag$4: case uint8ClampedTag$4: case uint16Tag$4: case uint32Tag$4:
      return cloneTypedArray$2(object, isDeep);

    case mapTag$7:
      return new Ctor;

    case numberTag$4:
    case stringTag$4:
      return new Ctor(object);

    case regexpTag$4:
      return cloneRegExp$2(object);

    case setTag$7:
      return new Ctor;

    case symbolTag$3:
      return cloneSymbol$2(object);
  }
}

var _initCloneByTag$1 = initCloneByTag$3;

var getTag$6 = _getTag$1,
    isObjectLike$7 = isObjectLike_1$1;

/** `Object#toString` result references. */
var mapTag$6 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$3(value) {
  return isObjectLike$7(value) && getTag$6(value) == mapTag$6;
}

var _baseIsMap$1 = baseIsMap$3;

var baseIsMap$2 = _baseIsMap$1,
    baseUnary$5 = _baseUnary$1,
    nodeUtil$4 = _nodeUtilExports$1;

/* Node.js helper references. */
var nodeIsMap$1 = nodeUtil$4 && nodeUtil$4.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$3 = nodeIsMap$1 ? baseUnary$5(nodeIsMap$1) : baseIsMap$2;

var isMap_1$1 = isMap$3;

var getTag$5 = _getTag$1,
    isObjectLike$6 = isObjectLike_1$1;

/** `Object#toString` result references. */
var setTag$6 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$3(value) {
  return isObjectLike$6(value) && getTag$5(value) == setTag$6;
}

var _baseIsSet$1 = baseIsSet$3;

var baseIsSet$2 = _baseIsSet$1,
    baseUnary$4 = _baseUnary$1,
    nodeUtil$3 = _nodeUtilExports$1;

/* Node.js helper references. */
var nodeIsSet$1 = nodeUtil$3 && nodeUtil$3.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$3 = nodeIsSet$1 ? baseUnary$4(nodeIsSet$1) : baseIsSet$2;

var isSet_1$1 = isSet$3;

var Stack$2 = _Stack$1,
    arrayEach$2 = _arrayEach$1,
    assignValue$3 = _assignValue$1,
    baseAssign$2 = _baseAssign$1,
    baseAssignIn$2 = _baseAssignIn$1,
    cloneBuffer$1 = _cloneBufferExports$1,
    copyArray$2 = _copyArray$1,
    copySymbols$2 = _copySymbols$1,
    copySymbolsIn$2 = _copySymbolsIn$1,
    getAllKeys$2 = _getAllKeys$1,
    getAllKeysIn$3 = _getAllKeysIn$1,
    getTag$4 = _getTag$1,
    initCloneArray$2 = _initCloneArray$1,
    initCloneByTag$2 = _initCloneByTag$1,
    initCloneObject$2 = _initCloneObject$1,
    isArray$4 = isArray_1$1,
    isBuffer$3 = isBufferExports$1,
    isMap$2 = isMap_1$1,
    isObject$6 = isObject_1$1,
    isSet$2 = isSet_1$1,
    keys$4 = keys_1$1,
    keysIn$4 = keysIn_1$1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$3 = 1,
    CLONE_FLAT_FLAG$2 = 2,
    CLONE_SYMBOLS_FLAG$3 = 4;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$3 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]',
    mapTag$5 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$2 = '[object Symbol]',
    weakMapTag$3 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$3 = '[object Float32Array]',
    float64Tag$3 = '[object Float64Array]',
    int8Tag$3 = '[object Int8Array]',
    int16Tag$3 = '[object Int16Array]',
    int32Tag$3 = '[object Int32Array]',
    uint8Tag$3 = '[object Uint8Array]',
    uint8ClampedTag$3 = '[object Uint8ClampedArray]',
    uint16Tag$3 = '[object Uint16Array]',
    uint32Tag$3 = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags$1 = {};
cloneableTags$1[argsTag$3] = cloneableTags$1[arrayTag$2] =
cloneableTags$1[arrayBufferTag$3] = cloneableTags$1[dataViewTag$4] =
cloneableTags$1[boolTag$3] = cloneableTags$1[dateTag$3] =
cloneableTags$1[float32Tag$3] = cloneableTags$1[float64Tag$3] =
cloneableTags$1[int8Tag$3] = cloneableTags$1[int16Tag$3] =
cloneableTags$1[int32Tag$3] = cloneableTags$1[mapTag$5] =
cloneableTags$1[numberTag$3] = cloneableTags$1[objectTag$3] =
cloneableTags$1[regexpTag$3] = cloneableTags$1[setTag$5] =
cloneableTags$1[stringTag$3] = cloneableTags$1[symbolTag$2] =
cloneableTags$1[uint8Tag$3] = cloneableTags$1[uint8ClampedTag$3] =
cloneableTags$1[uint16Tag$3] = cloneableTags$1[uint32Tag$3] = true;
cloneableTags$1[errorTag$2] = cloneableTags$1[funcTag$3] =
cloneableTags$1[weakMapTag$3] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$3(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$3,
      isFlat = bitmask & CLONE_FLAT_FLAG$2,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$3;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$6(value)) {
    return value;
  }
  var isArr = isArray$4(value);
  if (isArr) {
    result = initCloneArray$2(value);
    if (!isDeep) {
      return copyArray$2(value, result);
    }
  } else {
    var tag = getTag$4(value),
        isFunc = tag == funcTag$3 || tag == genTag$2;

    if (isBuffer$3(value)) {
      return cloneBuffer$1(value, isDeep);
    }
    if (tag == objectTag$3 || tag == argsTag$3 || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject$2(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn$2(value, baseAssignIn$2(result, value))
          : copySymbols$2(value, baseAssign$2(result, value));
      }
    } else {
      if (!cloneableTags$1[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag$2(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack$2);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet$2(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$3(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$2(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$3(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn$3 : getAllKeys$2)
    : (isFlat ? keysIn$4 : keys$4);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach$2(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue$3(result, key, baseClone$3(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone$1 = baseClone$3;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$1;

var baseGet = _baseGet,
    baseSlice = _baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent$1(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

var _parent = parent$1;

var castPath$1 = _castPath,
    last = last_1,
    parent = _parent,
    toKey = _toKey;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset$1(object, path) {
  path = castPath$1(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

var _baseUnset = baseUnset$1;

var isPlainObject = isPlainObject_1;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone$1(value) {
  return isPlainObject(value) ? undefined : value;
}

var _customOmitClone = customOmitClone$1;

var arrayMap = _arrayMap,
    baseClone$2 = _baseClone$1,
    baseUnset = _baseUnset,
    castPath = _castPath,
    copyObject$5 = _copyObject$1,
    customOmitClone = _customOmitClone,
    flatRest = _flatRest,
    getAllKeysIn$2 = _getAllKeysIn$1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$2 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$2 = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit$1 = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject$5(object, getAllKeysIn$2(object), result);
  if (isDeep) {
    result = baseClone$2(result, CLONE_DEEP_FLAG$2 | CLONE_FLAT_FLAG$1 | CLONE_SYMBOLS_FLAG$2, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

var omit_1 = omit$1;

var omit$2 = /*@__PURE__*/getDefaultExportFromCjs(omit_1);

PropTypes.shape({
  match: PropTypes.oneOfType([PropTypes.func, PropTypes.object]).isRequired,
  type: PropTypes.oneOf(['circle', 'rect', 'dot']).isRequired,
  noteX: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    abs: PropTypes.number.isRequired
  })]).isRequired,
  noteY: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    abs: PropTypes.number.isRequired
  })]).isRequired,
  noteWidth: PropTypes.number,
  noteTextOffset: PropTypes.number,
  note: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  offset: PropTypes.number
});
var defaultProps$3 = {
  noteWidth: 120,
  noteTextOffset: 8,
  animate: true,
  motionStiffness: 90,
  motionDamping: 13
};

function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$8(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$8(Object(source), true).forEach(function (key) {
        _defineProperty$4(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$8(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

var defaultPositionAccessor = function defaultPositionAccessor(item) {
  return {
    x: item.x,
    y: item.y
  };
};
var bindAnnotations = function bindAnnotations(_ref) {
  var items = _ref.items,
      annotations = _ref.annotations,
      _ref$getPosition = _ref.getPosition,
      getPosition = _ref$getPosition === void 0 ? defaultPositionAccessor : _ref$getPosition,
      getDimensions = _ref.getDimensions;
  return annotations.reduce(function (acc, annotation) {
    filter$1(items, annotation.match).forEach(function (item) {
      var position = getPosition(item);
      var dimensions = getDimensions(item, annotation.offset || 0);
      acc.push(_objectSpread2$3(_objectSpread2$3(_objectSpread2$3(_objectSpread2$3({}, omit$2(annotation, ['match', 'offset'])), position), dimensions), {}, {
        datum: item,
        size: annotation.size || dimensions.size
      }));
    });
    return acc;
  }, []);
};
var getLinkAngle = function getLinkAngle(sourceX, sourceY, targetX, targetY) {
  var angle = Math.atan2(targetY - sourceY, targetX - sourceX);
  return absoluteAngleDegrees(radiansToDegrees(angle));
};
var computeAnnotation = function computeAnnotation(_ref2) {
  var type = _ref2.type,
      x = _ref2.x,
      y = _ref2.y,
      size = _ref2.size,
      width = _ref2.width,
      height = _ref2.height,
      noteX = _ref2.noteX,
      noteY = _ref2.noteY,
      _ref2$noteWidth = _ref2.noteWidth,
      noteWidth = _ref2$noteWidth === void 0 ? defaultProps$3.noteWidth : _ref2$noteWidth,
      _ref2$noteTextOffset = _ref2.noteTextOffset,
      noteTextOffset = _ref2$noteTextOffset === void 0 ? defaultProps$3.noteTextOffset : _ref2$noteTextOffset;
  var computedNoteX;
  var computedNoteY;
  if (isPlainObject$3(noteX)) {
    if (noteX.abs !== undefined) {
      computedNoteX = noteX.abs;
    }
  } else {
    computedNoteX = x + noteX;
  }
  if (isPlainObject$3(noteY)) {
    if (noteY.abs !== undefined) {
      computedNoteY = noteY.abs;
    }
  } else {
    computedNoteY = y + noteY;
  }
  var computedX = x;
  var computedY = y;
  var angle = getLinkAngle(x, y, computedNoteX, computedNoteY);
  if (type === 'circle') {
    var position = positionFromAngle(degreesToRadians(angle), size / 2);
    computedX += position.x;
    computedY += position.y;
  }
  if (type === 'rect') {
    var eighth = Math.round((angle + 90) / 45) % 8;
    if (eighth === 0) {
      computedY -= height / 2;
    }
    if (eighth === 1) {
      computedX += width / 2;
      computedY -= height / 2;
    }
    if (eighth === 2) {
      computedX += width / 2;
    }
    if (eighth === 3) {
      computedX += width / 2;
      computedY += height / 2;
    }
    if (eighth === 4) {
      computedY += height / 2;
    }
    if (eighth === 5) {
      computedX -= width / 2;
      computedY += height / 2;
    }
    if (eighth === 6) {
      computedX -= width / 2;
    }
    if (eighth === 7) {
      computedX -= width / 2;
      computedY -= height / 2;
    }
  }
  var textX = computedNoteX;
  var textY = computedNoteY - noteTextOffset;
  var noteLineX = computedNoteX;
  var noteLineY = computedNoteY;
  if ((angle + 90) % 360 > 180) {
    textX -= noteWidth;
    noteLineX -= noteWidth;
  } else {
    noteLineX += noteWidth;
  }
  return {
    points: [[computedX, computedY], [computedNoteX, computedNoteY], [noteLineX, noteLineY]],
    text: [textX, textY],
    angle: angle + 90
  };
};

var useAnnotations = function useAnnotations(_ref) {
  var items = _ref.items,
      annotations = _ref.annotations,
      getPosition = _ref.getPosition,
      getDimensions = _ref.getDimensions;
  return useMemo$1(function () {
    return bindAnnotations({
      items: items,
      annotations: annotations,
      getPosition: getPosition,
      getDimensions: getDimensions
    });
  }, [items, annotations, getPosition, getDimensions]);
};
var useComputedAnnotation = function useComputedAnnotation(_ref3) {
  var type = _ref3.type,
      containerWidth = _ref3.containerWidth,
      containerHeight = _ref3.containerHeight,
      x = _ref3.x,
      y = _ref3.y,
      size = _ref3.size,
      width = _ref3.width,
      height = _ref3.height,
      noteX = _ref3.noteX,
      noteY = _ref3.noteY,
      noteWidth = _ref3.noteWidth,
      noteTextOffset = _ref3.noteTextOffset;
  return useMemo$1(function () {
    return computeAnnotation({
      type: type,
      containerWidth: containerWidth,
      containerHeight: containerHeight,
      x: x,
      y: y,
      size: size,
      width: width,
      height: height,
      noteX: noteX,
      noteY: noteY,
      noteWidth: noteWidth,
      noteTextOffset: noteTextOffset
    });
  }, [type, containerWidth, containerHeight, x, y, size, width, height, noteX, noteY, noteWidth, noteTextOffset]);
};

var AnnotationNote = memo(function (_ref) {
  var datum = _ref.datum,
      x = _ref.x,
      y = _ref.y,
      note = _ref.note;
  var theme = useTheme();
  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfiig = _useMotionConfig.config;
  var animatedProps = useSpring({
    x: x,
    y: y,
    config: springConfiig,
    immediate: !animate
  });
  if (typeof note === 'function') {
    return note({
      x: x,
      y: y,
      datum: datum
    });
  }
  return React__default.createElement(React__default.Fragment, null, theme.annotations.text.outlineWidth > 0 && React__default.createElement(animated.text, {
    x: animatedProps.x,
    y: animatedProps.y,
    style: _objectSpread2$3(_objectSpread2$3({}, theme.annotations.text), {}, {
      strokeLinejoin: 'round',
      strokeWidth: theme.annotations.text.outlineWidth * 2,
      stroke: theme.annotations.text.outlineColor
    })
  }, note), React__default.createElement(animated.text, {
    x: animatedProps.x,
    y: animatedProps.y,
    style: omit$2(theme.annotations.text, ['outlineWidth', 'outlineColor'])
  }, note));
});
AnnotationNote.displayName = 'AnnotationNote';
AnnotationNote.defaultProps = {};

function _arrayWithHoles$3(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$3(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray$3(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen);
}

function _nonIterableRest$3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$3(arr, i) {
  return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$3();
}

function _iterableToArray$2(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _toArray(arr) {
  return _arrayWithHoles$3(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableRest$3();
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$2(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var AnnotationLink = memo(function (_ref) {
  var isOutline = _ref.isOutline,
      props = _objectWithoutProperties$2(_ref, ["isOutline"]);
  var theme = useTheme();
  var _props$points = _toArray(props.points),
      point = _props$points[0],
      points = _props$points.slice(1);
  var path = points.reduce(function (acc, _ref2) {
    var _ref3 = _slicedToArray$3(_ref2, 2),
        x = _ref3[0],
        y = _ref3[1];
    return "".concat(acc, " L").concat(x, ",").concat(y);
  }, "M".concat(point[0], ",").concat(point[1]));
  var animatedPath = useAnimatedPath(path);
  if (isOutline && theme.annotations.link.outlineWidth <= 0) {
    return null;
  }
  var style = _objectSpread2$3({}, theme.annotations.link);
  if (isOutline) {
    style.strokeLinecap = 'square';
    style.strokeWidth = theme.annotations.link.strokeWidth + theme.annotations.link.outlineWidth * 2;
    style.stroke = theme.annotations.link.outlineColor;
  }
  return React__default.createElement(animated.path, {
    fill: "none",
    d: animatedPath,
    style: style
  });
});
AnnotationLink.displayName = 'AnnotationLink';
AnnotationLink.defaultProps = {
  isOutline: false
};

var CircleAnnotationOutline = memo(function (_ref) {
  var x = _ref.x,
      y = _ref.y,
      size = _ref.size;
  var theme = useTheme();
  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;
  var animatedProps = useSpring({
    x: x,
    y: y,
    radius: size / 2,
    config: springConfig,
    immediate: !animate
  });
  return React__default.createElement(React__default.Fragment, null, theme.annotations.outline.outlineWidth > 0 && React__default.createElement(animated.circle, {
    cx: animatedProps.x,
    cy: animatedProps.y,
    r: animatedProps.radius,
    style: _objectSpread2$3(_objectSpread2$3({}, theme.annotations.outline), {}, {
      fill: 'none',
      strokeWidth: theme.annotations.outline.strokeWidth + theme.annotations.outline.outlineWidth * 2,
      stroke: theme.annotations.outline.outlineColor
    })
  }), React__default.createElement(animated.circle, {
    cx: animatedProps.x,
    cy: animatedProps.y,
    r: animatedProps.radius,
    style: theme.annotations.outline
  }));
});
CircleAnnotationOutline.displayName = 'CircleAnnotationOutline';

var DotAnnotationOutline = memo(function (_ref) {
  var x = _ref.x,
      y = _ref.y,
      size = _ref.size;
  var theme = useTheme();
  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;
  var animatedProps = useSpring({
    x: x,
    y: y,
    radius: size / 2,
    config: springConfig,
    immediate: !animate
  });
  return React__default.createElement(React__default.Fragment, null, theme.annotations.outline.outlineWidth > 0 && React__default.createElement(animated.circle, {
    cx: animatedProps.x,
    cy: animatedProps.y,
    r: animatedProps.radius,
    style: _objectSpread2$3(_objectSpread2$3({}, theme.annotations.outline), {}, {
      fill: 'none',
      strokeWidth: theme.annotations.outline.outlineWidth * 2,
      stroke: theme.annotations.outline.outlineColor
    })
  }), React__default.createElement(animated.circle, {
    cx: animatedProps.x,
    cy: animatedProps.y,
    r: animatedProps.radius,
    style: theme.annotations.symbol
  }));
});
DotAnnotationOutline.displayName = 'DotAnnotationOutline';
DotAnnotationOutline.defaultProps = {
  size: 4
};

var RectAnnotationOutline = memo(function (_ref) {
  var x = _ref.x,
      y = _ref.y,
      width = _ref.width,
      height = _ref.height;
  var theme = useTheme();
  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;
  var animatedProps = useSpring({
    x: x - width / 2,
    y: y - height / 2,
    width: width,
    height: height,
    config: springConfig,
    immediate: !animate
  });
  return React__default.createElement(React__default.Fragment, null, theme.annotations.outline.outlineWidth > 0 && React__default.createElement(animated.rect, {
    x: animatedProps.x,
    y: animatedProps.y,
    width: animatedProps.width,
    height: animatedProps.height,
    style: _objectSpread2$3(_objectSpread2$3({}, theme.annotations.outline), {}, {
      fill: 'none',
      strokeWidth: theme.annotations.outline.strokeWidth + theme.annotations.outline.outlineWidth * 2,
      stroke: theme.annotations.outline.outlineColor
    })
  }), React__default.createElement(animated.rect, {
    x: animatedProps.x,
    y: animatedProps.y,
    width: animatedProps.width,
    height: animatedProps.height,
    style: theme.annotations.outline
  }));
});
RectAnnotationOutline.displayName = 'RectAnnotationOutline';

var Annotation = memo(function (_ref) {
  var datum = _ref.datum,
      type = _ref.type,
      containerWidth = _ref.containerWidth,
      containerHeight = _ref.containerHeight,
      x = _ref.x,
      y = _ref.y,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      noteX = _ref.noteX,
      noteY = _ref.noteY,
      noteWidth = _ref.noteWidth,
      noteTextOffset = _ref.noteTextOffset,
      note = _ref.note;
  var computed = useComputedAnnotation({
    type: type,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    x: x,
    y: y,
    size: size,
    width: width,
    height: height,
    noteX: noteX,
    noteY: noteY,
    noteWidth: noteWidth,
    noteTextOffset: noteTextOffset
  });
  return React__default.createElement(React__default.Fragment, null, React__default.createElement(AnnotationLink, {
    points: computed.points,
    isOutline: true
  }), type === 'circle' && React__default.createElement(CircleAnnotationOutline, {
    x: x,
    y: y,
    size: size
  }), type === 'dot' && React__default.createElement(DotAnnotationOutline, {
    x: x,
    y: y,
    size: size
  }), type === 'rect' && React__default.createElement(RectAnnotationOutline, {
    x: x,
    y: y,
    width: width,
    height: height
  }), React__default.createElement(AnnotationLink, {
    points: computed.points
  }), React__default.createElement(AnnotationNote, {
    datum: datum,
    x: computed.text[0],
    y: computed.text[1],
    note: note
  }));
});
Annotation.displayName = 'Annotation';
Annotation.defaultProps = {
  noteWidth: defaultProps$3.noteWidth,
  noteTextOffset: defaultProps$3.noteTextOffset
};

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$7(Object(source), true).forEach(function (key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$7(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$2(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen);
}

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$2(arr, i) {
  return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2();
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$2(arr);
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$1();
}

var getIndexScale = function getIndexScale(data, getIndex, range, padding, indexScale) {
  return band().domain(data.map(getIndex)).range(range).round(Boolean(indexScale.round)).padding(padding);
};
var normalizeData = function normalizeData(data, keys) {
  return data.map(function (item) {
    return _objectSpread2$2(_objectSpread2$2({}, keys.reduce(function (acc, key) {
      acc[key] = null;
      return acc;
    }, {})), item);
  });
};
var filterNullValues = function filterNullValues(data) {
  return Object.keys(data).reduce(function (acc, key) {
    if (data[key]) {
      acc[key] = data[key];
    }
    return acc;
  }, {});
};

var gt = function gt(value, other) {
  return value > other;
};
var lt = function lt(value, other) {
  return value < other;
};
var flatten = function flatten(array) {
  var _ref;
  return (_ref = []).concat.apply(_ref, _toConsumableArray$1(array));
};
var range = function range(start, end) {
  return Array.from(' '.repeat(end - start), function (_, index) {
    return start + index;
  });
};
var clampToZero = function clampToZero(value) {
  return gt(value, 0) ? 0 : value;
};
var generateVerticalGroupedBars = function generateVerticalGroupedBars(_ref2, barWidth, reverse, yRef) {
  var data = _ref2.data,
      getIndex = _ref2.getIndex,
      keys = _ref2.keys,
      getColor = _ref2.getColor,
      innerPadding = _ref2.innerPadding,
      xScale = _ref2.xScale,
      yScale = _ref2.yScale;
  var compare = reverse ? lt : gt;
  var getY = function getY(d) {
    return compare(d, 0) ? yScale(d) : yRef;
  };
  var getHeight = function getHeight(d, y) {
    return compare(d, 0) ? yRef - y : yScale(d) - yRef;
  };
  var cleanedData = data.map(filterNullValues);
  var bars = flatten(keys.map(function (key, i) {
    return range(0, xScale.domain().length).map(function (index) {
      var x = xScale(getIndex(data[index])) + barWidth * i + innerPadding * i;
      var y = getY(data[index][key]);
      var barHeight = getHeight(data[index][key], y);
      var barData = {
        id: key,
        value: data[index][key],
        index: index,
        indexValue: getIndex(data[index]),
        data: cleanedData[index]
      };
      return {
        key: "".concat(key, ".").concat(barData.indexValue),
        data: barData,
        x: x,
        y: y,
        width: barWidth,
        height: barHeight,
        color: getColor(barData)
      };
    });
  }));
  return bars;
};
var generateHorizontalGroupedBars = function generateHorizontalGroupedBars(_ref3, barHeight, reverse, xRef) {
  var data = _ref3.data,
      getIndex = _ref3.getIndex,
      keys = _ref3.keys,
      getColor = _ref3.getColor,
      _ref3$innerPadding = _ref3.innerPadding,
      innerPadding = _ref3$innerPadding === void 0 ? 0 : _ref3$innerPadding,
      xScale = _ref3.xScale,
      yScale = _ref3.yScale;
  var compare = reverse ? lt : gt;
  var getX = function getX(d) {
    return compare(d, 0) ? xRef : xScale(d);
  };
  var getWidth = function getWidth(d, x) {
    return compare(d, 0) ? xScale(d) - xRef : xRef - x;
  };
  var cleanedData = data.map(filterNullValues);
  var bars = flatten(keys.map(function (key, i) {
    return range(0, yScale.domain().length).map(function (index) {
      var x = getX(data[index][key]);
      var y = yScale(getIndex(data[index])) + barHeight * i + innerPadding * i;
      var barWidth = getWidth(data[index][key], x);
      var barData = {
        id: key,
        value: data[index][key],
        index: index,
        indexValue: getIndex(data[index]),
        data: cleanedData[index]
      };
      return {
        key: "".concat(key, ".").concat(barData.indexValue),
        data: barData,
        x: x,
        y: y,
        width: barWidth,
        height: barHeight,
        color: getColor(barData)
      };
    });
  }));
  return bars;
};
var generateGroupedBars = function generateGroupedBars(_ref4) {
  var layout = _ref4.layout,
      keys = _ref4.keys,
      minValue = _ref4.minValue,
      maxValue = _ref4.maxValue,
      reverse = _ref4.reverse,
      width = _ref4.width,
      height = _ref4.height,
      _ref4$padding = _ref4.padding,
      padding = _ref4$padding === void 0 ? 0 : _ref4$padding,
      _ref4$innerPadding = _ref4.innerPadding,
      innerPadding = _ref4$innerPadding === void 0 ? 0 : _ref4$innerPadding,
      valueScale = _ref4.valueScale,
      indexScaleConfig = _ref4.indexScale,
      props = _objectWithoutProperties$1(_ref4, ["layout", "keys", "minValue", "maxValue", "reverse", "width", "height", "padding", "innerPadding", "valueScale", "indexScale"]);
  var data = normalizeData(props.data, keys);
  var _ref5 = layout === 'vertical' ? ['y', [0, width]] : ['x', [height, 0]],
      _ref6 = _slicedToArray$2(_ref5, 2),
      axis = _ref6[0],
      range = _ref6[1];
  var indexScale = getIndexScale(data, props.getIndex, range, padding, indexScaleConfig);
  var scaleSpec = _objectSpread2$2({
    axis: axis,
    max: maxValue,
    min: minValue,
    reverse: reverse
  }, valueScale);
  var clampMin = scaleSpec.min === 'auto' ? clampToZero : function (value) {
    return value;
  };
  var values = data.reduce(function (acc, entry) {
    return [].concat(_toConsumableArray$1(acc), _toConsumableArray$1(keys.map(function (k) {
      return entry[k];
    })));
  }, []).filter(Boolean);
  var min = clampMin(Math.min.apply(Math, _toConsumableArray$1(values)));
  var max = Math.max.apply(Math, _toConsumableArray$1(values));
  var scale = computeScale(scaleSpec, _defineProperty$3({}, axis, {
    min: min,
    max: max
  }), width, height);
  var _ref7 = layout === 'vertical' ? [indexScale, scale] : [scale, indexScale],
      _ref8 = _slicedToArray$2(_ref7, 2),
      xScale = _ref8[0],
      yScale = _ref8[1];
  var bandwidth = (indexScale.bandwidth() - innerPadding * (keys.length - 1)) / keys.length;
  var params = [_objectSpread2$2(_objectSpread2$2({}, props), {}, {
    data: data,
    keys: keys,
    innerPadding: innerPadding,
    xScale: xScale,
    yScale: yScale
  }), bandwidth, scaleSpec.reverse, scale(0)];
  var bars = bandwidth > 0 ? layout === 'vertical' ? generateVerticalGroupedBars.apply(void 0, params) : generateHorizontalGroupedBars.apply(void 0, params) : [];
  return {
    xScale: xScale,
    yScale: yScale,
    bars: bars
  };
};

var flattenDeep = function flattenDeep(array) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return depth > 0 ? array.reduce(function (acc, value) {
    return acc.concat(Array.isArray(value) ? flattenDeep(value, depth - 1) : value);
  }, []) : array.slice();
};
var generateVerticalStackedBars = function generateVerticalStackedBars(_ref, barWidth, reverse) {
  var getIndex = _ref.getIndex,
      getColor = _ref.getColor,
      innerPadding = _ref.innerPadding,
      stackedData = _ref.stackedData,
      xScale = _ref.xScale,
      yScale = _ref.yScale;
  var getY = function getY(d) {
    return yScale(d[reverse ? 0 : 1]);
  };
  var getHeight = function getHeight(d, y) {
    return yScale(d[reverse ? 1 : 0]) - y;
  };
  var bars = flattenDeep(stackedData.map(function (stackedDataItem) {
    return xScale.domain().map(function (index, i) {
      var d = stackedDataItem[i];
      var x = xScale(getIndex(d.data));
      var y = getY(d) + innerPadding * 0.5;
      var barHeight = getHeight(d, y) - innerPadding;
      var barData = {
        id: stackedDataItem.key,
        value: d.data[stackedDataItem.key],
        index: i,
        indexValue: index,
        data: filterNullValues(d.data)
      };
      return {
        key: "".concat(stackedDataItem.key, ".").concat(index),
        data: barData,
        x: x,
        y: y,
        width: barWidth,
        height: barHeight,
        color: getColor(barData)
      };
    });
  }));
  return bars;
};
var generateHorizontalStackedBars = function generateHorizontalStackedBars(_ref2, barHeight, reverse) {
  var getIndex = _ref2.getIndex,
      getColor = _ref2.getColor,
      innerPadding = _ref2.innerPadding,
      stackedData = _ref2.stackedData,
      xScale = _ref2.xScale,
      yScale = _ref2.yScale;
  var getX = function getX(d) {
    return xScale(d[reverse ? 1 : 0]);
  };
  var getWidth = function getWidth(d, x) {
    return xScale(d[reverse ? 0 : 1]) - x;
  };
  var bars = flattenDeep(stackedData.map(function (stackedDataItem) {
    return yScale.domain().map(function (index, i) {
      var d = stackedDataItem[i];
      var y = yScale(getIndex(d.data));
      var x = getX(d) + innerPadding * 0.5;
      var barWidth = getWidth(d, x) - innerPadding;
      var barData = {
        id: stackedDataItem.key,
        value: d.data[stackedDataItem.key],
        index: i,
        indexValue: index,
        data: filterNullValues(d.data)
      };
      return {
        key: "".concat(stackedDataItem.key, ".").concat(index),
        data: barData,
        x: x,
        y: y,
        width: barWidth,
        height: barHeight,
        color: getColor(barData)
      };
    });
  }));
  return bars;
};
var generateStackedBars = function generateStackedBars(_ref3) {
  var data = _ref3.data,
      keys = _ref3.keys,
      layout = _ref3.layout,
      minValue = _ref3.minValue,
      maxValue = _ref3.maxValue,
      reverse = _ref3.reverse,
      width = _ref3.width,
      height = _ref3.height,
      _ref3$padding = _ref3.padding,
      padding = _ref3$padding === void 0 ? 0 : _ref3$padding,
      valueScale = _ref3.valueScale,
      indexScaleConfig = _ref3.indexScale,
      props = _objectWithoutProperties$1(_ref3, ["data", "keys", "layout", "minValue", "maxValue", "reverse", "width", "height", "padding", "valueScale", "indexScale"]);
  var stackedData = stack().keys(keys).offset(stackOffsetDiverging)(normalizeData(data, keys));
  var _ref4 = layout === 'vertical' ? ['y', [0, width]] : ['x', [height, 0]],
      _ref5 = _slicedToArray$2(_ref4, 2),
      axis = _ref5[0],
      range = _ref5[1];
  var indexScale = getIndexScale(data, props.getIndex, range, padding, indexScaleConfig);
  var scaleSpec = _objectSpread2$2({
    axis: axis,
    max: maxValue,
    min: minValue,
    reverse: reverse
  }, valueScale);
  var values = flattenDeep(stackedData, 2);
  var min = Math.min.apply(Math, _toConsumableArray$1(values));
  var max = Math.max.apply(Math, _toConsumableArray$1(values));
  var scale = computeScale(scaleSpec, _defineProperty$3({}, axis, {
    min: min,
    max: max
  }), width, height);
  var _ref6 = layout === 'vertical' ? [indexScale, scale] : [scale, indexScale],
      _ref7 = _slicedToArray$2(_ref6, 2),
      xScale = _ref7[0],
      yScale = _ref7[1];
  var innerPadding = props.innerPadding > 0 ? props.innerPadding : 0;
  var bandwidth = indexScale.bandwidth();
  var params = [_objectSpread2$2(_objectSpread2$2({}, props), {}, {
    innerPadding: innerPadding,
    stackedData: stackedData,
    xScale: xScale,
    yScale: yScale
  }), bandwidth, scaleSpec.reverse];
  var bars = bandwidth > 0 ? layout === 'vertical' ? generateVerticalStackedBars.apply(void 0, params) : generateHorizontalStackedBars.apply(void 0, params) : [];
  return {
    xScale: xScale,
    yScale: yScale,
    bars: bars
  };
};

var getLegendDataForKeys = function getLegendDataForKeys(bars, layout, direction, groupMode, reverse) {
  var data = _uniqBy(bars.map(function (bar) {
    return {
      id: bar.data.id,
      label: bar.data.id,
      color: bar.color,
      fill: bar.data.fill
    };
  }), function (_ref) {
    var id = _ref.id;
    return id;
  });
  if (layout === 'vertical' && groupMode === 'stacked' && direction === 'column' && reverse !== true || layout === 'horizontal' && groupMode === 'stacked' && reverse === true) {
    data.reverse();
  }
  return data;
};
var getLegendDataForIndexes = function getLegendDataForIndexes(bars) {
  return _uniqBy(bars.map(function (bar) {
    return {
      id: bar.data.indexValue,
      label: bar.data.indexValue,
      color: bar.color,
      fill: bar.data.fill
    };
  }), function (_ref2) {
    var id = _ref2.id;
    return id;
  });
};
var getLegendData = function getLegendData(_ref3) {
  var from = _ref3.from,
      bars = _ref3.bars,
      layout = _ref3.layout,
      direction = _ref3.direction,
      groupMode = _ref3.groupMode,
      reverse = _ref3.reverse;
  if (from === 'indexes') {
    return getLegendDataForIndexes(bars);
  }
  return getLegendDataForKeys(bars, layout, direction, groupMode, reverse);
};

var BarItem = function BarItem(_ref) {
  var data = _ref.data,
      x = _ref.x,
      y = _ref.y,
      width = _ref.width,
      height = _ref.height,
      borderRadius = _ref.borderRadius,
      color = _ref.color,
      borderWidth = _ref.borderWidth,
      borderColor = _ref.borderColor,
      label = _ref.label,
      shouldRenderLabel = _ref.shouldRenderLabel,
      labelColor = _ref.labelColor,
      showTooltip = _ref.showTooltip,
      hideTooltip = _ref.hideTooltip,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      tooltip = _ref.tooltip,
      theme = _ref.theme;
  var handleTooltip = function handleTooltip(e) {
    return showTooltip(tooltip, e);
  };
  var handleMouseEnter = function handleMouseEnter(e) {
    onMouseEnter(data, e);
    showTooltip(tooltip, e);
  };
  var handleMouseLeave = function handleMouseLeave(e) {
    onMouseLeave(data, e);
    hideTooltip(e);
  };
  return React__default.createElement("g", {
    transform: "translate(".concat(x, ", ").concat(y, ")")
  }, React__default.createElement("rect", {
    width: width,
    height: height,
    rx: borderRadius,
    ry: borderRadius,
    fill: data.fill ? data.fill : color,
    strokeWidth: borderWidth,
    stroke: borderColor,
    onMouseEnter: handleMouseEnter,
    onMouseMove: handleTooltip,
    onMouseLeave: handleMouseLeave,
    onClick: onClick
  }), shouldRenderLabel && React__default.createElement("text", {
    x: width / 2,
    y: height / 2,
    textAnchor: "middle",
    dominantBaseline: "central",
    style: _objectSpread2$2(_objectSpread2$2({}, theme.labels.text), {}, {
      pointerEvents: 'none',
      fill: labelColor
    })
  }, label));
};
var enhance = compose(withPropsOnChange(['data', 'color', 'onClick'], function (_ref2) {
  var data = _ref2.data,
      color = _ref2.color,
      _onClick = _ref2.onClick;
  return {
    onClick: function onClick(event) {
      return _onClick(_objectSpread2$2({
        color: color
      }, data), event);
    }
  };
}), withPropsOnChange(['data', 'color', 'theme', 'tooltip', 'getTooltipLabel', 'tooltipFormat'], function (_ref3) {
  var data = _ref3.data,
      color = _ref3.color,
      theme = _ref3.theme,
      tooltip = _ref3.tooltip,
      getTooltipLabel = _ref3.getTooltipLabel,
      tooltipFormat = _ref3.tooltipFormat;
  return {
    tooltip: React__default.createElement(BasicTooltip, {
      id: getTooltipLabel(data),
      value: data.value,
      enableChip: true,
      color: color,
      theme: theme,
      format: tooltipFormat,
      renderContent: typeof tooltip === 'function' ? tooltip.bind(null, _objectSpread2$2({
        color: color,
        theme: theme
      }, data)) : null
    })
  };
}), pure);
var BarItem$1 = enhance(BarItem);

var BarPropTypes = _objectSpread2$2(_objectSpread2$2({
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  indexBy: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  getIndex: PropTypes.func.isRequired,
  keys: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  layers: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.oneOf(['grid', 'axes', 'bars', 'markers', 'legends', 'annotations']), PropTypes.func])).isRequired,
  groupMode: PropTypes.oneOf(['stacked', 'grouped']).isRequired,
  layout: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,
  reverse: PropTypes.bool.isRequired,
  valueScale: scalePropType.isRequired,
  indexScale: bandScalePropTypes.isRequired,
  minValue: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]).isRequired,
  maxValue: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]).isRequired,
  padding: PropTypes.number.isRequired,
  innerPadding: PropTypes.number.isRequired,
  axisTop: axisPropType,
  axisRight: axisPropType,
  axisBottom: axisPropType,
  axisLeft: axisPropType,
  enableGridX: PropTypes.bool.isRequired,
  enableGridY: PropTypes.bool.isRequired,
  gridXValues: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]),
  gridYValues: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]),
  barComponent: PropTypes.func.isRequired,
  enableLabel: PropTypes.bool.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  labelFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  getLabel: PropTypes.func.isRequired,
  labelSkipWidth: PropTypes.number.isRequired,
  labelSkipHeight: PropTypes.number.isRequired,
  labelTextColor: inheritedColorPropType.isRequired,
  getLabelTextColor: PropTypes.func.isRequired,
  labelLinkColor: inheritedColorPropType.isRequired,
  getLabelLinkColor: PropTypes.func.isRequired,
  colors: ordinalColorsPropType.isRequired,
  colorBy: colorPropertyAccessorPropType.isRequired,
  borderRadius: PropTypes.number.isRequired,
  getColor: PropTypes.func.isRequired
}, defsPropTypes), {}, {
  borderWidth: PropTypes.number.isRequired,
  borderColor: inheritedColorPropType.isRequired,
  getBorderColor: PropTypes.func.isRequired,
  isInteractive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func.isRequired,
  onMouseLeave: PropTypes.func.isRequired,
  tooltipLabel: PropTypes.func,
  getTooltipLabel: PropTypes.func.isRequired,
  tooltipFormat: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  tooltip: PropTypes.func,
  legends: PropTypes.arrayOf(PropTypes.shape(_objectSpread2$2({
    dataFrom: PropTypes.oneOf(['indexes', 'keys']).isRequired
  }, LegendPropShape))).isRequired,
  pixelRatio: PropTypes.number.isRequired
});
_objectSpread2$2(_objectSpread2$2({}, BarPropTypes), {}, {
  role: PropTypes.string.isRequired
});
var BarDefaultProps = {
  indexBy: 'id',
  keys: ['value'],
  layers: ['grid', 'axes', 'bars', 'markers', 'legends', 'annotations'],
  groupMode: 'stacked',
  layout: 'vertical',
  reverse: false,
  minValue: 'auto',
  maxValue: 'auto',
  valueScale: {
    type: 'linear'
  },
  indexScale: {
    type: 'band',
    round: true
  },
  padding: 0.1,
  innerPadding: 0,
  axisBottom: {},
  axisLeft: {},
  enableGridX: false,
  enableGridY: true,
  barComponent: BarItem$1,
  enableLabel: true,
  label: 'value',
  labelSkipWidth: 0,
  labelSkipHeight: 0,
  labelLinkColor: 'theme',
  labelTextColor: 'theme',
  colors: {
    scheme: 'nivo'
  },
  colorBy: 'id',
  defs: [],
  fill: [],
  borderRadius: 0,
  borderWidth: 0,
  borderColor: {
    from: 'color'
  },
  isInteractive: true,
  onClick: noop$3,
  onMouseEnter: noop$3,
  onMouseLeave: noop$3,
  legends: [],
  annotations: [],
  pixelRatio: global.window && global.window.devicePixelRatio ? global.window.devicePixelRatio : 1
};
var BarSvgDefaultProps = _objectSpread2$2(_objectSpread2$2({}, BarDefaultProps), {}, {
  role: 'img'
});

var enhance$1 = (function (Component) {
  return compose(defaultProps$4(BarDefaultProps), withTheme(), withDimensions(), withMotion(), withPropsOnChange(['colors', 'colorBy'], function (_ref) {
    var colors = _ref.colors,
        colorBy = _ref.colorBy;
    return {
      getColor: getOrdinalColorScale(colors, colorBy)
    };
  }), withPropsOnChange(['indexBy'], function (_ref2) {
    var indexBy = _ref2.indexBy;
    return {
      getIndex: getPropertyAccessor(indexBy)
    };
  }), withPropsOnChange(['labelTextColor', 'theme'], function (_ref3) {
    var labelTextColor = _ref3.labelTextColor,
        theme = _ref3.theme;
    return {
      getLabelTextColor: getInheritedColorGenerator(labelTextColor, theme)
    };
  }), withPropsOnChange(['labelLinkColor', 'theme'], function (_ref4) {
    var labelLinkColor = _ref4.labelLinkColor,
        theme = _ref4.theme;
    return {
      getLabelLinkColor: getInheritedColorGenerator(labelLinkColor, theme)
    };
  }), withPropsOnChange(['label', 'labelFormat'], function (_ref5) {
    var label = _ref5.label,
        labelFormat = _ref5.labelFormat;
    return {
      getLabel: getLabelGenerator(label, labelFormat)
    };
  }), withPropsOnChange(['borderColor', 'theme'], function (_ref6) {
    var borderColor = _ref6.borderColor,
        theme = _ref6.theme;
    return {
      getBorderColor: getInheritedColorGenerator(borderColor, theme)
    };
  }), withPropsOnChange(['tooltipLabel'], function (_ref7) {
    var tooltipLabel = _ref7.tooltipLabel;
    var getTooltipLabel = function getTooltipLabel(d) {
      return "".concat(d.id, " - ").concat(d.indexValue);
    };
    if (typeof tooltipLabel === 'function') {
      getTooltipLabel = tooltipLabel;
    }
    return {
      getTooltipLabel: getTooltipLabel
    };
  }), pure)(Component);
});

var BarAnnotations = function BarAnnotations(_ref) {
  var bars = _ref.bars,
      annotations = _ref.annotations,
      animate = _ref.animate,
      innerWidth = _ref.innerWidth,
      innerHeight = _ref.innerHeight,
      motionStiffness = _ref.motionStiffness,
      motionDamping = _ref.motionDamping;
  var boundAnnotations = useAnnotations({
    items: bars,
    annotations: annotations,
    getPosition: function getPosition(bar) {
      return {
        x: bar.x + bar.width / 2,
        y: bar.y + bar.height / 2
      };
    },
    getDimensions: function getDimensions(bar, offset) {
      var width = bar.width + offset * 2;
      var height = bar.height + offset * 2;
      return {
        width: width,
        height: height,
        size: Math.max(width, height)
      };
    }
  });
  return boundAnnotations.map(function (annotation, i) {
    return React__default.createElement(Annotation, Object.assign({
      key: i
    }, annotation, {
      containerWidth: innerWidth,
      containerHeight: innerHeight,
      animate: animate,
      motionStiffness: motionStiffness,
      motionDamping: motionDamping
    }));
  });
};

var barWillEnterHorizontal = function barWillEnterHorizontal(_ref) {
  var style = _ref.style;
  return {
    x: style.x.val,
    y: style.y.val,
    width: 0,
    height: style.height.val
  };
};
var barWillEnterVertical = function barWillEnterVertical(_ref2) {
  var style = _ref2.style;
  return {
    x: style.x.val,
    y: style.y.val + style.height.val,
    width: style.width.val,
    height: 0
  };
};
var barWillLeaveHorizontal = function barWillLeaveHorizontal(springConfig) {
  return function (_ref3) {
    var style = _ref3.style;
    return {
      x: style.x,
      y: style.y,
      width: spring$1(0, springConfig),
      height: style.height
    };
  };
};
var barWillLeaveVertical = function barWillLeaveVertical(springConfig) {
  return function (_ref4) {
    var style = _ref4.style;
    return {
      x: style.x,
      y: spring$1(style.y.val + style.height.val, springConfig),
      width: style.width,
      height: spring$1(0, springConfig)
    };
  };
};
var Bar = function Bar(props) {
  var data = props.data,
      getIndex = props.getIndex,
      keys = props.keys,
      groupMode = props.groupMode,
      layout = props.layout,
      reverse = props.reverse,
      minValue = props.minValue,
      maxValue = props.maxValue,
      valueScale = props.valueScale,
      indexScale = props.indexScale,
      margin = props.margin,
      width = props.width,
      height = props.height,
      outerWidth = props.outerWidth,
      outerHeight = props.outerHeight,
      padding = props.padding,
      innerPadding = props.innerPadding,
      axisTop = props.axisTop,
      axisRight = props.axisRight,
      axisBottom = props.axisBottom,
      axisLeft = props.axisLeft,
      enableGridX = props.enableGridX,
      enableGridY = props.enableGridY,
      gridXValues = props.gridXValues,
      gridYValues = props.gridYValues,
      layers = props.layers,
      barComponent = props.barComponent,
      enableLabel = props.enableLabel,
      getLabel = props.getLabel,
      labelSkipWidth = props.labelSkipWidth,
      labelSkipHeight = props.labelSkipHeight,
      getLabelTextColor = props.getLabelTextColor,
      markers = props.markers,
      theme = props.theme,
      getColor = props.getColor,
      defs = props.defs,
      fill = props.fill,
      borderRadius = props.borderRadius,
      borderWidth = props.borderWidth,
      getBorderColor = props.getBorderColor,
      annotations = props.annotations,
      isInteractive = props.isInteractive,
      getTooltipLabel = props.getTooltipLabel,
      tooltipFormat = props.tooltipFormat,
      tooltip = props.tooltip,
      onClick = props.onClick,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      legends = props.legends,
      animate = props.animate,
      motionStiffness = props.motionStiffness,
      motionDamping = props.motionDamping,
      role = props.role;
  var generateBars = groupMode === 'grouped' ? generateGroupedBars : generateStackedBars;
  var result = generateBars({
    layout: layout,
    reverse: reverse,
    data: data,
    getIndex: getIndex,
    keys: keys,
    minValue: minValue,
    maxValue: maxValue,
    width: width,
    height: height,
    getColor: getColor,
    padding: padding,
    innerPadding: innerPadding,
    valueScale: valueScale,
    indexScale: indexScale
  });
  var motionProps = {
    animate: animate,
    motionDamping: motionDamping,
    motionStiffness: motionStiffness
  };
  var springConfig = {
    damping: motionDamping,
    stiffness: motionStiffness
  };
  var willEnter = layout === 'vertical' ? barWillEnterVertical : barWillEnterHorizontal;
  var willLeave = layout === 'vertical' ? barWillLeaveVertical(springConfig) : barWillLeaveHorizontal(springConfig);
  var shouldRenderLabel = function shouldRenderLabel(_ref5) {
    var width = _ref5.width,
        height = _ref5.height;
    if (!enableLabel) return false;
    if (labelSkipWidth > 0 && width < labelSkipWidth) return false;
    if (labelSkipHeight > 0 && height < labelSkipHeight) return false;
    return true;
  };
  var boundDefs = bindDefs(defs, result.bars, fill, {
    dataKey: 'data',
    targetKey: 'data.fill'
  });
  return React__default.createElement(LegacyContainer, {
    isInteractive: isInteractive,
    theme: theme,
    animate: animate,
    motionStiffness: motionStiffness,
    motionDamping: motionDamping
  }, function (_ref6) {
    var showTooltip = _ref6.showTooltip,
        hideTooltip = _ref6.hideTooltip;
    var commonProps = {
      borderRadius: borderRadius,
      borderWidth: borderWidth,
      enableLabel: enableLabel,
      labelSkipWidth: labelSkipWidth,
      labelSkipHeight: labelSkipHeight,
      showTooltip: showTooltip,
      hideTooltip: hideTooltip,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      theme: theme,
      getTooltipLabel: getTooltipLabel,
      tooltipFormat: tooltipFormat,
      tooltip: tooltip
    };
    var bars;
    if (animate === true) {
      bars = React__default.createElement(TransitionMotion$1, {
        key: "bars",
        willEnter: willEnter,
        willLeave: willLeave,
        styles: result.bars.filter(function (bar) {
          return bar.data.value !== null;
        }).map(function (bar) {
          return {
            key: bar.key,
            data: bar,
            style: {
              x: spring$1(bar.x, springConfig),
              y: spring$1(bar.y, springConfig),
              width: spring$1(bar.width, springConfig),
              height: spring$1(bar.height, springConfig)
            }
          };
        })
      }, function (interpolatedStyles) {
        return React__default.createElement("g", null, interpolatedStyles.map(function (_ref7) {
          var key = _ref7.key,
              style = _ref7.style,
              bar = _ref7.data;
          var baseProps = _objectSpread2$2(_objectSpread2$2({}, bar), style);
          return React__default.createElement(barComponent, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
            key: key
          }, baseProps), commonProps), {}, {
            shouldRenderLabel: shouldRenderLabel(baseProps),
            width: Math.max(style.width, 0),
            height: Math.max(style.height, 0),
            label: getLabel(bar.data),
            labelColor: getLabelTextColor(baseProps, theme),
            borderColor: getBorderColor(baseProps),
            theme: theme
          }));
        }));
      });
    } else {
      bars = result.bars.filter(function (bar) {
        return bar.data.value !== null;
      }).map(function (d) {
        return React__default.createElement(barComponent, _objectSpread2$2(_objectSpread2$2(_objectSpread2$2({
          key: d.key
        }, d), commonProps), {}, {
          label: getLabel(d.data),
          shouldRenderLabel: shouldRenderLabel(d),
          labelColor: getLabelTextColor(d, theme),
          borderColor: getBorderColor(d),
          theme: theme
        }));
      });
    }
    var layerById = {
      grid: React__default.createElement(Grid, {
        key: "grid",
        width: width,
        height: height,
        xScale: enableGridX ? result.xScale : null,
        yScale: enableGridY ? result.yScale : null,
        xValues: gridXValues,
        yValues: gridYValues
      }),
      axes: React__default.createElement(Axes, {
        key: "axes",
        xScale: result.xScale,
        yScale: result.yScale,
        width: width,
        height: height,
        top: axisTop,
        right: axisRight,
        bottom: axisBottom,
        left: axisLeft
      }),
      bars: bars,
      markers: React__default.createElement(CartesianMarkers$1, {
        key: "markers",
        markers: markers,
        width: width,
        height: height,
        xScale: result.xScale,
        yScale: result.yScale,
        theme: theme
      }),
      legends: legends.map(function (legend, i) {
        var legendData = getLegendData({
          from: legend.dataFrom,
          bars: result.bars,
          layout: layout,
          direction: legend.direction,
          groupMode: groupMode,
          reverse: reverse
        });
        if (legendData === undefined) return null;
        return React__default.createElement(BoxLegendSvg, Object.assign({
          key: i
        }, legend, {
          containerWidth: width,
          containerHeight: height,
          data: legendData,
          theme: theme
        }));
      }),
      annotations: React__default.createElement(BarAnnotations, Object.assign({
        key: "annotations",
        innerWidth: width,
        innerHeight: height,
        bars: result.bars,
        annotations: annotations
      }, motionProps))
    };
    return React__default.createElement(SvgWrapper, {
      width: outerWidth,
      height: outerHeight,
      margin: margin,
      defs: boundDefs,
      theme: theme,
      role: role
    }, layers.map(function (layer, i) {
      if (typeof layer === 'function') {
        return React__default.createElement(Fragment, {
          key: i
        }, layer(_objectSpread2$2(_objectSpread2$2(_objectSpread2$2({}, props), result), {}, {
          showTooltip: showTooltip,
          hideTooltip: hideTooltip
        })));
      }
      return layerById[layer];
    }));
  });
};
Bar.defaultProps = BarSvgDefaultProps;
var Bar$1 = setDisplayName('Bar')(enhance$1(Bar));

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }
  return _typeof(obj);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }
  return _assertThisInitialized(self);
}

function _createSuper$1(Derived) {
  return function () {
    var Super = _getPrototypeOf$1(Derived),
        result;
    if (_isNativeReflectConstruct$1()) {
      var NewTarget = _getPrototypeOf$1(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn$1(this, result);
  };
}

var findNodeUnderCursor = function findNodeUnderCursor(nodes, margin, x, y) {
  return nodes.find(function (node) {
    return isCursorInRect(node.x + margin.left, node.y + margin.top, node.width, node.height, x, y);
  });
};
var BarCanvas = function (_Component) {
  _inherits$1(BarCanvas, _Component);
  var _super = _createSuper$1(BarCanvas);
  function BarCanvas() {
    var _this;
    _classCallCheck(this, BarCanvas);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.handleMouseHover = function (showTooltip, hideTooltip) {
      return function (event) {
        if (!_this.bars) return;
        var _this$props = _this.props,
            margin = _this$props.margin,
            theme = _this$props.theme,
            tooltip = _this$props.tooltip,
            getTooltipLabel = _this$props.getTooltipLabel,
            tooltipFormat = _this$props.tooltipFormat;
        var _getRelativeCursor = getRelativeCursor(_this.surface, event),
            _getRelativeCursor2 = _slicedToArray$2(_getRelativeCursor, 2),
            x = _getRelativeCursor2[0],
            y = _getRelativeCursor2[1];
        var bar = findNodeUnderCursor(_this.bars, margin, x, y);
        if (bar !== undefined) {
          showTooltip(React__default.createElement(BasicTooltip, {
            id: getTooltipLabel(bar.data),
            value: bar.data.value,
            enableChip: true,
            color: bar.color,
            theme: theme,
            format: tooltipFormat,
            renderContent: typeof tooltip === 'function' ? tooltip.bind(null, _objectSpread2$2({
              color: bar.color
            }, bar.data)) : null
          }), event);
        } else {
          hideTooltip();
        }
      };
    };
    _this.handleMouseLeave = function (hideTooltip) {
      return function () {
        hideTooltip();
      };
    };
    _this.handleClick = function (event) {
      if (!_this.bars) return;
      var _this$props2 = _this.props,
          margin = _this$props2.margin,
          onClick = _this$props2.onClick;
      var _getRelativeCursor3 = getRelativeCursor(_this.surface, event),
          _getRelativeCursor4 = _slicedToArray$2(_getRelativeCursor3, 2),
          x = _getRelativeCursor4[0],
          y = _getRelativeCursor4[1];
      var node = findNodeUnderCursor(_this.bars, margin, x, y);
      if (node !== undefined) onClick(node.data, event);
    };
    return _this;
  }
  _createClass(BarCanvas, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ctx = this.surface.getContext('2d');
      this.draw(this.props);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(props) {
      if (this.props.outerWidth !== props.outerWidth || this.props.outerHeight !== props.outerHeight || this.props.isInteractive !== props.isInteractive || this.props.theme !== props.theme) {
        return true;
      } else {
        this.draw(props);
        return false;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.ctx = this.surface.getContext('2d');
      this.draw(this.props);
    }
  }, {
    key: "draw",
    value: function draw(props) {
      var _this2 = this;
      var data = props.data,
          keys = props.keys,
          getIndex = props.getIndex,
          minValue = props.minValue,
          maxValue = props.maxValue,
          valueScale = props.valueScale,
          indexScale = props.indexScale,
          width = props.width,
          height = props.height,
          outerWidth = props.outerWidth,
          outerHeight = props.outerHeight,
          pixelRatio = props.pixelRatio,
          margin = props.margin,
          layout = props.layout,
          reverse = props.reverse,
          groupMode = props.groupMode,
          padding = props.padding,
          innerPadding = props.innerPadding,
          axisTop = props.axisTop,
          axisRight = props.axisRight,
          axisBottom = props.axisBottom,
          axisLeft = props.axisLeft,
          theme = props.theme,
          getColor = props.getColor,
          borderWidth = props.borderWidth,
          getBorderColor = props.getBorderColor,
          legends = props.legends,
          enableGridX = props.enableGridX,
          gridXValues = props.gridXValues,
          enableGridY = props.enableGridY,
          gridYValues = props.gridYValues;
      this.surface.width = outerWidth * pixelRatio;
      this.surface.height = outerHeight * pixelRatio;
      this.ctx.scale(pixelRatio, pixelRatio);
      var options = {
        layout: layout,
        reverse: reverse,
        data: data,
        getIndex: getIndex,
        keys: keys,
        minValue: minValue,
        maxValue: maxValue,
        width: width,
        height: height,
        getColor: getColor,
        padding: padding,
        innerPadding: innerPadding,
        valueScale: valueScale,
        indexScale: indexScale
      };
      var result = groupMode === 'grouped' ? generateGroupedBars(options) : generateStackedBars(options);
      this.bars = result.bars;
      this.ctx.fillStyle = theme.background;
      this.ctx.fillRect(0, 0, outerWidth, outerHeight);
      this.ctx.translate(margin.left, margin.top);
      if (theme.grid.line.strokeWidth > 0) {
        this.ctx.lineWidth = theme.grid.line.strokeWidth;
        this.ctx.strokeStyle = theme.grid.line.stroke;
        enableGridX && renderGridLinesToCanvas(this.ctx, {
          width: width,
          height: height,
          scale: result.xScale,
          axis: 'x',
          values: gridXValues
        });
        enableGridY && renderGridLinesToCanvas(this.ctx, {
          width: width,
          height: height,
          scale: result.yScale,
          axis: 'y',
          values: gridYValues
        });
      }
      this.ctx.strokeStyle = '#dddddd';
      var legendDataForKeys = _uniqBy(result.bars.map(function (bar) {
        return {
          id: bar.data.id,
          label: bar.data.id,
          color: bar.color,
          fill: bar.data.fill
        };
      }).reverse(), function (_ref) {
        var id = _ref.id;
        return id;
      });
      var legendDataForIndexes = _uniqBy(result.bars.map(function (bar) {
        return {
          id: bar.data.indexValue,
          label: bar.data.indexValue,
          color: bar.color,
          fill: bar.data.fill
        };
      }), function (_ref2) {
        var id = _ref2.id;
        return id;
      });
      legends.forEach(function (legend) {
        var legendData;
        if (legend.dataFrom === 'keys') {
          legendData = legendDataForKeys;
        } else if (legend.dataFrom === 'indexes') {
          legendData = legendDataForIndexes;
        }
        if (legendData === undefined) return null;
        renderLegendToCanvas(_this2.ctx, _objectSpread2$2(_objectSpread2$2({}, legend), {}, {
          data: legendData,
          containerWidth: width,
          containerHeight: height,
          itemTextColor: '#999',
          symbolSize: 16,
          theme: theme
        }));
      });
      renderAxesToCanvas(this.ctx, {
        xScale: result.xScale,
        yScale: result.yScale,
        width: width,
        height: height,
        top: axisTop,
        right: axisRight,
        bottom: axisBottom,
        left: axisLeft,
        theme: theme
      });
      result.bars.forEach(function (bar) {
        var x = bar.x,
            y = bar.y,
            color = bar.color,
            width = bar.width,
            height = bar.height;
        _this2.ctx.fillStyle = color;
        if (borderWidth > 0) {
          _this2.ctx.strokeStyle = getBorderColor(bar);
          _this2.ctx.lineWidth = borderWidth;
        }
        _this2.ctx.beginPath();
        _this2.ctx.rect(x, y, width, height);
        _this2.ctx.fill();
        if (borderWidth > 0) {
          _this2.ctx.stroke();
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props3 = this.props,
          outerWidth = _this$props3.outerWidth,
          outerHeight = _this$props3.outerHeight,
          pixelRatio = _this$props3.pixelRatio,
          isInteractive = _this$props3.isInteractive,
          theme = _this$props3.theme,
          canvasRef = _this$props3.canvasRef;
      return React__default.createElement(LegacyContainer, {
        isInteractive: isInteractive,
        theme: theme,
        animate: false
      }, function (_ref3) {
        var showTooltip = _ref3.showTooltip,
            hideTooltip = _ref3.hideTooltip;
        return React__default.createElement("canvas", {
          ref: function ref(surface) {
            _this3.surface = surface;
            if (canvasRef) canvasRef.current = surface;
          },
          width: outerWidth * pixelRatio,
          height: outerHeight * pixelRatio,
          style: {
            width: outerWidth,
            height: outerHeight
          },
          onMouseEnter: _this3.handleMouseHover(showTooltip, hideTooltip),
          onMouseMove: _this3.handleMouseHover(showTooltip, hideTooltip),
          onMouseLeave: _this3.handleMouseLeave(hideTooltip),
          onClick: _this3.handleClick
        });
      });
    }
  }]);
  return BarCanvas;
}(Component);
BarCanvas.defaultProps = BarDefaultProps;
var EnhancedBarCanvas = setDisplayName('BarCanvas')(enhance$1(BarCanvas));
var BarCanvas$1 = React__default.forwardRef(function (props, ref) {
  return React__default.createElement(EnhancedBarCanvas, Object.assign({}, props, {
    canvasRef: ref
  }));
});

var ResponsiveBar = function ResponsiveBar(props) {
  return React__default.createElement(ResponsiveWrapper$1, null, function (_ref) {
    var width = _ref.width,
        height = _ref.height;
    return React__default.createElement(Bar$1, Object.assign({
      width: width,
      height: height
    }, props));
  });
};

var ResponsiveBarCanvas = function ResponsiveBarCanvas(props, ref) {
  return React__default.createElement(ResponsiveWrapper$1, null, function (_ref) {
    var width = _ref.width,
        height = _ref.height;
    return React__default.createElement(BarCanvas$1, Object.assign({
      width: width,
      height: height
    }, props, {
      ref: ref
    }));
  });
};
React__default.forwardRef(ResponsiveBarCanvas);

var css_248z$1u = ".tick{-webkit-box-orient:vertical;-webkit-line-clamp:3!important;display:block;display:-webkit-box;height:auto!important;margin:0 auto;max-height:4rem!important;overflow:hidden;overflow-wrap:break-word;text-overflow:ellipsis}.tick-subtitle{opacity:.5;padding-top:2px}";
styleInject(css_248z$1u);

const calcMaxDataValue = (data, keys) => {
    if (data.length === 0)
        return 0;
    if (keys === undefined) {
        return Math.max(...data.map(item => item.value));
    }
    const values = data.map(item => keys.reduce((sum, key) => sum + item[key], 0));
    return Math.max(...values);
};
const calcMaxBarChartValue = (maxValue, gridYValues, data, keys) => {
    if (maxValue !== 'auto')
        return maxValue;
    let calculatedMaxValue = calcMaxDataValue(data, keys);
    const hasGridYValues = gridYValues && Array.isArray(gridYValues) && !isNaN(Number(gridYValues[0]));
    if (hasGridYValues) {
        const maxGridYValue = Math.max(...gridYValues);
        calculatedMaxValue = Math.max(maxGridYValue, calculatedMaxValue);
    }
    return calculatedMaxValue;
};

const useResizeObserver = () => {
    const [width, setWidth] = useState(0);
    const [height, setHeight] = useState(0);
    let resizeObserverObj = null;
    if (window.ResizeObserver) {
        resizeObserverObj = new ResizeObserver((entries) => {
            var _a, _b;
            setWidth((_a = entries[0]) === null || _a === void 0 ? void 0 : _a.target.scrollWidth);
            setHeight((_b = entries[0]) === null || _b === void 0 ? void 0 : _b.target.scrollHeight);
        });
    }
    else {
        // the else is for the tests, where it's not defined
        resizeObserverObj = { observe: () => undefined, disconnect: () => undefined };
    }
    const resizeObserver = useRef(resizeObserverObj);
    const resizedContainerRef = useCallback$1((container) => {
        if (container !== null) {
            resizeObserver.current.observe(container);
        }
        else if (resizeObserver.current) {
            resizeObserver.current.disconnect();
        }
    }, [resizeObserver.current]);
    return { width, height, resizedContainerRef };
};

const useStyles$i = makeStyles$1(() => ({
    label: {
        fontSize: '11px',
        fontFamily: 'sans-serif',
        color: 'rgb(51, 51, 51)',
        textAlign: 'center'
    }
}));
const calcIdsToItems = (data) => {
    const idsToItems = {};
    data.forEach(item => {
        idsToItems[item.id] = item;
    });
    return idsToItems;
};
const defaultBottomLegendWidth = 47;
const minBottomLegendWidth = 30;
const chartMarginWidth = 180;
const BarChart = (props) => {
    const { data, maxValue = 100, minValue = 0, gridYValues, borderRadius = 4, axisBottomLegend, axisLeftLegend, labelUnSelectedTextColor = 'white', keys, colors, showTooltip = false, customTooltip, topMargin = 50, dynamicLegendWidth = true, showUnitAndValuesInTooltip, singularUnitText, pluralUnitText } = props;
    const classes = useStyles$i();
    const { width: chartWidth, resizedContainerRef } = useResizeObserver();
    const idsToItems = useMemo$1(() => calcIdsToItems(data), [data]);
    const hasSubTitles = useMemo$1(() => data.filter(item => item.subTitle !== undefined).length > 0, [data]);
    const getBottomLegendWidth = () => {
        let bottomLegendWidth = defaultBottomLegendWidth;
        const netChartWidth = chartWidth - chartMarginWidth;
        if (dynamicLegendWidth && netChartWidth > minBottomLegendWidth) {
            const numberOfBars = data.length;
            if (numberOfBars === 0)
                return bottomLegendWidth;
            bottomLegendWidth = netChartWidth / numberOfBars;
        }
        return bottomLegendWidth;
    };
    const bottomLegendWidth = useMemo$1(() => getBottomLegendWidth(), [getBottomLegendWidth]);
    const getPadding = (numberOfBars) => {
        const padding = 0.94 - 0.055 * numberOfBars;
        if (padding > 0.2)
            return padding;
        return 0.2;
    };
    const renderTick = ({ value, x, y }) => {
        var _a;
        const subTitle = (_a = idsToItems[value]) === null || _a === void 0 ? void 0 : _a.subTitle;
        let title = '';
        if (idsToItems[value]) {
            title = idsToItems[value].displayName || value;
        }
        return (jsxs("foreignObject", Object.assign({ x: x - bottomLegendWidth / 2, y: y + 5, width: bottomLegendWidth, height: subTitle ? 60 : 45 }, { children: [jsx("div", Object.assign({ title: title, className: classNames(classes.label, 'tick', 'class-ellipsis-2-lines') }, { children: title }), void 0), subTitle && (jsx("div", Object.assign({ title: value, className: classNames(classes.label, 'tick', 'tick-subtitle', 'class-ellipsis-2-lines') }, { children: subTitle }), void 0))] }), void 0));
    };
    const calculatedMaxValue = useMemo$1(() => calcMaxBarChartValue(maxValue, gridYValues, data, keys), [maxValue, gridYValues, data, keys]);
    const calcColumnTotal = (id) => {
        let columnTotal = 0;
        const column = idsToItems[id];
        if (keys)
            columnTotal = (keys === null || keys === void 0 ? void 0 : keys.reduce((sum, key) => sum + (column[key] || 0), 0)) || 0;
        else
            columnTotal = column.value || 0;
        return columnTotal;
    };
    const customTooltipWithUnitAndValues = ({ index, color, id, value, data }) => {
        return (jsx(LegendComponent, { legends: [
                {
                    color,
                    text: id,
                    value,
                    className: 'legend-rows'
                }
            ], singularUnitText: singularUnitText, pluralUnitText: pluralUnitText, isVertical: true, showValues: true, total: calcColumnTotal(data.id) }, index));
    };
    return (jsx("div", Object.assign({ ref: resizedContainerRef, style: { width: '100%', height: '100%' } }, { children: jsx(ResponsiveBar, { data: data, keys: keys, indexBy: "id", maxValue: calculatedMaxValue, minValue: minValue, labelSkipHeight: 26, margin: { top: topMargin, right: 60, bottom: hasSubTitles ? 100 : 60, left: 60 }, padding: getPadding(data.length), colors: (bar) => (colors === null || colors === void 0 ? void 0 : colors[bar.id]) || bar.data.color, isInteractive: showTooltip, animate: false, gridYValues: gridYValues, axisLeft: {
                tickSize: 0,
                tickPadding: 15,
                tickValues: gridYValues,
                legend: axisLeftLegend,
                legendOffset: -50,
                legendPosition: 'middle'
            }, axisBottom: {
                tickSize: 0,
                tickPadding: 10,
                renderTick,
                legend: axisBottomLegend,
                legendOffset: hasSubTitles ? 80 : 40,
                legendPosition: 'middle'
            }, borderColor: (bar) => {
                return bar.data.data.isSelected ? '#565360' : bar.data.data.color;
            }, borderWidth: 3, labelTextColor: (bar) => {
                return bar.data.data.isSelected ? 'black' : labelUnSelectedTextColor;
            }, borderRadius: borderRadius, labelFormat: (labelValue) => (jsx("tspan", Object.assign({ y: 20 }, { children: labelValue }), void 0)), tooltip: showUnitAndValuesInTooltip ? customTooltipWithUnitAndValues : customTooltip }, void 0) }), void 0));
};

var css_248z$1t = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.square-card-view .title{align-items:center;display:flex;font-size:1.0625rem;height:23%;margin-left:1rem}.square-card-view hr{border:0;border-top:1px solid #ebebeb;display:block;height:1px;margin:0;padding:0}.square-card-view .content{align-items:center;display:flex;height:77%;justify-content:center}";
styleInject(css_248z$1t);

const SquareCardView = (props) => {
    const { title, content, widthAndHeightClass = 'class-width-height-230-px' } = props;
    return (jsxs(Card, Object.assign({ className: classNames('square-card-view', widthAndHeightClass) }, { children: [jsx("div", Object.assign({ className: "title" }, { children: title }), void 0), jsx("hr", {}, void 0), jsx("div", Object.assign({ className: "content" }, { children: content }), void 0)] }), void 0));
};

const LabelInformation = (props) => {
    const { dataTestId, title, value, type, isLast, isSelected, className, onClick } = props;
    let text = '';
    switch (type) {
        case 'leftWithComma':
            text = `(${value}) ${title}${isLast ? '' : ',\u00A0'}`;
            break;
        case 'right':
            text = isSelected ? `${title} \u00A0(${value})` : title;
            break;
    }
    return (jsx("div", Object.assign({ "data-testid": dataTestId, className: className, onClick: (_e) => onClick === null || onClick === void 0 ? void 0 : onClick() }, { children: text }), void 0));
};

var LabelInformationType;
(function (LabelInformationType) {
    LabelInformationType[LabelInformationType["leftWithComma"] = 0] = "leftWithComma";
    LabelInformationType[LabelInformationType["right"] = 1] = "right";
})(LabelInformationType || (LabelInformationType = {}));

var css_248z$1s = ".back{align-items:center;cursor:pointer;display:flex}.back h1{font-size:1.4375rem}.back .title{font-weight:700}";
styleInject(css_248z$1s);

const Back = (props) => {
    const { onBack, text, dataTestId, color } = props;
    return (jsxs("div", Object.assign({ className: "back", onClick: () => onBack(), "data-testid": "back" }, { children: [jsx(ArrowBackIosIcon, { color: color, "data-testid": dataTestId || 'arrow-back' }, void 0), jsx("h2", Object.assign({ className: "title" }, { children: text }), void 0)] }), void 0));
};

var BackColors;
(function (BackColors) {
    BackColors[BackColors["inherit"] = 0] = "inherit";
    BackColors[BackColors["disabled"] = 1] = "disabled";
    BackColors[BackColors["action"] = 2] = "action";
    BackColors[BackColors["primary"] = 3] = "primary";
    BackColors[BackColors["secondary"] = 4] = "secondary";
    BackColors[BackColors["error"] = 5] = "error";
})(BackColors || (BackColors = {}));

var css_248z$1r = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.drop-select{align-items:center!important;display:flex!important}.drop-select .front-text{color:#6b6874!important;font-size:1rem!important}.drop-select .front-text,.drop-select .MuiInputBase-input{line-height:normal!important}";
styleInject(css_248z$1r);

const useStyles$h = makeStyles$1(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2)
    },
    select: {
        '&:focus': {
            backgroundColor: 'transparent'
        }
    },
    icon: {
        lineHeight: 'normal',
        top: 'calc(50% - 0.75rem)'
    }
}));
const DropDown = (props) => {
    const classes = useStyles$h();
    const { values, onChange, currentValue = '', frontText = '', disabled = false } = props;
    const minWidth = '12.125rem';
    return (jsxs("div", Object.assign({ className: "drop-select" }, { children: [frontText !== '' && jsx("div", Object.assign({ className: "front-text" }, { children: `${frontText}\u00A0\u00A0` }), void 0), jsx(FormControl, { children: jsx(Select, Object.assign({ "data-testid": "drop-down", classes: { select: classes.select, icon: classes.icon }, disableUnderline: true, disabled: disabled, value: currentValue, onChange: (e) => onChange(e.target.value), displayEmpty: true, MenuProps: {
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'right'
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'right'
                        },
                        PaperProps: {
                            style: {
                                minWidth
                            }
                        }
                    } }, { children: values.map(value => (jsx(MenuItem, Object.assign({ value: value.value }, { children: value.text }), value.value))) }), void 0) }, void 0)] }), void 0));
};

var css_248z$1q = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.class-hover-pointer{cursor:pointer}.class-font-colour-disabled-icon{color:#d8d8d8!important}.class-full-width{justify-content:flex-start!important;width:100%!important}.class-disabled-menuItem{cursor:not-allowed!important;pointer-events:all!important}";
styleInject(css_248z$1q);

const Menu = ({ menuItems, iconClassName, disabled = false }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        if (!disabled)
            setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const [openTooltip, setOpenTooltip] = useState(-1);
    return (jsxs(Fragment, { children: [jsx(MoreVertOutlinedIcon, { "data-testid": "menu-items-icon", color: "action", onClick: handleClick, className: classNames(iconClassName, {
                    'class-hover-pointer': !disabled,
                    'class-font-colour-disabled-icon': disabled
                }) }, void 0), jsx(Menu$1, Object.assign({ anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose }, { children: menuItems === null || menuItems === void 0 ? void 0 : menuItems.map((menuItem, i) => (jsx(TooltipContainer, Object.assign({ title: menuItem.tooltipText || '', open: openTooltip === i }, { children: jsx(MenuItem, Object.assign({ onClick: (e) => {
                            var _a;
                            if (menuItem.disabled) {
                                e.stopPropagation();
                                return;
                            }
                            setAnchorEl(null);
                            // eslint-disable-next-line
                            (_a = menuItem.onClick) === null || _a === void 0 ? void 0 : _a.call(menuItem, e);
                        }, onMouseEnter: () => setOpenTooltip(i), onMouseLeave: () => setOpenTooltip(-1), disabled: menuItem.disabled, className: classNames({ 'class-disabled-menuItem': menuItem.disabled }) }, { children: menuItem.text }), menuItem.text) }), menuItem.text))) }), void 0)] }, void 0));
};

var css_248z$1p = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.class-overflow-y-unset .MuiPaper-root{overflow-y:unset!important}.class-close-icon{color:#d8d8d8!important;cursor:pointer;position:absolute;right:-1.5rem;top:-3.3rem}.dialog-title{align-items:center;display:flex;justify-content:space-between;width:100%}.class-margin-bottom-1-rem{margin-bottom:1rem}.dialog .MuiPaper-root{position:absolute!important;top:var(--top)!important}";
styleInject(css_248z$1p);

const DialogContainer = (props) => {
    const { title, onClose, open, children, isList, className, style, hasCloseIconOutside, dataTestid } = props;
    return (jsxs(Dialog, Object.assign({ onClose: (e) => onClose(e), open: open, style: style, fullWidth: true, "data-testid": dataTestid, className: classNames(className, 'dialog', { 'class-overflow-y-unset': hasCloseIconOutside }) }, { children: [hasCloseIconOutside && (jsx(CloseIcon, { "data-testid": "close-icon", className: "class-close-icon", fontSize: "large", onClick: () => onClose() }, void 0)), jsx(DialogTitle, { children: jsxs("div", Object.assign({ className: "dialog-title" }, { children: [title, !hasCloseIconOutside && (jsx(IconButton$1, Object.assign({ onClick: (e) => onClose(e), "data-testid": "close-icon" }, { children: jsx(CloseIcon, {}, void 0) }), void 0))] }), void 0) }, void 0), !isList && jsx(DialogContent, Object.assign({ className: "class-margin-bottom-1-rem" }, { children: children }), void 0), isList && (jsx(List, { children: children.map((child, i) => (jsx(ListItem, Object.assign({ button: true }, child === null || child === void 0 ? void 0 : child.props, { children: child }), i))) }, void 0))] }), void 0));
};

var css_248z$1o = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.go-back{align-items:center;background-color:#30424b;cursor:pointer;display:flex;height:6%;justify-content:center;position:absolute;top:.1%;width:3%}.arrow-back{color:#fff;font-size:1.5rem}";
styleInject(css_248z$1o);

const GoBack = (props) => {
    const { goBackFunction, onClick, dataTestid } = props;
    const onClickArrow = () => {
        // eslint-disable-next-line
        goBackFunction === null || goBackFunction === void 0 ? void 0 : goBackFunction();
        // eslint-disable-next-line
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    return (jsx("div", Object.assign({ "data-testid": dataTestid, className: "go-back", onClick: onClickArrow }, { children: jsx(ArrowBack, { className: "arrow-back" }, void 0) }), void 0));
};

var TextFieldTypesName;
(function (TextFieldTypesName) {
    TextFieldTypesName[TextFieldTypesName["default"] = 0] = "default";
    TextFieldTypesName[TextFieldTypesName["transparent"] = 1] = "transparent";
    TextFieldTypesName[TextFieldTypesName["transparent-0-point-1"] = 2] = "transparent-0-point-1";
})(TextFieldTypesName || (TextFieldTypesName = {}));
const TextFieldType = {
    default: {},
    transparent: { className: 'transparent-text-field' },
    'transparent-0-point-1': { className: 'transparent-0-point-1-text-field' }
};

var css_248z$1n = ".textField-module_class-ellipsis-2-lines__DALJK,.textField-module_class-ellipsis-lines__hkeJe{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.textField-module_class-ellipsis-2-lines__DALJK{-webkit-line-clamp:2!important;max-height:4rem!important}.textField-module_MuiChip-root__jGp-L{margin:.5rem .3rem .5rem .5rem}.textField-module_ellipse-chip__dNONO.textField-module_MuiChip-root__jGp-L{border-radius:1rem;height:20px}.textField-module_ellipse-chip__dNONO.textField-module_MuiChip-root__jGp-L .textField-module_MuiChip-label__1EDW2{padding-left:8px;padding-right:8px}.textField-module_square-chip__VNpo0.textField-module_MuiChip-root__jGp-L{border-radius:0!important}.textField-module_class-width-height-100__k9D9f{height:100%;width:100%}.textField-module_MuiTooltip-tooltip__QrE2y{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.textField-module_MuiTooltip-arrow__eYOjt{color:#fff!important}.textField-module_class-font-size-icon__Igyes{font-size:1.25rem}.textField-module_text-field__koAHR{height:100%}.textField-module_text-field__koAHR::-webkit-scrollbar-thumb{border-radius:none!important}.textField-module_text-field__koAHR div{background-color:#fff}.textField-module_text-field__koAHR .MuiOutlinedInput-root{border-radius:0!important}.textField-module_class-height-75-div__E0am2 div{height:75%}.textField-module_transparent-text-field__YJ8QX .MuiOutlinedInput-notchedOutline{border-color:var(--inputNotchedOutlineColor)!important;border-width:0 0 2px!important;outline:0!important}.textField-module_transparent-text-field__YJ8QX .MuiOutlinedInput-input{color:var(--inputTextColor)!important;font-size:var(--inputTextSize)}.textField-module_transparent-text-field__YJ8QX .textField-module_text-field__koAHR div{background:none!important;font-weight:var(--textFieldFontWeight)}.textField-module_transparent-0-point-1-text-field__h8J2F .MuiOutlinedInput-input{color:hsla(0,0%,100%,.7)!important}.textField-module_transparent-0-point-1-text-field__h8J2F .MuiOutlinedInput-root{background:hsla(0,0%,100%,.1);border-radius:4px!important}";
var styles$H = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"textField-module_class-ellipsis-lines__hkeJe","class-ellipsis-2-lines":"textField-module_class-ellipsis-2-lines__DALJK","MuiChip-root":"textField-module_MuiChip-root__jGp-L","ellipse-chip":"textField-module_ellipse-chip__dNONO","MuiChip-label":"textField-module_MuiChip-label__1EDW2","square-chip":"textField-module_square-chip__VNpo0","class-width-height-100":"textField-module_class-width-height-100__k9D9f","MuiTooltip-tooltip":"textField-module_MuiTooltip-tooltip__QrE2y","MuiTooltip-arrow":"textField-module_MuiTooltip-arrow__eYOjt","class-font-size-icon":"textField-module_class-font-size-icon__Igyes","text-field":"textField-module_text-field__koAHR","class-height-75-div":"textField-module_class-height-75-div__E0am2","transparent-text-field":"textField-module_transparent-text-field__YJ8QX","transparent-0-point-1-text-field":"textField-module_transparent-0-point-1-text-field__h8J2F"};
styleInject(css_248z$1n);

const TextFieldContainer = (props) => {
    const { placeholder = '', variant = 'outlined', dataTestid = 'text-field', size = 'small', onChange, value = '', params, autoComplete, inputProps, className, fullHeight = true, maxLength, error, InputProps, type = 'default', onBlur, width, inputTextSize = 'large', inputTextColor = 'white', inputNotchedOutlineColor = 'white', textFieldFontWeight = 700 } = props, rest = __rest$1(props, ["placeholder", "variant", "dataTestid", "size", "onChange", "value", "params", "autoComplete", "inputProps", "className", "fullHeight", "maxLength", "error", "InputProps", "type", "onBlur", "width", "inputTextSize", "inputTextColor", "inputNotchedOutlineColor", "textFieldFontWeight"]);
    const useStyles = makeStyles$1(() => createStyles({
        input: {
            color: '#757575 !important'
        },
        notchedOutline: {
            border: '1px solid #c4c4c4 !important'
        },
        helperText: Object.assign({ marginLeft: 0 }, (error && { color: '#F1605D !important' }))
    }));
    const classes = useStyles();
    const auxiliaryProps = Object.assign({}, TextFieldType[type]);
    return (jsx("span", Object.assign({ className: classNames(styles$H[auxiliaryProps.className || ''], 'text-field-wrapper') }, { children: jsx(TextField, Object.assign({}, rest, { placeholder: placeholder, variant: variant, onChange: (e) => onChange && onChange(e.target.value), value: value, inputProps: Object.assign({ 'data-testid': dataTestid, maxLength }, inputProps), size: size, name: autoComplete ? 'username' : '', autoComplete: autoComplete ? 'username' : '', error: error, onBlur: (e) => onBlur && onBlur(e.target.value), className: classNames(styles$H['text-field'], className, styles$H[auxiliaryProps.className || ''], {
                [styles$H['class-height-75-div']]: fullHeight
            }), FormHelperTextProps: {
                className: classes.helperText
            }, InputProps: Object.assign(Object.assign({}, InputProps), { classes: Object.assign({}, (variant === 'outlined' && {
                    notchedOutline: classes.notchedOutline,
                    input: classes.input
                })) }), style: {
                width,
                '--inputTextSize': inputTextSize,
                '--inputTextColor': inputTextColor,
                '--textFieldFontWeight': textFieldFontWeight,
                '--inputNotchedOutlineColor': inputNotchedOutlineColor
            } }, params), void 0) }), void 0));
};

var css_248z$1m = ".noPermission-module_container__GTjVW{align-items:center;display:flex;flex-direction:column;height:100vh;justify-content:center}";
var styles$G = {"container":"noPermission-module_container__GTjVW"};
styleInject(css_248z$1m);

const NoPermission = () => jsx("div", Object.assign({ className: styles$G.container }, { children: "No Permission" }), void 0);

var css_248z$1l = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.key-value-rectangle-wrapper{align-items:center;border:1px solid #bfbdc2;border-radius:5px;display:flex;height:100%;justify-content:space-around;justify-content:center;min-width:20rem;position:relative}.key-value-rectangle-wrapper .element,.key-value-rectangle-wrapper .key-element,.key-value-rectangle-wrapper .value-element{align-items:center;color:#565360;display:flex;height:100%;justify-content:center;max-width:40rem;min-width:9rem}.key-value-rectangle-wrapper .key-element{font-size:.9375rem;font-weight:300}.key-value-rectangle-wrapper .value-element{-webkit-box-orient:vertical;-webkit-line-clamp:3!important;display:block;display:-webkit-box;font-size:1.0625rem;height:auto!important;margin:0 auto;max-height:4rem!important;overflow:hidden;padding-left:1rem;padding-right:1rem;text-align:center;text-overflow:ellipsis}.key-value-rectangle-wrapper .key-element-left{justify-content:left!important;padding-left:1rem;padding-right:1rem}.key-value-rectangle-wrapper .value-element-left{text-align:left!important}.with-margin{margin-left:3rem}.vertical-line{border-left:1px solid #bfbdc2;height:100%}";
styleInject(css_248z$1l);

const KeyValueRectanglePresent = (props) => {
    const { keyElement, valueElement, withMargin, valueWidthClassName, alignTextsLeft = false } = props;
    return (jsxs("div", Object.assign({ "data-testid": "key-value-rectangle", className: classNames('key-value-rectangle-wrapper', {
            'with-margin': withMargin
        }) }, { children: [jsx("div", Object.assign({ className: classNames('key-element', {
                    'key-element-left': alignTextsLeft
                }), title: typeof keyElement === 'string' ? keyElement : '' }, { children: keyElement }), void 0), jsx("div", { className: "vertical-line" }, void 0), jsx("div", Object.assign({ className: classNames('value-element', {
                    'value-element-left': alignTextsLeft
                }), style: { width: valueWidthClassName }, title: typeof valueElement === 'string' ? valueElement : '' }, { children: valueElement }), void 0)] }), void 0));
};

var css_248z$1k = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.button-group-root{align-items:\"center\";display:\"flex\";flex-direction:\"column\"}.button-group-group{color:#f9f9f9}#button-group .MuiButton-contained{background-color:#f9f9f9}#button-group .MuiButtonGroup-contained{box-shadow:none}#button-group .selected-group-button{background-color:#f36a22!important;color:#fff!important}#button-group .selected-group-button :hover{color:#fff!important}#button-group .button{border-radius:0!important;width:8rem!important}#button-group .MuiButton-contained:hover{box-shadow:none!important}.class-opacity{opacity:.5}";
styleInject(css_248z$1k);

const ButtonGroupContainer = ({ buttons, selectedButtonIndex = 0, dataTestId }) => {
    const [selectedButton, setSelectedButton] = useState(selectedButtonIndex);
    const onButtonClick = (onClick, index) => {
        setSelectedButton(index);
        onClick();
    };
    return (jsx("div", Object.assign({ id: "button-group", className: "button-group-root" }, { children: jsx(ButtonGroup, Object.assign({ variant: "contained", className: "button-group-group", "data-testid": dataTestId }, { children: buttons.map(({ title, onClick, value, dataTestId = '', disable }, index) => {
                const isSelectedButton = selectedButton === index;
                return (jsx(Button, Object.assign({ "data-testid": dataTestId, onClick: () => onButtonClick(onClick, index), disabled: disable, className: classNames('button', {
                        'selected-group-button': isSelectedButton,
                        'class-opacity': isSelectedButton && disable
                    }) }, { children: isSelectedButton ? `${title} \u00A0 (${value})\u00A0` : title }), index));
            }) }), void 0) }), void 0));
};

var css_248z$1j = ".dialog-actions{width:90%}.dialog-actions .button-action{width:unset!important}";
styleInject(css_248z$1j);

const Actions = (props) => {
    const { buttons, className, dataTestId } = props;
    return (jsx(DialogActions, Object.assign({ className: classNames('dialog-actions', className), "data-testid": dataTestId }, { children: buttons.map(buttonProps => {
            return createElement(ButtonContainer, Object.assign({ className: "button-action" }, buttonProps, { key: buttonProps.text }));
        }) }), void 0));
};

var css_248z$1i = ".option{display:flex;justify-content:space-between;width:100%}.option .title-wrapper{align-items:center;display:flex}.option .sub-title{margin-left:.5rem;opacity:.5}.option .ellipsis-title{display:inline-block;max-width:12rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.option .right{align-items:center;display:flex}.option .right .icon svg{height:1rem;width:1rem}";
styleInject(css_248z$1i);

const OptionContainer = (props) => {
    const { dataTestId, title, subTitle, icon, optionWidth, disableMenuItemEllipsis, showSelectedOptionCheckIcon, rightComponent, isSelected } = props;
    const specificIcon = typeof icon == 'string';
    const selectedOptionIcon = showSelectedOptionCheckIcon && isSelected;
    const checkedIcon = selectedOptionIcon || (typeof icon == 'boolean' && icon);
    return (jsxs("div", Object.assign({ title: String(title), className: "option", "data-testid": dataTestId }, { children: [jsxs("div", Object.assign({ className: "title-wrapper" }, { children: [jsx("span", Object.assign({ className: disableMenuItemEllipsis ? '' : 'ellipsis-title', style: optionWidth ? { width: optionWidth } : {} }, { children: title }), void 0), subTitle && jsx("span", Object.assign({ className: "sub-title" }, { children: subTitle }), void 0)] }), void 0), (specificIcon || checkedIcon || rightComponent) && (jsxs("div", Object.assign({ className: "right" }, { children: [checkedIcon ? jsx(CheckIcon, { color: "action" }, void 0) : specificIcon && jsx(Icon, { name: icon, className: "icon" }, void 0), rightComponent] }), void 0))] }), void 0));
};

const MultiSelectItem = (props) => {
    const { type, style, className } = props, rest = __rest$1(props, ["type", "style", "className"]);
    const checkboxType = rest.isSelected ? 'selected' : 'unSelected';
    return (jsxs(Fragment$1, { children: [jsx(CheckboxContainer, { type: (type !== undefined && type) || checkboxType, style: style, className: className }, void 0), jsx(OptionContainer, Object.assign({}, rest), void 0)] }, void 0));
};

const findObjIndexByValue = (obj, arr) => {
    return arr.findIndex(item => item.optionValue === obj.optionValue);
};
const removeChildIfHasParent = (selected) => {
    const arrToShow = [...selected];
    selected.forEach(item => {
        var _a;
        (_a = item.list) === null || _a === void 0 ? void 0 : _a.forEach(o => {
            const indexOfItem = findObjIndexByValue(o, arrToShow);
            arrToShow.splice(indexOfItem, 1);
        });
    });
    return arrToShow;
};
const MultiSelect = (props) => {
    const { values, list = [], onChange, dataTestId, selectClassName, inputClassName } = props;
    const [parentType, setParentType] = useState({});
    const getNumOfChildrenChecked = (parent, arr) => { var _a; return (_a = parent.list) === null || _a === void 0 ? void 0 : _a.filter(child => checkIfObjExistInArr(child, arr)).length; };
    const getParentType = (parent, arr) => {
        var _a;
        let pType;
        const numOfChildrenChecked = getNumOfChildrenChecked(parent, arr);
        if (numOfChildrenChecked === ((_a = parent.list) === null || _a === void 0 ? void 0 : _a.length)) {
            pType = 'selected';
        }
        else if (numOfChildrenChecked === 0) {
            pType = 'unSelected';
        }
        else {
            pType = 'indeterminate';
        }
        return pType;
    };
    const initButtonType = () => {
        const parentTypeTmp = {};
        list.forEach(parent => {
            parentTypeTmp[parent.optionValue] = getParentType(parent, values);
        });
        setParentType(parentTypeTmp);
    };
    useEffect(() => {
        initButtonType();
    }, []);
    const checkIfObjExistInArr = (obj, arr) => findObjIndexByValue(obj, arr) > -1;
    const checkIfChildSelected = (child, parent, arr) => checkIfObjExistInArr(child, arr) || checkIfObjExistInArr(parent, arr);
    const onChangeParent = (obj) => {
        var _a, _b;
        let newValues = [...values];
        let indexOfItem = findObjIndexByValue(obj, newValues);
        const isExist = indexOfItem !== -1;
        const parentTypeTmp = Object.assign({}, parentType);
        let pType;
        if (isExist) {
            newValues.splice(indexOfItem, 1);
            (_a = obj.list) === null || _a === void 0 ? void 0 : _a.forEach(o => {
                indexOfItem = findObjIndexByValue(o, newValues);
                newValues.splice(indexOfItem, 1);
            });
            pType = 'unSelected';
        }
        else {
            newValues = [...newValues, obj];
            (_b = obj === null || obj === void 0 ? void 0 : obj.list) === null || _b === void 0 ? void 0 : _b.forEach(o => !checkIfObjExistInArr(o, newValues) && newValues.push(o));
            pType = 'selected';
        }
        parentTypeTmp[obj.optionValue] = pType;
        onChange([...newValues]);
        setParentType(parentTypeTmp);
    };
    const onChangeChild = (child, parent) => {
        var _a;
        let newValues = [...values];
        const indexOfItem = findObjIndexByValue(child, newValues);
        const isExist = indexOfItem !== -1;
        if (isExist) {
            newValues.splice(indexOfItem, 1);
            const indexOfParentItem = findObjIndexByValue(parent, newValues);
            indexOfParentItem > -1 && newValues.splice(indexOfParentItem, 1);
        }
        else {
            newValues = [...newValues, child];
            const numOfChildrenChecked = getNumOfChildrenChecked(parent, newValues);
            if (numOfChildrenChecked === ((_a = parent.list) === null || _a === void 0 ? void 0 : _a.length)) {
                newValues = [...newValues, parent];
            }
        }
        const parentTypeTmp = Object.assign({}, parentType);
        parentTypeTmp[parent.optionValue] = getParentType(parent, newValues);
        setParentType(parentTypeTmp);
        onChange([...newValues]);
    };
    const renderValue = (selected) => {
        return removeChildIfHasParent(selected)
            .map(o => o.title)
            .join(', ');
    };
    return (jsx(FormControl, Object.assign({ "data-testid": dataTestId }, { children: jsx(Select, Object.assign({ multiple: true, value: values, renderValue: selected => renderValue(selected), className: selectClassName, classes: { root: inputClassName }, MenuProps: {
                getContentAnchorEl: null,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left'
                }
            } }, { children: list.map(item => {
                var _a;
                return [
                    jsx(MenuItem, Object.assign({ value: item.optionValue, onClick: () => onChangeParent(item) }, { children: jsx(MultiSelectItem, { type: parentType[item.optionValue], title: item.title }, void 0) }), item.optionValue),
                    (_a = item.list) === null || _a === void 0 ? void 0 : _a.map(subItem => (jsx(MenuItem, Object.assign({ value: subItem.optionValue, onClick: () => onChangeChild(subItem, item) }, { children: jsx(MultiSelectItem, { style: { marginLeft: '1rem' }, isSelected: checkIfChildSelected(subItem, item, values), title: subItem.title }, void 0) }), subItem.optionValue)))
                ];
            }) }), void 0) }), void 0));
};

var css_248z$1h = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.label-informations{display:flex;opacity:.8}.class-label-informations-opacity{color:#767676}";
styleInject(css_248z$1h);

const LabelInformations = ({ list, disabled }) => {
    return (jsx("div", Object.assign({ "data-testid": "label-informations", className: classNames('label-informations', { 'class-label-informations-opacity': disabled }) }, { children: list.map(({ title, value }, index) => (jsx(LabelInformation, { dataTestId: `label-information-${title}`, title: title, value: value, type: "leftWithComma", isLast: index === list.length - 1 }, title + value))) }), void 0));
};

var css_248z$1g = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.simple-search-input{height:100%}.reset-icon{cursor:pointer}.reset-icon:hover{fill:#f36a22!important}";
styleInject(css_248z$1g);

const SimpleSearch = (_a) => {
    var { onChange, onReset, searchIconClassSuffix } = _a, rest = __rest$1(_a, ["onChange", "onReset", "searchIconClassSuffix"]);
    return (jsx(TextFieldContainer, Object.assign({ className: "common-components-1786027375754-1" }, rest, { onChange: (text) => {
            onChange(text);
        }, InputProps: Object.assign({ startAdornment: (jsx(InputAdornment, Object.assign({ position: "start", className: "simple-search-input" }, { children: jsx(SearchIcon, { className: searchIconClassSuffix }, void 0) }), void 0)) }, (onReset && {
            endAdornment: (jsx(InputAdornment, Object.assign({ position: "end" }, { children: jsx(CloseIcon, { onClick: () => onReset(''), className: "reset-icon" }, void 0) }), void 0))
        })) }), void 0));
};

var lib$1 = {};

var filesTreeViewUtils = {};

(function (exports) {
	var __spreadArray = (commonjsGlobal$1 && commonjsGlobal$1.__spreadArray) || function (to, from, pack) {
	    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
	        if (ar || !(i in from)) {
	            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
	            ar[i] = from[i];
	        }
	    }
	    return to.concat(ar || Array.prototype.slice.call(from));
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.searchFileById = exports.getIndicatedIds = exports.getFirstOpenFile = exports.getDefaultExpandedFolders = void 0;
	/* eslint-disable */
	var getDefaultExpandedFoldersbyIsIndicated = function (tree, list, res) {
	    if (res.length >= 1) {
	        return res;
	    }
	    if (tree.type === 'file') {
	        if (tree.isIndicated) {
	            for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
	                var item = list_1[_i];
	                if (!res.includes(item)) {
	                    res.push(item);
	                }
	            }
	            return res;
	        }
	    }
	    if (tree.type === 'directory' && tree.children) {
	        for (var _a = 0, _b = tree.children; _a < _b.length; _a++) {
	            var child = _b[_a];
	            getDefaultExpandedFoldersbyIsIndicated(child, __spreadArray(__spreadArray([], list, true), [tree.id], false), res);
	        }
	    }
	    return res;
	};
	var getDefaultExpandedFoldersByFirstFile = function (tree, list, res) {
	    if (res.length >= 1) {
	        return res;
	    }
	    if (tree.type === 'file') {
	        for (var _i = 0, list_2 = list; _i < list_2.length; _i++) {
	            var item = list_2[_i];
	            if (!res.includes(item)) {
	                res.push(item);
	            }
	        }
	        return res;
	    }
	    if (tree.type === 'directory' && tree.children) {
	        for (var _a = 0, _b = tree.children; _a < _b.length; _a++) {
	            var child = _b[_a];
	            getDefaultExpandedFoldersByFirstFile(child, __spreadArray(__spreadArray([], list, true), [tree.id], false), res);
	        }
	    }
	    return res;
	};
	var getDefaultExpandedFolders = function (tree) {
	    var folders = getDefaultExpandedFoldersbyIsIndicated(tree, [], []);
	    return folders.length !== 0 ? folders : getDefaultExpandedFoldersByFirstFile(tree, [], []);
	};
	exports.getDefaultExpandedFolders = getDefaultExpandedFolders;
	var getFirstOpenFile = function (tree) {
	    return getFirstIndicatedFileIdInTree(tree) || getFirstFileIdInTree(tree);
	};
	exports.getFirstOpenFile = getFirstOpenFile;
	var getFirstFileIdInTree = function (tree) {
	    if (tree.type === 'file') {
	        return tree.id;
	    }
	    if (tree.type === 'directory' && tree.children)
	        for (var _i = 0, _a = tree.children; _i < _a.length; _i++) {
	            var child = _a[_i];
	            var res = getFirstFileIdInTree(child);
	            if (res) {
	                return res;
	            }
	        }
	    return '';
	};
	var getFirstIndicatedFileIdInTree = function (tree) {
	    if (tree.type === 'file' && tree.isIndicated) {
	        return tree.id;
	    }
	    if (tree.type === 'directory' && tree.children)
	        for (var _i = 0, _a = tree.children; _i < _a.length; _i++) {
	            var child = _a[_i];
	            var res = getFirstIndicatedFileIdInTree(child);
	            if (res) {
	                return res;
	            }
	        }
	    return '';
	};
	var getIndicatedIds = function (tree, list, res) {
	    if (tree.type === 'file') {
	        if (tree.isIndicated) {
	            res.push(tree.id);
	            for (var _i = 0, list_3 = list; _i < list_3.length; _i++) {
	                var item = list_3[_i];
	                if (!res.includes(item)) {
	                    res.push(item);
	                }
	            }
	        }
	        return res;
	    }
	    if (tree.children)
	        for (var _a = 0, _b = tree.children; _a < _b.length; _a++) {
	            var child = _b[_a];
	            (0, exports.getIndicatedIds)(child, __spreadArray(__spreadArray([], list, true), [tree.id], false), res);
	        }
	    return res;
	};
	exports.getIndicatedIds = getIndicatedIds;
	var searchFileById = function (tree, id) {
	    if (tree.type === 'file' && tree.id === id) {
	        return tree;
	    }
	    if (tree.type === 'directory' && tree.children) {
	        for (var _i = 0, _a = tree.children; _i < _a.length; _i++) {
	            var child = _a[_i];
	            var res = (0, exports.searchFileById)(child, id);
	            if (res) {
	                return res;
	            }
	        }
	    }
	    return null;
	};
	exports.searchFileById = searchFileById; 
} (filesTreeViewUtils));

var iframeFunctions = {};

var getPlatformUrl$1 = {};

var getTenant$1 = {};

Object.defineProperty(getTenant$1, "__esModule", { value: true });
var localTenant = process.env.CB_LOCAL_TENANT || 'dev';
var getSubDomain = function () {
    var parts = window.location.host.split('.');
    if (parts.length > 1)
        return parts[0];
    return process.env.NODE_ENV === 'development' ? localTenant : null;
};
var getTenantFromUrlParams = function () {
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    return urlParams.get('tenant');
};
var getTenant = function () {
    var storedTenant = sessionStorage.getItem('tenant');
    var paramsTenant = getTenantFromUrlParams();
    if (paramsTenant && storedTenant !== paramsTenant) {
        sessionStorage.setItem('tenant', paramsTenant);
        storedTenant = paramsTenant;
    }
    if (storedTenant)
        return storedTenant;
    return getSubDomain();
};
getTenant$1.default = getTenant;

var __importDefault$2 = (commonjsGlobal$1 && commonjsGlobal$1.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(getPlatformUrl$1, "__esModule", { value: true });
var getTenant_1 = __importDefault$2(getTenant$1);
var getPlatformUrl = function () {
    if (process.env.CB_PLATFORM_CLIENT_URL)
        return process.env.CB_PLATFORM_CLIENT_URL;
    var tenant = (0, getTenant_1.default)();
    var domain = window.location.host.split('.').slice(1).join('.');
    return "https://".concat(tenant, ".").concat(domain);
};
getPlatformUrl$1.default = getPlatformUrl;

(function (exports) {
	var __importDefault = (commonjsGlobal$1 && commonjsGlobal$1.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.scrollToTop = exports.postRefreshPage = exports.postSetTitle = exports.postInnerRoute = exports.postRedirectMessage = exports.postResizeMessage = exports.onIframeUnmount = exports.onIframeMount = void 0;
	// import variables from '../styles/_globals.scss';
	/* eslint-disable css-modules/no-undef-class */
	var getPlatformUrl_1 = __importDefault(getPlatformUrl$1);
	var getTenant_1 = __importDefault(getTenant$1);
	var onIframeMount = function (_a) {
	    var parentRoute = _a.parentRoute, styles = _a.styles, title = _a.title;
	    (0, getTenant_1.default)(); // call to make sure tenant from url params is cached in sessionStorage
	    document.body.style.minWidth = 'initial';
	    document.body.style.height = 'max-content';
	    var rootElement = Object(document.getElementById('root'));
	    if (rootElement.style !== undefined) {
	        rootElement.style.height = 'initial';
	        rootElement.style['overflow-x'] = 'clip';
	    }
	    window.addEventListener('resize', exports.postResizeMessage);
	    if (window.ResizeObserver) {
	        // the if is for the tests, where it's not defined
	        new ResizeObserver(exports.postResizeMessage).observe(window.document.body);
	    }
	    (0, exports.postResizeMessage)();
	    window.addEventListener('message', handleMessageFromParent);
	    if (parentRoute)
	        (0, exports.postInnerRoute)(parentRoute);
	    if (title)
	        (0, exports.postSetTitle)(title);
	    if (styles) {
	        Object.keys(styles).forEach(function (key) {
	            var value = styles[key];
	            rootElement.style[key] = value;
	        });
	    }
	};
	exports.onIframeMount = onIframeMount;
	var onIframeUnmount = function () {
	    document.body.style.minWidth = '1280px'; // variables['min-width'];
	    // eslint-disable-next-line dot-notation
	    Object(document.getElementById('root')).style.height = '100vh'; // variables.height;
	};
	exports.onIframeUnmount = onIframeUnmount;
	// eslint-disable-next-line no-restricted-globals
	var platformClientUrl = (0, getPlatformUrl_1.default)();
	var postResizeMessage = function () {
	    window.parent.postMessage({ type: 'height', value: window.document.body.scrollHeight }, platformClientUrl);
	};
	exports.postResizeMessage = postResizeMessage;
	var postRedirectMessage = function (url) {
	    window.parent.postMessage({ type: 'redirect', value: url }, platformClientUrl);
	};
	exports.postRedirectMessage = postRedirectMessage;
	var postInnerRoute = function (parentRoute) {
	    window.parent.postMessage({ type: 'innerRoute', value: parentRoute }, platformClientUrl);
	};
	exports.postInnerRoute = postInnerRoute;
	var postSetTitle = function (title) {
	    window.parent.postMessage({ type: 'setTitle', value: title }, platformClientUrl);
	};
	exports.postSetTitle = postSetTitle;
	var postRefreshPage = function () {
	    window.parent.postMessage({ type: 'refreshPage' }, platformClientUrl);
	};
	exports.postRefreshPage = postRefreshPage;
	var scrollToTop = function () {
	    window.parent.postMessage({ type: 'scrollToTop' }, platformClientUrl);
	};
	exports.scrollToTop = scrollToTop;
	var handleMessageFromParent = function (message) {
	    if (!message.origin.startsWith(platformClientUrl))
	        return;
	    var data = message.data;
	    if (data.topOffset !== undefined && window.parentScroll !== undefined) {
	        window.parentScroll(data.topOffset);
	    }
	}; 
} (iframeFunctions));

var dateTimeUtils = {};

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var moment$1 = {exports: {}};

(function (module, exports) {
(function (global, factory) {
	    module.exports = factory() ;
	}(commonjsGlobal$1, (function () {
	    var hookCallback;

	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }

	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }

	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }

	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }

	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }

	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }

	    function isUndefined(input) {
	        return input === void 0;
	    }

	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }

	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }

	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }

	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }

	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }

	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }

	        return a;
	    }

	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }

	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }

	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }

	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;

	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }

	            return false;
	        };
	    }

	    function isValid(m) {
	        var flags = null,
	            parsedParts = false,
	            isNowValid = m._d && !isNaN(m._d.getTime());
	        if (isNowValid) {
	            flags = getParsingFlags(m);
	            parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            isNowValid =
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidEra &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	        }
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        } else {
	            return isNowValid;
	        }
	        return m._isValid;
	    }

	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }

	        return m;
	    }

	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;

	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;

	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }

	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }

	        return to;
	    }

	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }

	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }

	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }

	    function deprecate(msg, fn) {
	        var firstTime = true;

	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }

	    var deprecations = {};

	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }

	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;

	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }

	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }

	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }

	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }

	    var keys;

	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }

	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };

	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }

	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }

	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};

	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }

	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }

	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;

	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }

	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }

	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }

	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);

	        return formatFunctions[format](m);
	    }

	    function expandFormat(format, locale) {
	        var i = 5;

	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }

	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }

	        return format;
	    }

	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };

	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];

	        if (format || !formatUpper) {
	            return format;
	        }

	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');

	        return this._longDateFormat[key];
	    }

	    var defaultInvalidDate = 'Invalid date';

	    function invalidDate() {
	        return this._invalidDate;
	    }

	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }

	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };

	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }

	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }

	    var aliases = {
	        D: 'date',
	        dates: 'date',
	        date: 'date',
	        d: 'day',
	        days: 'day',
	        day: 'day',
	        e: 'weekday',
	        weekdays: 'weekday',
	        weekday: 'weekday',
	        E: 'isoWeekday',
	        isoweekdays: 'isoWeekday',
	        isoweekday: 'isoWeekday',
	        DDD: 'dayOfYear',
	        dayofyears: 'dayOfYear',
	        dayofyear: 'dayOfYear',
	        h: 'hour',
	        hours: 'hour',
	        hour: 'hour',
	        ms: 'millisecond',
	        milliseconds: 'millisecond',
	        millisecond: 'millisecond',
	        m: 'minute',
	        minutes: 'minute',
	        minute: 'minute',
	        M: 'month',
	        months: 'month',
	        month: 'month',
	        Q: 'quarter',
	        quarters: 'quarter',
	        quarter: 'quarter',
	        s: 'second',
	        seconds: 'second',
	        second: 'second',
	        gg: 'weekYear',
	        weekyears: 'weekYear',
	        weekyear: 'weekYear',
	        GG: 'isoWeekYear',
	        isoweekyears: 'isoWeekYear',
	        isoweekyear: 'isoWeekYear',
	        w: 'week',
	        weeks: 'week',
	        week: 'week',
	        W: 'isoWeek',
	        isoweeks: 'isoWeek',
	        isoweek: 'isoWeek',
	        y: 'year',
	        years: 'year',
	        year: 'year',
	    };

	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }

	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;

	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }

	        return normalizedInput;
	    }

	    var priorities = {
	        date: 9,
	        day: 11,
	        weekday: 11,
	        isoWeekday: 11,
	        dayOfYear: 4,
	        hour: 13,
	        millisecond: 16,
	        minute: 14,
	        month: 8,
	        quarter: 7,
	        second: 15,
	        weekYear: 1,
	        isoWeekYear: 1,
	        week: 5,
	        isoWeek: 5,
	        year: 1,
	    };

	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }

	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
	        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
	        regexes;

	    regexes = {};

	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }

	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }

	        return regexes[token](config._strict, config._locale);
	    }

	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }

	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }

	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }

	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;

	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }

	        return value;
	    }

	    var tokens = {};

	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }

	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }

	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }

	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }

	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;

	    // FORMATTING

	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });

	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });

	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

	    // PARSING

	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);

	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });

	    // HELPERS

	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }

	    // HOOKS

	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };

	    // MOMENTS

	    var getSetYear = makeGetSet('FullYear', true);

	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }

	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }

	    function get(mom, unit) {
	        if (!mom.isValid()) {
	            return NaN;
	        }

	        var d = mom._d,
	            isUTC = mom._isUTC;

	        switch (unit) {
	            case 'Milliseconds':
	                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
	            case 'Seconds':
	                return isUTC ? d.getUTCSeconds() : d.getSeconds();
	            case 'Minutes':
	                return isUTC ? d.getUTCMinutes() : d.getMinutes();
	            case 'Hours':
	                return isUTC ? d.getUTCHours() : d.getHours();
	            case 'Date':
	                return isUTC ? d.getUTCDate() : d.getDate();
	            case 'Day':
	                return isUTC ? d.getUTCDay() : d.getDay();
	            case 'Month':
	                return isUTC ? d.getUTCMonth() : d.getMonth();
	            case 'FullYear':
	                return isUTC ? d.getUTCFullYear() : d.getFullYear();
	            default:
	                return NaN; // Just in case
	        }
	    }

	    function set$1(mom, unit, value) {
	        var d, isUTC, year, month, date;

	        if (!mom.isValid() || isNaN(value)) {
	            return;
	        }

	        d = mom._d;
	        isUTC = mom._isUTC;

	        switch (unit) {
	            case 'Milliseconds':
	                return void (isUTC
	                    ? d.setUTCMilliseconds(value)
	                    : d.setMilliseconds(value));
	            case 'Seconds':
	                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
	            case 'Minutes':
	                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
	            case 'Hours':
	                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
	            case 'Date':
	                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
	            // case 'Day': // Not real
	            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
	            // case 'Month': // Not used because we need to pass two variables
	            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
	            case 'FullYear':
	                break; // See below ...
	            default:
	                return; // Just in case
	        }

	        year = value;
	        month = mom.month();
	        date = mom.date();
	        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
	        void (isUTC
	            ? d.setUTCFullYear(year, month, date)
	            : d.setFullYear(year, month, date));
	    }

	    // MOMENTS

	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }

	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }

	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }

	    var indexOf;

	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }

	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }

	    // FORMATTING

	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });

	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });

	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });

	    // PARSING

	    addRegexToken('M', match1to2, match1to2NoLeadingZero);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });

	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });

	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });

	    // LOCALES

	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;

	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }

	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }

	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }

	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }

	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;

	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }

	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }

	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }

	    // MOMENTS

	    function setMonth(mom, value) {
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }

	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }

	        var month = value,
	            date = mom.date();

	        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
	        void (mom._isUTC
	            ? mom._d.setUTCMonth(month, date)
	            : mom._d.setMonth(month, date));
	        return mom;
	    }

	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }

	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }

	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }

	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }

	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }

	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            shortP,
	            longP;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortP = regexEscape(this.monthsShort(mom, ''));
	            longP = regexEscape(this.months(mom, ''));
	            shortPieces.push(shortP);
	            longPieces.push(longP);
	            mixedPieces.push(longP);
	            mixedPieces.push(shortP);
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);

	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }

	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }

	        return date;
	    }

	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }

	        return date;
	    }

	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

	        return -fwdlw + fwd - 1;
	    }

	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;

	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }

	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }

	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;

	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }

	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }

	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }

	    // FORMATTING

	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

	    // PARSING

	    addRegexToken('w', match1to2, match1to2NoLeadingZero);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2, match1to2NoLeadingZero);
	    addRegexToken('WW', match1to2, match2);

	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );

	    // HELPERS

	    // LOCALES

	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }

	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };

	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }

	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }

	    // MOMENTS

	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }

	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }

	    // FORMATTING

	    addFormatToken('d', 0, 'do', 'day');

	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });

	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });

	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });

	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');

	    // PARSING

	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });

	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });

	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });

	    // HELPERS

	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }

	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }

	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }

	        return null;
	    }

	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }

	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }

	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;

	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	              ? weekdays[m.day()]
	              : weekdays;
	    }

	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	              ? this._weekdaysShort[m.day()]
	              : this._weekdaysShort;
	    }

	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	              ? this._weekdaysMin[m.day()]
	              : this._weekdaysMin;
	    }

	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];

	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }

	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }

	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;

	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }

	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }

	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already

	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }

	    // MOMENTS

	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }

	        var day = get(this, 'Day');
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }

	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }

	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }

	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.

	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }

	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }

	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }

	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }

	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }

	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);

	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;

	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }

	    // FORMATTING

	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }

	    function kFormat() {
	        return this.hours() || 24;
	    }

	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);

	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });

	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });

	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });

	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });

	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }

	    meridiem('a', true);
	    meridiem('A', false);

	    // PARSING

	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }

	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2, match1to2HasZero);
	    addRegexToken('h', match1to2, match1to2NoLeadingZero);
	    addRegexToken('k', match1to2, match1to2NoLeadingZero);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);

	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);

	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });

	    // LOCALES

	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }

	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);

	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }

	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,

	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,

	        week: defaultLocaleWeek,

	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,

	        meridiemParse: defaultLocaleMeridiemParse,
	    };

	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;

	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }

	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }

	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;

	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }

	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        // Ensure name is available and function returns boolean
	        return !!(name && name.match('^[^/\\\\]*$'));
	    }

	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            'object' !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = commonjsRequire;
	                aliasedRequire('./locale/' + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }

	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }

	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }

	        return globalLocale._abbr;
	    }

	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));

	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }

	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);

	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }

	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;

	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }

	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }

	    // returns locale data
	    function getLocale(key) {
	        var locale;

	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }

	        if (!key) {
	            return globalLocale;
	        }

	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }

	        return chooseLocale(key);
	    }

	    function listLocales() {
	        return keys(locales);
	    }

	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;

	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                      ? DATE
	                      : a[HOUR] < 0 ||
	                          a[HOUR] > 24 ||
	                          (a[HOUR] === 24 &&
	                              (a[MINUTE] !== 0 ||
	                                  a[SECOND] !== 0 ||
	                                  a[MILLISECOND] !== 0))
	                        ? HOUR
	                        : a[MINUTE] < 0 || a[MINUTE] > 59
	                          ? MINUTE
	                          : a[SECOND] < 0 || a[SECOND] > 59
	                            ? SECOND
	                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                              ? MILLISECOND
	                              : -1;

	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }

	            getParsingFlags(m).overflow = overflow;
	        }

	        return m;
	    }

	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };

	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;

	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }

	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];

	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }

	        return result;
	    }

	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }

	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }

	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }

	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }

	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }

	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);

	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }

	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }

	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }

	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }

	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }

	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );

	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }

	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }

	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;

	        if (config._d) {
	            return;
	        }

	        currentDate = currentDateArray(config);

	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }

	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }

	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }

	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }

	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }

	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }

	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();

	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }

	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }

	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }

	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;

	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;

	            curWeek = weekOfYear(createLocal(), dow, doy);

	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

	            // Default to current week.
	            week = defaults(w.w, curWeek.week);

	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }

	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};

	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};

	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;

	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;

	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }

	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }

	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }

	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );

	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }

	        configFromArray(config);
	        checkOverflow(config);
	    }

	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;

	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }

	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;

	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }

	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);

	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }

	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;

	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

	            getParsingFlags(tempConfig).score = currentScore;

	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }

	        extend(config, bestMoment || tempConfig);
	    }

	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }

	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );

	        configFromArray(config);
	    }

	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }

	        return res;
	    }

	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;

	        config._locale = config._locale || getLocale(config._l);

	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }

	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }

	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }

	        if (!isValid(config)) {
	            config._d = null;
	        }

	        return config;
	    }

	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }

	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};

	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }

	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }

	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;

	        return createFromConfig(c);
	    }

	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }

	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );

	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }

	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);

	        return pickBy('isBefore', args);
	    }

	    function max() {
	        var args = [].slice.call(arguments, 0);

	        return pickBy('isAfter', args);
	    }

	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };

	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];

	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }

	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }

	        return true;
	    }

	    function isValid$1() {
	        return this._isValid;
	    }

	    function createInvalid$1() {
	        return createDuration(NaN);
	    }

	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;

	        this._isValid = isDurationValid(normalizedInput);

	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;

	        this._data = {};

	        this._locale = getLocale();

	        this._bubble();
	    }

	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }

	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }

	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }

	    // FORMATTING

	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }

	    offset('Z', ':');
	    offset('ZZ', '');

	    // PARSING

	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });

	    // HELPERS

	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;

	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;

	        if (matches === null) {
	            return null;
	        }

	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);

	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }

	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }

	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }

	    // HOOKS

	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};

	    // MOMENTS

	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }

	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }

	            this.utcOffset(input, keepLocalTime);

	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }

	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }

	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;

	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }

	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }

	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;

	        return (this.utcOffset() - input) % 60 === 0;
	    }

	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }

	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }

	        var c = {},
	            other;

	        copyConfig(c, this);
	        c = prepareConfig(c);

	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }

	        return this._isDSTShifted;
	    }

	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }

	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }

	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }

	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;

	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );

	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }

	        ret = new Duration(duration);

	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }

	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }

	        return ret;
	    }

	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;

	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }

	    function positiveMomentsDifference(base, other) {
	        var res = {};

	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }

	        res.milliseconds = +other - +base.clone().add(res.months, 'M');

	        return res;
	    }

	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }

	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }

	        return res;
	    }

	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }

	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }

	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);

	        if (!mom.isValid()) {
	            // No op
	            return;
	        }

	        updateOffset = updateOffset == null ? true : updateOffset;

	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }

	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');

	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }

	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }

	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;

	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }

	        return objectTest && propertyTest;
	    }

	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }

	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;

	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }

	        return objectTest && propertyTest;
	    }

	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	              ? 'lastWeek'
	              : diff < 0
	                ? 'lastDay'
	                : diff < 1
	                  ? 'sameDay'
	                  : diff < 2
	                    ? 'nextDay'
	                    : diff < 7
	                      ? 'nextWeek'
	                      : 'sameElse';
	    }

	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);

	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }

	    function clone() {
	        return new Moment(this);
	    }

	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }

	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }

	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }

	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }

	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }

	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }

	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;

	        if (!this.isValid()) {
	            return NaN;
	        }

	        that = cloneWithOffset(input, this);

	        if (!that.isValid()) {
	            return NaN;
	        }

	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

	        units = normalizeUnits(units);

	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }

	        return asFloat ? output : absFloor(output);
	    }

	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;

	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }

	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }

	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }

	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }

	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';

	        return this.format(prefix + year + datetime + suffix);
	    }

	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }

	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }

	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }

	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }

	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }

	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;

	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }

	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );

	    function localeData() {
	        return this._locale;
	    }

	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }

	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }

	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }

	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }

	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }

	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }

	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }

	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }

	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }

	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }

	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }

	    function toDate() {
	        return new Date(this.valueOf());
	    }

	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }

	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }

	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }

	    function isValid$2() {
	        return isValid(this);
	    }

	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }

	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }

	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }

	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);

	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );

	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);

	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }

	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });

	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }

	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }

	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();

	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();

	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;

	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;

	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }

	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }

	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }

	        return '';
	    }

	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }

	        return '';
	    }

	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }

	        return '';
	    }

	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;

	            // truncate time
	            val = this.clone().startOf('day').valueOf();

	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }

	        return this.year();
	    }

	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }

	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }

	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }

	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }

	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }

	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }

	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }

	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            erasName,
	            erasAbbr,
	            erasNarrow,
	            eras = this.eras();

	        for (i = 0, l = eras.length; i < l; ++i) {
	            erasName = regexEscape(eras[i].name);
	            erasAbbr = regexEscape(eras[i].abbr);
	            erasNarrow = regexEscape(eras[i].narrow);

	            namePieces.push(erasName);
	            abbrPieces.push(erasAbbr);
	            narrowPieces.push(erasNarrow);
	            mixedPieces.push(erasName);
	            mixedPieces.push(erasAbbr);
	            mixedPieces.push(erasNarrow);
	        }

	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }

	    // FORMATTING

	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });

	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });

	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }

	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

	    // ALIASES

	    // PARSING

	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);

	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );

	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });

	    // MOMENTS

	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday() + this.localeData()._week.dow,
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }

	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }

	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }

	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }

	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }

	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }

	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }

	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }

	    // FORMATTING

	    addFormatToken('Q', 0, 'Qo', 'quarter');

	    // PARSING

	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });

	    // MOMENTS

	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }

	    // FORMATTING

	    addFormatToken('D', ['DD', 2], 'Do', 'date');

	    // PARSING

	    addRegexToken('D', match1to2, match1to2NoLeadingZero);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });

	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });

	    // MOMENTS

	    var getSetDayOfMonth = makeGetSet('Date', true);

	    // FORMATTING

	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

	    // PARSING

	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });

	    // HELPERS

	    // MOMENTS

	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }

	    // FORMATTING

	    addFormatToken('m', ['mm', 2], 0, 'minute');

	    // PARSING

	    addRegexToken('m', match1to2, match1to2HasZero);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);

	    // MOMENTS

	    var getSetMinute = makeGetSet('Minutes', false);

	    // FORMATTING

	    addFormatToken('s', ['ss', 2], 0, 'second');

	    // PARSING

	    addRegexToken('s', match1to2, match1to2HasZero);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);

	    // MOMENTS

	    var getSetSecond = makeGetSet('Seconds', false);

	    // FORMATTING

	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });

	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });

	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });

	    // PARSING

	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);

	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }

	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }

	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }

	    getSetMillisecond = makeGetSet('Milliseconds', false);

	    // FORMATTING

	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');

	    // MOMENTS

	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }

	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }

	    var proto = Moment.prototype;

	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );

	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }

	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }

	    function preParsePostFormat(string) {
	        return string;
	    }

	    var proto$1 = Locale.prototype;

	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;

	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;

	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;

	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;

	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }

	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }

	        format = format || '';

	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }

	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }

	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;

	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }

	            format = format || '';
	        }

	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];

	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }

	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }

	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }

	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }

	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }

	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }

	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }

	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                          ? 'st'
	                          : b === 2
	                            ? 'nd'
	                            : b === 3
	                              ? 'rd'
	                              : 'th';
	            return number + output;
	        },
	    });

	    // Side effect imports

	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );

	    var mathAbs = Math.abs;

	    function abs() {
	        var data = this._data;

	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);

	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);

	        return this;
	    }

	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);

	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;

	        return duration._bubble();
	    }

	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }

	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }

	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }

	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;

	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }

	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;

	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;

	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;

	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;

	        days += absFloor(hours / 24);

	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));

	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;

	        data.days = days;
	        data.months = months;
	        data.years = years;

	        return this;
	    }

	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }

	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }

	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;

	        units = normalizeUnits(units);

	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }

	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }

	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y'),
	        valueOf$1 = asMilliseconds;

	    function clone$1() {
	        return createDuration(this);
	    }

	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }

	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }

	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');

	    function weeks() {
	        return absFloor(this.days() / 7);
	    }

	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };

	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }

	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);

	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];

	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }

	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }

	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }

	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }

	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;

	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }

	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);

	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }

	        return locale.postformat(output);
	    }

	    var abs$1 = Math.abs;

	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }

	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }

	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;

	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }

	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;

	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;

	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }

	    var proto$2 = Duration.prototype;

	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;

	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;

	    // FORMATTING

	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');

	    // PARSING

	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });

	    //! moment.js

	    hooks.version = '2.30.1';

	    setHookCallback(createLocal);

	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;

	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };

	    return hooks;

	}))); 
} (moment$1));

var momentExports = moment$1.exports;
var moment = /*@__PURE__*/getDefaultExportFromCjs(momentExports);

var __importDefault$1 = (commonjsGlobal$1 && commonjsGlobal$1.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(dateTimeUtils, "__esModule", { value: true });
dateTimeUtils.parseMinutesToString = dateTimeUtils.formatISODate = dateTimeUtils.getDateModified = dateTimeUtils.getLocaleTime = dateTimeUtils.getYearString = dateTimeUtils.getLocaleDateTimeString = dateTimeUtils.formatSubscriptionDate = dateTimeUtils.getLocaleDateString = void 0;
var moment_1 = __importDefault$1(momentExports);
var getLocaleDateString = function (date, locale) {
    return new Date(date).toLocaleDateString(locale, { year: 'numeric', month: 'short', day: 'numeric' });
};
dateTimeUtils.getLocaleDateString = getLocaleDateString;
var formatSubscriptionDate = function (subscriptionEndDate) {
    if (!subscriptionEndDate || subscriptionEndDate.trim() === '') {
        return 'No date available';
    }
    var endDate = moment_1.default.utc(subscriptionEndDate);
    if (!endDate.isValid()) {
        return 'Invalid Date';
    }
    return endDate.format('MMM D, YYYY');
};
dateTimeUtils.formatSubscriptionDate = formatSubscriptionDate;
var getLocaleDateTimeString = function (date, locale) {
    var options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    };
    var formattedDate = new Date(date).toLocaleDateString(locale, options);
    return "".concat(formattedDate);
};
dateTimeUtils.getLocaleDateTimeString = getLocaleDateTimeString;
var getYearString = function (date, locale) {
    var options = {
        year: 'numeric'
    };
    return new Date(date).toLocaleDateString(locale, options);
};
dateTimeUtils.getYearString = getYearString;
var getLocaleTime = function (date, locale) {
    return new Date(date).toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit'
    });
};
dateTimeUtils.getLocaleTime = getLocaleTime;
var getDateModified = function (date, locale) {
    var momentDate = (0, moment_1.default)(new Date(date));
    momentDate.locale(locale);
    return momentDate.fromNow();
};
dateTimeUtils.getDateModified = getDateModified;
var formatISODate = function (date) {
    return date.toISOString().split('T')[0];
};
dateTimeUtils.formatISODate = formatISODate;
var parseMinutesToString = function (minutes) {
    if (!minutes)
        return '';
    var hours = Math.floor(minutes / 60);
    var hoursString = hours ? "".concat(hours, "h:") : '';
    return "".concat(hoursString).concat(minutes % 60, "min");
};
dateTimeUtils.parseMinutesToString = parseMinutesToString;

var stringUtils = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.notEmptyAndHasDescriptionSpecialChars = exports.hasDescriptionSpecialChars = exports.notEmptyAndHasSpecialChars = exports.hasSpecialChars = exports.capitalizeFirstLetter = exports.concatStrings = exports.validateEmail = exports.isEmptyString = exports.testRegExp = void 0;
	var testRegExp = function (regExp, str) { return new RegExp(regExp).test(str); };
	exports.testRegExp = testRegExp;
	var isEmptyString = function (str) {
	    if (str === void 0) { str = ''; }
	    return str.trim() === '';
	};
	exports.isEmptyString = isEmptyString;
	var validateEmail = function (email) {
	    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(email.toLowerCase());
	};
	exports.validateEmail = validateEmail;
	var concatStrings = function (arr, concatChar) {
	    if (concatChar === void 0) { concatChar = '.'; }
	    var concatenateStr = '';
	    arr.forEach(function (str) {
	        if (str) {
	            var newStr = String(str);
	            if (concatenateStr) {
	                concatenateStr = concatenateStr.concat(concatChar, newStr);
	            }
	            else {
	                concatenateStr = newStr;
	            }
	        }
	    });
	    return concatenateStr;
	};
	exports.concatStrings = concatStrings;
	var capitalizeFirstLetter = function (text) {
	    return text.charAt(0).toUpperCase() + text.slice(1);
	};
	exports.capitalizeFirstLetter = capitalizeFirstLetter;
	var hasSpecialChars = function (str) {
	    if (str === void 0) { str = ''; }
	    return !(0, exports.testRegExp)(/^([a-zA-Z0-9 _-]+)$/, str);
	};
	exports.hasSpecialChars = hasSpecialChars;
	var notEmptyAndHasSpecialChars = function (value) { return !(0, exports.isEmptyString)(value) && (0, exports.hasSpecialChars)(value); };
	exports.notEmptyAndHasSpecialChars = notEmptyAndHasSpecialChars;
	var hasDescriptionSpecialChars = function (str) {
	    if (str === void 0) { str = ''; }
	    return !(0, exports.testRegExp)(/^([a-zA-Z0-9 _.,!;-]+)$/, str);
	};
	exports.hasDescriptionSpecialChars = hasDescriptionSpecialChars;
	var notEmptyAndHasDescriptionSpecialChars = function (value) { return !(0, exports.isEmptyString)(value) && (0, exports.hasDescriptionSpecialChars)(value); };
	exports.notEmptyAndHasDescriptionSpecialChars = notEmptyAndHasDescriptionSpecialChars; 
} (stringUtils));

var testFunctions = {};

Object.defineProperty(testFunctions, "__esModule", { value: true });
testFunctions.isElementInput = testFunctions.checkExistInClassList = void 0;
var checkExistInClassList = function (item, classNames) {
    classNames.forEach(function (className) {
        expect(item.classList.contains(className)).toBe(true);
    });
};
testFunctions.checkExistInClassList = checkExistInClassList;
var isElementInput = function (element) { return element instanceof HTMLInputElement; };
testFunctions.isElementInput = isElementInput;

var constants = {};

(function (exports) {
	var _a, _b;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ProgressTranslationKey = exports.Progress = exports.UserRoleTranslationKey = exports.UserRole = exports.inputMaxLength = void 0;
	exports.inputMaxLength = 50;
	var UserRole;
	(function (UserRole) {
	    UserRole["USER"] = "user";
	    UserRole["ADMIN"] = "admin";
	    UserRole["MANAGER"] = "manager";
	    UserRole["SUPER_ADMIN"] = "superAdmin";
	})(UserRole = exports.UserRole || (exports.UserRole = {}));
	exports.UserRoleTranslationKey = (_a = {},
	    _a[UserRole.USER] = 'Users',
	    _a[UserRole.ADMIN] = 'Admins',
	    _a[UserRole.MANAGER] = 'Managers',
	    _a[UserRole.SUPER_ADMIN] = 'SuperAdmins',
	    _a);
	var Progress;
	(function (Progress) {
	    Progress["NOT_STARTED"] = "not_started";
	    Progress["STARTED"] = "started";
	    Progress["COMPLETED"] = "completed";
	})(Progress = exports.Progress || (exports.Progress = {}));
	exports.ProgressTranslationKey = (_b = {},
	    _b[Progress.NOT_STARTED] = 'NotStarted',
	    _b[Progress.STARTED] = 'InProgress',
	    _b[Progress.COMPLETED] = 'Completed',
	    _b); 
} (constants));

var tags = {};

Object.defineProperty(tags, "__esModule", { value: true });
var tagsMapping = {
    'CWE-611': 'https://cwe.mitre.org/data/definitions/611.html',
    'CWE-77': 'https://cwe.mitre.org/data/definitions/77.html',
    'CWE-384': 'https://cwe.mitre.org/data/definitions/384.html',
    'CWE-330': 'https://cwe.mitre.org/data/definitions/330.html',
    'CWE-79': 'https://cwe.mitre.org/data/definitions/79.html',
    'CWE-22': 'https://cwe.mitre.org/data/definitions/22.html',
    'CWE-265': 'https://cwe.mitre.org/data/definitions/265.html',
    'CWE-489': 'https://cwe.mitre.org/data/definitions/489.html',
    'CWE-522': 'https://cwe.mitre.org/data/definitions/522.html',
    'CWE-613': 'https://cwe.mitre.org/data/definitions/613.html',
    'CWE-203': 'https://cwe.mitre.org/data/definitions/203.html',
    'CWE-352': 'https://cwe.mitre.org/data/definitions/352.html',
    'CWE-451': 'https://cwe.mitre.org/data/definitions/451.html',
    'CWE-601': 'https://cwe.mitre.org/data/definitions/601.html',
    'CWE-425': 'https://cwe.mitre.org/data/definitions/425.html',
    'CWE-779': 'https://cwe.mitre.org/data/definitions/779.html',
    'CWE-922': 'https://cwe.mitre.org/data/definitions/922.html',
    'CWE-89': 'https://cwe.mitre.org/data/definitions/89.html',
    'CWE-121': 'https://cwe.mitre.org/data/definitions/121.html',
    'CWE-193': 'https://cwe.mitre.org/data/definitions/193.html',
    'CWE-122': 'https://cwe.mitre.org/data/definitions/122.html',
    'CWE-190': 'https://cwe.mitre.org/data/definitions/190.html',
    'CWE-134': 'https://cwe.mitre.org/data/definitions/134.html',
    'CWE-244': 'https://cwe.mitre.org/data/definitions/244.html',
    'CWE-749': 'https://cwe.mitre.org/data/definitions/749.html',
    'CWE-733': 'https://cwe.mitre.org/data/definitions/733.html',
    'CWE-476': 'https://cwe.mitre.org/data/definitions/476.html',
    'CWE-362': 'https://cwe.mitre.org/data/definitions/362.html',
    'CWE-295': 'https://cwe.mitre.org/data/definitions/295.html',
    'CWE-502': 'https://cwe.mitre.org/data/definitions/502.html',
    'CWE-540': 'https://cwe.mitre.org/data/definitions/540.html',
    'CWE-1035': 'https://cwe.mitre.org/data/definitions/1035.html',
    'CWE-602': 'https://cwe.mitre.org/data/definitions/602.html',
    'CWE-830': 'https://cwe.mitre.org/data/definitions/830.html',
    'CWE-284': 'https://cwe.mitre.org/data/definitions/284.html',
    'CWE-285': 'https://cwe.mitre.org/data/definitions/285.html',
    'CWE-213': 'https://cwe.mitre.org/data/definitions/213.html',
    'CWE-307': 'https://cwe.mitre.org/data/definitions/307.html',
    'CWE-248': 'https://cwe.mitre.org/data/definitions/284.html',
    'CWE-1032': 'https://cwe.mitre.org/data/definitions/1032.html',
    'CWE-1028': 'https://cwe.mitre.org/data/definitions/1028.html',
    'CWE-434': 'https://cwe.mitre.org/data/definitions/434.html',
    'CWE-90': 'https://cwe.mitre.org/data/definitions/90.html',
    'CWE-256': 'https://cwe.mitre.org/data/definitions/256.html',
    'CWE-778': 'https://cwe.mitre.org/data/definitions/778.html',
    'CWE-113': 'https://cwe.mitre.org/data/definitions/113.html',
    'CWE-74': 'https://cwe.mitre.org/data/definitions/74.html',
    'A3: Injection': 'https://owasp.org/Top10/A03_2021-Injection/',
    'A5: Security Misconfiguration ': 'https://owasp.org/Top10/A05_2021-Security_Misconfiguration/',
    'A7: Identification and Authentication Failures ': 'https://owasp.org/Top10/A07_2021-Identification_and_Authentication_Failures/',
    'A1: Broken Access Control ': 'https://owasp.org/Top10/A01_2021-Broken_Access_Control/',
    'A4: Insecure Design': 'https://owasp.org/Top10/A04_2021-Insecure_Design/',
    'A9: Security Logging and Monitoring Failures ': 'https://owasp.org/Top10/A09_2021-Security_Logging_and_Monitoring_Failures/',
    'is it "Sensitive Data in File Storage"?': 'https://www.owasp.org/index.php/Top_10-2017_A5-Broken_Access_Control',
    'is it "Insecure Local Storage"?': 'https://www.owasp.org/index.php/Top_10-2017_A5-Broken_Access_Control',
    'what is this lesson?': 'https://www.owasp.org/index.php/Top_10-2017_A5-Broken_Access_Control',
    'A6: Vulnerable and Outdated Components ': 'https://owasp.org/Top10/A06_2021-Vulnerable_and_Outdated_Components/',
    'A2: Cryptographic Failures': 'https://owasp.org/Top10/A02_2021-Cryptographic_Failures/',
    'A8: Software and Data Integrity Failures': 'https://owasp.org/Top10/A08_2021-Software_and_Data_Integrity_Failures/',
    'A10: Server-Side Request Forgery ': 'https://owasp.org/Top10/A10_2021-Server-Side_Request_Forgery_%28SSRF%29/',
    'A10:2021': 'https://owasp.org/Top10/A10_2021-Server-Side_Request_Forgery_%28SSRF%29/',
    'SANS-#1': 'http://cwe.mitre.org/top25/#CWE-89',
    'SANS-#4': 'http://cwe.mitre.org/top25/#CWE-79',
    'SANS-#13': 'http://cwe.mitre.org/top25/#CWE-22',
    'SANS-#12': 'http://cwe.mitre.org/top25/#CWE-352',
    'SANS-#22': 'http://cwe.mitre.org/top25/#CWE-601',
    'SANS-#15': 'http://cwe.mitre.org/top25/#CWE-863',
    'SANS-#3': 'http://cwe.mitre.org/top25/#CWE-120',
    'SANS-#20': 'http://cwe.mitre.org/top25/#CWE-131',
    'SANS-#24': 'http://cwe.mitre.org/top25/#CWE-190',
    'SANS-#23': 'http://cwe.mitre.org/top25/#CWE-134',
    'SANS-#16': 'http://cwe.mitre.org/top25/#CWE-829'
};
var getTags = function (lesson, cwekey, owaspKey, sansKey) {
    if (cwekey === void 0) { cwekey = 'cwe'; }
    if (owaspKey === void 0) { owaspKey = 'owasp'; }
    if (sansKey === void 0) { sansKey = 'sans'; }
    var tags = [];
    if (lesson[cwekey]) {
        tags.push({ tag: lesson[cwekey], url: tagsMapping[lesson[cwekey]] });
    }
    if (lesson[owaspKey]) {
        tags.push({ tag: lesson[owaspKey], url: tagsMapping[lesson[owaspKey]] });
    }
    if (lesson[sansKey]) {
        tags.push({ tag: lesson[sansKey], url: tagsMapping[lesson[sansKey]] });
    }
    return tags;
};
tags.default = getTags;

var badgesMapping = {};

Object.defineProperty(badgesMapping, "__esModule", { value: true });
var badges = {
    all_in_one: {
        notEarnIconName: 'badgeNotEarnAllInOne',
        earnIconName: 'allInOneEarn',
        descriptionKey: 'AllInOneBadge'
    },
    certified: {
        notEarnIconName: 'certifiedNotEarn',
        earnIconName: 'certifiedEarn',
        descriptionKey: 'badgeGame'
    },
    share: { notEarnIconName: 'shareNotEarn', earnIconName: 'shareEarn', descriptionKey: 'ShareBadge' },
    streak: { notEarnIconName: 'streakNotEarn', earnIconName: 'streakEarn', descriptionKey: 'StreakBadge' },
    multilingual: {
        notEarnIconName: 'multilanguageNotEarn',
        earnIconName: 'multilanguageEarn',
        descriptionKey: 'badgeMultilanguage'
    },
    classical: {
        notEarnIconName: 'classicalNotEarn',
        earnIconName: 'classicalEarn',
        descriptionKey: 'badgeClassical'
    },
    god: { notEarnIconName: 'godNotEarn', earnIconName: 'godEarn', descriptionKey: 'badgeGod' },
    mobility: { notEarnIconName: 'mobileNotEarn', earnIconName: 'mobileEarn', descriptionKey: 'badgeMobile' },
    embedded: { notEarnIconName: 'embeddedNotEarn', earnIconName: 'embeddedEarn', descriptionKey: 'badgeC' },
    webbed: {
        notEarnIconName: 'webbedNotEarn',
        earnIconName: 'webbedEarn',
        descriptionKey: 'badgeWebbed'
    },
    game: {
        notEarnIconName: 'gameNotEarn',
        earnIconName: 'gameEarn',
        descriptionKey: 'badgeGame'
    }
};
badgesMapping.default = badges;

var functions = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.deepClone = exports.getPercentAsString = exports.getColorByMark = exports.POOR_COLOUR = exports.MODERATE_COLOUR = exports.STRONG_COLOUR = exports.POOR_VALUE = exports.STRONG_VALUE = exports.titleizeArr = void 0;
	var titleizeArr = function (arr) {
	    return arr.map(function (item) { return ({ title: item, optionValue: item }); });
	};
	exports.titleizeArr = titleizeArr;
	exports.STRONG_VALUE = 80;
	exports.POOR_VALUE = 50;
	exports.STRONG_COLOUR = '#3dc483';
	exports.MODERATE_COLOUR = '#e5ba4d';
	exports.POOR_COLOUR = '#f0575b';
	var getColorByMark = function (num) {
	    if (num < exports.POOR_VALUE)
	        return exports.POOR_COLOUR;
	    if (num < exports.STRONG_VALUE)
	        return exports.MODERATE_COLOUR;
	    return exports.STRONG_COLOUR;
	};
	exports.getColorByMark = getColorByMark;
	var getPercentAsString = function (value, total) {
	    return "".concat(Math.round((value / total) * 100), "%");
	};
	exports.getPercentAsString = getPercentAsString;
	var deepClone = function (obj) {
	    return JSON.parse(JSON.stringify(obj));
	};
	exports.deepClone = deepClone; 
} (functions));

var dateFormats$1o = {};

Object.defineProperty(dateFormats$1o, "__esModule", { value: true });
dateFormats$1o.dateFormats = void 0;
/* eslint-disable import/prefer-default-export */
dateFormats$1o.dateFormats = {
    IL: 'ddd/MMM/yyyy',
    US: 'dd/MM/yyyy',
    SHORT_FORMAT: 'DD/MM/YY',
    LONG_FORMAT: 'dd/MMMM/YYYY',
    SPACED_LONG_FORMAT: 'DD MMMM YYYY',
    SPACED_LONG_FORMAT_COMMA: 'DD MMMM, YYYY'
};

var getParentRouteByRole$1 = {};

Object.defineProperty(getParentRouteByRole$1, "__esModule", { value: true });
var getParentRouteByRole = function (url, role) {
    var pathPrefix = '';
    if (role === 'superAdmin')
        pathPrefix = '/admin';
    else if (role === 'manager')
        pathPrefix = '/manager';
    var parentRoute = "".concat(pathPrefix).concat(url);
    return parentRoute;
};
getParentRouteByRole$1.default = getParentRouteByRole;

var passwordValidation = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getReEnteredPasswordError = exports.getPasswordError = exports.isValidPassword = exports.TRANSLATION_KEYS = void 0;
	var MIN_PASSWORD_LENGTH = 6;
	exports.TRANSLATION_KEYS = {
	    TOO_SHORT: 'ErrorTooShort',
	    INVALID: 'ErrorPasswordConsistMix',
	    DO_NOT_MATCH: 'PasswordsDoNotMatch'
	};
	var isValidPassword = function (password) {
	    var matchCount = 0;
	    matchCount += password.match(/(?=.*\d)/) ? 1 : 0; // Digits
	    matchCount += password.match(/(?=.*[a-z])/) ? 1 : 0; // lowercase
	    matchCount += password.match(/(?=.*[A-Z])/) ? 1 : 0; // Uppercase
	    matchCount += password.match(/\W/) ? 1 : 0; // Non-word (special) characters
	    return matchCount >= 3;
	};
	exports.isValidPassword = isValidPassword;
	var getPasswordError = function (password) {
	    if (password.length < MIN_PASSWORD_LENGTH) {
	        return exports.TRANSLATION_KEYS.TOO_SHORT;
	    }
	    if (!(0, exports.isValidPassword)(password)) {
	        return exports.TRANSLATION_KEYS.INVALID;
	    }
	    return '';
	};
	exports.getPasswordError = getPasswordError;
	var getReEnteredPasswordError = function (password, reEnteredPassword) {
	    if (reEnteredPassword && password !== reEnteredPassword) {
	        return exports.TRANSLATION_KEYS.DO_NOT_MATCH;
	    }
	    return '';
	};
	exports.getReEnteredPasswordError = getReEnteredPasswordError; 
} (passwordValidation));

var fullNameValidation = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.MAX_FULL_NAME = exports.MIN_FULL_NAME = exports.getFullNameError = exports.isValidFullName = exports.FULL_NAME_TRANSLATION_KEYS = void 0;
	var MIN_FULL_NAME_LENGTH = 2;
	var MAX_FULL_NAME_LENGTH = 250;
	// Unicode-aware whitelist matching: Unicode letters (\p{L}, any script),
	// marks (\p{M}, accents/diacritics), spaces (\p{Zs}), plus apostrophe, hyphen, period.
	// Built via the RegExp constructor (not a literal) so the `u` flag and Unicode
	// property escapes are not validated against the TS compile target (es5); both are
	// supported at runtime by all evergreen browsers and Node.
	var VALID_FULL_NAME_PATTERN = new RegExp('^[\\p{L}\\p{M}\\p{Zs}\u0027\\-.]+$', 'u');
	var HAS_LETTER_PATTERN = new RegExp('\\p{L}', 'u');
	exports.FULL_NAME_TRANSLATION_KEYS = {
	    REQUIRED: 'FullNameRequired',
	    TOO_SHORT: 'FullNameTooShort',
	    NO_LETTER: 'FullNameNoLetter',
	    INVALID: 'FullNameInvalid'
	};
	/**
	 * Validates if a full name string is valid based on:
	 * - Minimum length of 2 characters, ignoring surrounding whitespace (so 'a ' is invalid)
	 * - Maximum length of 250 characters (raw, to guard against DB buffer overflows)
	 * - Only allows Unicode letters, marks, spaces, hyphens, apostrophes, and periods
	 * - Must contain at least one letter (rejects pure-punctuation like "--" or "..")
	 */
	var isValidFullName = function (fullName) {
	    if (!fullName || fullName.length > MAX_FULL_NAME_LENGTH) {
	        return false;
	    }
	    // Require at least MIN real (non-whitespace-padding) characters: rejects '', '  ', 'a ', ' a'.
	    if (fullName.trim().length < MIN_FULL_NAME_LENGTH) {
	        return false;
	    }
	    if (!HAS_LETTER_PATTERN.test(fullName)) {
	        return false;
	    }
	    return VALID_FULL_NAME_PATTERN.test(fullName);
	};
	exports.isValidFullName = isValidFullName;
	/**
	 * Returns an appropriate error translation key based on validation failure
	 * Returns empty string if full name is valid
	 */
	var getFullNameError = function (fullName) {
	    var trimmedLength = fullName ? fullName.trim().length : 0;
	    if (trimmedLength === 0) {
	        return exports.FULL_NAME_TRANSLATION_KEYS.REQUIRED;
	    }
	    if (trimmedLength < MIN_FULL_NAME_LENGTH) {
	        return exports.FULL_NAME_TRANSLATION_KEYS.TOO_SHORT;
	    }
	    if (fullName.length > MAX_FULL_NAME_LENGTH) {
	        return exports.FULL_NAME_TRANSLATION_KEYS.INVALID;
	    }
	    if (!HAS_LETTER_PATTERN.test(fullName)) {
	        return exports.FULL_NAME_TRANSLATION_KEYS.NO_LETTER;
	    }
	    if (!VALID_FULL_NAME_PATTERN.test(fullName)) {
	        return exports.FULL_NAME_TRANSLATION_KEYS.INVALID;
	    }
	    return '';
	};
	exports.getFullNameError = getFullNameError;
	exports.MIN_FULL_NAME = MIN_FULL_NAME_LENGTH;
	exports.MAX_FULL_NAME = MAX_FULL_NAME_LENGTH; 
} (fullNameValidation));

var initializeGainsight = {};

Object.defineProperty(initializeGainsight, "__esModule", { value: true });
initializeGainsight.gainsightTrack = initializeGainsight.initializeGainsightWithScript = initializeGainsight.prepareGainsightData = void 0;
var prepareGainsightData = function (data) {
    if (!shouldUseGainsight) {
        return;
    }
    window.aptrinsic('identify', {
        id: data.email,
        fullName: data.fullName,
        role: data.role,
        locale: data.locale
    }, {
        id: data.account_name,
        name: data.customer_display_name,
        isPoc: data.is_poc,
        isPlgTenant: data.is_plg_tenant,
        isUniversity: data.is_university,
        isLean: data.is_lean_license,
        isInternal: data.is_internal,
        authType: data.auth_type,
        sfdcId: data.sf_account_id,
        parentGroupId: data.sf_account_id
    });
};
initializeGainsight.prepareGainsightData = prepareGainsightData;
var scriptElement = "\n  (function (n, t, a, e, co) {\n    var i = \"aptrinsic\"; n[i] = n[i] || function () {\n      (n[i].q = n[i].q || []).push(arguments)\n    }, n[i].p = e; n[i].c = co;\n    var r = t.createElement(\"script\"); r.async = !0, r.src = a + \"?a=\" + e;\n    var c = t.getElementsByTagName(\"script\")[0]; c.parentNode.insertBefore(r, c)\n  })(window, document, \"https://web-sdk-eu.aptrinsic.com/api/aptrinsic.js\", \"AP-OUTCS1LUU47P-2\");\n";
var initializeGainsightWithScript = function () {
    if (!shouldUseGainsight) {
        return;
    }
    try {
        var gainsightScriptElement = document.querySelector('script#gainsight-script');
        if (!gainsightScriptElement) {
            gainsightScriptElement = document.createElement('script');
            gainsightScriptElement.classList.add('gainsight-script');
            document.head.appendChild(gainsightScriptElement);
        }
        gainsightScriptElement.innerHTML = scriptElement;
    }
    catch (e) {
        console.error('gainsight initialization failed');
    }
};
initializeGainsight.initializeGainsightWithScript = initializeGainsightWithScript;
var gainsightTrack = function (eventName, properties) {
    if (!shouldUseGainsight) {
        return;
    }
    try {
        window.aptrinsic('track', eventName, properties);
    }
    catch (e) {
        console.error(e);
    }
};
initializeGainsight.gainsightTrack = gainsightTrack;
var shouldUseGainsight = process.env.CB_USE_MIXPANEL == 'true';

var programLanguages = {};

Object.defineProperty(programLanguages, "__esModule", { value: true });
programLanguages.languagesNameToDisplayName = void 0;
programLanguages.languagesNameToDisplayName = {
    java: 'Java',
    dotnet: '.NET',
    python: 'Python',
    php: 'PHP',
    scala: 'Scala',
    go: 'Go',
    ruby: 'Ruby',
    nodejs: 'Node.js',
    ios: 'iOS',
    android: 'Android'
};

var mixpanelInstance = {};

var Config = {
    DEBUG: false,
    LIB_VERSION: '2.48.1'
};

// since es6 imports are static and we run unit tests from the console, window won't be defined when importing this file
var window$1;
if (typeof(window) === 'undefined') {
    var loc = {
        hostname: ''
    };
    window$1 = {
        navigator: { userAgent: '' },
        document: {
            location: loc,
            referrer: ''
        },
        screen: { width: 0, height: 0 },
        location: loc
    };
} else {
    window$1 = window;
}

/*
 * Saved references to long variable names, so that closure compiler can
 * minimize file size.
 */

var ArrayProto = Array.prototype;
var FuncProto = Function.prototype;
var ObjProto = Object.prototype;
var slice = ArrayProto.slice;
var toString = ObjProto.toString;
var hasOwnProperty$a = ObjProto.hasOwnProperty;
var windowConsole = window$1.console;
var navigator$1 = window$1.navigator;
var document$1 = window$1.document;
var windowOpera = window$1.opera;
var screen = window$1.screen;
var userAgent = navigator$1.userAgent;
var nativeBind = FuncProto.bind;
var nativeForEach = ArrayProto.forEach;
var nativeIndexOf = ArrayProto.indexOf;
var nativeMap = ArrayProto.map;
var nativeIsArray = Array.isArray;
var breaker = {};
var _ = {
    trim: function(str) {
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
        return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    }
};

// Console override
var console$1 = {
    /** @type {function(...*)} */
    log: function() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            try {
                windowConsole.log.apply(windowConsole, arguments);
            } catch (err) {
                _.each(arguments, function(arg) {
                    windowConsole.log(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */
    warn: function() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel warning:'].concat(_.toArray(arguments));
            try {
                windowConsole.warn.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.warn(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */
    error: function() {
        if (Config.DEBUG && !_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.error(arg);
                });
            }
        }
    },
    /** @type {function(...*)} */
    critical: function() {
        if (!_.isUndefined(windowConsole) && windowConsole) {
            var args = ['Mixpanel error:'].concat(_.toArray(arguments));
            try {
                windowConsole.error.apply(windowConsole, args);
            } catch (err) {
                _.each(args, function(arg) {
                    windowConsole.error(arg);
                });
            }
        }
    }
};

var log_func_with_prefix = function(func, prefix) {
    return function() {
        arguments[0] = '[' + prefix + '] ' + arguments[0];
        return func.apply(console$1, arguments);
    };
};
var console_with_prefix = function(prefix) {
    return {
        log: log_func_with_prefix(console$1.log, prefix),
        error: log_func_with_prefix(console$1.error, prefix),
        critical: log_func_with_prefix(console$1.critical, prefix)
    };
};


// UNDERSCORE
// Embed part of the Underscore Library
_.bind = function(func, context) {
    var args, bound;
    if (nativeBind && func.bind === nativeBind) {
        return nativeBind.apply(func, slice.call(arguments, 1));
    }
    if (!_.isFunction(func)) {
        throw new TypeError();
    }
    args = slice.call(arguments, 2);
    bound = function() {
        if (!(this instanceof bound)) {
            return func.apply(context, args.concat(slice.call(arguments)));
        }
        var ctor = {};
        ctor.prototype = func.prototype;
        var self = new ctor();
        ctor.prototype = null;
        var result = func.apply(self, args.concat(slice.call(arguments)));
        if (Object(result) === result) {
            return result;
        }
        return self;
    };
    return bound;
};

/**
 * @param {*=} obj
 * @param {function(...*)=} iterator
 * @param {Object=} context
 */
_.each = function(obj, iterator, context) {
    if (obj === null || obj === undefined) {
        return;
    }
    if (nativeForEach && obj.forEach === nativeForEach) {
        obj.forEach(iterator, context);
    } else if (obj.length === +obj.length) {
        for (var i = 0, l = obj.length; i < l; i++) {
            if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) {
                return;
            }
        }
    } else {
        for (var key in obj) {
            if (hasOwnProperty$a.call(obj, key)) {
                if (iterator.call(context, obj[key], key, obj) === breaker) {
                    return;
                }
            }
        }
    }
};

_.extend = function(obj) {
    _.each(slice.call(arguments, 1), function(source) {
        for (var prop in source) {
            if (source[prop] !== void 0) {
                obj[prop] = source[prop];
            }
        }
    });
    return obj;
};

_.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
};

// from a comment on http://dbj.org/dbj/?p=286
// fails on only one very rare and deliberate custom object:
// var bomb = { toString : undefined, valueOf: function(o) { return "function BOMBA!"; }};
_.isFunction = function(f) {
    try {
        return /^\s*\bfunction\b/.test(f);
    } catch (x) {
        return false;
    }
};

_.isArguments = function(obj) {
    return !!(obj && hasOwnProperty$a.call(obj, 'callee'));
};

_.toArray = function(iterable) {
    if (!iterable) {
        return [];
    }
    if (iterable.toArray) {
        return iterable.toArray();
    }
    if (_.isArray(iterable)) {
        return slice.call(iterable);
    }
    if (_.isArguments(iterable)) {
        return slice.call(iterable);
    }
    return _.values(iterable);
};

_.map = function(arr, callback, context) {
    if (nativeMap && arr.map === nativeMap) {
        return arr.map(callback, context);
    } else {
        var results = [];
        _.each(arr, function(item) {
            results.push(callback.call(context, item));
        });
        return results;
    }
};

_.keys = function(obj) {
    var results = [];
    if (obj === null) {
        return results;
    }
    _.each(obj, function(value, key) {
        results[results.length] = key;
    });
    return results;
};

_.values = function(obj) {
    var results = [];
    if (obj === null) {
        return results;
    }
    _.each(obj, function(value) {
        results[results.length] = value;
    });
    return results;
};

_.include = function(obj, target) {
    var found = false;
    if (obj === null) {
        return found;
    }
    if (nativeIndexOf && obj.indexOf === nativeIndexOf) {
        return obj.indexOf(target) != -1;
    }
    _.each(obj, function(value) {
        if (found || (found = (value === target))) {
            return breaker;
        }
    });
    return found;
};

_.includes = function(str, needle) {
    return str.indexOf(needle) !== -1;
};

// Underscore Addons
_.inherit = function(subclass, superclass) {
    subclass.prototype = new superclass();
    subclass.prototype.constructor = subclass;
    subclass.superclass = superclass.prototype;
    return subclass;
};

_.isObject = function(obj) {
    return (obj === Object(obj) && !_.isArray(obj));
};

_.isEmptyObject = function(obj) {
    if (_.isObject(obj)) {
        for (var key in obj) {
            if (hasOwnProperty$a.call(obj, key)) {
                return false;
            }
        }
        return true;
    }
    return false;
};

_.isUndefined = function(obj) {
    return obj === void 0;
};

_.isString = function(obj) {
    return toString.call(obj) == '[object String]';
};

_.isDate = function(obj) {
    return toString.call(obj) == '[object Date]';
};

_.isNumber = function(obj) {
    return toString.call(obj) == '[object Number]';
};

_.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
};

_.encodeDates = function(obj) {
    _.each(obj, function(v, k) {
        if (_.isDate(v)) {
            obj[k] = _.formatDate(v);
        } else if (_.isObject(v)) {
            obj[k] = _.encodeDates(v); // recurse
        }
    });
    return obj;
};

_.timestamp = function() {
    Date.now = Date.now || function() {
        return +new Date;
    };
    return Date.now();
};

_.formatDate = function(d) {
    // YYYY-MM-DDTHH:MM:SS in UTC
    function pad(n) {
        return n < 10 ? '0' + n : n;
    }
    return d.getUTCFullYear() + '-' +
        pad(d.getUTCMonth() + 1) + '-' +
        pad(d.getUTCDate()) + 'T' +
        pad(d.getUTCHours()) + ':' +
        pad(d.getUTCMinutes()) + ':' +
        pad(d.getUTCSeconds());
};

_.strip_empty_properties = function(p) {
    var ret = {};
    _.each(p, function(v, k) {
        if (_.isString(v) && v.length > 0) {
            ret[k] = v;
        }
    });
    return ret;
};

/*
 * this function returns a copy of object after truncating it.  If
 * passed an Array or Object it will iterate through obj and
 * truncate all the values recursively.
 */
_.truncate = function(obj, length) {
    var ret;

    if (typeof(obj) === 'string') {
        ret = obj.slice(0, length);
    } else if (_.isArray(obj)) {
        ret = [];
        _.each(obj, function(val) {
            ret.push(_.truncate(val, length));
        });
    } else if (_.isObject(obj)) {
        ret = {};
        _.each(obj, function(val, key) {
            ret[key] = _.truncate(val, length);
        });
    } else {
        ret = obj;
    }

    return ret;
};

_.JSONEncode = (function() {
    return function(mixed_val) {
        var value = mixed_val;
        var quote = function(string) {
            var escapable = /[\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g; // eslint-disable-line no-control-regex
            var meta = { // table of character substitutions
                '\b': '\\b',
                '\t': '\\t',
                '\n': '\\n',
                '\f': '\\f',
                '\r': '\\r',
                '"': '\\"',
                '\\': '\\\\'
            };

            escapable.lastIndex = 0;
            return escapable.test(string) ?
                '"' + string.replace(escapable, function(a) {
                    var c = meta[a];
                    return typeof c === 'string' ? c :
                        '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
                }) + '"' :
                '"' + string + '"';
        };

        var str = function(key, holder) {
            var gap = '';
            var indent = '    ';
            var i = 0; // The loop counter.
            var k = ''; // The member key.
            var v = ''; // The member value.
            var length = 0;
            var mind = gap;
            var partial = [];
            var value = holder[key];

            // If the value has a toJSON method, call it to obtain a replacement value.
            if (value && typeof value === 'object' &&
                typeof value.toJSON === 'function') {
                value = value.toJSON(key);
            }

            // What happens next depends on the value's type.
            switch (typeof value) {
                case 'string':
                    return quote(value);

                case 'number':
                    // JSON numbers must be finite. Encode non-finite numbers as null.
                    return isFinite(value) ? String(value) : 'null';

                case 'boolean':
                case 'null':
                    // If the value is a boolean or null, convert it to a string. Note:
                    // typeof null does not produce 'null'. The case is included here in
                    // the remote chance that this gets fixed someday.

                    return String(value);

                case 'object':
                    // If the type is 'object', we might be dealing with an object or an array or
                    // null.
                    // Due to a specification blunder in ECMAScript, typeof null is 'object',
                    // so watch out for that case.
                    if (!value) {
                        return 'null';
                    }

                    // Make an array to hold the partial results of stringifying this object value.
                    gap += indent;
                    partial = [];

                    // Is the value an array?
                    if (toString.apply(value) === '[object Array]') {
                        // The value is an array. Stringify every element. Use null as a placeholder
                        // for non-JSON values.

                        length = value.length;
                        for (i = 0; i < length; i += 1) {
                            partial[i] = str(i, value) || 'null';
                        }

                        // Join all of the elements together, separated with commas, and wrap them in
                        // brackets.
                        v = partial.length === 0 ? '[]' :
                            gap ? '[\n' + gap +
                            partial.join(',\n' + gap) + '\n' +
                            mind + ']' :
                                '[' + partial.join(',') + ']';
                        gap = mind;
                        return v;
                    }

                    // Iterate through all of the keys in the object.
                    for (k in value) {
                        if (hasOwnProperty$a.call(value, k)) {
                            v = str(k, value);
                            if (v) {
                                partial.push(quote(k) + (gap ? ': ' : ':') + v);
                            }
                        }
                    }

                    // Join all of the member texts together, separated with commas,
                    // and wrap them in braces.
                    v = partial.length === 0 ? '{}' :
                        gap ? '{' + partial.join(',') + '' +
                        mind + '}' : '{' + partial.join(',') + '}';
                    gap = mind;
                    return v;
            }
        };

        // Make a fake root object containing our value under the key of ''.
        // Return the result of stringifying the value.
        return str('', {
            '': value
        });
    };
})();

/**
 * From https://github.com/douglascrockford/JSON-js/blob/master/json_parse.js
 * Slightly modified to throw a real Error rather than a POJO
 */
_.JSONDecode = (function() {
    var at, // The index of the current character
        ch, // The current character
        escapee = {
            '"': '"',
            '\\': '\\',
            '/': '/',
            'b': '\b',
            'f': '\f',
            'n': '\n',
            'r': '\r',
            't': '\t'
        },
        text,
        error = function(m) {
            var e = new SyntaxError(m);
            e.at = at;
            e.text = text;
            throw e;
        },
        next = function(c) {
            // If a c parameter is provided, verify that it matches the current character.
            if (c && c !== ch) {
                error('Expected \'' + c + '\' instead of \'' + ch + '\'');
            }
            // Get the next character. When there are no more characters,
            // return the empty string.
            ch = text.charAt(at);
            at += 1;
            return ch;
        },
        number = function() {
            // Parse a number value.
            var number,
                string = '';

            if (ch === '-') {
                string = '-';
                next('-');
            }
            while (ch >= '0' && ch <= '9') {
                string += ch;
                next();
            }
            if (ch === '.') {
                string += '.';
                while (next() && ch >= '0' && ch <= '9') {
                    string += ch;
                }
            }
            if (ch === 'e' || ch === 'E') {
                string += ch;
                next();
                if (ch === '-' || ch === '+') {
                    string += ch;
                    next();
                }
                while (ch >= '0' && ch <= '9') {
                    string += ch;
                    next();
                }
            }
            number = +string;
            if (!isFinite(number)) {
                error('Bad number');
            } else {
                return number;
            }
        },

        string = function() {
            // Parse a string value.
            var hex,
                i,
                string = '',
                uffff;
            // When parsing for string values, we must look for " and \ characters.
            if (ch === '"') {
                while (next()) {
                    if (ch === '"') {
                        next();
                        return string;
                    }
                    if (ch === '\\') {
                        next();
                        if (ch === 'u') {
                            uffff = 0;
                            for (i = 0; i < 4; i += 1) {
                                hex = parseInt(next(), 16);
                                if (!isFinite(hex)) {
                                    break;
                                }
                                uffff = uffff * 16 + hex;
                            }
                            string += String.fromCharCode(uffff);
                        } else if (typeof escapee[ch] === 'string') {
                            string += escapee[ch];
                        } else {
                            break;
                        }
                    } else {
                        string += ch;
                    }
                }
            }
            error('Bad string');
        },
        white = function() {
            // Skip whitespace.
            while (ch && ch <= ' ') {
                next();
            }
        },
        word = function() {
            // true, false, or null.
            switch (ch) {
                case 't':
                    next('t');
                    next('r');
                    next('u');
                    next('e');
                    return true;
                case 'f':
                    next('f');
                    next('a');
                    next('l');
                    next('s');
                    next('e');
                    return false;
                case 'n':
                    next('n');
                    next('u');
                    next('l');
                    next('l');
                    return null;
            }
            error('Unexpected "' + ch + '"');
        },
        value, // Placeholder for the value function.
        array = function() {
            // Parse an array value.
            var array = [];

            if (ch === '[') {
                next('[');
                white();
                if (ch === ']') {
                    next(']');
                    return array; // empty array
                }
                while (ch) {
                    array.push(value());
                    white();
                    if (ch === ']') {
                        next(']');
                        return array;
                    }
                    next(',');
                    white();
                }
            }
            error('Bad array');
        },
        object = function() {
            // Parse an object value.
            var key,
                object = {};

            if (ch === '{') {
                next('{');
                white();
                if (ch === '}') {
                    next('}');
                    return object; // empty object
                }
                while (ch) {
                    key = string();
                    white();
                    next(':');
                    if (Object.hasOwnProperty.call(object, key)) {
                        error('Duplicate key "' + key + '"');
                    }
                    object[key] = value();
                    white();
                    if (ch === '}') {
                        next('}');
                        return object;
                    }
                    next(',');
                    white();
                }
            }
            error('Bad object');
        };

    value = function() {
        // Parse a JSON value. It could be an object, an array, a string,
        // a number, or a word.
        white();
        switch (ch) {
            case '{':
                return object();
            case '[':
                return array();
            case '"':
                return string();
            case '-':
                return number();
            default:
                return ch >= '0' && ch <= '9' ? number() : word();
        }
    };

    // Return the json_parse function. It will have access to all of the
    // above functions and variables.
    return function(source) {
        var result;

        text = source;
        at = 0;
        ch = ' ';
        result = value();
        white();
        if (ch) {
            error('Syntax error');
        }

        return result;
    };
})();

_.base64Encode = function(data) {
    var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    var o1, o2, o3, h1, h2, h3, h4, bits, i = 0,
        ac = 0,
        enc = '',
        tmp_arr = [];

    if (!data) {
        return data;
    }

    data = _.utf8Encode(data);

    do { // pack three octets into four hexets
        o1 = data.charCodeAt(i++);
        o2 = data.charCodeAt(i++);
        o3 = data.charCodeAt(i++);

        bits = o1 << 16 | o2 << 8 | o3;

        h1 = bits >> 18 & 0x3f;
        h2 = bits >> 12 & 0x3f;
        h3 = bits >> 6 & 0x3f;
        h4 = bits & 0x3f;

        // use hexets to index into b64, and append result to encoded string
        tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
    } while (i < data.length);

    enc = tmp_arr.join('');

    switch (data.length % 3) {
        case 1:
            enc = enc.slice(0, -2) + '==';
            break;
        case 2:
            enc = enc.slice(0, -1) + '=';
            break;
    }

    return enc;
};

_.utf8Encode = function(string) {
    string = (string + '').replace(/\r\n/g, '\n').replace(/\r/g, '\n');

    var utftext = '',
        start,
        end;
    var stringl = 0,
        n;

    start = end = 0;
    stringl = string.length;

    for (n = 0; n < stringl; n++) {
        var c1 = string.charCodeAt(n);
        var enc = null;

        if (c1 < 128) {
            end++;
        } else if ((c1 > 127) && (c1 < 2048)) {
            enc = String.fromCharCode((c1 >> 6) | 192, (c1 & 63) | 128);
        } else {
            enc = String.fromCharCode((c1 >> 12) | 224, ((c1 >> 6) & 63) | 128, (c1 & 63) | 128);
        }
        if (enc !== null) {
            if (end > start) {
                utftext += string.substring(start, end);
            }
            utftext += enc;
            start = end = n + 1;
        }
    }

    if (end > start) {
        utftext += string.substring(start, string.length);
    }

    return utftext;
};

_.UUID = (function() {

    // Time-based entropy
    var T = function() {
        var time = 1 * new Date(); // cross-browser version of Date.now()
        var ticks;
        if (window$1.performance && window$1.performance.now) {
            ticks = window$1.performance.now();
        } else {
            // fall back to busy loop
            ticks = 0;

            // this while loop figures how many browser ticks go by
            // before 1*new Date() returns a new number, ie the amount
            // of ticks that go by per millisecond
            while (time == 1 * new Date()) {
                ticks++;
            }
        }
        return time.toString(16) + Math.floor(ticks).toString(16);
    };

    // Math.Random entropy
    var R = function() {
        return Math.random().toString(16).replace('.', '');
    };

    // User agent entropy
    // This function takes the user agent string, and then xors
    // together each sequence of 8 bytes.  This produces a final
    // sequence of 8 bytes which it returns as hex.
    var UA = function() {
        var ua = userAgent,
            i, ch, buffer = [],
            ret = 0;

        function xor(result, byte_array) {
            var j, tmp = 0;
            for (j = 0; j < byte_array.length; j++) {
                tmp |= (buffer[j] << j * 8);
            }
            return result ^ tmp;
        }

        for (i = 0; i < ua.length; i++) {
            ch = ua.charCodeAt(i);
            buffer.unshift(ch & 0xFF);
            if (buffer.length >= 4) {
                ret = xor(ret, buffer);
                buffer = [];
            }
        }

        if (buffer.length > 0) {
            ret = xor(ret, buffer);
        }

        return ret.toString(16);
    };

    return function() {
        var se = (screen.height * screen.width).toString(16);
        return (T() + '-' + R() + '-' + UA() + '-' + se + '-' + T());
    };
})();

// _.isBlockedUA()
// This is to block various web spiders from executing our JS and
// sending false tracking data
var BLOCKED_UA_STRS = [
    'ahrefsbot',
    'baiduspider',
    'bingbot',
    'bingpreview',
    'chrome-lighthouse',
    'facebookexternal',
    'petalbot',
    'pinterest',
    'screaming frog',
    'yahoo! slurp',
    'yandexbot',

    // a whole bunch of goog-specific crawlers
    // https://developers.google.com/search/docs/advanced/crawling/overview-google-crawlers
    'adsbot-google',
    'apis-google',
    'duplexweb-google',
    'feedfetcher-google',
    'google favicon',
    'google web preview',
    'google-read-aloud',
    'googlebot',
    'googleweblight',
    'mediapartners-google',
    'storebot-google'
];
_.isBlockedUA = function(ua) {
    var i;
    ua = ua.toLowerCase();
    for (i = 0; i < BLOCKED_UA_STRS.length; i++) {
        if (ua.indexOf(BLOCKED_UA_STRS[i]) !== -1) {
            return true;
        }
    }
    return false;
};

/**
 * @param {Object=} formdata
 * @param {string=} arg_separator
 */
_.HTTPBuildQuery = function(formdata, arg_separator) {
    var use_val, use_key, tmp_arr = [];

    if (_.isUndefined(arg_separator)) {
        arg_separator = '&';
    }

    _.each(formdata, function(val, key) {
        use_val = encodeURIComponent(val.toString());
        use_key = encodeURIComponent(key);
        tmp_arr[tmp_arr.length] = use_key + '=' + use_val;
    });

    return tmp_arr.join(arg_separator);
};

_.getQueryParam = function(url, param) {
    // Expects a raw URL

    param = param.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
    var regexS = '[\\?&]' + param + '=([^&#]*)',
        regex = new RegExp(regexS),
        results = regex.exec(url);
    if (results === null || (results && typeof(results[1]) !== 'string' && results[1].length)) {
        return '';
    } else {
        var result = results[1];
        try {
            result = decodeURIComponent(result);
        } catch(err) {
            console$1.error('Skipping decoding for malformed query param: ' + result);
        }
        return result.replace(/\+/g, ' ');
    }
};


// _.cookie
// Methods partially borrowed from quirksmode.org/js/cookies.html
_.cookie = {
    get: function(name) {
        var nameEQ = name + '=';
        var ca = document$1.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    },

    parse: function(name) {
        var cookie;
        try {
            cookie = _.JSONDecode(_.cookie.get(name)) || {};
        } catch (err) {
            // noop
        }
        return cookie;
    },

    set_seconds: function(name, value, seconds, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '',
            expires = '',
            secure = '';

        if (domain_override) {
            cdomain = '; domain=' + domain_override;
        } else if (is_cross_subdomain) {
            var domain = extract_domain(document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }

        if (seconds) {
            var date = new Date();
            date.setTime(date.getTime() + (seconds * 1000));
            expires = '; expires=' + date.toGMTString();
        }

        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) {
            secure += '; secure';
        }

        document$1.cookie = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
    },

    set: function(name, value, days, is_cross_subdomain, is_secure, is_cross_site, domain_override) {
        var cdomain = '', expires = '', secure = '';

        if (domain_override) {
            cdomain = '; domain=' + domain_override;
        } else if (is_cross_subdomain) {
            var domain = extract_domain(document$1.location.hostname);
            cdomain = domain ? '; domain=.' + domain : '';
        }

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toGMTString();
        }

        if (is_cross_site) {
            is_secure = true;
            secure = '; SameSite=None';
        }
        if (is_secure) {
            secure += '; secure';
        }

        var new_cookie_val = name + '=' + encodeURIComponent(value) + expires + '; path=/' + cdomain + secure;
        document$1.cookie = new_cookie_val;
        return new_cookie_val;
    },

    remove: function(name, is_cross_subdomain, domain_override) {
        _.cookie.set(name, '', -1, is_cross_subdomain, false, false, domain_override);
    }
};

var _localStorageSupported = null;
var localStorageSupported = function(storage, forceCheck) {
    if (_localStorageSupported !== null && !forceCheck) {
        return _localStorageSupported;
    }

    var supported = true;
    try {
        storage = storage || window.localStorage;
        var key = '__mplss_' + cheap_guid(8),
            val = 'xyz';
        storage.setItem(key, val);
        if (storage.getItem(key) !== val) {
            supported = false;
        }
        storage.removeItem(key);
    } catch (err) {
        supported = false;
    }

    _localStorageSupported = supported;
    return supported;
};

// _.localStorage
_.localStorage = {
    is_supported: function(force_check) {
        var supported = localStorageSupported(null, force_check);
        if (!supported) {
            console$1.error('localStorage unsupported; falling back to cookie store');
        }
        return supported;
    },

    error: function(msg) {
        console$1.error('localStorage error: ' + msg);
    },

    get: function(name) {
        try {
            return window.localStorage.getItem(name);
        } catch (err) {
            _.localStorage.error(err);
        }
        return null;
    },

    parse: function(name) {
        try {
            return _.JSONDecode(_.localStorage.get(name)) || {};
        } catch (err) {
            // noop
        }
        return null;
    },

    set: function(name, value) {
        try {
            window.localStorage.setItem(name, value);
        } catch (err) {
            _.localStorage.error(err);
        }
    },

    remove: function(name) {
        try {
            window.localStorage.removeItem(name);
        } catch (err) {
            _.localStorage.error(err);
        }
    }
};

_.register_event = (function() {
    // written by Dean Edwards, 2005
    // with input from Tino Zijdel - crisp@xs4all.nl
    // with input from Carl Sverre - mail@carlsverre.com
    // with input from Mixpanel
    // http://dean.edwards.name/weblog/2005/10/add-event/
    // https://gist.github.com/1930440

    /**
     * @param {Object} element
     * @param {string} type
     * @param {function(...*)} handler
     * @param {boolean=} oldSchool
     * @param {boolean=} useCapture
     */
    var register_event = function(element, type, handler, oldSchool, useCapture) {
        if (!element) {
            console$1.error('No valid element provided to register_event');
            return;
        }

        if (element.addEventListener && !oldSchool) {
            element.addEventListener(type, handler, !!useCapture);
        } else {
            var ontype = 'on' + type;
            var old_handler = element[ontype]; // can be undefined
            element[ontype] = makeHandler(element, handler, old_handler);
        }
    };

    function makeHandler(element, new_handler, old_handlers) {
        var handler = function(event) {
            event = event || fixEvent(window.event);

            // this basically happens in firefox whenever another script
            // overwrites the onload callback and doesn't pass the event
            // object to previously defined callbacks.  All the browsers
            // that don't define window.event implement addEventListener
            // so the dom_loaded handler will still be fired as usual.
            if (!event) {
                return undefined;
            }

            var ret = true;
            var old_result, new_result;

            if (_.isFunction(old_handlers)) {
                old_result = old_handlers(event);
            }
            new_result = new_handler.call(element, event);

            if ((false === old_result) || (false === new_result)) {
                ret = false;
            }

            return ret;
        };

        return handler;
    }

    function fixEvent(event) {
        if (event) {
            event.preventDefault = fixEvent.preventDefault;
            event.stopPropagation = fixEvent.stopPropagation;
        }
        return event;
    }
    fixEvent.preventDefault = function() {
        this.returnValue = false;
    };
    fixEvent.stopPropagation = function() {
        this.cancelBubble = true;
    };

    return register_event;
})();


var TOKEN_MATCH_REGEX = new RegExp('^(\\w*)\\[(\\w+)([=~\\|\\^\\$\\*]?)=?"?([^\\]"]*)"?\\]$');

_.dom_query = (function() {
    /* document.getElementsBySelector(selector)
    - returns an array of element objects from the current document
    matching the CSS selector. Selectors can contain element names,
    class names and ids and can be nested. For example:

    elements = document.getElementsBySelector('div#main p a.external')

    Will return an array of all 'a' elements with 'external' in their
    class attribute that are contained inside 'p' elements that are
    contained inside the 'div' element which has id="main"

    New in version 0.4: Support for CSS2 and CSS3 attribute selectors:
    See http://www.w3.org/TR/css3-selectors/#attribute-selectors

    Version 0.4 - Simon Willison, March 25th 2003
    -- Works in Phoenix 0.5, Mozilla 1.3, Opera 7, Internet Explorer 6, Internet Explorer 5 on Windows
    -- Opera 7 fails

    Version 0.5 - Carl Sverre, Jan 7th 2013
    -- Now uses jQuery-esque `hasClass` for testing class name
    equality.  This fixes a bug related to '-' characters being
    considered not part of a 'word' in regex.
    */

    function getAllChildren(e) {
        // Returns all children of element. Workaround required for IE5/Windows. Ugh.
        return e.all ? e.all : e.getElementsByTagName('*');
    }

    var bad_whitespace = /[\t\r\n]/g;

    function hasClass(elem, selector) {
        var className = ' ' + selector + ' ';
        return ((' ' + elem.className + ' ').replace(bad_whitespace, ' ').indexOf(className) >= 0);
    }

    function getElementsBySelector(selector) {
        // Attempt to fail gracefully in lesser browsers
        if (!document$1.getElementsByTagName) {
            return [];
        }
        // Split selector in to tokens
        var tokens = selector.split(' ');
        var token, bits, tagName, found, foundCount, i, j, k, elements, currentContextIndex;
        var currentContext = [document$1];
        for (i = 0; i < tokens.length; i++) {
            token = tokens[i].replace(/^\s+/, '').replace(/\s+$/, '');
            if (token.indexOf('#') > -1) {
                // Token is an ID selector
                bits = token.split('#');
                tagName = bits[0];
                var id = bits[1];
                var element = document$1.getElementById(id);
                if (!element || (tagName && element.nodeName.toLowerCase() != tagName)) {
                    // element not found or tag with that ID not found, return false
                    return [];
                }
                // Set currentContext to contain just this element
                currentContext = [element];
                continue; // Skip to next token
            }
            if (token.indexOf('.') > -1) {
                // Token contains a class selector
                bits = token.split('.');
                tagName = bits[0];
                var className = bits[1];
                if (!tagName) {
                    tagName = '*';
                }
                // Get elements matching tag, filter them for class selector
                found = [];
                foundCount = 0;
                for (j = 0; j < currentContext.length; j++) {
                    if (tagName == '*') {
                        elements = getAllChildren(currentContext[j]);
                    } else {
                        elements = currentContext[j].getElementsByTagName(tagName);
                    }
                    for (k = 0; k < elements.length; k++) {
                        found[foundCount++] = elements[k];
                    }
                }
                currentContext = [];
                currentContextIndex = 0;
                for (j = 0; j < found.length; j++) {
                    if (found[j].className &&
                        _.isString(found[j].className) && // some SVG elements have classNames which are not strings
                        hasClass(found[j], className)
                    ) {
                        currentContext[currentContextIndex++] = found[j];
                    }
                }
                continue; // Skip to next token
            }
            // Code to deal with attribute selectors
            var token_match = token.match(TOKEN_MATCH_REGEX);
            if (token_match) {
                tagName = token_match[1];
                var attrName = token_match[2];
                var attrOperator = token_match[3];
                var attrValue = token_match[4];
                if (!tagName) {
                    tagName = '*';
                }
                // Grab all of the tagName elements within current context
                found = [];
                foundCount = 0;
                for (j = 0; j < currentContext.length; j++) {
                    if (tagName == '*') {
                        elements = getAllChildren(currentContext[j]);
                    } else {
                        elements = currentContext[j].getElementsByTagName(tagName);
                    }
                    for (k = 0; k < elements.length; k++) {
                        found[foundCount++] = elements[k];
                    }
                }
                currentContext = [];
                currentContextIndex = 0;
                var checkFunction; // This function will be used to filter the elements
                switch (attrOperator) {
                    case '=': // Equality
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName) == attrValue);
                        };
                        break;
                    case '~': // Match one of space seperated words
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).match(new RegExp('\\b' + attrValue + '\\b')));
                        };
                        break;
                    case '|': // Match start with value followed by optional hyphen
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).match(new RegExp('^' + attrValue + '-?')));
                        };
                        break;
                    case '^': // Match starts with value
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).indexOf(attrValue) === 0);
                        };
                        break;
                    case '$': // Match ends with value - fails with "Warning" in Opera 7
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).lastIndexOf(attrValue) == e.getAttribute(attrName).length - attrValue.length);
                        };
                        break;
                    case '*': // Match ends with value
                        checkFunction = function(e) {
                            return (e.getAttribute(attrName).indexOf(attrValue) > -1);
                        };
                        break;
                    default:
                        // Just test for existence of attribute
                        checkFunction = function(e) {
                            return e.getAttribute(attrName);
                        };
                }
                currentContext = [];
                currentContextIndex = 0;
                for (j = 0; j < found.length; j++) {
                    if (checkFunction(found[j])) {
                        currentContext[currentContextIndex++] = found[j];
                    }
                }
                // alert('Attribute Selector: '+tagName+' '+attrName+' '+attrOperator+' '+attrValue);
                continue; // Skip to next token
            }
            // If we get here, token is JUST an element (not a class or ID selector)
            tagName = token;
            found = [];
            foundCount = 0;
            for (j = 0; j < currentContext.length; j++) {
                elements = currentContext[j].getElementsByTagName(tagName);
                for (k = 0; k < elements.length; k++) {
                    found[foundCount++] = elements[k];
                }
            }
            currentContext = found;
        }
        return currentContext;
    }

    return function(query) {
        if (_.isElement(query)) {
            return [query];
        } else if (_.isObject(query) && !_.isUndefined(query.length)) {
            return query;
        } else {
            return getElementsBySelector.call(this, query);
        }
    };
})();

var CAMPAIGN_KEYWORDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
var CLICK_IDS = ['dclid', 'fbclid', 'gclid', 'ko_click_id', 'li_fat_id', 'msclkid', 'ttclid', 'twclid', 'wbraid'];

_.info = {
    campaignParams: function(default_value) {
        var kw = '',
            params = {};
        _.each(CAMPAIGN_KEYWORDS, function(kwkey) {
            kw = _.getQueryParam(document$1.URL, kwkey);
            if (kw.length) {
                params[kwkey] = kw;
            } else if (default_value !== undefined) {
                params[kwkey] = default_value;
            }
        });

        return params;
    },

    clickParams: function() {
        var id = '',
            params = {};
        _.each(CLICK_IDS, function(idkey) {
            id = _.getQueryParam(document$1.URL, idkey);
            if (id.length) {
                params[idkey] = id;
            }
        });

        return params;
    },

    marketingParams: function() {
        return _.extend(_.info.campaignParams(), _.info.clickParams());
    },

    searchEngine: function(referrer) {
        if (referrer.search('https?://(.*)google.([^/?]*)') === 0) {
            return 'google';
        } else if (referrer.search('https?://(.*)bing.com') === 0) {
            return 'bing';
        } else if (referrer.search('https?://(.*)yahoo.com') === 0) {
            return 'yahoo';
        } else if (referrer.search('https?://(.*)duckduckgo.com') === 0) {
            return 'duckduckgo';
        } else {
            return null;
        }
    },

    searchInfo: function(referrer) {
        var search = _.info.searchEngine(referrer),
            param = (search != 'yahoo') ? 'q' : 'p',
            ret = {};

        if (search !== null) {
            ret['$search_engine'] = search;

            var keyword = _.getQueryParam(referrer, param);
            if (keyword.length) {
                ret['mp_keyword'] = keyword;
            }
        }

        return ret;
    },

    /**
     * This function detects which browser is running this script.
     * The order of the checks are important since many user agents
     * include key words used in later checks.
     */
    browser: function(user_agent, vendor, opera) {
        vendor = vendor || ''; // vendor is undefined for at least IE9
        if (opera || _.includes(user_agent, ' OPR/')) {
            if (_.includes(user_agent, 'Mini')) {
                return 'Opera Mini';
            }
            return 'Opera';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
            return 'BlackBerry';
        } else if (_.includes(user_agent, 'IEMobile') || _.includes(user_agent, 'WPDesktop')) {
            return 'Internet Explorer Mobile';
        } else if (_.includes(user_agent, 'SamsungBrowser/')) {
            // https://developer.samsung.com/internet/user-agent-string-format
            return 'Samsung Internet';
        } else if (_.includes(user_agent, 'Edge') || _.includes(user_agent, 'Edg/')) {
            return 'Microsoft Edge';
        } else if (_.includes(user_agent, 'FBIOS')) {
            return 'Facebook Mobile';
        } else if (_.includes(user_agent, 'Chrome')) {
            return 'Chrome';
        } else if (_.includes(user_agent, 'CriOS')) {
            return 'Chrome iOS';
        } else if (_.includes(user_agent, 'UCWEB') || _.includes(user_agent, 'UCBrowser')) {
            return 'UC Browser';
        } else if (_.includes(user_agent, 'FxiOS')) {
            return 'Firefox iOS';
        } else if (_.includes(vendor, 'Apple')) {
            if (_.includes(user_agent, 'Mobile')) {
                return 'Mobile Safari';
            }
            return 'Safari';
        } else if (_.includes(user_agent, 'Android')) {
            return 'Android Mobile';
        } else if (_.includes(user_agent, 'Konqueror')) {
            return 'Konqueror';
        } else if (_.includes(user_agent, 'Firefox')) {
            return 'Firefox';
        } else if (_.includes(user_agent, 'MSIE') || _.includes(user_agent, 'Trident/')) {
            return 'Internet Explorer';
        } else if (_.includes(user_agent, 'Gecko')) {
            return 'Mozilla';
        } else {
            return '';
        }
    },

    /**
     * This function detects which browser version is running this script,
     * parsing major and minor version (e.g., 42.1). User agent strings from:
     * http://www.useragentstring.com/pages/useragentstring.php
     */
    browserVersion: function(userAgent, vendor, opera) {
        var browser = _.info.browser(userAgent, vendor, opera);
        var versionRegexs = {
            'Internet Explorer Mobile': /rv:(\d+(\.\d+)?)/,
            'Microsoft Edge': /Edge?\/(\d+(\.\d+)?)/,
            'Chrome': /Chrome\/(\d+(\.\d+)?)/,
            'Chrome iOS': /CriOS\/(\d+(\.\d+)?)/,
            'UC Browser' : /(UCBrowser|UCWEB)\/(\d+(\.\d+)?)/,
            'Safari': /Version\/(\d+(\.\d+)?)/,
            'Mobile Safari': /Version\/(\d+(\.\d+)?)/,
            'Opera': /(Opera|OPR)\/(\d+(\.\d+)?)/,
            'Firefox': /Firefox\/(\d+(\.\d+)?)/,
            'Firefox iOS': /FxiOS\/(\d+(\.\d+)?)/,
            'Konqueror': /Konqueror:(\d+(\.\d+)?)/,
            'BlackBerry': /BlackBerry (\d+(\.\d+)?)/,
            'Android Mobile': /android\s(\d+(\.\d+)?)/,
            'Samsung Internet': /SamsungBrowser\/(\d+(\.\d+)?)/,
            'Internet Explorer': /(rv:|MSIE )(\d+(\.\d+)?)/,
            'Mozilla': /rv:(\d+(\.\d+)?)/
        };
        var regex = versionRegexs[browser];
        if (regex === undefined) {
            return null;
        }
        var matches = userAgent.match(regex);
        if (!matches) {
            return null;
        }
        return parseFloat(matches[matches.length - 2]);
    },

    os: function() {
        var a = userAgent;
        if (/Windows/i.test(a)) {
            if (/Phone/.test(a) || /WPDesktop/.test(a)) {
                return 'Windows Phone';
            }
            return 'Windows';
        } else if (/(iPhone|iPad|iPod)/.test(a)) {
            return 'iOS';
        } else if (/Android/.test(a)) {
            return 'Android';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(a)) {
            return 'BlackBerry';
        } else if (/Mac/i.test(a)) {
            return 'Mac OS X';
        } else if (/Linux/.test(a)) {
            return 'Linux';
        } else if (/CrOS/.test(a)) {
            return 'Chrome OS';
        } else {
            return '';
        }
    },

    device: function(user_agent) {
        if (/Windows Phone/i.test(user_agent) || /WPDesktop/.test(user_agent)) {
            return 'Windows Phone';
        } else if (/iPad/.test(user_agent)) {
            return 'iPad';
        } else if (/iPod/.test(user_agent)) {
            return 'iPod Touch';
        } else if (/iPhone/.test(user_agent)) {
            return 'iPhone';
        } else if (/(BlackBerry|PlayBook|BB10)/i.test(user_agent)) {
            return 'BlackBerry';
        } else if (/Android/.test(user_agent)) {
            return 'Android';
        } else {
            return '';
        }
    },

    referringDomain: function(referrer) {
        var split = referrer.split('/');
        if (split.length >= 3) {
            return split[2];
        }
        return '';
    },

    properties: function() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera),
            '$referrer': document$1.referrer,
            '$referring_domain': _.info.referringDomain(document$1.referrer),
            '$device': _.info.device(userAgent)
        }), {
            '$current_url': window$1.location.href,
            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, windowOpera),
            '$screen_height': screen.height,
            '$screen_width': screen.width,
            'mp_lib': 'web',
            '$lib_version': Config.LIB_VERSION,
            '$insert_id': cheap_guid(),
            'time': _.timestamp() / 1000 // epoch time in seconds
        });
    },

    people_properties: function() {
        return _.extend(_.strip_empty_properties({
            '$os': _.info.os(),
            '$browser': _.info.browser(userAgent, navigator$1.vendor, windowOpera)
        }), {
            '$browser_version': _.info.browserVersion(userAgent, navigator$1.vendor, windowOpera)
        });
    },

    mpPageViewProperties: function() {
        return _.strip_empty_properties({
            'current_page_title': document$1.title,
            'current_domain': window$1.location.hostname,
            'current_url_path': window$1.location.pathname,
            'current_url_protocol': window$1.location.protocol,
            'current_url_search': window$1.location.search
        });
    }
};

var cheap_guid = function(maxlen) {
    var guid = Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
    return maxlen ? guid.substring(0, maxlen) : guid;
};

// naive way to extract domain name (example.com) from full hostname (my.sub.example.com)
var SIMPLE_DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]*\.[a-z]+$/i;
// this next one attempts to account for some ccSLDs, e.g. extracting oxford.ac.uk from www.oxford.ac.uk
var DOMAIN_MATCH_REGEX = /[a-z0-9][a-z0-9-]+\.[a-z.]{2,6}$/i;
/**
 * Attempts to extract main domain name from full hostname, using a few blunt heuristics. For
 * common TLDs like .com/.org that always have a simple SLD.TLD structure (example.com), we
 * simply extract the last two .-separated parts of the hostname (SIMPLE_DOMAIN_MATCH_REGEX).
 * For others, we attempt to account for short ccSLD+TLD combos (.ac.uk) with the legacy
 * DOMAIN_MATCH_REGEX (kept to maintain backwards compatibility with existing Mixpanel
 * integrations). The only _reliable_ way to extract domain from hostname is with an up-to-date
 * list like at https://publicsuffix.org/ so for cases that this helper fails at, the SDK
 * offers the 'cookie_domain' config option to set it explicitly.
 * @example
 * extract_domain('my.sub.example.com')
 * // 'example.com'
 */
var extract_domain = function(hostname) {
    var domain_regex = DOMAIN_MATCH_REGEX;
    var parts = hostname.split('.');
    var tld = parts[parts.length - 1];
    if (tld.length > 4 || tld === 'com' || tld === 'org') {
        domain_regex = SIMPLE_DOMAIN_MATCH_REGEX;
    }
    var matches = hostname.match(domain_regex);
    return matches ? matches[0] : '';
};

var JSONStringify = null;
var JSONParse = null;
if (typeof JSON !== 'undefined') {
    JSONStringify = JSON.stringify;
    JSONParse = JSON.parse;
}
JSONStringify = JSONStringify || _.JSONEncode;
JSONParse = JSONParse || _.JSONDecode;

// EXPORTS (for closure compiler)
_['toArray']                = _.toArray;
_['isObject']               = _.isObject;
_['JSONEncode']             = _.JSONEncode;
_['JSONDecode']             = _.JSONDecode;
_['isBlockedUA']            = _.isBlockedUA;
_['isEmptyObject']          = _.isEmptyObject;
_['info']                   = _.info;
_['info']['device']         = _.info.device;
_['info']['browser']        = _.info.browser;
_['info']['browserVersion'] = _.info.browserVersion;
_['info']['properties']     = _.info.properties;

/**
 * DomTracker Object
 * @constructor
 */
var DomTracker = function() {};


// interface
DomTracker.prototype.create_properties = function() {};
DomTracker.prototype.event_handler = function() {};
DomTracker.prototype.after_track_handler = function() {};

DomTracker.prototype.init = function(mixpanel_instance) {
    this.mp = mixpanel_instance;
    return this;
};

/**
 * @param {Object|string} query
 * @param {string} event_name
 * @param {Object=} properties
 * @param {function=} user_callback
 */
DomTracker.prototype.track = function(query, event_name, properties, user_callback) {
    var that = this;
    var elements = _.dom_query(query);

    if (elements.length === 0) {
        console$1.error('The DOM query (' + query + ') returned 0 elements');
        return;
    }

    _.each(elements, function(element) {
        _.register_event(element, this.override_event, function(e) {
            var options = {};
            var props = that.create_properties(properties, this);
            var timeout = that.mp.get_config('track_links_timeout');

            that.event_handler(e, this, options);

            // in case the mixpanel servers don't get back to us in time
            window.setTimeout(that.track_callback(user_callback, props, options, true), timeout);

            // fire the tracking event
            that.mp.track(event_name, props, that.track_callback(user_callback, props, options));
        });
    }, this);

    return true;
};

/**
 * @param {function} user_callback
 * @param {Object} props
 * @param {boolean=} timeout_occured
 */
DomTracker.prototype.track_callback = function(user_callback, props, options, timeout_occured) {
    timeout_occured = timeout_occured || false;
    var that = this;

    return function() {
        // options is referenced from both callbacks, so we can have
        // a 'lock' of sorts to ensure only one fires
        if (options.callback_fired) { return; }
        options.callback_fired = true;

        if (user_callback && user_callback(timeout_occured, props) === false) {
            // user can prevent the default functionality by
            // returning false from their callback
            return;
        }

        that.after_track_handler(props, options, timeout_occured);
    };
};

DomTracker.prototype.create_properties = function(properties, element) {
    var props;

    if (typeof(properties) === 'function') {
        props = properties(element);
    } else {
        props = _.extend({}, properties);
    }

    return props;
};

/**
 * LinkTracker Object
 * @constructor
 * @extends DomTracker
 */
var LinkTracker = function() {
    this.override_event = 'click';
};
_.inherit(LinkTracker, DomTracker);

LinkTracker.prototype.create_properties = function(properties, element) {
    var props = LinkTracker.superclass.create_properties.apply(this, arguments);

    if (element.href) { props['url'] = element.href; }

    return props;
};

LinkTracker.prototype.event_handler = function(evt, element, options) {
    options.new_tab = (
        evt.which === 2 ||
        evt.metaKey ||
        evt.ctrlKey ||
        element.target === '_blank'
    );
    options.href = element.href;

    if (!options.new_tab) {
        evt.preventDefault();
    }
};

LinkTracker.prototype.after_track_handler = function(props, options) {
    if (options.new_tab) { return; }

    setTimeout(function() {
        window.location = options.href;
    }, 0);
};

/**
 * FormTracker Object
 * @constructor
 * @extends DomTracker
 */
var FormTracker = function() {
    this.override_event = 'submit';
};
_.inherit(FormTracker, DomTracker);

FormTracker.prototype.event_handler = function(evt, element, options) {
    options.element = element;
    evt.preventDefault();
};

FormTracker.prototype.after_track_handler = function(props, options) {
    setTimeout(function() {
        options.element.submit();
    }, 0);
};

// eslint-disable-line camelcase

var logger$2 = console_with_prefix('lock');

/**
 * SharedLock: a mutex built on HTML5 localStorage, to ensure that only one browser
 * window/tab at a time will be able to access shared resources.
 *
 * Based on the Alur and Taubenfeld fast lock
 * (http://www.cs.rochester.edu/research/synchronization/pseudocode/fastlock.html)
 * with an added timeout to ensure there will be eventual progress in the event
 * that a window is closed in the middle of the callback.
 *
 * Implementation based on the original version by David Wolever (https://github.com/wolever)
 * at https://gist.github.com/wolever/5fd7573d1ef6166e8f8c4af286a69432.
 *
 * @example
 * const myLock = new SharedLock('some-key');
 * myLock.withLock(function() {
 *   console.log('I hold the mutex!');
 * });
 *
 * @constructor
 */
var SharedLock = function(key, options) {
    options = options || {};

    this.storageKey = key;
    this.storage = options.storage || window.localStorage;
    this.pollIntervalMS = options.pollIntervalMS || 100;
    this.timeoutMS = options.timeoutMS || 2000;
};

// pass in a specific pid to test contention scenarios; otherwise
// it is chosen randomly for each acquisition attempt
SharedLock.prototype.withLock = function(lockedCB, errorCB, pid) {
    if (!pid && typeof errorCB !== 'function') {
        pid = errorCB;
        errorCB = null;
    }

    var i = pid || (new Date().getTime() + '|' + Math.random());
    var startTime = new Date().getTime();

    var key = this.storageKey;
    var pollIntervalMS = this.pollIntervalMS;
    var timeoutMS = this.timeoutMS;
    var storage = this.storage;

    var keyX = key + ':X';
    var keyY = key + ':Y';
    var keyZ = key + ':Z';

    var reportError = function(err) {
        errorCB && errorCB(err);
    };

    var delay = function(cb) {
        if (new Date().getTime() - startTime > timeoutMS) {
            logger$2.error('Timeout waiting for mutex on ' + key + '; clearing lock. [' + i + ']');
            storage.removeItem(keyZ);
            storage.removeItem(keyY);
            loop();
            return;
        }
        setTimeout(function() {
            try {
                cb();
            } catch(err) {
                reportError(err);
            }
        }, pollIntervalMS * (Math.random() + 0.1));
    };

    var waitFor = function(predicate, cb) {
        if (predicate()) {
            cb();
        } else {
            delay(function() {
                waitFor(predicate, cb);
            });
        }
    };

    var getSetY = function() {
        var valY = storage.getItem(keyY);
        if (valY && valY !== i) { // if Y == i then this process already has the lock (useful for test cases)
            return false;
        } else {
            storage.setItem(keyY, i);
            if (storage.getItem(keyY) === i) {
                return true;
            } else {
                if (!localStorageSupported(storage, true)) {
                    throw new Error('localStorage support dropped while acquiring lock');
                }
                return false;
            }
        }
    };

    var loop = function() {
        storage.setItem(keyX, i);

        waitFor(getSetY, function() {
            if (storage.getItem(keyX) === i) {
                criticalSection();
                return;
            }

            delay(function() {
                if (storage.getItem(keyY) !== i) {
                    loop();
                    return;
                }
                waitFor(function() {
                    return !storage.getItem(keyZ);
                }, criticalSection);
            });
        });
    };

    var criticalSection = function() {
        storage.setItem(keyZ, '1');
        try {
            lockedCB();
        } finally {
            storage.removeItem(keyZ);
            if (storage.getItem(keyY) === i) {
                storage.removeItem(keyY);
            }
            if (storage.getItem(keyX) === i) {
                storage.removeItem(keyX);
            }
        }
    };

    try {
        if (localStorageSupported(storage, true)) {
            loop();
        } else {
            throw new Error('localStorage support check failed');
        }
    } catch(err) {
        reportError(err);
    }
};

// eslint-disable-line camelcase

var logger$1 = console_with_prefix('batch');

/**
 * RequestQueue: queue for batching API requests with localStorage backup for retries.
 * Maintains an in-memory queue which represents the source of truth for the current
 * page, but also writes all items out to a copy in the browser's localStorage, which
 * can be read on subsequent pageloads and retried. For batchability, all the request
 * items in the queue should be of the same type (events, people updates, group updates)
 * so they can be sent in a single request to the same API endpoint.
 *
 * LocalStorage keying and locking: In order for reloads and subsequent pageloads of
 * the same site to access the same persisted data, they must share the same localStorage
 * key (for instance based on project token and queue type). Therefore access to the
 * localStorage entry is guarded by an asynchronous mutex (SharedLock) to prevent
 * simultaneously open windows/tabs from overwriting each other's data (which would lead
 * to data loss in some situations).
 * @constructor
 */
var RequestQueue = function(storageKey, options) {
    options = options || {};
    this.storageKey = storageKey;
    this.storage = options.storage || window.localStorage;
    this.reportError = options.errorReporter || _.bind(logger$1.error, logger$1);
    this.lock = new SharedLock(storageKey, {storage: this.storage});

    this.pid = options.pid || null; // pass pid to test out storage lock contention scenarios

    this.memQueue = [];
};

/**
 * Add one item to queues (memory and localStorage). The queued entry includes
 * the given item along with an auto-generated ID and a "flush-after" timestamp.
 * It is expected that the item will be sent over the network and dequeued
 * before the flush-after time; if this doesn't happen it is considered orphaned
 * (e.g., the original tab where it was enqueued got closed before it could be
 * sent) and the item can be sent by any tab that finds it in localStorage.
 *
 * The final callback param is called with a param indicating success or
 * failure of the enqueue operation; it is asynchronous because the localStorage
 * lock is asynchronous.
 */
RequestQueue.prototype.enqueue = function(item, flushInterval, cb) {
    var queueEntry = {
        'id': cheap_guid(),
        'flushAfter': new Date().getTime() + flushInterval * 2,
        'payload': item
    };

    this.lock.withLock(_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue.push(queueEntry);
            succeeded = this.saveToStorage(storedQueue);
            if (succeeded) {
                // only add to in-memory queue when storage succeeds
                this.memQueue.push(queueEntry);
            }
        } catch(err) {
            this.reportError('Error enqueueing item', item);
            succeeded = false;
        }
        if (cb) {
            cb(succeeded);
        }
    }, this), _.bind(function lockFailure(err) {
        this.reportError('Error acquiring storage lock', err);
        if (cb) {
            cb(false);
        }
    }, this), this.pid);
};

/**
 * Read out the given number of queue entries. If this.memQueue
 * has fewer than batchSize items, then look for "orphaned" items
 * in the persisted queue (items where the 'flushAfter' time has
 * already passed).
 */
RequestQueue.prototype.fillBatch = function(batchSize) {
    var batch = this.memQueue.slice(0, batchSize);
    if (batch.length < batchSize) {
        // don't need lock just to read events; localStorage is thread-safe
        // and the worst that could happen is a duplicate send of some
        // orphaned events, which will be deduplicated on the server side
        var storedQueue = this.readFromStorage();
        if (storedQueue.length) {
            // item IDs already in batch; don't duplicate out of storage
            var idsInBatch = {}; // poor man's Set
            _.each(batch, function(item) { idsInBatch[item['id']] = true; });

            for (var i = 0; i < storedQueue.length; i++) {
                var item = storedQueue[i];
                if (new Date().getTime() > item['flushAfter'] && !idsInBatch[item['id']]) {
                    item.orphaned = true;
                    batch.push(item);
                    if (batch.length >= batchSize) {
                        break;
                    }
                }
            }
        }
    }
    return batch;
};

/**
 * Remove items with matching 'id' from array (immutably)
 * also remove any item without a valid id (e.g., malformed
 * storage entries).
 */
var filterOutIDsAndInvalid = function(items, idSet) {
    var filteredItems = [];
    _.each(items, function(item) {
        if (item['id'] && !idSet[item['id']]) {
            filteredItems.push(item);
        }
    });
    return filteredItems;
};

/**
 * Remove items with matching IDs from both in-memory queue
 * and persisted queue
 */
RequestQueue.prototype.removeItemsByID = function(ids, cb) {
    var idSet = {}; // poor man's Set
    _.each(ids, function(id) { idSet[id] = true; });

    this.memQueue = filterOutIDsAndInvalid(this.memQueue, idSet);

    var removeFromStorage = _.bind(function() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = filterOutIDsAndInvalid(storedQueue, idSet);
            succeeded = this.saveToStorage(storedQueue);

            // an extra check: did storage report success but somehow
            // the items are still there?
            if (succeeded) {
                storedQueue = this.readFromStorage();
                for (var i = 0; i < storedQueue.length; i++) {
                    var item = storedQueue[i];
                    if (item['id'] && !!idSet[item['id']]) {
                        this.reportError('Item not removed from storage');
                        return false;
                    }
                }
            }
        } catch(err) {
            this.reportError('Error removing items', ids);
            succeeded = false;
        }
        return succeeded;
    }, this);

    this.lock.withLock(function lockAcquired() {
        var succeeded = removeFromStorage();
        if (cb) {
            cb(succeeded);
        }
    }, _.bind(function lockFailure(err) {
        var succeeded = false;
        this.reportError('Error acquiring storage lock', err);
        if (!localStorageSupported(this.storage, true)) {
            // Looks like localStorage writes have stopped working sometime after
            // initialization (probably full), and so nobody can acquire locks
            // anymore. Consider it temporarily safe to remove items without the
            // lock, since nobody's writing successfully anyway.
            succeeded = removeFromStorage();
            if (!succeeded) {
                // OK, we couldn't even write out the smaller queue. Try clearing it
                // entirely.
                try {
                    this.storage.removeItem(this.storageKey);
                } catch(err) {
                    this.reportError('Error clearing queue', err);
                }
            }
        }
        if (cb) {
            cb(succeeded);
        }
    }, this), this.pid);
};

// internal helper for RequestQueue.updatePayloads
var updatePayloads = function(existingItems, itemsToUpdate) {
    var newItems = [];
    _.each(existingItems, function(item) {
        var id = item['id'];
        if (id in itemsToUpdate) {
            var newPayload = itemsToUpdate[id];
            if (newPayload !== null) {
                item['payload'] = newPayload;
                newItems.push(item);
            }
        } else {
            // no update
            newItems.push(item);
        }
    });
    return newItems;
};

/**
 * Update payloads of given items in both in-memory queue and
 * persisted queue. Items set to null are removed from queues.
 */
RequestQueue.prototype.updatePayloads = function(itemsToUpdate, cb) {
    this.memQueue = updatePayloads(this.memQueue, itemsToUpdate);
    this.lock.withLock(_.bind(function lockAcquired() {
        var succeeded;
        try {
            var storedQueue = this.readFromStorage();
            storedQueue = updatePayloads(storedQueue, itemsToUpdate);
            succeeded = this.saveToStorage(storedQueue);
        } catch(err) {
            this.reportError('Error updating items', itemsToUpdate);
            succeeded = false;
        }
        if (cb) {
            cb(succeeded);
        }
    }, this), _.bind(function lockFailure(err) {
        this.reportError('Error acquiring storage lock', err);
        if (cb) {
            cb(false);
        }
    }, this), this.pid);
};

/**
 * Read and parse items array from localStorage entry, handling
 * malformed/missing data if necessary.
 */
RequestQueue.prototype.readFromStorage = function() {
    var storageEntry;
    try {
        storageEntry = this.storage.getItem(this.storageKey);
        if (storageEntry) {
            storageEntry = JSONParse(storageEntry);
            if (!_.isArray(storageEntry)) {
                this.reportError('Invalid storage entry:', storageEntry);
                storageEntry = null;
            }
        }
    } catch (err) {
        this.reportError('Error retrieving queue', err);
        storageEntry = null;
    }
    return storageEntry || [];
};

/**
 * Serialize the given items array to localStorage.
 */
RequestQueue.prototype.saveToStorage = function(queue) {
    try {
        this.storage.setItem(this.storageKey, JSONStringify(queue));
        return true;
    } catch (err) {
        this.reportError('Error saving queue', err);
        return false;
    }
};

/**
 * Clear out queues (memory and localStorage).
 */
RequestQueue.prototype.clear = function() {
    this.memQueue = [];
    this.storage.removeItem(this.storageKey);
};

// eslint-disable-line camelcase

// maximum interval between request retries after exponential backoff
var MAX_RETRY_INTERVAL_MS = 10 * 60 * 1000; // 10 minutes

var logger = console_with_prefix('batch');

/**
 * RequestBatcher: manages the queueing, flushing, retry etc of requests of one
 * type (events, people, groups).
 * Uses RequestQueue to manage the backing store.
 * @constructor
 */
var RequestBatcher = function(storageKey, options) {
    this.errorReporter = options.errorReporter;
    this.queue = new RequestQueue(storageKey, {
        errorReporter: _.bind(this.reportError, this),
        storage: options.storage
    });

    this.libConfig = options.libConfig;
    this.sendRequest = options.sendRequestFunc;
    this.beforeSendHook = options.beforeSendHook;
    this.stopAllBatching = options.stopAllBatchingFunc;

    // seed variable batch size + flush interval with configured values
    this.batchSize = this.libConfig['batch_size'];
    this.flushInterval = this.libConfig['batch_flush_interval_ms'];

    this.stopped = !this.libConfig['batch_autostart'];
    this.consecutiveRemovalFailures = 0;

    // extra client-side dedupe
    this.itemIdsSentSuccessfully = {};
};

/**
 * Add one item to queue.
 */
RequestBatcher.prototype.enqueue = function(item, cb) {
    this.queue.enqueue(item, this.flushInterval, cb);
};

/**
 * Start flushing batches at the configured time interval. Must call
 * this method upon SDK init in order to send anything over the network.
 */
RequestBatcher.prototype.start = function() {
    this.stopped = false;
    this.consecutiveRemovalFailures = 0;
    this.flush();
};

/**
 * Stop flushing batches. Can be restarted by calling start().
 */
RequestBatcher.prototype.stop = function() {
    this.stopped = true;
    if (this.timeoutID) {
        clearTimeout(this.timeoutID);
        this.timeoutID = null;
    }
};

/**
 * Clear out queue.
 */
RequestBatcher.prototype.clear = function() {
    this.queue.clear();
};

/**
 * Restore batch size configuration to whatever is set in the main SDK.
 */
RequestBatcher.prototype.resetBatchSize = function() {
    this.batchSize = this.libConfig['batch_size'];
};

/**
 * Restore flush interval time configuration to whatever is set in the main SDK.
 */
RequestBatcher.prototype.resetFlush = function() {
    this.scheduleFlush(this.libConfig['batch_flush_interval_ms']);
};

/**
 * Schedule the next flush in the given number of milliseconds.
 */
RequestBatcher.prototype.scheduleFlush = function(flushMS) {
    this.flushInterval = flushMS;
    if (!this.stopped) { // don't schedule anymore if batching has been stopped
        this.timeoutID = setTimeout(_.bind(this.flush, this), this.flushInterval);
    }
};

/**
 * Flush one batch to network. Depending on success/failure modes, it will either
 * remove the batch from the queue or leave it in for retry, and schedule the next
 * flush. In cases of most network or API failures, it will back off exponentially
 * when retrying.
 * @param {Object} [options]
 * @param {boolean} [options.sendBeacon] - whether to send batch with
 * navigator.sendBeacon (only useful for sending batches before page unloads, as
 * sendBeacon offers no callbacks or status indications)
 */
RequestBatcher.prototype.flush = function(options) {
    try {

        if (this.requestInProgress) {
            logger.log('Flush: Request already in progress');
            return;
        }

        options = options || {};
        var timeoutMS = this.libConfig['batch_request_timeout_ms'];
        var startTime = new Date().getTime();
        var currentBatchSize = this.batchSize;
        var batch = this.queue.fillBatch(currentBatchSize);
        var dataForRequest = [];
        var transformedItems = {};
        _.each(batch, function(item) {
            var payload = item['payload'];
            if (this.beforeSendHook && !item.orphaned) {
                payload = this.beforeSendHook(payload);
            }
            if (payload) {
                // mp_sent_by_lib_version prop captures which lib version actually
                // sends each event (regardless of which version originally queued
                // it for sending)
                if (payload['event'] && payload['properties']) {
                    payload['properties'] = _.extend(
                        {},
                        payload['properties'],
                        {'mp_sent_by_lib_version': Config.LIB_VERSION}
                    );
                }
                var addPayload = true;
                var itemId = item['id'];
                if (itemId) {
                    if ((this.itemIdsSentSuccessfully[itemId] || 0) > 5) {
                        this.reportError('[dupe] item ID sent too many times, not sending', {
                            item: item,
                            batchSize: batch.length,
                            timesSent: this.itemIdsSentSuccessfully[itemId]
                        });
                        addPayload = false;
                    }
                } else {
                    this.reportError('[dupe] found item with no ID', {item: item});
                }

                if (addPayload) {
                    dataForRequest.push(payload);
                }
            }
            transformedItems[item['id']] = payload;
        }, this);
        if (dataForRequest.length < 1) {
            this.resetFlush();
            return; // nothing to do
        }

        this.requestInProgress = true;

        var batchSendCallback = _.bind(function(res) {
            this.requestInProgress = false;

            try {

                // handle API response in a try-catch to make sure we can reset the
                // flush operation if something goes wrong

                var removeItemsFromQueue = false;
                if (options.unloading) {
                    // update persisted data to include hook transformations
                    this.queue.updatePayloads(transformedItems);
                } else if (
                    _.isObject(res) &&
                    res.error === 'timeout' &&
                    new Date().getTime() - startTime >= timeoutMS
                ) {
                    this.reportError('Network timeout; retrying');
                    this.flush();
                } else if (
                    _.isObject(res) &&
                    res.xhr_req &&
                    (res.xhr_req['status'] >= 500 || res.xhr_req['status'] === 429 || res.error === 'timeout')
                ) {
                    // network or API error, or 429 Too Many Requests, retry
                    var retryMS = this.flushInterval * 2;
                    var headers = res.xhr_req['responseHeaders'];
                    if (headers) {
                        var retryAfter = headers['Retry-After'];
                        if (retryAfter) {
                            retryMS = (parseInt(retryAfter, 10) * 1000) || retryMS;
                        }
                    }
                    retryMS = Math.min(MAX_RETRY_INTERVAL_MS, retryMS);
                    this.reportError('Error; retry in ' + retryMS + ' ms');
                    this.scheduleFlush(retryMS);
                } else if (_.isObject(res) && res.xhr_req && res.xhr_req['status'] === 413) {
                    // 413 Payload Too Large
                    if (batch.length > 1) {
                        var halvedBatchSize = Math.max(1, Math.floor(currentBatchSize / 2));
                        this.batchSize = Math.min(this.batchSize, halvedBatchSize, batch.length - 1);
                        this.reportError('413 response; reducing batch size to ' + this.batchSize);
                        this.resetFlush();
                    } else {
                        this.reportError('Single-event request too large; dropping', batch);
                        this.resetBatchSize();
                        removeItemsFromQueue = true;
                    }
                } else {
                    // successful network request+response; remove each item in batch from queue
                    // (even if it was e.g. a 400, in which case retrying won't help)
                    removeItemsFromQueue = true;
                }

                if (removeItemsFromQueue) {
                    this.queue.removeItemsByID(
                        _.map(batch, function(item) { return item['id']; }),
                        _.bind(function(succeeded) {
                            if (succeeded) {
                                this.consecutiveRemovalFailures = 0;
                                this.flush(); // handle next batch if the queue isn't empty
                            } else {
                                this.reportError('Failed to remove items from queue');
                                if (++this.consecutiveRemovalFailures > 5) {
                                    this.reportError('Too many queue failures; disabling batching system.');
                                    this.stopAllBatching();
                                } else {
                                    this.resetFlush();
                                }
                            }
                        }, this)
                    );

                    // client-side dedupe
                    _.each(batch, _.bind(function(item) {
                        var itemId = item['id'];
                        if (itemId) {
                            this.itemIdsSentSuccessfully[itemId] = this.itemIdsSentSuccessfully[itemId] || 0;
                            this.itemIdsSentSuccessfully[itemId]++;
                            if (this.itemIdsSentSuccessfully[itemId] > 5) {
                                this.reportError('[dupe] item ID sent too many times', {
                                    item: item,
                                    batchSize: batch.length,
                                    timesSent: this.itemIdsSentSuccessfully[itemId]
                                });
                            }
                        } else {
                            this.reportError('[dupe] found item with no ID while removing', {item: item});
                        }
                    }, this));
                }

            } catch(err) {
                this.reportError('Error handling API response', err);
                this.resetFlush();
            }
        }, this);
        var requestOptions = {
            method: 'POST',
            verbose: true,
            ignore_json_errors: true, // eslint-disable-line camelcase
            timeout_ms: timeoutMS // eslint-disable-line camelcase
        };
        if (options.unloading) {
            requestOptions.transport = 'sendBeacon';
        }
        logger.log('MIXPANEL REQUEST:', dataForRequest);
        this.sendRequest(dataForRequest, requestOptions, batchSendCallback);

    } catch(err) {
        this.reportError('Error flushing request queue', err);
        this.resetFlush();
    }
};

/**
 * Log error to global logger and optional user-defined logger.
 */
RequestBatcher.prototype.reportError = function(msg, err) {
    logger.error.apply(logger.error, arguments);
    if (this.errorReporter) {
        try {
            if (!(err instanceof Error)) {
                err = new Error(msg);
            }
            this.errorReporter(msg, err);
        } catch(err) {
            logger.error(err);
        }
    }
};

/**
 * A function used to track a Mixpanel event (e.g. MixpanelLib.track)
 * @callback trackFunction
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 */

/** Public **/

var GDPR_DEFAULT_PERSISTENCE_PREFIX = '__mp_opt_in_out_';

/**
 * Opt the user in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function optIn(token, options) {
    _optInOut(true, token, options);
}

/**
 * Opt the user out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-out cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-out cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-out cookie is set as secure or not
 */
function optOut(token, options) {
    _optInOut(false, token, options);
}

/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} whether the user has opted in to the given opt type
 */
function hasOptedIn(token, options) {
    return _getStorageValue(token, options) === '1';
}

/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the user has opted out of the given opt type
 */
function hasOptedOut(token, options) {
    if (_hasDoNotTrackFlagOn(options)) {
        console$1.warn('This browser has "Do Not Track" enabled. This will prevent the Mixpanel SDK from sending any data. To ignore the "Do Not Track" browser setting, initialize the Mixpanel instance with the config "ignore_dnt: true"');
        return true;
    }
    var optedOut = _getStorageValue(token, options) === '0';
    if (optedOut) {
        console$1.warn('You are opted out of Mixpanel tracking. This will prevent the Mixpanel SDK from sending any data.');
    }
    return optedOut;
}

/**
 * Wrap a MixpanelLib method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelLib(method) {
    return _addOptOutCheck(method, function(name) {
        return this.get_config(name);
    });
}

/**
 * Wrap a MixpanelPeople method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelPeople(method) {
    return _addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}

/**
 * Wrap a MixpanelGroup method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function addOptOutCheckMixpanelGroup(method) {
    return _addOptOutCheck(method, function(name) {
        return this._get_config(name);
    });
}

/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for the given token
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistenceType] Persistence mechanism used - cookie or localStorage
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function clearOptInOut(token, options) {
    options = options || {};
    _getStorage(options).remove(
        _getStorageKey(token, options), !!options.crossSubdomainCookie, options.cookieDomain
    );
}

/** Private **/

/**
 * Get storage util
 * @param {Object} [options]
 * @param {string} [options.persistenceType]
 * @returns {object} either _.cookie or _.localstorage
 */
function _getStorage(options) {
    options = options || {};
    return options.persistenceType === 'localStorage' ? _.localStorage : _.cookie;
}

/**
 * Get the name of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the name of the cookie for the given opt type
 */
function _getStorageKey(token, options) {
    options = options || {};
    return (options.persistencePrefix || GDPR_DEFAULT_PERSISTENCE_PREFIX) + token;
}

/**
 * Get the value of the cookie that is used for the given opt type (tracking, cookie, etc.)
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @returns {string} the value of the cookie for the given opt type
 */
function _getStorageValue(token, options) {
    return _getStorage(options).get(_getStorageKey(token, options));
}

/**
 * Check whether the user has set the DNT/doNotTrack setting to true in their browser
 * @param {Object} [options]
 * @param {string} [options.window] - alternate window object to check; used to force various DNT settings in browser tests
 * @param {boolean} [options.ignoreDnt] - flag to ignore browser DNT settings and always return false
 * @returns {boolean} whether the DNT setting is true
 */
function _hasDoNotTrackFlagOn(options) {
    if (options && options.ignoreDnt) {
        return false;
    }
    var win = (options && options.window) || window$1;
    var nav = win['navigator'] || {};
    var hasDntOn = false;

    _.each([
        nav['doNotTrack'], // standard
        nav['msDoNotTrack'],
        win['doNotTrack']
    ], function(dntValue) {
        if (_.includes([true, 1, '1', 'yes'], dntValue)) {
            hasDntOn = true;
        }
    });

    return hasDntOn;
}

/**
 * Set cookie/localstorage for the user indicating that they are opted in or out for the given opt type
 * @param {boolean} optValue - whether to opt the user in or out for the given opt type
 * @param {string} token - Mixpanel project tracking token
 * @param {Object} [options]
 * @param {trackFunction} [options.track] - function used for tracking a Mixpanel event to record the opt-in action
 * @param {string} [options.trackEventName] - event name to be used for tracking the opt-in action
 * @param {Object} [options.trackProperties] - set of properties to be tracked along with the opt-in action
 * @param {string} [options.persistencePrefix=__mp_opt_in_out] - custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookieExpiration] - number of days until the opt-in cookie expires
 * @param {string} [options.cookieDomain] - custom cookie domain
 * @param {boolean} [options.crossSiteCookie] - whether the opt-in cookie is set as cross-site-enabled
 * @param {boolean} [options.crossSubdomainCookie] - whether the opt-in cookie is set as cross-subdomain or not
 * @param {boolean} [options.secureCookie] - whether the opt-in cookie is set as secure or not
 */
function _optInOut(optValue, token, options) {
    if (!_.isString(token) || !token.length) {
        console$1.error('gdpr.' + (optValue ? 'optIn' : 'optOut') + ' called with an invalid token');
        return;
    }

    options = options || {};

    _getStorage(options).set(
        _getStorageKey(token, options),
        optValue ? 1 : 0,
        _.isNumber(options.cookieExpiration) ? options.cookieExpiration : null,
        !!options.crossSubdomainCookie,
        !!options.secureCookie,
        !!options.crossSiteCookie,
        options.cookieDomain
    );

    if (options.track && optValue) { // only track event if opting in (optValue=true)
        options.track(options.trackEventName || '$opt_in', options.trackProperties, {
            'send_immediately': true
        });
    }
}

/**
 * Wrap a method with a check for whether the user is opted out of data tracking and cookies/localstorage for the given token
 * If the user has opted out, return early instead of executing the method.
 * If a callback argument was provided, execute it passing the 0 error code.
 * @param {function} method - wrapped method to be executed if the user has not opted out
 * @param {function} getConfigValue - getter function for the Mixpanel API token and other options to be used with opt-out check
 * @returns {*} the result of executing method OR undefined if the user has opted out
 */
function _addOptOutCheck(method, getConfigValue) {
    return function() {
        var optedOut = false;

        try {
            var token = getConfigValue.call(this, 'token');
            var ignoreDnt = getConfigValue.call(this, 'ignore_dnt');
            var persistenceType = getConfigValue.call(this, 'opt_out_tracking_persistence_type');
            var persistencePrefix = getConfigValue.call(this, 'opt_out_tracking_cookie_prefix');
            var win = getConfigValue.call(this, 'window'); // used to override window during browser tests

            if (token) { // if there was an issue getting the token, continue method execution as normal
                optedOut = hasOptedOut(token, {
                    ignoreDnt: ignoreDnt,
                    persistenceType: persistenceType,
                    persistencePrefix: persistencePrefix,
                    window: win
                });
            }
        } catch(err) {
            console$1.error('Unexpected error when checking tracking opt-out status: ' + err);
        }

        if (!optedOut) {
            return method.apply(this, arguments);
        }

        var callback = arguments[arguments.length - 1];
        if (typeof(callback) === 'function') {
            callback(0);
        }

        return;
    };
}

/** @const */ var SET_ACTION      = '$set';
/** @const */ var SET_ONCE_ACTION = '$set_once';
/** @const */ var UNSET_ACTION    = '$unset';
/** @const */ var ADD_ACTION      = '$add';
/** @const */ var APPEND_ACTION   = '$append';
/** @const */ var UNION_ACTION    = '$union';
/** @const */ var REMOVE_ACTION   = '$remove';
/** @const */ var DELETE_ACTION   = '$delete';

// Common internal methods for mixpanel.people and mixpanel.group APIs.
// These methods shouldn't involve network I/O.
var apiActions = {
    set_action: function(prop, to) {
        var data = {};
        var $set = {};
        if (_.isObject(prop)) {
            _.each(prop, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $set[k] = v;
                }
            }, this);
        } else {
            $set[prop] = to;
        }

        data[SET_ACTION] = $set;
        return data;
    },

    unset_action: function(prop) {
        var data = {};
        var $unset = [];
        if (!_.isArray(prop)) {
            prop = [prop];
        }

        _.each(prop, function(k) {
            if (!this._is_reserved_property(k)) {
                $unset.push(k);
            }
        }, this);

        data[UNSET_ACTION] = $unset;
        return data;
    },

    set_once_action: function(prop, to) {
        var data = {};
        var $set_once = {};
        if (_.isObject(prop)) {
            _.each(prop, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $set_once[k] = v;
                }
            }, this);
        } else {
            $set_once[prop] = to;
        }
        data[SET_ONCE_ACTION] = $set_once;
        return data;
    },

    union_action: function(list_name, values) {
        var data = {};
        var $union = {};
        if (_.isObject(list_name)) {
            _.each(list_name, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $union[k] = _.isArray(v) ? v : [v];
                }
            }, this);
        } else {
            $union[list_name] = _.isArray(values) ? values : [values];
        }
        data[UNION_ACTION] = $union;
        return data;
    },

    append_action: function(list_name, value) {
        var data = {};
        var $append = {};
        if (_.isObject(list_name)) {
            _.each(list_name, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $append[k] = v;
                }
            }, this);
        } else {
            $append[list_name] = value;
        }
        data[APPEND_ACTION] = $append;
        return data;
    },

    remove_action: function(list_name, value) {
        var data = {};
        var $remove = {};
        if (_.isObject(list_name)) {
            _.each(list_name, function(v, k) {
                if (!this._is_reserved_property(k)) {
                    $remove[k] = v;
                }
            }, this);
        } else {
            $remove[list_name] = value;
        }
        data[REMOVE_ACTION] = $remove;
        return data;
    },

    delete_action: function() {
        var data = {};
        data[DELETE_ACTION] = '';
        return data;
    }
};

/**
 * Mixpanel Group Object
 * @constructor
 */
var MixpanelGroup = function() {};

_.extend(MixpanelGroup.prototype, apiActions);

MixpanelGroup.prototype._init = function(mixpanel_instance, group_key, group_id) {
    this._mixpanel = mixpanel_instance;
    this._group_key = group_key;
    this._group_id = group_id;
};

/**
 * Set properties on a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, dates, or lists
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.set = addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    return this._send_request(data, callback);
});

/**
 * Set properties on a group, only if they do not yet exist.
 * This will not overwrite previous group property values, unlike
 * group.set().
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').set_once('Location', '405 Howard');
 *
 *     // or set multiple properties at once
 *     mixpanel.get_group('company', 'mixpanel').set_once({
 *          'Location': '405 Howard',
 *          'Founded' : 2009,
 *     });
 *     // properties can be strings, integers, lists or dates
 *
 * @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
 * @param {*} [to] A value to set on the given property name
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.set_once = addOptOutCheckMixpanelGroup(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    return this._send_request(data, callback);
});

/**
 * Unset properties on a group permanently.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').unset('Founded');
 *
 * @param {String} prop The name of the property.
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.unset = addOptOutCheckMixpanelGroup(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});

/**
 * Merge a given list with a list-valued group property, excluding duplicate values.
 *
 * ### Usage:
 *
 *     // merge a value to a list, creating it if needed
 *     mixpanel.get_group('company', 'mixpanel').union('Location', ['San Francisco', 'London']);
 *
 * @param {String} list_name Name of the property.
 * @param {Array} values Values to merge with the given property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.union = addOptOutCheckMixpanelGroup(function(list_name, values, callback) {
    if (_.isObject(list_name)) {
        callback = values;
    }
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});

/**
 * Permanently delete a group.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').delete();
 *
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype['delete'] = addOptOutCheckMixpanelGroup(function(callback) {
    // bracket notation above prevents a minification error related to reserved words
    var data = this.delete_action();
    return this._send_request(data, callback);
});

/**
 * Remove a property from a group. The value will be ignored if doesn't exist.
 *
 * ### Usage:
 *
 *     mixpanel.get_group('company', 'mixpanel').remove('Location', 'London');
 *
 * @param {String} list_name Name of the property.
 * @param {Object} value Value to remove from the given group property
 * @param {Function} [callback] If provided, the callback will be called after the tracking event
 */
MixpanelGroup.prototype.remove = addOptOutCheckMixpanelGroup(function(list_name, value, callback) {
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});

MixpanelGroup.prototype._send_request = function(data, callback) {
    data['$group_key'] = this._group_key;
    data['$group_id'] = this._group_id;
    data['$token'] = this._get_config('token');

    var date_encoded_data = _.encodeDates(data);
    return this._mixpanel._track_or_batch({
        type: 'groups',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' +  this._get_config('api_routes')['groups'],
        batcher: this._mixpanel.request_batchers.groups
    }, callback);
};

MixpanelGroup.prototype._is_reserved_property = function(prop) {
    return prop === '$group_key' || prop === '$group_id';
};

MixpanelGroup.prototype._get_config = function(conf) {
    return this._mixpanel.get_config(conf);
};

MixpanelGroup.prototype.toString = function() {
    return this._mixpanel.toString() + '.group.' + this._group_key + '.' + this._group_id;
};

// MixpanelGroup Exports
MixpanelGroup.prototype['remove']   = MixpanelGroup.prototype.remove;
MixpanelGroup.prototype['set']      = MixpanelGroup.prototype.set;
MixpanelGroup.prototype['set_once'] = MixpanelGroup.prototype.set_once;
MixpanelGroup.prototype['union']    = MixpanelGroup.prototype.union;
MixpanelGroup.prototype['unset']    = MixpanelGroup.prototype.unset;
MixpanelGroup.prototype['toString'] = MixpanelGroup.prototype.toString;

/**
 * Mixpanel People Object
 * @constructor
 */
var MixpanelPeople = function() {};

_.extend(MixpanelPeople.prototype, apiActions);

MixpanelPeople.prototype._init = function(mixpanel_instance) {
    this._mixpanel = mixpanel_instance;
};

/*
* Set properties on a user record.
*
* ### Usage:
*
*     mixpanel.people.set('gender', 'm');
*
*     // or set multiple properties at once
*     mixpanel.people.set({
*         'Company': 'Acme',
*         'Plan': 'Premium',
*         'Upgrade date': new Date()
*     });
*     // properties can be strings, integers, dates, or lists
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.set = addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    // make sure that the referrer info has been updated and saved
    if (this._get_config('save_referrer')) {
        this._mixpanel['persistence'].update_referrer_info(document.referrer);
    }

    // update $set object with default people properties
    data[SET_ACTION] = _.extend(
        {},
        _.info.people_properties(),
        this._mixpanel['persistence'].get_referrer_info(),
        data[SET_ACTION]
    );
    return this._send_request(data, callback);
});

/*
* Set properties on a user record, only if they do not yet exist.
* This will not overwrite previous people property values, unlike
* people.set().
*
* ### Usage:
*
*     mixpanel.people.set_once('First Login Date', new Date());
*
*     // or set multiple properties at once
*     mixpanel.people.set_once({
*         'First Login Date': new Date(),
*         'Starting Plan': 'Premium'
*     });
*
*     // properties can be strings, integers or dates
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [to] A value to set on the given property name
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.set_once = addOptOutCheckMixpanelPeople(function(prop, to, callback) {
    var data = this.set_once_action(prop, to);
    if (_.isObject(prop)) {
        callback = to;
    }
    return this._send_request(data, callback);
});

/*
* Unset properties on a user record (permanently removes the properties and their values from a profile).
*
* ### Usage:
*
*     mixpanel.people.unset('gender');
*
*     // or unset multiple properties at once
*     mixpanel.people.unset(['gender', 'Company']);
*
* @param {Array|String} prop If a string, this is the name of the property. If an array, this is a list of property names.
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.unset = addOptOutCheckMixpanelPeople(function(prop, callback) {
    var data = this.unset_action(prop);
    return this._send_request(data, callback);
});

/*
* Increment/decrement numeric people analytics properties.
*
* ### Usage:
*
*     mixpanel.people.increment('page_views', 1);
*
*     // or, for convenience, if you're just incrementing a counter by
*     // 1, you can simply do
*     mixpanel.people.increment('page_views');
*
*     // to decrement a counter, pass a negative number
*     mixpanel.people.increment('credits_left', -1);
*
*     // like mixpanel.people.set(), you can increment multiple
*     // properties at once:
*     mixpanel.people.increment({
*         counter1: 1,
*         counter2: 6
*     });
*
* @param {Object|String} prop If a string, this is the name of the property. If an object, this is an associative array of names and numeric values.
* @param {Number} [by] An amount to increment the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.increment = addOptOutCheckMixpanelPeople(function(prop, by, callback) {
    var data = {};
    var $add = {};
    if (_.isObject(prop)) {
        _.each(prop, function(v, k) {
            if (!this._is_reserved_property(k)) {
                if (isNaN(parseFloat(v))) {
                    console$1.error('Invalid increment value passed to mixpanel.people.increment - must be a number');
                    return;
                } else {
                    $add[k] = v;
                }
            }
        }, this);
        callback = by;
    } else {
        // convenience: mixpanel.people.increment('property'); will
        // increment 'property' by 1
        if (_.isUndefined(by)) {
            by = 1;
        }
        $add[prop] = by;
    }
    data[ADD_ACTION] = $add;

    return this._send_request(data, callback);
});

/*
* Append a value to a list-valued people analytics property.
*
* ### Usage:
*
*     // append a value to a list, creating it if needed
*     mixpanel.people.append('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.append({
*         list1: 'bob',
*         list2: 123
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value An item to append to the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.append = addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if (_.isObject(list_name)) {
        callback = value;
    }
    var data = this.append_action(list_name, value);
    return this._send_request(data, callback);
});

/*
* Remove a value from a list-valued people analytics property.
*
* ### Usage:
*
*     mixpanel.people.remove('School', 'UCB');
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] value Item to remove from the list
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.remove = addOptOutCheckMixpanelPeople(function(list_name, value, callback) {
    if (_.isObject(list_name)) {
        callback = value;
    }
    var data = this.remove_action(list_name, value);
    return this._send_request(data, callback);
});

/*
* Merge a given list with a list-valued people analytics property,
* excluding duplicate values.
*
* ### Usage:
*
*     // merge a value to a list, creating it if needed
*     mixpanel.people.union('pages_visited', 'homepage');
*
*     // like mixpanel.people.set(), you can append multiple
*     // properties at once:
*     mixpanel.people.union({
*         list1: 'bob',
*         list2: 123
*     });
*
*     // like mixpanel.people.append(), you can append multiple
*     // values to the same list:
*     mixpanel.people.union({
*         list1: ['bob', 'billy']
*     });
*
* @param {Object|String} list_name If a string, this is the name of the property. If an object, this is an associative array of names and values.
* @param {*} [value] Value / values to merge with the given property
* @param {Function} [callback] If provided, the callback will be called after tracking the event.
*/
MixpanelPeople.prototype.union = addOptOutCheckMixpanelPeople(function(list_name, values, callback) {
    if (_.isObject(list_name)) {
        callback = values;
    }
    var data = this.union_action(list_name, values);
    return this._send_request(data, callback);
});

/*
 * Record that you have charged the current user a certain amount
 * of money. Charges recorded with track_charge() will appear in the
 * Mixpanel revenue report.
 *
 * ### Usage:
 *
 *     // charge a user $50
 *     mixpanel.people.track_charge(50);
 *
 *     // charge a user $30.50 on the 2nd of january
 *     mixpanel.people.track_charge(30.50, {
 *         '$time': new Date('jan 1 2012')
 *     });
 *
 * @param {Number} amount The amount of money charged to the current user
 * @param {Object} [properties] An associative array of properties associated with the charge
 * @param {Function} [callback] If provided, the callback will be called when the server responds
 * @deprecated
 */
MixpanelPeople.prototype.track_charge = addOptOutCheckMixpanelPeople(function(amount, properties, callback) {
    if (!_.isNumber(amount)) {
        amount = parseFloat(amount);
        if (isNaN(amount)) {
            console$1.error('Invalid value passed to mixpanel.people.track_charge - must be a number');
            return;
        }
    }

    return this.append('$transactions', _.extend({
        '$amount': amount
    }, properties), callback);
});

/*
 * Permanently clear all revenue report transactions from the
 * current user's people analytics profile.
 *
 * ### Usage:
 *
 *     mixpanel.people.clear_charges();
 *
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 * @deprecated
 */
MixpanelPeople.prototype.clear_charges = function(callback) {
    return this.set('$transactions', [], callback);
};

/*
* Permanently deletes the current people analytics profile from
* Mixpanel (using the current distinct_id).
*
* ### Usage:
*
*     // remove the all data you have stored about the current user
*     mixpanel.people.delete_user();
*
*/
MixpanelPeople.prototype.delete_user = function() {
    if (!this._identify_called()) {
        console$1.error('mixpanel.people.delete_user() requires you to call identify() first');
        return;
    }
    var data = {'$delete': this._mixpanel.get_distinct_id()};
    return this._send_request(data);
};

MixpanelPeople.prototype.toString = function() {
    return this._mixpanel.toString() + '.people';
};

MixpanelPeople.prototype._send_request = function(data, callback) {
    data['$token'] = this._get_config('token');
    data['$distinct_id'] = this._mixpanel.get_distinct_id();
    var device_id = this._mixpanel.get_property('$device_id');
    var user_id = this._mixpanel.get_property('$user_id');
    var had_persisted_distinct_id = this._mixpanel.get_property('$had_persisted_distinct_id');
    if (device_id) {
        data['$device_id'] = device_id;
    }
    if (user_id) {
        data['$user_id'] = user_id;
    }
    if (had_persisted_distinct_id) {
        data['$had_persisted_distinct_id'] = had_persisted_distinct_id;
    }

    var date_encoded_data = _.encodeDates(data);

    if (!this._identify_called()) {
        this._enqueue(data);
        if (!_.isUndefined(callback)) {
            if (this._get_config('verbose')) {
                callback({status: -1, error: null});
            } else {
                callback(-1);
            }
        }
        return _.truncate(date_encoded_data, 255);
    }

    return this._mixpanel._track_or_batch({
        type: 'people',
        data: date_encoded_data,
        endpoint: this._get_config('api_host') + '/' +  this._get_config('api_routes')['engage'],
        batcher: this._mixpanel.request_batchers.people
    }, callback);
};

MixpanelPeople.prototype._get_config = function(conf_var) {
    return this._mixpanel.get_config(conf_var);
};

MixpanelPeople.prototype._identify_called = function() {
    return this._mixpanel._flags.identify_called === true;
};

// Queue up engage operations if identify hasn't been called yet.
MixpanelPeople.prototype._enqueue = function(data) {
    if (SET_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(SET_ACTION, data);
    } else if (SET_ONCE_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(SET_ONCE_ACTION, data);
    } else if (UNSET_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(UNSET_ACTION, data);
    } else if (ADD_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(ADD_ACTION, data);
    } else if (APPEND_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, data);
    } else if (REMOVE_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(REMOVE_ACTION, data);
    } else if (UNION_ACTION in data) {
        this._mixpanel['persistence']._add_to_people_queue(UNION_ACTION, data);
    } else {
        console$1.error('Invalid call to _enqueue():', data);
    }
};

MixpanelPeople.prototype._flush_one_queue = function(action, action_method, callback, queue_to_params_fn) {
    var _this = this;
    var queued_data = _.extend({}, this._mixpanel['persistence'].load_queue(action));
    var action_params = queued_data;

    if (!_.isUndefined(queued_data) && _.isObject(queued_data) && !_.isEmptyObject(queued_data)) {
        _this._mixpanel['persistence']._pop_from_people_queue(action, queued_data);
        _this._mixpanel['persistence'].save();
        if (queue_to_params_fn) {
            action_params = queue_to_params_fn(queued_data);
        }
        action_method.call(_this, action_params, function(response, data) {
            // on bad response, we want to add it back to the queue
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(action, queued_data);
            }
            if (!_.isUndefined(callback)) {
                callback(response, data);
            }
        });
    }
};

// Flush queued engage operations - order does not matter,
// and there are network level race conditions anyway
MixpanelPeople.prototype._flush = function(
    _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback
) {
    var _this = this;

    this._flush_one_queue(SET_ACTION, this.set, _set_callback);
    this._flush_one_queue(SET_ONCE_ACTION, this.set_once, _set_once_callback);
    this._flush_one_queue(UNSET_ACTION, this.unset, _unset_callback, function(queue) { return _.keys(queue); });
    this._flush_one_queue(ADD_ACTION, this.increment, _add_callback);
    this._flush_one_queue(UNION_ACTION, this.union, _union_callback);

    // we have to fire off each $append individually since there is
    // no concat method server side
    var $append_queue = this._mixpanel['persistence'].load_queue(APPEND_ACTION);
    if (!_.isUndefined($append_queue) && _.isArray($append_queue) && $append_queue.length) {
        var $append_item;
        var append_callback = function(response, data) {
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(APPEND_ACTION, $append_item);
            }
            if (!_.isUndefined(_append_callback)) {
                _append_callback(response, data);
            }
        };
        for (var i = $append_queue.length - 1; i >= 0; i--) {
            $append_queue = this._mixpanel['persistence'].load_queue(APPEND_ACTION);
            $append_item = $append_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!_.isEmptyObject($append_item)) {
                _this.append($append_item, append_callback);
            }
        }
    }

    // same for $remove
    var $remove_queue = this._mixpanel['persistence'].load_queue(REMOVE_ACTION);
    if (!_.isUndefined($remove_queue) && _.isArray($remove_queue) && $remove_queue.length) {
        var $remove_item;
        var remove_callback = function(response, data) {
            if (response === 0) {
                _this._mixpanel['persistence']._add_to_people_queue(REMOVE_ACTION, $remove_item);
            }
            if (!_.isUndefined(_remove_callback)) {
                _remove_callback(response, data);
            }
        };
        for (var j = $remove_queue.length - 1; j >= 0; j--) {
            $remove_queue = this._mixpanel['persistence'].load_queue(REMOVE_ACTION);
            $remove_item = $remove_queue.pop();
            _this._mixpanel['persistence'].save();
            if (!_.isEmptyObject($remove_item)) {
                _this.remove($remove_item, remove_callback);
            }
        }
    }
};

MixpanelPeople.prototype._is_reserved_property = function(prop) {
    return prop === '$distinct_id' || prop === '$token' || prop === '$device_id' || prop === '$user_id' || prop === '$had_persisted_distinct_id';
};

// MixpanelPeople Exports
MixpanelPeople.prototype['set']           = MixpanelPeople.prototype.set;
MixpanelPeople.prototype['set_once']      = MixpanelPeople.prototype.set_once;
MixpanelPeople.prototype['unset']         = MixpanelPeople.prototype.unset;
MixpanelPeople.prototype['increment']     = MixpanelPeople.prototype.increment;
MixpanelPeople.prototype['append']        = MixpanelPeople.prototype.append;
MixpanelPeople.prototype['remove']        = MixpanelPeople.prototype.remove;
MixpanelPeople.prototype['union']         = MixpanelPeople.prototype.union;
MixpanelPeople.prototype['track_charge']  = MixpanelPeople.prototype.track_charge;
MixpanelPeople.prototype['clear_charges'] = MixpanelPeople.prototype.clear_charges;
MixpanelPeople.prototype['delete_user']   = MixpanelPeople.prototype.delete_user;
MixpanelPeople.prototype['toString']      = MixpanelPeople.prototype.toString;

/*
 * Constants
 */
/** @const */ var SET_QUEUE_KEY          = '__mps';
/** @const */ var SET_ONCE_QUEUE_KEY     = '__mpso';
/** @const */ var UNSET_QUEUE_KEY        = '__mpus';
/** @const */ var ADD_QUEUE_KEY          = '__mpa';
/** @const */ var APPEND_QUEUE_KEY       = '__mpap';
/** @const */ var REMOVE_QUEUE_KEY       = '__mpr';
/** @const */ var UNION_QUEUE_KEY        = '__mpu';
// This key is deprecated, but we want to check for it to see whether aliasing is allowed.
/** @const */ var PEOPLE_DISTINCT_ID_KEY = '$people_distinct_id';
/** @const */ var ALIAS_ID_KEY           = '__alias';
/** @const */ var EVENT_TIMERS_KEY       = '__timers';
/** @const */ var RESERVED_PROPERTIES = [
    SET_QUEUE_KEY,
    SET_ONCE_QUEUE_KEY,
    UNSET_QUEUE_KEY,
    ADD_QUEUE_KEY,
    APPEND_QUEUE_KEY,
    REMOVE_QUEUE_KEY,
    UNION_QUEUE_KEY,
    PEOPLE_DISTINCT_ID_KEY,
    ALIAS_ID_KEY,
    EVENT_TIMERS_KEY
];

/**
 * Mixpanel Persistence Object
 * @constructor
 */
var MixpanelPersistence = function(config) {
    this['props'] = {};
    this.campaign_params_saved = false;

    if (config['persistence_name']) {
        this.name = 'mp_' + config['persistence_name'];
    } else {
        this.name = 'mp_' + config['token'] + '_mixpanel';
    }

    var storage_type = config['persistence'];
    if (storage_type !== 'cookie' && storage_type !== 'localStorage') {
        console$1.critical('Unknown persistence type ' + storage_type + '; falling back to cookie');
        storage_type = config['persistence'] = 'cookie';
    }

    if (storage_type === 'localStorage' && _.localStorage.is_supported()) {
        this.storage = _.localStorage;
    } else {
        this.storage = _.cookie;
    }

    this.load();
    this.update_config(config);
    this.upgrade(config);
    this.save();
};

MixpanelPersistence.prototype.properties = function() {
    var p = {};

    this.load();

    // Filter out reserved properties
    _.each(this['props'], function(v, k) {
        if (!_.include(RESERVED_PROPERTIES, k)) {
            p[k] = v;
        }
    });
    return p;
};

MixpanelPersistence.prototype.load = function() {
    if (this.disabled) { return; }

    var entry = this.storage.parse(this.name);

    if (entry) {
        this['props'] = _.extend({}, entry);
    }
};

MixpanelPersistence.prototype.upgrade = function(config) {
    var upgrade_from_old_lib = config['upgrade'],
        old_cookie_name,
        old_cookie;

    if (upgrade_from_old_lib) {
        old_cookie_name = 'mp_super_properties';
        // Case where they had a custom cookie name before.
        if (typeof(upgrade_from_old_lib) === 'string') {
            old_cookie_name = upgrade_from_old_lib;
        }

        old_cookie = this.storage.parse(old_cookie_name);

        // remove the cookie
        this.storage.remove(old_cookie_name);
        this.storage.remove(old_cookie_name, true);

        if (old_cookie) {
            this['props'] = _.extend(
                this['props'],
                old_cookie['all'],
                old_cookie['events']
            );
        }
    }

    if (!config['cookie_name'] && config['name'] !== 'mixpanel') {
        // special case to handle people with cookies of the form
        // mp_TOKEN_INSTANCENAME from the first release of this library
        old_cookie_name = 'mp_' + config['token'] + '_' + config['name'];
        old_cookie = this.storage.parse(old_cookie_name);

        if (old_cookie) {
            this.storage.remove(old_cookie_name);
            this.storage.remove(old_cookie_name, true);

            // Save the prop values that were in the cookie from before -
            // this should only happen once as we delete the old one.
            this.register_once(old_cookie);
        }
    }

    if (this.storage === _.localStorage) {
        old_cookie = _.cookie.parse(this.name);

        _.cookie.remove(this.name);
        _.cookie.remove(this.name, true);

        if (old_cookie) {
            this.register_once(old_cookie);
        }
    }
};

MixpanelPersistence.prototype.save = function() {
    if (this.disabled) { return; }

    this.storage.set(
        this.name,
        _.JSONEncode(this['props']),
        this.expire_days,
        this.cross_subdomain,
        this.secure,
        this.cross_site,
        this.cookie_domain
    );
};

MixpanelPersistence.prototype.load_prop = function(key) {
    this.load();
    return this['props'][key];
};

MixpanelPersistence.prototype.remove = function() {
    // remove both domain and subdomain cookies
    this.storage.remove(this.name, false, this.cookie_domain);
    this.storage.remove(this.name, true, this.cookie_domain);
};

// removes the storage entry and deletes all loaded data
// forced name for tests
MixpanelPersistence.prototype.clear = function() {
    this.remove();
    this['props'] = {};
};

/**
* @param {Object} props
* @param {*=} default_value
* @param {number=} days
*/
MixpanelPersistence.prototype.register_once = function(props, default_value, days) {
    if (_.isObject(props)) {
        if (typeof(default_value) === 'undefined') { default_value = 'None'; }
        this.expire_days = (typeof(days) === 'undefined') ? this.default_expiry : days;

        this.load();

        _.each(props, function(val, prop) {
            if (!this['props'].hasOwnProperty(prop) || this['props'][prop] === default_value) {
                this['props'][prop] = val;
            }
        }, this);

        this.save();

        return true;
    }
    return false;
};

/**
* @param {Object} props
* @param {number=} days
*/
MixpanelPersistence.prototype.register = function(props, days) {
    if (_.isObject(props)) {
        this.expire_days = (typeof(days) === 'undefined') ? this.default_expiry : days;

        this.load();
        _.extend(this['props'], props);
        this.save();

        return true;
    }
    return false;
};

MixpanelPersistence.prototype.unregister = function(prop) {
    this.load();
    if (prop in this['props']) {
        delete this['props'][prop];
        this.save();
    }
};

MixpanelPersistence.prototype.update_search_keyword = function(referrer) {
    this.register(_.info.searchInfo(referrer));
};

// EXPORTED METHOD, we test this directly.
MixpanelPersistence.prototype.update_referrer_info = function(referrer) {
    // If referrer doesn't exist, we want to note the fact that it was type-in traffic.
    this.register_once({
        '$initial_referrer': referrer || '$direct',
        '$initial_referring_domain': _.info.referringDomain(referrer) || '$direct'
    }, '');
};

MixpanelPersistence.prototype.get_referrer_info = function() {
    return _.strip_empty_properties({
        '$initial_referrer': this['props']['$initial_referrer'],
        '$initial_referring_domain': this['props']['$initial_referring_domain']
    });
};

MixpanelPersistence.prototype.update_config = function(config) {
    this.default_expiry = this.expire_days = config['cookie_expiration'];
    this.set_disabled(config['disable_persistence']);
    this.set_cookie_domain(config['cookie_domain']);
    this.set_cross_site(config['cross_site_cookie']);
    this.set_cross_subdomain(config['cross_subdomain_cookie']);
    this.set_secure(config['secure_cookie']);
};

MixpanelPersistence.prototype.set_disabled = function(disabled) {
    this.disabled = disabled;
    if (this.disabled) {
        this.remove();
    } else {
        this.save();
    }
};

MixpanelPersistence.prototype.set_cookie_domain = function(cookie_domain) {
    if (cookie_domain !== this.cookie_domain) {
        this.remove();
        this.cookie_domain = cookie_domain;
        this.save();
    }
};

MixpanelPersistence.prototype.set_cross_site = function(cross_site) {
    if (cross_site !== this.cross_site) {
        this.cross_site = cross_site;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype.set_cross_subdomain = function(cross_subdomain) {
    if (cross_subdomain !== this.cross_subdomain) {
        this.cross_subdomain = cross_subdomain;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype.get_cross_subdomain = function() {
    return this.cross_subdomain;
};

MixpanelPersistence.prototype.set_secure = function(secure) {
    if (secure !== this.secure) {
        this.secure = secure ? true : false;
        this.remove();
        this.save();
    }
};

MixpanelPersistence.prototype._add_to_people_queue = function(queue, data) {
    var q_key = this._get_queue_key(queue),
        q_data = data[queue],
        set_q = this._get_or_create_queue(SET_ACTION),
        set_once_q = this._get_or_create_queue(SET_ONCE_ACTION),
        unset_q = this._get_or_create_queue(UNSET_ACTION),
        add_q = this._get_or_create_queue(ADD_ACTION),
        union_q = this._get_or_create_queue(UNION_ACTION),
        remove_q = this._get_or_create_queue(REMOVE_ACTION, []),
        append_q = this._get_or_create_queue(APPEND_ACTION, []);

    if (q_key === SET_QUEUE_KEY) {
        // Update the set queue - we can override any existing values
        _.extend(set_q, q_data);
        // if there was a pending increment, override it
        // with the set.
        this._pop_from_people_queue(ADD_ACTION, q_data);
        // if there was a pending union, override it
        // with the set.
        this._pop_from_people_queue(UNION_ACTION, q_data);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === SET_ONCE_QUEUE_KEY) {
        // only queue the data if there is not already a set_once call for it.
        _.each(q_data, function(v, k) {
            if (!(k in set_once_q)) {
                set_once_q[k] = v;
            }
        });
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === UNSET_QUEUE_KEY) {
        _.each(q_data, function(prop) {

            // undo previously-queued actions on this key
            _.each([set_q, set_once_q, add_q, union_q], function(enqueued_obj) {
                if (prop in enqueued_obj) {
                    delete enqueued_obj[prop];
                }
            });
            _.each(append_q, function(append_obj) {
                if (prop in append_obj) {
                    delete append_obj[prop];
                }
            });

            unset_q[prop] = true;

        });
    } else if (q_key === ADD_QUEUE_KEY) {
        _.each(q_data, function(v, k) {
            // If it exists in the set queue, increment
            // the value
            if (k in set_q) {
                set_q[k] += v;
            } else {
                // If it doesn't exist, update the add
                // queue
                if (!(k in add_q)) {
                    add_q[k] = 0;
                }
                add_q[k] += v;
            }
        }, this);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === UNION_QUEUE_KEY) {
        _.each(q_data, function(v, k) {
            if (_.isArray(v)) {
                if (!(k in union_q)) {
                    union_q[k] = [];
                }
                // We may send duplicates, the server will dedup them.
                union_q[k] = union_q[k].concat(v);
            }
        });
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    } else if (q_key === REMOVE_QUEUE_KEY) {
        remove_q.push(q_data);
        this._pop_from_people_queue(APPEND_ACTION, q_data);
    } else if (q_key === APPEND_QUEUE_KEY) {
        append_q.push(q_data);
        this._pop_from_people_queue(UNSET_ACTION, q_data);
    }

    console$1.log('MIXPANEL PEOPLE REQUEST (QUEUED, PENDING IDENTIFY):');
    console$1.log(data);

    this.save();
};

MixpanelPersistence.prototype._pop_from_people_queue = function(queue, data) {
    var q = this['props'][this._get_queue_key(queue)];
    if (!_.isUndefined(q)) {
        _.each(data, function(v, k) {
            if (queue === APPEND_ACTION || queue === REMOVE_ACTION) {
                // list actions: only remove if both k+v match
                // e.g. remove should not override append in a case like
                // append({foo: 'bar'}); remove({foo: 'qux'})
                _.each(q, function(queued_action) {
                    if (queued_action[k] === v) {
                        delete queued_action[k];
                    }
                });
            } else {
                delete q[k];
            }
        }, this);
    }
};

MixpanelPersistence.prototype.load_queue = function(queue) {
    return this.load_prop(this._get_queue_key(queue));
};

MixpanelPersistence.prototype._get_queue_key = function(queue) {
    if (queue === SET_ACTION) {
        return SET_QUEUE_KEY;
    } else if (queue === SET_ONCE_ACTION) {
        return SET_ONCE_QUEUE_KEY;
    } else if (queue === UNSET_ACTION) {
        return UNSET_QUEUE_KEY;
    } else if (queue === ADD_ACTION) {
        return ADD_QUEUE_KEY;
    } else if (queue === APPEND_ACTION) {
        return APPEND_QUEUE_KEY;
    } else if (queue === REMOVE_ACTION) {
        return REMOVE_QUEUE_KEY;
    } else if (queue === UNION_ACTION) {
        return UNION_QUEUE_KEY;
    } else {
        console$1.error('Invalid queue:', queue);
    }
};

MixpanelPersistence.prototype._get_or_create_queue = function(queue, default_val) {
    var key = this._get_queue_key(queue);
    default_val = _.isUndefined(default_val) ? {} : default_val;
    return this['props'][key] || (this['props'][key] = default_val);
};

MixpanelPersistence.prototype.set_event_timer = function(event_name, timestamp) {
    var timers = this.load_prop(EVENT_TIMERS_KEY) || {};
    timers[event_name] = timestamp;
    this['props'][EVENT_TIMERS_KEY] = timers;
    this.save();
};

MixpanelPersistence.prototype.remove_event_timer = function(event_name) {
    var timers = this.load_prop(EVENT_TIMERS_KEY) || {};
    var timestamp = timers[event_name];
    if (!_.isUndefined(timestamp)) {
        delete this['props'][EVENT_TIMERS_KEY][event_name];
        this.save();
    }
    return timestamp;
};

/*
 * Mixpanel JS Library
 *
 * Copyright 2012, Mixpanel, Inc. All Rights Reserved
 * http://mixpanel.com/
 *
 * Includes portions of Underscore.js
 * http://documentcloud.github.com/underscore/
 * (c) 2011 Jeremy Ashkenas, DocumentCloud Inc.
 * Released under the MIT License.
 */

// ==ClosureCompiler==
// @compilation_level ADVANCED_OPTIMIZATIONS
// @output_file_name mixpanel-2.8.min.js
// ==/ClosureCompiler==

/*
SIMPLE STYLE GUIDE:

this.x === public function
this._x === internal - only use within this file
this.__x === private - only use within the class

Globals should be all caps
*/

var init_type;       // MODULE or SNIPPET loader
var mixpanel_master; // main mixpanel instance / object
var INIT_MODULE  = 0;
var INIT_SNIPPET = 1;

var IDENTITY_FUNC = function(x) {return x;};
var NOOP_FUNC = function() {};

/** @const */ var PRIMARY_INSTANCE_NAME = 'mixpanel';
/** @const */ var PAYLOAD_TYPE_BASE64   = 'base64';
/** @const */ var PAYLOAD_TYPE_JSON     = 'json';
/** @const */ var DEVICE_ID_PREFIX      = '$device:';


/*
 * Dynamic... constants? Is that an oxymoron?
 */
// http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/
// https://developer.mozilla.org/en-US/docs/DOM/XMLHttpRequest#withCredentials
var USE_XHR = (window$1.XMLHttpRequest && 'withCredentials' in new XMLHttpRequest());

// IE<10 does not support cross-origin XHR's but script tags
// with defer won't block window.onload; ENQUEUE_REQUESTS
// should only be true for Opera<12
var ENQUEUE_REQUESTS = !USE_XHR && (userAgent.indexOf('MSIE') === -1) && (userAgent.indexOf('Mozilla') === -1);

// save reference to navigator.sendBeacon so it can be minified
var sendBeacon = null;
if (navigator$1['sendBeacon']) {
    sendBeacon = function() {
        // late reference to navigator.sendBeacon to allow patching/spying
        return navigator$1['sendBeacon'].apply(navigator$1, arguments);
    };
}

var DEFAULT_API_ROUTES = {
    'track': 'track/',
    'engage': 'engage/',
    'groups': 'groups/'
};

/*
 * Module-level globals
 */
var DEFAULT_CONFIG = {
    'api_host':                          'https://api-js.mixpanel.com',
    'api_routes':                        DEFAULT_API_ROUTES,
    'api_method':                        'POST',
    'api_transport':                     'XHR',
    'api_payload_format':                PAYLOAD_TYPE_BASE64,
    'app_host':                          'https://mixpanel.com',
    'cdn':                               'https://cdn.mxpnl.com',
    'cross_site_cookie':                 false,
    'cross_subdomain_cookie':            true,
    'error_reporter':                    NOOP_FUNC,
    'persistence':                       'cookie',
    'persistence_name':                  '',
    'cookie_domain':                     '',
    'cookie_name':                       '',
    'loaded':                            NOOP_FUNC,
    'track_marketing':                   true,
    'track_pageview':                    false,
    'skip_first_touch_marketing':        false,
    'store_google':                      true,
    'save_referrer':                     true,
    'test':                              false,
    'verbose':                           false,
    'img':                               false,
    'debug':                             false,
    'track_links_timeout':               300,
    'cookie_expiration':                 365,
    'upgrade':                           false,
    'disable_persistence':               false,
    'disable_cookie':                    false,
    'secure_cookie':                     false,
    'ip':                                true,
    'opt_out_tracking_by_default':       false,
    'opt_out_persistence_by_default':    false,
    'opt_out_tracking_persistence_type': 'localStorage',
    'opt_out_tracking_cookie_prefix':    null,
    'property_blacklist':                [],
    'xhr_headers':                       {}, // { header: value, header2: value }
    'ignore_dnt':                        false,
    'batch_requests':                    true,
    'batch_size':                        50,
    'batch_flush_interval_ms':           5000,
    'batch_request_timeout_ms':          90000,
    'batch_autostart':                   true,
    'hooks':                             {}
};

var DOM_LOADED = false;

/**
 * Mixpanel Library Object
 * @constructor
 */
var MixpanelLib = function() {};


/**
 * create_mplib(token:string, config:object, name:string)
 *
 * This function is used by the init method of MixpanelLib objects
 * as well as the main initializer at the end of the JSLib (that
 * initializes document.mixpanel as well as any additional instances
 * declared before this file has loaded).
 */
var create_mplib = function(token, config, name) {
    var instance,
        target = (name === PRIMARY_INSTANCE_NAME) ? mixpanel_master : mixpanel_master[name];

    if (target && init_type === INIT_MODULE) {
        instance = target;
    } else {
        if (target && !_.isArray(target)) {
            console$1.error('You have already initialized ' + name);
            return;
        }
        instance = new MixpanelLib();
    }

    instance._cached_groups = {}; // cache groups in a pool

    instance._init(token, config, name);

    instance['people'] = new MixpanelPeople();
    instance['people']._init(instance);

    if (!instance.get_config('skip_first_touch_marketing')) {
        // We need null UTM params in the object because
        // UTM parameters act as a tuple. If any UTM param
        // is present, then we set all UTM params including
        // empty ones together
        var utm_params = _.info.campaignParams(null);
        var initial_utm_params = {};
        var has_utm = false;
        _.each(utm_params, function(utm_value, utm_key) {
            initial_utm_params['initial_' + utm_key] = utm_value;
            if (utm_value) {
                has_utm = true;
            }
        });
        if (has_utm) {
            instance['people'].set_once(initial_utm_params);
        }
    }

    // if any instance on the page has debug = true, we set the
    // global debug to be true
    Config.DEBUG = Config.DEBUG || instance.get_config('debug');

    // if target is not defined, we called init after the lib already
    // loaded, so there won't be an array of things to execute
    if (!_.isUndefined(target) && _.isArray(target)) {
        // Crunch through the people queue first - we queue this data up &
        // flush on identify, so it's better to do all these operations first
        instance._execute_array.call(instance['people'], target['people']);
        instance._execute_array(target);
    }

    return instance;
};

// Initialization methods

/**
 * This function initializes a new instance of the Mixpanel tracking object.
 * All new instances are added to the main mixpanel object as sub properties (such as
 * mixpanel.library_name) and also returned by this function. To define a
 * second instance on the page, you would call:
 *
 *     mixpanel.init('new token', { your: 'config' }, 'library_name');
 *
 * and use it like so:
 *
 *     mixpanel.library_name.track(...);
 *
 * @param {String} token   Your Mixpanel API token
 * @param {Object} [config]  A dictionary of config options to override. <a href="https://github.com/mixpanel/mixpanel-js/blob/v2.46.0/src/mixpanel-core.js#L88-L127">See a list of default config options</a>.
 * @param {String} [name]    The name for the new mixpanel instance that you want created
 */
MixpanelLib.prototype.init = function (token, config, name) {
    if (_.isUndefined(name)) {
        this.report_error('You must name your new library: init(token, config, name)');
        return;
    }
    if (name === PRIMARY_INSTANCE_NAME) {
        this.report_error('You must initialize the main mixpanel object right after you include the Mixpanel js snippet');
        return;
    }

    var instance = create_mplib(token, config, name);
    mixpanel_master[name] = instance;
    instance._loaded();

    return instance;
};

// mixpanel._init(token:string, config:object, name:string)
//
// This function sets up the current instance of the mixpanel
// library.  The difference between this method and the init(...)
// method is this one initializes the actual instance, whereas the
// init(...) method sets up a new library and calls _init on it.
//
MixpanelLib.prototype._init = function(token, config, name) {
    config = config || {};

    this['__loaded'] = true;
    this['config'] = {};

    var variable_features = {};

    // default to JSON payload for standard mixpanel.com API hosts
    if (!('api_payload_format' in config)) {
        var api_host = config['api_host'] || DEFAULT_CONFIG['api_host'];
        if (api_host.match(/\.mixpanel\.com/)) {
            variable_features['api_payload_format'] = PAYLOAD_TYPE_JSON;
        }
    }

    this.set_config(_.extend({}, DEFAULT_CONFIG, variable_features, config, {
        'name': name,
        'token': token,
        'callback_fn': ((name === PRIMARY_INSTANCE_NAME) ? name : PRIMARY_INSTANCE_NAME + '.' + name) + '._jsc'
    }));

    this['_jsc'] = NOOP_FUNC;

    this.__dom_loaded_queue = [];
    this.__request_queue = [];
    this.__disabled_events = [];
    this._flags = {
        'disable_all_events': false,
        'identify_called': false
    };

    // set up request queueing/batching
    this.request_batchers = {};
    this._batch_requests = this.get_config('batch_requests');
    if (this._batch_requests) {
        if (!_.localStorage.is_supported(true) || !USE_XHR) {
            this._batch_requests = false;
            console$1.log('Turning off Mixpanel request-queueing; needs XHR and localStorage support');
            _.each(this.get_batcher_configs(), function(batcher_config) {
                console$1.log('Clearing batch queue ' + batcher_config.queue_key);
                _.localStorage.remove(batcher_config.queue_key);
            });
        } else {
            this.init_batchers();
            if (sendBeacon && window$1.addEventListener) {
                // Before page closes or hides (user tabs away etc), attempt to flush any events
                // queued up via navigator.sendBeacon. Since sendBeacon doesn't report success/failure,
                // events will not be removed from the persistent store; if the site is loaded again,
                // the events will be flushed again on startup and deduplicated on the Mixpanel server
                // side.
                // There is no reliable way to capture only page close events, so we lean on the
                // visibilitychange and pagehide events as recommended at
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event#usage_notes.
                // These events fire when the user clicks away from the current page/tab, so will occur
                // more frequently than page unload, but are the only mechanism currently for capturing
                // this scenario somewhat reliably.
                var flush_on_unload = _.bind(function() {
                    if (!this.request_batchers.events.stopped) {
                        this.request_batchers.events.flush({unloading: true});
                    }
                }, this);
                window$1.addEventListener('pagehide', function(ev) {
                    if (ev['persisted']) {
                        flush_on_unload();
                    }
                });
                window$1.addEventListener('visibilitychange', function() {
                    if (document$1['visibilityState'] === 'hidden') {
                        flush_on_unload();
                    }
                });
            }
        }
    }

    this['persistence'] = this['cookie'] = new MixpanelPersistence(this['config']);
    this.unpersisted_superprops = {};
    this._gdpr_init();

    var uuid = _.UUID();
    if (!this.get_distinct_id()) {
        // There is no need to set the distinct id
        // or the device id if something was already stored
        // in the persitence
        this.register_once({
            'distinct_id': DEVICE_ID_PREFIX + uuid,
            '$device_id': uuid
        }, '');
    }

    if (this.get_config('track_pageview')) {
        this.track_pageview();
    }
};

// Private methods

MixpanelLib.prototype._loaded = function() {
    this.get_config('loaded')(this);
    this._set_default_superprops();
};

// update persistence with info on referrer, UTM params, etc
MixpanelLib.prototype._set_default_superprops = function() {
    this['persistence'].update_search_keyword(document$1.referrer);
    if (this.get_config('store_google')) {
        this.register(_.info.campaignParams());
    }
    if (this.get_config('save_referrer')) {
        this['persistence'].update_referrer_info(document$1.referrer);
    }
};

MixpanelLib.prototype._dom_loaded = function() {
    _.each(this.__dom_loaded_queue, function(item) {
        this._track_dom.apply(this, item);
    }, this);

    if (!this.has_opted_out_tracking()) {
        _.each(this.__request_queue, function(item) {
            this._send_request.apply(this, item);
        }, this);
    }

    delete this.__dom_loaded_queue;
    delete this.__request_queue;
};

MixpanelLib.prototype._track_dom = function(DomClass, args) {
    if (this.get_config('img')) {
        this.report_error('You can\'t use DOM tracking functions with img = true.');
        return false;
    }

    if (!DOM_LOADED) {
        this.__dom_loaded_queue.push([DomClass, args]);
        return false;
    }

    var dt = new DomClass().init(this);
    return dt.track.apply(dt, args);
};

/**
 * _prepare_callback() should be called by callers of _send_request for use
 * as the callback argument.
 *
 * If there is no callback, this returns null.
 * If we are going to make XHR/XDR requests, this returns a function.
 * If we are going to use script tags, this returns a string to use as the
 * callback GET param.
 */
MixpanelLib.prototype._prepare_callback = function(callback, data) {
    if (_.isUndefined(callback)) {
        return null;
    }

    if (USE_XHR) {
        var callback_function = function(response) {
            callback(response, data);
        };
        return callback_function;
    } else {
        // if the user gives us a callback, we store as a random
        // property on this instances jsc function and update our
        // callback string to reflect that.
        var jsc = this['_jsc'];
        var randomized_cb = '' + Math.floor(Math.random() * 100000000);
        var callback_string = this.get_config('callback_fn') + '[' + randomized_cb + ']';
        jsc[randomized_cb] = function(response) {
            delete jsc[randomized_cb];
            callback(response, data);
        };
        return callback_string;
    }
};

MixpanelLib.prototype._send_request = function(url, data, options, callback) {
    var succeeded = true;

    if (ENQUEUE_REQUESTS) {
        this.__request_queue.push(arguments);
        return succeeded;
    }

    var DEFAULT_OPTIONS = {
        method: this.get_config('api_method'),
        transport: this.get_config('api_transport'),
        verbose: this.get_config('verbose')
    };
    var body_data = null;

    if (!callback && (_.isFunction(options) || typeof options === 'string')) {
        callback = options;
        options = null;
    }
    options = _.extend(DEFAULT_OPTIONS, options || {});
    if (!USE_XHR) {
        options.method = 'GET';
    }
    var use_post = options.method === 'POST';
    var use_sendBeacon = sendBeacon && use_post && options.transport.toLowerCase() === 'sendbeacon';

    // needed to correctly format responses
    var verbose_mode = options.verbose;
    if (data['verbose']) { verbose_mode = true; }

    if (this.get_config('test')) { data['test'] = 1; }
    if (verbose_mode) { data['verbose'] = 1; }
    if (this.get_config('img')) { data['img'] = 1; }
    if (!USE_XHR) {
        if (callback) {
            data['callback'] = callback;
        } else if (verbose_mode || this.get_config('test')) {
            // Verbose output (from verbose mode, or an error in test mode) is a json blob,
            // which by itself is not valid javascript. Without a callback, this verbose output will
            // cause an error when returned via jsonp, so we force a no-op callback param.
            // See the ECMA script spec: http://www.ecma-international.org/ecma-262/5.1/#sec-12.4
            data['callback'] = '(function(){})';
        }
    }

    data['ip'] = this.get_config('ip')?1:0;
    data['_'] = new Date().getTime().toString();

    if (use_post) {
        body_data = 'data=' + encodeURIComponent(data['data']);
        delete data['data'];
    }

    url += '?' + _.HTTPBuildQuery(data);

    var lib = this;
    if ('img' in data) {
        var img = document$1.createElement('img');
        img.src = url;
        document$1.body.appendChild(img);
    } else if (use_sendBeacon) {
        try {
            succeeded = sendBeacon(url, body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
        try {
            if (callback) {
                callback(succeeded ? 1 : 0);
            }
        } catch (e) {
            lib.report_error(e);
        }
    } else if (USE_XHR) {
        try {
            var req = new XMLHttpRequest();
            req.open(options.method, url, true);

            var headers = this.get_config('xhr_headers');
            if (use_post) {
                headers['Content-Type'] = 'application/x-www-form-urlencoded';
            }
            _.each(headers, function(headerValue, headerName) {
                req.setRequestHeader(headerName, headerValue);
            });

            if (options.timeout_ms && typeof req.timeout !== 'undefined') {
                req.timeout = options.timeout_ms;
                var start_time = new Date().getTime();
            }

            // send the mp_optout cookie
            // withCredentials cannot be modified until after calling .open on Android and Mobile Safari
            req.withCredentials = true;
            req.onreadystatechange = function () {
                if (req.readyState === 4) { // XMLHttpRequest.DONE == 4, except in safari 4
                    if (req.status === 200) {
                        if (callback) {
                            if (verbose_mode) {
                                var response;
                                try {
                                    response = _.JSONDecode(req.responseText);
                                } catch (e) {
                                    lib.report_error(e);
                                    if (options.ignore_json_errors) {
                                        response = req.responseText;
                                    } else {
                                        return;
                                    }
                                }
                                callback(response);
                            } else {
                                callback(Number(req.responseText));
                            }
                        }
                    } else {
                        var error;
                        if (
                            req.timeout &&
                            !req.status &&
                            new Date().getTime() - start_time >= req.timeout
                        ) {
                            error = 'timeout';
                        } else {
                            error = 'Bad HTTP status: ' + req.status + ' ' + req.statusText;
                        }
                        lib.report_error(error);
                        if (callback) {
                            if (verbose_mode) {
                                callback({status: 0, error: error, xhr_req: req});
                            } else {
                                callback(0);
                            }
                        }
                    }
                }
            };
            req.send(body_data);
        } catch (e) {
            lib.report_error(e);
            succeeded = false;
        }
    } else {
        var script = document$1.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.defer = true;
        script.src = url;
        var s = document$1.getElementsByTagName('script')[0];
        s.parentNode.insertBefore(script, s);
    }

    return succeeded;
};

/**
 * _execute_array() deals with processing any mixpanel function
 * calls that were called before the Mixpanel library were loaded
 * (and are thus stored in an array so they can be called later)
 *
 * Note: we fire off all the mixpanel function calls && user defined
 * functions BEFORE we fire off mixpanel tracking calls. This is so
 * identify/register/set_config calls can properly modify early
 * tracking calls.
 *
 * @param {Array} array
 */
MixpanelLib.prototype._execute_array = function(array) {
    var fn_name, alias_calls = [], other_calls = [], tracking_calls = [];
    _.each(array, function(item) {
        if (item) {
            fn_name = item[0];
            if (_.isArray(fn_name)) {
                tracking_calls.push(item); // chained call e.g. mixpanel.get_group().set()
            } else if (typeof(item) === 'function') {
                item.call(this);
            } else if (_.isArray(item) && fn_name === 'alias') {
                alias_calls.push(item);
            } else if (_.isArray(item) && fn_name.indexOf('track') !== -1 && typeof(this[fn_name]) === 'function') {
                tracking_calls.push(item);
            } else {
                other_calls.push(item);
            }
        }
    }, this);

    var execute = function(calls, context) {
        _.each(calls, function(item) {
            if (_.isArray(item[0])) {
                // chained call
                var caller = context;
                _.each(item, function(call) {
                    caller = caller[call[0]].apply(caller, call.slice(1));
                });
            } else {
                this[item[0]].apply(this, item.slice(1));
            }
        }, context);
    };

    execute(alias_calls, this);
    execute(other_calls, this);
    execute(tracking_calls, this);
};

// request queueing utils

MixpanelLib.prototype.are_batchers_initialized = function() {
    return !!this.request_batchers.events;
};

MixpanelLib.prototype.get_batcher_configs = function() {
    var queue_prefix = '__mpq_' + this.get_config('token');
    var api_routes = this.get_config('api_routes');
    this._batcher_configs = this._batcher_configs || {
        events: {type: 'events', endpoint: '/' + api_routes['track'], queue_key: queue_prefix + '_ev'},
        people: {type: 'people', endpoint: '/' + api_routes['engage'], queue_key: queue_prefix + '_pp'},
        groups: {type: 'groups', endpoint: '/' + api_routes['groups'], queue_key: queue_prefix + '_gr'}
    };
    return this._batcher_configs;
};

MixpanelLib.prototype.init_batchers = function() {
    if (!this.are_batchers_initialized()) {
        var batcher_for = _.bind(function(attrs) {
            return new RequestBatcher(
                attrs.queue_key,
                {
                    libConfig: this['config'],
                    sendRequestFunc: _.bind(function(data, options, cb) {
                        this._send_request(
                            this.get_config('api_host') + attrs.endpoint,
                            this._encode_data_for_request(data),
                            options,
                            this._prepare_callback(cb, data)
                        );
                    }, this),
                    beforeSendHook: _.bind(function(item) {
                        return this._run_hook('before_send_' + attrs.type, item);
                    }, this),
                    errorReporter: this.get_config('error_reporter'),
                    stopAllBatchingFunc: _.bind(this.stop_batch_senders, this)
                }
            );
        }, this);
        var batcher_configs = this.get_batcher_configs();
        this.request_batchers = {
            events: batcher_for(batcher_configs.events),
            people: batcher_for(batcher_configs.people),
            groups: batcher_for(batcher_configs.groups)
        };
    }
    if (this.get_config('batch_autostart')) {
        this.start_batch_senders();
    }
};

MixpanelLib.prototype.start_batch_senders = function() {
    this._batchers_were_started = true;
    if (this.are_batchers_initialized()) {
        this._batch_requests = true;
        _.each(this.request_batchers, function(batcher) {
            batcher.start();
        });
    }
};

MixpanelLib.prototype.stop_batch_senders = function() {
    this._batch_requests = false;
    _.each(this.request_batchers, function(batcher) {
        batcher.stop();
        batcher.clear();
    });
};

/**
 * push() keeps the standard async-array-push
 * behavior around after the lib is loaded.
 * This is only useful for external integrations that
 * do not wish to rely on our convenience methods
 * (created in the snippet).
 *
 * ### Usage:
 *     mixpanel.push(['register', { a: 'b' }]);
 *
 * @param {Array} item A [function_name, args...] array to be executed
 */
MixpanelLib.prototype.push = function(item) {
    this._execute_array([item]);
};

/**
 * Disable events on the Mixpanel object. If passed no arguments,
 * this function disables tracking of any event. If passed an
 * array of event names, those events will be disabled, but other
 * events will continue to be tracked.
 *
 * Note: this function does not stop other mixpanel functions from
 * firing, such as register() or people.set().
 *
 * @param {Array} [events] An array of event names to disable
 */
MixpanelLib.prototype.disable = function(events) {
    if (typeof(events) === 'undefined') {
        this._flags.disable_all_events = true;
    } else {
        this.__disabled_events = this.__disabled_events.concat(events);
    }
};

MixpanelLib.prototype._encode_data_for_request = function(data) {
    var encoded_data = _.JSONEncode(data);
    if (this.get_config('api_payload_format') === PAYLOAD_TYPE_BASE64) {
        encoded_data = _.base64Encode(encoded_data);
    }
    return {'data': encoded_data};
};

// internal method for handling track vs batch-enqueue logic
MixpanelLib.prototype._track_or_batch = function(options, callback) {
    var truncated_data = _.truncate(options.data, 255);
    var endpoint = options.endpoint;
    var batcher = options.batcher;
    var should_send_immediately = options.should_send_immediately;
    var send_request_options = options.send_request_options || {};
    callback = callback || NOOP_FUNC;

    var request_enqueued_or_initiated = true;
    var send_request_immediately = _.bind(function() {
        if (!send_request_options.skip_hooks) {
            truncated_data = this._run_hook('before_send_' + options.type, truncated_data);
        }
        if (truncated_data) {
            console$1.log('MIXPANEL REQUEST:');
            console$1.log(truncated_data);
            return this._send_request(
                endpoint,
                this._encode_data_for_request(truncated_data),
                send_request_options,
                this._prepare_callback(callback, truncated_data)
            );
        } else {
            return null;
        }
    }, this);

    if (this._batch_requests && !should_send_immediately) {
        batcher.enqueue(truncated_data, function(succeeded) {
            if (succeeded) {
                callback(1, truncated_data);
            } else {
                send_request_immediately();
            }
        });
    } else {
        request_enqueued_or_initiated = send_request_immediately();
    }

    return request_enqueued_or_initiated && truncated_data;
};

/**
 * Track an event. This is the most important and
 * frequently used Mixpanel function.
 *
 * ### Usage:
 *
 *     // track an event named 'Registered'
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 *     // track an event using navigator.sendBeacon
 *     mixpanel.track('Left page', {'duration_seconds': 35}, {transport: 'sendBeacon'});
 *
 * To track link clicks or form submissions, see track_links() or track_forms().
 *
 * @param {String} event_name The name of the event. This can be anything the user does - 'Button Click', 'Sign Up', 'Item Purchased', etc.
 * @param {Object} [properties] A set of properties to include with the event you're sending. These describe the user who did the event or details about the event itself.
 * @param {Object} [options] Optional configuration for this track request.
 * @param {String} [options.transport] Transport method for network request ('xhr' or 'sendBeacon').
 * @param {Boolean} [options.send_immediately] Whether to bypass batching/queueing and send track request immediately.
 * @param {Function} [callback] If provided, the callback function will be called after tracking the event.
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */
MixpanelLib.prototype.track = addOptOutCheckMixpanelLib(function(event_name, properties, options, callback) {
    if (!callback && typeof options === 'function') {
        callback = options;
        options = null;
    }
    options = options || {};
    var transport = options['transport']; // external API, don't minify 'transport' prop
    if (transport) {
        options.transport = transport; // 'transport' prop name can be minified internally
    }
    var should_send_immediately = options['send_immediately'];
    if (typeof callback !== 'function') {
        callback = NOOP_FUNC;
    }

    if (_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.track');
        return;
    }

    if (this._event_is_disabled(event_name)) {
        callback(0);
        return;
    }

    // set defaults
    properties = _.extend({}, properties);
    properties['token'] = this.get_config('token');

    // set $duration if time_event was previously called for this event
    var start_timestamp = this['persistence'].remove_event_timer(event_name);
    if (!_.isUndefined(start_timestamp)) {
        var duration_in_ms = new Date().getTime() - start_timestamp;
        properties['$duration'] = parseFloat((duration_in_ms / 1000).toFixed(3));
    }

    this._set_default_superprops();

    var marketing_properties = this.get_config('track_marketing')
        ? _.info.marketingParams()
        : {};

    // note: extend writes to the first object, so lets make sure we
    // don't write to the persistence properties object and info
    // properties object by passing in a new object

    // update properties with pageview info and super-properties
    properties = _.extend(
        {},
        _.info.properties(),
        marketing_properties,
        this['persistence'].properties(),
        this.unpersisted_superprops,
        properties
    );

    var property_blacklist = this.get_config('property_blacklist');
    if (_.isArray(property_blacklist)) {
        _.each(property_blacklist, function(blacklisted_prop) {
            delete properties[blacklisted_prop];
        });
    } else {
        this.report_error('Invalid value for property_blacklist config: ' + property_blacklist);
    }

    var data = {
        'event': event_name,
        'properties': properties
    };
    var ret = this._track_or_batch({
        type: 'events',
        data: data,
        endpoint: this.get_config('api_host') + '/' + this.get_config('api_routes')['track'],
        batcher: this.request_batchers.events,
        should_send_immediately: should_send_immediately,
        send_request_options: options
    }, callback);

    return ret;
});

/**
 * Register the current user into one/many groups.
 *
 * ### Usage:
 *
 *      mixpanel.set_group('company', ['mixpanel', 'google']) // an array of IDs
 *      mixpanel.set_group('company', 'mixpanel')
 *      mixpanel.set_group('company', 128746312)
 *
 * @param {String} group_key Group key
 * @param {Array|String|Number} group_ids An array of group IDs, or a singular group ID
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 *
 */
MixpanelLib.prototype.set_group = addOptOutCheckMixpanelLib(function(group_key, group_ids, callback) {
    if (!_.isArray(group_ids)) {
        group_ids = [group_ids];
    }
    var prop = {};
    prop[group_key] = group_ids;
    this.register(prop);
    return this['people'].set(group_key, group_ids, callback);
});

/**
 * Add a new group for this user.
 *
 * ### Usage:
 *
 *      mixpanel.add_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */
MixpanelLib.prototype.add_group = addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_values = this.get_property(group_key);
    var prop = {};
    if (old_values === undefined) {
        prop[group_key] = [group_id];
        this.register(prop);
    } else {
        if (old_values.indexOf(group_id) === -1) {
            old_values.push(group_id);
            prop[group_key] = old_values;
            this.register(prop);
        }
    }
    return this['people'].union(group_key, group_id, callback);
});

/**
 * Remove a group from this user.
 *
 * ### Usage:
 *
 *      mixpanel.remove_group('company', 'mixpanel')
 *
 * @param {String} group_key Group key
 * @param {*} group_id A valid Mixpanel property type
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */
MixpanelLib.prototype.remove_group = addOptOutCheckMixpanelLib(function(group_key, group_id, callback) {
    var old_value = this.get_property(group_key);
    // if the value doesn't exist, the persistent store is unchanged
    if (old_value !== undefined) {
        var idx = old_value.indexOf(group_id);
        if (idx > -1) {
            old_value.splice(idx, 1);
            this.register({group_key: old_value});
        }
        if (old_value.length === 0) {
            this.unregister(group_key);
        }
    }
    return this['people'].remove(group_key, group_id, callback);
});

/**
 * Track an event with specific groups.
 *
 * ### Usage:
 *
 *      mixpanel.track_with_groups('purchase', {'product': 'iphone'}, {'University': ['UCB', 'UCLA']})
 *
 * @param {String} event_name The name of the event (see `mixpanel.track()`)
 * @param {Object=} properties A set of properties to include with the event you're sending (see `mixpanel.track()`)
 * @param {Object=} groups An object mapping group name keys to one or more values
 * @param {Function} [callback] If provided, the callback will be called after tracking the event.
 */
MixpanelLib.prototype.track_with_groups = addOptOutCheckMixpanelLib(function(event_name, properties, groups, callback) {
    var tracking_props = _.extend({}, properties || {});
    _.each(groups, function(v, k) {
        if (v !== null && v !== undefined) {
            tracking_props[k] = v;
        }
    });
    return this.track(event_name, tracking_props, callback);
});

MixpanelLib.prototype._create_map_key = function (group_key, group_id) {
    return group_key + '_' + JSON.stringify(group_id);
};

MixpanelLib.prototype._remove_group_from_cache = function (group_key, group_id) {
    delete this._cached_groups[this._create_map_key(group_key, group_id)];
};

/**
 * Look up reference to a Mixpanel group
 *
 * ### Usage:
 *
 *       mixpanel.get_group(group_key, group_id)
 *
 * @param {String} group_key Group key
 * @param {Object} group_id A valid Mixpanel property type
 * @returns {Object} A MixpanelGroup identifier
 */
MixpanelLib.prototype.get_group = function (group_key, group_id) {
    var map_key = this._create_map_key(group_key, group_id);
    var group = this._cached_groups[map_key];
    if (group === undefined || group._group_key !== group_key || group._group_id !== group_id) {
        group = new MixpanelGroup();
        group._init(this, group_key, group_id);
        this._cached_groups[map_key] = group;
    }
    return group;
};

/**
 * Track a default Mixpanel page view event, which includes extra default event properties to
 * improve page view data. The `config.track_pageview` option for <a href="#mixpanelinit">mixpanel.init()</a>
 * may be turned on for tracking page loads automatically.
 *
 * ### Usage
 *
 *     // track a default $mp_web_page_view event
 *     mixpanel.track_pageview();
 *
 *     // track a page view event with additional event properties
 *     mixpanel.track_pageview({'ab_test_variant': 'card-layout-b'});
 *
 *     // example approach to track page views on different page types as event properties
 *     mixpanel.track_pageview({'page': 'pricing'});
 *     mixpanel.track_pageview({'page': 'homepage'});
 *
 *     // UNCOMMON: Tracking a page view event with a custom event_name option. NOT expected to be used for
 *     // individual pages on the same site or product. Use cases for custom event_name may be page
 *     // views on different products or internal applications that are considered completely separate
 *     mixpanel.track_pageview({'page': 'customer-search'}, {'event_name': '[internal] Admin Page View'});
 *
 * @param {Object} [properties] An optional set of additional properties to send with the page view event
 * @param {Object} [options] Page view tracking options
 * @param {String} [options.event_name] - Alternate name for the tracking event
 * @returns {Boolean|Object} If the tracking request was successfully initiated/queued, an object
 * with the tracking payload sent to the API server is returned; otherwise false.
 */
MixpanelLib.prototype.track_pageview = addOptOutCheckMixpanelLib(function(properties, options) {
    if (typeof properties !== 'object') {
        properties = {};
    }
    options = options || {};
    var event_name = options['event_name'] || '$mp_web_page_view';

    var default_page_properties = _.extend(
        _.info.mpPageViewProperties(),
        _.info.campaignParams(),
        _.info.clickParams()
    );

    var event_properties = _.extend(
        {},
        default_page_properties,
        properties
    );

    return this.track(event_name, event_properties);
});

/**
 * Track clicks on a set of document elements. Selector must be a
 * valid query. Elements must exist on the page at the time track_links is called.
 *
 * ### Usage:
 *
 *     // track click for link id #nav
 *     mixpanel.track_links('#nav', 'Clicked Nav Link');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the Mixpanel
 * servers to respond. If they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] A properties object or function that returns a dictionary of properties when passed a DOMElement
 */
MixpanelLib.prototype.track_links = function() {
    return this._track_dom.call(this, LinkTracker, arguments);
};

/**
 * Track form submissions. Selector must be a valid query.
 *
 * ### Usage:
 *
 *     // track submission for form id 'register'
 *     mixpanel.track_forms('#register', 'Created Account');
 *
 * ### Notes:
 *
 * This function will wait up to 300 ms for the mixpanel
 * servers to respond, if they have not responded by that time
 * it will head to the link without ensuring that your event
 * has been tracked.  To configure this timeout please see the
 * set_config() documentation below.
 *
 * If you pass a function in as the properties argument, the
 * function will receive the DOMElement that triggered the
 * event as an argument.  You are expected to return an object
 * from the function; any properties defined on this object
 * will be sent to mixpanel as event properties.
 *
 * @type {Function}
 * @param {Object|String} query A valid DOM query, element or jQuery-esque list
 * @param {String} event_name The name of the event to track
 * @param {Object|Function} [properties] This can be a set of properties, or a function that returns a set of properties after being passed a DOMElement
 */
MixpanelLib.prototype.track_forms = function() {
    return this._track_dom.call(this, FormTracker, arguments);
};

/**
 * Time an event by including the time between this call and a
 * later 'track' call for the same event in the properties sent
 * with the event.
 *
 * ### Usage:
 *
 *     // time an event named 'Registered'
 *     mixpanel.time_event('Registered');
 *     mixpanel.track('Registered', {'Gender': 'Male', 'Age': 21});
 *
 * When called for a particular event name, the next track call for that event
 * name will include the elapsed time between the 'time_event' and 'track'
 * calls. This value is stored as seconds in the '$duration' property.
 *
 * @param {String} event_name The name of the event.
 */
MixpanelLib.prototype.time_event = function(event_name) {
    if (_.isUndefined(event_name)) {
        this.report_error('No event name provided to mixpanel.time_event');
        return;
    }

    if (this._event_is_disabled(event_name)) {
        return;
    }

    this['persistence'].set_event_timer(event_name,  new Date().getTime());
};

var REGISTER_DEFAULTS = {
    'persistent': true
};
/**
 * Helper to parse options param for register methods, maintaining
 * legacy support for plain "days" param instead of options object
 * @param {Number|Object} [days_or_options] 'days' option (Number), or Options object for register methods
 * @returns {Object} options object
 */
var options_for_register = function(days_or_options) {
    var options;
    if (_.isObject(days_or_options)) {
        options = days_or_options;
    } else if (!_.isUndefined(days_or_options)) {
        options = {'days': days_or_options};
    } else {
        options = {};
    }
    return _.extend({}, REGISTER_DEFAULTS, options);
};

/**
 * Register a set of super properties, which are included with all
 * events. This will overwrite previous super property values.
 *
 * ### Usage:
 *
 *     // register 'Gender' as a super property
 *     mixpanel.register({'Gender': 'Female'});
 *
 *     // register several super properties when a user signs up
 *     mixpanel.register({
 *         'Email': 'jdoe@example.com',
 *         'Account Type': 'Free'
 *     });
 *
 *     // register only for the current pageload
 *     mixpanel.register({'Name': 'Pat'}, {persistent: false});
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */
MixpanelLib.prototype.register = function(props, days_or_options) {
    var options = options_for_register(days_or_options);
    if (options['persistent']) {
        this['persistence'].register(props, options['days']);
    } else {
        _.extend(this.unpersisted_superprops, props);
    }
};

/**
 * Register a set of super properties only once. This will not
 * overwrite previous super property values, unlike register().
 *
 * ### Usage:
 *
 *     // register a super property for the first time only
 *     mixpanel.register_once({
 *         'First Login Date': new Date().toISOString()
 *     });
 *
 *     // register once, only for the current pageload
 *     mixpanel.register_once({
 *         'First interaction time': new Date().toISOString()
 *     }, 'None', {persistent: false});
 *
 * ### Notes:
 *
 * If default_value is specified, current super properties
 * with that value will be overwritten.
 *
 * @param {Object} properties An associative array of properties to store about the user
 * @param {*} [default_value] Value to override if already set in super properties (ex: 'False') Default: 'None'
 * @param {Number|Object} [days_or_options] Options object or number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.days] - number of days since the user's last visit to store the super properties (only valid for persisted props)
 * @param {boolean} [days_or_options.persistent=true] - whether to put in persistent storage (cookie/localStorage)
 */
MixpanelLib.prototype.register_once = function(props, default_value, days_or_options) {
    var options = options_for_register(days_or_options);
    if (options['persistent']) {
        this['persistence'].register_once(props, default_value, options['days']);
    } else {
        if (typeof(default_value) === 'undefined') {
            default_value = 'None';
        }
        _.each(props, function(val, prop) {
            if (!this.unpersisted_superprops.hasOwnProperty(prop) || this.unpersisted_superprops[prop] === default_value) {
                this.unpersisted_superprops[prop] = val;
            }
        }, this);
    }
};

/**
 * Delete a super property stored with the current user.
 *
 * @param {String} property The name of the super property to remove
 * @param {Object} [options]
 * @param {boolean} [options.persistent=true] - whether to look in persistent storage (cookie/localStorage)
 */
MixpanelLib.prototype.unregister = function(property, options) {
    options = options_for_register(options);
    if (options['persistent']) {
        this['persistence'].unregister(property);
    } else {
        delete this.unpersisted_superprops[property];
    }
};

MixpanelLib.prototype._register_single = function(prop, value) {
    var props = {};
    props[prop] = value;
    this.register(props);
};

/**
 * Identify a user with a unique ID to track user activity across
 * devices, tie a user to their events, and create a user profile.
 * If you never call this method, unique visitors are tracked using
 * a UUID generated the first time they visit the site.
 *
 * Call identify when you know the identity of the current user,
 * typically after login or signup. We recommend against using
 * identify for anonymous visitors to your site.
 *
 * ### Notes:
 * If your project has
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the identify method will connect pre- and
 * post-authentication events when appropriate.
 *
 * If your project does not have ID Merge enabled, identify will
 * change the user's local distinct_id to the unique ID you pass.
 * Events tracked prior to authentication will not be connected
 * to the same user identity. If ID Merge is disabled, alias can
 * be used to connect pre- and post-registration events.
 *
 * @param {String} [unique_id] A string that uniquely identifies a user. If not provided, the distinct_id currently in the persistent store (cookie or localStorage) will be used.
 */
MixpanelLib.prototype.identify = function(
    new_distinct_id, _set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback
) {
    // Optional Parameters
    //  _set_callback:function  A callback to be run if and when the People set queue is flushed
    //  _add_callback:function  A callback to be run if and when the People add queue is flushed
    //  _append_callback:function  A callback to be run if and when the People append queue is flushed
    //  _set_once_callback:function  A callback to be run if and when the People set_once queue is flushed
    //  _union_callback:function  A callback to be run if and when the People union queue is flushed
    //  _unset_callback:function  A callback to be run if and when the People unset queue is flushed

    var previous_distinct_id = this.get_distinct_id();
    if (new_distinct_id && previous_distinct_id !== new_distinct_id) {
        // we allow the following condition if previous distinct_id is same as new_distinct_id
        // so that you can force flush people updates for anonymous profiles.
        if (typeof new_distinct_id === 'string' && new_distinct_id.indexOf(DEVICE_ID_PREFIX) === 0) {
            this.report_error('distinct_id cannot have $device: prefix');
            return -1;
        }
        this.register({'$user_id': new_distinct_id});
    }

    if (!this.get_property('$device_id')) {
        // The persisted distinct id might not actually be a device id at all
        // it might be a distinct id of the user from before
        var device_id = previous_distinct_id;
        this.register_once({
            '$had_persisted_distinct_id': true,
            '$device_id': device_id
        }, '');
    }

    // identify only changes the distinct id if it doesn't match either the existing or the alias;
    // if it's new, blow away the alias as well.
    if (new_distinct_id !== previous_distinct_id && new_distinct_id !== this.get_property(ALIAS_ID_KEY)) {
        this.unregister(ALIAS_ID_KEY);
        this.register({'distinct_id': new_distinct_id});
    }
    this._flags.identify_called = true;
    // Flush any queued up people requests
    this['people']._flush(_set_callback, _add_callback, _append_callback, _set_once_callback, _union_callback, _unset_callback, _remove_callback);

    // send an $identify event any time the distinct_id is changing - logic on the server
    // will determine whether or not to do anything with it.
    if (new_distinct_id !== previous_distinct_id) {
        this.track('$identify', {
            'distinct_id': new_distinct_id,
            '$anon_distinct_id': previous_distinct_id
        }, {skip_hooks: true});
    }
};

/**
 * Clears super properties and generates a new random distinct_id for this instance.
 * Useful for clearing data when a user logs out.
 */
MixpanelLib.prototype.reset = function() {
    this['persistence'].clear();
    this._flags.identify_called = false;
    var uuid = _.UUID();
    this.register_once({
        'distinct_id': DEVICE_ID_PREFIX + uuid,
        '$device_id': uuid
    }, '');
};

/**
 * Returns the current distinct id of the user. This is either the id automatically
 * generated by the library or the id that has been passed by a call to identify().
 *
 * ### Notes:
 *
 * get_distinct_id() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // set distinct_id after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             distinct_id = mixpanel.get_distinct_id();
 *         }
 *     });
 */
MixpanelLib.prototype.get_distinct_id = function() {
    return this.get_property('distinct_id');
};

/**
 * The alias method creates an alias which Mixpanel will use to
 * remap one id to another. Multiple aliases can point to the
 * same identifier.
 *
 * The following is a valid use of alias:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // You can add multiple id aliases to the existing ID
 *     mixpanel.alias('newer_id', 'existing_id');
 *
 * Aliases can also be chained - the following is a valid example:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // chain newer_id - new_id - existing_id
 *     mixpanel.alias('newer_id', 'new_id');
 *
 * Aliases cannot point to multiple identifiers - the following
 * example will not work:
 *
 *     mixpanel.alias('new_id', 'existing_id');
 *     // this is invalid as 'new_id' already points to 'existing_id'
 *     mixpanel.alias('new_id', 'newer_id');
 *
 * ### Notes:
 *
 * If your project does not have
 * <a href="https://help.mixpanel.com/hc/en-us/articles/360039133851">ID Merge</a>
 * enabled, the best practice is to call alias once when a unique
 * ID is first created for a user (e.g., when a user first registers
 * for an account). Do not use alias multiple times for a single
 * user without ID Merge enabled.
 *
 * @param {String} alias A unique identifier that you want to use for this user in the future.
 * @param {String} [original] The current identifier being used for this user.
 */
MixpanelLib.prototype.alias = function(alias, original) {
    // If the $people_distinct_id key exists in persistence, there has been a previous
    // mixpanel.people.identify() call made for this user. It is VERY BAD to make an alias with
    // this ID, as it will duplicate users.
    if (alias === this.get_property(PEOPLE_DISTINCT_ID_KEY)) {
        this.report_error('Attempting to create alias for existing People user - aborting.');
        return -2;
    }

    var _this = this;
    if (_.isUndefined(original)) {
        original = this.get_distinct_id();
    }
    if (alias !== original) {
        this._register_single(ALIAS_ID_KEY, alias);
        return this.track('$create_alias', {
            'alias': alias,
            'distinct_id': original
        }, {
            skip_hooks: true
        }, function() {
            // Flush the people queue
            _this.identify(alias);
        });
    } else {
        this.report_error('alias matches current distinct_id - skipping api call.');
        this.identify(alias);
        return -1;
    }
};

/**
 * Provide a string to recognize the user by. The string passed to
 * this method will appear in the Mixpanel Streams product rather
 * than an automatically generated name. Name tags do not have to
 * be unique.
 *
 * This value will only be included in Streams data.
 *
 * @param {String} name_tag A human readable name for the user
 * @deprecated
 */
MixpanelLib.prototype.name_tag = function(name_tag) {
    this._register_single('mp_name_tag', name_tag);
};

/**
 * Update the configuration of a mixpanel library instance.
 *
 * The default config is:
 *
 *     {
 *       // host for requests (customizable for e.g. a local proxy)
 *       api_host: 'https://api-js.mixpanel.com',
 *
 *       // endpoints for different types of requests
 *       api_routes: {
 *         track: 'track/',
 *         engage: 'engage/',
 *         groups: 'groups/',
 *       }
 *
 *       // HTTP method for tracking requests
 *       api_method: 'POST'
 *
 *       // transport for sending requests ('XHR' or 'sendBeacon')
 *       // NB: sendBeacon should only be used for scenarios such as
 *       // page unload where a "best-effort" attempt to send is
 *       // acceptable; the sendBeacon API does not support callbacks
 *       // or any way to know the result of the request. Mixpanel
 *       // tracking via sendBeacon will not support any event-
 *       // batching or retry mechanisms.
 *       api_transport: 'XHR'
 *
 *       // request-batching/queueing/retry
 *       batch_requests: true,
 *
 *       // maximum number of events/updates to send in a single
 *       // network request
 *       batch_size: 50,
 *
 *       // milliseconds to wait between sending batch requests
 *       batch_flush_interval_ms: 5000,
 *
 *       // milliseconds to wait for network responses to batch requests
 *       // before they are considered timed-out and retried
 *       batch_request_timeout_ms: 90000,
 *
 *       // override value for cookie domain, only useful for ensuring
 *       // correct cross-subdomain cookies on unusual domains like
 *       // subdomain.mainsite.avocat.fr; NB this cannot be used to
 *       // set cookies on a different domain than the current origin
 *       cookie_domain: ''
 *
 *       // super properties cookie expiration (in days)
 *       cookie_expiration: 365
 *
 *       // if true, cookie will be set with SameSite=None; Secure
 *       // this is only useful in special situations, like embedded
 *       // 3rd-party iframes that set up a Mixpanel instance
 *       cross_site_cookie: false
 *
 *       // super properties span subdomains
 *       cross_subdomain_cookie: true
 *
 *       // debug mode
 *       debug: false
 *
 *       // if this is true, the mixpanel cookie or localStorage entry
 *       // will be deleted, and no user persistence will take place
 *       disable_persistence: false
 *
 *       // if this is true, Mixpanel will automatically determine
 *       // City, Region and Country data using the IP address of
 *       //the client
 *       ip: true
 *
 *       // opt users out of tracking by this Mixpanel instance by default
 *       opt_out_tracking_by_default: false
 *
 *       // opt users out of browser data storage by this Mixpanel instance by default
 *       opt_out_persistence_by_default: false
 *
 *       // persistence mechanism used by opt-in/opt-out methods - cookie
 *       // or localStorage - falls back to cookie if localStorage is unavailable
 *       opt_out_tracking_persistence_type: 'localStorage'
 *
 *       // customize the name of cookie/localStorage set by opt-in/opt-out methods
 *       opt_out_tracking_cookie_prefix: null
 *
 *       // type of persistent store for super properties (cookie/
 *       // localStorage) if set to 'localStorage', any existing
 *       // mixpanel cookie value with the same persistence_name
 *       // will be transferred to localStorage and deleted
 *       persistence: 'cookie'
 *
 *       // name for super properties persistent store
 *       persistence_name: ''
 *
 *       // names of properties/superproperties which should never
 *       // be sent with track() calls
 *       property_blacklist: []
 *
 *       // if this is true, mixpanel cookies will be marked as
 *       // secure, meaning they will only be transmitted over https
 *       secure_cookie: false
 *
 *       // disables enriching user profiles with first touch marketing data
 *       skip_first_touch_marketing: false
 *
 *       // the amount of time track_links will
 *       // wait for Mixpanel's servers to respond
 *       track_links_timeout: 300
 *
 *       // adds any UTM parameters and click IDs present on the page to any events fired
 *       track_marketing: true
 *
 *       // enables automatic page view tracking using default page view events through
 *       // the track_pageview() method
 *       track_pageview: false
 *
 *       // if you set upgrade to be true, the library will check for
 *       // a cookie from our old js library and import super
 *       // properties from it, then the old cookie is deleted
 *       // The upgrade config option only works in the initialization,
 *       // so make sure you set it when you create the library.
 *       upgrade: false
 *
 *       // extra HTTP request headers to set for each API request, in
 *       // the format {'Header-Name': value}
 *       xhr_headers: {}
 *
 *       // whether to ignore or respect the web browser's Do Not Track setting
 *       ignore_dnt: false
 *     }
 *
 *
 * @param {Object} config A dictionary of new configuration values to update
 */
MixpanelLib.prototype.set_config = function(config) {
    if (_.isObject(config)) {
        _.extend(this['config'], config);

        var new_batch_size = config['batch_size'];
        if (new_batch_size) {
            _.each(this.request_batchers, function(batcher) {
                batcher.resetBatchSize();
            });
        }

        if (!this.get_config('persistence_name')) {
            this['config']['persistence_name'] = this['config']['cookie_name'];
        }
        if (!this.get_config('disable_persistence')) {
            this['config']['disable_persistence'] = this['config']['disable_cookie'];
        }

        if (this['persistence']) {
            this['persistence'].update_config(this['config']);
        }
        Config.DEBUG = Config.DEBUG || this.get_config('debug');
    }
};

/**
 * returns the current config object for the library.
 */
MixpanelLib.prototype.get_config = function(prop_name) {
    return this['config'][prop_name];
};

/**
 * Fetch a hook function from config, with safe default, and run it
 * against the given arguments
 * @param {string} hook_name which hook to retrieve
 * @returns {any|null} return value of user-provided hook, or null if nothing was returned
 */
MixpanelLib.prototype._run_hook = function(hook_name) {
    var ret = (this['config']['hooks'][hook_name] || IDENTITY_FUNC).apply(this, slice.call(arguments, 1));
    if (typeof ret === 'undefined') {
        this.report_error(hook_name + ' hook did not return a value');
        ret = null;
    }
    return ret;
};

/**
 * Returns the value of the super property named property_name. If no such
 * property is set, get_property() will return the undefined value.
 *
 * ### Notes:
 *
 * get_property() can only be called after the Mixpanel library has finished loading.
 * init() has a loaded function available to handle this automatically. For example:
 *
 *     // grab value for 'user_id' after the mixpanel library has loaded
 *     mixpanel.init('YOUR PROJECT TOKEN', {
 *         loaded: function(mixpanel) {
 *             user_id = mixpanel.get_property('user_id');
 *         }
 *     });
 *
 * @param {String} property_name The name of the super property you want to retrieve
 */
MixpanelLib.prototype.get_property = function(property_name) {
    return this['persistence'].load_prop([property_name]);
};

MixpanelLib.prototype.toString = function() {
    var name = this.get_config('name');
    if (name !== PRIMARY_INSTANCE_NAME) {
        name = PRIMARY_INSTANCE_NAME + '.' + name;
    }
    return name;
};

MixpanelLib.prototype._event_is_disabled = function(event_name) {
    return _.isBlockedUA(userAgent) ||
        this._flags.disable_all_events ||
        _.include(this.__disabled_events, event_name);
};

// perform some housekeeping around GDPR opt-in/out state
MixpanelLib.prototype._gdpr_init = function() {
    var is_localStorage_requested = this.get_config('opt_out_tracking_persistence_type') === 'localStorage';

    // try to convert opt-in/out cookies to localStorage if possible
    if (is_localStorage_requested && _.localStorage.is_supported()) {
        if (!this.has_opted_in_tracking() && this.has_opted_in_tracking({'persistence_type': 'cookie'})) {
            this.opt_in_tracking({'enable_persistence': false});
        }
        if (!this.has_opted_out_tracking() && this.has_opted_out_tracking({'persistence_type': 'cookie'})) {
            this.opt_out_tracking({'clear_persistence': false});
        }
        this.clear_opt_in_out_tracking({
            'persistence_type': 'cookie',
            'enable_persistence': false
        });
    }

    // check whether the user has already opted out - if so, clear & disable persistence
    if (this.has_opted_out_tracking()) {
        this._gdpr_update_persistence({'clear_persistence': true});

    // check whether we should opt out by default
    // note: we don't clear persistence here by default since opt-out default state is often
    //       used as an initial state while GDPR information is being collected
    } else if (!this.has_opted_in_tracking() && (
        this.get_config('opt_out_tracking_by_default') || _.cookie.get('mp_optout')
    )) {
        _.cookie.remove('mp_optout');
        this.opt_out_tracking({
            'clear_persistence': this.get_config('opt_out_persistence_by_default')
        });
    }
};

/**
 * Enable or disable persistence based on options
 * only enable/disable if persistence is not already in this state
 * @param {boolean} [options.clear_persistence] If true, will delete all data stored by the sdk in persistence and disable it
 * @param {boolean} [options.enable_persistence] If true, will re-enable sdk persistence
 */
MixpanelLib.prototype._gdpr_update_persistence = function(options) {
    var disabled;
    if (options && options['clear_persistence']) {
        disabled = true;
    } else if (options && options['enable_persistence']) {
        disabled = false;
    } else {
        return;
    }

    if (!this.get_config('disable_persistence') && this['persistence'].disabled !== disabled) {
        this['persistence'].set_disabled(disabled);
    }

    if (disabled) {
        this.stop_batch_senders();
    } else {
        // only start batchers after opt-in if they have previously been started
        // in order to avoid unintentionally starting up batching for the first time
        if (this._batchers_were_started) {
            this.start_batch_senders();
        }
    }
};

// call a base gdpr function after constructing the appropriate token and options args
MixpanelLib.prototype._gdpr_call_func = function(func, options) {
    options = _.extend({
        'track': _.bind(this.track, this),
        'persistence_type': this.get_config('opt_out_tracking_persistence_type'),
        'cookie_prefix': this.get_config('opt_out_tracking_cookie_prefix'),
        'cookie_expiration': this.get_config('cookie_expiration'),
        'cross_site_cookie': this.get_config('cross_site_cookie'),
        'cross_subdomain_cookie': this.get_config('cross_subdomain_cookie'),
        'cookie_domain': this.get_config('cookie_domain'),
        'secure_cookie': this.get_config('secure_cookie'),
        'ignore_dnt': this.get_config('ignore_dnt')
    }, options);

    // check if localStorage can be used for recording opt out status, fall back to cookie if not
    if (!_.localStorage.is_supported()) {
        options['persistence_type'] = 'cookie';
    }

    return func(this.get_config('token'), {
        track: options['track'],
        trackEventName: options['track_event_name'],
        trackProperties: options['track_properties'],
        persistenceType: options['persistence_type'],
        persistencePrefix: options['cookie_prefix'],
        cookieDomain: options['cookie_domain'],
        cookieExpiration: options['cookie_expiration'],
        crossSiteCookie: options['cross_site_cookie'],
        crossSubdomainCookie: options['cross_subdomain_cookie'],
        secureCookie: options['secure_cookie'],
        ignoreDnt: options['ignore_dnt']
    });
};

/**
 * Opt the user in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user in
 *     mixpanel.opt_in_tracking();
 *
 *     // opt user in with specific event name, properties, cookie configuration
 *     mixpanel.opt_in_tracking({
 *         track_event_name: 'User opted in',
 *         track_event_properties: {
 *             'Email': 'jdoe@example.com'
 *         },
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {function} [options.track] Function used for tracking a Mixpanel event to record the opt-in action (default is this Mixpanel instance's track method)
 * @param {string} [options.track_event_name=$opt_in] Event name to be used for tracking the opt-in action
 * @param {Object} [options.track_properties] Set of properties to be tracked along with the opt-in action
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.opt_in_tracking = function(options) {
    options = _.extend({
        'enable_persistence': true
    }, options);

    this._gdpr_call_func(optIn, options);
    this._gdpr_update_persistence(options);
};

/**
 * Opt the user out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // opt user out
 *     mixpanel.opt_out_tracking();
 *
 *     // opt user out with different cookie configuration from Mixpanel instance
 *     mixpanel.opt_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.delete_user=true] If true, will delete the currently identified user's profile and clear all charges after opting the user out
 * @param {boolean} [options.clear_persistence=true] If true, will delete all data stored by the sdk in persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.opt_out_tracking = function(options) {
    options = _.extend({
        'clear_persistence': true,
        'delete_user': true
    }, options);

    // delete user and clear charges since these methods may be disabled by opt-out
    if (options['delete_user'] && this['people'] && this['people']._identify_called()) {
        this['people'].delete_user();
        this['people'].clear_charges();
    }

    this._gdpr_call_func(optOut, options);
    this._gdpr_update_persistence(options);
};

/**
 * Check whether the user has opted in to data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_in = mixpanel.has_opted_in_tracking();
 *     // use has_opted_in value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-in status
 */
MixpanelLib.prototype.has_opted_in_tracking = function(options) {
    return this._gdpr_call_func(hasOptedIn, options);
};

/**
 * Check whether the user has opted out of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     var has_opted_out = mixpanel.has_opted_out_tracking();
 *     // use has_opted_out value
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @returns {boolean} current opt-out status
 */
MixpanelLib.prototype.has_opted_out_tracking = function(options) {
    return this._gdpr_call_func(hasOptedOut, options);
};

/**
 * Clear the user's opt in/out status of data tracking and cookies/localstorage for this Mixpanel instance
 *
 * ### Usage
 *
 *     // clear user's opt-in/out status
 *     mixpanel.clear_opt_in_out_tracking();
 *
 *     // clear user's opt-in/out status with specific cookie configuration - should match
 *     // configuration used when opt_in_tracking/opt_out_tracking methods were called.
 *     mixpanel.clear_opt_in_out_tracking({
 *         cookie_expiration: 30,
 *         secure_cookie: true
 *     });
 *
 * @param {Object} [options] A dictionary of config options to override
 * @param {boolean} [options.enable_persistence=true] If true, will re-enable sdk persistence
 * @param {string} [options.persistence_type=localStorage] Persistence mechanism used - cookie or localStorage - falls back to cookie if localStorage is unavailable
 * @param {string} [options.cookie_prefix=__mp_opt_in_out] Custom prefix to be used in the cookie/localstorage name
 * @param {Number} [options.cookie_expiration] Number of days until the opt-in cookie expires (overrides value specified in this Mixpanel instance's config)
 * @param {string} [options.cookie_domain] Custom cookie domain (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_site_cookie] Whether the opt-in cookie is set as cross-site-enabled (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.cross_subdomain_cookie] Whether the opt-in cookie is set as cross-subdomain or not (overrides value specified in this Mixpanel instance's config)
 * @param {boolean} [options.secure_cookie] Whether the opt-in cookie is set as secure or not (overrides value specified in this Mixpanel instance's config)
 */
MixpanelLib.prototype.clear_opt_in_out_tracking = function(options) {
    options = _.extend({
        'enable_persistence': true
    }, options);

    this._gdpr_call_func(clearOptInOut, options);
    this._gdpr_update_persistence(options);
};

MixpanelLib.prototype.report_error = function(msg, err) {
    console$1.error.apply(console$1.error, arguments);
    try {
        if (!err && !(msg instanceof Error)) {
            msg = new Error(msg);
        }
        this.get_config('error_reporter')(msg, err);
    } catch(err) {
        console$1.error(err);
    }
};

// EXPORTS (for closure compiler)

// MixpanelLib Exports
MixpanelLib.prototype['init']                      = MixpanelLib.prototype.init;
MixpanelLib.prototype['reset']                     = MixpanelLib.prototype.reset;
MixpanelLib.prototype['disable']                   = MixpanelLib.prototype.disable;
MixpanelLib.prototype['time_event']                = MixpanelLib.prototype.time_event;
MixpanelLib.prototype['track']                     = MixpanelLib.prototype.track;
MixpanelLib.prototype['track_links']               = MixpanelLib.prototype.track_links;
MixpanelLib.prototype['track_forms']               = MixpanelLib.prototype.track_forms;
MixpanelLib.prototype['track_pageview']            = MixpanelLib.prototype.track_pageview;
MixpanelLib.prototype['register']                  = MixpanelLib.prototype.register;
MixpanelLib.prototype['register_once']             = MixpanelLib.prototype.register_once;
MixpanelLib.prototype['unregister']                = MixpanelLib.prototype.unregister;
MixpanelLib.prototype['identify']                  = MixpanelLib.prototype.identify;
MixpanelLib.prototype['alias']                     = MixpanelLib.prototype.alias;
MixpanelLib.prototype['name_tag']                  = MixpanelLib.prototype.name_tag;
MixpanelLib.prototype['set_config']                = MixpanelLib.prototype.set_config;
MixpanelLib.prototype['get_config']                = MixpanelLib.prototype.get_config;
MixpanelLib.prototype['get_property']              = MixpanelLib.prototype.get_property;
MixpanelLib.prototype['get_distinct_id']           = MixpanelLib.prototype.get_distinct_id;
MixpanelLib.prototype['toString']                  = MixpanelLib.prototype.toString;
MixpanelLib.prototype['opt_out_tracking']          = MixpanelLib.prototype.opt_out_tracking;
MixpanelLib.prototype['opt_in_tracking']           = MixpanelLib.prototype.opt_in_tracking;
MixpanelLib.prototype['has_opted_out_tracking']    = MixpanelLib.prototype.has_opted_out_tracking;
MixpanelLib.prototype['has_opted_in_tracking']     = MixpanelLib.prototype.has_opted_in_tracking;
MixpanelLib.prototype['clear_opt_in_out_tracking'] = MixpanelLib.prototype.clear_opt_in_out_tracking;
MixpanelLib.prototype['get_group']                 = MixpanelLib.prototype.get_group;
MixpanelLib.prototype['set_group']                 = MixpanelLib.prototype.set_group;
MixpanelLib.prototype['add_group']                 = MixpanelLib.prototype.add_group;
MixpanelLib.prototype['remove_group']              = MixpanelLib.prototype.remove_group;
MixpanelLib.prototype['track_with_groups']         = MixpanelLib.prototype.track_with_groups;
MixpanelLib.prototype['start_batch_senders']       = MixpanelLib.prototype.start_batch_senders;
MixpanelLib.prototype['stop_batch_senders']        = MixpanelLib.prototype.stop_batch_senders;
MixpanelLib.prototype['DEFAULT_API_ROUTES']        = DEFAULT_API_ROUTES;

// MixpanelPersistence Exports
MixpanelPersistence.prototype['properties']            = MixpanelPersistence.prototype.properties;
MixpanelPersistence.prototype['update_search_keyword'] = MixpanelPersistence.prototype.update_search_keyword;
MixpanelPersistence.prototype['update_referrer_info']  = MixpanelPersistence.prototype.update_referrer_info;
MixpanelPersistence.prototype['get_cross_subdomain']   = MixpanelPersistence.prototype.get_cross_subdomain;
MixpanelPersistence.prototype['clear']                 = MixpanelPersistence.prototype.clear;


var instances = {};
var extend_mp = function() {
    // add all the sub mixpanel instances
    _.each(instances, function(instance, name) {
        if (name !== PRIMARY_INSTANCE_NAME) { mixpanel_master[name] = instance; }
    });

    // add private functions as _
    mixpanel_master['_'] = _;
};

var override_mp_init_func = function() {
    // we override the snippets init function to handle the case where a
    // user initializes the mixpanel library after the script loads & runs
    mixpanel_master['init'] = function(token, config, name) {
        if (name) {
            // initialize a sub library
            if (!mixpanel_master[name]) {
                mixpanel_master[name] = instances[name] = create_mplib(token, config, name);
                mixpanel_master[name]._loaded();
            }
            return mixpanel_master[name];
        } else {
            var instance = mixpanel_master;

            if (instances[PRIMARY_INSTANCE_NAME]) {
                // main mixpanel lib already initialized
                instance = instances[PRIMARY_INSTANCE_NAME];
            } else if (token) {
                // intialize the main mixpanel lib
                instance = create_mplib(token, config, PRIMARY_INSTANCE_NAME);
                instance._loaded();
                instances[PRIMARY_INSTANCE_NAME] = instance;
            }

            mixpanel_master = instance;
            if (init_type === INIT_SNIPPET) {
                window$1[PRIMARY_INSTANCE_NAME] = mixpanel_master;
            }
            extend_mp();
        }
    };
};

var add_dom_loaded_handler = function() {
    // Cross browser DOM Loaded support
    function dom_loaded_handler() {
        // function flag since we only want to execute this once
        if (dom_loaded_handler.done) { return; }
        dom_loaded_handler.done = true;

        DOM_LOADED = true;
        ENQUEUE_REQUESTS = false;

        _.each(instances, function(inst) {
            inst._dom_loaded();
        });
    }

    function do_scroll_check() {
        try {
            document$1.documentElement.doScroll('left');
        } catch(e) {
            setTimeout(do_scroll_check, 1);
            return;
        }

        dom_loaded_handler();
    }

    if (document$1.addEventListener) {
        if (document$1.readyState === 'complete') {
            // safari 4 can fire the DOMContentLoaded event before loading all
            // external JS (including this file). you will see some copypasta
            // on the internet that checks for 'complete' and 'loaded', but
            // 'loaded' is an IE thing
            dom_loaded_handler();
        } else {
            document$1.addEventListener('DOMContentLoaded', dom_loaded_handler, false);
        }
    } else if (document$1.attachEvent) {
        // IE
        document$1.attachEvent('onreadystatechange', dom_loaded_handler);

        // check to make sure we arn't in a frame
        var toplevel = false;
        try {
            toplevel = window$1.frameElement === null;
        } catch(e) {
            // noop
        }

        if (document$1.documentElement.doScroll && toplevel) {
            do_scroll_check();
        }
    }

    // fallback handler, always will work
    _.register_event(window$1, 'load', dom_loaded_handler, true);
};

function init_as_module() {
    init_type = INIT_MODULE;
    mixpanel_master = new MixpanelLib();

    override_mp_init_func();
    mixpanel_master['init']();
    add_dom_loaded_handler();

    return mixpanel_master;
}

var mixpanel = init_as_module();

var mixpanel_cjs = mixpanel;

var __importDefault = (commonjsGlobal$1 && commonjsGlobal$1.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(mixpanelInstance, "__esModule", { value: true });
mixpanelInstance.mixpanelTimeEvent = mixpanelInstance.mixpanelTrack = mixpanelInstance.mixpanelReset = mixpanelInstance.mixpanelIdentify = mixpanelInstance.mixpanelInit = void 0;
var mixpanel_browser_1 = __importDefault(mixpanel_cjs);
var mixpanelVerify = process.env.CB_USE_MIXPANEL == 'true';
var mixpanelInit = function () {
    mixpanelVerify &&
        mixpanel_browser_1.default.init(process.env.CB_MIXPANEL_TOKEN || '', {
            debug: true,
            track_pageview: false,
            persistence: 'localStorage'
        });
};
mixpanelInstance.mixpanelInit = mixpanelInit;
var mixpanelIdentify = function (props) {
    var id = props.id, tenant = props.tenant, locale = props.locale, role = props.role, isLean = props.isLean;
    if (mixpanelVerify) {
        mixpanel_browser_1.default.identify(id);
        mixpanel_browser_1.default.register({
            tenant: tenant,
            locale: locale,
            role: role,
            isLean: isLean
        });
    }
};
mixpanelInstance.mixpanelIdentify = mixpanelIdentify;
var mixpanelReset = function () {
    mixpanelVerify && mixpanel_browser_1.default.reset();
};
mixpanelInstance.mixpanelReset = mixpanelReset;
var mixpanelTrack = function (props) {
    var eventName = props.eventName, properties = props.properties, optionsOrCallback = props.optionsOrCallback, callback = props.callback;
    mixpanelVerify && mixpanel_browser_1.default.track(eventName, properties, optionsOrCallback, callback);
};
mixpanelInstance.mixpanelTrack = mixpanelTrack;
var mixpanelTimeEvent = function (endEvent) {
    mixpanelVerify && mixpanel_browser_1.default.time_event(endEvent);
};
mixpanelInstance.mixpanelTimeEvent = mixpanelTimeEvent;

var labs = {};

Object.defineProperty(labs, "__esModule", { value: true });
var getColorByScore = function (score) {
    if (score === undefined) {
        return '#9BA0FB';
    }
    if (score >= 75) {
        return '#32A26C';
    }
    if (score >= 50) {
        return '#FCD851';
    }
    if (score >= 25) {
        return '#FC9963';
    }
    return '#FC4F78';
};
labs.default = getColorByScore;

var initSaola = {};

(function (exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.customEvent = exports.stop = exports.start = exports.init = void 0;
	var VERSION_PLACEHOLDER = 'v1.1.3';
	var SDK_URL = "https://www.saola.ai/sdk/saola.".concat(VERSION_PLACEHOLDER, ".js");
	var win = window;
	var initialized = false;
	var init = function (accountToken, version, customOptions) {
	    if (version === void 0) { version = 'latest'; }
	    if (customOptions === void 0) { customOptions = {}; }
	    if (initialized)
	        return;
	    setParams(accountToken, customOptions);
	    injectSDK(version);
	    initialized = true;
	};
	exports.init = init;
	var start = function () {
	    if (!win.Saola || !win.Saola.start)
	        return;
	    win.Saola.start();
	};
	exports.start = start;
	var stop = function () {
	    if (!win.Saola || !win.Saola.stop)
	        return;
	    win.Saola.stop();
	};
	exports.stop = stop;
	var customEvent = function (eventType, data) {
	    if (!win.Saola || !win.Saola.customEvent)
	        return;
	    win.Saola.customEvent(eventType, data);
	};
	exports.customEvent = customEvent;
	var setParams = function (accountToken, customOptions) {
	    if (customOptions === void 0) { customOptions = {}; }
	    win.SaolaParams = { token: accountToken, options: customOptions };
	};
	var injectSDK = function (version) {
	    var SDKScript = win.document.createElement('script');
	    SDKScript.defer = true;
	    SDKScript.src = SDK_URL.replace(VERSION_PLACEHOLDER, version);
	    win.document.head.appendChild(SDKScript);
	};
	exports.default = exports.init; 
} (initSaola));

var customBrandNameLogoMapping = {};

Object.defineProperty(customBrandNameLogoMapping, "__esModule", { value: true });
var getLogoNameBrandName = function (brandName) {
    if (!brandName) {
        return 'cbLogo';
    }
    var brandNameToLogo = {
        CodeDefender: 'appleLogo'
    };
    return brandNameToLogo[brandName] || 'cbLogo';
};
customBrandNameLogoMapping.default = getLogoNameBrandName;

(function (exports) {
	var __createBinding = (commonjsGlobal$1 && commonjsGlobal$1.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (commonjsGlobal$1 && commonjsGlobal$1.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
	};
	var __importDefault = (commonjsGlobal$1 && commonjsGlobal$1.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getLogoNameBrandName = exports.initializeSaola = exports.getColorByScore = exports.getParentRouteByRole = exports.getPlatformUrl = exports.getTenant = exports.badges = exports.getTags = void 0;
	__exportStar(filesTreeViewUtils, exports);
	__exportStar(iframeFunctions, exports);
	__exportStar(dateTimeUtils, exports);
	__exportStar(stringUtils, exports);
	__exportStar(testFunctions, exports);
	__exportStar(constants, exports);
	var tags_1 = tags;
	Object.defineProperty(exports, "getTags", { enumerable: true, get: function () { return __importDefault(tags_1).default; } });
	var badgesMapping_1 = badgesMapping;
	Object.defineProperty(exports, "badges", { enumerable: true, get: function () { return __importDefault(badgesMapping_1).default; } });
	var getTenant_1 = getTenant$1;
	Object.defineProperty(exports, "getTenant", { enumerable: true, get: function () { return __importDefault(getTenant_1).default; } });
	var getPlatformUrl_1 = getPlatformUrl$1;
	Object.defineProperty(exports, "getPlatformUrl", { enumerable: true, get: function () { return __importDefault(getPlatformUrl_1).default; } });
	__exportStar(functions, exports);
	__exportStar(dateFormats$1o, exports);
	var getParentRouteByRole_1 = getParentRouteByRole$1;
	Object.defineProperty(exports, "getParentRouteByRole", { enumerable: true, get: function () { return __importDefault(getParentRouteByRole_1).default; } });
	__exportStar(passwordValidation, exports);
	__exportStar(fullNameValidation, exports);
	__exportStar(initializeGainsight, exports);
	__exportStar(programLanguages, exports);
	__exportStar(mixpanelInstance, exports);
	var labs_1 = labs;
	Object.defineProperty(exports, "getColorByScore", { enumerable: true, get: function () { return __importDefault(labs_1).default; } });
	var initSaola_1 = initSaola;
	Object.defineProperty(exports, "initializeSaola", { enumerable: true, get: function () { return __importDefault(initSaola_1).default; } });
	var customBrandNameLogoMapping_1 = customBrandNameLogoMapping;
	Object.defineProperty(exports, "getLogoNameBrandName", { enumerable: true, get: function () { return __importDefault(customBrandNameLogoMapping_1).default; } }); 
} (lib$1));

var SelectTypesName;
(function (SelectTypesName) {
    SelectTypesName[SelectTypesName["primary"] = 0] = "primary";
    SelectTypesName[SelectTypesName["purple"] = 1] = "purple";
    SelectTypesName[SelectTypesName["adminPanel"] = 2] = "adminPanel";
})(SelectTypesName || (SelectTypesName = {}));
const selectType = {
    primary: {},
    purple: { className: 'purple' },
    adminPanel: { className: 'adminPanel' }
};
const selectDefaultValueKey = 'Select';

var css_248z$1f = ".select-module_class-ellipsis-2-lines__8SfDR,.select-module_class-ellipsis-lines__HEEL9{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.select-module_class-ellipsis-2-lines__8SfDR{-webkit-line-clamp:2!important;max-height:4rem!important}.select-module_MuiChip-root__XZFrd{margin:.5rem .3rem .5rem .5rem}.select-module_ellipse-chip__WfUb-.select-module_MuiChip-root__XZFrd{border-radius:1rem;height:20px}.select-module_ellipse-chip__WfUb-.select-module_MuiChip-root__XZFrd .select-module_MuiChip-label__XfR8g{padding-left:8px;padding-right:8px}.select-module_square-chip__of1-m.select-module_MuiChip-root__XZFrd{border-radius:0!important}.select-module_class-width-height-100__IeHgQ{height:100%;width:100%}.select-module_MuiTooltip-tooltip__-9z-r{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.select-module_MuiTooltip-arrow__p7wtI{color:#fff!important}.select-module_class-font-size-icon__zOBv6{font-size:1.25rem}.select-module_full-width__bPVj1{width:100%}.select-module_select-component__wv8WC{background-color:#fff;height:2.5rem}.select-module_select-component__wv8WC .select-module_select-component-input__P-ONc{padding-bottom:.625rem!important;padding-top:.625rem!important}.select-module_select-component-label__un91q{line-height:1.25rem!important;transform:translate(14px,.625rem)!important}.select-module_select-component-label__un91q.MuiInputLabel-outlined.MuiInputLabel-shrink{transform:translate(14px,-6px) scale(.75)!important}.select-module_purple__7NCPh{background-color:transparent}.select-module_purple__7NCPh .MuiPaper-root.MuiPopover-paper{color:#fff}.select-module_purple__7NCPh .MuiList-padding{padding-bottom:0;padding-top:0}.select-module_purple__7NCPh .MuiPaper-root{background-color:#2f1d61}.select-module_purple__7NCPh .MuiMenuItem-root{border-top:.01px solid hsla(0,0%,100%,.502)}.select-module_purple__7NCPh .MuiMenuItem-root:nth-child(odd){background:#382470}.select-module_purple__7NCPh .MuiInputBase-input{color:hsla(0,0%,100%,.702)}.select-module_purple__7NCPh .MuiOutlinedInput-notchedOutline{border:1px solid #b4b2bc!important}.select-module_purple__7NCPh svg{color:hsla(0,0%,100%,.7)}.select-module_adminPanel__AYsGp{background-color:transparent}.select-module_adminPanel__AYsGp .select-module_MuiPaper-root__lunIB.select-module_MuiPopover-paper__N7tHP{color:#626262}.select-module_adminPanel__AYsGp .MuiList-padding{min-height:10.4rem;padding-bottom:0;padding-top:0}.select-module_adminPanel__AYsGp .MuiMenuItem-root{background-color:transparent;border-radius:4px;margin:0 .8rem}.select-module_adminPanel__AYsGp .MuiSelect-selectMenu{min-height:0;min-width:fit-content}.select-module_adminPanel__AYsGp .MuiMenuItem-root.Mui-selected,.select-module_adminPanel__AYsGp .MuiMenuItem-root:hover{background:linear-gradient(83.41deg,rgba(226,216,247,.4) 2.82%,rgba(242,125,177,.05) 52.7%,rgba(226,216,247,.4) 94.71%);border-radius:4px;margin:0 .8rem}.select-module_adminPanel__AYsGp .MuiMenuItem-root:last-child{margin-bottom:1rem!important}.select-module_adminPanel__AYsGp .MuiOutlinedInput-notchedOutline{border:1px solid #b4b2bc!important}.select-module_adminPanel__AYsGp .MuiSelect-outlined.MuiSelect-outlined,.select-module_adminPanel__AYsGp .MuiSelect-select.MuiSelect-select{padding-right:0}.select-module_adminPanel__AYsGp .MuiOutlinedInput-notchedOutline{border:0!important}.select-module_adminPanel__AYsGp .MuiFormHelperText-root{margin:0}.select-module_adminPanel__AYsGp .MuiInputBase-input{color:#626262;font-size:.875rem;font-weight:400}.select-module_adminPanel__AYsGp svg{color:#626262}";
var styles$F = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"select-module_class-ellipsis-lines__HEEL9","class-ellipsis-2-lines":"select-module_class-ellipsis-2-lines__8SfDR","MuiChip-root":"select-module_MuiChip-root__XZFrd","ellipse-chip":"select-module_ellipse-chip__WfUb-","MuiChip-label":"select-module_MuiChip-label__XfR8g","square-chip":"select-module_square-chip__of1-m","class-width-height-100":"select-module_class-width-height-100__IeHgQ","MuiTooltip-tooltip":"select-module_MuiTooltip-tooltip__-9z-r","MuiTooltip-arrow":"select-module_MuiTooltip-arrow__p7wtI","class-font-size-icon":"select-module_class-font-size-icon__zOBv6","full-width":"select-module_full-width__bPVj1","select-component":"select-module_select-component__wv8WC","select-component-input":"select-module_select-component-input__P-ONc","select-component-label":"select-module_select-component-label__un91q","purple":"select-module_purple__7NCPh","adminPanel":"select-module_adminPanel__AYsGp","MuiPaper-root":"select-module_MuiPaper-root__lunIB","MuiPopover-paper":"select-module_MuiPopover-paper__N7tHP"};
styleInject(css_248z$1f);

const SelectContainer = (props) => {
    var _a;
    const defaultValue = props.selectText;
    const { dataTestid = '', label = undefined, helperText = '', formClassName, className = '', value = defaultValue, list = [], iconOpen, iconClose, maxHeight = '20rem', fullWidth = true, childComponent: ChildComponent = OptionContainer, disableMenuItemEllipsis, onChange, inputClassName, optionWidth, showDefaultValueInItems = true, type, filterRef, notRenderIcon = false, outerOpen, onClose } = props, rest = __rest$1(props, ["dataTestid", "label", "helperText", "formClassName", "className", "value", "list", "iconOpen", "iconClose", "maxHeight", "fullWidth", "childComponent", "disableMenuItemEllipsis", "onChange", "inputClassName", "optionWidth", "showDefaultValueInItems", "type", "filterRef", "notRenderIcon", "outerOpen", "onClose"]);
    const [isOpen, setIsOpen] = useState(false);
    const isDefaultValue = value === selectDefaultValueKey;
    const auxiliaryProps = Object.assign({}, selectType[type || 'primary']);
    const selectClasses = classNames(styles$F['select-component'], className, styles$F[auxiliaryProps.className || ''], {
        'class-font-colour-gray': isDefaultValue
    });
    const useOptionValue = ((_a = list === null || list === void 0 ? void 0 : list[0]) === null || _a === void 0 ? void 0 : _a.optionValue) !== undefined;
    let optionValueMap = {};
    if (useOptionValue) {
        optionValueMap = list.reduce((map, item) => {
            const fullTitle = lib$1.concatStrings([item.title, item.subTitle, item.count ? `(${item.count})` : ''], ' ');
            map[item.optionValue || ''] = fullTitle;
            return map;
        }, {});
    }
    useEffect(() => {
        if (outerOpen !== undefined)
            setIsOpen(outerOpen);
    }, [outerOpen]);
    useEffect(() => {
        if (isOpen === false)
            onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [isOpen]);
    const getItemTitle = (itemValue) => {
        if (!useOptionValue)
            return String(itemValue);
        if (itemValue === selectDefaultValueKey)
            return String(defaultValue);
        return optionValueMap[itemValue];
    };
    const title = isDefaultValue ? '' : getItemTitle(value);
    return (jsxs(FormControl, Object.assign({ variant: "outlined", className: classNames(formClassName, { [styles$F['full-width']]: fullWidth }) }, { children: [jsx(InputLabel, Object.assign({ id: label, className: styles$F['select-component-label'] }, { children: label }), void 0), jsxs(Select, Object.assign({}, rest, { title: title, className: selectClasses, classes: { root: classNames(styles$F['select-component-input'], inputClassName) }, value: value, "data-testid": dataTestid, label: label, open: outerOpen, onOpen: () => setIsOpen(true), onClose: () => setIsOpen(false), IconComponent: isOpen ? iconOpen : iconClose, renderValue: () => title, inputProps: notRenderIcon ? { IconComponent: () => null } : {}, MenuProps: {
                    getContentAnchorEl: null,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    PaperProps: {
                        style: {
                            maxHeight
                        }
                    },
                    className: styles$F[auxiliaryProps.className || ''],
                    ref: filterRef
                } }, { children: [showDefaultValueInItems && (jsx(MenuItem, Object.assign({ value: defaultValue, disabled: true, className: className }, { children: defaultValue }), void 0)), list.map((item, i) => {
                        const itemTitle = lib$1.concatStrings([item.title, item.subTitle], ' ');
                        const itemValue = useOptionValue ? item.optionValue : itemTitle;
                        return (jsx(MenuItem, Object.assign({ value: itemValue, className: className, onClick: () => onChange(itemValue), disabled: item.disabled, title: itemTitle, id: item.id }, { children: jsx(ChildComponent, Object.assign({}, item, { isOpen: isOpen || outerOpen, disableMenuItemEllipsis: disableMenuItemEllipsis, optionWidth: optionWidth, isSelected: false }), void 0) }), i));
                    })] }), void 0), jsx(FormHelperText, Object.assign({ className: "class-no-margin-left" }, { children: helperText }), void 0)] }), label));
};

const userRelativePath = 'avatars/tournaments/';
const tournamentRelativePath = 'icons/tournaments/';
const fallbackRelativePath = 'icons/fallback.svg';
const getFallbackPath = () => `${process.env.PUBLIC_URL}/${fallbackRelativePath}`;
const getFullPathByType = (type, src) => {
    let relativePath;
    let imageSrc = src;
    switch (type) {
        case 'User':
            relativePath = userRelativePath;
            imageSrc = `${imageSrc}.svg`;
            break;
        default:
            relativePath = tournamentRelativePath;
            imageSrc = `${imageSrc}.svg`;
            break;
    }
    return `${process.env.PUBLIC_URL}/${relativePath}${imageSrc}`;
};

var css_248z$1e = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.margin-avatar{margin-right:2.5rem;margin-top:1.5rem}.animation-fade-in-2s{animation:fx-fadeIn 2s ease-in-out}.class-border-selected-icon svg>path:first-child{stroke:#22bcbe}.class-background-selected-icon svg>path:first-child{fill:#fb86b6}.class-opacity-half{opacity:.5}.class-hover-pointer:hover{cursor:pointer}@keyframes fx-fadeIn{0%{opacity:0}to{opacity:1}}@keyframes fx-fadeOut{0%{opacity:1}to{opacity:0}}";
styleInject(css_248z$1e);

const AvatarContainer = (props) => {
    const { type, src, name, isSelected = false, hasMargin = true, selectedAvatar, onClick, avatarSize = '5.5rem', isAnimated, className, getDefaultImage, toolTipText = '' } = props;
    const isPointer = Boolean(onClick);
    const avatarClassNames = classNames(className, 'avatars', {
        'margin-avatar': hasMargin,
        'animation-fade-in-2s': isAnimated,
        'class-border-selected-icon': isSelected,
        'class-background-selected-icon': isSelected && type === 'User',
        'class-opacity-half': !isSelected && selectedAvatar,
        'class-hover-pointer': isPointer
    });
    const fullPath = src || (type && name && getFullPathByType(type, name));
    return (jsx(DynamicSvg, { dataTestid: "avatar", className: avatarClassNames, fullPath: fullPath, getDefaultImage: getDefaultImage || getFallbackPath(), onClick: onClick, style: { width: avatarSize, height: avatarSize }, toolTipText: toolTipText }, String(src || name)));
};
var AvatarType$1;
(function (AvatarType) {
    AvatarType[AvatarType["Tournament"] = 0] = "Tournament";
    AvatarType[AvatarType["User"] = 1] = "User";
    AvatarType[AvatarType["CustomCourse"] = 2] = "CustomCourse";
    AvatarType[AvatarType["Default"] = 3] = "Default";
})(AvatarType$1 || (AvatarType$1 = {}));

var css_248z$1d = ".message{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.full-screen{height:100vh!important}.pink-loader{color:#f178ae!important}";
styleInject(css_248z$1d);

const Message = ({ type, message = '', children, className, fullScreen, pinkLoader }) => {
    let childComponent;
    switch (type) {
        case 'loader':
            childComponent = (jsx(CircularProgress, { className: classNames({ 'pink-loader': pinkLoader }), "data-testid": "circular-loader" }, void 0));
            break;
        case 'component':
            childComponent = children;
            break;
        default:
            childComponent = message;
            break;
    }
    return (jsx("div", Object.assign({ "data-testid": type, className: classNames('message', className, { 'full-screen': fullScreen }) }, { children: childComponent }), void 0));
};

var css_248z$1c = ".not-found-container{align-items:center;display:flex;flex-direction:column;height:100vh;justify-content:center}.not-found-container .not-found-number{font-size:4rem;text-align:center}.not-found-container .not-found-content{display:flex}.not-found-container .not-found-content .not-found-message{align-items:center;display:flex;font-size:2.5rem;height:100%;justify-content:center}.not-found-container .not-found-content .not-found-icon{font-size:2.5rem!important;margin-left:1rem}.not-found-container .home-page{margin-top:2rem;text-align:center}";
styleInject(css_248z$1c);

const NotFound = ({ text, goToHomePageText }) => {
    return (jsxs("div", Object.assign({ className: "not-found-container" }, { children: [jsx("div", Object.assign({ className: "not-found-number" }, { children: "404" }), void 0), jsx("div", Object.assign({ className: "not-found-content" }, { children: jsxs("div", Object.assign({ className: "not-found-message" }, { children: [text, jsx(SentimentVeryDissatisfied, { className: "not-found-icon" }, void 0)] }), void 0) }), void 0), jsx("div", Object.assign({ className: "home-page" }, { children: jsx("a", Object.assign({ href: lib$1.getPlatformUrl(), target: "_parent" }, { children: goToHomePageText }), void 0) }), void 0)] }), void 0));
};

const defaultValue = {
    translate: () => (value) => value,
    setTranslate: () => undefined,
    locale: 'en',
    setLocale: () => undefined
};
const TranslationContext = createContext(defaultValue);
const TranslationContextProvider = (props) => {
    const [translate, setTranslate] = useState(defaultValue.translate);
    const [locale, setLocale] = useState(defaultValue.locale);
    return (jsx(TranslationContext.Provider, Object.assign({ value: {
            translate,
            setTranslate,
            locale,
            setLocale
        } }, { children: props.children }), void 0));
};
const useTranslationContext = () => useContext(TranslationContext);

const MessageHandling = ({ error, loading, displayMessage, fullScreen, pinkLoader }) => {
    const { translate } = useTranslationContext();
    if (error && displayMessage)
        return jsx(Message, { message: translate(displayMessage), fullScreen: fullScreen }, void 0);
    if (loading)
        return jsx(Message, { type: "loader", fullScreen: fullScreen, pinkLoader: pinkLoader }, void 0);
    return null;
};

var css_248z$1b = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.side-tooltip{align-items:center;background-color:#141626;display:flex;flex-direction:column;height:99.6%;justify-content:center;position:relative;width:99.6%}.side-tooltip .content{height:80%;width:80%}.side-tooltip .content .title{color:#f178ae}.side-tooltip .content .body{color:hsla(0,0%,100%,.8);line-height:2.5rem}.side-tooltip .content .image{align-items:center;display:flex;justify-content:center}.class-right-triangle:after,.class-right-triangle:before,.class-triangle,.side-tooltip:after,.side-tooltip:before{border-bottom:1.3rem solid transparent;border-left:1.3rem solid;border-top:1.3rem solid transparent;content:\"\";height:0;position:absolute;width:0}.class-right-triangle:before,.side-tooltip:before{border-left-color:#141626;right:-1.3rem}.class-right-triangle:after,.side-tooltip:after{border-left-color:#141626;right:-1.2rem}";
styleInject(css_248z$1b);

const SideTooltip = (props) => {
    const { children, dataTestId } = props;
    return (jsx("div", Object.assign({ className: "side-tooltip", "data-testid": dataTestId }, { children: children }), void 0));
};

var css_248z$1a = ".ellipsis-text{display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}";
styleInject(css_248z$1a);

const EllipsisText = ({ text, maxWidthClassName = '15rem', className = '' }) => {
    return (jsx("span", Object.assign({ title: String(text), className: classNames(className, 'ellipsis-text'), style: { maxWidth: maxWidthClassName } }, { children: text }), void 0));
};

var css_248z$19 = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.legend-container{font-size:1rem;width:max-content}.legend-vertical{display:flex}.legend-tootip{background-color:#fff!important;border:1px solid #f0f0f2}.legend-tooltip{padding:.6rem}.legend,.legend-vertical{display:flex;padding:.3rem}.legend-vertical .legend-icon-fill svg rect,.legend .legend-icon-fill svg rect{fill:var(--fill-color)!important}.legend-vertical .legend-label,.legend .legend-label{color:#565360;display:flex;margin-left:.5rem}.legend-vertical .legend-label .legend-value,.legend .legend-label .legend-value{font-weight:700;margin-left:.3rem}.legend-vertical .legend-rows,.legend .legend-rows{flex-direction:column}.legend-vertical .legend-rows .legend-value,.legend .legend-rows .legend-value{margin-left:0;margin-top:1rem}";
styleInject(css_248z$19);

const LegendComponent = (props) => {
    const { legends, showValues, isVertical, legendText, singularUnitText, pluralUnitText, total, className } = props;
    const hasUnitText = singularUnitText || pluralUnitText;
    let valueSum = 0;
    const getValueSum = () => {
        if (valueSum !== 0)
            return valueSum;
        valueSum = legends.reduce((sum, val) => sum + (val.value || 0), 0);
        return valueSum;
    };
    const getValueString = (value) => {
        const unitText = hasUnitText ? `${hasUnitText && value === 1 ? singularUnitText : pluralUnitText} ` : '';
        return `${value} ${unitText}(${lib$1.getPercentAsString(value, total || getValueSum())})`;
    };
    return (jsxs("div", Object.assign({ className: classNames('legend-container', className, { 'legend-vertical': isVertical }) }, { children: [legendText && (jsx("h3", Object.assign({ "data-testid": "title", className: "legend-title" }, { children: legendText }), void 0)), legends.map(({ color, text, className, value = 0 }, i) => (jsxs("div", Object.assign({ className: "legend" }, { children: [jsx(Icon, { dataTestid: "icon", name: "rectangle", className: "legend-icon-fill", style: { '--fill-color': color } }, void 0), jsxs("div", Object.assign({ "data-testid": "label", className: classNames('legend-label', className) }, { children: [text, showValues && jsx("div", Object.assign({ className: "legend-value" }, { children: getValueString(value) }), void 0)] }), void 0)] }), i)))] }), void 0));
};

const LegendTooltip$1 = (props) => {
    const { children } = props, legendProps = __rest$1(props, ["children"]);
    return (jsx(TooltipContainer, Object.assign({ hasBorder: true, hasDefaultStyle: true, title: jsx(LegendComponent, Object.assign({}, legendProps, { className: "legend-tooltip" }), void 0) }, { children: children }), void 0));
};

const copyToClipboard = (path) => {
    navigator.clipboard.writeText(path);
};

var css_248z$18 = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.copy-link{border:1px solid #bdbdbd;border-radius:10px;display:flex;height:3.5rem}.copy-link .path{align-self:center;color:#95939b;display:inline-block;font-size:1.6rem;margin:.5rem;max-width:40rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.copy-link .button-wrapper{align-self:center;font-size:1.4rem;height:91%!important;margin-right:2px}.copy-link hr{margin:0;padding:0}.copy-link .icon-wrapper{display:flex;margin:.5rem}.copy-link .icon-wrapper .link-icon{align-self:center;color:#95939b;transform:rotate(45deg)}";
styleInject(css_248z$18);

const CopyLink = ({ path, copiedText, copyText }) => {
    const [isCopied, setIsCopied] = useState(false);
    return (jsxs("div", Object.assign({ className: "copy-link", "data-testid": "copy-link" }, { children: [jsx("div", Object.assign({ className: "icon-wrapper" }, { children: jsx(LinkIcon, { className: "link-icon", fontSize: "large" }, void 0) }), void 0), jsx("hr", {}, void 0), jsx("span", Object.assign({ className: "path" }, { children: path }), void 0), jsx("div", Object.assign({ className: "button-wrapper" }, { children: jsx(ButtonContainer, { type: isCopied ? 'green' : 'primary', text: isCopied ? copiedText : copyText, onClick: () => {
                        copyToClipboard(path);
                        setIsCopied(true);
                    }, onMouseLeave: () => {
                        setTimeout(() => setIsCopied(false), 300);
                    } }, void 0) }), void 0)] }), void 0));
};

var AutocompleteTypesName;
(function (AutocompleteTypesName) {
    AutocompleteTypesName[AutocompleteTypesName["default"] = 0] = "default";
    AutocompleteTypesName[AutocompleteTypesName["search"] = 1] = "search";
    AutocompleteTypesName[AutocompleteTypesName["purpleSearch"] = 2] = "purpleSearch";
})(AutocompleteTypesName || (AutocompleteTypesName = {}));
const AutocompleteType = {
    default: {},
    search: {},
    purpleSearch: { className: 'purple-search' }
};

var css_248z$17 = ".autocomplete-module_class-ellipsis-2-lines__I7TTi,.autocomplete-module_class-ellipsis-lines__B6wiW{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.autocomplete-module_class-ellipsis-2-lines__I7TTi{-webkit-line-clamp:2!important;max-height:4rem!important}.autocomplete-module_MuiChip-root__VPljq{margin:.5rem .3rem .5rem .5rem}.autocomplete-module_ellipse-chip__e3niL.autocomplete-module_MuiChip-root__VPljq{border-radius:1rem;height:20px}.autocomplete-module_ellipse-chip__e3niL.autocomplete-module_MuiChip-root__VPljq .autocomplete-module_MuiChip-label__7-VGw{padding-left:8px;padding-right:8px}.autocomplete-module_square-chip__01gnh.autocomplete-module_MuiChip-root__VPljq{border-radius:0!important}.autocomplete-module_class-width-height-100__k-fjx{height:100%;width:100%}.autocomplete-module_MuiTooltip-tooltip__RbUxW{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.autocomplete-module_MuiTooltip-arrow__iLiJs{color:#fff!important}.autocomplete-module_class-font-size-icon__b9-rf{font-size:1.25rem}.autocomplete-module_full-width__lAbt2{width:100%}.autocomplete-module_full-height__xOdqX{height:100%}span.MuiAutocomplete-tag{align-items:center;border:1px solid rgba(0,0,0,.231)!important;display:flex;height:1.24375rem;margin:0 .1875rem;padding:.4%}.MuiAutocomplete-inputRoot.MuiOutlinedInput-root.MuiOutlinedInput-marginDense{padding:.625rem 2.4375rem .625rem .625rem!important}.MuiAutocomplete-inputRoot.MuiOutlinedInput-root.MuiOutlinedInput-marginDense .MuiAutocomplete-input{padding:0 .25rem!important}.MuiAutocomplete-listbox .MuiAutocomplete-option .MuiCheckbox-root{padding:.3rem .5625rem .3rem 0}.autocomplete-module_autocomplete-component__qZ41O .autocomplete-module_text-field__jdeh7.autocomplete-module_closed-text-field__q52Uz div{height:2.5rem}.autocomplete-module_autocomplete-component__qZ41O .autocomplete-module_text-field__jdeh7 .MuiInputBase-root div{background-color:initial}.autocomplete-module_autocomplete-component__qZ41O .MuiInputLabel-root{line-height:1.25rem!important;transform:translate(14px,.625rem)!important}.autocomplete-module_autocomplete-component__qZ41O .MuiInputLabel-root.MuiInputLabel-outlined.MuiInputLabel-shrink{transform:translate(14px,-6px) scale(.75)!important}.autocomplete-module_purple-search__J7P0L .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{border-color:#3b6ba7!important}.autocomplete-module_purple-search__J7P0L .MuiPaper-root.MuiAutocomplete-paper{color:#fff}.autocomplete-module_purple-search__J7P0L .MuiAutocomplete-listbox{padding-bottom:0!important;padding-top:0!important}.autocomplete-module_purple-search__J7P0L .MuiAutocomplete-listbox,.autocomplete-module_purple-search__J7P0L .MuiPaper-root{background-color:#2f1d61!important}.autocomplete-module_purple-search__J7P0L .MuiAutocomplete-option{border-top:.01px solid hsla(0,0%,100%,.502)}.autocomplete-module_purple-search__J7P0L .MuiAutocomplete-option:nth-child(odd){background:#382470}.autocomplete-module_purple-search__J7P0L .MuiInputBase-input{color:hsla(0,0%,100%,.702)}.autocomplete-module_purple-search__J7P0L .MuiOutlinedInput-notchedOutline{border:1px solid #b4b2bc!important}.autocomplete-module_purple-search__J7P0L .MuiAutocomplete-noOptions,.autocomplete-module_purple-search__J7P0L .MuiInputBase-root{background-color:transparent!important;color:hsla(0,0%,100%,.702)!important}.autocomplete-module_storybook-select-team__If4V- .autocomplete-module_MuiSvgIcon-colorAction__psxRi{color:green!important}";
var styles$E = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"autocomplete-module_class-ellipsis-lines__B6wiW","class-ellipsis-2-lines":"autocomplete-module_class-ellipsis-2-lines__I7TTi","MuiChip-root":"autocomplete-module_MuiChip-root__VPljq","ellipse-chip":"autocomplete-module_ellipse-chip__e3niL","MuiChip-label":"autocomplete-module_MuiChip-label__7-VGw","square-chip":"autocomplete-module_square-chip__01gnh","class-width-height-100":"autocomplete-module_class-width-height-100__k-fjx","MuiTooltip-tooltip":"autocomplete-module_MuiTooltip-tooltip__RbUxW","MuiTooltip-arrow":"autocomplete-module_MuiTooltip-arrow__iLiJs","class-font-size-icon":"autocomplete-module_class-font-size-icon__b9-rf","full-width":"autocomplete-module_full-width__lAbt2","full-height":"autocomplete-module_full-height__xOdqX","autocomplete-component":"autocomplete-module_autocomplete-component__qZ41O","text-field":"autocomplete-module_text-field__jdeh7","closed-text-field":"autocomplete-module_closed-text-field__q52Uz","purple-search":"autocomplete-module_purple-search__J7P0L","storybook-select-team":"autocomplete-module_storybook-select-team__If4V-","MuiSvgIcon-colorAction":"autocomplete-module_MuiSvgIcon-colorAction__psxRi"};
styleInject(css_248z$17);

const AutocompleteContainer = (props) => {
    const { value = [], dataTestid, size = 'small', options = [], childComponent: ChildComponent = OptionContainer, onChange, onInputChange, leftIcon, type = 'default', doRenderValueAsString, doRenderValueAsTagsOnClose, showSelectedOptionCheckIcon, limitTags = 15, onOpen, onClose, disableCloseOnSelect = true, textFieldOnCloseClassName = '', textFieldClassName, textFieldVariant, maxHeight = '20rem', maxWidth, typeText = '', searchText = '', selectText = '', disabled, disableClearable = true, label = undefined, className, popperClassName, multiple = true, noOptionsText } = props, rest = __rest$1(props, ["value", "dataTestid", "size", "options", "childComponent", "onChange", "onInputChange", "leftIcon", "type", "doRenderValueAsString", "doRenderValueAsTagsOnClose", "showSelectedOptionCheckIcon", "limitTags", "onOpen", "onClose", "disableCloseOnSelect", "textFieldOnCloseClassName", "textFieldClassName", "textFieldVariant", "maxHeight", "maxWidth", "typeText", "searchText", "selectText", "disabled", "disableClearable", "label", "className", "popperClassName", "multiple", "noOptionsText"]);
    const isSearchType = type === 'search' || type === 'purpleSearch';
    const auxiliaryProps = Object.assign({}, AutocompleteType[type]);
    const useStyles = makeStyles$1(() => {
        var _a, _b, _c, _d;
        let popperStyle = {};
        let paperStyle = {};
        if (isSearchType) {
            const paperLeft = ((_b = (_a = document.getElementsByTagName('input')) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.offsetLeft) || 0;
            const paperWidth = (_d = (_c = document.getElementsByClassName('MuiAutocomplete-popper')) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.clientWidth;
            popperStyle = { '& :not(p)': { maxWidth } };
            paperStyle = {
                position: 'relative',
                left: `${paperLeft < 0.8 * paperWidth ? paperLeft : 0}px`
            };
        }
        return createStyles({ popper: popperStyle, paper: paperStyle });
    });
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(isSearchType);
    const [isTyping, setIsTyping] = useState(false);
    const handleOnClose = useCallback$1(() => onClose === null || onClose === void 0 ? void 0 : onClose(), [onClose]);
    const handleOnOpenOrOnClose = useCallback$1((diff = 1) => {
        const tagsPerRow = 6;
        const doRenderOnOpen = value.length + diff > tagsPerRow;
        doRenderOnOpen ? onOpen === null || onOpen === void 0 ? void 0 : onOpen() : handleOnClose();
    }, [value, onOpen, handleOnClose]);
    const getPlaceholderText = () => {
        const isEmpty = !(value === null || value === void 0 ? void 0 : value.length);
        if (isTyping && isOpen)
            return typeText;
        if (isSearchType)
            return searchText;
        if (isEmpty)
            return selectText;
        return '';
    };
    const renderInput = (params) => {
        if (leftIcon)
            params.InputProps.startAdornment = (jsxs(Fragment$1, { children: [jsx(InputAdornment, Object.assign({ position: "start", className: styles$E['full-height'] }, { children: leftIcon }), void 0), params.InputProps.startAdornment] }, void 0));
        return (jsx(TextFieldContainer, { params: params, placeholder: getPlaceholderText(), onChange: v => {
                onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange(v);
                setIsTyping(true);
            }, className: classNames(styles$E['text-field'], textFieldClassName, styles$E[auxiliaryProps.className || ''], {
                [textFieldOnCloseClassName]: !isOpen,
                [styles$E['closed-text-field']]: !isOpen
            }), fullHeight: false, variant: textFieldVariant, label: label }, void 0));
    };
    const renderTags = (values, getTagProps) => values.map((option, index) => {
        const isLimitTag = option.optionValue === 'limitTag';
        const chipType = isLimitTag ? 'unSelected' : 'removable';
        const onDelete = isLimitTag ? undefined : getTagProps({ index }).onDelete;
        const label = lib$1.concatStrings([option.title, option.subTitle], ' ');
        const title = isLimitTag ? renderValueAsString() : label;
        return (jsx(ChipContainer, Object.assign({}, getTagProps({ index }), { type: chipType, onDelete: onDelete, label: label, title: title, size: "small" }), index));
    });
    const handleLimitTags = (values) => {
        let newValues = [...values];
        if (limitTags > -1) {
            const more = newValues.length - limitTags;
            if (limitTags && more > 0) {
                newValues = newValues.splice(0, limitTags);
                newValues.push({ title: `+${more}`, optionValue: 'limitTag' });
            }
        }
        return newValues;
    };
    const renderValue = (values, getTagProps) => {
        if (doRenderValueAsString)
            return renderValueAsString();
        if (!doRenderValueAsTagsOnClose && !isOpen)
            return renderValueAsString();
        if (!isOpen)
            return renderTags(values, getTagProps);
        return renderTags(handleLimitTags(values), getTagProps);
    };
    const renderValueAsString = () => {
        const valueAsString = String(value ? value.map((option) => `\u00A0\u00A0${option.title || ''}`) : '');
        if (!isOpen)
            return (jsx("div", Object.assign({ className: styles$E['full-width'] }, { children: jsx(EllipsisText, { text: valueAsString, maxWidthClassName: "100%" }, void 0) }), void 0));
        return valueAsString;
    };
    const CustomPopper = popperProps => {
        return (jsx(Popper, Object.assign({}, popperProps, { className: classNames(popperProps.className, popperClassName, styles$E[auxiliaryProps.className || '']) }), void 0));
    };
    useEffect(() => {
        handleOnOpenOrOnClose();
    }, [value, handleOnOpenOrOnClose]);
    return (jsx("span", Object.assign({ className: classNames(styles$E[auxiliaryProps.className || '']) }, { children: jsx(Autocomplete$1, Object.assign({}, rest, { className: classNames(styles$E['autocomplete-component'], className), classes: classes, "data-testid": dataTestid, value: multiple ? value : value[0], size: size, multiple: multiple, disableCloseOnSelect: disableCloseOnSelect, disableClearable: disableClearable, openOnFocus: true, ListboxProps: { style: { maxHeight } }, options: options.filter(({ visible = true }) => visible), getOptionLabel: (option) => option.title, getOptionSelected: (option, newValue) => newValue.title === option.title, getOptionDisabled: (option) => isSearchType ? value.some(v => v.title === option.title) || option.disabled || false : false, popupIcon: isSearchType ? jsx("span", {}, void 0) : undefined, onChange: (onChangeEvent, onChangeValue) => {
                const onChangeValues = multiple
                    ? onChangeValue
                    : [onChangeValue];
                onChange(onChangeEvent, onChangeValues);
                handleOnOpenOrOnClose(onChangeValues.length - value.length);
            }, onClose: () => setIsTyping(false), onOpen: () => {
                !isSearchType && setIsOpen(true);
            }, noOptionsText: noOptionsText, onBlur: () => !isSearchType && setIsOpen(false), renderInput: renderInput, renderTags: (values, getTagProps) => renderValue(values, getTagProps), renderOption: (option, { selected }) => (jsx(ChildComponent, Object.assign({}, option, { showSelectedOptionCheckIcon: showSelectedOptionCheckIcon, isSelected: selected }), void 0)), PopperComponent: CustomPopper, disabled: disabled }), void 0) }), void 0));
};

const Search = (_a) => {
    var { onChange, leftIcon, toText, typeText, searchText, selectText, disabled } = _a, rest = __rest$1(_a, ["onChange", "leftIcon", "toText", "typeText", "searchText", "selectText", "disabled"]);
    return (jsx(AutocompleteContainer, Object.assign({}, rest, { onChange: (_, selectedValue) => onChange(selectedValue.map(({ optionValue = '', title = '' }) => String(optionValue || title))), type: "search", doRenderValueAsTagsOnClose: true, leftIcon: leftIcon || toText.concat(':'), maxWidth: "20rem", typeText: typeText, searchText: searchText, selectText: selectText, disabled: disabled }), void 0));
};

function useCountdown(date, intervalTime = 200) {
    const [timeLeft, setTimeLeft] = useState(() => date - Date.now());
    useEffect(() => {
        const interval = setInterval(() => {
            setTimeLeft(current => {
                if (current - intervalTime <= 0) {
                    clearInterval(interval);
                    return 0;
                }
                return date - Date.now();
            });
        }, intervalTime);
        return () => clearInterval(interval);
    }, [intervalTime, date]);
    return timeLeft;
}

var css_248z$16 = ".subtitle-font-size-15{font-size:.9375rem}.subtitle-font-size-23{font-size:1.4375rem}.subtitle-margin-left-0_point_5-rem{margin-left:.5rem}";
styleInject(css_248z$16);

const CountdownTimer = (props) => {
    const { initialRemainingSeconds, format, hasSubTitle, hasShortSubTitle, subTitleClassName = 'subtitle-font-size-23', minutesText, minText, minuteText, secText } = props;
    const millisecondsInSecond = 1000;
    const [startTime] = useState(() => Date.now() + initialRemainingSeconds * millisecondsInSecond);
    const millisecondsLeft = useCountdown(startTime);
    const secondsLeft = millisecondsLeft / millisecondsInSecond;
    let calculatedFormat = format;
    let timeUnit = hasSubTitle ? minutesText : minText;
    if (!format) {
        calculatedFormat = 'mm:ss';
        if (Math.round(secondsLeft) === 60) {
            timeUnit = minuteText;
        }
        else if (secondsLeft < 60) {
            calculatedFormat = 's';
            timeUnit = secText;
        }
    }
    return (jsxs("div", Object.assign({ "data-testid": "countdown-timer" }, { children: [moment.utc(millisecondsLeft).format(calculatedFormat), (hasSubTitle || hasShortSubTitle) && (jsxs("span", Object.assign({ className: subTitleClassName }, { children: ['\u00A0', timeUnit] }), void 0))] }), void 0));
};

var css_248z$15 = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.user-message .MuiPaper-root{position:absolute!important;top:var(--top)!important}.class-overflow-y-unset .MuiPaper-root{overflow-y:unset!important}.class-close-icon{color:#d8d8d8!important;cursor:pointer;position:absolute;right:-1.5rem;top:-3.3rem}.class-white-space-pre-wrap{white-space:pre-wrap}.class-width-unset{width:unset!important}";
styleInject(css_248z$15);

const UserMessage = (props) => {
    const { isOpen, title, content, buttons, handleClose, dataTestId, hasCloseIcon, topOffset, children, className, isLoading, titleClassName } = props;
    const theme = useTheme$2();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    return (jsxs(Dialog, Object.assign({ open: isOpen, onClose: () => handleClose(), "aria-labelledby": "responsive-dialog-title", fullScreen: fullScreen, "data-testid": dataTestId, style: { '--top': `${hasCloseIcon ? topOffset + 30 : topOffset}px` }, className: classNames('user-message', className, { 'class-overflow-y-unset': hasCloseIcon }) }, { children: [hasCloseIcon && (jsx(CloseIcon, { "data-testid": "close-icon", className: "class-close-icon", fontSize: "large", onClick: () => handleClose() }, void 0)), isLoading && jsx(MessageHandling, { loading: isLoading }, void 0), !isLoading && (jsx(DialogTitle, Object.assign({ className: titleClassName, id: "responsive-dialog-title" }, { children: title }), void 0)), !isLoading && content && (jsx(DialogContent, { children: jsx(DialogContentText, { children: jsx("span", Object.assign({ className: "class-white-space-pre-wrap" }, { children: content }), void 0) }, void 0) }, void 0)), children, !isLoading && (jsx(DialogActions, { children: buttons.map(buttonProps => {
                    return createElement(ButtonContainer, Object.assign({}, buttonProps, { key: buttonProps.text, className: "class-width-unset" }));
                }) }, void 0))] }), void 0));
};

var css_248z$14 = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.simple-table-root::-webkit-scrollbar{width:4px!important}.simple-table-root::-webkit-scrollbar-thumb{border-radius:1.5px!important;height:69px!important}.simple-table-root .MuiPaper-elevation1{box-shadow:none!important}.simple-table-root-dark{border:1px solid #fff;height:90%}.simple-table-root-dark .MuiTableCell-stickyHeader{background-color:#223138!important}.simple-table-root-light{border:1px solid #d6d6d6;height:90%}.simple-table-root-light .MuiTableCell-stickyHeader{background-color:#fff!important}.simple-table-root-free{background-color:transparent!important;border-radius:8px 0 0 0 #d6d6d6;height:90%;width:100%}.simple-table-root-free .MuiTableCell{background-color:rgba(66,26,106,.4)!important}.simple-table-root-free .MuiTableCell-stickyHeader{background-color:#421a6a!important}.simple-table-root-free .MuiPaper-root{background-color:transparent!important}.simple-table-container{border-radius:5px;max-height:100%}.table-pagination{display:\"flex\";justify-content:\"flex-end\";padding:0}.class-bg-colur-white{background-color:#fff}.class-bg-colour-transparent{background-color:transparent}.dark .MuiTablePagination-root,.light .MuiTablePagination-root{border:0}.dark .MuiTableCell-head{border-bottom-color:hsla(0,0%,100%,.761)!important;color:hsla(0,0%,100%,.761)!important}.dark .MuiTableCell-body{color:#fff!important}.dark .no-data{background-color:#18262c!important}.dark .MuiSelect-icon,.dark .MuiTableCell-body,.dark .MuiTablePagination-root,.dark .no-data{color:#fff!important}.dark .MuiIconButton-root.Mui-disabled{color:#6b6874!important}.light .MuiTableCell-head{color:#95939b!important}.light .MuiTableCell-body{color:#565360!important}.free .MuiTableCell-head{border-bottom-color:hsla(0,0%,100%,.2)!important;color:hsla(0,0%,100%,.8);font-size:1rem;font-weight:700;letter-spacing:.025em;line-height:130%}.free .MuiTableCell-body{background:rgba(90,45,135,.5)!important;border-bottom-color:hsla(0,0%,100%,.1)!important;color:hsla(0,0%,100%,.7);font-size:.8125rem;font-weight:600;letter-spacing:.025em;line-height:130%}.free .MuiPaper-root{background-color:transparent!important}";
styleInject(css_248z$14);

const SimpleTable = (props) => {
    var _a;
    const { isLoading, headers, rows, mode = 'light', bgColor, paperBgColor, noDataText, ofText, hideTableWhenNoData, changeBackgroundColorCondition, changedBackgroundColor, paginationData, alignToRight, rowsWidth } = props;
    const { setCurrentPage, setRowsPerPage, currentPage, rowsPerPage } = paginationData, restPaginationData = __rest$1(paginationData, ["setCurrentPage", "setRowsPerPage", "currentPage", "rowsPerPage"]);
    const defaultRowWidth = `${100 / ((_a = rows === null || rows === void 0 ? void 0 : rows[0]) === null || _a === void 0 ? void 0 : _a.length) || 1}%`;
    const hasData = rows.length;
    const getMode = () => {
        if (mode === 'free')
            return 'simple-table-root-free';
        if (mode === 'light')
            return 'simple-table-root-light';
        if (mode === 'dark')
            return 'simple-table-root-dark';
        return 'simple-table-root-light';
    };
    const renderTable = (jsx(Paper$1, Object.assign({ "data-testid": "simple-table", className: classNames('simple-table-root', getMode(), paperBgColor || 'class-bg-colour-transparent', 'common-components-1786027376044-8') }, { children: jsx(TableContainer, Object.assign({ className: classNames(mode, 'simple-table-container') }, { children: jsxs(Table, Object.assign({ stickyHeader: true }, { children: [headers && (jsx(TableHead, { children: jsx(TableRow, Object.assign({ className: bgColor }, { children: headers.map((header, headerIndex) => (jsx(TableCell, Object.assign({ align: alignToRight && headerIndex === headers.length - 1 ? 'right' : 'left', style: { width: header.width || defaultRowWidth }, className: 'MuiTableCell-stickyHeader common-components-1786027376320-0' }, { children: header.label }), headerIndex))) }), void 0) }, void 0)), jsxs(TableBody, { children: [!isLoading &&
                                rows.slice(currentPage * rowsPerPage, (currentPage + 1) * rowsPerPage).map((row, i) => (jsx(TableRow, Object.assign({ style: {
                                        backgroundColor: (changeBackgroundColorCondition === null || changeBackgroundColorCondition === void 0 ? void 0 : changeBackgroundColorCondition(row))
                                            ? changedBackgroundColor
                                            : undefined
                                    } }, { children: row.map((rowItem, rowIndex) => (jsx(TableCell, Object.assign({ align: alignToRight && rowIndex === row.length - 1 ? 'right' : 'left', style: {
                                            width: (rowsWidth && rowsWidth[rowIndex] && rowsWidth[rowIndex]) ||
                                                (headers && headers[rowIndex].width) ||
                                                defaultRowWidth
                                        }, className: "common-components-1786027376587-8" }, { children: typeof rowItem !== 'object' ? jsx(EllipsisText, { text: rowItem }, void 0) : rowItem }), rowIndex))) }), i))), isLoading && (jsx(TableRow, { children: jsx(TableCell, Object.assign({ align: "center", className: "alignJustify common-components-1786027376861-9", colSpan: headers === null || headers === void 0 ? void 0 : headers.length }, { children: jsx(Message, { type: "loader" }, void 0) }), void 0) }, void 0)), !isLoading && !rows.length && (jsx(TableRow, { children: jsx(TableCell, Object.assign({ "data-testid": "no-records", align: "center", colSpan: headers === null || headers === void 0 ? void 0 : headers.length, className: "common-components-1786027377148-9" }, { children: noDataText }), void 0) }, void 0))] }, void 0)] }), void 0) }), void 0) }), void 0));
    const renderTablePagination = (jsx("div", Object.assign({ className: classNames(mode, 'table-pagination', 'common-components-1786027377152-7') }, { children: jsx(Table, { children: jsx(TableBody, { children: jsx(TableRow, { children: jsx(TablePagination, Object.assign({ component: "div", id: "common-components-1786027377452-9" }, restPaginationData, { page: currentPage, rowsPerPage: rowsPerPage, onPageChange: (_, _newPage) => setCurrentPage(_newPage), labelDisplayedRows: ({ from, to, count }) => `${from}-${to} ${ofText} ${count}`, onChangeRowsPerPage: (e) => {
                            setRowsPerPage === null || setRowsPerPage === void 0 ? void 0 : setRowsPerPage(parseInt(e.target.value, 10));
                            setCurrentPage(0);
                        } }), void 0) }, void 0) }, void 0) }, void 0) }), void 0));
    const getComponent = () => {
        const { showPagination = true } = props;
        if (hideTableWhenNoData && isLoading)
            return jsx(Message, { type: "loader" }, void 0);
        if (hideTableWhenNoData && !hasData) {
            return (jsx(Message, Object.assign({ type: "component", className: classNames(mode, 'no-data') }, { children: jsx("h1", Object.assign({ id: "common-components-1786027377494-10" }, { children: noDataText }), void 0) }), void 0));
        }
        return (jsxs(Fragment$1, { children: [renderTable, showPagination && renderTablePagination] }, void 0));
    };
    return getComponent();
};

var css_248z$13 = ".linkable-popup .MuiDialog-paper{border-radius:1rem;position:absolute!important;top:var(--top)!important}.linkable-popup .MuiDialogContent-root{overflow-y:unset}";
styleInject(css_248z$13);

const LinkablePopup = (props) => {
    const { text, title, tableData, component, topOffset } = props;
    const [searchValue, setSearchValue] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const rowsPerPageOptions = [5, 25, 50, 100];
    const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);
    const [currentPage, setCurrentPage] = useState(0);
    useEffect(() => {
        tableData === null || tableData === void 0 ? void 0 : tableData.setFilteredRows(tableData.rows.filter(row => row[0].toLowerCase().includes(searchValue.toLowerCase())));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData === null || tableData === void 0 ? void 0 : tableData.rows, searchValue, tableData === null || tableData === void 0 ? void 0 : tableData.setFilteredRows]);
    let childComponent = component;
    if (tableData) {
        const tableProps = {
            headers: tableData === null || tableData === void 0 ? void 0 : tableData.headers,
            rows: tableData.filteredRows,
            mode: 'light',
            bgColor: 'bg-colour-white',
            noDataText: tableData.noDataText,
            ofText: tableData.ofText,
            paginationData: {
                rowsPerPageOptions,
                rowsPerPage,
                currentPage,
                count: tableData.rows.length,
                setCurrentPage,
                setRowsPerPage
            }
        };
        childComponent = (jsxs(Fragment$1, { children: [jsx(SimpleSearch, { value: searchValue, onChange: setSearchValue, placeholder: "Search", leftIcon: jsx(SearchIcon, {}, void 0), className: "class-margin-bottom-1-rem", dataTestid: "simple-search" }, void 0), jsx("div", Object.assign({ className: "class-height-28-rem" }, { children: component || jsx(SimpleTable, Object.assign({}, tableProps), void 0) }), void 0)] }, void 0));
    }
    return (jsxs(Fragment$1, { children: [jsx("h2", Object.assign({ "data-testid": "linkable-text", className: "link class-underline class-text-align-left", onClick: () => setIsOpen(true) }, { children: text }), void 0), jsx(DialogContainer, Object.assign({ title: title, onClose: () => setIsOpen(false), open: isOpen, dataTestid: "linkable-popup", hasCloseIconOutside: true, className: "linkable-popup", style: { '--top': `${topOffset + 30}px` } }, { children: childComponent }), void 0)] }, void 0));
};

var lib = {};

var enums = {};

Object.defineProperty(enums, "__esModule", {
  value: true
});
enums.SHARE_SITES = void 0;
var SHARE_SITES = {
  GOOGLE: 'Google',
  ICAL: 'iCal',
  OUTLOOK: 'Outlook',
  YAHOO: 'Yahoo'
};
enums.SHARE_SITES = SHARE_SITES;

var utils = {};

Object.defineProperty(utils, "__esModule", {
  value: true
});
utils.buildShareUrl = utils.escapeICSDescription = utils.isInternetExplorer = utils.isMobile = utils.formatDuration = utils.formatDate = void 0;

var _enums = enums;

/**
 * Converts Date String with UTC timezone to date consumable by calendar
 * apps. Changes +00:00 to Z.
 * @param {string} Date in YYYYMMDDTHHmmssZ format
 * @returns {string} Date with +00:00 replaceed with Z
 */
var formatDate = function formatDate(date) {
  return date && date.replace('+00:00', 'Z');
};

utils.formatDate = formatDate;

var formatDuration = function formatDuration(duration) {
  if (typeof duration === 'string') return duration;
  var parts = duration.toString().split('.');

  if (parts.length < 2) {
    parts.push('00');
  }

  return parts.map(function (part) {
    return part.length === 2 ? part : "0".concat(part);
  }).join('');
};
/**
 * Tests provided UserAgent against Known Mobile User Agents
 * @returns {bool} isMobileDevice
 */


utils.formatDuration = formatDuration;

var isMobile = function isMobile() {
  return /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/.test(window.navigator.userAgent || window.navigator.vendor || window.opera);
};
/**
 * Tests userAgent to see if browser is IE
 * @returns {bool} isInternetExplorer
 */


utils.isMobile = isMobile;

var isInternetExplorer = function isInternetExplorer() {
  return /MSIE/.test(window.navigator.userAgent) || /Trident/.test(window.navigator.userAgent);
};

utils.isInternetExplorer = isInternetExplorer;

var escapeICSDescription = function escapeICSDescription(description) {
  return description.replace(/(\r?\n|<br ?\/?>)/g, '\\n');
};
/**
 * Takes an event object and returns a Google Calendar Event URL
 * @param {string} event.description
 * @param {string} event.endDatetime
 * @param {string} event.location
 * @param {string} event.startDatetime
 * @param {string} event.title
 * @returns {string} Google Calendar Event URL
 */


utils.escapeICSDescription = escapeICSDescription;

var googleShareUrl = function googleShareUrl(_ref) {
  var description = _ref.description,
      endDatetime = _ref.endDatetime,
      location = _ref.location,
      startDatetime = _ref.startDatetime,
      timezone = _ref.timezone,
      title = _ref.title;
  return "https://calendar.google.com/calendar/render?action=TEMPLATE&dates=".concat(startDatetime, "/").concat(endDatetime).concat(timezone && "&ctz=".concat(timezone), "&location=").concat(location, "&text=").concat(title, "&details=").concat(description);
};
/**
 * Takes an event object and returns a Yahoo Calendar Event URL
 * @param {string} event.description
 * @param {string} event.duration
 * @param {string} event.location
 * @param {string} event.startDatetime
 * @param {string} event.title
 * @returns {string} Yahoo Calendar Event URL
 */


var yahooShareUrl = function yahooShareUrl(_ref2) {
  var description = _ref2.description,
      duration = _ref2.duration,
      location = _ref2.location,
      startDatetime = _ref2.startDatetime,
      title = _ref2.title;
  return "https://calendar.yahoo.com/?v=60&view=d&type=20&title=".concat(title, "&st=").concat(startDatetime, "&dur=").concat(duration, "&desc=").concat(description, "&in_loc=").concat(location);
};
/**
 * Takes an event object and returns an array to be downloaded as ics file
 * @param {string} event.description
 * @param {string} event.endDatetime
 * @param {string} event.location
 * @param {string} event.startDatetime
 * @param {string} event.title
 * @returns {array} ICS Content
 */


var buildShareFile = function buildShareFile(_ref3) {
  var _ref3$description = _ref3.description,
      description = _ref3$description === void 0 ? '' : _ref3$description;
      _ref3.ctz;
      var endDatetime = _ref3.endDatetime,
      _ref3$location = _ref3.location,
      location = _ref3$location === void 0 ? '' : _ref3$location,
      startDatetime = _ref3.startDatetime,
      _ref3$timezone = _ref3.timezone,
      timezone = _ref3$timezone === void 0 ? '' : _ref3$timezone,
      _ref3$title = _ref3.title,
      title = _ref3$title === void 0 ? '' : _ref3$title;
  var content = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'BEGIN:VEVENT', "URL:".concat(document.URL), 'METHOD:PUBLISH', // TODO: Will need to parse the date without Z for ics
  // This means I'll probably have to require a date lib - luxon most likely or datefns
  timezone === '' ? "DTSTART:".concat(startDatetime) : "DTSTART;TZID=".concat(timezone, ":").concat(startDatetime), timezone === '' ? "DTEND:".concat(endDatetime) : "DTEND;TZID=".concat(timezone, ":").concat(endDatetime), "SUMMARY:".concat(title), "DESCRIPTION:".concat(escapeICSDescription(description)), "LOCATION:".concat(location), 'END:VEVENT', 'END:VCALENDAR'].join('\n');
  return isMobile() ? encodeURI("data:text/calendar;charset=utf8,".concat(content)) : content;
};
/**
 * Takes an event object and a type of URL and returns either a calendar event
 * URL or the contents of an ics file.
 * @param {string} event.description
 * @param {string} event.duration
 * @param {string} event.endDatetime
 * @param {string} event.location
 * @param {string} event.startDatetime
 * @param {string} event.title
 * @param {enum} type One of SHARE_SITES from ./enums
 */


var buildShareUrl = function buildShareUrl(_ref4, type) {
  var _ref4$description = _ref4.description,
      description = _ref4$description === void 0 ? '' : _ref4$description,
      duration = _ref4.duration,
      endDatetime = _ref4.endDatetime,
      _ref4$location = _ref4.location,
      location = _ref4$location === void 0 ? '' : _ref4$location,
      startDatetime = _ref4.startDatetime,
      _ref4$timezone = _ref4.timezone,
      timezone = _ref4$timezone === void 0 ? '' : _ref4$timezone,
      _ref4$title = _ref4.title,
      title = _ref4$title === void 0 ? '' : _ref4$title;
  var encodeURI = type !== _enums.SHARE_SITES.ICAL && type !== _enums.SHARE_SITES.OUTLOOK;
  var data = {
    description: encodeURI ? encodeURIComponent(description) : description,
    duration: formatDuration(duration),
    endDatetime: formatDate(endDatetime),
    location: encodeURI ? encodeURIComponent(location) : location,
    startDatetime: formatDate(startDatetime),
    timezone: timezone,
    title: encodeURI ? encodeURIComponent(title) : title
  };

  switch (type) {
    case _enums.SHARE_SITES.GOOGLE:
      return googleShareUrl(data);

    case _enums.SHARE_SITES.YAHOO:
      return yahooShareUrl(data);

    default:
      return buildShareFile(data);
  }
};

utils.buildShareUrl = buildShareUrl;

(function (exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = AddToCalendar;
	Object.defineProperty(exports, "SHARE_SITES", {
	  enumerable: true,
	  get: function get() {
	    return _enums.SHARE_SITES;
	  }
	});

	var _react = _interopRequireWildcard(React__default);

	var _propTypes = _interopRequireDefault(propTypesExports);

	var _enums = enums;

	var _utils = utils;

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function AddToCalendar(WrappedButton, WrappedDropdown) {
	  var _class, _temp2;

	  return _temp2 = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(AddToCalendarWrapped, _Component);

	    function AddToCalendarWrapped() {
	      var _getPrototypeOf2;

	      var _temp, _this;

	      _classCallCheck(this, AddToCalendarWrapped);

	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }

	      return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(AddToCalendarWrapped)).call.apply(_getPrototypeOf2, [this].concat(args))), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
	        dropdownOpen: false
	      }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCalendarButtonClick", function (e) {
	        var filename = _this.props.filename;
	        e.preventDefault();
	        var url = e.currentTarget.getAttribute('href');

	        if (url.startsWith('BEGIN')) {
	          var blob = new Blob([url], {
	            type: 'text/calendar;charset=utf-8'
	          });

	          if ((0, _utils.isInternetExplorer)()) {
	            window.navigator.msSaveOrOpenBlob(blob, "".concat(filename, ".ics"));
	          } else {
	            var link = document.createElement('a');
	            link.href = window.URL.createObjectURL(blob);
	            link.setAttribute('download', "".concat(filename, ".ics"));
	            document.body.appendChild(link);
	            link.click();
	            document.body.removeChild(link);
	          }
	        } else {
	          window.open(url, '_blank');
	        }
	      }), _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDropdownToggle", function (e) {
	        e.preventDefault();

	        _this.setState(function (prevState) {
	          return {
	            dropdownOpen: !prevState.dropdownOpen
	          };
	        });
	      }), _temp));
	    }

	    _createClass(AddToCalendarWrapped, [{
	      key: "render",
	      value: function render() {
	        var _this2 = this;

	        var _this$props = this.props,
	            buttonProps = _this$props.buttonProps,
	            buttonText = _this$props.buttonText,
	            className = _this$props.className,
	            dropdownProps = _this$props.dropdownProps,
	            event = _this$props.event,
	            items = _this$props.items,
	            linkProps = _this$props.linkProps;
	        return _react.default.createElement("div", {
	          className: className
	        }, _react.default.createElement(WrappedButton, _extends({}, buttonProps, {
	          onClick: this.handleDropdownToggle
	        }), buttonText), this.state.dropdownOpen && _react.default.createElement(WrappedDropdown, _extends({}, dropdownProps, {
	          isOpen: this.state.dropdownOpen,
	          onRequestClose: this.handleDropdownToggle
	        }), items.map(function (item) {
	          return _react.default.createElement("a", _extends({}, linkProps, {
	            key: item,
	            onClick: _this2.handleCalendarButtonClick,
	            href: (0, _utils.buildShareUrl)(event, item)
	          }), item);
	        })));
	      }
	    }]);

	    return AddToCalendarWrapped;
	  }(_react.Component), _defineProperty(_class, "propTypes", {
	    buttonProps: _propTypes.default.shape(),
	    buttonText: _propTypes.default.node,
	    className: _propTypes.default.string,
	    dropdownProps: _propTypes.default.shape(),
	    event: _propTypes.default.shape({
	      description: _propTypes.default.string,
	      duration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
	      endDatetime: _propTypes.default.string.isRequired,
	      location: _propTypes.default.string,
	      startDatetime: _propTypes.default.string.isRequired,
	      title: _propTypes.default.string
	    }).isRequired,
	    filename: _propTypes.default.string,
	    items: _propTypes.default.arrayOf(_propTypes.default.oneOf(Object.keys(_enums.SHARE_SITES).map(function (itm) {
	      return _enums.SHARE_SITES[itm];
	    }))),
	    linkProps: _propTypes.default.shape()
	  }), _defineProperty(_class, "defaultProps", {
	    buttonProps: {},
	    buttonText: 'Add to Calendar',
	    className: null,
	    dropdownProps: {},
	    filename: 'download',
	    items: Object.keys(_enums.SHARE_SITES).map(function (itm) {
	      return _enums.SHARE_SITES[itm];
	    }),
	    linkProps: {}
	  }), _temp2;
	} 
} (lib));

var AddToCalendarHOC = /*@__PURE__*/getDefaultExportFromCjs(lib);

var css_248z$12 = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.add-to-calendar .MuiPaper-root{position:absolute!important;top:var(--top)!important}.class-overflow-y-unset .MuiPaper-root{overflow-y:unset!important}.class-close-icon{color:#d8d8d8!important;cursor:pointer;position:absolute;right:-1.5rem;top:-3.3rem}.class-white-space-pre-wrap{white-space:pre-wrap}.class-width-unset{width:unset!important}.class-margin-left-1_point_3-rem{margin-left:1.3rem}";
styleInject(css_248z$12);

const AddToCalendar = (props) => {
    const { title, event, type = 'primaryFlat', className, topOffset } = props;
    const WrappedButton = ({ onClick }) => (jsx(ButtonContainer, { onClick: onClick, text: title, type: type, className: classNames('class-relative', { className }) }, void 0));
    const WrappedDropdown = ({ children, isOpen, onRequestClose }) => (jsx(DialogContainer, Object.assign({ open: isOpen, title: title, onClose: onRequestClose, isList: true, className: "add-to-calendar", style: { '--top': `${topOffset}px` } }, { children: children }), void 0));
    const AddToCalendarModal = AddToCalendarHOC(WrappedButton, WrappedDropdown);
    return (jsx(AddToCalendarModal, { event: event, linkProps: { className: 'link' }, className: "class-margin-left-1_point_3-rem" }, void 0));
};

/* eslint-disable css-modules/no-undef-class */
const ProgressBarContainer = ({ value, backgroundColor = '#36454e', barColor = '#22bcbe' }) => {
    const BorderLinearProgress = withStyles(_theme => ({
        root: {
            height: 15,
            borderRadius: 2
        },
        colorPrimary: {
            backgroundColor
        },
        bar: {
            borderRadius: 2,
            backgroundColor: barColor
        }
    }))(LinearProgress);
    return jsx(BorderLinearProgress, { variant: "determinate", value: value, "data-testid": "progress-bar" }, void 0);
};

var css_248z$11 = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.sharableLink{align-items:center;color:#f36a22!important;display:flex;flex-direction:row;font-size:.825rem;font-weight:700;white-space:nowrap}.sharableLink.disabled{color:#000!important;font-weight:400}.linkText{height:0;opacity:0;width:0}.sharable-tooltip{font-size:\"14px\"}";
styleInject(css_248z$11);

const SharableLink = (props) => {
    const { url, disabled } = props;
    const { translate } = useTranslationContext();
    const [isCopied, setIsCopied] = useState(false);
    const [isHover, setIsHover] = useState(false);
    const title = props.title || (disabled ? translate('SharableLinkTitleEveryone') : translate('SharableLinkTitle'));
    const tooltipCopy = props.tooltipCopy ||
        (disabled ? translate('SharableLinkTooltipEveryone') : translate('SharableLinkTooltipCopy'));
    const tooltipCopied = props.tooltipCopied || translate('SharableLinkTooltipCopied');
    return (jsx(TooltipContainer, Object.assign({ title: isCopied ? tooltipCopied : tooltipCopy, open: isHover, hasBorder: true, titleClassName: "sharable-tooltip", "data-testid": "sharable-link" }, { children: disabled ? (jsxs("span", Object.assign({ className: classNames('sharableLink', 'disabled'), onMouseOver: () => setIsHover(true), onMouseLeave: () => setIsHover(false) }, { children: [jsx(LinkIcon, { style: { transform: 'rotate(45deg)' } }, void 0), title] }), void 0)) : (jsxs("a", Object.assign({ className: "sharableLink", onClick: e => {
                e.preventDefault();
                copyToClipboard(url);
                setIsCopied(true);
            }, href: url, onMouseOver: () => setIsHover(true), onMouseLeave: () => {
                setIsHover(false);
                setTimeout(() => setIsCopied(false), 100);
            } }, { children: [jsx(LinkIcon, { style: { transform: 'rotate(45deg)' } }, void 0), title] }), void 0)) }), void 0));
};

const LimitTag = (props) => {
    const { texts, limitTag, chipClassName, textClassName } = props;
    const limitTagNumber = texts.length - limitTag;
    return (jsxs("div", { children: [jsx("span", Object.assign({ className: textClassName, "data-testid": "limited-text" }, { children: lib$1.concatStrings(texts.slice(0, limitTag), ', ') }), void 0), limitTagNumber > 0 && (jsx(TooltipContainer, Object.assign({ hasBorder: true, hasDefaultStyle: true, title: lib$1.concatStrings(texts.slice(limitTag, texts.length), ', ') }, { children: jsx("span", { children: jsx(ChipContainer, { dataTestid: "limit-tag", label: `+${limitTagNumber}`, type: "ellipse", className: chipClassName }, void 0) }, void 0) }), void 0))] }, void 0));
};

var css_248z$10 = ".class-tabs{align-items:space-between;align-self:center;display:flex;font-size:1.125rem;height:100%;width:100%}.class-tabs .tab{align-items:center;display:flex;justify-content:center}.class-hover-pointer{cursor:pointer}.class-opacity-half{opacity:.5}";
styleInject(css_248z$10);

const Tabs = ({ texts, selectedTab, selectedAmount, onClick }) => {
    return (jsx("div", Object.assign({ className: "class-tabs" }, { children: texts.map(text => {
            const { content, key } = text;
            const isSelected = key === selectedTab;
            return (jsx(LabelInformation, { dataTestId: `tab-${key}`, title: lib$1.capitalizeFirstLetter(content), value: selectedAmount, type: "right", isSelected: isSelected, className: classNames('tab', {
                    'class-hover-pointer': !isSelected,
                    'class-opacity-half': !isSelected
                }), onClick: (_) => !isSelected && onClick(key) }, key));
        }) }), void 0));
};

const useStyles$g = makeStyles$1(() => ({
    wrapper: {
        display: 'grid'
    },
    rightNumber: {
        gridArea: '1 / 1',
        zIndex: 2,
        paddingLeft: '1rem',
        fontSize: '0.8rem',
        color: 'white',
        margin: 'auto 0'
    }
}));
const CustomizedProgressBars = (props) => {
    const { value, bgColor, color, showValue = true, hasBorder, height = '1.2rem' } = props;
    const classes = useStyles$g();
    const BorderLinearProgress = withStyles(_theme => ({
        root: Object.assign({ gridArea: '1 / 1', height, borderRadius: 10, zIndex: 1 }, (hasBorder && { border: '1px solid #FFFFFF' })),
        colorPrimary: {
            backgroundColor: bgColor || '#6b6874'
        },
        bar: {
            backgroundColor: color || '#3dc483'
        }
    }))(LinearProgress);
    return (jsxs("div", Object.assign({ className: classes.wrapper }, { children: [showValue && jsxs("span", Object.assign({ className: classes.rightNumber }, { children: [value % 1 === 0 ? value : value.toFixed(0), "%"] }), void 0), jsx(BorderLinearProgress, { variant: "determinate", value: value }, void 0)] }), void 0));
};

var css_248z$$ = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.head{background-color:#fff!important;color:#95939b}.class-td-last-child,.td-first-child{border-top-left-radius:5px!important}";
styleInject(css_248z$$);

const SelectTableHeader = (props) => {
    const { headers, onSelectAll, numOfSelectedRows, numOfRows, disabled } = props;
    const isAllRowsSelected = numOfRows !== 0 && numOfSelectedRows === numOfRows;
    const isNoRowsSelected = numOfSelectedRows === 0;
    const getType = () => {
        if (isAllRowsSelected)
            return 'selected';
        return disabled ? 'disabled' : (isNoRowsSelected && 'unSelected') || 'indeterminate';
    };
    return (jsx(TableHead, { children: jsxs(TableRow, { children: [jsx(TableCell, Object.assign({ padding: "checkbox", className: classNames('head', 'td-first-child') }, { children: jsx(CheckboxContainer, { type: getType(), onChange: (_) => (disabled ? undefined : onSelectAll()) }, void 0) }), void 0), headers.map((header, i) => (jsx(TableCell, Object.assign({ align: "left", padding: header.disablePadding ? 'none' : 'default', className: i === headers.length - 1 ? classNames('head', 'td-last-child') : 'head' }, { children: header.label }), header.id)))] }, void 0) }, void 0));
};

const SelectTableBody = (props) => {
    const { headers, rows, rowClassname, onClickRow, isRowSelected, rowsPerPage, page, disabled, isServerPagination } = props;
    const emptyRows = isServerPagination
        ? rowsPerPage - rows.length
        : rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
    const pageRows = isServerPagination ? rows : rows.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    return (jsxs(TableBody, { children: [pageRows.map((pageRow, index) => {
                const row = (pageRow === null || pageRow === void 0 ? void 0 : pageRow.key) ? pageRow === null || pageRow === void 0 ? void 0 : pageRow.values : pageRow;
                const isRowSelectedParams = (pageRow === null || pageRow === void 0 ? void 0 : pageRow.key) ||
                    [row[0], row[1]];
                const rowSelectionType = isRowSelected(isRowSelectedParams);
                const isSelected = rowSelectionType === CheckboxTypesName.selected;
                const labelId = `enhanced-table-checkbox-${index}`;
                return (jsxs(TableRow, Object.assign({ hover: true, onClick: () => (disabled ? undefined : onClickRow((pageRow === null || pageRow === void 0 ? void 0 : pageRow.key) || row)), role: "checkbox", "aria-checked": isSelected, tabIndex: -1, selected: isSelected, className: rowClassname }, { children: [jsx(TableCell, Object.assign({ padding: "checkbox" }, { children: jsx(CheckboxContainer, { type: disabled ? 'disabled' : rowSelectionType }, void 0) }), void 0), jsx(TableCell, Object.assign({ component: "th", id: labelId, scope: "row", padding: "none", style: { width: `${100 / headers.length}%` } }, { children: jsx(EllipsisText, { text: row[0] }, void 0) }), void 0), row.map((r, i) => i !== 0 && (jsx(TableCell, Object.assign({ align: "left", style: { width: `${100 / headers.length}%` } }, { children: jsx(EllipsisText, { text: r }, void 0) }), i)))] }), row[0]));
            }), emptyRows > 0 && (jsx(TableRow, Object.assign({ style: { height: 53 * emptyRows } }, { children: jsx(TableCell, { colSpan: headers.length }, void 0) }), void 0))] }, void 0));
};

const rowsPerPageOptionsList = [5, 10, 25, 50];

var AnswerType;
(function (AnswerType) {
    AnswerType[AnswerType["single"] = 0] = "single";
    AnswerType[AnswerType["multiple"] = 1] = "multiple";
})(AnswerType || (AnswerType = {}));

/* eslint-disable import/prefer-default-export, camelcase */
var QuestionType;
(function (QuestionType) {
    QuestionType[QuestionType["multichoice"] = 0] = "multichoice";
    QuestionType[QuestionType["correctCode"] = 1] = "correctCode";
    QuestionType[QuestionType["binary_choice"] = 2] = "binary_choice";
    QuestionType[QuestionType["quad_choice"] = 3] = "quad_choice";
    QuestionType[QuestionType["snippet_binary_choice"] = 4] = "snippet_binary_choice";
    QuestionType[QuestionType["single_select_remediation"] = 5] = "single_select_remediation";
})(QuestionType || (QuestionType = {}));

var AvatarType;
(function (AvatarType) {
    AvatarType[AvatarType["Tournament"] = 0] = "Tournament";
    AvatarType[AvatarType["User"] = 1] = "User";
    AvatarType[AvatarType["CustomCourse"] = 2] = "CustomCourse";
    AvatarType[AvatarType["Default"] = 3] = "Default";
})(AvatarType || (AvatarType = {}));

var css_248z$_ = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.select-table-container{border-radius:5px;box-shadow:0 0 1px 1px #d6d6d6;transition:height .1s ease-in-out}.select-table-container::-webkit-scrollbar{width:4px!important}.select-table-container::-webkit-scrollbar-thumb{border-radius:1.5px!important;height:69px!important}.MuiTableRow-root.Mui-selected{background-color:#fff!important}.max-height-longer-table{height:17.2rem!important;max-height:17.2rem!important}.max-height-table{height:15.625rem!important;max-height:15.625rem!important}.min-height-table{height:13rem!important;max-height:13rem!important}.max-height-table-tree{height:90%!important;max-height:90%!important}.class-opacity-table{opacity:.5}";
styleInject(css_248z$_);

/* eslint-disable css-modules/no-undef-class */
const useStyles$f = makeStyles$1((theme) => createStyles({
    root: {
        width: '100%',
        fontSize: '0.875rem'
    },
    paper: {
        width: '100%',
        border: 'none',
        marginBottom: theme.spacing(2),
        boxShadow: 'none'
    },
    table: {
        minWidth: 750
    },
    tr: {
        '&:hover': {
            cursor: 'pointer'
        }
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));
const SelectTable = (props) => {
    const { headers, rows, selectedRows, onSelectAll, onClickRow, isRowSelected, tableHeight, disabled, isServerPagination, isLoading, onPageChange, totalRecords = 0 } = props;
    const classes = useStyles$f();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const handleChangePage = (newPage) => {
        setPage(newPage);
        isServerPagination && (onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(newPage, rowsPerPage));
    };
    const handleChangeRowsPerPage = (event) => {
        const rowsPerPageTemp = parseInt(event.target.value, 10);
        setRowsPerPage(rowsPerPageTemp);
        setPage(0);
        isServerPagination && (onPageChange === null || onPageChange === void 0 ? void 0 : onPageChange(0, rowsPerPageTemp));
    };
    const previousRefHeaders = useRef(headers);
    useEffect(() => {
        previousRefHeaders.current = headers;
    });
    const prevHeaders = previousRefHeaders.current;
    useEffect(() => {
        if (prevHeaders[0].id !== headers[0].id) {
            setRowsPerPage(5);
            setPage(0);
        }
    }, [prevHeaders, headers, setRowsPerPage, setPage]);
    return (jsx("div", Object.assign({ "data-testid": "select-table", className: classes.root }, { children: jsxs(Paper$1, Object.assign({ className: classNames(classes.paper, {
                'class-opacity-table': disabled || isLoading
            }) }, { children: [jsx(TableContainer, Object.assign({ className: classNames('select-table-container', tableHeight) }, { children: jsxs(Table, Object.assign({ stickyHeader: true, "aria-label": "sticky table", className: classes.table, "aria-labelledby": "tableTitle", size: "medium" }, { children: [jsx(SelectTableHeader, { headers: headers, onSelectAll: onSelectAll, numOfSelectedRows: selectedRows.length, numOfRows: rows.length, disabled: disabled }, void 0), jsx(SelectTableBody, { headers: headers, rows: rows, page: page, rowClassname: classes.tr, onClickRow: onClickRow, isRowSelected: isRowSelected, rowsPerPage: rowsPerPage, disabled: disabled, isServerPagination: isServerPagination }, void 0)] }), void 0) }), void 0), jsx(TablePagination, { rowsPerPageOptions: rowsPerPageOptionsList, component: "div", count: isServerPagination ? totalRecords : rows.length, rowsPerPage: rowsPerPage, page: page, onPageChange: (_, newPage) => handleChangePage(newPage), onChangeRowsPerPage: handleChangeRowsPerPage }, void 0)] }), void 0) }), void 0));
};

var css_248z$Z = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.head{background-color:#fff!important;color:#95939b}.td-first-child{border-top-left-radius:5px!important}.class-hover-pointer:hover{cursor:pointer}.class-td-last-child{border-top-left-radius:5px!important}";
styleInject(css_248z$Z);

const SelectTableTreeHeader = (props) => {
    const { tableData } = props;
    const { headers, onClick, hasOpenIcon, isTableOpen, handleIconClick, isSelected } = tableData[0];
    return (jsx(TableHead, { children: jsxs(TableRow, { children: [hasOpenIcon && (jsx(TableCell, Object.assign({ padding: "checkbox", className: classNames('head', 'td-first-child') }, { children: isTableOpen ? (jsx(ArrowDropDownIcon$1, { color: "action", onClick: () => handleIconClick === null || handleIconClick === void 0 ? void 0 : handleIconClick([0]), className: "class-hover-pointer" }, void 0)) : (jsx(ArrowRightIcon$1, { color: "action", onClick: () => handleIconClick === null || handleIconClick === void 0 ? void 0 : handleIconClick([0]), className: "class-hover-pointer" }, void 0)) }), void 0)), jsx(TableCell, Object.assign({ padding: "checkbox", className: classNames('head', 'td-first-child') }, { children: jsx(CheckboxContainer, { type: isSelected, onChange: (_) => onClick === null || onClick === void 0 ? void 0 : onClick([0]) }, void 0) }), void 0), headers === null || headers === void 0 ? void 0 : headers.map((header, i) => (jsx(TableCell, Object.assign({ align: "left", padding: header.disablePadding ? 'none' : 'default', className: i === (headers === null || headers === void 0 ? void 0 : headers.length) - 1 ? classNames('head', 'td-last-child') : 'head' }, { children: header.label }), header.id)))] }, void 0) }, void 0));
};

var css_248z$Y = ".class-hover-pointer:hover{cursor:pointer}";
styleInject(css_248z$Y);

const renderRow = (table, ids, headersLength = 1) => {
    const { hasOpenIcon, isTableOpen, isSelected, onClick, row } = table;
    const isSelectedAsBoolean = isSelected !== 'indeterminate';
    return (jsxs(TableRow, Object.assign({ hover: true, role: "checkbox", "aria-checked": isSelectedAsBoolean, tabIndex: -1, selected: isSelectedAsBoolean }, { children: [jsx(TableCell, Object.assign({ padding: "checkbox" }, { children: hasOpenIcon &&
                    (isTableOpen ? (jsx(ArrowDropDownIcon$1, { color: "action", onClick: () => { var _a; return (_a = table.handleIconClick) === null || _a === void 0 ? void 0 : _a.call(table, ids); }, className: "class-hover-pointer" }, void 0)) : (jsx(ArrowRightIcon$1, { color: "action", onClick: () => { var _a; return (_a = table.handleIconClick) === null || _a === void 0 ? void 0 : _a.call(table, ids); }, className: "class-hover-pointer" }, void 0))) }), void 0), jsx(TableCell, Object.assign({ padding: "checkbox" }, { children: jsx(CheckboxContainer, { type: isSelected, onChange: () => onClick === null || onClick === void 0 ? void 0 : onClick(ids) }, void 0) }), void 0), jsx(TableCell, Object.assign({ component: "th", scope: "row", padding: "none", style: { width: `${100 / headersLength}%` } }, { children: jsx(EllipsisText, { text: String(row === null || row === void 0 ? void 0 : row[0]) }, void 0) }), void 0), row === null || row === void 0 ? void 0 : row.map((td, i) => i !== 0 && (jsx(TableCell, Object.assign({ align: "left", style: { width: `${100 / headersLength}%` } }, { children: jsx(EllipsisText, { text: td }, void 0) }), i)))] }), String(ids)));
};
const renderTable = (tableData, ids, headersLength) => {
    return tableData.map(obj => {
        const children = [];
        let newIds = [...ids];
        if (obj.id !== undefined)
            newIds = [...ids, obj.id];
        if (obj.row) {
            children.push(renderRow(obj, newIds));
        }
        if (obj.table && (obj.isTableOpen || obj.headers)) {
            children.push(renderTable(obj.table, newIds));
        }
        return children;
    });
};
const SelectTableTreeBody = (props) => {
    var _a, _b, _c;
    const { tableData, rowsPerPage, page, noRecordsText } = props;
    const data = ((_a = tableData[0].table) === null || _a === void 0 ? void 0 : _a.slice(page * rowsPerPage, (page + 1) * rowsPerPage)) || tableData;
    const ids = [];
    if (tableData[0].table)
        ids.push(0);
    const emptyRows = !tableData[0].table || !data.length;
    return (jsxs(TableBody, { children: [jsx(Fragment$1, { children: renderTable(data, ids, (_b = tableData[0].headers) === null || _b === void 0 ? void 0 : _b.length) }, void 0), emptyRows ? (jsx(TableRow, { children: jsx(TableCell, Object.assign({ colSpan: (((_c = tableData[0].headers) === null || _c === void 0 ? void 0 : _c.length) || 1) * 2, align: "center", className: "alignJustify" }, { children: noRecordsText }), void 0) }, void 0)) : null] }, void 0));
};

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$2(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$2;

var eq$1 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$1(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal$1 == 'object' && commonjsGlobal$1 && commonjsGlobal$1.Object === Object && commonjsGlobal$1;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$8 = freeGlobal || freeSelf || Function('return this')();

var _root = root$8;

var root$7 = _root;

/** Built-in value references. */
var Symbol$4 = root$7.Symbol;

var _Symbol = Symbol$4;

var Symbol$3 = _Symbol;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$c.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$9.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$b = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$b.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$2 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$4(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$4;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$5(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$5;

var baseGetTag$3 = _baseGetTag,
    isObject$4 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject$4(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$3(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$1 = isFunction_1,
    isMasked = _isMasked,
    isObject$3 = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$a = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$3(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$6(root$5, 'Map');

var _Map = Map$4;

var getNative$5 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$5(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$6.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$3 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$1.prototype.clear = mapCacheClear;
MapCache$1.prototype['delete'] = mapCacheDelete;
MapCache$1.prototype.get = mapCacheGet;
MapCache$1.prototype.has = mapCacheHas;
MapCache$1.prototype.set = mapCacheSet;

var _MapCache = MapCache$1;

var ListCache$1 = _ListCache,
    Map$2 = _Map,
    MapCache = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$1(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$1.prototype.clear = stackClear;
Stack$1.prototype['delete'] = stackDelete;
Stack$1.prototype.get = stackGet;
Stack$1.prototype.has = stackHas;
Stack$1.prototype.set = stackSet;

var _Stack = Stack$1;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$1;

var getNative$4 = _getNative;

var defineProperty$1 = (function() {
  try {
    var func = getNative$4(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$2 = defineProperty$1;

var defineProperty = _defineProperty$2;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$2(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$2;

var baseAssignValue$1 = _baseAssignValue,
    eq = eq_1;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$2;

var assignValue$1 = _assignValue,
    baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$4(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$4;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$5(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$5;

var baseGetTag$2 = _baseGetTag,
    isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$4(value) && baseGetTag$2(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$3 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$1 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$3(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$1;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$3 = Array.isArray;

var isArray_1 = isArray$3;

var isBuffer$2 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

isBuffer$2.exports;

(function (module, exports) {
	var root = _root,
	    stubFalse = stubFalse_1;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;

	module.exports = isBuffer; 
} (isBuffer$2, isBuffer$2.exports));

var isBufferExports = isBuffer$2.exports;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$1(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$1;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$2(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$2;

var baseGetTag$1 = _baseGetTag,
    isLength$1 = isLength_1,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] =
typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$2(value) &&
    isLength$1(value.length) && !!typedArrayTags[baseGetTag$1(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$3(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$3;

var _nodeUtil = {exports: {}};

_nodeUtil.exports;

(function (module, exports) {
	var freeGlobal = _freeGlobal;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;

	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;

	    if (types) {
	      return types;
	    }

	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());

	module.exports = nodeUtil; 
} (_nodeUtil, _nodeUtil.exports));

var _nodeUtilExports = _nodeUtil.exports;

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$2 = _baseUnary,
    nodeUtil$2 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$1 = nodeIsTypedArray ? baseUnary$2(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$1;

var baseTimes = _baseTimes,
    isArguments = isArguments_1,
    isArray$2 = isArray_1,
    isBuffer$1 = isBufferExports,
    isIndex = _isIndex,
    isTypedArray = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$2(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */

var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$3(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

var _isPrototype = isPrototype$3;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$2 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$2(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

var isFunction = isFunction_1,
    isLength = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$2(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

var isArrayLike_1 = isArrayLike$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$1 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$3(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys(object);
}

var keys_1 = keys$3;

var copyObject$3 = _copyObject,
    keys$2 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$3(source, keys$2(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$2 = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$2(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$3(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$3;

var copyObject$2 = _copyObject,
    keysIn$2 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$2(source, keysIn$2(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

_cloneBuffer.exports;

(function (module, exports) {
	var root = _root;

	/** Detect free variable `exports`. */
	var freeExports = exports && !exports.nodeType && exports;

	/** Detect free variable `module`. */
	var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;

	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

	  buffer.copy(result);
	  return result;
	}

	module.exports = cloneBuffer; 
} (_cloneBuffer, _cloneBuffer.exports));

var _cloneBufferExports = _cloneBuffer.exports;

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$1(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$1;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$3;

var copyObject$1 = _copyObject,
    getSymbols$2 = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$1(source, getSymbols$2(source), object);
}

var _copySymbols = copySymbols$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$2(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$2;

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$2 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$2;

var arrayPush$1 = _arrayPush,
    getPrototype$1 = _getPrototype,
    getSymbols$1 = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush$1(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;

var copyObject = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var arrayPush = _arrayPush,
    isArray$1 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols = _getSymbols,
    keys$1 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys$1(object, keys$1, getSymbols);
}

var _getAllKeys = getAllKeys$1;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$1 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$1(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$1;

var getNative$3 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$3(root$4, 'DataView');

var _DataView = DataView$2;

var getNative$2 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$2(root$3, 'Promise');

var _Promise = Promise$2;

var getNative$1 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var Set$2 = getNative$1(root$2, 'Set');

var _Set = Set$2;

var getNative = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative(root$1, 'WeakMap');

var _WeakMap = WeakMap$2;

var DataView$1 = _DataView,
    Map$1 = _Map,
    Promise$1 = _Promise,
    Set$1 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$1),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$3 = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag$3(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map$1 && getTag$3(new Map$1) != mapTag$3) ||
    (Promise$1 && getTag$3(Promise$1.resolve()) != promiseTag) ||
    (Set$1 && getTag$3(new Set$1) != setTag$3) ||
    (WeakMap$1 && getTag$3(new WeakMap$1) != weakMapTag$1)) {
  getTag$3 = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$3;

/** Used for built-in method references. */

var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var root = _root;

/** Built-in value references. */
var Uint8Array$2 = root.Uint8Array;

var _Uint8Array = Uint8Array$2;

var Uint8Array$1 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$1 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$1:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$1 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
    getPrototype = _getPrototype,
    isPrototype = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$1(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject$1;

var getTag$2 = _getTag,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$1(value) && getTag$2(value) == mapTag$1;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$1 = _baseUnary,
    nodeUtil$1 = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$1 = _getTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtilExports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack = _Stack,
    arrayEach = _arrayEach,
    assignValue = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer = _cloneBufferExports,
    copyArray = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys = _getAllKeys,
    getAllKeysIn = _getAllKeysIn,
    getTag = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject = _initCloneObject,
    isArray = isArray_1,
    isBuffer = isBufferExports,
    isMap = isMap_1,
    isObject = isObject_1,
    isSet = isSet_1,
    keys = keys_1,
    keysIn = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

var baseClone = _baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

var cloneDeep_1 = cloneDeep;

var cloneDeep$1 = /*@__PURE__*/getDefaultExportFromCjs(cloneDeep_1);

/* eslint-disable css-modules/no-undef-class */
const useStyles$e = makeStyles$1(() => createStyles({
    root: {
        width: '100%',
        height: '100%',
        fontSize: '0.875rem'
    },
    paper: {
        width: '100%',
        border: 'none',
        height: '100%',
        boxShadow: 'none'
    },
    table: {
        minWidth: 750
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1
    }
}));
const SelectTableTree = (props) => {
    var _a, _b;
    const { tableData, tableHeight, noRecordsText } = props;
    const classes = useStyles$e();
    const defualtPage = 0;
    const defualtRowsPerPage = rowsPerPageOptionsList[0];
    const [page, setPage] = useState(defualtPage);
    const [rowsPerPage, setRowsPerPage] = useState(defualtRowsPerPage);
    const [selectAllCheckboxType, setSelectAllCheckboxType] = useState('indeterminate');
    const handleChangePage = (newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    // TODO: [CO-2961]
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const headers = ((_a = tableData[0]) === null || _a === void 0 ? void 0 : _a.headers) || [];
    const previousRefHeaders = useRef(headers);
    useEffect(() => {
        previousRefHeaders.current = headers;
    });
    const prevHeaders = previousRefHeaders.current;
    useEffect(() => {
        if (prevHeaders[0].id !== headers[0].id) {
            setRowsPerPage(defualtRowsPerPage);
            setPage(defualtPage);
        }
    }, [defualtRowsPerPage, prevHeaders, headers, setRowsPerPage, setPage]);
    return (jsx("div", Object.assign({ "data-testid": "select-table-tree", className: classes.root }, { children: jsxs(Paper$1, Object.assign({ className: classes.paper }, { children: [jsx(TableContainer, Object.assign({ className: classNames('select-table-container', tableHeight) }, { children: jsxs(Table, Object.assign({ stickyHeader: true, "aria-label": "sticky table", className: classes.table, "aria-labelledby": "tableTitle", size: "medium" }, { children: [jsx(SelectTableTreeHeader, { tableData: tableData, selectAllCheckboxType: selectAllCheckboxType }, void 0), jsx(SelectTableTreeBody, { tableData: tableData, page: page, rowsPerPage: rowsPerPage, setSelectAllCheckboxType: setSelectAllCheckboxType, noRecordsText: noRecordsText }, void 0)] }), void 0) }), void 0), jsx(TablePagination, { rowsPerPageOptions: rowsPerPageOptionsList, component: "div", count: ((_b = tableData[0].table) === null || _b === void 0 ? void 0 : _b.length) || 0, rowsPerPage: rowsPerPage, page: page, onPageChange: (_, newPage) => handleChangePage(newPage), onChangeRowsPerPage: handleChangeRowsPerPage }, void 0)] }), void 0) }), void 0));
};

const SelectTableTreeContainer = (props) => {
    const { data, setSelectedRows, setText, treeDepth, noRecordsText } = props;
    const setIsSelected = (ids) => handleOnSelect(ids, 'isSelected');
    const handleIconClick = (ids) => handleOnClick(ids, 'isTableOpen');
    const handleOnSelect = (ids, prop) => {
        const node = cloneDeep$1(tableDataRef.current);
        const obj = findByIds(node, ids);
        let status = obj[prop];
        if (status === 'selected' || status === 'indeterminate')
            status = 'unSelected';
        else if (status === 'unSelected')
            status = 'selected';
        obj[prop] = status;
        if (obj.table) {
            setText(obj, status === 'selected' ? obj.table.length : 0, obj.table.length);
            obj.table.forEach(item => item.table && setText(item, status === 'selected' ? item.table.length : 0, item.table.length));
            setAllChildren(obj.table, { prop, value: status });
        }
        setParentState(node, ids, prop);
        setSelectedRows(obj.pointer, status === 'selected');
        setTableData(node);
    };
    const setParentState = (root, ids, prop) => {
        if (ids.length <= 1)
            return;
        const parentIds = [...ids];
        parentIds.pop();
        const parent = findByIds(root, parentIds);
        const isFirstParent = parentIds.length === treeDepth - 1;
        if (isFirstParent)
            setText(parent, parent.table.filter((item) => item.isSelected === 'selected').length, parent.table.length);
        let status = 'indeterminate';
        let countAll = 0;
        let countPart = 0;
        if (parent.table) {
            parent.table.forEach((item) => {
                if (item.isSelected === 'selected') {
                    countAll++;
                    countPart++;
                }
                else if (item.isSelected === 'indeterminate')
                    countPart++;
            });
            if (countAll === parent.table.length)
                status = 'selected';
            else if (countAll === 0 && countPart === 0)
                status = 'unSelected';
        }
        parent[prop] = status;
        parentIds.length > 1 && setParentState(root, parentIds, prop);
    };
    const handleOnClick = (ids, prop) => {
        const node = cloneDeep$1(tableDataRef.current);
        const obj = findByIds(node, ids);
        const newStatus = !obj[prop];
        obj[prop] = newStatus;
        if (obj.table)
            setAllChildren(obj.table, { prop, value: newStatus });
        setTableData(node);
    };
    const findByIds = (root, ids) => {
        let currNode = root;
        [...Array(ids.length)].forEach((_num, i) => {
            if (i === ids.length - 1) {
                currNode = currNode[ids[i]];
            }
            else {
                currNode = currNode[ids[i]].table;
            }
        });
        return currNode;
    };
    const setAllChildren = (item, actions) => {
        item.forEach((obj) => {
            obj[actions.prop] = actions.value;
            if (obj.table)
                setAllChildren(obj.table, actions);
        });
    };
    const convertItemToExpectedData = (node, defaultObj) => {
        for (let i = 0; i < node.length; i++) {
            node[i] = Object.assign(Object.assign(Object.assign({}, defaultObj), node[i]), { id: i });
            if (node[i].table) {
                node[i].hasOpenIcon = true;
                convertItemToExpectedData(node[i].table, defaultObj);
            }
        }
    };
    const convertToExpectedData = () => {
        const defaultObj = {
            isSelected: 'unSelected',
            onClick: setIsSelected,
            isTableOpen: false,
            hasOpenIcon: false,
            handleIconClick
        };
        const dataTmp = cloneDeep$1(data);
        dataTmp[0] = Object.assign(Object.assign(Object.assign({}, defaultObj), dataTmp[0]), { id: 0, hasOpenIcon: true });
        if (dataTmp[0].table) {
            convertItemToExpectedData(dataTmp[0].table, defaultObj);
        }
        return dataTmp;
    };
    const [tableData, setTableData] = useState(convertToExpectedData());
    const tableDataRef = useRef(tableData);
    tableDataRef.current = tableData;
    return (jsx(SelectTableTree, { tableData: tableDataRef.current, tableHeight: "max-height-table-tree", noRecordsText: noRecordsText }, void 0));
};

var css_248z$X = ".search-table{display:flex;flex-direction:column;height:100%;justify-content:space-around}.simple-search{height:10%}.simple-table{height:90%}";
styleInject(css_248z$X);

const SearchTable = (props) => {
    const { searchData, tableData, isTeamBoard } = props;
    const rootId = isTeamBoard ? 'common-components-1786027375689-1' : 'common-components-1786037206689-1';
    const searchWrapperId = isTeamBoard ? 'common-components-1786027375690-6' : 'common-components-1786037206690-6';
    const tableWrapperId = isTeamBoard ? 'common-components-1786027375720-9' : 'common-components-1786037206720-9';
    return (jsxs("div", Object.assign({ "data-testid": "search-table", className: "search-table", id: rootId }, { children: [jsx("div", Object.assign({ className: "simple-search", id: searchWrapperId }, { children: jsx(SimpleSearch, Object.assign({}, searchData), void 0) }), void 0), jsx("div", Object.assign({ className: "simple-table", id: tableWrapperId }, { children: jsx(SimpleTable, Object.assign({}, tableData), void 0) }), void 0)] }), void 0));
};

/* loaded by smart-asset */
var js = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0iI0YxREQzRiIgZD0iTTExLjQgMTBoMi43djcuNmMwIDMuNC0xLjYgNC42LTQuMyA0LjYtLjYgMC0xLjUtLjEtMi0uM2wuMy0yLjJjLjQuMi45LjMgMS40LjMgMS4xIDAgMS45LS41IDEuOS0yLjRWMTB6bTUuMSA5LjJjLjcuNCAxLjkuOCAzIC44IDEuMyAwIDEuOS0uNSAxLjktMS4zcy0uNi0xLjItMi0xLjdjLTItLjctMy4zLTEuOC0zLjMtMy42IDAtMi4xIDEuNy0zLjYgNC42LTMuNiAxLjQgMCAyLjQuMyAzLjEuNmwtLjYgMi4yYy0uNS0uMi0xLjMtLjYtMi41LS42cy0xLjguNS0xLjggMS4yYzAgLjguNyAxLjEgMi4yIDEuNyAyLjEuOCAzLjEgMS45IDMuMSAzLjYgMCAyLTEuNiAzLjctNC45IDMuNy0xLjQgMC0yLjctLjQtMy40LS43bC42LTIuM3oiLz48L3N2Zz4K";

/* loaded by smart-asset */
var java = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii00IC00IDIwIDIwIiBmaWxsPSIjY2MzZTQ0Ij48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02IDBhNiA2IDAgMSAwIDYgNiA2IDYgMCAwIDAtNi02em0yLjE0IDYuOGEyLjE2IDIuMTYgMCAwIDEtMi4yOSAyLjQxIDIuNSAyLjUgMCAwIDEtMi0uODdsLjczLS45MmExLjUyIDEuNTIgMCAwIDAgMS4yMy41OWMuNjYgMCAxLjA2LS40MiAxLjA2LTEuMzJWMi44aDEuMjZ6Ii8+PC9zdmc+Cg==";

/* loaded by smart-asset */
var json = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0iI0RCQ0Q2OCIgZD0iTTcuNSAxNS4xYzEuNSAwIDEuNy0uOCAxLjctMS41IDAtLjYtLjEtMS4xLS4xLTEuN1M5IDEwLjcgOSAxMC4yYzAtMi4xIDEuMy0zIDMuNC0zaC44djEuOWgtLjRjLTEgMC0xLjMuNi0xLjMgMS42IDAgLjQuMS44LjEgMS4zIDAgLjQuMS45LjEgMS41IDAgMS43LS43IDIuMy0xLjkgMi42IDEuMi4zIDEuOS45IDEuOSAyLjYgMCAuNi0uMSAxLjEtLjEgMS41IDAgLjQtLjEuOS0uMSAxLjIgMCAxIC4zIDEuNiAxLjMgMS42aC40djEuOWgtLjhjLTIgMC0zLjMtLjgtMy4zLTMgMC0uNiAwLTEuMS4xLTEuNy4xLS42LjEtMS4yLjEtMS43IDAtLjYtLjItMS41LTEuNy0xLjVsLS4xLTEuOXptMTcgMS43Yy0xLjUgMC0xLjcuOS0xLjcgMS41cy4xIDEuMS4xIDEuN2MuMS42LjEgMS4yLjEgMS43IDAgMi4yLTEuNCAzLTMuNCAzaC0uOFYyM2guNGMxIDAgMS4zLS42IDEuMy0xLjYgMC0uNCAwLS44LS4xLTEuMiAwLS41LS4xLTEtLjEtMS41IDAtMS43LjctMi4zIDEuOS0yLjYtMS4yLS4zLTEuOS0uOS0xLjktMi42IDAtLjYuMS0xLjEuMS0xLjUuMS0uNS4xLS45LjEtMS4zIDAtMS0uNC0xLjUtMS4zLTEuNmgtLjRWNy4yaC44YzIuMSAwIDMuNC45IDMuNCAzIDAgLjYtLjEgMS4xLS4xIDEuNy0uMS42LS4xIDEuMi0uMSAxLjcgMCAuNy4yIDEuNSAxLjcgMS41djEuN3oiLz48L3N2Zz4K";

/* loaded by smart-asset */
var cs = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PGcgZmlsbD0iIzUyOUJCQSI+PHBhdGggZD0iTTcuMSAxNS45YzAtMS4zLjItMi40LjYtMy40LjQtMSAuOS0xLjggMS42LTIuNS43LS43IDEuNS0xLjIgMi40LTEuNnMxLjktLjUgMi45LS41IDEuOS4yIDIuNy42Yy44LjQgMS41LjkgMiAxLjRsLTIuMiAyLjVjLS40LS4zLS43LS42LTEuMS0uNy0uNC0uMS0uOC0uMy0xLjQtLjMtLjUgMC0uOS4xLTEuMy4zLS40LjItLjguNS0xLjEuOXMtLjUuOC0uNyAxLjRjLS4yLjYtLjMgMS4yLS4zIDEuOSAwIDEuNS4zIDIuNiAxIDMuMy43LjggMS41IDEuMiAyLjYgMS4yLjUgMCAxLS4xIDEuNC0uMy40LS4yLjgtLjUgMS4xLS45bDIuMiAyLjVjLS43LjgtMS40IDEuMy0yLjIgMS43LS44LjQtMS43LjYtMi43LjZzLTItLjItMi45LS41LTEuNy0uOC0yLjQtMS41LTEuMS0xLjctMS41LTIuN2MtLjUtLjktLjctMi4xLS43LTMuNHoiLz48cGF0aCBkPSJNMjEuOCAxNy4xaC0xbC0uNCAyLjRoLTEuMmwuNC0yLjRoLTEuMlYxNmgxLjVsLjItMS42aC0xLjN2LTEuMWgxLjVsLjQtMi40aDEuMmwtLjQgMi40aDFsLjQtMi40aDEuMmwtLjQgMi40SDI1djEuMWgtMS42bC0uMiAxLjZoMS4zdjEuMWgtMS42bC0uNCAyLjRoLTEuMmMwIC4xLjUtMi40LjUtMi40em0tLjgtMWgxbC4yLTEuNmgtMWwtLjIgMS42eiIvPjwvZz48L3N2Zz4K";

/* loaded by smart-asset */
var cshtml = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0iI0VGNzYyMyIgZD0iTTggMTVsNi01LjZWMTJsLTQuNSA0IDQuNSA0djIuNkw4IDE3di0yem0xNiAyLjFsLTYgNS42VjIwbDQuNi00LTQuNi00VjkuM2w2IDUuNnYyLjJ6Ii8+PC9zdmc+Cg==";

/* loaded by smart-asset */
var css = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0iIzUyOUJCQSIgZD0iTTEwLjMgMjMuM2wuOC00SDguNnYtMi4xaDNsLjUtMi41SDkuNXYtMi4xaDMuMWwuOC0zLjloMi44bC0uOCAzLjloMi44bC44LTMuOWgyLjhsLS44IDMuOWgyLjV2Mi4xaC0yLjlsLS42IDIuNWgyLjZ2Mi4xaC0zbC0uOCA0SDE2bC44LTRIMTRsLS44IDRoLTIuOXptNi45LTYuMWwuNS0yLjVoLTIuOGwtLjUgMi41aDIuOHoiLz48L3N2Zz4K";

/* loaded by smart-asset */
var py = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0iIzM1NkVBMSIgZD0iTTE1LjYgMTUuNWgtMmMtMS40IDAtMi4zLjktMi4zIDIuM3YxLjhjMCAuMi0uMS4zLS4zLjNoLS45Yy0uOSAwLTEuNi0uNC0yLTEuMi0uMy0uNi0uNS0xLjItLjUtMS44LS4xLTEuMS0uMS0yLjIuMy0zLjMuMy0uOS45LTEuNiAxLjktMS44aDUuOGMuMSAwIC4zIDAgLjMtLjF2LS41cy0uMi0uMS0uMy0uMWgtMy40Yy0uMyAwLS40LS4xLS40LS40VjkuNGMwLS43LjMtMS4yLjktMS40LjUtLjIgMS0uNCAxLjUtLjUgMS4yLS4yIDIuNC0uMiAzLjYuMS41LjEgMSAuMyAxLjQuNi40LjQuNy44LjYgMS40djMuNmMwIDEuNC0uOCAyLjItMi4yIDIuMi0uNy4xLTEuNC4xLTIgLjF6bS0yLjgtNmMwIC40LjMuOC44LjguNCAwIC44LS40LjgtLjhzLS40LS43LS44LS44Yy0uNSAwLS44LjQtLjguOHptMy42IDdoMmMxLjQgMCAyLjMtLjkgMi4zLTIuM3YtMS44YzAtLjIuMS0uMy4zLS4zaC45Yy45IDAgMS42LjQgMiAxLjIuMy42LjUgMS4yLjUgMS44LjEgMS4xLjEgMi4yLS4zIDMuMy0uMy45LS45IDEuNi0xLjkgMS44aC01LjhjLS4xIDAtLjMgMC0uMy4xdi41cy4yLjEuMy4xaDMuNGMuMyAwIC40LjEuNC40djEuM2MwIC43LS4zIDEuMi0uOSAxLjQtLjUuMi0xIC40LTEuNS41LTEuMi4yLTIuNC4yLTMuNi0uMS0uNS0uMS0xLS4zLTEuNC0uNi0uNC0uNC0uNy0uOC0uNi0xLjR2LTMuNmMwLTEuNC44LTIuMiAyLjItMi4yLjctLjEgMS40LS4xIDItLjF6bTIuOCA2YzAtLjQtLjMtLjgtLjgtLjgtLjQgMC0uOC40LS44LjhzLjQuNy44LjhjLjUgMCAuOC0uNC44LS44eiIvPjwvc3ZnPgo=";

/* loaded by smart-asset */
var html = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0iI0VGNzYyMyIgZD0iTTggMTVsNi01LjZWMTJsLTQuNSA0IDQuNSA0djIuNkw4IDE3di0yem0xNiAyLjFsLTYgNS42VjIwbDQuNi00LTQuNi00VjkuM2w2IDUuNnYyLjJ6Ii8+PC9zdmc+Cg==";

/* loaded by smart-asset */
var xml = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHBhdGggZmlsbD0iI0VGNzYyMyIgZD0iTTkuNyA5LjZjNy4yLS4xIDEyLjkgNi4yIDEyLjcgMTIuN2gtMi42Yy0uMS0yLjgtMS01LjEtMi45LTcuMXMtNC40LTIuOS03LjEtMi45Yy0uMS0uOS0uMS0xLjgtLjEtMi43em04LjYgMTIuOGgtMi42Yy0uMS0uNS0uMi0xLjEtLjMtMS42LS44LTIuNC0yLjMtMy44LTQuOC00LjMtLjItLjEtLjQtLjEtLjctLjEtLjIgMC0uMi0uMS0uMi0uMnYtMi41YzIuMSAwIDMuOS43IDUuNSAyIDIgMS44IDMgNCAzLjEgNi43em0tNS4xLTEuOGMwIDEtLjggMS44LTEuOCAxLjhzLTEuNy0uOC0xLjgtMS44YzAtMSAuOC0xLjggMS44LTEuOHMxLjguOCAxLjggMS44eiIvPjwvc3ZnPgo=";

/* loaded by smart-asset */
var php = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHRpdGxlPmZpbGVfdHlwZV9waHAzPC90aXRsZT48cGF0aCBkPSJNNy42LDEzLjc5MWEyLjM1MiwyLjM1MiwwLDAsMSwxLjc0NS40ODMsMS45MTYsMS45MTYsMCwwLDEsLjIwNywxLjY2LDIuNzgsMi43OCwwLDAsMS0uOTE4LDEuNzQ4LDMuMzc1LDMuMzc1LDAsMCwxLTIuMDcuNTI5aC0xLjRMNi4wMjQsMTMuOFpNMiwyMi42NzdINC4zbC41NDUtMi44SDYuODEyQTcuMDQ5LDcuMDQ5LDAsMCwwLDguOTU2LDE5LjZhNC4wNiw0LjA2LDAsMCwwLDEuNTMtLjkxOEE0LjU4NSw0LjU4NSwwLDAsMCwxMS45MywxNi4xYTMuMjg4LDMuMjg4LDAsMCwwLS41NS0yLjkyMkEzLjY3MSwzLjY3MSwwLDAsMCw4LjQ3LDEyLjEyOUg0LjA1N1oiIHN0eWxlPSJmaWxsOiM4OTkzYmUiLz48cGF0aCBkPSJNMTMuNjE3LDkuMzIzSDE1LjlsLS41NTMsMi44aDIuMDMxYTMuOTU2LDMuOTU2LDAsMCwxLDIuNjQ1LjY2OSwyLjIxMywyLjIxMywwLDAsMSwuNDM2LDIuMTY3bC0uOTU0LDQuOTA5SDE3LjE5NWwuOTA4LTQuNjY3YTEuMjY3LDEuMjY3LDAsMCwwLS4xMTQtMS4wODYsMS42LDEuNiwwLDAsMC0xLjE0NC0uMjg2SDE1LjAyMmwtMS4xNzUsNi4wNDRIMTEuNTU5WiIgc3R5bGU9ImZpbGw6Izg5OTNiZSIvPjxwYXRoIGQ9Ik0yNS41MzksMTMuNzkxYTIuMzUyLDIuMzUyLDAsMCwxLDEuNzQ1LjQ4MywxLjkxNiwxLjkxNiwwLDAsMSwuMjA3LDEuNjYsMi43OCwyLjc4LDAsMCwxLS45MTgsMS43NDgsMy4zNzUsMy4zNzUsMCwwLDEtMi4wNzQuNTI5SDIzLjFsLjg1OC00LjQxNlptLTUuNiw4Ljg4NmgyLjNsLjU0NS0yLjhoMS45NjhBNy4wNDksNy4wNDksMCwwLDAsMjYuOSwxOS42YTQuMDYsNC4wNiwwLDAsMCwxLjUzLS45MThBNC41ODUsNC41ODUsMCwwLDAsMjkuODY5LDE2LjFhMy4yODgsMy4yODgsMCwwLDAtLjU1LTIuOTIyLDMuNjcxLDMuNjcxLDAsMCwwLTIuOTA5LTEuMDQ2aC00LjQyWiIgc3R5bGU9ImZpbGw6Izg5OTNiZSIvPjwvc3ZnPgo=";

/* loaded by smart-asset */
var pug = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiI+PHRpdGxlPmZpbGVfdHlwZV9wdWc8L3RpdGxlPjxwYXRoIGQ9Ik0yNS41MTQsMTIuODQ2Yy0uMDUyLS45MzguMjA5LTEuODI1LS4yMDktMi41NTQtMS4wNDMtMS44MjUtMy42NDktMi44NjctOC44NjMtMi44NjdWNy4zNzJoMHYuMDUyYy01LjczNSwwLTguMTg1LDEuMDQzLTkuMjI3LDIuODY3YTUuNiw1LjYsMCwwLDAtLjQ2OSwyLjU1NCw5LjU0Niw5LjU0NiwwLDAsMC0uMjYxLDIuNDVjLjE1NiwxLjE0Ny4yNjEsMi4yOTQuNDE3LDMuMzM2LjE1Ni44ODYsMS40MDgsMS41NjQsMS41NjQsMi40LjMxMywyLjI0MiwyLjI5NCwzLjI4NCw4LjAyOCwzLjI4NHYuMjYxaC0uMXYtLjI2MWM1LjIxMywwLDcuNC0xLjA0Myw3LjcxNi0zLjI4NC4xLS44MzQsMS4xNDctMS41MTIsMS4zLTIuNC4xNTYtMS4wNDMuMjA5LTIuMTkuMzY1LTMuMzM2QTExLjc3NCwxMS43NzQsMCwwLDAsMjUuNTE0LDEyLjg0NloiIHN0eWxlPSJmaWxsOiNlZmNjYTMiLz48cGF0aCBkPSJNMTYuMTgyLDEzLjY4YTMuMjQxLDMuMjQxLDAsMCwxLDIuMTksMS4xNDdjLjczLjYyNiwxLjkyOSwxLjA0MywyLjQ1LDEuNjE2YTQuNzE1LDQuNzE1LDAsMCwxLDEuNDA4LDEuOTgxLDguOSw4LjksMCwwLDEsLjMxMywyLjI0MmMwLC4yNjEuMTU2LjIwOS41NzMsMGE5LjAyLDkuMDIsMCwwLDAsMi4xOS0xLjg3N2MtLjE1Ni44ODYtMS4yNTEsMS42NjgtMS4zNTUsMi41LS4zMTMsMi4yNDItMi41LDMuMzM2LTcuODcyLDMuMzM2aC4zMTMiIHN0eWxlPSJmaWxsOiNjY2FjOGQiLz48cGF0aCBkPSJNMTkuNTE5LDExLjkwOGMuMjA5LjY3OC44ODYsMy4wMjQtLjQ2OSwyLjI0MmEyLjU1NywyLjU1NywwLDAsMSwuOTM4LDEuNTY0LDEuODMxLDEuODMxLDAsMCwwLDEuMywxLjQwOCwzLjQ3OSwzLjQ3OSwwLDAsMCwyLjU1NC0uNjI2LDIuOTU2LDIuOTU2LDAsMCwwLC42NzgtMy4yODQsMi40MywyLjQzLDAsMCwwLTIuMTM3LTEuNjE2QzIxLjQsMTEuMzM0LDE5LjMxLDExLjEyNiwxOS41MTksMTEuOTA4WiIgc3R5bGU9ImZpbGw6I2NjYWM4ZCIvPjxjaXJjbGUgY3g9IjIyLjE3OCIgY3k9IjE0LjQxIiByPSIxLjkyOSIvPjxjaXJjbGUgY3g9IjIxLjY1NiIgY3k9IjEzLjUyNCIgcj0iMC41MjEiIHN0eWxlPSJmaWxsOiNmZmYiLz48cGF0aCBkPSJNMTkuMjA2LDE0LjMwNmExNy42OCwxNy42OCwwLDAsMSwyLjcxMSwyLjM0NmMuOTM4LDEuMi45MzgsMS40MDguOTM4LDEuNDA4bC0uNjc4LjMxM2E3LjEsNy4xLDAsMCwwLTIuMTM3LTIuNWMtMS4yLS42NzgtMS4zNTUtMS4yNTEtMS4zNTUtMS4yNTFaIiBzdHlsZT0iZmlsbDojZWZjY2EzIi8+PHBhdGggZD0iTTE2LjIzNSwxMy42OGEzLjYwNSwzLjYwNSwwLDAsMC0yLjM0NiwxLjE0N2MtLjczLjYyNi0yLjAzMywxLjA0My0yLjUsMS42MTZhNC44MDYsNC44MDYsMCwwLDAtMS40NiwxLjk4MSw4LjksOC45LDAsMCwwLS4zMTMsMi4yNDJjMCwuMjYxLjA1Mi4zMTMtLjYyNiwwQTcuOTcyLDcuOTcyLDAsMCwxLDYuOCwxOC43ODljLjE1Ni44ODYsMS4yNTEsMS42NjgsMS4zNTUsMi41LjMxMywyLjE5LDIuNSwzLjI4NCw3Ljg3MiwzLjI4NGguMzY1IiBzdHlsZT0iZmlsbDojY2NhYzhkIi8+PHBhdGggZD0iTTIxLjIzOSwxNy4yNzdhNi41NTIsNi41NTIsMCwwLDAtNS4xMDktMi42MDdoMGE2LjYzOCw2LjYzOCwwLDAsMC01LjEwOSwyLjYwNywzLjg2MSwzLjg2MSwwLDAsMC0xLjA0MywzLjE4YzAsNC42NCwxLjYxNiwzLjIzMiwyLjcxMSwzLjgwNmE3LjQ2Niw3LjQ2NiwwLDAsMCwzLjM4OS4zMTNoMGE3LjQsNy40LDAsMCwwLDMuMzg5LS4zMTNjMS4wOTUtLjU3MywyLjcxMS44MzQsMi43MTEtMy44MDZBMy4zODYsMy4zODYsMCwwLDAsMjEuMjM5LDE3LjI3N1oiIHN0eWxlPSJmaWxsOiM1NjMzMmIiLz48cGF0aCBkPSJNMTYuMDI2LDE1Ljk3NGE5LjU0OSw5LjU0OSwwLDAsMS0uNDY5LDIuNTU0bC41NzMtLjE1NloiIHN0eWxlPSJmaWxsOiM0NDI4MjMiLz48cGF0aCBkPSJNMTYuMTgyLDE1Ljk3NGE5LjU0OSw5LjU0OSwwLDAsMCwuNDY5LDIuNTU0bC0uNTczLS4xNTZaIiBzdHlsZT0iZmlsbDojNDQyODIzIi8+PHBhdGggZD0iTTE0LjM1OCwxNS40NTNjLS4yMDktLjUyMS41NzMtMS4zNTUsMS44MjUtMS4zNTVzMi4wMzMuODM0LDEuODI1LDEuMzU1LTEuMDQzLjY3OC0xLjgyNS42NzhDMTUuMzQ4LDE2LjEzLDE0LjU2NiwxNS45NzQsMTQuMzU4LDE1LjQ1M1oiIHN0eWxlPSJmaWxsOiM1NjMzMmIiLz48cGF0aCBkPSJNMTYuMTgyLDE1Ljk3NGMwLS4xLjczLS4xLDEuMTQ3LS4zNjUsMCwwLS44MzQuMjYxLS45OTEuMTU2YS42NTYuNjU2LDAsMCwxLS4yMDktLjM2NS42NTYuNjU2LDAsMCwxLS4yMDkuMzY1Yy0uMTU2LjEtMS4wOTUtLjE1Ni0xLjA5NS0uMTU2YTguMDU4LDguMDU4LDAsMCwxLDEuMi4zNjV2LjQxN2ExMC40OTIsMTAuNDkyLDAsMCwwLC4xLDIuMDMzYy4xNTYuMjA5LjEtMS40Ni4xLTIuMDMzQTEuMywxLjMsMCwwLDEsMTYuMTgyLDE1Ljk3NFoiLz48cGF0aCBkPSJNMTYuMTgyLDE4Ljk0NWEzLjM1LDMuMzUsMCwwLDEsMS42MTYuNjc4LDMuMTIxLDMuMTIxLDAsMCwwLTEuNjE2LTEuMDk1LDMuMDM2LDMuMDM2LDAsMCwwLTEuODI1LDEuMkEzLjMxMiwzLjMxMiwwLDAsMSwxNi4xODIsMTguOTQ1WiIgc3R5bGU9ImZpbGw6IzdmNGE0MSIvPjxwYXRoIGQ9Ik0xNi4wNzgsMjIuOGE4LjksOC45LDAsMCwxLTIuNC0uNDY5Yy0uMTU2LS4wNTItLjMxMy4wNTItLjQ2OSwwYTYuMTcyLDYuMTcyLDAsMCwxLTMuMTgtMi4xMzd2LjIwOWMwLDQuNjQsMS42MTYsMy4yMzIsMi43MTEsMy44MDZhNy40NjYsNy40NjYsMCwwLDAsMy4zODkuMzEzaDBhNy40LDcuNCwwLDAsMCwzLjM4OS0uMzEzYzEuMDk1LS41NzMsMi43MTEuODM0LDIuNzExLTMuODA2di0uNDY5QTUuOTE0LDUuOTE0LDAsMCwxLDE5LDIyLjI4MmMtLjE1Ni4wNTItLjQxNy0uMDUyLS41NzMtLjA1MkE3LjA0NSw3LjA0NSwwLDAsMSwxNi4wNzgsMjIuOFoiIHN0eWxlPSJmaWxsOiM0NDI4MjMiLz48cGF0aCBkPSJNMTMuOTQxLDIwLjNzLS41NzMsMS42NjgtLjE1NiwyLjRsLS41MjEtLjIwOUExNS40MzMsMTUuNDMzLDAsMCwxLDEzLjk0MSwyMC4zWiIgc3R5bGU9ImZpbGw6IzQ0MjgyMyIvPjxwYXRoIGQ9Ik0xOC4zMiwyMC4zcy41NzMsMS42NjguMTU2LDIuNEwxOSwyMi40OTFBMTAuNjI5LDEwLjYyOSwwLDAsMCwxOC4zMiwyMC4zWiIgc3R5bGU9ImZpbGw6IzQ0MjgyMyIvPjxwYXRoIGQ9Ik0xMi41ODUsMTEuOTA4Yy0uMjA5LjY3OC0uODg2LDMuMDI0LjQ2OSwyLjI0MmEyLjU1NywyLjU1NywwLDAsMC0uOTM4LDEuNTY0LDEuODMxLDEuODMxLDAsMCwxLTEuMywxLjQwOEEzLjQ3OSwzLjQ3OSwwLDAsMSw4LjI1OCwxNi41YTIuOTU2LDIuOTU2LDAsMCwxLS42NzgtMy4yODQsMi40MywyLjQzLDAsMCwxLDIuMTM3LTEuNjE2QzEwLjcwOSwxMS4zMzQsMTIuNzk0LDExLjEyNiwxMi41ODUsMTEuOTA4WiIgc3R5bGU9ImZpbGw6I2NjYWM4ZCIvPjxwYXRoIGQ9Ik0xNi4xMywxOC41MjhhMy4zOTMsMy4zOTMsMCwwLDEsMi40NSwyLjg2N3YtLjFhMy4wNTEsMy4wNTEsMCwwLDAtMi40NS0yLjkxOSwzLDMsMCwwLDAtMi40NSwyLjkxOXYuMUEzLjQ2MywzLjQ2MywwLDAsMSwxNi4xMywxOC41MjhaIi8+PGVsbGlwc2UgY3g9IjE2LjU0NiIgY3k9IjE1LjEzOCIgcng9IjAuMTU2IiByeT0iMC4zMTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zLjI1NiA0LjYxMSkgcm90YXRlKC0xNC40NikiIHN0eWxlPSJmaWxsOiMzMzE3MTIiLz48ZWxsaXBzZSBjeD0iMTUuNjA5IiBjeT0iMTUuMTQ2IiByeD0iMC4zMTMiIHJ5PSIwLjE1NiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMuNDgyIDI1LjU2Nykgcm90YXRlKC03Mi43NjUpIiBzdHlsZT0iZmlsbDojMzMxNzEyIi8+PGNpcmNsZSBjeD0iMTAuMDMxIiBjeT0iMTQuNDEiIHI9IjEuOTI5Ii8+PGNpcmNsZSBjeD0iMTAuNTUyIiBjeT0iMTMuNTI0IiByPSIwLjUyMSIgc3R5bGU9ImZpbGw6I2ZmZiIvPjxwYXRoIGQ9Ik0xNi43LDE0LjQxcy0uNTIxLjIwOS0uNjI2LjI2MWEyLjQ5MiwyLjQ5MiwwLDAsMS0uNjI2LS4yNjFIMTYuN1oiIHN0eWxlPSJmaWxsOiM3ZjRhNDEiLz48cGF0aCBkPSJNMTIuOSwxNC4zMDZhMTcuNjgsMTcuNjgsMCwwLDAtMi43MTEsMi4zNDZjLS45MzgsMS4yLS45MzgsMS40MDgtLjkzOCwxLjQwOGwuNjc4LjMxM2E3LjEsNy4xLDAsMCwxLDIuMTM3LTIuNWMxLjItLjY3OCwxLjM1NS0xLjI1MSwxLjM1NS0xLjI1MVoiIHN0eWxlPSJmaWxsOiNlZmNjYTMiLz48cGF0aCBkPSJNOS4wOTIsMTAuODEzYTQuNTE5LDQuNTE5LDAsMCwxLTEuOTI5LDIuMjk0QTIuMTksMi4xOSwwLDAsMCw5LjA5MiwxMC44MTNaIiBzdHlsZT0iZmlsbDojY2NhYzhkIi8+PHBhdGggZD0iTTIyLjkwOCwxMC44MTNhNC41MTksNC41MTksMCwwLDAsMS45MjksMi4yOTRBMi4xOSwyLjE5LDAsMCwxLDIyLjkwOCwxMC44MTNaIiBzdHlsZT0iZmlsbDojY2NhYzhkIi8+PHBhdGggZD0iTTE5LjMxLDEzLjgzNmE1LjE2LDUuMTYsMCwwLDAtMy4wNzYtMS40MDhoLjE1NmEzLjg1MiwzLjg1MiwwLDAsMC0zLjAyNCwxLjQwOCw0LjgzMiw0LjgzMiwwLDAsMSwzLjAyNC0xLjA0M2gwQTUuNzg1LDUuNzg1LDAsMCwxLDE5LjMxLDEzLjgzNloiIHN0eWxlPSJmaWxsOiNjY2FjOGQiLz48cGF0aCBkPSJNMTcuNzQ2LDEwLjk2OWEyLjQ1NSwyLjQ1NSwwLDAsMC0xLjU2NC0uOTM4aC4xNTZhMS43ODYsMS43ODYsMCwwLDAtMS41MTIuOTM4LDIuMTg3LDIuMTg3LDAsMCwxLDEuNTEyLS42NzhoMEExLjg5NCwxLjg5NCwwLDAsMSwxNy43NDYsMTAuOTY5WiIgc3R5bGU9ImZpbGw6I2NjYWM4ZCIvPjxwYXRoIGQ9Ik0xMC4wMzEsMTcuNzQ2YTIuNTQ1LDIuNTQ1LDAsMCwxLTEuNzczLjIwOUg4LjA1YTMuNjgsMy42OCwwLDAsMS0uODg2LTEuNTEyQTIuMjcsMi4yNywwLDAsMCwxMC4wMzEsMTcuNzQ2WiIgc3R5bGU9ImZpbGw6I2NjYWM4ZCIvPjxwYXRoIGQ9Ik0yMi4xMjYsMTcuNzQ2YTIuNTQ1LDIuNTQ1LDAsMCwwLDEuNzczLjIwOUgyMy42OWExLjc0OSwxLjc0OSwwLDAsMCwxLjA5NS0xLjUxMkEyLjAyLDIuMDIsMCwwLDEsMjIuMTI2LDE3Ljc0NloiIHN0eWxlPSJmaWxsOiNjY2FjOGQiLz48cGF0aCBkPSJNMTEuMjMsMTAuNzA5YTQuNzUsNC43NSwwLDAsMSwyLjI0Mi4xYy45MzguMzEzLjIwOSwxLjU2NC4zNjUsMS42MTZhMi44NjUsMi44NjUsMCwwLDEsMi4yNDItLjczYzEuNzczLjEsMS45ODEuODg2LDIuMjQyLjczLjI2MS0uMS0uMjYxLTIuMTksMi40NS0xLjcyLDAsMC0yLjc2My0uNzMtMi42NTksMS4yNTFhMy42NzUsMy42NzUsMCwwLDAtMy44NTgtLjFTMTQuODI3LDkuOTI3LDExLjIzLDEwLjcwOVoiIHN0eWxlPSJmaWxsOiNjY2FjOGQiLz48cGF0aCBkPSJNMTAuNSw4cy0yLjQsMi45NzItMi43MTEsNC4xMThjLS4zNjUsMS4xNDctLjYyNiw1Ljk0My0uOTM4LDYuNjIxTDUuNzU2LDE0LjA0NWwyLjAzMy00LjlaIiBzdHlsZT0iZmlsbDojY2NhYzhkIi8+PHBhdGggZD0iTTIxLjY1Niw4czIuNCwyLjk3MiwyLjcxMSw0LjExOGMuMzY1LDEuMTQ3LjYyNiw1Ljk0My45MzgsNi42MjFMMjYuNCwxNC4wNDVsLTIuMDMzLTQuOVoiIHN0eWxlPSJmaWxsOiNjY2FjOGQiLz48cGF0aCBkPSJNMjEuNSw4YTExLjYxNywxMS42MTcsMCwwLDEsMy4yODQsNC41ODhjLjczLDIuNDUuNDE3LDUuNDc0Ljk5MSw1LjgzOS44MzQuNTIxLDEuNzItMi42MDcsMi4wMzMtMi45MTkuNDY5LS41MjEsMi4wODUtMS44NzcsMi4xOS0yLjEzN3MtMy4yMzItMy45MS00Ljc0NC00LjY0QzIzLjU4NSw3Ljg5MywyMS40LDcuNzg5LDIxLjUsOFoiIHN0eWxlPSJmaWxsOiM1NjMzMmIiLz48cGF0aCBkPSJNMjMuNjksOS4zYTE1LjM3OSwxNS4zNzksMCwwLDEsMi45NzIsOC42NTRsMS4yLTIuNDVBMTYuNTY0LDE2LjU2NCwwLDAsMCwyMy42OSw5LjNaIiBzdHlsZT0iZmlsbDojNDQyODIzIi8+PHBhdGggZD0iTTEwLjUsOGExMS42MTcsMTEuNjE3LDAsMCwwLTMuMjg0LDQuNTg4Yy0uNzMsMi40NS0uNDE3LDUuNDc0LS45OTEsNS44MzktLjgzNC41MjEtMS43Mi0yLjYwNy0yLjAzMy0yLjkxOS0uNDY5LS41MjEtMi4wODUtMS44NzctMi4xOS0yLjEzN3MzLjIzMi0zLjkxLDQuNzQ0LTQuNjRDOC40MTUsNy44OTMsMTAuNiw3Ljc4OSwxMC41LDhaIiBzdHlsZT0iZmlsbDojNTYzMzJiIi8+PHBhdGggZD0iTTguMzEsOS4zYTE1LjM3OSwxNS4zNzksMCwwLDAtMi45NzIsOC42NTRMNC4xNCwxNS41QTE2LjU2NCwxNi41NjQsMCwwLDEsOC4zMSw5LjNaIiBzdHlsZT0iZmlsbDojNDQyODIzIi8+PHBhdGggZD0iTTYuNjQyLDE4LjAwN2E0LjExOCw0LjExOCwwLDAsMCwuNTczLDEuNTY0Yy4zNjUuMzY1LjEtLjMxMy4xLS4zMTNzLS4zNjUtLjIwOS0uMzEzLTEuNzJTNi42NDIsMTguMDA3LDYuNjQyLDE4LjAwN1oiIHN0eWxlPSJmaWxsOiNjY2FjOGQiLz48cGF0aCBkPSJNMjUuNDEsMTguMDA3YTQuMTE4LDQuMTE4LDAsMCwxLS41NzMsMS41NjRjLS4zNjUuMzY1LS4xLS4zMTMtLjEtLjMxM3MuMzY1LS4yMDkuMzEzLTEuNzJDMjQuOTkzLDE2LjA3OCwyNS40MSwxOC4wMDcsMjUuNDEsMTguMDA3WiIgc3R5bGU9ImZpbGw6I2NjYWM4ZCIvPjxjaXJjbGUgY3g9IjEzLjg4OSIgY3k9IjE3LjEyMSIgcj0iMC4xNTYiIHN0eWxlPSJmaWxsOiM0NDI4MjMiLz48Y2lyY2xlIGN4PSIxMi44NDYiIGN5PSIxOC4yMTYiIHI9IjAuMTU2IiBzdHlsZT0iZmlsbDojNDQyODIzIi8+PGNpcmNsZSBjeD0iMTIuNTMzIiBjeT0iMTcuMTIxIiByPSIwLjE1NiIgc3R5bGU9ImZpbGw6IzQ0MjgyMyIvPjxjaXJjbGUgY3g9IjE4LjE2NCIgY3k9IjE3LjEyMSIgcj0iMC4xNTYiIHN0eWxlPSJmaWxsOiM0NDI4MjMiLz48Y2lyY2xlIGN4PSIxOS4xNTQiIGN5PSIxOC4yMTYiIHI9IjAuMTU2IiBzdHlsZT0iZmlsbDojNDQyODIzIi8+PGNpcmNsZSBjeD0iMTkuNDY3IiBjeT0iMTcuMTIxIiByPSIwLjE1NiIgc3R5bGU9ImZpbGw6IzQ0MjgyMyIvPjwvc3ZnPgo=";

/* loaded by smart-asset */
var scala = "data:image/svg+xml;base64,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";

/* loaded by smart-asset */
var defaultFile = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjAwIDEwMDAiIGZpbGw9IndoaXRlIj48cGF0aCBkPSJNMzk0LjEgNTM3LjhoNDExLjd2NTQuN0gzOTQuMXYtNTQuN3ptMC0xMzAuM0g2MjR2NTQuN0gzOTQuMXYtNTQuN3ptMC0xMzAuM2g0MTEuN3Y1NC43SDM5NC4xdi01NC43em0wIDM5MC45SDcwMHY1NC43SDM5NC4xdi01NC43eiIvPjwvc3ZnPgo=";

const icons = {
    js,
    java,
    jsp: html,
    json,
    cs,
    cshtml,
    aspx: html,
    css,
    py,
    html,
    xml,
    php,
    pug,
    scala,
    default: defaultFile
};

var css_248z$W = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.file-explorer-container{background-color:#252526;color:#c9c9c9;height:100%;padding-left:.5rem;padding-top:.5rem}.file-explorer-container .text{align-items:center;display:flex;font-size:1.06rem;width:80%}.file-explorer-container .text span{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.file-explorer-container .indicated{color:#d6bb8d}.file-explorer-container .indicated .dot{padding-top:1px;position:absolute!important;right:10px!important}.file-explorer-container img{height:1.4rem}.file-explorer-container .MuiTreeItem-label{min-width:0!important}.file-explorer-container .MuiTreeItem-root>.MuiTreeItem-content .MuiTreeItem-label:hover{background-color:#343a40!important}.file-explorer-container .MuiTreeItem-root.Mui-selected>.MuiTreeItem-content .MuiTreeItem-label{background-color:#094771!important}";
styleInject(css_248z$W);

const FilesExplorer = ({ files, onFileClick }) => {
    const indicatedFiles = lib$1.getIndicatedIds(files, [], []);
    const getFileIcon = (name) => {
        var _a;
        const typeFile = (_a = name === null || name === void 0 ? void 0 : name.split('.').pop()) !== null && _a !== void 0 ? _a : '';
        let iconSrc = icons.default;
        if (icons[typeFile]) {
            iconSrc = icons[typeFile];
        }
        return jsx("img", { src: iconSrc, alt: "file_icon" }, void 0);
    };
    const renderLabel = (name, isIndicated) => {
        return (jsxs("div", Object.assign({ title: name, className: classNames('text', { indicated: isIndicated }) }, { children: [jsx("span", { children: name }, void 0), isIndicated && jsx(ErrorOutlineRoundedIcon, { className: "dot", fontSize: "small" }, void 0)] }), void 0));
    };
    const renderTree = (treeItem) => {
        const { name, id } = treeItem;
        if (treeItem.type === 'directory') {
            return (jsx(TreeItem$1, Object.assign({ nodeId: id, label: renderLabel(name, indicatedFiles.includes(id)) }, { children: treeItem.children.map(node => renderTree(node)) }), id));
        }
        return (jsx(TreeItem$1, { nodeId: id, icon: getFileIcon(name), label: renderLabel(name, indicatedFiles.includes(id)), onLabelClick: () => onFileClick(id), onIconClick: () => onFileClick(id) }, id));
    };
    return (jsx("div", Object.assign({ className: "file-explorer-container" }, { children: jsx(TreeView$1, Object.assign({ defaultCollapseIcon: jsx(ExpandMore, {}, void 0), defaultExpandIcon: jsx(ChevronRight, {}, void 0), defaultExpanded: lib$1.getDefaultExpandedFolders(files), defaultSelected: lib$1.getFirstOpenFile(files) }, { children: renderTree(files) }), void 0) }), void 0));
};

const useStyles$d = makeStyles$1(() => ({
    wrapper: {
        width: '100%',
        display: 'flex',
        overflow: 'hidden',
        height: '95%',
        borderRadius: '0'
    }
}));
const FilesExplorerWrapper = ({ files, onFileClick, children, defaultWidth, maxWidth, minWidth }) => {
    const classes = useStyles$d();
    return (jsxs(Paper$1, Object.assign({ elevation: 24, className: classes.wrapper }, { children: [jsx(RightResizeable, Object.assign({ defaultSize: {
                    width: defaultWidth || '25%',
                    height: '100%'
                }, maxWidth: maxWidth || '40%', minWidth: minWidth || '15%' }, { children: jsx(FilesExplorer, { files: files, onFileClick: onFileClick }, void 0) }), void 0), children] }), void 0));
};

var css_248z$V = ".radioButton-module_radio-tooltip-wrapper__h2a-V{align-items:center;display:flex}.radioButton-module_radio-tooltip__29--a{white-space:pre-wrap}.radioButton-module_radio-tooltip-icon__FwaEU{font-size:1rem;margin-left:-.5rem}";
var styles$D = {"radio-tooltip-wrapper":"radioButton-module_radio-tooltip-wrapper__h2a-V","radio-tooltip":"radioButton-module_radio-tooltip__29--a","radio-tooltip-icon":"radioButton-module_radio-tooltip-icon__FwaEU"};
styleInject(css_248z$V);

const RadioButtonContainer = (props) => {
    return (jsx(FormControl, Object.assign({ component: "fieldset" }, { children: jsx(RadioGroup, Object.assign({ value: props.value, onChange: event => props.onChange(event.target.value) }, { children: props.buttons.map(button => (jsxs("div", Object.assign({ className: styles$D['radio-tooltip-wrapper'] }, { children: [jsx(FormControlLabel, { value: button.value, disabled: button.disable, control: jsx(Radio, { color: props.radioButtonsColor || 'primary', size: props.radioButtonsSize || 'medium' }, void 0), label: button.label }, void 0), button.tooltipText && button.tooltipText !== '' && (jsx(TooltipContainer, Object.assign({ "data-testid": "info-tooltip", hasBorder: true, hasDefaultStyle: true, unsetMaxWidth: true, titleClassName: styles$D['radio-tooltip'], title: button.tooltipText || '' }, { children: jsx(HelpOutlineSharpIcon, { className: styles$D['radio-tooltip-icon'], color: "disabled" }, void 0) }), void 0))] }), button.value))) }), void 0) }), void 0));
};

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$6(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$6(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$6(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

var getNormalizedAngle = function getNormalizedAngle(angle) {
  var normalizedAngle = angle % (Math.PI * 2);

  if (normalizedAngle < 0) {
    normalizedAngle += Math.PI * 2;
  }

  return normalizedAngle;
};
var filterDataBySkipAngle = function filterDataBySkipAngle(data, skipAngle) {
  return data.filter(function (datum) {
    return Math.abs(radiansToDegrees(datum.arc.endAngle - datum.arc.startAngle)) >= skipAngle;
  });
};
var useFilteredDataBySkipAngle = function useFilteredDataBySkipAngle(data, skipAngle) {
  return useMemo$1(function () {
    return filterDataBySkipAngle(data, skipAngle);
  }, [data, skipAngle]);
};
var arcTransitionModeById = {
  startAngle: {
    enter: function enter(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        endAngle: arc.startAngle
      });
    },
    update: function update(arc) {
      return arc;
    },
    leave: function leave(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        startAngle: arc.endAngle
      });
    }
  },
  middleAngle: {
    enter: function enter(arc) {
      var middleAngle = arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        startAngle: middleAngle,
        endAngle: middleAngle
      });
    },
    update: function update(arc) {
      return arc;
    },
    leave: function leave(arc) {
      var middleAngle = arc.startAngle + (arc.endAngle - arc.startAngle) / 2;
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        startAngle: middleAngle,
        endAngle: middleAngle
      });
    }
  },
  endAngle: {
    enter: function enter(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        startAngle: arc.endAngle
      });
    },
    update: function update(arc) {
      return arc;
    },
    leave: function leave(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        endAngle: arc.startAngle
      });
    }
  },
  innerRadius: {
    enter: function enter(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        outerRadius: arc.innerRadius
      });
    },
    update: function update(arc) {
      return arc;
    },
    leave: function leave(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        innerRadius: arc.outerRadius
      });
    }
  },
  centerRadius: {
    enter: function enter(arc) {
      var centerRadius = arc.innerRadius + (arc.outerRadius - arc.innerRadius) / 2;
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        innerRadius: centerRadius,
        outerRadius: centerRadius
      });
    },
    update: function update(arc) {
      return arc;
    },
    leave: function leave(arc) {
      var centerRadius = arc.innerRadius + (arc.outerRadius - arc.innerRadius) / 2;
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        innerRadius: centerRadius,
        outerRadius: centerRadius
      });
    }
  },
  outerRadius: {
    enter: function enter(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        innerRadius: arc.outerRadius
      });
    },
    update: function update(arc) {
      return arc;
    },
    leave: function leave(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        outerRadius: arc.innerRadius
      });
    }
  },
  pushIn: {
    enter: function enter(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        innerRadius: arc.innerRadius - arc.outerRadius + arc.innerRadius,
        outerRadius: arc.innerRadius
      });
    },
    update: function update(arc) {
      return arc;
    },
    leave: function leave(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        innerRadius: arc.outerRadius,
        outerRadius: arc.outerRadius + arc.outerRadius - arc.innerRadius
      });
    }
  },
  pushOut: {
    enter: function enter(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        innerRadius: arc.outerRadius,
        outerRadius: arc.outerRadius + arc.outerRadius - arc.innerRadius
      });
    },
    update: function update(arc) {
      return arc;
    },
    leave: function leave(arc) {
      return _objectSpread2$1(_objectSpread2$1({}, arc), {}, {
        innerRadius: arc.innerRadius - arc.outerRadius + arc.innerRadius,
        outerRadius: arc.innerRadius
      });
    }
  }
};
var useArcTransitionMode = function useArcTransitionMode(mode, extraTransition) {
  return useMemo$1(function () {
    var transitionMode = arcTransitionModeById[mode];
    return {
      enter: function enter(datum) {
        return _objectSpread2$1(_objectSpread2$1({
          progress: 0
        }, transitionMode.enter(datum.arc)), extraTransition ? extraTransition.enter(datum) : {});
      },
      update: function update(datum) {
        return _objectSpread2$1(_objectSpread2$1({
          progress: 1
        }, transitionMode.update(datum.arc)), extraTransition ? extraTransition.update(datum) : {});
      },
      leave: function leave(datum) {
        return _objectSpread2$1(_objectSpread2$1({
          progress: 0
        }, transitionMode.leave(datum.arc)), extraTransition ? extraTransition.leave(datum) : {});
      }
    };
  }, [mode, extraTransition]);
};

var computeArcCenter = function computeArcCenter(arc, offset) {
  var angle = midAngle(arc) - Math.PI / 2;
  var radius = arc.innerRadius + (arc.outerRadius - arc.innerRadius) * offset;
  return positionFromAngle(angle, radius);
};
var interpolateArcCenter = function interpolateArcCenter(offset) {
  return function (startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue) {
    return to([startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue], function (startAngle, endAngle, innerRadius, outerRadius) {
      var centroid = computeArcCenter({
        startAngle: startAngle,
        endAngle: endAngle,
        innerRadius: innerRadius,
        outerRadius: outerRadius
      }, offset);
      return "translate(".concat(centroid.x, ",").concat(centroid.y, ")");
    });
  };
};
var useArcCentersTransition = function useArcCentersTransition(data) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
  var mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'innerRadius';
  var extra = arguments.length > 3 ? arguments[3] : undefined;

  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;

  var phases = useArcTransitionMode(mode, extra);
  var transition = useTransition(data, {
    keys: function keys(datum) {
      return datum.id;
    },
    initial: phases.update,
    from: phases.enter,
    enter: phases.update,
    update: phases.update,
    leave: phases.leave,
    config: springConfig,
    immediate: !animate
  });
  return {
    transition: transition,
    interpolate: interpolateArcCenter(offset)
  };
};

var staticStyle = {
  pointerEvents: 'none'
};
var ArcLabel = function ArcLabel(_ref) {
  var label = _ref.label,
      style = _ref.style;
  var theme = useTheme();
  return React__default.createElement(animated.g, {
    transform: style.transform,
    opacity: style.progress,
    style: staticStyle
  }, React__default.createElement(animated.text, {
    textAnchor: "middle",
    dominantBaseline: "central",
    style: _objectSpread2$1(_objectSpread2$1({}, theme.labels.text), {}, {
      fill: style.textColor
    })
  }, label));
};

var ArcLabelsLayer = function ArcLabelsLayer(_ref) {
  var center = _ref.center,
      data = _ref.data,
      transitionMode = _ref.transitionMode,
      labelAccessor = _ref.label,
      radiusOffset = _ref.radiusOffset,
      skipAngle = _ref.skipAngle,
      textColor = _ref.textColor,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? ArcLabel : _ref$component;
  var getLabel = usePropertyAccessor(labelAccessor);
  var theme = useTheme();
  var getTextColor = useInheritedColor(textColor, theme);
  var filteredData = useMemo$1(function () {
    return data.filter(function (datum) {
      return Math.abs(radiansToDegrees(datum.arc.endAngle - datum.arc.startAngle)) >= skipAngle;
    });
  }, [data, skipAngle]);

  var _useArcCentersTransit = useArcCentersTransition(filteredData, radiusOffset, transitionMode),
      transition = _useArcCentersTransit.transition,
      interpolate = _useArcCentersTransit.interpolate;

  var Label = component;
  return React__default.createElement("g", {
    transform: "translate(".concat(center[0], ",").concat(center[1], ")")
  }, transition(function (transitionProps, datum) {
    return React__default.createElement(Label, {
      key: datum.id,
      datum: datum,
      label: getLabel(datum),
      style: _objectSpread2$1(_objectSpread2$1({}, transitionProps), {}, {
        transform: interpolate(transitionProps.startAngle, transitionProps.endAngle, transitionProps.innerRadius, transitionProps.outerRadius),
        textColor: getTextColor(datum)
      })
    });
  }));
};

var computeArcLinkTextAnchor = function computeArcLinkTextAnchor(arc) {
  var centerAngle = getNormalizedAngle(arc.startAngle + (arc.endAngle - arc.startAngle) / 2 - Math.PI / 2);

  if (centerAngle < Math.PI / 2 || centerAngle > Math.PI * 1.5) {
    return 'start';
  }

  return 'end';
};
var computeArcLink = function computeArcLink(arc, offset, diagonalLength, straightLength) {
  var centerAngle = getNormalizedAngle(arc.startAngle + (arc.endAngle - arc.startAngle) / 2 - Math.PI / 2);
  var point0 = positionFromAngle(centerAngle, arc.outerRadius + offset);
  var point1 = positionFromAngle(centerAngle, arc.outerRadius + offset + diagonalLength);
  var side;
  var point2;

  if (centerAngle < Math.PI / 2 || centerAngle > Math.PI * 1.5) {
    side = 'after';
    point2 = {
      x: point1.x + straightLength,
      y: point1.y
    };
  } else {
    side = 'before';
    point2 = {
      x: point1.x - straightLength,
      y: point1.y
    };
  }

  return {
    side: side,
    points: [point0, point1, point2]
  };
};

var lineGenerator = line().x(function (d) {
  return d.x;
}).y(function (d) {
  return d.y;
});

var useTransitionPhases = function useTransitionPhases(_ref) {
  var offset = _ref.offset,
      diagonalLength = _ref.diagonalLength,
      straightLength = _ref.straightLength,
      textOffset = _ref.textOffset,
      getLinkColor = _ref.getLinkColor,
      getTextColor = _ref.getTextColor;
  return useMemo$1(function () {
    return {
      enter: function enter(datum) {
        return {
          startAngle: datum.arc.startAngle,
          endAngle: datum.arc.endAngle,
          innerRadius: datum.arc.innerRadius,
          outerRadius: datum.arc.outerRadius,
          offset: offset,
          diagonalLength: 0,
          straightLength: 0,
          textOffset: textOffset,
          linkColor: getLinkColor(datum),
          textColor: getTextColor(datum),
          opacity: 0
        };
      },
      update: function update(d) {
        return {
          startAngle: d.arc.startAngle,
          endAngle: d.arc.endAngle,
          innerRadius: d.arc.innerRadius,
          outerRadius: d.arc.outerRadius,
          offset: offset,
          diagonalLength: diagonalLength,
          straightLength: straightLength,
          textOffset: textOffset,
          linkColor: getLinkColor(d),
          textColor: getTextColor(d),
          opacity: 1
        };
      },
      leave: function leave(d) {
        return {
          startAngle: d.arc.startAngle,
          endAngle: d.arc.endAngle,
          innerRadius: d.arc.innerRadius,
          outerRadius: d.arc.outerRadius,
          offset: offset,
          diagonalLength: 0,
          straightLength: 0,
          textOffset: textOffset,
          linkColor: getLinkColor(d),
          textColor: getTextColor(d),
          opacity: 0
        };
      }
    };
  }, [diagonalLength, straightLength, textOffset, getLinkColor, getTextColor]);
};

var interpolateLink = function interpolateLink(startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue, offsetValue, diagonalLengthValue, straightLengthValue) {
  return to([startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue, offsetValue, diagonalLengthValue, straightLengthValue], function (startAngle, endAngle, innerRadius, outerRadius, offset, diagonalLengthAnimated, straightLengthAnimated) {
    var _computeArcLink = computeArcLink({
      startAngle: startAngle,
      endAngle: endAngle,
      innerRadius: innerRadius,
      outerRadius: outerRadius
    }, offset, diagonalLengthAnimated, straightLengthAnimated),
        points = _computeArcLink.points;

    return lineGenerator(points);
  });
};

var interpolateTextAnchor = function interpolateTextAnchor(startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue) {
  return to([startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue], function (startAngle, endAngle, innerRadius, outerRadius) {
    return computeArcLinkTextAnchor({
      startAngle: startAngle,
      endAngle: endAngle,
      innerRadius: innerRadius,
      outerRadius: outerRadius
    });
  });
};

var interpolateTextPosition = function interpolateTextPosition(startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue, offsetValue, diagonalLengthValue, straightLengthValue, textOffsetValue) {
  return to([startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue, offsetValue, diagonalLengthValue, straightLengthValue, textOffsetValue], function (startAngle, endAngle, innerRadius, outerRadius, offset, diagonalLengthAnimated, straightLengthAnimated, textOffset) {
    var _computeArcLink2 = computeArcLink({
      startAngle: startAngle,
      endAngle: endAngle,
      innerRadius: innerRadius,
      outerRadius: outerRadius
    }, offset, diagonalLengthAnimated, straightLengthAnimated),
        points = _computeArcLink2.points,
        side = _computeArcLink2.side;

    var position = points[2];

    if (side === 'before') {
      position.x -= textOffset;
    } else {
      position.x += textOffset;
    }

    return "translate(".concat(position.x, ",").concat(position.y, ")");
  });
};

var useArcLinkLabelsTransition = function useArcLinkLabelsTransition(_ref2) {
  var data = _ref2.data,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === void 0 ? 0 : _ref2$offset,
      diagonalLength = _ref2.diagonalLength,
      straightLength = _ref2.straightLength,
      _ref2$skipAngle = _ref2.skipAngle,
      skipAngle = _ref2$skipAngle === void 0 ? 0 : _ref2$skipAngle,
      textOffset = _ref2.textOffset,
      linkColor = _ref2.linkColor,
      textColor = _ref2.textColor;

  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;

  var theme = useTheme();
  var getLinkColor = useInheritedColor(linkColor, theme);
  var getTextColor = useInheritedColor(textColor, theme);
  var filteredData = useFilteredDataBySkipAngle(data, skipAngle);
  var transitionPhases = useTransitionPhases({
    offset: offset,
    diagonalLength: diagonalLength,
    straightLength: straightLength,
    textOffset: textOffset,
    getLinkColor: getLinkColor,
    getTextColor: getTextColor
  });
  var transition = useTransition(filteredData, {
    keys: function keys(datum) {
      return datum.id;
    },
    initial: transitionPhases.update,
    from: transitionPhases.enter,
    enter: transitionPhases.update,
    update: transitionPhases.update,
    leave: transitionPhases.leave,
    config: springConfig,
    immediate: !animate
  });
  return {
    transition: transition,
    interpolateLink: interpolateLink,
    interpolateTextAnchor: interpolateTextAnchor,
    interpolateTextPosition: interpolateTextPosition
  };
};

var ArcLinkLabel = function ArcLinkLabel(_ref) {
  var label = _ref.label,
      style = _ref.style;
  var theme = useTheme();
  return React__default.createElement(animated.g, {
    opacity: style.opacity
  }, React__default.createElement(animated.path, {
    fill: "none",
    stroke: style.linkColor,
    strokeWidth: style.thickness,
    d: style.path
  }), React__default.createElement(animated.text, {
    transform: style.textPosition,
    textAnchor: style.textAnchor,
    dominantBaseline: "central",
    style: _objectSpread2$1(_objectSpread2$1({}, theme.labels.text), {}, {
      fill: style.textColor
    })
  }, label));
};

var ArcLinkLabelsLayer = function ArcLinkLabelsLayer(_ref) {
  var center = _ref.center,
      data = _ref.data,
      labelAccessor = _ref.label,
      skipAngle = _ref.skipAngle,
      offset = _ref.offset,
      diagonalLength = _ref.diagonalLength,
      straightLength = _ref.straightLength,
      strokeWidth = _ref.strokeWidth,
      textOffset = _ref.textOffset,
      textColor = _ref.textColor,
      linkColor = _ref.linkColor,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? ArcLinkLabel : _ref$component;
  var getLabel = usePropertyAccessor(labelAccessor);

  var _useArcLinkLabelsTran = useArcLinkLabelsTransition({
    data: data,
    skipAngle: skipAngle,
    offset: offset,
    diagonalLength: diagonalLength,
    straightLength: straightLength,
    textOffset: textOffset,
    linkColor: linkColor,
    textColor: textColor
  }),
      transition = _useArcLinkLabelsTran.transition,
      interpolateLink = _useArcLinkLabelsTran.interpolateLink,
      interpolateTextAnchor = _useArcLinkLabelsTran.interpolateTextAnchor,
      interpolateTextPosition = _useArcLinkLabelsTran.interpolateTextPosition;

  var Label = component;
  return React__default.createElement("g", {
    transform: "translate(".concat(center[0], ",").concat(center[1], ")")
  }, transition(function (transitionProps, datum) {
    return React__default.createElement(Label, {
      key: datum.id,
      datum: datum,
      label: getLabel(datum),
      style: _objectSpread2$1(_objectSpread2$1({}, transitionProps), {}, {
        thickness: strokeWidth,
        path: interpolateLink(transitionProps.startAngle, transitionProps.endAngle, transitionProps.innerRadius, transitionProps.outerRadius, transitionProps.offset, transitionProps.diagonalLength, transitionProps.straightLength),
        textAnchor: interpolateTextAnchor(transitionProps.startAngle, transitionProps.endAngle, transitionProps.innerRadius, transitionProps.outerRadius),
        textPosition: interpolateTextPosition(transitionProps.startAngle, transitionProps.endAngle, transitionProps.innerRadius, transitionProps.outerRadius, transitionProps.offset, transitionProps.diagonalLength, transitionProps.straightLength, transitionProps.textOffset)
      })
    });
  }));
};

var ArcShape = function ArcShape(_ref) {
  var datum = _ref.datum,
      style = _ref.style,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseMove = _ref.onMouseMove,
      onMouseLeave = _ref.onMouseLeave;
  var handleClick = useCallback$1(function (event) {
    return onClick === null || onClick === void 0 ? void 0 : onClick(datum, event);
  }, [onClick, datum]);
  var handleMouseEnter = useCallback$1(function (event) {
    return onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(datum, event);
  }, [onMouseEnter, datum]);
  var handleMouseMove = useCallback$1(function (event) {
    return onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove(datum, event);
  }, [onMouseMove, datum]);
  var handleMouseLeave = useCallback$1(function (event) {
    return onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(datum, event);
  }, [onMouseLeave, datum]);
  return React__default.createElement(animated.path, {
    d: style.path,
    opacity: style.opacity,
    fill: datum.fill || style.color,
    stroke: style.borderColor,
    strokeWidth: style.borderWidth,
    onClick: onClick ? handleClick : undefined,
    onMouseEnter: onMouseEnter ? handleMouseEnter : undefined,
    onMouseMove: onMouseMove ? handleMouseMove : undefined,
    onMouseLeave: onMouseLeave ? handleMouseLeave : undefined
  });
};

var interpolateArc = function interpolateArc(startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue, arcGenerator) {
  return to([startAngleValue, endAngleValue, innerRadiusValue, outerRadiusValue], function (startAngle, endAngle, innerRadius, outerRadius) {
    return arcGenerator({
      startAngle: startAngle,
      endAngle: endAngle,
      innerRadius: Math.max(0, innerRadius),
      outerRadius: Math.max(0, outerRadius)
    });
  });
};

var useArcsTransition = function useArcsTransition(data) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'innerRadius';
  var extra = arguments.length > 2 ? arguments[2] : undefined;

  var _useMotionConfig = useMotionConfig(),
      animate = _useMotionConfig.animate,
      springConfig = _useMotionConfig.config;

  var phases = useArcTransitionMode(mode, extra);
  var transition = useTransition(data, {
    keys: function keys(datum) {
      return datum.id;
    },
    initial: phases.update,
    from: phases.enter,
    enter: phases.update,
    update: phases.update,
    leave: phases.leave,
    config: springConfig,
    immediate: !animate
  });
  return {
    transition: transition,
    interpolate: interpolateArc
  };
};

var ArcsLayer = function ArcsLayer(_ref) {
  var center = _ref.center,
      data = _ref.data,
      arcGenerator = _ref.arcGenerator,
      borderWidth = _ref.borderWidth,
      borderColor = _ref.borderColor,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseMove = _ref.onMouseMove,
      onMouseLeave = _ref.onMouseLeave,
      transitionMode = _ref.transitionMode,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? ArcShape : _ref$component;
  var theme = useTheme();
  var getBorderColor = useInheritedColor(borderColor, theme);

  var _useArcsTransition = useArcsTransition(data, transitionMode, {
    enter: function enter(datum) {
      return {
        opacity: 0,
        color: datum.color,
        borderColor: getBorderColor(datum)
      };
    },
    update: function update(datum) {
      return {
        opacity: 1,
        color: datum.color,
        borderColor: getBorderColor(datum)
      };
    },
    leave: function leave(datum) {
      return {
        opacity: 0,
        color: datum.color,
        borderColor: getBorderColor(datum)
      };
    }
  }),
      transition = _useArcsTransition.transition,
      interpolate = _useArcsTransition.interpolate;

  var Arc = component;
  return React__default.createElement("g", {
    transform: "translate(".concat(center[0], ",").concat(center[1], ")")
  }, transition(function (transitionProps, datum) {
    return createElement(Arc, {
      key: datum.id,
      datum: datum,
      style: _objectSpread2$1(_objectSpread2$1({}, transitionProps), {}, {
        borderWidth: borderWidth,
        path: interpolate(transitionProps.startAngle, transitionProps.endAngle, transitionProps.innerRadius, transitionProps.outerRadius, arcGenerator)
      }),
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseMove: onMouseMove,
      onMouseLeave: onMouseLeave
    });
  }));
};

function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$1(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread();
}

function _arrayWithHoles$1(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit$1(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _nonIterableRest$1() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray$1(arr, i) {
  return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1();
}

var computeArcBoundingBox = function computeArcBoundingBox(centerX, centerY, radius, startAngle, endAngle) {
  var includeCenter = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
  var points = [];
  var p0 = positionFromAngle(degreesToRadians(startAngle), radius);
  points.push([p0.x, p0.y]);
  var p1 = positionFromAngle(degreesToRadians(endAngle), radius);
  points.push([p1.x, p1.y]);

  for (var angle = Math.round(Math.min(startAngle, endAngle)); angle <= Math.round(Math.max(startAngle, endAngle)); angle++) {
    if (angle % 90 === 0) {
      var p = positionFromAngle(degreesToRadians(angle), radius);
      points.push([p.x, p.y]);
    }
  }

  points = points.map(function (_ref) {
    var _ref2 = _slicedToArray$1(_ref, 2),
        x = _ref2[0],
        y = _ref2[1];

    return [centerX + x, centerY + y];
  });

  if (includeCenter === true) {
    points.push([centerX, centerY]);
  }

  var xs = points.map(function (_ref3) {
    var _ref4 = _slicedToArray$1(_ref3, 1),
        x = _ref4[0];

    return x;
  });
  var ys = points.map(function (_ref5) {
    var _ref6 = _slicedToArray$1(_ref5, 2),
        y = _ref6[1];

    return y;
  });
  var x0 = Math.min.apply(Math, _toConsumableArray(xs));
  var x1 = Math.max.apply(Math, _toConsumableArray(xs));
  var y0 = Math.min.apply(Math, _toConsumableArray(ys));
  var y1 = Math.max.apply(Math, _toConsumableArray(ys));
  return {
    points: points,
    x: x0,
    y: y0,
    width: x1 - x0,
    height: y1 - y0
  };
};

var useArcGenerator = function useArcGenerator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$cornerRadius = _ref.cornerRadius,
      cornerRadius = _ref$cornerRadius === void 0 ? 0 : _ref$cornerRadius,
      _ref$padAngle = _ref.padAngle,
      padAngle = _ref$padAngle === void 0 ? 0 : _ref$padAngle;

  return useMemo$1(function () {
    return arc().innerRadius(function (arc) {
      return arc.innerRadius;
    }).outerRadius(function (arc) {
      return arc.outerRadius;
    }).cornerRadius(cornerRadius).padAngle(padAngle);
  }, [cornerRadius, padAngle]);
};

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var PieLegends = function PieLegends(_ref) {
  var width = _ref.width,
      height = _ref.height,
      legends = _ref.legends,
      dataWithArc = _ref.dataWithArc;
  return React__default.createElement(React__default.Fragment, null, legends.map(function (legend, i) {
    return React__default.createElement(BoxLegendSvg, Object.assign({
      key: i
    }, legend, {
      containerWidth: width,
      containerHeight: height,
      data: dataWithArc
    }));
  }));
};

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys$5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}

var PieTooltip = function PieTooltip(_ref) {
  var datum = _ref.datum;
  return React__default.createElement(BasicTooltip, {
    id: datum.id,
    value: datum.formattedValue,
    enableChip: true,
    color: datum.color
  });
};

var _window$devicePixelRa;
var defaultProps$2 = {
  id: 'id',
  value: 'value',
  sortByValue: false,
  innerRadius: 0,
  padAngle: 0,
  cornerRadius: 0,
  layers: ['arcLinkLabels', 'arcs', 'arcLabels', 'legends'],
  startAngle: 0,
  endAngle: 360,
  fit: true,
  activeInnerRadiusOffset: 0,
  activeOuterRadiusOffset: 0,
  borderWidth: 0,
  borderColor: {
    from: 'color',
    modifiers: [['darker', 1]]
  },
  enableArcLabels: true,
  arcLabel: 'formattedValue',
  arcLabelsSkipAngle: 0,
  arcLabelsRadiusOffset: 0.5,
  arcLabelsTextColor: {
    theme: 'labels.text.fill'
  },
  enableArcLinkLabels: true,
  arcLinkLabel: 'id',
  arcLinkLabelsSkipAngle: 0,
  arcLinkLabelsOffset: 0,
  arcLinkLabelsDiagonalLength: 16,
  arcLinkLabelsStraightLength: 24,
  arcLinkLabelsThickness: 1,
  arcLinkLabelsTextOffset: 6,
  arcLinkLabelsTextColor: {
    theme: 'labels.text.fill'
  },
  arcLinkLabelsColor: {
    theme: 'axis.ticks.line.stroke'
  },
  colors: {
    scheme: 'nivo'
  },
  defs: [],
  fill: [],
  isInteractive: true,
  animate: true,
  motionConfig: 'gentle',
  transitionMode: 'innerRadius',
  tooltip: PieTooltip,
  legends: [],
  role: 'img',
  pixelRatio: typeof window !== 'undefined' ? (_window$devicePixelRa = window.devicePixelRatio) !== null && _window$devicePixelRa !== void 0 ? _window$devicePixelRa : 1 : 1
};

var useNormalizedData = function useNormalizedData(_ref) {
  var data = _ref.data,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? defaultProps$2.id : _ref$id,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? defaultProps$2.value : _ref$value,
      valueFormat = _ref.valueFormat,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? defaultProps$2.colors : _ref$colors;
  var getId = usePropertyAccessor(id);
  var getValue = usePropertyAccessor(value);
  var formatValue = useValueFormatter(valueFormat);
  var getColor = useOrdinalColorScale(colors, 'id');
  return useMemo$1(function () {
    return data.map(function (datum) {
      var _datum$label;

      var datumId = getId(datum);
      var datumValue = getValue(datum);
      var normalizedDatum = {
        id: datumId,
        label: (_datum$label = datum.label) !== null && _datum$label !== void 0 ? _datum$label : datumId,
        value: datumValue,
        formattedValue: formatValue(datumValue),
        data: datum
      };
      return _objectSpread2(_objectSpread2({}, normalizedDatum), {}, {
        color: getColor(normalizedDatum)
      });
    });
  }, [data, getId, getValue, formatValue, getColor]);
};
var usePieArcs = function usePieArcs(_ref2) {
  var data = _ref2.data,
      startAngle = _ref2.startAngle,
      endAngle = _ref2.endAngle,
      innerRadius = _ref2.innerRadius,
      outerRadius = _ref2.outerRadius,
      padAngle = _ref2.padAngle,
      sortByValue = _ref2.sortByValue,
      activeId = _ref2.activeId,
      activeInnerRadiusOffset = _ref2.activeInnerRadiusOffset,
      activeOuterRadiusOffset = _ref2.activeOuterRadiusOffset;
  var pie$1 = useMemo$1(function () {
    var innerPie = pie().value(function (d) {
      return d.value;
    }).startAngle(degreesToRadians(startAngle)).endAngle(degreesToRadians(endAngle)).padAngle(degreesToRadians(padAngle));

    if (!sortByValue) {
      innerPie.sortValues(null);
    }

    return innerPie;
  }, [startAngle, endAngle, padAngle, sortByValue]);
  return useMemo$1(function () {
    return pie$1(data).map(function (arc) {
      var angle = Math.abs(arc.endAngle - arc.startAngle);
      return _objectSpread2(_objectSpread2({}, arc.data), {}, {
        arc: {
          index: arc.index,
          startAngle: arc.startAngle,
          endAngle: arc.endAngle,
          innerRadius: activeId === arc.data.id ? innerRadius - activeInnerRadiusOffset : innerRadius,
          outerRadius: activeId === arc.data.id ? outerRadius + activeOuterRadiusOffset : outerRadius,
          thickness: outerRadius - innerRadius,
          padAngle: arc.padAngle,
          angle: angle,
          angleDeg: radiansToDegrees(angle)
        }
      });
    });
  }, [pie$1, data, innerRadius, outerRadius, activeId, activeInnerRadiusOffset, activeInnerRadiusOffset]);
};
var usePieFromBox = function usePieFromBox(_ref4) {
  var data = _ref4.data,
      width = _ref4.width,
      height = _ref4.height,
      _ref4$innerRadius = _ref4.innerRadius,
      innerRadiusRatio = _ref4$innerRadius === void 0 ? defaultProps$2.innerRadius : _ref4$innerRadius,
      _ref4$startAngle = _ref4.startAngle,
      startAngle = _ref4$startAngle === void 0 ? defaultProps$2.startAngle : _ref4$startAngle,
      _ref4$endAngle = _ref4.endAngle,
      endAngle = _ref4$endAngle === void 0 ? defaultProps$2.endAngle : _ref4$endAngle,
      _ref4$padAngle = _ref4.padAngle,
      padAngle = _ref4$padAngle === void 0 ? defaultProps$2.padAngle : _ref4$padAngle,
      _ref4$sortByValue = _ref4.sortByValue,
      sortByValue = _ref4$sortByValue === void 0 ? defaultProps$2.sortByValue : _ref4$sortByValue,
      _ref4$cornerRadius = _ref4.cornerRadius,
      cornerRadius = _ref4$cornerRadius === void 0 ? defaultProps$2.cornerRadius : _ref4$cornerRadius,
      _ref4$fit = _ref4.fit,
      fit = _ref4$fit === void 0 ? defaultProps$2.fit : _ref4$fit,
      _ref4$activeInnerRadi = _ref4.activeInnerRadiusOffset,
      activeInnerRadiusOffset = _ref4$activeInnerRadi === void 0 ? defaultProps$2.activeInnerRadiusOffset : _ref4$activeInnerRadi,
      _ref4$activeOuterRadi = _ref4.activeOuterRadiusOffset,
      activeOuterRadiusOffset = _ref4$activeOuterRadi === void 0 ? defaultProps$2.activeOuterRadiusOffset : _ref4$activeOuterRadi;

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      activeId = _useState4[0],
      setActiveId = _useState4[1];

  var computedProps = useMemo$1(function () {
    var radius = Math.min(width, height) / 2;
    var innerRadius = radius * Math.min(innerRadiusRatio, 1);
    var centerX = width / 2;
    var centerY = height / 2;
    var boundingBox;

    if (fit) {
      var _computeArcBoundingBo = computeArcBoundingBox(centerX, centerY, radius, startAngle - 90, endAngle - 90),
          points = _computeArcBoundingBo.points,
          box = _objectWithoutProperties(_computeArcBoundingBo, ["points"]);

      var ratio = Math.min(width / box.width, height / box.height);
      var adjustedBox = {
        width: box.width * ratio,
        height: box.height * ratio
      };
      adjustedBox.x = (width - adjustedBox.width) / 2;
      adjustedBox.y = (height - adjustedBox.height) / 2;
      centerX = (centerX - box.x) / box.width * box.width * ratio + adjustedBox.x;
      centerY = (centerY - box.y) / box.height * box.height * ratio + adjustedBox.y;
      boundingBox = {
        box: box,
        ratio: ratio,
        points: points
      };
      radius = radius * ratio;
      innerRadius = innerRadius * ratio;
    }

    return {
      centerX: centerX,
      centerY: centerY,
      radius: radius,
      innerRadius: innerRadius,
      debug: boundingBox
    };
  }, [width, height, innerRadiusRatio, startAngle, endAngle, fit, cornerRadius]);
  var dataWithArc = usePieArcs({
    data: data,
    startAngle: startAngle,
    endAngle: endAngle,
    innerRadius: computedProps.innerRadius,
    outerRadius: computedProps.radius,
    padAngle: padAngle,
    sortByValue: sortByValue,
    activeId: activeId,
    activeInnerRadiusOffset: activeInnerRadiusOffset,
    activeOuterRadiusOffset: activeOuterRadiusOffset
  });
  var arcGenerator = useArcGenerator({
    cornerRadius: cornerRadius,
    padAngle: degreesToRadians(padAngle)
  });
  return _objectSpread2({
    dataWithArc: dataWithArc,
    arcGenerator: arcGenerator,
    setActiveId: setActiveId
  }, computedProps);
};
var usePieLayerContext = function usePieLayerContext(_ref5) {
  var dataWithArc = _ref5.dataWithArc,
      arcGenerator = _ref5.arcGenerator,
      centerX = _ref5.centerX,
      centerY = _ref5.centerY,
      radius = _ref5.radius,
      innerRadius = _ref5.innerRadius;
  return useMemo$1(function () {
    return {
      dataWithArc: dataWithArc,
      arcGenerator: arcGenerator,
      centerX: centerX,
      centerY: centerY,
      radius: radius,
      innerRadius: innerRadius
    };
  }, [dataWithArc, arcGenerator, centerX, centerY, radius, innerRadius]);
};

var Arcs = function Arcs(_ref) {
  var center = _ref.center,
      data = _ref.data,
      arcGenerator = _ref.arcGenerator,
      borderWidth = _ref.borderWidth,
      borderColor = _ref.borderColor,
      isInteractive = _ref.isInteractive,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseMove = _ref.onMouseMove,
      onMouseLeave = _ref.onMouseLeave,
      setActiveId = _ref.setActiveId,
      tooltip = _ref.tooltip,
      transitionMode = _ref.transitionMode;

  var _useTooltip = useTooltip(),
      showTooltipFromEvent = _useTooltip.showTooltipFromEvent,
      hideTooltip = _useTooltip.hideTooltip;

  var handleClick = useMemo$1(function () {
    if (!isInteractive) return undefined;
    return function (datum, event) {
      onClick === null || onClick === void 0 ? void 0 : onClick(datum, event);
    };
  }, [isInteractive, onClick]);
  var handleMouseEnter = useMemo$1(function () {
    if (!isInteractive) return undefined;
    return function (datum, event) {
      showTooltipFromEvent(createElement(tooltip, {
        datum: datum
      }), event);
      setActiveId(datum.id);
      onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(datum, event);
    };
  }, [isInteractive, showTooltipFromEvent, setActiveId, onMouseEnter]);
  var handleMouseMove = useMemo$1(function () {
    if (!isInteractive) return undefined;
    return function (datum, event) {
      showTooltipFromEvent(createElement(tooltip, {
        datum: datum
      }), event);
      onMouseMove === null || onMouseMove === void 0 ? void 0 : onMouseMove(datum, event);
    };
  }, [isInteractive, showTooltipFromEvent, onMouseMove]);
  var handleMouseLeave = useMemo$1(function () {
    if (!isInteractive) return undefined;
    return function (datum, event) {
      hideTooltip();
      setActiveId(null);
      onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(datum, event);
    };
  }, [isInteractive, hideTooltip, setActiveId, onMouseLeave]);
  return React__default.createElement(ArcsLayer, {
    center: center,
    data: data,
    arcGenerator: arcGenerator,
    borderWidth: borderWidth,
    borderColor: borderColor,
    transitionMode: transitionMode,
    onClick: handleClick,
    onMouseEnter: handleMouseEnter,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave
  });
};

var InnerPie = function InnerPie(_ref) {
  var data = _ref.data,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? defaultProps$2.id : _ref$id,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? defaultProps$2.value : _ref$value,
      valueFormat = _ref.valueFormat,
      _ref$sortByValue = _ref.sortByValue,
      sortByValue = _ref$sortByValue === void 0 ? defaultProps$2.sortByValue : _ref$sortByValue,
      _ref$layers = _ref.layers,
      layers = _ref$layers === void 0 ? defaultProps$2.layers : _ref$layers,
      _ref$startAngle = _ref.startAngle,
      startAngle = _ref$startAngle === void 0 ? defaultProps$2.startAngle : _ref$startAngle,
      _ref$endAngle = _ref.endAngle,
      endAngle = _ref$endAngle === void 0 ? defaultProps$2.endAngle : _ref$endAngle,
      _ref$padAngle = _ref.padAngle,
      padAngle = _ref$padAngle === void 0 ? defaultProps$2.padAngle : _ref$padAngle,
      _ref$fit = _ref.fit,
      fit = _ref$fit === void 0 ? defaultProps$2.fit : _ref$fit,
      _ref$innerRadius = _ref.innerRadius,
      innerRadiusRatio = _ref$innerRadius === void 0 ? defaultProps$2.innerRadius : _ref$innerRadius,
      _ref$cornerRadius = _ref.cornerRadius,
      cornerRadius = _ref$cornerRadius === void 0 ? defaultProps$2.cornerRadius : _ref$cornerRadius,
      _ref$activeInnerRadiu = _ref.activeInnerRadiusOffset,
      activeInnerRadiusOffset = _ref$activeInnerRadiu === void 0 ? defaultProps$2.activeInnerRadiusOffset : _ref$activeInnerRadiu,
      _ref$activeOuterRadiu = _ref.activeOuterRadiusOffset,
      activeOuterRadiusOffset = _ref$activeOuterRadiu === void 0 ? defaultProps$2.activeOuterRadiusOffset : _ref$activeOuterRadiu,
      width = _ref.width,
      height = _ref.height,
      partialMargin = _ref.margin,
      _ref$colors = _ref.colors,
      colors = _ref$colors === void 0 ? defaultProps$2.colors : _ref$colors,
      _ref$borderWidth = _ref.borderWidth,
      borderWidth = _ref$borderWidth === void 0 ? defaultProps$2.borderWidth : _ref$borderWidth,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? defaultProps$2.borderColor : _ref$borderColor,
      _ref$enableArcLabels = _ref.enableArcLabels,
      enableArcLabels = _ref$enableArcLabels === void 0 ? defaultProps$2.enableArcLabels : _ref$enableArcLabels,
      _ref$arcLabel = _ref.arcLabel,
      arcLabel = _ref$arcLabel === void 0 ? defaultProps$2.arcLabel : _ref$arcLabel,
      _ref$arcLabelsSkipAng = _ref.arcLabelsSkipAngle,
      arcLabelsSkipAngle = _ref$arcLabelsSkipAng === void 0 ? defaultProps$2.arcLabelsSkipAngle : _ref$arcLabelsSkipAng,
      _ref$arcLabelsTextCol = _ref.arcLabelsTextColor,
      arcLabelsTextColor = _ref$arcLabelsTextCol === void 0 ? defaultProps$2.arcLabelsTextColor : _ref$arcLabelsTextCol,
      _ref$arcLabelsRadiusO = _ref.arcLabelsRadiusOffset,
      arcLabelsRadiusOffset = _ref$arcLabelsRadiusO === void 0 ? defaultProps$2.arcLabelsRadiusOffset : _ref$arcLabelsRadiusO,
      arcLabelsComponent = _ref.arcLabelsComponent,
      _ref$enableArcLinkLab = _ref.enableArcLinkLabels,
      enableArcLinkLabels = _ref$enableArcLinkLab === void 0 ? defaultProps$2.enableArcLinkLabels : _ref$enableArcLinkLab,
      _ref$arcLinkLabel = _ref.arcLinkLabel,
      arcLinkLabel = _ref$arcLinkLabel === void 0 ? defaultProps$2.arcLinkLabel : _ref$arcLinkLabel,
      _ref$arcLinkLabelsSki = _ref.arcLinkLabelsSkipAngle,
      arcLinkLabelsSkipAngle = _ref$arcLinkLabelsSki === void 0 ? defaultProps$2.arcLinkLabelsSkipAngle : _ref$arcLinkLabelsSki,
      _ref$arcLinkLabelsOff = _ref.arcLinkLabelsOffset,
      arcLinkLabelsOffset = _ref$arcLinkLabelsOff === void 0 ? defaultProps$2.arcLinkLabelsOffset : _ref$arcLinkLabelsOff,
      _ref$arcLinkLabelsDia = _ref.arcLinkLabelsDiagonalLength,
      arcLinkLabelsDiagonalLength = _ref$arcLinkLabelsDia === void 0 ? defaultProps$2.arcLinkLabelsDiagonalLength : _ref$arcLinkLabelsDia,
      _ref$arcLinkLabelsStr = _ref.arcLinkLabelsStraightLength,
      arcLinkLabelsStraightLength = _ref$arcLinkLabelsStr === void 0 ? defaultProps$2.arcLinkLabelsStraightLength : _ref$arcLinkLabelsStr,
      _ref$arcLinkLabelsThi = _ref.arcLinkLabelsThickness,
      arcLinkLabelsThickness = _ref$arcLinkLabelsThi === void 0 ? defaultProps$2.arcLinkLabelsThickness : _ref$arcLinkLabelsThi,
      _ref$arcLinkLabelsTex = _ref.arcLinkLabelsTextOffset,
      arcLinkLabelsTextOffset = _ref$arcLinkLabelsTex === void 0 ? defaultProps$2.arcLinkLabelsTextOffset : _ref$arcLinkLabelsTex,
      _ref$arcLinkLabelsTex2 = _ref.arcLinkLabelsTextColor,
      arcLinkLabelsTextColor = _ref$arcLinkLabelsTex2 === void 0 ? defaultProps$2.arcLinkLabelsTextColor : _ref$arcLinkLabelsTex2,
      _ref$arcLinkLabelsCol = _ref.arcLinkLabelsColor,
      arcLinkLabelsColor = _ref$arcLinkLabelsCol === void 0 ? defaultProps$2.arcLinkLabelsColor : _ref$arcLinkLabelsCol,
      arcLinkLabelComponent = _ref.arcLinkLabelComponent,
      _ref$defs = _ref.defs,
      defs = _ref$defs === void 0 ? defaultProps$2.defs : _ref$defs,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? defaultProps$2.fill : _ref$fill,
      _ref$isInteractive = _ref.isInteractive,
      isInteractive = _ref$isInteractive === void 0 ? defaultProps$2.isInteractive : _ref$isInteractive,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      onMouseMove = _ref.onMouseMove,
      onMouseLeave = _ref.onMouseLeave,
      _ref$tooltip = _ref.tooltip,
      tooltip = _ref$tooltip === void 0 ? defaultProps$2.tooltip : _ref$tooltip,
      _ref$transitionMode = _ref.transitionMode,
      transitionMode = _ref$transitionMode === void 0 ? defaultProps$2.transitionMode : _ref$transitionMode,
      _ref$legends = _ref.legends,
      legends = _ref$legends === void 0 ? defaultProps$2.legends : _ref$legends,
      _ref$role = _ref.role,
      role = _ref$role === void 0 ? defaultProps$2.role : _ref$role;

  var _useDimensions = useDimensions(width, height, partialMargin),
      outerWidth = _useDimensions.outerWidth,
      outerHeight = _useDimensions.outerHeight,
      margin = _useDimensions.margin,
      innerWidth = _useDimensions.innerWidth,
      innerHeight = _useDimensions.innerHeight;

  var normalizedData = useNormalizedData({
    data: data,
    id: id,
    value: value,
    valueFormat: valueFormat,
    colors: colors
  });

  var _usePieFromBox = usePieFromBox({
    data: normalizedData,
    width: innerWidth,
    height: innerHeight,
    fit: fit,
    innerRadius: innerRadiusRatio,
    startAngle: startAngle,
    endAngle: endAngle,
    padAngle: padAngle,
    sortByValue: sortByValue,
    cornerRadius: cornerRadius,
    activeInnerRadiusOffset: activeInnerRadiusOffset,
    activeOuterRadiusOffset: activeOuterRadiusOffset
  }),
      dataWithArc = _usePieFromBox.dataWithArc,
      arcGenerator = _usePieFromBox.arcGenerator,
      centerX = _usePieFromBox.centerX,
      centerY = _usePieFromBox.centerY,
      radius = _usePieFromBox.radius,
      innerRadius = _usePieFromBox.innerRadius,
      setActiveId = _usePieFromBox.setActiveId;

  var boundDefs = bindDefs(defs, dataWithArc, fill);
  var layerById = {
    arcLinkLabels: null,
    arcs: null,
    arcLabels: null,
    legends: null
  };

  if (enableArcLinkLabels && layers.includes('arcLinkLabels')) {
    layerById.arcLinkLabels = React__default.createElement(ArcLinkLabelsLayer, {
      key: "arcLinkLabels",
      center: [centerX, centerY],
      data: dataWithArc,
      label: arcLinkLabel,
      skipAngle: arcLinkLabelsSkipAngle,
      offset: arcLinkLabelsOffset,
      diagonalLength: arcLinkLabelsDiagonalLength,
      straightLength: arcLinkLabelsStraightLength,
      strokeWidth: arcLinkLabelsThickness,
      textOffset: arcLinkLabelsTextOffset,
      textColor: arcLinkLabelsTextColor,
      linkColor: arcLinkLabelsColor,
      component: arcLinkLabelComponent
    });
  }

  if (layers.includes('arcs')) {
    layerById.arcs = React__default.createElement(Arcs, {
      key: "arcs",
      center: [centerX, centerY],
      data: dataWithArc,
      arcGenerator: arcGenerator,
      borderWidth: borderWidth,
      borderColor: borderColor,
      isInteractive: isInteractive,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseMove: onMouseMove,
      onMouseLeave: onMouseLeave,
      setActiveId: setActiveId,
      tooltip: tooltip,
      transitionMode: transitionMode
    });
  }

  if (enableArcLabels && layers.includes('arcLabels')) {
    layerById.arcLabels = React__default.createElement(ArcLabelsLayer, {
      key: "arcLabels",
      center: [centerX, centerY],
      data: dataWithArc,
      label: arcLabel,
      radiusOffset: arcLabelsRadiusOffset,
      skipAngle: arcLabelsSkipAngle,
      textColor: arcLabelsTextColor,
      transitionMode: transitionMode,
      component: arcLabelsComponent
    });
  }

  if (legends.length > 0 && layers.includes('legends')) {
    layerById.legends = React__default.createElement(PieLegends, {
      key: "legends",
      width: innerWidth,
      height: innerHeight,
      dataWithArc: dataWithArc,
      legends: legends
    });
  }

  var layerContext = usePieLayerContext({
    dataWithArc: dataWithArc,
    arcGenerator: arcGenerator,
    centerX: centerX,
    centerY: centerY,
    radius: radius,
    innerRadius: innerRadius
  });
  return React__default.createElement(SvgWrapper, {
    width: outerWidth,
    height: outerHeight,
    margin: margin,
    defs: boundDefs,
    role: role
  }, layers.map(function (layer, i) {
    if (layerById[layer] !== undefined) {
      return layerById[layer];
    }

    if (typeof layer === 'function') {
      return React__default.createElement(Fragment, {
        key: i
      }, createElement(layer, layerContext));
    }

    return null;
  }));
};

var Pie$1 = function Pie(_ref2) {
  var _ref2$isInteractive = _ref2.isInteractive,
      isInteractive = _ref2$isInteractive === void 0 ? defaultProps$2.isInteractive : _ref2$isInteractive,
      _ref2$animate = _ref2.animate,
      animate = _ref2$animate === void 0 ? defaultProps$2.animate : _ref2$animate,
      _ref2$motionConfig = _ref2.motionConfig,
      motionConfig = _ref2$motionConfig === void 0 ? defaultProps$2.motionConfig : _ref2$motionConfig,
      theme = _ref2.theme,
      otherProps = _objectWithoutProperties(_ref2, ["isInteractive", "animate", "motionConfig", "theme"]);

  return React__default.createElement(Container, {
    isInteractive: isInteractive,
    animate: animate,
    motionConfig: motionConfig,
    theme: theme
  }, React__default.createElement(InnerPie, Object.assign({
    isInteractive: isInteractive
  }, otherProps)));
};

var ResponsivePie = function ResponsivePie(props) {
  return React__default.createElement(ResponsiveWrapper$1, null, function (_ref) {
    var width = _ref.width,
        height = _ref.height;
    return React__default.createElement(Pie$1, Object.assign({
      width: width,
      height: height
    }, props));
  });
};

var css_248z$U = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.pie-root{height:100%;position:relative;width:100%}.pie-root .overlay{align-items:center;bottom:0;color:#565360;display:flex;flex-direction:column;font-size:.8125rem;justify-content:center;left:80px;pointer-events:none;position:absolute;right:80px;text-align:center;top:0;white-space:pre}";
styleInject(css_248z$U);

const Pie = (props) => {
    const { data, innerRadius, showUnitAndValuesInTooltip, singularUnitText, pluralUnitText, customTooltip, linkLabelColor, totalText, showPercentInLabel, dataTestId, margins = { right: 80, left: 80 } } = props;
    const total = data.reduce((total, val) => total + (val.value || 0), 0);
    const getColors = () => {
        const pieColors = [];
        data === null || data === void 0 ? void 0 : data.forEach((val) => pieColors.push(val.color));
        return pieColors;
    };
    const getPercentInLabel = (data) => {
        return data === null || data === void 0 ? void 0 : data.map(data => (Object.assign(Object.assign({}, data), { label: lib$1.getPercentAsString(data.value, total) })));
    };
    const customTooltipWithUnitAndValues = ({ datum }) => {
        const { data } = datum;
        return (jsx(LegendComponent, { legends: [
                {
                    color: data.color,
                    text: data.id,
                    value: data.value
                }
            ], singularUnitText: singularUnitText, pluralUnitText: pluralUnitText, isVertical: true, showValues: true, total: total, className: "legend-tootip" }, data.id));
    };
    return (jsxs("div", Object.assign({ className: "pie-root", "data-testid": dataTestId }, { children: [jsx(ResponsivePie, { data: showPercentInLabel ? getPercentInLabel(data) : data, margin: margins, innerRadius: innerRadius, padAngle: 1, tooltip: showUnitAndValuesInTooltip ? customTooltipWithUnitAndValues : customTooltip, colors: getColors(), enableArcLabels: false, arcLinkLabel: "label", arcLinkLabelsSkipAngle: 10, arcLinkLabelsTextColor: linkLabelColor, arcLinkLabelsThickness: 1, arcLinkLabelsColor: "#BFBDC2", arcLabelsSkipAngle: 10, arcLabelsTextColor: linkLabelColor }, void 0), jsxs("div", Object.assign({ className: "overlay" }, { children: [jsx("div", { children: totalText }, void 0), jsx("span", { children: total }, void 0)] }), void 0)] }), void 0));
};

var css_248z$T = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.pie-legend-card{height:100%;width:100%}.pie-legend-card .title{color:#565360;font-size:1.25rem;margin-left:1rem}.pie-legend-card .pie-legend{align-items:center;display:flex;height:100%;justify-content:center;width:100%}.pie-legend-card .pie-legend .pie-legend-wrapper{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:space-between;width:100%}.pie-legend-card .pie-legend .pie-legend-wrapper .pie-wrapper{display:flex;height:74%;justify-content:center;width:67%}.pie-legend-card .pie-legend .pie-legend-wrapper .legend-tooltip{align-self:unset!important;margin:0!important}";
styleInject(css_248z$T);

const PieLegendCard = (props) => {
    const { title, pieData, totalText, customTooltip, showPercentInLabel = true, showUnitAndValuesInTooltip, singularUnitText, pluralUnitText } = props;
    const getLegends = () => {
        const legends = [];
        pieData === null || pieData === void 0 ? void 0 : pieData.map(data => legends.push({ color: data.color, text: data.label, value: data.value }));
        return legends;
    };
    return (jsxs("div", Object.assign({ className: "pie-legend-card" }, { children: [title && jsx("div", Object.assign({ className: "title" }, { children: title }), void 0), jsx("div", Object.assign({ className: "pie-legend" }, { children: jsxs("div", Object.assign({ className: "pie-legend-wrapper" }, { children: [jsx("div", Object.assign({ className: "pie-wrapper" }, { children: jsx(Pie, { showPercentInLabel: showPercentInLabel, data: pieData, innerRadius: 0.8, linkLabelColor: "#565360", totalText: totalText, customTooltip: customTooltip, showUnitAndValuesInTooltip: showUnitAndValuesInTooltip, singularUnitText: singularUnitText, pluralUnitText: pluralUnitText }, void 0) }), void 0), jsx(LegendComponent, { showValues: true, legends: getLegends(), singularUnitText: singularUnitText, pluralUnitText: pluralUnitText }, void 0)] }), void 0) }), void 0)] }), void 0));
};

var css_248z$S = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.icon-detailed-card-container{background-color:#fff;border:1px solid #bfbdc2;border-radius:.3rem;display:flex;justify-content:space-between;padding:1rem;width:10rem}.icon-detailed-card-container .left{color:#565360;display:flex;flex-direction:column;font-family:Inter;font-size:.9rem;justify-content:space-around}.icon-detailed-card-container .right{align-items:center;background-color:#dad8dc;border-radius:50%;display:flex;height:3rem;justify-content:center;width:3rem}";
styleInject(css_248z$S);

const IconDetailedCard = (props) => {
    const { title, value, iconName, dataTestid } = props;
    return (jsxs("div", Object.assign({ className: "icon-detailed-card-container", "data-testid": dataTestid }, { children: [jsxs("div", Object.assign({ className: "left" }, { children: [jsx("div", { children: title }, void 0), jsx("div", { children: value }, void 0)] }), void 0), jsx(Icon, { name: iconName, className: "right", dataTestid: "icon" }, void 0)] }), void 0));
};

var css_248z$R = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.rating-bar-wrapper{color:#fff;display:flex;font-family:sans-serif;font-size:.7rem;height:1.1rem}.rating-bar-wrapper .rating{align-items:center;display:flex;justify-content:center}.rating-bar-wrapper .first-rating{border-bottom-left-radius:30px;border-top-left-radius:30px}.rating-bar-wrapper .last-rating{border-bottom-right-radius:30px;border-top-right-radius:30px}";
styleInject(css_248z$R);

const RatingBar = ({ ratingData, showTooltip, getRatingBarItemLegends, legendsTootlipProps }) => {
    const getRatingBarItemContent = (rating, i) => {
        const { value, percentage, color } = rating;
        return (jsx("div", Object.assign({ className: classNames('rating', {
                'first-rating': i === 0,
                'last-rating ': i === ratingData.length - 1
            }), style: { backgroundColor: color, width: `${percentage}%` } }, { children: percentage >= 5 && value }), i));
    };
    return (jsx("div", Object.assign({ "data-testid": "rating-bar", className: "rating-bar-wrapper" }, { children: ratingData.map((rating, i) => {
            if (showTooltip && legendsTootlipProps && getRatingBarItemLegends)
                return (jsx(LegendTooltip$1, Object.assign({}, legendsTootlipProps, { legends: getRatingBarItemLegends(rating), isVertical: true, className: "legend-tootip" }, { children: getRatingBarItemContent(rating, i) }), void 0));
            return getRatingBarItemContent(rating, i);
        }) }), void 0));
};

var css_248z$Q = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.selection-wrapper{align-items:center;color:#6b6874;display:flex;margin-left:1rem}.selection-wrapper .prefix-text{margin-right:.5rem}.selection-wrapper .selection-input{align-items:center;background:#f6f6f6;cursor:pointer;display:flex;height:2.5rem;justify-content:space-between;padding-left:.7rem;width:13rem}.selection-wrapper .selection-input .selection-input-text-open{color:#109cf1}.selection-wrapper .selection-input .selection-action{align-items:center;display:flex;justify-content:space-around;margin-right:.5rem}.selection-wrapper .selection-input .selection-action .selection-close-icon-hover:hover{color:#109cf1;cursor:pointer}.selection-wrapper .selection-input .selection-action .selection-close-icon{padding:.1rem;width:2rem}.selection-wrapper .selection-input .selection-action .selection-arrow-icon{padding:.1rem 1rem .1rem .1rem}.selection-wrapper .selection-input .selection-action .selection-arrow-icon svg{height:1rem;width:1.1rem}";
styleInject(css_248z$Q);

const RadioMultiSelectText = (props) => {
    const { buttonPrefixText, calcSelectedOptions, numChecked, open, handleDropdownClick, handleClear } = props;
    const { translate } = useTranslationContext();
    const hasCloseIcon = numChecked > 0;
    return (jsxs("div", Object.assign({ className: "selection-wrapper", id: "common-components-1786027375027-5" }, { children: [jsx("div", Object.assign({ className: "prefix-text", id: "common-components-1786027375029-2" }, { children: buttonPrefixText }), void 0), jsxs("div", Object.assign({ "data-testid": "toggle-popover-button", className: "selection-input", onClick: handleDropdownClick, id: "common-components-1786027375031-3" }, { children: [jsx(TooltipContainer, Object.assign({ hasBorder: true, hasDefaultStyle: true, unsetMaxWidth: true, title: lib$1.concatStrings(calcSelectedOptions().map(i => i.title), ', '), dataTestid: "selection-tooltip", isTooltipHidden: numChecked <= 0 || open }, { children: jsx("div", Object.assign({ className: classNames({ 'selection-input-text-open': open }), id: "common-components-1786027375066-2" }, { children: numChecked <= 0 ? translate('None_selected') : translate('x_selected', { number: numChecked }) }), void 0) }), void 0), jsxs("div", Object.assign({ className: "selection-action", id: "common-components-1786027375068-0" }, { children: [jsx("div", Object.assign({ onClick: hasCloseIcon ? handleClear : undefined, className: classNames('selection-close-icon', { 'selection-close-icon-hover': hasCloseIcon }), id: "common-components-1786027375069-10" }, { children: hasCloseIcon && jsx(CloseIcon, {}, void 0) }), void 0), jsx("div", Object.assign({ className: "selection-arrow-icon", id: "common-components-1786027375325-8" }, { children: jsx(Icon, { name: "downArrowIcon", className: "icon" }, void 0) }), void 0)] }), void 0)] }), void 0)] }), void 0));
};

var css_248z$P = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.radio-multi-select-wide .MuiPaper-root.MuiPopover-paper{padding:1.5rem!important}.radio-multi-select-not-wide .MuiMenuItem-root{color:#565360;font-weight:400;min-height:2.5rem!important;padding:0 .7rem!important;width:20rem!important}.radio-multi-select-not-wide .MuiTextField-root{width:18.75rem!important}.radio-multi-select .MuiPaper-root.MuiPopover-paper{padding:.9rem 0}.radio-multi-select .not-wide-checkbox.PrivateSwitchBase-root-15{padding:0 .5rem}.radio-multi-select .footer-buttons{display:flex;justify-content:flex-end;margin-top:1rem;padding:0 .9rem}.radio-multi-select .footer-buttons .reset-button{margin-right:10px}.radio-multi-select .checkbox-container{height:200px;max-width:300px;overflow-y:scroll;padding-top:.5rem}";
styleInject(css_248z$P);

const calcInitialCheckboxValues = (radioGroup) => {
    const initialCheckboxValues = {};
    radioGroup.forEach(radioItem => {
        var _a;
        const checkboxValues = {};
        (_a = radioItem.checkboxGroup) === null || _a === void 0 ? void 0 : _a.forEach(checkboxItem => {
            checkboxValues[checkboxItem.optionValue] = false;
        });
        initialCheckboxValues[radioItem.optionValue] = checkboxValues;
    });
    return initialCheckboxValues;
};
const calcRadioValuesToTitles = (radioGroup) => {
    const radioValuesToTitles = {};
    radioGroup.forEach(radioItem => {
        radioValuesToTitles[radioItem.optionValue] = radioItem.title;
    });
    return radioValuesToTitles;
};
const RadioMultiSelect = (props) => {
    const { selectedValues = [], radioGroup, dataTestId, buttonPrefixText, buttonType = 'button', color = 'primary', onChange, resetText, applyText, isWide = true } = props;
    const { translate } = useTranslationContext();
    const initialCheckboxValues = useMemo$1(() => calcInitialCheckboxValues(radioGroup), [radioGroup]);
    const [radioValue, setRadioValue] = useState(radioGroup[0].optionValue);
    const [checkboxValues, setCheckboxValues] = useState(initialCheckboxValues);
    const [anchorEl, setAnchorEl] = useState(null);
    const [numChecked, setNumChecked] = useState(0);
    const [searchString, setSearchString] = useState('');
    const onSearchChange = (value) => {
        setSearchString(value);
    };
    const radioValuesToTitles = useMemo$1(() => calcRadioValuesToTitles(radioGroup), [radioGroup]);
    useEffect(() => {
        const selectedCheckboxValues = checkboxValues[radioValue];
        const checkboxKeys = Object.keys(selectedCheckboxValues);
        if (checkboxKeys.length === 0) {
            setNumChecked(-1);
            return;
        }
        const sum = checkboxKeys.reduce((sum, key) => sum + (selectedCheckboxValues[key] ? 1 : 0), 0);
        setNumChecked(sum);
    }, [radioValue, checkboxValues]);
    const calcSelectedOptions = () => {
        var _a;
        const checkboxGroup = (_a = radioGroup.find(group => group.optionValue === radioValue)) === null || _a === void 0 ? void 0 : _a.checkboxGroup;
        const currValues = checkboxValues[radioValue];
        const selectedOptions = [];
        checkboxGroup === null || checkboxGroup === void 0 ? void 0 : checkboxGroup.forEach(checkbox => {
            if ((checkbox.optionValue || checkbox.optionValue === 0) && currValues[checkbox.optionValue]) {
                selectedOptions.push(checkbox);
            }
        });
        return selectedOptions;
    };
    const handleDropdownClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
        const selectedOptions = calcSelectedOptions();
        onChange(selectedOptions);
        setSearchString('');
    };
    const handleReset = () => {
        setRadioValue(radioGroup[0].optionValue);
        setCheckboxValues(calcInitialCheckboxValues(radioGroup));
    };
    const handleClear = (e) => {
        e.stopPropagation();
        handleReset();
        onChange([]);
    };
    useEffect(() => {
        if (selectedValues.length === 0) {
            handleReset();
        }
    }, [selectedValues.length]);
    const handleCheckboxClick = (radioItem, checkboxItem) => {
        const newCheckboxValues = Object.assign({}, checkboxValues);
        const radioOption = radioItem.optionValue;
        const checkboxOption = checkboxItem.optionValue;
        newCheckboxValues[radioOption][checkboxOption] = !newCheckboxValues[radioOption][checkboxOption];
        setCheckboxValues(newCheckboxValues);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const buttonText = `${buttonPrefixText || ''}${radioValuesToTitles[radioValue]}${numChecked === -1 ? '' : ` (${numChecked})`}`;
    return (jsxs(FormControl, Object.assign({ "data-testid": dataTestId }, { children: [buttonType === 'button' && (jsx(ButtonContainer, { dataTestid: "toggle-popover-button", text: buttonText, type: "primary", onClick: handleDropdownClick, endIcon: open ? jsx(ArrowDropUpIcon, {}, void 0) : jsx(ArrowDropDownIcon$1, {}, void 0), id: "common-components-1786027373212-2" }, void 0)), buttonType === 'text' && (jsx(RadioMultiSelectText, { buttonPrefixText: buttonPrefixText, calcSelectedOptions: calcSelectedOptions, numChecked: numChecked, open: open, handleDropdownClick: handleDropdownClick, handleClear: handleClear }, void 0)), jsxs(Popover, Object.assign({ id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right'
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                }, marginThreshold: 0, className: classNames('radio-multi-select', {
                    'radio-multi-select-wide': isWide,
                    'radio-multi-select-not-wide': !isWide
                }) }, { children: [radioGroup.map(radioItem => {
                        var _a;
                        return [
                            radioGroup.length > 1 && (jsx(MenuItem, Object.assign({ "data-testid": radioItem.optionValue, value: radioItem.optionValue, onClick: () => setRadioValue(radioItem.optionValue) }, { children: jsx(FormControlLabel, { value: radioItem.optionValue, control: jsx(Radio, { color: color, className: "common-components-1786027374316-2" }, void 0), label: radioItem.title, checked: radioValue === radioItem.optionValue, className: "common-components-1786027373962-10" }, void 0) }), `radio-${radioItem.optionValue}`)),
                            radioItem.checkboxGroup ? (jsx(MenuItem, Object.assign({ disabled: radioItem.optionValue !== radioValue, value: "search-bar", "data-testid": "checkbox-search" }, { children: jsx(SimpleSearch, { value: searchString, onChange: onSearchChange, placeholder: translate('FreeTextSearch') }, void 0) }), "search-bar")) : (jsx(Fragment$1, {}, void 0)),
                            radioItem.checkboxGroup ? (jsx("div", Object.assign({ className: "checkbox-container common-components-1786027374634-5" }, { children: (_a = radioItem.checkboxGroup) === null || _a === void 0 ? void 0 : _a.map((checkboxItem, checkboxItemIndex) => {
                                    const isCheckboxItemSelected = checkboxValues[radioItem.optionValue][checkboxItem.optionValue];
                                    let checkboxType;
                                    if (color === 'secondary') {
                                        checkboxType = isCheckboxItemSelected ? 'selectedDefault' : 'unSelected';
                                    }
                                    return checkboxItem.title
                                        .toLowerCase()
                                        .includes(searchString.toLowerCase()) ? (jsx(MenuItem, Object.assign({ "data-testid": `checkbox-${checkboxItem.optionValue}`, value: checkboxItem.optionValue, disabled: radioItem.optionValue !== radioValue, onClick: () => handleCheckboxClick(radioItem, checkboxItem) }, { children: jsx(MultiSelectItem, { title: checkboxItem.title, isSelected: isCheckboxItemSelected, type: checkboxType, className: classNames({ 'not-wide-checkbox': !isWide }, 'common-components-1786027374929-9') }, checkboxItemIndex) }), `checkbox-${checkboxItem.optionValue} `)) : (jsx(Fragment$1, {}, void 0));
                                }) }), "checkbox-container")) : (jsx(Fragment$1, {}, void 0))
                        ];
                    }), jsxs("div", Object.assign({ className: "footer-buttons", id: "common-components-1786027374937-2" }, { children: [jsx(ButtonContainer, { className: "reset-button", text: resetText, type: "textFlat", onClick: handleReset, dataTestid: "reset-button", id: "common-components-1786027374974-3" }, void 0), jsx(ButtonContainer, { className: "apply-button", text: applyText, onClick: handleClose, type: color === 'secondary' ? 'secondaryFlat' : undefined, id: "common-components-1786027375007-9" }, void 0)] }), void 0)] }), void 0)] }), void 0));
};

const useIframeFunctions = ({ parentRoute, styles, title }) => {
    useEffect(() => {
        lib$1.onIframeMount({ parentRoute, styles, title });
        return () => {
            lib$1.onIframeUnmount();
        };
    }, [parentRoute, styles]);
};

var css_248z$O = ".notification-module_class-ellipsis-2-lines__o-K6R,.notification-module_class-ellipsis-lines__rXqNr{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.notification-module_class-ellipsis-2-lines__o-K6R{-webkit-line-clamp:2!important;max-height:4rem!important}.notification-module_MuiChip-root__eXg8S{margin:.5rem .3rem .5rem .5rem}.notification-module_ellipse-chip__j5BAz.notification-module_MuiChip-root__eXg8S{border-radius:1rem;height:20px}.notification-module_ellipse-chip__j5BAz.notification-module_MuiChip-root__eXg8S .notification-module_MuiChip-label__jWHMO{padding-left:8px;padding-right:8px}.notification-module_square-chip__FyCkL.notification-module_MuiChip-root__eXg8S{border-radius:0!important}.notification-module_class-width-height-100__PihNx{height:100%;width:100%}.notification-module_MuiTooltip-tooltip__Ve7MN{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.notification-module_MuiTooltip-arrow__nmgJP{color:#fff!important}.notification-module_class-font-size-icon__z-JN8{font-size:1.25rem}.notification-module_notification-container__r0j-Z{align-items:center;background-color:rgba(52,50,58,.851);border:1px solid #f36a22;border-radius:3px;color:#fff;display:flex;font-family:OpenSans;justify-content:space-between;padding:1rem;position:absolute;top:var(--top)!important;width:45rem;z-index:1}.notification-module_notification-container__r0j-Z .notification-module_notification-text__ZGjK-{font-weight:700;width:30rem}.notification-module_notification-container__r0j-Z .notification-module_notification-actions__mCNyl{align-items:center;display:flex;justify-content:space-between}.notification-module_notification-container__r0j-Z .notification-module_notification-actions__mCNyl .notification-module_notification-button__3igRA{height:2rem;padding:1rem}.notification-module_notification-container__r0j-Z .notification-module_notification-actions__mCNyl .notification-module_notification-button__3igRA svg{height:1.5rem;width:1.5rem}.notification-module_notification-container__r0j-Z .notification-module_notification-actions__mCNyl .notification-module_notification-close-icon__rPXIf{cursor:pointer;margin-left:1rem}.notification-module_notification-container__r0j-Z .notification-module_notification-actions__mCNyl .notification-module_notification-close-icon__rPXIf:hover{fill:#f36a22}";
var styles$C = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"notification-module_class-ellipsis-lines__rXqNr","class-ellipsis-2-lines":"notification-module_class-ellipsis-2-lines__o-K6R","MuiChip-root":"notification-module_MuiChip-root__eXg8S","ellipse-chip":"notification-module_ellipse-chip__j5BAz","MuiChip-label":"notification-module_MuiChip-label__jWHMO","square-chip":"notification-module_square-chip__FyCkL","class-width-height-100":"notification-module_class-width-height-100__PihNx","MuiTooltip-tooltip":"notification-module_MuiTooltip-tooltip__Ve7MN","MuiTooltip-arrow":"notification-module_MuiTooltip-arrow__nmgJP","class-font-size-icon":"notification-module_class-font-size-icon__z-JN8","notification-container":"notification-module_notification-container__r0j-Z","notification-text":"notification-module_notification-text__ZGjK-","notification-actions":"notification-module_notification-actions__mCNyl","notification-button":"notification-module_notification-button__3igRA","notification-close-icon":"notification-module_notification-close-icon__rPXIf"};
styleInject(css_248z$O);

const Notification = (props) => {
    const { notificationText, undoButtonText, undoButtonOnClick, handleClose, topOffset = 0 } = props;
    return (jsxs("div", Object.assign({ className: styles$C['notification-container'], style: { '--top': `${topOffset}px` } }, { children: [jsx("div", Object.assign({ "data-testid": "notification-text", className: styles$C['notification-text'] }, { children: notificationText }), void 0), jsxs("div", Object.assign({ "data-testid": "notification-actions", className: styles$C['notification-actions'] }, { children: [undoButtonOnClick && (jsx(ButtonContainer, { dataTestid: "notification-button", type: "outlinedFlatGray", text: undoButtonText, onClick: undoButtonOnClick, className: styles$C['notification-button'], startIcon: jsx(Icon, { name: "carbonUndo", dataTestid: "notification-undo-icon" }, void 0) }, void 0)), jsx(CloseIcon, { "data-testid": "notification-close-icon", onClick: () => handleClose(), className: styles$C['notification-close-icon'] }, void 0)] }), void 0)] }), void 0));
};

var css_248z$N = ".snackbar-module_alert-container__qxcDL{position:absolute;top:var(--top)!important;z-index:1}";
var styles$B = {"alert-container":"snackbar-module_alert-container__qxcDL"};
styleInject(css_248z$N);

const statusColor$1 = {
    success: { color: '#4DBB40', borderColor: '#4DBB40', bgColor: 'rgba(255, 255, 255, 0.1)' },
    error: { color: '#F1605D', borderColor: '#F1605D', bgColor: 'rgba(241, 96, 93, 0.5)' },
    information: { color: '#90C9FF', borderColor: '#90C9FF', bgColor: 'rgba(255, 255, 255, 0.1)' },
    almostTransparent: { color: '#fff', borderColor: '#afa4ba', bgColor: 'rgba(255, 255, 255, 0.1)' }
};

var css_248z$M = ".learningPanelNotification-module_class-ellipsis-2-lines__VGo9a,.learningPanelNotification-module_class-ellipsis-lines__sbsKm{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.learningPanelNotification-module_class-ellipsis-2-lines__VGo9a{-webkit-line-clamp:2!important;max-height:4rem!important}.learningPanelNotification-module_MuiChip-root__-3nME{margin:.5rem .3rem .5rem .5rem}.learningPanelNotification-module_ellipse-chip__pwFbj.learningPanelNotification-module_MuiChip-root__-3nME{border-radius:1rem;height:20px}.learningPanelNotification-module_ellipse-chip__pwFbj.learningPanelNotification-module_MuiChip-root__-3nME .learningPanelNotification-module_MuiChip-label__pF4x3{padding-left:8px;padding-right:8px}.learningPanelNotification-module_square-chip__ap-HL.learningPanelNotification-module_MuiChip-root__-3nME{border-radius:0!important}.learningPanelNotification-module_class-width-height-100__BiYav{height:100%;width:100%}.learningPanelNotification-module_MuiTooltip-tooltip__urGei{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.learningPanelNotification-module_MuiTooltip-arrow__2Z-6n{color:#fff!important}.learningPanelNotification-module_class-font-size-icon__olCgC{font-size:1.25rem}.learningPanelNotification-module_clicked-text__172-L,.learningPanelNotification-module_input-title__T6XKV,.learningPanelNotification-module_normal-text__oUpqY{color:#fff;font-size:.8125rem;opacity:.7}.learningPanelNotification-module_input-title__T6XKV{font-weight:500;opacity:1!important}.learningPanelNotification-module_page-title__Aq8vc{color:hsla(0,0%,100%,.7);font-weight:700}.learningPanelNotification-module_button-text__o-bfo{color:hsla(0,0%,100%,.7)!important;font-size:1.125rem!important;font-weight:600!important}.learningPanelNotification-module_retake-text__ihItQ{color:#fff!important;font-size:1.125rem!important;font-weight:700!important}.learningPanelNotification-module_title-text__qukZU{color:hsla(0,0%,100%,.7)!important;font-size:1.125rem!important;font-weight:400!important}.learningPanelNotification-module_sub-title__EvODi{color:#fff;font-size:1rem;font-weight:400;opacity:.7}.learningPanelNotification-module_date-title__g-f0r{color:hsla(0,0%,100%,.5);font-size:1rem;font-weight:400}.learningPanelNotification-module_page-title__Aq8vc{color:#fff;font-size:1.5rem;font-weight:500;opacity:.7}.learningPanelNotification-module_notification-content__8JqyV{color:#fff;font-size:1rem;font-weight:600;opacity:.9}.learningPanelNotification-module_clicked-text__172-L{font-weight:500}.learningPanelNotification-module_clicked-text__172-L:hover{opacity:1!important}.learningPanelNotification-module_clicked-text__172-L:focus{opacity:.5!important}.learningPanelNotification-module_class-ellipsis__b8JZs{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.learningPanelNotification-module_notification-container-full-width__IbKOw{height:2rem!important;width:100%!important}.learningPanelNotification-module_notification-container__IbzUY{align-items:center;background:var(--bgColor);border:1px solid var(--borderColor);border-radius:3px;color:var(--color);display:flex;font-family:OpenSans;height:max-content;justify-content:space-between;padding:.5rem 1rem;width:22.5rem;z-index:1}.learningPanelNotification-module_notification-container__IbzUY .learningPanelNotification-module_notification-close-icon__4-FQ6{background:#230c2e;border:.5px solid var(--color);border-radius:50%;box-shadow:0 4px 4px rgba(0,0,0,.25);cursor:pointer;height:1.3rem;left:-.75rem;padding:.2rem;position:absolute;top:-.75rem;visibility:visible;visibility:hidden;width:1.3rem}.learningPanelNotification-module_notification-container__IbzUY .learningPanelNotification-module_icon__XpTI0{align-items:center;color:var(--color);display:flex;margin-left:.5rem;margin-right:1.5rem}.learningPanelNotification-module_notification-container__IbzUY:hover .learningPanelNotification-module_notification-close-icon__4-FQ6{animation:learningPanelNotification-module_fade__-69Gl .5s linear;opacity:1;visibility:visible}.learningPanelNotification-module_notification-container__IbzUY .learningPanelNotification-module_notification-text__ylTbE{font-weight:700;height:max-content;white-space:pre-wrap;width:20rem}.learningPanelNotification-module_notification-container__IbzUY .learningPanelNotification-module_notification-full-width-text__C8P-V{width:100%}@keyframes learningPanelNotification-module_fade__-69Gl{0%{opacity:0}50%{opacity:1}}";
var styles$A = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"learningPanelNotification-module_class-ellipsis-lines__sbsKm","class-ellipsis-2-lines":"learningPanelNotification-module_class-ellipsis-2-lines__VGo9a","MuiChip-root":"learningPanelNotification-module_MuiChip-root__-3nME","ellipse-chip":"learningPanelNotification-module_ellipse-chip__pwFbj","MuiChip-label":"learningPanelNotification-module_MuiChip-label__pF4x3","square-chip":"learningPanelNotification-module_square-chip__ap-HL","class-width-height-100":"learningPanelNotification-module_class-width-height-100__BiYav","MuiTooltip-tooltip":"learningPanelNotification-module_MuiTooltip-tooltip__urGei","MuiTooltip-arrow":"learningPanelNotification-module_MuiTooltip-arrow__2Z-6n","class-font-size-icon":"learningPanelNotification-module_class-font-size-icon__olCgC","normal-text":"learningPanelNotification-module_normal-text__oUpqY","clicked-text":"learningPanelNotification-module_clicked-text__172-L","input-title":"learningPanelNotification-module_input-title__T6XKV","page-title":"learningPanelNotification-module_page-title__Aq8vc","button-text":"learningPanelNotification-module_button-text__o-bfo","retake-text":"learningPanelNotification-module_retake-text__ihItQ","title-text":"learningPanelNotification-module_title-text__qukZU","sub-title":"learningPanelNotification-module_sub-title__EvODi","date-title":"learningPanelNotification-module_date-title__g-f0r","notification-content":"learningPanelNotification-module_notification-content__8JqyV","class-ellipsis":"learningPanelNotification-module_class-ellipsis__b8JZs","notification-container-full-width":"learningPanelNotification-module_notification-container-full-width__IbKOw","notification-container":"learningPanelNotification-module_notification-container__IbzUY","notification-close-icon":"learningPanelNotification-module_notification-close-icon__4-FQ6","icon":"learningPanelNotification-module_icon__XpTI0","fade":"learningPanelNotification-module_fade__-69Gl","notification-text":"learningPanelNotification-module_notification-text__ylTbE","notification-full-width-text":"learningPanelNotification-module_notification-full-width-text__C8P-V"};
styleInject(css_248z$M);

const LearningPanelNotification = (props) => {
    const { notificationText, handleClose, variant, hasClose = true, fullWidth, id } = props;
    return (jsxs("div", Object.assign({ title: notificationText, id: id, className: classNames(styles$A['notification-container'], {
            [styles$A['notification-container-full-width']]: fullWidth
        }), style: {
            '--color': `${statusColor$1[variant].color}`,
            '--borderColor': `${statusColor$1[variant].borderColor}`,
            '--bgColor': `${statusColor$1[variant].bgColor}`
        }, "data-testid": "notification" }, { children: [jsx("div", Object.assign({ "data-testid": "notification-icon" }, { children: variant === 'error' ? (jsx(ErrorOutlinedIcon, { className: styles$A.icon, "data-testid": "notification-error-icon", fontSize: "medium" }, void 0)) : (jsx(CheckIcon, { className: styles$A.icon, "data-testid": "notification-check-icon", fontSize: "medium" }, void 0)) }), void 0), jsx("div", Object.assign({ "data-testid": "notification-text", className: classNames(styles$A['notification-text'], {
                    [styles$A['notification-full-width-text']]: fullWidth
                }) }, { children: notificationText }), void 0), hasClose && (jsx(CloseIcon, { "data-testid": "notification-close-icon", onClick: () => handleClose(), className: styles$A['notification-close-icon'], fontSize: "small" }, void 0))] }), void 0));
};

const statusColor = {
    success: { color: '#62D382' },
    error: { color: '#FF6593' },
    information: { color: '#90C9FF' }
};

var css_248z$L = ".adminPanelNotification-module_class-ellipsis-2-lines__xvJ9Q,.adminPanelNotification-module_class-ellipsis-lines__pp3j4{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.adminPanelNotification-module_class-ellipsis-2-lines__xvJ9Q{-webkit-line-clamp:2!important;max-height:4rem!important}.adminPanelNotification-module_MuiChip-root__OT2Nk{margin:.5rem .3rem .5rem .5rem}.adminPanelNotification-module_ellipse-chip__MC8wK.adminPanelNotification-module_MuiChip-root__OT2Nk{border-radius:1rem;height:20px}.adminPanelNotification-module_ellipse-chip__MC8wK.adminPanelNotification-module_MuiChip-root__OT2Nk .adminPanelNotification-module_MuiChip-label__yX6ba{padding-left:8px;padding-right:8px}.adminPanelNotification-module_square-chip__sGDlT.adminPanelNotification-module_MuiChip-root__OT2Nk{border-radius:0!important}.adminPanelNotification-module_class-width-height-100__DnyWo{height:100%;width:100%}.adminPanelNotification-module_MuiTooltip-tooltip__L4uTd{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.adminPanelNotification-module_MuiTooltip-arrow__-tKtQ{color:#fff!important}.adminPanelNotification-module_class-font-size-icon__904ZS{font-size:1.25rem}.adminPanelNotification-module_clicked-text__7FvVO,.adminPanelNotification-module_input-title__CbAav,.adminPanelNotification-module_normal-text__Z64LP{color:#fff;font-size:.8125rem;opacity:.7}.adminPanelNotification-module_input-title__CbAav{font-weight:500;opacity:1!important}.adminPanelNotification-module_page-title__b3pSX{color:hsla(0,0%,100%,.7);font-weight:700}.adminPanelNotification-module_button-text__ry1oB{color:hsla(0,0%,100%,.7)!important;font-size:1.125rem!important;font-weight:600!important}.adminPanelNotification-module_retake-text__Tx6PR{color:#fff!important;font-size:1.125rem!important;font-weight:700!important}.adminPanelNotification-module_title-text__CPmYn{color:hsla(0,0%,100%,.7)!important;font-size:1.125rem!important;font-weight:400!important}.adminPanelNotification-module_sub-title__GiM1g{color:#fff;font-size:1rem;font-weight:400;opacity:.7}.adminPanelNotification-module_date-title__FZAkm{color:hsla(0,0%,100%,.5);font-size:1rem;font-weight:400}.adminPanelNotification-module_page-title__b3pSX{color:#fff;font-size:1.5rem;font-weight:500;opacity:.7}.adminPanelNotification-module_notification-content__LY-uE{color:#fff;font-size:1rem;font-weight:600;opacity:.9}.adminPanelNotification-module_clicked-text__7FvVO{font-weight:500}.adminPanelNotification-module_clicked-text__7FvVO:hover{opacity:1!important}.adminPanelNotification-module_clicked-text__7FvVO:focus{opacity:.5!important}.adminPanelNotification-module_class-ellipsis__hlhy-{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.adminPanelNotification-module_notification-container-full-width__K-eWs{height:2rem!important;width:100%!important}.adminPanelNotification-module_admin-notification-container__TjbGJ{align-items:center;background:#141626;border:1px solid var(--color);border-radius:3px;border-radius:12px;color:#fff;display:flex;font-family:OpenSans;height:max-content;padding-right:1.5rem;width:max-content;z-index:1240}.adminPanelNotification-module_admin-notification-container__TjbGJ .adminPanelNotification-module_notification-close-icon__ETfnU{background:#141626;border:1.229px solid var(--color);border-radius:50%;box-shadow:0 4px 4px rgba(0,0,0,.25);cursor:pointer;height:1.3rem;left:-.6rem;padding:.2rem;position:absolute;top:-.6em;visibility:visible;visibility:hidden;width:1.3rem}.adminPanelNotification-module_admin-notification-container__TjbGJ .adminPanelNotification-module_notification-texts__mB1yr{display:flex;flex-direction:column;margin-bottom:.5rem;margin-top:.5rem}.adminPanelNotification-module_admin-notification-container__TjbGJ .adminPanelNotification-module_error-icon__-Es-C,.adminPanelNotification-module_admin-notification-container__TjbGJ .adminPanelNotification-module_icon__9zJtr{align-items:center;display:flex;margin-right:1.5rem}.adminPanelNotification-module_admin-notification-container__TjbGJ .adminPanelNotification-module_icon__9zJtr{margin-left:.5rem}.adminPanelNotification-module_admin-notification-container__TjbGJ:hover .adminPanelNotification-module_notification-close-icon__ETfnU{animation:adminPanelNotification-module_fade__F0g36 .5s linear;opacity:1;visibility:visible}.adminPanelNotification-module_admin-notification-container__TjbGJ .adminPanelNotification-module_notification-text__rfQgq{height:max-content;white-space:pre-wrap}.adminPanelNotification-module_admin-notification-container__TjbGJ .adminPanelNotification-module_notification-full-width-text__A779o{width:100%}.adminPanelNotification-module_admin-notification-container__TjbGJ .adminPanelNotification-module_notification-title__l8oAC{color:var(--color);font-weight:700;height:max-content;white-space:pre-wrap}.adminPanelNotification-module_admin-notification-container__TjbGJ .adminPanelNotification-module_notification-full-width-title__93eQC{width:100%}@keyframes adminPanelNotification-module_fade__F0g36{0%{opacity:0}50%{opacity:1}}";
var styles$z = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"adminPanelNotification-module_class-ellipsis-lines__pp3j4","class-ellipsis-2-lines":"adminPanelNotification-module_class-ellipsis-2-lines__xvJ9Q","MuiChip-root":"adminPanelNotification-module_MuiChip-root__OT2Nk","ellipse-chip":"adminPanelNotification-module_ellipse-chip__MC8wK","MuiChip-label":"adminPanelNotification-module_MuiChip-label__yX6ba","square-chip":"adminPanelNotification-module_square-chip__sGDlT","class-width-height-100":"adminPanelNotification-module_class-width-height-100__DnyWo","MuiTooltip-tooltip":"adminPanelNotification-module_MuiTooltip-tooltip__L4uTd","MuiTooltip-arrow":"adminPanelNotification-module_MuiTooltip-arrow__-tKtQ","class-font-size-icon":"adminPanelNotification-module_class-font-size-icon__904ZS","normal-text":"adminPanelNotification-module_normal-text__Z64LP","clicked-text":"adminPanelNotification-module_clicked-text__7FvVO","input-title":"adminPanelNotification-module_input-title__CbAav","page-title":"adminPanelNotification-module_page-title__b3pSX","button-text":"adminPanelNotification-module_button-text__ry1oB","retake-text":"adminPanelNotification-module_retake-text__Tx6PR","title-text":"adminPanelNotification-module_title-text__CPmYn","sub-title":"adminPanelNotification-module_sub-title__GiM1g","date-title":"adminPanelNotification-module_date-title__FZAkm","notification-content":"adminPanelNotification-module_notification-content__LY-uE","class-ellipsis":"adminPanelNotification-module_class-ellipsis__hlhy-","notification-container-full-width":"adminPanelNotification-module_notification-container-full-width__K-eWs","admin-notification-container":"adminPanelNotification-module_admin-notification-container__TjbGJ","notification-close-icon":"adminPanelNotification-module_notification-close-icon__ETfnU","notification-texts":"adminPanelNotification-module_notification-texts__mB1yr","icon":"adminPanelNotification-module_icon__9zJtr","error-icon":"adminPanelNotification-module_error-icon__-Es-C","fade":"adminPanelNotification-module_fade__F0g36","notification-text":"adminPanelNotification-module_notification-text__rfQgq","notification-full-width-text":"adminPanelNotification-module_notification-full-width-text__A779o","notification-title":"adminPanelNotification-module_notification-title__l8oAC","notification-full-width-title":"adminPanelNotification-module_notification-full-width-title__93eQC"};
styleInject(css_248z$L);

const AdminPanelNotification = (props) => {
    const { notificationText, handleClose, variant, hasClose = true, fullWidth, id, notificationTitle } = props;
    return (jsxs("div", Object.assign({ title: notificationText, id: id, className: classNames(styles$z['admin-notification-container'], {
            [styles$z['notification-container-full-width']]: fullWidth
        }), style: {
            '--color': `${statusColor[variant].color}`
        }, "data-testid": "notification" }, { children: [jsx("div", Object.assign({ "data-testid": "notification-icon" }, { children: variant === 'error' ? (jsx("img", { src: `${process.env.PUBLIC_URL}/images/errorNotificationIcon.svg`, alt: "error", className: styles$z['error-icon'] }, void 0)) : (jsx(Icon, { className: styles$z.icon, "data-testid": "notification-check-icon", name: "successIcon" }, "success")) }), void 0), jsxs("div", Object.assign({ className: styles$z['notification-texts'] }, { children: [jsx("div", Object.assign({ "data-testid": "notification-title", className: classNames(styles$z['notification-title'], {
                            [styles$z['notification-full-width-title']]: fullWidth
                        }) }, { children: notificationTitle }), void 0), jsx("div", Object.assign({ "data-testid": "notification-text", className: classNames(styles$z['notification-text'], {
                            [styles$z['notification-full-width-text']]: fullWidth
                        }) }, { children: notificationText }), void 0)] }), void 0), hasClose && (jsx(CloseIcon, { "data-testid": "notification-close-icon", onClick: () => handleClose(), className: styles$z['notification-close-icon'], fontSize: "small" }, void 0))] }), void 0));
};

const Snackbar = (props) => {
    const { variant, message, title, isOpen, onClose, autoHideDuration = null, anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'left'
    }, isInIframe = false, undoButtonText, undoButtonOnClick, topOffset, subVariant } = props;
    const isInIframeStyle = {
        position: 'absolute',
        top: 0,
        zIndex: 20,
        width: 'max-content'
    };
    const style = isInIframe ? isInIframeStyle : {};
    const transitionComponent = (props) => {
        return jsx(Slide, Object.assign({}, props, { direction: "right", style: style }), void 0);
    };
    return (jsx(Snackbar$1, Object.assign({ anchorOrigin: anchorOrigin, open: isOpen, autoHideDuration: autoHideDuration, onClose: (_) => onClose(), TransitionComponent: transitionComponent, style: style }, { children: variant === 'notificationAction' ? (jsx("div", { children: jsx(Notification, { notificationText: message, undoButtonText: undoButtonText, undoButtonOnClick: undoButtonOnClick
                    ? () => {
                        onClose();
                        undoButtonOnClick === null || undoButtonOnClick === void 0 ? void 0 : undoButtonOnClick();
                    }
                    : undefined, handleClose: onClose, topOffset: topOffset }, void 0) }, void 0)) : variant === 'learningPanelNotification' ? (jsx("div", { children: jsx(LearningPanelNotification, { notificationText: message, handleClose: onClose, variant: subVariant || 'success' }, void 0) }, void 0)) : variant === 'adminPanelNotification' ? (jsx("div", { children: jsx(AdminPanelNotification, { notificationText: message, handleClose: onClose, variant: subVariant || 'success', notificationTitle: title }, void 0) }, void 0)) : (jsx(Alert$1, Object.assign({ onClose: (_) => onClose(), severity: variant, color: variant, className: styles$B['alert-container'], style: { '--top': `${topOffset}px` } }, { children: message }), void 0)) }), void 0));
};

var SnackBarStatuses;
(function (SnackBarStatuses) {
    SnackBarStatuses[SnackBarStatuses["success"] = 0] = "success";
    SnackBarStatuses[SnackBarStatuses["info"] = 1] = "info";
    SnackBarStatuses[SnackBarStatuses["warning"] = 2] = "warning";
    SnackBarStatuses[SnackBarStatuses["error"] = 3] = "error";
    SnackBarStatuses[SnackBarStatuses["notificationAction"] = 4] = "notificationAction";
    SnackBarStatuses[SnackBarStatuses["learningPanelNotification"] = 5] = "learningPanelNotification";
    SnackBarStatuses[SnackBarStatuses["adminPanelNotification"] = 6] = "adminPanelNotification";
})(SnackBarStatuses || (SnackBarStatuses = {}));
var SnackBarSubVariant;
(function (SnackBarSubVariant) {
    SnackBarSubVariant[SnackBarSubVariant["success"] = 0] = "success";
    SnackBarSubVariant[SnackBarSubVariant["info"] = 1] = "info";
    SnackBarSubVariant[SnackBarSubVariant["error"] = 2] = "error";
})(SnackBarSubVariant || (SnackBarSubVariant = {}));
const informationDefaultValue = {
    variant: 'success',
    message: '',
    title: '',
    isOpen: false,
    isAdmin: false,
    isInIframe: true,
    useTopOffset: false,
    showAccountSettings: false,
    actions: {
        showAlert: () => undefined,
        onClose: () => undefined,
        resetAlert: () => undefined
    }
};

var css_248z$K = ".data-grid-wrapper .data-grid{font-size:1rem!important;min-height:20vh}.data-grid-wrapper .data-grid .custom-header,.data-grid-wrapper .data-grid .MuiDataGrid-columnHeaderTitle{font-weight:700}.data-grid-wrapper .MuiPaper-elevation1{box-shadow:none!important}.data-grid-wrapper .MuiCardContent-root{display:flex;flex-direction:column}.data-grid-wrapper .MuiPaper-root{height:100%}.data-grid-wrapper .table-loading{align-items:center;display:flex;justify-content:center}.data-grid-wrapper .table-loading .MuiCardContent-root{align-items:center;display:flex}";
styleInject(css_248z$K);

const DataGridWrapper = (props) => {
    const { isLoading, dataGridData } = props;
    return (jsxs("div", Object.assign({ className: classNames({ 'data-grid-wrapper-loading': isLoading }, 'data-grid-wrapper'), "data-testid": "data-grid-wrapper" }, { children: [isLoading && jsx(Message, { type: "loader", "data-testid": "loader" }, void 0), !isLoading && jsx(_s, Object.assign({}, dataGridData, { className: classNames('data-grid', dataGridData.className) }), void 0)] }), void 0));
};

var css_248z$J = ".data-grid-search-wrapper{width:100%}.data-grid-search-wrapper .data-grid-simple-search{height:3rem;width:100%}";
styleInject(css_248z$J);

const DataGridSearch = (props) => {
    const { isLoading, dataGridData, simpleSearchData } = props;
    return (jsxs("div", Object.assign({ className: "data-grid-search-wrapper", "data-testid": "data-grid-search-wrapper" }, { children: [jsx(SimpleSearch, Object.assign({ className: "data-grid-simple-search", dataTestid: "data-grid-simple-search" }, simpleSearchData), void 0), jsx(DataGridWrapper, { isLoading: isLoading, dataGridData: dataGridData }, void 0)] }), void 0));
};

const DiffCodeEditor = ({ codeLeft, codeRight, language }) => {
    return (jsx(index$2, { language: language, theme: "vs-dark", original: codeLeft, modified: codeRight, loading: jsx(Message, { type: "loader", pinkLoader: true }, void 0), options: {
            readOnly: true,
            padding: { top: 8 },
            automaticLayout: true,
            selectOnLineNumbers: true,
            wordWrap: 'on',
            smoothScrolling: true
        } }, void 0));
};

const useStyles$c = makeStyles$1(() => ({
    highlightLines: {
        backgroundColor: '#52493287'
    }
}));
const NewCodeEditor = ({ code, language, highlightLines }) => {
    const classes = useStyles$c();
    const editor = useRef();
    const monaco = useRef();
    const [isEditorReady, setIsEditorReady] = useState(false);
    const [, setDecorators] = useState([]);
    useEffect(() => {
        const setHighlightLines = () => {
            if (isEditorReady) {
                const newDecorations = [];
                highlightLines.forEach(line => {
                    newDecorations.push({
                        range: new monaco.current.Range(line + 1, 0, line + 1, 1),
                        options: {
                            className: classes.highlightLines,
                            isWholeLine: true
                        }
                    });
                });
                setDecorators(prevDecorators => editor.current.deltaDecorations(prevDecorators, newDecorations));
            }
        };
        setHighlightLines();
    }, [highlightLines, classes, isEditorReady]);
    const editorDidMount = (monacoEditor, monacoModule) => {
        editor.current = monacoEditor;
        monaco.current = monacoModule;
        setIsEditorReady(true);
    };
    return (jsx("div", Object.assign({ className: "notranslate class-width-height-100" }, { children: jsx(index$1, { language: language, theme: "vs-dark", value: code, onMount: editorDidMount, loading: jsx(Message, { type: "loader", pinkLoader: true }, void 0), options: {
                readOnly: true,
                minimap: { enabled: false },
                padding: { top: 8 }
            } }, void 0) }), void 0));
};

var css_248z$I = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.possible-text-answer-wrapper{position:relative}.possible-text-answer-wrapper .user-selection{position:absolute;right:10px}.possible-text-answer-wrapper .user-selection-closer{position:absolute;right:22px;top:28px}.possible-text-answer-wrapper .user-selection-hovered{opacity:.7!important}.possible-text-answer-wrapper .answer-tooltip-title{opacity:1;padding:1rem}.possible-text-answer-wrapper .possible-text-answer{display:flex;margin-bottom:1rem;padding:0 3.5rem}.possible-text-answer-wrapper .possible-text-answer .hover-answer:hover{background:hsla(0,0%,100%,.3);color:#fff!important;cursor:pointer}.possible-text-answer-wrapper .possible-text-answer .selected-question{background:hsla(0,0%,100%,.3)!important;border-color:hsla(0,0%,100%,.3)!important;color:#fff!important}.possible-text-answer-wrapper .possible-text-answer .correct-answer{background:rgba(16,156,241,.1)!important;border:2px solid #109cf1!important}.possible-text-answer-wrapper .possible-text-answer .wrong-answer{background:rgba(242,84,127,.1)!important;border:1px solid #f2547f!important}.possible-text-answer-wrapper .possible-text-answer .correct-answer-quiz{background:rgba(63,202,135,.2)!important;border:2px solid #3fca87!important;border-radius:4px!important}.possible-text-answer-wrapper .possible-text-answer .wrong-answer-quiz{background:rgba(252,79,120,.2)!important;border:1px solid #fc4f78!important;border-radius:4px!important}.possible-text-answer-wrapper .possible-text-answer .answer{background:hsla(0,0%,100%,.1);border:1px solid hsla(0,0%,100%,.15);border-radius:4px;font-weight:700;transition:border .2s ease;width:100%}.possible-text-answer-wrapper .possible-text-answer .answer .body{display:flex}.possible-text-answer-wrapper .possible-text-answer .answer .body .not-selected-question{border-color:#485361!important}.possible-text-answer-wrapper .possible-text-answer .answer .body .icon{align-items:center;border-bottom-left-radius:5px!important;border-top-left-radius:5px!important;color:#fff;display:flex;font-weight:500}.possible-text-answer-wrapper .possible-text-answer .answer .body .icon span{font-size:1.0625rem}.possible-text-answer-wrapper .possible-text-answer .answer .body .show-results{padding-left:1.2rem;padding-right:1.2rem}.possible-text-answer-wrapper .possible-text-answer .answer .body .not-show-results{padding-left:1.9rem;padding-right:1.9rem}.possible-text-answer-wrapper .possible-text-answer .answer .body .not-half-screen{min-height:5rem}.possible-text-answer-wrapper .possible-text-answer .answer .body .content-wrapper{align-items:center;display:flex}.possible-text-answer-wrapper .possible-text-answer .answer .body .content-wrapper .answer-content{color:hsla(0,0%,100%,.8);font-size:1.375rem;font-weight:300;line-height:1.56;padding:1rem 1.5rem}";
styleInject(css_248z$I);

const PossibleTextAnswer = (props) => {
    const { answerText, answerIndex, isQuestionSubmitted, showResults, onSelectAnswer, isAnswerSelected, status, halfScreen, isQuiz, selectQuestionComponent } = props;
    const [isHovered, setIsHovered] = useState(false);
    const isSelectedStatus = isAnswerSelected ? 'selected' : 'unselected';
    const renderIcon = () => {
        return String.fromCharCode(answerIndex + 65);
    };
    return (jsxs("div", Object.assign({ className: "possible-text-answer-wrapper" }, { children: [(isAnswerSelected || (isHovered && !showResults && !isQuestionSubmitted)) &&
                (selectQuestionComponent ? (jsx("div", Object.assign({ className: classNames('user-selection-closer', {
                        'user-selection-hovered': isHovered && !isAnswerSelected
                    }) }, { children: selectQuestionComponent }), void 0)) : (jsx(Icon, { name: "userSelection", className: classNames('user-selection', {
                        'user-selection-hovered': isHovered && !isAnswerSelected
                    }) }, void 0))), jsx("div", Object.assign({ className: "possible-text-answer", onMouseOver: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false) }, { children: jsx("div", Object.assign({ className: classNames('answer', {
                        [`${isSelectedStatus}-question`]: !(showResults && isAnswerSelected),
                        [`${status}-answer`]: showResults && !isQuiz,
                        [`${status}-answer-quiz`]: showResults && isQuiz,
                        'hover-answer': !isQuestionSubmitted
                    }), onClick: () => !isQuestionSubmitted && onSelectAnswer(String(answerIndex + 1)), "data-testid": "answer-button" }, { children: jsx("div", Object.assign({ className: "body" }, { children: jsx("div", Object.assign({ className: classNames('content-wrapper', { 'not-half-screen': !halfScreen }), "data-testid": "content-wrapper" }, { children: jsx("div", Object.assign({ className: classNames('answer-content') }, { children: `${renderIcon()}. ${answerText}` }), void 0) }), void 0) }), void 0) }), answerIndex) }), answerIndex)] }), void 0));
};

var css_248z$H = ".points-module_points-wrapper__u8hDm{align-items:center;color:#f7f9a8;display:flex;font-weight:700;justify-content:center;margin-left:1rem}.points-module_points-wrapper__u8hDm .points-module_points__rpo-3{margin-left:.6rem}.points-module_points-wrapper__u8hDm .points-module_earned-text__4yjbM{margin-right:.6rem}.points-module_points-wrapper__u8hDm .points-module_tooltip-icon__HVrrU{margin-left:.4rem}.points-module_points-wrapper__u8hDm .points-module_disabled__T5b5Y{opacity:.5}.points-module_no-points-tooltip-text__g71mc{color:#fff}";
var styles$y = {"points-wrapper":"points-module_points-wrapper__u8hDm","points":"points-module_points__rpo-3","earned-text":"points-module_earned-text__4yjbM","tooltip-icon":"points-module_tooltip-icon__HVrrU","disabled":"points-module_disabled__T5b5Y","no-points-tooltip-text":"points-module_no-points-tooltip-text__g71mc"};
styleInject(css_248z$H);

const Points = (props) => {
    const { points } = props;
    return points ? (jsxs("div", Object.assign({ className: styles$y['points-wrapper'] }, { children: [jsx(Icon, { style: { height: '100%' }, name: "trophy", isPng: true }, void 0), jsx("div", Object.assign({ className: styles$y.points }, { children: points }), void 0)] }), void 0)) : null;
};

const NoPointsTooltip = (props) => {
    const { lessonPointsEarned } = props;
    const { translate } = useTranslationContext();
    return (jsxs("div", Object.assign({ className: styles$y['points-wrapper'] }, { children: [jsx("div", Object.assign({ className: styles$y['earned-text'] }, { children: translate('Earned') }), void 0), jsx(Icon, { style: { height: '100%' }, className: styles$y.disabled, name: "trophy", isPng: true }, void 0), jsx("div", Object.assign({ className: classNames(styles$y.points, styles$y.disabled) }, { children: lessonPointsEarned }), void 0), jsx(TooltipContainer, Object.assign({ hasBorder: true, unsetMaxWidth: true, hasDefaultStyle: true, titleClassName: styles$y['no-points-tooltip-text'], title: translate('NoCoins6Months'), borderColor: "#f178ae", backgroundColor: "black" }, { children: jsx(ErrorOutlineRoundedIcon, { className: styles$y['tooltip-icon'], fontSize: "small" }, void 0) }), void 0)] }), void 0));
};

var css_248z$G = ".questionTitle-module_class-ellipsis-2-lines__Q-FCF,.questionTitle-module_class-ellipsis-lines__yhreu{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.questionTitle-module_class-ellipsis-2-lines__Q-FCF{-webkit-line-clamp:2!important;max-height:4rem!important}.questionTitle-module_MuiChip-root__D-ooR{margin:.5rem .3rem .5rem .5rem}.questionTitle-module_ellipse-chip__3LxYS.questionTitle-module_MuiChip-root__D-ooR{border-radius:1rem;height:20px}.questionTitle-module_ellipse-chip__3LxYS.questionTitle-module_MuiChip-root__D-ooR .questionTitle-module_MuiChip-label__JCyB3{padding-left:8px;padding-right:8px}.questionTitle-module_square-chip__CIkLj.questionTitle-module_MuiChip-root__D-ooR{border-radius:0!important}.questionTitle-module_class-width-height-100__kKQ-0{height:100%;width:100%}.questionTitle-module_MuiTooltip-tooltip__wZOwx{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.questionTitle-module_MuiTooltip-arrow__AiuWK{color:#fff!important}.questionTitle-module_class-font-size-icon__ArpV6{font-size:1.25rem}.questionTitle-module_question-title__OWkR0 .questionTitle-module_title-wrapper__MzSX5{align-items:center;display:flex;justify-content:space-between}.questionTitle-module_question-title__OWkR0 .questionTitle-module_title-wrapper__MzSX5 .questionTitle-module_test-your-knowledge__nCkw-{color:#f178ae;font-size:1.25rem;font-weight:500;padding-bottom:.5rem}.questionTitle-module_question-title__OWkR0 .questionTitle-module_title-wrapper__MzSX5 .questionTitle-module_title__jGWS3{color:var(--titleColor);font-size:1.5rem;font-weight:700;line-height:1.3;overflow-wrap:break-word;padding-top:.1rem}.questionTitle-module_question-title__OWkR0 .questionTitle-module_subtitle__0biyr{color:#f178ae;font-size:1.25rem;font-weight:500;padding-top:.5rem}";
var styles$x = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"questionTitle-module_class-ellipsis-lines__yhreu","class-ellipsis-2-lines":"questionTitle-module_class-ellipsis-2-lines__Q-FCF","MuiChip-root":"questionTitle-module_MuiChip-root__D-ooR","ellipse-chip":"questionTitle-module_ellipse-chip__3LxYS","MuiChip-label":"questionTitle-module_MuiChip-label__JCyB3","square-chip":"questionTitle-module_square-chip__CIkLj","class-width-height-100":"questionTitle-module_class-width-height-100__kKQ-0","MuiTooltip-tooltip":"questionTitle-module_MuiTooltip-tooltip__wZOwx","MuiTooltip-arrow":"questionTitle-module_MuiTooltip-arrow__AiuWK","class-font-size-icon":"questionTitle-module_class-font-size-icon__ArpV6","question-title":"questionTitle-module_question-title__OWkR0","title-wrapper":"questionTitle-module_title-wrapper__MzSX5","test-your-knowledge":"questionTitle-module_test-your-knowledge__nCkw-","title":"questionTitle-module_title__jGWS3","subtitle":"questionTitle-module_subtitle__0biyr"};
styleInject(css_248z$G);

const QuestionTitle = (props) => {
    const { title, titleColor = 'white', className, showAnswerType, answerTypeText, points, lessonPointsEarned, canEarnPoints, testYourKnowledge } = props;
    return (jsxs("div", Object.assign({ className: classNames(styles$x['question-title'], className) }, { children: [jsxs("div", Object.assign({ className: styles$x['title-wrapper'] }, { children: [jsxs("div", { children: [testYourKnowledge && jsx("div", Object.assign({ className: styles$x['test-your-knowledge'] }, { children: testYourKnowledge }), void 0), jsx("div", Object.assign({ className: styles$x.title, style: { '--titleColor': `${titleColor}` } }, { children: title }), "question")] }, void 0), canEarnPoints && jsx(Points, { points: points }, void 0), !canEarnPoints && lessonPointsEarned !== undefined && (jsx(NoPointsTooltip, { lessonPointsEarned: Number(lessonPointsEarned) }, void 0))] }), void 0), showAnswerType && (jsxs("div", Object.assign({ className: styles$x.subtitle }, { children: ["* ", answerTypeText] }), "text"))] }), void 0));
};

var css_248z$F = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.challenges{align-items:center;display:flex;flex-direction:column;font-family:OpenSans;height:100%;justify-content:center;width:100%}.challenges .challenges-content{background:#141626;box-shadow:0 0 200px hsla(0,0%,100%,.5);overflow-y:auto;width:var(--customWidth)}.challenges .challenges-content .description{background:hsla(0,0%,100%,.15);box-shadow:0 30px 40px rgba(0,0,0,.25);font-weight:600;padding:1.5rem 2.1rem;text-align:left}.challenges .challenges-content .bottom{padding:2rem 0}.challenges .challenges-content .bottom .content-answers{height:unset!important;max-height:30rem;min-width:62%;overflow:auto}.challenges .challenges-content .bottom .button-container{display:flex;justify-content:end;padding-right:3.5rem}.challenges .challenges-content .button-wrapper,.challenges .challenges-content .button-wrapper-half-screen{margin:1.5rem 0 0 2rem}.challenges .challenges-content .button-wrapper-half-screen .button,.challenges .challenges-content .button-wrapper .button{box-shadow:0 3px 7px 0 rgba(0,0,0,.43);font-size:1.375rem}.challenges .challenges-content .button-wrapper-half-screen .button-disabled,.challenges .challenges-content .button-wrapper .button-disabled{color:hsla(0,0%,100%,.459)!important}.challenges .challenges-content .button-wrapper-half-screen{height:6%;min-width:33%}.challenges .challenges-content .button-wrapper{height:7%;width:20%}";
styleInject(css_248z$F);

const MultiChoice = (props) => {
    const { currentQuestion, isQuestionSubmitted, onSubmit, withButton = true, halfScreen, showAnswerType = true, submitText, answerTypeText, customWidth, titleColor, lowerCase, isQuiz, isQuizNextDisabled, selectQuestionComponent } = props;
    const { type, correctAnswers, userAnswers, setUserAnswers, data: { answers } } = currentQuestion;
    const disableSubmit = !userAnswers.length || isQuestionSubmitted;
    const indexAsString = (index) => String(index + 1);
    const isIncludedInAnswers = (answersArray, index) => {
        return answersArray.indexOf(index) !== -1;
    };
    const onSelectAnswer = (selectedAnswerIndex) => {
        let answersSelected = [...userAnswers];
        const isAnswerSelected = isIncludedInAnswers(userAnswers, selectedAnswerIndex);
        const isSingleAnswerAndShouldReplace = type === 'single' && userAnswers.length > 0;
        if (isAnswerSelected) {
            answersSelected = userAnswers.filter(userAnswer => userAnswer !== selectedAnswerIndex);
        }
        else {
            if (isSingleAnswerAndShouldReplace) {
                answersSelected = [];
            }
            answersSelected.push(selectedAnswerIndex);
        }
        setUserAnswers(answersSelected);
    };
    const getButtonType = () => {
        if (isQuiz && correctAnswers.length) {
            return 'gradientNoBorder';
        }
        if (disableSubmit) {
            return 'gradientNoBorderDisabled';
        }
        return 'gradientNoBorder';
    };
    return (jsx("div", Object.assign({ className: "challenges", "data-testid": "challenges" }, { children: jsxs("div", Object.assign({ className: "challenges-content", style: { '--customWidth': `${customWidth}` } }, { children: [jsx(QuestionTitle, { className: "description", title: currentQuestion.description, answerTypeText: answerTypeText, showAnswerType: showAnswerType, titleColor: titleColor }, void 0), jsxs("div", Object.assign({ className: "bottom" }, { children: [jsx("div", Object.assign({ className: "content-answers" }, { children: answers.map((answerText, i) => {
                                return (jsx(PossibleTextAnswer, { answerText: answerText, answerIndex: i, onSelectAnswer: onSelectAnswer, showResults: Boolean(isQuestionSubmitted && correctAnswers.length), isQuestionSubmitted: isQuestionSubmitted, status: isIncludedInAnswers(correctAnswers, indexAsString(i)) ? 'correct' : 'wrong', isAnswerSelected: isIncludedInAnswers(userAnswers, indexAsString(i)), halfScreen: halfScreen, isQuiz: isQuiz, selectQuestionComponent: selectQuestionComponent }, i));
                            }) }), void 0), jsx("div", Object.assign({ className: "button-container" }, { children: jsx("div", Object.assign({ className: classNames({
                                    'button-wrapper': !halfScreen,
                                    'button-wrapper-half-screen': halfScreen
                                }), "data-testid": "button-wrapper" }, { children: withButton && (jsx(ButtonContainer, { dataTestid: "submit", text: submitText, className: classNames('button', {
                                        'button-disabled': isQuiz && correctAnswers.length ? isQuizNextDisabled : disableSubmit
                                    }), type: getButtonType(), style: { textTransform: isQuiz ? 'capitalize' : undefined }, onClick: onSubmit, lowerCase: lowerCase }, void 0)) }), void 0) }), void 0)] }), void 0)] }), void 0) }), void 0));
};

const TabPanel = (props) => {
    const { component, tabId, selectedTabId } = props;
    return (jsx("div", Object.assign({ role: "tabpanel", hidden: tabId !== selectedTabId, id: `wrapped-tabpanel-${tabId}` }, { children: tabId === selectedTabId && jsx("div", { children: component }, void 0) }), void 0));
};

var css_248z$E = ".tabsWrapper-module_class-ellipsis-2-lines__M4qA0,.tabsWrapper-module_class-ellipsis-lines__7LxHn{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.tabsWrapper-module_class-ellipsis-2-lines__M4qA0{-webkit-line-clamp:2!important;max-height:4rem!important}.tabsWrapper-module_MuiChip-root__r1zSX{margin:.5rem .3rem .5rem .5rem}.tabsWrapper-module_ellipse-chip__sWE49.tabsWrapper-module_MuiChip-root__r1zSX{border-radius:1rem;height:20px}.tabsWrapper-module_ellipse-chip__sWE49.tabsWrapper-module_MuiChip-root__r1zSX .tabsWrapper-module_MuiChip-label__bQeQg{padding-left:8px;padding-right:8px}.tabsWrapper-module_square-chip__yIUAY.tabsWrapper-module_MuiChip-root__r1zSX{border-radius:0!important}.tabsWrapper-module_class-width-height-100__ZkUdj{height:100%;width:100%}.tabsWrapper-module_MuiTooltip-tooltip__UQLwB{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.tabsWrapper-module_MuiTooltip-arrow__IVBDw{color:#fff!important}.tabsWrapper-module_class-font-size-icon__-pWZw{font-size:1.25rem}.tabsWrapper-module_tabs-wrapper-rounded__2cphv .MuiTabs-root{background-color:#fff;border-radius:30px;box-shadow:4px 4px 8px 0 hsla(0,0%,44%,.25);font-size:1rem!important;min-height:max-content!important;min-width:unset!important;overflow:visible;width:max-content!important}.tabsWrapper-module_tabs-wrapper-rounded__2cphv .MuiTab-root{min-height:unset!important;min-width:unset!important}.tabsWrapper-module_tabs-wrapper-rounded__2cphv .MuiTabs-flexContainer{align-items:center!important}.tabsWrapper-module_tabs-wrapper-rounded__2cphv .Mui-selected{background:#109cf1;border-radius:30px;color:#fff;font-weight:600;margin:.3rem}.tabsWrapper-module_tabs-wrapper-rounded__2cphv .MuiTabs-indicator{background-color:transparent!important}.tabsWrapper-module_tabs-wrapper-rounded__2cphv .MuiTabs-fixed{overflow-x:visible!important;overflow:visible!important}.tabsWrapper-module_tab-indictor-wrapper__HsL1t{height:100%;position:relative;width:100%}.tabsWrapper-module_tab-indictor-wrapper__HsL1t .tabsWrapper-module_indictor-wrapper__YxQEu{display:flex;font-size:.7rem;height:100%;justify-content:flex-end;position:absolute;right:-1.5rem;top:-.5rem;width:100%;z-index:1}.tabsWrapper-module_tab-indictor-wrapper__HsL1t .tabsWrapper-module_indictor-number__aQig9{align-items:center;background-color:#f36a22;border-radius:50%;color:#fff;display:flex;height:1rem;justify-content:center;text-align:center;width:1rem}.tabsWrapper-module_tab-indictor-wrapper__HsL1t .tabsWrapper-module_indictor-text__WxNV5{align-items:center;color:#f36a22;display:flex;height:1rem;justify-content:center;margin-left:.3rem}.tabsWrapper-module_tabs-wrapper__5pdW7 .MuiTabs-indicator{background-color:\"#635ee7\";max-width:40;width:\"100%\"}.tabsWrapper-module_tabs-wrapper__5pdW7 .MuiTabs-flexContainer{border-bottom:var(--borderBottomWidth) solid var(--borderBottomColor)!important;width:var(--borderBottomContainerWidth)!important}.tabsWrapper-module_tabs-learning-panel__90Krj{color:#fff;font-size:1rem}";
var styles$w = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"tabsWrapper-module_class-ellipsis-lines__7LxHn","class-ellipsis-2-lines":"tabsWrapper-module_class-ellipsis-2-lines__M4qA0","MuiChip-root":"tabsWrapper-module_MuiChip-root__r1zSX","ellipse-chip":"tabsWrapper-module_ellipse-chip__sWE49","MuiChip-label":"tabsWrapper-module_MuiChip-label__bQeQg","square-chip":"tabsWrapper-module_square-chip__yIUAY","class-width-height-100":"tabsWrapper-module_class-width-height-100__ZkUdj","MuiTooltip-tooltip":"tabsWrapper-module_MuiTooltip-tooltip__UQLwB","MuiTooltip-arrow":"tabsWrapper-module_MuiTooltip-arrow__IVBDw","class-font-size-icon":"tabsWrapper-module_class-font-size-icon__-pWZw","tabs-wrapper-rounded":"tabsWrapper-module_tabs-wrapper-rounded__2cphv","tab-indictor-wrapper":"tabsWrapper-module_tab-indictor-wrapper__HsL1t","indictor-wrapper":"tabsWrapper-module_indictor-wrapper__YxQEu","indictor-number":"tabsWrapper-module_indictor-number__aQig9","indictor-text":"tabsWrapper-module_indictor-text__WxNV5","tabs-wrapper":"tabsWrapper-module_tabs-wrapper__5pdW7","tabs-learning-panel":"tabsWrapper-module_tabs-learning-panel__90Krj"};
styleInject(css_248z$E);

const TabsWrapper = (props) => {
    var _a;
    const { data, underlineColor = '#2991f3', tabClasses, isRounded, selectedId, borderBottomColor = '', indicatorNumber, indicatorText, isLearningPanel, borderBottomWidth = '1px', borderBottomContainerWidth, underLineWidth = '100%' } = props;
    const [selectedTabId, setSelectedTabId] = useState(selectedId || ((_a = data[0]) === null || _a === void 0 ? void 0 : _a.id));
    const handleChange = (_event, newSelectedTabId) => {
        setSelectedTabId(newSelectedTabId);
        _event.stopPropagation();
    };
    useEffect(() => {
        selectedId && setSelectedTabId(selectedId);
    }, [selectedId]);
    const StyledTabs = withStyles({
        indicator: {
            display: 'flex',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            '& > span': {
                maxWidth: underLineWidth,
                width: '100%',
                backgroundColor: underlineColor
            }
        }
    })((props) => jsx(Tabs$1, Object.assign({}, props, { TabIndicatorProps: { children: jsx("span", {}, void 0) } }), void 0));
    return (jsxs("div", Object.assign({ className: classNames({
            [styles$w['tabs-wrapper-rounded']]: isRounded,
            [styles$w['tabs-wrapper']]: !isRounded,
            [styles$w['tabs-learning-panel']]: isLearningPanel
        }), style: {
            '--borderBottomColor': borderBottomColor,
            '--borderBottomWidth': borderBottomWidth,
            '--borderBottomContainerWidth': borderBottomContainerWidth
        } }, { children: [jsx(StyledTabs, Object.assign({ value: selectedTabId, onChange: handleChange, style: {
                    '--borderBottomColor': borderBottomColor,
                    '--borderBottomWidth': borderBottomWidth,
                    '--borderBottomContainerWidth': borderBottomContainerWidth
                } }, { children: data.map(tab => {
                    return indicatorNumber && tab.id === selectedTabId ? (jsxs("div", Object.assign({ className: styles$w['tab-indictor-wrapper'] }, { children: [jsxs("div", Object.assign({ className: styles$w['indictor-wrapper'] }, { children: [jsx("div", Object.assign({ className: styles$w['indictor-number'] }, { children: indicatorNumber }), void 0), jsx("div", Object.assign({ className: styles$w['indictor-text'] }, { children: indicatorText }), void 0)] }), void 0), jsx(Tab, { value: tab.id, label: tab.label, wrapped: true, classes: tabClasses, onClick: tab === null || tab === void 0 ? void 0 : tab.onTabClick, className: "Mui-selected" }, tab.id)] }), void 0)) : (jsx(Tab, { value: tab.id, label: tab.label, wrapped: true, classes: tabClasses, onClick: (tab === null || tab === void 0 ? void 0 : tab.onTabClick) || undefined }, tab.id));
                }) }), void 0), data.map(tab => {
                return (tab.component && (jsx(TabPanel, { selectedTabId: selectedTabId, tabId: tab.id, component: tab.component }, tab.id)));
            })] }), void 0));
};

const typeFileToLanguage = {
    cs: 'csharp',
    aspx: 'csharp',
    js: 'javascript',
    java: 'java',
    jsp: 'html',
    json: 'json',
    cshtml: 'html',
    css: 'css',
    html: 'html',
    py: 'python',
    xml: 'xml',
    php: 'php',
    pug: 'pug',
    scala: 'scala',
    default: 'java'
};
const getProgrammingLanguageByFileName = (name) => {
    var _a;
    const typeFile = (_a = name === null || name === void 0 ? void 0 : name.split('.').pop()) !== null && _a !== void 0 ? _a : 'default';
    const language = typeFileToLanguage[typeFile] || 'java';
    return language;
};

var css_248z$D = ".multichoiceSelect-module_class-ellipsis-2-lines__e0PiC,.multichoiceSelect-module_class-ellipsis-lines__ta1xK{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.multichoiceSelect-module_class-ellipsis-2-lines__e0PiC{-webkit-line-clamp:2!important;max-height:4rem!important}.multichoiceSelect-module_MuiChip-root__6gJQ5{margin:.5rem .3rem .5rem .5rem}.multichoiceSelect-module_ellipse-chip__71SRC.multichoiceSelect-module_MuiChip-root__6gJQ5{border-radius:1rem;height:20px}.multichoiceSelect-module_ellipse-chip__71SRC.multichoiceSelect-module_MuiChip-root__6gJQ5 .multichoiceSelect-module_MuiChip-label__5OzBN{padding-left:8px;padding-right:8px}.multichoiceSelect-module_square-chip__S7Lwt.multichoiceSelect-module_MuiChip-root__6gJQ5{border-radius:0!important}.multichoiceSelect-module_class-width-height-100__cbaoL{height:100%;width:100%}.multichoiceSelect-module_MuiTooltip-tooltip__3Xq-l{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.multichoiceSelect-module_MuiTooltip-arrow__V-Ujk{color:#fff!important}.multichoiceSelect-module_class-font-size-icon__izQmI{font-size:1.25rem}.multichoiceSelect-module_multichoice-common-select-class__fnn-f{background:#5a5b67!important;justify-content:flex-start!important;padding:0!important;width:100%!important}.multichoiceSelect-module_multichoice-select-menu-item__M0R1z{background:#141626;border:1px solid #141626;display:flex;height:2.7rem;width:calc(100% - 2px)}.multichoiceSelect-module_multichoice-select-menu-item__M0R1z:hover{background:#5a5b67;border-color:#5a5b67}.multichoiceSelect-module_multichoice-select-menu-item__M0R1z .multichoiceSelect-module_icon__RvW0M{align-items:center;color:#fff;display:flex;font-weight:500;justify-content:center;width:3rem}.multichoiceSelect-module_multichoice-select-menu-item__M0R1z .multichoiceSelect-module_icon__RvW0M span{font-size:1.0625rem}.multichoiceSelect-module_multichoice-select-menu-item__M0R1z .multichoiceSelect-module_text-answer__WroZd{align-items:center;color:hsla(0,0%,100%,.8);display:flex;font-family:OpenSans;font-size:1.125rem;font-weight:300;margin-left:1rem}.multichoiceSelect-module_multichoice-select-answer-item__iODyR{background:#5a5b67;border-color:#5a5b67}.multichoiceSelect-module_multichoice-select__LVw0c{display:flex}.multichoiceSelect-module_multichoice-select__LVw0c .MuiSelect-select.MuiSelect-select{border-radius:4px!important}.multichoiceSelect-module_multichoice-select__LVw0c .MuiSelect-icon{color:hsla(0,0%,100%,.8)!important;margin-right:.5rem;margin-top:.2rem}.multichoiceSelect-module_multichoice-select__LVw0c .multichoiceSelect-module_multichoice-select-content__gIa-k{width:100%}.multichoiceSelect-module_bg-colour-selected-question__RJNzH{background-color:#5a5b67;border-color:#fff!important;border-radius:4px!important}.multichoiceSelect-module_bg-colour-correct-question__rCeLK{background-color:#183e62!important;border-color:#109cf1!important;border-radius:4px!important}.multichoiceSelect-module_bg-colour-wrong-question__v7o2m{background-color:#582a42!important;border-color:#f2547f!important;border-radius:4px!important}.multichoiceSelect-module_bg-colour-correct-answer__CH3PO{background-color:#15243a!important;border-color:#15243a!important}.multichoiceSelect-module_bg-colour-wrong-answer__XLvZS{background-color:#2b1d2f!important;border-color:#2b1d2f!important}.MuiPaper-root.MuiPopover-paper{margin-top:6px}";
var styles$v = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"multichoiceSelect-module_class-ellipsis-lines__ta1xK","class-ellipsis-2-lines":"multichoiceSelect-module_class-ellipsis-2-lines__e0PiC","MuiChip-root":"multichoiceSelect-module_MuiChip-root__6gJQ5","ellipse-chip":"multichoiceSelect-module_ellipse-chip__71SRC","MuiChip-label":"multichoiceSelect-module_MuiChip-label__5OzBN","square-chip":"multichoiceSelect-module_square-chip__S7Lwt","class-width-height-100":"multichoiceSelect-module_class-width-height-100__cbaoL","MuiTooltip-tooltip":"multichoiceSelect-module_MuiTooltip-tooltip__3Xq-l","MuiTooltip-arrow":"multichoiceSelect-module_MuiTooltip-arrow__V-Ujk","class-font-size-icon":"multichoiceSelect-module_class-font-size-icon__izQmI","multichoice-common-select-class":"multichoiceSelect-module_multichoice-common-select-class__fnn-f","multichoice-select-menu-item":"multichoiceSelect-module_multichoice-select-menu-item__M0R1z","icon":"multichoiceSelect-module_icon__RvW0M","text-answer":"multichoiceSelect-module_text-answer__WroZd","multichoice-select-answer-item":"multichoiceSelect-module_multichoice-select-answer-item__iODyR","multichoice-select":"multichoiceSelect-module_multichoice-select__LVw0c","multichoice-select-content":"multichoiceSelect-module_multichoice-select-content__gIa-k","bg-colour-selected-question":"multichoiceSelect-module_bg-colour-selected-question__RJNzH","bg-colour-correct-question":"multichoiceSelect-module_bg-colour-correct-question__rCeLK","bg-colour-wrong-question":"multichoiceSelect-module_bg-colour-wrong-question__v7o2m","bg-colour-correct-answer":"multichoiceSelect-module_bg-colour-correct-answer__CH3PO","bg-colour-wrong-answer":"multichoiceSelect-module_bg-colour-wrong-answer__XLvZS"};
styleInject(css_248z$D);

const MultichoiceSelect = (props) => {
    const { answers, correctAnswers = [], userAnswers = [], isQuestionSubmitted, setUserAnswers, selectAnswerText } = props;
    const value = parseInt(userAnswers[0], 10) || 0;
    const indexAsString = (index) => String(index);
    const isIncludedInAnswers = (answersArray, index) => answersArray.indexOf(index) !== -1;
    const beforeShowResults = !isQuestionSubmitted || (isQuestionSubmitted && !correctAnswers.length);
    const selectClass = styles$v['multichoice-common-select-class'];
    return (jsx("div", Object.assign({ className: styles$v['multichoice-select'] }, { children: jsx(FormControl, Object.assign({ className: styles$v['multichoice-select-content'] }, { children: jsxs(Select, Object.assign({ classes: { root: selectClass }, MenuProps: {
                    getContentAnchorEl: null,
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                    },
                    classes: {
                        list: selectClass
                    }
                }, disableUnderline: true, value: value }, { children: [jsx(MenuItem, Object.assign({ classes: { root: selectClass }, value: 0 }, { children: jsx("div", Object.assign({ className: classNames(styles$v['multichoice-select-menu-item'], styles$v['multichoice-select-answer-item']) }, { children: jsx("div", Object.assign({ className: styles$v['text-answer'] }, { children: selectAnswerText }), void 0) }), void 0) }), void 0), answers.map((answer, i) => {
                        let answerStatus;
                        if (beforeShowResults) {
                            answerStatus = value === i + 1 ? 'selected' : 'unselected';
                        }
                        else {
                            answerStatus = isIncludedInAnswers(correctAnswers, indexAsString(i + 1))
                                ? 'correct'
                                : 'wrong';
                        }
                        return [
                            jsx(MenuItem, Object.assign({ "data-testid": `menu-item-${i + 1}`, onClick: () => !isQuestionSubmitted && setUserAnswers([indexAsString(i + 1)]), classes: { root: selectClass }, value: i + 1 }, { children: jsx("div", Object.assign({ "data-testid": `answer${i + 1}`, className: classNames(styles$v['multichoice-select-menu-item'], {
                                        [styles$v[`bg-colour-${answerStatus}-question`]]: value === i + 1,
                                        [styles$v[`bg-colour-${answerStatus}-answer`]]: value !== i + 1
                                    }) }, { children: jsx("div", Object.assign({ className: styles$v['text-answer'] }, { children: answer }), void 0) }), void 0) }), i + 1)
                        ];
                    })] }), void 0) }), void 0) }), void 0));
};

var css_248z$C = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.snippet-multichoice-header{align-items:center;background:hsla(0,0%,100%,.15);box-shadow:0 30px 40px rgba(0,0,0,.25);box-sizing:border-box;display:flex;padding:.75rem 2rem;width:100%}.snippet-multichoice-header .right-side-wrapper{display:flex;flex-direction:row;justify-content:flex-end;width:50%}.snippet-multichoice-header .question-header{color:#fff;font-family:OpenSans;font-size:1.25rem;font-weight:500;width:50%}.snippet-multichoice-header .available-answers{width:62%}.snippet-multichoice-header .button-wrapper{min-width:24%;padding-left:2rem}.snippet-multichoice-header .button-wrapper .button{box-shadow:0 3px 7px 0 rgba(0,0,0,.43);font-size:1rem}.snippet-multichoice-header .button-wrapper .button-disabled{color:hsla(0,0%,100%,.459)!important}";
styleInject(css_248z$C);

const SnippetMultichoiceHeader = (props) => {
    const { isQuestionSubmitted, onSubmit, currentQuestion, submitText, tooltipText, selectAnswerText } = props;
    const { description, correctAnswers, userAnswers, setUserAnswers, data: { answers } } = currentQuestion;
    const disableSubmit = !userAnswers.length || isQuestionSubmitted;
    return (jsxs("div", Object.assign({ className: "snippet-multichoice-header" }, { children: [jsx("div", Object.assign({ className: "question-header" }, { children: description }), void 0), jsxs("div", Object.assign({ className: "right-side-wrapper" }, { children: [jsx("div", Object.assign({ className: "available-answers" }, { children: jsx(MultichoiceSelect, { isQuestionSubmitted: isQuestionSubmitted, answers: answers, correctAnswers: correctAnswers, userAnswers: userAnswers, setUserAnswers: setUserAnswers, tooltipText: tooltipText, selectAnswerText: selectAnswerText }, void 0) }), void 0), jsx("div", Object.assign({ className: "button-wrapper", "data-testid": "button-wrapper" }, { children: jsx(ButtonContainer, { dataTestid: "submit", text: submitText, className: classNames('button', {
                                'button-disabled': disableSubmit
                            }), type: disableSubmit ? 'gradientNoBorderDisabled' : 'gradientNoBorder', onClick: onSubmit }, void 0) }), void 0)] }), void 0)] }), void 0));
};

var css_248z$B = ".switchCodeTitle-module_disabled-arrow__HJDGm{color:hsla(0,0%,100%,.5)!important}";
var styles$u = {"disabled-arrow":"switchCodeTitle-module_disabled-arrow__HJDGm"};
styleInject(css_248z$B);

const SwitchCodeTitle = (props) => {
    const { isFirstAnswer, isLastAnswer, setCurrentSolutionIndex, title } = props;
    return (jsxs(Fragment$1, { children: [jsx(ArrowLeftIcon$1, { className: classNames('class-padding-right-0_point_5-rem', {
                    'class-hover-pointer': !isFirstAnswer,
                    [styles$u['disabled-arrow']]: isFirstAnswer
                }), onClick: () => {
                    !isFirstAnswer && setCurrentSolutionIndex((prevIndex) => prevIndex - 1);
                }, "data-testid": "left-arrow", fontSize: "large" }, void 0), jsx("div", { children: title }, void 0), jsx(ArrowRightIcon$1, { className: classNames('class-padding-left-0_point_5-rem', {
                    'class-hover-pointer': !isLastAnswer,
                    [styles$u['disabled-arrow']]: isLastAnswer
                }), onClick: () => {
                    !isLastAnswer && setCurrentSolutionIndex((prevIndex) => prevIndex + 1);
                }, "data-testid": "right-arrow", fontSize: "large" }, void 0)] }, void 0));
};

var css_248z$A = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.snippet-binary-choice-wrapper{align-items:center;display:flex;flex-direction:column;font-family:OpenSans;height:100%;justify-content:center;margin:0 1.5rem;width:97%!important}.snippet-binary-choice-wrapper .content-container{background-color:#1e1e1e;display:flex;flex-direction:column;width:100%}.snippet-binary-choice-wrapper .content-container .code-wrapper{flex:16}.snippet-binary-choice-wrapper .content-container .codes-titles-wrapper{display:flex;flex:1;max-height:3rem;width:100%}.snippet-binary-choice-wrapper .content-container .codes-titles-wrapper .bg-colour-vulnerable-code-title{color:#f1605d!important}.snippet-binary-choice-wrapper .content-container .codes-titles-wrapper .left-code-title,.snippet-binary-choice-wrapper .content-container .codes-titles-wrapper .right-code-title{align-items:center;color:#fff;display:flex;font-size:1.125rem;padding:.75rem 2rem}.snippet-binary-choice-wrapper .content-container .codes-titles-wrapper .right-code-title{width:50%}.snippet-binary-choice-wrapper .content-container .codes-titles-wrapper .left-code-title{width:47.6%}.snippet-binary-choice-wrapper .content-container .codes-titles-wrapper .switch-code-title{display:flex;justify-content:center}";
styleInject(css_248z$A);

const SingleSelectRemediation = (props) => {
    const { currentQuestion, codeTitleText } = props;
    const { data: { answers } } = currentQuestion;
    const files = currentQuestion.folderStructureCode;
    const [currentFile, setCurrentFile] = useState(lib$1.searchFileById(files, lib$1.getFirstOpenFile(files)));
    const [currentSolutionIndex, setCurrentSolutionIndex] = useState(0);
    const isFirstAnswer = currentSolutionIndex === 0;
    const isLastAnswer = answers.length === currentSolutionIndex + 1;
    const onFileClick = (id) => {
        setCurrentFile(lib$1.searchFileById(files, id));
    };
    const renderCodeTitles = (jsxs("div", Object.assign({ className: "codes-titles-wrapper" }, { children: [jsx("div", Object.assign({ className: "left-code-title bg-colour-vulnerable-code-title" }, { children: codeTitleText }), void 0), jsx("div", Object.assign({ className: "right-code-title switch-code-title" }, { children: jsx(SwitchCodeTitle, { isFirstAnswer: isFirstAnswer, isLastAnswer: isLastAnswer, setCurrentSolutionIndex: setCurrentSolutionIndex, title: answers[currentSolutionIndex] }, void 0) }), void 0)] }), void 0));
    return (jsx("div", Object.assign({ className: "snippet-binary-choice-wrapper" }, { children: jsx(FilesExplorerWrapper, Object.assign({ files: files, onFileClick: onFileClick, defaultWidth: "15%", minWidth: "13%", maxWidth: "25%" }, { children: jsxs("div", Object.assign({ className: "content-container" }, { children: [jsx(SnippetMultichoiceHeader, Object.assign({}, props), void 0), renderCodeTitles, jsx("div", Object.assign({ className: "code-wrapper" }, { children: jsx(DiffCodeEditor, { codeLeft: currentFile.vulnerableCode || '', codeRight: (currentSolutionIndex === 0 ? currentFile.codeA : currentFile.codeB) || '', language: getProgrammingLanguageByFileName(currentFile.name || '') }, void 0) }), void 0)] }), void 0) }), void 0) }), void 0));
};

var css_248z$z = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.binary-choice-wrapper{flex-direction:row!important;margin-left:1.5rem}.binary-choice-wrapper .right-side{height:95%;margin-left:2rem;margin-right:2rem;width:70%}.binary-choice-wrapper .right-side-1{width:100%;z-index:1}.binary-choice-wrapper .code-wrapper{background-color:#1e1e1e;height:100%;width:100%}";
styleInject(css_248z$z);

const BinaryChoice = (props) => {
    const { currentQuestion, showAnswerType, tooltipText, answerTypeText, submitText } = props;
    const files = currentQuestion.folderStructureCode;
    const [currentFile, setcurrentFile] = useState(lib$1.searchFileById(files, lib$1.getFirstOpenFile(files)));
    const onFileClick = (id) => {
        setcurrentFile(lib$1.searchFileById(files, id));
    };
    const renderLeftSide = () => {
        return (jsx("div", Object.assign({ className: "right-side-1" }, { children: jsx("div", Object.assign({ className: "code-wrapper" }, { children: jsx(NewCodeEditor, { language: getProgrammingLanguageByFileName(currentFile.name || ''), code: currentFile.initialCode || '', highlightLines: currentFile.highlightLines || [] }, void 0) }), void 0) }), void 0));
    };
    const renderRightSide = () => {
        return (jsx("div", Object.assign({ className: "right-side" }, { children: jsx(MultiChoice, Object.assign({}, props, { halfScreen: true, showAnswerType: showAnswerType, tooltipText: tooltipText, submitText: submitText, answerTypeText: answerTypeText }), void 0) }), void 0));
    };
    return (jsxs("div", Object.assign({ className: "challenges binary-choice-wrapper", "data-testid": "challenges" }, { children: [jsx(FilesExplorerWrapper, Object.assign({ files: files, onFileClick: onFileClick }, { children: renderLeftSide() }), void 0), renderRightSide()] }), void 0));
};

const SnippetBinaryChoice = (props) => {
    const files = props.currentQuestion.folderStructureCode;
    const [currentFile, setcurrentFile] = useState(lib$1.searchFileById(files, lib$1.getFirstOpenFile(files)));
    const onFileClick = (id) => {
        setcurrentFile(lib$1.searchFileById(files, id));
    };
    const renderCodeTitles = (jsxs("div", Object.assign({ className: "codes-titles-wrapper" }, { children: [jsx("div", Object.assign({ className: "left-code-title" }, { children: props.currentQuestion.data.answers[0] }), void 0), jsx("div", Object.assign({ className: "right-code-title" }, { children: props.currentQuestion.data.answers[1] }), void 0)] }), void 0));
    return (jsx("div", Object.assign({ className: "snippet-binary-choice-wrapper" }, { children: jsx(FilesExplorerWrapper, Object.assign({ files: files, onFileClick: onFileClick, defaultWidth: "15%", minWidth: "13%", maxWidth: "25%" }, { children: jsxs("div", Object.assign({ className: "content-container" }, { children: [jsx(SnippetMultichoiceHeader, Object.assign({}, props), void 0), renderCodeTitles, jsx("div", Object.assign({ className: "code-wrapper" }, { children: jsx(DiffCodeEditor, { codeLeft: currentFile.codeA || '', codeRight: currentFile.codeB || '', language: getProgrammingLanguageByFileName(currentFile.name || '') }, void 0) }), void 0)] }), void 0) }), void 0) }), void 0));
};

var formatDistanceLocale$1e = {
  lessThanXSeconds: {
    one: "minder as 'n sekonde",
    other: 'minder as {{count}} sekondes'
  },
  xSeconds: {
    one: '1 sekonde',
    other: '{{count}} sekondes'
  },
  halfAMinute: "'n halwe minuut",
  lessThanXMinutes: {
    one: "minder as 'n minuut",
    other: 'minder as {{count}} minute'
  },
  xMinutes: {
    one: "'n minuut",
    other: '{{count}} minute'
  },
  aboutXHours: {
    one: 'ongeveer 1 uur',
    other: 'ongeveer {{count}} ure'
  },
  xHours: {
    one: '1 uur',
    other: '{{count}} ure'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dae'
  },
  aboutXWeeks: {
    one: 'ongeveer 1 week',
    other: 'ongeveer {{count}} weke'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weke'
  },
  aboutXMonths: {
    one: 'ongeveer 1 maand',
    other: 'ongeveer {{count}} maande'
  },
  xMonths: {
    one: '1 maand',
    other: '{{count}} maande'
  },
  aboutXYears: {
    one: 'ongeveer 1 jaar',
    other: 'ongeveer {{count}} jaar'
  },
  xYears: {
    one: '1 jaar',
    other: '{{count}} jaar'
  },
  overXYears: {
    one: 'meer as 1 jaar',
    other: 'meer as {{count}} jaar'
  },
  almostXYears: {
    one: 'byna 1 jaar',
    other: 'byna {{count}} jaar'
  }
};

var formatDistance$1H = function (token, count) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var usageGroup = formatDistanceLocale$1e[token];
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else {
    result = usageGroup.other.replace('{{count}}', String(count));
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'oor ' + result;
    } else {
      return result + ' gelede';
    }
  }

  return result;
};

var formatDistance$1I = formatDistance$1H;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats$1n = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'yyyy/MM/dd'
};
var timeFormats$1n = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$1n = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2K = {
  date: buildFormatLongFn({
    formats: dateFormats$1n,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1n,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1n,
    defaultWidth: 'full'
  })
};
var formatLong$2L = formatLong$2K;

var formatRelativeLocale$1g = {
  lastWeek: "'verlede' eeee 'om' p",
  yesterday: "'gister om' p",
  today: "'vandag om' p",
  tomorrow: "'môre om' p",
  nextWeek: "eeee 'om' p",
  other: 'P'
};

var formatRelative$1H = function (token) {
  return formatRelativeLocale$1g[token];
};

var formatRelative$1I = formatRelative$1H;

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!

    return valuesArray[index];
  };
}

var eraValues$1g = {
  narrow: ['vC', 'nC'],
  abbreviated: ['vC', 'nC'],
  wide: ['voor Christus', 'na Christus']
};
var quarterValues$1g = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1ste kwartaal', '2de kwartaal', '3de kwartaal', '4de kwartaal']
};
var monthValues$1g = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Des'],
  wide: ['Januarie', 'Februarie', 'Maart', 'April', 'Mei', 'Junie', 'Julie', 'Augustus', 'September', 'Oktober', 'November', 'Desember']
};
var dayValues$1g = {
  narrow: ['S', 'M', 'D', 'W', 'D', 'V', 'S'],
  short: ['So', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Sa'],
  abbreviated: ['Son', 'Maa', 'Din', 'Woe', 'Don', 'Vry', 'Sat'],
  wide: ['Sondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrydag', 'Saterdag']
};
var dayPeriodValues$1f = {
  narrow: {
    am: 'vm',
    pm: 'nm',
    midnight: 'middernag',
    noon: 'middaguur',
    morning: 'oggend',
    afternoon: 'middag',
    evening: 'laat middag',
    night: 'aand'
  },
  abbreviated: {
    am: 'vm',
    pm: 'nm',
    midnight: 'middernag',
    noon: 'middaguur',
    morning: 'oggend',
    afternoon: 'middag',
    evening: 'laat middag',
    night: 'aand'
  },
  wide: {
    am: 'vm',
    pm: 'nm',
    midnight: 'middernag',
    noon: 'middaguur',
    morning: 'oggend',
    afternoon: 'middag',
    evening: 'laat middag',
    night: 'aand'
  }
};
var formattingDayPeriodValues$10 = {
  narrow: {
    am: 'vm',
    pm: 'nm',
    midnight: 'middernag',
    noon: 'uur die middag',
    morning: 'uur die oggend',
    afternoon: 'uur die middag',
    evening: 'uur die aand',
    night: 'uur die aand'
  },
  abbreviated: {
    am: 'vm',
    pm: 'nm',
    midnight: 'middernag',
    noon: 'uur die middag',
    morning: 'uur die oggend',
    afternoon: 'uur die middag',
    evening: 'uur die aand',
    night: 'uur die aand'
  },
  wide: {
    am: 'vm',
    pm: 'nm',
    midnight: 'middernag',
    noon: 'uur die middag',
    morning: 'uur die oggend',
    afternoon: 'uur die middag',
    evening: 'uur die aand',
    night: 'uur die aand'
  }
};

var ordinalNumber$1g = function (dirtyNumber) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;

  if (rem100 < 20) {
    switch (rem100) {
      case 1:
      case 8:
        return number + 'ste';

      default:
        return number + 'de';
    }
  }

  return number + 'ste';
};

var localize$2w = {
  ordinalNumber: ordinalNumber$1g,
  era: buildLocalizeFn({
    values: eraValues$1g,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1g,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1g,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1g,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1f,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$10,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2x = localize$2w;

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }

  return undefined;
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }

  return undefined;
}

var matchOrdinalNumberPattern$1f = /^(\d+)(ste|de)?/i;
var parseOrdinalNumberPattern$1f = /\d+/i;
var matchEraPatterns$1f = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?C\.?)/,
  wide: /^((voor|na) Christus)/
};
var parseEraPatterns$1f = {
  any: [/^v/, /^n/]
};
var matchQuarterPatterns$1f = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](st|d)e kwartaal/i
};
var parseQuarterPatterns$1f = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1f = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
  wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var parseMonthPatterns$1f = {
  narrow: [/^J/i, /^F/i, /^M/i, /^A/i, /^M/i, /^J/i, /^J/i, /^A/i, /^S/i, /^O/i, /^N/i, /^D/i],
  any: [/^Jan/i, /^Feb/i, /^Mrt/i, /^Apr/i, /^Mei/i, /^Jun/i, /^Jul/i, /^Aug/i, /^Sep/i, /^Okt/i, /^Nov/i, /^Dec/i]
};
var matchDayPatterns$1f = {
  narrow: /^[smdwv]/i,
  short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
  abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
  wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var parseDayPatterns$1f = {
  narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
  any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i]
};
var matchDayPeriodPatterns$1f = {
  any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var parseDayPeriodPatterns$1f = {
  any: {
    am: /^vm/i,
    pm: /^nm/i,
    midnight: /^middernag/i,
    noon: /^middaguur/i,
    morning: /oggend/i,
    afternoon: /middag/i,
    evening: /laat middag/i,
    night: /aand/i
  }
};
var match$2u = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1f,
    parsePattern: parseOrdinalNumberPattern$1f,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1f,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1f,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1f,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1f,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return Number(index) + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1f,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1f,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1f,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1f,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1f,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1f,
    defaultParseWidth: 'any'
  })
};
var match$2v = match$2u;

/**
 * @type {Locale}
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
 */

var locale$2N = {
  code: 'af',
  formatDistance: formatDistance$1I,
  formatLong: formatLong$2L,
  formatRelative: formatRelative$1I,
  localize: localize$2x,
  match: match$2v,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$2O = locale$2N;

var formatDistanceLocale$1d = {
  lessThanXSeconds: {
    one: 'أقل من ثانية',
    two: 'أقل من ثانيتين',
    threeToTen: 'أقل من {{count}} ثواني',
    other: 'أقل من {{count}} ثانية'
  },
  xSeconds: {
    one: 'ثانية واحدة',
    two: 'ثانيتان',
    threeToTen: '{{count}} ثواني',
    other: '{{count}} ثانية'
  },
  halfAMinute: 'نصف دقيقة',
  lessThanXMinutes: {
    one: 'أقل من دقيقة',
    two: 'أقل من دقيقتين',
    threeToTen: 'أقل من {{count}} دقائق',
    other: 'أقل من {{count}} دقيقة'
  },
  xMinutes: {
    one: 'دقيقة واحدة',
    two: 'دقيقتان',
    threeToTen: '{{count}} دقائق',
    other: '{{count}} دقيقة'
  },
  aboutXHours: {
    one: 'ساعة واحدة تقريباً',
    two: 'ساعتين تقريبا',
    threeToTen: '{{count}} ساعات تقريباً',
    other: '{{count}} ساعة تقريباً'
  },
  xHours: {
    one: 'ساعة واحدة',
    two: 'ساعتان',
    threeToTen: '{{count}} ساعات',
    other: '{{count}} ساعة'
  },
  xDays: {
    one: 'يوم واحد',
    two: 'يومان',
    threeToTen: '{{count}} أيام',
    other: '{{count}} يوم'
  },
  aboutXWeeks: {
    one: 'أسبوع واحد تقريبا',
    two: 'أسبوعين تقريبا',
    threeToTen: '{{count}} أسابيع تقريبا',
    other: '{{count}} أسبوعا تقريبا'
  },
  xWeeks: {
    one: 'أسبوع واحد',
    two: 'أسبوعان',
    threeToTen: '{{count}} أسابيع',
    other: '{{count}} أسبوعا'
  },
  aboutXMonths: {
    one: 'شهر واحد تقريباً',
    two: 'شهرين تقريبا',
    threeToTen: '{{count}} أشهر تقريبا',
    other: '{{count}} شهرا تقريباً'
  },
  xMonths: {
    one: 'شهر واحد',
    two: 'شهران',
    threeToTen: '{{count}} أشهر',
    other: '{{count}} شهرا'
  },
  aboutXYears: {
    one: 'سنة واحدة تقريباً',
    two: 'سنتين تقريبا',
    threeToTen: '{{count}} سنوات تقريباً',
    other: '{{count}} سنة تقريباً'
  },
  xYears: {
    one: 'سنة واحد',
    two: 'سنتان',
    threeToTen: '{{count}} سنوات',
    other: '{{count}} سنة'
  },
  overXYears: {
    one: 'أكثر من سنة',
    two: 'أكثر من سنتين',
    threeToTen: 'أكثر من {{count}} سنوات',
    other: 'أكثر من {{count}} سنة'
  },
  almostXYears: {
    one: 'ما يقارب سنة واحدة',
    two: 'ما يقارب سنتين',
    threeToTen: 'ما يقارب {{count}} سنوات',
    other: 'ما يقارب {{count}} سنة'
  }
};

var formatDistance$1F = function (token, count, options) {
  var usageGroup = formatDistanceLocale$1d[token];
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else if (count === 2) {
    result = usageGroup.two;
  } else if (count <= 10) {
    result = usageGroup.threeToTen.replace('{{count}}', String(count));
  } else {
    result = usageGroup.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'خلال ' + result;
    } else {
      return 'منذ ' + result;
    }
  }

  return result;
};

var formatDistance$1G = formatDistance$1F;

var dateFormats$1m = {
  full: 'EEEE، do MMMM y',
  long: 'do MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/yyyy'
};
var timeFormats$1m = {
  full: 'HH:mm:ss',
  long: 'HH:mm:ss',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$1m = {
  full: "{{date}} 'عند الساعة' {{time}}",
  long: "{{date}} 'عند الساعة' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2I = {
  date: buildFormatLongFn({
    formats: dateFormats$1m,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1m,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1m,
    defaultWidth: 'full'
  })
};
var formatLong$2J = formatLong$2I;

var formatRelativeLocale$1f = {
  lastWeek: "eeee 'الماضي عند الساعة' p",
  yesterday: "'الأمس عند الساعة' p",
  today: "'اليوم عند الساعة' p",
  tomorrow: "'غدا عند الساعة' p",
  nextWeek: "eeee 'القادم عند الساعة' p",
  other: 'P'
};

var formatRelative$1F = function (token) {
  return formatRelativeLocale$1f[token];
};

var formatRelative$1G = formatRelative$1F;

var eraValues$1f = {
  narrow: ['ق', 'ب'],
  abbreviated: ['ق.م.', 'ب.م.'],
  wide: ['قبل الميلاد', 'بعد الميلاد']
};
var quarterValues$1f = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
};
var monthValues$1f = {
  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'أ', 'س', 'أ', 'ن', 'د'],
  abbreviated: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
};
var dayValues$1f = {
  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  abbreviated: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
};
var dayPeriodValues$1e = {
  narrow: {
    am: 'ص',
    pm: 'م',
    morning: 'الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'المساء',
    night: 'الليل',
    midnight: 'منتصف الليل'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    morning: 'الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'المساء',
    night: 'الليل',
    midnight: 'منتصف الليل'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    morning: 'الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'المساء',
    night: 'الليل',
    midnight: 'منتصف الليل'
  }
};
var formattingDayPeriodValues$$ = {
  narrow: {
    am: 'ص',
    pm: 'م',
    morning: 'في الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل',
    midnight: 'منتصف الليل'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    morning: 'في الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل',
    midnight: 'منتصف الليل'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    morning: 'في الصباح',
    noon: 'الظهر',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل',
    midnight: 'منتصف الليل'
  }
};

var ordinalNumber$1f = function (num) {
  return String(num);
};

var localize$2u = {
  ordinalNumber: ordinalNumber$1f,
  era: buildLocalizeFn({
    values: eraValues$1f,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1f,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1f,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1f,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1e,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$$,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2v = localize$2u;

var matchOrdinalNumberPattern$1e = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1e = /\d+/i;
var matchEraPatterns$1e = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/
};
var parseEraPatterns$1e = {
  any: [/قبل/, /بعد/]
};
var matchQuarterPatterns$1e = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns$1e = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1e = {
  narrow: /^[أيفمسند]/,
  abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns$1e = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^يناير/i, /^فبراير/i, /^مارس/i, /^أبريل/i, /^مايو/i, /^يونيو/i, /^يوليو/i, /^أغسطس/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
};
var matchDayPatterns$1e = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns$1e = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
};
var matchDayPeriodPatterns$1e = {
  narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
  any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var parseDayPeriodPatterns$1e = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /منتصف الليل/,
    noon: /الظهر/,
    afternoon: /بعد الظهر/,
    morning: /في الصباح/,
    evening: /في المساء/,
    night: /في الليل/
  }
};
var match$2s = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1e,
    parsePattern: parseOrdinalNumberPattern$1e,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1e,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1e,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1e,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1e,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1e,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1e,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1e,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1e,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1e,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1e,
    defaultParseWidth: 'any'
  })
};
var match$2t = match$2s;

/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */
var locale$2L = {
  code: 'ar',
  formatDistance: formatDistance$1G,
  formatLong: formatLong$2J,
  formatRelative: formatRelative$1G,
  localize: localize$2v,
  match: match$2t,
  options: {
    weekStartsOn: 6
    /* Saturday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$2M = locale$2L;

var formatDistanceLocale$1c = {
  lessThanXSeconds: {
    one: 'أقل من ثانية واحدة',
    two: 'أقل من ثانتين',
    threeToTen: 'أقل من {{count}} ثواني',
    other: 'أقل من {{count}} ثانية'
  },
  xSeconds: {
    one: 'ثانية واحدة',
    two: 'ثانتين',
    threeToTen: '{{count}} ثواني',
    other: '{{count}} ثانية'
  },
  halfAMinute: 'نصف دقيقة',
  lessThanXMinutes: {
    one: 'أقل من دقيقة',
    two: 'أقل من دقيقتين',
    threeToTen: 'أقل من {{count}} دقائق',
    other: 'أقل من {{count}} دقيقة'
  },
  xMinutes: {
    one: 'دقيقة واحدة',
    two: 'دقيقتين',
    threeToTen: '{{count}} دقائق',
    other: '{{count}} دقيقة'
  },
  aboutXHours: {
    one: 'ساعة واحدة تقريباً',
    two: 'ساعتين تقريباً',
    threeToTen: '{{count}} ساعات تقريباً',
    other: '{{count}} ساعة تقريباً'
  },
  xHours: {
    one: 'ساعة واحدة',
    two: 'ساعتين',
    threeToTen: '{{count}} ساعات',
    other: '{{count}} ساعة'
  },
  xDays: {
    one: 'يوم واحد',
    two: 'يومين',
    threeToTen: '{{count}} أيام',
    other: '{{count}} يوم'
  },
  aboutXWeeks: {
    one: 'أسبوع واحد تقريباً',
    two: 'أسبوعين تقريباً',
    threeToTen: '{{count}} أسابيع تقريباً',
    other: '{{count}} أسبوع تقريباً'
  },
  xWeeks: {
    one: 'أسبوع واحد',
    two: 'أسبوعين',
    threeToTen: '{{count}} أسابيع',
    other: '{{count}} أسبوع'
  },
  aboutXMonths: {
    one: 'شهر واحد تقريباً',
    two: 'شهرين تقريباً',
    threeToTen: '{{count}} أشهر تقريباً',
    other: '{{count}} شهر تقريباً'
  },
  xMonths: {
    one: 'شهر واحد',
    two: 'شهرين',
    threeToTen: '{{count}} أشهر',
    other: '{{count}} شهر'
  },
  aboutXYears: {
    one: 'عام واحد تقريباً',
    two: 'عامين تقريباً',
    threeToTen: '{{count}} أعوام تقريباً',
    other: '{{count}} عام تقريباً'
  },
  xYears: {
    one: 'عام واحد',
    two: 'عامين',
    threeToTen: '{{count}} أعوام',
    other: '{{count}} عام'
  },
  overXYears: {
    one: 'أكثر من عام',
    two: 'أكثر من عامين',
    threeToTen: 'أكثر من {{count}} أعوام',
    other: 'أكثر من {{count}} عام'
  },
  almostXYears: {
    one: 'عام واحد تقريباً',
    two: 'عامين تقريباً',
    threeToTen: '{{count}} أعوام تقريباً',
    other: '{{count}} عام تقريباً'
  }
};

var formatDistance$1D = function (token, count, options) {
  options = options || {};
  var usageGroup = formatDistanceLocale$1c[token];
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else if (count === 2) {
    result = usageGroup.two;
  } else if (count <= 10) {
    result = usageGroup.threeToTen.replace('{{count}}', String(count));
  } else {
    result = usageGroup.other.replace('{{count}}', String(count));
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'في خلال ' + result;
    } else {
      return 'منذ ' + result;
    }
  }

  return result;
};

var formatDistance$1E = formatDistance$1D;

var dateFormats$1l = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1l = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1l = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2G = {
  date: buildFormatLongFn({
    formats: dateFormats$1l,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1l,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1l,
    defaultWidth: 'full'
  })
};
var formatLong$2H = formatLong$2G;

var formatRelativeLocale$1e = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: 'P'
};

var formatRelative$1D = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$1e[token];
};

var formatRelative$1E = formatRelative$1D;

var eraValues$1e = {
  narrow: ['ق', 'ب'],
  abbreviated: ['ق.م.', 'ب.م.'],
  wide: ['قبل الميلاد', 'بعد الميلاد']
};
var quarterValues$1e = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
};
var monthValues$1e = {
  narrow: ['ج', 'ف', 'م', 'أ', 'م', 'ج', 'ج', 'أ', 'س', 'أ', 'ن', 'د'],
  abbreviated: ['جانـ', 'فيفـ', 'مارس', 'أفريل', 'مايـ', 'جوانـ', 'جويـ', 'أوت', 'سبتـ', 'أكتـ', 'نوفـ', 'ديسـ'],
  wide: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
};
var dayValues$1e = {
  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
};
var dayPeriodValues$1d = {
  narrow: {
    am: 'ص',
    pm: 'م',
    midnight: 'ن',
    noon: 'ظ',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءاً',
    night: 'ليلاً'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءاً',
    night: 'ليلاً'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءاً',
    night: 'ليلاً'
  }
};
var formattingDayPeriodValues$_ = {
  narrow: {
    am: 'ص',
    pm: 'م',
    midnight: 'ن',
    noon: 'ظ',
    morning: 'في الصباح',
    afternoon: 'بعد الظـهر',
    evening: 'في المساء',
    night: 'في الليل'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'في الصباح',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'صباحاً',
    afternoon: 'بعد الظـهر',
    evening: 'في المساء',
    night: 'في الليل'
  }
};

var ordinalNumber$1e = function (dirtyNumber) {
  return String(dirtyNumber);
};

var localize$2s = {
  ordinalNumber: ordinalNumber$1e,
  era: buildLocalizeFn({
    values: eraValues$1e,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1e,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1e,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1e,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1d,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$_,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2t = localize$2s;

var matchOrdinalNumberPattern$1d = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1d = /\d+/i;
var matchEraPatterns$1d = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns$1d = {
  any: [/^قبل/i, /^بعد/i]
};
var matchQuarterPatterns$1d = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
};
var parseQuarterPatterns$1d = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1d = {
  narrow: /^[جفمأسند]/i,
  abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var parseMonthPatterns$1d = {
  narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^جان/i, /^فيف/i, /^مار/i, /^أفر/i, /^ماي/i, /^جوا/i, /^جوي/i, /^أوت/i, /^سبت/i, /^أكت/i, /^نوف/i, /^ديس/i]
};
var matchDayPatterns$1d = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns$1d = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
};
var matchDayPeriodPatterns$1d = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1d = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$2q = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1d,
    parsePattern: parseOrdinalNumberPattern$1d,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1d,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1d,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1d,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1d,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return Number(index) + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1d,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1d,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1d,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1d,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1d,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1d,
    defaultParseWidth: 'any'
  })
};
var match$2r = match$2q;

/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */
var locale$2J = {
  code: 'ar-DZ',
  formatDistance: formatDistance$1E,
  formatLong: formatLong$2H,
  formatRelative: formatRelative$1E,
  localize: localize$2t,
  match: match$2r,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$2K = locale$2J;

var formatDistanceLocale$1b = {
  lessThanXSeconds: {
    one: 'أقل من ثانية',
    two: 'أقل من ثانيتين',
    threeToTen: 'أقل من {{count}} ثواني',
    other: 'أقل من {{count}} ثانية'
  },
  xSeconds: {
    one: 'ثانية',
    two: 'ثانيتين',
    threeToTen: '{{count}} ثواني',
    other: '{{count}} ثانية'
  },
  halfAMinute: 'نص دقيقة',
  lessThanXMinutes: {
    one: 'أقل من دقيقة',
    two: 'أقل من دقيقتين',
    threeToTen: 'أقل من {{count}} دقايق',
    other: 'أقل من {{count}} دقيقة'
  },
  xMinutes: {
    one: 'دقيقة',
    two: 'دقيقتين',
    threeToTen: '{{count}} دقايق',
    other: '{{count}} دقيقة'
  },
  aboutXHours: {
    one: 'حوالي ساعة',
    two: 'حوالي ساعتين',
    threeToTen: 'حوالي {{count}} ساعات',
    other: 'حوالي {{count}} ساعة'
  },
  xHours: {
    one: 'ساعة',
    two: 'ساعتين',
    threeToTen: '{{count}} ساعات',
    other: '{{count}} ساعة'
  },
  xDays: {
    one: 'يوم',
    two: 'يومين',
    threeToTen: '{{count}} أيام',
    other: '{{count}} يوم'
  },
  aboutXWeeks: {
    one: 'حوالي أسبوع',
    two: 'حوالي أسبوعين',
    threeToTen: 'حوالي {{count}} أسابيع',
    other: 'حوالي {{count}} أسبوع'
  },
  xWeeks: {
    one: 'أسبوع',
    two: 'أسبوعين',
    threeToTen: '{{count}} أسابيع',
    other: '{{count}} أسبوع'
  },
  aboutXMonths: {
    one: 'حوالي شهر',
    two: 'حوالي شهرين',
    threeToTen: 'حوالي {{count}} أشهر',
    other: 'حوالي {{count}} شهر'
  },
  xMonths: {
    one: 'شهر',
    two: 'شهرين',
    threeToTen: '{{count}} أشهر',
    other: '{{count}} شهر'
  },
  aboutXYears: {
    one: 'حوالي سنة',
    two: 'حوالي سنتين',
    threeToTen: 'حوالي {{count}} سنين',
    other: 'حوالي {{count}} سنة'
  },
  xYears: {
    one: 'عام',
    two: 'عامين',
    threeToTen: '{{count}} أعوام',
    other: '{{count}} عام'
  },
  overXYears: {
    one: 'أكثر من سنة',
    two: 'أكثر من سنتين',
    threeToTen: 'أكثر من {{count}} سنين',
    other: 'أكثر من {{count}} سنة'
  },
  almostXYears: {
    one: 'عام تقريبًا',
    two: 'عامين تقريبًا',
    threeToTen: '{{count}} أعوام تقريبًا',
    other: '{{count}} عام تقريبًا'
  }
};

var formatDistance$1B = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$1b[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else if (count === 2) {
    result = tokenValue.two;
  } else if (count <= 10) {
    result = tokenValue.threeToTen.replace('{{count}}', String(count));
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
    } else {
      return "\u0645\u0646\u0630 ".concat(result);
    }
  }

  return result;
};

var formatDistance$1C = formatDistance$1B;

var dateFormats$1k = {
  full: 'EEEE، do MMMM y',
  long: 'do MMMM y',
  medium: 'dd/MMM/y',
  short: 'd/MM/y'
};
var timeFormats$1k = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1k = {
  full: "{{date}} 'الساعة' {{time}}",
  long: "{{date}} 'الساعة' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2E = {
  date: buildFormatLongFn({
    formats: dateFormats$1k,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1k,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1k,
    defaultWidth: 'full'
  })
};
var formatLong$2F = formatLong$2E;

var formatRelativeLocale$1d = {
  lastWeek: "eeee 'اللي جاي الساعة' p",
  yesterday: "'إمبارح الساعة' p",
  today: "'النهاردة الساعة' p",
  tomorrow: "'بكرة الساعة' p",
  nextWeek: "eeee 'الساعة' p",
  other: 'P'
};

var formatRelative$1B = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$1d[token];
};

var formatRelative$1C = formatRelative$1B;

var eraValues$1d = {
  narrow: ['ق', 'ب'],
  abbreviated: ['ق.م', 'ب.م'],
  wide: ['قبل الميلاد', 'بعد الميلاد']
};
var quarterValues$1d = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
};
var monthValues$1d = {
  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'أ', 'س', 'أ', 'ن', 'د'],
  abbreviated: ['ينا', 'فبر', 'مارس', 'أبريل', 'مايو', 'يونـ', 'يولـ', 'أغسـ', 'سبتـ', 'أكتـ', 'نوفـ', 'ديسـ'],
  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
};
var dayValues$1d = {
  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  abbreviated: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
};
var dayPeriodValues$1c = {
  narrow: {
    am: 'ص',
    pm: 'م',
    midnight: 'ن',
    noon: 'ظ',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءً',
    night: 'ليلاً'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهراً',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءً',
    night: 'ليلاً'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهراً',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءً',
    night: 'ليلاً'
  }
};
var formattingDayPeriodValues$Z = {
  narrow: {
    am: 'ص',
    pm: 'م',
    midnight: 'ن',
    noon: 'ظ',
    morning: 'في الصباح',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهراً',
    morning: 'في الصباح',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    morning: 'في الصباح',
    noon: 'ظهراً',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل'
  }
};

var ordinalNumber$1d = function (dirtyNumber, _options) {
  return String(dirtyNumber);
};

var localize$2q = {
  ordinalNumber: ordinalNumber$1d,
  era: buildLocalizeFn({
    values: eraValues$1d,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1d,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1d,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1d,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1c,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$Z,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2r = localize$2q;

var matchOrdinalNumberPattern$1c = /^(\d+)/;
var parseOrdinalNumberPattern$1c = /\d+/i;
var matchEraPatterns$1c = {
  narrow: /^(ق|ب)/g,
  abbreviated: /^(ق.م|ب.م)/g,
  wide: /^(قبل الميلاد|بعد الميلاد)/g
};
var parseEraPatterns$1c = {
  any: [/^ق/g, /^ب/g]
};
var matchQuarterPatterns$1c = {
  narrow: /^[1234]/,
  abbreviated: /^ر[1234]/,
  wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns$1c = {
  wide: [/الربع الأول/, /الربع الثاني/, /الربع الثالث/, /الربع الرابع/],
  any: [/1/, /2/, /3/, /4/]
};
var matchMonthPatterns$1c = {
  narrow: /^(ي|ف|م|أ|س|ن|د)/,
  abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns$1c = {
  narrow: [/^ي/, /^ف/, /^م/, /^أ/, /^م/, /^ي/, /^ي/, /^أ/, /^س/, /^أ/, /^ن/, /^د/],
  any: [/^ينا/, /^فبر/, /^مارس/, /^أبريل/, /^مايو/, /^يون/, /^يول/, /^أغس/, /^سبت/, /^أكت/, /^نوف/, /^ديس/]
};
var matchDayPatterns$1c = {
  narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var parseDayPatterns$1c = {
  narrow: [/^ح/, /^ن/, /^ث/, /^ر/, /^خ/, /^ج/, /^س/],
  any: [/أحد/, /اثنين/, /ثلاثاء/, /أربعاء/, /خميس/, /جمعة/, /سبت/]
};
var matchDayPeriodPatterns$1c = {
  narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
  abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
  wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
  any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
var parseDayPeriodPatterns$1c = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /^ن/,
    noon: /^ظ/,
    morning: /^ص/,
    afternoon: /^بعد/,
    evening: /^م/,
    night: /^ل/
  }
};
var match$2o = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1c,
    parsePattern: parseOrdinalNumberPattern$1c,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1c,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1c,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1c,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1c,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1c,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1c,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1c,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1c,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1c,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1c,
    defaultParseWidth: 'any'
  })
};
var match$2p = match$2o;

/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
 */
var locale$2H = {
  code: 'ar-EG',
  formatDistance: formatDistance$1C,
  formatLong: formatLong$2F,
  formatRelative: formatRelative$1C,
  localize: localize$2r,
  match: match$2p,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$2I = locale$2H;

var formatDistanceLocale$1a = {
  lessThanXSeconds: {
    one: 'أقل من ثانية واحدة',
    two: 'أقل من ثانتين',
    threeToTen: 'أقل من {{count}} ثواني',
    other: 'أقل من {{count}} ثانية'
  },
  xSeconds: {
    one: 'ثانية واحدة',
    two: 'ثانتين',
    threeToTen: '{{count}} ثواني',
    other: '{{count}} ثانية'
  },
  halfAMinute: 'نصف دقيقة',
  lessThanXMinutes: {
    one: 'أقل من دقيقة',
    two: 'أقل من دقيقتين',
    threeToTen: 'أقل من {{count}} دقائق',
    other: 'أقل من {{count}} دقيقة'
  },
  xMinutes: {
    one: 'دقيقة واحدة',
    two: 'دقيقتين',
    threeToTen: '{{count}} دقائق',
    other: '{{count}} دقيقة'
  },
  aboutXHours: {
    one: 'ساعة واحدة تقريباً',
    two: 'ساعتين تقريباً',
    threeToTen: '{{count}} ساعات تقريباً',
    other: '{{count}} ساعة تقريباً'
  },
  xHours: {
    one: 'ساعة واحدة',
    two: 'ساعتين',
    threeToTen: '{{count}} ساعات',
    other: '{{count}} ساعة'
  },
  xDays: {
    one: 'يوم واحد',
    two: 'يومين',
    threeToTen: '{{count}} أيام',
    other: '{{count}} يوم'
  },
  aboutXWeeks: {
    one: 'أسبوع واحد تقريباً',
    two: 'أسبوعين تقريباً',
    threeToTen: '{{count}} أسابيع تقريباً',
    other: '{{count}} أسبوع تقريباً'
  },
  xWeeks: {
    one: 'أسبوع واحد',
    two: 'أسبوعين',
    threeToTen: '{{count}} أسابيع',
    other: '{{count}} أسبوع'
  },
  aboutXMonths: {
    one: 'شهر واحد تقريباً',
    two: 'شهرين تقريباً',
    threeToTen: '{{count}} أشهر تقريباً',
    other: '{{count}} شهر تقريباً'
  },
  xMonths: {
    one: 'شهر واحد',
    two: 'شهرين',
    threeToTen: '{{count}} أشهر',
    other: '{{count}} شهر'
  },
  aboutXYears: {
    one: 'عام واحد تقريباً',
    two: 'عامين تقريباً',
    threeToTen: '{{count}} أعوام تقريباً',
    other: '{{count}} عام تقريباً'
  },
  xYears: {
    one: 'عام واحد',
    two: 'عامين',
    threeToTen: '{{count}} أعوام',
    other: '{{count}} عام'
  },
  overXYears: {
    one: 'أكثر من عام',
    two: 'أكثر من عامين',
    threeToTen: 'أكثر من {{count}} أعوام',
    other: 'أكثر من {{count}} عام'
  },
  almostXYears: {
    one: 'عام واحد تقريباً',
    two: 'عامين تقريباً',
    threeToTen: '{{count}} أعوام تقريباً',
    other: '{{count}} عام تقريباً'
  }
};

var formatDistance$1z = function (token, count, options) {
  options = options || {};
  var usageGroup = formatDistanceLocale$1a[token];
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else if (count === 2) {
    result = usageGroup.two;
  } else if (count <= 10) {
    result = usageGroup.threeToTen.replace('{{count}}', String(count));
  } else {
    result = usageGroup.other.replace('{{count}}', String(count));
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'في خلال ' + result;
    } else {
      return 'منذ ' + result;
    }
  }

  return result;
};

var formatDistance$1A = formatDistance$1z;

var dateFormats$1j = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1j = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1j = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2C = {
  date: buildFormatLongFn({
    formats: dateFormats$1j,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1j,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1j,
    defaultWidth: 'full'
  })
};
var formatLong$2D = formatLong$2C;

var formatRelativeLocale$1c = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: 'P'
};

var formatRelative$1z = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$1c[token];
};

var formatRelative$1A = formatRelative$1z;

var eraValues$1c = {
  narrow: ['ق', 'ب'],
  abbreviated: ['ق.م.', 'ب.م.'],
  wide: ['قبل الميلاد', 'بعد الميلاد']
};
var quarterValues$1c = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
};
var monthValues$1c = {
  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'غ', 'ش', 'أ', 'ن', 'د'],
  abbreviated: ['ينا', 'فبر', 'مارس', 'أبريل', 'ماي', 'يونـ', 'يولـ', 'غشت', 'شتنـ', 'أكتـ', 'نونـ', 'دجنـ'],
  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'ماي', 'يونيو', 'يوليوز', 'غشت', 'شتنبر', 'أكتوبر', 'نونبر', 'دجنبر']
};
var dayValues$1c = {
  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
  wide: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
};
var dayPeriodValues$1b = {
  narrow: {
    am: 'ص',
    pm: 'م',
    midnight: 'ن',
    noon: 'ظ',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءاً',
    night: 'ليلاً'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءاً',
    night: 'ليلاً'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءاً',
    night: 'ليلاً'
  }
};
var formattingDayPeriodValues$Y = {
  narrow: {
    am: 'ص',
    pm: 'م',
    midnight: 'ن',
    noon: 'ظ',
    morning: 'في الصباح',
    afternoon: 'بعد الظـهر',
    evening: 'في المساء',
    night: 'في الليل'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'في الصباح',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'صباحاً',
    afternoon: 'بعد الظـهر',
    evening: 'في المساء',
    night: 'في الليل'
  }
};

var ordinalNumber$1c = function (dirtyNumber) {
  return String(dirtyNumber);
};

var localize$2o = {
  ordinalNumber: ordinalNumber$1c,
  era: buildLocalizeFn({
    values: eraValues$1c,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1c,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1c,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1c,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1b,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$Y,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2p = localize$2o;

var matchOrdinalNumberPattern$1b = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1b = /\d+/i;
var matchEraPatterns$1b = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns$1b = {
  any: [/^قبل/i, /^بعد/i]
};
var matchQuarterPatterns$1b = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
};
var parseQuarterPatterns$1b = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1b = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var parseMonthPatterns$1b = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^غ/i, /^ش/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^ين/i, /^فب/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^غشت/i, /^ش/i, /^أك/i, /^ن/i, /^د/i]
};
var matchDayPatterns$1b = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns$1b = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الإثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
};
var matchDayPeriodPatterns$1b = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1b = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$2m = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1b,
    parsePattern: parseOrdinalNumberPattern$1b,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1b,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1b,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1b,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1b,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return Number(index) + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1b,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1b,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1b,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1b,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1b,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1b,
    defaultParseWidth: 'any'
  })
};
var match$2n = match$2m;

/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
 */
var locale$2F = {
  code: 'ar-MA',
  formatDistance: formatDistance$1A,
  formatLong: formatLong$2D,
  formatRelative: formatRelative$1A,
  localize: localize$2p,
  match: match$2n,
  options: {
    // Monday is 1
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var locale$2G = locale$2F;

var formatDistanceLocale$19 = {
  lessThanXSeconds: {
    one: 'أقل من ثانية واحدة',
    two: 'أقل من ثانتين',
    threeToTen: 'أقل من {{count}} ثواني',
    other: 'أقل من {{count}} ثانية'
  },
  xSeconds: {
    one: 'ثانية واحدة',
    two: 'ثانتين',
    threeToTen: '{{count}} ثواني',
    other: '{{count}} ثانية'
  },
  halfAMinute: 'نصف دقيقة',
  lessThanXMinutes: {
    one: 'أقل من دقيقة',
    two: 'أقل من دقيقتين',
    threeToTen: 'أقل من {{count}} دقائق',
    other: 'أقل من {{count}} دقيقة'
  },
  xMinutes: {
    one: 'دقيقة واحدة',
    two: 'دقيقتين',
    threeToTen: '{{count}} دقائق',
    other: '{{count}} دقيقة'
  },
  aboutXHours: {
    one: 'ساعة واحدة تقريباً',
    two: 'ساعتين تقريباً',
    threeToTen: '{{count}} ساعات تقريباً',
    other: '{{count}} ساعة تقريباً'
  },
  xHours: {
    one: 'ساعة واحدة',
    two: 'ساعتين',
    threeToTen: '{{count}} ساعات',
    other: '{{count}} ساعة'
  },
  xDays: {
    one: 'يوم واحد',
    two: 'يومين',
    threeToTen: '{{count}} أيام',
    other: '{{count}} يوم'
  },
  aboutXWeeks: {
    one: 'أسبوع واحد تقريباً',
    two: 'أسبوعين تقريباً',
    threeToTen: '{{count}} أسابيع تقريباً',
    other: '{{count}} أسبوع تقريباً'
  },
  xWeeks: {
    one: 'أسبوع واحد',
    two: 'أسبوعين',
    threeToTen: '{{count}} أسابيع',
    other: '{{count}} أسبوع'
  },
  aboutXMonths: {
    one: 'شهر واحد تقريباً',
    two: 'شهرين تقريباً',
    threeToTen: '{{count}} أشهر تقريباً',
    other: '{{count}} شهر تقريباً'
  },
  xMonths: {
    one: 'شهر واحد',
    two: 'شهرين',
    threeToTen: '{{count}} أشهر',
    other: '{{count}} شهر'
  },
  aboutXYears: {
    one: 'عام واحد تقريباً',
    two: 'عامين تقريباً',
    threeToTen: '{{count}} أعوام تقريباً',
    other: '{{count}} عام تقريباً'
  },
  xYears: {
    one: 'عام واحد',
    two: 'عامين',
    threeToTen: '{{count}} أعوام',
    other: '{{count}} عام'
  },
  overXYears: {
    one: 'أكثر من عام',
    two: 'أكثر من عامين',
    threeToTen: 'أكثر من {{count}} أعوام',
    other: 'أكثر من {{count}} عام'
  },
  almostXYears: {
    one: 'عام واحد تقريباً',
    two: 'عامين تقريباً',
    threeToTen: '{{count}} أعوام تقريباً',
    other: '{{count}} عام تقريباً'
  }
};

var formatDistance$1x = function (token, count, options) {
  options = options || {};
  var usageGroup = formatDistanceLocale$19[token];
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else if (count === 2) {
    result = usageGroup.two;
  } else if (count <= 10) {
    result = usageGroup.threeToTen.replace('{{count}}', String(count));
  } else {
    result = usageGroup.other.replace('{{count}}', String(count));
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'في خلال ' + result;
    } else {
      return 'منذ ' + result;
    }
  }

  return result;
};

var formatDistance$1y = formatDistance$1x;

var dateFormats$1i = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1i = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1i = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2A = {
  date: buildFormatLongFn({
    formats: dateFormats$1i,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1i,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1i,
    defaultWidth: 'full'
  })
};
var formatLong$2B = formatLong$2A;

var formatRelativeLocale$1b = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: 'P'
};

var formatRelative$1x = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$1b[token];
};

var formatRelative$1y = formatRelative$1x;

var eraValues$1b = {
  narrow: ['ق', 'ب'],
  abbreviated: ['ق.م.', 'ب.م.'],
  wide: ['قبل الميلاد', 'بعد الميلاد']
};
var quarterValues$1b = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
};
var monthValues$1b = {
  narrow: ['ي', 'ف', 'م', 'أ', 'م', 'ي', 'ي', 'أ', 'س', 'أ', 'ن', 'د'],
  abbreviated: ['ينا', 'فبر', 'مارس', 'أبريل', 'مايو', 'يونـ', 'يولـ', 'أغسـ', 'سبتـ', 'أكتـ', 'نوفـ', 'ديسـ'],
  wide: ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
};
var dayValues$1b = {
  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  abbreviated: ['أحد', 'اثنـ', 'ثلا', 'أربـ', 'خميـ', 'جمعة', 'سبت'],
  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
};
var dayPeriodValues$1a = {
  narrow: {
    am: 'ص',
    pm: 'م',
    midnight: 'ن',
    noon: 'ظ',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءاً',
    night: 'ليلاً'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءاً',
    night: 'ليلاً'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'صباحاً',
    afternoon: 'بعد الظهر',
    evening: 'مساءاً',
    night: 'ليلاً'
  }
};
var formattingDayPeriodValues$X = {
  narrow: {
    am: 'ص',
    pm: 'م',
    midnight: 'ن',
    noon: 'ظ',
    morning: 'في الصباح',
    afternoon: 'بعد الظـهر',
    evening: 'في المساء',
    night: 'في الليل'
  },
  abbreviated: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'في الصباح',
    afternoon: 'بعد الظهر',
    evening: 'في المساء',
    night: 'في الليل'
  },
  wide: {
    am: 'ص',
    pm: 'م',
    midnight: 'نصف الليل',
    noon: 'ظهر',
    morning: 'صباحاً',
    afternoon: 'بعد الظـهر',
    evening: 'في المساء',
    night: 'في الليل'
  }
};

var ordinalNumber$1b = function (dirtyNumber) {
  return String(dirtyNumber);
};

var localize$2m = {
  ordinalNumber: ordinalNumber$1b,
  era: buildLocalizeFn({
    values: eraValues$1b,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1b,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1b,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1b,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1a,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$X,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2n = localize$2m;

var matchOrdinalNumberPattern$1a = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1a = /\d+/i;
var matchEraPatterns$1a = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var parseEraPatterns$1a = {
  any: [/^قبل/i, /^بعد/i]
};
var matchQuarterPatterns$1a = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
};
var parseQuarterPatterns$1a = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1a = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var parseMonthPatterns$1a = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ي/i, /^ي/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^ين/i, /^ف/i, /^مار/i, /^أب/i, /^ماي/i, /^يون/i, /^يول/i, /^أغ/i, /^س/i, /^أك/i, /^ن/i, /^د/i]
};
var matchDayPatterns$1a = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns$1a = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
};
var matchDayPeriodPatterns$1a = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1a = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$2k = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1a,
    parsePattern: parseOrdinalNumberPattern$1a,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1a,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1a,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1a,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1a,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1a,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1a,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1a,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1a,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1a,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1a,
    defaultParseWidth: 'any'
  })
};
var match$2l = match$2k;

/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
 */

var locale$2D = {
  code: 'ar-SA',
  formatDistance: formatDistance$1y,
  formatLong: formatLong$2B,
  formatRelative: formatRelative$1y,
  localize: localize$2n,
  match: match$2l,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$2E = locale$2D;

var formatDistanceLocale$18 = {
  lessThanXSeconds: {
    one: 'أقل من ثانية',
    two: 'أقل من زوز ثواني',
    threeToTen: 'أقل من {{count}} ثواني',
    other: 'أقل من {{count}} ثانية'
  },
  xSeconds: {
    one: 'ثانية',
    two: 'زوز ثواني',
    threeToTen: '{{count}} ثواني',
    other: '{{count}} ثانية'
  },
  halfAMinute: 'نص دقيقة',
  lessThanXMinutes: {
    one: 'أقل من دقيقة',
    two: 'أقل من دقيقتين',
    threeToTen: 'أقل من {{count}} دقايق',
    other: 'أقل من {{count}} دقيقة'
  },
  xMinutes: {
    one: 'دقيقة',
    two: 'دقيقتين',
    threeToTen: '{{count}} دقايق',
    other: '{{count}} دقيقة'
  },
  aboutXHours: {
    one: 'ساعة تقريب',
    two: 'ساعتين تقريب',
    threeToTen: '{{count}} سوايع تقريب',
    other: '{{count}} ساعة تقريب'
  },
  xHours: {
    one: 'ساعة',
    two: 'ساعتين',
    threeToTen: '{{count}} سوايع',
    other: '{{count}} ساعة'
  },
  xDays: {
    one: 'نهار',
    two: 'نهارين',
    threeToTen: '{{count}} أيام',
    other: '{{count}} يوم'
  },
  aboutXWeeks: {
    one: 'جمعة تقريب',
    two: 'جمعتين تقريب',
    threeToTen: '{{count}} جماع تقريب',
    other: '{{count}} جمعة تقريب'
  },
  xWeeks: {
    one: 'جمعة',
    two: 'جمعتين',
    threeToTen: '{{count}} جماع',
    other: '{{count}} جمعة'
  },
  aboutXMonths: {
    one: 'شهر تقريب',
    two: 'شهرين تقريب',
    threeToTen: '{{count}} أشهرة تقريب',
    other: '{{count}} شهر تقريب'
  },
  xMonths: {
    one: 'شهر',
    two: 'شهرين',
    threeToTen: '{{count}} أشهرة',
    other: '{{count}} شهر'
  },
  aboutXYears: {
    one: 'عام تقريب',
    two: 'عامين تقريب',
    threeToTen: '{{count}} أعوام تقريب',
    other: '{{count}} عام تقريب'
  },
  xYears: {
    one: 'عام',
    two: 'عامين',
    threeToTen: '{{count}} أعوام',
    other: '{{count}} عام'
  },
  overXYears: {
    one: 'أكثر من عام',
    two: 'أكثر من عامين',
    threeToTen: 'أكثر من {{count}} أعوام',
    other: 'أكثر من {{count}} عام'
  },
  almostXYears: {
    one: 'عام تقريب',
    two: 'عامين تقريب',
    threeToTen: '{{count}} أعوام تقريب',
    other: '{{count}} عام تقريب'
  }
};

var formatDistance$1v = function (token, count, options) {
  var usageGroup = formatDistanceLocale$18[token];
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else if (count === 2) {
    result = usageGroup.two;
  } else if (count <= 10) {
    result = usageGroup.threeToTen.replace('{{count}}', String(count));
  } else {
    result = usageGroup.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'في ' + result;
    } else {
      return 'عندو ' + result;
    }
  }

  return result;
};

var formatDistance$1w = formatDistance$1v;

var dateFormats$1h = {
  full: 'EEEE، do MMMM y',
  long: 'do MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/yyyy'
};
var timeFormats$1h = {
  full: 'HH:mm:ss',
  long: 'HH:mm:ss',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$1h = {
  full: "{{date}} 'مع' {{time}}",
  long: "{{date}} 'مع' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2y = {
  date: buildFormatLongFn({
    formats: dateFormats$1h,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1h,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1h,
    defaultWidth: 'full'
  })
};
var formatLong$2z = formatLong$2y;

var formatRelativeLocale$1a = {
  lastWeek: "eeee 'إلي فات مع' p",
  yesterday: "'البارح مع' p",
  today: "'اليوم مع' p",
  tomorrow: "'غدوة مع' p",
  nextWeek: "eeee 'الجمعة الجاية مع' p 'نهار'",
  other: 'P'
};

var formatRelative$1v = function (token) {
  return formatRelativeLocale$1a[token];
};

var formatRelative$1w = formatRelative$1v;

var eraValues$1a = {
  narrow: ['ق', 'ب'],
  abbreviated: ['ق.م.', 'ب.م.'],
  wide: ['قبل الميلاد', 'بعد الميلاد']
};
var quarterValues$1a = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['ر1', 'ر2', 'ر3', 'ر4'],
  wide: ['الربع الأول', 'الربع الثاني', 'الربع الثالث', 'الربع الرابع']
};
var monthValues$1a = {
  narrow: ['د', 'ن', 'أ', 'س', 'أ', 'ج', 'ج', 'م', 'أ', 'م', 'ف', 'ج'],
  abbreviated: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'],
  wide: ['جانفي', 'فيفري', 'مارس', 'أفريل', 'ماي', 'جوان', 'جويلية', 'أوت', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر']
};
var dayValues$1a = {
  narrow: ['ح', 'ن', 'ث', 'ر', 'خ', 'ج', 'س'],
  short: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  abbreviated: ['أحد', 'اثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت'],
  wide: ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت']
};
var dayPeriodValues$19 = {
  narrow: {
    am: 'ص',
    pm: 'ع',
    morning: 'الصباح',
    noon: 'القايلة',
    afternoon: 'بعد القايلة',
    evening: 'العشية',
    night: 'الليل',
    midnight: 'نص الليل'
  },
  abbreviated: {
    am: 'ص',
    pm: 'ع',
    morning: 'الصباح',
    noon: 'القايلة',
    afternoon: 'بعد القايلة',
    evening: 'العشية',
    night: 'الليل',
    midnight: 'نص الليل'
  },
  wide: {
    am: 'ص',
    pm: 'ع',
    morning: 'الصباح',
    noon: 'القايلة',
    afternoon: 'بعد القايلة',
    evening: 'العشية',
    night: 'الليل',
    midnight: 'نص الليل'
  }
};
var formattingDayPeriodValues$W = {
  narrow: {
    am: 'ص',
    pm: 'ع',
    morning: 'في الصباح',
    noon: 'في القايلة',
    afternoon: 'بعد القايلة',
    evening: 'في العشية',
    night: 'في الليل',
    midnight: 'نص الليل'
  },
  abbreviated: {
    am: 'ص',
    pm: 'ع',
    morning: 'في الصباح',
    noon: 'في القايلة',
    afternoon: 'بعد القايلة',
    evening: 'في العشية',
    night: 'في الليل',
    midnight: 'نص الليل'
  },
  wide: {
    am: 'ص',
    pm: 'ع',
    morning: 'في الصباح',
    noon: 'في القايلة',
    afternoon: 'بعد القايلة',
    evening: 'في العشية',
    night: 'في الليل',
    midnight: 'نص الليل'
  }
};

var ordinalNumber$1a = function (num) {
  return String(num);
};

var localize$2k = {
  ordinalNumber: ordinalNumber$1a,
  era: buildLocalizeFn({
    values: eraValues$1a,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1a,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1a,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1a,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$19,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$W,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2l = localize$2k;

var matchOrdinalNumberPattern$19 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$19 = /\d+/i;
var matchEraPatterns$19 = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/
};
var parseEraPatterns$19 = {
  any: [/قبل/, /بعد/]
};
var matchQuarterPatterns$19 = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var parseQuarterPatterns$19 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$19 = {
  narrow: /^[جفمأسند]/,
  abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var parseMonthPatterns$19 = {
  narrow: [/^ج/i, /^ف/i, /^م/i, /^أ/i, /^م/i, /^ج/i, /^ج/i, /^أ/i, /^س/i, /^أ/i, /^ن/i, /^د/i],
  any: [/^جانفي/i, /^فيفري/i, /^مارس/i, /^أفريل/i, /^ماي/i, /^جوان/i, /^جويلية/i, /^أوت/i, /^سبتمبر/i, /^أكتوبر/i, /^نوفمبر/i, /^ديسمبر/i]
};
var matchDayPatterns$19 = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var parseDayPatterns$19 = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [/^الأحد/i, /^الاثنين/i, /^الثلاثاء/i, /^الأربعاء/i, /^الخميس/i, /^الجمعة/i, /^السبت/i],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
};
var matchDayPeriodPatterns$19 = {
  narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
  any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var parseDayPeriodPatterns$19 = {
  any: {
    am: /^ص/,
    pm: /^ع/,
    midnight: /نص الليل/,
    noon: /قايلة/,
    afternoon: /بعد القايلة/,
    morning: /صباح/,
    evening: /عشية/,
    night: /ليل/
  }
};
var match$2i = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$19,
    parsePattern: parseOrdinalNumberPattern$19,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$19,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$19,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$19,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$19,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$19,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$19,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$19,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$19,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$19,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$19,
    defaultParseWidth: 'any'
  })
};
var match$2j = match$2i;

/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */
var locale$2B = {
  code: 'ar-TN',
  formatDistance: formatDistance$1w,
  formatLong: formatLong$2z,
  formatRelative: formatRelative$1w,
  localize: localize$2l,
  match: match$2j,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$2C = locale$2B;

var formatDistanceLocale$17 = {
  lessThanXSeconds: {
    one: 'bir saniyədən az',
    other: '{{count}} bir saniyədən az'
  },
  xSeconds: {
    one: '1 saniyə',
    other: '{{count}} saniyə'
  },
  halfAMinute: 'yarım dəqiqə',
  lessThanXMinutes: {
    one: 'bir dəqiqədən az',
    other: '{{count}} bir dəqiqədən az'
  },
  xMinutes: {
    one: 'bir dəqiqə',
    other: '{{count}} dəqiqə'
  },
  aboutXHours: {
    one: 'təxminən 1 saat',
    other: 'təxminən {{count}} saat'
  },
  xHours: {
    one: '1 saat',
    other: '{{count}} saat'
  },
  xDays: {
    one: '1 gün',
    other: '{{count}} gün'
  },
  aboutXWeeks: {
    one: 'təxminən 1 həftə',
    other: 'təxminən {{count}} həftə'
  },
  xWeeks: {
    one: '1 həftə',
    other: '{{count}} həftə'
  },
  aboutXMonths: {
    one: 'təxminən 1 ay',
    other: 'təxminən {{count}} ay'
  },
  xMonths: {
    one: '1 ay',
    other: '{{count}} ay'
  },
  aboutXYears: {
    one: 'təxminən 1 il',
    other: 'təxminən {{count}} il'
  },
  xYears: {
    one: '1 il',
    other: '{{count}} il'
  },
  overXYears: {
    one: '1 ildən çox',
    other: '{{count}} ildən çox'
  },
  almostXYears: {
    one: 'demək olar ki 1 il',
    other: 'demək olar ki {{count}} il'
  }
};

var formatDistance$1t = function (token, count, options) {
  options = options || {};
  var usageGroup = formatDistanceLocale$17[token];
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else {
    result = usageGroup.other.replace('{{count}}', String(count));
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + ' əvvəl';
    } else {
      return result + ' sonra';
    }
  }

  return result;
};

var formatDistance$1u = formatDistance$1t;

var dateFormats$1g = {
  full: "EEEE, do MMMM y 'il'",
  long: "do MMMM y 'il'",
  medium: "d MMM y 'il'",
  short: 'dd.MM.yyyy'
};
var timeFormats$1g = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$1g = {
  full: "{{date}} {{time}} - 'də'",
  long: "{{date}} {{time}} - 'də'",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2w = {
  date: buildFormatLongFn({
    formats: dateFormats$1g,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1g,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1g,
    defaultWidth: 'full'
  })
};
var formatLong$2x = formatLong$2w;

var formatRelativeLocale$19 = {
  lastWeek: "'sonuncu' eeee p -'də'",
  yesterday: "'dünən' p -'də'",
  today: "'bugün' p -'də'",
  tomorrow: "'sabah' p -'də'",
  nextWeek: "eeee p -'də'",
  other: 'P'
};

var formatRelative$1t = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$19[token];
};

var formatRelative$1u = formatRelative$1t;

var eraValues$19 = {
  narrow: ['e.ə', 'b.e'],
  abbreviated: ['e.ə', 'b.e'],
  wide: ['eramızdan əvvəl', 'bizim era']
};
var quarterValues$19 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1ci kvartal', '2ci kvartal', '3cü kvartal', '4cü kvartal']
};
var monthValues$19 = {
  narrow: ['Y', 'F', 'M', 'A', 'M', 'İ', 'İ', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'İyun', 'İyul', 'Avq', 'Sen', 'Okt', 'Noy', 'Dek'],
  wide: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'İyun', 'İyul', 'Avqust', 'Sentyabr', 'Oktyabr', 'Noyabr', 'Dekabr']
};
var dayValues$19 = {
  narrow: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
  short: ['B.', 'B.e', 'Ç.a', 'Ç.', 'C.a', 'C.', 'Ş.'],
  abbreviated: ['Baz', 'Baz.e', 'Çər.a', 'Çər', 'Cüm.a', 'Cüm', 'Şə'],
  wide: ['Bazar', 'Bazar ertəsi', 'Çərşənbə axşamı', 'Çərşənbə', 'Cümə axşamı', 'Cümə', 'Şənbə']
};
var dayPeriodValues$18 = {
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'gecəyarı',
    noon: 'gün',
    morning: 'səhər',
    afternoon: 'gündüz',
    evening: 'axşam',
    night: 'gecə'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'gecəyarı',
    noon: 'gün',
    morning: 'səhər',
    afternoon: 'gündüz',
    evening: 'axşam',
    night: 'gecə'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'gecəyarı',
    noon: 'gün',
    morning: 'səhər',
    afternoon: 'gündüz',
    evening: 'axşam',
    night: 'gecə'
  }
};
var formattingDayPeriodValues$V = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'gecəyarı',
    noon: 'gün',
    morning: 'səhər',
    afternoon: 'gündüz',
    evening: 'axşam',
    night: 'gecə'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'gecəyarı',
    noon: 'gün',
    morning: 'səhər',
    afternoon: 'gündüz',
    evening: 'axşam',
    night: 'gecə'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'gecəyarı',
    noon: 'gün',
    morning: 'səhər',
    afternoon: 'gündüz',
    evening: 'axşam',
    night: 'gecə'
  }
};
var suffixes$1 = {
  1: '-inci',
  5: '-inci',
  8: '-inci',
  70: '-inci',
  80: '-inci',
  2: '-nci',
  7: '-nci',
  20: '-nci',
  50: '-nci',
  3: '-üncü',
  4: '-üncü',
  100: '-üncü',
  6: '-ncı',
  9: '-uncu',
  10: '-uncu',
  30: '-uncu',
  60: '-ıncı',
  90: '-ıncı'
};

var getSuffix = function (number) {
  if (number === 0) {
    // special case for zero
    return number + '-ıncı';
  }

  var a = number % 10;
  var b = number % 100 - a;
  var c = number >= 100 ? 100 : null;

  if (suffixes$1[a]) {
    return suffixes$1[a];
  } else if (suffixes$1[b]) {
    return suffixes$1[b];
  } else if (c !== null) {
    return suffixes$1[c];
  }

  return '';
};

var ordinalNumber$19 = function (dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);
  var suffix = getSuffix(number);
  return number + suffix;
};

var localize$2i = {
  ordinalNumber: ordinalNumber$19,
  era: buildLocalizeFn({
    values: eraValues$19,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$19,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$19,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$19,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$18,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$V,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2j = localize$2i;

var matchOrdinalNumberPattern$18 = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var parseOrdinalNumberPattern$18 = /\d+/i;
var matchEraPatterns$18 = {
  narrow: /^(b|a)$/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
  wide: /^(bizim eradan əvvəl|bizim era)$/i
};
var parseEraPatterns$18 = {
  any: [/^b$/i, /^(a|c)$/i]
};
var matchQuarterPatterns$18 = {
  narrow: /^[1234]$/i,
  abbreviated: /^K[1234]$/i,
  wide: /^[1234](ci)? kvartal$/i
};
var parseQuarterPatterns$18 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$18 = {
  narrow: /^[(?-i)yfmaisond]$/i,
  abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
  wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var parseMonthPatterns$18 = {
  narrow: [/^[(?-i)y]$/i, /^[(?-i)f]$/i, /^[(?-i)m]$/i, /^[(?-i)a]$/i, /^[(?-i)m]$/i, /^[(?-i)i]$/i, /^[(?-i)i]$/i, /^[(?-i)a]$/i, /^[(?-i)s]$/i, /^[(?-i)o]$/i, /^[(?-i)n]$/i, /^[(?-i)d]$/i],
  abbreviated: [/^Yan$/i, /^Fev$/i, /^Mar$/i, /^Apr$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avg$/i, /^Sen$/i, /^Okt$/i, /^Noy$/i, /^Dek$/i],
  wide: [/^Yanvar$/i, /^Fevral$/i, /^Mart$/i, /^Aprel$/i, /^May$/i, /^İyun$/i, /^İyul$/i, /^Avgust$/i, /^Sentyabr$/i, /^Oktyabr$/i, /^Noyabr$/i, /^Dekabr$/i]
};
var matchDayPatterns$18 = {
  narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
  wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var parseDayPatterns$18 = {
  narrow: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i],
  abbreviated: [/^Baz$/i, /^Baz\.e$/i, /^Çər\.a$/i, /^Çər$/i, /^Cüm\.a$/i, /^Cüm$/i, /^Şə$/i],
  wide: [/^Bazar$/i, /^Bazar ertəsi$/i, /^Çərşənbə axşamı$/i, /^Çərşənbə$/i, /^Cümə axşamı$/i, /^Cümə$/i, /^Şənbə$/i],
  any: [/^B\.$/i, /^B\.e$/i, /^Ç\.a$/i, /^Ç\.$/i, /^C\.a$/i, /^C\.$/i, /^Ş\.$/i]
};
var matchDayPeriodPatterns$18 = {
  narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
  any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var parseDayPeriodPatterns$18 = {
  any: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /^gecəyarı$/i,
    noon: /^gün$/i,
    morning: /səhər$/i,
    afternoon: /gündüz$/i,
    evening: /axşam$/i,
    night: /gecə$/i
  }
};
var match$2g = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$18,
    parsePattern: parseOrdinalNumberPattern$18,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$18,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$18,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$18,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$18,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return Number(index) + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$18,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$18,
    defaultParseWidth: 'narrow'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$18,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$18,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$18,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$18,
    defaultParseWidth: 'any'
  })
};
var match$2h = match$2g;

/**
 * @type {Locale}
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */

var locale$2z = {
  code: 'az',
  formatDistance: formatDistance$1u,
  formatLong: formatLong$2x,
  formatRelative: formatRelative$1u,
  localize: localize$2j,
  match: match$2h,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
var locale$2A = locale$2z;

function declension$5(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  var rem10 = count % 10;
  var rem100 = count % 100; // 1, 21, 31, ...

  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace('{{count}}', String(count)); // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace('{{count}}', String(count)); // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace('{{count}}', String(count));
  }
}

function buildLocalizeTokenFn$4(scheme) {
  return function (count, options) {
    if (options && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        if (scheme.future) {
          return declension$5(scheme.future, count);
        } else {
          return 'праз ' + declension$5(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension$5(scheme.past, count);
        } else {
          return declension$5(scheme.regular, count) + ' таму';
        }
      }
    } else {
      return declension$5(scheme.regular, count);
    }
  };
}

var halfAMinute = function (_, options) {
  if (options && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'праз паўхвіліны';
    } else {
      return 'паўхвіліны таму';
    }
  }

  return 'паўхвіліны';
};

var formatDistanceLocale$16 = {
  lessThanXSeconds: buildLocalizeTokenFn$4({
    regular: {
      one: 'менш за секунду',
      singularNominative: 'менш за {{count}} секунду',
      singularGenitive: 'менш за {{count}} секунды',
      pluralGenitive: 'менш за {{count}} секунд'
    },
    future: {
      one: 'менш, чым праз секунду',
      singularNominative: 'менш, чым праз {{count}} секунду',
      singularGenitive: 'менш, чым праз {{count}} секунды',
      pluralGenitive: 'менш, чым праз {{count}} секунд'
    }
  }),
  xSeconds: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: '{{count}} секунда',
      singularGenitive: '{{count}} секунды',
      pluralGenitive: '{{count}} секунд'
    },
    past: {
      singularNominative: '{{count}} секунду таму',
      singularGenitive: '{{count}} секунды таму',
      pluralGenitive: '{{count}} секунд таму'
    },
    future: {
      singularNominative: 'праз {{count}} секунду',
      singularGenitive: 'праз {{count}} секунды',
      pluralGenitive: 'праз {{count}} секунд'
    }
  }),
  halfAMinute: halfAMinute,
  lessThanXMinutes: buildLocalizeTokenFn$4({
    regular: {
      one: 'менш за хвіліну',
      singularNominative: 'менш за {{count}} хвіліну',
      singularGenitive: 'менш за {{count}} хвіліны',
      pluralGenitive: 'менш за {{count}} хвілін'
    },
    future: {
      one: 'менш, чым праз хвіліну',
      singularNominative: 'менш, чым праз {{count}} хвіліну',
      singularGenitive: 'менш, чым праз {{count}} хвіліны',
      pluralGenitive: 'менш, чым праз {{count}} хвілін'
    }
  }),
  xMinutes: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: '{{count}} хвіліна',
      singularGenitive: '{{count}} хвіліны',
      pluralGenitive: '{{count}} хвілін'
    },
    past: {
      singularNominative: '{{count}} хвіліну таму',
      singularGenitive: '{{count}} хвіліны таму',
      pluralGenitive: '{{count}} хвілін таму'
    },
    future: {
      singularNominative: 'праз {{count}} хвіліну',
      singularGenitive: 'праз {{count}} хвіліны',
      pluralGenitive: 'праз {{count}} хвілін'
    }
  }),
  aboutXHours: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: 'каля {{count}} гадзіны',
      singularGenitive: 'каля {{count}} гадзін',
      pluralGenitive: 'каля {{count}} гадзін'
    },
    future: {
      singularNominative: 'прыблізна праз {{count}} гадзіну',
      singularGenitive: 'прыблізна праз {{count}} гадзіны',
      pluralGenitive: 'прыблізна праз {{count}} гадзін'
    }
  }),
  xHours: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: '{{count}} гадзіна',
      singularGenitive: '{{count}} гадзіны',
      pluralGenitive: '{{count}} гадзін'
    },
    past: {
      singularNominative: '{{count}} гадзіну таму',
      singularGenitive: '{{count}} гадзіны таму',
      pluralGenitive: '{{count}} гадзін таму'
    },
    future: {
      singularNominative: 'праз {{count}} гадзіну',
      singularGenitive: 'праз {{count}} гадзіны',
      pluralGenitive: 'праз {{count}} гадзін'
    }
  }),
  xDays: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: '{{count}} дзень',
      singularGenitive: '{{count}} дні',
      pluralGenitive: '{{count}} дзён'
    }
  }),
  aboutXWeeks: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: 'каля {{count}} месяца',
      // TODO
      singularGenitive: 'каля {{count}} месяцаў',
      // TODO
      pluralGenitive: 'каля {{count}} месяцаў' // TODO

    },
    future: {
      singularNominative: 'прыблізна праз {{count}} месяц',
      // TODO
      singularGenitive: 'прыблізна праз {{count}} месяцы',
      // TODO
      pluralGenitive: 'прыблізна праз {{count}} месяцаў' // TODO

    }
  }),
  xWeeks: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: '{{count}} месяц',
      singularGenitive: '{{count}} месяцы',
      pluralGenitive: '{{count}} месяцаў'
    }
  }),
  aboutXMonths: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: 'каля {{count}} месяца',
      singularGenitive: 'каля {{count}} месяцаў',
      pluralGenitive: 'каля {{count}} месяцаў'
    },
    future: {
      singularNominative: 'прыблізна праз {{count}} месяц',
      singularGenitive: 'прыблізна праз {{count}} месяцы',
      pluralGenitive: 'прыблізна праз {{count}} месяцаў'
    }
  }),
  xMonths: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: '{{count}} месяц',
      singularGenitive: '{{count}} месяцы',
      pluralGenitive: '{{count}} месяцаў'
    }
  }),
  aboutXYears: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: 'каля {{count}} года',
      singularGenitive: 'каля {{count}} гадоў',
      pluralGenitive: 'каля {{count}} гадоў'
    },
    future: {
      singularNominative: 'прыблізна праз {{count}} год',
      singularGenitive: 'прыблізна праз {{count}} гады',
      pluralGenitive: 'прыблізна праз {{count}} гадоў'
    }
  }),
  xYears: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: '{{count}} год',
      singularGenitive: '{{count}} гады',
      pluralGenitive: '{{count}} гадоў'
    }
  }),
  overXYears: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: 'больш за {{count}} год',
      singularGenitive: 'больш за {{count}} гады',
      pluralGenitive: 'больш за {{count}} гадоў'
    },
    future: {
      singularNominative: 'больш, чым праз {{count}} год',
      singularGenitive: 'больш, чым праз {{count}} гады',
      pluralGenitive: 'больш, чым праз {{count}} гадоў'
    }
  }),
  almostXYears: buildLocalizeTokenFn$4({
    regular: {
      singularNominative: 'амаль {{count}} год',
      singularGenitive: 'амаль {{count}} гады',
      pluralGenitive: 'амаль {{count}} гадоў'
    },
    future: {
      singularNominative: 'амаль праз {{count}} год',
      singularGenitive: 'амаль праз {{count}} гады',
      pluralGenitive: 'амаль праз {{count}} гадоў'
    }
  })
};

var formatDistance$1r = function (token, count, options) {
  options = options || {};
  return formatDistanceLocale$16[token](count, options);
};

var formatDistance$1s = formatDistance$1r;

var dateFormats$1f = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: 'dd.MM.y'
};
var timeFormats$1f = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$1f = {
  any: '{{date}}, {{time}}'
};
var formatLong$2u = {
  date: buildFormatLongFn({
    formats: dateFormats$1f,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1f,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1f,
    defaultWidth: 'any'
  })
};
var formatLong$2v = formatLong$2u;

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function isSameUTCWeek(dirtyDateLeft, dirtyDateRight, options) {
  requiredArgs(2, arguments);
  var dateLeftStartOfWeek = startOfUTCWeek(dirtyDateLeft, options);
  var dateRightStartOfWeek = startOfUTCWeek(dirtyDateRight, options);
  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var MILLISECONDS_IN_HOUR$1 = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR$1);
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY$1 = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}

var MILLISECONDS_IN_MINUTE$1 = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE$1);
}

/**
 * @name addSeconds
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * const result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */

function addSeconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * 1000);
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */

function compareAsc(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInMinute = 60000;
/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */

var millisecondsInHour = 3600000;

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 * 
 * @example
 * // Are 4 September and 4 October in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 * 
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */

function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);

  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }

  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */

function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.

function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */


function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * const result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dateLeft, dateRight) {
  requiredArgs(2, arguments);
  return toDate(dateLeft).getTime() - toDate(dateRight).getTime();
}

var roundingMap = {
  ceil: Math.ceil,
  round: Math.round,
  floor: Math.floor,
  trunc: function (value) {
    return value < 0 ? Math.ceil(value) : Math.floor(value);
  } // Math.trunc is not supported by IE

};
var defaultRoundingMethod = 'trunc';
function getRoundingMethod(method) {
  return method ? roundingMap[method] : roundingMap[defaultRoundingMethod];
}

/**
 * @name differenceInHours
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of hours
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * const result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */

function differenceInHours(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInHour;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * const result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are between 10:01:59 and 10:00:00
 * const result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */

function differenceInMinutes(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / millisecondsInMinute;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isLastDayOfMonth
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */

function isLastDayOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return endOfDay(date).getTime() === endOfMonth(date).getTime();
}

/**
 * @name differenceInMonths
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates using trunc as a default rounding method.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInMonths(new Date(2014, 8, 1), new Date(2014, 0, 31))
 * //=> 7
 */

function differenceInMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight));
  var result; // Check for the difference of less than month

  if (difference < 1) {
    result = 0;
  } else {
    if (dateLeft.getMonth() === 1 && dateLeft.getDate() > 27) {
      // This will check if the date is end of Feb and assign a higher end of month date
      // to compare it with Jan
      dateLeft.setDate(30);
    }

    dateLeft.setMonth(dateLeft.getMonth() - sign * difference); // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
    // If so, result must be decreased by 1 in absolute value

    var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign; // Check for cases of one full calendar month

    if (isLastDayOfMonth(toDate(dirtyDateLeft)) && difference === 1 && compareAsc(dirtyDateLeft, dateRight) === 1) {
      isLastMonthNotFull = false;
    }

    result = sign * (difference - Number(isLastMonthNotFull));
  } // Prevent negative zero


  return result === 0 ? 0 : result;
}

/**
 * @name differenceInQuarters
 * @category Quarter Helpers
 * @summary Get the number of quarters between the given dates.
 *
 * @description
 * Get the number of quarters between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full quarters
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * const result = differenceInQuarters(new Date(2014, 6, 2), new Date(2013, 11, 31))
 * //=> 2
 */

function differenceInQuarters(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMonths(dateLeft, dateRight) / 3;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * const result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */

function differenceInSeconds(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dateLeft, dateRight) / 1000;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name differenceInWeeks
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between two dates. Fractional weeks are
 * truncated towards zero by default.
 *
 * One "full week" is the distance between a local time in one day to the same
 * local time 7 days earlier or later. A full week can sometimes be less than
 * or more than 7*24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 7*24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/(7*24))|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {String} [options.roundingMethod='trunc'] - a rounding method (`ceil`, `floor`, `round` or `trunc`)
 * @returns {Number} the number of full weeks
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * const result = differenceInWeeks(new Date(2014, 6, 20), new Date(2014, 6, 5))
 * //=> 2
 *
 * // How many full weeks are between
 * // 1 March 2020 0:00 and 6 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 8 weeks (54 days),
 * // even if DST starts and the period has
 * // only 54*24-1 hours.
 * const result = differenceInWeeks(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 6)
 * )
 * //=> 8
 */

function differenceInWeeks(dateLeft, dateRight, options) {
  requiredArgs(2, arguments);
  var diff = differenceInDays(dateLeft, dateRight) / 7;
  return getRoundingMethod(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

/**
 * @name differenceInYears
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInYears(new Date(2015, 1, 11), new Date(2013, 11, 31))
 * //=> 1
 */

function differenceInYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight)); // Set both dates to a valid leap year for accurate comparison when dealing
  // with leap days

  dateLeft.setFullYear(1584);
  dateRight.setFullYear(1584); // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign;
  var result = sign * (difference - Number(isLastYearNotFull)); // Prevent negative zero

  return result === 0 ? 0 : result;
}

/**
 * @name eachDayOfInterval
 * @category Interval Helpers
 * @summary Return the array of dates within the specified time interval.
 *
 * @description
 * Return the array of dates within the specified time interval.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `eachDay` to `eachDayOfInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   eachDay(new Date(2014, 0, 10), new Date(2014, 0, 20))
 *
 *   // v2.0.0 onward
 *
 *   eachDayOfInterval(
 *     { start: new Date(2014, 0, 10), end: new Date(2014, 0, 20) }
 *   )
 *   ```
 *
 * @param {Interval} interval - the interval. See [Interval]{@link https://date-fns.org/docs/Interval}
 * @param {Object} [options] - an object with options.
 * @param {Number} [options.step=1] - the step to increment by. The value should be more than 1.
 * @returns {Date[]} the array with starts of days from the day of the interval start to the day of the interval end
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.step` must be a number greater than 1
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * const result = eachDayOfInterval({
 *   start: new Date(2014, 9, 6),
 *   end: new Date(2014, 9, 10)
 * })
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */

function eachDayOfInterval(dirtyInterval, options) {
  requiredArgs(1, arguments);
  var interval = dirtyInterval || {};
  var startDate = toDate(interval.start);
  var endDate = toDate(interval.end);
  var endTime = endDate.getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startDate.getTime() <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  var dates = [];
  var currentDate = startDate;
  currentDate.setHours(0, 0, 0, 0);
  var step = options && 'step' in options ? Number(options.step) : 1;
  if (step < 1 || isNaN(step)) throw new RangeError('`options.step` must be a number greater than 1');

  while (currentDate.getTime() <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }

  return dates;
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */

function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * const result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

var formatDistanceLocale$15 = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

var formatDistance$1p = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$15[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

var formatDistance$1q = formatDistance$1p;

var dateFormats$1e = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1e = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1e = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2s = {
  date: buildFormatLongFn({
    formats: dateFormats$1e,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1e,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1e,
    defaultWidth: 'full'
  })
};
var formatLong$2t = formatLong$2s;

var formatRelativeLocale$18 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

var formatRelative$1r = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$18[token];
};

var formatRelative$1s = formatRelative$1r;

var eraValues$18 = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues$18 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$18 = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues$18 = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues$17 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues$U = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

var ordinalNumber$18 = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
};

var localize$2g = {
  ordinalNumber: ordinalNumber$18,
  era: buildLocalizeFn({
    values: eraValues$18,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$18,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$18,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$18,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$17,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$U,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2h = localize$2g;

var matchOrdinalNumberPattern$17 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$17 = /\d+/i;
var matchEraPatterns$17 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$17 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$17 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$17 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$17 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$17 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$17 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$17 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$17 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$17 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$2e = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$17,
    parsePattern: parseOrdinalNumberPattern$17,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$17,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$17,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$17,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$17,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$17,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$17,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$17,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$17,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$17,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$17,
    defaultParseWidth: 'any'
  })
};
var match$2f = match$2e;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$2y = {
  code: 'en-US',
  formatDistance: formatDistance$1q,
  formatLong: formatLong$2t,
  formatRelative: formatRelative$1s,
  localize: localize$2h,
  match: match$2f,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale$2y;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$2 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$3.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$3.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var formatters$1 = formatters;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters$2 = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$3 = longFormatters$2;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$3[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp$1).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString$1(input) {
  return input.match(escapedStringRegExp$1)[1].replace(doubleQuoteRegExp$1, "'");
}

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (Object.prototype.hasOwnProperty.call(dirtyObject, property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
 * @returns {String} the formatted date string (in local time zone)
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.represenation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */

function formatISO(date, options) {
  requiredArgs(1, arguments);
  var originalDate = toDate(date);

  if (isNaN(originalDate.getTime())) {
    throw new RangeError('Invalid time value');
  }

  var format = !(options !== null && options !== void 0 && options.format) ? 'extended' : String(options.format);
  var representation = !(options !== null && options !== void 0 && options.representation) ? 'complete' : String(options.representation);

  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }

  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }

  var result = '';
  var tzOffset = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : ''; // Representation is either 'date' or 'complete'

  if (representation !== 'time') {
    var day = addLeadingZeros(originalDate.getDate(), 2);
    var month = addLeadingZeros(originalDate.getMonth() + 1, 2);
    var year = addLeadingZeros(originalDate.getFullYear(), 4); // yyyyMMdd or yyyy-MM-dd.

    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  } // Representation is either 'time' or 'complete'


  if (representation !== 'date') {
    // Add the timezone.
    var offset = originalDate.getTimezoneOffset();

    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = addLeadingZeros(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = addLeadingZeros(absoluteOffset % 60, 2); // If less than 0, the sign is +, because it is ahead of time.

      var sign = offset < 0 ? '+' : '-';
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = 'Z';
    }

    var hour = addLeadingZeros(originalDate.getHours(), 2);
    var minute = addLeadingZeros(originalDate.getMinutes(), 2);
    var second = addLeadingZeros(originalDate.getSeconds(), 2); // If there's also date, separate it with time with 'T'

    var separator = result === '' ? '' : 'T'; // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.

    var time = [hour, minute, second].join(timeDelimiter); // HHmmss or HH:mm:ss.

    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }

  return result;
}

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours$1(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  requiredArgs(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    subPriority: 1,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = setUTCISODay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
var parsers$1 = parsers;

var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward (toDate no longer accepts a string)
 *   toDate(1392098430000) // Unix to timestamp
 *   toDate(new Date(2014, 1, 11, 11, 30, 30)) // Cloning the date
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, dirtyOptions) {
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  }; // If timezone isn't specified, it will be set to the system timezone

  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    subPriority: -1,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$3[firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(token)) {
      throwProtectedError(token, formatString, dirtyDateString);
    }

    var firstCharacter = token[0];
    var parser = parsers$1[firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        subPriority: parser.subPriority || 0,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      assign(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name startOfHour
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an hour
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * const result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */

function startOfHour(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setMinutes(0, 0, 0);
  return date;
}

/**
 * @name isSameHour
 * @category Hour Helpers
 * @summary Are the given dates in the same hour (and same day)?
 *
 * @description
 * Are the given dates in the same hour (and same day)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour (and same day)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 6, 30))
 * //=> true
 * 
 * @example
 * // Are 4 September 2014 06:00:00 and 5 September 06:00:00 in the same hour?
 * var result = isSameHour(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 5, 6, 0))
 * //=> false
 */

function isSameHour(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft);
  var dateRightStartOfHour = startOfHour(dirtyDateRight);
  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? 2 : toInteger(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time)) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }

  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null; // either year or century is null, not both

  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate$1(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate$1(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

var accusativeWeekdays$6 = ['нядзелю', 'панядзелак', 'аўторак', 'сераду', 'чацвер', 'пятніцу', 'суботу'];

function lastWeek$7(day) {
  var weekday = accusativeWeekdays$6[day];

  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у мінулую " + weekday + " а' p";

    case 1:
    case 2:
    case 4:
      return "'у мінулы " + weekday + " а' p";
  }
}

function thisWeek$7(day) {
  var weekday = accusativeWeekdays$6[day];
  return "'у " + weekday + " а' p";
}

function nextWeek$7(day) {
  var weekday = accusativeWeekdays$6[day];

  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступную " + weekday + " а' p";

    case 1:
    case 2:
    case 4:
      return "'у наступны " + weekday + " а' p";
  }
}

var lastWeekFormat = function (dirtyDate, baseDate, options) {
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();

  if (isSameUTCWeek(date, baseDate, options)) {
    return thisWeek$7(day);
  } else {
    return lastWeek$7(day);
  }
};

var nextWeekFormat = function (dirtyDate, baseDate, options) {
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();

  if (isSameUTCWeek(date, baseDate, options)) {
    return thisWeek$7(day);
  } else {
    return nextWeek$7(day);
  }
};

var formatRelativeLocale$17 = {
  lastWeek: lastWeekFormat,
  yesterday: "'учора а' p",
  today: "'сёння а' p",
  tomorrow: "'заўтра а' p",
  nextWeek: nextWeekFormat,
  other: 'P'
};

var formatRelative$1p = function (token, date, baseDate, options) {
  var format = formatRelativeLocale$17[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
};

var formatRelative$1q = formatRelative$1p;

var eraValues$17 = {
  narrow: ['да н.э.', 'н.э.'],
  abbreviated: ['да н. э.', 'н. э.'],
  wide: ['да нашай эры', 'нашай эры']
};
var quarterValues$17 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-ы кв.', '2-і кв.', '3-і кв.', '4-ы кв.'],
  wide: ['1-ы квартал', '2-і квартал', '3-і квартал', '4-ы квартал']
};
var monthValues$17 = {
  narrow: ['С', 'Л', 'С', 'К', 'М', 'Ч', 'Л', 'Ж', 'В', 'К', 'Л', 'С'],
  abbreviated: ['студз.', 'лют.', 'сак.', 'крас.', 'май', 'чэрв.', 'ліп.', 'жн.', 'вер.', 'кастр.', 'ліст.', 'снеж.'],
  wide: ['студзень', 'люты', 'сакавік', 'красавік', 'май', 'чэрвень', 'ліпень', 'жнівень', 'верасень', 'кастрычнік', 'лістапад', 'снежань']
};
var formattingMonthValues$h = {
  narrow: ['С', 'Л', 'С', 'К', 'М', 'Ч', 'Л', 'Ж', 'В', 'К', 'Л', 'С'],
  abbreviated: ['студз.', 'лют.', 'сак.', 'крас.', 'мая', 'чэрв.', 'ліп.', 'жн.', 'вер.', 'кастр.', 'ліст.', 'снеж.'],
  wide: ['студзеня', 'лютага', 'сакавіка', 'красавіка', 'мая', 'чэрвеня', 'ліпеня', 'жніўня', 'верасня', 'кастрычніка', 'лістапада', 'снежня']
};
var dayValues$17 = {
  narrow: ['Н', 'П', 'А', 'С', 'Ч', 'П', 'С'],
  short: ['нд', 'пн', 'аў', 'ср', 'чц', 'пт', 'сб'],
  abbreviated: ['нядз', 'пан', 'аўт', 'сер', 'чац', 'пят', 'суб'],
  wide: ['нядзеля', 'панядзелак', 'аўторак', 'серада', 'чацвер', 'пятніца', 'субота']
};
var dayPeriodValues$16 = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'поўн.',
    noon: 'поўд.',
    morning: 'ран.',
    afternoon: 'дзень',
    evening: 'веч.',
    night: 'ноч'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'поўн.',
    noon: 'поўд.',
    morning: 'ран.',
    afternoon: 'дзень',
    evening: 'веч.',
    night: 'ноч'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'поўнач',
    noon: 'поўдзень',
    morning: 'раніца',
    afternoon: 'дзень',
    evening: 'вечар',
    night: 'ноч'
  }
};
var formattingDayPeriodValues$T = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'поўн.',
    noon: 'поўд.',
    morning: 'ран.',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночы'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'поўн.',
    noon: 'поўд.',
    morning: 'ран.',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночы'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'поўнач',
    noon: 'поўдзень',
    morning: 'раніцы',
    afternoon: 'дня',
    evening: 'вечара',
    night: 'ночы'
  }
};

var ordinalNumber$17 = function (dirtyNumber, dirtyOptions) {
  var options = dirtyOptions || {};
  var unit = String(options.unit);
  var number = Number(dirtyNumber);
  var suffix;
  /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */

  if (unit === 'date') {
    suffix = '-га';
  } else if (unit === 'hour' || unit === 'minute' || unit === 'second') {
    suffix = '-я';
  } else {
    suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? '-і' : '-ы';
  }

  return number + suffix;
};

var localize$2e = {
  ordinalNumber: ordinalNumber$17,
  era: buildLocalizeFn({
    values: eraValues$17,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$17,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$17,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$h,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$17,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$16,
    defaultWidth: 'any',
    formattingValues: formattingDayPeriodValues$T,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2f = localize$2e;

var matchOrdinalNumberPattern$16 = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var parseOrdinalNumberPattern$16 = /\d+/i;
var matchEraPatterns$16 = {
  narrow: /^((да )?н\.?\s?э\.?)/i,
  abbreviated: /^((да )?н\.?\s?э\.?)/i,
  wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var parseEraPatterns$16 = {
  any: [/^д/i, /^н/i]
};
var matchQuarterPatterns$16 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
  wide: /^[1234](-?[ыі]?)? квартал/i
};
var parseQuarterPatterns$16 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$16 = {
  narrow: /^[слкмчжв]/i,
  abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var parseMonthPatterns$16 = {
  narrow: [/^с/i, /^л/i, /^с/i, /^к/i, /^м/i, /^ч/i, /^л/i, /^ж/i, /^в/i, /^к/i, /^л/i, /^с/i],
  any: [/^ст/i, /^лю/i, /^са/i, /^кр/i, /^ма/i, /^ч/i, /^ліп/i, /^ж/i, /^в/i, /^ка/i, /^ліс/i, /^сн/i]
};
var matchDayPatterns$16 = {
  narrow: /^[нпасч]/i,
  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var parseDayPatterns$16 = {
  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
};
var matchDayPeriodPatterns$16 = {
  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var parseDayPeriodPatterns$16 = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^поўн/i,
    noon: /^поўд/i,
    morning: /^р/i,
    afternoon: /^д[зн]/i,
    evening: /^в/i,
    night: /^н/i
  }
};
var match$2c = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$16,
    parsePattern: parseOrdinalNumberPattern$16,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$16,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$16,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$16,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$16,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return Number(index) + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$16,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$16,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$16,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$16,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$16,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns$16,
    defaultParseWidth: 'any'
  })
};
var match$2d = match$2c;

/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
 */

var locale$2w = {
  code: 'be',
  formatDistance: formatDistance$1s,
  formatLong: formatLong$2v,
  formatRelative: formatRelative$1q,
  localize: localize$2f,
  match: match$2d,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$2x = locale$2w;

var formatDistanceLocale$14 = {
  lessThanXSeconds: {
    one: 'по-малко от секунда',
    other: 'по-малко от {{count}} секунди'
  },
  xSeconds: {
    one: '1 секунда',
    other: '{{count}} секунди'
  },
  halfAMinute: 'половин минута',
  lessThanXMinutes: {
    one: 'по-малко от минута',
    other: 'по-малко от {{count}} минути'
  },
  xMinutes: {
    one: '1 минута',
    other: '{{count}} минути'
  },
  aboutXHours: {
    one: 'около час',
    other: 'около {{count}} часа'
  },
  xHours: {
    one: '1 час',
    other: '{{count}} часа'
  },
  xDays: {
    one: '1 ден',
    other: '{{count}} дни'
  },
  aboutXWeeks: {
    one: 'около седмица',
    other: 'около {{count}} седмици'
  },
  xWeeks: {
    one: '1 седмица',
    other: '{{count}} седмици'
  },
  aboutXMonths: {
    one: 'около месец',
    other: 'около {{count}} месеца'
  },
  xMonths: {
    one: '1 месец',
    other: '{{count}} месеца'
  },
  aboutXYears: {
    one: 'около година',
    other: 'около {{count}} години'
  },
  xYears: {
    one: '1 година',
    other: '{{count}} години'
  },
  overXYears: {
    one: 'над година',
    other: 'над {{count}} години'
  },
  almostXYears: {
    one: 'почти година',
    other: 'почти {{count}} години'
  }
};

var formatDistance$1n = function (token, count) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var usageGroup = formatDistanceLocale$14[token];
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else {
    result = usageGroup.other.replace('{{count}}', String(count));
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'след ' + result;
    } else {
      return 'преди ' + result;
    }
  }

  return result;
};

var formatDistance$1o = formatDistance$1n;

var dateFormats$1d = {
  full: 'EEEE, dd MMMM yyyy',
  long: 'dd MMMM yyyy',
  medium: 'dd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats$1d = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$1d = {
  any: '{{date}} {{time}}'
};
var formatLong$2q = {
  date: buildFormatLongFn({
    formats: dateFormats$1d,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1d,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1d,
    defaultWidth: 'any'
  })
};
var formatLong$2r = formatLong$2q;

// Adapted from the `ru` translation
var weekdays$3 = ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота'];

function lastWeek$6(day) {
  var weekday = weekdays$3[day];

  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'миналата " + weekday + " в' p";

    case 1:
    case 2:
    case 4:
    case 5:
      return "'миналия " + weekday + " в' p";
  }
}

function thisWeek$6(day) {
  var weekday = weekdays$3[day];

  if (day === 2
  /* Tue */
  ) {
      return "'във " + weekday + " в' p";
    } else {
    return "'в " + weekday + " в' p";
  }
}

function nextWeek$6(day) {
  var weekday = weekdays$3[day];

  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'следващата " + weekday + " в' p";

    case 1:
    case 2:
    case 4:
    case 5:
      return "'следващия " + weekday + " в' p";
  }
}

var lastWeekFormatToken = function (dirtyDate, baseDate, options) {
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();

  if (isSameUTCWeek(date, baseDate, options)) {
    return thisWeek$6(day);
  } else {
    return lastWeek$6(day);
  }
};

var nextWeekFormatToken = function (dirtyDate, baseDate, options) {
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();

  if (isSameUTCWeek(date, baseDate, options)) {
    return thisWeek$6(day);
  } else {
    return nextWeek$6(day);
  }
};

var formatRelativeLocale$16 = {
  lastWeek: lastWeekFormatToken,
  yesterday: "'вчера в' p",
  today: "'днес в' p",
  tomorrow: "'утре в' p",
  nextWeek: nextWeekFormatToken,
  other: 'P'
};

var formatRelative$1n = function (token, date, baseDate, options) {
  var format = formatRelativeLocale$16[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
};

var formatRelative$1o = formatRelative$1n;

var eraValues$16 = {
  narrow: ['пр.н.е.', 'н.е.'],
  abbreviated: ['преди н. е.', 'н. е.'],
  wide: ['преди новата ера', 'новата ера']
};
var quarterValues$16 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-во тримес.', '2-ро тримес.', '3-то тримес.', '4-то тримес.'],
  wide: ['1-во тримесечие', '2-ро тримесечие', '3-то тримесечие', '4-то тримесечие']
};
var monthValues$16 = {
  abbreviated: ['яну', 'фев', 'мар', 'апр', 'май', 'юни', 'юли', 'авг', 'сеп', 'окт', 'ное', 'дек'],
  wide: ['януари', 'февруари', 'март', 'април', 'май', 'юни', 'юли', 'август', 'септември', 'октомври', 'ноември', 'декември']
};
var dayValues$16 = {
  narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  short: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  abbreviated: ['нед', 'пон', 'вто', 'сря', 'чет', 'пет', 'съб'],
  wide: ['неделя', 'понеделник', 'вторник', 'сряда', 'четвъртък', 'петък', 'събота']
};
var dayPeriodValues$15 = {
  wide: {
    am: 'преди обяд',
    pm: 'след обяд',
    midnight: 'в полунощ',
    noon: 'на обяд',
    morning: 'сутринта',
    afternoon: 'следобед',
    evening: 'вечерта',
    night: 'през нощта'
  }
};

function isFeminine(unit) {
  return unit === 'year' || unit === 'week' || unit === 'minute' || unit === 'second';
}

function isNeuter(unit) {
  return unit === 'quarter';
}

function numberWithSuffix(number, unit, masculine, feminine, neuter) {
  var suffix = isNeuter(unit) ? neuter : isFeminine(unit) ? feminine : masculine;
  return number + '-' + suffix;
}

var ordinalNumber$16 = function (dirtyNumber) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var unit = String(options.unit);
  var number = Number(dirtyNumber);

  if (number === 0) {
    return numberWithSuffix(0, unit, 'ев', 'ева', 'ево');
  } else if (number % 1000 === 0) {
    return numberWithSuffix(number, unit, 'ен', 'на', 'но');
  } else if (number % 100 === 0) {
    return numberWithSuffix(number, unit, 'тен', 'тна', 'тно');
  }

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return numberWithSuffix(number, unit, 'ви', 'ва', 'во');

      case 2:
        return numberWithSuffix(number, unit, 'ри', 'ра', 'ро');

      case 7:
      case 8:
        return numberWithSuffix(number, unit, 'ми', 'ма', 'мо');
    }
  }

  return numberWithSuffix(number, unit, 'ти', 'та', 'то');
};

var localize$2c = {
  ordinalNumber: ordinalNumber$16,
  era: buildLocalizeFn({
    values: eraValues$16,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$16,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$16,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$16,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$15,
    defaultWidth: 'wide'
  })
};
var localize$2d = localize$2c;

var matchOrdinalNumberPattern$15 = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var parseOrdinalNumberPattern$15 = /\d+/i;
var matchEraPatterns$15 = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(преди новата ера|новата ера|нова ера)/i
};
var parseEraPatterns$15 = {
  any: [/^п/i, /^н/i]
};
var matchQuarterPatterns$15 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
  wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var parseQuarterPatterns$15 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchDayPatterns$15 = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var parseDayPatterns$15 = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
};
var matchMonthPatterns$15 = {
  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns$15 = {
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^юн/i, /^юл/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
};
var matchDayPeriodPatterns$15 = {
  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var parseDayPeriodPatterns$15 = {
  any: {
    am: /^преди о/i,
    pm: /^след о/i,
    midnight: /^в пол/i,
    noon: /^на об/i,
    morning: /^сут/i,
    afternoon: /^следо/i,
    evening: /^веч/i,
    night: /^през н/i
  }
};
var match$2a = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$15,
    parsePattern: parseOrdinalNumberPattern$15,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$15,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$15,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$15,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$15,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return Number(index) + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$15,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$15,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$15,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$15,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$15,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$15,
    defaultParseWidth: 'any'
  })
};
var match$2b = match$2a;

/**
 * @type {Locale}
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
 */

var locale$2u = {
  code: 'bg',
  formatDistance: formatDistance$1o,
  formatLong: formatLong$2r,
  formatRelative: formatRelative$1o,
  localize: localize$2d,
  match: match$2b,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$2v = locale$2u;

var numberValues$1 = {
  locale: {
    '1': '১',
    '2': '২',
    '3': '৩',
    '4': '৪',
    '5': '৫',
    '6': '৬',
    '7': '৭',
    '8': '৮',
    '9': '৯',
    '0': '০'
  },
  number: {
    '১': '1',
    '২': '2',
    '৩': '3',
    '৪': '4',
    '৫': '5',
    '৬': '6',
    '৭': '7',
    '৮': '8',
    '৯': '9',
    '০': '0'
  }
};
var eraValues$15 = {
  narrow: ['খ্রিঃপূঃ', 'খ্রিঃ'],
  abbreviated: ['খ্রিঃপূর্ব', 'খ্রিঃ'],
  wide: ['খ্রিস্টপূর্ব', 'খ্রিস্টাব্দ']
};
var quarterValues$15 = {
  narrow: ['১', '২', '৩', '৪'],
  abbreviated: ['১ত্রৈ', '২ত্রৈ', '৩ত্রৈ', '৪ত্রৈ'],
  wide: ['১ম ত্রৈমাসিক', '২য় ত্রৈমাসিক', '৩য় ত্রৈমাসিক', '৪র্থ ত্রৈমাসিক']
};
var monthValues$15 = {
  narrow: ['জানু', 'ফেব্রু', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্ট', 'অক্টো', 'নভে', 'ডিসে'],
  abbreviated: ['জানু', 'ফেব্রু', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্ট', 'অক্টো', 'নভে', 'ডিসে'],
  wide: ['জানুয়ারি', 'ফেব্রুয়ারি', 'মার্চ', 'এপ্রিল', 'মে', 'জুন', 'জুলাই', 'আগস্ট', 'সেপ্টেম্বর', 'অক্টোবর', 'নভেম্বর', 'ডিসেম্বর']
};
var dayValues$15 = {
  narrow: ['র', 'সো', 'ম', 'বু', 'বৃ', 'শু', 'শ'],
  short: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহ', 'শুক্র', 'শনি'],
  abbreviated: ['রবি', 'সোম', 'মঙ্গল', 'বুধ', 'বৃহ', 'শুক্র', 'শনি'],
  wide: ['রবিবার', 'সোমবার', 'মঙ্গলবার', 'বুধবার', 'বৃহস্পতিবার ', 'শুক্রবার', 'শনিবার']
};
var dayPeriodValues$14 = {
  narrow: {
    am: 'পূ',
    pm: 'অপ',
    midnight: 'মধ্যরাত',
    noon: 'মধ্যাহ্ন',
    morning: 'সকাল',
    afternoon: 'বিকাল',
    evening: 'সন্ধ্যা',
    night: 'রাত'
  },
  abbreviated: {
    am: 'পূর্বাহ্ন',
    pm: 'অপরাহ্ন',
    midnight: 'মধ্যরাত',
    noon: 'মধ্যাহ্ন',
    morning: 'সকাল',
    afternoon: 'বিকাল',
    evening: 'সন্ধ্যা',
    night: 'রাত'
  },
  wide: {
    am: 'পূর্বাহ্ন',
    pm: 'অপরাহ্ন',
    midnight: 'মধ্যরাত',
    noon: 'মধ্যাহ্ন',
    morning: 'সকাল',
    afternoon: 'বিকাল',
    evening: 'সন্ধ্যা',
    night: 'রাত'
  }
};
var formattingDayPeriodValues$S = {
  narrow: {
    am: 'পূ',
    pm: 'অপ',
    midnight: 'মধ্যরাত',
    noon: 'মধ্যাহ্ন',
    morning: 'সকাল',
    afternoon: 'বিকাল',
    evening: 'সন্ধ্যা',
    night: 'রাত'
  },
  abbreviated: {
    am: 'পূর্বাহ্ন',
    pm: 'অপরাহ্ন',
    midnight: 'মধ্যরাত',
    noon: 'মধ্যাহ্ন',
    morning: 'সকাল',
    afternoon: 'বিকাল',
    evening: 'সন্ধ্যা',
    night: 'রাত'
  },
  wide: {
    am: 'পূর্বাহ্ন',
    pm: 'অপরাহ্ন',
    midnight: 'মধ্যরাত',
    noon: 'মধ্যাহ্ন',
    morning: 'সকাল',
    afternoon: 'বিকাল',
    evening: 'সন্ধ্যা',
    night: 'রাত'
  }
};

function dateOrdinalNumber(number, localeNumber) {
  if (number > 18 && number <= 31) {
    return localeNumber + 'শে';
  } else {
    switch (number) {
      case 1:
        return localeNumber + 'লা';

      case 2:
      case 3:
        return localeNumber + 'রা';

      case 4:
        return localeNumber + 'ঠা';

      default:
        return localeNumber + 'ই';
    }
  }
}

var ordinalNumber$15 = function (dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);
  var localeNumber = numberToLocale$1(number);
  var unit = dirtyOptions === null || dirtyOptions === void 0 ? void 0 : dirtyOptions.unit;

  if (unit === 'date') {
    return dateOrdinalNumber(number, localeNumber);
  }

  if (number > 10 || number === 0) return localeNumber + 'তম';
  var rem10 = number % 10;

  switch (rem10) {
    case 2:
    case 3:
      return localeNumber + 'য়';

    case 4:
      return localeNumber + 'র্থ';

    case 6:
      return localeNumber + 'ষ্ঠ';

    default:
      return localeNumber + 'ম';
  }
}; // function localeToNumber(locale: string): number {
//   const enNumber = locale.toString().replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
//     return numberValues.number[match as keyof typeof numberValues.number]
//   })
//   return Number(enNumber)
// }


function numberToLocale$1(enNumber) {
  return enNumber.toString().replace(/\d/g, function (match) {
    return numberValues$1.locale[match];
  });
}
var localize$2a = {
  ordinalNumber: ordinalNumber$15,
  era: buildLocalizeFn({
    values: eraValues$15,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$15,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$15,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$15,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$14,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$S,
    defaultFormattingWidth: 'wide'
  })
};
var localize$2b = localize$2a;

var formatDistanceLocale$13 = {
  lessThanXSeconds: {
    one: 'প্রায় ১ সেকেন্ড',
    other: 'প্রায় {{count}} সেকেন্ড'
  },
  xSeconds: {
    one: '১ সেকেন্ড',
    other: '{{count}} সেকেন্ড'
  },
  halfAMinute: 'আধ মিনিট',
  lessThanXMinutes: {
    one: 'প্রায় ১ মিনিট',
    other: 'প্রায় {{count}} মিনিট'
  },
  xMinutes: {
    one: '১ মিনিট',
    other: '{{count}} মিনিট'
  },
  aboutXHours: {
    one: 'প্রায় ১ ঘন্টা',
    other: 'প্রায় {{count}} ঘন্টা'
  },
  xHours: {
    one: '১ ঘন্টা',
    other: '{{count}} ঘন্টা'
  },
  xDays: {
    one: '১ দিন',
    other: '{{count}} দিন'
  },
  aboutXWeeks: {
    one: 'প্রায় ১ সপ্তাহ',
    other: 'প্রায় {{count}} সপ্তাহ'
  },
  xWeeks: {
    one: '১ সপ্তাহ',
    other: '{{count}} সপ্তাহ'
  },
  aboutXMonths: {
    one: 'প্রায় ১ মাস',
    other: 'প্রায় {{count}} মাস'
  },
  xMonths: {
    one: '১ মাস',
    other: '{{count}} মাস'
  },
  aboutXYears: {
    one: 'প্রায় ১ বছর',
    other: 'প্রায় {{count}} বছর'
  },
  xYears: {
    one: '১ বছর',
    other: '{{count}} বছর'
  },
  overXYears: {
    one: '১ বছরের বেশি',
    other: '{{count}} বছরের বেশি'
  },
  almostXYears: {
    one: 'প্রায় ১ বছর',
    other: 'প্রায় {{count}} বছর'
  }
};

var formatDistance$1l = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$13[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', numberToLocale$1(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + ' এর মধ্যে';
    } else {
      return result + ' আগে';
    }
  }

  return result;
};

var formatDistance$1m = formatDistance$1l;

var dateFormats$1c = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1c = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1c = {
  full: "{{date}} {{time}} 'সময়'",
  long: "{{date}} {{time}} 'সময়'",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2o = {
  date: buildFormatLongFn({
    formats: dateFormats$1c,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1c,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1c,
    defaultWidth: 'full'
  })
};
var formatLong$2p = formatLong$2o;

var formatRelativeLocale$15 = {
  lastWeek: "'গত' eeee 'সময়' p",
  yesterday: "'গতকাল' 'সময়' p",
  today: "'আজ' 'সময়' p",
  tomorrow: "'আগামীকাল' 'সময়' p",
  nextWeek: "eeee 'সময়' p",
  other: 'P'
};

var formatRelative$1l = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$15[token];
};

var formatRelative$1m = formatRelative$1l;

var matchOrdinalNumberPattern$14 = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var parseOrdinalNumberPattern$14 = /\d+/i;
var matchEraPatterns$14 = {
  narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
  abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
  wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var parseEraPatterns$14 = {
  narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
  abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
  wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i]
};
var matchQuarterPatterns$14 = {
  narrow: /^[১২৩৪]/i,
  abbreviated: /^[১২৩৪]ত্রৈ/i,
  wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var parseQuarterPatterns$14 = {
  any: [/১/i, /২/i, /৩/i, /৪/i]
};
var matchMonthPatterns$14 = {
  narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var parseMonthPatterns$14 = {
  any: [/^জানু/i, /^ফেব্রু/i, /^মার্চ/i, /^এপ্রিল/i, /^মে/i, /^জুন/i, /^জুলাই/i, /^আগস্ট/i, /^সেপ্ট/i, /^অক্টো/i, /^নভে/i, /^ডিসে/i]
};
var matchDayPatterns$14 = {
  narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
  short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var parseDayPatterns$14 = {
  narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
  short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
  abbreviated: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
  wide: [/^রবিবার/i, /^সোমবার/i, /^মঙ্গলবার/i, /^বুধবার/i, /^বৃহস্পতিবার /i, /^শুক্রবার/i, /^শনিবার/i]
};
var matchDayPeriodPatterns$14 = {
  narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var parseDayPeriodPatterns$14 = {
  any: {
    am: /^পূ/i,
    pm: /^অপ/i,
    midnight: /^মধ্যরাত/i,
    noon: /^মধ্যাহ্ন/i,
    morning: /সকাল/i,
    afternoon: /বিকাল/i,
    evening: /সন্ধ্যা/i,
    night: /রাত/i
  }
};
var match$28 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$14,
    parsePattern: parseOrdinalNumberPattern$14,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$14,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$14,
    defaultParseWidth: 'wide'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$14,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$14,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$14,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$14,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$14,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$14,
    defaultParseWidth: 'wide'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$14,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns$14,
    defaultParseWidth: 'any'
  })
};
var match$29 = match$28;

/**
 * @type {Locale}
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
 */

var locale$2s = {
  code: 'bn',
  formatDistance: formatDistance$1m,
  formatLong: formatLong$2p,
  formatRelative: formatRelative$1m,
  localize: localize$2b,
  match: match$29,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$2t = locale$2s;

var formatDistanceLocale$12 = {
  lessThanXSeconds: {
    one: {
      standalone: 'manje od 1 sekunde',
      withPrepositionAgo: 'manje od 1 sekunde',
      withPrepositionIn: 'manje od 1 sekundu'
    },
    dual: 'manje od {{count}} sekunde',
    other: 'manje od {{count}} sekundi'
  },
  xSeconds: {
    one: {
      standalone: '1 sekunda',
      withPrepositionAgo: '1 sekunde',
      withPrepositionIn: '1 sekundu'
    },
    dual: '{{count}} sekunde',
    other: '{{count}} sekundi'
  },
  halfAMinute: 'pola minute',
  lessThanXMinutes: {
    one: {
      standalone: 'manje od 1 minute',
      withPrepositionAgo: 'manje od 1 minute',
      withPrepositionIn: 'manje od 1 minutu'
    },
    dual: 'manje od {{count}} minute',
    other: 'manje od {{count}} minuta'
  },
  xMinutes: {
    one: {
      standalone: '1 minuta',
      withPrepositionAgo: '1 minute',
      withPrepositionIn: '1 minutu'
    },
    dual: '{{count}} minute',
    other: '{{count}} minuta'
  },
  aboutXHours: {
    one: {
      standalone: 'oko 1 sat',
      withPrepositionAgo: 'oko 1 sat',
      withPrepositionIn: 'oko 1 sat'
    },
    dual: 'oko {{count}} sata',
    other: 'oko {{count}} sati'
  },
  xHours: {
    one: {
      standalone: '1 sat',
      withPrepositionAgo: '1 sat',
      withPrepositionIn: '1 sat'
    },
    dual: '{{count}} sata',
    other: '{{count}} sati'
  },
  xDays: {
    one: {
      standalone: '1 dan',
      withPrepositionAgo: '1 dan',
      withPrepositionIn: '1 dan'
    },
    dual: '{{count}} dana',
    other: '{{count}} dana'
  },
  aboutXWeeks: {
    one: {
      standalone: 'oko 1 sedmicu',
      withPrepositionAgo: 'oko 1 sedmicu',
      withPrepositionIn: 'oko 1 sedmicu'
    },
    dual: 'oko {{count}} sedmice',
    other: 'oko {{count}} sedmice'
  },
  xWeeks: {
    one: {
      standalone: '1 sedmicu',
      withPrepositionAgo: '1 sedmicu',
      withPrepositionIn: '1 sedmicu'
    },
    dual: '{{count}} sedmice',
    other: '{{count}} sedmice'
  },
  aboutXMonths: {
    one: {
      standalone: 'oko 1 mjesec',
      withPrepositionAgo: 'oko 1 mjesec',
      withPrepositionIn: 'oko 1 mjesec'
    },
    dual: 'oko {{count}} mjeseca',
    other: 'oko {{count}} mjeseci'
  },
  xMonths: {
    one: {
      standalone: '1 mjesec',
      withPrepositionAgo: '1 mjesec',
      withPrepositionIn: '1 mjesec'
    },
    dual: '{{count}} mjeseca',
    other: '{{count}} mjeseci'
  },
  aboutXYears: {
    one: {
      standalone: 'oko 1 godinu',
      withPrepositionAgo: 'oko 1 godinu',
      withPrepositionIn: 'oko 1 godinu'
    },
    dual: 'oko {{count}} godine',
    other: 'oko {{count}} godina'
  },
  xYears: {
    one: {
      standalone: '1 godina',
      withPrepositionAgo: '1 godine',
      withPrepositionIn: '1 godinu'
    },
    dual: '{{count}} godine',
    other: '{{count}} godina'
  },
  overXYears: {
    one: {
      standalone: 'preko 1 godinu',
      withPrepositionAgo: 'preko 1 godinu',
      withPrepositionIn: 'preko 1 godinu'
    },
    dual: 'preko {{count}} godine',
    other: 'preko {{count}} godina'
  },
  almostXYears: {
    one: {
      standalone: 'gotovo 1 godinu',
      withPrepositionAgo: 'gotovo 1 godinu',
      withPrepositionIn: 'gotovo 1 godinu'
    },
    dual: 'gotovo {{count}} godine',
    other: 'gotovo {{count}} godina'
  }
};

var formatDistance$1j = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$12[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    if (options !== null && options !== void 0 && options.addSuffix) {
      if (options.comparison && options.comparison > 0) {
        result = tokenValue.one.withPrepositionIn;
      } else {
        result = tokenValue.one.withPrepositionAgo;
      }
    } else {
      result = tokenValue.one.standalone;
    }
  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
  ) {
      result = tokenValue.dual.replace('{{count}}', String(count));
    } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'za ' + result;
    } else {
      return 'prije ' + result;
    }
  }

  return result;
};

var formatDistance$1k = formatDistance$1j;

var dateFormats$1b = {
  full: 'EEEE, d. MMMM yyyy.',
  long: 'd. MMMM yyyy.',
  medium: 'd. MMM yy.',
  short: 'dd. MM. yy.'
};
var timeFormats$1b = {
  full: 'HH:mm:ss (zzzz)',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$1b = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$2m = {
  date: buildFormatLongFn({
    formats: dateFormats$1b,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1b,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1b,
    defaultWidth: 'full'
  })
};
var formatLong$2n = formatLong$2m;

var formatRelativeLocale$14 = {
  lastWeek: function (date) {
    switch (date.getUTCDay()) {
      case 0:
        return "'prošle nedjelje u' p";

      case 3:
        return "'prošle srijede u' p";

      case 6:
        return "'prošle subote u' p";

      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function (date) {
    switch (date.getUTCDay()) {
      case 0:
        return "'sljedeće nedjelje u' p";

      case 3:
        return "'sljedeću srijedu u' p";

      case 6:
        return "'sljedeću subotu u' p";

      default:
        return "'sljedeći' EEEE 'u' p";
    }
  },
  other: 'P'
};

var formatRelative$1j = function (token, date, _baseDate, _options) {
  var format = formatRelativeLocale$14[token];

  if (typeof format === 'function') {
    return format(date);
  }

  return format;
};

var formatRelative$1k = formatRelative$1j;

var eraValues$14 = {
  narrow: ['pr.n.e.', 'AD'],
  abbreviated: ['pr. Hr.', 'po. Hr.'],
  wide: ['Prije Hrista', 'Poslije Hrista']
};
var quarterValues$14 = {
  narrow: ['1.', '2.', '3.', '4.'],
  abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
};
var monthValues$14 = {
  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'juni', 'juli', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
};
var formattingMonthValues$g = {
  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'juni', 'juli', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
};
var dayValues$14 = {
  narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
  short: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
  abbreviated: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
  wide: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota']
};
var dayPeriodValues$13 = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'popodne',
    evening: 'uveče',
    night: 'noću'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'popodne',
    evening: 'uveče',
    night: 'noću'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'poslije podne',
    evening: 'uveče',
    night: 'noću'
  }
};
var formattingDayPeriodValues$R = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'popodne',
    evening: 'uveče',
    night: 'noću'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'popodne',
    evening: 'uveče',
    night: 'noću'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'poslije podne',
    evening: 'uveče',
    night: 'noću'
  }
};

var ordinalNumber$14 = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return String(number) + '.';
};

var localize$28 = {
  ordinalNumber: ordinalNumber$14,
  era: buildLocalizeFn({
    values: eraValues$14,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$14,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$14,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$g,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$14,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$13,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$R,
    defaultFormattingWidth: 'wide'
  })
};
var localize$29 = localize$28;

var matchOrdinalNumberPattern$13 = /^(\d+)\./i;
var parseOrdinalNumberPattern$13 = /\d+/i;
var matchEraPatterns$13 = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var parseEraPatterns$13 = {
  any: [/^pr/i, /^(po|nova)/i]
};
var matchQuarterPatterns$13 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns$13 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$13 = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns$13 = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$13 = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns$13 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$13 = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var parseDayPeriodPatterns$13 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
};
var match$26 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$13,
    parsePattern: parseOrdinalNumberPattern$13,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$13,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$13,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$13,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$13,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$13,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$13,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$13,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$13,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$13,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$13,
    defaultParseWidth: 'any'
  })
};
var match$27 = match$26;

/**
 * @type {Locale}
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
 */

var locale$2q = {
  code: 'bs',
  formatDistance: formatDistance$1k,
  formatLong: formatLong$2n,
  formatRelative: formatRelative$1k,
  localize: localize$29,
  match: match$27,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$2r = locale$2q;

/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */
var formatDistanceLocale$11 = {
  lessThanXSeconds: {
    one: "menys d'un segon",
    eleven: "menys d'onze segons",
    other: 'menys de {{count}} segons'
  },
  xSeconds: {
    one: '1 segon',
    other: '{{count}} segons'
  },
  halfAMinute: 'mig minut',
  lessThanXMinutes: {
    one: "menys d'un minut",
    eleven: "menys d'onze minuts",
    other: 'menys de {{count}} minuts'
  },
  xMinutes: {
    one: '1 minut',
    other: '{{count}} minuts'
  },
  aboutXHours: {
    one: 'aproximadament una hora',
    other: 'aproximadament {{count}} hores'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} hores'
  },
  xDays: {
    one: '1 dia',
    other: '{{count}} dies'
  },
  aboutXWeeks: {
    one: 'aproximadament una setmana',
    other: 'aproximadament {{count}} setmanes'
  },
  xWeeks: {
    one: '1 setmana',
    other: '{{count}} setmanes'
  },
  aboutXMonths: {
    one: 'aproximadament un mes',
    other: 'aproximadament {{count}} mesos'
  },
  xMonths: {
    one: '1 mes',
    other: '{{count}} mesos'
  },
  aboutXYears: {
    one: 'aproximadament un any',
    other: 'aproximadament {{count}} anys'
  },
  xYears: {
    one: '1 any',
    other: '{{count}} anys'
  },
  overXYears: {
    one: "més d'un any",
    eleven: "més d'onze anys",
    other: 'més de {{count}} anys'
  },
  almostXYears: {
    one: 'gairebé un any',
    other: 'gairebé {{count}} anys'
  }
};
function formatDistance$1i(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$11[token] === 'string') {
    result = formatDistanceLocale$11[token];
  } else if (count === 1) {
    result = formatDistanceLocale$11[token].one;
  } else if (count === 11 && formatDistanceLocale$11[token].eleven) {
    result = formatDistanceLocale$11[token].eleven;
  } else {
    result = formatDistanceLocale$11[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'en ' + result;
    } else {
      return 'fa ' + result;
    }
  }

  return result;
}

var dateFormats$1a = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var timeFormats$1a = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$1a = {
  full: "{{date}} 'a les' {{time}}",
  long: "{{date}} 'a les' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2k = {
  date: buildFormatLongFn({
    formats: dateFormats$1a,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1a,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1a,
    defaultWidth: 'full'
  })
};
var formatLong$2l = formatLong$2k;

var formatRelativeLocale$13 = {
  lastWeek: "'el' eeee 'passat a la' LT",
  yesterday: "'ahir a la' p",
  today: "'avui a la' p",
  tomorrow: "'demà a la' p",
  nextWeek: "eeee 'a la' p",
  other: 'P'
};
var formatRelativeLocalePlural$3 = {
  lastWeek: "'el' eeee 'passat a les' p",
  yesterday: "'ahir a les' p",
  today: "'avui a les' p",
  tomorrow: "'demà a les' p",
  nextWeek: "eeee 'a les' p",
  other: 'P'
};
function formatRelative$1i(token, date, _baseDate, _options) {
  if (date.getUTCHours() !== 1) {
    return formatRelativeLocalePlural$3[token];
  }

  return formatRelativeLocale$13[token];
}

/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */

/**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */

var eraValues$13 = {
  narrow: ['aC', 'dC'],
  abbreviated: ['a. de C.', 'd. de C.'],
  wide: ['abans de Crist', 'després de Crist']
};
var quarterValues$13 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1r trimestre', '2n trimestre', '3r trimestre', '4t trimestre']
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */

var monthValues$13 = {
  narrow: ['GN', 'FB', 'MÇ', 'AB', 'MG', 'JN', 'JL', 'AG', 'ST', 'OC', 'NV', 'DS'],

  /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */
  abbreviated: ['gen.', 'febr.', 'març', 'abr.', 'maig', 'juny', 'jul.', 'ag.', 'set.', 'oct.', 'nov.', 'des.'],
  wide: ['gener', 'febrer', 'març', 'abril', 'maig', 'juny', 'juliol', 'agost', 'setembre', 'octubre', 'novembre', 'desembre']
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */

var dayValues$13 = {
  narrow: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
  short: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
  abbreviated: ['dg.', 'dl.', 'dt.', 'dm.', 'dj.', 'dv.', 'ds.'],
  wide: ['diumenge', 'dilluns', 'dimarts', 'dimecres', 'dijous', 'divendres', 'dissabte']
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */

var dayPeriodValues$12 = {
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'mitjanit',
    noon: 'migdia',
    morning: 'matí',
    afternoon: 'tarda',
    evening: 'vespre',
    night: 'nit'
  },
  abbreviated: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'mitjanit',
    noon: 'migdia',
    morning: 'matí',
    afternoon: 'tarda',
    evening: 'vespre',
    night: 'nit'
  },
  wide: {
    am: 'ante meridiem',
    pm: 'post meridiem',
    midnight: 'mitjanit',
    noon: 'migdia',
    morning: 'matí',
    afternoon: 'tarda',
    evening: 'vespre',
    night: 'nit'
  }
};
var formattingDayPeriodValues$Q = {
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'de la mitjanit',
    noon: 'del migdia',
    morning: 'del matí',
    afternoon: 'de la tarda',
    evening: 'del vespre',
    night: 'de la nit'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'de la mitjanit',
    noon: 'del migdia',
    morning: 'del matí',
    afternoon: 'de la tarda',
    evening: 'del vespre',
    night: 'de la nit'
  },
  wide: {
    am: 'ante meridiem',
    pm: 'post meridiem',
    midnight: 'de la mitjanit',
    noon: 'del migdia',
    morning: 'del matí',
    afternoon: 'de la tarda',
    evening: 'del vespre',
    night: 'de la nit'
  }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 *
 * @param {Number} dirtyNumber
 * @param {Object} [_dirtyOptions]
 */

function ordinalNumber$13(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'r';

      case 2:
        return number + 'n';

      case 3:
        return number + 'r';

      case 4:
        return number + 't';
    }
  }

  return number + 'è';
}

var localize$26 = {
  ordinalNumber: ordinalNumber$13,
  era: buildLocalizeFn({
    values: eraValues$13,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$13,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$13,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$13,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$12,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$Q,
    defaultFormattingWidth: 'wide'
  })
};
var localize$27 = localize$26;

var matchOrdinalNumberPattern$12 = /^(\d+)(è|r|n|r|t)?/i;
var parseOrdinalNumberPattern$12 = /\d+/i;
var matchEraPatterns$12 = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a. de C.|d. de C.)/i,
  wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
var parseEraPatterns$12 = {
  narrow: [/^aC/i, /^dC/i],
  abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
  wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i]
};
var matchQuarterPatterns$12 = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](è|r|n|r|t)? trimestre/i
};
var parseQuarterPatterns$12 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$12 = {
  narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
  abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
  wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var parseMonthPatterns$12 = {
  narrow: [/^GN/i, /^FB/i, /^MÇ/i, /^AB/i, /^MG/i, /^JN/i, /^JL/i, /^AG/i, /^ST/i, /^OC/i, /^NV/i, /^DS/i],
  abbreviated: [/^gen./i, /^febr./i, /^març/i, /^abr./i, /^maig/i, /^juny/i, /^jul./i, /^ag./i, /^set./i, /^oct./i, /^nov./i, /^des./i],
  wide: [/^gener/i, /^febrer/i, /^març/i, /^abril/i, /^maig/i, /^juny/i, /^juliol/i, /^agost/i, /^setembre/i, /^octubre/i, /^novembre/i, /^desembre/i]
};
var matchDayPatterns$12 = {
  narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var parseDayPatterns$12 = {
  narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
  abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
  wide: [/^diumenge/i, /^dilluns/i, /^dimarts/i, /^dimecres/i, /^dijous/i, /^divendres/i, /^disssabte/i]
};
var matchDayPeriodPatterns$12 = {
  narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
  abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
  wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var parseDayPeriodPatterns$12 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mitjanit/i,
    noon: /^migdia/i,
    morning: /matí/i,
    afternoon: /tarda/i,
    evening: /vespre/i,
    night: /nit/i
  }
};
var match$24 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$12,
    parsePattern: parseOrdinalNumberPattern$12,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$12,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$12,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$12,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$12,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$12,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$12,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$12,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$12,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$12,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$12,
    defaultParseWidth: 'any'
  })
};
var match$25 = match$24;

/**
 * @type {Locale}
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
 */

var locale$2o = {
  code: 'ca',
  formatDistance: formatDistance$1i,
  formatLong: formatLong$2l,
  formatRelative: formatRelative$1i,
  localize: localize$27,
  match: match$25,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$2p = locale$2o; // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')

var formatDistanceLocale$10 = {
  lessThanXSeconds: {
    one: {
      regular: 'méně než sekunda',
      past: 'před méně než sekundou',
      future: 'za méně než sekundu'
    },
    few: {
      regular: 'méně než {{count}} sekundy',
      past: 'před méně než {{count}} sekundami',
      future: 'za méně než {{count}} sekundy'
    },
    many: {
      regular: 'méně než {{count}} sekund',
      past: 'před méně než {{count}} sekundami',
      future: 'za méně než {{count}} sekund'
    }
  },
  xSeconds: {
    one: {
      regular: 'sekunda',
      past: 'před sekundou',
      future: 'za sekundu'
    },
    few: {
      regular: '{{count}} sekundy',
      past: 'před {{count}} sekundami',
      future: 'za {{count}} sekundy'
    },
    many: {
      regular: '{{count}} sekund',
      past: 'před {{count}} sekundami',
      future: 'za {{count}} sekund'
    }
  },
  halfAMinute: {
    other: {
      regular: 'půl minuty',
      past: 'před půl minutou',
      future: 'za půl minuty'
    }
  },
  lessThanXMinutes: {
    one: {
      regular: 'méně než minuta',
      past: 'před méně než minutou',
      future: 'za méně než minutu'
    },
    few: {
      regular: 'méně než {{count}} minuty',
      past: 'před méně než {{count}} minutami',
      future: 'za méně než {{count}} minuty'
    },
    many: {
      regular: 'méně než {{count}} minut',
      past: 'před méně než {{count}} minutami',
      future: 'za méně než {{count}} minut'
    }
  },
  xMinutes: {
    one: {
      regular: 'minuta',
      past: 'před minutou',
      future: 'za minutu'
    },
    few: {
      regular: '{{count}} minuty',
      past: 'před {{count}} minutami',
      future: 'za {{count}} minuty'
    },
    many: {
      regular: '{{count}} minut',
      past: 'před {{count}} minutami',
      future: 'za {{count}} minut'
    }
  },
  aboutXHours: {
    one: {
      regular: 'přibližně hodina',
      past: 'přibližně před hodinou',
      future: 'přibližně za hodinu'
    },
    few: {
      regular: 'přibližně {{count}} hodiny',
      past: 'přibližně před {{count}} hodinami',
      future: 'přibližně za {{count}} hodiny'
    },
    many: {
      regular: 'přibližně {{count}} hodin',
      past: 'přibližně před {{count}} hodinami',
      future: 'přibližně za {{count}} hodin'
    }
  },
  xHours: {
    one: {
      regular: 'hodina',
      past: 'před hodinou',
      future: 'za hodinu'
    },
    few: {
      regular: '{{count}} hodiny',
      past: 'před {{count}} hodinami',
      future: 'za {{count}} hodiny'
    },
    many: {
      regular: '{{count}} hodin',
      past: 'před {{count}} hodinami',
      future: 'za {{count}} hodin'
    }
  },
  xDays: {
    one: {
      regular: 'den',
      past: 'před dnem',
      future: 'za den'
    },
    few: {
      regular: '{{count}} dny',
      past: 'před {{count}} dny',
      future: 'za {{count}} dny'
    },
    many: {
      regular: '{{count}} dní',
      past: 'před {{count}} dny',
      future: 'za {{count}} dní'
    }
  },
  aboutXWeeks: {
    one: {
      regular: 'přibližně týden',
      past: 'přibližně před týdnem',
      future: 'přibližně za týden'
    },
    few: {
      regular: 'přibližně {{count}} týdny',
      past: 'přibližně před {{count}} týdny',
      future: 'přibližně za {{count}} týdny'
    },
    many: {
      regular: 'přibližně {{count}} týdnů',
      past: 'přibližně před {{count}} týdny',
      future: 'přibližně za {{count}} týdnů'
    }
  },
  xWeeks: {
    one: {
      regular: 'týden',
      past: 'před týdnem',
      future: 'za týden'
    },
    few: {
      regular: '{{count}} týdny',
      past: 'před {{count}} týdny',
      future: 'za {{count}} týdny'
    },
    many: {
      regular: '{{count}} týdnů',
      past: 'před {{count}} týdny',
      future: 'za {{count}} týdnů'
    }
  },
  aboutXMonths: {
    one: {
      regular: 'přibližně měsíc',
      past: 'přibližně před měsícem',
      future: 'přibližně za měsíc'
    },
    few: {
      regular: 'přibližně {{count}} měsíce',
      past: 'přibližně před {{count}} měsíci',
      future: 'přibližně za {{count}} měsíce'
    },
    many: {
      regular: 'přibližně {{count}} měsíců',
      past: 'přibližně před {{count}} měsíci',
      future: 'přibližně za {{count}} měsíců'
    }
  },
  xMonths: {
    one: {
      regular: 'měsíc',
      past: 'před měsícem',
      future: 'za měsíc'
    },
    few: {
      regular: '{{count}} měsíce',
      past: 'před {{count}} měsíci',
      future: 'za {{count}} měsíce'
    },
    many: {
      regular: '{{count}} měsíců',
      past: 'před {{count}} měsíci',
      future: 'za {{count}} měsíců'
    }
  },
  aboutXYears: {
    one: {
      regular: 'přibližně rok',
      past: 'přibližně před rokem',
      future: 'přibližně za rok'
    },
    few: {
      regular: 'přibližně {{count}} roky',
      past: 'přibližně před {{count}} roky',
      future: 'přibližně za {{count}} roky'
    },
    many: {
      regular: 'přibližně {{count}} roků',
      past: 'přibližně před {{count}} roky',
      future: 'přibližně za {{count}} roků'
    }
  },
  xYears: {
    one: {
      regular: 'rok',
      past: 'před rokem',
      future: 'za rok'
    },
    few: {
      regular: '{{count}} roky',
      past: 'před {{count}} roky',
      future: 'za {{count}} roky'
    },
    many: {
      regular: '{{count}} roků',
      past: 'před {{count}} roky',
      future: 'za {{count}} roků'
    }
  },
  overXYears: {
    one: {
      regular: 'více než rok',
      past: 'před více než rokem',
      future: 'za více než rok'
    },
    few: {
      regular: 'více než {{count}} roky',
      past: 'před více než {{count}} roky',
      future: 'za více než {{count}} roky'
    },
    many: {
      regular: 'více než {{count}} roků',
      past: 'před více než {{count}} roky',
      future: 'za více než {{count}} roků'
    }
  },
  almostXYears: {
    one: {
      regular: 'skoro rok',
      past: 'skoro před rokem',
      future: 'skoro za rok'
    },
    few: {
      regular: 'skoro {{count}} roky',
      past: 'skoro před {{count}} roky',
      future: 'skoro za {{count}} roky'
    },
    many: {
      regular: 'skoro {{count}} roků',
      past: 'skoro před {{count}} roky',
      future: 'skoro za {{count}} roků'
    }
  }
};
function formatDistance$1h(token, count, options) {
  options = options || {};
  var scheme = formatDistanceLocale$10[token]; // cs pluralization

  var pluralToken;

  if (typeof scheme.other === 'object') {
    pluralToken = 'other';
  } else if (count === 1) {
    pluralToken = 'one';
  } else if (count > 1 && count < 5) {
    pluralToken = 'few';
  } else {
    pluralToken = 'many';
  } // times


  var suffixExist = options.addSuffix === true;
  var comparison = options.comparison;
  var timeToken;

  if (suffixExist && comparison === -1) {
    timeToken = 'past';
  } else if (suffixExist && comparison === 1) {
    timeToken = 'future';
  } else {
    timeToken = 'regular';
  }

  return scheme[pluralToken][timeToken].replace('{{count}}', count);
}

var dateFormats$19 = {
  full: 'EEEE, d. MMMM yyyy',
  long: 'd. MMMM yyyy',
  medium: 'd. M. yyyy',
  short: 'dd.MM.yyyy'
};
var timeFormats$19 = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$19 = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2i = {
  date: buildFormatLongFn({
    formats: dateFormats$19,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$19,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$19,
    defaultWidth: 'full'
  })
};
var formatLong$2j = formatLong$2i;

var accusativeWeekdays$5 = ['neděli', 'pondělí', 'úterý', 'středu', 'čtvrtek', 'pátek', 'sobotu'];
var formatRelativeLocale$12 = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: function (date, _baseDate, _options) {
    var day = date.getUTCDay();
    return "'v " + accusativeWeekdays$5[day] + " o' p";
  },
  other: 'P'
};
function formatRelative$1h(token, date, baseDate, options) {
  var format = formatRelativeLocale$12[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}

var eraValues$12 = {
  narrow: ['př. n. l.', 'n. l.'],
  abbreviated: ['př. n. l.', 'n. l.'],
  wide: ['před naším letopočtem', 'našeho letopočtu']
};
var quarterValues$12 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1. čtvrtletí', '2. čtvrtletí', '3. čtvrtletí', '4. čtvrtletí'],
  wide: ['1. čtvrtletí', '2. čtvrtletí', '3. čtvrtletí', '4. čtvrtletí']
};
var monthValues$12 = {
  narrow: ['L', 'Ú', 'B', 'D', 'K', 'Č', 'Č', 'S', 'Z', 'Ř', 'L', 'P'],
  abbreviated: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
  wide: ['leden', 'únor', 'březen', 'duben', 'květen', 'červen', 'červenec', 'srpen', 'září', 'říjen', 'listopad', 'prosinec']
};
var formattingMonthValues$f = {
  narrow: ['L', 'Ú', 'B', 'D', 'K', 'Č', 'Č', 'S', 'Z', 'Ř', 'L', 'P'],
  abbreviated: ['led', 'úno', 'bře', 'dub', 'kvě', 'čvn', 'čvc', 'srp', 'zář', 'říj', 'lis', 'pro'],
  wide: ['ledna', 'února', 'března', 'dubna', 'května', 'června', 'července', 'srpna', 'září', 'října', 'listopadu', 'prosince']
};
var dayValues$12 = {
  narrow: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
  short: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
  abbreviated: ['ned', 'pon', 'úte', 'stř', 'čtv', 'pát', 'sob'],
  wide: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota']
};
var dayPeriodValues$11 = {
  narrow: {
    am: 'dop.',
    pm: 'odp.',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  },
  abbreviated: {
    am: 'dop.',
    pm: 'odp.',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  },
  wide: {
    am: 'dopoledne',
    pm: 'odpoledne',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  }
};
var formattingDayPeriodValues$P = {
  narrow: {
    am: 'dop.',
    pm: 'odp.',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  },
  abbreviated: {
    am: 'dop.',
    pm: 'odp.',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  },
  wide: {
    am: 'dopoledne',
    pm: 'odpoledne',
    midnight: 'půlnoc',
    noon: 'poledne',
    morning: 'ráno',
    afternoon: 'odpoledne',
    evening: 'večer',
    night: 'noc'
  }
};

function ordinalNumber$12(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
}

var localize$24 = {
  ordinalNumber: ordinalNumber$12,
  era: buildLocalizeFn({
    values: eraValues$12,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$12,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$12,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$f,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$12,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$11,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$P,
    defaultFormattingWidth: 'wide'
  })
};
var localize$25 = localize$24;

var matchOrdinalNumberPattern$11 = /^(\d+)\.?/i;
var parseOrdinalNumberPattern$11 = /\d+/i;
var matchEraPatterns$11 = {
  narrow: /^(p[řr]ed Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pe[řr]ed Kr\.|pe[řr]ed n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr]ed Kristem|pred na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var parseEraPatterns$11 = {
  any: [/^p[řr]/i, /^(po|n)/i]
};
var matchQuarterPatterns$11 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var parseQuarterPatterns$11 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$11 = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var parseMonthPatterns$11 = {
  narrow: [/^l/i, /^[úu]/i, /^b/i, /^d/i, /^k/i, /^[čc]/i, /^[čc]/i, /^s/i, /^z/i, /^[řr]/i, /^l/i, /^p/i],
  any: [/^led/i, /^[úu]n/i, /^b[řr]e/i, /^dub/i, /^kv[ěe]/i, /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i, /^[čc]vc|[čc]erven(ec|ce)/i, /^srp/i, /^z[áa][řr]/i, /^[řr][íi]j/i, /^lis/i, /^pro/i]
};
var matchDayPatterns$11 = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var parseDayPatterns$11 = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^ut/i, /^st/i, /^[čc]t/i, /^p/i, /^so/i]
};
var matchDayPeriodPatterns$11 = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|půlnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci/i
};
var parseDayPeriodPatterns$11 = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
};
var match$22 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$11,
    parsePattern: parseOrdinalNumberPattern$11,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$11,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$11,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$11,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$11,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$11,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$11,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$11,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$11,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$11,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$11,
    defaultParseWidth: 'any'
  })
};
var match$23 = match$22;

/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */

var locale$2m = {
  code: 'cs',
  formatDistance: formatDistance$1h,
  formatLong: formatLong$2j,
  formatRelative: formatRelative$1h,
  localize: localize$25,
  match: match$23,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$2n = locale$2m;

var formatDistanceLocale$$ = {
  lessThanXSeconds: {
    one: 'llai na eiliad',
    other: 'llai na {{count}} eiliad'
  },
  xSeconds: {
    one: '1 eiliad',
    other: '{{count}} eiliad'
  },
  halfAMinute: 'hanner munud',
  lessThanXMinutes: {
    one: 'llai na munud',
    two: 'llai na 2 funud',
    other: 'llai na {{count}} munud'
  },
  xMinutes: {
    one: '1 munud',
    two: '2 funud',
    other: '{{count}} munud'
  },
  aboutXHours: {
    one: 'tua 1 awr',
    other: 'tua {{count}} awr'
  },
  xHours: {
    one: '1 awr',
    other: '{{count}} awr'
  },
  xDays: {
    one: '1 diwrnod',
    two: '2 ddiwrnod',
    other: '{{count}} diwrnod'
  },
  aboutXWeeks: {
    one: 'tua 1 wythnos',
    two: 'tua pythefnos',
    other: 'tua {{count}} wythnos'
  },
  xWeeks: {
    one: '1 wythnos',
    two: 'pythefnos',
    other: '{{count}} wythnos'
  },
  aboutXMonths: {
    one: 'tua 1 mis',
    two: 'tua 2 fis',
    other: 'tua {{count}} mis'
  },
  xMonths: {
    one: '1 mis',
    two: '2 fis',
    other: '{{count}} mis'
  },
  aboutXYears: {
    one: 'tua 1 flwyddyn',
    two: 'tua 2 flynedd',
    other: 'tua {{count}} mlynedd'
  },
  xYears: {
    one: '1 flwyddyn',
    two: '2 flynedd',
    other: '{{count}} mlynedd'
  },
  overXYears: {
    one: 'dros 1 flwyddyn',
    two: 'dros 2 flynedd',
    other: 'dros {{count}} mlynedd'
  },
  almostXYears: {
    one: 'bron 1 flwyddyn',
    two: 'bron 2 flynedd',
    other: 'bron {{count}} mlynedd'
  }
};
function formatDistance$1g(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$$[token] === 'string') {
    result = formatDistanceLocale$$[token];
  } else if (count === 1) {
    result = formatDistanceLocale$$[token].one;
  } else if (count === 2 && !!formatDistanceLocale$$[token].two) {
    result = formatDistanceLocale$$[token].two;
  } else {
    result = formatDistanceLocale$$[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'mewn ' + result;
    } else {
      return result + ' yn ôl';
    }
  }

  return result;
}

var dateFormats$18 = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats$18 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$18 = {
  full: "{{date}} 'am' {{time}}",
  long: "{{date}} 'am' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2g = {
  date: buildFormatLongFn({
    formats: dateFormats$18,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$18,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$18,
    defaultWidth: 'full'
  })
};
var formatLong$2h = formatLong$2g;

var formatRelativeLocale$11 = {
  lastWeek: "eeee 'diwethaf am' p",
  yesterday: "'ddoe am' p",
  today: "'heddiw am' p",
  tomorrow: "'yfory am' p",
  nextWeek: "eeee 'am' p",
  other: 'P'
};
function formatRelative$1g(token, _date, _baseDate, _options) {
  return formatRelativeLocale$11[token];
}

var eraValues$11 = {
  narrow: ['C', 'O'],
  abbreviated: ['CC', 'OC'],
  wide: ['Cyn Crist', 'Ar ôl Crist']
};
var quarterValues$11 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Ch1', 'Ch2', 'Ch3', 'Ch4'],
  wide: ['Chwarter 1af', '2ail chwarter', '3ydd chwarter', '4ydd chwarter']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$11 = {
  narrow: ['I', 'Ch', 'Ma', 'E', 'Mi', 'Me', 'G', 'A', 'Md', 'H', 'T', 'Rh'],
  abbreviated: ['Ion', 'Chwe', 'Maw', 'Ebr', 'Mai', 'Meh', 'Gor', 'Aws', 'Med', 'Hyd', 'Tach', 'Rhag'],
  wide: ['Ionawr', 'Chwefror', 'Mawrth', 'Ebrill', 'Mai', 'Mehefin', 'Gorffennaf', 'Awst', 'Medi', 'Hydref', 'Tachwedd', 'Rhagfyr']
};
var dayValues$11 = {
  narrow: ['S', 'Ll', 'M', 'M', 'I', 'G', 'S'],
  short: ['Su', 'Ll', 'Ma', 'Me', 'Ia', 'Gw', 'Sa'],
  abbreviated: ['Sul', 'Llun', 'Maw', 'Mer', 'Iau', 'Gwe', 'Sad'],
  wide: ['dydd Sul', 'dydd Llun', 'dydd Mawrth', 'dydd Mercher', 'dydd Iau', 'dydd Gwener', 'dydd Sadwrn']
};
var dayPeriodValues$10 = {
  narrow: {
    am: 'b',
    pm: 'h',
    midnight: 'hn',
    noon: 'hd',
    morning: 'bore',
    afternoon: 'prynhawn',
    evening: "gyda'r nos",
    night: 'nos'
  },
  abbreviated: {
    am: 'yb',
    pm: 'yh',
    midnight: 'hanner nos',
    noon: 'hanner dydd',
    morning: 'bore',
    afternoon: 'prynhawn',
    evening: "gyda'r nos",
    night: 'nos'
  },
  wide: {
    am: 'y.b.',
    pm: 'y.h.',
    midnight: 'hanner nos',
    noon: 'hanner dydd',
    morning: 'bore',
    afternoon: 'prynhawn',
    evening: "gyda'r nos",
    night: 'nos'
  }
};
var formattingDayPeriodValues$O = {
  narrow: {
    am: 'b',
    pm: 'h',
    midnight: 'hn',
    noon: 'hd',
    morning: 'yn y bore',
    afternoon: 'yn y prynhawn',
    evening: "gyda'r nos",
    night: 'yn y nos'
  },
  abbreviated: {
    am: 'yb',
    pm: 'yh',
    midnight: 'hanner nos',
    noon: 'hanner dydd',
    morning: 'yn y bore',
    afternoon: 'yn y prynhawn',
    evening: "gyda'r nos",
    night: 'yn y nos'
  },
  wide: {
    am: 'y.b.',
    pm: 'y.h.',
    midnight: 'hanner nos',
    noon: 'hanner dydd',
    morning: 'yn y bore',
    afternoon: 'yn y prynhawn',
    evening: "gyda'r nos",
    night: 'yn y nos'
  }
};

function ordinalNumber$11(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);

  if (number < 20) {
    switch (number) {
      case 0:
        return number + 'fed';

      case 1:
        return number + 'af';

      case 2:
        return number + 'ail';

      case 3:
      case 4:
        return number + 'ydd';

      case 5:
      case 6:
        return number + 'ed';

      case 7:
      case 8:
      case 9:
      case 10:
      case 12:
      case 15:
      case 18:
        return number + 'fed';

      case 11:
      case 13:
      case 14:
      case 16:
      case 17:
      case 19:
        return number + 'eg';
    }
  } else if (number >= 50 && number <= 60 || number === 80 || number >= 100) {
    return number + 'fed';
  }

  return number + 'ain';
}

var localize$22 = {
  ordinalNumber: ordinalNumber$11,
  era: buildLocalizeFn({
    values: eraValues$11,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$11,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$11,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$11,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$10,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$O,
    defaultFormattingWidth: 'wide'
  })
};
var localize$23 = localize$22;

var matchOrdinalNumberPattern$10 = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var parseOrdinalNumberPattern$10 = /\d+/i;
var matchEraPatterns$10 = {
  narrow: /^(c|o)/i,
  abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
  wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
var parseEraPatterns$10 = {
  wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
  any: [/^c/i, /^o/i]
};
var matchQuarterPatterns$10 = {
  narrow: /^[1234]/i,
  abbreviated: /^ch[1234]/i,
  wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var parseQuarterPatterns$10 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$10 = {
  narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
  abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
  wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var parseMonthPatterns$10 = {
  narrow: [/^i/i, /^ch/i, /^m/i, /^e/i, /^m/i, /^m/i, /^g/i, /^a/i, /^m/i, /^h/i, /^t/i, /^rh/i],
  any: [/^io/i, /^ch/i, /^maw/i, /^e/i, /^mai/i, /^meh/i, /^g/i, /^a/i, /^med/i, /^h/i, /^t/i, /^rh/i]
};
var matchDayPatterns$10 = {
  narrow: /^(s|ll|m|i|g)/i,
  short: /^(su|ll|ma|me|ia|gw|sa)/i,
  abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
  wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var parseDayPatterns$10 = {
  narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
  wide: [/^dydd su/i, /^dydd ll/i, /^dydd ma/i, /^dydd me/i, /^dydd i/i, /^dydd g/i, /^dydd sa/i],
  any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i]
};
var matchDayPeriodPatterns$10 = {
  narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
  any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var parseDayPeriodPatterns$10 = {
  any: {
    am: /^b|(y\.?\s?b\.?)/i,
    pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
    midnight: /^hn|hanner nos/i,
    noon: /^hd|hanner dydd/i,
    morning: /bore/i,
    afternoon: /prynhawn/i,
    evening: /^gyda'r nos$/i,
    night: /blah/i
  }
};
var match$20 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$10,
    parsePattern: parseOrdinalNumberPattern$10,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$10,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$10,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$10,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$10,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$10,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$10,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$10,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$10,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$10,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$10,
    defaultParseWidth: 'any'
  })
};
var match$21 = match$20;

/**
 * @type {Locale}
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
 */

var locale$2k = {
  code: 'cy',
  formatDistance: formatDistance$1g,
  formatLong: formatLong$2h,
  formatRelative: formatRelative$1g,
  localize: localize$23,
  match: match$21,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$2l = locale$2k;

var formatDistanceLocale$_ = {
  lessThanXSeconds: {
    one: 'mindre end ét sekund',
    other: 'mindre end {{count}} sekunder'
  },
  xSeconds: {
    one: '1 sekund',
    other: '{{count}} sekunder'
  },
  halfAMinute: 'ét halvt minut',
  lessThanXMinutes: {
    one: 'mindre end ét minut',
    other: 'mindre end {{count}} minutter'
  },
  xMinutes: {
    one: '1 minut',
    other: '{{count}} minutter'
  },
  aboutXHours: {
    one: 'cirka 1 time',
    other: 'cirka {{count}} timer'
  },
  xHours: {
    one: '1 time',
    other: '{{count}} timer'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dage'
  },
  aboutXWeeks: {
    one: 'cirka 1 uge',
    other: 'cirka {{count}} uger'
  },
  xWeeks: {
    one: '1 uge',
    other: '{{count}} uger'
  },
  aboutXMonths: {
    one: 'cirka 1 måned',
    other: 'cirka {{count}} måneder'
  },
  xMonths: {
    one: '1 måned',
    other: '{{count}} måneder'
  },
  aboutXYears: {
    one: 'cirka 1 år',
    other: 'cirka {{count}} år'
  },
  xYears: {
    one: '1 år',
    other: '{{count}} år'
  },
  overXYears: {
    one: 'over 1 år',
    other: 'over {{count}} år'
  },
  almostXYears: {
    one: 'næsten 1 år',
    other: 'næsten {{count}} år'
  }
};
function formatDistance$1f(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$_[token] === 'string') {
    result = formatDistanceLocale$_[token];
  } else if (count === 1) {
    result = formatDistanceLocale$_[token].one;
  } else {
    result = formatDistanceLocale$_[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'om ' + result;
    } else {
      return result + ' siden';
    }
  }

  return result;
}

var dateFormats$17 = {
  full: "EEEE 'den' d. MMMM y",
  long: 'd. MMMM y',
  medium: 'd. MMM y',
  short: 'dd/MM/y'
};
var timeFormats$17 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$17 = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$2e = {
  date: buildFormatLongFn({
    formats: dateFormats$17,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$17,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$17,
    defaultWidth: 'full'
  })
};
var formatLong$2f = formatLong$2e;

var formatRelativeLocale$10 = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: 'P'
};
function formatRelative$1f(token, _date, _baseDate, _options) {
  return formatRelativeLocale$10[token];
}

var eraValues$10 = {
  narrow: ['fvt', 'vt'],
  abbreviated: ['f.v.t.', 'v.t.'],
  wide: ['før vesterlandsk tidsregning', 'vesterlandsk tidsregning']
};
var quarterValues$10 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1. kvt.', '2. kvt.', '3. kvt.', '4. kvt.'],
  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
};
var monthValues$10 = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december']
}; // Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.

var dayValues$10 = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
  abbreviated: ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'],
  wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
};
var dayPeriodValues$$ = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'morgen',
    afternoon: 'eftermiddag',
    evening: 'aften',
    night: 'nat'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'morgen',
    afternoon: 'eftermiddag',
    evening: 'aften',
    night: 'nat'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'morgen',
    afternoon: 'eftermiddag',
    evening: 'aften',
    night: 'nat'
  }
};
var formattingDayPeriodValues$N = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'om morgenen',
    afternoon: 'om eftermiddagen',
    evening: 'om aftenen',
    night: 'om natten'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'om morgenen',
    afternoon: 'om eftermiddagen',
    evening: 'om aftenen',
    night: 'om natten'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnat',
    noon: 'middag',
    morning: 'om morgenen',
    afternoon: 'om eftermiddagen',
    evening: 'om aftenen',
    night: 'om natten'
  }
};

function ordinalNumber$10(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
}

var localize$20 = {
  ordinalNumber: ordinalNumber$10,
  era: buildLocalizeFn({
    values: eraValues$10,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$10,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$10,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$10,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$$,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$N,
    defaultFormattingWidth: 'wide'
  })
};
var localize$21 = localize$20;

var matchOrdinalNumberPattern$$ = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern$$ = /\d+/i;
var matchEraPatterns$$ = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var parseEraPatterns$$ = {
  any: [/^f/i, /^(v|e)/i]
};
var matchQuarterPatterns$$ = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
};
var parseQuarterPatterns$$ = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$$ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var parseMonthPatterns$$ = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$$ = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns$$ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
var matchDayPeriodPatterns$$ = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var parseDayPeriodPatterns$$ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
};
var match$1_ = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$$,
    parsePattern: parseOrdinalNumberPattern$$,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$$,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$$,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$$,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$$,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$$,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$$,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$$,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$$,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$$,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$$,
    defaultParseWidth: 'any'
  })
};
var match$1$ = match$1_;

/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */

var locale$2i = {
  code: 'da',
  formatDistance: formatDistance$1f,
  formatLong: formatLong$2f,
  formatRelative: formatRelative$1f,
  localize: localize$21,
  match: match$1$,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$2j = locale$2i;

var formatDistanceLocale$Z = {
  lessThanXSeconds: {
    standalone: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    },
    withPreposition: {
      one: 'weniger als 1 Sekunde',
      other: 'weniger als {{count}} Sekunden'
    }
  },
  xSeconds: {
    standalone: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    },
    withPreposition: {
      one: '1 Sekunde',
      other: '{{count}} Sekunden'
    }
  },
  halfAMinute: {
    standalone: 'halbe Minute',
    withPreposition: 'halben Minute'
  },
  lessThanXMinutes: {
    standalone: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    },
    withPreposition: {
      one: 'weniger als 1 Minute',
      other: 'weniger als {{count}} Minuten'
    }
  },
  xMinutes: {
    standalone: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    },
    withPreposition: {
      one: '1 Minute',
      other: '{{count}} Minuten'
    }
  },
  aboutXHours: {
    standalone: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    },
    withPreposition: {
      one: 'etwa 1 Stunde',
      other: 'etwa {{count}} Stunden'
    }
  },
  xHours: {
    standalone: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    },
    withPreposition: {
      one: '1 Stunde',
      other: '{{count}} Stunden'
    }
  },
  xDays: {
    standalone: {
      one: '1 Tag',
      other: '{{count}} Tage'
    },
    withPreposition: {
      one: '1 Tag',
      other: '{{count}} Tagen'
    }
  },
  aboutXWeeks: {
    standalone: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    },
    withPreposition: {
      one: 'etwa 1 Woche',
      other: 'etwa {{count}} Wochen'
    }
  },
  xWeeks: {
    standalone: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    },
    withPreposition: {
      one: '1 Woche',
      other: '{{count}} Wochen'
    }
  },
  aboutXMonths: {
    standalone: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monate'
    },
    withPreposition: {
      one: 'etwa 1 Monat',
      other: 'etwa {{count}} Monaten'
    }
  },
  xMonths: {
    standalone: {
      one: '1 Monat',
      other: '{{count}} Monate'
    },
    withPreposition: {
      one: '1 Monat',
      other: '{{count}} Monaten'
    }
  },
  aboutXYears: {
    standalone: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahre'
    },
    withPreposition: {
      one: 'etwa 1 Jahr',
      other: 'etwa {{count}} Jahren'
    }
  },
  xYears: {
    standalone: {
      one: '1 Jahr',
      other: '{{count}} Jahre'
    },
    withPreposition: {
      one: '1 Jahr',
      other: '{{count}} Jahren'
    }
  },
  overXYears: {
    standalone: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahre'
    },
    withPreposition: {
      one: 'mehr als 1 Jahr',
      other: 'mehr als {{count}} Jahren'
    }
  },
  almostXYears: {
    standalone: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahre'
    },
    withPreposition: {
      one: 'fast 1 Jahr',
      other: 'fast {{count}} Jahren'
    }
  }
};

var formatDistance$1d = function (token, count, options) {
  var result;
  var tokenValue = options !== null && options !== void 0 && options.addSuffix ? formatDistanceLocale$Z[token].withPreposition : formatDistanceLocale$Z[token].standalone;

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return 'vor ' + result;
    }
  }

  return result;
};

var formatDistance$1e = formatDistance$1d;

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var dateFormats$16 = {
  full: 'EEEE, do MMMM y',
  // Montag, 7. Januar 2018
  long: 'do MMMM y',
  // 7. Januar 2018
  medium: 'do MMM y',
  // 7. Jan. 2018
  short: 'dd.MM.y' // 07.01.2018

};
var timeFormats$16 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$16 = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$2c = {
  date: buildFormatLongFn({
    formats: dateFormats$16,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$16,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$16,
    defaultWidth: 'full'
  })
};
var formatLong$2d = formatLong$2c;

var formatRelativeLocale$$ = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: 'P'
};

var formatRelative$1d = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$$[token];
};

var formatRelative$1e = formatRelative$1d;

var eraValues$$ = {
  narrow: ['v.Chr.', 'n.Chr.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['vor Christus', 'nach Christus']
};
var quarterValues$$ = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
}; // Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$$ = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  wide: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
}; // https://st.unicode.org/cldr-apps/v#/de/Gregorian/

var formattingMonthValues$e = {
  narrow: monthValues$$.narrow,
  abbreviated: ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
  wide: monthValues$$.wide
};
var dayValues$$ = {
  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
}; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881

var dayPeriodValues$_ = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachm.',
    evening: 'Abend',
    night: 'Nacht'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  }
};
var formattingDayPeriodValues$M = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachm.',
    evening: 'abends',
    night: 'nachts'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  }
};

var ordinalNumber$$ = function (dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
};

var localize$1_ = {
  ordinalNumber: ordinalNumber$$,
  era: buildLocalizeFn({
    values: eraValues$$,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$$,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$$,
    formattingValues: formattingMonthValues$e,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$$,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$_,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$M,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1$ = localize$1_;

var matchOrdinalNumberPattern$_ = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern$_ = /\d+/i;
var matchEraPatterns$_ = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var parseEraPatterns$_ = {
  any: [/^v/i, /^n/i]
};
var matchQuarterPatterns$_ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns$_ = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$_ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns$_ = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$_ = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var parseDayPatterns$_ = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$_ = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var parseDayPeriodPatterns$_ = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i // will never be matched. Night is matched by `pm`

  }
};
var match$1Y = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$_,
    parsePattern: parseOrdinalNumberPattern$_,
    valueCallback: function (value) {
      return parseInt(value);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$_,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$_,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$_,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$_,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$_,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$_,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$_,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$_,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$_,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns$_,
    defaultParseWidth: 'any'
  })
};
var match$1Z = match$1Y;

/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */
var locale$2g = {
  code: 'de',
  formatDistance: formatDistance$1e,
  formatLong: formatLong$2d,
  formatRelative: formatRelative$1e,
  localize: localize$1$,
  match: match$1Z,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$2h = locale$2g;

var eraValues$_ = {
  narrow: ['v.Chr.', 'n.Chr.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['vor Christus', 'nach Christus']
};
var quarterValues$_ = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
}; // Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$_ = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jän', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  wide: ['Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
}; // https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/

var formattingMonthValues$d = {
  narrow: monthValues$_.narrow,
  abbreviated: ['Jän.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'],
  wide: monthValues$_.wide
};
var dayValues$_ = {
  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  short: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  abbreviated: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
  wide: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag']
}; // https://www.unicode.org/cldr/charts/32/summary/de.html#1881

var dayPeriodValues$Z = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachm.',
    evening: 'Abend',
    night: 'Nacht'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'Morgen',
    afternoon: 'Nachmittag',
    evening: 'Abend',
    night: 'Nacht'
  }
};
var formattingDayPeriodValues$L = {
  narrow: {
    am: 'vm.',
    pm: 'nm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachm.',
    evening: 'abends',
    night: 'nachts'
  },
  abbreviated: {
    am: 'vorm.',
    pm: 'nachm.',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  },
  wide: {
    am: 'vormittags',
    pm: 'nachmittags',
    midnight: 'Mitternacht',
    noon: 'Mittag',
    morning: 'morgens',
    afternoon: 'nachmittags',
    evening: 'abends',
    night: 'nachts'
  }
};

var ordinalNumber$_ = function (dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);
  return number + '.';
};

var localize$1Y = {
  ordinalNumber: ordinalNumber$_,
  era: buildLocalizeFn({
    values: eraValues$_,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$_,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$_,
    formattingValues: formattingMonthValues$d,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$_,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$Z,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$L,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1Z = localize$1Y;

/**
 * @type {Locale}
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
 */

var locale$2e = {
  code: 'de-AT',
  formatDistance: formatDistance$1e,
  formatLong: formatLong$2d,
  formatRelative: formatRelative$1e,
  localize: localize$1Z,
  match: match$1Z,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$2f = locale$2e;

var formatDistanceLocale$Y = {
  lessThanXSeconds: {
    one: 'λιγότερο από ένα δευτερόλεπτο',
    other: 'λιγότερο από {{count}} δευτερόλεπτα'
  },
  xSeconds: {
    one: '1 δευτερόλεπτο',
    other: '{{count}} δευτερόλεπτα'
  },
  halfAMinute: 'μισό λεπτό',
  lessThanXMinutes: {
    one: 'λιγότερο από ένα λεπτό',
    other: 'λιγότερο από {{count}} λεπτά'
  },
  xMinutes: {
    one: '1 λεπτό',
    other: '{{count}} λεπτά'
  },
  aboutXHours: {
    one: 'περίπου 1 ώρα',
    other: 'περίπου {{count}} ώρες'
  },
  xHours: {
    one: '1 ώρα',
    other: '{{count}} ώρες'
  },
  xDays: {
    one: '1 ημέρα',
    other: '{{count}} ημέρες'
  },
  aboutXWeeks: {
    one: 'περίπου 1 εβδομάδα',
    other: 'περίπου {{count}} εβδομάδες'
  },
  xWeeks: {
    one: '1 εβδομάδα',
    other: '{{count}} εβδομάδες'
  },
  aboutXMonths: {
    one: 'περίπου 1 μήνας',
    other: 'περίπου {{count}} μήνες'
  },
  xMonths: {
    one: '1 μήνας',
    other: '{{count}} μήνες'
  },
  aboutXYears: {
    one: 'περίπου 1 χρόνο',
    other: 'περίπου {{count}} χρόνια'
  },
  xYears: {
    one: '1 χρόνο',
    other: '{{count}} χρόνια'
  },
  overXYears: {
    one: 'πάνω από 1 χρόνο',
    other: 'πάνω από {{count}} χρόνια'
  },
  almostXYears: {
    one: 'περίπου 1 χρόνο',
    other: 'περίπου {{count}} χρόνια'
  }
};
function formatDistance$1c(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$Y[token] === 'string') {
    result = formatDistanceLocale$Y[token];
  } else if (count === 1) {
    result = formatDistanceLocale$Y[token].one;
  } else {
    result = formatDistanceLocale$Y[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'σε ' + result;
    } else {
      return result + ' πριν';
    }
  }

  return result;
}

var dateFormats$15 = {
  full: 'EEEE, d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'd/M/yy'
};
var timeFormats$15 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$15 = {
  full: '{{date}} - {{time}}',
  long: '{{date}} - {{time}}',
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2a = {
  date: buildFormatLongFn({
    formats: dateFormats$15,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$15,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$15,
    defaultWidth: 'full'
  })
};
var formatLong$2b = formatLong$2a;

var formatRelativeLocale$_ = {
  lastWeek: function (date) {
    switch (date.getUTCDay()) {
      case 6:
        //Σάββατο
        return "'το προηγούμενο' eeee 'στις' p";

      default:
        return "'την προηγούμενη' eeee 'στις' p";
    }
  },
  yesterday: "'χθες στις' p",
  today: "'σήμερα στις' p",
  tomorrow: "'αύριο στις' p",
  nextWeek: "eeee 'στις' p",
  other: 'P'
};
function formatRelative$1c(token, date, baseDate, options) {
  var format = formatRelativeLocale$_[token];
  if (typeof format === 'function') return format(date, baseDate, options);
  return format;
}

var eraValues$Z = {
  narrow: ['πΧ', 'μΧ'],
  abbreviated: ['π.Χ.', 'μ.Χ.'],
  wide: ['προ Χριστού', 'μετά Χριστόν']
};
var quarterValues$Z = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Τ1', 'Τ2', 'Τ3', 'Τ4'],
  wide: ['1ο τρίμηνο', '2ο τρίμηνο', '3ο τρίμηνο', '4ο τρίμηνο']
};
var monthValues$Z = {
  narrow: ['Ι', 'Φ', 'Μ', 'Α', 'Μ', 'Ι', 'Ι', 'Α', 'Σ', 'Ο', 'Ν', 'Δ'],
  abbreviated: ['Ιαν', 'Φεβ', 'Μάρ', 'Απρ', 'Μάι', 'Ιούν', 'Ιούλ', 'Αύγ', 'Σεπ', 'Οκτ', 'Νοέ', 'Δεκ'],
  wide: ['Ιανουάριος', 'Φεβρουάριος', 'Μάρτιος', 'Απρίλιος', 'Μάιος', 'Ιούνιος', 'Ιούλιος', 'Αύγουστος', 'Σεπτέμβριος', 'Οκτώβριος', 'Νοέμβριος', 'Δεκέμβριος']
};
var formattingMonthValues$c = {
  narrow: ['Ι', 'Φ', 'Μ', 'Α', 'Μ', 'Ι', 'Ι', 'Α', 'Σ', 'Ο', 'Ν', 'Δ'],
  abbreviated: ['Ιαν', 'Φεβ', 'Μαρ', 'Απρ', 'Μαΐ', 'Ιουν', 'Ιουλ', 'Αυγ', 'Σεπ', 'Οκτ', 'Νοε', 'Δεκ'],
  wide: ['Ιανουαρίου', 'Φεβρουαρίου', 'Μαρτίου', 'Απριλίου', 'Μαΐου', 'Ιουνίου', 'Ιουλίου', 'Αυγούστου', 'Σεπτεμβρίου', 'Οκτωβρίου', 'Νοεμβρίου', 'Δεκεμβρίου']
};
var dayValues$Z = {
  narrow: ['Κ', 'Δ', 'T', 'Τ', 'Π', 'Π', 'Σ'],
  short: ['Κυ', 'Δε', 'Τρ', 'Τε', 'Πέ', 'Πα', 'Σά'],
  abbreviated: ['Κυρ', 'Δευ', 'Τρί', 'Τετ', 'Πέμ', 'Παρ', 'Σάβ'],
  wide: ['Κυριακή', 'Δευτέρα', 'Τρίτη', 'Τετάρτη', 'Πέμπτη', 'Παρασκευή', 'Σάββατο']
};
var dayPeriodValues$Y = {
  narrow: {
    am: 'πμ',
    pm: 'μμ',
    midnight: 'μεσάνυχτα',
    noon: 'μεσημέρι',
    morning: 'πρωί',
    afternoon: 'απόγευμα',
    evening: 'βράδυ',
    night: 'νύχτα'
  },
  abbreviated: {
    am: 'π.μ.',
    pm: 'μ.μ.',
    midnight: 'μεσάνυχτα',
    noon: 'μεσημέρι',
    morning: 'πρωί',
    afternoon: 'απόγευμα',
    evening: 'βράδυ',
    night: 'νύχτα'
  },
  wide: {
    am: 'π.μ.',
    pm: 'μ.μ.',
    midnight: 'μεσάνυχτα',
    noon: 'μεσημέρι',
    morning: 'πρωί',
    afternoon: 'απόγευμα',
    evening: 'βράδυ',
    night: 'νύχτα'
  }
};

function ordinalNumber$Z(dirtyNumber, dirtyOptions) {
  var options = dirtyOptions || {};
  var unit = String(options.unit);
  var suffix;

  if (unit === 'year' || unit === 'month') {
    suffix = 'ος';
  } else if (unit === 'week' || unit === 'dayOfYear' || unit === 'day' || unit === 'hour' || unit === 'date') {
    suffix = 'η';
  } else {
    suffix = 'ο';
  }

  return dirtyNumber + suffix;
}

var localize$1W = {
  ordinalNumber: ordinalNumber$Z,
  era: buildLocalizeFn({
    values: eraValues$Z,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$Z,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$Z,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$c,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$Z,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$Y,
    defaultWidth: 'wide'
  })
};
var localize$1X = localize$1W;

var matchOrdinalNumberPattern$Z = /^(\d+)(ος|η|ο)?/i;
var parseOrdinalNumberPattern$Z = /\d+/i;
var matchEraPatterns$Z = {
  narrow: /^(πΧ|μΧ)/i,
  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var parseEraPatterns$Z = {
  any: [/^π/i, /^(μ|κ)/i]
};
var matchQuarterPatterns$Z = {
  narrow: /^[1234]/i,
  abbreviated: /^τ[1234]/i,
  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var parseQuarterPatterns$Z = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$Z = {
  narrow: /^[ιφμαμιιασονδ]/i,
  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var parseMonthPatterns$Z = {
  narrow: [/^ι/i, /^φ/i, /^μ/i, /^α/i, /^μ/i, /^ι/i, /^ι/i, /^α/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i],
  any: [/^ια/i, /^φ/i, /^μ[άα]ρ/i, /^απ/i, /^μ[άα][ιΐ]/i, /^ιο[ύυ]ν/i, /^ιο[ύυ]λ/i, /^α[ύυ]/i, /^σ/i, /^ο/i, /^ν/i, /^δ/i]
};
var matchDayPatterns$Z = {
  narrow: /^[κδτπσ]/i,
  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var parseDayPatterns$Z = {
  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
};
var matchDayPeriodPatterns$Z = {
  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var parseDayPeriodPatterns$Z = {
  any: {
    am: /^πμ|π\.\s?μ\./i,
    pm: /^μμ|μ\.\s?μ\./i,
    midnight: /^μεσάν/i,
    noon: /^μεσημ(έ|ε)/i,
    morning: /πρω(ί|ι)/i,
    afternoon: /απ(ό|ο)γευμα/i,
    evening: /βρ(ά|α)δυ/i,
    night: /ν(ύ|υ)χτα/i
  }
};
var match$1W = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$Z,
    parsePattern: parseOrdinalNumberPattern$Z,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$Z,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$Z,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$Z,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$Z,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$Z,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$Z,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$Z,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$Z,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$Z,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$Z,
    defaultParseWidth: 'any'
  })
};
var match$1X = match$1W;

/**
 * @type {Locale}
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
 */

var locale$2c = {
  code: 'el',
  formatDistance: formatDistance$1c,
  formatLong: formatLong$2b,
  formatRelative: formatRelative$1c,
  localize: localize$1X,
  match: match$1X,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$2d = locale$2c;

var dateFormats$14 = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats$14 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$14 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$28 = {
  date: buildFormatLongFn({
    formats: dateFormats$14,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$14,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$14,
    defaultWidth: 'full'
  })
};
var formatLong$29 = formatLong$28;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */
var locale$2a = {
  code: 'en-AU',
  formatDistance: formatDistance$1q,
  formatLong: formatLong$29,
  formatRelative: formatRelative$1s,
  localize: localize$2h,
  match: match$2f,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$2b = locale$2a;

var formatDistanceLocale$X = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: 'a second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: 'a minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about an hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: 'an hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: 'a day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about a week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: 'a week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about a month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: 'a month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about a year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: 'a year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over a year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost a year',
    other: 'almost {{count}} years'
  }
};

var formatDistance$1a = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$X[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
};

var formatDistance$1b = formatDistance$1a;

var dateFormats$13 = {
  full: 'EEEE, MMMM do, yyyy',
  long: 'MMMM do, yyyy',
  medium: 'MMM d, yyyy',
  short: 'yyyy-MM-dd'
};
var timeFormats$13 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$13 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$26 = {
  date: buildFormatLongFn({
    formats: dateFormats$13,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$13,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$13,
    defaultWidth: 'full'
  })
};
var formatLong$27 = formatLong$26;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
 */

var locale$28 = {
  code: 'en-CA',
  formatDistance: formatDistance$1b,
  formatLong: formatLong$27,
  formatRelative: formatRelative$1s,
  localize: localize$2h,
  match: match$2f,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$29 = locale$28;

var dateFormats$12 = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats$12 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$12 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$24 = {
  date: buildFormatLongFn({
    formats: dateFormats$12,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$12,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$12,
    defaultWidth: 'full'
  })
};
var formatLong$25 = formatLong$24;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */

var locale$26 = {
  code: 'en-GB',
  formatDistance: formatDistance$1q,
  formatLong: formatLong$25,
  formatRelative: formatRelative$1s,
  localize: localize$2h,
  match: match$2f,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$27 = locale$26;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75]{@link https://github.com/tan75}
 */

var locale$24 = {
  code: 'en-IE',
  formatDistance: formatDistance$1q,
  formatLong: formatLong$25,
  formatRelative: formatRelative$1s,
  localize: localize$2h,
  match: match$2f,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$25 = locale$24;

var dateFormats$11 = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM, yyyy',
  medium: 'd MMM, yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats$11 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$11 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$22 = {
  date: buildFormatLongFn({
    formats: dateFormats$11,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$11,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$11,
    defaultWidth: 'full'
  })
};
var formatLong$23 = formatLong$22;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
 */

var locale$22 = {
  code: 'en-IN',
  formatDistance: formatDistance$1q,
  formatLong: formatLong$23,
  formatRelative: formatRelative$1s,
  localize: localize$2h,
  match: match$2f,
  options: {
    weekStartsOn: 1,
    // Monday is the first day of the week.
    firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.

  }
};
var locale$23 = locale$22;

var dateFormats$10 = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats$10 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$10 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$20 = {
  date: buildFormatLongFn({
    formats: dateFormats$10,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$10,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$10,
    defaultWidth: 'full'
  })
};
var formatLong$21 = formatLong$20;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
 */

var locale$20 = {
  code: 'en-NZ',
  formatDistance: formatDistance$1q,
  formatLong: formatLong$21,
  formatRelative: formatRelative$1s,
  localize: localize$2h,
  match: match$2f,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$21 = locale$20;

var dateFormats$$ = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats$$ = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$$ = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1_ = {
  date: buildFormatLongFn({
    formats: dateFormats$$,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$$,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$$,
    defaultWidth: 'full'
  })
};
var formatLong$1$ = formatLong$1_;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
 */

var locale$1_ = {
  code: 'en-ZA',
  formatDistance: formatDistance$1q,
  formatLong: formatLong$1$,
  formatRelative: formatRelative$1s,
  localize: localize$2h,
  match: match$2f,
  options: {
    weekStartsOn: 0,
    // Sunday is the first day of the week.
    firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.

  }
};
var locale$1$ = locale$1_;

var formatDistanceLocale$W = {
  lessThanXSeconds: {
    one: 'malpli ol sekundo',
    other: 'malpli ol {{count}} sekundoj'
  },
  xSeconds: {
    one: '1 sekundo',
    other: '{{count}} sekundoj'
  },
  halfAMinute: 'duonminuto',
  lessThanXMinutes: {
    one: 'malpli ol minuto',
    other: 'malpli ol {{count}} minutoj'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutoj'
  },
  aboutXHours: {
    one: 'proksimume 1 horo',
    other: 'proksimume {{count}} horoj'
  },
  xHours: {
    one: '1 horo',
    other: '{{count}} horoj'
  },
  xDays: {
    one: '1 tago',
    other: '{{count}} tagoj'
  },
  aboutXMonths: {
    one: 'proksimume 1 monato',
    other: 'proksimume {{count}} monatoj'
  },
  xWeeks: {
    one: '1 semajno',
    other: '{{count}} semajnoj'
  },
  aboutXWeeks: {
    one: 'proksimume 1 semajno',
    other: 'proksimume {{count}} semajnoj'
  },
  xMonths: {
    one: '1 monato',
    other: '{{count}} monatoj'
  },
  aboutXYears: {
    one: 'proksimume 1 jaro',
    other: 'proksimume {{count}} jaroj'
  },
  xYears: {
    one: '1 jaro',
    other: '{{count}} jaroj'
  },
  overXYears: {
    one: 'pli ol 1 jaro',
    other: 'pli ol {{count}} jaroj'
  },
  almostXYears: {
    one: 'preskaŭ 1 jaro',
    other: 'preskaŭ {{count}} jaroj'
  }
};

var formatDistance$18 = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$W[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) {
      return 'post ' + result;
    } else {
      return 'antaŭ ' + result;
    }
  }

  return result;
};

var formatDistance$19 = formatDistance$18;

var dateFormats$_ = {
  full: "EEEE, do 'de' MMMM y",
  long: 'y-MMMM-dd',
  medium: 'y-MMM-dd',
  short: 'yyyy-MM-dd'
};
var timeFormats$_ = {
  full: "Ho 'horo kaj' m:ss zzzz",
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$_ = {
  any: '{{date}} {{time}}'
};
var formatLong$1Y = {
  date: buildFormatLongFn({
    formats: dateFormats$_,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$_,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$_,
    defaultWidth: 'any'
  })
};
var formatLong$1Z = formatLong$1Y;

var formatRelativeLocale$Z = {
  lastWeek: "'pasinta' eeee 'je' p",
  yesterday: "'hieraŭ je' p",
  today: "'hodiaŭ je' p",
  tomorrow: "'morgaŭ je' p",
  nextWeek: "eeee 'je' p",
  other: 'P'
};

var formatRelative$1a = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$Z[token];
};

var formatRelative$1b = formatRelative$1a;

var eraValues$Y = {
  narrow: ['aK', 'pK'],
  abbreviated: ['a.K.E.', 'p.K.E.'],
  wide: ['antaŭ Komuna Erao', 'Komuna Erao']
};
var quarterValues$Y = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1-a kvaronjaro', '2-a kvaronjaro', '3-a kvaronjaro', '4-a kvaronjaro']
};
var monthValues$Y = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'aŭg', 'sep', 'okt', 'nov', 'dec'],
  wide: ['januaro', 'februaro', 'marto', 'aprilo', 'majo', 'junio', 'julio', 'aŭgusto', 'septembro', 'oktobro', 'novembro', 'decembro']
};
var dayValues$Y = {
  narrow: ['D', 'L', 'M', 'M', 'Ĵ', 'V', 'S'],
  short: ['di', 'lu', 'ma', 'me', 'ĵa', 've', 'sa'],
  abbreviated: ['dim', 'lun', 'mar', 'mer', 'ĵaŭ', 'ven', 'sab'],
  wide: ['dimanĉo', 'lundo', 'mardo', 'merkredo', 'ĵaŭdo', 'vendredo', 'sabato']
};
var dayPeriodValues$X = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'noktomezo',
    noon: 'tagmezo',
    morning: 'matene',
    afternoon: 'posttagmeze',
    evening: 'vespere',
    night: 'nokte'
  },
  abbreviated: {
    am: 'a.t.m.',
    pm: 'p.t.m.',
    midnight: 'noktomezo',
    noon: 'tagmezo',
    morning: 'matene',
    afternoon: 'posttagmeze',
    evening: 'vespere',
    night: 'nokte'
  },
  wide: {
    am: 'antaŭtagmeze',
    pm: 'posttagmeze',
    midnight: 'noktomezo',
    noon: 'tagmezo',
    morning: 'matene',
    afternoon: 'posttagmeze',
    evening: 'vespere',
    night: 'nokte'
  }
};

var ordinalNumber$Y = function (dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '-a';
};

var localize$1U = {
  ordinalNumber: ordinalNumber$Y,
  era: buildLocalizeFn({
    values: eraValues$Y,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$Y,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$Y,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$Y,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$X,
    defaultWidth: 'wide'
  })
};
var localize$1V = localize$1U;

var matchOrdinalNumberPattern$Y = /^(\d+)(-?a)?/i;
var parseOrdinalNumberPattern$Y = /\d+/i;
var matchEraPatterns$Y = {
  narrow: /^([ap]k)/i,
  abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
  wide: /^((antaǔ |post )?komuna erao)/i
};
var parseEraPatterns$Y = {
  any: [/^a/i, /^[kp]/i]
};
var matchQuarterPatterns$Y = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](-?a)? kvaronjaro/i
};
var parseQuarterPatterns$Y = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$Y = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
  wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var parseMonthPatterns$Y = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^a(u|ŭ)/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$Y = {
  narrow: /^[dlmĵjvs]/i,
  short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
  wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var parseDayPatterns$Y = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i]
};
var matchDayPeriodPatterns$Y = {
  narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var parseDayPeriodPatterns$Y = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^noktom/i,
    noon: /^t/i,
    morning: /^m/i,
    afternoon: /^posttagmeze/i,
    evening: /^v/i,
    night: /^n/i
  }
};
var match$1U = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$Y,
    parsePattern: parseOrdinalNumberPattern$Y,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$Y,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$Y,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$Y,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$Y,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$Y,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$Y,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$Y,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$Y,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$Y,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns$Y,
    defaultParseWidth: 'any'
  })
};
var match$1V = match$1U;

/**
 * @type {Locale}
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */
var locale$1Y = {
  code: 'eo',
  formatDistance: formatDistance$19,
  formatLong: formatLong$1Z,
  formatRelative: formatRelative$1b,
  localize: localize$1V,
  match: match$1V,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1Z = locale$1Y;

var formatDistanceLocale$V = {
  lessThanXSeconds: {
    one: 'menos de un segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'medio minuto',
  lessThanXMinutes: {
    one: 'menos de un minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'alrededor de 1 hora',
    other: 'alrededor de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 día',
    other: '{{count}} días'
  },
  aboutXWeeks: {
    one: 'alrededor de 1 semana',
    other: 'alrededor de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'alrededor de 1 mes',
    other: 'alrededor de {{count}} meses'
  },
  xMonths: {
    one: '1 mes',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'alrededor de 1 año',
    other: 'alrededor de {{count}} años'
  },
  xYears: {
    one: '1 año',
    other: '{{count}} años'
  },
  overXYears: {
    one: 'más de 1 año',
    other: 'más de {{count}} años'
  },
  almostXYears: {
    one: 'casi 1 año',
    other: 'casi {{count}} años'
  }
};

var formatDistance$16 = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$V[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'en ' + result;
    } else {
      return 'hace ' + result;
    }
  }

  return result;
};

var formatDistance$17 = formatDistance$16;

var dateFormats$Z = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var timeFormats$Z = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$Z = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1W = {
  date: buildFormatLongFn({
    formats: dateFormats$Z,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$Z,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$Z,
    defaultWidth: 'full'
  })
};
var formatLong$1X = formatLong$1W;

var formatRelativeLocale$Y = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: 'P'
};
var formatRelativeLocalePlural$2 = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: 'P'
};

var formatRelative$18 = function (token, date, _baseDate, _options) {
  if (date.getUTCHours() !== 1) {
    return formatRelativeLocalePlural$2[token];
  } else {
    return formatRelativeLocale$Y[token];
  }
};

var formatRelative$19 = formatRelative$18;

var eraValues$X = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'después de cristo']
};
var quarterValues$X = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues$X = {
  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
  wide: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']
};
var dayValues$X = {
  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
  short: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
  abbreviated: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  wide: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado']
};
var dayPeriodValues$W = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'mañana',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noche'
  }
};
var formattingDayPeriodValues$K = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoche',
    noon: 'mediodia',
    morning: 'de la mañana',
    afternoon: 'de la tarde',
    evening: 'de la tarde',
    night: 'de la noche'
  }
};

var ordinalNumber$X = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + 'º';
};

var localize$1S = {
  ordinalNumber: ordinalNumber$X,
  era: buildLocalizeFn({
    values: eraValues$X,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$X,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$X,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$X,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$W,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$K,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1T = localize$1S;

var matchOrdinalNumberPattern$X = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern$X = /\d+/i;
var matchEraPatterns$X = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var parseEraPatterns$X = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes de la era com[uú]n)/i, /^(despu[eé]s de cristo|era com[uú]n)/i]
};
var matchQuarterPatterns$X = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns$X = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$X = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var parseMonthPatterns$X = {
  narrow: [/^e/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^en/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i]
};
var matchDayPatterns$X = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var parseDayPatterns$X = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
};
var matchDayPeriodPatterns$X = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var parseDayPeriodPatterns$X = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
};
var match$1S = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$X,
    parsePattern: parseOrdinalNumberPattern$X,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$X,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$X,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$X,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$X,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$X,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$X,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$X,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$X,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$X,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$X,
    defaultParseWidth: 'any'
  })
};
var match$1T = match$1S;

/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */
var locale$1W = {
  code: 'es',
  formatDistance: formatDistance$17,
  formatLong: formatLong$1X,
  formatRelative: formatRelative$19,
  localize: localize$1T,
  match: match$1T,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1X = locale$1W;

var formatDistanceLocale$U = {
  lessThanXSeconds: {
    standalone: {
      one: 'vähem kui üks sekund',
      other: 'vähem kui {{count}} sekundit'
    },
    withPreposition: {
      one: 'vähem kui ühe sekundi',
      other: 'vähem kui {{count}} sekundi'
    }
  },
  xSeconds: {
    standalone: {
      one: 'üks sekund',
      other: '{{count}} sekundit'
    },
    withPreposition: {
      one: 'ühe sekundi',
      other: '{{count}} sekundi'
    }
  },
  halfAMinute: {
    standalone: 'pool minutit',
    withPreposition: 'poole minuti'
  },
  lessThanXMinutes: {
    standalone: {
      one: 'vähem kui üks minut',
      other: 'vähem kui {{count}} minutit'
    },
    withPreposition: {
      one: 'vähem kui ühe minuti',
      other: 'vähem kui {{count}} minuti'
    }
  },
  xMinutes: {
    standalone: {
      one: 'üks minut',
      other: '{{count}} minutit'
    },
    withPreposition: {
      one: 'ühe minuti',
      other: '{{count}} minuti'
    }
  },
  aboutXHours: {
    standalone: {
      one: 'umbes üks tund',
      other: 'umbes {{count}} tundi'
    },
    withPreposition: {
      one: 'umbes ühe tunni',
      other: 'umbes {{count}} tunni'
    }
  },
  xHours: {
    standalone: {
      one: 'üks tund',
      other: '{{count}} tundi'
    },
    withPreposition: {
      one: 'ühe tunni',
      other: '{{count}} tunni'
    }
  },
  xDays: {
    standalone: {
      one: 'üks päev',
      other: '{{count}} päeva'
    },
    withPreposition: {
      one: 'ühe päeva',
      other: '{{count}} päeva'
    }
  },
  aboutXWeeks: {
    standalone: {
      one: 'umbes üks nädal',
      other: 'umbes {{count}} nädalat'
    },
    withPreposition: {
      one: 'umbes ühe nädala',
      other: 'umbes {{count}} nädala'
    }
  },
  xWeeks: {
    standalone: {
      one: 'üks nädal',
      other: '{{count}} nädalat'
    },
    withPreposition: {
      one: 'ühe nädala',
      other: '{{count}} nädala'
    }
  },
  aboutXMonths: {
    standalone: {
      one: 'umbes üks kuu',
      other: 'umbes {{count}} kuud'
    },
    withPreposition: {
      one: 'umbes ühe kuu',
      other: 'umbes {{count}} kuu'
    }
  },
  xMonths: {
    standalone: {
      one: 'üks kuu',
      other: '{{count}} kuud'
    },
    withPreposition: {
      one: 'ühe kuu',
      other: '{{count}} kuu'
    }
  },
  aboutXYears: {
    standalone: {
      one: 'umbes üks aasta',
      other: 'umbes {{count}} aastat'
    },
    withPreposition: {
      one: 'umbes ühe aasta',
      other: 'umbes {{count}} aasta'
    }
  },
  xYears: {
    standalone: {
      one: 'üks aasta',
      other: '{{count}} aastat'
    },
    withPreposition: {
      one: 'ühe aasta',
      other: '{{count}} aasta'
    }
  },
  overXYears: {
    standalone: {
      one: 'rohkem kui üks aasta',
      other: 'rohkem kui {{count}} aastat'
    },
    withPreposition: {
      one: 'rohkem kui ühe aasta',
      other: 'rohkem kui {{count}} aasta'
    }
  },
  almostXYears: {
    standalone: {
      one: 'peaaegu üks aasta',
      other: 'peaaegu {{count}} aastat'
    },
    withPreposition: {
      one: 'peaaegu ühe aasta',
      other: 'peaaegu {{count}} aasta'
    }
  }
};
function formatDistance$15(token, count, options) {
  options = options || {};
  var usageGroup = options.addSuffix ? formatDistanceLocale$U[token].withPreposition : formatDistanceLocale$U[token].standalone;
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else {
    result = usageGroup.other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result + ' pärast';
    } else {
      return result + ' eest';
    }
  }

  return result;
}

var dateFormats$Y = {
  full: 'EEEE, d. MMMM y',
  long: 'd. MMMM y',
  medium: 'd. MMM y',
  short: 'dd.MM.y'
};
var timeFormats$Y = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$Y = {
  full: "{{date}} 'kell' {{time}}",
  long: "{{date}} 'kell' {{time}}",
  medium: '{{date}}. {{time}}',
  short: '{{date}}. {{time}}'
};
var formatLong$1U = {
  date: buildFormatLongFn({
    formats: dateFormats$Y,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$Y,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$Y,
    defaultWidth: 'full'
  })
};
var formatLong$1V = formatLong$1U;

var formatRelativeLocale$X = {
  lastWeek: "'eelmine' eeee 'kell' p",
  yesterday: "'eile kell' p",
  today: "'täna kell' p",
  tomorrow: "'homme kell' p",
  nextWeek: "'järgmine' eeee 'kell' p",
  other: 'P'
};
function formatRelative$17(token, _date, _baseDate, _options) {
  return formatRelativeLocale$X[token];
}

var eraValues$W = {
  narrow: ['e.m.a', 'm.a.j'],
  abbreviated: ['e.m.a', 'm.a.j'],
  wide: ['enne meie ajaarvamist', 'meie ajaarvamise järgi']
};
var quarterValues$W = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
};
var monthValues$W = {
  narrow: ['J', 'V', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jaan', 'veebr', 'märts', 'apr', 'mai', 'juuni', 'juuli', 'aug', 'sept', 'okt', 'nov', 'dets'],
  wide: ['jaanuar', 'veebruar', 'märts', 'aprill', 'mai', 'juuni', 'juuli', 'august', 'september', 'oktoober', 'november', 'detsember']
};
var dayValues$W = {
  narrow: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
  short: ['P', 'E', 'T', 'K', 'N', 'R', 'L'],
  abbreviated: ['pühap.', 'esmasp.', 'teisip.', 'kolmap.', 'neljap.', 'reede.', 'laup.'],
  wide: ['pühapäev', 'esmaspäev', 'teisipäev', 'kolmapäev', 'neljapäev', 'reede', 'laupäev']
};
var dayPeriodValues$V = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'kesköö',
    noon: 'keskpäev',
    morning: 'hommik',
    afternoon: 'pärastlõuna',
    evening: 'õhtu',
    night: 'öö'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'kesköö',
    noon: 'keskpäev',
    morning: 'hommik',
    afternoon: 'pärastlõuna',
    evening: 'õhtu',
    night: 'öö'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'kesköö',
    noon: 'keskpäev',
    morning: 'hommik',
    afternoon: 'pärastlõuna',
    evening: 'õhtu',
    night: 'öö'
  }
};
var formattingDayPeriodValues$J = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'keskööl',
    noon: 'keskpäeval',
    morning: 'hommikul',
    afternoon: 'pärastlõunal',
    evening: 'õhtul',
    night: 'öösel'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'keskööl',
    noon: 'keskpäeval',
    morning: 'hommikul',
    afternoon: 'pärastlõunal',
    evening: 'õhtul',
    night: 'öösel'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'keskööl',
    noon: 'keskpäeval',
    morning: 'hommikul',
    afternoon: 'pärastlõunal',
    evening: 'õhtul',
    night: 'öösel'
  }
};

function ordinalNumber$W(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
}

var localize$1Q = {
  ordinalNumber: ordinalNumber$W,
  era: buildLocalizeFn({
    values: eraValues$W,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$W,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$W,
    formattingValues: monthValues$W,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$W,
    formattingValues: dayValues$W,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$V,
    formattingValues: formattingDayPeriodValues$J,
    defaultWidth: 'wide'
  })
};
var localize$1R = localize$1Q;

var matchOrdinalNumberPattern$W = /^\d+\./i;
var parseOrdinalNumberPattern$W = /\d+/i;
var matchEraPatterns$W = {
  narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var parseEraPatterns$W = {
  any: [/^e/i, /^(m|p)/i]
};
var matchQuarterPatterns$W = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns$W = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$W = {
  narrow: /^[jvmasond]/i,
  abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
  wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var parseMonthPatterns$W = {
  narrow: [/^j/i, /^v/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^v/i, /^mär/i, /^ap/i, /^mai/i, /^juun/i, /^juul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$W = {
  narrow: /^[petknrl]/i,
  short: /^[petknrl]/i,
  abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
  wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var parseDayPatterns$W = {
  any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
};
var matchDayPeriodPatterns$W = {
  any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var parseDayPeriodPatterns$W = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^keskö/i,
    noon: /^keskp/i,
    morning: /hommik/i,
    afternoon: /pärastlõuna/i,
    evening: /õhtu/i,
    night: /öö/i
  }
};
var match$1Q = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$W,
    parsePattern: parseOrdinalNumberPattern$W,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$W,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$W,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$W,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$W,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$W,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$W,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$W,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$W,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$W,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$W,
    defaultParseWidth: 'any'
  })
};
var match$1R = match$1Q;

/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */

var locale$1U = {
  code: 'et',
  formatDistance: formatDistance$15,
  formatLong: formatLong$1V,
  formatRelative: formatRelative$17,
  localize: localize$1R,
  match: match$1R,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1V = locale$1U;

var formatDistanceLocale$T = {
  lessThanXSeconds: {
    one: 'segundo bat baino gutxiago',
    other: '{{count}} segundo baino gutxiago'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundo'
  },
  halfAMinute: 'minutu erdi',
  lessThanXMinutes: {
    one: 'minutu bat baino gutxiago',
    other: '{{count}} minutu baino gutxiago'
  },
  xMinutes: {
    one: '1 minutu',
    other: '{{count}} minutu'
  },
  aboutXHours: {
    one: '1 ordu gutxi gorabehera',
    other: '{{count}} ordu gutxi gorabehera'
  },
  xHours: {
    one: '1 ordu',
    other: '{{count}} ordu'
  },
  xDays: {
    one: '1 egun',
    other: '{{count}} egun'
  },
  aboutXWeeks: {
    one: 'aste 1 inguru',
    other: '{{count}} aste inguru'
  },
  xWeeks: {
    one: '1 aste',
    other: '{{count}} astean'
  },
  aboutXMonths: {
    one: '1 hilabete gutxi gorabehera',
    other: '{{count}} hilabete gutxi gorabehera'
  },
  xMonths: {
    one: '1 hilabete',
    other: '{{count}} hilabete'
  },
  aboutXYears: {
    one: '1 urte gutxi gorabehera',
    other: '{{count}} urte gutxi gorabehera'
  },
  xYears: {
    one: '1 urte',
    other: '{{count}} urte'
  },
  overXYears: {
    one: '1 urte baino gehiago',
    other: '{{count}} urte baino gehiago'
  },
  almostXYears: {
    one: 'ia 1 urte',
    other: 'ia {{count}} urte'
  }
};
function formatDistance$14(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$T[token] === 'string') {
    result = formatDistanceLocale$T[token];
  } else if (count === 1) {
    result = formatDistanceLocale$T[token].one;
  } else {
    result = formatDistanceLocale$T[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'en ' + result;
    } else {
      return 'duela ' + result;
    }
  }

  return result;
}

var dateFormats$X = {
  full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
  long: "y'ko' MMMM'ren' d'a'",
  medium: 'y MMM d',
  short: 'yy/MM/dd'
};
var timeFormats$X = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$X = {
  full: "{{date}} 'tan' {{time}}",
  long: "{{date}} 'tan' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1S = {
  date: buildFormatLongFn({
    formats: dateFormats$X,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$X,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$X,
    defaultWidth: 'full'
  })
};
var formatLong$1T = formatLong$1S;

var formatRelativeLocale$W = {
  lastWeek: "'joan den' eeee, LT",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: 'eeee, p',
  other: 'P'
};
var formatRelativeLocalePlural$1 = {
  lastWeek: "'joan den' eeee, p",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: 'eeee, p',
  other: 'P'
};
function formatRelative$16(token, date, _baseDate, _options) {
  if (date.getUTCHours() !== 1) {
    return formatRelativeLocalePlural$1[token];
  }

  return formatRelativeLocale$W[token];
}

var eraValues$V = {
  narrow: ['k.a.', 'k.o.'],
  abbreviated: ['k.a.', 'k.o.'],
  wide: ['kristo aurretik', 'kristo ondoren']
};
var quarterValues$V = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1H', '2H', '3H', '4H'],
  wide: ['1. hiruhilekoa', '2. hiruhilekoa', '3. hiruhilekoa', '4. hiruhilekoa']
};
var monthValues$V = {
  narrow: ['u', 'o', 'm', 'a', 'm', 'e', 'u', 'a', 'i', 'u', 'a', 'a'],
  abbreviated: ['urt', 'ots', 'mar', 'api', 'mai', 'eka', 'uzt', 'abu', 'ira', 'urr', 'aza', 'abe'],
  wide: ['urtarrila', 'otsaila', 'martxoa', 'apirila', 'maiatza', 'ekaina', 'uztaila', 'abuztua', 'iraila', 'urria', 'azaroa', 'abendua']
};
var dayValues$V = {
  narrow: ['i', 'a', 'a', 'a', 'o', 'o', 'l'],
  short: ['ig', 'al', 'as', 'az', 'og', 'or', 'lr'],
  abbreviated: ['iga', 'ast', 'ast', 'ast', 'ost', 'ost', 'lar'],
  wide: ['igandea', 'astelehena', 'asteartea', 'asteazkena', 'osteguna', 'ostirala', 'larunbata']
};
var dayPeriodValues$U = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'ge',
    noon: 'eg',
    morning: 'goiza',
    afternoon: 'arratsaldea',
    evening: 'arratsaldea',
    night: 'gaua'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'gauerdia',
    noon: 'eguerdia',
    morning: 'goiza',
    afternoon: 'arratsaldea',
    evening: 'arratsaldea',
    night: 'gaua'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'gauerdia',
    noon: 'eguerdia',
    morning: 'goiza',
    afternoon: 'arratsaldea',
    evening: 'arratsaldea',
    night: 'gaua'
  }
};
var formattingDayPeriodValues$I = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'ge',
    noon: 'eg',
    morning: 'goizean',
    afternoon: 'arratsaldean',
    evening: 'arratsaldean',
    night: 'gauean'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'gauerdia',
    noon: 'eguerdia',
    morning: 'goizean',
    afternoon: 'arratsaldean',
    evening: 'arratsaldean',
    night: 'gauean'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'gauerdia',
    noon: 'eguerdia',
    morning: 'goizean',
    afternoon: 'arratsaldean',
    evening: 'arratsaldean',
    night: 'gauean'
  }
};

function ordinalNumber$V(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
}

var localize$1O = {
  ordinalNumber: ordinalNumber$V,
  era: buildLocalizeFn({
    values: eraValues$V,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$V,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$V,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$V,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$U,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$I,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1P = localize$1O;

var matchOrdinalNumberPattern$V = /^(\d+)(.)?/i;
var parseOrdinalNumberPattern$V = /\d+/i;
var matchEraPatterns$V = {
  narrow: /^(k.a.|k.o.)/i,
  abbreviated: /^(k.a.|k.o.)/i,
  wide: /^(kristo aurretik|kristo ondoren)/i
};
var parseEraPatterns$V = {
  narrow: [/^k.a./i, /^k.o./i],
  abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
  wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i]
};
var matchQuarterPatterns$V = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]H/i,
  wide: /^[1234](.)? hiruhilekoa/i
};
var parseQuarterPatterns$V = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$V = {
  narrow: /^[uomaei]/i,
  abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
  wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var parseMonthPatterns$V = {
  narrow: [/^u/i, /^o/i, /^m/i, /^a/i, /^m/i, /^e/i, /^u/i, /^a/i, /^i/i, /^u/i, /^a/i, /^a/i],
  any: [/^urt/i, /^ots/i, /^mar/i, /^api/i, /^mai/i, /^eka/i, /^uzt/i, /^abu/i, /^ira/i, /^urr/i, /^aza/i, /^abe/i]
};
var matchDayPatterns$V = {
  narrow: /^[iaol]/i,
  short: /^(ig|al|as|az|og|or|lr)/i,
  abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
  wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var parseDayPatterns$V = {
  narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
  short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
  abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],
  wide: [/^igandea/i, /^astelehena/i, /^asteartea/i, /^asteazkena/i, /^osteguna/i, /^ostirala/i, /^larunbata/i]
};
var matchDayPeriodPatterns$V = {
  narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
  any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var parseDayPeriodPatterns$V = {
  narrow: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^ge/i,
    noon: /^eg/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i
  },
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^gauerdia/i,
    noon: /^eguerdia/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i
  }
};
var match$1O = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$V,
    parsePattern: parseOrdinalNumberPattern$V,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$V,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$V,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$V,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$V,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$V,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$V,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$V,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$V,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$V,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$V,
    defaultParseWidth: 'any'
  })
};
var match$1P = match$1O;

/**
 * @type {Locale}
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
 */

var locale$1S = {
  code: 'eu',
  formatDistance: formatDistance$14,
  formatLong: formatLong$1T,
  formatRelative: formatRelative$16,
  localize: localize$1P,
  match: match$1P,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1T = locale$1S;

var formatDistanceLocale$S = {
  lessThanXSeconds: {
    one: 'کمتر از یک ثانیه',
    other: 'کمتر از {{count}} ثانیه'
  },
  xSeconds: {
    one: '1 ثانیه',
    other: '{{count}} ثانیه'
  },
  halfAMinute: 'نیم دقیقه',
  lessThanXMinutes: {
    one: 'کمتر از یک دقیقه',
    other: 'کمتر از {{count}} دقیقه'
  },
  xMinutes: {
    one: '1 دقیقه',
    other: '{{count}} دقیقه'
  },
  aboutXHours: {
    one: 'حدود 1 ساعت',
    other: 'حدود {{count}} ساعت'
  },
  xHours: {
    one: '1 ساعت',
    other: '{{count}} ساعت'
  },
  xDays: {
    one: '1 روز',
    other: '{{count}} روز'
  },
  aboutXWeeks: {
    one: 'حدود 1 هفته',
    other: 'حدود {{count}} هفته'
  },
  xWeeks: {
    one: '1 هفته',
    other: '{{count}} هفته'
  },
  aboutXMonths: {
    one: 'حدود 1 ماه',
    other: 'حدود {{count}} ماه'
  },
  xMonths: {
    one: '1 ماه',
    other: '{{count}} ماه'
  },
  aboutXYears: {
    one: 'حدود 1 سال',
    other: 'حدود {{count}} سال'
  },
  xYears: {
    one: '1 سال',
    other: '{{count}} سال'
  },
  overXYears: {
    one: 'بیشتر از 1 سال',
    other: 'بیشتر از {{count}} سال'
  },
  almostXYears: {
    one: 'نزدیک 1 سال',
    other: 'نزدیک {{count}} سال'
  }
};
function formatDistance$13(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$S[token] === 'string') {
    result = formatDistanceLocale$S[token];
  } else if (count === 1) {
    result = formatDistanceLocale$S[token].one;
  } else {
    result = formatDistanceLocale$S[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'در ' + result;
    } else {
      return result + ' قبل';
    }
  }

  return result;
}

var dateFormats$W = {
  full: 'EEEE do MMMM y',
  long: 'do MMMM y',
  medium: 'd MMM y',
  short: 'yyyy/MM/dd'
};
var timeFormats$W = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$W = {
  full: "{{date}} 'در' {{time}}",
  long: "{{date}} 'در' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1Q = {
  date: buildFormatLongFn({
    formats: dateFormats$W,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$W,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$W,
    defaultWidth: 'full'
  })
};
var formatLong$1R = formatLong$1Q;

var formatRelativeLocale$V = {
  lastWeek: "eeee 'گذشته در' p",
  yesterday: "'دیروز در' p",
  today: "'امروز در' p",
  tomorrow: "'فردا در' p",
  nextWeek: "eeee 'در' p",
  other: 'P'
};
function formatRelative$15(token, _date, _baseDate, _options) {
  return formatRelativeLocale$V[token];
}

var eraValues$U = {
  narrow: ['ق', 'ب'],
  abbreviated: ['ق.م.', 'ب.م.'],
  wide: ['قبل از میلاد', 'بعد از میلاد']
};
var quarterValues$U = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['س‌م1', 'س‌م2', 'س‌م3', 'س‌م4'],
  wide: ['سه‌ماهه 1', 'سه‌ماهه 2', 'سه‌ماهه 3', 'سه‌ماهه 4']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$U = {
  narrow: ['ژ', 'ف', 'م', 'آ', 'م', 'ج', 'ج', 'آ', 'س', 'ا', 'ن', 'د'],
  abbreviated: ['ژانـ', 'فور', 'مارس', 'آپر', 'می', 'جون', 'جولـ', 'آگو', 'سپتـ', 'اکتـ', 'نوامـ', 'دسامـ'],
  wide: ['ژانویه', 'فوریه', 'مارس', 'آپریل', 'می', 'جون', 'جولای', 'آگوست', 'سپتامبر', 'اکتبر', 'نوامبر', 'دسامبر']
};
var dayValues$U = {
  narrow: ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
  short: ['1ش', '2ش', '3ش', '4ش', '5ش', 'ج', 'ش'],
  abbreviated: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه'],
  wide: ['یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه', 'شنبه']
};
var dayPeriodValues$T = {
  narrow: {
    am: 'ق',
    pm: 'ب',
    midnight: 'ن',
    noon: 'ظ',
    morning: 'ص',
    afternoon: 'ب.ظ.',
    evening: 'ع',
    night: 'ش'
  },
  abbreviated: {
    am: 'ق.ظ.',
    pm: 'ب.ظ.',
    midnight: 'نیمه‌شب',
    noon: 'ظهر',
    morning: 'صبح',
    afternoon: 'بعدازظهر',
    evening: 'عصر',
    night: 'شب'
  },
  wide: {
    am: 'قبل‌ازظهر',
    pm: 'بعدازظهر',
    midnight: 'نیمه‌شب',
    noon: 'ظهر',
    morning: 'صبح',
    afternoon: 'بعدازظهر',
    evening: 'عصر',
    night: 'شب'
  }
};
var formattingDayPeriodValues$H = {
  narrow: {
    am: 'ق',
    pm: 'ب',
    midnight: 'ن',
    noon: 'ظ',
    morning: 'ص',
    afternoon: 'ب.ظ.',
    evening: 'ع',
    night: 'ش'
  },
  abbreviated: {
    am: 'ق.ظ.',
    pm: 'ب.ظ.',
    midnight: 'نیمه‌شب',
    noon: 'ظهر',
    morning: 'صبح',
    afternoon: 'بعدازظهر',
    evening: 'عصر',
    night: 'شب'
  },
  wide: {
    am: 'قبل‌ازظهر',
    pm: 'بعدازظهر',
    midnight: 'نیمه‌شب',
    noon: 'ظهر',
    morning: 'صبح',
    afternoon: 'بعدازظهر',
    evening: 'عصر',
    night: 'شب'
  }
};

function ordinalNumber$U(dirtyNumber) {
  return String(dirtyNumber);
}

var localize$1M = {
  ordinalNumber: ordinalNumber$U,
  era: buildLocalizeFn({
    values: eraValues$U,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$U,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$U,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$U,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$T,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$H,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1N = localize$1M;

var matchOrdinalNumberPattern$U = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$U = /\d+/i;
var matchEraPatterns$U = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
  wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var parseEraPatterns$U = {
  any: [/^قبل/i, /^بعد/i]
};
var matchQuarterPatterns$U = {
  narrow: /^[1234]/i,
  abbreviated: /^س‌م[1234]/i,
  wide: /^سه‌ماهه [1234]/i
};
var parseQuarterPatterns$U = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$U = {
  narrow: /^[جژفمآاماسند]/i,
  abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
  wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var parseMonthPatterns$U = {
  narrow: [/^(ژ|ج)/i, /^ف/i, /^م/i, /^(آ|ا)/i, /^م/i, /^(ژ|ج)/i, /^(ج|ژ)/i, /^(آ|ا)/i, /^س/i, /^ا/i, /^ن/i, /^د/i],
  any: [/^ژا/i, /^ف/i, /^ما/i, /^آپ/i, /^(می|مه)/i, /^(ژوئن|جون)/i, /^(ژوئی|جول)/i, /^(اوت|آگ)/i, /^س/i, /^(اوک|اک)/i, /^ن/i, /^د/i]
};
var matchDayPatterns$U = {
  narrow: /^[شیدسچپج]/i,
  short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
  abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
  wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var parseDayPatterns$U = {
  narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [/^(ی|1ش|یکشنبه)/i, /^(د|2ش|دوشنبه)/i, /^(س|3ش|سه‌شنبه)/i, /^(چ|4ش|چهارشنبه)/i, /^(پ|5ش|پنجشنبه)/i, /^(ج|جمعه)/i, /^(ش|شنبه)/i]
};
var matchDayPeriodPatterns$U = {
  narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
  abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
  wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var parseDayPeriodPatterns$U = {
  any: {
    am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
    pm: /^(ب|ب.ظ.|بعدازظهر)/i,
    midnight: /^(‌نیمه‌شب|ن)/i,
    noon: /^(ظ|ظهر)/i,
    morning: /(ص|صبح)/i,
    afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
    evening: /(ع|عصر)/i,
    night: /(ش|شب)/i
  }
};
var match$1M = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$U,
    parsePattern: parseOrdinalNumberPattern$U,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$U,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$U,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$U,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$U,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$U,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$U,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$U,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$U,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$U,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$U,
    defaultParseWidth: 'any'
  })
};
var match$1N = match$1M;

/**
 * @type {Locale}
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
 */

var locale$1Q = {
  code: 'fa-IR',
  formatDistance: formatDistance$13,
  formatLong: formatLong$1R,
  formatRelative: formatRelative$15,
  localize: localize$1N,
  match: match$1N,
  options: {
    weekStartsOn: 6
    /* Saturday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1R = locale$1Q;

function futureSeconds(text) {
  return text.replace(/sekuntia?/, 'sekunnin');
}

function futureMinutes(text) {
  return text.replace(/minuuttia?/, 'minuutin');
}

function futureHours(text) {
  return text.replace(/tuntia?/, 'tunnin');
}

function futureDays(text) {
  return text.replace(/päivää?/, 'päivän');
}

function futureWeeks(text) {
  return text.replace(/(viikko|viikkoa)/, 'viikon');
}

function futureMonths(text) {
  return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}

function futureYears(text) {
  return text.replace(/(vuosi|vuotta)/, 'vuoden');
}

var formatDistanceLocale$R = {
  lessThanXSeconds: {
    one: 'alle sekunti',
    other: 'alle {{count}} sekuntia',
    futureTense: futureSeconds
  },
  xSeconds: {
    one: 'sekunti',
    other: '{{count}} sekuntia',
    futureTense: futureSeconds
  },
  halfAMinute: {
    one: 'puoli minuuttia',
    other: 'puoli minuuttia',
    futureTense: function (_text) {
      return 'puolen minuutin';
    }
  },
  lessThanXMinutes: {
    one: 'alle minuutti',
    other: 'alle {{count}} minuuttia',
    futureTense: futureMinutes
  },
  xMinutes: {
    one: 'minuutti',
    other: '{{count}} minuuttia',
    futureTense: futureMinutes
  },
  aboutXHours: {
    one: 'noin tunti',
    other: 'noin {{count}} tuntia',
    futureTense: futureHours
  },
  xHours: {
    one: 'tunti',
    other: '{{count}} tuntia',
    futureTense: futureHours
  },
  xDays: {
    one: 'päivä',
    other: '{{count}} päivää',
    futureTense: futureDays
  },
  aboutXWeeks: {
    one: 'noin viikko',
    other: 'noin {{count}} viikkoa',
    futureTense: futureWeeks
  },
  xWeeks: {
    one: 'viikko',
    other: '{{count}} viikkoa',
    futureTense: futureWeeks
  },
  aboutXMonths: {
    one: 'noin kuukausi',
    other: 'noin {{count}} kuukautta',
    futureTense: futureMonths
  },
  xMonths: {
    one: 'kuukausi',
    other: '{{count}} kuukautta',
    futureTense: futureMonths
  },
  aboutXYears: {
    one: 'noin vuosi',
    other: 'noin {{count}} vuotta',
    futureTense: futureYears
  },
  xYears: {
    one: 'vuosi',
    other: '{{count}} vuotta',
    futureTense: futureYears
  },
  overXYears: {
    one: 'yli vuosi',
    other: 'yli {{count}} vuotta',
    futureTense: futureYears
  },
  almostXYears: {
    one: 'lähes vuosi',
    other: 'lähes {{count}} vuotta',
    futureTense: futureYears
  }
};
function formatDistance$12(token, count, options) {
  options = options || {};
  var distance = formatDistanceLocale$R[token];
  var result = count === 1 ? distance.one : distance.other.replace('{{count}}', count);

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return distance.futureTense(result) + ' kuluttua';
    } else {
      return result + ' sitten';
    }
  }

  return result;
}

var dateFormats$V = {
  full: 'eeee d. MMMM y',
  long: 'd. MMMM y',
  medium: 'd. MMM y',
  short: 'd.M.y'
};
var timeFormats$V = {
  full: 'HH.mm.ss zzzz',
  long: 'HH.mm.ss z',
  medium: 'HH.mm.ss',
  short: 'HH.mm'
};
var dateTimeFormats$V = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$1O = {
  date: buildFormatLongFn({
    formats: dateFormats$V,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$V,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$V,
    defaultWidth: 'full'
  })
};
var formatLong$1P = formatLong$1O;

var formatRelativeLocale$U = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'tänään klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: 'P'
};
function formatRelative$14(token, _date, _baseDate, _options) {
  return formatRelativeLocale$U[token];
}

var eraValues$T = {
  narrow: ['eaa.', 'jaa.'],
  abbreviated: ['eaa.', 'jaa.'],
  wide: ['ennen ajanlaskun alkua', 'jälkeen ajanlaskun alun']
};
var quarterValues$T = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. kvartaali', '2. kvartaali', '3. kvartaali', '4. kvartaali']
};
var monthValues$T = {
  narrow: ['T', 'H', 'M', 'H', 'T', 'K', 'H', 'E', 'S', 'L', 'M', 'J'],
  abbreviated: ['tammi', 'helmi', 'maalis', 'huhti', 'touko', 'kesä', 'heinä', 'elo', 'syys', 'loka', 'marras', 'joulu'],
  wide: ['tammikuu', 'helmikuu', 'maaliskuu', 'huhtikuu', 'toukokuu', 'kesäkuu', 'heinäkuu', 'elokuu', 'syyskuu', 'lokakuu', 'marraskuu', 'joulukuu']
};
var formattingMonthValues$b = {
  narrow: monthValues$T.narrow,
  abbreviated: monthValues$T.abbreviated,
  wide: monthValues$T.wide.map(function (name) {
    return name + 'ta';
  })
};
var dayValues$T = {
  narrow: ['S', 'M', 'T', 'K', 'T', 'P', 'L'],
  short: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
  abbreviated: ['sunn.', 'maan.', 'tiis.', 'kesk.', 'torst.', 'perj.', 'la'],
  wide: ['sunnuntai', 'maanantai', 'tiistai', 'keskiviikko', 'torstai', 'perjantai', 'lauantai']
};
var formattingDayValues$3 = {
  narrow: dayValues$T.narrow,
  short: dayValues$T.short,
  abbreviated: dayValues$T.abbreviated,
  wide: dayValues$T.wide.map(function (name) {
    return name + 'na';
  })
};
var dayPeriodValues$S = {
  narrow: {
    am: 'ap',
    pm: 'ip',
    midnight: 'keskiyö',
    noon: 'keskipäivä',
    morning: 'ap',
    afternoon: 'ip',
    evening: 'illalla',
    night: 'yöllä'
  },
  abbreviated: {
    am: 'ap',
    pm: 'ip',
    midnight: 'keskiyö',
    noon: 'keskipäivä',
    morning: 'ap',
    afternoon: 'ip',
    evening: 'illalla',
    night: 'yöllä'
  },
  wide: {
    am: 'ap',
    pm: 'ip',
    midnight: 'keskiyöllä',
    noon: 'keskipäivällä',
    morning: 'aamupäivällä',
    afternoon: 'iltapäivällä',
    evening: 'illalla',
    night: 'yöllä'
  }
};

function ordinalNumber$T(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
}

var localize$1K = {
  ordinalNumber: ordinalNumber$T,
  era: buildLocalizeFn({
    values: eraValues$T,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$T,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$T,
    formattingValues: formattingMonthValues$b,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$T,
    formattingValues: formattingDayValues$3,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$S,
    defaultWidth: 'wide'
  })
};
var localize$1L = localize$1K;

var matchOrdinalNumberPattern$T = /^(\d+)(\.)/i;
var parseOrdinalNumberPattern$T = /\d+/i;
var matchEraPatterns$T = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var parseEraPatterns$T = {
  any: [/^e/i, /^j/i]
};
var matchQuarterPatterns$T = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
};
var parseQuarterPatterns$T = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$T = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var parseMonthPatterns$T = {
  narrow: [/^t/i, /^h/i, /^m/i, /^h/i, /^t/i, /^k/i, /^h/i, /^e/i, /^s/i, /^l/i, /^m/i, /^j/i],
  any: [/^ta/i, /^hel/i, /^maa/i, /^hu/i, /^to/i, /^k/i, /^hei/i, /^e/i, /^s/i, /^l/i, /^mar/i, /^j/i]
};
var matchDayPatterns$T = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var parseDayPatterns$T = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
};
var matchDayPeriodPatterns$T = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var parseDayPeriodPatterns$T = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
};
var match$1K = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$T,
    parsePattern: parseOrdinalNumberPattern$T,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$T,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$T,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$T,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$T,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$T,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$T,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$T,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$T,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$T,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$T,
    defaultParseWidth: 'any'
  })
};
var match$1L = match$1K;

/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */

var locale$1O = {
  code: 'fi',
  formatDistance: formatDistance$12,
  formatLong: formatLong$1P,
  formatRelative: formatRelative$14,
  localize: localize$1L,
  match: match$1L,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1P = locale$1O;

var formatDistanceLocale$Q = {
  lessThanXSeconds: {
    one: 'moins d’une seconde',
    other: 'moins de {{count}} secondes'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} secondes'
  },
  halfAMinute: '30 secondes',
  lessThanXMinutes: {
    one: 'moins d’une minute',
    other: 'moins de {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'environ 1 heure',
    other: 'environ {{count}} heures'
  },
  xHours: {
    one: '1 heure',
    other: '{{count}} heures'
  },
  xDays: {
    one: '1 jour',
    other: '{{count}} jours'
  },
  aboutXWeeks: {
    one: 'environ 1 semaine',
    other: 'environ {{count}} semaines'
  },
  xWeeks: {
    one: '1 semaine',
    other: '{{count}} semaines'
  },
  aboutXMonths: {
    one: 'environ 1 mois',
    other: 'environ {{count}} mois'
  },
  xMonths: {
    one: '1 mois',
    other: '{{count}} mois'
  },
  aboutXYears: {
    one: 'environ 1 an',
    other: 'environ {{count}} ans'
  },
  xYears: {
    one: '1 an',
    other: '{{count}} ans'
  },
  overXYears: {
    one: 'plus d’un an',
    other: 'plus de {{count}} ans'
  },
  almostXYears: {
    one: 'presqu’un an',
    other: 'presque {{count}} ans'
  }
};

var formatDistance$10 = function (token, count, options) {
  var result;
  var form = formatDistanceLocale$Q[token];

  if (typeof form === 'string') {
    result = form;
  } else if (count === 1) {
    result = form.one;
  } else {
    result = form.other.replace('{{count}}', String(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'dans ' + result;
    } else {
      return 'il y a ' + result;
    }
  }

  return result;
};

var formatDistance$11 = formatDistance$10;

var dateFormats$U = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var timeFormats$U = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$U = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1M = {
  date: buildFormatLongFn({
    formats: dateFormats$U,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$U,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$U,
    defaultWidth: 'full'
  })
};
var formatLong$1N = formatLong$1M;

var formatRelativeLocale$T = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: 'P'
};

var formatRelative$12 = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$T[token];
};

var formatRelative$13 = formatRelative$12;

var eraValues$S = {
  narrow: ['av. J.-C', 'ap. J.-C'],
  abbreviated: ['av. J.-C', 'ap. J.-C'],
  wide: ['avant Jésus-Christ', 'après Jésus-Christ']
};
var quarterValues$S = {
  narrow: ['T1', 'T2', 'T3', 'T4'],
  abbreviated: ['1er trim.', '2ème trim.', '3ème trim.', '4ème trim.'],
  wide: ['1er trimestre', '2ème trimestre', '3ème trimestre', '4ème trimestre']
};
var monthValues$S = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'],
  wide: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']
};
var dayValues$S = {
  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  short: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
  abbreviated: ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'],
  wide: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi']
};
var dayPeriodValues$R = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'mat.',
    afternoon: 'ap.m.',
    evening: 'soir',
    night: 'mat.'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'matin',
    afternoon: 'après-midi',
    evening: 'soir',
    night: 'matin'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minuit',
    noon: 'midi',
    morning: 'du matin',
    afternoon: 'de l’après-midi',
    evening: 'du soir',
    night: 'du matin'
  }
};

var ordinalNumber$S = function (dirtyNumber, options) {
  var number = Number(dirtyNumber);
  var unit = options === null || options === void 0 ? void 0 : options.unit;
  if (number === 0) return '0';
  var feminineUnits = ['year', 'week', 'hour', 'minute', 'second'];
  var suffix;

  if (number === 1) {
    suffix = unit && feminineUnits.includes(unit) ? 'ère' : 'er';
  } else {
    suffix = 'ème';
  }

  return number + suffix;
};

var localize$1I = {
  ordinalNumber: ordinalNumber$S,
  era: buildLocalizeFn({
    values: eraValues$S,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$S,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$S,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$S,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$R,
    defaultWidth: 'wide'
  })
};
var localize$1J = localize$1I;

var matchOrdinalNumberPattern$S = /^(\d+)(ième|ère|ème|er|e)?/i;
var parseOrdinalNumberPattern$S = /\d+/i;
var matchEraPatterns$S = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var parseEraPatterns$S = {
  any: [/^av/i, /^ap/i]
};
var matchQuarterPatterns$S = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
};
var parseQuarterPatterns$S = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$S = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var parseMonthPatterns$S = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$S = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var parseDayPatterns$S = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
};
var matchDayPeriodPatterns$S = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var parseDayPeriodPatterns$S = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
};
var match$1I = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$S,
    parsePattern: parseOrdinalNumberPattern$S,
    valueCallback: function (value) {
      return parseInt(value);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$S,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$S,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$S,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$S,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$S,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$S,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$S,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$S,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$S,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$S,
    defaultParseWidth: 'any'
  })
};
var match$1J = match$1I;

/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */

var locale$1M = {
  code: 'fr',
  formatDistance: formatDistance$11,
  formatLong: formatLong$1N,
  formatRelative: formatRelative$13,
  localize: localize$1J,
  match: match$1J,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1N = locale$1M;

var dateFormats$T = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'yy-MM-dd'
};
var timeFormats$T = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$T = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1K = {
  date: buildFormatLongFn({
    formats: dateFormats$T,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$T,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$T,
    defaultWidth: 'full'
  })
};
var formatLong$1L = formatLong$1K;

// Same as fr
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
 */

var locale$1K = {
  code: 'fr-CA',
  formatDistance: formatDistance$11,
  formatLong: formatLong$1L,
  formatRelative: formatRelative$13,
  localize: localize$1J,
  match: match$1J,
  // Unique for fr-CA
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1L = locale$1K;

var dateFormats$S = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd.MM.y'
};
var timeFormats$S = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$S = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1I = {
  date: buildFormatLongFn({
    formats: dateFormats$S,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$S,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$S,
    defaultWidth: 'full'
  })
};
var formatLong$1J = formatLong$1I;

var formatRelativeLocale$S = {
  lastWeek: "eeee 'la semaine dernière à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'la semaine prochaine à' p",
  other: 'P'
};

var formatRelative$10 = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$S[token];
};

var formatRelative$11 = formatRelative$10;

// Same as fr
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */

var locale$1I = {
  code: 'fr-CH',
  formatDistance: formatDistance$11,
  formatLong: formatLong$1J,
  formatRelative: formatRelative$11,
  localize: localize$1J,
  match: match$1J,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1J = locale$1I;

var formatDistanceLocale$P = {
  lessThanXSeconds: {
    one: 'minder as 1 sekonde',
    other: 'minder as {{count}} sekonden'
  },
  xSeconds: {
    one: '1 sekonde',
    other: '{{count}} sekonden'
  },
  halfAMinute: 'oardel minút',
  lessThanXMinutes: {
    one: 'minder as 1 minút',
    other: 'minder as {{count}} minuten'
  },
  xMinutes: {
    one: '1 minút',
    other: '{{count}} minuten'
  },
  aboutXHours: {
    one: 'sawat 1 oere',
    other: 'sawat {{count}} oere'
  },
  xHours: {
    one: '1 oere',
    other: '{{count}} oere'
  },
  xDays: {
    one: '1 dei',
    other: '{{count}} dagen'
  },
  aboutXWeeks: {
    one: 'sawat 1 wike',
    other: 'sawat {{count}} wiken'
  },
  xWeeks: {
    one: '1 wike',
    other: '{{count}} wiken'
  },
  aboutXMonths: {
    one: 'sawat 1 moanne',
    other: 'sawat {{count}} moannen'
  },
  xMonths: {
    one: '1 moanne',
    other: '{{count}} moannen'
  },
  aboutXYears: {
    one: 'sawat 1 jier',
    other: 'sawat {{count}} jier'
  },
  xYears: {
    one: '1 jier',
    other: '{{count}} jier'
  },
  overXYears: {
    one: 'mear as 1 jier',
    other: 'mear as {{count}}s jier'
  },
  almostXYears: {
    one: 'hast 1 jier',
    other: 'hast {{count}} jier'
  }
};
function formatDistance$$(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$P[token] === 'string') {
    result = formatDistanceLocale$P[token];
  } else if (count === 1) {
    result = formatDistanceLocale$P[token].one;
  } else {
    result = formatDistanceLocale$P[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'oer ' + result;
    } else {
      return result + ' lyn';
    }
  }

  return result;
}

var dateFormats$R = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd-MM-y'
};
var timeFormats$R = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$R = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1G = {
  date: buildFormatLongFn({
    formats: dateFormats$R,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$R,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$R,
    defaultWidth: 'full'
  })
};
var formatLong$1H = formatLong$1G;

var formatRelativeLocale$R = {
  lastWeek: "'ôfrûne' eeee 'om' p",
  yesterday: "'juster om' p",
  today: "'hjoed om' p",
  tomorrow: "'moarn om' p",
  nextWeek: "eeee 'om' p",
  other: 'P'
};
function formatRelative$$(token, _date, _baseDate, _options) {
  return formatRelativeLocale$R[token];
}

var eraValues$R = {
  narrow: ['f.K.', 'n.K.'],
  abbreviated: ['f.Kr.', 'n.Kr.'],
  wide: ['foar Kristus', 'nei Kristus']
};
var quarterValues$R = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1e fearnsjier', '2e fearnsjier', '3e fearnsjier', '4e fearnsjier']
};
var monthValues$R = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mai.', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
  wide: ['jannewaris', 'febrewaris', 'maart', 'april', 'maaie', 'juny', 'july', 'augustus', 'septimber', 'oktober', 'novimber', 'desimber']
};
var dayValues$R = {
  narrow: ['s', 'm', 't', 'w', 't', 'f', 's'],
  short: ['si', 'mo', 'ti', 'wo', 'to', 'fr', 'so'],
  abbreviated: ['snein', 'moa', 'tii', 'woa', 'ton', 'fre', 'sneon'],
  wide: ['snein', 'moandei', 'tiisdei', 'woansdei', 'tongersdei', 'freed', 'sneon']
};
var dayPeriodValues$Q = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'middei',
    morning: 'moarns',
    afternoon: 'middeis',
    evening: 'jûns',
    night: 'nachts'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'middei',
    morning: 'moarns',
    afternoon: 'middeis',
    evening: 'jûns',
    night: 'nachts'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'middei',
    morning: 'moarns',
    afternoon: 'middeis',
    evening: 'jûns',
    night: 'nachts'
  }
};

function ordinalNumber$R(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + 'e';
}

var localize$1G = {
  ordinalNumber: ordinalNumber$R,
  era: buildLocalizeFn({
    values: eraValues$R,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$R,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$R,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$R,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$Q,
    defaultWidth: 'wide'
  })
};
var localize$1H = localize$1G;

var matchOrdinalNumberPattern$R = /^(\d+)e?/i;
var parseOrdinalNumberPattern$R = /\d+/i;
var matchEraPatterns$R = {
  narrow: /^([fn]\.? ?K\.?)/,
  abbreviated: /^([fn]\. ?Kr\.?)/,
  wide: /^((foar|nei) Kristus)/
};
var parseEraPatterns$R = {
  any: [/^f/, /^n/]
};
var matchQuarterPatterns$R = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e fearnsjier/i
};
var parseQuarterPatterns$R = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$R = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
  wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var parseMonthPatterns$R = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^des/i]
};
var matchDayPatterns$R = {
  narrow: /^[smtwf]/i,
  short: /^(si|mo|ti|wo|to|fr|so)/i,
  abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
  wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var parseDayPatterns$R = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^sn/i, /^mo/i, /^ti/i, /^wo/i, /^to/i, /^fr/i, /^sn/i]
};
var matchDayPeriodPatterns$R = {
  any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var parseDayPeriodPatterns$R = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^middei/i,
    morning: /moarns/i,
    afternoon: /^middeis/i,
    evening: /jûns/i,
    night: /nachts/i
  }
};
var match$1G = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$R,
    parsePattern: parseOrdinalNumberPattern$R,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$R,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$R,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$R,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$R,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$R,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$R,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$R,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$R,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$R,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$R,
    defaultParseWidth: 'any'
  })
};
var match$1H = match$1G;

/**
 * @type {Locale}
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
 */

var locale$1G = {
  code: 'fy',
  formatDistance: formatDistance$$,
  formatLong: formatLong$1H,
  formatRelative: formatRelative$$,
  localize: localize$1H,
  match: match$1H,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1H = locale$1G;

var formatDistanceLocale$O = {
  lessThanXSeconds: {
    one: 'nas lugha na diog',
    other: 'nas lugha na {{count}} diogan'
  },
  xSeconds: {
    one: '1 diog',
    two: '2 dhiog',
    twenty: '20 diog',
    other: '{{count}} diogan'
  },
  halfAMinute: 'leth mhionaid',
  lessThanXMinutes: {
    one: 'nas lugha na mionaid',
    other: 'nas lugha na {{count}} mionaidean'
  },
  xMinutes: {
    one: '1 mionaid',
    two: '2 mhionaid',
    twenty: '20 mionaid',
    other: '{{count}} mionaidean'
  },
  aboutXHours: {
    one: 'mu uair de thìde',
    other: 'mu {{count}} uairean de thìde'
  },
  xHours: {
    one: '1 uair de thìde',
    two: '2 uair de thìde',
    twenty: '20 uair de thìde',
    other: '{{count}} uairean de thìde'
  },
  xDays: {
    one: '1 là',
    other: '{{count}} là'
  },
  aboutXWeeks: {
    one: 'mu 1 seachdain',
    other: 'mu {{count}} seachdainean'
  },
  xWeeks: {
    one: '1 seachdain',
    other: '{{count}} seachdainean'
  },
  aboutXMonths: {
    one: 'mu mhìos',
    other: 'mu {{count}} mìosan'
  },
  xMonths: {
    one: '1 mìos',
    other: '{{count}} mìosan'
  },
  aboutXYears: {
    one: 'mu bhliadhna',
    other: 'mu {{count}} bliadhnaichean'
  },
  xYears: {
    one: '1 bhliadhna',
    other: '{{count}} bliadhna'
  },
  overXYears: {
    one: 'còrr is bliadhna',
    other: 'còrr is {{count}} bliadhnaichean'
  },
  almostXYears: {
    one: 'cha mhòr bliadhna',
    other: 'cha mhòr {{count}} bliadhnaichean'
  }
};
function formatDistance$_(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$O[token] === 'string') {
    result = formatDistanceLocale$O[token];
  } else if (count === 1) {
    result = formatDistanceLocale$O[token].one;
  } else if (count === 2 && !!formatDistanceLocale$O[token].two) {
    result = formatDistanceLocale$O[token].two;
  } else if (count === 9 && !!formatDistanceLocale$O[token].nine) {
    result = formatDistanceLocale$O[token].nine;
  } else if (count === 20 && !!formatDistanceLocale$O[token].twenty) {
    result = formatDistanceLocale$O[token].twenty;
  } else if (count === 30 && !!formatDistanceLocale$O[token].thirty) {
    result = formatDistanceLocale$O[token].thirty;
  } else {
    result = formatDistanceLocale$O[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'ann an ' + result;
    } else {
      return 'o chionn ' + result;
    }
  }

  return result;
}

var dateFormats$Q = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$Q = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$Q = {
  full: "{{date}} 'aig' {{time}}",
  long: "{{date}} 'aig' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1E = {
  date: buildFormatLongFn({
    formats: dateFormats$Q,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$Q,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$Q,
    defaultWidth: 'full'
  })
};
var formatLong$1F = formatLong$1E;

var formatRelativeLocale$Q = {
  lastWeek: "'mu dheireadh' eeee 'aig' p",
  //FIX
  yesterday: "'an-dè aig' p",
  today: "'an-diugh aig' p",
  tomorrow: "'a-màireach aig' p",
  nextWeek: "eeee 'aig' p",
  other: 'P'
};
function formatRelative$_(token, _date, _baseDate, _options) {
  return formatRelativeLocale$Q[token];
}

var eraValues$Q = {
  narrow: ['R', 'A'],
  abbreviated: ['RC', 'AD'],
  wide: ['ro Chrìosta', 'anno domini']
};
var quarterValues$Q = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['C1', 'C2', 'C3', 'C4'],
  wide: ["a' chiad chairteal", 'an dàrna cairteal', 'an treas cairteal', 'an ceathramh cairteal']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$Q = {
  narrow: ['F', 'G', 'M', 'G', 'C', 'Ò', 'I', 'L', 'S', 'D', 'S', 'D'],
  abbreviated: ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'],
  wide: ['Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd']
};
var dayValues$Q = {
  narrow: ['D', 'L', 'M', 'C', 'A', 'H', 'S'],
  short: ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'],
  abbreviated: ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
  wide: ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne']
};
var dayPeriodValues$P = {
  narrow: {
    am: 'm',
    pm: 'f',
    midnight: 'm.o.',
    noon: 'm.l.',
    morning: 'madainn',
    afternoon: 'feasgar',
    evening: 'feasgar',
    night: 'oidhche'
  },
  abbreviated: {
    am: 'M.',
    pm: 'F.',
    midnight: 'meadhan oidhche',
    noon: 'meadhan là',
    morning: 'madainn',
    afternoon: 'feasgar',
    evening: 'feasgar',
    night: 'oidhche'
  },
  wide: {
    am: 'm.',
    pm: 'f.',
    midnight: 'meadhan oidhche',
    noon: 'meadhan là',
    morning: 'madainn',
    afternoon: 'feasgar',
    evening: 'feasgar',
    night: 'oidhche'
  }
};
var formattingDayPeriodValues$G = {
  narrow: {
    am: 'm',
    pm: 'f',
    midnight: 'm.o.',
    noon: 'm.l.',
    morning: 'sa mhadainn',
    afternoon: 'feasgar',
    evening: 'feasgar',
    night: 'air an oidhche'
  },
  abbreviated: {
    am: 'M.',
    pm: 'F.',
    midnight: 'meadhan oidhche',
    noon: 'meadhan là',
    morning: 'sa mhadainn',
    afternoon: 'feasgar',
    evening: 'feasgar',
    night: 'air an oidhche'
  },
  wide: {
    am: 'm.',
    pm: 'f.',
    midnight: 'meadhan oidhche',
    noon: 'meadhan là',
    morning: 'sa mhadainn',
    afternoon: 'feasgar',
    evening: 'feasgar',
    night: 'air an oidhche'
  }
};

function ordinalNumber$Q(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'd';

      case 2:
        return number + 'na';
    }
  }

  if (rem100 === 12) {
    return number + 'na';
  }

  return number + 'mh';
}

var localize$1E = {
  ordinalNumber: ordinalNumber$Q,
  era: buildLocalizeFn({
    values: eraValues$Q,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$Q,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$Q,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$Q,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$P,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$G,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1F = localize$1E;

var matchOrdinalNumberPattern$Q = /^(\d+)(d|na|tr|mh)?/i;
var parseOrdinalNumberPattern$Q = /\d+/i;
var matchEraPatterns$Q = {
  narrow: /^(r|a)/i,
  abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
  wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var parseEraPatterns$Q = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$Q = {
  narrow: /^[1234]/i,
  abbreviated: /^c[1234]/i,
  wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
var parseQuarterPatterns$Q = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$Q = {
  narrow: /^[fgmcòilsd]/i,
  abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
  wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var parseMonthPatterns$Q = {
  narrow: [/^f/i, /^g/i, /^m/i, /^g/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^s/i, /^d/i, /^s/i, /^d/i],
  any: [/^fa/i, /^ge/i, /^mà/i, /^gi/i, /^c/i, /^ò/i, /^i/i, /^l/i, /^su/i, /^d/i, /^sa/i, /^d/i]
};
var matchDayPatterns$Q = {
  narrow: /^[dlmcahs]/i,
  short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
  abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
  wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var parseDayPatterns$Q = {
  narrow: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
  any: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i]
};
var matchDayPeriodPatterns$Q = {
  narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
  any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var parseDayPeriodPatterns$Q = {
  any: {
    am: /^m/i,
    pm: /^f/i,
    midnight: /^meadhan oidhche/i,
    noon: /^meadhan là/i,
    morning: /sa mhadainn/i,
    afternoon: /feasgar/i,
    evening: /feasgar/i,
    night: /air an oidhche/i
  }
};
var match$1E = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$Q,
    parsePattern: parseOrdinalNumberPattern$Q,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$Q,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$Q,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$Q,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$Q,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$Q,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$Q,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$Q,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$Q,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$Q,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$Q,
    defaultParseWidth: 'any'
  })
};
var match$1F = match$1E;

/**
 * @type {Locale}
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
 */

var locale$1E = {
  code: 'gd',
  formatDistance: formatDistance$_,
  formatLong: formatLong$1F,
  formatRelative: formatRelative$_,
  localize: localize$1F,
  match: match$1F,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1F = locale$1E;

var formatDistanceLocale$N = {
  lessThanXSeconds: {
    one: 'menos dun segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'medio minuto',
  lessThanXMinutes: {
    one: 'menos dun minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'arredor dunha hora',
    other: 'arredor de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 día',
    other: '{{count}} días'
  },
  aboutXWeeks: {
    one: 'arredor dunha semana',
    other: 'arredor de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'arredor de 1 mes',
    other: 'arredor de {{count}} meses'
  },
  xMonths: {
    one: '1 mes',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'arredor dun ano',
    other: 'arredor de {{count}} anos'
  },
  xYears: {
    one: '1 ano',
    other: '{{count}} anos'
  },
  overXYears: {
    one: 'máis dun ano',
    other: 'máis de {{count}} anos'
  },
  almostXYears: {
    one: 'case un ano',
    other: 'case {{count}} anos'
  }
};
function formatDistance$Z(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$N[token] === 'string') {
    result = formatDistanceLocale$N[token];
  } else if (count === 1) {
    result = formatDistanceLocale$N[token].one;
  } else {
    result = formatDistanceLocale$N[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'en ' + result;
    } else {
      return 'hai ' + result;
    }
  }

  return result;
}

var dateFormats$P = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var timeFormats$P = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$P = {
  full: "{{date}} 'ás' {{time}}",
  long: "{{date}} 'ás' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1C = {
  date: buildFormatLongFn({
    formats: dateFormats$P,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$P,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$P,
    defaultWidth: 'full'
  })
};
var formatLong$1D = formatLong$1C;

var formatRelativeLocale$P = {
  lastWeek: "'o' eeee 'pasado á' LT",
  yesterday: "'onte á' p",
  today: "'hoxe á' p",
  tomorrow: "'mañá á' p",
  nextWeek: "eeee 'á' p",
  other: 'P'
};
var formatRelativeLocalePlural = {
  lastWeek: "'o' eeee 'pasado ás' p",
  yesterday: "'onte ás' p",
  today: "'hoxe ás' p",
  tomorrow: "'mañá ás' p",
  nextWeek: "eeee 'ás' p",
  other: 'P'
};
function formatRelative$Z(token, date, _baseDate, _options) {
  if (date.getUTCHours() !== 1) {
    return formatRelativeLocalePlural[token];
  }

  return formatRelativeLocale$P[token];
}

var eraValues$P = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'despois de cristo']
};
var quarterValues$P = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues$P = {
  narrow: ['e', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['xan', 'feb', 'mar', 'abr', 'mai', 'xun', 'xul', 'ago', 'set', 'out', 'nov', 'dec'],
  wide: ['xaneiro', 'febreiro', 'marzo', 'abril', 'maio', 'xuño', 'xullo', 'agosto', 'setembro', 'outubro', 'novembro', 'decembro']
};
var dayValues$P = {
  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
  short: ['do', 'lu', 'ma', 'me', 'xo', 've', 'sa'],
  abbreviated: ['dom', 'lun', 'mar', 'mer', 'xov', 'ven', 'sab'],
  wide: ['domingo', 'luns', 'martes', 'mércores', 'xoves', 'venres', 'sábado']
};
var dayPeriodValues$O = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'mañá',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoite',
    noon: 'mediodía',
    morning: 'mañá',
    afternoon: 'tarde',
    evening: 'tardiña',
    night: 'noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoite',
    noon: 'mediodía',
    morning: 'mañá',
    afternoon: 'tarde',
    evening: 'tardiña',
    night: 'noite'
  }
};
var formattingDayPeriodValues$F = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'da mañá',
    afternoon: 'da tarde',
    evening: 'da tardiña',
    night: 'da noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'medianoite',
    noon: 'mediodía',
    morning: 'da mañá',
    afternoon: 'da tarde',
    evening: 'da tardiña',
    night: 'da noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'medianoite',
    noon: 'mediodía',
    morning: 'da mañá',
    afternoon: 'da tarde',
    evening: 'da tardiña',
    night: 'da noite'
  }
};

function ordinalNumber$P(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + 'º';
}

var localize$1C = {
  ordinalNumber: ordinalNumber$P,
  era: buildLocalizeFn({
    values: eraValues$P,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$P,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$P,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$P,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$O,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$F,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1D = localize$1C;

var matchOrdinalNumberPattern$P = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern$P = /\d+/i;
var matchEraPatterns$P = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var parseEraPatterns$P = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era com[uú]n)/i, /^(despois de cristo|era com[uú]n)/i]
};
var matchQuarterPatterns$P = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns$P = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$P = {
  narrow: /^[xfmasond]/i,
  abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
  wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var parseMonthPatterns$P = {
  narrow: [/^x/i, /^f/i, /^m/i, /^a/i, /^m/i, /^x/i, /^x/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^xan/i, /^feb/i, /^mar/i, /^abr/i, /^mai/i, /^xun/i, /^xul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dec/i]
};
var matchDayPatterns$P = {
  narrow: /^[dlmxvs]/i,
  short: /^(do|lu|ma|me|xo|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
  wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var parseDayPatterns$P = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i]
};
var matchDayPeriodPatterns$P = {
  narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var parseDayPeriodPatterns$P = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañ[aá]/i,
    afternoon: /tarde/i,
    evening: /tardiña/i,
    night: /noite/i
  }
};
var match$1C = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$P,
    parsePattern: parseOrdinalNumberPattern$P,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$P,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$P,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$P,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$P,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$P,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$P,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$P,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$P,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$P,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$P,
    defaultParseWidth: 'any'
  })
};
var match$1D = match$1C;

/**
 * @type {Locale}
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
 */

var locale$1C = {
  code: 'gl',
  formatDistance: formatDistance$Z,
  formatLong: formatLong$1D,
  formatRelative: formatRelative$Z,
  localize: localize$1D,
  match: match$1D,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1D = locale$1C;

// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var formatDistanceLocale$M = {
  lessThanXSeconds: {
    one: 'હમણાં',
    // CLDR #1461
    other: '​આશરે {{count}} સેકંડ'
  },
  xSeconds: {
    one: '1 સેકંડ',
    other: '{{count}} સેકંડ'
  },
  halfAMinute: 'અડધી મિનિટ',
  lessThanXMinutes: {
    one: 'આ મિનિટ',
    // CLDR #1448
    other: '​આશરે {{count}} મિનિટ'
  },
  xMinutes: {
    one: '1 મિનિટ',
    other: '{{count}} મિનિટ'
  },
  aboutXHours: {
    one: '​આશરે 1 કલાક',
    other: '​આશરે {{count}} કલાક'
  },
  xHours: {
    one: '1 કલાક',
    other: '{{count}} કલાક'
  },
  xDays: {
    one: '1 દિવસ',
    other: '{{count}} દિવસ'
  },
  aboutXWeeks: {
    one: 'આશરે 1 અઠવાડિયું',
    other: 'આશરે {{count}} અઠવાડિયા'
  },
  xWeeks: {
    one: '1 અઠવાડિયું',
    other: '{{count}} અઠવાડિયા'
  },
  aboutXMonths: {
    one: 'આશરે 1 મહિનો',
    other: 'આશરે {{count}} મહિના'
  },
  xMonths: {
    one: '1 મહિનો',
    other: '{{count}} મહિના'
  },
  aboutXYears: {
    one: 'આશરે 1 વર્ષ',
    other: 'આશરે {{count}} વર્ષ'
  },
  xYears: {
    one: '1 વર્ષ',
    other: '{{count}} વર્ષ'
  },
  overXYears: {
    one: '1 વર્ષથી વધુ',
    other: '{{count}} વર્ષથી વધુ'
  },
  almostXYears: {
    one: 'લગભગ 1 વર્ષ',
    other: 'લગભગ {{count}} વર્ષ'
  }
};
function formatDistance$Y(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$M[token] === 'string') {
    result = formatDistanceLocale$M[token];
  } else if (count === 1) {
    result = formatDistanceLocale$M[token].one;
  } else {
    result = formatDistanceLocale$M[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result + 'માં';
    } else {
      return result + ' પહેલાં';
    }
  }

  return result;
}

var dateFormats$O = {
  full: 'EEEE, d MMMM, y',
  // CLDR #1825
  long: 'd MMMM, y',
  // CLDR #1826
  medium: 'd MMM, y',
  // CLDR #1827
  short: 'd/M/yy' // CLDR #1828

};
var timeFormats$O = {
  full: 'hh:mm:ss a zzzz',
  // CLDR #1829
  long: 'hh:mm:ss a z',
  // CLDR #1830
  medium: 'hh:mm:ss a',
  // CLDR #1831
  short: 'hh:mm a' // CLDR #1832

};
var dateTimeFormats$O = {
  full: '{{date}} {{time}}',
  // CLDR #1833
  long: '{{date}} {{time}}',
  // CLDR #1834
  medium: '{{date}} {{time}}',
  // CLDR #1835
  short: '{{date}} {{time}}' // CLDR #1836

};
var formatLong$1A = {
  date: buildFormatLongFn({
    formats: dateFormats$O,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$O,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$O,
    defaultWidth: 'full'
  })
};
var formatLong$1B = formatLong$1A;

// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var formatRelativeLocale$O = {
  lastWeek: "'પાછલા' eeee p",
  // CLDR #1384
  yesterday: "'ગઈકાલે' p",
  // CLDR #1409
  today: "'આજે' p",
  // CLDR #1410
  tomorrow: "'આવતીકાલે' p",
  // CLDR #1411
  nextWeek: 'eeee p',
  // CLDR #1386
  other: 'P'
};
function formatRelative$Y(token, _date, _baseDate, _options) {
  return formatRelativeLocale$O[token];
}

// #1621 - #1630

var eraValues$O = {
  narrow: ['ઈસપૂ', 'ઈસ'],
  abbreviated: ['ઈ.સ.પૂર્વે', 'ઈ.સ.'],
  wide: ['ઈસવીસન પૂર્વે', 'ઈસવીસન']
}; // https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654

var quarterValues$O = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1લો ત્રિમાસ', '2જો ત્રિમાસ', '3જો ત્રિમાસ', '4થો ત્રિમાસ']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726

var monthValues$O = {
  narrow: ['જા', 'ફે', 'મા', 'એ', 'મે', 'જૂ', 'જુ', 'ઓ', 'સ', 'ઓ', 'ન', 'ડિ'],
  abbreviated: ['જાન્યુ', 'ફેબ્રુ', 'માર્ચ', 'એપ્રિલ', 'મે', 'જૂન', 'જુલાઈ', 'ઑગસ્ટ', 'સપ્ટે', 'ઓક્ટો', 'નવે', 'ડિસે'],
  wide: ['જાન્યુઆરી', 'ફેબ્રુઆરી', 'માર્ચ', 'એપ્રિલ', 'મે', 'જૂન', 'જુલાઇ', 'ઓગસ્ટ', 'સપ્ટેમ્બર', 'ઓક્ટોબર', 'નવેમ્બર', 'ડિસેમ્બર']
}; // https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768

var dayValues$O = {
  narrow: ['ર', 'સો', 'મં', 'બુ', 'ગુ', 'શુ', 'શ'],
  short: ['ર', 'સો', 'મં', 'બુ', 'ગુ', 'શુ', 'શ'],
  abbreviated: ['રવિ', 'સોમ', 'મંગળ', 'બુધ', 'ગુરુ', 'શુક્ર', 'શનિ'],
  wide: ['રવિવાર'
  /* Sunday */
  , 'સોમવાર'
  /* Monday */
  , 'મંગળવાર'
  /* Tuesday */
  , 'બુધવાર'
  /* Wednesday */
  , 'ગુરુવાર'
  /* Thursday */
  , 'શુક્રવાર'
  /* Friday */
  , 'શનિવાર'
  /* Saturday */
  ]
}; // https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824

var dayPeriodValues$N = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'મ.રાત્રિ',
    noon: 'બ.',
    morning: 'સવારે',
    afternoon: 'બપોરે',
    evening: 'સાંજે',
    night: 'રાત્રે'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: '​મધ્યરાત્રિ',
    noon: 'બપોરે',
    morning: 'સવારે',
    afternoon: 'બપોરે',
    evening: 'સાંજે',
    night: 'રાત્રે'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: '​મધ્યરાત્રિ',
    noon: 'બપોરે',
    morning: 'સવારે',
    afternoon: 'બપોરે',
    evening: 'સાંજે',
    night: 'રાત્રે'
  }
};
var formattingDayPeriodValues$E = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'મ.રાત્રિ',
    noon: 'બપોરે',
    morning: 'સવારે',
    afternoon: 'બપોરે',
    evening: 'સાંજે',
    night: 'રાત્રે'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'મધ્યરાત્રિ',
    noon: 'બપોરે',
    morning: 'સવારે',
    afternoon: 'બપોરે',
    evening: 'સાંજે',
    night: 'રાત્રે'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: '​મધ્યરાત્રિ',
    noon: 'બપોરે',
    morning: 'સવારે',
    afternoon: 'બપોરે',
    evening: 'સાંજે',
    night: 'રાત્રે'
  }
};

function ordinalNumber$O(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);
  return number;
}

var localize$1A = {
  ordinalNumber: ordinalNumber$O,
  era: buildLocalizeFn({
    values: eraValues$O,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$O,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$O,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$O,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$N,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$E,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1B = localize$1A;

var matchOrdinalNumberPattern$O = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var parseOrdinalNumberPattern$O = /\d+/i;
var matchEraPatterns$O = {
  narrow: /^(ઈસપૂ|ઈસ)/i,
  abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
  wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var parseEraPatterns$O = {
  any: [/^(ઈસપૂ|ઈસ)/i, /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i, /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i]
};
var matchQuarterPatterns$O = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var parseQuarterPatterns$O = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$O = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
  abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
  wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var parseMonthPatterns$O = {
  narrow: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i],
  any: [/^જા/i, /^ફે/i, /^મા/i, /^એ/i, /^મે/i, /^જૂ/i, /^જુ/i, /^ઑગ/i, /^સ/i, /^ઓક્ટો/i, /^ન/i, /^ડિ/i]
};
var matchDayPatterns$O = {
  narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
  wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var parseDayPatterns$O = {
  narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
  any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i]
};
var matchDayPeriodPatterns$O = {
  narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
  any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var parseDayPeriodPatterns$O = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^મ\.?/i,
    noon: /^બ/i,
    morning: /સ/i,
    afternoon: /બ/i,
    evening: /સાં/i,
    night: /રા/i
  }
};
var match$1A = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$O,
    parsePattern: parseOrdinalNumberPattern$O,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$O,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$O,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$O,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$O,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$O,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$O,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$O,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$O,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$O,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$O,
    defaultParseWidth: 'any'
  })
};
var match$1B = match$1A;

/**
 * @type {Locale}
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
 */

var locale$1A = {
  code: 'gu',
  formatDistance: formatDistance$Y,
  formatLong: formatLong$1B,
  formatRelative: formatRelative$Y,
  localize: localize$1B,
  match: match$1B,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1B = locale$1A;

var formatDistanceLocale$L = {
  lessThanXSeconds: {
    one: 'פחות משנייה',
    two: 'פחות משתי שניות',
    other: 'פחות מ־{{count}} שניות'
  },
  xSeconds: {
    one: 'שנייה',
    two: 'שתי שניות',
    other: '{{count}} שניות'
  },
  halfAMinute: 'חצי דקה',
  lessThanXMinutes: {
    one: 'פחות מדקה',
    two: 'פחות משתי דקות',
    other: 'פחות מ־{{count}} דקות'
  },
  xMinutes: {
    one: 'דקה',
    two: 'שתי דקות',
    other: '{{count}} דקות'
  },
  aboutXHours: {
    one: 'כשעה',
    two: 'כשעתיים',
    other: 'כ־{{count}} שעות'
  },
  xHours: {
    one: 'שעה',
    two: 'שעתיים',
    other: '{{count}} שעות'
  },
  xDays: {
    one: 'יום',
    two: 'יומיים',
    other: '{{count}} ימים'
  },
  aboutXWeeks: {
    one: 'כשבוע',
    two: 'כשבועיים',
    other: 'כ־{{count}} שבועות'
  },
  xWeeks: {
    one: 'שבוע',
    two: 'שבועיים',
    other: '{{count}} שבועות'
  },
  aboutXMonths: {
    one: 'כחודש',
    two: 'כחודשיים',
    other: 'כ־{{count}} חודשים'
  },
  xMonths: {
    one: 'חודש',
    two: 'חודשיים',
    other: '{{count}} חודשים'
  },
  aboutXYears: {
    one: 'כשנה',
    two: 'כשנתיים',
    other: 'כ־{{count}} שנים'
  },
  xYears: {
    one: 'שנה',
    two: 'שנתיים',
    other: '{{count}} שנים'
  },
  overXYears: {
    one: 'יותר משנה',
    two: 'יותר משנתיים',
    other: 'יותר מ־{{count}} שנים'
  },
  almostXYears: {
    one: 'כמעט שנה',
    two: 'כמעט שנתיים',
    other: 'כמעט {{count}} שנים'
  }
};
function formatDistance$X(token, count, options) {
  options = options || {}; // Return word instead of `in one day` or `one day ago`

  if (token === 'xDays' && options.addSuffix && count <= 2) {
    var past = {
      1: 'אתמול',
      2: 'שלשום'
    };
    var future = {
      1: 'מחר',
      2: 'מחרתיים'
    };
    return options.comparison > 0 ? future[count] : past[count];
  }

  var result;

  if (typeof formatDistanceLocale$L[token] === 'string') {
    result = formatDistanceLocale$L[token];
  } else if (count === 1) {
    result = formatDistanceLocale$L[token].one;
  } else if (count === 2) {
    result = formatDistanceLocale$L[token].two;
  } else {
    result = formatDistanceLocale$L[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'בעוד ' + result;
    } else {
      return 'לפני ' + result;
    }
  }

  return result;
}

var dateFormats$N = {
  full: 'EEEE, d בMMMM y',
  long: 'd בMMMM y',
  medium: 'd בMMM y',
  short: 'd.M.y'
};
var timeFormats$N = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$N = {
  full: "{{date}} 'בשעה' {{time}}",
  long: "{{date}} 'בשעה' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1y = {
  date: buildFormatLongFn({
    formats: dateFormats$N,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$N,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$N,
    defaultWidth: 'full'
  })
};
var formatLong$1z = formatLong$1y;

var formatRelativeLocale$N = {
  lastWeek: "eeee 'שעבר בשעה' p",
  yesterday: "'אתמול בשעה' p",
  today: "'היום בשעה' p",
  tomorrow: "'מחר בשעה' p",
  nextWeek: "eeee 'בשעה' p",
  other: 'P'
};
function formatRelative$X(token, _date, _baseDate, _options) {
  return formatRelativeLocale$N[token];
}

var eraValues$N = {
  narrow: ['לפנה״ס', 'לספירה'],
  abbreviated: ['לפנה״ס', 'לספירה'],
  wide: ['לפני הספירה', 'לספירה']
};
var quarterValues$N = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['רבעון 1', 'רבעון 2', 'רבעון 3', 'רבעון 4']
};
var monthValues$N = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['ינו׳', 'פבר׳', 'מרץ', 'אפר׳', 'מאי', 'יוני', 'יולי', 'אוג׳', 'ספט׳', 'אוק׳', 'נוב׳', 'דצמ׳'],
  wide: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר']
};
var dayValues$N = {
  narrow: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
  short: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
  abbreviated: ['יום א׳', 'יום ב׳', 'יום ג׳', 'יום ד׳', 'יום ה׳', 'יום ו׳', 'שבת'],
  wide: ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי', 'יום שישי', 'יום שבת']
};
var dayPeriodValues$M = {
  narrow: {
    am: 'לפנה״צ',
    pm: 'אחה״צ',
    midnight: 'חצות',
    noon: 'צהריים',
    morning: 'בוקר',
    afternoon: 'אחר הצהריים',
    evening: 'ערב',
    night: 'לילה'
  },
  abbreviated: {
    am: 'לפנה״צ',
    pm: 'אחה״צ',
    midnight: 'חצות',
    noon: 'צהריים',
    morning: 'בוקר',
    afternoon: 'אחר הצהריים',
    evening: 'ערב',
    night: 'לילה'
  },
  wide: {
    am: 'לפנה״צ',
    pm: 'אחה״צ',
    midnight: 'חצות',
    noon: 'צהריים',
    morning: 'בוקר',
    afternoon: 'אחר הצהריים',
    evening: 'ערב',
    night: 'לילה'
  }
};
var formattingDayPeriodValues$D = {
  narrow: {
    am: 'לפנה״צ',
    pm: 'אחה״צ',
    midnight: 'חצות',
    noon: 'צהריים',
    morning: 'בבוקר',
    afternoon: 'בצהריים',
    evening: 'בערב',
    night: 'בלילה'
  },
  abbreviated: {
    am: 'לפנה״צ',
    pm: 'אחה״צ',
    midnight: 'חצות',
    noon: 'צהריים',
    morning: 'בבוקר',
    afternoon: 'אחר הצהריים',
    evening: 'בערב',
    night: 'בלילה'
  },
  wide: {
    am: 'לפנה״צ',
    pm: 'אחה״צ',
    midnight: 'חצות',
    noon: 'צהריים',
    morning: 'בבוקר',
    afternoon: 'אחר הצהריים',
    evening: 'בערב',
    night: 'בלילה'
  }
};

function ordinalNumber$N(dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber); // We only show words till 10

  if (number <= 0 || number > 10) return number;
  var options = dirtyOptions || {};
  var unit = String(options.unit);
  var isFemale = ['year', 'hour', 'minute', 'second'].indexOf(unit) >= 0;
  var male = ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שביעי', 'שמיני', 'תשיעי', 'עשירי'];
  var female = ['ראשונה', 'שנייה', 'שלישית', 'רביעית', 'חמישית', 'שישית', 'שביעית', 'שמינית', 'תשיעית', 'עשירית'];
  var index = number - 1;
  return isFemale ? female[index] : male[index];
}

var localize$1y = {
  ordinalNumber: ordinalNumber$N,
  era: buildLocalizeFn({
    values: eraValues$N,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$N,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$N,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$N,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$M,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$D,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1z = localize$1y;

var matchOrdinalNumberPattern$N = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var parseOrdinalNumberPattern$N = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var matchEraPatterns$N = {
  narrow: /^ל(ספירה|פנה״ס)/i,
  abbreviated: /^ל(ספירה|פנה״ס)/i,
  wide: /^ל(פני ה)?ספירה/i
};
var parseEraPatterns$N = {
  any: [/^לפ/i, /^לס/i]
};
var matchQuarterPatterns$N = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^רבעון [1234]/i
};
var parseQuarterPatterns$N = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$N = {
  narrow: /^\d+/i,
  abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
  wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var parseMonthPatterns$N = {
  narrow: [/^1$/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^7/i, /^8/i, /^9/i, /^10/i, /^11/i, /^12/i],
  any: [/^ינ/i, /^פ/i, /^מר/i, /^אפ/i, /^מא/i, /^יונ/i, /^יול/i, /^אוג/i, /^ס/i, /^אוק/i, /^נ/i, /^ד/i]
};
var matchDayPatterns$N = {
  narrow: /^[אבגדהוש]׳/i,
  short: /^[אבגדהוש]׳/i,
  abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
  wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var parseDayPatterns$N = {
  abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
  wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
  any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i]
};
var matchDayPeriodPatterns$N = {
  any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var parseDayPeriodPatterns$N = {
  any: {
    am: /^לפ/i,
    pm: /^אחה/i,
    midnight: /^ח/i,
    noon: /^צ/i,
    morning: /בוקר/i,
    afternoon: /בצ|אחר/i,
    evening: /ערב/i,
    night: /לילה/i
  }
};
var ordinalName = ['רא', 'שנ', 'של', 'רב', 'ח', 'שי', 'שב', 'שמ', 'ת', 'ע'];
var match$1y = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$N,
    parsePattern: parseOrdinalNumberPattern$N,
    valueCallback: function (value) {
      var number = parseInt(value, 10);
      return isNaN(number) ? ordinalName.indexOf(value) + 1 : number;
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$N,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$N,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$N,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$N,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$N,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$N,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$N,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$N,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$N,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$N,
    defaultParseWidth: 'any'
  })
};
var match$1z = match$1y;

/**
 * @type {Locale}
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
 */

var locale$1y = {
  code: 'he',
  formatDistance: formatDistance$X,
  formatLong: formatLong$1z,
  formatRelative: formatRelative$X,
  localize: localize$1z,
  match: match$1z,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1z = locale$1y;

var numberValues = {
  locale: {
    '1': '१',
    '2': '२',
    '3': '३',
    '4': '४',
    '5': '५',
    '6': '६',
    '7': '७',
    '8': '८',
    '9': '९',
    '0': '०'
  },
  number: {
    '१': '1',
    '२': '2',
    '३': '3',
    '४': '4',
    '५': '5',
    '६': '6',
    '७': '7',
    '८': '8',
    '९': '9',
    '०': '0'
  }
}; // CLDR #1585 - #1592

var eraValues$M = {
  narrow: ['ईसा-पूर्व', 'ईस्वी'],
  abbreviated: ['ईसा-पूर्व', 'ईस्वी'],
  wide: ['ईसा-पूर्व', 'ईसवी सन']
}; // CLDR #1593 - #1616

var quarterValues$M = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['ति1', 'ति2', 'ति3', 'ति4'],
  wide: ['पहली तिमाही', 'दूसरी तिमाही', 'तीसरी तिमाही', 'चौथी तिमाही']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688

var monthValues$M = {
  narrow: ['ज', 'फ़', 'मा', 'अ', 'मई', 'जू', 'जु', 'अग', 'सि', 'अक्टू', 'न', 'दि'],
  abbreviated: ['जन', 'फ़र', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुल', 'अग', 'सित', 'अक्टू', 'नव', 'दिस'],
  wide: ['जनवरी', 'फ़रवरी', 'मार्च', 'अप्रैल', 'मई', 'जून', 'जुलाई', 'अगस्त', 'सितंबर', 'अक्टूबर', 'नवंबर', 'दिसंबर']
}; // CLDR #1689 - #1744

var dayValues$M = {
  narrow: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
  short: ['र', 'सो', 'मं', 'बु', 'गु', 'शु', 'श'],
  abbreviated: ['रवि', 'सोम', 'मंगल', 'बुध', 'गुरु', 'शुक्र', 'शनि'],
  wide: ['रविवार', 'सोमवार', 'मंगलवार', 'बुधवार', 'गुरुवार', 'शुक्रवार', 'शनिवार']
};
var dayPeriodValues$L = {
  narrow: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  },
  abbreviated: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  },
  wide: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  }
};
var formattingDayPeriodValues$C = {
  narrow: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  },
  abbreviated: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  },
  wide: {
    am: 'पूर्वाह्न',
    pm: 'अपराह्न',
    midnight: 'मध्यरात्रि',
    noon: 'दोपहर',
    morning: 'सुबह',
    afternoon: 'दोपहर',
    evening: 'शाम',
    night: 'रात'
  }
};

var ordinalNumber$M = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return numberToLocale(number);
};

function localeToNumber(locale) {
  var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function (match) {
    return numberValues.number[match];
  });
  return Number(enNumber);
}
function numberToLocale(enNumber) {
  return enNumber.toString().replace(/\d/g, function (match) {
    return numberValues.locale[match];
  });
}
var localize$1w = {
  ordinalNumber: ordinalNumber$M,
  era: buildLocalizeFn({
    values: eraValues$M,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$M,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$M,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$M,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$L,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$C,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1x = localize$1w;

var formatDistanceLocale$K = {
  lessThanXSeconds: {
    one: '१ सेकंड से कम',
    // CLDR #1310
    other: '{{count}} सेकंड से कम'
  },
  xSeconds: {
    one: '१ सेकंड',
    other: '{{count}} सेकंड'
  },
  halfAMinute: 'आधा मिनट',
  lessThanXMinutes: {
    one: '१ मिनट से कम',
    other: '{{count}} मिनट से कम'
  },
  xMinutes: {
    one: '१ मिनट',
    // CLDR #1307
    other: '{{count}} मिनट'
  },
  aboutXHours: {
    one: 'लगभग १ घंटा',
    other: 'लगभग {{count}} घंटे'
  },
  xHours: {
    one: '१ घंटा',
    // CLDR #1304
    other: '{{count}} घंटे' // CLDR #4467

  },
  xDays: {
    one: '१ दिन',
    // CLDR #1286
    other: '{{count}} दिन'
  },
  aboutXWeeks: {
    one: 'लगभग १ सप्ताह',
    other: 'लगभग {{count}} सप्ताह'
  },
  xWeeks: {
    one: '१ सप्ताह',
    other: '{{count}} सप्ताह'
  },
  aboutXMonths: {
    one: 'लगभग १ महीना',
    other: 'लगभग {{count}} महीने'
  },
  xMonths: {
    one: '१ महीना',
    other: '{{count}} महीने'
  },
  aboutXYears: {
    one: 'लगभग १ वर्ष',
    other: 'लगभग {{count}} वर्ष' // CLDR #4823

  },
  xYears: {
    one: '१ वर्ष',
    other: '{{count}} वर्ष'
  },
  overXYears: {
    one: '१ वर्ष से अधिक',
    other: '{{count}} वर्ष से अधिक'
  },
  almostXYears: {
    one: 'लगभग १ वर्ष',
    other: 'लगभग {{count}} वर्ष'
  }
};

var formatDistance$V = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$K[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', numberToLocale(count));
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + 'मे ';
    } else {
      return result + ' पहले';
    }
  }

  return result;
};

var formatDistance$W = formatDistance$V;

var dateFormats$M = {
  full: 'EEEE, do MMMM, y',
  // CLDR #1787
  long: 'do MMMM, y',
  // CLDR #1788
  medium: 'd MMM, y',
  // CLDR #1789
  short: 'dd/MM/yyyy' // CLDR #1790

};
var timeFormats$M = {
  full: 'h:mm:ss a zzzz',
  // CLDR #1791
  long: 'h:mm:ss a z',
  // CLDR #1792
  medium: 'h:mm:ss a',
  // CLDR #1793
  short: 'h:mm a' // CLDR #1794

};
var dateTimeFormats$M = {
  full: "{{date}} 'को' {{time}}",
  // CLDR #1795
  long: "{{date}} 'को' {{time}}",
  // CLDR #1796
  medium: '{{date}}, {{time}}',
  // CLDR #1797
  short: '{{date}}, {{time}}' // CLDR #1798

};
var formatLong$1w = {
  date: buildFormatLongFn({
    formats: dateFormats$M,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$M,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$M,
    defaultWidth: 'full'
  })
};
var formatLong$1x = formatLong$1w;

var formatRelativeLocale$M = {
  lastWeek: "'पिछले' eeee p",
  yesterday: "'कल' p",
  today: "'आज' p",
  tomorrow: "'कल' p",
  nextWeek: "eeee 'को' p",
  other: 'P'
};

var formatRelative$V = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$M[token];
};

var formatRelative$W = formatRelative$V;

var matchOrdinalNumberPattern$M = /^[०१२३४५६७८९]+/i;
var parseOrdinalNumberPattern$M = /^[०१२३४५६७८९]+/i;
var matchEraPatterns$M = {
  narrow: /^(ईसा-पूर्व|ईस्वी)/i,
  abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
  wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var parseEraPatterns$M = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$M = {
  narrow: /^[1234]/i,
  abbreviated: /^ति[1234]/i,
  wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var parseQuarterPatterns$M = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$M = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
  abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
  wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var parseMonthPatterns$M = {
  narrow: [/^ज/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^न/i, /^दि/i],
  any: [/^जन/i, /^फ़/i, /^मा/i, /^अप्/i, /^मई/i, /^जू/i, /^जु/i, /^अग/i, /^सि/i, /^अक्तू/i, /^नव/i, /^दिस/i]
};
var matchDayPatterns$M = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
  short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var parseDayPatterns$M = {
  narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
  any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
};
var matchDayPeriodPatterns$M = {
  narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
  any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var parseDayPeriodPatterns$M = {
  any: {
    am: /^पूर्वाह्न/i,
    pm: /^अपराह्न/i,
    midnight: /^मध्य/i,
    noon: /^दो/i,
    morning: /सु/i,
    afternoon: /दो/i,
    evening: /शा/i,
    night: /रा/i
  }
};
var match$1w = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$M,
    parsePattern: parseOrdinalNumberPattern$M,
    valueCallback: localeToNumber
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$M,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$M,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$M,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$M,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$M,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$M,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$M,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$M,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$M,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$M,
    defaultParseWidth: 'any'
  })
};
var match$1x = match$1w;

/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */

var locale$1w = {
  code: 'hi',
  formatDistance: formatDistance$W,
  formatLong: formatLong$1x,
  formatRelative: formatRelative$W,
  localize: localize$1x,
  match: match$1x,
  options: {
    weekStartsOn: 0
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1x = locale$1w;

var formatDistanceLocale$J = {
  lessThanXSeconds: {
    one: {
      standalone: 'manje od 1 sekunde',
      withPrepositionAgo: 'manje od 1 sekunde',
      withPrepositionIn: 'manje od 1 sekundu'
    },
    dual: 'manje od {{count}} sekunde',
    other: 'manje od {{count}} sekundi'
  },
  xSeconds: {
    one: {
      standalone: '1 sekunda',
      withPrepositionAgo: '1 sekunde',
      withPrepositionIn: '1 sekundu'
    },
    dual: '{{count}} sekunde',
    other: '{{count}} sekundi'
  },
  halfAMinute: 'pola minute',
  lessThanXMinutes: {
    one: {
      standalone: 'manje od 1 minute',
      withPrepositionAgo: 'manje od 1 minute',
      withPrepositionIn: 'manje od 1 minutu'
    },
    dual: 'manje od {{count}} minute',
    other: 'manje od {{count}} minuta'
  },
  xMinutes: {
    one: {
      standalone: '1 minuta',
      withPrepositionAgo: '1 minute',
      withPrepositionIn: '1 minutu'
    },
    dual: '{{count}} minute',
    other: '{{count}} minuta'
  },
  aboutXHours: {
    one: {
      standalone: 'oko 1 sat',
      withPrepositionAgo: 'oko 1 sat',
      withPrepositionIn: 'oko 1 sat'
    },
    dual: 'oko {{count}} sata',
    other: 'oko {{count}} sati'
  },
  xHours: {
    one: {
      standalone: '1 sat',
      withPrepositionAgo: '1 sat',
      withPrepositionIn: '1 sat'
    },
    dual: '{{count}} sata',
    other: '{{count}} sati'
  },
  xDays: {
    one: {
      standalone: '1 dan',
      withPrepositionAgo: '1 dan',
      withPrepositionIn: '1 dan'
    },
    dual: '{{count}} dana',
    other: '{{count}} dana'
  },
  aboutXWeeks: {
    one: {
      standalone: 'oko 1 tjedan',
      withPrepositionAgo: 'oko 1 tjedan',
      withPrepositionIn: 'oko 1 tjedan'
    },
    dual: 'oko {{count}} tjedna',
    other: 'oko {{count}} tjedana'
  },
  xWeeks: {
    one: {
      standalone: '1 tjedan',
      withPrepositionAgo: '1 tjedan',
      withPrepositionIn: '1 tjedan'
    },
    dual: '{{count}} tjedna',
    other: '{{count}} tjedana'
  },
  aboutXMonths: {
    one: {
      standalone: 'oko 1 mjesec',
      withPrepositionAgo: 'oko 1 mjesec',
      withPrepositionIn: 'oko 1 mjesec'
    },
    dual: 'oko {{count}} mjeseca',
    other: 'oko {{count}} mjeseci'
  },
  xMonths: {
    one: {
      standalone: '1 mjesec',
      withPrepositionAgo: '1 mjesec',
      withPrepositionIn: '1 mjesec'
    },
    dual: '{{count}} mjeseca',
    other: '{{count}} mjeseci'
  },
  aboutXYears: {
    one: {
      standalone: 'oko 1 godinu',
      withPrepositionAgo: 'oko 1 godinu',
      withPrepositionIn: 'oko 1 godinu'
    },
    dual: 'oko {{count}} godine',
    other: 'oko {{count}} godina'
  },
  xYears: {
    one: {
      standalone: '1 godina',
      withPrepositionAgo: '1 godine',
      withPrepositionIn: '1 godinu'
    },
    dual: '{{count}} godine',
    other: '{{count}} godina'
  },
  overXYears: {
    one: {
      standalone: 'preko 1 godinu',
      withPrepositionAgo: 'preko 1 godinu',
      withPrepositionIn: 'preko 1 godinu'
    },
    dual: 'preko {{count}} godine',
    other: 'preko {{count}} godina'
  },
  almostXYears: {
    one: {
      standalone: 'gotovo 1 godinu',
      withPrepositionAgo: 'gotovo 1 godinu',
      withPrepositionIn: 'gotovo 1 godinu'
    },
    dual: 'gotovo {{count}} godine',
    other: 'gotovo {{count}} godina'
  }
};
function formatDistance$U(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$J[token] === 'string') {
    result = formatDistanceLocale$J[token];
  } else if (count === 1) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        result = formatDistanceLocale$J[token].one.withPrepositionIn;
      } else {
        result = formatDistanceLocale$J[token].one.withPrepositionAgo;
      }
    } else {
      result = formatDistanceLocale$J[token].one.standalone;
    }
  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
  ) {
      result = formatDistanceLocale$J[token].dual.replace('{{count}}', count);
    } else {
    result = formatDistanceLocale$J[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'za ' + result;
    } else {
      return 'prije ' + result;
    }
  }

  return result;
}

var dateFormats$L = {
  full: 'EEEE, d. MMMM y.',
  long: 'd. MMMM y.',
  medium: 'd. MMM y.',
  short: 'dd. MM. y.'
};
var timeFormats$L = {
  full: 'HH:mm:ss (zzzz)',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$L = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$1u = {
  date: buildFormatLongFn({
    formats: dateFormats$L,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$L,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$L,
    defaultWidth: 'full'
  })
};
var formatLong$1v = formatLong$1u;

var formatRelativeLocale$L = {
  lastWeek: function (date) {
    var day = date.getUTCDay();

    switch (day) {
      case 0:
        return "'prošlu nedjelju u' p";

      case 3:
        return "'prošlu srijedu u' p";

      case 6:
        return "'prošlu subotu u' p";

      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'jučer u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function (date) {
    var day = date.getUTCDay();

    switch (day) {
      case 0:
        return "'iduću nedjelju u' p";

      case 3:
        return "'iduću srijedu u' p";

      case 6:
        return "'iduću subotu u' p";

      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  other: 'P'
};
function formatRelative$U(token, date, _baseDate, _options) {
  var format = formatRelativeLocale$L[token];

  if (typeof format === 'function') {
    return format(date);
  }

  return format;
}

function ordinalNumber$L(dirtyNumber) {
  var number = Number(dirtyNumber);
  return String(number).concat('.');
}

var eraValues$L = {
  narrow: ['pr.n.e.', 'AD'],
  abbreviated: ['pr. Kr.', 'po. Kr.'],
  wide: ['Prije Krista', 'Poslije Krista']
};
var monthValues$L = {
  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
  abbreviated: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
  wide: ['siječanj', 'veljača', 'ožujak', 'travanj', 'svibanj', 'lipanj', 'srpanj', 'kolovoz', 'rujan', 'listopad', 'studeni', 'prosinac']
};
var formattingMonthValues$a = {
  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
  abbreviated: ['sij', 'velj', 'ožu', 'tra', 'svi', 'lip', 'srp', 'kol', 'ruj', 'lis', 'stu', 'pro'],
  wide: ['siječnja', 'veljače', 'ožujka', 'travnja', 'svibnja', 'lipnja', 'srpnja', 'kolovoza', 'rujna', 'listopada', 'studenog', 'prosinca']
};
var quarterValues$L = {
  narrow: ['1.', '2.', '3.', '4.'],
  abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
};
var dayValues$L = {
  narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
  short: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
  abbreviated: ['ned', 'pon', 'uto', 'sri', 'čet', 'pet', 'sub'],
  wide: ['nedjelja', 'ponedjeljak', 'utorak', 'srijeda', 'četvrtak', 'petak', 'subota']
};
var formattingDayPeriodValues$B = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutro',
    afternoon: 'popodne',
    evening: 'navečer',
    night: 'noću'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutro',
    afternoon: 'popodne',
    evening: 'navečer',
    night: 'noću'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutro',
    afternoon: 'poslije podne',
    evening: 'navečer',
    night: 'noću'
  }
};
var dayPeriodValues$K = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutro',
    afternoon: 'popodne',
    evening: 'navečer',
    night: 'noću'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutro',
    afternoon: 'popodne',
    evening: 'navečer',
    night: 'noću'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutro',
    afternoon: 'poslije podne',
    evening: 'navečer',
    night: 'noću'
  }
};
var localize$1u = {
  ordinalNumber: ordinalNumber$L,
  era: buildLocalizeFn({
    values: eraValues$L,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$L,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$L,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$a,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$L,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$K,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$B,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1v = localize$1u;

var matchOrdinalNumberPattern$L = /^(\d+)\./i;
var parseOrdinalNumberPattern$L = /\d+/i;
var matchEraPatterns$L = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
  wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var parseEraPatterns$L = {
  any: [/^pr/i, /^(po|nova)/i]
};
var matchQuarterPatterns$L = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns$L = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$L = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
  wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var parseMonthPatterns$L = {
  narrow: [/(10|11|12|[123456789])/i],
  abbreviated: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i],
  wide: [/^sij/i, /^velj/i, /^(ožu|ozu)/i, /^tra/i, /^svi/i, /^lip/i, /^srp/i, /^kol/i, /^ruj/i, /^lis/i, /^stu/i, /^pro/i]
};
var matchDayPatterns$L = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns$L = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$L = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var parseDayPeriodPatterns$L = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(navece|naveče)/i,
    night: /(nocu|noću)/i
  }
};
var match$1u = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$L,
    parsePattern: parseOrdinalNumberPattern$L,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$L,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$L,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$L,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$L,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$L,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$L,
    defaultParseWidth: 'wide'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$L,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$L,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$L,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$L,
    defaultParseWidth: 'any'
  })
};
var match$1v = match$1u;

/**
 * @type {Locale}
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
 * @author Manico [@manico]{@link https://github.com/manico}
 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
 */

var locale$1u = {
  code: 'hr',
  formatDistance: formatDistance$U,
  formatLong: formatLong$1v,
  formatRelative: formatRelative$U,
  localize: localize$1v,
  match: match$1v,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1v = locale$1u;

var formatDistanceLocale$I = {
  lessThanXSeconds: {
    one: 'mwens pase yon segond',
    other: 'mwens pase {{count}} segond'
  },
  xSeconds: {
    one: '1 segond',
    other: '{{count}} segond'
  },
  halfAMinute: '30 segond',
  lessThanXMinutes: {
    one: 'mwens pase yon minit',
    other: 'mwens pase {{count}} minit'
  },
  xMinutes: {
    one: '1 minit',
    other: '{{count}} minit'
  },
  aboutXHours: {
    one: 'anviwon inè',
    other: 'anviwon {{count}} è'
  },
  xHours: {
    one: '1 lè',
    other: '{{count}} lè'
  },
  xDays: {
    one: '1 jou',
    other: '{{count}} jou'
  },
  aboutXWeeks: {
    one: 'anviwon 1 semèn',
    other: 'anviwon {{count}} semèn'
  },
  xWeeks: {
    one: '1 semèn',
    other: '{{count}} semèn'
  },
  aboutXMonths: {
    one: 'anviwon 1 mwa',
    other: 'anviwon {{count}} mwa'
  },
  xMonths: {
    one: '1 mwa',
    other: '{{count}} mwa'
  },
  aboutXYears: {
    one: 'anviwon 1 an',
    other: 'anviwon {{count}} an'
  },
  xYears: {
    one: '1 an',
    other: '{{count}} an'
  },
  overXYears: {
    one: 'plis pase 1 an',
    other: 'plis pase {{count}} an'
  },
  almostXYears: {
    one: 'prèske 1 an',
    other: 'prèske {{count}} an'
  }
};
function formatDistance$T(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$I[token] === 'string') {
    result = formatDistanceLocale$I[token];
  } else if (count === 1) {
    result = formatDistanceLocale$I[token].one;
  } else {
    result = formatDistanceLocale$I[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'nan ' + result;
    } else {
      return 'sa fè ' + result;
    }
  }

  return result;
}

var dateFormats$K = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var timeFormats$K = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$K = {
  full: "{{date}} 'nan lè' {{time}}",
  long: "{{date}} 'nan lè' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1s = {
  date: buildFormatLongFn({
    formats: dateFormats$K,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$K,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$K,
    defaultWidth: 'full'
  })
};
var formatLong$1t = formatLong$1s;

var formatRelativeLocale$K = {
  lastWeek: "eeee 'pase nan lè' p",
  yesterday: "'yè nan lè' p",
  today: "'jodi a' p",
  tomorrow: "'demen nan lè' p'",
  nextWeek: "eeee 'pwochen nan lè' p",
  other: 'P'
};
function formatRelative$T(token, _date, _baseDate, _options) {
  return formatRelativeLocale$K[token];
}

var eraValues$K = {
  narrow: ['av. J.-K', 'ap. J.-K'],
  abbreviated: ['av. J.-K', 'ap. J.-K'],
  wide: ['anvan Jezi Kris', 'apre Jezi Kris']
};
var quarterValues$K = {
  narrow: ['T1', 'T2', 'T3', 'T4'],
  abbreviated: ['1ye trim.', '2yèm trim.', '3yèm trim.', '4yèm trim.'],
  wide: ['1ye trimès', '2yèm trimès', '3yèm trimès', '4yèm trimès']
};
var monthValues$K = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'O', 'S', 'O', 'N', 'D'],
  abbreviated: ['janv.', 'fevr.', 'mas', 'avr.', 'me', 'jen', 'jiyè', 'out', 'sept.', 'okt.', 'nov.', 'des.'],
  wide: ['janvye', 'fevrye', 'mas', 'avril', 'me', 'jen', 'jiyè', 'out', 'septanm', 'oktòb', 'novanm', 'desanm']
};
var dayValues$K = {
  narrow: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
  short: ['di', 'le', 'ma', 'mè', 'je', 'va', 'sa'],
  abbreviated: ['dim.', 'len.', 'mad.', 'mèk.', 'jed.', 'van.', 'sam.'],
  wide: ['dimanch', 'lendi', 'madi', 'mèkredi', 'jedi', 'vandredi', 'samdi']
};
var dayPeriodValues$J = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minwit',
    noon: 'midi',
    morning: 'mat.',
    afternoon: 'ap.m.',
    evening: 'swa',
    night: 'mat.'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minwit',
    noon: 'midi',
    morning: 'maten',
    afternoon: 'aprèmidi',
    evening: 'swa',
    night: 'maten'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'minwit',
    noon: 'midi',
    morning: 'nan maten',
    afternoon: 'nan aprèmidi',
    evening: 'nan aswè',
    night: 'nan maten'
  }
};

function ordinalNumber$K(dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);
  var options = dirtyOptions || {};
  var unit = String(options.unit);
  var suffix;

  if (number === 0) {
    return number;
  }

  if (unit === 'year' || unit === 'hour' || unit === 'week') {
    if (number === 1) {
      suffix = 'ye';
    } else {
      suffix = 'yèm';
    }
  } else {
    if (number === 1) {
      suffix = 'ye';
    } else {
      suffix = 'yèm';
    }
  }

  return number + suffix;
}

var localize$1s = {
  ordinalNumber: ordinalNumber$K,
  era: buildLocalizeFn({
    values: eraValues$K,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$K,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$K,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$K,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$J,
    defaultWidth: 'wide'
  })
};
var localize$1t = localize$1s;

var matchOrdinalNumberPattern$K = /^(\d+)(ye|yèm)?/i;
var parseOrdinalNumberPattern$K = /\d+/i;
var matchEraPatterns$K = {
  narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
  abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
  wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
var parseEraPatterns$K = {
  any: [/^av/i, /^ap/i]
};
var matchQuarterPatterns$K = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](ye|yèm)? trimès/i
};
var parseQuarterPatterns$K = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$K = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
  wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var parseMonthPatterns$K = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^ma/i, /^av/i, /^me/i, /^je/i, /^ji/i, /^ou/i, /^s/i, /^ok/i, /^n/i, /^d/i]
};
var matchDayPatterns$K = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|le|ma|me|je|va|sa)/i,
  abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
  wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var parseDayPatterns$K = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^le/i, /^ma/i, /^mè/i, /^je/i, /^va/i, /^sa/i]
};
var matchDayPeriodPatterns$K = {
  narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
  any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var parseDayPeriodPatterns$K = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /sw/i,
    night: /nwit/i
  }
};
var match$1s = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$K,
    parsePattern: parseOrdinalNumberPattern$K,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$K,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$K,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$K,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$K,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$K,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$K,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$K,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$K,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$K,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$K,
    defaultParseWidth: 'any'
  })
};
var match$1t = match$1s;

/**
 * @type {Locale}
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
 */

var locale$1s = {
  code: 'ht',
  formatDistance: formatDistance$T,
  formatLong: formatLong$1t,
  formatRelative: formatRelative$T,
  localize: localize$1t,
  match: match$1t,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1t = locale$1s;

var translations$1 = {
  about: 'körülbelül',
  over: 'több mint',
  almost: 'majdnem',
  lessthan: 'kevesebb mint'
};
var withoutSuffixes = {
  xseconds: ' másodperc',
  halfaminute: 'fél perc',
  xminutes: ' perc',
  xhours: ' óra',
  xdays: ' nap',
  xweeks: ' hét',
  xmonths: ' hónap',
  xyears: ' év'
};
var withSuffixes = {
  xseconds: {
    '-1': ' másodperccel ezelőtt',
    '1': ' másodperc múlva',
    '0': ' másodperce'
  },
  halfaminute: {
    '-1': 'fél perccel ezelőtt',
    '1': 'fél perc múlva',
    '0': 'fél perce'
  },
  xminutes: {
    '-1': ' perccel ezelőtt',
    '1': ' perc múlva',
    '0': ' perce'
  },
  xhours: {
    '-1': ' órával ezelőtt',
    '1': ' óra múlva',
    '0': ' órája'
  },
  xdays: {
    '-1': ' nappal ezelőtt',
    '1': ' nap múlva',
    '0': ' napja'
  },
  xweeks: {
    '-1': ' héttel ezelőtt',
    '1': ' hét múlva',
    '0': ' hete'
  },
  xmonths: {
    '-1': ' hónappal ezelőtt',
    '1': ' hónap múlva',
    '0': ' hónapja'
  },
  xyears: {
    '-1': ' évvel ezelőtt',
    '1': ' év múlva',
    '0': ' éve'
  }
};

function translate$1(number, addSuffix, key, comparison) {
  var translated = addSuffix ? withSuffixes[key][comparison] : withoutSuffixes[key];

  if (key === 'halfaminute') {
    return translated;
  }

  return number + translated;
}

function formatDistance$S(token, count, options) {
  options = options || {};
  var adverb = token.match(/about|over|almost|lessthan/i);
  var unit = token.replace(adverb, '');
  var result;
  result = translate$1(count, options.addSuffix, unit.toLowerCase(), options.comparison);

  if (adverb) {
    result = translations$1[adverb[0].toLowerCase()] + ' ' + result;
  }

  return result;
}

var dateFormats$J = {
  full: 'y. MMMM d., EEEE',
  long: 'y. MMMM d.',
  medium: 'y. MMM d.',
  short: 'y. MM. dd.'
};
var timeFormats$J = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$J = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$1q = {
  date: buildFormatLongFn({
    formats: dateFormats$J,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$J,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$J,
    defaultWidth: 'full'
  })
};
var formatLong$1r = formatLong$1q;

var accusativeWeekdays$4 = ['vasárnap', 'hétfőn', 'kedden', 'szerdán', 'csütörtökön', 'pénteken', 'szombaton'];

function week(isFuture) {
  return function (date, _baseDate, _options) {
    var day = date.getUTCDay();
    return (isFuture ? '' : "'múlt' ") + "'" + accusativeWeekdays$4[day] + "'" + " p'-kor'";
  };
}

var formatRelativeLocale$J = {
  lastWeek: week(false),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: week(true),
  other: 'P'
};
function formatRelative$S(token, date, baseDate, options) {
  var format = formatRelativeLocale$J[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}

var eraValues$J = {
  narrow: ['ie.', 'isz.'],
  abbreviated: ['i. e.', 'i. sz.'],
  wide: ['Krisztus előtt', 'időszámításunk szerint']
};
var quarterValues$J = {
  narrow: ['1.', '2.', '3.', '4.'],
  abbreviated: ['1. n.év', '2. n.év', '3. n.év', '4. n.év'],
  wide: ['1. negyedév', '2. negyedév', '3. negyedév', '4. negyedév']
};
var formattingQuarterValues$3 = {
  narrow: ['I.', 'II.', 'III.', 'IV.'],
  abbreviated: ['I. n.év', 'II. n.év', 'III. n.év', 'IV. n.év'],
  wide: ['I. negyedév', 'II. negyedév', 'III. negyedév', 'IV. negyedév']
};
var monthValues$J = {
  narrow: ['J', 'F', 'M', 'Á', 'M', 'J', 'J', 'A', 'Sz', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'],
  wide: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december']
};
var dayValues$J = {
  narrow: ['V', 'H', 'K', 'Sz', 'Cs', 'P', 'Sz'],
  short: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
  abbreviated: ['V', 'H', 'K', 'Sze', 'Cs', 'P', 'Szo'],
  wide: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat']
};
var dayPeriodValues$I = {
  narrow: {
    am: 'de.',
    pm: 'du.',
    midnight: 'éjfél',
    noon: 'dél',
    morning: 'reggel',
    afternoon: 'du.',
    evening: 'este',
    night: 'éjjel'
  },
  abbreviated: {
    am: 'de.',
    pm: 'du.',
    midnight: 'éjfél',
    noon: 'dél',
    morning: 'reggel',
    afternoon: 'du.',
    evening: 'este',
    night: 'éjjel'
  },
  wide: {
    am: 'de.',
    pm: 'du.',
    midnight: 'éjfél',
    noon: 'dél',
    morning: 'reggel',
    afternoon: 'délután',
    evening: 'este',
    night: 'éjjel'
  }
};

function ordinalNumber$J(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);
  return number + '.';
}

var localize$1q = {
  ordinalNumber: ordinalNumber$J,
  era: buildLocalizeFn({
    values: eraValues$J,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$J,
    defaultWidth: 'wide',
    formattingValues: formattingQuarterValues$3,
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$J,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$J,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$I,
    defaultWidth: 'wide',
    defaultFormattingWidth: 'wide'
  })
};
var localize$1r = localize$1q;

var matchOrdinalNumberPattern$J = /^(\d+)\.?/i;
var parseOrdinalNumberPattern$J = /\d+/i;
var matchEraPatterns$J = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var parseEraPatterns$J = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i]
};
var matchQuarterPatterns$J = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var parseQuarterPatterns$J = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
};
var matchMonthPatterns$J = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var parseMonthPatterns$J = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a|á/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s|sz/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^már/i, /^áp/i, /^máj/i, /^jún/i, /^júl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$J = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var parseDayPatterns$J = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
};
var matchDayPeriodPatterns$J = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var parseDayPeriodPatterns$J = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i
  }
};
var match$1q = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$J,
    parsePattern: parseOrdinalNumberPattern$J,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$J,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$J,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$J,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$J,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$J,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$J,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$J,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$J,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$J,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$J,
    defaultParseWidth: 'any'
  })
};
var match$1r = match$1q;

/**
 * @type {Locale}
 * @category Locales
 *
 * @summary Hungarian locale.
 * @language Hungarian
 *
 * @iso-639-2 hun
 *
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */

var locale$1q = {
  code: 'hu',
  formatDistance: formatDistance$S,
  formatLong: formatLong$1r,
  formatRelative: formatRelative$S,
  localize: localize$1r,
  match: match$1r,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1r = locale$1q;

var formatDistanceLocale$H = {
  lessThanXSeconds: {
    one: 'ավելի քիչ քան 1 վայրկյան',
    other: 'ավելի քիչ քան {{count}} վայրկյան'
  },
  xSeconds: {
    one: '1 վայրկյան',
    other: '{{count}} վայրկյան'
  },
  halfAMinute: 'կես րոպե',
  lessThanXMinutes: {
    one: 'ավելի քիչ քան 1 րոպե',
    other: 'ավելի քիչ քան {{count}} րոպե'
  },
  xMinutes: {
    one: '1 րոպե',
    other: '{{count}} րոպե'
  },
  aboutXHours: {
    one: 'մոտ 1 ժամ',
    other: 'մոտ {{count}} ժամ'
  },
  xHours: {
    one: '1 ժամ',
    other: '{{count}} ժամ'
  },
  xDays: {
    one: '1 օր',
    other: '{{count}} օր'
  },
  aboutXWeeks: {
    one: 'մոտ 1 շաբաթ',
    other: 'մոտ {{count}} շաբաթ'
  },
  xWeeks: {
    one: '1 շաբաթ',
    other: '{{count}} շաբաթ'
  },
  aboutXMonths: {
    one: 'մոտ 1 ամիս',
    other: 'մոտ {{count}} ամիս'
  },
  xMonths: {
    one: '1 ամիս',
    other: '{{count}} ամիս'
  },
  aboutXYears: {
    one: 'մոտ 1 տարի',
    other: 'մոտ {{count}} տարի'
  },
  xYears: {
    one: '1 տարի',
    other: '{{count}} տարի'
  },
  overXYears: {
    one: 'ավելի քան 1 տարի',
    other: 'ավելի քան {{count}} տարի'
  },
  almostXYears: {
    one: 'համարյա 1 տարի',
    other: 'համարյա {{count}} տարի'
  }
};
function formatDistance$R(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$H[token] === 'string') {
    result = formatDistanceLocale$H[token];
  } else if (count === 1) {
    result = formatDistanceLocale$H[token].one;
  } else {
    result = formatDistanceLocale$H[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result + ' հետո';
    } else {
      return result + ' առաջ';
    }
  }

  return result;
}

var dateFormats$I = {
  full: 'd MMMM, y, EEEE',
  long: 'd MMMM, y',
  medium: 'd MMM, y',
  short: 'dd.MM.yyyy'
};
var timeFormats$I = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$I = {
  full: "{{date}} 'ժ․'{{time}}",
  long: "{{date}} 'ժ․'{{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1o = {
  date: buildFormatLongFn({
    formats: dateFormats$I,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$I,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$I,
    defaultWidth: 'full'
  })
};
var formatLong$1p = formatLong$1o;

var formatRelativeLocale$I = {
  lastWeek: "'նախորդ' eeee p'֊ին'",
  yesterday: "'երեկ' p'֊ին'",
  today: "'այսօր' p'֊ին'",
  tomorrow: "'վաղը' p'֊ին'",
  nextWeek: "'հաջորդ' eeee p'֊ին'",
  other: 'P'
};
function formatRelative$R(token, _date, _baseDate, _options) {
  return formatRelativeLocale$I[token];
}

var eraValues$I = {
  narrow: ['Ք', 'Մ'],
  abbreviated: ['ՔԱ', 'ՄԹ'],
  wide: ['Քրիստոսից առաջ', 'Մեր թվարկության']
};
var quarterValues$I = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Ք1', 'Ք2', 'Ք3', 'Ք4'],
  wide: ['1֊ին քառորդ', '2֊րդ քառորդ', '3֊րդ քառորդ', '4֊րդ քառորդ']
};
var monthValues$I = {
  narrow: ['Հ', 'Փ', 'Մ', 'Ա', 'Մ', 'Հ', 'Հ', 'Օ', 'Ս', 'Հ', 'Ն', 'Դ'],
  abbreviated: ['հուն', 'փետ', 'մար', 'ապր', 'մայ', 'հուն', 'հուլ', 'օգս', 'սեպ', 'հոկ', 'նոյ', 'դեկ'],
  wide: ['հունվար', 'փետրվար', 'մարտ', 'ապրիլ', 'մայիս', 'հունիս', 'հուլիս', 'օգոստոս', 'սեպտեմբեր', 'հոկտեմբեր', 'նոյեմբեր', 'դեկտեմբեր']
};
var dayValues$I = {
  narrow: ['Կ', 'Ե', 'Ե', 'Չ', 'Հ', 'Ո', 'Շ'],
  short: ['կր', 'եր', 'եք', 'չք', 'հգ', 'ուր', 'շբ'],
  abbreviated: ['կիր', 'երկ', 'երք', 'չոր', 'հնգ', 'ուրբ', 'շաբ'],
  wide: ['կիրակի', 'երկուշաբթի', 'երեքշաբթի', 'չորեքշաբթի', 'հինգշաբթի', 'ուրբաթ', 'շաբաթ']
};
var dayPeriodValues$H = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'կեսգշ',
    noon: 'կեսօր',
    morning: 'առավոտ',
    afternoon: 'ցերեկ',
    evening: 'երեկո',
    night: 'գիշեր'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'կեսգիշեր',
    noon: 'կեսօր',
    morning: 'առավոտ',
    afternoon: 'ցերեկ',
    evening: 'երեկո',
    night: 'գիշեր'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'կեսգիշեր',
    noon: 'կեսօր',
    morning: 'առավոտ',
    afternoon: 'ցերեկ',
    evening: 'երեկո',
    night: 'գիշեր'
  }
};
var formattingDayPeriodValues$A = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'կեսգշ',
    noon: 'կեսօր',
    morning: 'առավոտը',
    afternoon: 'ցերեկը',
    evening: 'երեկոյան',
    night: 'գիշերը'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'կեսգիշերին',
    noon: 'կեսօրին',
    morning: 'առավոտը',
    afternoon: 'ցերեկը',
    evening: 'երեկոյան',
    night: 'գիշերը'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'կեսգիշերին',
    noon: 'կեսօրին',
    morning: 'առավոտը',
    afternoon: 'ցերեկը',
    evening: 'երեկոյան',
    night: 'գիշերը'
  }
};

function ordinalNumber$I(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 < 10) {
    if (rem100 % 10 === 1) {
      return number + '֊ին';
    }
  }

  return number + '֊րդ';
}

var localize$1o = {
  ordinalNumber: ordinalNumber$I,
  era: buildLocalizeFn({
    values: eraValues$I,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$I,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$I,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$I,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$H,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$A,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1p = localize$1o;

var matchOrdinalNumberPattern$I = /^(\d+)((-|֊)?(ին|րդ))?/i;
var parseOrdinalNumberPattern$I = /\d+/i;
var matchEraPatterns$I = {
  narrow: /^(Ք|Մ)/i,
  abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
  wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var parseEraPatterns$I = {
  any: [/^(ք|մ)/i]
};
var matchQuarterPatterns$I = {
  narrow: /^[1234]/i,
  abbreviated: /^ք[1234]/i,
  wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var parseQuarterPatterns$I = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$I = {
  narrow: /^[հփմաօսնդ]/i,
  abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
  wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var parseMonthPatterns$I = {
  narrow: [/^հ/i, /^փ/i, /^մ/i, /^ա/i, /^մ/i, /^հ/i, /^հ/i, /^օ/i, /^ս/i, /^հ/i, /^ն/i, /^դ/i],
  any: [/^հու/i, /^փ/i, /^մար/i, /^ա/i, /^մայ/i, /^հուն/i, /^հուլ/i, /^օ/i, /^ս/i, /^հոկ/i, /^ն/i, /^դ/i]
};
var matchDayPatterns$I = {
  narrow: /^[եչհոշկ]/i,
  short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
  abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
  wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var parseDayPatterns$I = {
  narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i]
};
var matchDayPeriodPatterns$I = {
  narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
  any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var parseDayPeriodPatterns$I = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /կեսգիշեր/i,
    noon: /կեսօր/i,
    morning: /առավոտ/i,
    afternoon: /ցերեկ/i,
    evening: /երեկո/i,
    night: /գիշեր/i
  }
};
var match$1o = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$I,
    parsePattern: parseOrdinalNumberPattern$I,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$I,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$I,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$I,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$I,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$I,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$I,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$I,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$I,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$I,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$I,
    defaultParseWidth: 'any'
  })
};
var match$1p = match$1o;

/**
 * @type {Locale}
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
 */

var locale$1o = {
  code: 'hy',
  formatDistance: formatDistance$R,
  formatLong: formatLong$1p,
  formatRelative: formatRelative$R,
  localize: localize$1p,
  match: match$1p,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1p = locale$1o;

var formatDistanceLocale$G = {
  lessThanXSeconds: {
    one: 'kurang dari 1 detik',
    other: 'kurang dari {{count}} detik'
  },
  xSeconds: {
    one: '1 detik',
    other: '{{count}} detik'
  },
  halfAMinute: 'setengah menit',
  lessThanXMinutes: {
    one: 'kurang dari 1 menit',
    other: 'kurang dari {{count}} menit'
  },
  xMinutes: {
    one: '1 menit',
    other: '{{count}} menit'
  },
  aboutXHours: {
    one: 'sekitar 1 jam',
    other: 'sekitar {{count}} jam'
  },
  xHours: {
    one: '1 jam',
    other: '{{count}} jam'
  },
  xDays: {
    one: '1 hari',
    other: '{{count}} hari'
  },
  aboutXWeeks: {
    one: 'sekitar 1 minggu',
    other: 'sekitar {{count}} minggu'
  },
  xWeeks: {
    one: '1 minggu',
    other: '{{count}} minggu'
  },
  aboutXMonths: {
    one: 'sekitar 1 bulan',
    other: 'sekitar {{count}} bulan'
  },
  xMonths: {
    one: '1 bulan',
    other: '{{count}} bulan'
  },
  aboutXYears: {
    one: 'sekitar 1 tahun',
    other: 'sekitar {{count}} tahun'
  },
  xYears: {
    one: '1 tahun',
    other: '{{count}} tahun'
  },
  overXYears: {
    one: 'lebih dari 1 tahun',
    other: 'lebih dari {{count}} tahun'
  },
  almostXYears: {
    one: 'hampir 1 tahun',
    other: 'hampir {{count}} tahun'
  }
};

var formatDistance$P = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$G[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'dalam waktu ' + result;
    } else {
      return result + ' yang lalu';
    }
  }

  return result;
};

var formatDistance$Q = formatDistance$P;

var dateFormats$H = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'd/M/yyyy'
};
var timeFormats$H = {
  full: 'HH.mm.ss',
  long: 'HH.mm.ss',
  medium: 'HH.mm',
  short: 'HH.mm'
};
var dateTimeFormats$H = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1m = {
  date: buildFormatLongFn({
    formats: dateFormats$H,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$H,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$H,
    defaultWidth: 'full'
  })
};
var formatLong$1n = formatLong$1m;

var formatRelativeLocale$H = {
  lastWeek: "eeee 'lalu pukul' p",
  yesterday: "'Kemarin pukul' p",
  today: "'Hari ini pukul' p",
  tomorrow: "'Besok pukul' p",
  nextWeek: "eeee 'pukul' p",
  other: 'P'
};

var formatRelative$P = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$H[token];
};

var formatRelative$Q = formatRelative$P;

// https://www.unicode.org/cldr/charts/32/summary/id.html

var eraValues$H = {
  narrow: ['SM', 'M'],
  abbreviated: ['SM', 'M'],
  wide: ['Sebelum Masehi', 'Masehi']
};
var quarterValues$H = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['Kuartal ke-1', 'Kuartal ke-2', 'Kuartal ke-3', 'Kuartal ke-4']
}; // Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$H = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agt', 'Sep', 'Okt', 'Nov', 'Des'],
  wide: ['Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember']
};
var dayValues$H = {
  narrow: ['M', 'S', 'S', 'R', 'K', 'J', 'S'],
  short: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
  abbreviated: ['Min', 'Sen', 'Sel', 'Rab', 'Kam', 'Jum', 'Sab'],
  wide: ['Minggu', 'Senin', 'Selasa', 'Rabu', 'Kamis', 'Jumat', 'Sabtu']
};
var dayPeriodValues$G = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'siang',
    evening: 'sore',
    night: 'malam'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'siang',
    evening: 'sore',
    night: 'malam'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'siang',
    evening: 'sore',
    night: 'malam'
  }
};
var formattingDayPeriodValues$z = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'siang',
    evening: 'sore',
    night: 'malam'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'siang',
    evening: 'sore',
    night: 'malam'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'siang',
    evening: 'sore',
    night: 'malam'
  }
};

var ordinalNumber$H = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber); // Can't use "pertama", "kedua" because can't be parsed

  return 'ke-' + number;
};

var localize$1m = {
  ordinalNumber: ordinalNumber$H,
  era: buildLocalizeFn({
    values: eraValues$H,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$H,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$H,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$H,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$G,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$z,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1n = localize$1m;

var matchOrdinalNumberPattern$H = /^ke-(\d+)?/i;
var parseOrdinalNumberPattern$H = /\d+/i;
var matchEraPatterns$H = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
  wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var parseEraPatterns$H = {
  any: [/^s/i, /^(m|e)/i]
};
var matchQuarterPatterns$H = {
  narrow: /^[1234]/i,
  abbreviated: /^K-?\s[1234]/i,
  wide: /^Kuartal ke-?\s?[1234]/i
};
var parseQuarterPatterns$H = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$H = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
  wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var parseMonthPatterns$H = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$H = {
  narrow: /^[srkjm]/i,
  short: /^(min|sen|sel|rab|kam|jum|sab)/i,
  abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
  wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var parseDayPatterns$H = {
  narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i]
};
var matchDayPeriodPatterns$H = {
  narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var parseDayPeriodPatterns$H = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pagi/i,
    afternoon: /siang/i,
    evening: /sore/i,
    night: /malam/i
  }
};
var match$1m = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$H,
    parsePattern: parseOrdinalNumberPattern$H,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$H,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$H,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$H,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$H,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$H,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$H,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$H,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$H,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$H,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$H,
    defaultParseWidth: 'any'
  })
};
var match$1n = match$1m;

/**
 * @type {Locale}
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
 */

var locale$1m = {
  code: 'id',
  formatDistance: formatDistance$Q,
  formatLong: formatLong$1n,
  formatRelative: formatRelative$Q,
  localize: localize$1n,
  match: match$1n,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1n = locale$1m;

var formatDistanceLocale$F = {
  lessThanXSeconds: {
    one: 'minna en 1 sekúnda',
    other: 'minna en {{count}} sekúndur'
  },
  xSeconds: {
    one: '1 sekúnda',
    other: '{{count}} sekúndur'
  },
  halfAMinute: 'hálf mínúta',
  lessThanXMinutes: {
    one: 'minna en 1 mínúta',
    other: 'minna en {{count}} mínútur'
  },
  xMinutes: {
    one: '1 mínúta',
    other: '{{count}} mínútur'
  },
  aboutXHours: {
    one: 'u.þ.b. 1 klukkustund',
    other: 'u.þ.b. {{count}} klukkustundir'
  },
  xHours: {
    one: '1 klukkustund',
    other: '{{count}} klukkustundir'
  },
  xDays: {
    one: '1 dagur',
    other: '{{count}} dagar'
  },
  aboutXWeeks: {
    one: 'um viku',
    other: 'um {{count}} vikur'
  },
  xWeeks: {
    one: '1 viku',
    other: '{{count}} vikur'
  },
  aboutXMonths: {
    one: 'u.þ.b. 1 mánuður',
    other: 'u.þ.b. {{count}} mánuðir'
  },
  xMonths: {
    one: '1 mánuður',
    other: '{{count}} mánuðir'
  },
  aboutXYears: {
    one: 'u.þ.b. 1 ár',
    other: 'u.þ.b. {{count}} ár'
  },
  xYears: {
    one: '1 ár',
    other: '{{count}} ár'
  },
  overXYears: {
    one: 'meira en 1 ár',
    other: 'meira en {{count}} ár'
  },
  almostXYears: {
    one: 'næstum 1 ár',
    other: 'næstum {{count}} ár'
  }
};

var formatDistance$N = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$F[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'í ' + result;
    } else {
      return result + ' síðan';
    }
  }

  return result;
};

var formatDistance$O = formatDistance$N;

var dateFormats$G = {
  full: 'EEEE, do MMMM y',
  long: 'do MMMM y',
  medium: 'do MMM y',
  short: 'd.MM.y'
};
var timeFormats$G = {
  full: "'kl'. HH:mm:ss zzzz",
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$G = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$1k = {
  date: buildFormatLongFn({
    formats: dateFormats$G,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$G,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$G,
    defaultWidth: 'full'
  })
};
var formatLong$1l = formatLong$1k;

var formatRelativeLocale$G = {
  lastWeek: "'síðasta' dddd 'kl.' p",
  yesterday: "'í gær kl.' p",
  today: "'í dag kl.' p",
  tomorrow: "'á morgun kl.' p",
  nextWeek: "dddd 'kl.' p",
  other: 'P'
};

var formatRelative$N = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$G[token];
};

var formatRelative$O = formatRelative$N;

var eraValues$G = {
  narrow: ['f.Kr.', 'e.Kr.'],
  abbreviated: ['f.Kr.', 'e.Kr.'],
  wide: ['fyrir Krist', 'eftir Krist']
};
var quarterValues$G = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1F', '2F', '3F', '4F'],
  wide: ['1. fjórðungur', '2. fjórðungur', '3. fjórðungur', '4. fjórðungur']
};
var monthValues$G = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'Á', 'S', 'Ó', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'sept.', 'okt.', 'nóv.', 'des.'],
  wide: ['janúar', 'febrúar', 'mars', 'apríl', 'maí', 'júní', 'júlí', 'ágúst', 'september', 'október', 'nóvember', 'desember']
};
var dayValues$G = {
  narrow: ['S', 'M', 'Þ', 'M', 'F', 'F', 'L'],
  short: ['Su', 'Má', 'Þr', 'Mi', 'Fi', 'Fö', 'La'],
  abbreviated: ['sun.', 'mán.', 'þri.', 'mið.', 'fim.', 'fös.', 'lau'],
  wide: ['sunnudagur', 'mánudagur', 'þriðjudagur', 'miðvikudagur', 'fimmtudagur', 'föstudagur', 'laugardagur']
};
var dayPeriodValues$F = {
  narrow: {
    am: 'f',
    pm: 'e',
    midnight: 'miðnætti',
    noon: 'hádegi',
    morning: 'morgunn',
    afternoon: 'síðdegi',
    evening: 'kvöld',
    night: 'nótt'
  },
  abbreviated: {
    am: 'f.h.',
    pm: 'e.h.',
    midnight: 'miðnætti',
    noon: 'hádegi',
    morning: 'morgunn',
    afternoon: 'síðdegi',
    evening: 'kvöld',
    night: 'nótt'
  },
  wide: {
    am: 'fyrir hádegi',
    pm: 'eftir hádegi',
    midnight: 'miðnætti',
    noon: 'hádegi',
    morning: 'morgunn',
    afternoon: 'síðdegi',
    evening: 'kvöld',
    night: 'nótt'
  }
};
var formattingDayPeriodValues$y = {
  narrow: {
    am: 'f',
    pm: 'e',
    midnight: 'á miðnætti',
    noon: 'á hádegi',
    morning: 'að morgni',
    afternoon: 'síðdegis',
    evening: 'um kvöld',
    night: 'um nótt'
  },
  abbreviated: {
    am: 'f.h.',
    pm: 'e.h.',
    midnight: 'á miðnætti',
    noon: 'á hádegi',
    morning: 'að morgni',
    afternoon: 'síðdegis',
    evening: 'um kvöld',
    night: 'um nótt'
  },
  wide: {
    am: 'fyrir hádegi',
    pm: 'eftir hádegi',
    midnight: 'á miðnætti',
    noon: 'á hádegi',
    morning: 'að morgni',
    afternoon: 'síðdegis',
    evening: 'um kvöld',
    night: 'um nótt'
  }
};

var ordinalNumber$G = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + '.';
};

var localize$1k = {
  ordinalNumber: ordinalNumber$G,
  era: buildLocalizeFn({
    values: eraValues$G,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$G,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$G,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$G,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$F,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$y,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1l = localize$1k;

var matchOrdinalNumberPattern$G = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern$G = /\d+(\.)?/i;
var matchEraPatterns$G = {
  narrow: /^(f\.Kr\.|e\.Kr\.)/i,
  abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
  wide: /^(fyrir Krist|eftir Krist)/i
};
var parseEraPatterns$G = {
  any: [/^(f\.Kr\.)/i, /^(e\.Kr\.)/i]
};
var matchQuarterPatterns$G = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^q[1234]\.?/i,
  wide: /^[1234]\.? fjórðungur/i
};
var parseQuarterPatterns$G = {
  any: [/1\.?/i, /2\.?/i, /3\.?/i, /4\.?/i]
};
var matchMonthPatterns$G = {
  narrow: /^[jfmásónd]/i,
  abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
  wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var parseMonthPatterns$G = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^á/i, /^s/i, /^ó/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maí/i, /^jún/i, /^júl/i, /^áu/i, /^s/i, /^ó/i, /^n/i, /^d/i]
};
var matchDayPatterns$G = {
  narrow: /^[smtwf]/i,
  short: /^(su|má|þr|mi|fi|fö|la)/i,
  abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
  wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var parseDayPatterns$G = {
  narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
  any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i]
};
var matchDayPeriodPatterns$G = {
  narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
  any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var parseDayPeriodPatterns$G = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^mi/i,
    noon: /^há/i,
    morning: /morgunn/i,
    afternoon: /síðdegi/i,
    evening: /kvöld/i,
    night: /nótt/i
  }
};
var match$1k = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$G,
    parsePattern: parseOrdinalNumberPattern$G,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$G,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$G,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$G,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$G,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$G,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$G,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$G,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$G,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$G,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$G,
    defaultParseWidth: 'any'
  })
};
var match$1l = match$1k;

/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */

var locale$1k = {
  code: 'is',
  formatDistance: formatDistance$O,
  formatLong: formatLong$1l,
  formatRelative: formatRelative$O,
  localize: localize$1l,
  match: match$1l,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1l = locale$1k;

var formatDistanceLocale$E = {
  lessThanXSeconds: {
    one: 'meno di un secondo',
    other: 'meno di {{count}} secondi'
  },
  xSeconds: {
    one: 'un secondo',
    other: '{{count}} secondi'
  },
  halfAMinute: 'alcuni secondi',
  lessThanXMinutes: {
    one: 'meno di un minuto',
    other: 'meno di {{count}} minuti'
  },
  xMinutes: {
    one: 'un minuto',
    other: '{{count}} minuti'
  },
  aboutXHours: {
    one: "circa un'ora",
    other: 'circa {{count}} ore'
  },
  xHours: {
    one: "un'ora",
    other: '{{count}} ore'
  },
  xDays: {
    one: 'un giorno',
    other: '{{count}} giorni'
  },
  aboutXWeeks: {
    one: 'circa una settimana',
    other: 'circa {{count}} settimane'
  },
  xWeeks: {
    one: 'una settimana',
    other: '{{count}} settimane'
  },
  aboutXMonths: {
    one: 'circa un mese',
    other: 'circa {{count}} mesi'
  },
  xMonths: {
    one: 'un mese',
    other: '{{count}} mesi'
  },
  aboutXYears: {
    one: 'circa un anno',
    other: 'circa {{count}} anni'
  },
  xYears: {
    one: 'un anno',
    other: '{{count}} anni'
  },
  overXYears: {
    one: 'più di un anno',
    other: 'più di {{count}} anni'
  },
  almostXYears: {
    one: 'quasi un anno',
    other: 'quasi {{count}} anni'
  }
};

var formatDistance$L = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$E[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'tra ' + result;
    } else {
      return result + ' fa';
    }
  }

  return result;
};

var formatDistance$M = formatDistance$L;

var dateFormats$F = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/y'
};
var timeFormats$F = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$F = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$1i = {
  date: buildFormatLongFn({
    formats: dateFormats$F,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$F,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$F,
    defaultWidth: 'full'
  })
};
var formatLong$1j = formatLong$1i;

var weekdays$2 = ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato'];

function lastWeek$5(day) {
  switch (day) {
    case 0:
      return "'domenica scorsa alle' p";

    default:
      return "'" + weekdays$2[day] + " scorso alle' p";
  }
}

function thisWeek$5(day) {
  return "'" + weekdays$2[day] + " alle' p";
}

function nextWeek$5(day) {
  switch (day) {
    case 0:
      return "'domenica prossima alle' p";

    default:
      return "'" + weekdays$2[day] + " prossimo alle' p";
  }
}

var formatRelativeLocale$F = {
  lastWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek$5(day);
    } else {
      return lastWeek$5(day);
    }
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek$5(day);
    } else {
      return nextWeek$5(day);
    }
  },
  other: 'P'
};

var formatRelative$L = function (token, date, baseDate, options) {
  var format = formatRelativeLocale$F[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
};

var formatRelative$M = formatRelative$L;

var eraValues$F = {
  narrow: ['aC', 'dC'],
  abbreviated: ['a.C.', 'd.C.'],
  wide: ['avanti Cristo', 'dopo Cristo']
};
var quarterValues$F = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues$F = {
  narrow: ['G', 'F', 'M', 'A', 'M', 'G', 'L', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic'],
  wide: ['gennaio', 'febbraio', 'marzo', 'aprile', 'maggio', 'giugno', 'luglio', 'agosto', 'settembre', 'ottobre', 'novembre', 'dicembre']
};
var dayValues$F = {
  narrow: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
  short: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
  abbreviated: ['dom', 'lun', 'mar', 'mer', 'gio', 'ven', 'sab'],
  wide: ['domenica', 'lunedì', 'martedì', 'mercoledì', 'giovedì', 'venerdì', 'sabato']
};
var dayPeriodValues$E = {
  narrow: {
    am: 'm.',
    pm: 'p.',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'mattina',
    afternoon: 'pomeriggio',
    evening: 'sera',
    night: 'notte'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'mattina',
    afternoon: 'pomeriggio',
    evening: 'sera',
    night: 'notte'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'mattina',
    afternoon: 'pomeriggio',
    evening: 'sera',
    night: 'notte'
  }
};
var formattingDayPeriodValues$x = {
  narrow: {
    am: 'm.',
    pm: 'p.',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'di mattina',
    afternoon: 'del pomeriggio',
    evening: 'di sera',
    night: 'di notte'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'di mattina',
    afternoon: 'del pomeriggio',
    evening: 'di sera',
    night: 'di notte'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'mezzanotte',
    noon: 'mezzogiorno',
    morning: 'di mattina',
    afternoon: 'del pomeriggio',
    evening: 'di sera',
    night: 'di notte'
  }
};

var ordinalNumber$F = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + 'º';
};

var localize$1i = {
  ordinalNumber: ordinalNumber$F,
  era: buildLocalizeFn({
    values: eraValues$F,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$F,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$F,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$F,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$E,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$x,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1j = localize$1i;

var matchOrdinalNumberPattern$F = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern$F = /\d+/i;
var matchEraPatterns$F = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var parseEraPatterns$F = {
  any: [/^a/i, /^(d|e)/i]
};
var matchQuarterPatterns$F = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns$F = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$F = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var parseMonthPatterns$F = {
  narrow: [/^g/i, /^f/i, /^m/i, /^a/i, /^m/i, /^g/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ge/i, /^f/i, /^mar/i, /^ap/i, /^mag/i, /^gi/i, /^l/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$F = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var parseDayPatterns$F = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
};
var matchDayPeriodPatterns$F = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var parseDayPeriodPatterns$F = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
};
var match$1i = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$F,
    parsePattern: parseOrdinalNumberPattern$F,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$F,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$F,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$F,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$F,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$F,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$F,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$F,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$F,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$F,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$F,
    defaultParseWidth: 'any'
  })
};
var match$1j = match$1i;

/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */

var locale$1i = {
  code: 'it',
  formatDistance: formatDistance$M,
  formatLong: formatLong$1j,
  formatRelative: formatRelative$M,
  localize: localize$1j,
  match: match$1j,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1j = locale$1i;

var formatDistanceLocale$D = {
  lessThanXSeconds: {
    one: '1秒未満',
    other: '{{count}}秒未満',
    oneWithSuffix: '約1秒',
    otherWithSuffix: '約{{count}}秒'
  },
  xSeconds: {
    one: '1秒',
    other: '{{count}}秒'
  },
  halfAMinute: '30秒',
  lessThanXMinutes: {
    one: '1分未満',
    other: '{{count}}分未満',
    oneWithSuffix: '約1分',
    otherWithSuffix: '約{{count}}分'
  },
  xMinutes: {
    one: '1分',
    other: '{{count}}分'
  },
  aboutXHours: {
    one: '約1時間',
    other: '約{{count}}時間'
  },
  xHours: {
    one: '1時間',
    other: '{{count}}時間'
  },
  xDays: {
    one: '1日',
    other: '{{count}}日'
  },
  aboutXWeeks: {
    one: '約1週間',
    other: '約{{count}}週間'
  },
  xWeeks: {
    one: '1週間',
    other: '{{count}}週間'
  },
  aboutXMonths: {
    one: '約1か月',
    other: '約{{count}}か月'
  },
  xMonths: {
    one: '1か月',
    other: '{{count}}か月'
  },
  aboutXYears: {
    one: '約1年',
    other: '約{{count}}年'
  },
  xYears: {
    one: '1年',
    other: '{{count}}年'
  },
  overXYears: {
    one: '1年以上',
    other: '{{count}}年以上'
  },
  almostXYears: {
    one: '1年近く',
    other: '{{count}}年近く'
  }
};

var formatDistance$J = function (token, count, options) {
  options = options || {};
  var result;
  var tokenValue = formatDistanceLocale$D[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    if (options.addSuffix && tokenValue.oneWithSuffix) {
      result = tokenValue.oneWithSuffix;
    } else {
      result = tokenValue.one;
    }
  } else {
    if (options.addSuffix && tokenValue.otherWithSuffix) {
      result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    } else {
      result = tokenValue.other.replace('{{count}}', String(count));
    }
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + '後';
    } else {
      return result + '前';
    }
  }

  return result;
};

var formatDistance$K = formatDistance$J;

var dateFormats$E = {
  full: 'y年M月d日EEEE',
  long: 'y年M月d日',
  medium: 'y/MM/dd',
  short: 'y/MM/dd'
};
var timeFormats$E = {
  full: 'H時mm分ss秒 zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$E = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$1g = {
  date: buildFormatLongFn({
    formats: dateFormats$E,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$E,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$E,
    defaultWidth: 'full'
  })
};
var formatLong$1h = formatLong$1g;

var formatRelativeLocale$E = {
  lastWeek: '先週のeeeeのp',
  yesterday: '昨日のp',
  today: '今日のp',
  tomorrow: '明日のp',
  nextWeek: '翌週のeeeeのp',
  other: 'P'
};

var formatRelative$J = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$E[token];
};

var formatRelative$K = formatRelative$J;

var eraValues$E = {
  narrow: ['BC', 'AC'],
  abbreviated: ['紀元前', '西暦'],
  wide: ['紀元前', '西暦']
};
var quarterValues$E = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['第1四半期', '第2四半期', '第3四半期', '第4四半期']
};
var monthValues$E = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  wide: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
};
var dayValues$E = {
  narrow: ['日', '月', '火', '水', '木', '金', '土'],
  short: ['日', '月', '火', '水', '木', '金', '土'],
  abbreviated: ['日', '月', '火', '水', '木', '金', '土'],
  wide: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日']
};
var dayPeriodValues$D = {
  narrow: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  },
  abbreviated: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  },
  wide: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  }
};
var formattingDayPeriodValues$w = {
  narrow: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  },
  abbreviated: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  },
  wide: {
    am: '午前',
    pm: '午後',
    midnight: '深夜',
    noon: '正午',
    morning: '朝',
    afternoon: '午後',
    evening: '夜',
    night: '深夜'
  }
};

var ordinalNumber$E = function (dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   const options = dirtyOptions || {}
  //   const unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var options = dirtyOptions || {};
  var unit = String(options.unit);

  switch (unit) {
    case 'year':
      return "".concat(number, "\u5E74");

    case 'quarter':
      return "\u7B2C".concat(number, "\u56DB\u534A\u671F");

    case 'month':
      return "".concat(number, "\u6708");

    case 'week':
      return "\u7B2C".concat(number, "\u9031");

    case 'date':
      return "".concat(number, "\u65E5");

    case 'hour':
      return "".concat(number, "\u6642");

    case 'minute':
      return "".concat(number, "\u5206");

    case 'second':
      return "".concat(number, "\u79D2");

    default:
      return "".concat(number);
  }
};

var localize$1g = {
  ordinalNumber: ordinalNumber$E,
  era: buildLocalizeFn({
    values: eraValues$E,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$E,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$E,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$E,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$D,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$w,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1h = localize$1g;

var matchOrdinalNumberPattern$E = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var parseOrdinalNumberPattern$E = /\d+/i;
var matchEraPatterns$E = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(紀元[前後]|西暦)/i,
  wide: /^(紀元[前後]|西暦)/i
};
var parseEraPatterns$E = {
  narrow: [/^B/i, /^A/i],
  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
};
var matchQuarterPatterns$E = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^第[1234一二三四１２３４]四半期/i
};
var parseQuarterPatterns$E = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
};
var matchMonthPatterns$E = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])月/i,
  wide: /^([123456789]|1[012])月/i
};
var parseMonthPatterns$E = {
  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
};
var matchDayPatterns$E = {
  narrow: /^[日月火水木金土]/,
  short: /^[日月火水木金土]/,
  abbreviated: /^[日月火水木金土]/,
  wide: /^[日月火水木金土]曜日/
};
var parseDayPatterns$E = {
  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
};
var matchDayPeriodPatterns$E = {
  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var parseDayPeriodPatterns$E = {
  any: {
    am: /^(A|午前)/i,
    pm: /^(P|午後)/i,
    midnight: /^深夜|真夜中/i,
    noon: /^正午/i,
    morning: /^朝/i,
    afternoon: /^午後/i,
    evening: /^夜/i,
    night: /^深夜/i
  }
};
var match$1g = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$E,
    parsePattern: parseOrdinalNumberPattern$E,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$E,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$E,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$E,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$E,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$E,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$E,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$E,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$E,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$E,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$E,
    defaultParseWidth: 'any'
  })
};
var match$1h = match$1g;

/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */
var locale$1g = {
  code: 'ja',
  formatDistance: formatDistance$K,
  formatLong: formatLong$1h,
  formatRelative: formatRelative$K,
  localize: localize$1h,
  match: match$1h,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1h = locale$1g;

var formatDistanceLocale$C = {
  lessThanXSeconds: {
    one: '1びょうみまん',
    other: '{{count}}びょうみまん',
    oneWithSuffix: 'やく1びょう',
    otherWithSuffix: 'やく{{count}}びょう'
  },
  xSeconds: {
    one: '1びょう',
    other: '{{count}}びょう'
  },
  halfAMinute: '30びょう',
  lessThanXMinutes: {
    one: '1ぷんみまん',
    other: '{{count}}ふんみまん',
    oneWithSuffix: 'やく1ぷん',
    otherWithSuffix: 'やく{{count}}ふん'
  },
  xMinutes: {
    one: '1ぷん',
    other: '{{count}}ふん'
  },
  aboutXHours: {
    one: 'やく1じかん',
    other: 'やく{{count}}じかん'
  },
  xHours: {
    one: '1じかん',
    other: '{{count}}じかん'
  },
  xDays: {
    one: '1にち',
    other: '{{count}}にち'
  },
  aboutXWeeks: {
    one: 'やく1しゅうかん',
    other: 'やく{{count}}しゅうかん'
  },
  xWeeks: {
    one: '1しゅうかん',
    other: '{{count}}しゅうかん'
  },
  aboutXMonths: {
    one: 'やく1かげつ',
    other: 'やく{{count}}かげつ'
  },
  xMonths: {
    one: '1かげつ',
    other: '{{count}}かげつ'
  },
  aboutXYears: {
    one: 'やく1ねん',
    other: 'やく{{count}}ねん'
  },
  xYears: {
    one: '1ねん',
    other: '{{count}}ねん'
  },
  overXYears: {
    one: '1ねんいじょう',
    other: '{{count}}ねんいじょう'
  },
  almostXYears: {
    one: '1ねんちかく',
    other: '{{count}}ねんちかく'
  }
};

var formatDistance$H = function (token, count, options) {
  options = options || {};
  var result;
  var tokenValue = formatDistanceLocale$C[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    if (options.addSuffix && tokenValue.oneWithSuffix) {
      result = tokenValue.oneWithSuffix;
    } else {
      result = tokenValue.one;
    }
  } else {
    if (options.addSuffix && tokenValue.otherWithSuffix) {
      result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    } else {
      result = tokenValue.other.replace('{{count}}', String(count));
    }
  }

  if (options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + 'あと';
    } else {
      return result + 'まえ';
    }
  }

  return result;
};

var formatDistance$I = formatDistance$H;

var dateFormats$D = {
  full: 'yねんMがつdにちEEEE',
  long: 'yねんMがつdにち',
  medium: 'y/MM/dd',
  short: 'y/MM/dd'
};
var timeFormats$D = {
  full: 'Hじmmふんssびょう zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$D = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$1e = {
  date: buildFormatLongFn({
    formats: dateFormats$D,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$D,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$D,
    defaultWidth: 'full'
  })
};
var formatLong$1f = formatLong$1e;

var formatRelativeLocale$D = {
  lastWeek: 'せんしゅうのeeeeのp',
  yesterday: 'きのうのp',
  today: 'きょうのp',
  tomorrow: 'あしたのp',
  nextWeek: 'よくしゅうのeeeeのp',
  other: 'P'
};

var formatRelative$H = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$D[token];
};

var formatRelative$I = formatRelative$H;

var eraValues$D = {
  narrow: ['BC', 'AC'],
  abbreviated: ['きげんぜん', 'せいれき'],
  wide: ['きげんぜん', 'せいれき']
};
var quarterValues$D = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['だい1しはんき', 'だい2しはんき', 'だい3しはんき', 'だい4しはんき']
};
var monthValues$D = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['1がつ', '2がつ', '3がつ', '4がつ', '5がつ', '6がつ', '7がつ', '8がつ', '9がつ', '10がつ', '11がつ', '12がつ'],
  wide: ['1がつ', '2がつ', '3がつ', '4がつ', '5がつ', '6がつ', '7がつ', '8がつ', '9がつ', '10がつ', '11がつ', '12がつ']
};
var dayValues$D = {
  narrow: ['にち', 'げつ', 'か', 'すい', 'もく', 'きん', 'ど'],
  short: ['にち', 'げつ', 'か', 'すい', 'もく', 'きん', 'ど'],
  abbreviated: ['にち', 'げつ', 'か', 'すい', 'もく', 'きん', 'ど'],
  wide: ['にちようび', 'げつようび', 'かようび', 'すいようび', 'もくようび', 'きんようび', 'どようび']
};
var dayPeriodValues$C = {
  narrow: {
    am: 'ごぜん',
    pm: 'ごご',
    midnight: 'しんや',
    noon: 'しょうご',
    morning: 'あさ',
    afternoon: 'ごご',
    evening: 'よる',
    night: 'しんや'
  },
  abbreviated: {
    am: 'ごぜん',
    pm: 'ごご',
    midnight: 'しんや',
    noon: 'しょうご',
    morning: 'あさ',
    afternoon: 'ごご',
    evening: 'よる',
    night: 'しんや'
  },
  wide: {
    am: 'ごぜん',
    pm: 'ごご',
    midnight: 'しんや',
    noon: 'しょうご',
    morning: 'あさ',
    afternoon: 'ごご',
    evening: 'よる',
    night: 'しんや'
  }
};
var formattingDayPeriodValues$v = {
  narrow: {
    am: 'ごぜん',
    pm: 'ごご',
    midnight: 'しんや',
    noon: 'しょうご',
    morning: 'あさ',
    afternoon: 'ごご',
    evening: 'よる',
    night: 'しんや'
  },
  abbreviated: {
    am: 'ごぜん',
    pm: 'ごご',
    midnight: 'しんや',
    noon: 'しょうご',
    morning: 'あさ',
    afternoon: 'ごご',
    evening: 'よる',
    night: 'しんや'
  },
  wide: {
    am: 'ごぜん',
    pm: 'ごご',
    midnight: 'しんや',
    noon: 'しょうご',
    morning: 'あさ',
    afternoon: 'ごご',
    evening: 'よる',
    night: 'しんや'
  }
};

var ordinalNumber$D = function (dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   const options = dirtyOptions || {}
  //   const unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var options = dirtyOptions || {};
  var unit = String(options.unit);

  switch (unit) {
    case 'year':
      return "".concat(number, "\u306D\u3093");

    case 'quarter':
      return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");

    case 'month':
      return "".concat(number, "\u304C\u3064");

    case 'week':
      return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");

    case 'date':
      return "".concat(number, "\u306B\u3061");

    case 'hour':
      return "".concat(number, "\u3058");

    case 'minute':
      return "".concat(number, "\u3075\u3093");

    case 'second':
      return "".concat(number, "\u3073\u3087\u3046");

    default:
      return "".concat(number);
  }
};

var localize$1e = {
  ordinalNumber: ordinalNumber$D,
  era: buildLocalizeFn({
    values: eraValues$D,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$D,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$D,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$D,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$C,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$v,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1f = localize$1e;

var matchOrdinalNumberPattern$D = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var parseOrdinalNumberPattern$D = /\d+/i;
var matchEraPatterns$D = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(きげん[前後]|せいれき)/i,
  wide: /^(きげん[前後]|せいれき)/i
};
var parseEraPatterns$D = {
  narrow: [/^B/i, /^A/i],
  any: [/^(きげんぜん)/i, /^(せいれき|きげんご)/i]
};
var matchQuarterPatterns$D = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^だい[1234一二三四１２３４]しはんき/i
};
var parseQuarterPatterns$D = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
};
var matchMonthPatterns$D = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])がつ/i,
  wide: /^([123456789]|1[012])がつ/i
};
var parseMonthPatterns$D = {
  any: [/^1\D/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
};
var matchDayPatterns$D = {
  narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
  short: /^(にち|げつ|か|すい|もく|きん|ど)/,
  abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
  wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var parseDayPatterns$D = {
  any: [/^にち/, /^げつ/, /^か/, /^すい/, /^もく/, /^きん/, /^ど/]
};
var matchDayPeriodPatterns$D = {
  any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var parseDayPeriodPatterns$D = {
  any: {
    am: /^(A|ごぜん)/i,
    pm: /^(P|ごご)/i,
    midnight: /^しんや|まよなか/i,
    noon: /^しょうご/i,
    morning: /^あさ/i,
    afternoon: /^ごご/i,
    evening: /^よる/i,
    night: /^しんや/i
  }
};
var match$1e = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$D,
    parsePattern: parseOrdinalNumberPattern$D,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$D,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$D,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$D,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$D,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$D,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$D,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$D,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$D,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$D,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$D,
    defaultParseWidth: 'any'
  })
};
var match$1f = match$1e;

/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
 */

var locale$1e = {
  code: 'ja-Hira',
  formatDistance: formatDistance$I,
  formatLong: formatLong$1f,
  formatRelative: formatRelative$I,
  localize: localize$1f,
  match: match$1f,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1f = locale$1e;

var formatDistanceLocale$B = {
  lessThanXSeconds: {
    past: '{{count}} წამზე ნაკლები ხნის წინ',
    present: '{{count}} წამზე ნაკლები',
    future: '{{count}} წამზე ნაკლებში'
  },
  xSeconds: {
    past: '{{count}} წამის წინ',
    present: '{{count}} წამი',
    future: '{{count}} წამში'
  },
  halfAMinute: {
    past: 'ნახევარი წუთის წინ',
    present: 'ნახევარი წუთი',
    future: 'ნახევარი წუთში'
  },
  lessThanXMinutes: {
    past: '{{count}} წუთზე ნაკლები ხნის წინ',
    present: '{{count}} წუთზე ნაკლები',
    future: '{{count}} წუთზე ნაკლებში'
  },
  xMinutes: {
    past: '{{count}} წუთის წინ',
    present: '{{count}} წუთი',
    future: '{{count}} წუთში'
  },
  aboutXHours: {
    past: 'დაახლოებით {{count}} საათის წინ',
    present: 'დაახლოებით {{count}} საათი',
    future: 'დაახლოებით {{count}} საათში'
  },
  xHours: {
    past: '{{count}} საათის წინ',
    present: '{{count}} საათი',
    future: '{{count}} საათში'
  },
  xDays: {
    past: '{{count}} დღის წინ',
    present: '{{count}} დღე',
    future: '{{count}} დღეში'
  },
  aboutXWeeks: {
    past: 'დაახლოებით {{count}} კვირას წინ',
    present: 'დაახლოებით {{count}} კვირა',
    future: 'დაახლოებით {{count}} კვირაში'
  },
  xWeeks: {
    past: '{{count}} კვირას კვირა',
    present: '{{count}} კვირა',
    future: '{{count}} კვირაში'
  },
  aboutXMonths: {
    past: 'დაახლოებით {{count}} თვის წინ',
    present: 'დაახლოებით {{count}} თვე',
    future: 'დაახლოებით {{count}} თვეში'
  },
  xMonths: {
    past: '{{count}} თვის წინ',
    present: '{{count}} თვე',
    future: '{{count}} თვეში'
  },
  aboutXYears: {
    past: 'დაახლოებით {{count}} წლის წინ',
    present: 'დაახლოებით {{count}} წელი',
    future: 'დაახლოებით {{count}} წელში'
  },
  xYears: {
    past: '{{count}} წლის წინ',
    present: '{{count}} წელი',
    future: '{{count}} წელში'
  },
  overXYears: {
    past: '{{count}} წელზე მეტი ხნის წინ',
    present: '{{count}} წელზე მეტი',
    future: '{{count}} წელზე მეტი ხნის შემდეგ'
  },
  almostXYears: {
    past: 'თითქმის {{count}} წლის წინ',
    present: 'თითქმის {{count}} წელი',
    future: 'თითქმის {{count}} წელში'
  }
};
function formatDistance$G(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$B[token] === 'string') {
    result = formatDistanceLocale$B[token];
  } else if (options.addSuffix && options.comparison > 0) {
    result = formatDistanceLocale$B[token].future.replace('{{count}}', count);
  } else if (options.addSuffix && options.comparison <= 0) {
    result = formatDistanceLocale$B[token].past.replace('{{count}}', count);
  } else {
    result = formatDistanceLocale$B[token].present.replace('{{count}}', count);
  }

  return result;
}

var dateFormats$C = {
  full: 'EEEE, do MMMM, y',
  long: 'do, MMMM, y',
  medium: 'd, MMM, y',
  short: 'dd/MM/yyyy'
};
var timeFormats$C = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$C = {
  full: "{{date}} {{time}}'-ზე'",
  long: "{{date}} {{time}}'-ზე'",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$1c = {
  date: buildFormatLongFn({
    formats: dateFormats$C,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$C,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$C,
    defaultWidth: 'full'
  })
};
var formatLong$1d = formatLong$1c;

var formatRelativeLocale$C = {
  lastWeek: "'წინა' eeee p'-ზე'",
  yesterday: "'გუშინ' p'-ზე'",
  today: "'დღეს' p'-ზე'",
  tomorrow: "'ხვალ' p'-ზე'",
  nextWeek: "'შემდეგი' eeee p'-ზე'",
  other: 'P'
};
function formatRelative$G(token, _date, _baseDate, _options) {
  return formatRelativeLocale$C[token];
}

var eraValues$C = {
  narrow: ['ჩ.წ-მდე', 'ჩ.წ'],
  abbreviated: ['ჩვ.წ-მდე', 'ჩვ.წ'],
  wide: ['ჩვენს წელთაღრიცხვამდე', 'ჩვენი წელთაღრიცხვით']
};
var quarterValues$C = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-ლი კვ', '2-ე კვ', '3-ე კვ', '4-ე კვ'],
  wide: ['1-ლი კვარტალი', '2-ე კვარტალი', '3-ე კვარტალი', '4-ე კვარტალი']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$C = {
  narrow: ['ია', 'თე', 'მა', 'აპ', 'მს', 'ვნ', 'ვლ', 'აგ', 'სე', 'ოქ', 'ნო', 'დე'],
  abbreviated: ['იან', 'თებ', 'მარ', 'აპრ', 'მაი', 'ივნ', 'ივლ', 'აგვ', 'სექ', 'ოქტ', 'ნოე', 'დეკ'],
  wide: ['იანვარი', 'თებერვალი', 'მარტი', 'აპრილი', 'მაისი', 'ივნისი', 'ივლისი', 'აგვისტო', 'სექტემბერი', 'ოქტომბერი', 'ნოემბერი', 'დეკემბერი']
};
var dayValues$C = {
  narrow: ['კვ', 'ორ', 'სა', 'ოთ', 'ხუ', 'პა', 'შა'],
  short: ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'],
  abbreviated: ['კვი', 'ორშ', 'სამ', 'ოთხ', 'ხუთ', 'პარ', 'შაბ'],
  wide: ['კვირა', 'ორშაბათი', 'სამშაბათი', 'ოთხშაბათი', 'ხუთშაბათი', 'პარასკევი', 'შაბათი']
};
var dayPeriodValues$B = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'შუაღამე',
    noon: 'შუადღე',
    morning: 'დილა',
    afternoon: 'საღამო',
    evening: 'საღამო',
    night: 'ღამე'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'შუაღამე',
    noon: 'შუადღე',
    morning: 'დილა',
    afternoon: 'საღამო',
    evening: 'საღამო',
    night: 'ღამე'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'შუაღამე',
    noon: 'შუადღე',
    morning: 'დილა',
    afternoon: 'საღამო',
    evening: 'საღამო',
    night: 'ღამე'
  }
};
var formattingDayPeriodValues$u = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'შუაღამით',
    noon: 'შუადღისას',
    morning: 'დილით',
    afternoon: 'ნაშუადღევს',
    evening: 'საღამოს',
    night: 'ღამით'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'შუაღამით',
    noon: 'შუადღისას',
    morning: 'დილით',
    afternoon: 'ნაშუადღევს',
    evening: 'საღამოს',
    night: 'ღამით'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'შუაღამით',
    noon: 'შუადღისას',
    morning: 'დილით',
    afternoon: 'ნაშუადღევს',
    evening: 'საღამოს',
    night: 'ღამით'
  }
};

function ordinalNumber$C(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  if (number === 1) {
    return number + '-ლი';
  }

  return number + '-ე';
}

var localize$1c = {
  ordinalNumber: ordinalNumber$C,
  era: buildLocalizeFn({
    values: eraValues$C,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$C,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$C,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$C,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$B,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$u,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1d = localize$1c;

var matchOrdinalNumberPattern$C = /^(\d+)(-ლი|-ე)?/i;
var parseOrdinalNumberPattern$C = /\d+/i;
var matchEraPatterns$C = {
  narrow: /^(ჩვ?\.წ)/i,
  abbreviated: /^(ჩვ?\.წ)/i,
  wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var parseEraPatterns$C = {
  any: [/^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i, /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i]
};
var matchQuarterPatterns$C = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-(ლი|ე)? კვ/i,
  wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
var parseQuarterPatterns$C = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$C = {
  any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var parseMonthPatterns$C = {
  any: [/^ია/i, /^თ/i, /^მარ/i, /^აპ/i, /^მაი/i, /^ი?ვნ/i, /^ი?ვლ/i, /^აგ/i, /^ს/i, /^ო/i, /^ნ/i, /^დ/i]
};
var matchDayPatterns$C = {
  narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
  short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
  long: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var parseDayPatterns$C = {
  any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i]
};
var matchDayPeriodPatterns$C = {
  any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var parseDayPeriodPatterns$C = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^შუაღ/i,
    noon: /^შუადღ/i,
    morning: /^დილ/i,
    afternoon: /ნაშუადღევს/i,
    evening: /საღამო/i,
    night: /ღამ/i
  }
};
var match$1c = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$C,
    parsePattern: parseOrdinalNumberPattern$C,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$C,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$C,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$C,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$C,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$C,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$C,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$C,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$C,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$C,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$C,
    defaultParseWidth: 'any'
  })
};
var match$1d = match$1c;

/**
 * @type {Locale}
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
 */

var locale$1c = {
  code: 'ka',
  formatDistance: formatDistance$G,
  formatLong: formatLong$1d,
  formatRelative: formatRelative$G,
  localize: localize$1d,
  match: match$1d,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1d = locale$1c;

function declension$4(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  var rem10 = count % 10;
  var rem100 = count % 100; // 1, 21, 31, ...

  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace('{{count}}', count);
  }
}

function buildLocalizeTokenFn$3(scheme) {
  return function (count, options) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        if (scheme.future) {
          return declension$4(scheme.future, count);
        } else {
          return declension$4(scheme.regular, count) + ' кейін';
        }
      } else {
        if (scheme.past) {
          return declension$4(scheme.past, count);
        } else {
          return declension$4(scheme.regular, count) + ' бұрын';
        }
      }
    } else {
      return declension$4(scheme.regular, count);
    }
  };
}

var formatDistanceLocale$A = {
  lessThanXSeconds: buildLocalizeTokenFn$3({
    regular: {
      one: '1 секундтан аз',
      singularNominative: '{{count}} секундтан аз',
      singularGenitive: '{{count}} секундтан аз',
      pluralGenitive: '{{count}} секундтан аз'
    },
    future: {
      one: 'бір секундтан кейін',
      singularNominative: '{{count}} секундтан кейін',
      singularGenitive: '{{count}} секундтан кейін',
      pluralGenitive: '{{count}} секундтан кейін'
    }
  }),
  xSeconds: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: '{{count}} секунд',
      singularGenitive: '{{count}} секунд',
      pluralGenitive: '{{count}} секунд'
    },
    past: {
      singularNominative: '{{count}} секунд бұрын',
      singularGenitive: '{{count}} секунд бұрын',
      pluralGenitive: '{{count}} секунд бұрын'
    },
    future: {
      singularNominative: '{{count}} секундтан кейін',
      singularGenitive: '{{count}} секундтан кейін',
      pluralGenitive: '{{count}} секундтан кейін'
    }
  }),
  halfAMinute: function (_, options) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'жарты минут ішінде';
      } else {
        return 'жарты минут бұрын';
      }
    }

    return 'жарты минут';
  },
  lessThanXMinutes: buildLocalizeTokenFn$3({
    regular: {
      one: '1 минуттан аз',
      singularNominative: '{{count}} минуттан аз',
      singularGenitive: '{{count}} минуттан аз',
      pluralGenitive: '{{count}} минуттан аз'
    },
    future: {
      one: 'минуттан кем ',
      singularNominative: '{{count}} минуттан кем',
      singularGenitive: '{{count}} минуттан кем',
      pluralGenitive: '{{count}} минуттан кем'
    }
  }),
  xMinutes: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: '{{count}} минут',
      singularGenitive: '{{count}} минут',
      pluralGenitive: '{{count}} минут'
    },
    past: {
      singularNominative: '{{count}} минут бұрын',
      singularGenitive: '{{count}} минут бұрын',
      pluralGenitive: '{{count}} минут бұрын'
    },
    future: {
      singularNominative: '{{count}} минуттан кейін',
      singularGenitive: '{{count}} минуттан кейін',
      pluralGenitive: '{{count}} минуттан кейін'
    }
  }),
  aboutXHours: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: 'шамамен {{count}} сағат',
      singularGenitive: 'шамамен {{count}} сағат',
      pluralGenitive: 'шамамен {{count}} сағат'
    },
    future: {
      singularNominative: 'шамамен {{count}} сағаттан кейін',
      singularGenitive: 'шамамен {{count}} сағаттан кейін',
      pluralGenitive: 'шамамен {{count}} сағаттан кейін'
    }
  }),
  xHours: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: '{{count}} сағат',
      singularGenitive: '{{count}} сағат',
      pluralGenitive: '{{count}} сағат'
    }
  }),
  xDays: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: '{{count}} күн',
      singularGenitive: '{{count}} күн',
      pluralGenitive: '{{count}} күн'
    },
    future: {
      singularNominative: '{{count}} күннен кейін',
      singularGenitive: '{{count}} күннен кейін',
      pluralGenitive: '{{count}} күннен кейін'
    }
  }),
  aboutXWeeks: {
    one: 'шамамен 1 апта',
    other: 'шамамен {{count}} апта'
  },
  xWeeks: {
    one: '1 апта',
    other: '{{count}} апта'
  },
  aboutXMonths: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: 'шамамен {{count}} ай',
      singularGenitive: 'шамамен {{count}} ай',
      pluralGenitive: 'шамамен {{count}} ай'
    },
    future: {
      singularNominative: 'шамамен {{count}} айдан кейін',
      singularGenitive: 'шамамен {{count}} айдан кейін',
      pluralGenitive: 'шамамен {{count}} айдан кейін'
    }
  }),
  xMonths: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: '{{count}} ай',
      singularGenitive: '{{count}} ай',
      pluralGenitive: '{{count}} ай'
    }
  }),
  aboutXYears: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: 'шамамен {{count}} жыл',
      singularGenitive: 'шамамен {{count}} жыл',
      pluralGenitive: 'шамамен {{count}} жыл'
    },
    future: {
      singularNominative: 'шамамен {{count}} жылдан кейін',
      singularGenitive: 'шамамен {{count}} жылдан кейін',
      pluralGenitive: 'шамамен {{count}} жылдан кейін'
    }
  }),
  xYears: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: '{{count}} жыл',
      singularGenitive: '{{count}} жыл',
      pluralGenitive: '{{count}} жыл'
    },
    future: {
      singularNominative: '{{count}} жылдан кейін',
      singularGenitive: '{{count}} жылдан кейін',
      pluralGenitive: '{{count}} жылдан кейін'
    }
  }),
  overXYears: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: '{{count}} жылдан астам',
      singularGenitive: '{{count}} жылдан астам',
      pluralGenitive: '{{count}} жылдан астам'
    },
    future: {
      singularNominative: '{{count}} жылдан астам',
      singularGenitive: '{{count}} жылдан астам',
      pluralGenitive: '{{count}} жылдан астам'
    }
  }),
  almostXYears: buildLocalizeTokenFn$3({
    regular: {
      singularNominative: '{{count}} жылға жақын',
      singularGenitive: '{{count}} жылға жақын',
      pluralGenitive: '{{count}} жылға жақын'
    },
    future: {
      singularNominative: '{{count}} жылдан кейін',
      singularGenitive: '{{count}} жылдан кейін',
      pluralGenitive: '{{count}} жылдан кейін'
    }
  })
};
function formatDistance$F(token, count, options) {
  options = options || {};
  return formatDistanceLocale$A[token](count, options);
}

var dateFormats$B = {
  full: "EEEE, do MMMM y 'ж.'",
  long: "do MMMM y 'ж.'",
  medium: "d MMM y 'ж.'",
  short: 'dd.MM.yyyy'
};
var timeFormats$B = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$B = {
  any: '{{date}}, {{time}}'
};
var formatLong$1a = {
  date: buildFormatLongFn({
    formats: dateFormats$B,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$B,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$B,
    defaultWidth: 'any'
  })
};
var formatLong$1b = formatLong$1a;

var accusativeWeekdays$3 = ['жексенбіде', 'дүйсенбіде', 'сейсенбіде', 'сәрсенбіде', 'бейсенбіде', 'жұмада', 'сенбіде'];

function lastWeek$4(day) {
  var weekday = accusativeWeekdays$3[day];
  return "'өткен " + weekday + " сағат' p'-де'";
}

function thisWeek$4(day) {
  var weekday = accusativeWeekdays$3[day];
  return "'" + weekday + " сағат' p'-де'";
}

function nextWeek$4(day) {
  var weekday = accusativeWeekdays$3[day];
  return "'келесі " + weekday + " сағат' p'-де'";
}

var formatRelativeLocale$B = {
  lastWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek$4(day);
    } else {
      return lastWeek$4(day);
    }
  },
  yesterday: "'кеше сағат' p'-де'",
  today: "'бүгін сағат' p'-де'",
  tomorrow: "'ертең сағат' p'-де'",
  nextWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek$4(day);
    } else {
      return nextWeek$4(day);
    }
  },
  other: 'P'
};
function formatRelative$F(token, date, baseDate, options) {
  var format = formatRelativeLocale$B[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}

var eraValues$B = {
  narrow: ['б.з.д.', 'б.з.'],
  abbreviated: ['б.з.д.', 'б.з.'],
  wide: ['біздің заманымызға дейін', 'біздің заманымыз']
};
var quarterValues$B = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-ші тоқ.', '2-ші тоқ.', '3-ші тоқ.', '4-ші тоқ.'],
  wide: ['1-ші тоқсан', '2-ші тоқсан', '3-ші тоқсан', '4-ші тоқсан']
};
var monthValues$B = {
  narrow: ['Қ', 'А', 'Н', 'С', 'М', 'М', 'Ш', 'Т', 'Қ', 'Қ', 'Қ', 'Ж'],
  abbreviated: ['қаң', 'ақп', 'нау', 'сәу', 'мам', 'мау', 'шіл', 'там', 'қыр', 'қаз', 'қар', 'жел'],
  wide: ['қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым', 'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан']
};
var formattingMonthValues$9 = {
  narrow: ['Қ', 'А', 'Н', 'С', 'М', 'М', 'Ш', 'Т', 'Қ', 'Қ', 'Қ', 'Ж'],
  abbreviated: ['қаң', 'ақп', 'нау', 'сәу', 'мам', 'мау', 'шіл', 'там', 'қыр', 'қаз', 'қар', 'жел'],
  wide: ['қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым', 'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан']
};
var dayValues$B = {
  narrow: ['Ж', 'Д', 'С', 'С', 'Б', 'Ж', 'С'],
  short: ['жс', 'дс', 'сс', 'ср', 'бс', 'жм', 'сб'],
  abbreviated: ['жс', 'дс', 'сс', 'ср', 'бс', 'жм', 'сб'],
  wide: ['жексенбі', 'дүйсенбі', 'сейсенбі', 'сәрсенбі', 'бейсенбі', 'жұма', 'сенбі']
};
var dayPeriodValues$A = {
  narrow: {
    am: 'ТД',
    pm: 'ТК',
    midnight: 'түн ортасы',
    noon: 'түс',
    morning: 'таң',
    afternoon: 'күндіз',
    evening: 'кеш',
    night: 'түн'
  },
  wide: {
    am: 'ТД',
    pm: 'ТК',
    midnight: 'түн ортасы',
    noon: 'түс',
    morning: 'таң',
    afternoon: 'күндіз',
    evening: 'кеш',
    night: 'түн'
  }
};
var formattingDayPeriodValues$t = {
  narrow: {
    am: 'ТД',
    pm: 'ТК',
    midnight: 'түн ортасында',
    noon: 'түс',
    morning: 'таң',
    afternoon: 'күн',
    evening: 'кеш',
    night: 'түн'
  },
  wide: {
    am: 'ТД',
    pm: 'ТК',
    midnight: 'түн ортасында',
    noon: 'түсте',
    morning: 'таңертең',
    afternoon: 'күндіз',
    evening: 'кеште',
    night: 'түнде'
  }
};
var suffixes = {
  0: '-ші',
  1: '-ші',
  2: '-ші',
  3: '-ші',
  4: '-ші',
  5: '-ші',
  6: '-шы',
  7: '-ші',
  8: '-ші',
  9: '-шы',
  10: '-шы',
  20: '-шы',
  30: '-шы',
  40: '-шы',
  50: '-ші',
  60: '-шы',
  70: '-ші',
  80: '-ші',
  90: '-шы',
  100: '-ші'
};

function ordinalNumber$B(dirtyNumber) {
  var number = Number(dirtyNumber);
  var a = number % 10;
  var b = number >= 100 ? 100 : null;
  return number + (suffixes[number] || suffixes[a] || suffixes[b]);
}

var localize$1a = {
  ordinalNumber: ordinalNumber$B,
  era: buildLocalizeFn({
    values: eraValues$B,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$B,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$B,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$9,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$B,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$A,
    defaultWidth: 'any',
    formattingValues: formattingDayPeriodValues$t,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1b = localize$1a;

var matchOrdinalNumberPattern$B = /^(\d+)(-?(ші|шы))?/i;
var parseOrdinalNumberPattern$B = /\d+/i;
var matchEraPatterns$B = {
  narrow: /^((б )?з\.?\s?д\.?)/i,
  abbreviated: /^((б )?з\.?\s?д\.?)/i,
  wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var parseEraPatterns$B = {
  any: [/^б/i, /^з/i]
};
var matchQuarterPatterns$B = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?ші)? тоқ.?/i,
  wide: /^[1234](-?ші)? тоқсан/i
};
var parseQuarterPatterns$B = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$B = {
  narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
  abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
  wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var parseMonthPatterns$B = {
  narrow: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i],
  abbreviated: [/^қаң/i, /^ақп/i, /^нау/i, /^сәу/i, /^мам/i, /^мау/i, /^шіл/i, /^там/i, /^қыр/i, /^қаз/i, /^қар/i, /^жел/i],
  any: [/^қ/i, /^а/i, /^н/i, /^с/i, /^м/i, /^м/i, /^ш/i, /^т/i, /^қ/i, /^қ/i, /^қ/i, /^ж/i]
};
var matchDayPatterns$B = {
  narrow: /^(ж|д|с|с|б|ж|с)/i,
  short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
  wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var parseDayPatterns$B = {
  narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
  short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
  any: [/^ж[ек]/i, /^д[үй]/i, /^сe[й]/i, /^сә[р]/i, /^б[ей]/i, /^ж[ұм]/i, /^се[н]/i]
};
var matchDayPeriodPatterns$B = {
  narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var parseDayPeriodPatterns$B = {
  any: {
    am: /^ТД/i,
    pm: /^ТК/i,
    midnight: /^түн орта/i,
    noon: /^күндіз/i,
    morning: /таң/i,
    afternoon: /түс/i,
    evening: /кеш/i,
    night: /түн/i
  }
};
var match$1a = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$B,
    parsePattern: parseOrdinalNumberPattern$B,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$B,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$B,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$B,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$B,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$B,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$B,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$B,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$B,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$B,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns$B,
    defaultParseWidth: 'any'
  })
};
var match$1b = match$1a;

/**
 * @type {Locale}
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
 */

var locale$1a = {
  code: 'kk',
  formatDistance: formatDistance$F,
  formatLong: formatLong$1b,
  formatRelative: formatRelative$F,
  localize: localize$1b,
  match: match$1b,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$1b = locale$1a;

var formatDistanceLocale$z = {
  lessThanXSeconds: 'តិចជាង {{count}} វិនាទី',
  xSeconds: '{{count}} វិនាទី',
  halfAMinute: 'កន្លះនាទី',
  lessThanXMinutes: 'តិចជាង {{count}} នាទី',
  xMinutes: '{{count}} នាទី',
  aboutXHours: 'ប្រហែល {{count}} ម៉ោង',
  xHours: '{{count}} ម៉ោង',
  xDays: '{{count}} ថ្ងៃ',
  aboutXWeeks: 'ប្រហែល {{count}} សប្តាហ៍',
  xWeeks: '{{count}} សប្តាហ៍',
  aboutXMonths: 'ប្រហែល {{count}} ខែ',
  xMonths: '{{count}} ខែ',
  aboutXYears: 'ប្រហែល {{count}} ឆ្នាំ',
  xYears: '{{count}} ឆ្នាំ',
  overXYears: 'ជាង {{count}} ឆ្នាំ',
  almostXYears: 'ជិត {{count}} ឆ្នាំ'
};

var formatDistance$D = function (token, count, options) {
  var tokenValue = formatDistanceLocale$z[token];
  var result = tokenValue;

  if (typeof count === 'number') {
    result = result.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'ក្នុងរយៈពេល ' + result;
    } else {
      return result + 'មុន';
    }
  }

  return result;
};

var formatDistance$E = formatDistance$D;

var dateFormats$A = {
  full: 'EEEE do MMMM y',
  long: 'do MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/yyyy'
};
var timeFormats$A = {
  full: 'h:mm:ss a',
  long: 'h:mm:ss a',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$A = {
  full: "{{date}} 'ម៉ោង' {{time}}",
  long: "{{date}} 'ម៉ោង' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$18 = {
  date: buildFormatLongFn({
    formats: dateFormats$A,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$A,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$A,
    defaultWidth: 'full'
  })
};
var formatLong$19 = formatLong$18;

var formatRelativeLocale$A = {
  lastWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​មុនម៉ោង' p",
  yesterday: "'ម្សិលមិញនៅម៉ោង' p",
  today: "'ថ្ងៃនេះម៉ោង' p",
  tomorrow: "'ថ្ងៃស្អែកម៉ោង' p",
  nextWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​ក្រោយម៉ោង' p",
  other: 'P'
};

var formatRelative$D = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$A[token];
};

var formatRelative$E = formatRelative$D;

var eraValues$A = {
  narrow: ['ម.គស', 'គស'],
  abbreviated: ['មុនគ.ស', 'គ.ស'],
  wide: ['មុនគ្រិស្តសករាជ', 'នៃគ្រិស្តសករាជ']
};
var quarterValues$A = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['ត្រីមាសទី 1', 'ត្រីមាសទី 2', 'ត្រីមាសទី 3', 'ត្រីមាសទី 4']
};
var monthValues$A = {
  narrow: ['ម.ក', 'ក.ម', 'មិ', 'ម.ស', 'ឧ.ស', 'ម.ថ', 'ក.ដ', 'សី', 'កញ', 'តុ', 'វិ', 'ធ'],
  abbreviated: ['មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា', 'មិថុនា', 'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា', 'វិច្ឆិកា', 'ធ្នូ'],
  wide: ['មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា', 'មិថុនា', 'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា', 'វិច្ឆិកា', 'ធ្នូ']
};
var dayValues$A = {
  narrow: ['អា', 'ច', 'អ', 'ព', 'ព្រ', 'សុ', 'ស'],
  short: ['អា', 'ច', 'អ', 'ព', 'ព្រ', 'សុ', 'ស'],
  abbreviated: ['អា', 'ច', 'អ', 'ព', 'ព្រ', 'សុ', 'ស'],
  wide: ['អាទិត្យ', 'ចន្ទ', 'អង្គារ', 'ពុធ', 'ព្រហស្បតិ៍', 'សុក្រ', 'សៅរ៍']
};
var dayPeriodValues$z = {
  narrow: {
    am: 'ព្រឹក',
    pm: 'ល្ងាច',
    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
    noon: 'ពេលថ្ងៃត្រង់',
    morning: 'ពេលព្រឹក',
    afternoon: 'ពេលរសៀល',
    evening: 'ពេលល្ងាច',
    night: 'ពេលយប់'
  },
  abbreviated: {
    am: 'ព្រឹក',
    pm: 'ល្ងាច',
    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
    noon: 'ពេលថ្ងៃត្រង់',
    morning: 'ពេលព្រឹក',
    afternoon: 'ពេលរសៀល',
    evening: 'ពេលល្ងាច',
    night: 'ពេលយប់'
  },
  wide: {
    am: 'ព្រឹក',
    pm: 'ល្ងាច',
    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
    noon: 'ពេលថ្ងៃត្រង់',
    morning: 'ពេលព្រឹក',
    afternoon: 'ពេលរសៀល',
    evening: 'ពេលល្ងាច',
    night: 'ពេលយប់'
  }
};
var formattingDayPeriodValues$s = {
  narrow: {
    am: 'ព្រឹក',
    pm: 'ល្ងាច',
    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
    noon: 'ពេលថ្ងៃត្រង់',
    morning: 'ពេលព្រឹក',
    afternoon: 'ពេលរសៀល',
    evening: 'ពេលល្ងាច',
    night: 'ពេលយប់'
  },
  abbreviated: {
    am: 'ព្រឹក',
    pm: 'ល្ងាច',
    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
    noon: 'ពេលថ្ងៃត្រង់',
    morning: 'ពេលព្រឹក',
    afternoon: 'ពេលរសៀល',
    evening: 'ពេលល្ងាច',
    night: 'ពេលយប់'
  },
  wide: {
    am: 'ព្រឹក',
    pm: 'ល្ងាច',
    midnight: '​ពេលកណ្ដាលអធ្រាត្រ',
    noon: 'ពេលថ្ងៃត្រង់',
    morning: 'ពេលព្រឹក',
    afternoon: 'ពេលរសៀល',
    evening: 'ពេលល្ងាច',
    night: 'ពេលយប់'
  }
};

var ordinalNumber$A = function (dirtyNumber, _) {
  var number = Number(dirtyNumber);
  return number.toString();
};

var localize$18 = {
  ordinalNumber: ordinalNumber$A,
  era: buildLocalizeFn({
    values: eraValues$A,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$A,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$A,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$A,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$z,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$s,
    defaultFormattingWidth: 'wide'
  })
};
var localize$19 = localize$18;

var matchOrdinalNumberPattern$A = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$A = /\d+/i;
var matchEraPatterns$A = {
  narrow: /^(ម\.)?គស/i,
  abbreviated: /^(មុន)?គ\.ស/i,
  wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var parseEraPatterns$A = {
  any: [/^(ម|មុន)គ\.?ស/i, /^(នៃ)?គ\.?ស/i]
};
var matchQuarterPatterns$A = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var parseQuarterPatterns$A = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$A = {
  narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
  abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
  wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var parseMonthPatterns$A = {
  narrow: [/^ម\.ក/i, /^ក\.ម/i, /^មិ/i, /^ម\.ស/i, /^ឧ\.ស/i, /^ម\.ថ/i, /^ក\.ដ/i, /^សី/i, /^កញ/i, /^តុ/i, /^វិ/i, /^ធ/i],
  any: [/^មក/i, /^កុ/i, /^មីន/i, /^មេ/i, /^ឧស/i, /^មិថ/i, /^កក/i, /^សី/i, /^កញ/i, /^តុ/i, /^វិច/i, /^ធ/i]
};
var matchDayPatterns$A = {
  narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var parseDayPatterns$A = {
  narrow: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^ស/i],
  any: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^សៅ/i]
};
var matchDayPeriodPatterns$A = {
  narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
  any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var parseDayPeriodPatterns$A = {
  any: {
    am: /^ព្រឹក/i,
    pm: /^ល្ងាច/i,
    midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
    noon: /^ពេលថ្ងៃត្រង់/i,
    morning: /ពេលព្រឹក/i,
    afternoon: /ពេលរសៀល/i,
    evening: /ពេលល្ងាច/i,
    night: /ពេលយប់/i
  }
};
var match$18 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$A,
    parsePattern: parseOrdinalNumberPattern$A,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$A,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$A,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$A,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$A,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$A,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$A,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$A,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$A,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$A,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$A,
    defaultParseWidth: 'any'
  })
};
var match$19 = match$18;

/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
 */

var locale$18 = {
  code: 'km',
  formatDistance: formatDistance$E,
  formatLong: formatLong$19,
  formatRelative: formatRelative$E,
  localize: localize$19,
  match: match$19,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$19 = locale$18;

var formatDistanceLocale$y = {
  lessThanXSeconds: {
    one: {
      default: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
      future: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
      past: '1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ'
    },
    other: {
      default: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
      future: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ',
      past: '{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ'
    }
  },
  xSeconds: {
    one: {
      default: '1 ಸೆಕೆಂಡ್',
      future: '1 ಸೆಕೆಂಡ್‌ನಲ್ಲಿ',
      past: '1 ಸೆಕೆಂಡ್ ಹಿಂದೆ'
    },
    other: {
      default: '{{count}} ಸೆಕೆಂಡುಗಳು',
      future: '{{count}} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ',
      past: '{{count}} ಸೆಕೆಂಡ್ ಹಿಂದೆ'
    }
  },
  halfAMinute: {
    other: {
      default: 'ಅರ್ಧ ನಿಮಿಷ',
      future: 'ಅರ್ಧ ನಿಮಿಷದಲ್ಲಿ',
      past: 'ಅರ್ಧ ನಿಮಿಷದ ಹಿಂದೆ'
    }
  },
  lessThanXMinutes: {
    one: {
      default: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
      future: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
      past: '1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ'
    },
    other: {
      default: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
      future: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ',
      past: '{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ'
    }
  },
  xMinutes: {
    one: {
      default: '1 ನಿಮಿಷ',
      future: '1 ನಿಮಿಷದಲ್ಲಿ',
      past: '1 ನಿಮಿಷದ ಹಿಂದೆ'
    },
    other: {
      default: '{{count}} ನಿಮಿಷಗಳು',
      future: '{{count}} ನಿಮಿಷಗಳಲ್ಲಿ',
      past: '{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ'
    }
  },
  aboutXHours: {
    one: {
      default: 'ಸುಮಾರು 1 ಗಂಟೆ',
      future: 'ಸುಮಾರು 1 ಗಂಟೆಯಲ್ಲಿ',
      past: 'ಸುಮಾರು 1 ಗಂಟೆ ಹಿಂದೆ'
    },
    other: {
      default: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳು',
      future: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳಲ್ಲಿ',
      past: 'ಸುಮಾರು {{count}} ಗಂಟೆಗಳ ಹಿಂದೆ'
    }
  },
  xHours: {
    one: {
      default: '1 ಗಂಟೆ',
      future: '1 ಗಂಟೆಯಲ್ಲಿ',
      past: '1 ಗಂಟೆ ಹಿಂದೆ'
    },
    other: {
      default: '{{count}} ಗಂಟೆಗಳು',
      future: '{{count}} ಗಂಟೆಗಳಲ್ಲಿ',
      past: '{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ'
    }
  },
  xDays: {
    one: {
      default: '1 ದಿನ',
      future: '1 ದಿನದಲ್ಲಿ',
      past: '1 ದಿನದ ಹಿಂದೆ'
    },
    other: {
      default: '{{count}} ದಿನಗಳು',
      future: '{{count}} ದಿನಗಳಲ್ಲಿ',
      past: '{{count}} ದಿನಗಳ ಹಿಂದೆ'
    }
  },
  aboutXMonths: {
    one: {
      default: 'ಸುಮಾರು 1 ತಿಂಗಳು',
      future: 'ಸುಮಾರು 1 ತಿಂಗಳಲ್ಲಿ',
      past: 'ಸುಮಾರು 1 ತಿಂಗಳ ಹಿಂದೆ'
    },
    other: {
      default: 'ಸುಮಾರು {{count}} ತಿಂಗಳು',
      future: 'ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳಲ್ಲಿ',
      past: 'ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ'
    }
  },
  xMonths: {
    one: {
      default: '1 ತಿಂಗಳು',
      future: '1 ತಿಂಗಳಲ್ಲಿ',
      past: '1 ತಿಂಗಳ ಹಿಂದೆ'
    },
    other: {
      default: '{{count}} ತಿಂಗಳು',
      future: '{{count}} ತಿಂಗಳುಗಳಲ್ಲಿ',
      past: '{{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ'
    }
  },
  aboutXYears: {
    one: {
      default: 'ಸುಮಾರು 1 ವರ್ಷ',
      future: 'ಸುಮಾರು 1 ವರ್ಷದಲ್ಲಿ',
      past: 'ಸುಮಾರು 1 ವರ್ಷದ ಹಿಂದೆ'
    },
    other: {
      default: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳು',
      future: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳಲ್ಲಿ',
      past: 'ಸುಮಾರು {{count}} ವರ್ಷಗಳ ಹಿಂದೆ'
    }
  },
  xYears: {
    one: {
      default: '1 ವರ್ಷ',
      future: '1 ವರ್ಷದಲ್ಲಿ',
      past: '1 ವರ್ಷದ ಹಿಂದೆ'
    },
    other: {
      default: '{{count}} ವರ್ಷಗಳು',
      future: '{{count}} ವರ್ಷಗಳಲ್ಲಿ',
      past: '{{count}} ವರ್ಷಗಳ ಹಿಂದೆ'
    }
  },
  overXYears: {
    one: {
      default: '1 ವರ್ಷದ ಮೇಲೆ',
      future: '1 ವರ್ಷದ ಮೇಲೆ',
      past: '1 ವರ್ಷದ ಮೇಲೆ'
    },
    other: {
      default: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ',
      future: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ',
      past: '{{count}} ವರ್ಷಗಳ ಮೇಲೆ'
    }
  },
  almostXYears: {
    one: {
      default: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ',
      future: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ',
      past: 'ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ'
    },
    other: {
      default: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ',
      future: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ',
      past: 'ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ'
    }
  }
};

function getResultByTense(parentToken, options) {
  if (options.addSuffix) {
    if (options.comparison > 0) {
      return parentToken.future;
    } else {
      return parentToken.past;
    }
  }

  return parentToken.default;
}

function formatDistance$C(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$y[token] === 'string') {
    result = formatDistanceLocale$y[token];
  } else if (count === 1) {
    result = getResultByTense(formatDistanceLocale$y[token].one, options);
  } else {
    result = getResultByTense(formatDistanceLocale$y[token].other, options);
  }

  return result.replace('{{count}}', count);
}

// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
var dateFormats$z = {
  full: 'EEEE, MMMM d, y',
  // CLDR 1816
  long: 'MMMM d, y',
  // CLDR 1817
  medium: 'MMM d, y',
  // CLDR 1818
  short: 'd/M/yy' // CLDR 1819

};
var timeFormats$z = {
  full: 'hh:mm:ss a zzzz',
  // CLDR 1820
  long: 'hh:mm:ss a z',
  // CLDR 1821
  medium: 'hh:mm:ss a',
  // CLDR 1822
  short: 'hh:mm a' // CLDR 1823

};
var dateTimeFormats$z = {
  full: '{{date}} {{time}}',
  // CLDR 1824
  long: '{{date}} {{time}}',
  // CLDR 1825
  medium: '{{date}} {{time}}',
  // CLDR 1826
  short: '{{date}} {{time}}' // CLDR 1827

};
var formatLong$16 = {
  date: buildFormatLongFn({
    formats: dateFormats$z,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$z,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$z,
    defaultWidth: 'full'
  })
};
var formatLong$17 = formatLong$16;

var formatRelativeLocale$z = {
  lastWeek: "'ಕಳೆದ' eeee p 'ಕ್ಕೆ'",
  yesterday: "'ನಿನ್ನೆ' p 'ಕ್ಕೆ'",
  today: "'ಇಂದು' p 'ಕ್ಕೆ'",
  tomorrow: "'ನಾಳೆ' p 'ಕ್ಕೆ'",
  nextWeek: "eeee p 'ಕ್ಕೆ'",
  other: 'P'
};
function formatRelative$C(token, _date, _baseDate, _options) {
  return formatRelativeLocale$z[token];
}

// Reference: https://www.unicode.org/cldr/charts/32/summary/kn.html
var eraValues$z = {
  narrow: ['ಕ್ರಿ.ಪೂ', 'ಕ್ರಿ.ಶ'],
  abbreviated: ['ಕ್ರಿ.ಪೂ', 'ಕ್ರಿ.ಶ'],
  // CLDR #1618, #1620
  wide: ['ಕ್ರಿಸ್ತ ಪೂರ್ವ', 'ಕ್ರಿಸ್ತ ಶಕ'] // CLDR #1614, #1616

};
var quarterValues$z = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['ತ್ರೈ 1', 'ತ್ರೈ 2', 'ತ್ರೈ 3', 'ತ್ರೈ 4'],
  // CLDR #1630 - #1638
  wide: ['1ನೇ ತ್ರೈಮಾಸಿಕ', '2ನೇ ತ್ರೈಮಾಸಿಕ', '3ನೇ ತ್ರೈಮಾಸಿಕ', '4ನೇ ತ್ರೈಮಾಸಿಕ'] // CLDR #1622 - #1629

}; // CLDR #1646 - #1717

var monthValues$z = {
  narrow: ['ಜ', 'ಫೆ', 'ಮಾ', 'ಏ', 'ಮೇ', 'ಜೂ', 'ಜು', 'ಆ', 'ಸೆ', 'ಅ', 'ನ', 'ಡಿ'],
  abbreviated: ['ಜನ', 'ಫೆಬ್ರ', 'ಮಾರ್ಚ್', 'ಏಪ್ರಿ', 'ಮೇ', 'ಜೂನ್', 'ಜುಲೈ', 'ಆಗ', 'ಸೆಪ್ಟೆಂ', 'ಅಕ್ಟೋ', 'ನವೆಂ', 'ಡಿಸೆಂ'],
  wide: ['ಜನವರಿ', 'ಫೆಬ್ರವರಿ', 'ಮಾರ್ಚ್', 'ಏಪ್ರಿಲ್', 'ಮೇ', 'ಜೂನ್', 'ಜುಲೈ', 'ಆಗಸ್ಟ್', 'ಸೆಪ್ಟೆಂಬರ್', 'ಅಕ್ಟೋಬರ್', 'ನವೆಂಬರ್', 'ಡಿಸೆಂಬರ್']
}; // CLDR #1718 - #1773

var dayValues$z = {
  narrow: ['ಭಾ', 'ಸೋ', 'ಮಂ', 'ಬು', 'ಗು', 'ಶು', 'ಶ'],
  short: ['ಭಾನು', 'ಸೋಮ', 'ಮಂಗಳ', 'ಬುಧ', 'ಗುರು', 'ಶುಕ್ರ', 'ಶನಿ'],
  abbreviated: ['ಭಾನು', 'ಸೋಮ', 'ಮಂಗಳ', 'ಬುಧ', 'ಗುರು', 'ಶುಕ್ರ', 'ಶನಿ'],
  wide: ['ಭಾನುವಾರ', 'ಸೋಮವಾರ', 'ಮಂಗಳವಾರ', 'ಬುಧವಾರ', 'ಗುರುವಾರ', 'ಶುಕ್ರವಾರ', 'ಶನಿವಾರ']
}; // CLDR #1774 - #1815

var dayPeriodValues$y = {
  narrow: {
    am: 'ಪೂರ್ವಾಹ್ನ',
    pm: 'ಅಪರಾಹ್ನ',
    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
    noon: 'ಮಧ್ಯಾಹ್ನ',
    morning: 'ಬೆಳಗ್ಗೆ',
    afternoon: 'ಮಧ್ಯಾಹ್ನ',
    evening: 'ಸಂಜೆ',
    night: 'ರಾತ್ರಿ'
  },
  abbreviated: {
    am: 'ಪೂರ್ವಾಹ್ನ',
    pm: 'ಅಪರಾಹ್ನ',
    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
    noon: 'ಮಧ್ಯಾನ್ಹ',
    morning: 'ಬೆಳಗ್ಗೆ',
    afternoon: 'ಮಧ್ಯಾನ್ಹ',
    evening: 'ಸಂಜೆ',
    night: 'ರಾತ್ರಿ'
  },
  wide: {
    am: 'ಪೂರ್ವಾಹ್ನ',
    pm: 'ಅಪರಾಹ್ನ',
    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
    noon: 'ಮಧ್ಯಾನ್ಹ',
    morning: 'ಬೆಳಗ್ಗೆ',
    afternoon: 'ಮಧ್ಯಾನ್ಹ',
    evening: 'ಸಂಜೆ',
    night: 'ರಾತ್ರಿ'
  }
};
var formattingDayPeriodValues$r = {
  narrow: {
    am: 'ಪೂ',
    pm: 'ಅ',
    midnight: 'ಮಧ್ಯರಾತ್ರಿ',
    noon: 'ಮಧ್ಯಾನ್ಹ',
    morning: 'ಬೆಳಗ್ಗೆ',
    afternoon: 'ಮಧ್ಯಾನ್ಹ',
    evening: 'ಸಂಜೆ',
    night: 'ರಾತ್ರಿ'
  },
  abbreviated: {
    am: 'ಪೂರ್ವಾಹ್ನ',
    pm: 'ಅಪರಾಹ್ನ',
    midnight: 'ಮಧ್ಯ ರಾತ್ರಿ',
    noon: 'ಮಧ್ಯಾನ್ಹ',
    morning: 'ಬೆಳಗ್ಗೆ',
    afternoon: 'ಮಧ್ಯಾನ್ಹ',
    evening: 'ಸಂಜೆ',
    night: 'ರಾತ್ರಿ'
  },
  wide: {
    am: 'ಪೂರ್ವಾಹ್ನ',
    pm: 'ಅಪರಾಹ್ನ',
    midnight: 'ಮಧ್ಯ ರಾತ್ರಿ',
    noon: 'ಮಧ್ಯಾನ್ಹ',
    morning: 'ಬೆಳಗ್ಗೆ',
    afternoon: 'ಮಧ್ಯಾನ್ಹ',
    evening: 'ಸಂಜೆ',
    night: 'ರಾತ್ರಿ'
  }
};

function ordinalNumber$z(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);
  return number + 'ನೇ';
}

var localize$16 = {
  ordinalNumber: ordinalNumber$z,
  era: buildLocalizeFn({
    values: eraValues$z,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$z,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$z,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$z,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$y,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$r,
    defaultFormattingWidth: 'wide'
  })
};
var localize$17 = localize$16;

var matchOrdinalNumberPattern$z = /^(\d+)(ನೇ|ನೆ)?/i;
var parseOrdinalNumberPattern$z = /\d+/i;
var matchEraPatterns$z = {
  narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
  abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
  wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var parseEraPatterns$z = {
  any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i]
};
var matchQuarterPatterns$z = {
  narrow: /^[1234]/i,
  abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
  wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var parseQuarterPatterns$z = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$z = {
  narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
  abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
  wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var parseMonthPatterns$z = {
  narrow: [/^ಜ$/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂ/i, /^ಜು$/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i],
  any: [/^ಜನ/i, /^ಫೆ/i, /^ಮಾ/i, /^ಏ/i, /^ಮೇ/i, /^ಜೂನ್/i, /^ಜುಲೈ/i, /^ಆ/i, /^ಸೆ/i, /^ಅ/i, /^ನ/i, /^ಡಿ/i]
};
var matchDayPatterns$z = {
  narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
  short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var parseDayPatterns$z = {
  narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
  any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i]
};
var matchDayPeriodPatterns$z = {
  narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
  any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var parseDayPeriodPatterns$z = {
  any: {
    am: /^ಪೂ/i,
    pm: /^ಅ/i,
    midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
    noon: /ಮಧ್ಯಾನ್ಹ/i,
    morning: /ಬೆಳಗ್ಗೆ/i,
    afternoon: /ಮಧ್ಯಾನ್ಹ/i,
    evening: /ಸಂಜೆ/i,
    night: /ರಾತ್ರಿ/i
  }
};
var match$16 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$z,
    parsePattern: parseOrdinalNumberPattern$z,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$z,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$z,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$z,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$z,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$z,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$z,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$z,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$z,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$z,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$z,
    defaultParseWidth: 'any'
  })
};
var match$17 = match$16;

/**
 * @type {Locale}
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
 */

var locale$16 = {
  code: 'kn',
  formatDistance: formatDistance$C,
  formatLong: formatLong$17,
  formatRelative: formatRelative$C,
  localize: localize$17,
  match: match$17,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$17 = locale$16;

var formatDistanceLocale$x = {
  lessThanXSeconds: {
    one: '1초 미만',
    other: '{{count}}초 미만'
  },
  xSeconds: {
    one: '1초',
    other: '{{count}}초'
  },
  halfAMinute: '30초',
  lessThanXMinutes: {
    one: '1분 미만',
    other: '{{count}}분 미만'
  },
  xMinutes: {
    one: '1분',
    other: '{{count}}분'
  },
  aboutXHours: {
    one: '약 1시간',
    other: '약 {{count}}시간'
  },
  xHours: {
    one: '1시간',
    other: '{{count}}시간'
  },
  xDays: {
    one: '1일',
    other: '{{count}}일'
  },
  aboutXWeeks: {
    one: '약 1주',
    other: '약 {{count}}주'
  },
  xWeeks: {
    one: '1주',
    other: '{{count}}주'
  },
  aboutXMonths: {
    one: '약 1개월',
    other: '약 {{count}}개월'
  },
  xMonths: {
    one: '1개월',
    other: '{{count}}개월'
  },
  aboutXYears: {
    one: '약 1년',
    other: '약 {{count}}년'
  },
  xYears: {
    one: '1년',
    other: '{{count}}년'
  },
  overXYears: {
    one: '1년 이상',
    other: '{{count}}년 이상'
  },
  almostXYears: {
    one: '거의 1년',
    other: '거의 {{count}}년'
  }
};

var formatDistance$A = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$x[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + ' 후';
    } else {
      return result + ' 전';
    }
  }

  return result;
};

var formatDistance$B = formatDistance$A;

var dateFormats$y = {
  full: 'y년 M월 d일 EEEE',
  long: 'y년 M월 d일',
  medium: 'y.MM.dd',
  short: 'y.MM.dd'
};
var timeFormats$y = {
  full: 'a H시 mm분 ss초 zzzz',
  long: 'a H:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$y = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$14 = {
  date: buildFormatLongFn({
    formats: dateFormats$y,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$y,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$y,
    defaultWidth: 'full'
  })
};
var formatLong$15 = formatLong$14;

var formatRelativeLocale$y = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: 'P'
};

var formatRelative$A = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$y[token];
};

var formatRelative$B = formatRelative$A;

var eraValues$y = {
  narrow: ['BC', 'AD'],
  abbreviated: ['BC', 'AD'],
  wide: ['기원전', '서기']
};
var quarterValues$y = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1분기', '2분기', '3분기', '4분기']
};
var monthValues$y = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
  wide: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월']
};
var dayValues$y = {
  narrow: ['일', '월', '화', '수', '목', '금', '토'],
  short: ['일', '월', '화', '수', '목', '금', '토'],
  abbreviated: ['일', '월', '화', '수', '목', '금', '토'],
  wide: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일']
};
var dayPeriodValues$x = {
  narrow: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  abbreviated: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  wide: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  }
};
var formattingDayPeriodValues$q = {
  narrow: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  abbreviated: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  },
  wide: {
    am: '오전',
    pm: '오후',
    midnight: '자정',
    noon: '정오',
    morning: '아침',
    afternoon: '오후',
    evening: '저녁',
    night: '밤'
  }
};

var ordinalNumber$y = function (dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);
  var options = dirtyOptions || {};
  var unit = String(options.unit);

  switch (unit) {
    case 'minute':
    case 'second':
      return String(number);

    case 'date':
      return number + '일';

    default:
      return number + '번째';
  }
};

var localize$14 = {
  ordinalNumber: ordinalNumber$y,
  era: buildLocalizeFn({
    values: eraValues$y,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$y,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$y,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$y,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$x,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$q,
    defaultFormattingWidth: 'wide'
  })
};
var localize$15 = localize$14;

var matchOrdinalNumberPattern$y = /^(\d+)(일|번째)?/i;
var parseOrdinalNumberPattern$y = /\d+/i;
var matchEraPatterns$y = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
};
var parseEraPatterns$y = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
};
var matchQuarterPatterns$y = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
};
var parseQuarterPatterns$y = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$y = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
};
var parseMonthPatterns$y = {
  any: [/^1월?$/, /^2/, /^3/, /^4/, /^5/, /^6/, /^7/, /^8/, /^9/, /^10/, /^11/, /^12/]
};
var matchDayPatterns$y = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
};
var parseDayPatterns$y = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
};
var matchDayPeriodPatterns$y = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var parseDayPeriodPatterns$y = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
};
var match$14 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$y,
    parsePattern: parseOrdinalNumberPattern$y,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$y,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$y,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$y,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$y,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$y,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$y,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$y,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$y,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$y,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$y,
    defaultParseWidth: 'any'
  })
};
var match$15 = match$14;

/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */

var locale$14 = {
  code: 'ko',
  formatDistance: formatDistance$B,
  formatLong: formatLong$15,
  formatRelative: formatRelative$B,
  localize: localize$15,
  match: match$15,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$15 = locale$14;

var formatDistanceLocale$w = {
  lessThanXSeconds: {
    standalone: {
      one: 'manner wéi eng Sekonn',
      other: 'manner wéi {{count}} Sekonnen'
    },
    withPreposition: {
      one: 'manner wéi enger Sekonn',
      other: 'manner wéi {{count}} Sekonnen'
    }
  },
  xSeconds: {
    standalone: {
      one: 'eng Sekonn',
      other: '{{count}} Sekonnen'
    },
    withPreposition: {
      one: 'enger Sekonn',
      other: '{{count}} Sekonnen'
    }
  },
  halfAMinute: {
    standalone: 'eng hallef Minutt',
    withPreposition: 'enger hallwer Minutt'
  },
  lessThanXMinutes: {
    standalone: {
      one: 'manner wéi eng Minutt',
      other: 'manner wéi {{count}} Minutten'
    },
    withPreposition: {
      one: 'manner wéi enger Minutt',
      other: 'manner wéi {{count}} Minutten'
    }
  },
  xMinutes: {
    standalone: {
      one: 'eng Minutt',
      other: '{{count}} Minutten'
    },
    withPreposition: {
      one: 'enger Minutt',
      other: '{{count}} Minutten'
    }
  },
  aboutXHours: {
    standalone: {
      one: 'ongeféier eng Stonn',
      other: 'ongeféier {{count}} Stonnen'
    },
    withPreposition: {
      one: 'ongeféier enger Stonn',
      other: 'ongeféier {{count}} Stonnen'
    }
  },
  xHours: {
    standalone: {
      one: 'eng Stonn',
      other: '{{count}} Stonnen'
    },
    withPreposition: {
      one: 'enger Stonn',
      other: '{{count}} Stonnen'
    }
  },
  xDays: {
    standalone: {
      one: 'een Dag',
      other: '{{count}} Deeg'
    },
    withPreposition: {
      one: 'engem Dag',
      other: '{{count}} Deeg'
    }
  },
  aboutXWeeks: {
    standalone: {
      one: 'ongeféier eng Woch',
      other: 'ongeféier {{count}} Wochen'
    },
    withPreposition: {
      one: 'ongeféier enger Woche',
      other: 'ongeféier {{count}} Wochen'
    }
  },
  xWeeks: {
    standalone: {
      one: 'eng Woch',
      other: '{{count}} Wochen'
    },
    withPreposition: {
      one: 'enger Woch',
      other: '{{count}} Wochen'
    }
  },
  aboutXMonths: {
    standalone: {
      one: 'ongeféier ee Mount',
      other: 'ongeféier {{count}} Méint'
    },
    withPreposition: {
      one: 'ongeféier engem Mount',
      other: 'ongeféier {{count}} Méint'
    }
  },
  xMonths: {
    standalone: {
      one: 'ee Mount',
      other: '{{count}} Méint'
    },
    withPreposition: {
      one: 'engem Mount',
      other: '{{count}} Méint'
    }
  },
  aboutXYears: {
    standalone: {
      one: 'ongeféier ee Joer',
      other: 'ongeféier {{count}} Joer'
    },
    withPreposition: {
      one: 'ongeféier engem Joer',
      other: 'ongeféier {{count}} Joer'
    }
  },
  xYears: {
    standalone: {
      one: 'ee Joer',
      other: '{{count}} Joer'
    },
    withPreposition: {
      one: 'engem Joer',
      other: '{{count}} Joer'
    }
  },
  overXYears: {
    standalone: {
      one: 'méi wéi ee Joer',
      other: 'méi wéi {{count}} Joer'
    },
    withPreposition: {
      one: 'méi wéi engem Joer',
      other: 'méi wéi {{count}} Joer'
    }
  },
  almostXYears: {
    standalone: {
      one: 'bal ee Joer',
      other: 'bal {{count}} Joer'
    },
    withPreposition: {
      one: 'bal engem Joer',
      other: 'bal {{count}} Joer'
    }
  }
};
var EXCEPTION_CONSONANTS = ['d', 'h', 'n', 't', 'z'];
var VOWELS = ['a,', 'e', 'i', 'o', 'u'];
var DIGITS_SPOKEN_N_NEEDED = [0, 1, 2, 3, 8, 9];
var FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [40, 50, 60, 70]; // Eifeler Regel

function isFinalNNeeded(nextWords) {
  var firstLetter = nextWords.charAt(0).toLowerCase();

  if (VOWELS.indexOf(firstLetter) != -1 || EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) {
    return true;
  } // Numbers would need to converted into words for checking.
  // Therefore, I have listed the digits that require a preceeding n with a few exceptions.


  var firstWord = nextWords.split(' ')[0];
  var number = parseInt(firstWord);

  if (!isNaN(number) && DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) {
    return true;
  } // Omit other checks as they are not expected here.


  return false;
}

function formatDistance$z(token, count, options) {
  options = options || {};
  var usageGroup = options.addSuffix ? formatDistanceLocale$w[token].withPreposition : formatDistanceLocale$w[token].standalone;
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else {
    result = usageGroup.other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'a' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
    } else {
      return 'viru' + (isFinalNNeeded(result) ? 'n' : '') + ' ' + result;
    }
  }

  return result;
}

var dateFormats$x = {
  full: 'EEEE, do MMMM y',
  // Méindeg, 7. Januar 2018
  long: 'do MMMM y',
  // 7. Januar 2018
  medium: 'do MMM y',
  // 7. Jan 2018
  short: 'dd.MM.yy' // 07.01.18

};
var timeFormats$x = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$x = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$12 = {
  date: buildFormatLongFn({
    formats: dateFormats$x,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$x,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$x,
    defaultWidth: 'full'
  })
};
var formatLong$13 = formatLong$12;

var formatRelativeLocale$x = {
  lastWeek: function (date) {
    var day = date.getUTCDay();
    var result = "'läschte";

    if (day === 2 || day === 4) {
      // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
      result += 'n';
    }

    result += "' eeee 'um' p";
    return result;
  },
  yesterday: "'gëschter um' p",
  today: "'haut um' p",
  tomorrow: "'moien um' p",
  nextWeek: "eeee 'um' p",
  other: 'P'
};
function formatRelative$z(token, date, _baseDate, _options) {
  var format = formatRelativeLocale$x[token];

  if (typeof format === 'function') {
    return format(date);
  }

  return format;
}

var eraValues$x = {
  narrow: ['v.Chr.', 'n.Chr.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['viru Christus', 'no Christus']
};
var quarterValues$x = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. Quartal', '2. Quartal', '3. Quartal', '4. Quartal']
};
var monthValues$x = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mäe', 'Abr', 'Mee', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  wide: ['Januar', 'Februar', 'Mäerz', 'Abrëll', 'Mee', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember']
};
var dayValues$x = {
  narrow: ['S', 'M', 'D', 'M', 'D', 'F', 'S'],
  short: ['So', 'Mé', 'Dë', 'Më', 'Do', 'Fr', 'Sa'],
  abbreviated: ['So.', 'Mé.', 'Dë.', 'Më.', 'Do.', 'Fr.', 'Sa.'],
  wide: ['Sonndeg', 'Méindeg', 'Dënschdeg', 'Mëttwoch', 'Donneschdeg', 'Freideg', 'Samschdeg']
};
var dayPeriodValues$w = {
  narrow: {
    am: 'mo.',
    pm: 'nomë.',
    midnight: 'Mëtternuecht',
    noon: 'Mëtteg',
    morning: 'Moien',
    afternoon: 'Nomëtteg',
    evening: 'Owend',
    night: 'Nuecht'
  },
  abbreviated: {
    am: 'moies',
    pm: 'nomëttes',
    midnight: 'Mëtternuecht',
    noon: 'Mëtteg',
    morning: 'Moien',
    afternoon: 'Nomëtteg',
    evening: 'Owend',
    night: 'Nuecht'
  },
  wide: {
    am: 'moies',
    pm: 'nomëttes',
    midnight: 'Mëtternuecht',
    noon: 'Mëtteg',
    morning: 'Moien',
    afternoon: 'Nomëtteg',
    evening: 'Owend',
    night: 'Nuecht'
  }
};
var formattingDayPeriodValues$p = {
  narrow: {
    am: 'mo.',
    pm: 'nom.',
    midnight: 'Mëtternuecht',
    noon: 'mëttes',
    morning: 'moies',
    afternoon: 'nomëttes',
    evening: 'owes',
    night: 'nuets'
  },
  abbreviated: {
    am: 'moies',
    pm: 'nomëttes',
    midnight: 'Mëtternuecht',
    noon: 'mëttes',
    morning: 'moies',
    afternoon: 'nomëttes',
    evening: 'owes',
    night: 'nuets'
  },
  wide: {
    am: 'moies',
    pm: 'nomëttes',
    midnight: 'Mëtternuecht',
    noon: 'mëttes',
    morning: 'moies',
    afternoon: 'nomëttes',
    evening: 'owes',
    night: 'nuets'
  }
};

function ordinalNumber$x(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);
  return number + '.';
}

var localize$12 = {
  ordinalNumber: ordinalNumber$x,
  era: buildLocalizeFn({
    values: eraValues$x,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$x,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$x,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$x,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$w,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$p,
    defaultFormattingWidth: 'wide'
  })
};
var localize$13 = localize$12;

var matchOrdinalNumberPattern$x = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern$x = /\d+/i;
var matchEraPatterns$x = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var parseEraPatterns$x = {
  any: [/^v/i, /^n/i]
};
var matchQuarterPatterns$x = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
};
var parseQuarterPatterns$x = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$x = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
  wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var parseMonthPatterns$x = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mä/i, /^ab/i, /^me/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$x = {
  narrow: /^[smdf]/i,
  short: /^(so|mé|dë|më|do|fr|sa)/i,
  abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
  wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var parseDayPatterns$x = {
  any: [/^so/i, /^mé/i, /^dë/i, /^më/i, /^do/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$x = {
  narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
  abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
  wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var parseDayPeriodPatterns$x = {
  any: {
    am: /^m/i,
    pm: /^n/i,
    midnight: /^Mëtter/i,
    noon: /^mëttes/i,
    morning: /moies/i,
    afternoon: /nomëttes/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /owes/i,
    night: /nuets/i // will never be matched. Night is matched by `pm`

  }
};
var match$12 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$x,
    parsePattern: parseOrdinalNumberPattern$x,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$x,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$x,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$x,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$x,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$x,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$x,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$x,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$x,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$x,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns$x,
    defaultParseWidth: 'any'
  })
};
var match$13 = match$12;

/**
 * @type {Locale}
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
 */

var locale$12 = {
  code: 'lb',
  formatDistance: formatDistance$z,
  formatLong: formatLong$13,
  formatRelative: formatRelative$z,
  localize: localize$13,
  match: match$13,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$13 = locale$12;

var formatDistanceLocale$v = {
  lessThanXSeconds: {
    one: translateSeconds,
    other: translate
  },
  xSeconds: {
    one: translateSeconds,
    other: translate
  },
  halfAMinute: 'pusė minutės',
  lessThanXMinutes: {
    one: translateSingular,
    other: translate
  },
  xMinutes: {
    one: translateSingular,
    other: translate
  },
  aboutXHours: {
    one: translateSingular,
    other: translate
  },
  xHours: {
    one: translateSingular,
    other: translate
  },
  xDays: {
    one: translateSingular,
    other: translate
  },
  aboutWeeks: {
    one: translateSingular,
    other: translate
  },
  xWeeks: {
    one: translateSingular,
    other: translate
  },
  aboutXMonths: {
    one: translateSingular,
    other: translate
  },
  xMonths: {
    one: translateSingular,
    other: translate
  },
  aboutXYears: {
    one: translateSingular,
    other: translate
  },
  xYears: {
    one: translateSingular,
    other: translate
  },
  overXYears: {
    one: translateSingular,
    other: translate
  },
  almostXYears: {
    one: translateSingular,
    other: translate
  }
};
var translations = {
  xseconds_other: 'sekundė_sekundžių_sekundes',
  xminutes_one: 'minutė_minutės_minutę',
  xminutes_other: 'minutės_minučių_minutes',
  xhours_one: 'valanda_valandos_valandą',
  xhours_other: 'valandos_valandų_valandas',
  xdays_one: 'diena_dienos_dieną',
  xdays_other: 'dienos_dienų_dienas',
  xweeks_one: 'savaitė_savaitės_savaitę',
  xweeks_other: 'savaitės_savaičių_savaites',
  xmonths_one: 'mėnuo_mėnesio_mėnesį',
  xmonths_other: 'mėnesiai_mėnesių_mėnesius',
  xyears_one: 'metai_metų_metus',
  xyears_other: 'metai_metų_metus',
  about: 'apie',
  over: 'daugiau nei',
  almost: 'beveik',
  lessthan: 'mažiau nei'
};

function translateSeconds(number, addSuffix, key, isFuture) {
  if (!addSuffix) {
    return 'kelios sekundės';
  } else {
    return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
  }
}

function translateSingular(number, addSuffix, key, isFuture) {
  return !addSuffix ? forms(key)[0] : isFuture ? forms(key)[1] : forms(key)[2];
}

function special(number) {
  return number % 10 === 0 || number > 10 && number < 20;
}

function forms(key) {
  return translations[key].split('_');
}

function translate(number, addSuffix, key, isFuture) {
  var result = number + ' ';

  if (number === 1) {
    return result + translateSingular(number, addSuffix, key[0], isFuture);
  } else if (!addSuffix) {
    return result + (special(number) ? forms(key)[1] : forms(key)[0]);
  } else {
    if (isFuture) {
      return result + forms(key)[1];
    } else {
      return result + (special(number) ? forms(key)[1] : forms(key)[2]);
    }
  }
}

function formatDistance$y(token, count, options) {
  options = options || {};
  var adverb = token.match(/about|over|almost|lessthan/i);
  var unit = token.replace(adverb, '');
  var result;

  if (typeof formatDistanceLocale$v[token] === 'string') {
    result = formatDistanceLocale$v[token];
  } else if (count === 1) {
    result = formatDistanceLocale$v[token].one(count, options.addSuffix, unit.toLowerCase() + '_one');
  } else {
    result = formatDistanceLocale$v[token].other(count, options.addSuffix, unit.toLowerCase() + '_other');
  }

  if (adverb) {
    result = translations[adverb[0].toLowerCase()] + ' ' + result;
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'po ' + result;
    } else {
      return 'prieš ' + result;
    }
  }

  return result;
}

var dateFormats$w = {
  full: "y 'm'. MMMM d 'd'., EEEE",
  long: "y 'm'. MMMM d 'd'.",
  medium: 'y-MM-dd',
  short: 'y-MM-dd'
};
var timeFormats$w = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$w = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$10 = {
  date: buildFormatLongFn({
    formats: dateFormats$w,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$w,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$w,
    defaultWidth: 'full'
  })
};
var formatLong$11 = formatLong$10;

var formatRelativeLocale$w = {
  lastWeek: "'Praėjusį' eeee p",
  yesterday: "'Vakar' p",
  today: "'Šiandien' p",
  tomorrow: "'Rytoj' p",
  nextWeek: 'eeee p',
  other: 'P'
};
function formatRelative$y(token, _date, _baseDate, _options) {
  return formatRelativeLocale$w[token];
}

var eraValues$w = {
  narrow: ['pr. Kr.', 'po Kr.'],
  abbreviated: ['pr. Kr.', 'po Kr.'],
  wide: ['prieš Kristų', 'po Kristaus']
};
var quarterValues$w = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['I ketv.', 'II ketv.', 'III ketv.', 'IV ketv.'],
  wide: ['I ketvirtis', 'II ketvirtis', 'III ketvirtis', 'IV ketvirtis']
};
var formattingQuarterValues$2 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['I k.', 'II k.', 'III k.', 'IV k.'],
  wide: ['I ketvirtis', 'II ketvirtis', 'III ketvirtis', 'IV ketvirtis']
};
var monthValues$w = {
  narrow: ['S', 'V', 'K', 'B', 'G', 'B', 'L', 'R', 'R', 'S', 'L', 'G'],
  abbreviated: ['saus.', 'vas.', 'kov.', 'bal.', 'geg.', 'birž.', 'liep.', 'rugp.', 'rugs.', 'spal.', 'lapkr.', 'gruod.'],
  wide: ['sausis', 'vasaris', 'kovas', 'balandis', 'gegužė', 'birželis', 'liepa', 'rugpjūtis', 'rugsėjis', 'spalis', 'lapkritis', 'gruodis']
};
var formattingMonthValues$8 = {
  narrow: ['S', 'V', 'K', 'B', 'G', 'B', 'L', 'R', 'R', 'S', 'L', 'G'],
  abbreviated: ['saus.', 'vas.', 'kov.', 'bal.', 'geg.', 'birž.', 'liep.', 'rugp.', 'rugs.', 'spal.', 'lapkr.', 'gruod.'],
  wide: ['sausio', 'vasario', 'kovo', 'balandžio', 'gegužės', 'birželio', 'liepos', 'rugpjūčio', 'rugsėjo', 'spalio', 'lapkričio', 'gruodžio']
};
var dayValues$w = {
  narrow: ['S', 'P', 'A', 'T', 'K', 'P', 'Š'],
  short: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
  abbreviated: ['sk', 'pr', 'an', 'tr', 'kt', 'pn', 'št'],
  wide: ['sekmadienis', 'pirmadienis', 'antradienis', 'trečiadienis', 'ketvirtadienis', 'penktadienis', 'šeštadienis']
};
var formattingDayValues$2 = {
  narrow: ['S', 'P', 'A', 'T', 'K', 'P', 'Š'],
  short: ['Sk', 'Pr', 'An', 'Tr', 'Kt', 'Pn', 'Št'],
  abbreviated: ['sk', 'pr', 'an', 'tr', 'kt', 'pn', 'št'],
  wide: ['sekmadienį', 'pirmadienį', 'antradienį', 'trečiadienį', 'ketvirtadienį', 'penktadienį', 'šeštadienį']
};
var dayPeriodValues$v = {
  narrow: {
    am: 'pr. p.',
    pm: 'pop.',
    midnight: 'vidurnaktis',
    noon: 'vidurdienis',
    morning: 'rytas',
    afternoon: 'diena',
    evening: 'vakaras',
    night: 'naktis'
  },
  abbreviated: {
    am: 'priešpiet',
    pm: 'popiet',
    midnight: 'vidurnaktis',
    noon: 'vidurdienis',
    morning: 'rytas',
    afternoon: 'diena',
    evening: 'vakaras',
    night: 'naktis'
  },
  wide: {
    am: 'priešpiet',
    pm: 'popiet',
    midnight: 'vidurnaktis',
    noon: 'vidurdienis',
    morning: 'rytas',
    afternoon: 'diena',
    evening: 'vakaras',
    night: 'naktis'
  }
};
var formattingDayPeriodValues$o = {
  narrow: {
    am: 'pr. p.',
    pm: 'pop.',
    midnight: 'vidurnaktis',
    noon: 'perpiet',
    morning: 'rytas',
    afternoon: 'popietė',
    evening: 'vakaras',
    night: 'naktis'
  },
  abbreviated: {
    am: 'priešpiet',
    pm: 'popiet',
    midnight: 'vidurnaktis',
    noon: 'perpiet',
    morning: 'rytas',
    afternoon: 'popietė',
    evening: 'vakaras',
    night: 'naktis'
  },
  wide: {
    am: 'priešpiet',
    pm: 'popiet',
    midnight: 'vidurnaktis',
    noon: 'perpiet',
    morning: 'rytas',
    afternoon: 'popietė',
    evening: 'vakaras',
    night: 'naktis'
  }
};

function ordinalNumber$w(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);
  return number + '-oji';
}

var localize$10 = {
  ordinalNumber: ordinalNumber$w,
  era: buildLocalizeFn({
    values: eraValues$w,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$w,
    defaultWidth: 'wide',
    formattingValues: formattingQuarterValues$2,
    defaultFormattingWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$w,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$8,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$w,
    defaultWidth: 'wide',
    formattingValues: formattingDayValues$2,
    defaultFormattingWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$v,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$o,
    defaultFormattingWidth: 'wide'
  })
};
var localize$11 = localize$10;

var matchOrdinalNumberPattern$w = /^(\d+)(-oji)?/i;
var parseOrdinalNumberPattern$w = /\d+/i;
var matchEraPatterns$w = {
  narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
  abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
  wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var parseEraPatterns$w = {
  wide: [/prieš/i, /(po|mūsų)/i],
  any: [/^pr/i, /^(po|m)/i]
};
var matchQuarterPatterns$w = {
  narrow: /^([1234])/i,
  abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
  wide: /^(I|II|III|IV)\s?ketvirtis/i
};
var parseQuarterPatterns$w = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/I$/i, /II$/i, /III/i, /IV/i]
};
var matchMonthPatterns$w = {
  narrow: /^[svkbglr]/i,
  abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
  wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var parseMonthPatterns$w = {
  narrow: [/^s/i, /^v/i, /^k/i, /^b/i, /^g/i, /^b/i, /^l/i, /^r/i, /^r/i, /^s/i, /^l/i, /^g/i],
  any: [/^saus/i, /^vas/i, /^kov/i, /^bal/i, /^geg/i, /^birž/i, /^liep/i, /^rugp/i, /^rugs/i, /^spal/i, /^lapkr/i, /^gruod/i]
};
var matchDayPatterns$w = {
  narrow: /^[spatkš]/i,
  short: /^(sk|pr|an|tr|kt|pn|št)/i,
  abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
  wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var parseDayPatterns$w = {
  narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
  wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
  any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i]
};
var matchDayPeriodPatterns$w = {
  narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
  any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var parseDayPeriodPatterns$w = {
  narrow: {
    am: /^pr/i,
    pm: /^pop./i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i
  },
  any: {
    am: /^pr/i,
    pm: /^popiet$/i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i
  }
};
var match$10 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$w,
    parsePattern: parseOrdinalNumberPattern$w,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$w,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$w,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$w,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$w,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$w,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$w,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$w,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$w,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$w,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$w,
    defaultParseWidth: 'any'
  })
};
var match$11 = match$10;

/**
 * @type {Locale}
 * @category Locales
 *
 * @summary Lithuanian locale.
 * @language Lithuanian
 *
 * @iso-639-2 lit
 *
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 */

var locale$10 = {
  code: 'lt',
  formatDistance: formatDistance$y,
  formatLong: formatLong$11,
  formatRelative: formatRelative$y,
  localize: localize$11,
  match: match$11,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$11 = locale$10;

function buildLocalizeTokenFn$2(schema) {
  return function (count, options) {
    if (count === 1) {
      if (options.addSuffix) {
        return schema.one[0].replace('{{time}}', schema.one[2]);
      } else {
        return schema.one[0].replace('{{time}}', schema.one[1]);
      }
    } else {
      var rem = count % 10 === 1 && count % 100 !== 11;

      if (options.addSuffix) {
        return schema.other[0].replace('{{time}}', rem ? schema.other[3] : schema.other[4]).replace('{{count}}', count);
      } else {
        return schema.other[0].replace('{{time}}', rem ? schema.other[1] : schema.other[2]).replace('{{count}}', count);
      }
    }
  };
}

var formatDistanceLocale$u = {
  lessThanXSeconds: buildLocalizeTokenFn$2({
    one: ['mazāk par {{time}}', 'sekundi', 'sekundi'],
    other: ['mazāk nekā {{count}} {{time}}', 'sekunde', 'sekundes', 'sekundes', 'sekundēm']
  }),
  xSeconds: buildLocalizeTokenFn$2({
    one: ['1 {{time}}', 'sekunde', 'sekundes'],
    other: ['{{count}} {{time}}', 'sekunde', 'sekundes', 'sekundes', 'sekundēm']
  }),
  halfAMinute: function (count, options) {
    if (options.addSuffix) {
      return 'pusminūtes';
    } else {
      return 'pusminūte';
    }
  },
  lessThanXMinutes: buildLocalizeTokenFn$2({
    one: ['mazāk par {{time}}', 'minūti', 'minūti'],
    other: ['mazāk nekā {{count}} {{time}}', 'minūte', 'minūtes', 'minūtes', 'minūtēm']
  }),
  xMinutes: buildLocalizeTokenFn$2({
    one: ['1 {{time}}', 'minūte', 'minūtes'],
    other: ['{{count}} {{time}}', 'minūte', 'minūtes', 'minūtes', 'minūtēm']
  }),
  aboutXHours: buildLocalizeTokenFn$2({
    one: ['apmēram 1 {{time}}', 'stunda', 'stundas'],
    other: ['apmēram {{count}} {{time}}', 'stunda', 'stundas', 'stundas', 'stundām']
  }),
  xHours: buildLocalizeTokenFn$2({
    one: ['1 {{time}}', 'stunda', 'stundas'],
    other: ['{{count}} {{time}}', 'stunda', 'stundas', 'stundas', 'stundām']
  }),
  xDays: buildLocalizeTokenFn$2({
    one: ['1 {{time}}', 'diena', 'dienas'],
    other: ['{{count}} {{time}}', 'diena', 'dienas', 'dienas', 'dienām']
  }),
  aboutXWeeks: buildLocalizeTokenFn$2({
    one: ['apmēram 1 {{time}}', 'nedēļa', 'nedēļas'],
    other: ['apmēram {{count}} {{time}}', 'nedēļa', 'nedēļu', 'nedēļas', 'nedēļām']
  }),
  xWeeks: buildLocalizeTokenFn$2({
    one: ['1 {{time}}', 'nedēļa', 'nedēļas'],
    other: ['{{count}} {{time}}', // TODO
    'nedēļa', 'nedēļu', 'nedēļas', 'nedēļām']
  }),
  aboutXMonths: buildLocalizeTokenFn$2({
    one: ['apmēram 1 {{time}}', 'mēnesis', 'mēneša'],
    other: ['apmēram {{count}} {{time}}', 'mēnesis', 'mēneši', 'mēneša', 'mēnešiem']
  }),
  xMonths: buildLocalizeTokenFn$2({
    one: ['1 {{time}}', 'mēnesis', 'mēneša'],
    other: ['{{count}} {{time}}', 'mēnesis', 'mēneši', 'mēneša', 'mēnešiem']
  }),
  aboutXYears: buildLocalizeTokenFn$2({
    one: ['apmēram 1 {{time}}', 'gads', 'gada'],
    other: ['apmēram {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
  }),
  xYears: buildLocalizeTokenFn$2({
    one: ['1 {{time}}', 'gads', 'gada'],
    other: ['{{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
  }),
  overXYears: buildLocalizeTokenFn$2({
    one: ['ilgāk par 1 {{time}}', 'gadu', 'gadu'],
    other: ['vairāk nekā {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
  }),
  almostXYears: buildLocalizeTokenFn$2({
    one: ['gandrīz 1 {{time}}', 'gads', 'gada'],
    other: ['vairāk nekā {{count}} {{time}}', 'gads', 'gadi', 'gada', 'gadiem']
  })
};
function formatDistance$x(token, count, options) {
  options = options || {};
  var result = formatDistanceLocale$u[token](count, options);

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'pēc ' + result;
    } else {
      return 'pirms ' + result;
    }
  }

  return result;
}

var dateFormats$v = {
  full: "EEEE, y. 'gada' d. MMMM",
  long: "y. 'gada' d. MMMM",
  medium: 'dd.MM.y.',
  short: 'dd.MM.y.'
};
var timeFormats$v = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$v = {
  full: "{{date}} 'plkst.' {{time}}",
  long: "{{date}} 'plkst.' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$_ = {
  date: buildFormatLongFn({
    formats: dateFormats$v,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$v,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$v,
    defaultWidth: 'full'
  })
};
var formatLong$$ = formatLong$_;

var weekdays$1 = ['svētdienā', 'pirmdienā', 'otrdienā', 'trešdienā', 'ceturtdienā', 'piektdienā', 'sestdienā'];
var formatRelativeLocale$v = {
  lastWeek: function (date, baseDate, options) {
    if (isSameUTCWeek(date, baseDate, options)) {
      return "eeee 'plkst.' p";
    }

    var weekday = weekdays$1[date.getUTCDay()];
    return "'Pagājušā " + weekday + " plkst.' p";
  },
  yesterday: "'Vakar plkst.' p",
  today: "'Šodien plkst.' p",
  tomorrow: "'Rīt plkst.' p",
  nextWeek: function (date, baseDate, options) {
    if (isSameUTCWeek(date, baseDate, options)) {
      return "eeee 'plkst.' p";
    }

    var weekday = weekdays$1[date.getUTCDay()];
    return "'Nākamajā " + weekday + " plkst.' p";
  },
  other: 'P'
};
function formatRelative$x(token, date, baseDate, options) {
  var format = formatRelativeLocale$v[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}

var eraValues$v = {
  narrow: ['p.m.ē', 'm.ē'],
  abbreviated: ['p. m. ē.', 'm. ē.'],
  wide: ['pirms mūsu ēras', 'mūsu ērā']
};
var quarterValues$v = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1. cet.', '2. cet.', '3. cet.', '4. cet.'],
  wide: ['pirmais ceturksnis', 'otrais ceturksnis', 'trešais ceturksnis', 'ceturtais ceturksnis']
};
var formattingQuarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1. cet.', '2. cet.', '3. cet.', '4. cet.'],
  wide: ['pirmajā ceturksnī', 'otrajā ceturksnī', 'trešajā ceturksnī', 'ceturtajā ceturksnī']
};
var monthValues$v = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['janv.', 'febr.', 'marts', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
  wide: ['janvāris', 'februāris', 'marts', 'aprīlis', 'maijs', 'jūnijs', 'jūlijs', 'augusts', 'septembris', 'oktobris', 'novembris', 'decembris']
};
var formattingMonthValues$7 = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['janv.', 'febr.', 'martā', 'apr.', 'maijs', 'jūn.', 'jūl.', 'aug.', 'sept.', 'okt.', 'nov.', 'dec.'],
  wide: ['janvārī', 'februārī', 'martā', 'aprīlī', 'maijā', 'jūnijā', 'jūlijā', 'augustā', 'septembrī', 'oktobrī', 'novembrī', 'decembrī']
};
var dayValues$v = {
  narrow: ['S', 'P', 'O', 'T', 'C', 'P', 'S'],
  short: ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'],
  abbreviated: ['svētd.', 'pirmd.', 'otrd.', 'trešd.', 'ceturtd.', 'piektd.', 'sestd.'],
  wide: ['svētdiena', 'pirmdiena', 'otrdiena', 'trešdiena', 'ceturtdiena', 'piektdiena', 'sestdiena']
};
var formattingDayValues$1 = {
  narrow: ['S', 'P', 'O', 'T', 'C', 'P', 'S'],
  short: ['Sv', 'P', 'O', 'T', 'C', 'Pk', 'S'],
  abbreviated: ['svētd.', 'pirmd.', 'otrd.', 'trešd.', 'ceturtd.', 'piektd.', 'sestd.'],
  wide: ['svētdienā', 'pirmdienā', 'otrdienā', 'trešdienā', 'ceturtdienā', 'piektdienā', 'sestdienā']
};
var dayPeriodValues$u = {
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'pusn.',
    noon: 'pusd.',
    morning: 'rīts',
    afternoon: 'diena',
    evening: 'vakars',
    night: 'nakts'
  },
  abbreviated: {
    am: 'am',
    pm: 'pm',
    midnight: 'pusn.',
    noon: 'pusd.',
    morning: 'rīts',
    afternoon: 'pēcpusd.',
    evening: 'vakars',
    night: 'nakts'
  },
  wide: {
    am: 'am',
    pm: 'pm',
    midnight: 'pusnakts',
    noon: 'pusdienlaiks',
    morning: 'rīts',
    afternoon: 'pēcpusdiena',
    evening: 'vakars',
    night: 'nakts'
  }
};
var formattingDayPeriodValues$n = {
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'pusn.',
    noon: 'pusd.',
    morning: 'rītā',
    afternoon: 'dienā',
    evening: 'vakarā',
    night: 'naktī'
  },
  abbreviated: {
    am: 'am',
    pm: 'pm',
    midnight: 'pusn.',
    noon: 'pusd.',
    morning: 'rītā',
    afternoon: 'pēcpusd.',
    evening: 'vakarā',
    night: 'naktī'
  },
  wide: {
    am: 'am',
    pm: 'pm',
    midnight: 'pusnaktī',
    noon: 'pusdienlaikā',
    morning: 'rītā',
    afternoon: 'pēcpusdienā',
    evening: 'vakarā',
    night: 'naktī'
  }
};

function ordinalNumber$v(number, _options) {
  return number + '.';
}

var localize$_ = {
  ordinalNumber: ordinalNumber$v,
  era: buildLocalizeFn({
    values: eraValues$v,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$v,
    defaultWidth: 'wide',
    formattingValues: formattingQuarterValues$1,
    defaultFormattingWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$v,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$7,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$v,
    defaultWidth: 'wide',
    formattingValues: formattingDayValues$1,
    defaultFormattingWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$u,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$n,
    defaultFormattingWidth: 'wide'
  })
};
var localize$$ = localize$_;

var matchOrdinalNumberPattern$v = /^(\d+)\./i;
var parseOrdinalNumberPattern$v = /\d+/i;
var matchEraPatterns$v = {
  narrow: /^(p\.m\.ē|m\.ē)/i,
  abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
  wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
var parseEraPatterns$v = {
  any: [/^p/i, /^m/i]
};
var matchQuarterPatterns$v = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](\. cet\.)/i,
  wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var parseQuarterPatterns$v = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
  abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
  wide: [/^p/i, /^o/i, /^t/i, /^c/i]
};
var matchMonthPatterns$v = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
  wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var parseMonthPatterns$v = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jūn/i, /^jūl/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$v = {
  narrow: /^[spotc]/i,
  short: /^(sv|pi|o|t|c|pk|s)/i,
  abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
  wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var parseDayPatterns$v = {
  narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
  any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i]
};
var matchDayPeriodPatterns$v = {
  narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
  abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
  wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var parseDayPeriodPatterns$v = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^pusn/i,
    noon: /^pusd/i,
    morning: /^r/i,
    afternoon: /^(d|pēc)/i,
    evening: /^v/i,
    night: /^n/i
  }
};
var match$_ = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$v,
    parsePattern: parseOrdinalNumberPattern$v,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$v,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$v,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$v,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$v,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$v,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$v,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$v,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$v,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$v,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$v,
    defaultParseWidth: 'any'
  })
};
var match$$ = match$_;

/**
 * @type {Locale}
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
 */

var locale$_ = {
  code: 'lv',
  formatDistance: formatDistance$x,
  formatLong: formatLong$$,
  formatRelative: formatRelative$x,
  localize: localize$$,
  match: match$$,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$$ = locale$_;

var formatDistanceLocale$t = {
  lessThanXSeconds: {
    one: 'помалку од секунда',
    other: 'помалку од {{count}} секунди'
  },
  xSeconds: {
    one: '1 секунда',
    other: '{{count}} секунди'
  },
  halfAMinute: 'половина минута',
  lessThanXMinutes: {
    one: 'помалку од минута',
    other: 'помалку од {{count}} минути'
  },
  xMinutes: {
    one: '1 минута',
    other: '{{count}} минути'
  },
  aboutXHours: {
    one: 'околу 1 час',
    other: 'околу {{count}} часа'
  },
  xHours: {
    one: '1 час',
    other: '{{count}} часа'
  },
  xDays: {
    one: '1 ден',
    other: '{{count}} дена'
  },
  aboutXWeeks: {
    one: 'околу 1 недела',
    other: 'околу {{count}} месеци'
  },
  xWeeks: {
    one: '1 недела',
    other: '{{count}} недели'
  },
  aboutXMonths: {
    one: 'околу 1 месец',
    other: 'околу {{count}} недели'
  },
  xMonths: {
    one: '1 месец',
    other: '{{count}} месеци'
  },
  aboutXYears: {
    one: 'околу 1 година',
    other: 'околу {{count}} години'
  },
  xYears: {
    one: '1 година',
    other: '{{count}} години'
  },
  overXYears: {
    one: 'повеќе од 1 година',
    other: 'повеќе од {{count}} години'
  },
  almostXYears: {
    one: 'безмалку 1 година',
    other: 'безмалку {{count}} години'
  }
};
function formatDistance$w(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$t[token] === 'string') {
    result = formatDistanceLocale$t[token];
  } else if (count === 1) {
    result = formatDistanceLocale$t[token].one;
  } else {
    result = formatDistanceLocale$t[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'за ' + result;
    } else {
      return 'пред ' + result;
    }
  }

  return result;
}

var dateFormats$u = {
  full: 'EEEE, dd MMMM yyyy',
  long: 'dd MMMM yyyy',
  medium: 'dd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats$u = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$u = {
  any: '{{date}} {{time}}'
};
var formatLong$Y = {
  date: buildFormatLongFn({
    formats: dateFormats$u,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$u,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$u,
    defaultWidth: 'any'
  })
};
var formatLong$Z = formatLong$Y;

var weekdays = ['недела', 'понеделник', 'вторник', 'среда', 'четврток', 'петок', 'сабота'];

function lastWeek$3(day) {
  var weekday = weekdays[day];

  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'минатата " + weekday + " во' p";

    case 1:
    case 2:
    case 4:
    case 5:
      return "'минатиот " + weekday + " во' p";
  }
}

function thisWeek$3(day) {
  var weekday = weekdays[day];

  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'ова " + weekday + " вo' p";

    case 1:
    case 2:
    case 4:
    case 5:
      return "'овој " + weekday + " вo' p";
  }
}

function nextWeek$3(day) {
  var weekday = weekdays[day];

  switch (day) {
    case 0:
    case 3:
    case 6:
      return "'следната " + weekday + " вo' p";

    case 1:
    case 2:
    case 4:
    case 5:
      return "'следниот " + weekday + " вo' p";
  }
}

var formatRelativeLocale$u = {
  lastWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek$3(day);
    } else {
      return lastWeek$3(day);
    }
  },
  yesterday: "'вчера во' p",
  today: "'денес во' p",
  tomorrow: "'утре во' p",
  nextWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek$3(day);
    } else {
      return nextWeek$3(day);
    }
  },
  other: 'P'
};
function formatRelative$w(token, date, baseDate, options) {
  var format = formatRelativeLocale$u[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}

var eraValues$u = {
  narrow: ['пр.н.е.', 'н.е.'],
  abbreviated: ['пред н. е.', 'н. е.'],
  wide: ['пред нашата ера', 'нашата ера']
};
var quarterValues$u = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-ви кв.', '2-ри кв.', '3-ти кв.', '4-ти кв.'],
  wide: ['1-ви квартал', '2-ри квартал', '3-ти квартал', '4-ти квартал']
};
var monthValues$u = {
  abbreviated: ['јан', 'фев', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'септ', 'окт', 'ноем', 'дек'],
  wide: ['јануари', 'февруари', 'март', 'април', 'мај', 'јуни', 'јули', 'август', 'септември', 'октомври', 'ноември', 'декември']
};
var dayValues$u = {
  narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  short: ['не', 'по', 'вт', 'ср', 'че', 'пе', 'са'],
  abbreviated: ['нед', 'пон', 'вто', 'сре', 'чет', 'пет', 'саб'],
  wide: ['недела', 'понеделник', 'вторник', 'среда', 'четврток', 'петок', 'сабота']
};
var dayPeriodValues$t = {
  wide: {
    am: 'претпладне',
    pm: 'попладне',
    midnight: 'полноќ',
    noon: 'напладне',
    morning: 'наутро',
    afternoon: 'попладне',
    evening: 'навечер',
    night: 'ноќе'
  }
};

function ordinalNumber$u(dirtyNumber) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + '-ви';

      case 2:
        return number + '-ри';

      case 7:
      case 8:
        return number + '-ми';
    }
  }

  return number + '-ти';
}

var localize$Y = {
  ordinalNumber: ordinalNumber$u,
  era: buildLocalizeFn({
    values: eraValues$u,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$u,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$u,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$u,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$t,
    defaultWidth: 'wide'
  })
};
var localize$Z = localize$Y;

var matchOrdinalNumberPattern$u = /^(\d+)(-?[врмт][и])?/i;
var parseOrdinalNumberPattern$u = /\d+/i;
var matchEraPatterns$u = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(пред нашата ера|нашата ера)/i
};
var parseEraPatterns$u = {
  any: [/^п/i, /^н/i]
};
var matchQuarterPatterns$u = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
  wide: /^[1234](-?[врт]?и?)? квартал/i
};
var parseQuarterPatterns$u = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchDayPatterns$u = {
  narrow: /^[нпвсч]/i,
  short: /^(не|по|вт|ср|че|пе|са)/i,
  abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
  wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var parseDayPatterns$u = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i]
};
var matchMonthPatterns$u = {
  abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
  wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var parseMonthPatterns$u = {
  any: [/^ја/i, /^Ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^ав/i, /^се/i, /^окт/i, /^но/i, /^де/i]
};
var matchDayPeriodPatterns$u = {
  any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var parseDayPeriodPatterns$u = {
  any: {
    am: /претпладне/i,
    pm: /попладне/i,
    midnight: /полноќ/i,
    noon: /напладне/i,
    morning: /наутро/i,
    afternoon: /попладне/i,
    evening: /навечер/i,
    night: /ноќе/i
  }
};
var match$Y = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$u,
    parsePattern: parseOrdinalNumberPattern$u,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$u,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$u,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$u,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$u,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$u,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$u,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$u,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$u,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$u,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$u,
    defaultParseWidth: 'any'
  })
};
var match$Z = match$Y;

/**
 * @type {Locale}
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
 */

var locale$Y = {
  code: 'mk',
  formatDistance: formatDistance$w,
  formatLong: formatLong$Z,
  formatRelative: formatRelative$w,
  localize: localize$Z,
  match: match$Z,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$Z = locale$Y;

var formatDistanceLocale$s = {
  lessThanXSeconds: {
    one: 'секунд хүрэхгүй',
    other: '{{count}} секунд хүрэхгүй'
  },
  xSeconds: {
    one: '1 секунд',
    other: '{{count}} секунд'
  },
  halfAMinute: 'хагас минут',
  lessThanXMinutes: {
    one: 'минут хүрэхгүй',
    other: '{{count}} минут хүрэхгүй'
  },
  xMinutes: {
    one: '1 минут',
    other: '{{count}} минут'
  },
  aboutXHours: {
    one: 'ойролцоогоор 1 цаг',
    other: 'ойролцоогоор {{count}} цаг'
  },
  xHours: {
    one: '1 цаг',
    other: '{{count}} цаг'
  },
  xDays: {
    one: '1 өдөр',
    other: '{{count}} өдөр'
  },
  aboutXWeeks: {
    one: 'ойролцоогоор 1 долоо хоног',
    other: 'ойролцоогоор {{count}} долоо хоног'
  },
  xWeeks: {
    one: '1 долоо хоног',
    other: '{{count}} долоо хоног'
  },
  aboutXMonths: {
    one: 'ойролцоогоор 1 сар',
    other: 'ойролцоогоор {{count}} сар'
  },
  xMonths: {
    one: '1 сар',
    other: '{{count}} сар'
  },
  aboutXYears: {
    one: 'ойролцоогоор 1 жил',
    other: 'ойролцоогоор {{count}} жил'
  },
  xYears: {
    one: '1 жил',
    other: '{{count}} жил'
  },
  overXYears: {
    one: '1 жил гаран',
    other: '{{count}} жил гаран'
  },
  almostXYears: {
    one: 'бараг 1 жил',
    other: 'бараг {{count}} жил'
  }
};
function formatDistance$v(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$s[token] === 'string') {
    result = formatDistanceLocale$s[token];
  } else if (count === 1) {
    result = formatDistanceLocale$s[token].one;
  } else {
    result = formatDistanceLocale$s[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    /**
     * Append genitive case
     */
    var words = result.split(' ');
    var lastword = words.pop();
    result = words.join(' ');

    switch (lastword) {
      case 'секунд':
        result += ' секундийн';
        break;

      case 'минут':
        result += ' минутын';
        break;

      case 'цаг':
        result += ' цагийн';
        break;

      case 'өдөр':
        result += ' өдрийн';
        break;

      case 'сар':
        result += ' сарын';
        break;

      case 'жил':
        result += ' жилийн';
        break;

      case 'хоног':
        result += ' хоногийн';
        break;

      case 'гаран':
        result += ' гараны';
        break;

      case 'хүрэхгүй':
        result += ' хүрэхгүй хугацааны';
        break;

      default:
        result += lastword + '-н';
    }

    if (options.comparison > 0) {
      return result + ' дараа';
    } else {
      return result + ' өмнө';
    }
  }

  return result;
}

var dateFormats$t = {
  full: "y 'оны' MMMM'ын' d, EEEE 'гараг'",
  long: "y 'оны' MMMM'ын' d",
  medium: "y 'оны' MMM'ын' d",
  short: 'y.MM.dd'
};
var timeFormats$t = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$t = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$W = {
  date: buildFormatLongFn({
    formats: dateFormats$t,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$t,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$t,
    defaultWidth: 'full'
  })
};
var formatLong$X = formatLong$W;

var formatRelativeLocale$t = {
  lastWeek: "'өнгөрсөн' eeee 'гарагийн' p 'цагт'",
  yesterday: "'өчигдөр' p 'цагт'",
  today: "'өнөөдөр' p 'цагт'",
  tomorrow: "'маргааш' p 'цагт'",
  nextWeek: "'ирэх' eeee 'гарагийн' p 'цагт'",
  other: 'P'
};
function formatRelative$v(token, _date, _baseDate, _options) {
  return formatRelativeLocale$t[token];
}

var eraValues$t = {
  narrow: ['НТӨ', 'НТ'],
  abbreviated: ['НТӨ', 'НТ'],
  wide: ['нийтийн тооллын өмнөх', 'нийтийн тооллын']
};
var quarterValues$t = {
  narrow: ['I', 'II', 'III', 'IV'],
  abbreviated: ['I улирал', 'II улирал', 'III улирал', 'IV улирал'],
  wide: ['1-р улирал', '2-р улирал', '3-р улирал', '4-р улирал']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$t = {
  narrow: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'],
  abbreviated: ['1-р сар', '2-р сар', '3-р сар', '4-р сар', '5-р сар', '6-р сар', '7-р сар', '8-р сар', '9-р сар', '10-р сар', '11-р сар', '12-р сар'],
  wide: ['Нэгдүгээр сар', 'Хоёрдугаар сар', 'Гуравдугаар сар', 'Дөрөвдүгээр сар', 'Тавдугаар сар', 'Зургаадугаар сар', 'Долоодугаар сар', 'Наймдугаар сар', 'Есдүгээр сар', 'Аравдугаар сар', 'Арваннэгдүгээр сар', 'Арван хоёрдугаар сар']
};
var formattingMonthValues$6 = {
  narrow: ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII'],
  abbreviated: ['1-р сар', '2-р сар', '3-р сар', '4-р сар', '5-р сар', '6-р сар', '7-р сар', '8-р сар', '9-р сар', '10-р сар', '11-р сар', '12-р сар'],
  wide: ['нэгдүгээр сар', 'хоёрдугаар сар', 'гуравдугаар сар', 'дөрөвдүгээр сар', 'тавдугаар сар', 'зургаадугаар сар', 'долоодугаар сар', 'наймдугаар сар', 'есдүгээр сар', 'аравдугаар сар', 'арваннэгдүгээр сар', 'арван хоёрдугаар сар']
};
var dayValues$t = {
  narrow: ['Н', 'Д', 'М', 'Л', 'П', 'Б', 'Б'],
  short: ['Ня', 'Да', 'Мя', 'Лх', 'Пү', 'Ба', 'Бя'],
  abbreviated: ['Ням', 'Дав', 'Мяг', 'Лха', 'Пүр', 'Баа', 'Бям'],
  wide: ['Ням', 'Даваа', 'Мягмар', 'Лхагва', 'Пүрэв', 'Баасан', 'Бямба']
};
var formattingDayValues = {
  narrow: ['Н', 'Д', 'М', 'Л', 'П', 'Б', 'Б'],
  short: ['Ня', 'Да', 'Мя', 'Лх', 'Пү', 'Ба', 'Бя'],
  abbreviated: ['Ням', 'Дав', 'Мяг', 'Лха', 'Пүр', 'Баа', 'Бям'],
  wide: ['ням', 'даваа', 'мягмар', 'лхагва', 'пүрэв', 'баасан', 'бямба']
};
var dayPeriodValues$s = {
  narrow: {
    am: 'ү.ө.',
    pm: 'ү.х.',
    midnight: 'шөнө дунд',
    noon: 'үд дунд',
    morning: 'өглөө',
    afternoon: 'өдөр',
    evening: 'орой',
    night: 'шөнө'
  },
  abbreviated: {
    am: 'ү.ө.',
    pm: 'ү.х.',
    midnight: 'шөнө дунд',
    noon: 'үд дунд',
    morning: 'өглөө',
    afternoon: 'өдөр',
    evening: 'орой',
    night: 'шөнө'
  },
  wide: {
    am: 'ү.ө.',
    pm: 'ү.х.',
    midnight: 'шөнө дунд',
    noon: 'үд дунд',
    morning: 'өглөө',
    afternoon: 'өдөр',
    evening: 'орой',
    night: 'шөнө'
  }
};

function ordinalNumber$t(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  return number;
}

var localize$W = {
  ordinalNumber: ordinalNumber$t,
  era: buildLocalizeFn({
    values: eraValues$t,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$t,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$t,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$6,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$t,
    defaultWidth: 'wide',
    formattingValues: formattingDayValues,
    defaultFormattingWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$s,
    defaultWidth: 'wide'
  })
};
var localize$X = localize$W;

var matchOrdinalNumberPattern$t = /\d+/i;
var parseOrdinalNumberPattern$t = /\d+/i;
var matchEraPatterns$t = {
  narrow: /^(нтө|нт)/i,
  abbreviated: /^(нтө|нт)/i,
  wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var parseEraPatterns$t = {
  any: [/^(нтө|нийтийн тооллын өмнө)/i, /^(нт|нийтийн тооллын)/i]
};
var matchQuarterPatterns$t = {
  narrow: /^(iv|iii|ii|i)/i,
  abbreviated: /^(iv|iii|ii|i) улирал/i,
  wide: /^[1-4]-р улирал/i
};
var parseQuarterPatterns$t = {
  any: [/^(i(\s|$)|1)/i, /^(ii(\s|$)|2)/i, /^(iii(\s|$)|3)/i, /^(iv(\s|$)|4)/i]
};
var matchMonthPatterns$t = {
  narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
  abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
  wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var parseMonthPatterns$t = {
  narrow: [/^i$/i, /^ii$/i, /^iii$/i, /^iv$/i, /^v$/i, /^vi$/i, /^vii$/i, /^viii$/i, /^ix$/i, /^x$/i, /^xi$/i, /^xii$/i],
  any: [/^(1|нэгдүгээр)/i, /^(2|хоёрдугаар)/i, /^(3|гуравдугаар)/i, /^(4|дөрөвдүгээр)/i, /^(5|тавдугаар)/i, /^(6|зургаадугаар)/i, /^(7|долоодугаар)/i, /^(8|наймдугаар)/i, /^(9|есдүгээр)/i, /^(10|аравдугаар)/i, /^(11|арван нэгдүгээр)/i, /^(12|арван хоёрдугаар)/i]
};
var matchDayPatterns$t = {
  narrow: /^[ндмлпбб]/i,
  short: /^(ня|да|мя|лх|пү|ба|бя)/i,
  abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
  wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var parseDayPatterns$t = {
  narrow: [/^н/i, /^д/i, /^м/i, /^л/i, /^п/i, /^б/i, /^б/i],
  any: [/^ня/i, /^да/i, /^мя/i, /^лх/i, /^пү/i, /^ба/i, /^бя/i]
};
var matchDayPeriodPatterns$t = {
  narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
  any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var parseDayPeriodPatterns$t = {
  any: {
    am: /^ү\.ө\./i,
    pm: /^ү\.х\./i,
    midnight: /^шөнө дунд/i,
    noon: /^үд дунд/i,
    morning: /өглөө/i,
    afternoon: /өдөр/i,
    evening: /орой/i,
    night: /шөнө/i
  }
};
var match$W = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$t,
    parsePattern: parseOrdinalNumberPattern$t,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$t,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$t,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$t,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$t,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$t,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$t,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$t,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$t,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$t,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$t,
    defaultParseWidth: 'any'
  })
};
var match$X = match$W;

/**
 * @type {Locale}
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
 */

var locale$W = {
  code: 'mn',
  formatDistance: formatDistance$v,
  formatLong: formatLong$X,
  formatRelative: formatRelative$v,
  localize: localize$X,
  match: match$X,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$X = locale$W;

var formatDistanceLocale$r = {
  lessThanXSeconds: {
    one: 'kurang dari 1 saat',
    other: 'kurang dari {{count}} saat'
  },
  xSeconds: {
    one: '1 saat',
    other: '{{count}} saat'
  },
  halfAMinute: 'setengah minit',
  lessThanXMinutes: {
    one: 'kurang dari 1 minit',
    other: 'kurang dari {{count}} minit'
  },
  xMinutes: {
    one: '1 minit',
    other: '{{count}} minit'
  },
  aboutXHours: {
    one: 'sekitar 1 jam',
    other: 'sekitar {{count}} jam'
  },
  xHours: {
    one: '1 jam',
    other: '{{count}} jam'
  },
  xDays: {
    one: '1 hari',
    other: '{{count}} hari'
  },
  aboutXWeeks: {
    one: 'sekitar 1 minggu',
    other: 'sekitar {{count}} minggu'
  },
  xWeeks: {
    one: '1 minggu',
    other: '{{count}} minggu'
  },
  aboutXMonths: {
    one: 'sekitar 1 bulan',
    other: 'sekitar {{count}} bulan'
  },
  xMonths: {
    one: '1 bulan',
    other: '{{count}} bulan'
  },
  aboutXYears: {
    one: 'sekitar 1 tahun',
    other: 'sekitar {{count}} tahun'
  },
  xYears: {
    one: '1 tahun',
    other: '{{count}} tahun'
  },
  overXYears: {
    one: 'lebih dari 1 tahun',
    other: 'lebih dari {{count}} tahun'
  },
  almostXYears: {
    one: 'hampir 1 tahun',
    other: 'hampir {{count}} tahun'
  }
};
function formatDistance$u(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$r[token] === 'string') {
    result = formatDistanceLocale$r[token];
  } else if (count === 1) {
    result = formatDistanceLocale$r[token].one;
  } else {
    result = formatDistanceLocale$r[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'dalam masa ' + result;
    } else {
      return result + ' yang lalu';
    }
  }

  return result;
}

var dateFormats$s = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'd/M/yyyy'
};
var timeFormats$s = {
  full: 'HH.mm.ss',
  long: 'HH.mm.ss',
  medium: 'HH.mm',
  short: 'HH.mm'
};
var dateTimeFormats$s = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$U = {
  date: buildFormatLongFn({
    formats: dateFormats$s,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$s,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$s,
    defaultWidth: 'full'
  })
};
var formatLong$V = formatLong$U;

var formatRelativeLocale$s = {
  lastWeek: "eeee 'lepas pada jam' p",
  yesterday: "'Semalam pada jam' p",
  today: "'Hari ini pada jam' p",
  tomorrow: "'Esok pada jam' p",
  nextWeek: "eeee 'pada jam' p",
  other: 'P'
};
function formatRelative$u(token, _date, _baseDate, _options) {
  return formatRelativeLocale$s[token];
}

// https://www.unicode.org/cldr/charts/32/summary/ms.html

var eraValues$s = {
  narrow: ['SM', 'M'],
  abbreviated: ['SM', 'M'],
  wide: ['Sebelum Masihi', 'Masihi']
};
var quarterValues$s = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['S1', 'S2', 'S3', 'S4'],
  wide: ['Suku pertama', 'Suku kedua', 'Suku ketiga', 'Suku keempat']
}; // Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$s = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'O', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mac', 'Apr', 'Mei', 'Jun', 'Jul', 'Ogo', 'Sep', 'Okt', 'Nov', 'Dis'],
  wide: ['Januari', 'Februari', 'Mac', 'April', 'Mei', 'Jun', 'Julai', 'Ogos', 'September', 'Oktober', 'November', 'Disember']
};
var dayValues$s = {
  narrow: ['A', 'I', 'S', 'R', 'K', 'J', 'S'],
  short: ['Ahd', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
  abbreviated: ['Ahd', 'Isn', 'Sel', 'Rab', 'Kha', 'Jum', 'Sab'],
  wide: ['Ahad', 'Isnin', 'Selasa', 'Rabu', 'Khamis', 'Jumaat', 'Sabtu']
};
var dayPeriodValues$r = {
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'tgh malam',
    noon: 'tgh hari',
    morning: 'pagi',
    afternoon: 'tengah hari',
    evening: 'petang',
    night: 'malam'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'tengah hari',
    evening: 'petang',
    night: 'malam'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'tengah hari',
    evening: 'petang',
    night: 'malam'
  }
};
var formattingDayPeriodValues$m = {
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'tengah hari',
    evening: 'petang',
    night: 'malam'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'tengah hari',
    evening: 'petang',
    night: 'malam'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'tengah malam',
    noon: 'tengah hari',
    morning: 'pagi',
    afternoon: 'tengah hari',
    evening: 'petang',
    night: 'malam'
  }
};

function ordinalNumber$s(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // Can't use "pertama", "kedua" because can't be parsed

  switch (number) {
    default:
      return 'ke-' + number;
  }
}

var localize$U = {
  ordinalNumber: ordinalNumber$s,
  era: buildLocalizeFn({
    values: eraValues$s,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$s,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$s,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$s,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$r,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$m,
    defaultFormattingWidth: 'wide'
  })
};
var localize$V = localize$U;

var matchOrdinalNumberPattern$s = /^ke-(\d+)?/i;
var parseOrdinalNumberPattern$s = /petama|\d+/i;
var matchEraPatterns$s = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
  wide: /^(sebelum masihi|masihi)/i
};
var parseEraPatterns$s = {
  any: [/^s/i, /^(m)/i]
};
var matchQuarterPatterns$s = {
  narrow: /^[1234]/i,
  abbreviated: /^S[1234]/i,
  wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
var parseQuarterPatterns$s = {
  any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i]
};
var matchMonthPatterns$s = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
  wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var parseMonthPatterns$s = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^o/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^ma/i, /^ap/i, /^me/i, /^jun/i, /^jul/i, /^og/i, /^s/i, /^ok/i, /^n/i, /^d/i]
};
var matchDayPatterns$s = {
  narrow: /^[aisrkj]/i,
  short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var parseDayPatterns$s = {
  narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i]
};
var matchDayPeriodPatterns$s = {
  narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var parseDayPeriodPatterns$s = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pa/i,
    afternoon: /tengah h/i,
    evening: /pe/i,
    night: /m/i
  }
};
var match$U = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$s,
    parsePattern: parseOrdinalNumberPattern$s,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$s,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$s,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$s,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$s,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$s,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$s,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$s,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$s,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$s,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$s,
    defaultParseWidth: 'any'
  })
};
var match$V = match$U;

/**
 * @type {Locale}
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
 */

var locale$U = {
  code: 'ms',
  formatDistance: formatDistance$u,
  formatLong: formatLong$V,
  formatRelative: formatRelative$u,
  localize: localize$V,
  match: match$V,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$V = locale$U;

var formatDistanceLocale$q = {
  lessThanXSeconds: {
    one: 'inqas minn sekonda',
    other: 'inqas minn {{count}} sekondi'
  },
  xSeconds: {
    one: 'sekonda',
    other: '{{count}} sekondi'
  },
  halfAMinute: 'nofs minuta',
  lessThanXMinutes: {
    one: 'inqas minn minuta',
    other: 'inqas minn {{count}} minuti'
  },
  xMinutes: {
    one: 'minuta',
    other: '{{count}} minuti'
  },
  aboutXHours: {
    one: 'madwar siegħa',
    other: 'madwar {{count}} siegħat'
  },
  xHours: {
    one: 'siegħa',
    other: '{{count}} siegħat'
  },
  xDays: {
    one: 'ġurnata',
    other: '{{count}} ġranet'
  },
  aboutXWeeks: {
    one: 'madwar ġimgħa',
    other: 'madwar {{count}} ġimgħat'
  },
  xWeeks: {
    one: 'ġimgħa',
    other: '{{count}} ġimgħat'
  },
  aboutXMonths: {
    one: 'madwar xahar',
    other: 'madwar {{count}} xhur'
  },
  xMonths: {
    one: 'xahar',
    other: '{{count}} xhur'
  },
  aboutXYears: {
    one: 'madwar sena',
    two: 'madwar sentejn',
    other: 'madwar {{count}} snin'
  },
  xYears: {
    one: 'sena',
    two: 'sentejn',
    other: '{{count}} snin'
  },
  overXYears: {
    one: 'aktar minn sena',
    two: 'aktar minn sentejn',
    other: 'aktar minn {{count}} snin'
  },
  almostXYears: {
    one: 'kważi sena',
    two: 'kważi sentejn',
    other: 'kważi {{count}} snin'
  }
};
function formatDistance$t(token, count, options) {
  options = options || {};
  var adverb = token.match(/years/i);
  var result;

  if (typeof formatDistanceLocale$q[token] === 'string') {
    result = formatDistanceLocale$q[token];
  } else if (count === 1) {
    result = formatDistanceLocale$q[token].one;
  } else if (count === 2 && adverb) {
    result = formatDistanceLocale$q[token].two;
  } else {
    result = formatDistanceLocale$q[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return "f'" + result;
    } else {
      return result + ' ilu';
    }
  }

  return result;
}

var dateFormats$r = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd/MM/yyyy'
};
var timeFormats$r = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$r = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$S = {
  date: buildFormatLongFn({
    formats: dateFormats$r,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$r,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$r,
    defaultWidth: 'full'
  })
};
var formatLong$T = formatLong$S;

var formatRelativeLocale$r = {
  lastWeek: "eeee 'li għadda' 'fil-'p",
  yesterday: "'Il-bieraħ fil-'p",
  today: "'Illum fil-'p",
  tomorrow: "'Għada fil-'p",
  nextWeek: "eeee 'fil-'p",
  other: 'P'
};
function formatRelative$t(token, _date, _baseDate, _options) {
  return formatRelativeLocale$r[token];
}

var eraValues$r = {
  narrow: ['Q', 'W'],
  abbreviated: ['QK', 'WK'],
  wide: ['qabel Kristu', 'wara Kristu']
};
var quarterValues$r = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1. kwart', '2. kwart', '3. kwart', '4. kwart']
};
var monthValues$r = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'Ġ', 'L', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Fra', 'Mar', 'Apr', 'Mej', 'Ġun', 'Lul', 'Aww', 'Set', 'Ott', 'Nov', 'Diċ'],
  wide: ['Jannar', 'Frar', 'Marzu', 'April', 'Mejju', 'Ġunju', 'Lulju', 'Awwissu', 'Settembru', 'Ottubru', 'Novembru', 'Diċembru']
};
var dayValues$r = {
  narrow: ['Ħ', 'T', 'T', 'E', 'Ħ', 'Ġ', 'S'],
  short: ['Ħa', 'Tn', 'Tl', 'Er', 'Ħa', 'Ġi', 'Si'],
  abbreviated: ['Ħad', 'Tne', 'Tli', 'Erb', 'Ħam', 'Ġim', 'Sib'],
  wide: ['Il-Ħadd', 'It-Tnejn', 'It-Tlieta', 'L-Erbgħa', 'Il-Ħamis', 'Il-Ġimgħa', 'Is-Sibt']
};
var dayPeriodValues$q = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'nofsillejl',
    noon: 'nofsinhar',
    morning: 'għodwa',
    afternoon: 'wara nofsinhar',
    evening: 'filgħaxija',
    night: 'lejl'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'nofsillejl',
    noon: 'nofsinhar',
    morning: 'għodwa',
    afternoon: 'wara nofsinhar',
    evening: 'filgħaxija',
    night: 'lejl'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'nofsillejl',
    noon: 'nofsinhar',
    morning: 'għodwa',
    afternoon: 'wara nofsinhar',
    evening: 'filgħaxija',
    night: 'lejl'
  }
};
var formattingDayPeriodValues$l = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: 'filgħodu',
    afternoon: 'wara nofsinhar',
    evening: 'filgħaxija',
    night: 'billejl'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: 'filgħodu',
    afternoon: 'wara nofsinhar',
    evening: 'filgħaxija',
    night: 'billejl'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: 'filgħodu',
    afternoon: 'wara nofsinhar',
    evening: 'filgħaxija',
    night: 'billejl'
  }
};

function ordinalNumber$r(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + 'º';
}

var localize$S = {
  ordinalNumber: ordinalNumber$r,
  era: buildLocalizeFn({
    values: eraValues$r,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$r,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$r,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$r,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$q,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$l,
    defaultFormattingWidth: 'wide'
  })
};
var localize$T = localize$S;

var matchOrdinalNumberPattern$r = /^(\d+)(º)?/i;
var parseOrdinalNumberPattern$r = /\d+/i;
var matchEraPatterns$r = {
  narrow: /^(q|w)/i,
  abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
  wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
var parseEraPatterns$r = {
  any: [/^(q|b)/i, /^(w|c)/i]
};
var matchQuarterPatterns$r = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](\.)? kwart/i
};
var parseQuarterPatterns$r = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$r = {
  narrow: /^[jfmaglsond]/i,
  abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
  wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var parseMonthPatterns$r = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^ġ/i, /^l/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mej/i, /^ġ/i, /^l/i, /^aw/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$r = {
  narrow: /^[ħteġs]/i,
  short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
  abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
  wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var parseDayPatterns$r = {
  narrow: [/^ħ/i, /^t/i, /^t/i, /^e/i, /^ħ/i, /^ġ/i, /^s/i],
  any: [/^(il-)?ħad/i, /^(it-)?tn/i, /^(it-)?tl/i, /^(l-)?er/i, /^(il-)?ham/i, /^(il-)?ġi/i, /^(is-)?si/i]
};
var matchDayPeriodPatterns$r = {
  narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
  any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var parseDayPeriodPatterns$r = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^f'nofsillejl/i,
    noon: /^f'nofsinhar/i,
    morning: /għodwa/i,
    afternoon: /wara(\s.*)nofsinhar/i,
    evening: /filgħaxija/i,
    night: /lejl/i
  }
};
var match$S = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$r,
    parsePattern: parseOrdinalNumberPattern$r,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$r,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$r,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$r,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$r,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$r,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$r,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$r,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$r,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$r,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$r,
    defaultParseWidth: 'any'
  })
};
var match$T = match$S;

/**
 * @type {Locale}
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */

var locale$S = {
  code: 'mt',
  formatDistance: formatDistance$t,
  formatLong: formatLong$T,
  formatRelative: formatRelative$t,
  localize: localize$T,
  match: match$T,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$T = locale$S;

var formatDistanceLocale$p = {
  lessThanXSeconds: {
    singular: 'mindre enn ett sekund',
    plural: 'mindre enn {{count}} sekunder'
  },
  xSeconds: {
    singular: 'ett sekund',
    plural: '{{count}} sekunder'
  },
  halfAMinute: 'et halvt minutt',
  lessThanXMinutes: {
    singular: 'mindre enn ett minutt',
    plural: 'mindre enn {{count}} minutter'
  },
  xMinutes: {
    singular: 'ett minutt',
    plural: '{{count}} minutter'
  },
  aboutXHours: {
    singular: 'omtrent en time',
    plural: 'omtrent {{count}} timer'
  },
  xHours: {
    singular: 'en time',
    plural: '{{count}} timer'
  },
  xDays: {
    singular: 'en dag',
    plural: '{{count}} dager'
  },
  aboutXWeeks: {
    singular: 'omtrent en uke',
    plural: 'omtrent {{count}} uker'
  },
  xWeeks: {
    singular: 'en uke',
    plural: '{{count}} uker'
  },
  aboutXMonths: {
    singular: 'omtrent en måned',
    plural: 'omtrent {{count}} måneder'
  },
  xMonths: {
    singular: 'en måned',
    plural: '{{count}} måneder'
  },
  aboutXYears: {
    singular: 'omtrent ett år',
    plural: 'omtrent {{count}} år'
  },
  xYears: {
    singular: 'ett år',
    plural: '{{count}} år'
  },
  overXYears: {
    singular: 'over ett år',
    plural: 'over {{count}} år'
  },
  almostXYears: {
    singular: 'nesten ett år',
    plural: 'nesten {{count}} år'
  }
};
function formatDistance$s(token, count, options) {
  options = options || {};
  var translation = formatDistanceLocale$p[token];
  var result;

  if (typeof translation === 'string') {
    result = translation;
  } else if (count === 0 || count > 1) {
    result = translation.plural.replace('{{count}}', count);
  } else {
    result = translation.singular;
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'om ' + result;
    } else {
      return result + ' siden';
    }
  }

  return result;
}

var dateFormats$q = {
  full: 'EEEE d. MMMM y',
  long: 'd. MMMM y',
  medium: 'd. MMM y',
  short: 'dd.MM.y'
};
var timeFormats$q = {
  full: "'kl'. HH:mm:ss zzzz",
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$q = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$Q = {
  date: buildFormatLongFn({
    formats: dateFormats$q,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$q,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$q,
    defaultWidth: 'full'
  })
};
var formatLong$R = formatLong$Q;

var formatRelativeLocale$q = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: 'P'
};
function formatRelative$s(token, _date, _baseDate, _options) {
  return formatRelativeLocale$q[token];
}

var eraValues$q = {
  narrow: ['f.Kr.', 'e.Kr.'],
  abbreviated: ['f.Kr.', 'e.Kr.'],
  wide: ['før Kristus', 'etter Kristus']
};
var quarterValues$q = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
};
var monthValues$q = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
  wide: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
};
var dayValues$q = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['sø', 'ma', 'ti', 'on', 'to', 'fr', 'lø'],
  abbreviated: ['søn', 'man', 'tir', 'ons', 'tor', 'fre', 'lør'],
  wide: ['søndag', 'mandag', 'tirsdag', 'onsdag', 'torsdag', 'fredag', 'lørdag']
};
var dayPeriodValues$p = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på etterm.',
    evening: 'på kvelden',
    night: 'på natten'
  },
  abbreviated: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på etterm.',
    evening: 'på kvelden',
    night: 'på natten'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morgenen',
    afternoon: 'på ettermiddagen',
    evening: 'på kvelden',
    night: 'på natten'
  }
};

function ordinalNumber$q(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
}

var localize$Q = {
  ordinalNumber: ordinalNumber$q,
  era: buildLocalizeFn({
    values: eraValues$q,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$q,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$q,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$q,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$p,
    defaultWidth: 'wide'
  })
};
var localize$R = localize$Q;

var matchOrdinalNumberPattern$q = /^(\d+)\.?/i;
var parseOrdinalNumberPattern$q = /\d+/i;
var matchEraPatterns$q = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns$q = {
  any: [/^f/i, /^e/i]
};
var matchQuarterPatterns$q = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns$q = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$q = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns$q = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$q = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var parseDayPatterns$q = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
var matchDayPeriodPatterns$q = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var parseDayPeriodPatterns$q = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
};
var match$Q = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$q,
    parsePattern: parseOrdinalNumberPattern$q,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$q,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$q,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$q,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$q,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$q,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$q,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$q,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$q,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$q,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$q,
    defaultParseWidth: 'any'
  })
};
var match$R = match$Q;

/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */

var locale$Q = {
  code: 'nb',
  formatDistance: formatDistance$s,
  formatLong: formatLong$R,
  formatRelative: formatRelative$s,
  localize: localize$R,
  match: match$R,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$R = locale$Q;

var formatDistanceLocale$o = {
  lessThanXSeconds: {
    one: 'minder dan een seconde',
    other: 'minder dan {{count}} seconden'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} seconden'
  },
  halfAMinute: 'een halve minuut',
  lessThanXMinutes: {
    one: 'minder dan een minuut',
    other: 'minder dan {{count}} minuten'
  },
  xMinutes: {
    one: 'een minuut',
    other: '{{count}} minuten'
  },
  aboutXHours: {
    one: 'ongeveer 1 uur',
    other: 'ongeveer {{count}} uur'
  },
  xHours: {
    one: '1 uur',
    other: '{{count}} uur'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dagen'
  },
  aboutXWeeks: {
    one: 'ongeveer 1 week',
    other: 'ongeveer {{count}} weken'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weken'
  },
  aboutXMonths: {
    one: 'ongeveer 1 maand',
    other: 'ongeveer {{count}} maanden'
  },
  xMonths: {
    one: '1 maand',
    other: '{{count}} maanden'
  },
  aboutXYears: {
    one: 'ongeveer 1 jaar',
    other: 'ongeveer {{count}} jaar'
  },
  xYears: {
    one: '1 jaar',
    other: '{{count}} jaar'
  },
  overXYears: {
    one: 'meer dan 1 jaar',
    other: 'meer dan {{count}} jaar'
  },
  almostXYears: {
    one: 'bijna 1 jaar',
    other: 'bijna {{count}} jaar'
  }
};
function formatDistance$r(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$o[token] === 'string') {
    result = formatDistanceLocale$o[token];
  } else if (count === 1) {
    result = formatDistanceLocale$o[token].one;
  } else {
    result = formatDistanceLocale$o[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'over ' + result;
    } else {
      return result + ' geleden';
    }
  }

  return result;
}

var dateFormats$p = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd-MM-y'
};
var timeFormats$p = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$p = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$O = {
  date: buildFormatLongFn({
    formats: dateFormats$p,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$p,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$p,
    defaultWidth: 'full'
  })
};
var formatLong$P = formatLong$O;

var formatRelativeLocale$p = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: 'P'
};
function formatRelative$r(token, _date, _baseDate, _options) {
  return formatRelativeLocale$p[token];
}

var eraValues$p = {
  narrow: ['v.C.', 'n.C.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['voor Christus', 'na Christus']
};
var quarterValues$p = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
};
var monthValues$p = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
};
var dayValues$p = {
  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
};
var dayPeriodValues$o = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
};

function ordinalNumber$p(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + 'e';
}

var localize$O = {
  ordinalNumber: ordinalNumber$p,
  era: buildLocalizeFn({
    values: eraValues$p,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$p,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$p,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$p,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$o,
    defaultWidth: 'wide'
  })
};
var localize$P = localize$O;

var matchOrdinalNumberPattern$p = /^(\d+)e?/i;
var parseOrdinalNumberPattern$p = /\d+/i;
var matchEraPatterns$p = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
};
var parseEraPatterns$p = {
  any: [/^v/, /^n/]
};
var matchQuarterPatterns$p = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns$p = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$p = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns$p = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
};
var matchDayPatterns$p = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns$p = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
};
var matchDayPeriodPatterns$p = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns$p = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
};
var match$O = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$p,
    parsePattern: parseOrdinalNumberPattern$p,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$p,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$p,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$p,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$p,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$p,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$p,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$p,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$p,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$p,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$p,
    defaultParseWidth: 'any'
  })
};
var match$P = match$O;

/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */

var locale$O = {
  code: 'nl',
  formatDistance: formatDistance$r,
  formatLong: formatLong$P,
  formatRelative: formatRelative$r,
  localize: localize$P,
  match: match$P,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$P = locale$O;

var formatDistanceLocale$n = {
  lessThanXSeconds: {
    one: 'minder dan een seconde',
    other: 'minder dan {{count}} seconden'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} seconden'
  },
  halfAMinute: 'een halve minuut',
  lessThanXMinutes: {
    one: 'minder dan een minuut',
    other: 'minder dan {{count}} minuten'
  },
  xMinutes: {
    one: 'een minuut',
    other: '{{count}} minuten'
  },
  aboutXHours: {
    one: 'ongeveer 1 uur',
    other: 'ongeveer {{count}} uur'
  },
  xHours: {
    one: '1 uur',
    other: '{{count}} uur'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dagen'
  },
  aboutXWeeks: {
    one: 'ongeveer 1 week',
    other: 'ongeveer {{count}} weken'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weken'
  },
  aboutXMonths: {
    one: 'ongeveer 1 maand',
    other: 'ongeveer {{count}} maanden'
  },
  xMonths: {
    one: '1 maand',
    other: '{{count}} maanden'
  },
  aboutXYears: {
    one: 'ongeveer 1 jaar',
    other: 'ongeveer {{count}} jaar'
  },
  xYears: {
    one: '1 jaar',
    other: '{{count}} jaar'
  },
  overXYears: {
    one: 'meer dan 1 jaar',
    other: 'meer dan {{count}} jaar'
  },
  almostXYears: {
    one: 'bijna 1 jaar',
    other: 'bijna {{count}} jaar'
  }
};
function formatDistance$q(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$n[token] === 'string') {
    result = formatDistanceLocale$n[token];
  } else if (count === 1) {
    result = formatDistanceLocale$n[token].one;
  } else {
    result = formatDistanceLocale$n[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'over ' + result;
    } else {
      return result + ' geleden';
    }
  }

  return result;
}

var dateFormats$o = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd.MM.y'
};
var timeFormats$o = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$o = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$M = {
  date: buildFormatLongFn({
    formats: dateFormats$o,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$o,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$o,
    defaultWidth: 'full'
  })
};
var formatLong$N = formatLong$M;

var formatRelativeLocale$o = {
  lastWeek: "'vorige' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: 'P'
};
function formatRelative$q(token, _date, _baseDate, _options) {
  return formatRelativeLocale$o[token];
}

var eraValues$o = {
  narrow: ['v.C.', 'n.C.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['voor Christus', 'na Christus']
};
var quarterValues$o = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
};
var monthValues$o = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
};
var dayValues$o = {
  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
};
var dayPeriodValues$n = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middag',
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middag',
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middag',
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  }
};

function ordinalNumber$o(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + 'e';
}

var localize$M = {
  ordinalNumber: ordinalNumber$o,
  era: buildLocalizeFn({
    values: eraValues$o,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$o,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$o,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$o,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$n,
    defaultWidth: 'wide'
  })
};
var localize$N = localize$M;

var matchOrdinalNumberPattern$o = /^(\d+)e?/i;
var parseOrdinalNumberPattern$o = /\d+/i;
var matchEraPatterns$o = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
};
var parseEraPatterns$o = {
  any: [/^v/, /^n/]
};
var matchQuarterPatterns$o = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns$o = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$o = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns$o = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
};
var matchDayPatterns$o = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns$o = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
};
var matchDayPeriodPatterns$o = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns$o = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
};
var match$M = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$o,
    parsePattern: parseOrdinalNumberPattern$o,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$o,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$o,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$o,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$o,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$o,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$o,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$o,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$o,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$o,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$o,
    defaultParseWidth: 'any'
  })
};
var match$N = match$M;

/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */

var locale$M = {
  code: 'nl-BE',
  formatDistance: formatDistance$q,
  formatLong: formatLong$N,
  formatRelative: formatRelative$q,
  localize: localize$N,
  match: match$N,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$N = locale$M;

var formatDistanceLocale$m = {
  lessThanXSeconds: {
    singular: 'mindre enn eitt sekund',
    plural: 'mindre enn {{count}} sekund'
  },
  xSeconds: {
    singular: 'eitt sekund',
    plural: '{{count}} sekund'
  },
  halfAMinute: 'eit halvt minutt',
  lessThanXMinutes: {
    singular: 'mindre enn eitt minutt',
    plural: 'mindre enn {{count}} minutt'
  },
  xMinutes: {
    singular: 'eitt minutt',
    plural: '{{count}} minutt'
  },
  aboutXHours: {
    singular: 'omtrent ein time',
    plural: 'omtrent {{count}} timar'
  },
  xHours: {
    singular: 'ein time',
    plural: '{{count}} timar'
  },
  xDays: {
    singular: 'ein dag',
    plural: '{{count}} dagar'
  },
  aboutXWeeks: {
    singular: 'omtrent ei veke',
    plural: 'omtrent {{count}} veker'
  },
  xWeeks: {
    singular: 'ei veke',
    plural: '{{count}} veker'
  },
  aboutXMonths: {
    singular: 'omtrent ein månad',
    plural: 'omtrent {{count}} månader'
  },
  xMonths: {
    singular: 'ein månad',
    plural: '{{count}} månader'
  },
  aboutXYears: {
    singular: 'omtrent eitt år',
    plural: 'omtrent {{count}} år'
  },
  xYears: {
    singular: 'eitt år',
    plural: '{{count}} år'
  },
  overXYears: {
    singular: 'over eitt år',
    plural: 'over {{count}} år'
  },
  almostXYears: {
    singular: 'nesten eitt år',
    plural: 'nesten {{count}} år'
  }
};
var wordMapping$1 = ['null', 'ein', 'to', 'tre', 'fire', 'fem', 'seks', 'sju', 'åtte', 'ni', 'ti', 'elleve', 'tolv'];
function formatDistance$p(token, count, options) {
  options = options || {
    onlyNumeric: false
  };
  var translation = formatDistanceLocale$m[token];
  var result;

  if (typeof translation === 'string') {
    result = translation;
  } else if (count === 0 || count > 1) {
    if (options.onlyNumeric) {
      result = translation.plural.replace('{{count}}', count);
    } else {
      result = translation.plural.replace('{{count}}', count < 13 ? wordMapping$1[count] : count);
    }
  } else {
    result = translation.singular;
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'om ' + result;
    } else {
      return result + ' sidan';
    }
  }

  return result;
}

var dateFormats$n = {
  full: 'EEEE d. MMMM y',
  long: 'd. MMMM y',
  medium: 'd. MMM y',
  short: 'dd.MM.y'
};
var timeFormats$n = {
  full: "'kl'. HH:mm:ss zzzz",
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$n = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$K = {
  date: buildFormatLongFn({
    formats: dateFormats$n,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$n,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$n,
    defaultWidth: 'full'
  })
};
var formatLong$L = formatLong$K;

var formatRelativeLocale$n = {
  lastWeek: "'førre' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: 'P'
};
function formatRelative$p(token, _date, _baseDate, _options) {
  return formatRelativeLocale$n[token];
}

var eraValues$n = {
  narrow: ['f.Kr.', 'e.Kr.'],
  abbreviated: ['f.Kr.', 'e.Kr.'],
  wide: ['før Kristus', 'etter Kristus']
};
var quarterValues$n = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
};
var monthValues$n = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'mai', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'des.'],
  wide: ['januar', 'februar', 'mars', 'april', 'mai', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'desember']
};
var dayValues$n = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['su', 'må', 'ty', 'on', 'to', 'fr', 'lau'],
  abbreviated: ['sun', 'mån', 'tys', 'ons', 'tor', 'fre', 'laur'],
  wide: ['sundag', 'måndag', 'tysdag', 'onsdag', 'torsdag', 'fredag', 'laurdag']
};
var dayPeriodValues$m = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på etterm.',
    evening: 'på kvelden',
    night: 'på natta'
  },
  abbreviated: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på etterm.',
    evening: 'på kvelden',
    night: 'på natta'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morgonen',
    afternoon: 'på ettermiddagen',
    evening: 'på kvelden',
    night: 'på natta'
  }
};

function ordinalNumber$n(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + '.';
}

var localize$K = {
  ordinalNumber: ordinalNumber$n,
  era: buildLocalizeFn({
    values: eraValues$n,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$n,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$n,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$n,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$m,
    defaultWidth: 'wide'
  })
};
var localize$L = localize$K;

var matchOrdinalNumberPattern$n = /^(\d+)\.?/i;
var parseOrdinalNumberPattern$n = /\d+/i;
var matchEraPatterns$n = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var parseEraPatterns$n = {
  any: [/^f/i, /^e/i]
};
var matchQuarterPatterns$n = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
};
var parseQuarterPatterns$n = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$n = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var parseMonthPatterns$n = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^aug/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$n = {
  narrow: /^[smtofl]/i,
  short: /^(su|må|ty|on|to|fr|la)/i,
  abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
  wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var parseDayPatterns$n = {
  any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
var matchDayPeriodPatterns$n = {
  narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var parseDayPeriodPatterns$n = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
};
var match$K = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$n,
    parsePattern: parseOrdinalNumberPattern$n,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$n,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$n,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$n,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$n,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$n,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$n,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$n,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$n,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$n,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$n,
    defaultParseWidth: 'any'
  })
};
var match$L = match$K;

/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
 */

var locale$K = {
  code: 'nn',
  formatDistance: formatDistance$p,
  formatLong: formatLong$L,
  formatRelative: formatRelative$p,
  localize: localize$L,
  match: match$L,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$L = locale$K;

function declensionGroup$1(scheme, count) {
  if (count === 1) {
    return scheme.one;
  }

  var rem100 = count % 100; // ends with 11-20

  if (rem100 <= 20 && rem100 > 10) {
    return scheme.other;
  }

  var rem10 = rem100 % 10; // ends with 2, 3, 4

  if (rem10 >= 2 && rem10 <= 4) {
    return scheme.twoFour;
  }

  return scheme.other;
}

function declension$3(scheme, count, time) {
  time = time || 'regular';
  var group = declensionGroup$1(scheme, count);
  var finalText = group[time] || group;
  return finalText.replace('{{count}}', count);
}

var formatDistanceLocale$l = {
  lessThanXSeconds: {
    one: {
      regular: 'mniej niż sekunda',
      past: 'mniej niż sekundę',
      future: 'mniej niż sekundę'
    },
    twoFour: 'mniej niż {{count}} sekundy',
    other: 'mniej niż {{count}} sekund'
  },
  xSeconds: {
    one: {
      regular: 'sekunda',
      past: 'sekundę',
      future: 'sekundę'
    },
    twoFour: '{{count}} sekundy',
    other: '{{count}} sekund'
  },
  halfAMinute: {
    one: 'pół minuty',
    twoFour: 'pół minuty',
    other: 'pół minuty'
  },
  lessThanXMinutes: {
    one: {
      regular: 'mniej niż minuta',
      past: 'mniej niż minutę',
      future: 'mniej niż minutę'
    },
    twoFour: 'mniej niż {{count}} minuty',
    other: 'mniej niż {{count}} minut'
  },
  xMinutes: {
    one: {
      regular: 'minuta',
      past: 'minutę',
      future: 'minutę'
    },
    twoFour: '{{count}} minuty',
    other: '{{count}} minut'
  },
  aboutXHours: {
    one: {
      regular: 'około godziny',
      past: 'około godziny',
      future: 'około godzinę'
    },
    twoFour: 'około {{count}} godziny',
    other: 'około {{count}} godzin'
  },
  xHours: {
    one: {
      regular: 'godzina',
      past: 'godzinę',
      future: 'godzinę'
    },
    twoFour: '{{count}} godziny',
    other: '{{count}} godzin'
  },
  xDays: {
    one: {
      regular: 'dzień',
      past: 'dzień',
      future: '1 dzień'
    },
    twoFour: '{{count}} dni',
    other: '{{count}} dni'
  },
  aboutXWeeks: {
    one: 'około tygodnia',
    twoFour: 'około {{count}} tygodni',
    other: 'około {{count}} tygodni'
  },
  xWeeks: {
    one: 'tydzień',
    twoFour: '{{count}} tygodnie',
    other: '{{count}} tygodni'
  },
  aboutXMonths: {
    one: 'około miesiąc',
    twoFour: 'około {{count}} miesiące',
    other: 'około {{count}} miesięcy'
  },
  xMonths: {
    one: 'miesiąc',
    twoFour: '{{count}} miesiące',
    other: '{{count}} miesięcy'
  },
  aboutXYears: {
    one: 'około rok',
    twoFour: 'około {{count}} lata',
    other: 'około {{count}} lat'
  },
  xYears: {
    one: 'rok',
    twoFour: '{{count}} lata',
    other: '{{count}} lat'
  },
  overXYears: {
    one: 'ponad rok',
    twoFour: 'ponad {{count}} lata',
    other: 'ponad {{count}} lat'
  },
  almostXYears: {
    one: 'prawie rok',
    twoFour: 'prawie {{count}} lata',
    other: 'prawie {{count}} lat'
  }
};
function formatDistance$o(token, count, options) {
  options = options || {};
  var scheme = formatDistanceLocale$l[token];

  if (!options.addSuffix) {
    return declension$3(scheme, count);
  }

  if (options.comparison > 0) {
    return 'za ' + declension$3(scheme, count, 'future');
  } else {
    return declension$3(scheme, count, 'past') + ' temu';
  }
}

var dateFormats$m = {
  full: 'EEEE, do MMMM y',
  long: 'do MMMM y',
  medium: 'do MMM y',
  short: 'dd.MM.y'
};
var timeFormats$m = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$m = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$I = {
  date: buildFormatLongFn({
    formats: dateFormats$m,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$m,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$m,
    defaultWidth: 'full'
  })
};
var formatLong$J = formatLong$I;

var adjectivesLastWeek = {
  masculine: 'ostatni',
  feminine: 'ostatnia'
};
var adjectivesThisWeek = {
  masculine: 'ten',
  feminine: 'ta'
};
var adjectivesNextWeek = {
  masculine: 'następny',
  feminine: 'następna'
};
var dayGrammaticalGender = {
  0: 'feminine',
  1: 'masculine',
  2: 'masculine',
  3: 'feminine',
  4: 'masculine',
  5: 'masculine',
  6: 'feminine'
};

function getAdjectives(token, date, baseDate, options) {
  if (isSameUTCWeek(date, baseDate, options)) {
    return adjectivesThisWeek;
  } else if (token === 'lastWeek') {
    return adjectivesLastWeek;
  } else if (token === 'nextWeek') {
    return adjectivesNextWeek;
  } else {
    throw new Error("Cannot determine adjectives for token ".concat(token));
  }
}

function getAdjective(token, date, baseDate, options) {
  var day = date.getUTCDay();
  var adjectives = getAdjectives(token, date, baseDate, options);
  var grammaticalGender = dayGrammaticalGender[day];
  return adjectives[grammaticalGender];
}

function dayAndTimeWithAdjective(token, date, baseDate, options) {
  var adjective = getAdjective(token, date, baseDate, options);
  return "'".concat(adjective, "' eeee 'o' p");
}

var formatRelativeLocale$m = {
  lastWeek: dayAndTimeWithAdjective,
  yesterday: "'wczoraj o' p",
  today: "'dzisiaj o' p",
  tomorrow: "'jutro o' p",
  nextWeek: dayAndTimeWithAdjective,
  other: 'P'
};
function formatRelative$o(token, date, baseDate, options) {
  var format = formatRelativeLocale$m[token];

  if (typeof format === 'function') {
    return format(token, date, baseDate, options);
  }

  return format;
}

function ordinalNumber$m(dirtyNumber) {
  var number = Number(dirtyNumber);
  return String(number);
}

var eraValues$m = {
  narrow: ['p.n.e.', 'n.e.'],
  abbreviated: ['p.n.e.', 'n.e.'],
  wide: ['przed naszą erą', 'naszej ery']
};
var quarterValues$m = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['I kw.', 'II kw.', 'III kw.', 'IV kw.'],
  wide: ['I kwartał', 'II kwartał', 'III kwartał', 'IV kwartał']
};
var monthValues$m = {
  narrow: ['S', 'L', 'M', 'K', 'M', 'C', 'L', 'S', 'W', 'P', 'L', 'G'],
  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  wide: ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'październik', 'listopad', 'grudzień']
};
var monthFormattingValues = {
  narrow: ['s', 'l', 'm', 'k', 'm', 'c', 'l', 's', 'w', 'p', 'l', 'g'],
  abbreviated: ['sty', 'lut', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'],
  wide: ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca', 'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia']
};
var dayValues$m = {
  narrow: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
};
var dayFormattingValues = {
  narrow: ['n', 'p', 'w', 'ś', 'c', 'p', 's'],
  short: ['nie', 'pon', 'wto', 'śro', 'czw', 'pią', 'sob'],
  abbreviated: ['niedz.', 'pon.', 'wt.', 'śr.', 'czw.', 'pt.', 'sob.'],
  wide: ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota']
};
var dayPeriodValues$l = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'półn.',
    noon: 'poł',
    morning: 'rano',
    afternoon: 'popoł.',
    evening: 'wiecz.',
    night: 'noc'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'północ',
    noon: 'południe',
    morning: 'rano',
    afternoon: 'popołudnie',
    evening: 'wieczór',
    night: 'noc'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'północ',
    noon: 'południe',
    morning: 'rano',
    afternoon: 'popołudnie',
    evening: 'wieczór',
    night: 'noc'
  }
};
var dayPeriodFormattingValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'o półn.',
    noon: 'w poł.',
    morning: 'rano',
    afternoon: 'po poł.',
    evening: 'wiecz.',
    night: 'w nocy'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o północy',
    noon: 'w południe',
    morning: 'rano',
    afternoon: 'po południu',
    evening: 'wieczorem',
    night: 'w nocy'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o północy',
    noon: 'w południe',
    morning: 'rano',
    afternoon: 'po południu',
    evening: 'wieczorem',
    night: 'w nocy'
  }
};
var localize$I = {
  ordinalNumber: ordinalNumber$m,
  era: buildLocalizeFn({
    values: eraValues$m,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$m,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$m,
    defaultWidth: 'wide',
    formattingValues: monthFormattingValues,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$m,
    defaultWidth: 'wide',
    formattingValues: dayFormattingValues,
    defaultFormattingWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$l,
    defaultWidth: 'wide',
    formattingValues: dayPeriodFormattingValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$J = localize$I;

var matchOrdinalNumberPattern$m = /^(\d+)?/i;
var parseOrdinalNumberPattern$m = /\d+/i;
var matchEraPatterns$m = {
  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var parseEraPatterns$m = {
  any: [/^p/i, /^n/i]
};
var matchQuarterPatterns$m = {
  narrow: /^[1234]/i,
  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var parseQuarterPatterns$m = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
};
var matchMonthPatterns$m = {
  narrow: /^[slmkcwpg]/i,
  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var parseMonthPatterns$m = {
  narrow: [/^s/i, /^l/i, /^m/i, /^k/i, /^m/i, /^c/i, /^l/i, /^s/i, /^w/i, /^p/i, /^l/i, /^g/i],
  any: [/^st/i, /^lu/i, /^mar/i, /^k/i, /^maj/i, /^c/i, /^lip/i, /^si/i, /^w/i, /^p/i, /^lis/i, /^g/i]
};
var matchDayPatterns$m = {
  narrow: /^[npwścs]/i,
  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var parseDayPatterns$m = {
  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
};
var matchDayPeriodPatterns$m = {
  narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var parseDayPeriodPatterns$m = {
  narrow: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  },
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  }
};
var match$I = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$m,
    parsePattern: parseOrdinalNumberPattern$m,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$m,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$m,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$m,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$m,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$m,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$m,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$m,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$m,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$m,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$m,
    defaultParseWidth: 'any'
  })
};
var match$J = match$I;

/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */

var locale$I = {
  code: 'pl',
  formatDistance: formatDistance$o,
  formatLong: formatLong$J,
  formatRelative: formatRelative$o,
  localize: localize$J,
  match: match$J,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$J = locale$I;

var formatDistanceLocale$k = {
  lessThanXSeconds: {
    one: 'menos de um segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'meio minuto',
  lessThanXMinutes: {
    one: 'menos de um minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'aproximadamente 1 hora',
    other: 'aproximadamente {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 dia',
    other: '{{count}} dias'
  },
  aboutXWeeks: {
    one: 'aproximadamente 1 semana',
    other: 'aproximadamente {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'aproximadamente 1 mês',
    other: 'aproximadamente {{count}} meses'
  },
  xMonths: {
    one: '1 mês',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'aproximadamente 1 ano',
    other: 'aproximadamente {{count}} anos'
  },
  xYears: {
    one: '1 ano',
    other: '{{count}} anos'
  },
  overXYears: {
    one: 'mais de 1 ano',
    other: 'mais de {{count}} anos'
  },
  almostXYears: {
    one: 'quase 1 ano',
    other: 'quase {{count}} anos'
  }
};
function formatDistance$n(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$k[token] === 'string') {
    result = formatDistanceLocale$k[token];
  } else if (count === 1) {
    result = formatDistanceLocale$k[token].one;
  } else {
    result = formatDistanceLocale$k[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'daqui a ' + result;
    } else {
      return 'há ' + result;
    }
  }

  return result;
}

var dateFormats$l = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: 'dd/MM/y'
};
var timeFormats$l = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$l = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$G = {
  date: buildFormatLongFn({
    formats: dateFormats$l,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$l,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$l,
    defaultWidth: 'full'
  })
};
var formatLong$H = formatLong$G;

var formatRelativeLocale$l = {
  lastWeek: "'na última' eeee 'às' p",
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: 'P'
};
function formatRelative$n(token, _date, _baseDate, _options) {
  return formatRelativeLocale$l[token];
}

function ordinalNumber$l(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + 'º';
}

var eraValues$l = {
  narrow: ['aC', 'dC'],
  abbreviated: ['a.C.', 'd.C.'],
  wide: ['antes de Cristo', 'depois de Cristo']
};
var quarterValues$l = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues$l = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
};
var dayValues$l = {
  narrow: ['d', 's', 't', 'q', 'q', 's', 's'],
  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  abbreviated: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'],
  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
};
var dayPeriodValues$k = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'noite',
    night: 'madrugada'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'noite',
    night: 'madrugada'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'noite',
    night: 'madrugada'
  }
};
var formattingDayPeriodValues$k = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da noite',
    night: 'da madrugada'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da noite',
    night: 'da madrugada'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da noite',
    night: 'da madrugada'
  }
};
var localize$G = {
  ordinalNumber: ordinalNumber$l,
  era: buildLocalizeFn({
    values: eraValues$l,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$l,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$l,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$l,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$k,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$k,
    defaultFormattingWidth: 'wide'
  })
};
var localize$H = localize$G;

var matchOrdinalNumberPattern$l = /^(\d+)(º|ª)?/i;
var parseOrdinalNumberPattern$l = /\d+/i;
var matchEraPatterns$l = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var parseEraPatterns$l = {
  any: [/^ac/i, /^dc/i],
  wide: [/^(antes de cristo|antes da era comum)/i, /^(depois de cristo|era comum)/i]
};
var matchQuarterPatterns$l = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
};
var parseQuarterPatterns$l = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$l = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns$l = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ab/i, /^mai/i, /^jun/i, /^jul/i, /^ag/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$l = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var parseDayPatterns$l = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
};
var matchDayPeriodPatterns$l = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var parseDayPeriodPatterns$l = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
};
var match$G = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$l,
    parsePattern: parseOrdinalNumberPattern$l,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$l,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$l,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$l,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$l,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$l,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$l,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$l,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$l,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$l,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$l,
    defaultParseWidth: 'any'
  })
};
var match$H = match$G;

/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */

var locale$G = {
  code: 'pt',
  formatDistance: formatDistance$n,
  formatLong: formatLong$H,
  formatRelative: formatRelative$n,
  localize: localize$H,
  match: match$H,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$H = locale$G;

var formatDistanceLocale$j = {
  lessThanXSeconds: {
    one: 'menos de um segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'meio minuto',
  lessThanXMinutes: {
    one: 'menos de um minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'cerca de 1 hora',
    other: 'cerca de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 dia',
    other: '{{count}} dias'
  },
  aboutXWeeks: {
    one: 'cerca de 1 semana',
    other: 'cerca de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'cerca de 1 mês',
    other: 'cerca de {{count}} meses'
  },
  xMonths: {
    one: '1 mês',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'cerca de 1 ano',
    other: 'cerca de {{count}} anos'
  },
  xYears: {
    one: '1 ano',
    other: '{{count}} anos'
  },
  overXYears: {
    one: 'mais de 1 ano',
    other: 'mais de {{count}} anos'
  },
  almostXYears: {
    one: 'quase 1 ano',
    other: 'quase {{count}} anos'
  }
};
function formatDistance$m(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$j[token] === 'string') {
    result = formatDistanceLocale$j[token];
  } else if (count === 1) {
    result = formatDistanceLocale$j[token].one;
  } else {
    result = formatDistanceLocale$j[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'em ' + result;
    } else {
      return 'há ' + result;
    }
  }

  return result;
}

var dateFormats$k = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/yyyy'
};
var timeFormats$k = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$k = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$E = {
  date: buildFormatLongFn({
    formats: dateFormats$k,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$k,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$k,
    defaultWidth: 'full'
  })
};
var formatLong$F = formatLong$E;

var formatRelativeLocale$k = {
  lastWeek: function (date, _baseDate, _options) {
    var weekday = date.getUTCDay();
    var last = weekday === 0 || weekday === 6 ? 'último' : 'última';
    return "'" + last + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: 'P'
};
function formatRelative$m(token, date, baseDate, options) {
  var format = formatRelativeLocale$k[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}

var eraValues$k = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'depois de cristo']
};
var quarterValues$k = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues$k = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
};
var dayValues$k = {
  narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
  abbreviated: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
};
var dayPeriodValues$j = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  }
};
var formattingDayPeriodValues$j = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  }
};

function ordinalNumber$k(dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber);
  var options = dirtyOptions || {};
  var unit = String(options.unit);

  if (unit === 'week' || unit === 'isoWeek') {
    return number + 'ª';
  }

  return number + 'º';
}

var localize$E = {
  ordinalNumber: ordinalNumber$k,
  era: buildLocalizeFn({
    values: eraValues$k,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$k,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$k,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$k,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$j,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$j,
    defaultFormattingWidth: 'wide'
  })
};
var localize$F = localize$E;

var matchOrdinalNumberPattern$k = /^(\d+)[ºªo]?/i;
var parseOrdinalNumberPattern$k = /\d+/i;
var matchEraPatterns$k = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
};
var parseEraPatterns$k = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
};
var matchQuarterPatterns$k = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns$k = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$k = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns$k = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
};
var matchDayPatterns$k = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var parseDayPatterns$k = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
};
var matchDayPeriodPatterns$k = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var parseDayPeriodPatterns$k = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
};
var match$E = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$k,
    parsePattern: parseOrdinalNumberPattern$k,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$k,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$k,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$k,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$k,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$k,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$k,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$k,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$k,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$k,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$k,
    defaultParseWidth: 'any'
  })
};
var match$F = match$E;

/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */

var locale$E = {
  code: 'pt-BR',
  formatDistance: formatDistance$m,
  formatLong: formatLong$F,
  formatRelative: formatRelative$m,
  localize: localize$F,
  match: match$F,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$F = locale$E;

var formatDistanceLocale$i = {
  lessThanXSeconds: {
    one: 'mai puțin de o secundă',
    other: 'mai puțin de {{count}} secunde'
  },
  xSeconds: {
    one: '1 secundă',
    other: '{{count}} secunde'
  },
  halfAMinute: 'jumătate de minut',
  lessThanXMinutes: {
    one: 'mai puțin de un minut',
    other: 'mai puțin de {{count}} minute'
  },
  xMinutes: {
    one: '1 minut',
    other: '{{count}} minute'
  },
  aboutXHours: {
    one: 'circa 1 oră',
    other: 'circa {{count}} ore'
  },
  xHours: {
    one: '1 oră',
    other: '{{count}} ore'
  },
  xDays: {
    one: '1 zi',
    other: '{{count}} zile'
  },
  aboutXWeeks: {
    one: 'circa o săptămână',
    other: 'circa {{count}} săptămâni'
  },
  xWeeks: {
    one: '1 săptămână',
    other: '{{count}} săptămâni'
  },
  aboutXMonths: {
    one: 'circa 1 lună',
    other: 'circa {{count}} luni'
  },
  xMonths: {
    one: '1 lună',
    other: '{{count}} luni'
  },
  aboutXYears: {
    one: 'circa 1 an',
    other: 'circa {{count}} ani'
  },
  xYears: {
    one: '1 an',
    other: '{{count}} ani'
  },
  overXYears: {
    one: 'peste 1 an',
    other: 'peste {{count}} ani'
  },
  almostXYears: {
    one: 'aproape 1 an',
    other: 'aproape {{count}} ani'
  }
};
function formatDistance$l(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$i[token] === 'string') {
    result = formatDistanceLocale$i[token];
  } else if (count === 1) {
    result = formatDistanceLocale$i[token].one;
  } else {
    result = formatDistanceLocale$i[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'în ' + result;
    } else {
      return result + ' în urmă';
    }
  }

  return result;
}

var dateFormats$j = {
  full: 'EEEE, d MMMM yyyy',
  long: 'd MMMM yyyy',
  medium: 'd MMM yyyy',
  short: 'dd.MM.yyyy'
};
var timeFormats$j = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$j = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$C = {
  date: buildFormatLongFn({
    formats: dateFormats$j,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$j,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$j,
    defaultWidth: 'full'
  })
};
var formatLong$D = formatLong$C;

var formatRelativeLocale$j = {
  lastWeek: "eeee 'trecută la' p",
  yesterday: "'ieri la' p",
  today: "'astăzi la' p",
  tomorrow: "'mâine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: 'P'
};
function formatRelative$l(token, _date, _baseDate, _options) {
  return formatRelativeLocale$j[token];
}

var eraValues$j = {
  narrow: ['Î', 'D'],
  abbreviated: ['Î.d.C.', 'D.C.'],
  wide: ['Înainte de Cristos', 'După Cristos']
};
var quarterValues$j = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['primul trimestru', 'al doilea trimestru', 'al treilea trimestru', 'al patrulea trimestru']
};
var monthValues$j = {
  narrow: ['I', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['ian', 'feb', 'mar', 'apr', 'mai', 'iun', 'iul', 'aug', 'sep', 'oct', 'noi', 'dec'],
  wide: ['ianuarie', 'februarie', 'martie', 'aprilie', 'mai', 'iunie', 'iulie', 'august', 'septembrie', 'octombrie', 'noiembrie', 'decembrie']
};
var dayValues$j = {
  narrow: ['d', 'l', 'm', 'm', 'j', 'v', 's'],
  short: ['du', 'lu', 'ma', 'mi', 'jo', 'vi', 'sâ'],
  abbreviated: ['dum', 'lun', 'mar', 'mie', 'joi', 'vin', 'sâm'],
  wide: ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă']
};
var dayPeriodValues$i = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'ami',
    morning: 'dim',
    afternoon: 'da',
    evening: 's',
    night: 'n'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'miezul nopții',
    noon: 'amiază',
    morning: 'dimineață',
    afternoon: 'după-amiază',
    evening: 'seară',
    night: 'noapte'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'miezul nopții',
    noon: 'amiază',
    morning: 'dimineață',
    afternoon: 'după-amiază',
    evening: 'seară',
    night: 'noapte'
  }
};
var formattingDayPeriodValues$i = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'amiază',
    morning: 'dimineață',
    afternoon: 'după-amiază',
    evening: 'seară',
    night: 'noapte'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'miezul nopții',
    noon: 'amiază',
    morning: 'dimineață',
    afternoon: 'după-amiază',
    evening: 'seară',
    night: 'noapte'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'miezul nopții',
    noon: 'amiază',
    morning: 'dimineață',
    afternoon: 'după-amiază',
    evening: 'seară',
    night: 'noapte'
  }
};

function ordinalNumber$j(dirtyNumber) {
  var number = Number(dirtyNumber);
  return String(number);
}

var localize$C = {
  ordinalNumber: ordinalNumber$j,
  era: buildLocalizeFn({
    values: eraValues$j,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$j,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$j,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$j,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$i,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$i,
    defaultFormattingWidth: 'wide'
  })
};
var localize$D = localize$C;

var matchOrdinalNumberPattern$j = /^(\d+)?/i;
var parseOrdinalNumberPattern$j = /\d+/i;
var matchEraPatterns$j = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var parseEraPatterns$j = {
  any: [/^ÎC/i, /^DC/i],
  wide: [/^(Înainte de Cristos|Înaintea erei noastre)/i, /^(După Cristos|Era noastră)/i]
};
var matchQuarterPatterns$j = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
};
var parseQuarterPatterns$j = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$j = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var parseMonthPatterns$j = {
  narrow: [/^i/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ia/i, /^f/i, /^mar/i, /^ap/i, /^mai/i, /^iun/i, /^iul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$j = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var parseDayPatterns$j = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
};
var matchDayPeriodPatterns$j = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var parseDayPeriodPatterns$j = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
};
var match$C = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$j,
    parsePattern: parseOrdinalNumberPattern$j,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$j,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$j,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$j,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$j,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$j,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$j,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$j,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$j,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$j,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$j,
    defaultParseWidth: 'any'
  })
};
var match$D = match$C;

/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */

var locale$C = {
  code: 'ro',
  formatDistance: formatDistance$l,
  formatLong: formatLong$D,
  formatRelative: formatRelative$l,
  localize: localize$D,
  match: match$D,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$D = locale$C;

function declension$2(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  var rem10 = count % 10;
  var rem100 = count % 100; // 1, 21, 31, ...

  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace('{{count}}', count);
  }
}

function buildLocalizeTokenFn$1(scheme) {
  return function (count, options) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        if (scheme.future) {
          return declension$2(scheme.future, count);
        } else {
          return 'через ' + declension$2(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension$2(scheme.past, count);
        } else {
          return declension$2(scheme.regular, count) + ' назад';
        }
      }
    } else {
      return declension$2(scheme.regular, count);
    }
  };
}

var formatDistanceLocale$h = {
  lessThanXSeconds: buildLocalizeTokenFn$1({
    regular: {
      one: 'меньше секунды',
      singularNominative: 'меньше {{count}} секунды',
      singularGenitive: 'меньше {{count}} секунд',
      pluralGenitive: 'меньше {{count}} секунд'
    },
    future: {
      one: 'меньше, чем через секунду',
      singularNominative: 'меньше, чем через {{count}} секунду',
      singularGenitive: 'меньше, чем через {{count}} секунды',
      pluralGenitive: 'меньше, чем через {{count}} секунд'
    }
  }),
  xSeconds: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: '{{count}} секунда',
      singularGenitive: '{{count}} секунды',
      pluralGenitive: '{{count}} секунд'
    },
    past: {
      singularNominative: '{{count}} секунду назад',
      singularGenitive: '{{count}} секунды назад',
      pluralGenitive: '{{count}} секунд назад'
    },
    future: {
      singularNominative: 'через {{count}} секунду',
      singularGenitive: 'через {{count}} секунды',
      pluralGenitive: 'через {{count}} секунд'
    }
  }),
  halfAMinute: function (_, options) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'через полминуты';
      } else {
        return 'полминуты назад';
      }
    }

    return 'полминуты';
  },
  lessThanXMinutes: buildLocalizeTokenFn$1({
    regular: {
      one: 'меньше минуты',
      singularNominative: 'меньше {{count}} минуты',
      singularGenitive: 'меньше {{count}} минут',
      pluralGenitive: 'меньше {{count}} минут'
    },
    future: {
      one: 'меньше, чем через минуту',
      singularNominative: 'меньше, чем через {{count}} минуту',
      singularGenitive: 'меньше, чем через {{count}} минуты',
      pluralGenitive: 'меньше, чем через {{count}} минут'
    }
  }),
  xMinutes: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: '{{count}} минута',
      singularGenitive: '{{count}} минуты',
      pluralGenitive: '{{count}} минут'
    },
    past: {
      singularNominative: '{{count}} минуту назад',
      singularGenitive: '{{count}} минуты назад',
      pluralGenitive: '{{count}} минут назад'
    },
    future: {
      singularNominative: 'через {{count}} минуту',
      singularGenitive: 'через {{count}} минуты',
      pluralGenitive: 'через {{count}} минут'
    }
  }),
  aboutXHours: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: 'около {{count}} часа',
      singularGenitive: 'около {{count}} часов',
      pluralGenitive: 'около {{count}} часов'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} час',
      singularGenitive: 'приблизительно через {{count}} часа',
      pluralGenitive: 'приблизительно через {{count}} часов'
    }
  }),
  xHours: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: '{{count}} час',
      singularGenitive: '{{count}} часа',
      pluralGenitive: '{{count}} часов'
    }
  }),
  xDays: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: '{{count}} день',
      singularGenitive: '{{count}} дня',
      pluralGenitive: '{{count}} дней'
    }
  }),
  aboutXWeeks: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: 'около {{count}} недели',
      singularGenitive: 'около {{count}} недель',
      pluralGenitive: 'около {{count}} недель'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} неделю',
      singularGenitive: 'приблизительно через {{count}} недели',
      pluralGenitive: 'приблизительно через {{count}} недель'
    }
  }),
  xWeeks: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: '{{count}} неделя',
      singularGenitive: '{{count}} недели',
      pluralGenitive: '{{count}} недель'
    }
  }),
  aboutXMonths: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: 'около {{count}} месяца',
      singularGenitive: 'около {{count}} месяцев',
      pluralGenitive: 'около {{count}} месяцев'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} месяц',
      singularGenitive: 'приблизительно через {{count}} месяца',
      pluralGenitive: 'приблизительно через {{count}} месяцев'
    }
  }),
  xMonths: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: '{{count}} месяц',
      singularGenitive: '{{count}} месяца',
      pluralGenitive: '{{count}} месяцев'
    }
  }),
  aboutXYears: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: 'около {{count}} года',
      singularGenitive: 'около {{count}} лет',
      pluralGenitive: 'около {{count}} лет'
    },
    future: {
      singularNominative: 'приблизительно через {{count}} год',
      singularGenitive: 'приблизительно через {{count}} года',
      pluralGenitive: 'приблизительно через {{count}} лет'
    }
  }),
  xYears: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: '{{count}} год',
      singularGenitive: '{{count}} года',
      pluralGenitive: '{{count}} лет'
    }
  }),
  overXYears: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: 'больше {{count}} года',
      singularGenitive: 'больше {{count}} лет',
      pluralGenitive: 'больше {{count}} лет'
    },
    future: {
      singularNominative: 'больше, чем через {{count}} год',
      singularGenitive: 'больше, чем через {{count}} года',
      pluralGenitive: 'больше, чем через {{count}} лет'
    }
  }),
  almostXYears: buildLocalizeTokenFn$1({
    regular: {
      singularNominative: 'почти {{count}} год',
      singularGenitive: 'почти {{count}} года',
      pluralGenitive: 'почти {{count}} лет'
    },
    future: {
      singularNominative: 'почти через {{count}} год',
      singularGenitive: 'почти через {{count}} года',
      pluralGenitive: 'почти через {{count}} лет'
    }
  })
};
function formatDistance$k(token, count, options) {
  options = options || {};
  return formatDistanceLocale$h[token](count, options);
}

var dateFormats$i = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: 'dd.MM.y'
};
var timeFormats$i = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$i = {
  any: '{{date}}, {{time}}'
};
var formatLong$A = {
  date: buildFormatLongFn({
    formats: dateFormats$i,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$i,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$i,
    defaultWidth: 'any'
  })
};
var formatLong$B = formatLong$A;

var accusativeWeekdays$2 = ['воскресенье', 'понедельник', 'вторник', 'среду', 'четверг', 'пятницу', 'субботу'];

function lastWeek$2(day) {
  var weekday = accusativeWeekdays$2[day];

  switch (day) {
    case 0:
      return "'в прошлое " + weekday + " в' p";

    case 1:
    case 2:
    case 4:
      return "'в прошлый " + weekday + " в' p";

    case 3:
    case 5:
    case 6:
      return "'в прошлую " + weekday + " в' p";
  }
}

function thisWeek$2(day) {
  var weekday = accusativeWeekdays$2[day];

  if (day === 2
  /* Tue */
  ) {
      return "'во " + weekday + " в' p";
    } else {
    return "'в " + weekday + " в' p";
  }
}

function nextWeek$2(day) {
  var weekday = accusativeWeekdays$2[day];

  switch (day) {
    case 0:
      return "'в следующее " + weekday + " в' p";

    case 1:
    case 2:
    case 4:
      return "'в следующий " + weekday + " в' p";

    case 3:
    case 5:
    case 6:
      return "'в следующую " + weekday + " в' p";
  }
}

var formatRelativeLocale$i = {
  lastWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek$2(day);
    } else {
      return lastWeek$2(day);
    }
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek$2(day);
    } else {
      return nextWeek$2(day);
    }
  },
  other: 'P'
};
function formatRelative$k(token, date, baseDate, options) {
  var format = formatRelativeLocale$i[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}

var eraValues$i = {
  narrow: ['до н.э.', 'н.э.'],
  abbreviated: ['до н. э.', 'н. э.'],
  wide: ['до нашей эры', 'нашей эры']
};
var quarterValues$i = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
  wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
};
var monthValues$i = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв.', 'фев.', 'март', 'апр.', 'май', 'июнь', 'июль', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
  wide: ['январь', 'февраль', 'март', 'апрель', 'май', 'июнь', 'июль', 'август', 'сентябрь', 'октябрь', 'ноябрь', 'декабрь']
};
var formattingMonthValues$5 = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв.', 'фев.', 'мар.', 'апр.', 'мая', 'июн.', 'июл.', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'],
  wide: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
};
var dayValues$i = {
  narrow: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  short: ['вс', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  abbreviated: ['вск', 'пнд', 'втр', 'срд', 'чтв', 'птн', 'суб'],
  wide: ['воскресенье', 'понедельник', 'вторник', 'среда', 'четверг', 'пятница', 'суббота']
};
var dayPeriodValues$h = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утро',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ночь'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утро',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ночь'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полночь',
    noon: 'полдень',
    morning: 'утро',
    afternoon: 'день',
    evening: 'вечер',
    night: 'ночь'
  }
};
var formattingDayPeriodValues$h = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночи'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полн.',
    noon: 'полд.',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночи'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'полночь',
    noon: 'полдень',
    morning: 'утра',
    afternoon: 'дня',
    evening: 'вечера',
    night: 'ночи'
  }
};

function ordinalNumber$i(dirtyNumber, dirtyOptions) {
  var options = dirtyOptions || {};
  var unit = String(options.unit);
  var suffix;

  if (unit === 'date') {
    suffix = '-е';
  } else if (unit === 'week' || unit === 'minute' || unit === 'second') {
    suffix = '-я';
  } else {
    suffix = '-й';
  }

  return dirtyNumber + suffix;
}

var localize$A = {
  ordinalNumber: ordinalNumber$i,
  era: buildLocalizeFn({
    values: eraValues$i,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$i,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$i,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$5,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$i,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$h,
    defaultWidth: 'any',
    formattingValues: formattingDayPeriodValues$h,
    defaultFormattingWidth: 'wide'
  })
};
var localize$B = localize$A;

var matchOrdinalNumberPattern$i = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var parseOrdinalNumberPattern$i = /\d+/i;
var matchEraPatterns$i = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var parseEraPatterns$i = {
  any: [/^д/i, /^н/i]
};
var matchQuarterPatterns$i = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var parseQuarterPatterns$i = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$i = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var parseMonthPatterns$i = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^я/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
};
var matchDayPatterns$i = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var parseDayPatterns$i = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
};
var matchDayPeriodPatterns$i = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var parseDayPeriodPatterns$i = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
};
var match$A = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$i,
    parsePattern: parseOrdinalNumberPattern$i,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$i,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$i,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$i,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$i,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$i,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$i,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$i,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$i,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$i,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns$i,
    defaultParseWidth: 'any'
  })
};
var match$B = match$A;

/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale$A = {
  code: 'ru',
  formatDistance: formatDistance$k,
  formatLong: formatLong$B,
  formatRelative: formatRelative$k,
  localize: localize$B,
  match: match$B,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$B = locale$A;

function declensionGroup(scheme, count) {
  if (count === 1 && scheme.one) {
    return scheme.one;
  }

  if (count >= 2 && count <= 4 && scheme.twoFour) {
    return scheme.twoFour;
  } // if count === null || count === 0 || count >= 5


  return scheme.other;
}

function declension$1(scheme, count, time) {
  var group = declensionGroup(scheme, count);
  var finalText = group[time];
  return finalText.replace('{{count}}', String(count));
}

function extractPreposition(token) {
  var result = ['lessThan', 'about', 'over', 'almost'].filter(function (preposition) {
    return !!token.match(new RegExp('^' + preposition));
  });
  return result[0];
}

function prefixPreposition(preposition) {
  var translation = '';

  if (preposition === 'almost') {
    translation = 'takmer';
  }

  if (preposition === 'about') {
    translation = 'približne';
  }

  return translation.length > 0 ? translation + ' ' : '';
}

function suffixPreposition(preposition) {
  var translation = '';

  if (preposition === 'lessThan') {
    translation = 'menej než';
  }

  if (preposition === 'over') {
    translation = 'viac než';
  }

  return translation.length > 0 ? translation + ' ' : '';
}

function lowercaseFirstLetter(string) {
  return string.charAt(0).toLowerCase() + string.slice(1);
}

var formatDistanceLocale$g = {
  xSeconds: {
    one: {
      present: 'sekunda',
      past: 'sekundou',
      future: 'sekundu'
    },
    twoFour: {
      present: '{{count}} sekundy',
      past: '{{count}} sekundami',
      future: '{{count}} sekundy'
    },
    other: {
      present: '{{count}} sekúnd',
      past: '{{count}} sekundami',
      future: '{{count}} sekúnd'
    }
  },
  halfAMinute: {
    other: {
      present: 'pol minúty',
      past: 'pol minútou',
      future: 'pol minúty'
    }
  },
  xMinutes: {
    one: {
      present: 'minúta',
      past: 'minútou',
      future: 'minútu'
    },
    twoFour: {
      present: '{{count}} minúty',
      past: '{{count}} minútami',
      future: '{{count}} minúty'
    },
    other: {
      present: '{{count}} minút',
      past: '{{count}} minútami',
      future: '{{count}} minút'
    }
  },
  xHours: {
    one: {
      present: 'hodina',
      past: 'hodinou',
      future: 'hodinu'
    },
    twoFour: {
      present: '{{count}} hodiny',
      past: '{{count}} hodinami',
      future: '{{count}} hodiny'
    },
    other: {
      present: '{{count}} hodín',
      past: '{{count}} hodinami',
      future: '{{count}} hodín'
    }
  },
  xDays: {
    one: {
      present: 'deň',
      past: 'dňom',
      future: 'deň'
    },
    twoFour: {
      present: '{{count}} dni',
      past: '{{count}} dňami',
      future: '{{count}} dni'
    },
    other: {
      present: '{{count}} dní',
      past: '{{count}} dňami',
      future: '{{count}} dní'
    }
  },
  xWeeks: {
    one: {
      present: 'týždeň',
      past: 'týždňom',
      future: 'týždeň'
    },
    twoFour: {
      present: '{{count}} týždne',
      past: '{{count}} týždňami',
      future: '{{count}} týždne'
    },
    other: {
      present: '{{count}} týždňov',
      past: '{{count}} týždňami',
      future: '{{count}} týždňov'
    }
  },
  xMonths: {
    one: {
      present: 'mesiac',
      past: 'mesiacom',
      future: 'mesiac'
    },
    twoFour: {
      present: '{{count}} mesiace',
      past: '{{count}} mesiacmi',
      future: '{{count}} mesiace'
    },
    other: {
      present: '{{count}} mesiacov',
      past: '{{count}} mesiacmi',
      future: '{{count}} mesiacov'
    }
  },
  xYears: {
    one: {
      present: 'rok',
      past: 'rokom',
      future: 'rok'
    },
    twoFour: {
      present: '{{count}} roky',
      past: '{{count}} rokmi',
      future: '{{count}} roky'
    },
    other: {
      present: '{{count}} rokov',
      past: '{{count}} rokmi',
      future: '{{count}} rokov'
    }
  }
};

var formatDistance$i = function (token, count, options) {
  var preposition = extractPreposition(token) || '';
  var key = lowercaseFirstLetter(token.substring(preposition.length));
  var scheme = formatDistanceLocale$g[key];

  if (!(options !== null && options !== void 0 && options.addSuffix)) {
    return prefixPreposition(preposition) + suffixPreposition(preposition) + declension$1(scheme, count, 'present');
  }

  if (options.comparison && options.comparison > 0) {
    return prefixPreposition(preposition) + 'o ' + suffixPreposition(preposition) + declension$1(scheme, count, 'future');
  } else {
    return prefixPreposition(preposition) + 'pred ' + suffixPreposition(preposition) + declension$1(scheme, count, 'past');
  }
};

var formatDistance$j = formatDistance$i;

var dateFormats$h = {
  full: 'EEEE d. MMMM y',
  long: 'd. MMMM y',
  medium: 'd. M. y',
  short: 'd. M. y'
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149

var timeFormats$h = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994

var dateTimeFormats$h = {
  full: '{{date}}, {{time}}',
  long: '{{date}}, {{time}}',
  medium: '{{date}}, {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$y = {
  date: buildFormatLongFn({
    formats: dateFormats$h,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$h,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$h,
    defaultWidth: 'full'
  })
};
var formatLong$z = formatLong$y;

// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var accusativeWeekdays$1 = ['nedeľu', 'pondelok', 'utorok', 'stredu', 'štvrtok', 'piatok', 'sobotu'];

function lastWeek$1(day) {
  var weekday = accusativeWeekdays$1[day];

  switch (day) {
    case 0:
    /* Sun */

    case 3:
    /* Wed */

    case 6
    /* Sat */
    :
      return "'minulú " + weekday + " o' p";

    default:
      return "'minulý' eeee 'o' p";
  }
}

function thisWeek$1(day) {
  var weekday = accusativeWeekdays$1[day];

  if (day === 4
  /* Thu */
  ) {
      return "'vo' eeee 'o' p";
    } else {
    return "'v " + weekday + " o' p";
  }
}

function nextWeek$1(day) {
  var weekday = accusativeWeekdays$1[day];

  switch (day) {
    case 0:
    /* Sun */

    case 4:
    /* Wed */

    case 6
    /* Sat */
    :
      return "'budúcu " + weekday + " o' p";

    default:
      return "'budúci' eeee 'o' p";
  }
}

var formatRelativeLocale$h = {
  lastWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek$1(day);
    } else {
      return lastWeek$1(day);
    }
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek$1(day);
    } else {
      return nextWeek$1(day);
    }
  },
  other: 'P'
};

var formatRelative$i = function (token, date, baseDate, options) {
  var format = formatRelativeLocale$h[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
};

var formatRelative$j = formatRelative$i;

var eraValues$h = {
  narrow: ['pred Kr.', 'po Kr.'],
  abbreviated: ['pred Kr.', 'po Kr.'],
  wide: ['pred Kristom', 'po Kristovi']
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1780

var quarterValues$h = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1. štvrťrok', '2. štvrťrok', '3. štvrťrok', '4. štvrťrok']
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1804

var monthValues$h = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
  wide: ['január', 'február', 'marec', 'apríl', 'máj', 'jún', 'júl', 'august', 'september', 'október', 'november', 'december']
};
var formattingMonthValues$4 = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan', 'feb', 'mar', 'apr', 'máj', 'jún', 'júl', 'aug', 'sep', 'okt', 'nov', 'dec'],
  wide: ['januára', 'februára', 'marca', 'apríla', 'mája', 'júna', 'júla', 'augusta', 'septembra', 'októbra', 'novembra', 'decembra']
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1876

var dayValues$h = {
  narrow: ['n', 'p', 'u', 's', 'š', 'p', 's'],
  short: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
  abbreviated: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
  wide: ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota']
}; // https://www.unicode.org/cldr/charts/32/summary/sk.html#1932

var dayPeriodValues$g = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'poln.',
    noon: 'pol.',
    morning: 'ráno',
    afternoon: 'pop.',
    evening: 'več.',
    night: 'noc'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'poln.',
    noon: 'pol.',
    morning: 'ráno',
    afternoon: 'popol.',
    evening: 'večer',
    night: 'noc'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'polnoc',
    noon: 'poludnie',
    morning: 'ráno',
    afternoon: 'popoludnie',
    evening: 'večer',
    night: 'noc'
  }
};
var formattingDayPeriodValues$g = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o poln.',
    noon: 'nap.',
    morning: 'ráno',
    afternoon: 'pop.',
    evening: 'več.',
    night: 'v n.'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o poln.',
    noon: 'napol.',
    morning: 'ráno',
    afternoon: 'popol.',
    evening: 'večer',
    night: 'v noci'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'o polnoci',
    noon: 'napoludnie',
    morning: 'ráno',
    afternoon: 'popoludní',
    evening: 'večer',
    night: 'v noci'
  }
};

var ordinalNumber$h = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + '.';
};

var localize$y = {
  ordinalNumber: ordinalNumber$h,
  era: buildLocalizeFn({
    values: eraValues$h,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$h,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$h,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$4,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$h,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$g,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$g,
    defaultFormattingWidth: 'wide'
  })
};
var localize$z = localize$y;

var matchOrdinalNumberPattern$h = /^(\d+)\.?/i;
var parseOrdinalNumberPattern$h = /\d+/i;
var matchEraPatterns$h = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var parseEraPatterns$h = {
  any: [/^pr/i, /^(po|n)/i]
};
var matchQuarterPatterns$h = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var parseQuarterPatterns$h = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$h = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var parseMonthPatterns$h = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^m[áa]j/i, /^j[úu]n/i, /^j[úu]l/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$h = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var parseDayPatterns$h = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
};
var matchDayPeriodPatterns$h = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var parseDayPeriodPatterns$h = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
};
var match$y = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$h,
    parsePattern: parseOrdinalNumberPattern$h,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$h,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$h,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$h,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$h,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$h,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$h,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$h,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$h,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$h,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$h,
    defaultParseWidth: 'any'
  })
};
var match$z = match$y;

/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */

var locale$y = {
  code: 'sk',
  formatDistance: formatDistance$j,
  formatLong: formatLong$z,
  formatRelative: formatRelative$j,
  localize: localize$z,
  match: match$z,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$z = locale$y;

var distanceInWordsLocale = {
  lessThanXSeconds: {
    one: 'manj kot {{count}} sekunda',
    two: 'manj kot {{count}} sekundi',
    few: 'manj kot {{count}} sekunde',
    other: 'manj kot {{count}} sekund'
  },
  xSeconds: {
    one: '{{count}} sekunda',
    two: '{{count}} sekundi',
    few: '{{count}} sekunde',
    other: '{{count}} sekund'
  },
  halfAMinute: 'pol minute',
  lessThanXMinutes: {
    one: 'manj kot {{count}} minuta',
    two: 'manj kot {{count}} minuti',
    few: 'manj kot {{count}} minute',
    other: 'manj kot {{count}} minut'
  },
  xMinutes: {
    one: '{{count}} minuta',
    two: '{{count}} minuti',
    few: '{{count}} minute',
    other: '{{count}} minut'
  },
  aboutXHours: {
    one: 'približno {{count}} ura',
    two: 'približno {{count}} uri',
    few: 'približno {{count}} ure',
    other: 'približno {{count}} ur'
  },
  xHours: {
    one: '{{count}} ura',
    two: '{{count}} uri',
    few: '{{count}} ure',
    other: '{{count}} ur'
  },
  xDays: {
    one: '{{count}} dan',
    two: '{{count}} dni',
    few: '{{count}} dni',
    other: '{{count}} dni'
  },
  aboutXWeeks: {
    one: 'približno {{count}} teden',
    two: 'približno {{count}} tedna',
    few: 'približno {{count}} tedne',
    other: 'približno {{count}} tednov'
  },
  xWeeks: {
    one: '{{count}} teden',
    two: '{{count}} tedna',
    few: '{{count}} tedne',
    other: '{{count}} tednov'
  },
  aboutXMonths: {
    one: 'približno {{count}} mesec',
    two: 'približno {{count}} meseca',
    few: 'približno {{count}} mesece',
    other: 'približno {{count}} mesecev'
  },
  xMonths: {
    one: '{{count}} mesec',
    two: '{{count}} meseca',
    few: '{{count}} meseci',
    other: '{{count}} mesecev'
  },
  aboutXYears: {
    one: 'približno {{count}} leto',
    two: 'približno {{count}} leti',
    few: 'približno {{count}} leta',
    other: 'približno {{count}} let'
  },
  xYears: {
    one: '{{count}} leto',
    two: '{{count}} leti',
    few: '{{count}} leta',
    other: '{{count}} let'
  },
  overXYears: {
    one: 'več kot {{count}} leto',
    two: 'več kot {{count}} leti',
    few: 'več kot {{count}} leta',
    other: 'več kot {{count}} let'
  },
  almostXYears: {
    one: 'skoraj {{count}} leto',
    two: 'skoraj {{count}} leti',
    few: 'skoraj {{count}} leta',
    other: 'skoraj {{count}} let'
  }
};
var distanceInWordsLocalePast = {
  lessThanXSeconds: {
    one: 'manj kot {{count}} sekundo',
    two: 'manj kot {{count}} sekundama',
    few: 'manj kot {{count}} sekundami',
    other: 'manj kot {{count}} sekundami'
  },
  xSeconds: {
    one: '{{count}} sekundo',
    two: '{{count}} sekundama',
    few: '{{count}} sekundami',
    other: '{{count}} sekundami'
  },
  halfAMinute: 'pol minute',
  lessThanXMinutes: {
    one: 'manj kot {{count}} minuto',
    two: 'manj kot {{count}} minutama',
    few: 'manj kot {{count}} minutami',
    other: 'manj kot {{count}} minutami'
  },
  xMinutes: {
    one: '{{count}} minuto',
    two: '{{count}} minutama',
    few: '{{count}} minutami',
    other: '{{count}} minutami'
  },
  aboutXHours: {
    one: 'približno {{count}} uro',
    two: 'približno {{count}} urama',
    few: 'približno {{count}} urami',
    other: 'približno {{count}} urami'
  },
  xHours: {
    one: '{{count}} uro',
    two: '{{count}} urama',
    few: '{{count}} urami',
    other: '{{count}} urami'
  },
  xDays: {
    one: '{{count}} dnem',
    two: '{{count}} dnevoma',
    few: '{{count}} dnevi',
    other: '{{count}} dnevi'
  },
  aboutXMonths: {
    one: 'približno {{count}} mesecem',
    two: 'približno {{count}} mesecema',
    few: 'približno {{count}} meseci',
    other: 'približno {{count}} meseci'
  },
  xMonths: {
    one: '{{count}} mesecem',
    two: '{{count}} mesecema',
    few: '{{count}} meseci',
    other: '{{count}} meseci'
  },
  aboutXYears: {
    one: 'približno {{count}} letom',
    two: 'približno {{count}} letoma',
    few: 'približno {{count}} leti',
    other: 'približno {{count}} leti'
  },
  xYears: {
    one: '{{count}} letom',
    two: '{{count}} letoma',
    few: '{{count}} leti',
    other: '{{count}} leti'
  },
  overXYears: {
    one: 'več kot {{count}} letom',
    two: 'več kot {{count}} letoma',
    few: 'več kot {{count}} leti',
    other: 'več kot {{count}} leti'
  },
  almostXYears: {
    one: 'skoraj {{count}} letom',
    two: 'skoraj {{count}} letoma',
    few: 'skoraj {{count}} leti',
    other: 'skoraj {{count}} leti'
  }
};
var distanceInWordsLocaleFuture = {
  lessThanXSeconds: {
    one: 'manj kot {{count}} sekundo',
    two: 'manj kot {{count}} sekundi',
    few: 'manj kot {{count}} sekunde',
    other: 'manj kot {{count}} sekund'
  },
  xSeconds: {
    one: '{{count}} sekundo',
    two: '{{count}} sekundi',
    few: '{{count}} sekunde',
    other: '{{count}} sekund'
  },
  halfAMinute: 'pol minute',
  lessThanXMinutes: {
    one: 'manj kot {{count}} minuto',
    two: 'manj kot {{count}} minuti',
    few: 'manj kot {{count}} minute',
    other: 'manj kot {{count}} minut'
  },
  xMinutes: {
    one: '{{count}} minuto',
    two: '{{count}} minuti',
    few: '{{count}} minute',
    other: '{{count}} minut'
  },
  aboutXHours: {
    one: 'približno {{count}} uro',
    two: 'približno {{count}} uri',
    few: 'približno {{count}} ure',
    other: 'približno {{count}} ur'
  },
  xHours: {
    one: '{{count}} uro',
    two: '{{count}} uri',
    few: '{{count}} ure',
    other: '{{count}} ur'
  },
  xDays: {
    one: '{{count}} dan',
    two: '{{count}} dni',
    few: '{{count}} dni',
    other: '{{count}} dni'
  },
  aboutXMonths: {
    one: 'približno {{count}} mesec',
    two: 'približno {{count}} meseca',
    few: 'približno {{count}} mesece',
    other: 'približno {{count}} mesecev'
  },
  xMonths: {
    one: '{{count}} mesec',
    two: '{{count}} meseca',
    few: '{{count}} mesece',
    other: '{{count}} mesecev'
  },
  aboutXYears: {
    one: 'približno {{count}} leto',
    two: 'približno {{count}} leti',
    few: 'približno {{count}} leta',
    other: 'približno {{count}} let'
  },
  xYears: {
    one: '{{count}} leto',
    two: '{{count}} leti',
    few: '{{count}} leta',
    other: '{{count}} let'
  },
  overXYears: {
    one: 'več kot {{count}} leto',
    two: 'več kot {{count}} leti',
    few: 'več kot {{count}} leta',
    other: 'več kot {{count}} let'
  },
  almostXYears: {
    one: 'skoraj {{count}} leto',
    two: 'skoraj {{count}} leti',
    few: 'skoraj {{count}} leta',
    other: 'skoraj {{count}} let'
  }
};

function getFormFromCount(count) {
  switch (count % 100) {
    case 1:
      return 'one';

    case 2:
      return 'two';

    case 3:
    case 4:
      return 'few';

    default:
      return 'other';
  }
}

function formatDistance$h(token, count, options) {
  options = options || {};
  var localeObject = distanceInWordsLocale;
  var result = '';

  if (options.addSuffix) {
    if (options.comparison > 0) {
      localeObject = distanceInWordsLocaleFuture;
      result += 'čez ';
    } else {
      localeObject = distanceInWordsLocalePast;
      result += 'pred ';
    }
  }

  if (typeof localeObject[token] === 'string') {
    result += localeObject[token];
  } else {
    var form = getFormFromCount(count);
    result += localeObject[token][form].replace('{{count}}', count);
  }

  return result;
}

var dateFormats$g = {
  full: 'EEEE, dd. MMMM y',
  long: 'dd. MMMM y',
  medium: 'd. MMM y',
  short: 'd. MM. yy'
};
var timeFormats$g = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$g = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$w = {
  date: buildFormatLongFn({
    formats: dateFormats$g,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$g,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$g,
    defaultWidth: 'full'
  })
};
var formatLong$x = formatLong$w;

var formatRelativeLocale$g = {
  lastWeek: function (date) {
    var day = date.getUTCDay();

    switch (day) {
      case 0:
        return "'prejšnjo nedeljo ob' p";

      case 3:
        return "'prejšnjo sredo ob' p";

      case 6:
        return "'prejšnjo soboto ob' p";

      default:
        return "'prejšnji' EEEE 'ob' p";
    }
  },
  yesterday: "'včeraj ob' p",
  today: "'danes ob' p",
  tomorrow: "'jutri ob' p",
  nextWeek: function (date) {
    var day = date.getUTCDay();

    switch (day) {
      case 0:
        return "'naslednjo nedeljo ob' p";

      case 3:
        return "'naslednjo sredo ob' p";

      case 6:
        return "'naslednjo soboto ob' p";

      default:
        return "'naslednji' EEEE 'ob' p";
    }
  },
  other: 'P'
};
function formatRelative$h(token, date, _baseDate, _options) {
  var format = formatRelativeLocale$g[token];

  if (typeof format === 'function') {
    return format(date);
  }

  return format;
}

function ordinalNumber$g(dirtyNumber) {
  var number = Number(dirtyNumber);
  return String(number).concat('.');
}

var eraValues$g = {
  narrow: ['pr. n. št.', 'po n. št.'],
  abbreviated: ['pr. n. št.', 'po n. št.'],
  wide: ['pred našim štetjem', 'po našem štetju']
};
var monthValues$g = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januar', 'februar', 'marec', 'april', 'maj', 'junij', 'julij', 'avgust', 'september', 'oktober', 'november', 'december']
};
var quarterValues$g = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1. čet.', '2. čet.', '3. čet.', '4. čet.'],
  wide: ['1. četrtletje', '2. četrtletje', '3. četrtletje', '4. četrtletje']
};
var dayValues$g = {
  narrow: ['n', 'p', 't', 's', 'č', 'p', 's'],
  short: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
  abbreviated: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
  wide: ['nedelja', 'ponedeljek', 'torek', 'sreda', 'četrtek', 'petek', 'sobota']
};
var dayPeriodValuesStandalone = {
  narrow: {
    am: 'd',
    pm: 'p',
    midnight: '24.00',
    noon: '12.00',
    morning: 'j',
    afternoon: 'p',
    evening: 'v',
    night: 'n'
  },
  abbreviated: {
    am: 'dop.',
    pm: 'pop.',
    midnight: 'poln.',
    noon: 'pold.',
    morning: 'jut.',
    afternoon: 'pop.',
    evening: 'več.',
    night: 'noč'
  },
  wide: {
    am: 'dop.',
    pm: 'pop.',
    midnight: 'polnoč',
    noon: 'poldne',
    morning: 'jutro',
    afternoon: 'popoldne',
    evening: 'večer',
    night: 'noč'
  }
};
var dayPeriodValuesFormatting = {
  narrow: {
    am: 'd',
    pm: 'p',
    midnight: '24.00',
    noon: '12.00',
    morning: 'zj',
    afternoon: 'p',
    evening: 'zv',
    night: 'po'
  },
  abbreviated: {
    am: 'dop.',
    pm: 'pop.',
    midnight: 'opoln.',
    noon: 'opold.',
    morning: 'zjut.',
    afternoon: 'pop.',
    evening: 'zveč.',
    night: 'ponoči'
  },
  wide: {
    am: 'dop.',
    pm: 'pop.',
    midnight: 'opolnoči',
    noon: 'opoldne',
    morning: 'zjutraj',
    afternoon: 'popoldan',
    evening: 'zvečer',
    night: 'ponoči'
  }
};
var localize$w = {
  ordinalNumber: ordinalNumber$g,
  era: buildLocalizeFn({
    values: eraValues$g,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$g,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$g,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$g,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValuesStandalone,
    defaultWidth: 'wide',
    formattingValues: dayPeriodValuesFormatting,
    defaultFormattingWidth: 'wide'
  })
};
var localize$x = localize$w;

var matchOrdinalNumberPattern$g = /^(\d+)\./i;
var parseOrdinalNumberPattern$g = /\d+/i;
var matchEraPatterns$g = {
  abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
  wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var parseEraPatterns$g = {
  any: [/^pr/i, /^(po|na[sš]em)/i]
};
var matchQuarterPatterns$g = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?[čc]et\.?/i,
  wide: /^[1234]\. [čc]etrtletje/i
};
var parseQuarterPatterns$g = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$g = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
  wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var parseMonthPatterns$g = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  abbreviated: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i],
  wide: [/^ja/i, /^fe/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$g = {
  narrow: /^[nptsčc]/i,
  short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var parseDayPatterns$g = {
  narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i]
};
var matchDayPeriodPatterns$g = {
  narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
  any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var parseDayPeriodPatterns$g = {
  narrow: {
    am: /^d/i,
    pm: /^p/i,
    midnight: /^24/i,
    noon: /^12/i,
    morning: /^(z?j)/i,
    afternoon: /^p/i,
    evening: /^(z?v)/i,
    night: /^(n|po)/i
  },
  any: {
    am: /^dop\./i,
    pm: /^pop\./i,
    midnight: /^o?poln/i,
    noon: /^o?pold/i,
    morning: /j/i,
    afternoon: /^pop\./i,
    evening: /^z?ve/i,
    night: /(po)?no/i
  }
};
var match$w = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$g,
    parsePattern: parseOrdinalNumberPattern$g,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$g,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$g,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$g,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$g,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$g,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$g,
    defaultParseWidth: 'wide'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$g,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$g,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$g,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$g,
    defaultParseWidth: 'any'
  })
};
var match$x = match$w;

/**
 * @type {Locale}
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
 */

var locale$w = {
  code: 'sl',
  formatDistance: formatDistance$h,
  formatLong: formatLong$x,
  formatRelative: formatRelative$h,
  localize: localize$x,
  match: match$x,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$x = locale$w;

var formatDistanceLocale$f = {
  lessThanXSeconds: {
    one: 'më pak se një sekondë',
    other: 'më pak se {{count}} sekonda'
  },
  xSeconds: {
    one: '1 sekondë',
    other: '{{count}} sekonda'
  },
  halfAMinute: 'gjysëm minuti',
  lessThanXMinutes: {
    one: 'më pak se një minute',
    other: 'më pak se {{count}} minuta'
  },
  xMinutes: {
    one: '1 minutë',
    other: '{{count}} minuta'
  },
  aboutXHours: {
    one: 'rreth 1 orë',
    other: 'rreth {{count}} orë'
  },
  xHours: {
    one: '1 orë',
    other: '{{count}} orë'
  },
  xDays: {
    one: '1 ditë',
    other: '{{count}} ditë'
  },
  aboutXWeeks: {
    one: 'rreth 1 javë',
    other: 'rreth {{count}} javë'
  },
  xWeeks: {
    one: '1 javë',
    other: '{{count}} javë'
  },
  aboutXMonths: {
    one: 'rreth 1 muaj',
    other: 'rreth {{count}} muaj'
  },
  xMonths: {
    one: '1 muaj',
    other: '{{count}} muaj'
  },
  aboutXYears: {
    one: 'rreth 1 vit',
    other: 'rreth {{count}} vite'
  },
  xYears: {
    one: '1 vit',
    other: '{{count}} vite'
  },
  overXYears: {
    one: 'mbi 1 vit',
    other: 'mbi {{count}} vite'
  },
  almostXYears: {
    one: 'pothuajse 1 vit',
    other: 'pothuajse {{count}} vite'
  }
};
function formatDistance$g(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$f[token] === 'string') {
    result = formatDistanceLocale$f[token];
  } else if (count === 1) {
    result = formatDistanceLocale$f[token].one;
  } else {
    result = formatDistanceLocale$f[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'në ' + result;
    } else {
      return result + ' më parë';
    }
  }

  return result;
}

var dateFormats$f = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$f = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$f = {
  full: "{{date}} 'në' {{time}}",
  long: "{{date}} 'në' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$u = {
  date: buildFormatLongFn({
    formats: dateFormats$f,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$f,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$f,
    defaultWidth: 'full'
  })
};
var formatLong$v = formatLong$u;

var formatRelativeLocale$f = {
  lastWeek: "'të' eeee 'e shkuar në' p",
  yesterday: "'dje në' p",
  today: "'sot në' p",
  tomorrow: "'nesër në' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative$g(token, _date, _baseDate, _options) {
  return formatRelativeLocale$f[token];
}

var eraValues$f = {
  narrow: ['P', 'M'],
  abbreviated: ['PK', 'MK'],
  wide: ['Para Krishtit', 'Mbas Krishtit']
};
var quarterValues$f = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['4-mujori I', '4-mujori II', '4-mujori III', '4-mujori IV']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$f = {
  narrow: ['J', 'S', 'M', 'P', 'M', 'Q', 'K', 'G', 'S', 'T', 'N', 'D'],
  abbreviated: ['Jan', 'Shk', 'Mar', 'Pri', 'Maj', 'Qer', 'Kor', 'Gus', 'Sht', 'Tet', 'Nën', 'Dhj'],
  wide: ['Janar', 'Shkurt', 'Mars', 'Prill', 'Maj', 'Qershor', 'Korrik', 'Gusht', 'Shtator', 'Tetor', 'Nëntor', 'Dhjetor']
};
var dayValues$f = {
  narrow: ['D', 'H', 'M', 'M', 'E', 'P', 'S'],
  short: ['Di', 'Hë', 'Ma', 'Më', 'En', 'Pr', 'Sh'],
  abbreviated: ['Die', 'Hën', 'Mar', 'Mër', 'Enj', 'Pre', 'Sht'],
  wide: ['Dielë', 'Hënë', 'Martë', 'Mërkurë', 'Enjte', 'Premte', 'Shtunë']
};
var dayPeriodValues$f = {
  narrow: {
    am: 'p',
    pm: 'm',
    midnight: 'm',
    noon: 'd',
    morning: 'mëngjes',
    afternoon: 'dite',
    evening: 'mbrëmje',
    night: 'natë'
  },
  abbreviated: {
    am: 'PD',
    pm: 'MD',
    midnight: 'mesnëtë',
    noon: 'drek',
    morning: 'mëngjes',
    afternoon: 'mbasdite',
    evening: 'mbrëmje',
    night: 'natë'
  },
  wide: {
    am: 'p.d.',
    pm: 'm.d.',
    midnight: 'mesnëtë',
    noon: 'drek',
    morning: 'mëngjes',
    afternoon: 'mbasdite',
    evening: 'mbrëmje',
    night: 'natë'
  }
};
var formattingDayPeriodValues$f = {
  narrow: {
    am: 'p',
    pm: 'm',
    midnight: 'm',
    noon: 'd',
    morning: 'në mëngjes',
    afternoon: 'në mbasdite',
    evening: 'në mbrëmje',
    night: 'në mesnatë'
  },
  abbreviated: {
    am: 'PD',
    pm: 'MD',
    midnight: 'mesnatë',
    noon: 'drek',
    morning: 'në mëngjes',
    afternoon: 'në mbasdite',
    evening: 'në mbrëmje',
    night: 'në mesnatë'
  },
  wide: {
    am: 'p.d.',
    pm: 'm.d.',
    midnight: 'mesnatë',
    noon: 'drek',
    morning: 'në mëngjes',
    afternoon: 'në mbasdite',
    evening: 'në mbrëmje',
    night: 'në mesnatë'
  }
};

function ordinalNumber$f(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var options = _dirtyOptions || {};
  var unit = String(options.unit);
  if (unit === 'hour') return number;
  if (number === 1) return number + '-rë';
  if (number === 4) return number + 't';
  return number + '-të';
}

var localize$u = {
  ordinalNumber: ordinalNumber$f,
  era: buildLocalizeFn({
    values: eraValues$f,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$f,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$f,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$f,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$f,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$f,
    defaultFormattingWidth: 'wide'
  })
};
var localize$v = localize$u;

var matchOrdinalNumberPattern$f = /^(\d+)(-rë|-të|t|)?/i;
var parseOrdinalNumberPattern$f = /\d+/i;
var matchEraPatterns$f = {
  narrow: /^(p|m)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(para krishtit|mbas krishtit)/i
};
var parseEraPatterns$f = {
  any: [/^b/i, /^(p|m)/i]
};
var matchQuarterPatterns$f = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]-mujori (i{1,3}|iv)/i
};
var parseQuarterPatterns$f = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$f = {
  narrow: /^[jsmpqkftnd]/i,
  abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
  wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var parseMonthPatterns$f = {
  narrow: [/^j/i, /^s/i, /^m/i, /^p/i, /^m/i, /^q/i, /^k/i, /^g/i, /^s/i, /^t/i, /^n/i, /^d/i],
  any: [/^ja/i, /^shk/i, /^mar/i, /^pri/i, /^maj/i, /^qer/i, /^kor/i, /^gu/i, /^sht/i, /^tet/i, /^n/i, /^d/i]
};
var matchDayPatterns$f = {
  narrow: /^[dhmeps]/i,
  short: /^(di|hë|ma|më|en|pr|sh)/i,
  abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
  wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var parseDayPatterns$f = {
  narrow: [/^d/i, /^h/i, /^m/i, /^m/i, /^e/i, /^p/i, /^s/i],
  any: [/^d/i, /^h/i, /^ma/i, /^më/i, /^e/i, /^p/i, /^s/i]
};
var matchDayPeriodPatterns$f = {
  narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
  any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var parseDayPeriodPatterns$f = {
  any: {
    am: /^p/i,
    pm: /^m/i,
    midnight: /^me/i,
    noon: /^dr/i,
    morning: /mëngjes/i,
    afternoon: /mbasdite/i,
    evening: /mbrëmje/i,
    night: /natë/i
  }
};
var match$u = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$f,
    parsePattern: parseOrdinalNumberPattern$f,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$f,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$f,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$f,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$f,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$f,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$f,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$f,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$f,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$f,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$f,
    defaultParseWidth: 'any'
  })
};
var match$v = match$u;

/**
 * @type {Locale}
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
 */

var locale$u = {
  code: 'sq',
  formatDistance: formatDistance$g,
  formatLong: formatLong$v,
  formatRelative: formatRelative$g,
  localize: localize$v,
  match: match$v,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$v = locale$u;

var formatDistanceLocale$e = {
  lessThanXSeconds: {
    one: {
      standalone: 'мање од 1 секунде',
      withPrepositionAgo: 'мање од 1 секунде',
      withPrepositionIn: 'мање од 1 секунду'
    },
    dual: 'мање од {{count}} секунде',
    other: 'мање од {{count}} секунди'
  },
  xSeconds: {
    one: {
      standalone: '1 секунда',
      withPrepositionAgo: '1 секунде',
      withPrepositionIn: '1 секунду'
    },
    dual: '{{count}} секунде',
    other: '{{count}} секунди'
  },
  halfAMinute: 'пола минуте',
  lessThanXMinutes: {
    one: {
      standalone: 'мање од 1 минуте',
      withPrepositionAgo: 'мање од 1 минуте',
      withPrepositionIn: 'мање од 1 минуту'
    },
    dual: 'мање од {{count}} минуте',
    other: 'мање од {{count}} минута'
  },
  xMinutes: {
    one: {
      standalone: '1 минута',
      withPrepositionAgo: '1 минуте',
      withPrepositionIn: '1 минуту'
    },
    dual: '{{count}} минуте',
    other: '{{count}} минута'
  },
  aboutXHours: {
    one: {
      standalone: 'око 1 сат',
      withPrepositionAgo: 'око 1 сат',
      withPrepositionIn: 'око 1 сат'
    },
    dual: 'око {{count}} сата',
    other: 'око {{count}} сати'
  },
  xHours: {
    one: {
      standalone: '1 сат',
      withPrepositionAgo: '1 сат',
      withPrepositionIn: '1 сат'
    },
    dual: '{{count}} сата',
    other: '{{count}} сати'
  },
  xDays: {
    one: {
      standalone: '1 дан',
      withPrepositionAgo: '1 дан',
      withPrepositionIn: '1 дан'
    },
    dual: '{{count}} дана',
    other: '{{count}} дана'
  },
  aboutXWeeks: {
    one: {
      standalone: 'око 1 недељу',
      withPrepositionAgo: 'око 1 недељу',
      withPrepositionIn: 'око 1 недељу'
    },
    dual: 'око {{count}} недеље',
    other: 'око {{count}} недеље'
  },
  xWeeks: {
    one: {
      standalone: '1 недељу',
      withPrepositionAgo: '1 недељу',
      withPrepositionIn: '1 недељу'
    },
    dual: '{{count}} недеље',
    other: '{{count}} недеље'
  },
  aboutXMonths: {
    one: {
      standalone: 'око 1 месец',
      withPrepositionAgo: 'око 1 месец',
      withPrepositionIn: 'око 1 месец'
    },
    dual: 'око {{count}} месеца',
    other: 'око {{count}} месеци'
  },
  xMonths: {
    one: {
      standalone: '1 месец',
      withPrepositionAgo: '1 месец',
      withPrepositionIn: '1 месец'
    },
    dual: '{{count}} месеца',
    other: '{{count}} месеци'
  },
  aboutXYears: {
    one: {
      standalone: 'око 1 годину',
      withPrepositionAgo: 'око 1 годину',
      withPrepositionIn: 'око 1 годину'
    },
    dual: 'око {{count}} године',
    other: 'око {{count}} година'
  },
  xYears: {
    one: {
      standalone: '1 година',
      withPrepositionAgo: '1 године',
      withPrepositionIn: '1 годину'
    },
    dual: '{{count}} године',
    other: '{{count}} година'
  },
  overXYears: {
    one: {
      standalone: 'преко 1 годину',
      withPrepositionAgo: 'преко 1 годину',
      withPrepositionIn: 'преко 1 годину'
    },
    dual: 'преко {{count}} године',
    other: 'преко {{count}} година'
  },
  almostXYears: {
    one: {
      standalone: 'готово 1 годину',
      withPrepositionAgo: 'готово 1 годину',
      withPrepositionIn: 'готово 1 годину'
    },
    dual: 'готово {{count}} године',
    other: 'готово {{count}} година'
  }
};
function formatDistance$f(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$e[token] === 'string') {
    result = formatDistanceLocale$e[token];
  } else if (count === 1) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        result = formatDistanceLocale$e[token].one.withPrepositionIn;
      } else {
        result = formatDistanceLocale$e[token].one.withPrepositionAgo;
      }
    } else {
      result = formatDistanceLocale$e[token].one.standalone;
    }
  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
  ) {
      result = formatDistanceLocale$e[token].dual.replace('{{count}}', count);
    } else {
    result = formatDistanceLocale$e[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'за ' + result;
    } else {
      return 'пре ' + result;
    }
  }

  return result;
}

var dateFormats$e = {
  full: 'EEEE, d. MMMM yyyy.',
  long: 'd. MMMM yyyy.',
  medium: 'd. MMM yy.',
  short: 'dd. MM. yy.'
};
var timeFormats$e = {
  full: 'HH:mm:ss (zzzz)',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$e = {
  full: "{{date}} 'у' {{time}}",
  long: "{{date}} 'у' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$s = {
  date: buildFormatLongFn({
    formats: dateFormats$e,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$e,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$e,
    defaultWidth: 'full'
  })
};
var formatLong$t = formatLong$s;

var formatRelativeLocale$e = {
  lastWeek: function (date) {
    var day = date.getUTCDay();

    switch (day) {
      case 0:
        return "'прошле недеље у' p";

      case 3:
        return "'прошле среде у' p";

      case 6:
        return "'прошле суботе у' p";

      default:
        return "'прошли' EEEE 'у' p";
    }
  },
  yesterday: "'јуче у' p",
  today: "'данас у' p",
  tomorrow: "'сутра у' p",
  nextWeek: function (date) {
    var day = date.getUTCDay();

    switch (day) {
      case 0:
        return "'следеће недеље у' p";

      case 3:
        return "'следећу среду у' p";

      case 6:
        return "'следећу суботу у' p";

      default:
        return "'следећи' EEEE 'у' p";
    }
  },
  other: 'P'
};
function formatRelative$f(token, date, _baseDate, _options) {
  var format = formatRelativeLocale$e[token];

  if (typeof format === 'function') {
    return format(date);
  }

  return format;
}

function ordinalNumber$e(dirtyNumber) {
  var number = Number(dirtyNumber);
  return String(number).concat('.');
}

var eraValues$e = {
  narrow: ['пр.н.е.', 'АД'],
  abbreviated: ['пр. Хр.', 'по. Хр.'],
  wide: ['Пре Христа', 'После Христа']
};
var monthValues$e = {
  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
  abbreviated: ['јан', 'феб', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'сеп', 'окт', 'нов', 'дец'],
  wide: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар']
};
var formattingMonthValues$3 = {
  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
  abbreviated: ['јан', 'феб', 'мар', 'апр', 'мај', 'јун', 'јул', 'авг', 'сеп', 'окт', 'нов', 'дец'],
  wide: ['јануар', 'фебруар', 'март', 'април', 'мај', 'јун', 'јул', 'август', 'септембар', 'октобар', 'новембар', 'децембар']
};
var quarterValues$e = {
  narrow: ['1.', '2.', '3.', '4.'],
  abbreviated: ['1. кв.', '2. кв.', '3. кв.', '4. кв.'],
  wide: ['1. квартал', '2. квартал', '3. квартал', '4. квартал']
};
var dayValues$e = {
  narrow: ['Н', 'П', 'У', 'С', 'Ч', 'П', 'С'],
  short: ['нед', 'пон', 'уто', 'сре', 'чет', 'пет', 'суб'],
  abbreviated: ['нед', 'пон', 'уто', 'сре', 'чет', 'пет', 'суб'],
  wide: ['недеља', 'понедељак', 'уторак', 'среда', 'четвртак', 'петак', 'субота']
};
var formattingDayPeriodValues$e = {
  narrow: {
    am: 'АМ',
    pm: 'ПМ',
    midnight: 'поноћ',
    noon: 'подне',
    morning: 'ујутру',
    afternoon: 'поподне',
    evening: 'увече',
    night: 'ноћу'
  },
  abbreviated: {
    am: 'АМ',
    pm: 'ПМ',
    midnight: 'поноћ',
    noon: 'подне',
    morning: 'ујутру',
    afternoon: 'поподне',
    evening: 'увече',
    night: 'ноћу'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'поноћ',
    noon: 'подне',
    morning: 'ујутру',
    afternoon: 'после подне',
    evening: 'увече',
    night: 'ноћу'
  }
};
var dayPeriodValues$e = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'поноћ',
    noon: 'подне',
    morning: 'ујутру',
    afternoon: 'поподне',
    evening: 'увече',
    night: 'ноћу'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'поноћ',
    noon: 'подне',
    morning: 'ујутру',
    afternoon: 'поподне',
    evening: 'увече',
    night: 'ноћу'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'поноћ',
    noon: 'подне',
    morning: 'ујутру',
    afternoon: 'после подне',
    evening: 'увече',
    night: 'ноћу'
  }
};
var localize$s = {
  ordinalNumber: ordinalNumber$e,
  era: buildLocalizeFn({
    values: eraValues$e,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$e,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$e,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$3,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$e,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$e,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$e,
    defaultFormattingWidth: 'wide'
  })
};
var localize$t = localize$s;

var matchOrdinalNumberPattern$e = /^(\d+)\./i;
var parseOrdinalNumberPattern$e = /\d+/i;
var matchEraPatterns$e = {
  narrow: /^(пр\.н\.е\.|АД)/i,
  abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
  wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var parseEraPatterns$e = {
  any: [/^пр/i, /^(по|нова)/i]
};
var matchQuarterPatterns$e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?кв\.?/i,
  wide: /^[1234]\. квартал/i
};
var parseQuarterPatterns$e = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$e = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
  wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var parseMonthPatterns$e = {
  narrow: [/(10|11|12|[123456789])/i],
  any: [/^ја/i, /^ф/i, /^мар/i, /^ап/i, /^мај/i, /^јун/i, /^јул/i, /^авг/i, /^с/i, /^о/i, /^н/i, /^д/i]
};
var matchDayPatterns$e = {
  narrow: /^[пусчн]/i,
  short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var parseDayPatterns$e = {
  narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^н/i],
  any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i]
};
var matchDayPeriodPatterns$e = {
  any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var parseDayPeriodPatterns$e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^поно/i,
    noon: /^под/i,
    morning: /ујутру/i,
    afternoon: /(после\s|по)+подне/i,
    evening: /(увече)/i,
    night: /(ноћу)/i
  }
};
var match$s = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$e,
    parsePattern: parseOrdinalNumberPattern$e,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$e,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$e,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$e,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$e,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$e,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$e,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$e,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$e,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$e,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$e,
    defaultParseWidth: 'any'
  })
};
var match$t = match$s;

/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */

var locale$s = {
  code: 'sr',
  formatDistance: formatDistance$f,
  formatLong: formatLong$t,
  formatRelative: formatRelative$f,
  localize: localize$t,
  match: match$t,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$t = locale$s;

var formatDistanceLocale$d = {
  lessThanXSeconds: {
    one: {
      standalone: 'manje od 1 sekunde',
      withPrepositionAgo: 'manje od 1 sekunde',
      withPrepositionIn: 'manje od 1 sekundu'
    },
    dual: 'manje od {{count}} sekunde',
    other: 'manje od {{count}} sekundi'
  },
  xSeconds: {
    one: {
      standalone: '1 sekunda',
      withPrepositionAgo: '1 sekunde',
      withPrepositionIn: '1 sekundu'
    },
    dual: '{{count}} sekunde',
    other: '{{count}} sekundi'
  },
  halfAMinute: 'pola minute',
  lessThanXMinutes: {
    one: {
      standalone: 'manje od 1 minute',
      withPrepositionAgo: 'manje od 1 minute',
      withPrepositionIn: 'manje od 1 minutu'
    },
    dual: 'manje od {{count}} minute',
    other: 'manje od {{count}} minuta'
  },
  xMinutes: {
    one: {
      standalone: '1 minuta',
      withPrepositionAgo: '1 minute',
      withPrepositionIn: '1 minutu'
    },
    dual: '{{count}} minute',
    other: '{{count}} minuta'
  },
  aboutXHours: {
    one: {
      standalone: 'oko 1 sat',
      withPrepositionAgo: 'oko 1 sat',
      withPrepositionIn: 'oko 1 sat'
    },
    dual: 'oko {{count}} sata',
    other: 'oko {{count}} sati'
  },
  xHours: {
    one: {
      standalone: '1 sat',
      withPrepositionAgo: '1 sat',
      withPrepositionIn: '1 sat'
    },
    dual: '{{count}} sata',
    other: '{{count}} sati'
  },
  xDays: {
    one: {
      standalone: '1 dan',
      withPrepositionAgo: '1 dan',
      withPrepositionIn: '1 dan'
    },
    dual: '{{count}} dana',
    other: '{{count}} dana'
  },
  aboutXWeeks: {
    one: {
      standalone: 'oko 1 nedelju',
      withPrepositionAgo: 'oko 1 nedelju',
      withPrepositionIn: 'oko 1 nedelju'
    },
    dual: 'oko {{count}} nedelje',
    other: 'oko {{count}} nedelje'
  },
  xWeeks: {
    one: {
      standalone: '1 nedelju',
      withPrepositionAgo: '1 nedelju',
      withPrepositionIn: '1 nedelju'
    },
    dual: '{{count}} nedelje',
    other: '{{count}} nedelje'
  },
  aboutXMonths: {
    one: {
      standalone: 'oko 1 mesec',
      withPrepositionAgo: 'oko 1 mesec',
      withPrepositionIn: 'oko 1 mesec'
    },
    dual: 'oko {{count}} meseca',
    other: 'oko {{count}} meseci'
  },
  xMonths: {
    one: {
      standalone: '1 mesec',
      withPrepositionAgo: '1 mesec',
      withPrepositionIn: '1 mesec'
    },
    dual: '{{count}} meseca',
    other: '{{count}} meseci'
  },
  aboutXYears: {
    one: {
      standalone: 'oko 1 godinu',
      withPrepositionAgo: 'oko 1 godinu',
      withPrepositionIn: 'oko 1 godinu'
    },
    dual: 'oko {{count}} godine',
    other: 'oko {{count}} godina'
  },
  xYears: {
    one: {
      standalone: '1 godina',
      withPrepositionAgo: '1 godine',
      withPrepositionIn: '1 godinu'
    },
    dual: '{{count}} godine',
    other: '{{count}} godina'
  },
  overXYears: {
    one: {
      standalone: 'preko 1 godinu',
      withPrepositionAgo: 'preko 1 godinu',
      withPrepositionIn: 'preko 1 godinu'
    },
    dual: 'preko {{count}} godine',
    other: 'preko {{count}} godina'
  },
  almostXYears: {
    one: {
      standalone: 'gotovo 1 godinu',
      withPrepositionAgo: 'gotovo 1 godinu',
      withPrepositionIn: 'gotovo 1 godinu'
    },
    dual: 'gotovo {{count}} godine',
    other: 'gotovo {{count}} godina'
  }
};
function formatDistance$e(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$d[token] === 'string') {
    result = formatDistanceLocale$d[token];
  } else if (count === 1) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        result = formatDistanceLocale$d[token].one.withPrepositionIn;
      } else {
        result = formatDistanceLocale$d[token].one.withPrepositionAgo;
      }
    } else {
      result = formatDistanceLocale$d[token].one.standalone;
    }
  } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
  String(count).substr(-2, 1) !== '1' // unless the 2nd to last digit is "1"
  ) {
      result = formatDistanceLocale$d[token].dual.replace('{{count}}', count);
    } else {
    result = formatDistanceLocale$d[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'za ' + result;
    } else {
      return 'pre ' + result;
    }
  }

  return result;
}

var dateFormats$d = {
  full: 'EEEE, d. MMMM yyyy.',
  long: 'd. MMMM yyyy.',
  medium: 'd. MMM yy.',
  short: 'dd. MM. yy.'
};
var timeFormats$d = {
  full: 'HH:mm:ss (zzzz)',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$d = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$q = {
  date: buildFormatLongFn({
    formats: dateFormats$d,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$d,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$d,
    defaultWidth: 'full'
  })
};
var formatLong$r = formatLong$q;

var formatRelativeLocale$d = {
  lastWeek: function (date) {
    var day = date.getUTCDay();

    switch (day) {
      case 0:
        return "'prošle nedelje u' p";

      case 3:
        return "'prošle srede u' p";

      case 6:
        return "'prošle subote u' p";

      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: function (date) {
    var day = date.getUTCDay();

    switch (day) {
      case 0:
        return "'sledeće nedelje u' p";

      case 3:
        return "'sledeću sredu u' p";

      case 6:
        return "'sledeću subotu u' p";

      default:
        return "'sledeći' EEEE 'u' p";
    }
  },
  other: 'P'
};
function formatRelative$e(token, date, _baseDate, _options) {
  var format = formatRelativeLocale$d[token];

  if (typeof format === 'function') {
    return format(date);
  }

  return format;
}

function ordinalNumber$d(dirtyNumber) {
  var number = Number(dirtyNumber);
  return String(number).concat('.');
}

var eraValues$d = {
  narrow: ['pr.n.e.', 'AD'],
  abbreviated: ['pr. Hr.', 'po. Hr.'],
  wide: ['Pre Hrista', 'Posle Hrista']
};
var monthValues$d = {
  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
};
var formattingMonthValues$2 = {
  narrow: ['1.', '2.', '3.', '4.', '5.', '6.', '7.', '8.', '9.', '10.', '11.', '12.'],
  abbreviated: ['jan', 'feb', 'mar', 'apr', 'maj', 'jun', 'jul', 'avg', 'sep', 'okt', 'nov', 'dec'],
  wide: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar']
};
var quarterValues$d = {
  narrow: ['1.', '2.', '3.', '4.'],
  abbreviated: ['1. kv.', '2. kv.', '3. kv.', '4. kv.'],
  wide: ['1. kvartal', '2. kvartal', '3. kvartal', '4. kvartal']
};
var dayValues$d = {
  narrow: ['N', 'P', 'U', 'S', 'Č', 'P', 'S'],
  short: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
  abbreviated: ['ned', 'pon', 'uto', 'sre', 'čet', 'pet', 'sub'],
  wide: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota']
};
var formattingDayPeriodValues$d = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'popodne',
    evening: 'uveče',
    night: 'noću'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'popodne',
    evening: 'uveče',
    night: 'noću'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'posle podne',
    evening: 'uveče',
    night: 'noću'
  }
};
var dayPeriodValues$d = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'popodne',
    evening: 'uveče',
    night: 'noću'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'popodne',
    evening: 'uveče',
    night: 'noću'
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'ponoć',
    noon: 'podne',
    morning: 'ujutru',
    afternoon: 'posle podne',
    evening: 'uveče',
    night: 'noću'
  }
};
var localize$q = {
  ordinalNumber: ordinalNumber$d,
  era: buildLocalizeFn({
    values: eraValues$d,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$d,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$d,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$2,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$d,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$d,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$d,
    defaultFormattingWidth: 'wide'
  })
};
var localize$r = localize$q;

var matchOrdinalNumberPattern$d = /^(\d+)\./i;
var parseOrdinalNumberPattern$d = /\d+/i;
var matchEraPatterns$d = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var parseEraPatterns$d = {
  any: [/^pr/i, /^(po|nova)/i]
};
var matchQuarterPatterns$d = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
};
var parseQuarterPatterns$d = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$d = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var parseMonthPatterns$d = {
  narrow: [/(10|11|12|[123456789])/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^avg/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$d = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var parseDayPatterns$d = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$d = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var parseDayPeriodPatterns$d = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
};
var match$q = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$d,
    parsePattern: parseOrdinalNumberPattern$d,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$d,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$d,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$d,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$d,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$d,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$d,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$d,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$d,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$d,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$d,
    defaultParseWidth: 'any'
  })
};
var match$r = match$q;

/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */

var locale$q = {
  code: 'sr-Latn',
  formatDistance: formatDistance$e,
  formatLong: formatLong$r,
  formatRelative: formatRelative$e,
  localize: localize$r,
  match: match$r,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$r = locale$q;

var formatDistanceLocale$c = {
  lessThanXSeconds: {
    singular: 'mindre än en sekund',
    plural: 'mindre än {{count}} sekunder'
  },
  xSeconds: {
    singular: 'en sekund',
    plural: '{{count}} sekunder'
  },
  halfAMinute: 'en halv minut',
  lessThanXMinutes: {
    singular: 'mindre än en minut',
    plural: 'mindre än {{count}} minuter'
  },
  xMinutes: {
    singular: 'en minut',
    plural: '{{count}} minuter'
  },
  aboutXHours: {
    singular: 'ungefär en timme',
    plural: 'ungefär {{count}} timmar'
  },
  xHours: {
    singular: 'en timme',
    plural: '{{count}} timmar'
  },
  xDays: {
    singular: 'en dag',
    plural: '{{count}} dagar'
  },
  aboutXWeeks: {
    singular: 'ungefär en vecka',
    plural: 'ungefär {{count}} vecka'
  },
  xWeeks: {
    singular: 'en vecka',
    plural: '{{count}} vecka'
  },
  aboutXMonths: {
    singular: 'ungefär en månad',
    plural: 'ungefär {{count}} månader'
  },
  xMonths: {
    singular: 'en månad',
    plural: '{{count}} månader'
  },
  aboutXYears: {
    singular: 'ungefär ett år',
    plural: 'ungefär {{count}} år'
  },
  xYears: {
    singular: 'ett år',
    plural: '{{count}} år'
  },
  overXYears: {
    singular: 'över ett år',
    plural: 'över {{count}} år'
  },
  almostXYears: {
    singular: 'nästan ett år',
    plural: 'nästan {{count}} år'
  }
};
var wordMapping = ['noll', 'en', 'två', 'tre', 'fyra', 'fem', 'sex', 'sju', 'åtta', 'nio', 'tio', 'elva', 'tolv'];
function formatDistance$d(token, count, options) {
  options = options || {
    onlyNumeric: false
  };
  var translation = formatDistanceLocale$c[token];
  var result;

  if (typeof translation === 'string') {
    result = translation;
  } else if (count === 0 || count > 1) {
    if (options.onlyNumeric) {
      result = translation.plural.replace('{{count}}', count);
    } else {
      result = translation.plural.replace('{{count}}', count < 13 ? wordMapping[count] : count);
    }
  } else {
    result = translation.singular;
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'om ' + result;
    } else {
      return result + ' sedan';
    }
  }

  return result;
}

var dateFormats$c = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'y-MM-dd'
};
var timeFormats$c = {
  full: "'kl'. HH:mm:ss zzzz",
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$c = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$o = {
  date: buildFormatLongFn({
    formats: dateFormats$c,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$c,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$c,
    defaultWidth: 'full'
  })
};
var formatLong$p = formatLong$o;

var formatRelativeLocale$c = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: 'P'
};
function formatRelative$d(token, _date, _baseDate, _options) {
  return formatRelativeLocale$c[token];
}

var eraValues$c = {
  narrow: ['f.Kr.', 'e.Kr.'],
  abbreviated: ['f.Kr.', 'e.Kr.'],
  wide: ['före Kristus', 'efter Kristus']
};
var quarterValues$c = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1:a kvartalet', '2:a kvartalet', '3:e kvartalet', '4:e kvartalet']
};
var monthValues$c = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mars', 'apr.', 'maj', 'juni', 'juli', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'mars', 'april', 'maj', 'juni', 'juli', 'augusti', 'september', 'oktober', 'november', 'december']
};
var dayValues$c = {
  narrow: ['S', 'M', 'T', 'O', 'T', 'F', 'L'],
  short: ['sö', 'må', 'ti', 'on', 'to', 'fr', 'lö'],
  abbreviated: ['sön', 'mån', 'tis', 'ons', 'tors', 'fre', 'lör'],
  wide: ['söndag', 'måndag', 'tisdag', 'onsdag', 'torsdag', 'fredag', 'lördag']
}; // https://www.unicode.org/cldr/charts/32/summary/sv.html#1888

var dayPeriodValues$c = {
  narrow: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morg.',
    afternoon: 'efterm.',
    evening: 'kväll',
    night: 'natt'
  },
  abbreviated: {
    am: 'f.m.',
    pm: 'e.m.',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morgon',
    afternoon: 'efterm.',
    evening: 'kväll',
    night: 'natt'
  },
  wide: {
    am: 'förmiddag',
    pm: 'eftermiddag',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'morgon',
    afternoon: 'eftermiddag',
    evening: 'kväll',
    night: 'natt'
  }
};
var formattingDayPeriodValues$c = {
  narrow: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på efterm.',
    evening: 'på kvällen',
    night: 'på natten'
  },
  abbreviated: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morg.',
    afternoon: 'på efterm.',
    evening: 'på kvällen',
    night: 'på natten'
  },
  wide: {
    am: 'fm',
    pm: 'em',
    midnight: 'midnatt',
    noon: 'middag',
    morning: 'på morgonen',
    afternoon: 'på eftermiddagen',
    evening: 'på kvällen',
    night: 'på natten'
  }
};

function ordinalNumber$c(dirtyNumber) {
  var number = Number(dirtyNumber);
  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
      case 2:
        return number + ':a';
    }
  }

  return number + ':e';
}

var localize$o = {
  ordinalNumber: ordinalNumber$c,
  era: buildLocalizeFn({
    values: eraValues$c,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$c,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$c,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$c,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$c,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$c,
    defaultFormattingWidth: 'wide'
  })
};
var localize$p = localize$o;

var matchOrdinalNumberPattern$c = /^(\d+)(:a|:e)?/i;
var parseOrdinalNumberPattern$c = /\d+/i;
var matchEraPatterns$c = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var parseEraPatterns$c = {
  any: [/^f/i, /^[ev]/i]
};
var matchQuarterPatterns$c = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
};
var parseQuarterPatterns$c = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$c = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var parseMonthPatterns$c = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$c = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var parseDayPatterns$c = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
};
var matchDayPeriodPatterns$c = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var parseDayPeriodPatterns$c = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
};
var match$o = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$c,
    parsePattern: parseOrdinalNumberPattern$c,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$c,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$c,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$c,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$c,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$c,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$c,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$c,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$c,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$c,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$c,
    defaultParseWidth: 'any'
  })
};
var match$p = match$o;

/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */

var locale$o = {
  code: 'sv',
  formatDistance: formatDistance$d,
  formatLong: formatLong$p,
  formatRelative: formatRelative$d,
  localize: localize$p,
  match: match$p,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$p = locale$o;

var formatDistanceLocale$b = {
  lessThanXSeconds: {
    one: {
      default: 'ஒரு வினாடிக்கு குறைவாக',
      in: 'ஒரு வினாடிக்குள்',
      ago: 'ஒரு வினாடிக்கு முன்பு'
    },
    other: {
      default: '{{count}} வினாடிகளுக்கு குறைவாக',
      in: '{{count}} வினாடிகளுக்குள்',
      ago: '{{count}} வினாடிகளுக்கு முன்பு'
    }
  },
  xSeconds: {
    one: {
      default: '1 வினாடி',
      in: '1 வினாடியில்',
      ago: '1 வினாடி முன்பு'
    },
    other: {
      default: '{{count}} விநாடிகள்',
      in: '{{count}} வினாடிகளில்',
      ago: '{{count}} விநாடிகளுக்கு முன்பு'
    }
  },
  halfAMinute: {
    default: 'அரை நிமிடம்',
    in: 'அரை நிமிடத்தில்',
    ago: 'அரை நிமிடம் முன்பு'
  },
  lessThanXMinutes: {
    one: {
      default: 'ஒரு நிமிடத்திற்கும் குறைவாக',
      in: 'ஒரு நிமிடத்திற்குள்',
      ago: 'ஒரு நிமிடத்திற்கு முன்பு'
    },
    other: {
      default: '{{count}} நிமிடங்களுக்கும் குறைவாக',
      in: '{{count}} நிமிடங்களுக்குள்',
      ago: '{{count}} நிமிடங்களுக்கு முன்பு'
    }
  },
  xMinutes: {
    one: {
      default: '1 நிமிடம்',
      in: '1 நிமிடத்தில்',
      ago: '1 நிமிடம் முன்பு'
    },
    other: {
      default: '{{count}} நிமிடங்கள்',
      in: '{{count}} நிமிடங்களில்',
      ago: '{{count}} நிமிடங்களுக்கு முன்பு'
    }
  },
  aboutXHours: {
    one: {
      default: 'சுமார் 1 மணி நேரம்',
      in: 'சுமார் 1 மணி நேரத்தில்',
      ago: 'சுமார் 1 மணி நேரத்திற்கு முன்பு'
    },
    other: {
      default: 'சுமார் {{count}} மணி நேரம்',
      in: 'சுமார் {{count}} மணி நேரத்திற்கு முன்பு',
      ago: 'சுமார் {{count}} மணி நேரத்தில்'
    }
  },
  xHours: {
    one: {
      default: '1 மணி நேரம்',
      in: '1 மணி நேரத்தில்',
      ago: '1 மணி நேரத்திற்கு முன்பு'
    },
    other: {
      default: '{{count}} மணி நேரம்',
      in: '{{count}} மணி நேரத்தில்',
      ago: '{{count}} மணி நேரத்திற்கு முன்பு'
    }
  },
  xDays: {
    one: {
      default: '1 நாள்',
      in: '1 நாளில்',
      ago: '1 நாள் முன்பு'
    },
    other: {
      default: '{{count}} நாட்கள்',
      in: '{{count}} நாட்களில்',
      ago: '{{count}} நாட்களுக்கு முன்பு'
    }
  },
  aboutXWeeks: {
    one: {
      default: 'சுமார் 1 வாரம்',
      in: 'சுமார் 1 வாரத்தில்',
      ago: 'சுமார் 1 வாரம் முன்பு'
    },
    other: {
      default: 'சுமார் {{count}} வாரங்கள்',
      in: 'சுமார் {{count}} வாரங்களில்',
      ago: 'சுமார் {{count}} வாரங்களுக்கு முன்பு'
    }
  },
  xWeeks: {
    one: {
      default: '1 வாரம்',
      in: '1 வாரத்தில்',
      ago: '1 வாரம் முன்பு'
    },
    other: {
      default: '{{count}} வாரங்கள்',
      in: '{{count}} வாரங்களில்',
      ago: '{{count}} வாரங்களுக்கு முன்பு'
    }
  },
  aboutXMonths: {
    one: {
      default: 'சுமார் 1 மாதம்',
      in: 'சுமார் 1 மாதத்தில்',
      ago: 'சுமார் 1 மாதத்திற்கு முன்பு'
    },
    other: {
      default: 'சுமார் {{count}} மாதங்கள்',
      in: 'சுமார் {{count}} மாதங்களில்',
      ago: 'சுமார் {{count}} மாதங்களுக்கு முன்பு'
    }
  },
  xMonths: {
    one: {
      default: '1 மாதம்',
      in: '1 மாதத்தில்',
      ago: '1 மாதம் முன்பு'
    },
    other: {
      default: '{{count}} மாதங்கள்',
      in: '{{count}} மாதங்களில்',
      ago: '{{count}} மாதங்களுக்கு முன்பு'
    }
  },
  aboutXYears: {
    one: {
      default: 'சுமார் 1 வருடம்',
      in: 'சுமார் 1 ஆண்டில்',
      ago: 'சுமார் 1 வருடம் முன்பு'
    },
    other: {
      default: 'சுமார் {{count}} ஆண்டுகள்',
      in: 'சுமார் {{count}} ஆண்டுகளில்',
      ago: 'சுமார் {{count}} ஆண்டுகளுக்கு முன்பு'
    }
  },
  xYears: {
    one: {
      default: '1 வருடம்',
      in: '1 ஆண்டில்',
      ago: '1 வருடம் முன்பு'
    },
    other: {
      default: '{{count}} ஆண்டுகள்',
      in: '{{count}} ஆண்டுகளில்',
      ago: '{{count}} ஆண்டுகளுக்கு முன்பு'
    }
  },
  overXYears: {
    one: {
      default: '1 வருடத்திற்கு மேல்',
      in: '1 வருடத்திற்கும் மேலாக',
      ago: '1 வருடம் முன்பு'
    },
    other: {
      default: '{{count}} ஆண்டுகளுக்கும் மேலாக',
      in: '{{count}} ஆண்டுகளில்',
      ago: '{{count}} ஆண்டுகளுக்கு முன்பு'
    }
  },
  almostXYears: {
    one: {
      default: 'கிட்டத்தட்ட 1 வருடம்',
      in: 'கிட்டத்தட்ட 1 ஆண்டில்',
      ago: 'கிட்டத்தட்ட 1 வருடம் முன்பு'
    },
    other: {
      default: 'கிட்டத்தட்ட {{count}} ஆண்டுகள்',
      in: 'கிட்டத்தட்ட {{count}} ஆண்டுகளில்',
      ago: 'கிட்டத்தட்ட {{count}} ஆண்டுகளுக்கு முன்பு'
    }
  }
};

function getFormatDistanceLocaleWithSuffix(resultObj, options) {
  if (options.addSuffix) {
    if (options.comparison > 0) {
      return resultObj.in;
    } else {
      return resultObj.ago;
    }
  }

  return resultObj.default;
}

function formatDistance$c(token, count) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var result;

  if (formatDistanceLocale$b[token].default) {
    result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale$b[token], options);
  } else if (count === 1) {
    result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale$b[token].one, options);
  } else {
    result = getFormatDistanceLocaleWithSuffix(formatDistanceLocale$b[token].other, options);
  }

  return result.replace('{{count}}', count);
}

// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html

var dateFormats$b = {
  full: 'EEEE, d MMMM, y',
  long: 'd MMMM, y',
  medium: 'd MMM, y',
  short: 'd/M/yy'
}; // CLDR #1850 - #1853

var timeFormats$b = {
  full: 'a h:mm:ss zzzz',
  long: 'a h:mm:ss z',
  medium: 'a h:mm:ss',
  short: 'a h:mm'
};
var dateTimeFormats$b = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$m = {
  date: buildFormatLongFn({
    formats: dateFormats$b,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$b,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$b,
    defaultWidth: 'full'
  })
};
var formatLong$n = formatLong$m;

var formatRelativeLocale$b = {
  lastWeek: "'கடந்த' eeee p 'மணிக்கு'",
  yesterday: "'நேற்று ' p 'மணிக்கு'",
  today: "'இன்று ' p 'மணிக்கு'",
  tomorrow: "'நாளை ' p 'மணிக்கு'",
  nextWeek: "eeee p 'மணிக்கு'",
  other: 'P'
};
function formatRelative$c(token, _date, _baseDate, _options) {
  return formatRelativeLocale$b[token];
}

// Ref: https://www.unicode.org/cldr/charts/32/summary/ta.html
var eraValues$b = {
  narrow: ['கி.மு.', 'கி.பி.'],
  abbreviated: ['கி.மு.', 'கி.பி.'],
  // CLDR #1624, #1626
  wide: ['கிறிஸ்துவுக்கு முன்', 'அன்னோ டோமினி'] // CLDR #1620, #1622

};
var quarterValues$b = {
  // CLDR #1644 - #1647
  narrow: ['1', '2', '3', '4'],
  // CLDR #1636 - #1639
  abbreviated: ['காலா.1', 'காலா.2', 'காலா.3', 'காலா.4'],
  // CLDR #1628 - #1631
  wide: ['ஒன்றாம் காலாண்டு', 'இரண்டாம் காலாண்டு', 'மூன்றாம் காலாண்டு', 'நான்காம் காலாண்டு']
};
var monthValues$b = {
  // CLDR #700 - #711
  narrow: ['ஜ', 'பி', 'மா', 'ஏ', 'மே', 'ஜூ', 'ஜூ', 'ஆ', 'செ', 'அ', 'ந', 'டி'],
  // CLDR #1676 - #1687
  abbreviated: ['ஜன.', 'பிப்.', 'மார்.', 'ஏப்.', 'மே', 'ஜூன்', 'ஜூலை', 'ஆக.', 'செப்.', 'அக்.', 'நவ.', 'டிச.'],
  // CLDR #1652 - #1663
  wide: ['ஜனவரி', // January
  'பிப்ரவரி', // February
  'மார்ச்', // March
  'ஏப்ரல்', // April
  'மே', // May
  'ஜூன்', // June
  'ஜூலை', // July
  'ஆகஸ்ட்', // August
  'செப்டம்பர்', // September
  'அக்டோபர்', // October
  'நவம்பர்', // November
  'டிசம்பர்' // December
  ]
};
var dayValues$b = {
  // CLDR #1766 - #1772
  narrow: ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'],
  // CLDR #1752 - #1758
  short: ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'],
  // CLDR #1738 - #1744
  abbreviated: ['ஞாயி.', 'திங்.', 'செவ்.', 'புத.', 'வியா.', 'வெள்.', 'சனி'],
  // CLDR #1724 - #1730
  wide: ['ஞாயிறு', // Sunday
  'திங்கள்', // Monday
  'செவ்வாய்', // Tuesday
  'புதன்', // Wednesday
  'வியாழன்', // Thursday
  'வெள்ளி', // Friday
  'சனி' // Saturday
  ]
}; // CLDR #1780 - #1845

var dayPeriodValues$b = {
  narrow: {
    am: 'மு.ப',
    pm: 'பி.ப',
    midnight: 'நள்.',
    noon: 'நண்.',
    morning: 'கா.',
    afternoon: 'மதி.',
    evening: 'மா.',
    night: 'இர.'
  },
  abbreviated: {
    am: 'முற்பகல்',
    pm: 'பிற்பகல்',
    midnight: 'நள்ளிரவு',
    noon: 'நண்பகல்',
    morning: 'காலை',
    afternoon: 'மதியம்',
    evening: 'மாலை',
    night: 'இரவு'
  },
  wide: {
    am: 'முற்பகல்',
    pm: 'பிற்பகல்',
    midnight: 'நள்ளிரவு',
    noon: 'நண்பகல்',
    morning: 'காலை',
    afternoon: 'மதியம்',
    evening: 'மாலை',
    night: 'இரவு'
  }
}; // CLDR #1780 - #1845

var formattingDayPeriodValues$b = {
  narrow: {
    am: 'மு.ப',
    pm: 'பி.ப',
    midnight: 'நள்.',
    noon: 'நண்.',
    morning: 'கா.',
    afternoon: 'மதி.',
    evening: 'மா.',
    night: 'இர.'
  },
  abbreviated: {
    am: 'முற்பகல்',
    pm: 'பிற்பகல்',
    midnight: 'நள்ளிரவு',
    noon: 'நண்பகல்',
    morning: 'காலை',
    afternoon: 'மதியம்',
    evening: 'மாலை',
    night: 'இரவு'
  },
  wide: {
    am: 'முற்பகல்',
    pm: 'பிற்பகல்',
    midnight: 'நள்ளிரவு',
    noon: 'நண்பகல்',
    morning: 'காலை',
    afternoon: 'மதியம்',
    evening: 'மாலை',
    night: 'இரவு'
  }
};

function ordinalNumber$b(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'
  // var rem100 = number % 100
  // if (rem100 > 20 || rem100 < 10) {
  //   switch (rem100 % 10) {
  //     case 1:
  //       return number + 'st'
  //     case 2:
  //       return number + 'nd'
  //     case 3:
  //       return number + 'rd'
  //   }
  // }
  // return number + 'th'

  return number;
}

var localize$m = {
  ordinalNumber: ordinalNumber$b,
  era: buildLocalizeFn({
    values: eraValues$b,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$b,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$b,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$b,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$b,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$b,
    defaultFormattingWidth: 'wide'
  })
};
var localize$n = localize$m;

var matchOrdinalNumberPattern$b = /^(\d+)(வது)?/i;
var parseOrdinalNumberPattern$b = /\d+/i;
var matchEraPatterns$b = {
  narrow: /^(கி.மு.|கி.பி.)/i,
  abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
  wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var parseEraPatterns$b = {
  any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/]
};
var matchQuarterPatterns$b = {
  narrow: /^[1234]/i,
  abbreviated: /^காலா.[1234]/i,
  wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var parseQuarterPatterns$b = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/(1|காலா.1|ஒன்றாம்)/i, /(2|காலா.2|இரண்டாம்)/i, /(3|காலா.3|மூன்றாம்)/i, /(4|காலா.4|நான்காம்)/i]
};
var matchMonthPatterns$b = {
  narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
  abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
  wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var parseMonthPatterns$b = {
  narrow: [/^ஜ$/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூ/i, /^ஜூ/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i],
  any: [/^ஜன/i, /^பி/i, /^மா/i, /^ஏ/i, /^மே/i, /^ஜூன்/i, /^ஜூலை/i, /^ஆ/i, /^செ/i, /^அ/i, /^ந/i, /^டி/i]
};
var matchDayPatterns$b = {
  narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
  wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var parseDayPatterns$b = {
  narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
  any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i]
};
var matchDayPeriodPatterns$b = {
  narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
  any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var parseDayPeriodPatterns$b = {
  any: {
    am: /^மு/i,
    pm: /^பி/i,
    midnight: /^நள்/i,
    noon: /^நண்/i,
    morning: /காலை/i,
    afternoon: /மதியம்/i,
    evening: /மாலை/i,
    night: /இரவு/i
  }
};
var match$m = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$b,
    parsePattern: parseOrdinalNumberPattern$b,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$b,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$b,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$b,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$b,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$b,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$b,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$b,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$b,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$b,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$b,
    defaultParseWidth: 'any'
  })
};
var match$n = match$m;

/**
 * @type {Locale}
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
 */

var locale$m = {
  code: 'ta',
  formatDistance: formatDistance$c,
  formatLong: formatLong$n,
  formatRelative: formatRelative$c,
  localize: localize$n,
  match: match$n,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$n = locale$m;

// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var formatDistanceLocale$a = {
  lessThanXSeconds: {
    standalone: {
      one: 'సెకను కన్నా తక్కువ',
      other: '{{count}} సెకన్ల కన్నా తక్కువ'
    },
    withPreposition: {
      one: 'సెకను',
      other: '{{count}} సెకన్ల'
    }
  },
  xSeconds: {
    standalone: {
      one: 'ఒక సెకను',
      // CLDR #1314
      other: '{{count}} సెకన్ల'
    },
    withPreposition: {
      one: 'ఒక సెకను',
      other: '{{count}} సెకన్ల'
    }
  },
  halfAMinute: {
    standalone: 'అర నిమిషం',
    withPreposition: 'అర నిమిషం'
  },
  lessThanXMinutes: {
    standalone: {
      one: 'ఒక నిమిషం కన్నా తక్కువ',
      other: '{{count}} నిమిషాల కన్నా తక్కువ'
    },
    withPreposition: {
      one: 'ఒక నిమిషం',
      other: '{{count}} నిమిషాల'
    }
  },
  xMinutes: {
    standalone: {
      one: 'ఒక నిమిషం',
      // CLDR #1311
      other: '{{count}} నిమిషాలు'
    },
    withPreposition: {
      one: 'ఒక నిమిషం',
      // CLDR #1311
      other: '{{count}} నిమిషాల'
    }
  },
  aboutXHours: {
    standalone: {
      one: 'సుమారు ఒక గంట',
      other: 'సుమారు {{count}} గంటలు'
    },
    withPreposition: {
      one: 'సుమారు ఒక గంట',
      other: 'సుమారు {{count}} గంటల'
    }
  },
  xHours: {
    standalone: {
      one: 'ఒక గంట',
      // CLDR #1308
      other: '{{count}} గంటలు'
    },
    withPreposition: {
      one: 'ఒక గంట',
      other: '{{count}} గంటల'
    }
  },
  xDays: {
    standalone: {
      one: 'ఒక రోజు',
      // CLDR #1292
      other: '{{count}} రోజులు'
    },
    withPreposition: {
      one: 'ఒక రోజు',
      other: '{{count}} రోజుల'
    }
  },
  aboutXWeeks: {
    standalone: {
      one: 'సుమారు ఒక వారం',
      other: 'సుమారు {{count}} వారాలు'
    },
    withPreposition: {
      one: 'సుమారు ఒక వారం',
      other: 'సుమారు {{count}} వారాలల'
    }
  },
  xWeeks: {
    standalone: {
      one: 'ఒక వారం',
      other: '{{count}} వారాలు'
    },
    withPreposition: {
      one: 'ఒక వారం',
      other: '{{count}} వారాలల'
    }
  },
  aboutXMonths: {
    standalone: {
      one: 'సుమారు ఒక నెల',
      other: 'సుమారు {{count}} నెలలు'
    },
    withPreposition: {
      one: 'సుమారు ఒక నెల',
      other: 'సుమారు {{count}} నెలల'
    }
  },
  xMonths: {
    standalone: {
      one: 'ఒక నెల',
      // CLDR #1281
      other: '{{count}} నెలలు'
    },
    withPreposition: {
      one: 'ఒక నెల',
      other: '{{count}} నెలల'
    }
  },
  aboutXYears: {
    standalone: {
      one: 'సుమారు ఒక సంవత్సరం',
      other: 'సుమారు {{count}} సంవత్సరాలు'
    },
    withPreposition: {
      one: 'సుమారు ఒక సంవత్సరం',
      other: 'సుమారు {{count}} సంవత్సరాల'
    }
  },
  xYears: {
    standalone: {
      one: 'ఒక సంవత్సరం',
      // CLDR #1275
      other: '{{count}} సంవత్సరాలు'
    },
    withPreposition: {
      one: 'ఒక సంవత్సరం',
      other: '{{count}} సంవత్సరాల'
    }
  },
  overXYears: {
    standalone: {
      one: 'ఒక సంవత్సరం పైగా',
      other: '{{count}} సంవత్సరాలకు పైగా'
    },
    withPreposition: {
      one: 'ఒక సంవత్సరం',
      other: '{{count}} సంవత్సరాల'
    }
  },
  almostXYears: {
    standalone: {
      one: 'దాదాపు ఒక సంవత్సరం',
      other: 'దాదాపు {{count}} సంవత్సరాలు'
    },
    withPreposition: {
      one: 'దాదాపు ఒక సంవత్సరం',
      other: 'దాదాపు {{count}} సంవత్సరాల'
    }
  }
};
function formatDistance$b(token, count, options) {
  options = options || {};
  var usageGroup = options.addSuffix ? formatDistanceLocale$a[token].withPreposition : formatDistanceLocale$a[token].standalone;
  var result;

  if (typeof usageGroup === 'string') {
    result = usageGroup;
  } else if (count === 1) {
    result = usageGroup.one;
  } else {
    result = usageGroup.other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result + 'లో';
    } else {
      return result + ' క్రితం';
    }
  }

  return result;
}

// CLDR #1807 - #1811

var dateFormats$a = {
  full: 'd, MMMM y, EEEE',
  long: 'd MMMM, y',
  medium: 'd MMM, y',
  short: 'dd-MM-yy'
}; // CLDR #1807 - #1811

var timeFormats$a = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
}; // CLDR #1815 - #1818

var dateTimeFormats$a = {
  full: "{{date}} {{time}}'కి'",
  long: "{{date}} {{time}}'కి'",
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$k = {
  date: buildFormatLongFn({
    formats: dateFormats$a,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$a,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$a,
    defaultWidth: 'full'
  })
};
var formatLong$l = formatLong$k;

// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var formatRelativeLocale$a = {
  lastWeek: "'గత' eeee p",
  // CLDR #1384
  yesterday: "'నిన్న' p",
  // CLDR #1393
  today: "'ఈ రోజు' p",
  // CLDR #1394
  tomorrow: "'రేపు' p",
  // CLDR #1395
  nextWeek: "'తదుపరి' eeee p",
  // CLDR #1386
  other: 'P'
};
function formatRelative$b(token, _date, _baseDate, _options) {
  return formatRelativeLocale$a[token];
}

// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608

var eraValues$a = {
  narrow: ['క్రీ.పూ.', 'క్రీ.శ.'],
  abbreviated: ['క్రీ.పూ.', 'క్రీ.శ.'],
  wide: ['క్రీస్తు పూర్వం', 'క్రీస్తుశకం']
}; // CLDR #1613 - #1628

var quarterValues$a = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['త్రై1', 'త్రై2', 'త్రై3', 'త్రై4'],
  wide: ['1వ త్రైమాసికం', '2వ త్రైమాసికం', '3వ త్రైమాసికం', '4వ త్రైమాసికం']
}; // CLDR #1637 - #1708

var monthValues$a = {
  narrow: ['జ', 'ఫి', 'మా', 'ఏ', 'మే', 'జూ', 'జు', 'ఆ', 'సె', 'అ', 'న', 'డి'],
  abbreviated: ['జన', 'ఫిబ్ర', 'మార్చి', 'ఏప్రి', 'మే', 'జూన్', 'జులై', 'ఆగ', 'సెప్టెం', 'అక్టో', 'నవం', 'డిసెం'],
  wide: ['జనవరి', 'ఫిబ్రవరి', 'మార్చి', 'ఏప్రిల్', 'మే', 'జూన్', 'జులై', 'ఆగస్టు', 'సెప్టెంబర్', 'అక్టోబర్', 'నవంబర్', 'డిసెంబర్']
}; // CLDR #1709 - #1764

var dayValues$a = {
  narrow: ['ఆ', 'సో', 'మ', 'బు', 'గు', 'శు', 'శ'],
  short: ['ఆది', 'సోమ', 'మంగళ', 'బుధ', 'గురు', 'శుక్ర', 'శని'],
  abbreviated: ['ఆది', 'సోమ', 'మంగళ', 'బుధ', 'గురు', 'శుక్ర', 'శని'],
  wide: ['ఆదివారం', 'సోమవారం', 'మంగళవారం', 'బుధవారం', 'గురువారం', 'శుక్రవారం', 'శనివారం']
}; // CLDR #1767 - #1806

var dayPeriodValues$a = {
  narrow: {
    am: 'పూర్వాహ్నం',
    pm: 'అపరాహ్నం',
    midnight: 'అర్ధరాత్రి',
    noon: 'మిట్టమధ్యాహ్నం',
    morning: 'ఉదయం',
    afternoon: 'మధ్యాహ్నం',
    evening: 'సాయంత్రం',
    night: 'రాత్రి'
  },
  abbreviated: {
    am: 'పూర్వాహ్నం',
    pm: 'అపరాహ్నం',
    midnight: 'అర్ధరాత్రి',
    noon: 'మిట్టమధ్యాహ్నం',
    morning: 'ఉదయం',
    afternoon: 'మధ్యాహ్నం',
    evening: 'సాయంత్రం',
    night: 'రాత్రి'
  },
  wide: {
    am: 'పూర్వాహ్నం',
    pm: 'అపరాహ్నం',
    midnight: 'అర్ధరాత్రి',
    noon: 'మిట్టమధ్యాహ్నం',
    morning: 'ఉదయం',
    afternoon: 'మధ్యాహ్నం',
    evening: 'సాయంత్రం',
    night: 'రాత్రి'
  }
};
var formattingDayPeriodValues$a = {
  narrow: {
    am: 'పూర్వాహ్నం',
    pm: 'అపరాహ్నం',
    midnight: 'అర్ధరాత్రి',
    noon: 'మిట్టమధ్యాహ్నం',
    morning: 'ఉదయం',
    afternoon: 'మధ్యాహ్నం',
    evening: 'సాయంత్రం',
    night: 'రాత్రి'
  },
  abbreviated: {
    am: 'పూర్వాహ్నం',
    pm: 'అపరాహ్నం',
    midnight: 'అర్ధరాత్రి',
    noon: 'మిట్టమధ్యాహ్నం',
    morning: 'ఉదయం',
    afternoon: 'మధ్యాహ్నం',
    evening: 'సాయంత్రం',
    night: 'రాత్రి'
  },
  wide: {
    am: 'పూర్వాహ్నం',
    pm: 'అపరాహ్నం',
    midnight: 'అర్ధరాత్రి',
    noon: 'మిట్టమధ్యాహ్నం',
    morning: 'ఉదయం',
    afternoon: 'మధ్యాహ్నం',
    evening: 'సాయంత్రం',
    night: 'రాత్రి'
  }
};

function ordinalNumber$a(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);
  return number + 'వ';
}

var localize$k = {
  ordinalNumber: ordinalNumber$a,
  era: buildLocalizeFn({
    values: eraValues$a,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$a,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$a,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$a,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$a,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$a,
    defaultFormattingWidth: 'wide'
  })
};
var localize$l = localize$k;

var matchOrdinalNumberPattern$a = /^(\d+)(వ)?/i;
var parseOrdinalNumberPattern$a = /\d+/i;
var matchEraPatterns$a = {
  narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
  abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
  wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var parseEraPatterns$a = {
  any: [/^(పూ|శ)/i, /^సా/i]
};
var matchQuarterPatterns$a = {
  narrow: /^[1234]/i,
  abbreviated: /^త్రై[1234]/i,
  wide: /^[1234](వ)? త్రైమాసికం/i
};
var parseQuarterPatterns$a = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$a = {
  narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
  abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
  wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var parseMonthPatterns$a = {
  narrow: [/^జ/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూ/i, /^జు/i, /^ఆ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i],
  any: [/^జన/i, /^ఫి/i, /^మా/i, /^ఏ/i, /^మే/i, /^జూన్/i, /^జులై/i, /^ఆగ/i, /^సె/i, /^అ/i, /^న/i, /^డి/i]
};
var matchDayPatterns$a = {
  narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
  short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var parseDayPatterns$a = {
  narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
  any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i]
};
var matchDayPeriodPatterns$a = {
  narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
  any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var parseDayPeriodPatterns$a = {
  any: {
    am: /^పూర్వాహ్నం/i,
    pm: /^అపరాహ్నం/i,
    midnight: /^అర్ధ/i,
    noon: /^మిట్ట/i,
    morning: /ఉదయం/i,
    afternoon: /మధ్యాహ్నం/i,
    evening: /సాయంత్రం/i,
    night: /రాత్రి/i
  }
};
var match$k = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$a,
    parsePattern: parseOrdinalNumberPattern$a,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$a,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$a,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$a,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$a,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$a,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$a,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$a,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$a,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$a,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$a,
    defaultParseWidth: 'any'
  })
};
var match$l = match$k;

/**
 * @type {Locale}
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
 */

var locale$k = {
  code: 'te',
  formatDistance: formatDistance$b,
  formatLong: formatLong$l,
  formatRelative: formatRelative$b,
  localize: localize$l,
  match: match$l,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$l = locale$k;

var formatDistanceLocale$9 = {
  lessThanXSeconds: {
    one: 'น้อยกว่า 1 วินาที',
    other: 'น้อยกว่า {{count}} วินาที'
  },
  xSeconds: {
    one: '1 วินาที',
    other: '{{count}} วินาที'
  },
  halfAMinute: 'ครึ่งนาที',
  lessThanXMinutes: {
    one: 'น้อยกว่า 1 นาที',
    other: 'น้อยกว่า {{count}} นาที'
  },
  xMinutes: {
    one: '1 นาที',
    other: '{{count}} นาที'
  },
  aboutXHours: {
    one: 'ประมาณ 1 ชั่วโมง',
    other: 'ประมาณ {{count}} ชั่วโมง'
  },
  xHours: {
    one: '1 ชั่วโมง',
    other: '{{count}} ชั่วโมง'
  },
  xDays: {
    one: '1 วัน',
    other: '{{count}} วัน'
  },
  aboutXWeeks: {
    one: 'ประมาณ 1 สัปดาห์',
    other: 'ประมาณ {{count}} สัปดาห์'
  },
  xWeeks: {
    one: '1 สัปดาห์',
    other: '{{count}} สัปดาห์'
  },
  aboutXMonths: {
    one: 'ประมาณ 1 เดือน',
    other: 'ประมาณ {{count}} เดือน'
  },
  xMonths: {
    one: '1 เดือน',
    other: '{{count}} เดือน'
  },
  aboutXYears: {
    one: 'ประมาณ 1 ปี',
    other: 'ประมาณ {{count}} ปี'
  },
  xYears: {
    one: '1 ปี',
    other: '{{count}} ปี'
  },
  overXYears: {
    one: 'มากกว่า 1 ปี',
    other: 'มากกว่า {{count}} ปี'
  },
  almostXYears: {
    one: 'เกือบ 1 ปี',
    other: 'เกือบ {{count}} ปี'
  }
};
function formatDistance$a(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$9[token] === 'string') {
    result = formatDistanceLocale$9[token];
  } else if (count === 1) {
    result = formatDistanceLocale$9[token].one;
  } else {
    result = formatDistanceLocale$9[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      if (token === 'halfAMinute') {
        return 'ใน' + result;
      } else {
        return 'ใน ' + result;
      }
    } else {
      return result + 'ที่ผ่านมา';
    }
  }

  return result;
}

var dateFormats$9 = {
  full: 'วันEEEEที่ do MMMM y',
  long: 'do MMMM y',
  medium: 'd MMM y',
  short: 'dd/MM/yyyy'
};
var timeFormats$9 = {
  full: 'H:mm:ss น. zzzz',
  long: 'H:mm:ss น. z',
  medium: 'H:mm:ss น.',
  short: 'H:mm น.'
};
var dateTimeFormats$9 = {
  full: "{{date}} 'เวลา' {{time}}",
  long: "{{date}} 'เวลา' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$i = {
  date: buildFormatLongFn({
    formats: dateFormats$9,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$9,
    defaultWidth: 'medium'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$9,
    defaultWidth: 'full'
  })
};
var formatLong$j = formatLong$i;

var formatRelativeLocale$9 = {
  lastWeek: "eeee'ที่แล้วเวลา' p",
  yesterday: "'เมื่อวานนี้เวลา' p",
  today: "'วันนี้เวลา' p",
  tomorrow: "'พรุ่งนี้เวลา' p",
  nextWeek: "eeee 'เวลา' p",
  other: 'P'
};
function formatRelative$a(token, _date, _baseDate, _options) {
  return formatRelativeLocale$9[token];
}

var eraValues$9 = {
  narrow: ['B', 'คศ'],
  abbreviated: ['BC', 'ค.ศ.'],
  wide: ['ปีก่อนคริสตกาล', 'คริสต์ศักราช']
};
var quarterValues$9 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['ไตรมาสแรก', 'ไตรมาสที่สอง', 'ไตรมาสที่สาม', 'ไตรมาสที่สี่']
};
var dayValues$9 = {
  narrow: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  short: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  abbreviated: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
  wide: ['อาทิตย์', 'จันทร์', 'อังคาร', 'พุธ', 'พฤหัสบดี', 'ศุกร์', 'เสาร์']
};
var monthValues$9 = {
  narrow: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
  abbreviated: ['ม.ค.', 'ก.พ.', 'มี.ค.', 'เม.ย.', 'พ.ค.', 'มิ.ย.', 'ก.ค.', 'ส.ค.', 'ก.ย.', 'ต.ค.', 'พ.ย.', 'ธ.ค.'],
  wide: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม']
};
var dayPeriodValues$9 = {
  narrow: {
    am: 'ก่อนเที่ยง',
    pm: 'หลังเที่ยง',
    midnight: 'เที่ยงคืน',
    noon: 'เที่ยง',
    morning: 'เช้า',
    afternoon: 'บ่าย',
    evening: 'เย็น',
    night: 'กลางคืน'
  },
  abbreviated: {
    am: 'ก่อนเที่ยง',
    pm: 'หลังเที่ยง',
    midnight: 'เที่ยงคืน',
    noon: 'เที่ยง',
    morning: 'เช้า',
    afternoon: 'บ่าย',
    evening: 'เย็น',
    night: 'กลางคืน'
  },
  wide: {
    am: 'ก่อนเที่ยง',
    pm: 'หลังเที่ยง',
    midnight: 'เที่ยงคืน',
    noon: 'เที่ยง',
    morning: 'เช้า',
    afternoon: 'บ่าย',
    evening: 'เย็น',
    night: 'กลางคืน'
  }
};
var formattingDayPeriodValues$9 = {
  narrow: {
    am: 'ก่อนเที่ยง',
    pm: 'หลังเที่ยง',
    midnight: 'เที่ยงคืน',
    noon: 'เที่ยง',
    morning: 'ตอนเช้า',
    afternoon: 'ตอนกลางวัน',
    evening: 'ตอนเย็น',
    night: 'ตอนกลางคืน'
  },
  abbreviated: {
    am: 'ก่อนเที่ยง',
    pm: 'หลังเที่ยง',
    midnight: 'เที่ยงคืน',
    noon: 'เที่ยง',
    morning: 'ตอนเช้า',
    afternoon: 'ตอนกลางวัน',
    evening: 'ตอนเย็น',
    night: 'ตอนกลางคืน'
  },
  wide: {
    am: 'ก่อนเที่ยง',
    pm: 'หลังเที่ยง',
    midnight: 'เที่ยงคืน',
    noon: 'เที่ยง',
    morning: 'ตอนเช้า',
    afternoon: 'ตอนกลางวัน',
    evening: 'ตอนเย็น',
    night: 'ตอนกลางคืน'
  }
};

function ordinalNumber$9(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number;
}

var localize$i = {
  ordinalNumber: ordinalNumber$9,
  era: buildLocalizeFn({
    values: eraValues$9,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$9,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$9,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$9,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$9,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$9,
    defaultFormattingWidth: 'wide'
  })
};
var localize$j = localize$i;

var matchOrdinalNumberPattern$9 = /^\d+/i;
var parseOrdinalNumberPattern$9 = /\d+/i;
var matchEraPatterns$9 = {
  narrow: /^([bB]|[aA]|คศ)/i,
  abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
  wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var parseEraPatterns$9 = {
  any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
};
var matchQuarterPatterns$9 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var parseQuarterPatterns$9 = {
  any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
};
var matchMonthPatterns$9 = {
  narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
  abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
  wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var parseMonthPatterns$9 = {
  wide: [/^มก/i, /^กุม/i, /^มี/i, /^เม/i, /^พฤษ/i, /^มิ/i, /^กรก/i, /^ส/i, /^กัน/i, /^ต/i, /^พฤศ/i, /^ธ/i],
  any: [/^ม\.?ค\.?/i, /^ก\.?พ\.?/i, /^มี\.?ค\.?/i, /^เม\.?ย\.?/i, /^พ\.?ค\.?/i, /^มิ\.?ย\.?/i, /^ก\.?ค\.?/i, /^ส\.?ค\.?/i, /^ก\.?ย\.?/i, /^ต\.?ค\.?/i, /^พ\.?ย\.?/i, /^ธ\.?ค\.?/i]
};
var matchDayPatterns$9 = {
  narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var parseDayPatterns$9 = {
  wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
  any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
};
var matchDayPeriodPatterns$9 = {
  any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var parseDayPeriodPatterns$9 = {
  any: {
    am: /^ก่อนเที่ยง/i,
    pm: /^หลังเที่ยง/i,
    midnight: /^เที่ยงคืน/i,
    noon: /^เที่ยง/i,
    morning: /เช้า/i,
    afternoon: /บ่าย/i,
    evening: /เย็น/i,
    night: /กลางคืน/i
  }
};
var match$i = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$9,
    parsePattern: parseOrdinalNumberPattern$9,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$9,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$9,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$9,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$9,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$9,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$9,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$9,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$9,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$9,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$9,
    defaultParseWidth: 'any'
  })
};
var match$j = match$i;

/**
 * @type {Locale}
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
 * @author [@hawkup]{@link https://github.com/hawkup}
 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
 */

var locale$i = {
  code: 'th',
  formatDistance: formatDistance$a,
  formatLong: formatLong$j,
  formatRelative: formatRelative$a,
  localize: localize$j,
  match: match$j,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$j = locale$i;

var formatDistanceLocale$8 = {
  lessThanXSeconds: {
    one: 'bir saniyeden az',
    other: '{{count}} saniyeden az'
  },
  xSeconds: {
    one: '1 saniye',
    other: '{{count}} saniye'
  },
  halfAMinute: 'yarım dakika',
  lessThanXMinutes: {
    one: 'bir dakikadan az',
    other: '{{count}} dakikadan az'
  },
  xMinutes: {
    one: '1 dakika',
    other: '{{count}} dakika'
  },
  aboutXHours: {
    one: 'yaklaşık 1 saat',
    other: 'yaklaşık {{count}} saat'
  },
  xHours: {
    one: '1 saat',
    other: '{{count}} saat'
  },
  xDays: {
    one: '1 gün',
    other: '{{count}} gün'
  },
  aboutXWeeks: {
    one: 'yaklaşık 1 hafta',
    other: 'yaklaşık {{count}} hafta'
  },
  xWeeks: {
    one: '1 hafta',
    other: '{{count}} hafta'
  },
  aboutXMonths: {
    one: 'yaklaşık 1 ay',
    other: 'yaklaşık {{count}} ay'
  },
  xMonths: {
    one: '1 ay',
    other: '{{count}} ay'
  },
  aboutXYears: {
    one: 'yaklaşık 1 yıl',
    other: 'yaklaşık {{count}} yıl'
  },
  xYears: {
    one: '1 yıl',
    other: '{{count}} yıl'
  },
  overXYears: {
    one: '1 yıldan fazla',
    other: '{{count}} yıldan fazla'
  },
  almostXYears: {
    one: 'neredeyse 1 yıl',
    other: 'neredeyse {{count}} yıl'
  }
};

var formatDistance$8 = function (token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$8[token];

  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }

  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return result + ' sonra';
    } else {
      return result + ' önce';
    }
  }

  return result;
};

var formatDistance$9 = formatDistance$8;

var dateFormats$8 = {
  full: 'd MMMM y EEEE',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd.MM.yyyy'
};
var timeFormats$8 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$8 = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$g = {
  date: buildFormatLongFn({
    formats: dateFormats$8,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$8,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$8,
    defaultWidth: 'full'
  })
};
var formatLong$h = formatLong$g;

var formatRelativeLocale$8 = {
  lastWeek: "'geçen hafta' eeee 'saat' p",
  yesterday: "'dün saat' p",
  today: "'bugün saat' p",
  tomorrow: "'yarın saat' p",
  nextWeek: "eeee 'saat' p",
  other: 'P'
};

var formatRelative$8 = function (token, _date, _baseDate, _options) {
  return formatRelativeLocale$8[token];
};

var formatRelative$9 = formatRelative$8;

var eraValues$8 = {
  narrow: ['MÖ', 'MS'],
  abbreviated: ['MÖ', 'MS'],
  wide: ['Milattan Önce', 'Milattan Sonra']
};
var quarterValues$8 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1Ç', '2Ç', '3Ç', '4Ç'],
  wide: ['İlk çeyrek', 'İkinci Çeyrek', 'Üçüncü çeyrek', 'Son çeyrek']
};
var monthValues$8 = {
  narrow: ['O', 'Ş', 'M', 'N', 'M', 'H', 'T', 'A', 'E', 'E', 'K', 'A'],
  abbreviated: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
  wide: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık']
};
var dayValues$8 = {
  narrow: ['P', 'P', 'S', 'Ç', 'P', 'C', 'C'],
  short: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
  abbreviated: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cts'],
  wide: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi']
};
var dayPeriodValues$8 = {
  narrow: {
    am: 'öö',
    pm: 'ös',
    midnight: 'gy',
    noon: 'ö',
    morning: 'sa',
    afternoon: 'ös',
    evening: 'ak',
    night: 'ge'
  },
  abbreviated: {
    am: 'ÖÖ',
    pm: 'ÖS',
    midnight: 'gece yarısı',
    noon: 'öğle',
    morning: 'sabah',
    afternoon: 'öğleden sonra',
    evening: 'akşam',
    night: 'gece'
  },
  wide: {
    am: 'Ö.Ö.',
    pm: 'Ö.S.',
    midnight: 'gece yarısı',
    noon: 'öğle',
    morning: 'sabah',
    afternoon: 'öğleden sonra',
    evening: 'akşam',
    night: 'gece'
  }
};
var formattingDayPeriodValues$8 = {
  narrow: {
    am: 'öö',
    pm: 'ös',
    midnight: 'gy',
    noon: 'ö',
    morning: 'sa',
    afternoon: 'ös',
    evening: 'ak',
    night: 'ge'
  },
  abbreviated: {
    am: 'ÖÖ',
    pm: 'ÖS',
    midnight: 'gece yarısı',
    noon: 'öğlen',
    morning: 'sabahleyin',
    afternoon: 'öğleden sonra',
    evening: 'akşamleyin',
    night: 'geceleyin'
  },
  wide: {
    am: 'ö.ö.',
    pm: 'ö.s.',
    midnight: 'gece yarısı',
    noon: 'öğlen',
    morning: 'sabahleyin',
    afternoon: 'öğleden sonra',
    evening: 'akşamleyin',
    night: 'geceleyin'
  }
};

var ordinalNumber$8 = function (dirtyNumber, _options) {
  var number = Number(dirtyNumber);
  return number + '.';
};

var localize$g = {
  ordinalNumber: ordinalNumber$8,
  era: buildLocalizeFn({
    values: eraValues$8,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$8,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$8,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$8,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$8,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$8,
    defaultFormattingWidth: 'wide'
  })
};
var localize$h = localize$g;

var matchOrdinalNumberPattern$8 = /^(\d+)(\.)?/i;
var parseOrdinalNumberPattern$8 = /\d+/i;
var matchEraPatterns$8 = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
};
var parseEraPatterns$8 = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
};
var matchQuarterPatterns$8 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var parseQuarterPatterns$8 = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [/^(i|İ)lk çeyrek/i, /(i|İ)kinci çeyrek/i, /üçüncü çeyrek/i, /son çeyrek/i]
};
var matchMonthPatterns$8 = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var parseMonthPatterns$8 = {
  narrow: [/^o/i, /^ş/i, /^m/i, /^n/i, /^m/i, /^h/i, /^t/i, /^a/i, /^e/i, /^e/i, /^k/i, /^a/i],
  any: [/^o/i, /^ş/i, /^mar/i, /^n/i, /^may/i, /^h/i, /^t/i, /^ağ/i, /^ey/i, /^ek/i, /^k/i, /^ar/i]
};
var matchDayPatterns$8 = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar|pazartesi|salı|çarşamba|perşembe|cuma|cumartesi)/i
};
var parseDayPatterns$8 = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [/^pazar/i, /^pazartesi/i, /^salı/i, /^çarşamba/i, /^perşembe/i, /^cuma/i, /cumartesi/i]
};
var matchDayPeriodPatterns$8 = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var parseDayPeriodPatterns$8 = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
};
var match$g = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$8,
    parsePattern: parseOrdinalNumberPattern$8,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$8,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$8,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$8,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$8,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$8,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$8,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$8,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$8,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$8,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$8,
    defaultParseWidth: 'any'
  })
};
var match$h = match$g;

/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */

var locale$g = {
  code: 'tr',
  formatDistance: formatDistance$9,
  formatLong: formatLong$h,
  formatRelative: formatRelative$9,
  localize: localize$h,
  match: match$h,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$h = locale$g;

var formatDistanceLocale$7 = {
  lessThanXSeconds: {
    one: 'بىر سىكۇنت ئىچىدە',
    other: 'سىكۇنت ئىچىدە {{count}}'
  },
  xSeconds: {
    one: 'بىر سىكۇنت',
    other: 'سىكۇنت {{count}}'
  },
  halfAMinute: 'يىرىم مىنۇت',
  lessThanXMinutes: {
    one: 'بىر مىنۇت ئىچىدە',
    other: 'مىنۇت ئىچىدە {{count}}'
  },
  xMinutes: {
    one: 'بىر مىنۇت',
    other: 'مىنۇت {{count}}'
  },
  aboutXHours: {
    one: 'تەخمىنەن بىر سائەت',
    other: 'سائەت {{count}} تەخمىنەن'
  },
  xHours: {
    one: 'بىر سائەت',
    other: 'سائەت {{count}}'
  },
  xDays: {
    one: 'بىر كۈن',
    other: 'كۈن {{count}}'
  },
  aboutXWeeks: {
    one: 'تەخمىنەن بىرھەپتە',
    other: 'ھەپتە {{count}} تەخمىنەن'
  },
  xWeeks: {
    one: 'بىرھەپتە',
    other: 'ھەپتە {{count}}'
  },
  aboutXMonths: {
    one: 'تەخمىنەن بىر ئاي',
    other: 'ئاي {{count}} تەخمىنەن'
  },
  xMonths: {
    one: 'بىر ئاي',
    other: 'ئاي {{count}}'
  },
  aboutXYears: {
    one: 'تەخمىنەن بىر يىل',
    other: 'يىل {{count}} تەخمىنەن'
  },
  xYears: {
    one: 'بىر يىل',
    other: 'يىل {{count}}'
  },
  overXYears: {
    one: 'بىر يىلدىن ئارتۇق',
    other: 'يىلدىن ئارتۇق {{count}}'
  },
  almostXYears: {
    one: 'ئاساسەن بىر يىل',
    other: 'يىل {{count}} ئاساسەن'
  }
};
function formatDistance$7(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$7[token] === 'string') {
    result = formatDistanceLocale$7[token];
  } else if (count === 1) {
    result = formatDistanceLocale$7[token].one;
  } else {
    result = formatDistanceLocale$7[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result;
    } else {
      return result + ' بولدى';
    }
  }

  return result;
}

var dateFormats$7 = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$7 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$7 = {
  full: "{{date}} 'دە' {{time}}",
  long: "{{date}} 'دە' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$e = {
  date: buildFormatLongFn({
    formats: dateFormats$7,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$7,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$7,
    defaultWidth: 'full'
  })
};
var formatLong$f = formatLong$e;

var formatRelativeLocale$7 = {
  lastWeek: "'ئ‍ۆتكەن' eeee 'دە' p",
  yesterday: "'تۈنۈگۈن دە' p",
  today: "'بۈگۈن دە' p",
  tomorrow: "'ئەتە دە' p",
  nextWeek: "eeee 'دە' p",
  other: 'P'
};
function formatRelative$7(token, _date, _baseDate, _options) {
  return formatRelativeLocale$7[token];
}

var eraValues$7 = {
  narrow: ['ب', 'ك'],
  abbreviated: ['ب', 'ك'],
  wide: ['مىيلادىدىن بۇرۇن', 'مىيلادىدىن كىيىن']
};
var quarterValues$7 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1', '2', '3', '4'],
  wide: ['بىرىنجى چارەك', 'ئىككىنجى چارەك', 'ئۈچىنجى چارەك', 'تۆتىنجى چارەك']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$7 = {
  narrow: ['ي', 'ف', 'م', 'ا', 'م', 'ى', 'ى', 'ا', 'س', 'ۆ', 'ن', 'د'],
  abbreviated: ['يانۋار', 'فېۋىرال', 'مارت', 'ئاپرىل', 'ماي', 'ئىيۇن', 'ئىيول', 'ئاۋغۇست', 'سىنتەبىر', 'ئۆكتەبىر', 'نويابىر', 'دىكابىر'],
  wide: ['يانۋار', 'فېۋىرال', 'مارت', 'ئاپرىل', 'ماي', 'ئىيۇن', 'ئىيول', 'ئاۋغۇست', 'سىنتەبىر', 'ئۆكتەبىر', 'نويابىر', 'دىكابىر']
};
var dayValues$7 = {
  narrow: ['ي', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
  short: ['ي', 'د', 'س', 'چ', 'پ', 'ج', 'ش'],
  abbreviated: ['يەكشەنبە', 'دۈشەنبە', 'سەيشەنبە', 'چارشەنبە', 'پەيشەنبە', 'جۈمە', 'شەنبە'],
  wide: ['يەكشەنبە', 'دۈشەنبە', 'سەيشەنبە', 'چارشەنبە', 'پەيشەنبە', 'جۈمە', 'شەنبە']
};
var dayPeriodValues$7 = {
  narrow: {
    am: 'ئە',
    pm: 'چ',
    midnight: 'ك',
    noon: 'چ',
    morning: 'ئەتىگەن',
    afternoon: 'چۈشتىن كىيىن',
    evening: 'ئاخشىم',
    night: 'كىچە'
  },
  abbreviated: {
    am: 'ئە',
    pm: 'چ',
    midnight: 'ك',
    noon: 'چ',
    morning: 'ئەتىگەن',
    afternoon: 'چۈشتىن كىيىن',
    evening: 'ئاخشىم',
    night: 'كىچە'
  },
  wide: {
    am: 'ئە',
    pm: 'چ',
    midnight: 'ك',
    noon: 'چ',
    morning: 'ئەتىگەن',
    afternoon: 'چۈشتىن كىيىن',
    evening: 'ئاخشىم',
    night: 'كىچە'
  }
};
var formattingDayPeriodValues$7 = {
  narrow: {
    am: 'ئە',
    pm: 'چ',
    midnight: 'ك',
    noon: 'چ',
    morning: 'ئەتىگەندە',
    afternoon: 'چۈشتىن كىيىن',
    evening: 'ئاخشامدا',
    night: 'كىچىدە'
  },
  abbreviated: {
    am: 'ئە',
    pm: 'چ',
    midnight: 'ك',
    noon: 'چ',
    morning: 'ئەتىگەندە',
    afternoon: 'چۈشتىن كىيىن',
    evening: 'ئاخشامدا',
    night: 'كىچىدە'
  },
  wide: {
    am: 'ئە',
    pm: 'چ',
    midnight: 'ك',
    noon: 'چ',
    morning: 'ئەتىگەندە',
    afternoon: 'چۈشتىن كىيىن',
    evening: 'ئاخشامدا',
    night: 'كىچىدە'
  }
};

function ordinalNumber$7(dirtyNumber, _dirtyOptions) {
  return String(dirtyNumber);
}

var localize$e = {
  ordinalNumber: ordinalNumber$7,
  era: buildLocalizeFn({
    values: eraValues$7,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$7,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$7,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$7,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$7,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$7,
    defaultFormattingWidth: 'wide'
  })
};
var localize$f = localize$e;

var matchOrdinalNumberPattern$7 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$7 = /\d+/i;
var matchEraPatterns$7 = {
  narrow: /^(ب|ك)/i,
  wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var parseEraPatterns$7 = {
  any: [/^بۇرۇن/i, /^كىيىن/i]
};
var matchQuarterPatterns$7 = {
  narrow: /^[1234]/i,
  abbreviated: /^چ[1234]/i,
  wide: /^چارەك [1234]/i
};
var parseQuarterPatterns$7 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$7 = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[يفمئامئ‍ئاسۆند]/i,
  abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
  wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var parseMonthPatterns$7 = {
  narrow: [/^ي/i, /^ف/i, /^م/i, /^ا/i, /^م/i, /^ى‍/i, /^ى‍/i, /^ا‍/i, /^س/i, /^ۆ/i, /^ن/i, /^د/i],
  any: [/^يان/i, /^فېۋ/i, /^مار/i, /^ئاپ/i, /^ماي/i, /^ئىيۇن/i, /^ئىيول/i, /^ئاۋ/i, /^سىن/i, /^ئۆك/i, /^نوي/i, /^دىك/i]
};
var matchDayPatterns$7 = {
  narrow: /^[دسچپجشي]/i,
  short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
  abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
  wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var parseDayPatterns$7 = {
  narrow: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i]
};
var matchDayPeriodPatterns$7 = {
  narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
  any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var parseDayPeriodPatterns$7 = {
  any: {
    am: /^ئە/i,
    pm: /^چ/i,
    midnight: /^ك/i,
    noon: /^چ/i,
    morning: /ئەتىگەن/i,
    afternoon: /چۈشتىن كىيىن/i,
    evening: /ئاخشىم/i,
    night: /كىچە/i
  }
};
var match$e = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$7,
    parsePattern: parseOrdinalNumberPattern$7,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$7,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$7,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$7,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$7,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$7,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$7,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$7,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$7,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$7,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$7,
    defaultParseWidth: 'any'
  })
};
var match$f = match$e;

/**
 * @type {Locale}
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
 */

var locale$e = {
  code: 'ug',
  formatDistance: formatDistance$7,
  formatLong: formatLong$f,
  formatRelative: formatRelative$7,
  localize: localize$f,
  match: match$f,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$f = locale$e;

function declension(scheme, count) {
  // scheme for count=1 exists
  if (scheme.one !== undefined && count === 1) {
    return scheme.one;
  }

  var rem10 = count % 10;
  var rem100 = count % 100; // 1, 21, 31, ...

  if (rem10 === 1 && rem100 !== 11) {
    return scheme.singularNominative.replace('{{count}}', count); // 2, 3, 4, 22, 23, 24, 32 ...
  } else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) {
    return scheme.singularGenitive.replace('{{count}}', count); // 5, 6, 7, 8, 9, 10, 11, ...
  } else {
    return scheme.pluralGenitive.replace('{{count}}', count);
  }
}

function buildLocalizeTokenFn(scheme) {
  return function (count, options) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        if (scheme.future) {
          return declension(scheme.future, count);
        } else {
          return 'за ' + declension(scheme.regular, count);
        }
      } else {
        if (scheme.past) {
          return declension(scheme.past, count);
        } else {
          return declension(scheme.regular, count) + ' тому';
        }
      }
    } else {
      return declension(scheme.regular, count);
    }
  };
}

var formatDistanceLocale$6 = {
  lessThanXSeconds: buildLocalizeTokenFn({
    regular: {
      one: 'менше секунди',
      singularNominative: 'менше {{count}} секунди',
      singularGenitive: 'менше {{count}} секунд',
      pluralGenitive: 'менше {{count}} секунд'
    },
    future: {
      one: 'менше, ніж за секунду',
      singularNominative: 'менше, ніж за {{count}} секунду',
      singularGenitive: 'менше, ніж за {{count}} секунди',
      pluralGenitive: 'менше, ніж за {{count}} секунд'
    }
  }),
  xSeconds: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} секунда',
      singularGenitive: '{{count}} секунди',
      pluralGenitive: '{{count}} секунд'
    },
    past: {
      singularNominative: '{{count}} секунду тому',
      singularGenitive: '{{count}} секунди тому',
      pluralGenitive: '{{count}} секунд тому'
    },
    future: {
      singularNominative: 'за {{count}} секунду',
      singularGenitive: 'за {{count}} секунди',
      pluralGenitive: 'за {{count}} секунд'
    }
  }),
  halfAMinute: function (_, options) {
    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'за півхвилини';
      } else {
        return 'півхвилини тому';
      }
    }

    return 'півхвилини';
  },
  lessThanXMinutes: buildLocalizeTokenFn({
    regular: {
      one: 'менше хвилини',
      singularNominative: 'менше {{count}} хвилини',
      singularGenitive: 'менше {{count}} хвилин',
      pluralGenitive: 'менше {{count}} хвилин'
    },
    future: {
      one: 'менше, ніж за хвилину',
      singularNominative: 'менше, ніж за {{count}} хвилину',
      singularGenitive: 'менше, ніж за {{count}} хвилини',
      pluralGenitive: 'менше, ніж за {{count}} хвилин'
    }
  }),
  xMinutes: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} хвилина',
      singularGenitive: '{{count}} хвилини',
      pluralGenitive: '{{count}} хвилин'
    },
    past: {
      singularNominative: '{{count}} хвилину тому',
      singularGenitive: '{{count}} хвилини тому',
      pluralGenitive: '{{count}} хвилин тому'
    },
    future: {
      singularNominative: 'за {{count}} хвилину',
      singularGenitive: 'за {{count}} хвилини',
      pluralGenitive: 'за {{count}} хвилин'
    }
  }),
  aboutXHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'близько {{count}} години',
      singularGenitive: 'близько {{count}} годин',
      pluralGenitive: 'близько {{count}} годин'
    },
    future: {
      singularNominative: 'приблизно за {{count}} годину',
      singularGenitive: 'приблизно за {{count}} години',
      pluralGenitive: 'приблизно за {{count}} годин'
    }
  }),
  xHours: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} годину',
      singularGenitive: '{{count}} години',
      pluralGenitive: '{{count}} годин'
    }
  }),
  xDays: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} день',
      singularGenitive: '{{count}} дня',
      pluralGenitive: '{{count}} днів'
    }
  }),
  aboutXWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'близько {{count}} тижня',
      singularGenitive: 'близько {{count}} тижнів',
      pluralGenitive: 'близько {{count}} тижнів'
    },
    future: {
      singularNominative: 'приблизно за {{count}} тиждень',
      singularGenitive: 'приблизно за {{count}} тижні',
      pluralGenitive: 'приблизно за {{count}} тижні'
    }
  }),
  xWeeks: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} тиждень',
      singularGenitive: '{{count}} тижня',
      pluralGenitive: '{{count}} тижні'
    }
  }),
  aboutXMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'близько {{count}} місяця',
      singularGenitive: 'близько {{count}} місяців',
      pluralGenitive: 'близько {{count}} місяців'
    },
    future: {
      singularNominative: 'приблизно за {{count}} місяць',
      singularGenitive: 'приблизно за {{count}} місяця',
      pluralGenitive: 'приблизно за {{count}} місяців'
    }
  }),
  xMonths: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} місяць',
      singularGenitive: '{{count}} місяця',
      pluralGenitive: '{{count}} місяців'
    }
  }),
  aboutXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'близько {{count}} року',
      singularGenitive: 'близько {{count}} років',
      pluralGenitive: 'близько {{count}} років'
    },
    future: {
      singularNominative: 'приблизно за {{count}} рік',
      singularGenitive: 'приблизно за {{count}} роки',
      pluralGenitive: 'приблизно за {{count}} років'
    }
  }),
  xYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: '{{count}} рік',
      singularGenitive: '{{count}} роки',
      pluralGenitive: '{{count}} років'
    }
  }),
  overXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'більше {{count}} року',
      singularGenitive: 'більше {{count}} років',
      pluralGenitive: 'більше {{count}} років'
    },
    future: {
      singularNominative: 'більше, ніж за {{count}} рік',
      singularGenitive: 'більше, ніж за {{count}} роки',
      pluralGenitive: 'більше, ніж за {{count}} років'
    }
  }),
  almostXYears: buildLocalizeTokenFn({
    regular: {
      singularNominative: 'майже {{count}} рік',
      singularGenitive: 'майже {{count}} роки',
      pluralGenitive: 'майже {{count}} років'
    },
    future: {
      singularNominative: 'майже за {{count}} рік',
      singularGenitive: 'майже за {{count}} роки',
      pluralGenitive: 'майже за {{count}} років'
    }
  })
};
function formatDistance$6(token, count, options) {
  options = options || {};
  return formatDistanceLocale$6[token](count, options);
}

var dateFormats$6 = {
  full: "EEEE, do MMMM y 'р.'",
  long: "do MMMM y 'р.'",
  medium: "d MMM y 'р.'",
  short: 'dd.MM.y'
};
var timeFormats$6 = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$6 = {
  full: "{{date}} 'о' {{time}}",
  long: "{{date}} 'о' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$c = {
  date: buildFormatLongFn({
    formats: dateFormats$6,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$6,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$6,
    defaultWidth: 'full'
  })
};
var formatLong$d = formatLong$c;

var accusativeWeekdays = ['неділю', 'понеділок', 'вівторок', 'середу', 'четвер', 'п’ятницю', 'суботу'];

function lastWeek(day) {
  var weekday = accusativeWeekdays[day];

  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у минулу " + weekday + " о' p";

    case 1:
    case 2:
    case 4:
      return "'у минулий " + weekday + " о' p";
  }
}

function thisWeek(day) {
  var weekday = accusativeWeekdays[day];
  return "'у " + weekday + " о' p";
}

function nextWeek(day) {
  var weekday = accusativeWeekdays[day];

  switch (day) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступну " + weekday + " о' p";

    case 1:
    case 2:
    case 4:
      return "'у наступний " + weekday + " о' p";
  }
}

var formatRelativeLocale$6 = {
  lastWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return lastWeek(day);
    }
  },
  yesterday: "'вчора о' p",
  today: "'сьогодні о' p",
  tomorrow: "'завтра о' p",
  nextWeek: function (date, baseDate, options) {
    var day = date.getUTCDay();

    if (isSameUTCWeek(date, baseDate, options)) {
      return thisWeek(day);
    } else {
      return nextWeek(day);
    }
  },
  other: 'P'
};
function formatRelative$6(token, date, baseDate, options) {
  var format = formatRelativeLocale$6[token];

  if (typeof format === 'function') {
    return format(date, baseDate, options);
  }

  return format;
}

var eraValues$6 = {
  narrow: ['до н.е.', 'н.е.'],
  abbreviated: ['до н. е.', 'н. е.'],
  wide: ['до нашої ери', 'нашої ери']
};
var quarterValues$6 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-й кв.', '2-й кв.', '3-й кв.', '4-й кв.'],
  wide: ['1-й квартал', '2-й квартал', '3-й квартал', '4-й квартал']
};
var monthValues$6 = {
  // ДСТУ 3582:2013
  narrow: ['С', 'Л', 'Б', 'К', 'Т', 'Ч', 'Л', 'С', 'В', 'Ж', 'Л', 'Г'],
  abbreviated: ['січ.', 'лют.', 'берез.', 'квіт.', 'трав.', 'черв.', 'лип.', 'серп.', 'верес.', 'жовт.', 'листоп.', 'груд.'],
  wide: ['січень', 'лютий', 'березень', 'квітень', 'травень', 'червень', 'липень', 'серпень', 'вересень', 'жовтень', 'листопад', 'грудень']
};
var formattingMonthValues$1 = {
  narrow: ['С', 'Л', 'Б', 'К', 'Т', 'Ч', 'Л', 'С', 'В', 'Ж', 'Л', 'Г'],
  abbreviated: ['січ.', 'лют.', 'берез.', 'квіт.', 'трав.', 'черв.', 'лип.', 'серп.', 'верес.', 'жовт.', 'листоп.', 'груд.'],
  wide: ['січня', 'лютого', 'березня', 'квітня', 'травня', 'червня', 'липня', 'серпня', 'вересня', 'жовтня', 'листопада', 'грудня']
};
var dayValues$6 = {
  narrow: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  short: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  abbreviated: ['нед', 'пон', 'вів', 'сер', 'чтв', 'птн', 'суб'],
  wide: ['неділя', 'понеділок', 'вівторок', 'середа', 'четвер', 'п’ятниця', 'субота']
};
var dayPeriodValues$6 = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'півн.',
    noon: 'пол.',
    morning: 'ранок',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ніч'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'півн.',
    noon: 'пол.',
    morning: 'ранок',
    afternoon: 'день',
    evening: 'веч.',
    night: 'ніч'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'північ',
    noon: 'полудень',
    morning: 'ранок',
    afternoon: 'день',
    evening: 'вечір',
    night: 'ніч'
  }
};
var formattingDayPeriodValues$6 = {
  narrow: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'півн.',
    noon: 'пол.',
    morning: 'ранку',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночі'
  },
  abbreviated: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'півн.',
    noon: 'пол.',
    morning: 'ранку',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночі'
  },
  wide: {
    am: 'ДП',
    pm: 'ПП',
    midnight: 'північ',
    noon: 'полудень',
    morning: 'ранку',
    afternoon: 'дня',
    evening: 'веч.',
    night: 'ночі'
  }
};

function ordinalNumber$6(dirtyNumber, dirtyOptions) {
  var options = dirtyOptions || {};
  var unit = String(options.unit);
  var suffix;

  if (unit === 'date') {
    if (dirtyNumber === 3 || dirtyNumber === 23) {
      suffix = '-є';
    } else {
      suffix = '-е';
    }
  } else if (unit === 'minute' || unit === 'second' || unit === 'hour') {
    suffix = '-а';
  } else {
    suffix = '-й';
  }

  return dirtyNumber + suffix;
}

var localize$c = {
  ordinalNumber: ordinalNumber$6,
  era: buildLocalizeFn({
    values: eraValues$6,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$6,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$6,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues$1,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$6,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$6,
    defaultWidth: 'any',
    formattingValues: formattingDayPeriodValues$6,
    defaultFormattingWidth: 'wide'
  })
};
var localize$d = localize$c;

var matchOrdinalNumberPattern$6 = /^(\d+)(-?(е|й|є|а|я))?/i;
var parseOrdinalNumberPattern$6 = /\d+/i;
var matchEraPatterns$6 = {
  narrow: /^((до )?н\.?\s?е\.?)/i,
  abbreviated: /^((до )?н\.?\s?е\.?)/i,
  wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var parseEraPatterns$6 = {
  any: [/^д/i, /^н/i]
};
var matchQuarterPatterns$6 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
  wide: /^[1234](-?[иі]?й?)? квартал/i
};
var parseQuarterPatterns$6 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$6 = {
  narrow: /^[слбктчвжг]/i,
  abbreviated: /^(січ|лют|бер|берез|кві|трав?|чер|лип|сер|вер|жов|лис(топ)?|груд)\.?/i,
  wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопада?|грудень|грудня)/i
};
var parseMonthPatterns$6 = {
  narrow: [/^с/i, /^л/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^л/i, /^с/i, /^в/i, /^ж/i, /^л/i, /^г/i],
  any: [/^сі/i, /^лю/i, /^б/i, /^к/i, /^т/i, /^ч/i, /^лип/i, /^се/i, /^в/i, /^ж/i, /^лис/i, /^г/i]
};
var matchDayPatterns$6 = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
  abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
  wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var parseDayPatterns$6 = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
};
var matchDayPeriodPatterns$6 = {
  narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var parseDayPeriodPatterns$6 = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^півн/i,
    noon: /^пол/i,
    morning: /^р/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
};
var match$c = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$6,
    parsePattern: parseOrdinalNumberPattern$6,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$6,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$6,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$6,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$6,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$6,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$6,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$6,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$6,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$6,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPeriodPatterns$6,
    defaultParseWidth: 'any'
  })
};
var match$d = match$c;

/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */

var locale$c = {
  code: 'uk',
  formatDistance: formatDistance$6,
  formatLong: formatLong$d,
  formatRelative: formatRelative$6,
  localize: localize$d,
  match: match$d,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$d = locale$c;

var formatDistanceLocale$5 = {
  lessThanXSeconds: {
    one: 'sekunddan kam',
    other: '{{count}} sekunddan kam'
  },
  xSeconds: {
    one: '1 sekund',
    other: '{{count}} sekund'
  },
  halfAMinute: 'yarim minut',
  lessThanXMinutes: {
    one: 'bir minutdan kam',
    other: '{{count}} minutdan kam'
  },
  xMinutes: {
    one: '1 minut',
    other: '{{count}} minut'
  },
  aboutXHours: {
    one: 'tahminan 1 soat',
    other: 'tahminan {{count}} soat'
  },
  xHours: {
    one: '1 soat',
    other: '{{count}} soat'
  },
  xDays: {
    one: '1 kun',
    other: '{{count}} kun'
  },
  aboutXWeeks: {
    one: 'tahminan 1 hafta',
    other: 'tahminan {{count}} hafta'
  },
  xWeeks: {
    one: '1 hafta',
    other: '{{count}} hafta'
  },
  aboutXMonths: {
    one: 'tahminan 1 oy',
    other: 'tahminan {{count}} oy'
  },
  xMonths: {
    one: '1 oy',
    other: '{{count}} oy'
  },
  aboutXYears: {
    one: 'tahminan 1 yil',
    other: 'tahminan {{count}} yil'
  },
  xYears: {
    one: '1 yil',
    other: '{{count}} yil'
  },
  overXYears: {
    one: "1 yildan ko'p",
    other: "{{count}} yildan ko'p"
  },
  almostXYears: {
    one: 'deyarli 1 yil',
    other: 'deyarli {{count}} yil'
  }
};
function formatDistance$5(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$5[token] === 'string') {
    result = formatDistanceLocale$5[token];
  } else if (count === 1) {
    result = formatDistanceLocale$5[token].one;
  } else {
    result = formatDistanceLocale$5[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result + ' dan keyin';
    } else {
      return result + ' oldin';
    }
  }

  return result;
}

var dateFormats$5 = {
  full: 'EEEE, do MMMM, y',
  long: 'do MMMM, y',
  medium: 'd MMM, y',
  short: 'dd/MM/yyyy'
};
var timeFormats$5 = {
  full: 'h:mm:ss zzzz',
  long: 'h:mm:ss z',
  medium: 'h:mm:ss',
  short: 'h:mm'
};
var dateTimeFormats$5 = {
  any: '{{date}}, {{time}}'
};
var formatLong$a = {
  date: buildFormatLongFn({
    formats: dateFormats$5,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$5,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$5,
    defaultWidth: 'any'
  })
};
var formatLong$b = formatLong$a;

var formatRelativeLocale$5 = {
  lastWeek: "'oldingi' eeee p 'da'",
  yesterday: "'kecha' p 'da'",
  today: "'bugun' p 'da'",
  tomorrow: "'ertaga' p 'da'",
  nextWeek: "eeee p 'da'",
  other: 'P'
};
function formatRelative$5(token, _date, _baseDate, _options) {
  return formatRelativeLocale$5[token];
}

var eraValues$5 = {
  narrow: ['M.A', 'M.'],
  abbreviated: ['M.A', 'M.'],
  wide: ['Miloddan Avvalgi', 'Milodiy']
};
var quarterValues$5 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['CH.1', 'CH.2', 'CH.3', 'CH.4'],
  wide: ['1-chi chorak', '2-chi chorak', '3-chi chorak', '4-chi chorak']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$5 = {
  narrow: ['Y', 'F', 'M', 'A', 'M', 'I', 'I', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Yan', 'Fev', 'Mar', 'Apr', 'May', 'Iyun', 'Iyul', 'Avg', 'Sen', 'Okt', 'Noy', 'Dek'],
  wide: ['Yanvar', 'Fevral', 'Mart', 'Aprel', 'May', 'Iyun', 'Iyul', 'Avgust', 'Sentabr', 'Oktabr', 'Noyabr', 'Dekabr']
};
var dayValues$5 = {
  narrow: ['Y', 'D', 'S', 'CH', 'P', 'J', 'SH'],
  short: ['Ya', 'Du', 'Se', 'Cho', 'Pa', 'Ju', 'Sha'],
  abbreviated: ['Yak', 'Dush', 'Sesh', 'Chor', 'Pay', 'Jum', 'Shan'],
  wide: ['Yakshanba', 'Dushanba', 'Seshanba', 'Chorshanba', 'Payshanba', 'Juma', 'Shanba']
};
var dayPeriodValues$5 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'y.t',
    noon: 'p.',
    morning: 'ertalab',
    afternoon: 'tushdan keyin',
    evening: 'kechqurun',
    night: 'tun'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'yarim tun',
    noon: 'peshin',
    morning: 'ertalab',
    afternoon: 'tushdan keyin',
    evening: 'kechqurun',
    night: 'tun'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'yarim tun',
    noon: 'peshin',
    morning: 'ertalab',
    afternoon: 'tushdan keyin',
    evening: 'kechqurun',
    night: 'tun'
  }
};
var formattingDayPeriodValues$5 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'y.t',
    noon: 'p.',
    morning: 'ertalab',
    afternoon: 'tushdan keyin',
    evening: 'kechqurun',
    night: 'tun'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'yarim tun',
    noon: 'peshin',
    morning: 'ertalab',
    afternoon: 'tushdan keyin',
    evening: 'kechqurun',
    night: 'tun'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'yarim tun',
    noon: 'peshin',
    morning: 'ertalab',
    afternoon: 'tushdan keyin',
    evening: 'kechqurun',
    night: 'tun'
  }
};

function ordinalNumber$5(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  return number;
}

var localize$a = {
  ordinalNumber: ordinalNumber$5,
  era: buildLocalizeFn({
    values: eraValues$5,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$5,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$5,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$5,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$5,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$5,
    defaultFormattingWidth: 'wide'
  })
};
var localize$b = localize$a;

var matchOrdinalNumberPattern$5 = /^(\d+)(chi)?/i;
var parseOrdinalNumberPattern$5 = /\d+/i;
var matchEraPatterns$5 = {
  narrow: /^(m\.a|m\.)/i,
  abbreviated: /^(m\.a\.?\s?m\.?)/i,
  wide: /^(miloddan avval|miloddan keyin)/i
};
var parseEraPatterns$5 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$5 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](chi)? chorak/i
};
var parseQuarterPatterns$5 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$5 = {
  narrow: /^[yfmasond]/i,
  abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
  wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var parseMonthPatterns$5 = {
  narrow: [/^y/i, /^f/i, /^m/i, /^a/i, /^m/i, /^i/i, /^i/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ya/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^iyun/i, /^iyul/i, /^av/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$5 = {
  narrow: /^[ydschj]/i,
  short: /^(ya|du|se|cho|pa|ju|sha)/i,
  abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
  wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var parseDayPatterns$5 = {
  narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
  any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i]
};
var matchDayPeriodPatterns$5 = {
  narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
  any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var parseDayPeriodPatterns$5 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^y\.t/i,
    noon: /^pe/i,
    morning: /ertalab/i,
    afternoon: /tushdan keyin/i,
    evening: /kechqurun/i,
    night: /tun/i
  }
};
var match$a = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$5,
    parsePattern: parseOrdinalNumberPattern$5,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$5,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$5,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$5,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$5,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$5,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$5,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$5,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$5,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$5,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$5,
    defaultParseWidth: 'any'
  })
};
var match$b = match$a;

/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
 */

var locale$a = {
  code: 'uz',
  formatDistance: formatDistance$5,
  formatLong: formatLong$b,
  formatRelative: formatRelative$5,
  localize: localize$b,
  match: match$b,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$b = locale$a;

var formatDistanceLocale$4 = {
  lessThanXSeconds: {
    one: '1 сониядан кам',
    other: '{{count}} сониядан кам'
  },
  xSeconds: {
    one: '1 сония',
    other: '{{count}} сония'
  },
  halfAMinute: 'ярим дақиқа',
  lessThanXMinutes: {
    one: '1 дақиқадан кам',
    other: '{{count}} дақиқадан кам'
  },
  xMinutes: {
    one: '1 дақиқа',
    other: '{{count}} дақиқа'
  },
  aboutXHours: {
    one: 'тахминан 1 соат',
    other: 'тахминан {{count}} соат'
  },
  xHours: {
    one: '1 соат',
    other: '{{count}} соат'
  },
  xDays: {
    one: '1 кун',
    other: '{{count}} кун'
  },
  aboutXWeeks: {
    one: 'тахминан 1 хафта',
    other: 'тахминан {{count}} хафта'
  },
  xWeeks: {
    one: '1 хафта',
    other: '{{count}} хафта'
  },
  aboutXMonths: {
    one: 'тахминан 1 ой',
    other: 'тахминан {{count}} ой'
  },
  xMonths: {
    one: '1 ой',
    other: '{{count}} ой'
  },
  aboutXYears: {
    one: 'тахминан 1 йил',
    other: 'тахминан {{count}} йил'
  },
  xYears: {
    one: '1 йил',
    other: '{{count}} йил'
  },
  overXYears: {
    one: '1 йилдан кўп',
    other: '{{count}} йилдан кўп'
  },
  almostXYears: {
    one: 'деярли 1 йил',
    other: 'деярли {{count}} йил'
  }
};
function formatDistance$4(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$4[token] === 'string') {
    result = formatDistanceLocale$4[token];
  } else if (count === 1) {
    result = formatDistanceLocale$4[token].one;
  } else {
    result = formatDistanceLocale$4[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result + 'дан кейин';
    } else {
      return result + ' олдин';
    }
  }

  return result;
}

var dateFormats$4 = {
  full: 'EEEE, do MMMM, y',
  long: 'do MMMM, y',
  medium: 'd MMM, y',
  short: 'dd/MM/yyyy'
};
var timeFormats$4 = {
  full: 'H:mm:ss zzzz',
  long: 'H:mm:ss z',
  medium: 'H:mm:ss',
  short: 'H:mm'
};
var dateTimeFormats$4 = {
  any: '{{date}}, {{time}}'
};
var formatLong$8 = {
  date: buildFormatLongFn({
    formats: dateFormats$4,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$4,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$4,
    defaultWidth: 'any'
  })
};
var formatLong$9 = formatLong$8;

var formatRelativeLocale$4 = {
  lastWeek: "'ўтган' eeee p 'да'",
  yesterday: "'кеча' p 'да'",
  today: "'бугун' p 'да'",
  tomorrow: "'эртага' p 'да'",
  nextWeek: "eeee p 'да'",
  other: 'P'
};
function formatRelative$4(token, _date, _baseDate, _options) {
  return formatRelativeLocale$4[token];
}

var eraValues$4 = {
  narrow: ['М.А', 'М'],
  abbreviated: ['М.А', 'М'],
  wide: ['Милоддан Аввалги', 'Милодий']
};
var quarterValues$4 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['1-чор.', '2-чор.', '3-чор.', '4-чор.'],
  wide: ['1-чорак', '2-чорак', '3-чорак', '4-чорак']
};
var monthValues$4 = {
  narrow: ['Я', 'Ф', 'М', 'А', 'М', 'И', 'И', 'А', 'С', 'О', 'Н', 'Д'],
  abbreviated: ['янв', 'фев', 'мар', 'апр', 'май', 'июн', 'июл', 'авг', 'сен', 'окт', 'ноя', 'дек'],
  wide: ['январ', 'феврал', 'март', 'апрел', 'май', 'июн', 'июл', 'август', 'сентабр', 'октабр', 'ноябр', 'декабр']
};
var dayValues$4 = {
  narrow: ['Я', 'Д', 'С', 'Ч', 'П', 'Ж', 'Ш'],
  short: ['як', 'ду', 'се', 'чо', 'па', 'жу', 'ша'],
  abbreviated: ['якш', 'душ', 'сеш', 'чор', 'пай', 'жум', 'шан'],
  wide: ['якшанба', 'душанба', 'сешанба', 'чоршанба', 'пайшанба', 'жума', 'шанба']
};
var dayPeriodValues$4 = {
  any: {
    am: 'П.О.',
    pm: 'П.К.',
    midnight: 'ярим тун',
    noon: 'пешин',
    morning: 'эрталаб',
    afternoon: 'пешиндан кейин',
    evening: 'кечаси',
    night: 'тун'
  }
};
var formattingDayPeriodValues$4 = {
  any: {
    am: 'П.О.',
    pm: 'П.К.',
    midnight: 'ярим тун',
    noon: 'пешин',
    morning: 'эрталаб',
    afternoon: 'пешиндан кейин',
    evening: 'кечаси',
    night: 'тун'
  }
};

function ordinalNumber$4(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber);
  return number;
}

var localize$8 = {
  ordinalNumber: ordinalNumber$4,
  era: buildLocalizeFn({
    values: eraValues$4,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$4,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$4,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$4,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$4,
    defaultWidth: 'any',
    formattingValues: formattingDayPeriodValues$4,
    defaultFormattingWidth: 'any'
  })
};
var localize$9 = localize$8;

var matchOrdinalNumberPattern$4 = /^(\d+)(чи)?/i;
var parseOrdinalNumberPattern$4 = /\d+/i;
var matchEraPatterns$4 = {
  narrow: /^(м\.а|м\.)/i,
  abbreviated: /^(м\.а|м\.)/i,
  wide: /^(милоддан аввал|милоддан кейин)/i
};
var parseEraPatterns$4 = {
  any: [/^м/i, /^а/i]
};
var matchQuarterPatterns$4 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-чор./i,
  wide: /^[1234]-чорак/i
};
var parseQuarterPatterns$4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$4 = {
  narrow: /^[яфмамииасонд]/i,
  abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
  wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var parseMonthPatterns$4 = {
  narrow: [/^я/i, /^ф/i, /^м/i, /^а/i, /^м/i, /^и/i, /^и/i, /^а/i, /^с/i, /^о/i, /^н/i, /^д/i],
  any: [/^я/i, /^ф/i, /^мар/i, /^ап/i, /^май/i, /^июн/i, /^июл/i, /^ав/i, /^с/i, /^о/i, /^н/i, /^д/i]
};
var matchDayPatterns$4 = {
  narrow: /^[ядсчпжш]/i,
  short: /^(як|ду|се|чо|па|жу|ша)/i,
  abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
  wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var parseDayPatterns$4 = {
  narrow: [/^я/i, /^д/i, /^с/i, /^ч/i, /^п/i, /^ж/i, /^ш/i],
  any: [/^як/i, /^ду/i, /^се/i, /^чор/i, /^пай/i, /^жу/i, /^шан/i]
};
var matchDayPeriodPatterns$4 = {
  any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var parseDayPeriodPatterns$4 = {
  any: {
    am: /^п\.о\./i,
    pm: /^п\.к\./i,
    midnight: /^ярим тун/i,
    noon: /^пешиндан кейин/i,
    morning: /эрталаб/i,
    afternoon: /пешиндан кейин/i,
    evening: /кечаси/i,
    night: /тун/i
  }
};
var match$8 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$4,
    parsePattern: parseOrdinalNumberPattern$4,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$4,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$4,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$4,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$4,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$4,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$4,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$4,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$4,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$4,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$4,
    defaultParseWidth: 'any'
  })
};
var match$9 = match$8;

/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
 */

var locale$8 = {
  code: 'uz-Cyrl',
  formatDistance: formatDistance$4,
  formatLong: formatLong$9,
  formatRelative: formatRelative$4,
  localize: localize$9,
  match: match$9,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$9 = locale$8;

var formatDistanceLocale$3 = {
  lessThanXSeconds: {
    one: 'dưới 1 giây',
    other: 'dưới {{count}} giây'
  },
  xSeconds: {
    one: '1 giây',
    other: '{{count}} giây'
  },
  halfAMinute: 'nửa phút',
  lessThanXMinutes: {
    one: 'dưới 1 phút',
    other: 'dưới {{count}} phút'
  },
  xMinutes: {
    one: '1 phút',
    other: '{{count}} phút'
  },
  aboutXHours: {
    one: 'khoảng 1 giờ',
    other: 'khoảng {{count}} giờ'
  },
  xHours: {
    one: '1 giờ',
    other: '{{count}} giờ'
  },
  xDays: {
    one: '1 ngày',
    other: '{{count}} ngày'
  },
  aboutXWeeks: {
    one: 'khoảng 1 tuần',
    other: 'khoảng {{count}} tuần'
  },
  xWeeks: {
    one: '1 tuần',
    other: '{{count}} tuần'
  },
  aboutXMonths: {
    one: 'khoảng 1 tháng',
    other: 'khoảng {{count}} tháng'
  },
  xMonths: {
    one: '1 tháng',
    other: '{{count}} tháng'
  },
  aboutXYears: {
    one: 'khoảng 1 năm',
    other: 'khoảng {{count}} năm'
  },
  xYears: {
    one: '1 năm',
    other: '{{count}} năm'
  },
  overXYears: {
    one: 'hơn 1 năm',
    other: 'hơn {{count}} năm'
  },
  almostXYears: {
    one: 'gần 1 năm',
    other: 'gần {{count}} năm'
  }
};
function formatDistance$3(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$3[token] === 'string') {
    result = formatDistanceLocale$3[token];
  } else if (count === 1) {
    result = formatDistanceLocale$3[token].one;
  } else {
    result = formatDistanceLocale$3[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result + ' nữa';
    } else {
      return result + ' trước';
    }
  }

  return result;
}

var dateFormats$3 = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017
  full: "EEEE, 'ngày' d MMMM 'năm' y",
  // ngày 25 tháng 08 năm 2017
  long: "'ngày' d MMMM 'năm' y",
  // 25 thg 08 năm 2017
  medium: "d MMM 'năm' y",
  // 25/08/2017
  short: 'dd/MM/y'
};
var timeFormats$3 = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats$3 = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
  full: '{{date}} {{time}}',
  // ngày 25 tháng 08 năm 2017 23:25
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$6 = {
  date: buildFormatLongFn({
    formats: dateFormats$3,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$3,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$3,
    defaultWidth: 'full'
  })
};
var formatLong$7 = formatLong$6;

var formatRelativeLocale$3 = {
  lastWeek: "eeee 'tuần trước vào lúc' p",
  yesterday: "'hôm qua vào lúc' p",
  today: "'hôm nay vào lúc' p",
  tomorrow: "'ngày mai vào lúc' p",
  nextWeek: "eeee 'tới vào lúc' p",
  other: 'P'
};
function formatRelative$3(token, _date, _baseDate, _options) {
  return formatRelativeLocale$3[token];
}

// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134

var eraValues$3 = {
  narrow: ['TCN', 'SCN'],
  abbreviated: ['trước CN', 'sau CN'],
  wide: ['trước Công Nguyên', 'sau Công Nguyên']
};
var quarterValues$3 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['Quý 1', 'Quý 2', 'Quý 3', 'Quý 4']
};
var formattingQuarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  // I notice many news outlet use this "quý II/2018"
  wide: ['quý I', 'quý II', 'quý III', 'quý IV']
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.

var monthValues$3 = {
  narrow: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
  abbreviated: ['Thg 1', 'Thg 2', 'Thg 3', 'Thg 4', 'Thg 5', 'Thg 6', 'Thg 7', 'Thg 8', 'Thg 9', 'Thg 10', 'Thg 11', 'Thg 12'],
  wide: ['Tháng Một', 'Tháng Hai', 'Tháng Ba', 'Tháng Tư', 'Tháng Năm', 'Tháng Sáu', 'Tháng Bảy', 'Tháng Tám', 'Tháng Chín', 'Tháng Mười', 'Tháng Mười Một', 'Tháng Mười Hai']
}; // In Vietnamese date formatting, month number less than 10 expected to have leading zero

var formattingMonthValues = {
  narrow: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
  abbreviated: ['thg 1', 'thg 2', 'thg 3', 'thg 4', 'thg 5', 'thg 6', 'thg 7', 'thg 8', 'thg 9', 'thg 10', 'thg 11', 'thg 12'],
  wide: ['tháng 01', 'tháng 02', 'tháng 03', 'tháng 04', 'tháng 05', 'tháng 06', 'tháng 07', 'tháng 08', 'tháng 09', 'tháng 10', 'tháng 11', 'tháng 12']
};
var dayValues$3 = {
  narrow: ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'],
  short: ['CN', 'Th 2', 'Th 3', 'Th 4', 'Th 5', 'Th 6', 'Th 7'],
  abbreviated: ['CN', 'Thứ 2', 'Thứ 3', 'Thứ 4', 'Thứ 5', 'Thứ 6', 'Thứ 7'],
  wide: ['Chủ Nhật', 'Thứ Hai', 'Thứ Ba', 'Thứ Tư', 'Thứ Năm', 'Thứ Sáu', 'Thứ Bảy']
}; // Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`

var dayPeriodValues$3 = {
  // narrow date period is extremely rare in Vietnamese
  // I used abbreviated form for noon, morning and afternoon
  // which are regconizable by Vietnamese, others cannot be any shorter
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'nửa đêm',
    noon: 'tr',
    morning: 'sg',
    afternoon: 'ch',
    evening: 'tối',
    night: 'đêm'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'nửa đêm',
    noon: 'trưa',
    morning: 'sáng',
    afternoon: 'chiều',
    evening: 'tối',
    night: 'đêm'
  },
  wide: {
    am: 'SA',
    pm: 'CH',
    midnight: 'nửa đêm',
    noon: 'trưa',
    morning: 'sáng',
    afternoon: 'chiều',
    evening: 'tối',
    night: 'đêm'
  }
};
var formattingDayPeriodValues$3 = {
  narrow: {
    am: 'am',
    pm: 'pm',
    midnight: 'nửa đêm',
    noon: 'tr',
    morning: 'sg',
    afternoon: 'ch',
    evening: 'tối',
    night: 'đêm'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'nửa đêm',
    noon: 'trưa',
    morning: 'sáng',
    afternoon: 'chiều',
    evening: 'tối',
    night: 'đêm'
  },
  wide: {
    am: 'SA',
    pm: 'CH',
    midnight: 'nửa đêm',
    noon: 'giữa trưa',
    morning: 'vào buổi sáng',
    afternoon: 'vào buổi chiều',
    evening: 'vào buổi tối',
    night: 'vào ban đêm'
  }
}; // If ordinal numbers depend on context, for example,
// if they are different for different grammatical genders,
// use `options.unit`:
//
//   var options = dirtyOptions || {}
//   var unit = String(options.unit)
//
// where `unit` can be 'month', 'quarter', 'week', 'isoWeek', 'dayOfYear',
// 'dayOfMonth' or 'dayOfWeek'

function ordinalNumber$3(dirtyNumber, dirtyOptions) {
  var options = dirtyOptions || {};
  var unit = String(options.unit);
  var number = parseInt(dirtyNumber, 10);

  if (unit === 'quarter') {
    // many news outlets use "quý I"...
    switch (number) {
      case 1:
        return 'I';

      case 2:
        return 'II';

      case 3:
        return 'III';

      case 4:
        return 'IV';
    }
  } else if (unit === 'day') {
    // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch (number) {
      case 1:
        return 'thứ 2';
      // meaning 2nd day but it's the first day of the week :D

      case 2:
        return 'thứ 3';
      // meaning 3rd day

      case 3:
        return 'thứ 4';
      // meaning 4th day and so on

      case 4:
        return 'thứ 5';

      case 5:
        return 'thứ 6';

      case 6:
        return 'thứ 7';

      case 7:
        return 'chủ nhật';
      // meaning Sunday, there's no 8th day :D
    }
  } else if (unit === 'week') {
    if (number === 1) {
      return 'thứ nhất';
    } else {
      return 'thứ ' + number;
    }
  } else if (unit === 'dayOfYear') {
    if (number === 1) {
      return 'đầu tiên';
    } else {
      return 'thứ ' + number;
    }
  } // there are no different forms of ordinal numbers in Vietnamese


  return number;
}

var localize$6 = {
  ordinalNumber: ordinalNumber$3,
  era: buildLocalizeFn({
    values: eraValues$3,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$3,
    defaultWidth: 'wide',
    formattingValues: formattingQuarterValues,
    defaultFormattingWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$3,
    defaultWidth: 'wide',
    formattingValues: formattingMonthValues,
    defaultFormattingWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$3,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$3,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$3,
    defaultFormattingWidth: 'wide'
  })
};
var localize$7 = localize$6;

var matchOrdinalNumberPattern$3 = /^(\d+)/i;
var parseOrdinalNumberPattern$3 = /\d+/i;
var matchEraPatterns$3 = {
  narrow: /^(tcn|scn)/i,
  abbreviated: /^(trước CN|sau CN)/i,
  wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var parseEraPatterns$3 = {
  any: [/^t/i, /^s/i]
};
var matchQuarterPatterns$3 = {
  narrow: /^([1234]|i{1,3}v?)/i,
  abbreviated: /^q([1234]|i{1,3}v?)/i,
  wide: /^quý ([1234]|i{1,3}v?)/i
};
var parseQuarterPatterns$3 = {
  any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
};
var matchMonthPatterns$3 = {
  // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
  // note the order of '1' since it is a sub-string of '10', so must be lower priority
  narrow: /^(0?[2-9]|10|11|12|0?1)/i,
  // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
  abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
  // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
  wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var parseMonthPatterns$3 = {
  narrow: [/0?1$/i, /0?2/i, /3/, /4/, /5/, /6/, /7/, /8/, /9/, /10/, /11/, /12/],
  abbreviated: [/^thg[ _]?0?1(?!\d)/i, /^thg[ _]?0?2/i, /^thg[ _]?0?3/i, /^thg[ _]?0?4/i, /^thg[ _]?0?5/i, /^thg[ _]?0?6/i, /^thg[ _]?0?7/i, /^thg[ _]?0?8/i, /^thg[ _]?0?9/i, /^thg[ _]?10/i, /^thg[ _]?11/i, /^thg[ _]?12/i],
  wide: [/^tháng ?(Một|0?1(?!\d))/i, /^tháng ?(Hai|0?2)/i, /^tháng ?(Ba|0?3)/i, /^tháng ?(Tư|0?4)/i, /^tháng ?(Năm|0?5)/i, /^tháng ?(Sáu|0?6)/i, /^tháng ?(Bảy|0?7)/i, /^tháng ?(Tám|0?8)/i, /^tháng ?(Chín|0?9)/i, /^tháng ?(Mười|10)/i, /^tháng ?(Mười ?Một|11)/i, /^tháng ?(Mười ?Hai|12)/i]
};
var matchDayPatterns$3 = {
  narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
  short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var parseDayPatterns$3 = {
  narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
};
var matchDayPeriodPatterns$3 = {
  narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var parseDayPeriodPatterns$3 = {
  any: {
    am: /^(a|sa)/i,
    pm: /^(p|ch[^i]*)/i,
    midnight: /nửa đêm/i,
    noon: /trưa/i,
    morning: /sáng/i,
    afternoon: /chiều/i,
    evening: /tối/i,
    night: /^đêm/i
  }
};
var match$6 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$3,
    parsePattern: parseOrdinalNumberPattern$3,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$3,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$3,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$3,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$3,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$3,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$3,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$3,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$3,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$3,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$3,
    defaultParseWidth: 'any'
  })
};
var match$7 = match$6;

/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */

var locale$6 = {
  code: 'vi',
  formatDistance: formatDistance$3,
  formatLong: formatLong$7,
  formatRelative: formatRelative$3,
  localize: localize$7,
  match: match$7,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 1
    /* First week of new year contains Jan 1st  */

  }
};
var locale$7 = locale$6;

var formatDistanceLocale$2 = {
  lessThanXSeconds: {
    one: '不到 1 秒',
    other: '不到 {{count}} 秒'
  },
  xSeconds: {
    one: '1 秒',
    other: '{{count}} 秒'
  },
  halfAMinute: '半分钟',
  lessThanXMinutes: {
    one: '不到 1 分钟',
    other: '不到 {{count}} 分钟'
  },
  xMinutes: {
    one: '1 分钟',
    other: '{{count}} 分钟'
  },
  xHours: {
    one: '1 小时',
    other: '{{count}} 小时'
  },
  aboutXHours: {
    one: '大约 1 小时',
    other: '大约 {{count}} 小时'
  },
  xDays: {
    one: '1 天',
    other: '{{count}} 天'
  },
  aboutXWeeks: {
    one: '大约 1 个星期',
    other: '大约 {{count}} 个星期'
  },
  xWeeks: {
    one: '1 个星期',
    other: '{{count}} 个星期'
  },
  aboutXMonths: {
    one: '大约 1 个月',
    other: '大约 {{count}} 个月'
  },
  xMonths: {
    one: '1 个月',
    other: '{{count}} 个月'
  },
  aboutXYears: {
    one: '大约 1 年',
    other: '大约 {{count}} 年'
  },
  xYears: {
    one: '1 年',
    other: '{{count}} 年'
  },
  overXYears: {
    one: '超过 1 年',
    other: '超过 {{count}} 年'
  },
  almostXYears: {
    one: '将近 1 年',
    other: '将近 {{count}} 年'
  }
};
function formatDistance$2(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$2[token] === 'string') {
    result = formatDistanceLocale$2[token];
  } else if (count === 1) {
    result = formatDistanceLocale$2[token].one;
  } else {
    result = formatDistanceLocale$2[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result + '内';
    } else {
      return result + '前';
    }
  }

  return result;
}

var dateFormats$2 = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: 'yyyy-MM-dd',
  short: 'yy-MM-dd'
};
var timeFormats$2 = {
  full: 'zzzz a h:mm:ss',
  long: 'z a h:mm:ss',
  medium: 'a h:mm:ss',
  short: 'a h:mm'
};
var dateTimeFormats$2 = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$4 = {
  date: buildFormatLongFn({
    formats: dateFormats$2,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$2,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$2,
    defaultWidth: 'full'
  })
};
var formatLong$5 = formatLong$4;

function checkWeek(_date, _baseDate, _options, baseFormat) {
  if (isSameUTCWeek(_date, _baseDate, _options)) {
    return baseFormat; // in same week
  } else if (_date.getTime() > _baseDate.getTime()) {
    return "'下个'" + baseFormat; // in next week
  }

  return "'上个'" + baseFormat; // in last week
}

var formatRelativeLocale$2 = {
  lastWeek: checkWeek,
  // days before yesterday, maybe in this week or last week
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: checkWeek,
  // days after tomorrow, maybe in this week or next week
  other: 'PP p'
};
function formatRelative$2(token, _date, _baseDate, _options) {
  var format = formatRelativeLocale$2[token];

  if (typeof format === 'function') {
    return format(_date, _baseDate, _options, 'eeee p');
  }

  return format;
}

var eraValues$2 = {
  narrow: ['前', '公元'],
  abbreviated: ['前', '公元'],
  wide: ['公元前', '公元']
};
var quarterValues$2 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['第一季', '第二季', '第三季', '第四季'],
  wide: ['第一季度', '第二季度', '第三季度', '第四季度']
};
var monthValues$2 = {
  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
};
var dayValues$2 = {
  narrow: ['日', '一', '二', '三', '四', '五', '六'],
  short: ['日', '一', '二', '三', '四', '五', '六'],
  abbreviated: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
};
var dayPeriodValues$2 = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '凌晨',
    noon: '午',
    morning: '早',
    afternoon: '下午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  }
};
var formattingDayPeriodValues$2 = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '凌晨',
    noon: '午',
    morning: '早',
    afternoon: '下午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜间'
  }
};

function ordinalNumber$2(dirtyNumber, dirtyOptions) {
  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'
  var number = Number(dirtyNumber);
  var options = dirtyOptions || {};
  var unit = String(options.unit);

  switch (unit) {
    case 'date':
      return number.toString() + '日';

    case 'hour':
      return number.toString() + '时';

    case 'minute':
      return number.toString() + '分';

    case 'second':
      return number.toString() + '秒';

    default:
      return '第 ' + number.toString();
  }
}

var localize$4 = {
  ordinalNumber: ordinalNumber$2,
  era: buildLocalizeFn({
    values: eraValues$2,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$2,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$2,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$2,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$2,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$2,
    defaultFormattingWidth: 'wide'
  })
};
var localize$5 = localize$4;

var matchOrdinalNumberPattern$2 = /^(第\s*)?\d+(日|时|分|秒)?/i;
var parseOrdinalNumberPattern$2 = /\d+/i;
var matchEraPatterns$2 = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
};
var parseEraPatterns$2 = {
  any: [/^(前)/i, /^(公元)/i]
};
var matchQuarterPatterns$2 = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻钟/i
};
var parseQuarterPatterns$2 = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
};
var matchMonthPatterns$2 = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns$2 = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
};
var matchDayPatterns$2 = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^周[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns$2 = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
};
var matchDayPeriodPatterns$2 = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var parseDayPeriodPatterns$2 = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
};
var match$4 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$2,
    parsePattern: parseOrdinalNumberPattern$2,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$2,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$2,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$2,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$2,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$2,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$2,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$2,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$2,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$2,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$2,
    defaultParseWidth: 'any'
  })
};
var match$5 = match$4;

/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */

var locale$4 = {
  code: 'zh-CN',
  formatDistance: formatDistance$2,
  formatLong: formatLong$5,
  formatRelative: formatRelative$2,
  localize: localize$5,
  match: match$5,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$5 = locale$4;

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: '少於 1 秒',
    other: '少於 {{count}} 秒'
  },
  xSeconds: {
    one: '1 秒',
    other: '{{count}} 秒'
  },
  halfAMinute: '半分鐘',
  lessThanXMinutes: {
    one: '少於 1 分鐘',
    other: '少於 {{count}} 分鐘'
  },
  xMinutes: {
    one: '1 分鐘',
    other: '{{count}} 分鐘'
  },
  xHours: {
    one: '1 小時',
    other: '{{count}} 小時'
  },
  aboutXHours: {
    one: '大約 1 小時',
    other: '大約 {{count}} 小時'
  },
  xDays: {
    one: '1 天',
    other: '{{count}} 天'
  },
  aboutXWeeks: {
    one: '大約 1 個星期',
    other: '大約 {{count}} 個星期'
  },
  xWeeks: {
    one: '1 個星期',
    other: '{{count}} 個星期'
  },
  aboutXMonths: {
    one: '大約 1 個月',
    other: '大約 {{count}} 個月'
  },
  xMonths: {
    one: '1 個月',
    other: '{{count}} 個月'
  },
  aboutXYears: {
    one: '大約 1 年',
    other: '大約 {{count}} 年'
  },
  xYears: {
    one: '1 年',
    other: '{{count}} 年'
  },
  overXYears: {
    one: '超過 1 年',
    other: '超過 {{count}} 年'
  },
  almostXYears: {
    one: '將近 1 年',
    other: '將近 {{count}} 年'
  }
};
function formatDistance$1(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale$1[token] === 'string') {
    result = formatDistanceLocale$1[token];
  } else if (count === 1) {
    result = formatDistanceLocale$1[token].one;
  } else {
    result = formatDistanceLocale$1[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result + '內';
    } else {
      return result + '前';
    }
  }

  return result;
}

var dateFormats$1 = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: 'yyyy-MM-dd',
  short: 'yy-MM-dd'
};
var timeFormats$1 = {
  full: 'zzzz a h:mm:ss',
  long: 'z a h:mm:ss',
  medium: 'a h:mm:ss',
  short: 'a h:mm'
};
var dateTimeFormats$1 = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};
var formatLong$3 = formatLong$2;

var formatRelativeLocale$1 = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: 'P'
};
function formatRelative$1(token, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token];
}

var eraValues$1 = {
  narrow: ['前', '公元'],
  abbreviated: ['前', '公元'],
  wide: ['公元前', '公元']
};
var quarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['第一季', '第二季', '第三季', '第四季'],
  wide: ['第一季度', '第二季度', '第三季度', '第四季度']
};
var monthValues$1 = {
  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
};
var dayValues$1 = {
  narrow: ['日', '一', '二', '三', '四', '五', '六'],
  short: ['日', '一', '二', '三', '四', '五', '六'],
  abbreviated: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
};
var dayPeriodValues$1 = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '午夜',
    noon: '晌',
    morning: '早',
    afternoon: '午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '午夜',
    noon: '中午',
    morning: '上午',
    afternoon: '下午',
    evening: '晚上',
    night: '夜晚'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '午夜',
    noon: '中午',
    morning: '上午',
    afternoon: '下午',
    evening: '晚上',
    night: '夜晚'
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '午夜',
    noon: '晌',
    morning: '早',
    afternoon: '午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '午夜',
    noon: '中午',
    morning: '上午',
    afternoon: '下午',
    evening: '晚上',
    night: '夜晚'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '午夜',
    noon: '中午',
    morning: '上午',
    afternoon: '下午',
    evening: '晚上',
    night: '夜晚'
  }
};

function ordinalNumber$1(dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var options = dirtyOptions || {};
  var unit = String(options.unit);

  switch (unit) {
    case 'date':
      return number.toString() + '日';

    case 'hour':
      return number.toString() + '時';

    case 'minute':
      return number.toString() + '分';

    case 'second':
      return number.toString() + '秒';

    default:
      return '第 ' + number.toString();
  }
}

var localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: 'wide'
  })
};
var localize$3 = localize$2;

var matchOrdinalNumberPattern$1 = /^(第\s*)?\d+(日|時|分|秒)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
};
var parseEraPatterns$1 = {
  any: [/^(前)/i, /^(公元)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]季/i,
  wide: /^第[一二三四]季度/i
};
var parseQuarterPatterns$1 = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
};
var matchMonthPatterns$1 = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns$1 = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
};
var matchDayPatterns$1 = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns$1 = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
};
var matchDayPeriodPatterns$1 = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
};
var match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};
var match$3 = match$2;

/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
 */

var locale$2 = {
  code: 'zh-HK',
  formatDistance: formatDistance$1,
  formatLong: formatLong$3,
  formatRelative: formatRelative$1,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var locale$3 = locale$2;

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: '少於 1 秒',
    other: '少於 {{count}} 秒'
  },
  xSeconds: {
    one: '1 秒',
    other: '{{count}} 秒'
  },
  halfAMinute: '半分鐘',
  lessThanXMinutes: {
    one: '少於 1 分鐘',
    other: '少於 {{count}} 分鐘'
  },
  xMinutes: {
    one: '1 分鐘',
    other: '{{count}} 分鐘'
  },
  xHours: {
    one: '1 小時',
    other: '{{count}} 小時'
  },
  aboutXHours: {
    one: '大約 1 小時',
    other: '大約 {{count}} 小時'
  },
  xDays: {
    one: '1 天',
    other: '{{count}} 天'
  },
  aboutXWeeks: {
    one: '大約 1 個星期',
    other: '大約 {{count}} 個星期'
  },
  xWeeks: {
    one: '1 個星期',
    other: '{{count}} 個星期'
  },
  aboutXMonths: {
    one: '大約 1 個月',
    other: '大約 {{count}} 個月'
  },
  xMonths: {
    one: '1 個月',
    other: '{{count}} 個月'
  },
  aboutXYears: {
    one: '大約 1 年',
    other: '大約 {{count}} 年'
  },
  xYears: {
    one: '1 年',
    other: '{{count}} 年'
  },
  overXYears: {
    one: '超過 1 年',
    other: '超過 {{count}} 年'
  },
  almostXYears: {
    one: '將近 1 年',
    other: '將近 {{count}} 年'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return result + '內';
    } else {
      return result + '前';
    }
  }

  return result;
}

var dateFormats = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: 'yyyy-MM-dd',
  short: 'yy-MM-dd'
};
var timeFormats = {
  full: 'zzzz a h:mm:ss',
  long: 'z a h:mm:ss',
  medium: 'a h:mm:ss',
  short: 'a h:mm'
};
var dateTimeFormats = {
  full: '{{date}} {{time}}',
  long: '{{date}} {{time}}',
  medium: '{{date}} {{time}}',
  short: '{{date}} {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

var eraValues = {
  narrow: ['前', '公元'],
  abbreviated: ['前', '公元'],
  wide: ['公元前', '公元']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['第一刻', '第二刻', '第三刻', '第四刻'],
  wide: ['第一刻鐘', '第二刻鐘', '第三刻鐘', '第四刻鐘']
};
var monthValues = {
  narrow: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二'],
  abbreviated: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
  wide: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
};
var dayValues = {
  narrow: ['日', '一', '二', '三', '四', '五', '六'],
  short: ['日', '一', '二', '三', '四', '五', '六'],
  abbreviated: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
  wide: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
};
var dayPeriodValues = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '凌晨',
    noon: '午',
    morning: '早',
    afternoon: '下午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜間'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜間'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: '上',
    pm: '下',
    midnight: '凌晨',
    noon: '午',
    morning: '早',
    afternoon: '下午',
    evening: '晚',
    night: '夜'
  },
  abbreviated: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜間'
  },
  wide: {
    am: '上午',
    pm: '下午',
    midnight: '凌晨',
    noon: '中午',
    morning: '早晨',
    afternoon: '中午',
    evening: '晚上',
    night: '夜間'
  }
};

function ordinalNumber(dirtyNumber, dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var options = dirtyOptions || {};
  var unit = String(options.unit);

  switch (unit) {
    case 'date':
      return number.toString() + '日';

    case 'hour':
      return number.toString() + '時';

    case 'minute':
      return number.toString() + '分';

    case 'second':
      return number.toString() + '秒';

    default:
      return '第 ' + number.toString();
  }
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

var matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
};
var parseEraPatterns = {
  any: [/^(前)/i, /^(公元)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻鐘/i
};
var parseQuarterPatterns = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
};
var matchMonthPatterns = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var parseMonthPatterns = {
  narrow: [/^一/i, /^二/i, /^三/i, /^四/i, /^五/i, /^六/i, /^七/i, /^八/i, /^九/i, /^十(?!(一|二))/i, /^十一/i, /^十二/i],
  any: [/^一|1/i, /^二|2/i, /^三|3/i, /^四|4/i, /^五|5/i, /^六|6/i, /^七|7/i, /^八|8/i, /^九|9/i, /^十(?!(一|二))|10/i, /^十一|11/i, /^十二|12/i]
};
var matchDayPatterns = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
};
var parseDayPatterns = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
};
var matchDayPeriodPatterns = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */

var locale = {
  code: 'zh-TW',
  formatDistance: formatDistance,
  formatLong: formatLong$1,
  formatRelative: formatRelative,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};
var locale$1 = locale;

// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

var Locales = /*#__PURE__*/Object.freeze({
  __proto__: null,
  af: locale$2O,
  ar: locale$2M,
  arDZ: locale$2K,
  arEG: locale$2I,
  arMA: locale$2G,
  arSA: locale$2E,
  arTN: locale$2C,
  az: locale$2A,
  be: locale$2x,
  bg: locale$2v,
  bn: locale$2t,
  bs: locale$2r,
  ca: locale$2p,
  cs: locale$2n,
  cy: locale$2l,
  da: locale$2j,
  de: locale$2h,
  deAT: locale$2f,
  el: locale$2d,
  enAU: locale$2b,
  enCA: locale$29,
  enGB: locale$27,
  enIE: locale$25,
  enIN: locale$23,
  enNZ: locale$21,
  enUS: defaultLocale,
  enZA: locale$1$,
  eo: locale$1Z,
  es: locale$1X,
  et: locale$1V,
  eu: locale$1T,
  faIR: locale$1R,
  fi: locale$1P,
  fr: locale$1N,
  frCA: locale$1L,
  frCH: locale$1J,
  fy: locale$1H,
  gd: locale$1F,
  gl: locale$1D,
  gu: locale$1B,
  he: locale$1z,
  hi: locale$1x,
  hr: locale$1v,
  ht: locale$1t,
  hu: locale$1r,
  hy: locale$1p,
  id: locale$1n,
  is: locale$1l,
  it: locale$1j,
  ja: locale$1h,
  jaHira: locale$1f,
  ka: locale$1d,
  kk: locale$1b,
  km: locale$19,
  kn: locale$17,
  ko: locale$15,
  lb: locale$13,
  lt: locale$11,
  lv: locale$$,
  mk: locale$Z,
  mn: locale$X,
  ms: locale$V,
  mt: locale$T,
  nb: locale$R,
  nl: locale$P,
  nlBE: locale$N,
  nn: locale$L,
  pl: locale$J,
  pt: locale$H,
  ptBR: locale$F,
  ro: locale$D,
  ru: locale$B,
  sk: locale$z,
  sl: locale$x,
  sq: locale$v,
  sr: locale$t,
  srLatn: locale$r,
  sv: locale$p,
  ta: locale$n,
  te: locale$l,
  th: locale$j,
  tr: locale$h,
  ug: locale$f,
  uk: locale$d,
  uz: locale$b,
  uzCyrl: locale$9,
  vi: locale$7,
  zhCN: locale$5,
  zhHK: locale$3,
  zhTW: locale$1
});

var longFormatters$1 = {exports: {}};

(function (module, exports) {

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;

	function dateLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'P':
	      return formatLong.date({
	        width: 'short'
	      });

	    case 'PP':
	      return formatLong.date({
	        width: 'medium'
	      });

	    case 'PPP':
	      return formatLong.date({
	        width: 'long'
	      });

	    case 'PPPP':
	    default:
	      return formatLong.date({
	        width: 'full'
	      });
	  }
	}

	function timeLongFormatter(pattern, formatLong) {
	  switch (pattern) {
	    case 'p':
	      return formatLong.time({
	        width: 'short'
	      });

	    case 'pp':
	      return formatLong.time({
	        width: 'medium'
	      });

	    case 'ppp':
	      return formatLong.time({
	        width: 'long'
	      });

	    case 'pppp':
	    default:
	      return formatLong.time({
	        width: 'full'
	      });
	  }
	}

	function dateTimeLongFormatter(pattern, formatLong) {
	  var matchResult = pattern.match(/(P+)(p+)?/) || [];
	  var datePattern = matchResult[1];
	  var timePattern = matchResult[2];

	  if (!timePattern) {
	    return dateLongFormatter(pattern, formatLong);
	  }

	  var dateTimeFormat;

	  switch (datePattern) {
	    case 'P':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'short'
	      });
	      break;

	    case 'PP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'medium'
	      });
	      break;

	    case 'PPP':
	      dateTimeFormat = formatLong.dateTime({
	        width: 'long'
	      });
	      break;

	    case 'PPPP':
	    default:
	      dateTimeFormat = formatLong.dateTime({
	        width: 'full'
	      });
	      break;
	  }

	  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
	}

	var longFormatters = {
	  p: timeLongFormatter,
	  P: dateTimeLongFormatter
	};
	var _default = longFormatters;
	exports.default = _default;
	module.exports = exports.default; 
} (longFormatters$1, longFormatters$1.exports));

var longFormattersExports = longFormatters$1.exports;
var longFormatters = /*@__PURE__*/getDefaultExportFromCjs(longFormattersExports);

var defaultFormats = {
    dayOfMonth: "d",
    fullDate: "PP",
    fullDateWithWeekday: "PPPP",
    fullDateTime: "PP p",
    fullDateTime12h: "PP hh:mm aaa",
    fullDateTime24h: "PP HH:mm",
    fullTime: "p",
    fullTime12h: "hh:mm aaa",
    fullTime24h: "HH:mm",
    hours12h: "hh",
    hours24h: "HH",
    keyboardDate: "P",
    keyboardDateTime: "P p",
    keyboardDateTime12h: "P hh:mm aaa",
    keyboardDateTime24h: "P HH:mm",
    minutes: "mm",
    month: "LLLL",
    monthAndDate: "MMMM d",
    monthAndYear: "LLLL yyyy",
    monthShort: "MMM",
    weekday: "EEEE",
    weekdayShort: "EEE",
    normalDate: "d MMMM",
    normalDateWithWeekday: "EEE, MMM d",
    seconds: "ss",
    shortDate: "MMM d",
    year: "yyyy",
};
var DateFnsUtils = /** @class */ (function () {
    function DateFnsUtils(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, locale = _b.locale, formats = _b.formats;
        this.lib = "date-fns";
        // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
        // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
        this.is12HourCycleInCurrentLocale = function () {
            if (_this.locale) {
                return /a/.test(_this.locale.formatLong.time());
            }
            // By default date-fns is using en-US locale with am/pm enabled
            return true;
        };
        this.getFormatHelperText = function (format) {
            // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
            var longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
            var locale = _this.locale || defaultLocale;
            return format
                .match(longFormatRegexp)
                .map(function (token) {
                var firstCharacter = token[0];
                if (firstCharacter === "p" || firstCharacter === "P") {
                    var longFormatter = longFormatters[firstCharacter];
                    return longFormatter(token, locale.formatLong, {});
                }
                return token;
            })
                .join("")
                .replace(/(aaa|aa|a)/g, "(a|p)m")
                .toLocaleLowerCase();
        };
        this.parseISO = function (isoString) {
            return parseISO(isoString);
        };
        this.toISO = function (value) {
            return formatISO(value, { format: "extended" });
        };
        this.getCurrentLocaleCode = function () {
            var _a;
            return ((_a = _this.locale) === null || _a === void 0 ? void 0 : _a.code) || "en-US";
        };
        this.addSeconds = function (value, count) {
            return addSeconds(value, count);
        };
        this.addMinutes = function (value, count) {
            return addMinutes(value, count);
        };
        this.addHours = function (value, count) {
            return addHours(value, count);
        };
        this.addDays = function (value, count) {
            return addDays(value, count);
        };
        this.addWeeks = function (value, count) {
            return addWeeks(value, count);
        };
        this.addMonths = function (value, count) {
            return addMonths(value, count);
        };
        this.isValid = function (value) {
            return isValid(_this.date(value));
        };
        this.getDiff = function (value, comparing, unit) {
            switch (unit) {
                case "years":
                    return differenceInYears(value, _this.date(comparing));
                case "quarters":
                    return differenceInQuarters(value, _this.date(comparing));
                case "months":
                    return differenceInMonths(value, _this.date(comparing));
                case "weeks":
                    return differenceInWeeks(value, _this.date(comparing));
                case "days":
                    return differenceInDays(value, _this.date(comparing));
                case "hours":
                    return differenceInHours(value, _this.date(comparing));
                case "minutes":
                    return differenceInMinutes(value, _this.date(comparing));
                case "seconds":
                    return differenceInSeconds(value, _this.date(comparing));
                default: {
                    return differenceInMilliseconds(value, _this.date(comparing));
                }
            }
        };
        this.isAfter = function (value, comparing) {
            return isAfter(value, comparing);
        };
        this.isBefore = function (value, comparing) {
            return isBefore(value, comparing);
        };
        this.startOfDay = function (value) {
            return startOfDay(value);
        };
        this.endOfDay = function (value) {
            return endOfDay(value);
        };
        this.getHours = function (value) {
            return getHours$1(value);
        };
        this.setHours = function (value, count) {
            return setHours(value, count);
        };
        this.setMinutes = function (value, count) {
            return setMinutes(value, count);
        };
        this.getSeconds = function (value) {
            return getSeconds(value);
        };
        this.setSeconds = function (value, count) {
            return setSeconds(value, count);
        };
        this.isSameDay = function (value, comparing) {
            return isSameDay(value, comparing);
        };
        this.isSameMonth = function (value, comparing) {
            return isSameMonth(value, comparing);
        };
        this.isSameYear = function (value, comparing) {
            return isSameYear(value, comparing);
        };
        this.isSameHour = function (value, comparing) {
            return isSameHour(value, comparing);
        };
        this.startOfMonth = function (value) {
            return startOfMonth(value);
        };
        this.endOfMonth = function (value) {
            return endOfMonth(value);
        };
        this.startOfWeek = function (value) {
            return startOfWeek(value, { locale: _this.locale });
        };
        this.endOfWeek = function (value) {
            return endOfWeek(value, { locale: _this.locale });
        };
        this.getYear = function (value) {
            return getYear(value);
        };
        this.setYear = function (value, count) {
            return setYear(value, count);
        };
        this.date = function (value) {
            if (typeof value === "undefined") {
                return new Date();
            }
            if (value === null) {
                return null;
            }
            return new Date(value);
        };
        this.toJsDate = function (value) {
            return value;
        };
        this.parse = function (value, formatString) {
            if (value === "") {
                return null;
            }
            return parse(value, formatString, new Date(), { locale: _this.locale });
        };
        this.format = function (date, formatKey) {
            return _this.formatByString(date, _this.formats[formatKey]);
        };
        this.formatByString = function (date, formatString) {
            return format(date, formatString, { locale: _this.locale });
        };
        this.isEqual = function (date, comparing) {
            if (date === null && comparing === null) {
                return true;
            }
            return isEqual(date, comparing);
        };
        this.isNull = function (date) {
            return date === null;
        };
        this.isAfterDay = function (date, value) {
            return isAfter(date, endOfDay(value));
        };
        this.isBeforeDay = function (date, value) {
            return isBefore(date, startOfDay(value));
        };
        this.isBeforeYear = function (date, value) {
            return isBefore(date, startOfYear(value));
        };
        this.isAfterYear = function (date, value) {
            return isAfter(date, endOfYear(value));
        };
        this.isWithinRange = function (date, _a) {
            var start = _a[0], end = _a[1];
            return isWithinInterval(date, { start: start, end: end });
        };
        this.formatNumber = function (numberToFormat) {
            return numberToFormat;
        };
        this.getMinutes = function (date) {
            return date.getMinutes();
        };
        this.getMonth = function (date) {
            return date.getMonth();
        };
        this.getDaysInMonth = function (date) {
            return getDaysInMonth(date);
        };
        this.setMonth = function (date, count) {
            return setMonth(date, count);
        };
        this.getMeridiemText = function (ampm) {
            return ampm === "am" ? "AM" : "PM";
        };
        this.getNextMonth = function (date) {
            return addMonths(date, 1);
        };
        this.getPreviousMonth = function (date) {
            return addMonths(date, -1);
        };
        this.getMonthArray = function (date) {
            var firstMonth = startOfYear(date);
            var monthArray = [firstMonth];
            while (monthArray.length < 12) {
                var prevMonth = monthArray[monthArray.length - 1];
                monthArray.push(_this.getNextMonth(prevMonth));
            }
            return monthArray;
        };
        this.mergeDateAndTime = function (date, time) {
            return _this.setSeconds(_this.setMinutes(_this.setHours(date, _this.getHours(time)), _this.getMinutes(time)), _this.getSeconds(time));
        };
        this.getWeekdays = function () {
            var now = new Date();
            return eachDayOfInterval({
                start: startOfWeek(now, { locale: _this.locale }),
                end: endOfWeek(now, { locale: _this.locale }),
            }).map(function (day) { return _this.formatByString(day, "EEEEEE"); });
        };
        this.getWeekArray = function (date) {
            var start = startOfWeek(startOfMonth(date), { locale: _this.locale });
            var end = endOfWeek(endOfMonth(date), { locale: _this.locale });
            var count = 0;
            var current = start;
            var nestedWeeks = [];
            var lastDay = null;
            while (isBefore(current, end)) {
                var weekNumber = Math.floor(count / 7);
                nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
                var day = getDay(current);
                if (lastDay !== day) {
                    lastDay = day;
                    nestedWeeks[weekNumber].push(current);
                    count += 1;
                }
                current = addDays(current, 1);
            }
            return nestedWeeks;
        };
        this.getYearRange = function (start, end) {
            var startDate = startOfYear(start);
            var endDate = endOfYear(end);
            var years = [];
            var current = startDate;
            while (isBefore(current, endDate)) {
                years.push(current);
                current = addYears(current, 1);
            }
            return years;
        };
        this.locale = locale;
        this.formats = Object.assign({}, defaultFormats, formats);
    }
    return DateFnsUtils;
}());

function withDefaultProps(_ref, Component) {
  var name = _ref.name;
  return function (_ref2) {
    var props = _extends({}, _ref2);

    var theme = useTheme$2();
    var propsWithDefault = getThemeProps({
      props: props,
      theme: theme,
      name: name
    });
    return /*#__PURE__*/createElement(Component, propsWithDefault);
  };
}

var MuiPickersAdapterContext = createContext(null);
var LocalizationProvider = function LocalizationProvider(_ref) {
  var Utils = _ref.dateAdapter,
      children = _ref.children,
      locale = _ref.locale,
      libFormats = _ref.dateFormats,
      libInstance = _ref.dateLibInstance;
  var utils = useMemo$1(function () {
    return new Utils({
      locale: locale,
      formats: libFormats,
      instance: libInstance
    });
  }, [Utils, locale, libFormats, libInstance]);
  return /*#__PURE__*/createElement(MuiPickersAdapterContext.Provider, {
    value: utils,
    children: children
  });
};
process.env.NODE_ENV !== "production" ? LocalizationProvider.propTypes = {
  dateAdapter: propTypesExports.func.isRequired,
  locale: propTypesExports.oneOfType([propTypesExports.object, propTypesExports.string]),

  /**
   * Your component tree.
   */
  children: propTypesExports.node.isRequired
} : void 0;
var LocalizationProvider$1 = withDefaultProps({
  name: 'MuiPickersLocalizationProvider'
}, LocalizationProvider);

// TODO uncomment when syntax will be allowed by next babel
function checkUtils(utils)
/* : asserts utils is MuiPickersUtils */
{
  if (!utils) {
    throw new Error('Can not find utils in context. It looks like you forgot to wrap your component in LocalizationProvider, or pass dateAdapter prop directly.');
  }
}

function useUtils() {
  var utils = useContext(MuiPickersAdapterContext);
  checkUtils(utils);
  return utils;
}
function useNow() {
  var utils = useUtils();
  var now = useRef(utils.date());
  return now.current;
}

var DIALOG_WIDTH = 320;
var DIALOG_WIDTH_WIDER = 325;
var VIEW_HEIGHT = 358;
var DAY_SIZE = 36;
var DAY_MARGIN = 2;
var IS_TOUCH_DEVICE_MEDIA = '@media (pointer: fine)';

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

/* Use it instead of .includes method for IE support */
function arrayIncludes(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(function (item) {
      return array.indexOf(item) !== -1;
    });
  }

  return array.indexOf(itemOrItems) !== -1;
}
var onSpaceOrEnter = function onSpaceOrEnter(innerFn, onFocus) {
  return function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      innerFn(); // prevent any side effects

      e.preventDefault();
      e.stopPropagation();
    }

    if (onFocus) {
      onFocus(e);
    }
  };
};
/* Quick untyped helper to improve function composition readability */

var pipe = function pipe() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return fns.reduceRight(function (prevFn, nextFn) {
    return function () {
      return nextFn(prevFn.apply(void 0, arguments));
    };
  }, function (value) {
    return value;
  });
};
function createDelegatedEventHandler(fn, onEvent) {
  return function (event) {
    fn(event);

    if (onEvent) {
      onEvent(event);
    }
  };
}

function useOpenState(_ref) {
  var open = _ref.open,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose;
  var isControllingOpenProp = useRef(typeof open === 'boolean').current;

  var _React$useState = useState(false),
      _React$useState2 = _slicedToArray$8(_React$useState, 2),
      _open = _React$useState2[0],
      _setIsOpen = _React$useState2[1]; // It is required to update inner state in useEffect in order to avoid situation when
  // Our component is not mounted yet, but `open` state is set to `true` (e.g. initially opened)


  useEffect(function () {
    if (isControllingOpenProp) {
      if (typeof open !== 'boolean') {
        throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
      }

      _setIsOpen(open);
    }
  }, [isControllingOpenProp, open]);
  var setIsOpen = useCallback$1(function (newIsOpen) {
    if (!isControllingOpenProp) {
      _setIsOpen(newIsOpen);
    }

    return newIsOpen ? onOpen && onOpen() : onClose && onClose();
  }, [isControllingOpenProp, onOpen, onClose]);
  return {
    isOpen: _open,
    setIsOpen: setIsOpen
  };
}

var FORCE_FINISH_PICKER = Symbol('Force closing picker, useful for accessibility');
function usePickerState(props, valueManager) {
  var autoOk = props.autoOk,
      inputFormat = props.inputFormat,
      disabled = props.disabled,
      readOnly = props.readOnly,
      onAccept = props.onAccept,
      onChange = props.onChange,
      value = props.value;

  if (!inputFormat) {
    throw new Error('inputFormat prop is required');
  }

  var now = useNow();
  var utils = useUtils();

  var _useOpenState = useOpenState(props),
      isOpen = _useOpenState.isOpen,
      setIsOpen = _useOpenState.setIsOpen;

  var _React$useState = useState(valueManager.parseInput(utils, props)),
      _React$useState2 = _slicedToArray$8(_React$useState, 2),
      pickerDate = _React$useState2[0],
      setPickerDate = _React$useState2[1]; // Mobile keyboard view is a special case.
  // When it's open picker should work like closed, cause we are just showing text field


  var _React$useState3 = useState(false),
      _React$useState4 = _slicedToArray$8(_React$useState3, 2),
      isMobileKeyboardViewOpen = _React$useState4[0],
      setMobileKeyboardViewOpen = _React$useState4[1];

  useEffect(function () {
    var parsedDateValue = valueManager.parseInput(utils, props);
    setPickerDate(function (currentPickerDate) {
      if (!valueManager.areValuesEqual(utils, currentPickerDate, parsedDateValue)) {
        return parsedDateValue;
      }

      return currentPickerDate;
    }); // We need to react only on value change, because `date` could potentially return new Date() on each render
  }, [value, utils]); // eslint-disable-line

  var acceptDate = useCallback$1(function (acceptedDate, needClosePicker) {
    onChange(acceptedDate);

    if (needClosePicker) {
      setIsOpen(false);

      if (onAccept) {
        onAccept(acceptedDate);
      }
    }
  }, [onAccept, onChange, setIsOpen]);
  var wrapperProps = useMemo$1(function () {
    return {
      open: isOpen,
      onClear: function onClear() {
        return acceptDate(valueManager.emptyValue, true);
      },
      onAccept: function onAccept() {
        return acceptDate(pickerDate, true);
      },
      onDismiss: function onDismiss() {
        return setIsOpen(false);
      },
      onSetToday: function onSetToday() {
        // TODO FIX ME
        setPickerDate(now);
        acceptDate(now, Boolean(autoOk));
      }
    };
  }, [acceptDate, autoOk, isOpen, now, pickerDate, setIsOpen, valueManager.emptyValue]);
  var pickerProps = useMemo$1(function () {
    return {
      date: pickerDate,
      isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
      toggleMobileKeyboardView: function toggleMobileKeyboardView() {
        if (!isMobileKeyboardViewOpen) {
          // accept any partial input done by React.user
          setPickerDate(pickerDate);
        }

        setMobileKeyboardViewOpen(!isMobileKeyboardViewOpen);
      },
      onDateChange: function onDateChange(newDate, currentVariant) {
        var isFinish = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        setPickerDate(newDate);
        var isFinishing = typeof isFinish === 'boolean' ? isFinish : isFinish === FORCE_FINISH_PICKER;

        if (isFinishing) {
          var autoAcceptRequested = Boolean(autoOk) || isFinish === FORCE_FINISH_PICKER;

          if (currentVariant === 'mobile' && autoAcceptRequested) {
            acceptDate(newDate, true);
          }

          if (currentVariant !== 'mobile') {
            acceptDate(newDate, autoAcceptRequested);
          }
        }
      }
    };
  }, [acceptDate, autoOk, isMobileKeyboardViewOpen, pickerDate]);
  var inputProps = useMemo$1(function () {
    return {
      onChange: onChange,
      inputFormat: inputFormat,
      open: isOpen,
      rawValue: value,
      openPicker: function openPicker() {
        return !readOnly && !disabled && setIsOpen(true);
      }
    };
  }, [onChange, inputFormat, isOpen, value, readOnly, disabled, setIsOpen]);
  var pickerState = {
    pickerProps: pickerProps,
    inputProps: inputProps,
    wrapperProps: wrapperProps
  };
  useDebugValue(pickerState, function () {
    return {
      MuiPickerState: {
        pickerDate: pickerDate,
        other: pickerState
      }
    };
  });
  return pickerState;
}

var useIsomorphicEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect$1;
function runKeyHandler(e, keyHandlers) {
  var handler = keyHandlers[e.keyCode];

  if (handler) {
    handler(); // if event was handled prevent other side effects (e.g. page scroll)

    e.preventDefault();
  }
}
function useGlobalKeyDown(active, keyHandlers) {
  var keyHandlersRef = useRef(keyHandlers);
  keyHandlersRef.current = keyHandlers;
  useIsomorphicEffect(function () {
    if (active) {
      var handleKeyDown = function handleKeyDown(event) {
        runKeyHandler(event, keyHandlersRef.current);
      };

      window.addEventListener('keydown', handleKeyDown);
      return function () {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [active]);
}
var keycode = {
  ArrowUp: 38,
  ArrowDown: 40,
  ArrowLeft: 37,
  ArrowRight: 39,
  Enter: 13,
  Home: 36,
  End: 35,
  PageUp: 33,
  PageDown: 34,
  Esc: 27
};

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$3(subClass, superClass);
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof$4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized$3(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

// consider getting rid from wrapper variant
var WrapperVariantContext = createContext(null);
var IsStaticVariantContext = createContext(false);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
var ClockPointer = /*#__PURE__*/function (_React$Component) {
  _inherits(ClockPointer, _React$Component);

  var _super = _createSuper(ClockPointer);

  function ClockPointer() {
    var _this;

    _classCallCheck$3(this, ClockPointer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      toAnimateTransform: false,
      previousType: undefined
    };

    _this.getAngleStyle = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          isInner = _this$props.isInner,
          type = _this$props.type;
      var max = type === 'hours' ? 12 : 60;
      var angle = 360 / max * value;

      if (type === 'hours' && value > 12) {
        angle -= 360; // round up angle to max 360 degrees
      }

      return {
        height: isInner ? '26%' : '40%',
        transform: "rotateZ(".concat(angle, "deg)")
      };
    };

    return _this;
  }

  _createClass$3(ClockPointer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          hasSelected = _this$props2.hasSelected;
          _this$props2.isInner;
          _this$props2.type;
          _this$props2.value;
          var other = _objectWithoutProperties$4(_this$props2, ["classes", "hasSelected", "isInner", "type", "value"]);

      return /*#__PURE__*/createElement("div", _extends({}, other, {
        style: this.getAngleStyle(),
        className: clsx(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
      }), /*#__PURE__*/createElement("div", {
        className: clsx(classes.thumb, hasSelected && classes.noPoint)
      }));
    }
  }]);

  return ClockPointer;
}(Component);

ClockPointer.getDerivedStateFromProps = function (nextProps, state) {
  if (nextProps.type !== state.previousType) {
    return {
      toAnimateTransform: true,
      previousType: nextProps.type
    };
  }

  return {
    toAnimateTransform: false,
    previousType: nextProps.type
  };
};

var styles$t = function styles(theme) {
  return createStyles({
    pointer: {
      width: 2,
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      left: 'calc(50% - 1px)',
      bottom: '50%',
      transformOrigin: 'center bottom 0px'
    },
    animateTransform: {
      transition: theme.transitions.create(['transform', 'height'])
    },
    thumb: {
      width: 4,
      height: 4,
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: '100%',
      position: 'absolute',
      top: -21,
      left: -15,
      border: "14px solid ".concat(theme.palette.primary.main),
      boxSizing: 'content-box'
    },
    noPoint: {
      backgroundColor: theme.palette.primary.main
    }
  });
};
var ClockPointer$1 = withStyles(styles$t, {
  name: 'MuiPickersClockPointer'
})(ClockPointer);

var getMeridiem = function getMeridiem(date, utils) {
  if (!date) {
    return null;
  }

  return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var convertValueToMeridiem = function convertValueToMeridiem(value, meridiem, ampm) {
  if (ampm) {
    var currentMeridiem = value >= 12 ? 'pm' : 'am';

    if (currentMeridiem !== meridiem) {
      return meridiem === 'am' ? value - 12 : value + 12;
    }
  }

  return value;
};
var convertToMeridiem = function convertToMeridiem(time, meridiem, ampm, utils) {
  var newHoursAmount = convertValueToMeridiem(utils.getHours(time), meridiem, ampm);
  return utils.setHours(time, newHoursAmount);
};
var clockCenter = {
  x: 260 / 2,
  y: 260 / 2
};
var baseClockPoint = {
  x: clockCenter.x,
  y: 0
};
var cx = baseClockPoint.x - clockCenter.x;
var cy = baseClockPoint.y - clockCenter.y;

var rad2deg = function rad2deg(rad) {
  return rad * 57.29577951308232;
};

var getAngleValue = function getAngleValue(step, offsetX, offsetY) {
  var x = offsetX - clockCenter.x;
  var y = offsetY - clockCenter.y;
  var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
  var deg = rad2deg(atan);
  deg = Math.round(deg / step) * step;
  deg %= 360;
  var value = Math.floor(deg / step) || 0;
  var delta = Math.pow(x, 2) + Math.pow(y, 2);
  var distance = Math.sqrt(delta);
  return {
    value: value,
    distance: distance
  };
};

var getMinutes = function getMinutes(offsetX, offsetY) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var angleStep = step * 6;

  var _getAngleValue = getAngleValue(angleStep, offsetX, offsetY),
      value = _getAngleValue.value;

  value = value * step % 60;
  return value;
};
var getHours = function getHours(offsetX, offsetY, ampm) {
  var _getAngleValue2 = getAngleValue(30, offsetX, offsetY),
      value = _getAngleValue2.value,
      distance = _getAngleValue2.distance;

  value = value || 12;

  if (!ampm) {
    if (distance < 90) {
      value += 12;
      value %= 24;
    }
  } else {
    value %= 12;
  }

  return value;
};
function getSecondsInDay(date, utils) {
  return utils.getHours(date) * 3600 + utils.getMinutes(date) * 60 + utils.getSeconds(date);
}
var createIsAfterIgnoreDatePart = function createIsAfterIgnoreDatePart(disableIgnoringDatePartForTimeValidation, utils) {
  return function (dateLeft, dateRight) {
    if (disableIgnoringDatePartForTimeValidation) {
      return utils.isAfter(dateLeft, dateRight);
    }

    return getSecondsInDay(dateLeft, utils) > getSecondsInDay(dateRight, utils);
  };
};

var muiComponentConfig$5 = {
  name: 'MuiPickersClock'
};
var useStyles$b = makeStyles$1(function (theme) {
  return {
    container: {
      display: 'flex',
      justifyContent: 'center',
      position: 'relative',
      minHeight: VIEW_HEIGHT,
      alignItems: 'center'
    },
    clock: {
      backgroundColor: 'rgba(0,0,0,.07)',
      borderRadius: '50%',
      height: 260,
      width: 260,
      position: 'relative',
      pointerEvents: 'none'
    },
    squareMask: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      pointerEvents: 'auto',
      outline: 'none',
      touchActions: 'none',
      userSelect: 'none',
      '&:active': {
        cursor: 'move'
      }
    },
    pin: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    },
    amButton: {
      zIndex: 1,
      left: 8,
      position: 'absolute',
      bottom: 8
    },
    pmButton: {
      zIndex: 1,
      position: 'absolute',
      bottom: 8,
      right: 8
    },
    meridiemButtonSelected: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      }
    }
  };
}, muiComponentConfig$5);
var Clock = withDefaultProps(muiComponentConfig$5, function (_ref) {
  var _useGlobalKeyDown;

  var date = _ref.date,
      _ref$ampmInClock = _ref.ampmInClock,
      ampmInClock = _ref$ampmInClock === void 0 ? false : _ref$ampmInClock,
      value = _ref.value,
      numbersElementsArray = _ref.children,
      type = _ref.type,
      ampm = _ref.ampm,
      isTimeDisabled = _ref.isTimeDisabled,
      _ref$minutesStep = _ref.minutesStep,
      minutesStep = _ref$minutesStep === void 0 ? 1 : _ref$minutesStep,
      allowKeyboardControl = _ref.allowKeyboardControl,
      onChange = _ref.onChange,
      meridiemMode = _ref.meridiemMode,
      handleMeridiemChange = _ref.handleMeridiemChange;
  var utils = useUtils();
  var classes = useStyles$b();
  var wrapperVariant = useContext(WrapperVariantContext);
  var isMoving = useRef(false);
  var isSelectedTimeDisabled = isTimeDisabled(value, type);
  var isPointerInner = !ampm && type === 'hours' && (value < 1 || value > 12);

  var handleValueChange = function handleValueChange(newValue, isFinish) {
    if (isTimeDisabled(newValue, type)) {
      return;
    }

    onChange(newValue, isFinish);
  };

  var setTime = function setTime(e) {
    var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var offsetX = e.offsetX,
        offsetY = e.offsetY;

    if (typeof offsetX === 'undefined') {
      var rect = e.target.getBoundingClientRect();
      offsetX = e.changedTouches[0].clientX - rect.left;
      offsetY = e.changedTouches[0].clientY - rect.top;
    }

    var value = type === 'seconds' || type === 'minutes' ? getMinutes(offsetX, offsetY, minutesStep) : getHours(offsetX, offsetY, Boolean(ampm));
    handleValueChange(value, isFinish);
  };

  var handleTouchMove = function handleTouchMove(e) {
    isMoving.current = true;
    setTime(e);
  };

  var handleTouchEnd = function handleTouchEnd(e) {
    if (isMoving.current) {
      setTime(e, true);
      isMoving.current = false;
    }
  };

  var handleMouseMove = function handleMouseMove(e) {
    e.preventDefault();
    e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari

    var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;

    if (isButtonPressed) {
      setTime(e.nativeEvent, false);
    }
  };

  var handleMouseUp = function handleMouseUp(e) {
    if (isMoving.current) {
      isMoving.current = false;
    }

    setTime(e.nativeEvent, true);
  };

  var hasSelected = useMemo$1(function () {
    if (type === 'hours') {
      return true;
    }

    return value % 5 === 0;
  }, [type, value]);
  var keyboardControlStep = type === 'minutes' ? minutesStep : 1;
  useGlobalKeyDown(Boolean(allowKeyboardControl !== null && allowKeyboardControl !== void 0 ? allowKeyboardControl : wrapperVariant !== 'static') && !isMoving.current, (_useGlobalKeyDown = {}, _defineProperty$d(_useGlobalKeyDown, keycode.Home, function () {
    return handleValueChange(0, false);
  }), _defineProperty$d(_useGlobalKeyDown, keycode.End, function () {
    return handleValueChange(type === 'minutes' ? 59 : 23, false);
  }), _defineProperty$d(_useGlobalKeyDown, keycode.ArrowUp, function () {
    return handleValueChange(value + keyboardControlStep, false);
  }), _defineProperty$d(_useGlobalKeyDown, keycode.ArrowDown, function () {
    return handleValueChange(value - keyboardControlStep, false);
  }), _useGlobalKeyDown));
  return /*#__PURE__*/createElement("div", {
    className: classes.container
  }, /*#__PURE__*/createElement("div", {
    className: classes.clock
  }, /*#__PURE__*/createElement("div", {
    role: "menu",
    tabIndex: -1,
    className: classes.squareMask,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
    onMouseUp: handleMouseUp,
    onMouseMove: handleMouseMove
  }), !isSelectedTimeDisabled && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: classes.pin
  }), date && /*#__PURE__*/createElement(ClockPointer$1, {
    type: type,
    value: value,
    isInner: isPointerInner,
    hasSelected: hasSelected,
    "aria-live": "polite",
    "aria-label": "Selected time ".concat(utils.format(date, 'fullTime'))
  })), numbersElementsArray), ampm && (wrapperVariant === 'desktop' || ampmInClock) && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(IconButton, {
    "data-mui-test": "in-clock-am-btn",
    onClick: function onClick() {
      return handleMeridiemChange('am');
    },
    disabled: meridiemMode === null,
    className: clsx(classes.amButton, meridiemMode === 'am' && classes.meridiemButtonSelected)
  }, /*#__PURE__*/createElement(Typography, {
    variant: "caption"
  }, "AM")), /*#__PURE__*/createElement(IconButton, {
    disabled: meridiemMode === null,
    "data-mui-test": "in-clock-pm-btn",
    onClick: function onClick() {
      return handleMeridiemChange('pm');
    },
    className: clsx(classes.pmButton, meridiemMode === 'pm' && classes.meridiemButtonSelected)
  }, /*#__PURE__*/createElement(Typography, {
    variant: "caption"
  }, "PM"))));
});
Clock.defaultProps = {
  ampm: propTypesExports.bool,
  minutesStep: propTypesExports.number
};
Clock.displayName = 'Clock';

/**
 * @ignore - internal component.
 */

var PenIcon = createSvgIcon( /*#__PURE__*/createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Pen');

/**
 * @ignore - internal component.
 */

var CalendarIcon = createSvgIcon( /*#__PURE__*/createElement("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');

var useStyles$a = makeStyles$1(function (theme) {
  var toolbarBackground = theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"];
  return {
    toolbar: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      paddingTop: 16,
      paddingBottom: 16,
      backgroundColor: toolbarBackground,
      color: theme.palette.getContrastText(toolbarBackground)
    },
    toolbarLandscape: {
      height: 'auto',
      maxWidth: 160,
      padding: 16,
      justifyContent: 'flex-start',
      flexWrap: 'wrap'
    },
    dateTitleContainer: {
      flex: 1
    }
  };
}, {
  name: 'MuiPickersToolbar'
});

function defaultGetKeyboardInputSwitchingButtonText(isKeyboardInputOpen) {
  return isKeyboardInputOpen ? 'text input view is open, go to calendar view' : 'calendar view is open, go to text input view';
}

var PickerToolbar = function PickerToolbar(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$getMobileKeyboar = _ref.getMobileKeyboardInputViewButtonText,
      getMobileKeyboardInputViewButtonText = _ref$getMobileKeyboar === void 0 ? defaultGetKeyboardInputSwitchingButtonText : _ref$getMobileKeyboar,
      isLandscape = _ref.isLandscape,
      isMobileKeyboardViewOpen = _ref.isMobileKeyboardViewOpen,
      _ref$landscapeDirecti = _ref.landscapeDirection,
      landscapeDirection = _ref$landscapeDirecti === void 0 ? 'column' : _ref$landscapeDirecti,
      penIconClassName = _ref.penIconClassName,
      toggleMobileKeyboardView = _ref.toggleMobileKeyboardView,
      toolbarTitle = _ref.toolbarTitle,
      other = _objectWithoutProperties$4(_ref, ["children", "className", "getMobileKeyboardInputViewButtonText", "isLandscape", "isMobileKeyboardViewOpen", "landscapeDirection", "penIconClassName", "toggleMobileKeyboardView", "toolbarTitle"]);

  var classes = useStyles$a();
  return /*#__PURE__*/createElement(Toolbar, _extends({
    "data-mui-test": "picker-toolbar",
    className: clsx(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
  }, other), /*#__PURE__*/createElement(Typography, {
    "data-mui-test": "picker-toolbar-title",
    color: "inherit",
    variant: "overline"
  }, toolbarTitle), /*#__PURE__*/createElement(Grid$2, {
    container: true,
    justify: "space-between",
    className: classes.dateTitleContainer,
    direction: isLandscape ? landscapeDirection : 'row',
    alignItems: isLandscape ? 'flex-start' : 'flex-end'
  }, children, /*#__PURE__*/createElement(IconButton, {
    onClick: toggleMobileKeyboardView,
    className: penIconClassName,
    color: "inherit",
    "data-mui-test": "toggle-mobile-keyboard-view",
    "aria-label": getMobileKeyboardInputViewButtonText(isMobileKeyboardViewOpen)
  }, isMobileKeyboardViewOpen ? /*#__PURE__*/createElement(CalendarIcon, {
    color: "inherit"
  }) : /*#__PURE__*/createElement(PenIcon, {
    color: "inherit"
  }))));
};

var positions = {
  0: [0, 40],
  1: [55, 19.6],
  2: [94.4, 59.5],
  3: [109, 114],
  4: [94.4, 168.5],
  5: [54.5, 208.4],
  6: [0, 223],
  7: [-54.5, 208.4],
  8: [-94.4, 168.5],
  9: [-109, 114],
  10: [-94.4, 59.5],
  11: [-54.5, 19.6],
  12: [0, 5],
  13: [36.9, 49.9],
  14: [64, 77],
  15: [74, 114],
  16: [64, 151],
  17: [37, 178],
  18: [0, 188],
  19: [-37, 178],
  20: [-64, 151],
  21: [-74, 114],
  22: [-64, 77],
  23: [-37, 50]
};
var useStyles$1$4 = makeStyles$1(function (theme) {
  var size = 32;
  var clockNumberColor = theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint;
  return {
    clockNumber: {
      outline: 0,
      width: size,
      height: size,
      userSelect: 'none',
      position: 'absolute',
      left: "calc((100% - ".concat(size, "px) / 2)"),
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      color: clockNumberColor,
      '&:focused': {
        backgroundColor: theme.palette.background.paper
      }
    },
    clockNumberSelected: {
      color: theme.palette.primary.contrastText
    },
    clockNumberDisabled: {
      pointerEvents: 'none',
      color: fade(clockNumberColor, 0.2)
    }
  };
}, {
  name: 'MuiPickersClockNumber'
});
var ClockNumber = function ClockNumber(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      index = _ref.index,
      onSelect = _ref.onSelect,
      isInner = _ref.isInner,
      disabled = _ref.disabled,
      getClockNumberText = _ref.getClockNumberText;
  var ref = useRef(null);
  var classes = useStyles$1$4();
  var className = clsx(classes.clockNumber, selected && classes.clockNumberSelected, disabled && classes.clockNumberDisabled);
  var transformStyle = useMemo$1(function () {
    var position = positions[index];
    return {
      transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
    };
  }, [index]);
  useEffect(function () {
    if (selected && ref.current) {
      ref.current.focus();
    }
  }, [selected]);
  return /*#__PURE__*/createElement(ButtonBase, {
    focusRipple: true,
    centerRipple: true,
    ref: ref,
    "aria-disabled": disabled,
    tabIndex: disabled ? -1 : 0,
    component: "span",
    className: className,
    style: transformStyle,
    "aria-label": getClockNumberText(label),
    onKeyDown: onSpaceOrEnter(function () {
      return onSelect(FORCE_FINISH_PICKER);
    })
  }, /*#__PURE__*/createElement(Typography, {
    variant: isInner ? 'body2' : 'body1'
  }, label));
};

var getHourNumbers = function getHourNumbers(_ref) {
  var ampm = _ref.ampm,
      date = _ref.date,
      utils = _ref.utils,
      onChange = _ref.onChange,
      isDisabled = _ref.isDisabled,
      getClockNumberText = _ref.getClockNumberText;
  var currentHours = date ? utils.getHours(date) : null;
  var hourNumbers = [];
  var startHour = ampm ? 1 : 0;
  var endHour = ampm ? 12 : 23;

  var isSelected = function isSelected(hour) {
    if (currentHours === null) {
      return false;
    }

    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }

      return currentHours === hour || currentHours - 12 === hour;
    }

    return currentHours === hour;
  };

  var _loop = function _loop(_hour) {
    var label = _hour.toString();

    if (_hour === 0) {
      label = '00';
    }

    var isInner = !ampm && (_hour === 0 || _hour > 12);
    hourNumbers.push( /*#__PURE__*/createElement(ClockNumber, {
      key: _hour,
      index: _hour,
      isInner: isInner,
      selected: isSelected(_hour),
      disabled: isDisabled(_hour),
      label: utils.formatNumber(label),
      onSelect: function onSelect() {
        return onChange(_hour, true);
      },
      getClockNumberText: getClockNumberText
    }));
  };

  for (var _hour = startHour; _hour <= endHour; _hour += 1) {
    _loop(_hour);
  }

  return hourNumbers;
};
var getMinutesNumbers = function getMinutesNumbers(_ref2) {
  var value = _ref2.value,
      utils = _ref2.utils,
      onChange = _ref2.onChange,
      isDisabled = _ref2.isDisabled,
      getClockNumberText = _ref2.getClockNumberText;
  var f = utils.formatNumber;
  return [[5, f('05')], [10, f('10')], [15, f('15')], [20, f('20')], [25, f('25')], [30, f('30')], [35, f('35')], [40, f('40')], [45, f('45')], [50, f('50')], [55, f('55')], [0, f('00')]].map(function (_ref3, index) {
    var _ref4 = _slicedToArray$8(_ref3, 2),
        numberValue = _ref4[0],
        label = _ref4[1];

    return /*#__PURE__*/createElement(ClockNumber, {
      key: numberValue,
      label: label,
      index: index + 1,
      disabled: isDisabled(numberValue),
      selected: numberValue === value,
      onSelect: function onSelect(isFinish) {
        return onChange(numberValue, isFinish);
      },
      getClockNumberText: getClockNumberText
    });
  });
};

var useStyles$2$2 = makeStyles$1(function (theme) {
  var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
  return {
    toolbarTxt: {
      transition: theme.transitions.create('color'),
      color: fade(textColor, 0.54)
    },
    toolbarBtnSelected: {
      color: textColor
    }
  };
}, {
  name: 'MuiPickersToolbarText'
});

var ToolbarText = function ToolbarText(_ref) {
  var className = _ref.className,
      selected = _ref.selected,
      label = _ref.value,
      other = _objectWithoutProperties$4(_ref, ["className", "selected", "value"]);

  var classes = useStyles$2$2();
  return /*#__PURE__*/createElement(Typography, _extends({
    children: label,
    className: clsx(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
  }, other));
};

var useStyles$3$2 = makeStyles$1({
  toolbarBtn: {
    padding: 0,
    minWidth: '16px',
    textTransform: 'none'
  }
}, {
  name: 'MuiPickersToolbarButton'
});
var ToolbarButton = function ToolbarButton(_ref) {
  var align = _ref.align,
      className = _ref.className,
      selected = _ref.selected,
      typographyClassName = _ref.typographyClassName,
      value = _ref.value,
      variant = _ref.variant,
      other = _objectWithoutProperties$4(_ref, ["align", "className", "selected", "typographyClassName", "value", "variant"]);

  var classes = useStyles$3$2();
  return /*#__PURE__*/createElement(F, _extends({
    "data-mui-test": "toolbar-button",
    variant: "text",
    className: clsx(classes.toolbarBtn, className)
  }, other), /*#__PURE__*/createElement(ToolbarText, {
    align: align,
    className: typographyClassName,
    variant: variant,
    value: value,
    selected: selected
  }));
};
ToolbarButton.displayName = 'ToolbarButton';

var muiComponentConfig$4 = {
  name: 'MuiPickersTimePickerToolbar'
};
var useStyles$4$2 = makeStyles$1({
  separator: {
    outline: 0,
    margin: '0 4px 0 2px',
    cursor: 'default'
  },
  hourMinuteLabel: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end'
  },
  hourMinuteLabelLandscape: {
    marginTop: 'auto'
  },
  hourMinuteLabelReverse: {
    flexDirection: 'row-reverse'
  },
  ampmSelection: {
    display: 'flex',
    flexDirection: 'column',
    marginRight: 'auto',
    marginLeft: 12
  },
  ampmLandscape: {
    margin: '4px 0 auto',
    flexDirection: 'row',
    justifyContent: 'space-around',
    flexBasis: '100%'
  },
  ampmLabel: {
    fontSize: 17
  },
  penIconLandscape: {
    marginTop: 'auto'
  }
}, muiComponentConfig$4);
function useMeridiemMode(date, ampm, onChange) {
  var utils = useUtils();
  var meridiemMode = getMeridiem(date, utils);
  var handleMeridiemChange = useCallback$1(function (mode) {
    var timeWithMeridiem = convertToMeridiem(date, mode, Boolean(ampm), utils);
    onChange(timeWithMeridiem, false);
  }, [ampm, date, onChange, utils]);
  return {
    meridiemMode: meridiemMode,
    handleMeridiemChange: handleMeridiemChange
  };
}
var clockTypographyVariant = 'h3';
withDefaultProps(muiComponentConfig$4, function (_ref) {
  var date = _ref.date,
      views = _ref.views,
      ampm = _ref.ampm,
      openView = _ref.openView,
      onChange = _ref.onChange,
      isLandscape = _ref.isLandscape,
      setOpenView = _ref.setOpenView,
      ampmInClock = _ref.ampmInClock,
      isMobileKeyboardViewOpen = _ref.isMobileKeyboardViewOpen,
      toggleMobileKeyboardView = _ref.toggleMobileKeyboardView,
      _ref$toolbarTitle = _ref.toolbarTitle,
      toolbarTitle = _ref$toolbarTitle === void 0 ? 'SELECT TIME' : _ref$toolbarTitle;
  var utils = useUtils();
  var theme = useTheme$2();
  var classes = useStyles$4$2();
  var showAmPmControl = Boolean(ampm && !ampmInClock);

  var _useMeridiemMode = useMeridiemMode(date, ampm, onChange),
      meridiemMode = _useMeridiemMode.meridiemMode,
      handleMeridiemChange = _useMeridiemMode.handleMeridiemChange;

  var formatHours = function formatHours(time) {
    return ampm ? utils.format(time, 'hours12h') : utils.format(time, 'hours24h');
  };

  var separator = /*#__PURE__*/createElement(ToolbarText, {
    tabIndex: -1,
    value: ":",
    variant: clockTypographyVariant,
    selected: false,
    className: classes.separator
  });
  return /*#__PURE__*/createElement(PickerToolbar, {
    landscapeDirection: "row",
    toolbarTitle: toolbarTitle,
    isLandscape: isLandscape,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView,
    penIconClassName: clsx(isLandscape && classes.penIconLandscape)
  }, /*#__PURE__*/createElement("div", {
    className: clsx(classes.hourMinuteLabel, isLandscape && classes.hourMinuteLabelLandscape, theme.direction === 'rtl' && classes.hourMinuteLabelReverse)
  }, arrayIncludes(views, 'hours') && /*#__PURE__*/createElement(ToolbarButton, {
    "data-mui-test": "hours",
    tabIndex: -1,
    variant: clockTypographyVariant,
    onClick: function onClick() {
      return setOpenView('hours');
    },
    selected: openView === 'hours',
    value: date ? formatHours(date) : '--'
  }), arrayIncludes(views, ['hours', 'minutes']) && separator, arrayIncludes(views, 'minutes') && /*#__PURE__*/createElement(ToolbarButton, {
    "data-mui-test": "minutes",
    tabIndex: -1,
    variant: clockTypographyVariant,
    onClick: function onClick() {
      return setOpenView('minutes');
    },
    selected: openView === 'minutes',
    value: date ? utils.format(date, 'minutes') : '--'
  }), arrayIncludes(views, ['minutes', 'seconds']) && separator, arrayIncludes(views, 'seconds') && /*#__PURE__*/createElement(ToolbarButton, {
    "data-mui-test": "seconds",
    variant: clockTypographyVariant,
    onClick: function onClick() {
      return setOpenView('seconds');
    },
    selected: openView === 'seconds',
    value: date ? utils.format(date, 'seconds') : '--'
  })), showAmPmControl && /*#__PURE__*/createElement("div", {
    className: clsx(classes.ampmSelection, isLandscape && classes.ampmLandscape)
  }, /*#__PURE__*/createElement(ToolbarButton, {
    disableRipple: true,
    variant: "subtitle2",
    "data-mui-test": "toolbar-am-btn",
    selected: meridiemMode === 'am',
    typographyClassName: classes.ampmLabel,
    value: utils.getMeridiemText('am'),
    onClick: function onClick() {
      return handleMeridiemChange('am');
    }
  }), /*#__PURE__*/createElement(ToolbarButton, {
    disableRipple: true,
    variant: "subtitle2",
    "data-mui-test": "toolbar-pm-btn",
    selected: meridiemMode === 'pm',
    typographyClassName: classes.ampmLabel,
    value: utils.getMeridiemText('pm'),
    onClick: function onClick() {
      return handleMeridiemChange('pm');
    }
  })));
});

/**
 * @ignore - internal component.
 */

var ArrowLeftIcon = createSvgIcon( /*#__PURE__*/createElement("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');

/**
 * @ignore - internal component.
 */

var ArrowRightIcon = createSvgIcon( /*#__PURE__*/createElement("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');

var useStyles$5$1 = makeStyles$1(function (theme) {
  return {
    iconButton: {
      zIndex: 1,
      backgroundColor: theme.palette.background.paper
    },
    previousMonthButtonMargin: {
      marginRight: 24
    },
    hidden: {
      visibility: 'hidden'
    }
  };
}, {
  name: 'MuiPickersArrowSwitcher'
});

var PureArrowSwitcher = function PureArrowSwitcher(_ref) {
  var className = _ref.className,
      isLeftDisabled = _ref.isLeftDisabled,
      isLeftHidden = _ref.isLeftHidden,
      isRightDisabled = _ref.isRightDisabled,
      isRightHidden = _ref.isRightHidden,
      leftArrowButtonProps = _ref.leftArrowButtonProps,
      leftArrowButtonText = _ref.leftArrowButtonText,
      _ref$leftArrowIcon = _ref.leftArrowIcon,
      leftArrowIcon = _ref$leftArrowIcon === void 0 ? /*#__PURE__*/createElement(ArrowLeftIcon, null) : _ref$leftArrowIcon,
      onLeftClick = _ref.onLeftClick,
      onRightClick = _ref.onRightClick,
      rightArrowButtonProps = _ref.rightArrowButtonProps,
      rightArrowButtonText = _ref.rightArrowButtonText,
      _ref$rightArrowIcon = _ref.rightArrowIcon,
      rightArrowIcon = _ref$rightArrowIcon === void 0 ? /*#__PURE__*/createElement(ArrowRightIcon, null) : _ref$rightArrowIcon,
      text = _ref.text,
      other = _objectWithoutProperties$4(_ref, ["className", "isLeftDisabled", "isLeftHidden", "isRightDisabled", "isRightHidden", "leftArrowButtonProps", "leftArrowButtonText", "leftArrowIcon", "onLeftClick", "onRightClick", "rightArrowButtonProps", "rightArrowButtonText", "rightArrowIcon", "text"]);

  var classes = useStyles$5$1();
  var theme = useTheme$2();
  var isRtl = theme.direction === 'rtl';
  return /*#__PURE__*/createElement("div", _extends({
    className: className
  }, other), /*#__PURE__*/createElement(IconButton, _extends({
    "data-mui-test": "previous-arrow-button",
    size: "small",
    "aria-label": leftArrowButtonText
  }, leftArrowButtonProps, {
    disabled: isLeftDisabled,
    onClick: onLeftClick,
    className: clsx(classes.iconButton, leftArrowButtonProps === null || leftArrowButtonProps === void 0 ? void 0 : leftArrowButtonProps.className, Boolean(isLeftHidden) && classes.hidden, !Boolean(text) && classes.previousMonthButtonMargin)
  }), isRtl ? rightArrowIcon : leftArrowIcon), text && /*#__PURE__*/createElement(Typography, {
    variant: "subtitle1",
    display: "inline"
  }, text), /*#__PURE__*/createElement(IconButton, _extends({
    "data-mui-test": "next-arrow-button",
    size: "small",
    "aria-label": rightArrowButtonText
  }, rightArrowButtonProps, {
    disabled: isRightDisabled,
    onClick: onRightClick,
    className: clsx(classes.iconButton, rightArrowButtonProps === null || rightArrowButtonProps === void 0 ? void 0 : rightArrowButtonProps.className, Boolean(isRightHidden) && classes.hidden)
  }), isRtl ? leftArrowIcon : rightArrowIcon));
};

PureArrowSwitcher.displayName = 'ArrowSwitcher';
var ArrowSwitcher = memo(PureArrowSwitcher);

var muiPickersComponentConfig$1 = {
  name: 'MuiPickersClockView'
};
var useStyles$6$1 = makeStyles$1(function () {
  return {
    arrowSwitcher: {
      position: 'absolute',
      right: 8,
      top: 8
    }
  };
}, muiPickersComponentConfig$1);

var getMinutesAriaText = function getMinutesAriaText(minute) {
  return "".concat(minute, " minutes");
};

var getHoursAriaText = function getHoursAriaText(hour) {
  return "".concat(hour, " hours");
};

var getSecondsAriaText = function getSecondsAriaText(seconds) {
  return "".concat(seconds, " seconds");
};

var ClockView = withDefaultProps(muiPickersComponentConfig$1, function (_ref) {
  var type = _ref.type,
      onDateChange = _ref.onDateChange,
      onChange = _ref.onChange,
      ampm = _ref.ampm,
      date = _ref.date,
      _ref$minutesStep = _ref.minutesStep,
      minutesStep = _ref$minutesStep === void 0 ? 1 : _ref$minutesStep,
      ampmInClock = _ref.ampmInClock,
      minTime = _ref.minTime,
      maxTime = _ref.maxTime,
      allowKeyboardControl = _ref.allowKeyboardControl,
      shouldDisableTime = _ref.shouldDisableTime,
      _ref$getHoursClockNum = _ref.getHoursClockNumberText,
      getHoursClockNumberText = _ref$getHoursClockNum === void 0 ? getHoursAriaText : _ref$getHoursClockNum,
      _ref$getMinutesClockN = _ref.getMinutesClockNumberText,
      getMinutesClockNumberText = _ref$getMinutesClockN === void 0 ? getMinutesAriaText : _ref$getMinutesClockN,
      _ref$getSecondsClockN = _ref.getSecondsClockNumberText,
      getSecondsClockNumberText = _ref$getSecondsClockN === void 0 ? getSecondsAriaText : _ref$getSecondsClockN,
      leftArrowButtonProps = _ref.leftArrowButtonProps,
      rightArrowButtonProps = _ref.rightArrowButtonProps,
      leftArrowIcon = _ref.leftArrowIcon,
      rightArrowIcon = _ref.rightArrowIcon,
      _ref$leftArrowButtonT = _ref.leftArrowButtonText,
      leftArrowButtonText = _ref$leftArrowButtonT === void 0 ? 'open previous view' : _ref$leftArrowButtonT,
      _ref$rightArrowButton = _ref.rightArrowButtonText,
      rightArrowButtonText = _ref$rightArrowButton === void 0 ? 'open next view' : _ref$rightArrowButton,
      openNextView = _ref.openNextView,
      openPreviousView = _ref.openPreviousView,
      nextViewAvailable = _ref.nextViewAvailable,
      showViewSwitcher = _ref.showViewSwitcher,
      previousViewAvailable = _ref.previousViewAvailable,
      disableIgnoringDatePartForTimeValidation = _ref.disableIgnoringDatePartForTimeValidation;
  var now = useNow();
  var utils = useUtils();
  var classes = useStyles$6$1();

  var _useMeridiemMode = useMeridiemMode(date, ampm, onDateChange),
      meridiemMode = _useMeridiemMode.meridiemMode,
      handleMeridiemChange = _useMeridiemMode.handleMeridiemChange;

  var isTimeDisabled = useCallback$1(function (rawValue, type) {
    var validateTimeValue = function validateTimeValue(getRequestedTimePoint) {
      var isAfterComparingFn = createIsAfterIgnoreDatePart(Boolean(disableIgnoringDatePartForTimeValidation), utils); // prettier-ignore

      return Boolean(minTime && isAfterComparingFn(minTime, getRequestedTimePoint('end')) || maxTime && isAfterComparingFn(getRequestedTimePoint('start'), maxTime) || shouldDisableTime && shouldDisableTime(rawValue, type));
    };

    switch (type) {
      case 'hours':
        var hoursWithMeridiem = convertValueToMeridiem(rawValue, meridiemMode, Boolean(ampm));
        return validateTimeValue(function (when) {
          return pipe(function (currentDate) {
            return utils.setHours(currentDate, hoursWithMeridiem);
          }, function (dateWithHours) {
            return utils.setMinutes(dateWithHours, when === 'start' ? 0 : 59);
          }, function (dateWithMinutes) {
            return utils.setSeconds(dateWithMinutes, when === 'start' ? 0 : 59);
          })(date);
        });

      case 'minutes':
        return validateTimeValue(function (when) {
          return pipe(function (currentDate) {
            return utils.setMinutes(currentDate, rawValue);
          }, function (dateWithMinutes) {
            return utils.setSeconds(dateWithMinutes, when === 'start' ? 0 : 59);
          })(date);
        });

      case 'seconds':
        return validateTimeValue(function () {
          return utils.setSeconds(date, rawValue);
        });
    }
  }, [ampm, date, disableIgnoringDatePartForTimeValidation, maxTime, meridiemMode, minTime, shouldDisableTime, utils]);
  var dateOrNow = date || now;
  var viewProps = useMemo$1(function () {
    switch (type) {
      case 'hours':
        var handleHoursChange = function handleHoursChange(value, isFinish) {
          var valueWithMeridiem = convertValueToMeridiem(value, meridiemMode, Boolean(ampm));
          onChange(utils.setHours(dateOrNow, valueWithMeridiem), isFinish);
        };

        return {
          onChange: handleHoursChange,
          value: utils.getHours(dateOrNow),
          children: getHourNumbers({
            date: date,
            utils: utils,
            ampm: Boolean(ampm),
            onChange: handleHoursChange,
            getClockNumberText: getHoursClockNumberText,
            isDisabled: function isDisabled(value) {
              return isTimeDisabled(value, 'hours');
            }
          })
        };

      case 'minutes':
        var minutesValue = utils.getMinutes(dateOrNow);

        var handleMinutesChange = function handleMinutesChange(value, isFinish) {
          onChange(utils.setMinutes(dateOrNow, value), isFinish);
        };

        return {
          value: minutesValue,
          onChange: handleMinutesChange,
          children: getMinutesNumbers({
            utils: utils,
            value: minutesValue,
            onChange: handleMinutesChange,
            getClockNumberText: getMinutesClockNumberText,
            isDisabled: function isDisabled(value) {
              return isTimeDisabled(value, 'minutes');
            }
          })
        };

      case 'seconds':
        var secondsValue = utils.getSeconds(dateOrNow);

        var handleSecondsChange = function handleSecondsChange(value, isFinish) {
          onChange(utils.setSeconds(dateOrNow, value), isFinish);
        };

        return {
          value: secondsValue,
          onChange: handleSecondsChange,
          children: getMinutesNumbers({
            utils: utils,
            value: secondsValue,
            onChange: handleSecondsChange,
            getClockNumberText: getSecondsClockNumberText,
            isDisabled: function isDisabled(value) {
              return isTimeDisabled(value, 'seconds');
            }
          })
        };

      default:
        throw new Error('You must provide the type for ClockView');
    }
  }, [type, utils, date, ampm, getHoursClockNumberText, getMinutesClockNumberText, getSecondsClockNumberText, meridiemMode, onChange, dateOrNow, isTimeDisabled]);
  return /*#__PURE__*/createElement(Fragment, null, showViewSwitcher && /*#__PURE__*/createElement(ArrowSwitcher, {
    className: classes.arrowSwitcher,
    leftArrowButtonProps: leftArrowButtonProps,
    rightArrowButtonProps: rightArrowButtonProps,
    leftArrowButtonText: leftArrowButtonText,
    rightArrowButtonText: rightArrowButtonText,
    leftArrowIcon: leftArrowIcon,
    rightArrowIcon: rightArrowIcon,
    onLeftClick: openPreviousView,
    onRightClick: openNextView,
    isLeftDisabled: previousViewAvailable,
    isRightDisabled: nextViewAvailable
  }), /*#__PURE__*/createElement(Clock, _extends({
    date: date,
    ampmInClock: ampmInClock,
    onDateChange: onDateChange,
    type: type,
    ampm: ampm,
    minutesStep: minutesStep,
    allowKeyboardControl: allowKeyboardControl,
    isTimeDisabled: isTimeDisabled,
    meridiemMode: meridiemMode,
    handleMeridiemChange: handleMeridiemChange
  }, viewProps)));
});
process.env.NODE_ENV !== "production" ? ClockView.propTypes = {
  ampm: propTypesExports.bool,
  date: propTypesExports.object,
  minutesStep: propTypesExports.number,
  onChange: propTypesExports.func.isRequired,
  type: propTypesExports.oneOf(['minutes', 'hours', 'seconds']).isRequired
} : void 0;
ClockView.displayName = 'ClockView';

var useRifm = function useRifm(props) {
  var _React$useReducer = useReducer(function (c) {
    return c + 1;
  }, 0),
      refresh = _React$useReducer[1];

  var valueRef = useRef(null);
  var replace = props.replace,
      append = props.append;
  var userValue = replace ? replace(props.format(props.value)) : props.format(props.value); // state of delete button see comments below about inputType support

  var isDeleleteButtonDownRef = useRef(false);

  var onChange = function onChange(evt) {
    if (process.env.NODE_ENV !== 'production') {
      if (evt.target.type === 'number') {
        console.error('Rifm does not support input type=number, use type=tel instead.');
        return;
      }

      if (evt.target.type === 'date') {
        console.error('Rifm does not support input type=date.');
        return;
      }
    }

    var eventValue = evt.target.value;
    valueRef.current = [eventValue, // eventValue
    evt.target, // input
    eventValue.length > userValue.length, // isSizeIncreaseOperation
    isDeleleteButtonDownRef.current, // isDeleleteButtonDown
    userValue === props.format(eventValue)];

    if (process.env.NODE_ENV !== 'production') {
      var formattedEventValue = props.format(eventValue);

      if (eventValue !== formattedEventValue && eventValue.toLowerCase() === formattedEventValue.toLowerCase()) {
        console.warn('Case enforcement does not work with format. Please use replace={value => value.toLowerCase()} instead');
      }
    } // The main trick is to update underlying input with non formatted value (= eventValue)
    // that allows us to calculate right cursor position after formatting (see getCursorPosition)
    // then we format new value and call props.onChange with masked/formatted value
    // and finally we are able to set cursor position into right place


    refresh();
  }; // React prints warn on server in non production mode about useLayoutEffect usage
  // in both cases it's noop


  if (process.env.NODE_ENV === 'production' || typeof window !== 'undefined') {
    useLayoutEffect$1(function () {
      if (valueRef.current == null) return;
      var _valueRef$current = valueRef.current,
          eventValue = _valueRef$current[0],
          input = _valueRef$current[1],
          isSizeIncreaseOperation = _valueRef$current[2],
          isDeleleteButtonDown = _valueRef$current[3],
          // No operation means that value itself hasn't been changed, BTW cursor, selection etc can be changed
      isNoOperation = _valueRef$current[4];
      valueRef.current = null; // this usually occurs on deleting special symbols like ' here 123'123.00
      // in case of isDeleleteButtonDown cursor should move differently vs backspace

      var deleteWasNoOp = isDeleleteButtonDown && isNoOperation; // Create string from only accepted symbols

      var clean = function clean(str) {
        return (str.match(props.accept || /\d/g) || []).join('');
      };

      var valueBeforeSelectionStart = clean(eventValue.substr(0, input.selectionStart)); // trying to find cursor position in formatted value having knowledge about valueBeforeSelectionStart
      // This works because we assume that format doesn't change the order of accepted symbols.
      // Imagine we have formatter which adds ' symbol between numbers, and by default we refuse all non numeric symbols
      // for example we had input = 1'2|'4 (| means cursor position) then user entered '3' symbol
      // inputValue = 1'23'|4 so valueBeforeSelectionStart = 123 and formatted value = 1'2'3'4
      // calling getCursorPosition("1'2'3'4") will give us position after 3, 1'2'3|'4
      // so for formatting just this function to determine cursor position after formatting is enough
      // with masking we need to do some additional checks see `mask` below

      var getCursorPosition = function getCursorPosition(val) {
        var start = 0;
        var cleanPos = 0;

        for (var i = 0; i !== valueBeforeSelectionStart.length; ++i) {
          var newPos = val.indexOf(valueBeforeSelectionStart[i], start) + 1;
          var newCleanPos = clean(val).indexOf(valueBeforeSelectionStart[i], cleanPos) + 1; // this skips position change if accepted symbols order was broken
          // For example fixes edge case with fixed point numbers:
          // You have '0|.00', then press 1, it becomes 01|.00 and after format 1.00, this breaks our assumption
          // that order of accepted symbols is not changed after format,
          // so here we don't update start position if other accepted symbols was inbetween current and new position

          if (newCleanPos - cleanPos > 1) {
            newPos = start;
            newCleanPos = cleanPos;
          }

          cleanPos = Math.max(newCleanPos, cleanPos);
          start = Math.max(start, newPos);
        }

        return start;
      }; // Masking part, for masks if size of mask is above some value
      // we need to replace symbols instead of do nothing as like in format


      if (props.mask === true && isSizeIncreaseOperation && !isNoOperation) {
        var start = getCursorPosition(eventValue);
        var c = clean(eventValue.substr(start))[0];
        start = eventValue.indexOf(c, start);
        eventValue = "" + eventValue.substr(0, start) + eventValue.substr(start + 1);
      }

      var formattedValue = props.format(eventValue);

      if (append != null && // cursor at the end
      input.selectionStart === eventValue.length && !isNoOperation) {
        if (isSizeIncreaseOperation) {
          formattedValue = append(formattedValue);
        } else {
          // If after delete last char is special character and we use append
          // delete it too
          // was: "12-3|" backspace pressed, then should be "12|"
          if (clean(formattedValue.slice(-1)) === '') {
            formattedValue = formattedValue.slice(0, -1);
          }
        }
      }

      var replacedValue = replace ? replace(formattedValue) : formattedValue;

      if (userValue === replacedValue) {
        // if nothing changed for formatted value, just refresh so userValue will be used at render
        refresh();
      } else {
        props.onChange(replacedValue);
      }

      return function () {
        var start = getCursorPosition(formattedValue); // Visually improves working with masked values,
        // like cursor jumping over refused symbols
        // as an example date mask: was "5|1-24-3" then user pressed "6"
        // it becomes "56-|12-43" with this code, and "56|-12-43" without

        if (props.mask != null && (isSizeIncreaseOperation || isDeleleteButtonDown && !deleteWasNoOp)) {
          while (formattedValue[start] && clean(formattedValue[start]) === '') {
            start += 1;
          }
        }

        input.selectionStart = input.selectionEnd = start + (deleteWasNoOp ? 1 : 0);
      };
    });
  }

  useEffect(function () {
    // until https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported
    // by all major browsers (now supported by: +chrome, +safari, ?edge, !firefox)
    // there is no way I found to distinguish in onChange
    // backspace or delete was called in some situations
    // firefox track https://bugzilla.mozilla.org/show_bug.cgi?id=1447239
    var handleKeyDown = function handleKeyDown(evt) {
      if (evt.code === 'Delete') {
        isDeleleteButtonDownRef.current = true;
      }
    };

    var handleKeyUp = function handleKeyUp(evt) {
      if (evt.code === 'Delete') {
        isDeleleteButtonDownRef.current = false;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    return function () {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);
  return {
    value: valueRef.current != null ? valueRef.current[0] : userValue,
    onChange: onChange
  };
};

/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

var config = {
  disabled: false
};

var timeoutsShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape = process.env.NODE_ENV !== 'production' ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

var TransitionGroupContext = React__default.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$4(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default.cloneElement(React__default.Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: PropTypes.shape({
    current: typeof Element === 'undefined' ? PropTypes.any : function (propValue, key, componentName, location, propFullName, secret) {
      var value = propValue[key];
      return PropTypes.instanceOf(value && 'ownerDocument' in value ? value.ownerDocument.defaultView.Element : Element)(propValue, key, componentName, location, propFullName, secret);
    }
  }),

  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func
} : {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose$4(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default.createElement(Transition$1, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = process.env.NODE_ENV !== "production" ? _extends({}, Transition$1.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var CSSTransition$1 = CSSTransition;

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps$1 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized$3(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$4(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default.createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default.Component);

TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps$1;
var TransitionGroup$1 = TransitionGroup;

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var muiComponentConfig$3 = {
  name: 'MuiPickersDay'
};
var useStyles$9 = makeStyles$1(function (theme) {
  return {
    day: _objectSpread$4(_objectSpread$4({}, theme.typography.caption), {}, {
      width: DAY_SIZE,
      height: DAY_SIZE,
      borderRadius: '50%',
      padding: 0,
      // background required here to prevent collides with the other days when animating with transition group
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      '&:hover': {
        backgroundColor: fade(theme.palette.action.active, theme.palette.action.hoverOpacity)
      },
      '&:focus': {
        backgroundColor: fade(theme.palette.action.active, theme.palette.action.hoverOpacity),
        '&$daySelected': {
          willChange: 'background-color',
          backgroundColor: theme.palette.primary.dark
        }
      }
    }),
    dayWithMargin: {
      margin: "0 ".concat(DAY_MARGIN, "px")
    },
    dayOutsideMonth: {
      color: theme.palette.text.hint
    },
    hiddenDaySpacingFiller: {
      visibility: 'hidden'
    },
    today: {
      '&:not($daySelected)': {
        border: "1px solid ".concat(theme.palette.text.hint)
      }
    },
    daySelected: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration["short"]
      }),
      '&:hover': {
        willChange: 'background-color',
        backgroundColor: theme.palette.primary.dark
      }
    },
    dayDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    },
    dayLabel: {// need for overrides
    }
  };
}, muiComponentConfig$3);

var PureDay = function PureDay(_ref) {
  var className = _ref.className,
      day = _ref.day,
      disabled = _ref.disabled;
      _ref.hidden;
      var isInCurrentMonth = _ref.inCurrentMonth,
      isToday = _ref.today,
      selected = _ref.selected,
      _ref$focused = _ref.focused,
      focused = _ref$focused === void 0 ? false : _ref$focused,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      isAnimating = _ref.isAnimating,
      onDayFocus = _ref.onDayFocus,
      onDaySelect = _ref.onDaySelect,
      onFocus = _ref.onFocus,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      _ref$disableMargin = _ref.disableMargin,
      disableMargin = _ref$disableMargin === void 0 ? false : _ref$disableMargin,
      allowKeyboardControl = _ref.allowKeyboardControl,
      _ref$disableHighlight = _ref.disableHighlightToday,
      disableHighlightToday = _ref$disableHighlight === void 0 ? false : _ref$disableHighlight,
      _ref$showDaysOutsideC = _ref.showDaysOutsideCurrentMonth,
      showDaysOutsideCurrentMonth = _ref$showDaysOutsideC === void 0 ? false : _ref$showDaysOutsideC,
      other = _objectWithoutProperties$4(_ref, ["className", "day", "disabled", "hidden", "inCurrentMonth", "today", "selected", "focused", "focusable", "isAnimating", "onDayFocus", "onDaySelect", "onFocus", "onClick", "onKeyDown", "disableMargin", "allowKeyboardControl", "disableHighlightToday", "showDaysOutsideCurrentMonth"]);

  var ref = useRef(null);
  var utils = useUtils();
  var classes = useStyles$9();
  useEffect(function () {
    if (focused && !disabled && !isAnimating && isInCurrentMonth && ref.current && allowKeyboardControl) {
      ref.current.focus();
    }
  }, [allowKeyboardControl, disabled, focused, isAnimating, isInCurrentMonth]);

  var handleFocus = function handleFocus(e) {
    if (!focused) {
      onDayFocus(day);
    }

    if (onFocus) {
      onFocus(e);
    }
  };

  var handleClick = function handleClick(e) {
    if (!disabled) {
      onDaySelect(day, true);
    }

    if (onClick) {
      onClick(e);
    }
  };

  var handleKeyDown = onSpaceOrEnter(function () {
    if (!disabled) {
      onDaySelect(day, FORCE_FINISH_PICKER);
    }
  }, onKeyDown);
  var dayClassName = clsx(classes.day, className, selected && classes.daySelected, disabled && classes.dayDisabled, !disableMargin && classes.dayWithMargin, !disableHighlightToday && isToday && classes.today, !isInCurrentMonth && showDaysOutsideCurrentMonth && classes.dayOutsideMonth);

  if (!isInCurrentMonth && !showDaysOutsideCurrentMonth) {
    // Do not render button and not attach any listeners for empty days
    return /*#__PURE__*/createElement("div", {
      "aria-hidden": true,
      className: clsx(dayClassName, classes.hiddenDaySpacingFiller)
    });
  }

  return /*#__PURE__*/createElement(ButtonBase, _extends({
    ref: ref,
    centerRipple: true,
    "data-mui-test": "day",
    "aria-label": utils.format(day, 'fullDate'),
    tabIndex: focused || focusable ? 0 : -1,
    className: dayClassName
  }, other, {
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onClick: handleClick
  }), /*#__PURE__*/createElement("span", {
    className: classes.dayLabel
  }, utils.format(day, 'dayOfMonth')));
};

var areDayPropsEqual = function areDayPropsEqual(prevProps, nextProps) {
  return prevProps.focused === nextProps.focused && prevProps.focusable === nextProps.focusable && prevProps.isAnimating === nextProps.isAnimating && prevProps.today === nextProps.today && prevProps.disabled === nextProps.disabled && prevProps.selected === nextProps.selected && prevProps.allowKeyboardControl === nextProps.allowKeyboardControl && prevProps.disableMargin === nextProps.disableMargin && prevProps.showDaysOutsideCurrentMonth === nextProps.showDaysOutsideCurrentMonth && prevProps.disableHighlightToday === nextProps.disableHighlightToday && prevProps.className === nextProps.className && prevProps.onDayFocus === nextProps.onDayFocus && prevProps.onDaySelect === nextProps.onDaySelect;
};
var Day = withDefaultProps(muiComponentConfig$3, memo(PureDay, areDayPropsEqual));
PureDay.displayName = 'Day';
process.env.NODE_ENV !== "production" ? PureDay.propTypes = {
  today: propTypesExports.bool,
  disabled: propTypesExports.bool,
  selected: propTypesExports.bool
} : void 0;
PureDay.defaultProps = {
  disabled: false,
  today: false,
  selected: false
};

var slideAnimationDuration = 350;
var useStyles$8 = makeStyles$1(function (theme) {
  var slideTransition = theme.transitions.create('transform', {
    duration: slideAnimationDuration,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return {
    transitionContainer: {
      display: 'block',
      position: 'relative',
      overflowX: 'hidden',
      '& > *': {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0
      }
    },
    'slideEnter-left': {
      willChange: 'transform',
      transform: 'translate(100%)',
      zIndex: 1
    },
    'slideEnter-right': {
      willChange: 'transform',
      transform: 'translate(-100%)',
      zIndex: 1
    },
    slideEnterActive: {
      transform: 'translate(0%)',
      transition: slideTransition
    },
    slideExit: {
      transform: 'translate(0%)'
    },
    'slideExitActiveLeft-left': {
      willChange: 'transform',
      transform: 'translate(-100%)',
      transition: slideTransition,
      zIndex: 0
    },
    'slideExitActiveLeft-right': {
      willChange: 'transform',
      transform: 'translate(100%)',
      transition: slideTransition,
      zIndex: 0
    }
  };
}, {
  name: 'MuiPickersSlideTransition'
});
var SlideTransition = function SlideTransition(_ref) {
  var children = _ref.children,
      transKey = _ref.transKey,
      reduceAnimations = _ref.reduceAnimations,
      slideDirection = _ref.slideDirection,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? undefined : _ref$className,
      other = _objectWithoutProperties$4(_ref, ["children", "transKey", "reduceAnimations", "slideDirection", "className"]);

  var classes = useStyles$8();

  if (reduceAnimations) {
    return /*#__PURE__*/createElement("div", {
      className: className
    }, children);
  }

  var transitionClasses = {
    exit: classes.slideExit,
    enterActive: classes.slideEnterActive,
    // @ts-ignore
    enter: classes['slideEnter-' + slideDirection],
    // @ts-ignore
    exitActive: classes['slideExitActiveLeft-' + slideDirection]
  };
  return /*#__PURE__*/createElement(TransitionGroup$1, {
    className: clsx(classes.transitionContainer, className),
    childFactory: function childFactory(element) {
      return cloneElement(element, {
        classNames: transitionClasses
      });
    }
  }, /*#__PURE__*/createElement(CSSTransition$1, _extends({
    mountOnEnter: true,
    unmountOnExit: true,
    key: transKey,
    timeout: slideAnimationDuration,
    classNames: transitionClasses,
    children: children
  }, other)));
};

var muiComponentConfig$2 = {
  name: 'MuiPickersCalendar'
};
var useStyles$1$3 = makeStyles$1(function (theme) {
  var weeksContainerHeight = (DAY_SIZE + DAY_MARGIN * 4) * 6;
  return {
    calendarContainer: {
      minHeight: weeksContainerHeight
    },
    loadingContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: weeksContainerHeight
    },
    weekContainer: {
      overflow: 'hidden'
    },
    week: {
      margin: "".concat(DAY_MARGIN, "px 0"),
      display: 'flex',
      justifyContent: 'center'
    },
    iconButton: {
      zIndex: 1,
      backgroundColor: theme.palette.background.paper
    },
    previousMonthButton: {
      marginRight: 12
    },
    daysHeader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    weekDayLabel: {
      width: 36,
      height: 40,
      margin: '0 2px',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      color: theme.palette.text.hint
    }
  };
}, muiComponentConfig$2);
var Calendar = withDefaultProps(muiComponentConfig$2, function (_ref) {
  var _useGlobalKeyDown;

  var date = _ref.date,
      isMonthSwitchingAnimating = _ref.isMonthSwitchingAnimating,
      onMonthSwitchingAnimationEnd = _ref.onMonthSwitchingAnimationEnd,
      focusedDay = _ref.focusedDay,
      changeFocusedDay = _ref.changeFocusedDay,
      onChange = _ref.onChange,
      slideDirection = _ref.slideDirection,
      currentMonth = _ref.currentMonth,
      renderDay = _ref.renderDay,
      reduceAnimations = _ref.reduceAnimations,
      allowKeyboardControl = _ref.allowKeyboardControl,
      isDateDisabled = _ref.isDateDisabled,
      disableHighlightToday = _ref.disableHighlightToday,
      showDaysOutsideCurrentMonth = _ref.showDaysOutsideCurrentMonth,
      className = _ref.className,
      loading = _ref.loading,
      _ref$renderLoading = _ref.renderLoading,
      renderLoading = _ref$renderLoading === void 0 ? function () {
    return /*#__PURE__*/createElement("span", {
      "data-mui-test": "loading-progress"
    }, "...");
  } : _ref$renderLoading,
      TransitionProps = _ref.TransitionProps;
  var now = useNow();
  var utils = useUtils();
  var theme = useTheme$2();
  var classes = useStyles$1$3();
  var handleDaySelect = useCallback$1(function (day) {
    var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    onChange(Array.isArray(date) ? day : utils.mergeDateAndTime(day, date || now), isFinish);
  }, [date, now, onChange, utils]);
  var initialDate = Array.isArray(date) ? date[0] : date;
  var nowFocusedDay = focusedDay || initialDate || now;
  useGlobalKeyDown(Boolean(allowKeyboardControl), (_useGlobalKeyDown = {}, _defineProperty$d(_useGlobalKeyDown, keycode.ArrowUp, function () {
    return changeFocusedDay(utils.addDays(nowFocusedDay, -7));
  }), _defineProperty$d(_useGlobalKeyDown, keycode.ArrowDown, function () {
    return changeFocusedDay(utils.addDays(nowFocusedDay, 7));
  }), _defineProperty$d(_useGlobalKeyDown, keycode.ArrowLeft, function () {
    return changeFocusedDay(utils.addDays(nowFocusedDay, theme.direction === 'ltr' ? -1 : 1));
  }), _defineProperty$d(_useGlobalKeyDown, keycode.ArrowRight, function () {
    return changeFocusedDay(utils.addDays(nowFocusedDay, theme.direction === 'ltr' ? 1 : -1));
  }), _defineProperty$d(_useGlobalKeyDown, keycode.Home, function () {
    return changeFocusedDay(utils.startOfWeek(nowFocusedDay));
  }), _defineProperty$d(_useGlobalKeyDown, keycode.End, function () {
    return changeFocusedDay(utils.endOfWeek(nowFocusedDay));
  }), _defineProperty$d(_useGlobalKeyDown, keycode.PageUp, function () {
    return changeFocusedDay(utils.getNextMonth(nowFocusedDay));
  }), _defineProperty$d(_useGlobalKeyDown, keycode.PageDown, function () {
    return changeFocusedDay(utils.getPreviousMonth(nowFocusedDay));
  }), _useGlobalKeyDown));
  var currentMonthNumber = utils.getMonth(currentMonth);
  var selectedDates = (Array.isArray(date) ? date : [date]).filter(Boolean).map(function (selectedDateItem) {
    return utils.startOfDay(selectedDateItem);
  });
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: classes.daysHeader
  }, utils.getWeekdays().map(function (day, i) {
    return /*#__PURE__*/createElement(Typography, {
      "aria-hidden": true,
      key: day + i.toString(),
      variant: "caption",
      className: classes.weekDayLabel,
      children: day.charAt(0).toUpperCase()
    });
  })), loading ? /*#__PURE__*/createElement("div", {
    className: classes.loadingContainer
  }, renderLoading()) : /*#__PURE__*/createElement(SlideTransition, _extends({
    transKey: currentMonthNumber,
    onExited: onMonthSwitchingAnimationEnd,
    reduceAnimations: reduceAnimations,
    slideDirection: slideDirection,
    className: clsx(classes.calendarContainer, className)
  }, TransitionProps), /*#__PURE__*/createElement("div", {
    role: "grid",
    className: classes.weekContainer
  }, utils.getWeekArray(currentMonth).map(function (week) {
    return /*#__PURE__*/createElement("div", {
      role: "row",
      key: "week-".concat(week[0]),
      className: classes.week
    }, week.map(function (day) {
      var _ref2;

      var disabled = isDateDisabled(day);
      var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
      var dayProps = {
        key: (_ref2 = day) === null || _ref2 === void 0 ? void 0 : _ref2.toString(),
        day: day,
        role: 'cell',
        isAnimating: isMonthSwitchingAnimating,
        disabled: disabled,
        allowKeyboardControl: allowKeyboardControl,
        focused: allowKeyboardControl && Boolean(focusedDay) && utils.isSameDay(day, focusedDay),
        today: utils.isSameDay(day, now),
        inCurrentMonth: isDayInCurrentMonth,
        selected: selectedDates.some(function (selectedDate) {
          return utils.isSameDay(selectedDate, day);
        }),
        disableHighlightToday: disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        focusable: allowKeyboardControl && Boolean(nowFocusedDay) && utils.toJsDate(nowFocusedDay).getDate() === utils.toJsDate(day).getDate(),
        onDayFocus: changeFocusedDay,
        onDaySelect: handleDaySelect
      };
      return renderDay ? renderDay(day, selectedDates, dayProps) : /*#__PURE__*/createElement(Day, dayProps);
    }));
  }))));
});
Calendar.displayName = 'Calendar';

var findClosestEnabledDate = function findClosestEnabledDate(_ref) {
  var date = _ref.date,
      utils = _ref.utils,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      disableFuture = _ref.disableFuture,
      disablePast = _ref.disablePast,
      shouldDisableDate = _ref.shouldDisableDate;
  var today = utils.startOfDay(utils.date());

  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }

  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }

  var forward = date;
  var backward = date;

  if (utils.isBefore(date, minDate)) {
    forward = utils.date(minDate);
    backward = null;
  }

  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = utils.date(maxDate);
    }

    forward = null;
  }

  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }

    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }

    if (forward) {
      if (!shouldDisableDate(forward)) {
        return forward;
      }

      forward = utils.addDays(forward, 1);
    }

    if (backward) {
      if (!shouldDisableDate(backward)) {
        return backward;
      }

      backward = utils.addDays(backward, -1);
    }
  } // fallback to today if no enabled days


  return utils.date();
};
var isYearOnlyView = function isYearOnlyView(views) {
  return views.length === 1 && views[0] === 'year';
};
var isYearAndMonthViews = function isYearAndMonthViews(views) {
  return views.length === 2 && arrayIncludes(views, 'month') && arrayIncludes(views, 'year');
};
var getFormatByViews = function getFormatByViews(views, utils) {
  if (isYearOnlyView(views)) {
    return utils.formats.year;
  }

  if (isYearAndMonthViews(views)) {
    return utils.formats.monthAndYear;
  }

  return utils.formats.keyboardDate;
};
function parsePickerInputValue(utils, _ref2) {
  var value = _ref2.value;
  var parsedValue = utils.date(value);
  return utils.isValid(parsedValue) ? parsedValue : null;
}
var validateDate = function validateDate(utils, value, _ref4) {
  var minDate = _ref4.minDate,
      maxDate = _ref4.maxDate,
      disableFuture = _ref4.disableFuture,
      shouldDisableDate = _ref4.shouldDisableDate,
      disablePast = _ref4.disablePast;
  var now = utils.date();
  var date = utils.date(value);

  if (value === null) {
    return null;
  }

  switch (true) {
    case !utils.isValid(value):
      return 'invalidDate';

    case Boolean(shouldDisableDate && shouldDisableDate(date)):
      return 'shouldDisableDate';

    case Boolean(disableFuture && utils.isAfterDay(date, now)):
      return 'disableFuture';

    case Boolean(disablePast && utils.isBeforeDay(date, now)):
      return 'disablePast';

    case Boolean(minDate && utils.isBeforeDay(date, minDate)):
      return 'minDate';

    case Boolean(maxDate && utils.isAfterDay(date, maxDate)):
      return 'maxDate';

    default:
      return null;
  }
};

function getTextFieldAriaText(rawValue, utils) {
  return rawValue && utils.isValid(utils.date(rawValue)) ? "Choose date, selected date is ".concat(utils.format(utils.date(rawValue), 'fullDate')) : 'Choose date';
}
var getDisplayDate = function getDisplayDate(utils, value, inputFormat) {
  var date = utils.date(value);
  var isEmpty = value === null;

  if (isEmpty) {
    return '';
  }

  return utils.isValid(date) ? utils.formatByString(date, inputFormat) : '';
};
var MASK_USER_INPUT_SYMBOL = '_';
var staticDateWith2DigitTokens = new Date('2019-11-21T22:30:00.000');
var staticDateWith1DigitTokens = new Date('2019-01-01T09:00:00.000');
function checkMaskIsValidForCurrentFormat(mask, format, acceptRegex, utils) {
  var formattedDateWith1Digit = utils.formatByString(utils.date(staticDateWith1DigitTokens), format);
  var inferredFormatPatternWith1Digits = formattedDateWith1Digit.replace(acceptRegex, MASK_USER_INPUT_SYMBOL);
  var inferredFormatPatternWith2Digits = utils.formatByString(utils.date(staticDateWith2DigitTokens), format).replace(acceptRegex, '_');
  var isMaskValid = inferredFormatPatternWith2Digits === mask && inferredFormatPatternWith1Digits === mask; // @ts-ignore

  if (!isMaskValid && process.env.NODE_ENV !== 'production') {
    console.warn("The mask \"".concat(mask, "\" you passed is not valid for the format used ").concat(format, ". Falling down to uncontrolled not-masked input."));
  }

  return isMaskValid;
}
var maskedDateFormatter = function maskedDateFormatter(mask, acceptRegexp) {
  return function (value) {
    return value.split('').map(function (_char, i) {
      acceptRegexp.lastIndex = 0;

      if (i > mask.length - 1) {
        return '';
      }

      var maskChar = mask[i];
      var nextMaskChar = mask[i + 1];
      var acceptedChar = acceptRegexp.test(_char) ? _char : '';
      var formattedChar = maskChar === MASK_USER_INPUT_SYMBOL ? acceptedChar : maskChar + acceptedChar;

      if (i === value.length - 1 && nextMaskChar && nextMaskChar !== MASK_USER_INPUT_SYMBOL) {
        // when cursor at the end of mask part (e.g. month) prerender next symbol "21" -> "21/"
        return formattedChar ? formattedChar + nextMaskChar : '';
      } else {
        return formattedChar;
      }
    }).join('');
  };
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useMaskedInput(_ref) {
  var disableMaskedInput = _ref.disableMaskedInput,
      rawValue = _ref.rawValue,
      validationError = _ref.validationError,
      onChange = _ref.onChange,
      mask = _ref.mask,
      _ref$acceptRegex = _ref.acceptRegex,
      acceptRegex = _ref$acceptRegex === void 0 ? /[\d]/gi : _ref$acceptRegex,
      inputFormat = _ref.inputFormat,
      disabled = _ref.disabled,
      rifmFormatter = _ref.rifmFormatter,
      ignoreInvalidInputs = _ref.ignoreInvalidInputs,
      readOnly = _ref.readOnly,
      TextFieldProps = _ref.TextFieldProps,
      label = _ref.label,
      inputProps = _ref.inputProps;
  var utils = useUtils();
  var isFocusedRef = useRef(false);
  var getInputValue = useCallback$1(function () {
    return getDisplayDate(utils, rawValue, inputFormat);
  }, [inputFormat, rawValue, utils]);
  var formatHelperText = utils.getFormatHelperText(inputFormat);

  var _React$useState = useState(getInputValue()),
      _React$useState2 = _slicedToArray$8(_React$useState, 2),
      innerInputValue = _React$useState2[0],
      setInnerInputValue = _React$useState2[1];

  var shouldUseMaskedInput = useMemo$1(function () {
    // formatting of dates is a quite slow thing, so do not make useless .format calls
    if (!mask || disableMaskedInput) {
      return false;
    }

    return checkMaskIsValidForCurrentFormat(mask, inputFormat, acceptRegex, utils);
  }, [acceptRegex, disableMaskedInput, inputFormat, mask, utils]);
  var formatter = useMemo$1(function () {
    return shouldUseMaskedInput && mask ? maskedDateFormatter(mask, acceptRegex) : function (st) {
      return st;
    };
  }, [acceptRegex, mask, shouldUseMaskedInput]);
  useEffect(function () {
    // We do not need to update the input value on keystroke
    // Because library formatters can change inputs from 12/12/2 to 12/12/0002
    if ((rawValue === null || utils.isValid(rawValue)) && !isFocusedRef.current) {
      setInnerInputValue(getInputValue());
    }
  }, [utils, getInputValue, rawValue]);

  var handleChange = function handleChange(text) {
    var finalString = text === '' || text === mask ? '' : text;
    setInnerInputValue(finalString);
    var date = finalString === null ? null : utils.parse(finalString, inputFormat);

    if (ignoreInvalidInputs && !utils.isValid(date)) {
      return;
    }

    onChange(date, finalString || undefined);
  };

  var rifmProps = useRifm({
    value: innerInputValue,
    onChange: handleChange,
    format: rifmFormatter || formatter
  });
  var inputStateArgs = shouldUseMaskedInput ? rifmProps : {
    value: innerInputValue,
    onChange: function onChange(e) {
      return handleChange(e.currentTarget.value);
    }
  };
  return _objectSpread$3({
    label: label,
    disabled: disabled,
    error: validationError,
    helperText: formatHelperText,
    inputProps: _objectSpread$3(_objectSpread$3(_objectSpread$3({}, inputStateArgs), {}, {
      disabled: disabled,
      // make spreading in custom input easier
      placeholder: formatHelperText,
      readOnly: readOnly,
      type: shouldUseMaskedInput ? 'tel' : 'text'
    }, inputProps), {}, {
      onFocus: createDelegatedEventHandler(function () {
        return isFocusedRef.current = true;
      }, inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus),
      onBlur: createDelegatedEventHandler(function () {
        return isFocusedRef.current = false;
      }, inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur)
    })
  }, TextFieldProps);
}

function ownKeys$1$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$2(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var KeyboardDateInput = function KeyboardDateInput(_ref) {
  var containerRef = _ref.containerRef,
      hideOpenPickerButton = _ref.disableOpenPicker,
      forwardedRef = _ref.forwardedRef,
      _ref$getOpenDialogAri = _ref.getOpenDialogAriaText,
      getOpenDialogAriaText = _ref$getOpenDialogAri === void 0 ? getTextFieldAriaText : _ref$getOpenDialogAri,
      InputAdornmentProps = _ref.InputAdornmentProps,
      InputProps = _ref.InputProps,
      onOpen = _ref.openPicker,
      OpenPickerButtonProps = _ref.OpenPickerButtonProps,
      _ref$openPickerIcon = _ref.openPickerIcon,
      openPickerIcon = _ref$openPickerIcon === void 0 ? /*#__PURE__*/createElement(CalendarIcon, null) : _ref$openPickerIcon,
      renderInput = _ref.renderInput,
      other = _objectWithoutProperties$4(_ref, ["containerRef", "disableOpenPicker", "forwardedRef", "getOpenDialogAriaText", "InputAdornmentProps", "InputProps", "openPicker", "OpenPickerButtonProps", "openPickerIcon", "renderInput"]);

  var utils = useUtils();
  var textFieldProps = useMaskedInput(other);
  var adornmentPosition = (InputAdornmentProps === null || InputAdornmentProps === void 0 ? void 0 : InputAdornmentProps.position) || 'end';
  return renderInput(_objectSpread$1$2(_objectSpread$1$2({
    ref: containerRef,
    inputRef: forwardedRef
  }, textFieldProps), {}, {
    InputProps: _objectSpread$1$2(_objectSpread$1$2({}, InputProps), {}, _defineProperty$d({}, "".concat(adornmentPosition, "Adornment"), hideOpenPickerButton ? undefined : /*#__PURE__*/createElement(InputAdornment$1, _extends({
      position: adornmentPosition
    }, InputAdornmentProps), /*#__PURE__*/createElement(IconButton, _extends({
      edge: adornmentPosition,
      "data-mui-test": "open-picker-from-keyboard",
      disabled: other.disabled,
      "aria-label": getOpenDialogAriaText(other.rawValue, utils)
    }, OpenPickerButtonProps, {
      onClick: onOpen
    }), openPickerIcon))))
  }));
};
process.env.NODE_ENV !== "production" ? KeyboardDateInput.propTypes = {
  acceptRegex: propTypesExports.instanceOf(RegExp),
  getOpenDialogAriaText: propTypesExports.func,
  mask: propTypesExports.string,
  OpenPickerButtonProps: propTypesExports.object,
  openPickerIcon: propTypesExports.node,
  renderInput: propTypesExports.func.isRequired,
  rifmFormatter: propTypesExports.func
} : void 0;

function useParsedDate(possiblyUnparsedValue) {
  var utils = useUtils();
  return useMemo$1(function () {
    return typeof possiblyUnparsedValue === 'undefined' ? undefined : utils.date(possiblyUnparsedValue);
  }, [possiblyUnparsedValue, utils]);
}
function useNextMonthDisabled(month, _ref) {
  var disableFuture = _ref.disableFuture,
      maxDate = _ref.maxDate;
  var utils = useUtils();
  return useMemo$1(function () {
    var now = utils.date();
    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, maxDate) ? now : maxDate);
    return !utils.isAfter(lastEnabledMonth, month);
  }, [disableFuture, maxDate, month, utils]);
}
function usePreviousMonthDisabled(month, _ref2) {
  var disablePast = _ref2.disablePast,
      minDate = _ref2.minDate;
  var utils = useUtils();
  return useMemo$1(function () {
    var now = utils.date();
    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, minDate) ? now : minDate);
    return !utils.isBefore(firstEnabledMonth, month);
  }, [disablePast, minDate, month, utils]);
}

propTypesExports.oneOfType([propTypesExports.object, propTypesExports.string, propTypesExports.number, propTypesExports.instanceOf(Date)]);
propTypesExports.oneOf(['year', 'month', 'day']);
var defaultMinDate = new Date('1900-01-01');
var defaultMaxDate = new Date('2099-12-31');

function useViews(_ref) {
  var views = _ref.views,
      openTo = _ref.openTo,
      onChange = _ref.onChange,
      isMobileKeyboardViewOpen = _ref.isMobileKeyboardViewOpen,
      toggleMobileKeyboardView = _ref.toggleMobileKeyboardView;

  var _React$useState = useState(openTo && arrayIncludes(views, openTo) ? openTo : views[0]),
      _React$useState2 = _slicedToArray$8(_React$useState, 2),
      openView = _React$useState2[0],
      _setOpenView = _React$useState2[1];

  var setOpenView = useCallback$1(function () {
    if (isMobileKeyboardViewOpen) {
      toggleMobileKeyboardView();
    }

    _setOpenView.apply(void 0, arguments);
  }, [isMobileKeyboardViewOpen, toggleMobileKeyboardView]);
  var previousView = views[views.indexOf(openView) - 1];
  var nextView = views[views.indexOf(openView) + 1];
  var openNext = useCallback$1(function () {
    if (nextView) {
      setOpenView(nextView);
    }
  }, [nextView, setOpenView]);
  var handleChangeAndOpenNext = useCallback$1(function (date, isFinishedSelectionInCurrentView) {
    onChange(date, Boolean(nextView) ? false : isFinishedSelectionInCurrentView);

    if (isFinishedSelectionInCurrentView) {
      openNext();
    }
  }, [nextView, onChange, openNext]);
  return {
    nextView: nextView,
    previousView: previousView,
    openNext: openNext,
    handleChangeAndOpenNext: handleChangeAndOpenNext,
    openView: openView,
    setOpenView: setOpenView
  };
}

var getOrientation = function getOrientation() {
  if (typeof window === 'undefined') {
    return 'portrait';
  }

  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
  } // Support IOS safari


  if (window.orientation) {
    return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
  }

  return 'portrait';
};

function useIsLandscape(views, customOrientation) {
  var _React$useState = useState(getOrientation()),
      _React$useState2 = _slicedToArray$8(_React$useState, 2),
      orientation = _React$useState2[0],
      setOrientation = _React$useState2[1];

  var eventHandler = useCallback$1(function () {
    return setOrientation(getOrientation());
  }, []);
  useIsomorphicEffect(function () {
    window.addEventListener('orientationchange', eventHandler);
    return function () {
      return window.removeEventListener('orientationchange', eventHandler);
    };
  }, [eventHandler]);

  if (arrayIncludes(views, ['hours', 'minutes', 'seconds'])) {
    // could not display 13:34:44 in landscape mode
    return false;
  }

  var orientationToUse = customOrientation || orientation;
  return orientationToUse === 'landscape';
}

var MobileKeyboardInputView = styled('div')({
  padding: '16px 24px'
});

var useStyles$4 = makeStyles$1(function (theme) {
  return {
    root: {
      flex: '1 0 33.33%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      height: 64,
      transition: theme.transitions.create('font-size', {
        duration: '100ms'
      }),
      '&:focus': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    monthSelected: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium
    },
    monthDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersMonth'
});
var Month = function Month(_ref) {
  var selected = _ref.selected,
      onSelect = _ref.onSelect,
      disabled = _ref.disabled,
      value = _ref.value,
      children = _ref.children,
      other = _objectWithoutProperties$4(_ref, ["selected", "onSelect", "disabled", "value", "children"]);

  var classes = useStyles$4();
  var handleSelection = useCallback$1(function () {
    onSelect(value);
  }, [onSelect, value]);
  return /*#__PURE__*/createElement(Typography, _extends({
    "data-mui-test": "month",
    role: "button",
    component: "div",
    className: clsx(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
    tabIndex: disabled ? -1 : 0,
    onClick: handleSelection,
    onKeyDown: onSpaceOrEnter(handleSelection),
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    children: children
  }, other));
};
Month.displayName = 'Month';

var useStyles$1$2 = makeStyles$1({
  container: {
    width: 310,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch'
  }
}, {
  name: 'MuiPickersMonthSelection'
});
var MonthSelection = function MonthSelection(_ref) {
  var disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      date = _ref.date,
      onMonthChange = _ref.onMonthChange,
      onChange = _ref.onChange;
  var utils = useUtils();
  var classes = useStyles$1$2();
  var currentMonth = utils.getMonth(date);

  var shouldDisableMonth = function shouldDisableMonth(month) {
    var now = utils.date();
    var utilMinDate = utils.date(minDate);
    var utilMaxDate = utils.date(maxDate);
    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
    var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
    var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
    return isBeforeFirstEnabled || isAfterLastEnabled;
  };

  var onMonthSelect = useCallback$1(function (month) {
    var newDate = utils.setMonth(date, month);
    onChange(newDate, true);

    if (onMonthChange) {
      onMonthChange(newDate);
    }
  }, [date, onChange, onMonthChange, utils]);
  return /*#__PURE__*/createElement("div", {
    className: classes.container
  }, utils.getMonthArray(date).map(function (month) {
    var monthNumber = utils.getMonth(month);
    var monthText = utils.format(month, 'monthShort');
    return /*#__PURE__*/createElement(Month, {
      key: monthText,
      value: monthNumber,
      selected: monthNumber === currentMonth,
      onSelect: onMonthSelect,
      disabled: shouldDisableMonth(month)
    }, monthText);
  }));
};

function ownKeys$2$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$1(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var createCalendarStateReducer = function createCalendarStateReducer(reduceAnimations, disableSwitchToMonthOnDayFocus, utils) {
  return function (state, action) {
    switch (action.type) {
      case 'changeMonth':
        {
          return _objectSpread$2$2(_objectSpread$2$2({}, state), {}, {
            slideDirection: action.direction,
            currentMonth: action.newMonth,
            isMonthSwitchingAnimating: !reduceAnimations
          });
        }

      case 'finishMonthSwitchingAnimation':
        {
          return _objectSpread$2$2(_objectSpread$2$2({}, state), {}, {
            isMonthSwitchingAnimating: false
          });
        }

      case 'changeFocusedDay':
        {
          // action.focusedDay = action.focusedDay || utils.date()
          var needMonthSwitch = Boolean(action.focusedDay) && !disableSwitchToMonthOnDayFocus && !utils.isSameMonth(state.currentMonth, action.focusedDay);
          return _objectSpread$2$2(_objectSpread$2$2({}, state), {}, {
            focusedDay: action.focusedDay,
            isMonthSwitchingAnimating: needMonthSwitch && !reduceAnimations,
            currentMonth: needMonthSwitch ? utils.startOfMonth(action.focusedDay) : state.currentMonth,
            slideDirection: utils.isAfterDay(action.focusedDay, state.currentMonth) ? 'left' : 'right'
          });
        }
    }
  };
};
function useCalendarState(_ref) {
  var date = _ref.date,
      reduceAnimations = _ref.reduceAnimations,
      onMonthChange = _ref.onMonthChange,
      disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      shouldDisableDate = _ref.shouldDisableDate,
      _ref$disableSwitchToM = _ref.disableSwitchToMonthOnDayFocus,
      disableSwitchToMonthOnDayFocus = _ref$disableSwitchToM === void 0 ? false : _ref$disableSwitchToM;
  var now = useNow();
  var utils = useUtils();
  var dateForMonth = date || now;
  var reducerFn = useRef(createCalendarStateReducer(Boolean(reduceAnimations), disableSwitchToMonthOnDayFocus, utils)).current;

  var _React$useReducer = useReducer(reducerFn, {
    isMonthSwitchingAnimating: false,
    focusedDay: date,
    currentMonth: utils.startOfMonth(dateForMonth),
    slideDirection: 'left'
  }),
      _React$useReducer2 = _slicedToArray$8(_React$useReducer, 2),
      calendarState = _React$useReducer2[0],
      dispatch = _React$useReducer2[1];

  var handleChangeMonth = useCallback$1(function (payload) {
    dispatch(_objectSpread$2$2({
      type: 'changeMonth'
    }, payload));

    if (onMonthChange) {
      onMonthChange(payload.newMonth);
    }
  }, [onMonthChange]);
  var changeMonth = useCallback$1(function (newDate) {
    var newDateRequested = newDate !== null && newDate !== void 0 ? newDate : now;

    if (utils.isSameMonth(newDateRequested, calendarState.currentMonth)) {
      return;
    }

    handleChangeMonth({
      newMonth: utils.startOfMonth(newDateRequested),
      direction: utils.isAfterDay(newDateRequested, calendarState.currentMonth) ? 'left' : 'right'
    });
  }, [calendarState.currentMonth, handleChangeMonth, now, utils]);
  var isDateDisabled = useCallback$1(function (day) {
    return validateDate(utils, day, {
      disablePast: disablePast,
      disableFuture: disableFuture,
      minDate: minDate,
      maxDate: maxDate,
      shouldDisableDate: shouldDisableDate
    }) !== null;
  }, [disableFuture, disablePast, maxDate, minDate, shouldDisableDate, utils]);
  var onMonthSwitchingAnimationEnd = useCallback$1(function () {
    dispatch({
      type: 'finishMonthSwitchingAnimation'
    });
  }, []);
  var changeFocusedDay = useCallback$1(function (newFocusedDate) {
    if (!isDateDisabled(newFocusedDate)) {
      dispatch({
        type: 'changeFocusedDay',
        focusedDay: newFocusedDate
      });
    }
  }, [isDateDisabled]);
  return {
    calendarState: calendarState,
    changeMonth: changeMonth,
    changeFocusedDay: changeFocusedDay,
    isDateDisabled: isDateDisabled,
    onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
    handleChangeMonth: handleChangeMonth
  };
}

var animationDuration = 500;
var useStyles$2$1 = makeStyles$1(function (theme) {
  return {
    transitionContainer: {
      display: 'block',
      position: 'relative'
    },
    fadeEnter: {
      willChange: 'transform',
      opacity: 0
    },
    fadeEnterActive: {
      opacity: 1,
      transition: theme.transitions.create('opacity', {
        duration: animationDuration
      })
    },
    fadeExit: {
      opacity: 1
    },
    fadeExitActive: {
      opacity: 0,
      transition: theme.transitions.create('opacity', {
        duration: animationDuration / 2
      })
    }
  };
}, {
  name: 'MuiPickersFadeTransition'
});
var FadeTransitionGroup = function FadeTransitionGroup(_ref) {
  var children = _ref.children,
      className = _ref.className,
      reduceAnimations = _ref.reduceAnimations,
      transKey = _ref.transKey;
  var classes = useStyles$2$1();

  if (reduceAnimations) {
    return children;
  }

  var transitionClasses = {
    exit: classes.fadeExit,
    enterActive: classes.fadeEnterActive,
    enter: classes.fadeEnter,
    exitActive: classes.fadeExitActive
  };
  return /*#__PURE__*/createElement(TransitionGroup$1, {
    className: clsx(classes.transitionContainer, className),
    childFactory: function childFactory(element) {
      return cloneElement(element, {
        classNames: transitionClasses
      });
    }
  }, /*#__PURE__*/createElement(CSSTransition$1, {
    mountOnEnter: true,
    unmountOnExit: true,
    key: transKey,
    timeout: {
      appear: animationDuration,
      enter: animationDuration / 2,
      exit: 0
    },
    classNames: transitionClasses,
    children: children
  }));
};

/**
 * @ignore - internal component.
 */

var ArrowDropDownIcon = createSvgIcon( /*#__PURE__*/createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

var useStyles$3$1 = makeStyles$1(function (theme) {
  return {
    switchHeader: {
      display: 'flex',
      alignItems: 'center',
      marginTop: 16,
      marginBottom: 8,
      paddingLeft: 24,
      paddingRight: 12,
      // prevent jumping in safari
      maxHeight: 30,
      minHeight: 30
    },
    yearSelectionSwitcher: {
      marginRight: 'auto'
    },
    previousMonthButton: {
      marginRight: 24
    },
    switchViewDropdown: {
      willChange: 'transform',
      transition: theme.transitions.create('transform'),
      transform: 'rotate(0deg)'
    },
    switchViewDropdownDown: {
      transform: 'rotate(180deg)'
    },
    monthTitleContainer: {
      display: 'flex',
      maxHeight: 30,
      overflow: 'hidden',
      cursor: 'pointer',
      marginRight: 'auto'
    },
    monthText: {
      marginRight: 4
    }
  };
}, {
  name: 'MuiPickersCalendarHeader'
});

function getSwitchingViewAriaText(view) {
  return view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view';
}

var CalendarHeader = function CalendarHeader(_ref) {
  var currentView = _ref.view,
      views = _ref.views,
      month = _ref.currentMonth,
      changeView = _ref.changeView,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      onMonthChange = _ref.onMonthChange,
      reduceAnimations = _ref.reduceAnimations,
      leftArrowButtonProps = _ref.leftArrowButtonProps,
      rightArrowButtonProps = _ref.rightArrowButtonProps,
      leftArrowIcon = _ref.leftArrowIcon,
      rightArrowIcon = _ref.rightArrowIcon,
      _ref$leftArrowButtonT = _ref.leftArrowButtonText,
      leftArrowButtonText = _ref$leftArrowButtonT === void 0 ? 'previous month' : _ref$leftArrowButtonT,
      _ref$rightArrowButton = _ref.rightArrowButtonText,
      rightArrowButtonText = _ref$rightArrowButton === void 0 ? 'next month' : _ref$rightArrowButton,
      _ref$getViewSwitching = _ref.getViewSwitchingButtonText,
      getViewSwitchingButtonText = _ref$getViewSwitching === void 0 ? getSwitchingViewAriaText : _ref$getViewSwitching;
  var utils = useUtils();
  var classes = useStyles$3$1();

  var selectNextMonth = function selectNextMonth() {
    return onMonthChange(utils.getNextMonth(month), 'left');
  };

  var selectPreviousMonth = function selectPreviousMonth() {
    return onMonthChange(utils.getPreviousMonth(month), 'right');
  };

  var isNextMonthDisabled = useNextMonthDisabled(month, {
    disableFuture: disableFuture,
    maxDate: maxDate
  });
  var isPreviousMonthDisabled = usePreviousMonthDisabled(month, {
    disablePast: disablePast,
    minDate: minDate
  });

  var toggleView = function toggleView() {
    if (views.length === 1) {
      return;
    }

    if (views.length === 2) {
      changeView(views.find(function (view) {
        return view !== currentView;
      }) || views[0]);
    } else {
      // switching only between first 2
      var nextIndexToOpen = views.indexOf(currentView) !== 0 ? 0 : 1;
      changeView(views[nextIndexToOpen]);
    }
  };

  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: classes.switchHeader
  }, /*#__PURE__*/createElement("div", {
    className: classes.monthTitleContainer,
    onClick: toggleView
  }, /*#__PURE__*/createElement(FadeTransitionGroup, {
    reduceAnimations: reduceAnimations,
    transKey: utils.format(month, 'month')
  }, /*#__PURE__*/createElement(Typography, {
    "aria-live": "polite",
    "data-mui-test": "calendar-month-text",
    align: "center",
    variant: "subtitle1",
    className: classes.monthText,
    children: utils.format(month, 'month')
  })), /*#__PURE__*/createElement(FadeTransitionGroup, {
    reduceAnimations: reduceAnimations,
    transKey: utils.format(month, 'year')
  }, /*#__PURE__*/createElement(Typography, {
    "aria-live": "polite",
    "data-mui-test": "calendar-year-text",
    align: "center",
    variant: "subtitle1",
    children: utils.format(month, 'year')
  })), views.length > 1 && /*#__PURE__*/createElement(IconButton, {
    size: "small",
    "data-mui-test": "calendar-view-switcher",
    onClick: toggleView,
    className: classes.yearSelectionSwitcher,
    "aria-label": getViewSwitchingButtonText(currentView)
  }, /*#__PURE__*/createElement(ArrowDropDownIcon, {
    className: clsx(classes.switchViewDropdown, currentView === 'year' && classes.switchViewDropdownDown)
  }))), /*#__PURE__*/createElement(Fade, {
    "in": currentView === 'date'
  }, /*#__PURE__*/createElement(ArrowSwitcher, {
    leftArrowButtonProps: leftArrowButtonProps,
    rightArrowButtonProps: rightArrowButtonProps,
    leftArrowButtonText: leftArrowButtonText,
    rightArrowButtonText: rightArrowButtonText,
    leftArrowIcon: leftArrowIcon,
    rightArrowIcon: rightArrowIcon,
    onLeftClick: selectPreviousMonth,
    onRightClick: selectNextMonth,
    isLeftDisabled: isPreviousMonthDisabled,
    isRightDisabled: isNextMonthDisabled
  }))));
};
CalendarHeader.displayName = 'CalendarHeader';
process.env.NODE_ENV !== "production" ? CalendarHeader.propTypes = {
  leftArrowIcon: propTypesExports.node,
  rightArrowIcon: propTypesExports.node,
  leftArrowButtonText: propTypesExports.string,
  rightArrowButtonText: propTypesExports.string
} : void 0;

var useStyles$4$1 = makeStyles$1(function (theme) {
  return {
    yearButtonContainer: {
      color: 'unset',
      backgroundColor: 'transparent',
      border: 'none',
      outline: 0,
      flexBasis: '33.3%',
      display: 'flex',
      justifyContent: 'center',
      padding: '8px 0'
    },
    yearButtonContainerDesktop: {
      flexBasis: '25%'
    },
    yearButton: {
      height: 36,
      width: 72,
      borderRadius: 16,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      '&:focus, &:hover': {
        backgroundColor: fade(theme.palette.action.active, theme.palette.action.hoverOpacity)
      }
    },
    yearSelected: {
      color: theme.palette.getContrastText(theme.palette.primary.main),
      backgroundColor: theme.palette.primary.main,
      '&:focus, &:hover': {
        backgroundColor: theme.palette.primary.dark
      }
    },
    yearDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersYear'
});
var Year = function Year(_ref) {
  var onSelect = _ref.onSelect,
      forwardedRef = _ref.forwardedRef,
      value = _ref.value,
      selected = _ref.selected,
      disabled = _ref.disabled,
      children = _ref.children,
      focused = _ref.focused,
      allowKeyboardControl = _ref.allowKeyboardControl,
      other = _objectWithoutProperties$4(_ref, ["onSelect", "forwardedRef", "value", "selected", "disabled", "children", "focused", "allowKeyboardControl"]);

  var classes = useStyles$4$1();
  var ref = useRef(null);
  var wrapperVariant = useContext(WrapperVariantContext);
  useEffect(function () {
    if (focused && ref.current && !disabled && allowKeyboardControl) {
      ref.current.focus();
    }
  }, [allowKeyboardControl, disabled, focused]);
  return /*#__PURE__*/createElement("button", {
    ref: forwardedRef,
    disabled: disabled,
    "data-mui-test": "year",
    onClick: function onClick() {
      return onSelect(value);
    },
    className: clsx(classes.yearButtonContainer, wrapperVariant === 'desktop' && classes.yearButtonContainerDesktop)
  }, /*#__PURE__*/createElement(Typography, _extends({
    ref: ref,
    variant: "subtitle1",
    "data-mui-test": "year-".concat(children),
    tabIndex: selected ? 0 : -1,
    color: selected ? 'primary' : undefined,
    onKeyDown: onSpaceOrEnter(function () {
      return onSelect(value);
    }),
    className: clsx(classes.yearButton, selected && classes.yearSelected, disabled && classes.yearDisabled)
  }, other), children));
};
var Year$1 = forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(Year, _extends({}, props, {
    forwardedRef: ref
  }));
});

var useStyles$5 = makeStyles$1({
  container: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    overflowY: 'auto',
    height: '100%'
  }
}, {
  name: 'MuiPickersYearSelection'
});
var YearSelection = function YearSelection(_ref) {
  var _useGlobalKeyDown;

  var __dateOrNull = _ref.date,
      onChange = _ref.onChange,
      onYearChange = _ref.onYearChange,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      isDateDisabled = _ref.isDateDisabled,
      shouldDisableYear = _ref.shouldDisableYear,
      changeFocusedDay = _ref.changeFocusedDay,
      allowKeyboardControl = _ref.allowKeyboardControl;
  var now = useNow();
  var theme = useTheme$2();
  var utils = useUtils();
  var classes = useStyles$5();
  var selectedDate = __dateOrNull || now;
  var currentYear = utils.getYear(selectedDate);
  var wrapperVariant = useContext(WrapperVariantContext);
  var selectedYearRef = useRef(null);

  var _React$useState = useState(currentYear),
      _React$useState2 = _slicedToArray$8(_React$useState, 2),
      focusedYear = _React$useState2[0],
      setFocusedYear = _React$useState2[1];

  useEffect(function () {
    if (allowKeyboardControl && selectedYearRef.current && selectedYearRef.current.scrollIntoView) {
      try {
        selectedYearRef.current.scrollIntoView({
          block: wrapperVariant === 'static' ? 'nearest' : 'center'
        });
      } catch (e) {
        // call without arguments in case when scrollIntoView works improperly (e.g. Firefox 52-57)
        selectedYearRef.current.scrollIntoView();
      }
    }
  }, []); // eslint-disable-line

  var handleYearSelection = useCallback$1(function (year) {
    var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var newDate = utils.setYear(selectedDate, year);

    if (isDateDisabled(newDate)) {
      return;
    }

    if (onYearChange) {
      onYearChange(newDate);
    }

    onChange(newDate, isFinish);
    changeFocusedDay(newDate);
  }, [changeFocusedDay, selectedDate, isDateDisabled, onChange, onYearChange, utils]);
  var focusYear = useCallback$1(function (year) {
    if (!isDateDisabled(utils.setYear(selectedDate, year))) {
      setFocusedYear(year);
    }
  }, [selectedDate, isDateDisabled, utils]);
  var yearsInRow = wrapperVariant === 'desktop' ? 4 : 3;
  var nowFocusedYear = focusedYear || currentYear;
  useGlobalKeyDown(Boolean(allowKeyboardControl), (_useGlobalKeyDown = {}, _defineProperty$d(_useGlobalKeyDown, keycode.ArrowUp, function () {
    return focusYear(nowFocusedYear - yearsInRow);
  }), _defineProperty$d(_useGlobalKeyDown, keycode.ArrowDown, function () {
    return focusYear(nowFocusedYear + yearsInRow);
  }), _defineProperty$d(_useGlobalKeyDown, keycode.ArrowLeft, function () {
    return focusYear(nowFocusedYear + (theme.direction === 'ltr' ? -1 : 1));
  }), _defineProperty$d(_useGlobalKeyDown, keycode.ArrowRight, function () {
    return focusYear(nowFocusedYear + (theme.direction === 'ltr' ? 1 : -1));
  }), _useGlobalKeyDown));
  return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
    className: classes.container
  }, utils.getYearRange(minDate, maxDate).map(function (year) {
    var yearNumber = utils.getYear(year);
    var selected = yearNumber === currentYear;
    return /*#__PURE__*/createElement(Year$1, {
      key: utils.format(year, 'year'),
      selected: selected,
      value: yearNumber,
      onSelect: handleYearSelection,
      allowKeyboardControl: allowKeyboardControl,
      focused: yearNumber === focusedYear,
      ref: selected ? selectedYearRef : undefined,
      disabled: // Make sure that final date (with month and day included) will be enabled
      isDateDisabled(utils.setYear(selectedDate, yearNumber)) || shouldDisableYear && shouldDisableYear(year)
    }, utils.format(year, 'year'));
  })));
};

var muiComponentConfig = {
  name: 'MuiPickersCalendarView'
};
var useStyles$6 = makeStyles$1({
  viewTransitionContainer: {
    overflowY: 'auto'
  },
  fullHeightContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: (DAY_SIZE + DAY_MARGIN * 4) * 7,
    height: '100%'
  }
}, muiComponentConfig);
var defaultReduceAnimations = typeof navigator !== 'undefined' && /(android)/i.test(navigator.userAgent);
var CalendarView = withDefaultProps(muiComponentConfig, function (_ref) {
  var date = _ref.date,
      view = _ref.view,
      onChange = _ref.onChange,
      changeView = _ref.changeView,
      onMonthChange = _ref.onMonthChange,
      __minDate = _ref.minDate,
      __maxDate = _ref.maxDate,
      _ref$reduceAnimations = _ref.reduceAnimations,
      reduceAnimations = _ref$reduceAnimations === void 0 ? defaultReduceAnimations : _ref$reduceAnimations,
      shouldDisableDate = _ref.shouldDisableDate,
      __allowKeyboardControlProp = _ref.allowKeyboardControl,
      disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      shouldDisableYear = _ref.shouldDisableYear,
      loading = _ref.loading,
      renderLoading = _ref.renderLoading,
      other = _objectWithoutProperties$4(_ref, ["date", "view", "onChange", "changeView", "onMonthChange", "minDate", "maxDate", "reduceAnimations", "shouldDisableDate", "allowKeyboardControl", "disablePast", "disableFuture", "shouldDisableYear", "loading", "renderLoading"]);

  var utils = useUtils();
  var classes = useStyles$6();
  var isStatic = useContext(IsStaticVariantContext);
  var allowKeyboardControl = __allowKeyboardControlProp !== null && __allowKeyboardControlProp !== void 0 ? __allowKeyboardControlProp : !isStatic;

  var minDate = __minDate || utils.date(defaultMinDate);

  var maxDate = __maxDate || utils.date(defaultMaxDate);

  var _useCalendarState = useCalendarState({
    date: date,
    reduceAnimations: reduceAnimations,
    onMonthChange: onMonthChange,
    minDate: minDate,
    maxDate: maxDate,
    shouldDisableDate: shouldDisableDate,
    disablePast: disablePast,
    disableFuture: disableFuture
  }),
      calendarState = _useCalendarState.calendarState,
      changeFocusedDay = _useCalendarState.changeFocusedDay,
      changeMonth = _useCalendarState.changeMonth,
      isDateDisabled = _useCalendarState.isDateDisabled,
      handleChangeMonth = _useCalendarState.handleChangeMonth,
      onMonthSwitchingAnimationEnd = _useCalendarState.onMonthSwitchingAnimationEnd;

  useEffect(function () {
    if (date && isDateDisabled(date)) {
      var closestEnabledDate = findClosestEnabledDate({
        utils: utils,
        date: date,
        minDate: utils.date(minDate),
        maxDate: utils.date(maxDate),
        disablePast: Boolean(disablePast),
        disableFuture: Boolean(disableFuture),
        shouldDisableDate: isDateDisabled
      });
      onChange(closestEnabledDate, false);
    } // This call is too expensive to run it on each prop change.
    // So just ensure that we are not rendering disabled as selected on mount.

  }, []); // eslint-disable-line

  useEffect(function () {
    changeMonth(date);
  }, [date]); // eslint-disable-line

  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(CalendarHeader, _extends({}, other, {
    view: view,
    currentMonth: calendarState.currentMonth,
    changeView: changeView,
    onMonthChange: function onMonthChange(newMonth, direction) {
      return handleChangeMonth({
        newMonth: newMonth,
        direction: direction
      });
    },
    minDate: minDate,
    maxDate: maxDate,
    disablePast: disablePast,
    disableFuture: disableFuture,
    reduceAnimations: reduceAnimations
  })), /*#__PURE__*/createElement(FadeTransitionGroup, {
    reduceAnimations: reduceAnimations,
    className: classes.viewTransitionContainer,
    transKey: view
  }, /*#__PURE__*/createElement("div", null, view === 'year' && /*#__PURE__*/createElement(YearSelection, _extends({}, other, {
    date: date,
    onChange: onChange,
    minDate: minDate,
    maxDate: maxDate,
    disableFuture: disableFuture,
    disablePast: disablePast,
    isDateDisabled: isDateDisabled,
    allowKeyboardControl: allowKeyboardControl,
    shouldDisableYear: shouldDisableYear,
    changeFocusedDay: changeFocusedDay
  })), view === 'month' && /*#__PURE__*/createElement(MonthSelection, _extends({}, other, {
    date: date,
    onChange: onChange,
    minDate: minDate,
    maxDate: maxDate,
    onMonthChange: onMonthChange
  })), view === 'date' && /*#__PURE__*/createElement(Calendar, _extends({}, other, calendarState, {
    onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
    changeFocusedDay: changeFocusedDay,
    reduceAnimations: reduceAnimations,
    date: date,
    onChange: onChange,
    isDateDisabled: isDateDisabled,
    allowKeyboardControl: allowKeyboardControl,
    loading: loading,
    renderLoading: renderLoading
  })))));
});

var muiComponentConfig$1 = {
  name: 'MuiPickersBasePicker'
};
var useStyles$7 = makeStyles$1({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  containerLandscape: {
    flexDirection: 'row'
  },
  pickerView: {
    overflowX: 'hidden',
    width: DIALOG_WIDTH,
    maxHeight: VIEW_HEIGHT,
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
  },
  pickerViewLandscape: {
    padding: '0 8px'
  }
}, muiComponentConfig$1);
var MobileKeyboardTextFieldProps = {
  fullWidth: true
};

var isTimePickerByViews = function isTimePickerByViews(views) {
  return !views.some(function (view) {
    return view === 'year' || view === 'month' || view === 'date';
  });
};

function Picker(_ref) {
  var date = _ref.date,
      _ref$openTo = _ref.openTo,
      openTo = _ref$openTo === void 0 ? 'date' : _ref$openTo,
      _ref$views = _ref.views,
      views = _ref$views === void 0 ? ['year', 'month', 'date', 'hours', 'minutes', 'seconds'] : _ref$views,
      toolbarTitle = _ref.toolbarTitle,
      showToolbar = _ref.showToolbar,
      onDateChange = _ref.onDateChange,
      _ref$ToolbarComponent = _ref.ToolbarComponent,
      ToolbarComponent = _ref$ToolbarComponent === void 0 ? function () {
    return null;
  } : _ref$ToolbarComponent,
      orientation = _ref.orientation,
      DateInputProps = _ref.DateInputProps,
      isMobileKeyboardViewOpen = _ref.isMobileKeyboardViewOpen,
      toggleMobileKeyboardView = _ref.toggleMobileKeyboardView,
      toolbarFormat = _ref.toolbarFormat,
      className = _ref.className,
      toolbarPlaceholder = _ref.toolbarPlaceholder,
      other = _objectWithoutProperties$4(_ref, ["date", "openTo", "views", "toolbarTitle", "showToolbar", "onDateChange", "ToolbarComponent", "orientation", "DateInputProps", "isMobileKeyboardViewOpen", "toggleMobileKeyboardView", "toolbarFormat", "className", "toolbarPlaceholder"]);

  var classes = useStyles$7();
  var isLandscape = useIsLandscape(views, orientation);
  var wrapperVariant = useContext(WrapperVariantContext);
  var handleDateChange = useCallback$1(function (date, isFinish) {
    onDateChange(date, wrapperVariant, isFinish);
  }, [onDateChange, wrapperVariant]);
  var toShowToolbar = typeof showToolbar === 'undefined' ? wrapperVariant !== 'desktop' : showToolbar;

  var _useViews = useViews({
    views: views,
    openTo: openTo,
    onChange: handleDateChange,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView
  }),
      openView = _useViews.openView,
      nextView = _useViews.nextView,
      previousView = _useViews.previousView,
      setOpenView = _useViews.setOpenView,
      handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;

  return /*#__PURE__*/createElement("div", {
    className: clsx(classes.container, className, isLandscape && classes.containerLandscape)
  }, toShowToolbar && /*#__PURE__*/createElement(ToolbarComponent, _extends({}, other, {
    views: views,
    isLandscape: isLandscape,
    date: date,
    onChange: handleDateChange,
    setOpenView: setOpenView,
    openView: openView,
    toolbarTitle: toolbarTitle,
    toolbarFormat: toolbarFormat,
    toolbarPlaceholder: toolbarPlaceholder,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView
  })), /*#__PURE__*/createElement("div", {
    className: clsx(classes.pickerView, isLandscape && classes.pickerViewLandscape)
  }, isMobileKeyboardViewOpen ? /*#__PURE__*/createElement(MobileKeyboardInputView, null, /*#__PURE__*/createElement(KeyboardDateInput, _extends({}, DateInputProps, {
    ignoreInvalidInputs: true,
    disableOpenPicker: true,
    TextFieldProps: MobileKeyboardTextFieldProps
  }))) : /*#__PURE__*/createElement(Fragment, null, (openView === 'year' || openView === 'month' || openView === 'date') && /*#__PURE__*/createElement(CalendarView, _extends({
    date: date,
    changeView: setOpenView // @ts-ignore
    ,
    views: views,
    onChange: handleChangeAndOpenNext,
    view: openView
  }, other)), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && /*#__PURE__*/createElement(ClockView, _extends({}, other, {
    date: date,
    type: openView,
    onDateChange: handleDateChange,
    onChange: handleChangeAndOpenNext,
    openNextView: function openNextView() {
      return setOpenView(nextView);
    },
    openPreviousView: function openPreviousView() {
      return setOpenView(previousView);
    },
    nextViewAvailable: !Boolean(nextView),
    previousViewAvailable: !Boolean(previousView),
    showViewSwitcher: isTimePickerByViews(views) && wrapperVariant === 'desktop'
  })))));
}

var Picker$1 = withDefaultProps(muiComponentConfig$1, Picker);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PureDateInput = function PureDateInput(_ref) {
  var containerRef = _ref.containerRef,
      disabled = _ref.disabled,
      forwardedRef = _ref.forwardedRef,
      _ref$getOpenDialogAri = _ref.getOpenDialogAriaText,
      getOpenDialogAriaText = _ref$getOpenDialogAri === void 0 ? getTextFieldAriaText : _ref$getOpenDialogAri,
      inputFormat = _ref.inputFormat,
      InputProps = _ref.InputProps,
      label = _ref.label,
      onOpen = _ref.openPicker,
      rawValue = _ref.rawValue,
      renderInput = _ref.renderInput,
      _ref$TextFieldProps = _ref.TextFieldProps,
      TextFieldProps = _ref$TextFieldProps === void 0 ? {} : _ref$TextFieldProps,
      validationError = _ref.validationError;
  var utils = useUtils();
  var PureDateInputProps = useMemo$1(function () {
    return _objectSpread$2(_objectSpread$2({}, InputProps), {}, {
      readOnly: true
    });
  }, [InputProps]);
  var inputValue = getDisplayDate(utils, rawValue, inputFormat);
  return renderInput(_objectSpread$2({
    label: label,
    disabled: disabled,
    ref: containerRef,
    inputRef: forwardedRef,
    error: validationError,
    InputProps: PureDateInputProps,
    inputProps: {
      disabled: disabled,
      'aria-readonly': true,
      'aria-label': getOpenDialogAriaText(rawValue, utils),
      value: inputValue,
      onClick: onOpen,
      onKeyDown: onSpaceOrEnter(onOpen)
    }
  }, TextFieldProps));
};
process.env.NODE_ENV !== "production" ? PureDateInput.propTypes = {
  acceptRegex: propTypesExports.instanceOf(RegExp),
  getOpenDialogAriaText: propTypesExports.func,
  mask: propTypesExports.string,
  OpenPickerButtonProps: propTypesExports.object,
  openPickerIcon: propTypesExports.node,
  renderInput: propTypesExports.func.isRequired,
  rifmFormatter: propTypesExports.func
} : void 0;

function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var useStyles$2 = makeStyles$1({
  dialogRoot: {
    minWidth: DIALOG_WIDTH
  },
  dialogRootWider: {
    minWidth: DIALOG_WIDTH_WIDER
  },
  dialogContainer: {
    '&:focus > $dialogRoot': {
      outline: 'auto',
      '@media (pointer:coarse)': {
        outline: 0
      }
    }
  },
  dialog: {
    '&:first-child': {
      padding: 0
    }
  },
  dialogAction: {// requested for overrides
  },
  withAdditionalAction: {
    // set justifyContent to default value to fix IE11 layout bug
    // see https://github.com/mui-org/material-ui-pickers/pull/267
    justifyContent: 'flex-start',
    '& > *:first-child': {
      marginRight: 'auto'
    }
  }
}, {
  name: 'MuiPickersModalDialog'
});
var PickerModalDialog = function PickerModalDialog(_ref) {
  var _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      children = _ref.children,
      MuiDialogClasses = _ref.classes,
      _ref$clearable = _ref.clearable,
      clearable = _ref$clearable === void 0 ? false : _ref$clearable,
      _ref$clearText = _ref.clearText,
      clearText = _ref$clearText === void 0 ? 'Clear' : _ref$clearText,
      _ref$okText = _ref.okText,
      okText = _ref$okText === void 0 ? 'OK' : _ref$okText,
      onAccept = _ref.onAccept,
      onClear = _ref.onClear,
      onDismiss = _ref.onDismiss,
      onSetToday = _ref.onSetToday;
      _ref.showTabs;
      var _ref$showTodayButton = _ref.showTodayButton,
      showTodayButton = _ref$showTodayButton === void 0 ? false : _ref$showTodayButton,
      _ref$todayText = _ref.todayText,
      todayText = _ref$todayText === void 0 ? 'Today' : _ref$todayText,
      wider = _ref.wider,
      other = _objectWithoutProperties$4(_ref, ["cancelText", "children", "classes", "clearable", "clearText", "okText", "onAccept", "onClear", "onDismiss", "onSetToday", "showTabs", "showTodayButton", "todayText", "wider"]);

  var classes = useStyles$2();
  return /*#__PURE__*/createElement(Dialog$1, _extends({
    onClose: onDismiss,
    classes: _objectSpread$1$1({
      container: classes.dialogContainer,
      paper: clsx(classes.dialogRoot, wider && classes.dialogRootWider)
    }, MuiDialogClasses)
  }, other), /*#__PURE__*/createElement(DialogContent$1, {
    children: children,
    className: classes.dialog
  }), /*#__PURE__*/createElement(DialogActions$1, {
    className: clsx(classes.dialogAction, (clearable || showTodayButton) && classes.withAdditionalAction)
  }, clearable && /*#__PURE__*/createElement(F, {
    "data-mui-test": "clear-action-button",
    color: "primary",
    onClick: onClear
  }, clearText), showTodayButton && /*#__PURE__*/createElement(F, {
    "data-mui-test": "today-action-button",
    color: "primary",
    onClick: onSetToday
  }, todayText), cancelText && /*#__PURE__*/createElement(F, {
    color: "primary",
    onClick: onDismiss
  }, cancelText), okText && /*#__PURE__*/createElement(F, {
    color: "primary",
    onClick: onAccept
  }, okText)));
};

var MobileWrapper = function MobileWrapper(_ref) {
  var open = _ref.open,
      children = _ref.children,
      okText = _ref.okText,
      cancelText = _ref.cancelText,
      clearText = _ref.clearText,
      todayText = _ref.todayText,
      showTodayButton = _ref.showTodayButton,
      clearable = _ref.clearable,
      DialogProps = _ref.DialogProps,
      showTabs = _ref.showTabs,
      wider = _ref.wider,
      DateInputProps = _ref.DateInputProps,
      onClear = _ref.onClear,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onSetToday = _ref.onSetToday;
      _ref.PopoverProps;
      _ref.displayStaticWrapperAs;
      _ref.KeyboardDateInputComponent;
      var _ref$PureDateInputCom = _ref.PureDateInputComponent,
      PureDateInputComponent = _ref$PureDateInputCom === void 0 ? PureDateInput : _ref$PureDateInputCom,
      other = _objectWithoutProperties$4(_ref, ["open", "children", "okText", "cancelText", "clearText", "todayText", "showTodayButton", "clearable", "DialogProps", "showTabs", "wider", "DateInputProps", "onClear", "onAccept", "onDismiss", "onSetToday", "PopoverProps", "displayStaticWrapperAs", "KeyboardDateInputComponent", "PureDateInputComponent"]);

  return /*#__PURE__*/createElement(WrapperVariantContext.Provider, {
    value: "mobile"
  }, /*#__PURE__*/createElement(PureDateInputComponent, _extends({}, other, DateInputProps)), /*#__PURE__*/createElement(PickerModalDialog, _extends({
    wider: wider,
    showTabs: showTabs,
    open: open,
    onClear: onClear,
    onAccept: onAccept,
    onDismiss: onDismiss,
    onSetToday: onSetToday,
    clearText: clearText,
    todayText: todayText,
    okText: okText,
    cancelText: cancelText,
    clearable: clearable,
    showTodayButton: showTodayButton,
    children: children,
    "data-mui-test": "mobile-wrapper-dialog"
  }, DialogProps)));
};
process.env.NODE_ENV !== "production" ? MobileWrapper.propTypes = {
  okText: propTypesExports.node,
  cancelText: propTypesExports.node,
  clearText: propTypesExports.node,
  clearable: propTypesExports.bool,
  todayText: propTypesExports.node,
  showTodayButton: propTypesExports.bool,
  DialogProps: propTypesExports.object
} : void 0;

var useStyles$1$1 = makeStyles$1({
  popover: {
    '&:focus': _defineProperty$d({
      outline: 'auto'
    }, IS_TOUCH_DEVICE_MEDIA, {
      outline: 0
    })
  }
});
var DesktopWrapper = function DesktopWrapper(_ref) {
  var open = _ref.open,
      children = _ref.children,
      PopoverProps = _ref.PopoverProps,
      onDismiss = _ref.onDismiss,
      DateInputProps = _ref.DateInputProps,
      _ref$KeyboardDateInpu = _ref.KeyboardDateInputComponent,
      KeyboardDateInputComponent = _ref$KeyboardDateInpu === void 0 ? KeyboardDateInput : _ref$KeyboardDateInpu;
  var ref = useRef(null);
  var classes = useStyles$1$1();
  return /*#__PURE__*/createElement(WrapperVariantContext.Provider, {
    value: "desktop"
  }, /*#__PURE__*/createElement(KeyboardDateInputComponent, _extends({}, DateInputProps, {
    containerRef: ref
  })), /*#__PURE__*/createElement(Popover$1, _extends({
    role: "dialog",
    open: open,
    onClose: onDismiss,
    anchorEl: ref.current,
    classes: {
      paper: classes.popover
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    }
  }, PopoverProps), children));
};
process.env.NODE_ENV !== "production" ? DesktopWrapper.propTypes = {
  onOpen: propTypesExports.func,
  onClose: propTypesExports.func,
  PopoverProps: propTypesExports.object
} : void 0;

makeStyles$1(function (theme) {
  return {
    popper: {
      zIndex: theme.zIndex.modal
    },
    paper: {
      transformOrigin: 'top center',
      '&:focus': _defineProperty$d({
        outline: 'auto'
      }, IS_TOUCH_DEVICE_MEDIA, {
        outline: 0
      })
    },
    topTransition: {
      transformOrigin: 'bottom center'
    }
  };
});

var makeResponsiveWrapper = function makeResponsiveWrapper(DesktopWrapperComponent, MobileWrapperComponent) {
  var ResponsiveWrapper = function ResponsiveWrapper(_ref) {
    var _ref$desktopModeMedia = _ref.desktopModeMediaQuery,
        desktopModeMediaQuery = _ref$desktopModeMedia === void 0 ? IS_TOUCH_DEVICE_MEDIA : _ref$desktopModeMedia,
        okText = _ref.okText,
        cancelText = _ref.cancelText,
        clearText = _ref.clearText,
        todayText = _ref.todayText,
        showTodayButton = _ref.showTodayButton,
        clearable = _ref.clearable,
        DialogProps = _ref.DialogProps,
        PopoverProps = _ref.PopoverProps,
        PopperProps = _ref.PopperProps,
        TransitionComponent = _ref.TransitionComponent;
        _ref.displayStaticWrapperAs;
        var other = _objectWithoutProperties$4(_ref, ["desktopModeMediaQuery", "okText", "cancelText", "clearText", "todayText", "showTodayButton", "clearable", "DialogProps", "PopoverProps", "PopperProps", "TransitionComponent", "displayStaticWrapperAs"]);

    var isDesktop = useMediaQuery$1(desktopModeMediaQuery);
    return isDesktop ? /*#__PURE__*/createElement(DesktopWrapperComponent, _extends({
      PopperProps: PopperProps,
      TransitionComponent: TransitionComponent,
      PopoverProps: PopoverProps
    }, other)) : /*#__PURE__*/createElement(MobileWrapperComponent, _extends({
      okText: okText,
      cancelText: cancelText,
      clearText: clearText,
      todayText: todayText,
      showTodayButton: showTodayButton,
      clearable: clearable,
      DialogProps: DialogProps
    }, other));
  };

  return ResponsiveWrapper;
};
var ResponsiveWrapper = makeResponsiveWrapper(DesktopWrapper, MobileWrapper);

var useStyles$3 = makeStyles$1(function (theme) {
  return {
    staticWrapperRoot: {
      overflow: 'hidden',
      minWidth: DIALOG_WIDTH,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.paper
    }
  };
}, {
  name: 'MuiPickersStaticWrapper'
});
var StaticWrapper = function StaticWrapper(_ref) {
  var _ref$displayStaticWra = _ref.displayStaticWrapperAs,
      displayStaticWrapperAs = _ref$displayStaticWra === void 0 ? 'static' : _ref$displayStaticWra,
      children = _ref.children;
  var classes = useStyles$3();
  return /*#__PURE__*/createElement(IsStaticVariantContext.Provider, {
    value: true
  }, /*#__PURE__*/createElement(WrapperVariantContext.Provider, {
    value: displayStaticWrapperAs
  }, /*#__PURE__*/createElement("div", {
    className: classes.staticWrapperRoot,
    children: children
  })));
};

var defaultIsSameError = function defaultIsSameError(a, b) {
  return a === b;
};

function makeValidationHook(validateFn) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultValidationError = _ref.defaultValidationError,
      _ref$isSameError = _ref.isSameError,
      isSameError = _ref$isSameError === void 0 ? defaultIsSameError : _ref$isSameError;

  return function (value, props) {
    var utils = useUtils();
    var previousValidationErrorRef = useRef(defaultValidationError || null);
    var validationError = validateFn(utils, value, props);
    useEffect(function () {
      if (props.onError && !isSameError(validationError, previousValidationErrorRef.current)) {
        props.onError(validationError, value);
      }

      previousValidationErrorRef.current = validationError;
    }, [previousValidationErrorRef, props, validationError, value]);
    return validationError;
  };
}

function withDateAdapterProp(Component) {
  return function (_ref) {
    var dateAdapter = _ref.dateAdapter,
        other = _objectWithoutProperties$4(_ref, ["dateAdapter"]);

    if (dateAdapter) {
      return /*#__PURE__*/createElement(MuiPickersAdapterContext.Provider, {
        value: dateAdapter
      }, /*#__PURE__*/createElement(Component, other));
    }

    return /*#__PURE__*/createElement(Component, other);
  };
}

/* Creates a component that rendering modal/popover/nothing and spreading props down to text field */
function makeWrapperComponent(Wrapper, _ref) {
  var KeyboardDateInputComponent = _ref.KeyboardDateInputComponent,
      PureDateInputComponent = _ref.PureDateInputComponent;

  function WrapperComponent(props) {
    props.open;
        props.value;
        props.autoOk;
        props.inputFormat;
        props.onChange;
        var children = props.children,
        clearable = props.clearable,
        clearText = props.clearText,
        DialogProps = props.DialogProps;
        props.PopoverProps;
        var okText = props.okText,
        cancelText = props.cancelText,
        todayText = props.todayText,
        DateInputProps = props.DateInputProps,
        wrapperProps = props.wrapperProps,
        wider = props.wider,
        showTabs = props.showTabs;
        props.onAccept;
        props.onClose;
        props.onOpen;
        var displayStaticWrapperAs = props.displayStaticWrapperAs,
        restPropsForTextField = _objectWithoutProperties$4(props, ["open", "value", "autoOk", "inputFormat", "onChange", "children", "clearable", "clearText", "DialogProps", "PopoverProps", "okText", "cancelText", "todayText", "DateInputProps", "wrapperProps", "wider", "showTabs", "onAccept", "onClose", "onOpen", "displayStaticWrapperAs"]);

    var WrapperComponent = Wrapper;
    return /*#__PURE__*/React__default.createElement(WrapperComponent, _extends({
      clearable: clearable,
      clearText: clearText,
      DialogProps: DialogProps,
      okText: okText,
      todayText: todayText,
      cancelText: cancelText,
      DateInputProps: DateInputProps // @ts-ignore
      ,
      KeyboardDateInputComponent: KeyboardDateInputComponent // @ts-ignore
      ,
      PureDateInputComponent: PureDateInputComponent,
      wider: wider,
      showTabs: showTabs,
      displayStaticWrapperAs: displayStaticWrapperAs
    }, wrapperProps, restPropsForTextField), children);
  }

  return WrapperComponent;
}

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var valueManager = {
  emptyValue: null,
  parseInput: parsePickerInputValue,
  areValuesEqual: function areValuesEqual(utils, a, b) {
    return utils.isEqual(a, b);
  }
};
function makePickerWithStateAndWrapper(Wrapper, _ref) {
  var name = _ref.name,
      useInterceptProps = _ref.useInterceptProps,
      useValidation = _ref.useValidation,
      DefaultToolbarComponent = _ref.DefaultToolbarComponent;
  var PickerWrapper = makeWrapperComponent(Wrapper, {
    KeyboardDateInputComponent: KeyboardDateInput,
    PureDateInputComponent: PureDateInput
  });

  function PickerWithState(__props) {
    var allProps = useInterceptProps(__props);
    var validationError = useValidation(allProps.value, allProps) !== null;

    var _usePickerState = usePickerState(allProps, valueManager),
        pickerProps = _usePickerState.pickerProps,
        inputProps = _usePickerState.inputProps,
        wrapperProps = _usePickerState.wrapperProps; // Note that we are passing down all the value without spread.
    // It saves us >1kb gzip and make any prop available automatically on any level down.


    allProps.value;
        allProps.onChange;
        var other = _objectWithoutProperties$4(allProps, ["value", "onChange"]);

    var AllDateInputProps = _objectSpread$2$1(_objectSpread$2$1(_objectSpread$2$1({}, inputProps), other), {}, {
      validationError: validationError
    });

    return /*#__PURE__*/createElement(PickerWrapper, _extends({
      wrapperProps: wrapperProps,
      DateInputProps: AllDateInputProps
    }, other), /*#__PURE__*/createElement(Picker$1, _extends({}, pickerProps, {
      toolbarTitle: allProps.label || allProps.toolbarTitle,
      ToolbarComponent: other.ToolbarComponent || DefaultToolbarComponent,
      DateInputProps: AllDateInputProps
    }, other)));
  }

  var FinalPickerComponent = withDefaultProps({
    name: name
  }, withDateAdapterProp(PickerWithState));
  return forwardRef(function (props, ref) {
    return /*#__PURE__*/createElement(FinalPickerComponent, _extends({}, props, {
      forwardedRef: ref
    }));
  });
}

var muiPickersComponentConfig = {
  name: 'MuiPickersDatePickerToolbar'
};
var useStyles$1 = makeStyles$1({
  dateTitleLandscape: {
    margin: 'auto 16px auto auto'
  },
  penIcon: {
    position: 'relative',
    top: 4
  }
}, muiPickersComponentConfig);
var DatePickerToolbar = withDefaultProps(muiPickersComponentConfig, function (_ref) {
  var date = _ref.date,
      views = _ref.views,
      isLandscape = _ref.isLandscape,
      isMobileKeyboardViewOpen = _ref.isMobileKeyboardViewOpen,
      toggleMobileKeyboardView = _ref.toggleMobileKeyboardView,
      toolbarFormat = _ref.toolbarFormat,
      _ref$toolbarPlacehold = _ref.toolbarPlaceholder,
      toolbarPlaceholder = _ref$toolbarPlacehold === void 0 ? '––' : _ref$toolbarPlacehold,
      _ref$toolbarTitle = _ref.toolbarTitle,
      toolbarTitle = _ref$toolbarTitle === void 0 ? 'SELECT DATE' : _ref$toolbarTitle;
  var utils = useUtils();
  var classes = useStyles$1();
  var dateText = useMemo$1(function () {
    if (!date) {
      return toolbarPlaceholder;
    }

    if (toolbarFormat) {
      return utils.formatByString(date, toolbarFormat);
    }

    if (isYearOnlyView(views)) {
      return utils.format(date, 'year');
    }

    if (isYearAndMonthViews(views)) {
      return utils.format(date, 'month');
    } // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1"
    // For other locales using strings like "June 1", without weekday


    return /en/.test(utils.getCurrentLocaleCode()) ? utils.format(date, 'normalDateWithWeekday') : utils.format(date, 'normalDate');
  }, [date, toolbarFormat, toolbarPlaceholder, utils, views]);
  return /*#__PURE__*/createElement(PickerToolbar, {
    toolbarTitle: toolbarTitle,
    isMobileKeyboardViewOpen: isMobileKeyboardViewOpen,
    toggleMobileKeyboardView: toggleMobileKeyboardView,
    isLandscape: isLandscape,
    penIconClassName: classes.penIcon
  }, /*#__PURE__*/createElement(Typography, {
    variant: "h4",
    children: dateText,
    "data-mui-test": "datepicker-toolbar-date",
    align: isLandscape ? 'left' : 'center',
    className: clsx(isLandscape && classes.dateTitleLandscape)
  }));
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty$d(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var datePickerConfig = {
  useValidation: makeValidationHook(validateDate),
  DefaultToolbarComponent: DatePickerToolbar,
  useInterceptProps: function useInterceptProps(_ref) {
    var _ref$openTo = _ref.openTo,
        openTo = _ref$openTo === void 0 ? 'date' : _ref$openTo,
        _ref$views = _ref.views,
        views = _ref$views === void 0 ? ['year', 'date'] : _ref$views,
        _ref$minDate = _ref.minDate,
        __minDate = _ref$minDate === void 0 ? defaultMinDate : _ref$minDate,
        _ref$maxDate = _ref.maxDate,
        __maxDate = _ref$maxDate === void 0 ? defaultMaxDate : _ref$maxDate,
        other = _objectWithoutProperties$4(_ref, ["openTo", "views", "minDate", "maxDate"]);

    var utils = useUtils();
    var minDate = useParsedDate(__minDate);
    var maxDate = useParsedDate(__maxDate);
    return _objectSpread$1({
      views: views,
      openTo: openTo,
      minDate: minDate,
      maxDate: maxDate,
      mask: '__/__/____',
      inputFormat: getFormatByViews(views, utils)
    }, other);
  }
};
var DatePicker = makePickerWithStateAndWrapper(ResponsiveWrapper, _objectSpread$1({
  name: 'MuiPickersDatePicker'
}, datePickerConfig));
makePickerWithStateAndWrapper(MobileWrapper, _objectSpread$1({
  name: 'MuiPickersMobileDatePicker'
}, datePickerConfig));
makePickerWithStateAndWrapper(DesktopWrapper, _objectSpread$1({
  name: 'MuiPickersDesktopDatePicker'
}, datePickerConfig));
makePickerWithStateAndWrapper(StaticWrapper, _objectSpread$1({
  name: 'MuiPickersStaticDatePicker'
}, datePickerConfig));

var css_248z$y = ".MuiOutlinedInput-inputAdornedEnd{padding-bottom:.7rem!important;padding-top:.7rem!important}";
styleInject(css_248z$y);

const DatepickerContainer = (props) => {
    const { dataTestid, value, onChange } = props;
    const { locale } = useTranslationContext();
    return (jsx(LocalizationProvider$1, Object.assign({ dateAdapter: DateFnsUtils, locale: Locales[locale] }, { children: jsx(DatePicker, { disablePast: true, value: value, onChange: (date) => onChange(date), renderInput: (inputProps) => (jsx(TextField, Object.assign({}, inputProps, { "data-testid": dataTestid, variant: "outlined" }), void 0)), autoOk: true }, void 0) }), void 0));
};

const CommonComponents = (props) => {
    const { setTranslate, setLocale } = useTranslationContext();
    useEffect(() => {
        props.translate && setTranslate(() => props.translate);
    }, [props.translate]);
    useEffect(() => {
        props.locale && setLocale(props.locale);
    }, [props.locale]);
    return jsx(Fragment$1, { children: props.children }, void 0);
};
const CommonComponentsProvider = (props) => {
    return (jsx(TranslationContextProvider, { children: jsx(CommonComponents, Object.assign({ translate: props.translate, locale: props.locale }, { children: props.children }), void 0) }, void 0));
};

var css_248z$x = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}html{overflow:hidden}html body{background-color:#ecf0f5;margin:0}html body .root{flex:1;min-height:750px;width:100%}html h1,html h2,html h3,html h4,html h5{font-weight:400;letter-spacing:normal;line-height:1.2;text-align:left}html h1{font-size:1.4375rem}html h2{font-size:1.1875rem}html h3{font-size:.947rem}html h4,html h5{font-size:.9375rem}@media (max-width:1300px){html{font-size:12px!important}}@media (min-width:1300px) and (max-width:1500px){html{font-size:12.8px!important}}@media (min-width:1500px) and (max-width:1580px){html{font-size:14.4px!important}}@media (min-width:1580px){html{font-size:16px!important}}";
styleInject(css_248z$x);

const StyleProvider = (props) => {
    return jsx(ThemeProvider$1, Object.assign({ theme: createTheme(props.theme) }, { children: props.children }), void 0);
};

var css_248z$w = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon,.stepper-wrapper .MuiSvgIcon-root,.stepper-wrapper .pencil-icon-circle{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.stepper-wrapper.class-margin{margin:1.55rem 5rem}.stepper-wrapper .MuiStepper-root{padding:0!important}.stepper-wrapper .MuiSvgIcon-root,.stepper-wrapper .pencil-icon-circle{height:1.3em;width:1.3em}.stepper-wrapper .pencil-icon-circle .pencil-icon{font-size:.75rem}.stepper-wrapper .MuiStepLabel-label{color:#767676;font-size:1rem}.stepper-wrapper .MuiStepIcon-root{color:#d8d8d8}.stepper-wrapper .MuiStep-root:first-child{padding-left:0!important}.stepper-wrapper .MuiStep-root:last-child{padding-right:0!important}.stepper-wrapper .MuiStepIcon-root.MuiStepIcon-active,.stepper-wrapper .MuiStepIcon-root.MuiStepIcon-completed{color:var(--color)}.stepper-wrapper .MuiStepIcon-root.Mui-error{color:#f44336}.stepper-wrapper .Mui-disabled .pencil-icon-circle,.stepper-wrapper .pencil-icon-circle{background-color:var(--color)}.stepper-wrapper .Mui-disabled .MuiStepIcon-root.MuiStepIcon-active,.stepper-wrapper .Mui-disabled .MuiStepIcon-root.MuiStepIcon-completed{color:#d8d8d8}.stepper-wrapper .MuiStepLabel-label.MuiStepLabel-active,.stepper-wrapper .MuiStepLabel-label.MuiStepLabel-completed{color:#000}";
styleInject(css_248z$w);

const useStyles = makeStyles$1((theme) => ({
    root: {
        width: '100%'
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1)
    },
    label: {
        cursor: 'pointer'
    }
}));
const pencilIcon = (jsx(Avatar, Object.assign({ className: "pencil-icon-circle" }, { children: jsx(CreateIcon, { className: "pencil-icon" }, void 0) }), void 0));
const StepperComponent = (props) => {
    const classes = useStyles();
    const { dataTestid, color, highestVisitedIndex, activeStep, steps, onClick, disableGoingBack } = props;
    let isDisabled = false;
    const checkIsDisabled = (index) => {
        if (isDisabled)
            return true;
        if (index <= highestEnabledIndex())
            return false;
        isDisabled = true;
        return isDisabled;
    };
    const checkIsCompleted = (index) => {
        if (index >= highestVisitedIndex)
            return false;
        return steps[index].isValid;
    };
    const highestEnabledIndex = () => {
        const firstInvalidIndex = steps.findIndex((step, index) => index < highestVisitedIndex && !step.isValid);
        return firstInvalidIndex !== -1 ? firstInvalidIndex : highestVisitedIndex;
    };
    return (jsx("div", Object.assign({ "data-testid": dataTestid, className: classNames('stepper-wrapper', 'class-margin'), style: { '--color': color } }, { children: jsx("div", Object.assign({ className: classes.root }, { children: jsx(Stepper, Object.assign({ activeStep: highestEnabledIndex() }, { children: steps.map(({ index, title, formErrors }) => {
                    const error = Boolean(Object.keys(formErrors).length);
                    return (jsx(Step$1, Object.assign({ disabled: disableGoingBack || checkIsDisabled(index), active: !checkIsDisabled(index) }, { children: jsx(StepButton, Object.assign({ completed: checkIsCompleted(index) }, (index === activeStep && {
                            icon: pencilIcon
                        }), { children: jsx(StepLabel, Object.assign({ "data-testid": `step${index}`, className: classes.label, onClick: () => {
                                    return index <= highestVisitedIndex ? onClick(index) : undefined;
                                }, error: error }, { children: title }), void 0) }), void 0) }), index));
                }) }), void 0) }), void 0) }), void 0));
};

const handleFormErrors = (validationErrors, steps, setSteps) => {
    const stepsTemp = [...steps];
    stepsTemp.forEach((step) => {
        const stepTemp = Object.assign({}, step);
        stepTemp.validationList.forEach(validationItem => {
            validationErrors.forEach(validationError => {
                if (validationItem.fields.includes(validationError.inputField))
                    stepTemp.formErrors[validationError.inputField] = validationError.errorKey;
            });
        });
    });
    setSteps(stepsTemp);
};
const createStepsFunc = (funcProps) => {
    const { stepComponents, stepsTitlesIds, testIds, validationsList } = funcProps;
    const stepsArray = [];
    stepComponents.forEach((component, i) => {
        stepsArray.push({
            index: i,
            title: stepsTitlesIds[i],
            component,
            testId: testIds[i],
            validationList: validationsList[i],
            formErrors: {},
            isValid: true
        });
    });
    return stepsArray;
};

var stepperUtils = /*#__PURE__*/Object.freeze({
  __proto__: null,
  createStepsFunc: createStepsFunc,
  handleFormErrors: handleFormErrors
});

var css_248z$v = ".stepperNavigation-module_stepper-navigation-wrapper__pTZ68{height:100%!important}.stepperNavigation-module_stepper-navigation-wrapper__pTZ68 .stepperNavigation-module_stepper-navigation__vM3Mw{box-shadow:none!important;display:flex;flex-direction:column;height:100%!important;margin:auto;width:100%!important}.stepperNavigation-module_stepper-navigation-wrapper__pTZ68 .stepperNavigation-module_stepper-navigation__vM3Mw .MuiCardActions-spacing{height:15%;justify-content:flex-end}.stepperNavigation-module_stepper-navigation-wrapper__pTZ68 .stepperNavigation-module_stepper-navigation__vM3Mw .MuiDialogActions-spacing{margin-right:4rem}.stepperNavigation-module_stepper-navigation-wrapper__pTZ68 .stepperNavigation-module_stepper-navigation__vM3Mw .loading-action.MuiDialogActions-spacing{margin-right:1rem}.stepperNavigation-module_stepper-navigation-wrapper__pTZ68 .stepperNavigation-module_stepper-navigation-content-card__2V-qt{padding:0!important}";
var styles$s = {"stepper-navigation-wrapper":"stepperNavigation-module_stepper-navigation-wrapper__pTZ68","stepper-navigation":"stepperNavigation-module_stepper-navigation__vM3Mw","stepper-navigation-content-card":"stepperNavigation-module_stepper-navigation-content-card__2V-qt"};
styleInject(css_248z$v);

const StepperNavigation = (props) => {
    const { isLoading, isLoadingAction, activeStep, highestVisitedIndex, onClick, steps, buttons, componentOnLoading, disableGoingBack, width = '80vw', isEdit } = props;
    const { component: Component, testId } = steps[activeStep];
    return (jsx("div", Object.assign({ className: styles$s['stepper-navigation-wrapper'], style: { '--width': width } }, { children: jsxs(CardContainer, Object.assign({ className: styles$s['stepper-navigation'], contentClassName: styles$s['stepper-navigation-content-card'], raised: true, actions: jsxs(Fragment$1, { children: [jsx(Actions, { className: "loading-action", buttons: buttons.filter(button => !button.isHidden) }, void 0), isLoadingAction && componentOnLoading] }, void 0) }, { children: [jsx(StepperComponent, { dataTestid: "stepper-navigation", color: "#1c476d", activeStep: activeStep, highestVisitedIndex: highestVisitedIndex, steps: steps.map(({ index, title, isValid, formErrors }) => ({
                        index,
                        title,
                        isValid,
                        formErrors
                    })), onClick: onClick, disableGoingBack: disableGoingBack }, void 0), isLoading && jsx(Message, { type: "loader" }, void 0), !isLoading && jsx(Component, { isEdit: isEdit, testId: testId, formErrors: steps[activeStep].formErrors }, void 0)] }), void 0) }), void 0));
};

const StepperNavigationContainer = (props) => {
    var _a, _b, _c, _d;
    const { isLoading, isLoadingAction, isEdit, steps, reset, fields, onCancel, configuredButtons, componentOnLoading, noButtons, disableGoingBack, width, backOnFirstStep } = props;
    const [activeIndex, setActiveIndex] = useState(0);
    const [highestVisitedIndex, setHighestVisitedIndex] = useState(0);
    const [formValidity, setFormValidity] = useState(false);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const isFirstIndex = activeIndex === 0;
    const isLastIndex = activeIndex === steps.length - 1;
    const { translate } = useTranslationContext();
    const onClickCancelButton = () => {
        reset();
        onCancel();
    };
    const onClickBackButton = () => {
        setActiveIndex(activeIndex - 1);
    };
    const onClickOkButton = () => {
        const updateBoth = activeIndex === highestVisitedIndex;
        setActiveIndex(activeIndex + 1);
        updateBoth && setHighestVisitedIndex(activeIndex + 1);
    };
    const cancelButton = Object.assign({ text: translate('CANCEL'), onClick: onClickCancelButton, type: 'textFlat' }, (_a = configuredButtons === null || configuredButtons === void 0 ? void 0 : configuredButtons[activeIndex]) === null || _a === void 0 ? void 0 : _a[0]);
    const backButton = Object.assign({ text: translate('BACK'), onClick: onClickBackButton, type: 'textFlat' }, (_b = configuredButtons === null || configuredButtons === void 0 ? void 0 : configuredButtons[activeIndex]) === null || _b === void 0 ? void 0 : _b[1]);
    const buttonSubmitKey = isEdit ? 'UPDATE' : 'CREATE';
    const okButton = Object.assign(Object.assign({ text: translate(isLastIndex ? buttonSubmitKey : 'CONTINUE'), type: formValidity && !isButtonClicked ? 'primary' : 'primaryDisabled' }, (_c = configuredButtons === null || configuredButtons === void 0 ? void 0 : configuredButtons[activeIndex]) === null || _c === void 0 ? void 0 : _c[2]), { onClick: () => {
            var _a, _b, _c, _d, _e;
            if (!((_b = (_a = configuredButtons === null || configuredButtons === void 0 ? void 0 : configuredButtons[activeIndex]) === null || _a === void 0 ? void 0 : _a[2]) === null || _b === void 0 ? void 0 : _b.onClick)) {
                !isLastIndex && onClickOkButton();
            }
            else {
                (_e = (_d = (_c = configuredButtons === null || configuredButtons === void 0 ? void 0 : configuredButtons[activeIndex]) === null || _c === void 0 ? void 0 : _c[2]) === null || _d === void 0 ? void 0 : _d.onClick) === null || _e === void 0 ? void 0 : _e.call(_d, onClickOkButton);
                setIsButtonClicked(true);
            }
        } });
    const secondOkButton = Object.assign(Object.assign({ type: formValidity && !isButtonClicked ? 'primary' : 'primaryDisabled' }, (_d = configuredButtons === null || configuredButtons === void 0 ? void 0 : configuredButtons[activeIndex]) === null || _d === void 0 ? void 0 : _d[3]), { onClick: () => {
            var _a, _b, _c;
            (_c = (_b = (_a = configuredButtons === null || configuredButtons === void 0 ? void 0 : configuredButtons[activeIndex]) === null || _a === void 0 ? void 0 : _a[3]) === null || _b === void 0 ? void 0 : _b.onClick) === null || _c === void 0 ? void 0 : _c.call(_b, onClickOkButton);
            setIsButtonClicked(true);
        } });
    const defaultButtons = [cancelButton, okButton];
    const [buttons, setButtons] = useState(defaultButtons);
    const calcButtons = useCallback$1(() => {
        var _a;
        const tmpButtons = [...defaultButtons];
        if (!isFirstIndex || backOnFirstStep) {
            tmpButtons.splice(1, 0, backButton);
        }
        if (isLastIndex && ((_a = configuredButtons === null || configuredButtons === void 0 ? void 0 : configuredButtons[activeIndex]) === null || _a === void 0 ? void 0 : _a[3])) {
            tmpButtons.push(secondOkButton);
        }
        setButtons(tmpButtons);
    }, [defaultButtons, isFirstIndex, backButton]);
    const previousRefIsFormValidated = useRef(false);
    useEffect(() => {
        previousRefIsFormValidated.current = formValidity;
    });
    const prevIsValidateForm = previousRefIsFormValidated.current;
    useEffect(() => {
        if (prevIsValidateForm !== formValidity) {
            calcButtons();
        }
    }, [formValidity, prevIsValidateForm, calcButtons]);
    useEffect(() => {
        calcButtons();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isButtonClicked, isLoadingAction, configuredButtons]);
    useEffect(() => {
        isButtonClicked && setIsButtonClicked(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fields, configuredButtons]);
    const checkValidation = useCallback$1(() => {
        let isValid = true;
        const stepValidation = [...steps[activeIndex].validationList];
        stepValidation.forEach((validation) => {
            const validationFields = validation.fields;
            const validationValue = validation.value;
            let numOfInvalidFields = 0;
            validationFields.forEach(field => {
                const selectedField = fields[field];
                if (typeof validationValue === 'function' && validationValue(selectedField)) {
                    numOfInvalidFields++;
                }
                else if (JSON.stringify(selectedField) === JSON.stringify(validationValue))
                    numOfInvalidFields++;
            });
            if (numOfInvalidFields === validationFields.length)
                isValid = false;
        });
        setFormValidity(isValid);
        steps[activeIndex].isValid = isValid;
    }, [activeIndex, steps, fields]);
    useEffect(() => {
        checkValidation();
    }, [fields, checkValidation]);
    const prevRefActiveIndex = useRef(0);
    useEffect(() => {
        prevRefActiveIndex.current = activeIndex;
    });
    const prevActiveIndex = prevRefActiveIndex.current;
    useEffect(() => {
        if (prevActiveIndex !== activeIndex) {
            calcButtons();
        }
    }, [activeIndex, backButton, defaultButtons, isFirstIndex, prevActiveIndex, calcButtons]);
    const onClickOnStepper = (step) => {
        if (!formValidity) {
            if (step >= activeIndex)
                return;
        }
        setActiveIndex(step);
    };
    return (jsx(StepperNavigation, { isEdit: isEdit, isLoading: isLoading, isLoadingAction: isLoadingAction, activeStep: activeIndex, highestVisitedIndex: highestVisitedIndex, onClick: onClickOnStepper, steps: steps, buttons: noButtons ? [] : buttons, componentOnLoading: componentOnLoading, disableGoingBack: disableGoingBack, width: width }, void 0));
};

var css_248z$u = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.empty-state{align-items:center;color:#95939b;display:flex;flex-direction:column;height:60%;justify-content:space-around;width:60%}.empty-state .icon{height:80%;width:88%}.empty-state img.icon{height:80%;width:auto}.empty-state svg{height:100%;width:100%}";
styleInject(css_248z$u);

const EmptyState$1 = (props) => {
    const { translate } = useTranslationContext();
    const { iconName = 'adminDashboardEmptyState', isPng = false } = props;
    const noDataText = translate('NoData');
    return (jsx(Message, Object.assign({ type: "component" }, { children: jsxs("div", Object.assign({ className: "empty-state", "data-testid": "empty-state" }, { children: [jsx(Icon, { name: iconName, className: "icon", dataTestid: iconName, isPng: isPng }, void 0), jsx("div", Object.assign({ "data-testid": "text" }, { children: noDataText }), void 0)] }), void 0) }), void 0));
};

var css_248z$t = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.leaderboard-card{display:flex;flex-direction:column;padding-top:1rem;width:100%}.leaderboard-card .leaderboard-card-header{align-items:center;display:flex;justify-content:space-between}.leaderboard-card .leaderboard-card-header .leaderboard-card-title{align-items:center;color:#565360;display:flex;justify-content:space-between;margin-bottom:1rem;width:12rem}.leaderboard-card .leaderboard-card-header .leaderboard-card-export svg{cursor:pointer;height:1.5rem;margin-right:1rem;width:1.5rem}.leaderboard-card .header{align-items:center;display:flex}.leaderboard-card .header .icon{margin-right:1rem}.leaderboard-card .bottom{align-items:center;display:flex;height:33.8rem;justify-content:center;width:100%}.leaderboard-card .bottom .text-field{width:100%}.leaderboard-card .bottom .search-table{width:96%}";
styleInject(css_248z$t);

const LeaderboardCard = (props) => {
    const { iconName, title, wrapperClassName, searchTableData, totalRows, hasExport, onExport } = props;
    const { translate } = useTranslationContext();
    const isEmptyState = !totalRows;
    const isTeamBoard = iconName === 'teamLeaderboard';
    const rootId = isTeamBoard ? 'common-components-1786037195455-1' : 'common-components-1786037195461-1';
    const headerId = isTeamBoard ? 'common-components-1786037195456-1' : 'common-components-1786037195462-1';
    const titleId = isTeamBoard ? 'common-components-1786037195457-2' : 'common-components-1786037195463-10';
    const exportId = isTeamBoard ? 'common-components-1786037195458-9' : 'common-components-1786037195464-0';
    const exportIconId = isTeamBoard ? 'common-components-1786037195459-1' : 'common-components-1786037195465-4';
    const bodyId = isTeamBoard ? 'common-components-1786037195460-9' : 'common-components-1786037195466-9';
    return (jsxs("div", Object.assign({ "data-testid": "leaderboard-card", className: classNames('leaderboard-card', wrapperClassName), id: rootId }, { children: [jsxs("div", Object.assign({ className: "leaderboard-card-header", id: headerId }, { children: [title && (jsxs("div", Object.assign({ "data-testid": "leaderboard-card-title", className: "leaderboard-card-title", id: titleId }, { children: [iconName && jsx(Icon, { dataTestid: `${iconName}-icon`, name: iconName }, void 0), title] }), void 0)), hasExport && (jsx("div", Object.assign({ "data-testid": "leaderboard-card-export", className: "leaderboard-card-export", id: exportId }, { children: jsx(TooltipContainer, Object.assign({ placement: "top", title: translate('Export') }, { children: jsx("span", Object.assign({ "data-testid": "export-icon-wrapper", id: exportIconId }, { children: jsx(Icon, { dataTestid: "export-icon", name: "publish", onClick: onExport }, void 0) }), void 0) }), void 0) }), void 0))] }), void 0), jsxs("div", Object.assign({ "data-testid": "card-wrapper", className: "bottom", id: bodyId }, { children: [isEmptyState && jsx(EmptyState$1, {}, void 0), !isEmptyState && jsx(SearchTable, Object.assign({}, searchTableData, { isTeamBoard: isTeamBoard }), void 0)] }), void 0)] }), void 0));
};

const calcSearchIndexes = (headers, searchColumns) => {
    const searchIndexes = [];
    headers.forEach((header, index) => {
        if (searchColumns.includes(header.id)) {
            searchIndexes.push(index);
        }
    });
    return searchIndexes;
};
const LeaderboardCardContainer = (props) => {
    const { translate } = useTranslationContext();
    const { headers, rows, searchColumns = [], changeBackgroundColorCondition, iconName } = props, rest = __rest$1(props, ["headers", "rows", "searchColumns", "changeBackgroundColorCondition", "iconName"]);
    const isTeamBoard = iconName === 'teamLeaderboard';
    const searchId = isTeamBoard ? 'common-components-1786037195467-10' : 'common-components-1786037195469-3';
    const paginationId = isTeamBoard ? 'common-components-1786037195468-6' : 'common-components-1786037195470-10';
    const rowsPerPageOptions = [5];
    const rowsPerPage = rowsPerPageOptions[0];
    const [searchValue, setSearchValue] = useState('');
    const [currentPage, setCurrentPage] = useState(0);
    const searchIndexes = useMemo$1(() => calcSearchIndexes(headers, searchColumns), [headers, searchColumns]);
    const getFilteredRows = (newRows) => {
        return newRows.filter(newRow => {
            return searchIndexes.some(index => String(newRow[index]).toLowerCase().includes(searchValue.toLowerCase()));
        });
    };
    const searchData = {
        placeholder: translate('SearchPlaceholder'),
        value: searchValue,
        onChange: (text) => {
            setCurrentPage(0);
            setSearchValue(text);
        },
        leftIcon: jsx(SearchIcon, {}, void 0),
        id: searchId
    };
    const filteredRows = getFilteredRows(rows);
    const tableData = {
        headers,
        rows: filteredRows,
        changeBackgroundColorCondition,
        changedBackgroundColor: '#ECF0F5',
        paginationData: {
            rowsPerPageOptions,
            rowsPerPage,
            currentPage,
            count: filteredRows.length,
            setCurrentPage,
            id: paginationId
        },
        noDataText: translate('NoRecords'),
        ofText: translate('of'),
        bgColor: 'bg-colour-white'
    };
    const data = Object.assign(Object.assign({}, rest), { iconName, searchTableData: { searchData, tableData }, totalRows: rows.length });
    return jsx(LeaderboardCard, Object.assign({}, data), void 0);
};

var css_248z$s = ".detailsPresentBody-module_wrapper__FNhh7{align-items:center;display:flex;flex-direction:column;height:66%;width:100%}.detailsPresentBody-module_wrapper__FNhh7 .detailsPresentBody-module_body__3kGAi{align-items:center;display:flex;height:100%;justify-content:space-between;width:97%}.detailsPresentBody-module_wrapper__FNhh7 .detailsPresentBody-module_avatar__RLQ03{height:60%;width:93%}.detailsPresentBody-module_fill-body__-ToST{align-items:center;display:flex;justify-content:space-between}.detailsPresentBody-module_not-fill-body__F44j9{align-items:center;display:flex}.detailsPresentBody-module_class-key-value-rectangle-grid__OUowl{grid-gap:2rem;display:grid;grid-template-columns:25.3% 25.3% 25.3% 25.3%;grid-template-rows:60% 60%}";
var styles$r = {"wrapper":"detailsPresentBody-module_wrapper__FNhh7","body":"detailsPresentBody-module_body__3kGAi","avatar":"detailsPresentBody-module_avatar__RLQ03","fill-body":"detailsPresentBody-module_fill-body__-ToST","not-fill-body":"detailsPresentBody-module_not-fill-body__F44j9","class-key-value-rectangle-grid":"detailsPresentBody-module_class-key-value-rectangle-grid__OUowl"};
styleInject(css_248z$s);

const DetailsPresentBody = (props) => {
    const { avatar, keyValueList, fillBody = true, withMargin = false, avatarClassName = '', lineNumbers = 1 } = props;
    return (jsx("div", Object.assign({ className: styles$r.wrapper }, { children: jsxs("div", Object.assign({ className: styles$r.body }, { children: [avatar && jsx(AvatarContainer, Object.assign({}, avatar, { hasMargin: false, className: avatarClassName }), void 0), jsx("div", Object.assign({ className: classNames(styles$r.avatar, {
                        [styles$r['fill-body']]: fillBody,
                        [styles$r['not-fill-body']]: !fillBody,
                        [styles$r['class-key-value-rectangle-grid']]: lineNumbers !== 1
                    }) }, { children: keyValueList.map((keyValueItem, i) => (jsx(KeyValueRectanglePresent, Object.assign({}, keyValueItem, { withMargin: withMargin && i !== 0 }), i))) }), void 0)] }), void 0) }), void 0));
};

var css_248z$r = ".detailsPresentHeader-module_class-ellipsis-2-lines__XA04E,.detailsPresentHeader-module_class-ellipsis-lines__-NeX8,.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_left__ehtk9 .detailsPresentHeader-module_text__L6Wtv,.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_left__ehtk9 .detailsPresentHeader-module_title__IzAgt{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.detailsPresentHeader-module_class-ellipsis-2-lines__XA04E{-webkit-line-clamp:2!important;max-height:4rem!important}.detailsPresentHeader-module_MuiChip-root__VdzMK{margin:.5rem .3rem .5rem .5rem}.detailsPresentHeader-module_ellipse-chip__KkZ5Z.detailsPresentHeader-module_MuiChip-root__VdzMK{border-radius:1rem;height:20px}.detailsPresentHeader-module_ellipse-chip__KkZ5Z.detailsPresentHeader-module_MuiChip-root__VdzMK .detailsPresentHeader-module_MuiChip-label__QpI53{padding-left:8px;padding-right:8px}.detailsPresentHeader-module_square-chip__4CQtq.detailsPresentHeader-module_MuiChip-root__VdzMK{border-radius:0!important}.detailsPresentHeader-module_class-width-height-100__PGotD{height:100%;width:100%}.detailsPresentHeader-module_MuiTooltip-tooltip__57ZPr{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.detailsPresentHeader-module_MuiTooltip-arrow__hn-yk{color:#fff!important}.detailsPresentHeader-module_class-font-size-icon__yVwxT{font-size:1.25rem}.detailsPresentHeader-module_header__1jC8P{align-items:center;display:flex;flex-direction:column;height:5rem;justify-content:center;width:100%}.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_body__I0IRJ{align-items:center;display:flex;height:100%;justify-content:space-between;width:97%}.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_left__ehtk9{align-items:center;display:flex;height:100%}.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_left__ehtk9 .detailsPresentHeader-module_class-margin-right-1-rem__kZGNQ{margin-right:1rem}.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_left__ehtk9 .detailsPresentHeader-module_text__L6Wtv,.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_left__ehtk9 .detailsPresentHeader-module_title__IzAgt{display:inline-block}.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_left__ehtk9 .detailsPresentHeader-module_title__IzAgt{font-size:21;font-weight:700}.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_left__ehtk9 .detailsPresentHeader-module_dotIcon__a2fM4{height:15%;margin-left:1rem;margin-right:1rem}.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_left__ehtk9 .detailsPresentHeader-module_text__L6Wtv{max-width:25rem}.detailsPresentHeader-module_header__1jC8P .detailsPresentHeader-module_left__ehtk9 .detailsPresentHeader-module_class-font-colour-present-header__y7Qf7{color:#f0575b}.detailsPresentHeader-module_right__L2-MO{align-items:center;display:flex;justify-content:space-between}.detailsPresentHeader-module_right__L2-MO .detailsPresentHeader-module_button-wrapper__lt7gy{margin-left:1rem}.detailsPresentHeader-module_right__L2-MO .detailsPresentHeader-module_button-wrapper__lt7gy .detailsPresentHeader-module_button__xEYcu{height:60%}.detailsPresentHeader-module_right__L2-MO .detailsPresentHeader-module_button__xEYcu:disabled{pointer-events:none}.detailsPresentHeader-module_right__L2-MO .detailsPresentHeader-module_icon__wF2LE{margin-left:1rem}";
var styles$q = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"detailsPresentHeader-module_class-ellipsis-lines__-NeX8","header":"detailsPresentHeader-module_header__1jC8P","left":"detailsPresentHeader-module_left__ehtk9","text":"detailsPresentHeader-module_text__L6Wtv","title":"detailsPresentHeader-module_title__IzAgt","class-ellipsis-2-lines":"detailsPresentHeader-module_class-ellipsis-2-lines__XA04E","MuiChip-root":"detailsPresentHeader-module_MuiChip-root__VdzMK","ellipse-chip":"detailsPresentHeader-module_ellipse-chip__KkZ5Z","MuiChip-label":"detailsPresentHeader-module_MuiChip-label__QpI53","square-chip":"detailsPresentHeader-module_square-chip__4CQtq","class-width-height-100":"detailsPresentHeader-module_class-width-height-100__PGotD","MuiTooltip-tooltip":"detailsPresentHeader-module_MuiTooltip-tooltip__57ZPr","MuiTooltip-arrow":"detailsPresentHeader-module_MuiTooltip-arrow__hn-yk","class-font-size-icon":"detailsPresentHeader-module_class-font-size-icon__yVwxT","body":"detailsPresentHeader-module_body__I0IRJ","class-margin-right-1-rem":"detailsPresentHeader-module_class-margin-right-1-rem__kZGNQ","dotIcon":"detailsPresentHeader-module_dotIcon__a2fM4","class-font-colour-present-header":"detailsPresentHeader-module_class-font-colour-present-header__y7Qf7","right":"detailsPresentHeader-module_right__L2-MO","button-wrapper":"detailsPresentHeader-module_button-wrapper__lt7gy","button":"detailsPresentHeader-module_button__xEYcu","icon":"detailsPresentHeader-module_icon__wF2LE"};
styleInject(css_248z$r);

const DetailsPresentHeader = (props) => {
    const { isStarted, name, leftComponents, buttons, components, menuItems, presentIcon = true, avatar, sharableLink, sharedToEveryone } = props;
    const getTextComponent = itemComponent => (jsx("span", Object.assign({ title: itemComponent.text, className: classNames(styles$q.text, itemComponent.sizeClassName, itemComponent.colorClassName, {
            [styles$q['class-font-colour-present-header']]: isStarted
        }) }, { children: itemComponent.text }), void 0));
    return (jsx("div", Object.assign({ className: styles$q.header }, { children: jsxs("div", Object.assign({ className: styles$q.body }, { children: [jsxs("div", Object.assign({ className: styles$q.left }, { children: [presentIcon && jsx(Icon, { name: "golbet", className: styles$q['class-margin-right-1-rem'] }, void 0), avatar && (jsx(AvatarContainer, Object.assign({}, avatar, { hasMargin: false, className: styles$q['class-margin-right-1-rem'], avatarSize: "2.5rem" }), void 0)), jsx("span", Object.assign({ title: name, className: styles$q.title }, { children: name }), void 0), leftComponents === null || leftComponents === void 0 ? void 0 : leftComponents.map((itemComponent, i) => {
                            let component = itemComponent;
                            if (!isValidElement(itemComponent))
                                component = getTextComponent(itemComponent);
                            return (jsxs(Fragment, { children: [jsx(FiberManualRecordIcon, { "data-testid": "dot-icon", color: "disabled", className: styles$q.dotIcon }, void 0), component] }, `left-component-${i}`));
                        })] }), void 0), jsxs("div", Object.assign({ className: styles$q.right }, { children: [sharableLink && jsx(SharableLink, { url: sharableLink, disabled: sharedToEveryone }, void 0), components === null || components === void 0 ? void 0 : components.map(itemComponent => itemComponent), buttons &&
                            buttons.map((_a) => {
                                var { className } = _a, buttonRest = __rest$1(_a, ["className"]);
                                return (jsx(ButtonContainer, Object.assign({}, buttonRest, { className: classNames(styles$q.button, className), wrapperClassName: styles$q['button-wrapper'] }), buttonRest.text));
                            }), menuItems && jsx(Menu, { menuItems: menuItems, iconClassName: styles$q.icon, disabled: !menuItems }, void 0)] }), void 0)] }), void 0) }), void 0));
};

var css_248z$q = ".detailsPresent-module_wrapper__Y-xuz{animation:detailsPresent-module_fade__uMi2x;animation-duration:1s;width:100%}.detailsPresent-module_class-pink-border__Cjsn1{border:2px solid #f0575b}";
var styles$p = {"wrapper":"detailsPresent-module_wrapper__Y-xuz","fade":"detailsPresent-module_fade__uMi2x","class-pink-border":"detailsPresent-module_class-pink-border__Cjsn1"};
styleInject(css_248z$q);

const DetailsPresent = (props) => {
    const { dataTestId, headerProps, bodyProps, className } = props;
    return (jsxs(Paper$1, Object.assign({ "data-testid": dataTestId, className: classNames(styles$p.wrapper, className, {
            [styles$p['class-pink-border']]: headerProps.isStarted
        }), style: { height: `${8 + 6 * (bodyProps.lineNumbers || 1)}rem` } }, { children: [jsx(DetailsPresentHeader, Object.assign({}, headerProps), void 0), jsx(DividerContainer, {}, void 0), jsx(DetailsPresentBody, Object.assign({}, bodyProps), void 0)] }), void 0));
};

var css_248z$p = ".optionButton-module_option-button__pVpjK .MuiPopover-paper{left:unset!important;right:0}";
var styles$o = {"option-button":"optionButton-module_option-button__pVpjK"};
styleInject(css_248z$p);

const OptionsButton = (props) => {
    const { mainText, options, dataTestId, width } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const getOptions = () => {
        return options.map(option => (jsx(MenuItem, Object.assign({ onClick: () => {
                handleClose();
                option.onClick();
            } }, { children: option.text }), option.text)));
    };
    return (jsxs("div", Object.assign({ "data-testid": dataTestId || 'options-button', style: { width } }, { children: [jsx(ButtonContainer, { text: mainText, onClick: handleClick }, void 0), jsx(Menu$1, Object.assign({ "aria-labelledby": "demo-positioned-button", anchorEl: anchorEl, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, transformOrigin: { vertical: 'top', horizontal: 'center' }, open: open, onClose: handleClose, className: styles$o['option-button'], PaperProps: {
                    style: {
                        width
                    }
                } }, { children: getOptions() }), void 0)] }), void 0));
};

const Pagination = (_a) => {
    var { dataTestid, onChange, page } = _a, rest = __rest$1(_a, ["dataTestid", "onChange", "page"]);
    return (jsx(MuiPagination, Object.assign({}, rest, { "data-testid": dataTestid, color: "primary", onChange: (_event, page) => onChange === null || onChange === void 0 ? void 0 : onChange(page), page: page }), void 0));
};

const CreateNewButton = (props) => {
    const { buttonOptions } = props;
    const { translate } = useTranslationContext();
    return (jsx("div", Object.assign({ style: { width: '15rem', height: '2rem' } }, { children: buttonOptions.length === 1 ? (jsx(ButtonContainer, { text: translate('Create_x', { whatToCreate: buttonOptions[0].text }), onClick: buttonOptions[0].onClick, dataTestid: "create-new-button" }, void 0)) : (jsx(OptionsButton, { mainText: translate('CreateNew'), width: "15rem", options: buttonOptions, dataTestId: "create-new-options-button" }, void 0)) }), void 0));
};

var css_248z$o = ".bodyPresentRight-module_class-ellipsis-2-lines__DZUlr,.bodyPresentRight-module_class-ellipsis-lines__GSewP{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.bodyPresentRight-module_class-ellipsis-2-lines__DZUlr{-webkit-line-clamp:2!important;max-height:4rem!important}.bodyPresentRight-module_MuiChip-root__mJ4tP{margin:.5rem .3rem .5rem .5rem}.bodyPresentRight-module_ellipse-chip__pUZ1U.bodyPresentRight-module_MuiChip-root__mJ4tP{border-radius:1rem;height:20px}.bodyPresentRight-module_ellipse-chip__pUZ1U.bodyPresentRight-module_MuiChip-root__mJ4tP .bodyPresentRight-module_MuiChip-label__raKKe{padding-left:8px;padding-right:8px}.bodyPresentRight-module_square-chip__k17-E.bodyPresentRight-module_MuiChip-root__mJ4tP{border-radius:0!important}.bodyPresentRight-module_class-width-height-100__sHc1N{height:100%;width:100%}.bodyPresentRight-module_MuiTooltip-tooltip__r3ILA{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.bodyPresentRight-module_MuiTooltip-arrow__p93Y6{color:#fff!important}.bodyPresentRight-module_class-font-size-icon__Z-TEu{font-size:1.25rem}.bodyPresentRight-module_body-present-right-wrapper__jmU7y{align-items:flex-end;display:flex;flex-direction:column;margin-bottom:.5rem}.bodyPresentRight-module_body-present-right-wrapper__jmU7y .bodyPresentRight-module_line__VQeLk{display:flex;font-size:.8125rem;line-height:1.5rem}.bodyPresentRight-module_body-present-right-wrapper__jmU7y .bodyPresentRight-module_line__VQeLk .bodyPresentRight-module_key__BdB-G{color:#95939b;font-weight:400}.bodyPresentRight-module_body-present-right-wrapper__jmU7y .bodyPresentRight-module_line__VQeLk .bodyPresentRight-module_value__r6lWE{color:#565360;font-weight:600}";
var styles$n = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"bodyPresentRight-module_class-ellipsis-lines__GSewP","class-ellipsis-2-lines":"bodyPresentRight-module_class-ellipsis-2-lines__DZUlr","MuiChip-root":"bodyPresentRight-module_MuiChip-root__mJ4tP","ellipse-chip":"bodyPresentRight-module_ellipse-chip__pUZ1U","MuiChip-label":"bodyPresentRight-module_MuiChip-label__raKKe","square-chip":"bodyPresentRight-module_square-chip__k17-E","class-width-height-100":"bodyPresentRight-module_class-width-height-100__sHc1N","MuiTooltip-tooltip":"bodyPresentRight-module_MuiTooltip-tooltip__r3ILA","MuiTooltip-arrow":"bodyPresentRight-module_MuiTooltip-arrow__p93Y6","class-font-size-icon":"bodyPresentRight-module_class-font-size-icon__Z-TEu","body-present-right-wrapper":"bodyPresentRight-module_body-present-right-wrapper__jmU7y","line":"bodyPresentRight-module_line__VQeLk","key":"bodyPresentRight-module_key__BdB-G","value":"bodyPresentRight-module_value__r6lWE"};
styleInject(css_248z$o);

const BodyPresentRight = (props) => {
    const { values } = props;
    return (jsx("div", Object.assign({ className: styles$n['body-present-right-wrapper'] }, { children: Object.values(values).map(value => (jsxs("div", Object.assign({ className: styles$n.line }, { children: [jsx("div", Object.assign({ className: styles$n.key }, { children: value.key }), void 0), ":\u00A0", jsx(EllipsisText, { text: value.value, className: styles$n.value, maxWidthClassName: "20rem" }, void 0)] }), value.key))) }), void 0));
};

var css_248z$n = ".bodyPresentLeft-module_class-ellipsis-2-lines__KX-9q,.bodyPresentLeft-module_class-ellipsis-lines__FfShH{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.bodyPresentLeft-module_class-ellipsis-2-lines__KX-9q{-webkit-line-clamp:2!important;max-height:4rem!important}.bodyPresentLeft-module_MuiChip-root__XnAmO{margin:.5rem .3rem .5rem .5rem}.bodyPresentLeft-module_ellipse-chip__XWRAw.bodyPresentLeft-module_MuiChip-root__XnAmO{border-radius:1rem;height:20px}.bodyPresentLeft-module_ellipse-chip__XWRAw.bodyPresentLeft-module_MuiChip-root__XnAmO .bodyPresentLeft-module_MuiChip-label__sMy6M{padding-left:8px;padding-right:8px}.bodyPresentLeft-module_square-chip__I2W-l.bodyPresentLeft-module_MuiChip-root__XnAmO{border-radius:0!important}.bodyPresentLeft-module_class-width-height-100__HiUCy{height:100%;width:100%}.bodyPresentLeft-module_MuiTooltip-tooltip__gcynu{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.bodyPresentLeft-module_MuiTooltip-arrow__IRxy1{color:#fff!important}.bodyPresentLeft-module_class-font-size-icon__dwBQw{font-size:1.25rem}.bodyPresentLeft-module_body-present-left-wrapper-width__BKX20{width:80%}.bodyPresentLeft-module_body-present-left-wrapper__J8uwC{display:flex}.bodyPresentLeft-module_body-present-left-wrapper__J8uwC .bodyPresentLeft-module_icon__VXEh0{align-items:center;display:flex;height:3rem!important;justify-content:center;margin-right:1.5rem;margin-top:0;width:3rem!important}.bodyPresentLeft-module_body-present-left-wrapper__J8uwC .bodyPresentLeft-module_bg-icon__t1v81{background-color:#dad8dc;border-radius:50%;height:3rem;margin-right:1.5rem;min-width:3rem}.bodyPresentLeft-module_body-present-left-wrapper__J8uwC .bodyPresentLeft-module_text__rIqus{color:#565360;font-size:.9rem;line-height:1.4375rem;margin:initial!important}";
var styles$m = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"bodyPresentLeft-module_class-ellipsis-lines__FfShH","class-ellipsis-2-lines":"bodyPresentLeft-module_class-ellipsis-2-lines__KX-9q","MuiChip-root":"bodyPresentLeft-module_MuiChip-root__XnAmO","ellipse-chip":"bodyPresentLeft-module_ellipse-chip__XWRAw","MuiChip-label":"bodyPresentLeft-module_MuiChip-label__sMy6M","square-chip":"bodyPresentLeft-module_square-chip__I2W-l","class-width-height-100":"bodyPresentLeft-module_class-width-height-100__HiUCy","MuiTooltip-tooltip":"bodyPresentLeft-module_MuiTooltip-tooltip__gcynu","MuiTooltip-arrow":"bodyPresentLeft-module_MuiTooltip-arrow__IRxy1","class-font-size-icon":"bodyPresentLeft-module_class-font-size-icon__dwBQw","body-present-left-wrapper-width":"bodyPresentLeft-module_body-present-left-wrapper-width__BKX20","body-present-left-wrapper":"bodyPresentLeft-module_body-present-left-wrapper__J8uwC","icon":"bodyPresentLeft-module_icon__VXEh0","bg-icon":"bodyPresentLeft-module_bg-icon__t1v81","text":"bodyPresentLeft-module_text__rIqus"};
styleInject(css_248z$n);

const BodyPresentLeft = (props) => {
    const { icon, text, showIconBackground, fullWidth } = props;
    const getIcon = () => {
        if ((icon === null || icon === void 0 ? void 0 : icon.src) && (icon === null || icon === void 0 ? void 0 : icon.src.indexOf('.svg')) > -1)
            return jsx(AvatarContainer, Object.assign({ className: styles$m.icon }, icon), void 0);
        return jsx(Icon, { className: styles$m.icon, src: icon === null || icon === void 0 ? void 0 : icon.src, isPng: true }, void 0);
    };
    return (jsxs("div", Object.assign({ className: classNames(styles$m['body-present-left-wrapper'], {
            [styles$m['body-present-left-wrapper-width']]: !fullWidth
        }) }, { children: [jsx("div", { children: icon && getIcon() }, void 0), showIconBackground && jsx("div", { className: styles$m['bg-icon'] }, void 0), jsx("div", Object.assign({ title: String(text), className: classNames(styles$m.text, {
                    'class-ellipsis-2-lines': !fullWidth,
                    'class-ellipsis-3-lines': fullWidth
                }) }, { children: text }), void 0)] }), void 0));
};

var css_248z$m = ".cardPresentBody-module_card-body-present-wrapper__VmB97{align-items:center;display:flex;margin:.75rem}.cardPresentBody-module_card-body-present-wrapper__VmB97 .cardPresentBody-module_left__8faHF{width:70%}.cardPresentBody-module_card-body-present-wrapper__VmB97 .cardPresentBody-module_right__O3Qj6{width:30%}.cardPresentBody-module_limit-height__jrFBa{height:5rem}";
var styles$l = {"card-body-present-wrapper":"cardPresentBody-module_card-body-present-wrapper__VmB97","left":"cardPresentBody-module_left__8faHF","right":"cardPresentBody-module_right__O3Qj6","limit-height":"cardPresentBody-module_limit-height__jrFBa"};
styleInject(css_248z$m);

const CardPresentBody = (props) => {
    const { values, text, icon, showIconBackground, fullWidth, fullHeight } = props;
    return (jsxs("div", Object.assign({ className: classNames(styles$l['card-body-present-wrapper'], { [styles$l['limit-height']]: !fullHeight }) }, { children: [jsx("div", Object.assign({ className: !fullWidth && styles$l.left }, { children: jsx(BodyPresentLeft, { text: text, icon: icon, showIconBackground: showIconBackground, fullWidth: fullWidth }, void 0) }), void 0), jsx("div", Object.assign({ className: !fullWidth && styles$l.right }, { children: jsx(BodyPresentRight, { values: values }, void 0) }), void 0)] }), void 0));
};

var css_248z$l = ".actions-module_class-ellipsis-2-lines__M8gOB,.actions-module_class-ellipsis-lines__T4j2f{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.actions-module_class-ellipsis-2-lines__M8gOB{-webkit-line-clamp:2!important;max-height:4rem!important}.actions-module_MuiChip-root__xVOhP{margin:.5rem .3rem .5rem .5rem}.actions-module_ellipse-chip__y4U1I.actions-module_MuiChip-root__xVOhP{border-radius:1rem;height:20px}.actions-module_ellipse-chip__y4U1I.actions-module_MuiChip-root__xVOhP .actions-module_MuiChip-label__le3zz{padding-left:8px;padding-right:8px}.actions-module_square-chip__Oyuuf.actions-module_MuiChip-root__xVOhP{border-radius:0!important}.actions-module_class-width-height-100__ka-fV{height:100%;width:100%}.actions-module_MuiTooltip-tooltip__5DOG-{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.actions-module_MuiTooltip-arrow__KFkh-{color:#fff!important}.actions-module_class-font-size-icon__F1VBQ{font-size:1.25rem}.actions-module_actions-wrapper__JzvLS{align-items:center;cursor:pointer;display:flex}.actions-module_class-horizontal-hr__Lmc2s{border-left:1px solid #c4c4c4;display:block;height:1.1875rem;margin:0;padding:0}";
var styles$k = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"actions-module_class-ellipsis-lines__T4j2f","class-ellipsis-2-lines":"actions-module_class-ellipsis-2-lines__M8gOB","MuiChip-root":"actions-module_MuiChip-root__xVOhP","ellipse-chip":"actions-module_ellipse-chip__y4U1I","MuiChip-label":"actions-module_MuiChip-label__le3zz","square-chip":"actions-module_square-chip__Oyuuf","class-width-height-100":"actions-module_class-width-height-100__ka-fV","MuiTooltip-tooltip":"actions-module_MuiTooltip-tooltip__5DOG-","MuiTooltip-arrow":"actions-module_MuiTooltip-arrow__KFkh-","class-font-size-icon":"actions-module_class-font-size-icon__F1VBQ","actions-wrapper":"actions-module_actions-wrapper__JzvLS","class-horizontal-hr":"actions-module_class-horizontal-hr__Lmc2s"};
styleInject(css_248z$l);

var ActionType;
(function (ActionType) {
    ActionType[ActionType["Edit"] = 0] = "Edit";
    ActionType[ActionType["Delete"] = 1] = "Delete";
    ActionType[ActionType["File"] = 2] = "File";
    ActionType[ActionType["LessonsList"] = 3] = "LessonsList";
    ActionType[ActionType["Publish"] = 4] = "Publish";
    ActionType[ActionType["MissingFile"] = 5] = "MissingFile";
    ActionType[ActionType["LinkedCourses"] = 6] = "LinkedCourses";
    ActionType[ActionType["LessonDuration"] = 7] = "LessonDuration";
})(ActionType || (ActionType = {}));

const ActionsList = {
    [ActionType.Edit]: { iconName: 'edit', tooltipText: 'Edit' },
    [ActionType.Delete]: { iconName: 'trash', tooltipText: 'Delete' },
    [ActionType.File]: { iconName: 'file', tooltipText: 'File' },
    [ActionType.LessonsList]: { iconName: 'lessonsList', tooltipText: 'Lessonslist' },
    [ActionType.Publish]: { iconName: 'publish', tooltipText: 'Publish' },
    [ActionType.MissingFile]: { iconName: 'missingFile', tooltipText: 'MissingFile' },
    [ActionType.LinkedCourses]: { iconName: 'linkedCourses', tooltipText: 'LinkedCourses' },
    [ActionType.LessonDuration]: { iconName: 'time', tooltipText: 'LessonDuration' }
};

var css_248z$k = ".action-module_class-ellipsis-2-lines__DuDdY,.action-module_class-ellipsis-lines__wRrcd{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.action-module_class-ellipsis-2-lines__DuDdY{-webkit-line-clamp:2!important;max-height:4rem!important}.action-module_MuiChip-root__kGWWs{margin:.5rem .3rem .5rem .5rem}.action-module_ellipse-chip__jdTLW.action-module_MuiChip-root__kGWWs{border-radius:1rem;height:20px}.action-module_ellipse-chip__jdTLW.action-module_MuiChip-root__kGWWs .action-module_MuiChip-label__Yd09g{padding-left:8px;padding-right:8px}.action-module_square-chip__lmRqS.action-module_MuiChip-root__kGWWs{border-radius:0!important}.action-module_class-width-height-100__tpU2y{height:100%;width:100%}.action-module_MuiTooltip-tooltip__B1QBO{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.action-module_MuiTooltip-arrow__yQasj{color:#fff!important}.action-module_class-font-size-icon__esdeW{font-size:1.25rem}.action-module_disable__UcA-Z{color:#bfbdc2;cursor:not-allowed;pointer-events:all!important}.action-module_disable__UcA-Z svg{stroke:#bfbdc2}.action-module_action-wrapper__EErww{align-items:center;display:flex;margin:1.3125rem}.action-module_additional-text__-ZOQY{color:#6b6874;font-size:.8125rem;line-height:1.125rem;margin-left:.5rem}.action-module_tooltip__xjiTz{font-size:.8125rem}";
var styles$j = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"action-module_class-ellipsis-lines__wRrcd","class-ellipsis-2-lines":"action-module_class-ellipsis-2-lines__DuDdY","MuiChip-root":"action-module_MuiChip-root__kGWWs","ellipse-chip":"action-module_ellipse-chip__jdTLW","MuiChip-label":"action-module_MuiChip-label__Yd09g","square-chip":"action-module_square-chip__lmRqS","class-width-height-100":"action-module_class-width-height-100__tpU2y","MuiTooltip-tooltip":"action-module_MuiTooltip-tooltip__B1QBO","MuiTooltip-arrow":"action-module_MuiTooltip-arrow__yQasj","class-font-size-icon":"action-module_class-font-size-icon__esdeW","disable":"action-module_disable__UcA-Z","action-wrapper":"action-module_action-wrapper__EErww","additional-text":"action-module_additional-text__-ZOQY","tooltip":"action-module_tooltip__xjiTz"};
styleInject(css_248z$k);

const ActionComponent = (props) => {
    const { type, isDisable, additionalText, onClick, textColor, dataTestId, customTooltip = '' } = props;
    const action = ActionsList[type];
    const { translate } = useTranslationContext();
    return (jsx(TooltipContainer, Object.assign({ title: customTooltip !== '' ? customTooltip : translate(action.tooltipText), titleClassName: styles$j.tooltip }, { children: jsxs("div", Object.assign({ className: classNames(styles$j['action-wrapper'], { [styles$j.disable]: isDisable }), onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(), "data-Testid": dataTestId }, { children: [type !== undefined && jsx(Icon, { name: action.iconName }, void 0), additionalText && (jsx("div", Object.assign({ title: additionalText, className: styles$j['additional-text'], style: { color: textColor || undefined } }, { children: additionalText }), void 0))] }), void 0) }), void 0));
};

const ActionsComponent = (props) => {
    const { actions } = props;
    return (jsx("div", Object.assign({ className: styles$k['actions-wrapper'] }, { children: actions === null || actions === void 0 ? void 0 : actions.map(action => (jsxs(Fragment, { children: [jsx("hr", { className: styles$k['class-horizontal-hr'] }, void 0), jsx(ActionComponent, Object.assign({}, action), void 0)] }, action.type))) }), void 0));
};

var css_248z$j = ".cardPresentTop-module_class-ellipsis-2-lines__nByZ1,.cardPresentTop-module_class-ellipsis-lines__CcWsZ{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.cardPresentTop-module_class-ellipsis-2-lines__nByZ1{-webkit-line-clamp:2!important;max-height:4rem!important}.cardPresentTop-module_MuiChip-root__oWJ6G{margin:.5rem .3rem .5rem .5rem}.cardPresentTop-module_ellipse-chip__9gchY.cardPresentTop-module_MuiChip-root__oWJ6G{border-radius:1rem;height:20px}.cardPresentTop-module_ellipse-chip__9gchY.cardPresentTop-module_MuiChip-root__oWJ6G .cardPresentTop-module_MuiChip-label__sRv4w{padding-left:8px;padding-right:8px}.cardPresentTop-module_square-chip__jgztT.cardPresentTop-module_MuiChip-root__oWJ6G{border-radius:0!important}.cardPresentTop-module_class-width-height-100__pwNhL{height:100%;width:100%}.cardPresentTop-module_MuiTooltip-tooltip__yOtRB{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.cardPresentTop-module_MuiTooltip-arrow__-y-hE{color:#fff!important}.cardPresentTop-module_class-font-size-icon__ODt5O{font-size:1.25rem}.cardPresentTop-module_card-body-top-wrapper__gSbRZ{display:flex;height:3rem;justify-content:space-between;margin-left:.75rem}.cardPresentTop-module_card-body-top-wrapper__gSbRZ .cardPresentTop-module_class-horizontal-hr__ZnWk3{border-left:1px solid #c9c9c9;display:block;height:1.5625rem;margin:0 1rem 0 0;padding:0}.cardPresentTop-module_card-body-top-wrapper__gSbRZ .cardPresentTop-module_left__xzI4W{align-items:center;display:flex}.cardPresentTop-module_card-body-top-wrapper__gSbRZ .cardPresentTop-module_title__PU0PN{align-items:center;color:#565360;display:flex;font-size:1.0625;font-weight:600;justify-content:center;margin-right:1rem}.cardPresentTop-module_card-body-top-wrapper__gSbRZ .cardPresentTop-module_details__jsQp7{align-items:center;color:#95939b;display:flex;font-size:.8125rem;font-weight:400;justify-content:center}.cardPresentTop-module_card-body-top-wrapper__gSbRZ .cardPresentTop-module_icon__VwQPf{margin-right:1rem}.cardPresentTop-module_card-body-top-wrapper__gSbRZ .cardPresentTop-module_margin-top__Yg29z{margin-top:.4rem}";
var styles$i = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"cardPresentTop-module_class-ellipsis-lines__CcWsZ","class-ellipsis-2-lines":"cardPresentTop-module_class-ellipsis-2-lines__nByZ1","MuiChip-root":"cardPresentTop-module_MuiChip-root__oWJ6G","ellipse-chip":"cardPresentTop-module_ellipse-chip__9gchY","MuiChip-label":"cardPresentTop-module_MuiChip-label__sRv4w","square-chip":"cardPresentTop-module_square-chip__jgztT","class-width-height-100":"cardPresentTop-module_class-width-height-100__pwNhL","MuiTooltip-tooltip":"cardPresentTop-module_MuiTooltip-tooltip__yOtRB","MuiTooltip-arrow":"cardPresentTop-module_MuiTooltip-arrow__-y-hE","class-font-size-icon":"cardPresentTop-module_class-font-size-icon__ODt5O","card-body-top-wrapper":"cardPresentTop-module_card-body-top-wrapper__gSbRZ","class-horizontal-hr":"cardPresentTop-module_class-horizontal-hr__ZnWk3","left":"cardPresentTop-module_left__xzI4W","title":"cardPresentTop-module_title__PU0PN","details":"cardPresentTop-module_details__jsQp7","icon":"cardPresentTop-module_icon__VwQPf","margin-top":"cardPresentTop-module_margin-top__Yg29z"};
styleInject(css_248z$j);

const CardPresentTop = (props) => {
    const { title, details, actions, titleMaxWidth = '27rem' } = props;
    const getTextAndIconElements = (element, textClass) => {
        const { iconName, text, marginTop } = element;
        return (jsxs("div", Object.assign({ className: textClass }, { children: [iconName && (jsx(Icon, { name: iconName, className: classNames(styles$i.icon, { [styles$i['margin-top']]: marginTop }) }, void 0)), jsx(EllipsisText, { text: text, maxWidthClassName: titleMaxWidth }, void 0)] }), void 0));
    };
    return (jsxs("div", Object.assign({ className: styles$i['card-body-top-wrapper'] }, { children: [jsxs("div", Object.assign({ className: styles$i.left }, { children: [getTextAndIconElements(title, styles$i.title), details !== undefined && jsx(DividerContainer, { className: styles$i['class-horizontal-hr'] }, void 0), details && getTextAndIconElements(details, styles$i.details)] }), void 0), jsx(ActionsComponent, { actions: actions }, void 0)] }), void 0));
};

var css_248z$i = ".card-module_class-ellipsis-2-lines__gVAcw,.card-module_class-ellipsis-lines__91PRe{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.card-module_class-ellipsis-2-lines__gVAcw{-webkit-line-clamp:2!important;max-height:4rem!important}.card-module_MuiChip-root__8cTqY{margin:.5rem .3rem .5rem .5rem}.card-module_ellipse-chip__6xfpQ.card-module_MuiChip-root__8cTqY{border-radius:1rem;height:20px}.card-module_ellipse-chip__6xfpQ.card-module_MuiChip-root__8cTqY .card-module_MuiChip-label__abW-T{padding-left:8px;padding-right:8px}.card-module_square-chip__zEuJW.card-module_MuiChip-root__8cTqY{border-radius:0!important}.card-module_class-width-height-100__hQhRj{height:100%;width:100%}.card-module_MuiTooltip-tooltip__K26Ig{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.card-module_MuiTooltip-arrow__Np4Vk{color:#fff!important}.card-module_class-font-size-icon__JTB4J{font-size:1.25rem}.card-module_card-wrapper__pTmzz{animation:card-module_fx-fadeIn__IMhr2 1s ease-in-out;background-color:#fff;border:1px;border-radius:8px;box-shadow:0 -4px 4px hsla(0,0%,44%,.25),0 4px 4px hsla(0,0%,44%,.25);padding:2px;position:relative}.card-module_card-wrapper__pTmzz .card-module_indicator__w6zRR{background-color:#f36a22;border-radius:50%;height:1rem;position:absolute;right:0;top:-.5rem;width:1rem}@keyframes card-module_fx-fadeIn__IMhr2{0%{opacity:0}to{opacity:1}}";
var styles$h = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"card-module_class-ellipsis-lines__91PRe","class-ellipsis-2-lines":"card-module_class-ellipsis-2-lines__gVAcw","MuiChip-root":"card-module_MuiChip-root__8cTqY","ellipse-chip":"card-module_ellipse-chip__6xfpQ","MuiChip-label":"card-module_MuiChip-label__abW-T","square-chip":"card-module_square-chip__zEuJW","class-width-height-100":"card-module_class-width-height-100__hQhRj","MuiTooltip-tooltip":"card-module_MuiTooltip-tooltip__K26Ig","MuiTooltip-arrow":"card-module_MuiTooltip-arrow__Np4Vk","class-font-size-icon":"card-module_class-font-size-icon__JTB4J","card-wrapper":"card-module_card-wrapper__pTmzz","fx-fadeIn":"card-module_fx-fadeIn__IMhr2","indicator":"card-module_indicator__w6zRR"};
styleInject(css_248z$i);

const CardComponent = (props) => {
    const { cardPresentTopData, cardPresentBodyData, style, withIndicator } = props;
    return (jsxs("div", Object.assign({ className: styles$h['card-wrapper'], style: style }, { children: [withIndicator && jsx("div", { className: styles$h.indicator }, void 0), jsx(CardPresentTop, Object.assign({}, cardPresentTopData), void 0), jsx(DividerContainer, {}, void 0), jsx(CardPresentBody, Object.assign({}, cardPresentBodyData), void 0)] }), void 0));
};

var css_248z$h = ".topLayout-module_class-ellipsis-2-lines__K1D1c,.topLayout-module_class-ellipsis-lines__rWEkP{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.topLayout-module_class-ellipsis-2-lines__K1D1c{-webkit-line-clamp:2!important;max-height:4rem!important}.topLayout-module_MuiChip-root__rHaUk{margin:.5rem .3rem .5rem .5rem}.topLayout-module_ellipse-chip__AJQyD.topLayout-module_MuiChip-root__rHaUk{border-radius:1rem;height:20px}.topLayout-module_ellipse-chip__AJQyD.topLayout-module_MuiChip-root__rHaUk .topLayout-module_MuiChip-label__-vXdN{padding-left:8px;padding-right:8px}.topLayout-module_square-chip__YDzuP.topLayout-module_MuiChip-root__rHaUk{border-radius:0!important}.topLayout-module_class-width-height-100__yqksY{height:100%;width:100%}.topLayout-module_MuiTooltip-tooltip__SzP7H{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.topLayout-module_MuiTooltip-arrow__w1sFq{color:#fff!important}.topLayout-module_class-font-size-icon__KOnQ0{font-size:1.25rem}.topLayout-module_top-layout-wrapper__2S-ox{display:flex;flex-direction:column;justify-content:space-between;margin-bottom:1rem}.topLayout-module_top-layout-wrapper__2S-ox .topLayout-module_title__-I1uL{color:#565360;font-size:1.1875rem;font-weight:700;line-height:1.6875rem;margin-bottom:2rem}.topLayout-module_top-layout-wrapper__2S-ox .topLayout-module_sub-title__vpDaF{color:#565360;font-family:OpenSans;font-size:1.188rem;font-weight:400;margin-top:1.7rem;position:fixed}.topLayout-module_top-layout-button-title__kPzgH{display:flex;justify-content:space-between}.topLayout-module_main-tabs-wrapper__rMe-- .topLayout-module_tab-root__ziMLk{min-width:7.25rem!important;width:7.25rem!important}.topLayout-module_main-tabs-wrapper__rMe-- .topLayout-module_tab-wrapper__g9Ldo{font-size:1.1375rem!important}.topLayout-module_sub-tabs-wrapper__ylWc-{margin-top:1rem}";
var styles$g = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"topLayout-module_class-ellipsis-lines__rWEkP","class-ellipsis-2-lines":"topLayout-module_class-ellipsis-2-lines__K1D1c","MuiChip-root":"topLayout-module_MuiChip-root__rHaUk","ellipse-chip":"topLayout-module_ellipse-chip__AJQyD","MuiChip-label":"topLayout-module_MuiChip-label__-vXdN","square-chip":"topLayout-module_square-chip__YDzuP","class-width-height-100":"topLayout-module_class-width-height-100__yqksY","MuiTooltip-tooltip":"topLayout-module_MuiTooltip-tooltip__SzP7H","MuiTooltip-arrow":"topLayout-module_MuiTooltip-arrow__w1sFq","class-font-size-icon":"topLayout-module_class-font-size-icon__KOnQ0","top-layout-wrapper":"topLayout-module_top-layout-wrapper__2S-ox","title":"topLayout-module_title__-I1uL","sub-title":"topLayout-module_sub-title__vpDaF","top-layout-button-title":"topLayout-module_top-layout-button-title__kPzgH","main-tabs-wrapper":"topLayout-module_main-tabs-wrapper__rMe--","tab-root":"topLayout-module_tab-root__ziMLk","tab-wrapper":"topLayout-module_tab-wrapper__g9Ldo","sub-tabs-wrapper":"topLayout-module_sub-tabs-wrapper__ylWc-"};
styleInject(css_248z$h);

const TopLayout = (props) => {
    const { title, subTitle, buttonOptions, tabs, className, subTabs, selectedTabId, selectedSubTabId, indicatorNumber, indicatorText } = props;
    return (jsxs("div", Object.assign({ className: classNames(styles$g['top-layout-wrapper'], className) }, { children: [jsxs("div", Object.assign({ className: styles$g['top-layout-button-title'] }, { children: [jsx("div", Object.assign({ className: styles$g.title }, { children: title }), void 0), subTitle && jsx("div", Object.assign({ className: styles$g['sub-title'] }, { children: subTitle }), void 0), jsx(CreateNewButton, { buttonOptions: buttonOptions }, void 0)] }), void 0), jsx("div", Object.assign({ className: styles$g['main-tabs-wrapper'] }, { children: jsx(TabsWrapper, { data: tabs, underlineColor: "#2991F3", tabClasses: { wrapped: styles$g['tab-wrapper'], root: styles$g['tab-root'] }, selectedId: selectedTabId, borderBottomColor: "#DAD8DC" }, void 0) }), void 0), subTabs && (jsx("div", Object.assign({ className: styles$g['sub-tabs-wrapper'] }, { children: jsx(TabsWrapper, { isRounded: true, data: subTabs, tabClasses: { wrapped: styles$g['tab-wrapper'], root: styles$g['tab-root'] }, selectedId: selectedSubTabId, indicatorNumber: indicatorNumber, indicatorText: indicatorText }, void 0) }), void 0))] }), void 0));
};

var FilterType;
(function (FilterType) {
    FilterType[FilterType["singleSelect"] = 0] = "singleSelect";
    FilterType[FilterType["multipleSelect"] = 1] = "multipleSelect";
    FilterType[FilterType["dateRange"] = 2] = "dateRange";
    FilterType[FilterType["sort"] = 3] = "sort";
})(FilterType || (FilterType = {}));

var css_248z$g = ".filters-module_class-ellipsis-2-lines__DYDsf,.filters-module_class-ellipsis-lines__lg2-R{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.filters-module_class-ellipsis-2-lines__DYDsf{-webkit-line-clamp:2!important;max-height:4rem!important}.filters-module_MuiChip-root__Mcb5d{margin:.5rem .3rem .5rem .5rem}.filters-module_ellipse-chip__u1TvJ.filters-module_MuiChip-root__Mcb5d{border-radius:1rem;height:20px}.filters-module_ellipse-chip__u1TvJ.filters-module_MuiChip-root__Mcb5d .filters-module_MuiChip-label__0K9Vd{padding-left:8px;padding-right:8px}.filters-module_square-chip__ZkW8C.filters-module_MuiChip-root__Mcb5d{border-radius:0!important}.filters-module_class-width-height-100__Ki9oK{height:100%;width:100%}.filters-module_MuiTooltip-tooltip__zGxEY{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.filters-module_MuiTooltip-arrow__n71ca{color:#fff!important}.filters-module_class-font-size-icon__wVeZf{font-size:1.25rem}.filters-module_filters-component__p-05u{display:flex;justify-content:space-between}.filters-module_filters-component__p-05u .filters-module_filter-wrapper__9waBe,.filters-module_filters-component__p-05u .filters-module_sort-wrapper__X1qe1{align-items:center;color:#6b6874;display:flex;margin-left:1rem;width:20rem}.filters-module_filters-component__p-05u .filters-module_filter-wrapper__9waBe .filters-module_prefix-text__YJXbT,.filters-module_filters-component__p-05u .filters-module_sort-wrapper__X1qe1 .filters-module_prefix-text__YJXbT{margin-right:.5rem}.filters-module_filters-component__p-05u .filters-module_filter-wrapper__9waBe .filters-module_sort__oX2Ss,.filters-module_filters-component__p-05u .filters-module_sort-wrapper__X1qe1 .filters-module_sort__oX2Ss{width:16rem}.filters-module_filters-component__p-05u .filters-module_filter-wrapper__9waBe .MuiOutlinedInput-root,.filters-module_filters-component__p-05u .filters-module_sort-wrapper__X1qe1 .MuiOutlinedInput-root{border-radius:0!important}.filters-module_filters-component__p-05u .filters-module_filter-wrapper__9waBe .MuiInputBase-input,.filters-module_filters-component__p-05u .filters-module_filter-wrapper__9waBe .single-select-filter,.filters-module_filters-component__p-05u .filters-module_sort-wrapper__X1qe1 .MuiInputBase-input,.filters-module_filters-component__p-05u .filters-module_sort-wrapper__X1qe1 .single-select-filter{background-color:#f6f6f6!important;color:#565360!important}.filters-module_filters-component__p-05u .filters-module_filter-wrapper__9waBe .MuiOutlinedInput-notchedOutline,.filters-module_filters-component__p-05u .filters-module_sort-wrapper__X1qe1 .MuiOutlinedInput-notchedOutline{border:none!important}.filters-module_filters-component__p-05u .filters-module_filter-wrapper__9waBe .filters-module_icon__10Mon,.filters-module_filters-component__p-05u .filters-module_sort-wrapper__X1qe1 .filters-module_icon__10Mon{pointer-events:none;position:absolute;right:1rem;top:.8rem}.filters-module_filters-component__p-05u .filters-module_filter-wrapper__9waBe .filters-module_icon__10Mon svg,.filters-module_filters-component__p-05u .filters-module_sort-wrapper__X1qe1 .filters-module_icon__10Mon svg{height:1rem;width:1.1rem}.MuiPaper-root.MuiPopover-paper{color:#565360}";
var styles$f = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"filters-module_class-ellipsis-lines__lg2-R","class-ellipsis-2-lines":"filters-module_class-ellipsis-2-lines__DYDsf","MuiChip-root":"filters-module_MuiChip-root__Mcb5d","ellipse-chip":"filters-module_ellipse-chip__u1TvJ","MuiChip-label":"filters-module_MuiChip-label__0K9Vd","square-chip":"filters-module_square-chip__ZkW8C","class-width-height-100":"filters-module_class-width-height-100__Ki9oK","MuiTooltip-tooltip":"filters-module_MuiTooltip-tooltip__zGxEY","MuiTooltip-arrow":"filters-module_MuiTooltip-arrow__n71ca","class-font-size-icon":"filters-module_class-font-size-icon__wVeZf","filters-component":"filters-module_filters-component__p-05u","sort-wrapper":"filters-module_sort-wrapper__X1qe1","filter-wrapper":"filters-module_filter-wrapper__9waBe","prefix-text":"filters-module_prefix-text__YJXbT","sort":"filters-module_sort__oX2Ss","icon":"filters-module_icon__10Mon"};
styleInject(css_248z$g);

const Filters$1 = ({ filters }) => {
    const { translate } = useTranslationContext();
    const getLabel = (props) => {
        return `${props.label}:`;
    };
    return (jsx("div", Object.assign({ className: classNames(styles$f['filters-component'], 'filters-list-wrapper') }, { children: filters.map(filter => {
            const { props } = filter;
            switch (filter.filterType) {
                case FilterType.singleSelect:
                    return (jsx("div", Object.assign({ className: `${styles$f['filter-wrapper']} ${filter.filterWrapperFrameClassSuffix}` }, { children: jsx(SelectContainer, Object.assign({}, props, { label: getLabel(props), dataTestid: "single-select-filter" }), void 0) }), filter.name));
                case FilterType.multipleSelect:
                    return (jsx("div", Object.assign({ className: `${styles$f['filter-wrapper']} ${filter.filterWrapperFrameClassSuffix}` }, { children: jsx(RadioMultiSelect, { dataTestId: "multiple-select-filter", radioGroup: [
                                {
                                    optionValue: '',
                                    title: 'Selected',
                                    checkboxGroup: props.options
                                }
                            ], selectedValues: props.value, buttonPrefixText: props.label, buttonType: "text", color: "secondary", onChange: (selectedValue) => {
                                props.onChange({}, selectedValue);
                            }, resetText: translate('ClearAll'), applyText: "Apply", isWide: false }, void 0) }), filter.name));
                case FilterType.sort:
                    return (jsxs("div", Object.assign({ className: `${styles$f['sort-wrapper']} ${filter.filterWrapperFrameClassSuffix}` }, { children: [jsx("div", Object.assign({ className: classNames(styles$f['prefix-text'], 'prefix-text-wrapper') }, { children: props.label }), void 0), jsx("div", Object.assign({ className: styles$f.sort }, { children: jsx(SelectContainer, Object.assign({}, props, { dataTestid: "single-select-filter", className: "single-select-filter", label: "", selectText: translate('None_selected'), iconClose: () => jsx(Icon, { name: "downArrowIcon", className: styles$f.icon }, void 0), iconOpen: () => jsx(Icon, { name: "downArrowIcon", className: styles$f.icon }, void 0) }), void 0) }), void 0)] }), filter.name));
                default:
                    return jsx(Fragment$1, {}, void 0);
            }
        }) }), void 0));
};

var css_248z$f = ".bodyLayout-module_class-ellipsis-2-lines__YLC9A,.bodyLayout-module_class-ellipsis-lines__Z8KQK{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.bodyLayout-module_class-ellipsis-2-lines__YLC9A{-webkit-line-clamp:2!important;max-height:4rem!important}.bodyLayout-module_MuiChip-root__vwmH4{margin:.5rem .3rem .5rem .5rem}.bodyLayout-module_ellipse-chip__hlptd.bodyLayout-module_MuiChip-root__vwmH4{border-radius:1rem;height:20px}.bodyLayout-module_ellipse-chip__hlptd.bodyLayout-module_MuiChip-root__vwmH4 .bodyLayout-module_MuiChip-label__aYcLv{padding-left:8px;padding-right:8px}.bodyLayout-module_square-chip__pKe4K.bodyLayout-module_MuiChip-root__vwmH4{border-radius:0!important}.bodyLayout-module_class-width-height-100__Cv3k4{height:100%;width:100%}.bodyLayout-module_MuiTooltip-tooltip__IKw4V{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.bodyLayout-module_MuiTooltip-arrow__dvDoh{color:#fff!important}.bodyLayout-module_class-font-size-icon__YAybb{font-size:1.25rem}.bodyLayout-module_body-layout-wrapper__CFUKd{display:flex;flex-direction:column;justify-content:space-between;position:relative;width:100%}.bodyLayout-module_body-layout-wrapper__CFUKd .bodyLayout-module_filters-wrapper__arNKV{align-self:flex-end;display:flex}.bodyLayout-module_body-layout-wrapper__CFUKd .bodyLayout-module_top__USssQ{background-color:#ecf0f5;display:flex;margin-bottom:2rem;position:sticky}.bodyLayout-module_body-layout-wrapper__CFUKd .bodyLayout-module_simple-search__yCYgJ{width:55rem}.bodyLayout-module_body-layout-wrapper__CFUKd .bodyLayout-module_pagination-wrapper__jkbSv{align-self:flex-end;display:flex;margin-top:1.5rem}";
var styles$e = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"bodyLayout-module_class-ellipsis-lines__Z8KQK","class-ellipsis-2-lines":"bodyLayout-module_class-ellipsis-2-lines__YLC9A","MuiChip-root":"bodyLayout-module_MuiChip-root__vwmH4","ellipse-chip":"bodyLayout-module_ellipse-chip__hlptd","MuiChip-label":"bodyLayout-module_MuiChip-label__aYcLv","square-chip":"bodyLayout-module_square-chip__pKe4K","class-width-height-100":"bodyLayout-module_class-width-height-100__Cv3k4","MuiTooltip-tooltip":"bodyLayout-module_MuiTooltip-tooltip__IKw4V","MuiTooltip-arrow":"bodyLayout-module_MuiTooltip-arrow__dvDoh","class-font-size-icon":"bodyLayout-module_class-font-size-icon__YAybb","body-layout-wrapper":"bodyLayout-module_body-layout-wrapper__CFUKd","filters-wrapper":"bodyLayout-module_filters-wrapper__arNKV","top":"bodyLayout-module_top__USssQ","simple-search":"bodyLayout-module_simple-search__yCYgJ","pagination-wrapper":"bodyLayout-module_pagination-wrapper__jkbSv"};
styleInject(css_248z$f);

var css_248z$e = ".class-ellipsis-2-lines,.class-ellipsis-lines{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.class-ellipsis-2-lines{-webkit-line-clamp:2!important;max-height:4rem!important}.MuiChip-root{margin:.5rem .3rem .5rem .5rem}.ellipse-chip.MuiChip-root{border-radius:1rem;height:20px}.ellipse-chip.MuiChip-root .MuiChip-label{padding-left:8px;padding-right:8px}.square-chip.MuiChip-root{border-radius:0!important}.class-width-height-100{height:100%;width:100%}.MuiTooltip-tooltip{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.MuiTooltip-arrow{color:#fff!important}.class-font-size-icon{font-size:1.25rem}:export{rem-size:16px;primary-colour:#f36a22;secondary-colour:#22bcbe;secondary-light-colour:#b4e8e9;font-size-button:.8125rem;font-colour-white:white;font-family:Inter}.body-layout-empty-state{align-items:center;background-color:#fff;display:flex;flex-direction:column;padding-bottom:4rem}.body-layout-empty-state .icon{margin:3rem}.body-layout-empty-state .sub-title,.body-layout-empty-state .title{color:#6b6874;font-size:1.1875rem;line-height:1.7rem}.body-layout-empty-state .title{font-weight:700}.body-layout-empty-state .button-wrapper{height:2rem;margin-top:1.5rem}";
styleInject(css_248z$e);

const EmptyState = (props) => {
    const { emptyStateTitle, emptyStateSubTitle, emptyStateButtonText, emptyStateButtonOnClick } = props;
    return (jsxs("div", Object.assign({ className: "body-layout-empty-state", "data-testid": "empty-state" }, { children: [jsx(Icon, { dataTestid: "empty-state-icon", name: "emptyStateContentManagement", className: "icon" }, void 0), jsx("div", Object.assign({ className: "title", "data-testid": "empty-state-title" }, { children: emptyStateTitle }), void 0), emptyStateSubTitle && (jsx("div", Object.assign({ className: "sub-title", "data-testid": "empty-state-sub-title" }, { children: emptyStateSubTitle }), void 0)), emptyStateButtonText && (jsx("div", Object.assign({ className: "button-wrapper" }, { children: jsx(ButtonContainer, { dataTestid: "empty-state-button", text: emptyStateButtonText, onClick: emptyStateButtonOnClick }, void 0) }), void 0))] }), void 0));
};

const BodyLayout = (props) => {
    const { filters, reset, searchPlaceHolder, onSearchFunction, records, isLoading, isEmptyState = false, emptyStateTitle, emptyStateSubTitle, emptyStateButtonText, emptyStateButtonOnClick } = props;
    const ROWS_PER_PAGE = 10;
    const [currentSearchValue, setCurrentSearchValue] = useState('');
    const [pageRecords, setPageRecords] = useState(records.slice(0, ROWS_PER_PAGE));
    const [page, setPage] = useState(1);
    useEffect(() => {
        setPageRecords(records.slice(0, ROWS_PER_PAGE));
        setPage(1);
    }, [records]);
    const onSearch = (value) => {
        setCurrentSearchValue(value);
        onSearchFunction(value);
    };
    const onPageChange = (pageNumber) => {
        setPage(pageNumber);
        lib$1.scrollToTop();
        setPageRecords(records.slice(ROWS_PER_PAGE * (pageNumber - 1), ROWS_PER_PAGE * pageNumber));
    };
    const getSearchComponent = () => {
        return (jsx(SimpleSearch, { value: currentSearchValue, onChange: onSearch, onReset: onSearch, placeholder: searchPlaceHolder, className: styles$e['simple-search'] }, void 0));
    };
    const searchInNewRow = filters.length > 4;
    const numberOfPages = Math.ceil(records.length / ROWS_PER_PAGE);
    return (jsxs("div", Object.assign({ className: styles$e['body-layout-wrapper'], "data-testid": "body-layout" }, { children: [jsxs("div", Object.assign({ className: styles$e.top, style: { flexDirection: searchInNewRow ? 'column' : 'row' } }, { children: [!searchInNewRow && getSearchComponent(), jsx("div", Object.assign({ className: styles$e['filters-wrapper'], style: { marginBottom: searchInNewRow ? '0.5rem' : '0' } }, { children: jsx(Filters$1, { filters: filters, reset: reset }, void 0) }), void 0), searchInNewRow && getSearchComponent()] }), void 0), jsxs("div", { children: [isLoading && jsx(Message, { type: "loader" }, void 0), !isLoading &&
                        !isEmptyState &&
                        pageRecords.map((record, i) => (jsx(CardComponent, Object.assign({}, record, { style: { margin: '0.2rem', marginBottom: '1.5rem' } }), `${record.cardPresentTopData.title.text}${i}`))), isEmptyState && (jsx(EmptyState, { emptyStateTitle: emptyStateTitle, emptyStateSubTitle: emptyStateSubTitle, emptyStateButtonText: emptyStateButtonText, emptyStateButtonOnClick: emptyStateButtonOnClick }, void 0))] }, void 0), jsx("div", Object.assign({ className: styles$e['pagination-wrapper'] }, { children: !isLoading && numberOfPages > 1 && !isEmptyState && (jsx(Pagination, { count: numberOfPages, onChange: onPageChange, page: page, dataTestid: "layout-pagination" }, void 0)) }), void 0)] }), void 0));
};

var css_248z$d = ".cardPopup-module_class-ellipsis-2-lines__u2Z2q,.cardPopup-module_class-ellipsis-lines__LQ0uZ{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.cardPopup-module_class-ellipsis-2-lines__u2Z2q{-webkit-line-clamp:2!important;max-height:4rem!important}.cardPopup-module_MuiChip-root__IVeTn{margin:.5rem .3rem .5rem .5rem}.cardPopup-module_ellipse-chip__-0Vhq.cardPopup-module_MuiChip-root__IVeTn{border-radius:1rem;height:20px}.cardPopup-module_ellipse-chip__-0Vhq.cardPopup-module_MuiChip-root__IVeTn .cardPopup-module_MuiChip-label__HIScJ{padding-left:8px;padding-right:8px}.cardPopup-module_square-chip__YSj8-.cardPopup-module_MuiChip-root__IVeTn{border-radius:0!important}.cardPopup-module_class-width-height-100__SJL8c{height:100%;width:100%}.cardPopup-module_MuiTooltip-tooltip__QHTkM{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.cardPopup-module_MuiTooltip-arrow__KkYQC{color:#fff!important}.cardPopup-module_class-font-size-icon__FQgvI{font-size:1.25rem}.cardPopup-module_card-popup__ZPpyT{animation:cardPopup-module_fx-fadeIn__a1n1I 1s ease-in-out}.cardPopup-module_card-popup__ZPpyT .MuiDialog-paperWidthSm{border:1px solid #f36a22!important;max-width:unset!important}.cardPopup-module_card-popup__ZPpyT .MuiDialogTitle-root{padding-bottom:1rem;padding-left:4rem;padding-right:4rem}.cardPopup-module_card-popup__ZPpyT .MuiTypography-h6{color:#f36a22!important;font-size:1.1875rem;font-weight:700}.cardPopup-module_card-popup__ZPpyT .cardPopup-module_sub-title__LDCAW{font-family:Lato;margin-left:4rem}.cardPopup-module_card-popup__ZPpyT .cardPopup-module_warning-title__oUc9a{color:red;font-family:Lato;margin-left:4rem}.cardPopup-module_card-popup__ZPpyT .cardPopup-module_card-wrapper__d0-zx{margin:2rem 4rem;width:44rem}@keyframes cardPopup-module_fx-fadeIn__a1n1I{0%{opacity:0}to{opacity:1}}";
var styles$d = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"cardPopup-module_class-ellipsis-lines__LQ0uZ","class-ellipsis-2-lines":"cardPopup-module_class-ellipsis-2-lines__u2Z2q","MuiChip-root":"cardPopup-module_MuiChip-root__IVeTn","ellipse-chip":"cardPopup-module_ellipse-chip__-0Vhq","MuiChip-label":"cardPopup-module_MuiChip-label__HIScJ","square-chip":"cardPopup-module_square-chip__YSj8-","class-width-height-100":"cardPopup-module_class-width-height-100__SJL8c","MuiTooltip-tooltip":"cardPopup-module_MuiTooltip-tooltip__QHTkM","MuiTooltip-arrow":"cardPopup-module_MuiTooltip-arrow__KkYQC","class-font-size-icon":"cardPopup-module_class-font-size-icon__FQgvI","card-popup":"cardPopup-module_card-popup__ZPpyT","fx-fadeIn":"cardPopup-module_fx-fadeIn__a1n1I","sub-title":"cardPopup-module_sub-title__LDCAW","warning-title":"cardPopup-module_warning-title__oUc9a","card-wrapper":"cardPopup-module_card-wrapper__d0-zx"};
styleInject(css_248z$d);

const CardPopup = (props) => {
    const { card, isOpen, cancelOnClick, title, subTitle, warning, okButtonOnClick, okButtonText, topOffset = 0, isLoading, showDeleteButton = true } = props;
    const { translate } = useTranslationContext();
    const [isClickedOk, setIsClickedOk] = useState(false);
    const onOkClicked = () => {
        okButtonOnClick === null || okButtonOnClick === void 0 ? void 0 : okButtonOnClick();
        setIsClickedOk(true);
        setTimeout(() => {
            setIsClickedOk(false);
            cancelOnClick();
        }, 1000);
    };
    const getButtons = () => {
        const buttons = [
            {
                text: translate('CANCEL'),
                onClick: cancelOnClick,
                type: 'textFlat',
                dataTestid: 'cancel-button'
            }
        ];
        if (showDeleteButton) {
            buttons.push({
                text: okButtonText,
                onClick: !isClickedOk ? onOkClicked : undefined,
                type: isClickedOk ? 'disabled' : 'primaryFlat',
                dataTestid: 'delete-button'
            });
        }
        return buttons;
    };
    return (jsxs(UserMessage, Object.assign({ isOpen: isOpen, handleClose: cancelOnClick, title: title, buttons: getButtons(), topOffset: topOffset, isLoading: isLoading, className: styles$d['card-popup'], dataTestId: "card-popup" }, { children: [subTitle && jsx("div", Object.assign({ className: styles$d['sub-title'] }, { children: subTitle }), void 0), warning && jsx("div", Object.assign({ className: styles$d['warning-title'] }, { children: warning }), void 0), jsx("div", Object.assign({ className: styles$d['card-wrapper'] }, { children: card && jsx(CardComponent, Object.assign({}, card), void 0) }), void 0)] }), void 0));
};

const SwitchContainer = (props) => {
    const { dataTestid = 'switch', checked, onChange, color = 'secondary', disabled = false } = props;
    return (jsx(Switch, { "data-testid": dataTestid, checked: checked, onChange: (_e, checked) => onChange(checked), color: color, disabled: disabled }, void 0));
};

const SliderContainer = (props) => {
    const { dataTestid = 'slider', onChange, color = 'secondary' } = props, rest = __rest$1(props, ["dataTestid", "onChange", "color"]);
    return (jsx(Slider, Object.assign({}, rest, { "data-testid": dataTestid, onChange: (_e, value) => onChange(value), color: color }), void 0));
};

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$d(target, key, source[key]);
    });
  }

  return target;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = process.env.NODE_ENV;

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1 = invariant;

var invariant$1 = /*@__PURE__*/getDefaultExportFromCjs(invariant_1);

var Manager = function () {
  function Manager() {
    _classCallCheck$3(this, Manager);

    _defineProperty$d(this, "refs", {});
  }

  _createClass$3(Manager, [{
    key: "add",
    value: function add(collection, ref) {
      if (!this.refs[collection]) {
        this.refs[collection] = [];
      }

      this.refs[collection].push(ref);
    }
  }, {
    key: "remove",
    value: function remove(collection, ref) {
      var index = this.getIndex(collection, ref);

      if (index !== -1) {
        this.refs[collection].splice(index, 1);
      }
    }
  }, {
    key: "isActive",
    value: function isActive() {
      return this.active;
    }
  }, {
    key: "getActive",
    value: function getActive() {
      var _this = this;

      return this.refs[this.active.collection].find(function (_ref) {
        var node = _ref.node;
        return node.sortableInfo.index == _this.active.index;
      });
    }
  }, {
    key: "getIndex",
    value: function getIndex(collection, ref) {
      return this.refs[collection].indexOf(ref);
    }
  }, {
    key: "getOrderedRefs",
    value: function getOrderedRefs() {
      var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.active.collection;
      return this.refs[collection].sort(sortByIndex);
    }
  }]);

  return Manager;
}();

function sortByIndex(_ref2, _ref3) {
  var index1 = _ref2.node.sortableInfo.index;
  var index2 = _ref3.node.sortableInfo.index;
  return index1 - index2;
}
function omit(obj, keysToOmit) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}
var events = {
  end: ['touchend', 'touchcancel', 'mouseup'],
  move: ['touchmove', 'mousemove'],
  start: ['touchstart', 'mousedown']
};
var vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return '';
  }

  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';

    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();
function setInlineStyles(node, styles) {
  Object.keys(styles).forEach(function (key) {
    node.style[key] = styles[key];
  });
}
function setTranslate3d(node, translate) {
  node.style["".concat(vendorPrefix, "Transform")] = translate == null ? '' : "translate3d(".concat(translate.x, "px,").concat(translate.y, "px,0)");
}
function setTransitionDuration(node, duration) {
  node.style["".concat(vendorPrefix, "TransitionDuration")] = duration == null ? '' : "".concat(duration, "ms");
}
function closest(el, fn) {
  while (el) {
    if (fn(el)) {
      return el;
    }

    el = el.parentNode;
  }

  return null;
}
function limit(min, max, value) {
  return Math.max(min, Math.min(value, max));
}

function getPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }

  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);
  return {
    bottom: getPixelValue(style.marginBottom),
    left: getPixelValue(style.marginLeft),
    right: getPixelValue(style.marginRight),
    top: getPixelValue(style.marginTop)
  };
}
function provideDisplayName(prefix, Component$$1) {
  var componentName = Component$$1.displayName || Component$$1.name;
  return componentName ? "".concat(prefix, "(").concat(componentName, ")") : prefix;
}
function getScrollAdjustedBoundingClientRect(node, scrollDelta) {
  var boundingClientRect = node.getBoundingClientRect();
  return {
    top: boundingClientRect.top + scrollDelta.top,
    left: boundingClientRect.left + scrollDelta.left
  };
}
function getPosition(event) {
  if (event.touches && event.touches.length) {
    return {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  } else if (event.changedTouches && event.changedTouches.length) {
    return {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
  } else {
    return {
      x: event.pageX,
      y: event.pageY
    };
  }
}
function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function getEdgeOffset(node, parent) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    left: 0,
    top: 0
  };

  if (!node) {
    return undefined;
  }

  var nodeOffset = {
    left: offset.left + node.offsetLeft,
    top: offset.top + node.offsetTop
  };

  if (node.parentNode === parent) {
    return nodeOffset;
  }

  return getEdgeOffset(node.parentNode, parent, nodeOffset);
}
function getTargetIndex(newIndex, prevIndex, oldIndex) {
  if (newIndex < oldIndex && newIndex > prevIndex) {
    return newIndex - 1;
  } else if (newIndex > oldIndex && newIndex < prevIndex) {
    return newIndex + 1;
  } else {
    return newIndex;
  }
}
function getLockPixelOffset(_ref) {
  var lockOffset = _ref.lockOffset,
      width = _ref.width,
      height = _ref.height;
  var offsetX = lockOffset;
  var offsetY = lockOffset;
  var unit = 'px';

  if (typeof lockOffset === 'string') {
    var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
    invariant$1(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);
    offsetX = parseFloat(lockOffset);
    offsetY = parseFloat(lockOffset);
    unit = match[1];
  }

  invariant$1(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

  if (unit === '%') {
    offsetX = offsetX * width / 100;
    offsetY = offsetY * height / 100;
  }

  return {
    x: offsetX,
    y: offsetY
  };
}
function getLockPixelOffsets(_ref2) {
  var height = _ref2.height,
      width = _ref2.width,
      lockOffset = _ref2.lockOffset;
  var offsets = Array.isArray(lockOffset) ? lockOffset : [lockOffset, lockOffset];
  invariant$1(offsets.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);

  var _offsets = _slicedToArray$8(offsets, 2),
      minLockOffset = _offsets[0],
      maxLockOffset = _offsets[1];

  return [getLockPixelOffset({
    height: height,
    lockOffset: minLockOffset,
    width: width
  }), getLockPixelOffset({
    height: height,
    lockOffset: maxLockOffset,
    width: width
  })];
}

function isScrollable(el) {
  var computedStyle = window.getComputedStyle(el);
  var overflowRegex = /(auto|scroll)/;
  var properties = ['overflow', 'overflowX', 'overflowY'];
  return properties.find(function (property) {
    return overflowRegex.test(computedStyle[property]);
  });
}

function getScrollingParent(el) {
  if (!(el instanceof HTMLElement)) {
    return null;
  } else if (isScrollable(el)) {
    return el;
  } else {
    return getScrollingParent(el.parentNode);
  }
}
function getContainerGridGap(element) {
  var style = window.getComputedStyle(element);

  if (style.display === 'grid') {
    return {
      x: getPixelValue(style.gridColumnGap),
      y: getPixelValue(style.gridRowGap)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var KEYCODE = {
  TAB: 9,
  ESC: 27,
  SPACE: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};
var NodeType = {
  Anchor: 'A',
  Button: 'BUTTON',
  Canvas: 'CANVAS',
  Input: 'INPUT',
  Option: 'OPTION',
  Textarea: 'TEXTAREA',
  Select: 'SELECT'
};
function cloneNode(node) {
  var selector = 'input, textarea, select, canvas, [contenteditable]';
  var fields = node.querySelectorAll(selector);
  var clonedNode = node.cloneNode(true);

  var clonedFields = _toConsumableArray$3(clonedNode.querySelectorAll(selector));

  clonedFields.forEach(function (field, i) {
    if (field.type !== 'file') {
      field.value = fields[i].value;
    }

    if (field.type === 'radio' && field.name) {
      field.name = "__sortableClone__".concat(field.name);
    }

    if (field.tagName === NodeType.Canvas && fields[i].width > 0 && fields[i].height > 0) {
      var destCtx = field.getContext('2d');
      destCtx.drawImage(fields[i], 0, 0);
    }
  });
  return clonedNode;
}
function isSortableHandle(node) {
  return node.sortableHandle != null;
}

var AutoScroller = function () {
  function AutoScroller(container, onScrollCallback) {
    _classCallCheck$3(this, AutoScroller);

    this.container = container;
    this.onScrollCallback = onScrollCallback;
  }

  _createClass$3(AutoScroller, [{
    key: "clear",
    value: function clear() {
      if (this.interval == null) {
        return;
      }

      clearInterval(this.interval);
      this.interval = null;
    }
  }, {
    key: "update",
    value: function update(_ref) {
      var _this = this;

      var translate = _ref.translate,
          minTranslate = _ref.minTranslate,
          maxTranslate = _ref.maxTranslate,
          width = _ref.width,
          height = _ref.height;
      var direction = {
        x: 0,
        y: 0
      };
      var speed = {
        x: 1,
        y: 1
      };
      var acceleration = {
        x: 10,
        y: 10
      };
      var _this$container = this.container,
          scrollTop = _this$container.scrollTop,
          scrollLeft = _this$container.scrollLeft,
          scrollHeight = _this$container.scrollHeight,
          scrollWidth = _this$container.scrollWidth,
          clientHeight = _this$container.clientHeight,
          clientWidth = _this$container.clientWidth;
      var isTop = scrollTop === 0;
      var isBottom = scrollHeight - scrollTop - clientHeight === 0;
      var isLeft = scrollLeft === 0;
      var isRight = scrollWidth - scrollLeft - clientWidth === 0;

      if (translate.y >= maxTranslate.y - height / 2 && !isBottom) {
        direction.y = 1;
        speed.y = acceleration.y * Math.abs((maxTranslate.y - height / 2 - translate.y) / height);
      } else if (translate.x >= maxTranslate.x - width / 2 && !isRight) {
        direction.x = 1;
        speed.x = acceleration.x * Math.abs((maxTranslate.x - width / 2 - translate.x) / width);
      } else if (translate.y <= minTranslate.y + height / 2 && !isTop) {
        direction.y = -1;
        speed.y = acceleration.y * Math.abs((translate.y - height / 2 - minTranslate.y) / height);
      } else if (translate.x <= minTranslate.x + width / 2 && !isLeft) {
        direction.x = -1;
        speed.x = acceleration.x * Math.abs((translate.x - width / 2 - minTranslate.x) / width);
      }

      if (this.interval) {
        this.clear();
        this.isAutoScrolling = false;
      }

      if (direction.x !== 0 || direction.y !== 0) {
        this.interval = setInterval(function () {
          _this.isAutoScrolling = true;
          var offset = {
            left: speed.x * direction.x,
            top: speed.y * direction.y
          };
          _this.container.scrollTop += offset.top;
          _this.container.scrollLeft += offset.left;

          _this.onScrollCallback(offset);
        }, 5);
      }
    }
  }]);

  return AutoScroller;
}();

function defaultGetHelperDimensions(_ref) {
  var node = _ref.node;
  return {
    height: node.offsetHeight,
    width: node.offsetWidth
  };
}

function defaultShouldCancelStart(event) {
  var interactiveElements = [NodeType.Input, NodeType.Textarea, NodeType.Select, NodeType.Option, NodeType.Button];

  if (interactiveElements.indexOf(event.target.tagName) !== -1) {
    return true;
  }

  if (closest(event.target, function (el) {
    return el.contentEditable === 'true';
  })) {
    return true;
  }

  return false;
}

var propTypes = {
  axis: PropTypes.oneOf(['x', 'y', 'xy']),
  contentWindow: PropTypes.any,
  disableAutoscroll: PropTypes.bool,
  distance: PropTypes.number,
  getContainer: PropTypes.func,
  getHelperDimensions: PropTypes.func,
  helperClass: PropTypes.string,
  helperContainer: PropTypes.oneOfType([PropTypes.func, typeof HTMLElement === 'undefined' ? PropTypes.any : PropTypes.instanceOf(HTMLElement)]),
  hideSortableGhost: PropTypes.bool,
  keyboardSortingTransitionDuration: PropTypes.number,
  lockAxis: PropTypes.string,
  lockOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]),
  lockToContainerEdges: PropTypes.bool,
  onSortEnd: PropTypes.func,
  onSortMove: PropTypes.func,
  onSortOver: PropTypes.func,
  onSortStart: PropTypes.func,
  pressDelay: PropTypes.number,
  pressThreshold: PropTypes.number,
  keyCodes: PropTypes.shape({
    lift: PropTypes.arrayOf(PropTypes.number),
    drop: PropTypes.arrayOf(PropTypes.number),
    cancel: PropTypes.arrayOf(PropTypes.number),
    up: PropTypes.arrayOf(PropTypes.number),
    down: PropTypes.arrayOf(PropTypes.number)
  }),
  shouldCancelStart: PropTypes.func,
  transitionDuration: PropTypes.number,
  updateBeforeSortStart: PropTypes.func,
  useDragHandle: PropTypes.bool,
  useWindowAsScrollContainer: PropTypes.bool
};
var defaultKeyCodes = {
  lift: [KEYCODE.SPACE],
  drop: [KEYCODE.SPACE],
  cancel: [KEYCODE.ESC],
  up: [KEYCODE.UP, KEYCODE.LEFT],
  down: [KEYCODE.DOWN, KEYCODE.RIGHT]
};
var defaultProps = {
  axis: 'y',
  disableAutoscroll: false,
  distance: 0,
  getHelperDimensions: defaultGetHelperDimensions,
  hideSortableGhost: true,
  lockOffset: '50%',
  lockToContainerEdges: false,
  pressDelay: 0,
  pressThreshold: 5,
  keyCodes: defaultKeyCodes,
  shouldCancelStart: defaultShouldCancelStart,
  transitionDuration: 300,
  useWindowAsScrollContainer: false
};
var omittedProps = Object.keys(propTypes);
function validateProps(props) {
  invariant$1(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
}

function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }

  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }

  return finalizer(false, value);
}
var SortableContext = createContext({
  manager: {}
});
function sortableContainer(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function (_React$Component) {
    _inherits(WithSortableContainer, _React$Component);

    function WithSortableContainer(props) {
      var _this;

      _classCallCheck$3(this, WithSortableContainer);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(WithSortableContainer).call(this, props));

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "state", {});

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "handleStart", function (event) {
        var _this$props = _this.props,
            distance = _this$props.distance,
            shouldCancelStart = _this$props.shouldCancelStart;

        if (event.button === 2 || shouldCancelStart(event)) {
          return;
        }

        _this.touched = true;
        _this.position = getPosition(event);
        var node = closest(event.target, function (el) {
          return el.sortableInfo != null;
        });

        if (node && node.sortableInfo && _this.nodeIsChild(node) && !_this.state.sorting) {
          var useDragHandle = _this.props.useDragHandle;
          var _node$sortableInfo = node.sortableInfo,
              index = _node$sortableInfo.index,
              collection = _node$sortableInfo.collection,
              disabled = _node$sortableInfo.disabled;

          if (disabled) {
            return;
          }

          if (useDragHandle && !closest(event.target, isSortableHandle)) {
            return;
          }

          _this.manager.active = {
            collection: collection,
            index: index
          };

          if (!isTouchEvent(event) && event.target.tagName === NodeType.Anchor) {
            event.preventDefault();
          }

          if (!distance) {
            if (_this.props.pressDelay === 0) {
              _this.handlePress(event);
            } else {
              _this.pressTimer = setTimeout(function () {
                return _this.handlePress(event);
              }, _this.props.pressDelay);
            }
          }
        }
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "nodeIsChild", function (node) {
        return node.sortableInfo.manager === _this.manager;
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "handleMove", function (event) {
        var _this$props2 = _this.props,
            distance = _this$props2.distance,
            pressThreshold = _this$props2.pressThreshold;

        if (!_this.state.sorting && _this.touched && !_this._awaitingUpdateBeforeSortStart) {
          var position = getPosition(event);
          var delta = {
            x: _this.position.x - position.x,
            y: _this.position.y - position.y
          };
          var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
          _this.delta = delta;

          if (!distance && (!pressThreshold || combinedDelta >= pressThreshold)) {
            clearTimeout(_this.cancelTimer);
            _this.cancelTimer = setTimeout(_this.cancel, 0);
          } else if (distance && combinedDelta >= distance && _this.manager.isActive()) {
            _this.handlePress(event);
          }
        }
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "handleEnd", function () {
        _this.touched = false;

        _this.cancel();
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "cancel", function () {
        var distance = _this.props.distance;
        var sorting = _this.state.sorting;

        if (!sorting) {
          if (!distance) {
            clearTimeout(_this.pressTimer);
          }

          _this.manager.active = null;
        }
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "handlePress", function (event) {
        try {
          var active = _this.manager.getActive();

          var _temp6 = function () {
            if (active) {
              var _temp7 = function _temp7() {
                var index = _node.sortableInfo.index;
                var margin = getElementMargin(_node);
                var gridGap = getContainerGridGap(_this.container);

                var containerBoundingRect = _this.scrollContainer.getBoundingClientRect();

                var dimensions = _getHelperDimensions({
                  index: index,
                  node: _node,
                  collection: _collection
                });

                _this.node = _node;
                _this.margin = margin;
                _this.gridGap = gridGap;
                _this.width = dimensions.width;
                _this.height = dimensions.height;
                _this.marginOffset = {
                  x: _this.margin.left + _this.margin.right + _this.gridGap.x,
                  y: Math.max(_this.margin.top, _this.margin.bottom, _this.gridGap.y)
                };
                _this.boundingClientRect = _node.getBoundingClientRect();
                _this.containerBoundingRect = containerBoundingRect;
                _this.index = index;
                _this.newIndex = index;
                _this.axis = {
                  x: _axis.indexOf('x') >= 0,
                  y: _axis.indexOf('y') >= 0
                };
                _this.offsetEdge = getEdgeOffset(_node, _this.container);

                if (_isKeySorting) {
                  _this.initialOffset = getPosition(_objectSpread({}, event, {
                    pageX: _this.boundingClientRect.left,
                    pageY: _this.boundingClientRect.top
                  }));
                } else {
                  _this.initialOffset = getPosition(event);
                }

                _this.initialScroll = {
                  left: _this.scrollContainer.scrollLeft,
                  top: _this.scrollContainer.scrollTop
                };
                _this.initialWindowScroll = {
                  left: window.pageXOffset,
                  top: window.pageYOffset
                };
                _this.helper = _this.helperContainer.appendChild(cloneNode(_node));
                setInlineStyles(_this.helper, {
                  boxSizing: 'border-box',
                  height: "".concat(_this.height, "px"),
                  left: "".concat(_this.boundingClientRect.left - margin.left, "px"),
                  pointerEvents: 'none',
                  position: 'fixed',
                  top: "".concat(_this.boundingClientRect.top - margin.top, "px"),
                  width: "".concat(_this.width, "px")
                });

                if (_isKeySorting) {
                  _this.helper.focus();
                }

                if (_hideSortableGhost) {
                  _this.sortableGhost = _node;
                  setInlineStyles(_node, {
                    opacity: 0,
                    visibility: 'hidden'
                  });
                }

                _this.minTranslate = {};
                _this.maxTranslate = {};

                if (_isKeySorting) {
                  var _ref = _useWindowAsScrollContainer ? {
                    top: 0,
                    left: 0,
                    width: _this.contentWindow.innerWidth,
                    height: _this.contentWindow.innerHeight
                  } : _this.containerBoundingRect,
                      containerTop = _ref.top,
                      containerLeft = _ref.left,
                      containerWidth = _ref.width,
                      containerHeight = _ref.height;

                  var containerBottom = containerTop + containerHeight;
                  var containerRight = containerLeft + containerWidth;

                  if (_this.axis.x) {
                    _this.minTranslate.x = containerLeft - _this.boundingClientRect.left;
                    _this.maxTranslate.x = containerRight - (_this.boundingClientRect.left + _this.width);
                  }

                  if (_this.axis.y) {
                    _this.minTranslate.y = containerTop - _this.boundingClientRect.top;
                    _this.maxTranslate.y = containerBottom - (_this.boundingClientRect.top + _this.height);
                  }
                } else {
                  if (_this.axis.x) {
                    _this.minTranslate.x = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                    _this.maxTranslate.x = (_useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                  }

                  if (_this.axis.y) {
                    _this.minTranslate.y = (_useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                    _this.maxTranslate.y = (_useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                  }
                }

                if (_helperClass) {
                  _helperClass.split(' ').forEach(function (className) {
                    return _this.helper.classList.add(className);
                  });
                }

                _this.listenerNode = event.touches ? event.target : _this.contentWindow;

                if (_isKeySorting) {
                  _this.listenerNode.addEventListener('wheel', _this.handleKeyEnd, true);

                  _this.listenerNode.addEventListener('mousedown', _this.handleKeyEnd, true);

                  _this.listenerNode.addEventListener('keydown', _this.handleKeyDown);
                } else {
                  events.move.forEach(function (eventName) {
                    return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false);
                  });
                  events.end.forEach(function (eventName) {
                    return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false);
                  });
                }

                _this.setState({
                  sorting: true,
                  sortingIndex: index
                });

                if (_onSortStart) {
                  _onSortStart({
                    node: _node,
                    index: index,
                    collection: _collection,
                    isKeySorting: _isKeySorting,
                    nodes: _this.manager.getOrderedRefs(),
                    helper: _this.helper
                  }, event);
                }

                if (_isKeySorting) {
                  _this.keyMove(0);
                }
              };

              var _this$props3 = _this.props,
                  _axis = _this$props3.axis,
                  _getHelperDimensions = _this$props3.getHelperDimensions,
                  _helperClass = _this$props3.helperClass,
                  _hideSortableGhost = _this$props3.hideSortableGhost,
                  updateBeforeSortStart = _this$props3.updateBeforeSortStart,
                  _onSortStart = _this$props3.onSortStart,
                  _useWindowAsScrollContainer = _this$props3.useWindowAsScrollContainer;
              var _node = active.node,
                  _collection = active.collection;
              var _isKeySorting = _this.manager.isKeySorting;

              var _temp8 = function () {
                if (typeof updateBeforeSortStart === 'function') {
                  _this._awaitingUpdateBeforeSortStart = true;

                  var _temp9 = _finallyRethrows(function () {
                    var index = _node.sortableInfo.index;
                    return Promise.resolve(updateBeforeSortStart({
                      collection: _collection,
                      index: index,
                      node: _node,
                      isKeySorting: _isKeySorting
                    }, event)).then(function () {});
                  }, function (_wasThrown, _result) {
                    _this._awaitingUpdateBeforeSortStart = false;
                    if (_wasThrown) throw _result;
                    return _result;
                  });

                  if (_temp9 && _temp9.then) return _temp9.then(function () {});
                }
              }();

              return _temp8 && _temp8.then ? _temp8.then(_temp7) : _temp7(_temp8);
            }
          }();

          return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "handleSortMove", function (event) {
        var onSortMove = _this.props.onSortMove;

        if (typeof event.preventDefault === 'function' && event.cancelable) {
          event.preventDefault();
        }

        _this.updateHelperPosition(event);

        _this.animateNodes();

        _this.autoscroll();

        if (onSortMove) {
          onSortMove(event);
        }
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "handleSortEnd", function (event) {
        var _this$props4 = _this.props,
            hideSortableGhost = _this$props4.hideSortableGhost,
            onSortEnd = _this$props4.onSortEnd;
        var _this$manager = _this.manager,
            collection = _this$manager.active.collection,
            isKeySorting = _this$manager.isKeySorting;

        var nodes = _this.manager.getOrderedRefs();

        if (_this.listenerNode) {
          if (isKeySorting) {
            _this.listenerNode.removeEventListener('wheel', _this.handleKeyEnd, true);

            _this.listenerNode.removeEventListener('mousedown', _this.handleKeyEnd, true);

            _this.listenerNode.removeEventListener('keydown', _this.handleKeyDown);
          } else {
            events.move.forEach(function (eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortMove);
            });
            events.end.forEach(function (eventName) {
              return _this.listenerNode.removeEventListener(eventName, _this.handleSortEnd);
            });
          }
        }

        _this.helper.parentNode.removeChild(_this.helper);

        if (hideSortableGhost && _this.sortableGhost) {
          setInlineStyles(_this.sortableGhost, {
            opacity: '',
            visibility: ''
          });
        }

        for (var i = 0, len = nodes.length; i < len; i++) {
          var _node2 = nodes[i];
          var el = _node2.node;
          _node2.edgeOffset = null;
          _node2.boundingClientRect = null;
          setTranslate3d(el, null);
          setTransitionDuration(el, null);
          _node2.translate = null;
        }

        _this.autoScroller.clear();

        _this.manager.active = null;
        _this.manager.isKeySorting = false;

        _this.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            collection: collection,
            newIndex: _this.newIndex,
            oldIndex: _this.index,
            isKeySorting: isKeySorting,
            nodes: nodes
          }, event);
        }

        _this.touched = false;
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "autoscroll", function () {
        var disableAutoscroll = _this.props.disableAutoscroll;
        var isKeySorting = _this.manager.isKeySorting;

        if (disableAutoscroll) {
          _this.autoScroller.clear();

          return;
        }

        if (isKeySorting) {
          var translate = _objectSpread({}, _this.translate);

          var scrollX = 0;
          var scrollY = 0;

          if (_this.axis.x) {
            translate.x = Math.min(_this.maxTranslate.x, Math.max(_this.minTranslate.x, _this.translate.x));
            scrollX = _this.translate.x - translate.x;
          }

          if (_this.axis.y) {
            translate.y = Math.min(_this.maxTranslate.y, Math.max(_this.minTranslate.y, _this.translate.y));
            scrollY = _this.translate.y - translate.y;
          }

          _this.translate = translate;
          setTranslate3d(_this.helper, _this.translate);
          _this.scrollContainer.scrollLeft += scrollX;
          _this.scrollContainer.scrollTop += scrollY;
          return;
        }

        _this.autoScroller.update({
          height: _this.height,
          maxTranslate: _this.maxTranslate,
          minTranslate: _this.minTranslate,
          translate: _this.translate,
          width: _this.width
        });
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "onAutoScroll", function (offset) {
        _this.translate.x += offset.left;
        _this.translate.y += offset.top;

        _this.animateNodes();
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "handleKeyDown", function (event) {
        var keyCode = event.keyCode;
        var _this$props5 = _this.props,
            shouldCancelStart = _this$props5.shouldCancelStart,
            _this$props5$keyCodes = _this$props5.keyCodes,
            customKeyCodes = _this$props5$keyCodes === void 0 ? {} : _this$props5$keyCodes;

        var keyCodes = _objectSpread({}, defaultKeyCodes, customKeyCodes);

        if (_this.manager.active && !_this.manager.isKeySorting || !_this.manager.active && (!keyCodes.lift.includes(keyCode) || shouldCancelStart(event) || !_this.isValidSortingTarget(event))) {
          return;
        }

        event.stopPropagation();
        event.preventDefault();

        if (keyCodes.lift.includes(keyCode) && !_this.manager.active) {
          _this.keyLift(event);
        } else if (keyCodes.drop.includes(keyCode) && _this.manager.active) {
          _this.keyDrop(event);
        } else if (keyCodes.cancel.includes(keyCode)) {
          _this.newIndex = _this.manager.active.index;

          _this.keyDrop(event);
        } else if (keyCodes.up.includes(keyCode)) {
          _this.keyMove(-1);
        } else if (keyCodes.down.includes(keyCode)) {
          _this.keyMove(1);
        }
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "keyLift", function (event) {
        var target = event.target;
        var node = closest(target, function (el) {
          return el.sortableInfo != null;
        });
        var _node$sortableInfo2 = node.sortableInfo,
            index = _node$sortableInfo2.index,
            collection = _node$sortableInfo2.collection;
        _this.initialFocusedNode = target;
        _this.manager.isKeySorting = true;
        _this.manager.active = {
          index: index,
          collection: collection
        };

        _this.handlePress(event);
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "keyMove", function (shift) {
        var nodes = _this.manager.getOrderedRefs();

        var lastIndex = nodes[nodes.length - 1].node.sortableInfo.index;
        var newIndex = _this.newIndex + shift;
        var prevIndex = _this.newIndex;

        if (newIndex < 0 || newIndex > lastIndex) {
          return;
        }

        _this.prevIndex = prevIndex;
        _this.newIndex = newIndex;
        var targetIndex = getTargetIndex(_this.newIndex, _this.prevIndex, _this.index);
        var target = nodes.find(function (_ref2) {
          var node = _ref2.node;
          return node.sortableInfo.index === targetIndex;
        });
        var targetNode = target.node;
        var scrollDelta = _this.containerScrollDelta;
        var targetBoundingClientRect = target.boundingClientRect || getScrollAdjustedBoundingClientRect(targetNode, scrollDelta);
        var targetTranslate = target.translate || {
          x: 0,
          y: 0
        };
        var targetPosition = {
          top: targetBoundingClientRect.top + targetTranslate.y - scrollDelta.top,
          left: targetBoundingClientRect.left + targetTranslate.x - scrollDelta.left
        };
        var shouldAdjustForSize = prevIndex < newIndex;
        var sizeAdjustment = {
          x: shouldAdjustForSize && _this.axis.x ? targetNode.offsetWidth - _this.width : 0,
          y: shouldAdjustForSize && _this.axis.y ? targetNode.offsetHeight - _this.height : 0
        };

        _this.handleSortMove({
          pageX: targetPosition.left + sizeAdjustment.x,
          pageY: targetPosition.top + sizeAdjustment.y,
          ignoreTransition: shift === 0
        });
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "keyDrop", function (event) {
        _this.handleSortEnd(event);

        if (_this.initialFocusedNode) {
          _this.initialFocusedNode.focus();
        }
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "handleKeyEnd", function (event) {
        if (_this.manager.active) {
          _this.keyDrop(event);
        }
      });

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "isValidSortingTarget", function (event) {
        var useDragHandle = _this.props.useDragHandle;
        var target = event.target;
        var node = closest(target, function (el) {
          return el.sortableInfo != null;
        });
        return node && node.sortableInfo && !node.sortableInfo.disabled && (useDragHandle ? isSortableHandle(target) : target.sortableInfo);
      });

      var manager = new Manager();
      validateProps(props);
      _this.manager = manager;
      _this.wrappedInstance = createRef();
      _this.sortableContextValue = {
        manager: manager
      };
      _this.events = {
        end: _this.handleEnd,
        move: _this.handleMove,
        start: _this.handleStart
      };
      return _this;
    }

    _createClass$3(WithSortableContainer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        var _this2 = this;

        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;
        var container = this.getContainer();
        Promise.resolve(container).then(function (containerNode) {
          _this2.container = containerNode;
          _this2.document = _this2.container.ownerDocument || document;
          var contentWindow = _this2.props.contentWindow || _this2.document.defaultView || window;
          _this2.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
          _this2.scrollContainer = useWindowAsScrollContainer ? _this2.document.scrollingElement || _this2.document.documentElement : getScrollingParent(_this2.container) || _this2.container;
          _this2.autoScroller = new AutoScroller(_this2.scrollContainer, _this2.onAutoScroll);
          Object.keys(_this2.events).forEach(function (key) {
            return events[key].forEach(function (eventName) {
              return _this2.container.addEventListener(eventName, _this2.events[key], false);
            });
          });

          _this2.container.addEventListener('keydown', _this2.handleKeyDown);
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        var _this3 = this;

        if (this.helper && this.helper.parentNode) {
          this.helper.parentNode.removeChild(this.helper);
        }

        if (!this.container) {
          return;
        }

        Object.keys(this.events).forEach(function (key) {
          return events[key].forEach(function (eventName) {
            return _this3.container.removeEventListener(eventName, _this3.events[key]);
          });
        });
        this.container.removeEventListener('keydown', this.handleKeyDown);
      }
    }, {
      key: "updateHelperPosition",
      value: function updateHelperPosition(event) {
        var _this$props6 = this.props,
            lockAxis = _this$props6.lockAxis,
            lockOffset = _this$props6.lockOffset,
            lockToContainerEdges = _this$props6.lockToContainerEdges,
            transitionDuration = _this$props6.transitionDuration,
            _this$props6$keyboard = _this$props6.keyboardSortingTransitionDuration,
            keyboardSortingTransitionDuration = _this$props6$keyboard === void 0 ? transitionDuration : _this$props6$keyboard;
        var isKeySorting = this.manager.isKeySorting;
        var ignoreTransition = event.ignoreTransition;
        var offset = getPosition(event);
        var translate = {
          x: offset.x - this.initialOffset.x,
          y: offset.y - this.initialOffset.y
        };
        translate.y -= window.pageYOffset - this.initialWindowScroll.top;
        translate.x -= window.pageXOffset - this.initialWindowScroll.left;
        this.translate = translate;

        if (lockToContainerEdges) {
          var _getLockPixelOffsets = getLockPixelOffsets({
            height: this.height,
            lockOffset: lockOffset,
            width: this.width
          }),
              _getLockPixelOffsets2 = _slicedToArray$8(_getLockPixelOffsets, 2),
              minLockOffset = _getLockPixelOffsets2[0],
              maxLockOffset = _getLockPixelOffsets2[1];

          var minOffset = {
            x: this.width / 2 - minLockOffset.x,
            y: this.height / 2 - minLockOffset.y
          };
          var maxOffset = {
            x: this.width / 2 - maxLockOffset.x,
            y: this.height / 2 - maxLockOffset.y
          };
          translate.x = limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
          translate.y = limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
        }

        if (lockAxis === 'x') {
          translate.y = 0;
        } else if (lockAxis === 'y') {
          translate.x = 0;
        }

        if (isKeySorting && keyboardSortingTransitionDuration && !ignoreTransition) {
          setTransitionDuration(this.helper, keyboardSortingTransitionDuration);
        }

        setTranslate3d(this.helper, translate);
      }
    }, {
      key: "animateNodes",
      value: function animateNodes() {
        var _this$props7 = this.props,
            transitionDuration = _this$props7.transitionDuration,
            hideSortableGhost = _this$props7.hideSortableGhost,
            onSortOver = _this$props7.onSortOver;
        var containerScrollDelta = this.containerScrollDelta,
            windowScrollDelta = this.windowScrollDelta;
        var nodes = this.manager.getOrderedRefs();
        var sortingOffset = {
          left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
          top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
        };
        var isKeySorting = this.manager.isKeySorting;
        var prevIndex = this.newIndex;
        this.newIndex = null;

        for (var i = 0, len = nodes.length; i < len; i++) {
          var _node3 = nodes[i].node;
          var index = _node3.sortableInfo.index;
          var width = _node3.offsetWidth;
          var height = _node3.offsetHeight;
          var offset = {
            height: this.height > height ? height / 2 : this.height / 2,
            width: this.width > width ? width / 2 : this.width / 2
          };
          var mustShiftBackward = isKeySorting && index > this.index && index <= prevIndex;
          var mustShiftForward = isKeySorting && index < this.index && index >= prevIndex;
          var translate = {
            x: 0,
            y: 0
          };
          var edgeOffset = nodes[i].edgeOffset;

          if (!edgeOffset) {
            edgeOffset = getEdgeOffset(_node3, this.container);
            nodes[i].edgeOffset = edgeOffset;

            if (isKeySorting) {
              nodes[i].boundingClientRect = getScrollAdjustedBoundingClientRect(_node3, containerScrollDelta);
            }
          }

          var nextNode = i < nodes.length - 1 && nodes[i + 1];
          var prevNode = i > 0 && nodes[i - 1];

          if (nextNode && !nextNode.edgeOffset) {
            nextNode.edgeOffset = getEdgeOffset(nextNode.node, this.container);

            if (isKeySorting) {
              nextNode.boundingClientRect = getScrollAdjustedBoundingClientRect(nextNode.node, containerScrollDelta);
            }
          }

          if (index === this.index) {
            if (hideSortableGhost) {
              this.sortableGhost = _node3;
              setInlineStyles(_node3, {
                opacity: 0,
                visibility: 'hidden'
              });
            }

            continue;
          }

          if (transitionDuration) {
            setTransitionDuration(_node3, transitionDuration);
          }

          if (this.axis.x) {
            if (this.axis.y) {
              if (mustShiftForward || index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
                translate.x = this.width + this.marginOffset.x;

                if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                  if (nextNode) {
                    translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                    translate.y = nextNode.edgeOffset.top - edgeOffset.top;
                  }
                }

                if (this.newIndex === null) {
                  this.newIndex = index;
                }
              } else if (mustShiftBackward || index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
                translate.x = -(this.width + this.marginOffset.x);

                if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                  if (prevNode) {
                    translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                    translate.y = prevNode.edgeOffset.top - edgeOffset.top;
                  }
                }

                this.newIndex = index;
              }
            } else {
              if (mustShiftBackward || index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
                translate.x = -(this.width + this.marginOffset.x);
                this.newIndex = index;
              } else if (mustShiftForward || index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
                translate.x = this.width + this.marginOffset.x;

                if (this.newIndex == null) {
                  this.newIndex = index;
                }
              }
            }
          } else if (this.axis.y) {
            if (mustShiftBackward || index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
              translate.y = -(this.height + this.marginOffset.y);
              this.newIndex = index;
            } else if (mustShiftForward || index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
              translate.y = this.height + this.marginOffset.y;

              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }

          setTranslate3d(_node3, translate);
          nodes[i].translate = translate;
        }

        if (this.newIndex == null) {
          this.newIndex = this.index;
        }

        if (isKeySorting) {
          this.newIndex = prevIndex;
        }

        var oldIndex = isKeySorting ? this.prevIndex : prevIndex;

        if (onSortOver && this.newIndex !== oldIndex) {
          onSortOver({
            collection: this.manager.active.collection,
            index: this.index,
            newIndex: this.newIndex,
            oldIndex: oldIndex,
            isKeySorting: isKeySorting,
            nodes: nodes,
            helper: this.helper
          });
        }
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant$1(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
        return this.wrappedInstance.current;
      }
    }, {
      key: "getContainer",
      value: function getContainer() {
        var getContainer = this.props.getContainer;

        if (typeof getContainer !== 'function') {
          return findDOMNode(this);
        }

        return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
      }
    }, {
      key: "render",
      value: function render() {
        var ref = config.withRef ? this.wrappedInstance : null;
        return createElement(SortableContext.Provider, {
          value: this.sortableContextValue
        }, createElement(WrappedComponent, _extends({
          ref: ref
        }, omit(this.props, omittedProps))));
      }
    }, {
      key: "helperContainer",
      get: function get() {
        var helperContainer = this.props.helperContainer;

        if (typeof helperContainer === 'function') {
          return helperContainer();
        }

        return this.props.helperContainer || this.document.body;
      }
    }, {
      key: "containerScrollDelta",
      get: function get() {
        var useWindowAsScrollContainer = this.props.useWindowAsScrollContainer;

        if (useWindowAsScrollContainer) {
          return {
            left: 0,
            top: 0
          };
        }

        return {
          left: this.scrollContainer.scrollLeft - this.initialScroll.left,
          top: this.scrollContainer.scrollTop - this.initialScroll.top
        };
      }
    }, {
      key: "windowScrollDelta",
      get: function get() {
        return {
          left: this.contentWindow.pageXOffset - this.initialWindowScroll.left,
          top: this.contentWindow.pageYOffset - this.initialWindowScroll.top
        };
      }
    }]);

    return WithSortableContainer;
  }(Component), _defineProperty$d(_class, "displayName", provideDisplayName('sortableList', WrappedComponent)), _defineProperty$d(_class, "defaultProps", defaultProps), _defineProperty$d(_class, "propTypes", propTypes), _temp;
}

var propTypes$1 = {
  index: PropTypes.number.isRequired,
  collection: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  disabled: PropTypes.bool
};
var omittedProps$1 = Object.keys(propTypes$1);
function sortableElement(WrappedComponent) {
  var _class, _temp;

  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    withRef: false
  };
  return _temp = _class = function (_React$Component) {
    _inherits(WithSortableElement, _React$Component);

    function WithSortableElement() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck$3(this, WithSortableElement);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(WithSortableElement)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty$d(_assertThisInitialized$3(_assertThisInitialized$3(_this)), "wrappedInstance", createRef());

      return _this;
    }

    _createClass$3(WithSortableElement, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.register();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        if (this.node) {
          if (prevProps.index !== this.props.index) {
            this.node.sortableInfo.index = this.props.index;
          }

          if (prevProps.disabled !== this.props.disabled) {
            this.node.sortableInfo.disabled = this.props.disabled;
          }
        }

        if (prevProps.collection !== this.props.collection) {
          this.unregister(prevProps.collection);
          this.register();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.unregister();
      }
    }, {
      key: "register",
      value: function register() {
        var _this$props = this.props,
            collection = _this$props.collection,
            disabled = _this$props.disabled,
            index = _this$props.index;
        var node = findDOMNode(this);
        node.sortableInfo = {
          collection: collection,
          disabled: disabled,
          index: index,
          manager: this.context.manager
        };
        this.node = node;
        this.ref = {
          node: node
        };
        this.context.manager.add(collection, this.ref);
      }
    }, {
      key: "unregister",
      value: function unregister() {
        var collection = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.collection;
        this.context.manager.remove(collection, this.ref);
      }
    }, {
      key: "getWrappedInstance",
      value: function getWrappedInstance() {
        invariant$1(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
        return this.wrappedInstance.current;
      }
    }, {
      key: "render",
      value: function render() {
        var ref = config.withRef ? this.wrappedInstance : null;
        return createElement(WrappedComponent, _extends({
          ref: ref
        }, omit(this.props, omittedProps$1)));
      }
    }]);

    return WithSortableElement;
  }(Component), _defineProperty$d(_class, "displayName", provideDisplayName('sortableElement', WrappedComponent)), _defineProperty$d(_class, "contextType", SortableContext), _defineProperty$d(_class, "propTypes", propTypes$1), _defineProperty$d(_class, "defaultProps", {
    collection: 0
  }), _temp;
}

var css_248z$c = ".cardDetailsExpand-module_class-ellipsis-2-lines__zkxoE,.cardDetailsExpand-module_class-ellipsis-lines__pIiBD{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.cardDetailsExpand-module_class-ellipsis-2-lines__zkxoE{-webkit-line-clamp:2!important;max-height:4rem!important}.cardDetailsExpand-module_MuiChip-root__fHeSk{margin:.5rem .3rem .5rem .5rem}.cardDetailsExpand-module_ellipse-chip__koea0.cardDetailsExpand-module_MuiChip-root__fHeSk{border-radius:1rem;height:20px}.cardDetailsExpand-module_ellipse-chip__koea0.cardDetailsExpand-module_MuiChip-root__fHeSk .cardDetailsExpand-module_MuiChip-label__NgKtM{padding-left:8px;padding-right:8px}.cardDetailsExpand-module_square-chip__d-nlc.cardDetailsExpand-module_MuiChip-root__fHeSk{border-radius:0!important}.cardDetailsExpand-module_class-width-height-100__vi25P{height:100%;width:100%}.cardDetailsExpand-module_MuiTooltip-tooltip__aTkjM{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.cardDetailsExpand-module_MuiTooltip-arrow__QYqy6{color:#fff!important}.cardDetailsExpand-module_class-font-size-icon__QCSE0{font-size:1.25rem}.cardDetailsExpand-module_card-expend-wrapper__fZWDb{position:relative}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_number__vvljh{align-items:center;background-color:#1c476d;border-radius:50%;color:#fff;display:flex;font-size:1.0625rem;font-weight:600;height:2rem;justify-content:center;left:-1rem;position:absolute;text-align:center;top:-1rem;width:2rem}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq{align-items:center;background-color:#fff;border:1px;border-radius:8px;box-shadow:0 4px 4px hsla(0,0%,44%,.25);box-sizing:border-box;color:#95939b;display:flex;flex-direction:column;font-size:.875rem;height:7rem;line-height:19px;max-width:17.7rem;min-height:7rem;width:17.7rem}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu:hover,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh:hover,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso:hover,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq:hover{cursor:pointer!important}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .cardDetailsExpand-module_title__vXO89,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .cardDetailsExpand-module_title__vXO89,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .cardDetailsExpand-module_title__vXO89,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .cardDetailsExpand-module_title__vXO89{-webkit-box-orient:vertical;-webkit-line-clamp:2!important;color:#413e48;display:block;display:-webkit-box;font-size:.9375rem;font-weight:700;height:auto!important;hyphens:auto;-webkit-hyphens:auto;-moz-hyphens:auto;-ms-hyphens:auto;max-height:4rem!important;max-width:10rem;overflow:hidden;text-overflow:ellipsis;word-break:break-word;word-break:break-all}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .cardDetailsExpand-module_content__ICboV,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .cardDetailsExpand-module_content__ICboV,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .cardDetailsExpand-module_content__ICboV,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .cardDetailsExpand-module_content__ICboV{display:flex;flex-direction:column;margin-left:2rem;margin-right:1rem;margin-top:1rem}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_sub-title__v40mE,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_sub-title__v40mE,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_sub-title__v40mE,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_sub-title__v40mE{margin-top:.3rem}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_bottom-detail__W9Q-u,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_bottom-detail__W9Q-u,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_bottom-detail__W9Q-u,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_bottom-detail__W9Q-u{margin-top:.5rem;max-width:10rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_top-description__HsH1w,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_top-description__HsH1w,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_top-description__HsH1w,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .cardDetailsExpand-module_content__ICboV .cardDetailsExpand-module_top-description__HsH1w{display:flex;flex-direction:row}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .cardDetailsExpand-module_top-content__T-NCO,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .cardDetailsExpand-module_top-content__T-NCO,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .cardDetailsExpand-module_top-content__T-NCO,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .cardDetailsExpand-module_top-content__T-NCO{align-items:center;display:flex;height:100%;width:100%}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .cardDetailsExpand-module_icon-wrapper__IdIJy,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .cardDetailsExpand-module_icon-wrapper__IdIJy,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .cardDetailsExpand-module_icon-wrapper__IdIJy,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .cardDetailsExpand-module_icon-wrapper__IdIJy{display:flex;justify-content:flex-end;margin-top:.5rem;width:15%}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .cardDetailsExpand-module_avatar__Jfusb,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .cardDetailsExpand-module_avatar__Jfusb,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .cardDetailsExpand-module_avatar__Jfusb,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .cardDetailsExpand-module_avatar__Jfusb{align-items:center;border-radius:50%;display:flex;height:3rem!important;justify-content:center;margin-left:1rem;margin-top:0;width:3rem!important}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .cardDetailsExpand-module_avatar__Jfusb svg,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .cardDetailsExpand-module_avatar__Jfusb svg,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .cardDetailsExpand-module_avatar__Jfusb svg,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .cardDetailsExpand-module_avatar__Jfusb svg{width:3.5rem!important}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .MuiTabs-root,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .MuiTabs-root,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .MuiTabs-root,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .MuiTabs-root{font-size:1rem!important;min-height:max-content!important;min-width:unset!important;width:max-content!important}.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu .MuiTab-root,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-open__0j8fh .MuiTab-root,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper-with-border__KTFso .MuiTab-root,.cardDetailsExpand-module_card-expend-wrapper__fZWDb .cardDetailsExpand-module_card-wrapper__-jGAq .MuiTab-root{min-height:unset!important;min-width:unset!important}.cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu,.cardDetailsExpand-module_card-wrapper-open__0j8fh{border-bottom-left-radius:0!important;border-bottom-right-radius:0!important}.cardDetailsExpand-module_tab-component-wrapper__fcYjE{height:7.5rem;line-height:2rem;margin-left:1rem;margin-right:1rem;overflow-y:auto;width:94%}.cardDetailsExpand-module_tab-component-wrapper__fcYjE span{display:block;margin:0!important;padding:0!important}.cardDetailsExpand-module_text-max-width__CUS5G{max-width:17rem}.cardDetailsExpand-module_expend-part-with-border__wqQC6,.cardDetailsExpand-module_expend-part__i2ZxC{background-color:#fff;border:1px;border-bottom-left-radius:8px;border-bottom-right-radius:8px;box-shadow:0 4px 4px hsla(0,0%,44%,.25);box-sizing:border-box;max-width:17.7rem;position:absolute;top:7rem;width:17.7rem;z-index:1}.cardDetailsExpand-module_expend-part-with-border__wqQC6 .cardDetailsExpand-module_bottom__1VR25,.cardDetailsExpand-module_expend-part__i2ZxC .cardDetailsExpand-module_bottom__1VR25{align-items:center;display:flex;justify-content:space-between;margin-left:1rem;margin-right:1rem}.cardDetailsExpand-module_card-wrapper-with-border__KTFso{border-width:2px}.cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu{border-width:2px;border-bottom:none!important}.cardDetailsExpand-module_expend-part-with-border__wqQC6{border-width:2px;border-top:none!important}";
var styles$c = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"cardDetailsExpand-module_class-ellipsis-lines__pIiBD","class-ellipsis-2-lines":"cardDetailsExpand-module_class-ellipsis-2-lines__zkxoE","MuiChip-root":"cardDetailsExpand-module_MuiChip-root__fHeSk","ellipse-chip":"cardDetailsExpand-module_ellipse-chip__koea0","MuiChip-label":"cardDetailsExpand-module_MuiChip-label__NgKtM","square-chip":"cardDetailsExpand-module_square-chip__d-nlc","class-width-height-100":"cardDetailsExpand-module_class-width-height-100__vi25P","MuiTooltip-tooltip":"cardDetailsExpand-module_MuiTooltip-tooltip__aTkjM","MuiTooltip-arrow":"cardDetailsExpand-module_MuiTooltip-arrow__QYqy6","class-font-size-icon":"cardDetailsExpand-module_class-font-size-icon__QCSE0","card-expend-wrapper":"cardDetailsExpand-module_card-expend-wrapper__fZWDb","number":"cardDetailsExpand-module_number__vvljh","card-wrapper":"cardDetailsExpand-module_card-wrapper__-jGAq","card-wrapper-with-border":"cardDetailsExpand-module_card-wrapper-with-border__KTFso","card-wrapper-open":"cardDetailsExpand-module_card-wrapper-open__0j8fh","card-wrapper-open-with-border":"cardDetailsExpand-module_card-wrapper-open-with-border__AyUbu","title":"cardDetailsExpand-module_title__vXO89","content":"cardDetailsExpand-module_content__ICboV","sub-title":"cardDetailsExpand-module_sub-title__v40mE","bottom-detail":"cardDetailsExpand-module_bottom-detail__W9Q-u","top-description":"cardDetailsExpand-module_top-description__HsH1w","top-content":"cardDetailsExpand-module_top-content__T-NCO","icon-wrapper":"cardDetailsExpand-module_icon-wrapper__IdIJy","avatar":"cardDetailsExpand-module_avatar__Jfusb","tab-component-wrapper":"cardDetailsExpand-module_tab-component-wrapper__fcYjE","text-max-width":"cardDetailsExpand-module_text-max-width__CUS5G","expend-part":"cardDetailsExpand-module_expend-part__i2ZxC","expend-part-with-border":"cardDetailsExpand-module_expend-part-with-border__wqQC6","bottom":"cardDetailsExpand-module_bottom__1VR25"};
styleInject(css_248z$c);

const CardDetailsExpend = (props) => {
    const { avatar, title, subTitle, bottomDetail, tabs, borderStyle, isSelected, serialNumber, onClick, style, className, refFunction } = props;
    const [isExpend, setIsExpand] = useState(false);
    const getTabs = () => {
        const tabsToRender = [];
        tabs.forEach(tab => tabsToRender.push({
            id: tab.tabTitle,
            label: tab.tabTitle,
            component: (jsx("div", Object.assign({ className: styles$c['tab-component-wrapper'] }, { children: tab.list ? (tab.list.map((lessonName, i) => (jsx(EllipsisText, { text: `${i + 1}. ${lessonName}`, maxWidthClassName: styles$c['text-max-width'] }, i + 1)))) : (jsx("div", { children: tab.text }, void 0)) }), void 0))
        }));
        return tabsToRender;
    };
    const getCardClassName = () => {
        return styles$c[isExpend
            ? borderStyle
                ? 'card-wrapper-open-with-border'
                : 'card-wrapper-open'
            : borderStyle
                ? 'card-wrapper-with-border'
                : 'card-wrapper'];
    };
    return (jsxs("div", Object.assign({ className: styles$c['card-expend-wrapper'], ref: refFunction }, { children: [serialNumber && jsx("div", Object.assign({ className: styles$c.number }, { children: serialNumber }), void 0), jsxs("div", Object.assign({ className: classNames(getCardClassName(), className), style: Object.assign({ borderColor: isSelected ? '#F36A22' : borderStyle ? '#95939B' : undefined, borderStyle }, style), onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick() }, { children: [jsxs("div", Object.assign({ className: styles$c['top-content'] }, { children: [avatar && jsx(Icon, { src: avatar.src, className: styles$c.avatar, dataTestid: "card-expend-icon", isPng: true }, void 0), jsxs("div", Object.assign({ className: styles$c.content }, { children: [jsx("div", Object.assign({ title: title, className: styles$c.title }, { children: title }), void 0), subTitle && jsx("div", Object.assign({ className: styles$c['sub-title'] }, { children: subTitle }), void 0), !isExpend && (jsxs("div", Object.assign({ className: styles$c['top-description'] }, { children: [jsx("div", Object.assign({ title: bottomDetail, className: styles$c['bottom-detail'] }, { children: bottomDetail }), void 0), jsx("div", Object.assign({ className: styles$c['icon-wrapper'] }, { children: jsx(ArrowDropDownIcon$1, { onClick: e => {
                                                        setIsExpand(true);
                                                        e.stopPropagation();
                                                    } }, void 0) }), void 0)] }), void 0))] }), void 0)] }), void 0), isExpend && (jsxs("div", Object.assign({ className: styles$c[borderStyle ? 'expend-part-with-border' : 'expend-part'], style: { borderColor: isSelected ? '#F36A22' : '#95939B', borderStyle } }, { children: [jsx(DividerContainer, {}, void 0), jsx(TabsWrapper, { data: getTabs(), underlineColor: "#2991F3" }, void 0), jsxs("div", Object.assign({ className: styles$c.bottom }, { children: [bottomDetail, jsx(ArrowDropUpIcon, { onClick: e => {
                                            setIsExpand(false);
                                            e.stopPropagation();
                                        } }, void 0)] }), void 0)] }), void 0))] }), void 0)] }), void 0));
};

var css_248z$b = ".cardsDetailsExpandWrapper-module_class-ellipsis-2-lines__iMoXD,.cardsDetailsExpandWrapper-module_class-ellipsis-lines__ubBRp{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.cardsDetailsExpandWrapper-module_class-ellipsis-2-lines__iMoXD{-webkit-line-clamp:2!important;max-height:4rem!important}.cardsDetailsExpandWrapper-module_MuiChip-root__p8mDj{margin:.5rem .3rem .5rem .5rem}.cardsDetailsExpandWrapper-module_ellipse-chip__xr8Nr.cardsDetailsExpandWrapper-module_MuiChip-root__p8mDj{border-radius:1rem;height:20px}.cardsDetailsExpandWrapper-module_ellipse-chip__xr8Nr.cardsDetailsExpandWrapper-module_MuiChip-root__p8mDj .cardsDetailsExpandWrapper-module_MuiChip-label__aZanU{padding-left:8px;padding-right:8px}.cardsDetailsExpandWrapper-module_square-chip__E0u-9.cardsDetailsExpandWrapper-module_MuiChip-root__p8mDj{border-radius:0!important}.cardsDetailsExpandWrapper-module_class-width-height-100__PPIaS{height:100%;width:100%}.cardsDetailsExpandWrapper-module_MuiTooltip-tooltip__Jg628{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.cardsDetailsExpandWrapper-module_MuiTooltip-arrow__AMUsM{color:#fff!important}.cardsDetailsExpandWrapper-module_class-font-size-icon__O-YSE{font-size:1.25rem}.cardsDetailsExpandWrapper-module_cards-expend-wrapper__GIkBP{background-color:#ecf0f5;display:grid;gap:10px;grid-auto-rows:minmax(100px,auto);grid-template-columns:repeat(var(--columnsNumber),1fr);height:26.25rem;overflow-x:hidden;overflow-y:auto;padding:2rem;row-gap:2rem}.cardsDetailsExpandWrapper-module_sortable-item__CW2R9{pointer-events:auto}.cardsDetailsExpandWrapper-module_sortable-container__Uz9J6>.cardsDetailsExpandWrapper-module_sortable-item__CW2R9:hover{cursor:grab}.cardsDetailsExpandWrapper-module_darged-element__4eIgy>div:nth-child(2){border:2px dashed #f36a22;border-radius:8px;cursor:grabbing;transform:rotate(-5.29deg)}.cardsDetailsExpandWrapper-module_darged-element__4eIgy>div:first-child{cursor:grabbing;top:0;transform:rotate(-10deg);z-index:1}";
var styles$b = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"cardsDetailsExpandWrapper-module_class-ellipsis-lines__ubBRp","class-ellipsis-2-lines":"cardsDetailsExpandWrapper-module_class-ellipsis-2-lines__iMoXD","MuiChip-root":"cardsDetailsExpandWrapper-module_MuiChip-root__p8mDj","ellipse-chip":"cardsDetailsExpandWrapper-module_ellipse-chip__xr8Nr","MuiChip-label":"cardsDetailsExpandWrapper-module_MuiChip-label__aZanU","square-chip":"cardsDetailsExpandWrapper-module_square-chip__E0u-9","class-width-height-100":"cardsDetailsExpandWrapper-module_class-width-height-100__PPIaS","MuiTooltip-tooltip":"cardsDetailsExpandWrapper-module_MuiTooltip-tooltip__Jg628","MuiTooltip-arrow":"cardsDetailsExpandWrapper-module_MuiTooltip-arrow__AMUsM","class-font-size-icon":"cardsDetailsExpandWrapper-module_class-font-size-icon__O-YSE","cards-expend-wrapper":"cardsDetailsExpandWrapper-module_cards-expend-wrapper__GIkBP","sortable-item":"cardsDetailsExpandWrapper-module_sortable-item__CW2R9","sortable-container":"cardsDetailsExpandWrapper-module_sortable-container__Uz9J6","darged-element":"cardsDetailsExpandWrapper-module_darged-element__4eIgy"};
styleInject(css_248z$b);

const CardsDetailsExpendWrapper = (props) => {
    const { columnsNumber = 4, cards, isDraggable, onSort } = props;
    const onSoretEnd = ({ oldIndex, newIndex }) => {
        onSort === null || onSort === void 0 ? void 0 : onSort(oldIndex, newIndex);
    };
    const SortableItem = sortableElement(({ value }) => (jsx(CardDetailsExpend, Object.assign({}, value, { className: styles$b['sortable-item'] }), value.title)));
    const SortableList = sortableContainer(({ items }) => {
        return (jsx("div", Object.assign({ className: classNames(styles$b['cards-expend-wrapper'], styles$b['sortable-container']), style: { '--columnsNumber': columnsNumber } }, { children: items.map((card, index) => (jsx(SortableItem, { index: index, value: card }, `item-${card.title}`))) }), void 0));
    });
    return !isDraggable ? (jsx("div", Object.assign({ className: styles$b['cards-expend-wrapper'], style: { '--columnsNumber': columnsNumber } }, { children: cards.map((card, i) => (createElement(CardDetailsExpend, Object.assign({}, card, { key: `${card.title}${i}` })))) }), void 0)) : (jsx(SortableList, { items: cards, onSortEnd: onSoretEnd, distance: 1, axis: "xy", helperClass: styles$b['darged-element'] }, void 0));
};

var css_248z$a = ".validateTextField-module_class-ellipsis-2-lines__skUvp,.validateTextField-module_class-ellipsis-lines__7IPSi{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.validateTextField-module_class-ellipsis-2-lines__skUvp{-webkit-line-clamp:2!important;max-height:4rem!important}.validateTextField-module_MuiChip-root__H2VP4{margin:.5rem .3rem .5rem .5rem}.validateTextField-module_ellipse-chip__A6QnH.validateTextField-module_MuiChip-root__H2VP4{border-radius:1rem;height:20px}.validateTextField-module_ellipse-chip__A6QnH.validateTextField-module_MuiChip-root__H2VP4 .validateTextField-module_MuiChip-label__bqP67{padding-left:8px;padding-right:8px}.validateTextField-module_square-chip__yv-U3.validateTextField-module_MuiChip-root__H2VP4{border-radius:0!important}.validateTextField-module_class-width-height-100__u5py9{height:100%;width:100%}.validateTextField-module_MuiTooltip-tooltip__ESdfX{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.validateTextField-module_MuiTooltip-arrow__zPa7W{color:#fff!important}.validateTextField-module_class-font-size-icon__jxmUz{font-size:1.25rem}.validateTextField-module_validate-textfield__-A6-k{align-items:center;display:flex;justify-content:center}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_error__wHg7S .MuiOutlinedInput-notchedOutline{border-bottom-color:#f0585b!important}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_error__wHg7S .MuiOutlinedInput-input{color:#f0585b!important}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_error__wHg7S .MuiFormHelperText-root{color:#f0585b!important;font-size:1rem;text-align:center;width:max-content!important}.validateTextField-module_validate-textfield__-A6-k .text-field-wrapper{height:100%!important}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_textfield__qjFQD{margin-right:var(--textFieldMarginRight);width:100%}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_textfield__qjFQD .MuiOutlinedInput-input{padding:0 0 .2rem}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_textfield__qjFQD .MuiOutlinedInput-root{border-radius:0}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_visible__41MTu{visibility:visible!important}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_hidden__wMq-5{visibility:hidden}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF{position:relative}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw{margin-top:var(--iconMarginTops);pointer-events:all;position:absolute}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_edit-icon__RJfGD,.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-error__N58-L,.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-loader__cWcJ5,.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon__-iI6n{padding-left:.4rem;padding-right:.8rem}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_edit-icon__RJfGD svg,.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-error__N58-L svg,.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-loader__cWcJ5 svg,.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon__-iI6n svg{height:var(--editIconHeight);width:var(--editIconWidth)}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_edit-icon__RJfGD svg path,.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-error__N58-L svg path,.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-loader__cWcJ5 svg path,.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon__-iI6n svg path{fill:var(--colorFont)}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_edit-icon__RJfGD{cursor:pointer}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-error__N58-L{cursor:pointer;margin-top:-1rem!important}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-error__N58-L svg{height:1.5rem;width:1.5rem}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-error__N58-L svg rect{fill:#f0585b!important}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-loader__cWcJ5{padding-left:.8rem}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-loader__cWcJ5 svg{height:1rem;width:1rem}.validateTextField-module_validate-textfield__-A6-k .validateTextField-module_relative-icon__lhwdF .validateTextField-module_icon-wrapper__UM1Zw .validateTextField-module_icon-loader__cWcJ5 svg circle{stroke:#fff}.validateTextField-module_tooltip__b-7y4{align-items:center;display:flex;font-family:Inter;font-size:1rem;height:1.7rem}.validateTextField-module_tooltip__b-7y4 .validateTextField-module_tooltip-text__aQjwT{color:#676972;font-weight:400;margin-right:.8rem}.validateTextField-module_tooltip__b-7y4 .validateTextField-module_cancel__72SMG{color:#109cf1;cursor:pointer}.validateTextField-module_text-width-helper__-Hot6{color:transparent;font-size:var(--fontSize);font-style:Inter;font-weight:700;position:absolute;z-index:-1}";
var styles$a = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"validateTextField-module_class-ellipsis-lines__7IPSi","class-ellipsis-2-lines":"validateTextField-module_class-ellipsis-2-lines__skUvp","MuiChip-root":"validateTextField-module_MuiChip-root__H2VP4","ellipse-chip":"validateTextField-module_ellipse-chip__A6QnH","MuiChip-label":"validateTextField-module_MuiChip-label__bqP67","square-chip":"validateTextField-module_square-chip__yv-U3","class-width-height-100":"validateTextField-module_class-width-height-100__u5py9","MuiTooltip-tooltip":"validateTextField-module_MuiTooltip-tooltip__ESdfX","MuiTooltip-arrow":"validateTextField-module_MuiTooltip-arrow__zPa7W","class-font-size-icon":"validateTextField-module_class-font-size-icon__jxmUz","validate-textfield":"validateTextField-module_validate-textfield__-A6-k","error":"validateTextField-module_error__wHg7S","textfield":"validateTextField-module_textfield__qjFQD","visible":"validateTextField-module_visible__41MTu","hidden":"validateTextField-module_hidden__wMq-5","relative-icon":"validateTextField-module_relative-icon__lhwdF","icon-wrapper":"validateTextField-module_icon-wrapper__UM1Zw","icon":"validateTextField-module_icon__-iI6n","edit-icon":"validateTextField-module_edit-icon__RJfGD","icon-error":"validateTextField-module_icon-error__N58-L","icon-loader":"validateTextField-module_icon-loader__cWcJ5","tooltip":"validateTextField-module_tooltip__b-7y4","tooltip-text":"validateTextField-module_tooltip-text__aQjwT","cancel":"validateTextField-module_cancel__72SMG","text-width-helper":"validateTextField-module_text-width-helper__-Hot6"};
styleInject(css_248z$a);

const ValidateTextField = (props) => {
    const { translate } = useTranslationContext();
    const { value, placeholder, loadingTooltipKey, onChange, onCancel, isLoading, error, isExternalEditing = false, maxLength = 600, smallMode = false, fontSize = '2.6rem', colorFont = 'white', editIconHeight = '1.7rem', editIconWidth = '1.7rem', textFieldMarginRight = '0.7rem', iconMarginTops = '-0.9rem', inputTextColor = 'white', inputTextSize = 'xx-large', textFieldFontWeight = 700, inputNotchedOutlineColor = 'white', editIconToolTipText = '' } = props;
    const [previousText] = useState(value);
    const [text, setText] = useState(value);
    const [isMouseOver, setIsMouseOver] = useState(false);
    const [isEditing, setIsEditing] = useState(isExternalEditing);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [status, setStatus] = useState('none');
    const inputRef = useRef();
    const [forceRerender, setForceRerender] = useState(false);
    useEffect(() => {
        setIsEditing(isExternalEditing);
    }, [isExternalEditing]);
    useEffect(() => {
        // forcing rerender in order to get correct width of helper div
        setTimeout(() => setForceRerender(true), 1);
    }, [forceRerender]);
    const handleStatus = useCallback$1(() => {
        if (isLoading)
            return setStatus('validating');
        if (error)
            return setStatus('error');
        if (isMouseOver)
            return setStatus('editableOnHover');
        if (isSubmitted)
            return setStatus('approved');
        if (isEditing)
            return setStatus('editing');
        return setStatus('none');
    }, [isMouseOver, isEditing, isLoading, error, isSubmitted]);
    useEffect(() => {
        handleStatus();
    }, [handleStatus]);
    useEffect(() => {
        setText(value);
    }, [value]);
    const onSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (text !== value) {
            setIsSubmitted(true);
            yield onChange(text);
        }
        else {
            setIsEditing(false);
        }
    });
    const handleCancel = () => {
        onCancel === null || onCancel === void 0 ? void 0 : onCancel(previousText);
        setText(previousText);
        setIsSubmitted(false);
    };
    const ValidateTooltip = () => (jsxs("div", Object.assign({ className: styles$a.tooltip }, { children: [jsx("div", Object.assign({ className: styles$a['tooltip-text'] }, { children: translate(loadingTooltipKey) }), void 0), jsx("div", Object.assign({ className: styles$a.cancel, onClick: handleCancel }, { children: translate('Cancel') }), void 0)] }), void 0));
    const getWidth = () => {
        var _a, _b;
        let width;
        const textWidth = smallMode ? ((_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) + 2 : (_b = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _b === void 0 ? void 0 : _b.offsetWidth;
        if (textWidth === 0)
            width = '16px';
        else if (smallMode && textWidth < 65 && status === 'editing')
            width = '100px';
        else if (textWidth > maxLength)
            width = `${maxLength}px`;
        else
            width = `${status === 'editing' ? textWidth + 16 : textWidth}px`;
        return width;
    };
    return (jsxs(Fragment$1, { children: [jsx("div", Object.assign({ ref: inputRef, className: styles$a['text-width-helper'], style: { '--fontSize': fontSize, '--colorFont': colorFont } }, { children: text }), void 0), jsxs("div", Object.assign({ className: styles$a['validate-textfield'], style: {
                    '--fontSize': fontSize,
                    '--colorFont': colorFont,
                    '--textFieldMarginRight': textFieldMarginRight
                }, onMouseEnter: () => (status === 'none' || status === 'approved') && setIsMouseOver(true), onMouseLeave: () => status === 'editableOnHover' && setIsMouseOver(false) }, { children: [jsx(TextFieldContainer, { inputRef: input => isEditing && input && input.focus(), dataTestid: "textfield", className: classNames(styles$a.textfield, { [styles$a.error]: status === 'error' }), type: "transparent", value: text, helperText: error, onChange: (v) => setText(v), placeholder: placeholder, disabled: status !== 'editing', width: getWidth(), inputTextColor: inputTextColor, inputTextSize: inputTextSize, textFieldFontWeight: textFieldFontWeight, inputNotchedOutlineColor: inputNotchedOutlineColor }, void 0), jsx("div", Object.assign({ className: styles$a['relative-icon'] }, { children: jsxs("div", Object.assign({ "data-testid": "icon", className: classNames(styles$a['icon-wrapper']), style: { '--iconMarginTops': iconMarginTops, '--colorFont': colorFont } }, { children: [(status === 'none' || status === 'editableOnHover') && (jsx(TooltipContainer, Object.assign({ title: editIconToolTipText, placement: "right-start", type: "primary" }, { children: jsx("span", { children: jsx(Icon, { style: {
                                                '--editIconHeight': editIconHeight,
                                                '--editIconWidth': editIconWidth
                                            }, dataTestid: "edit-left-icon", name: "editLeft", className: classNames(styles$a['edit-icon'], {
                                                [styles$a.visible]: status === 'editableOnHover',
                                                [styles$a.hidden]: status === 'none'
                                            }), onClick: () => {
                                                setIsMouseOver(false);
                                                setIsEditing(true);
                                                setIsSubmitted(false);
                                            } }, void 0) }, void 0) }), void 0)), isEditing && status === 'editing' && (jsx(Icon, { style: {
                                        '--editIconHeight': editIconHeight,
                                        '--editIconWidth': editIconWidth,
                                        '--colorFont': colorFont
                                    }, className: classNames(styles$a['edit-icon'], {
                                        [styles$a.visible]: status === 'editing'
                                    }), name: "saveAdmin", onClick: onSubmit }, void 0)), status === 'error' && (jsx(Icon, { dataTestid: "error-icon", name: "templateCardClose", className: styles$a['icon-error'], onClick: handleCancel }, void 0)), status === 'approved' && (jsx(Icon, { dataTestid: "approved-icon", name: "done", className: styles$a.icon }, void 0)), status === 'validating' && (jsx(TooltipContainer, Object.assign({ dataTestid: "loader-tooltip", title: jsx(ValidateTooltip, {}, void 0), placement: "right", interactive: true, isTooltipHidden: !loadingTooltipKey || !onCancel }, { children: jsx("span", Object.assign({ className: styles$a['icon-loader'] }, { children: jsx(SimpleLoader, { dataTestid: "validating-loader", color: "primary", size: "unset" }, void 0) }), void 0) }), void 0))] }), void 0) }), void 0)] }), void 0)] }, void 0));
};

var ValidateTextFieldStatuses;
(function (ValidateTextFieldStatuses) {
    ValidateTextFieldStatuses[ValidateTextFieldStatuses["none"] = 0] = "none";
    ValidateTextFieldStatuses[ValidateTextFieldStatuses["editableOnHover"] = 1] = "editableOnHover";
    ValidateTextFieldStatuses[ValidateTextFieldStatuses["editing"] = 2] = "editing";
    ValidateTextFieldStatuses[ValidateTextFieldStatuses["validating"] = 3] = "validating";
    ValidateTextFieldStatuses[ValidateTextFieldStatuses["error"] = 4] = "error";
    ValidateTextFieldStatuses[ValidateTextFieldStatuses["approved"] = 5] = "approved";
})(ValidateTextFieldStatuses || (ValidateTextFieldStatuses = {}));

var css_248z$9 = ".newFilters-module_accordion__BAOu7{border-top:.2px solid rgba(0,0,0,.12);margin:0!important}.newFilters-module_accordion__BAOu7 .newFilters-module_accordion-summary__btVFU{min-height:4.5rem!important}.newFilters-module_accordion__BAOu7 .newFilters-module_accordion-summary__btVFU .Mui-expanded{margin:0!important}.newFilters-module_accordion__BAOu7 .newFilters-module_accordion-summary__btVFU .newFilters-module_summary__i8OdI{align-items:center;display:flex;justify-content:space-between;width:100%}.newFilters-module_accordion__BAOu7 .newFilters-module_accordion-summary__btVFU .newFilters-module_summary__i8OdI .newFilters-module_left__r0skB{align-items:center;display:flex}.newFilters-module_accordion__BAOu7 .newFilters-module_accordion-summary__btVFU .newFilters-module_summary__i8OdI .newFilters-module_left__r0skB .newFilters-module_title__rJOrz{font-weight:500;margin-left:1rem}.newFilters-module_accordion__BAOu7 .newFilters-module_accordion-summary__btVFU .newFilters-module_summary__i8OdI .newFilters-module_right__2z1d2{align-items:center;display:flex}.newFilters-module_accordion__BAOu7 .newFilters-module_accordion-summary__btVFU .newFilters-module_summary__i8OdI .newFilters-module_right__2z1d2 .newFilters-module_text__OBv-h{color:#bfbdc2;margin-right:1rem}.newFilters-module_accordion__BAOu7 .newFilters-module_details-wrapper__7Sdkl{background-color:#f6f6f6;border-top:1px solid #dad8dc}.newFilters-module_accordion__BAOu7 .newFilters-module_details-wrapper__7Sdkl .newFilters-module_details__khBXV{display:flex;flex-direction:column}.newFilters-module_accordion__BAOu7 .newFilters-module_details-wrapper__7Sdkl .newFilters-module_details__khBXV .newFilters-module_label__EAShj{display:flex}.newFilters-module_accordion__BAOu7 .newFilters-module_details-wrapper__7Sdkl .newFilters-module_details__khBXV .newFilters-module_label__EAShj .newFilters-module_expand__VPapw{margin-left:.5rem;padding:0}.newFilters-module_accordion__BAOu7 .newFilters-module_details-wrapper__7Sdkl .newFilters-module_details__khBXV .newFilters-module_option-title__Z5QXl{padding:.5rem 0}.newFilters-module_accordion__BAOu7 .newFilters-module_details-wrapper__7Sdkl .newFilters-module_details__khBXV .newFilters-module_buttons-group__AiQBm{display:flex;flex-direction:column;margin-left:2rem}";
var styles$9 = {"accordion":"newFilters-module_accordion__BAOu7","accordion-summary":"newFilters-module_accordion-summary__btVFU","summary":"newFilters-module_summary__i8OdI","left":"newFilters-module_left__r0skB","title":"newFilters-module_title__rJOrz","right":"newFilters-module_right__2z1d2","text":"newFilters-module_text__OBv-h","details-wrapper":"newFilters-module_details-wrapper__7Sdkl","details":"newFilters-module_details__khBXV","label":"newFilters-module_label__EAShj","expand":"newFilters-module_expand__VPapw","option-title":"newFilters-module_option-title__Z5QXl","buttons-group":"newFilters-module_buttons-group__AiQBm"};
styleInject(css_248z$9);

const Filters = (props) => {
    const { filterData, selectedFiltersData, onFilterSelect, onFilterValueSelect, onFilterArrayValueSelect, clearFilter, onExpand } = props;
    const { translate } = useTranslationContext();
    const [expandedIndex, setExpandedIndex] = useState(-1);
    const handleChange = (index) => {
        setExpandedIndex(index === expandedIndex ? -1 : index);
    };
    const renderLabel = (option, disabled) => (jsxs("div", Object.assign({ className: styles$9.label }, { children: [jsx("div", { children: translate(option.label) }, void 0), option.expand && (jsx(IconButton$1, Object.assign({ disabled: disabled, onClick: event => {
                    event.preventDefault();
                    onExpand(option.value);
                }, className: styles$9.expand, "data-testid": "plus-icon" }, { children: jsx(AddIcon, {}, void 0) }), void 0))] }), void 0));
    const renderRadioGroup = (filter) => {
        var _a;
        const buttons = filter.options.map(option => {
            var _a;
            const disable = !((_a = selectedFiltersData[filter.value]) === null || _a === void 0 ? void 0 : _a.selected);
            return Object.assign(Object.assign({}, option), { label: renderLabel(option, disable), disable });
        });
        return (jsx(RadioButtonContainer, { radioButtonsSize: "small", radioButtonsColor: "secondary", onChange: (val) => onFilterValueSelect(filter.value, val), value: (_a = selectedFiltersData[filter.value]) === null || _a === void 0 ? void 0 : _a.value, buttons: buttons }, void 0));
    };
    const renderCheckBoxGroup = (filter) => filter.options.map((option, i) => {
        var _a;
        return (jsx(FormControlLabel, { control: jsx(Checkbox, { size: "small", checked: (_a = selectedFiltersData[filter.value].value) === null || _a === void 0 ? void 0 : _a.includes(option.value), onChange: event => onFilterArrayValueSelect(filter.value, option.value, event.target.checked) }, void 0), label: translate(option.label) }, i));
    });
    return (jsx("div", { children: filterData.map((filter, i) => (jsxs(Accordion, Object.assign({ className: styles$9.accordion, expanded: expandedIndex === i, onChange: () => handleChange(i) }, { children: [jsx(AccordionSummary, Object.assign({ "data-testid": "accordion-summary", className: styles$9['accordion-summary'] }, { children: jsxs("div", Object.assign({ className: styles$9.summary }, { children: [jsxs("div", Object.assign({ className: styles$9.left }, { children: [expandedIndex === i ? jsx(ExpandMore, {}, void 0) : jsx(ChevronRight, {}, void 0), jsx("div", Object.assign({ className: styles$9.title }, { children: translate(filter.label) }), void 0)] }), void 0), filter.options.find(option => { var _a; return (_a = selectedFiltersData[option.value]) === null || _a === void 0 ? void 0 : _a.selected; }) && (jsxs("div", Object.assign({ className: styles$9.right }, { children: [jsx(CheckIcon, { color: "disabled" }, void 0), jsx("div", Object.assign({ className: styles$9.text }, { children: translate('Applied') }), void 0), jsx(DeleteOutlineIcon, { onClick: event => {
                                            event.stopPropagation();
                                            clearFilter(filter.label);
                                        }, color: "disabled" }, void 0)] }), void 0))] }), void 0) }), void 0), jsx(AccordionDetails, Object.assign({ className: styles$9['details-wrapper'] }, { children: jsx("div", Object.assign({ className: styles$9.details }, { children: filter.options.map((option, i) => {
                            var _a, _b;
                            return (jsxs("div", { children: [option.multiSelect && (jsx("div", Object.assign({ className: styles$9['option-title'] }, { children: renderLabel(option, false) }), void 0)), !option.multiSelect && (jsx(FormControlLabel, { control: jsx(Checkbox, { size: "small", checked: (_a = selectedFiltersData[option.value]) === null || _a === void 0 ? void 0 : _a.selected, onChange: event => {
                                                if (option.expand && event.target.checked) {
                                                    onExpand(option.value);
                                                }
                                                onFilterSelect(option.value, event.target.checked);
                                            } }, void 0), label: renderLabel(option, !((_b = selectedFiltersData[option.value]) === null || _b === void 0 ? void 0 : _b.selected)) }, void 0)), option.options && (jsx("div", Object.assign({ className: styles$9['buttons-group'] }, { children: (option === null || option === void 0 ? void 0 : option.multiSelect)
                                            ? renderCheckBoxGroup(option)
                                            : renderRadioGroup(option) }), void 0))] }, i));
                        }) }), void 0) }), void 0)] }), i))) }, void 0));
};

const FiltersContainer = (props) => {
    const { filterData, selectedFiltersData, setSelectedFiltersData, initialSelectedFiltersData, onExpand } = props;
    const onFilterSelect = (filterValue, checked) => {
        const tempSelectedFiltersData = Object.assign({}, selectedFiltersData);
        const currentSelectedFilterData = Object.assign({}, selectedFiltersData[filterValue]);
        setSelectedFiltersData(Object.assign(Object.assign({}, tempSelectedFiltersData), { [filterValue]: Object.assign(Object.assign({}, currentSelectedFilterData), { selected: checked }) }));
    };
    const onFilterValueSelect = (filterValue, value) => {
        const tempSelectedFiltersData = Object.assign({}, selectedFiltersData);
        const currentSelectedFilterData = Object.assign({}, selectedFiltersData[filterValue]);
        setSelectedFiltersData(Object.assign(Object.assign({}, tempSelectedFiltersData), { [filterValue]: Object.assign(Object.assign({}, currentSelectedFilterData), { value }) }));
    };
    const onFilterArrayValueSelect = (filterValue, value, checked) => {
        const tempSelectedFiltersData = Object.assign({}, selectedFiltersData);
        const currentSelectedFilterData = Object.assign({}, selectedFiltersData[filterValue]);
        const arrayValueData = [...currentSelectedFilterData.value];
        checked ? arrayValueData.push(value) : arrayValueData.splice(arrayValueData.indexOf(value), 1);
        setSelectedFiltersData(Object.assign(Object.assign({}, tempSelectedFiltersData), { [filterValue]: {
                selected: arrayValueData.length > 0,
                value: arrayValueData
            } }));
    };
    const clearFilter = (filterLabel) => {
        const tempSelectedFiltersData = Object.assign({}, selectedFiltersData);
        const filtersToClear = filterData.find(filter => filter.label === filterLabel);
        const initialFilters = {};
        filtersToClear === null || filtersToClear === void 0 ? void 0 : filtersToClear.options.forEach(option => {
            initialFilters[option.value] = initialSelectedFiltersData[option.value];
        });
        setSelectedFiltersData(Object.assign(Object.assign({}, tempSelectedFiltersData), initialFilters));
    };
    return (jsx(Filters, { filterData: filterData, onFilterSelect: onFilterSelect, onFilterValueSelect: onFilterValueSelect, onFilterArrayValueSelect: onFilterArrayValueSelect, clearFilter: clearFilter, selectedFiltersData: selectedFiltersData, onExpand: onExpand }, void 0));
};

var css_248z$8 = ".selectContentListPopup-module_dialog__rFUvB .MuiPaper-rounded{border-radius:8px!important;max-width:70rem!important}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v{min-width:30rem}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_search__bbohN{border-radius:8px!important;box-shadow:0 4px 8px hsla(0,0%,44%,.25);display:flex;justify-content:center;padding:.6rem 3%;width:94%}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_search__bbohN .selectContentListPopup-module_tags__dI8bt{display:flex;justify-content:space-around}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_search__bbohN .selectContentListPopup-module_tags__dI8bt .selectContentListPopup-module_tag__sZjyd{align-items:center;display:flex;flex:auto;font-size:.9rem;justify-content:center;padding:.4rem 0}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_search__bbohN .selectContentListPopup-module_tags__dI8bt .selectContentListPopup-module_selected-tag__g-2YU{background:#edeff7;border:1px solid #cbcfe3;color:#5c69a4}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_search__bbohN .selectContentListPopup-module_tags__dI8bt .selectContentListPopup-module_first-tag__XZtUA{border-radius:4px 0 0 4px}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_search__bbohN .selectContentListPopup-module_tags__dI8bt .selectContentListPopup-module_last-tag__3jJ5e{border-radius:0 4px 4px 0}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_search__bbohN .selectContentListPopup-module_tags__dI8bt .selectContentListPopup-module_unselected-tag__BsOgh{background:#fff;border:1px solid #bfbdc2;box-shadow:0 4px 4px hsla(0,0%,44%,.25);cursor:pointer;opacity:.7}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_reset-icon__IqMh5{cursor:pointer}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_reset-icon__IqMh5:hover{fill:#f47b3b!important}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_selected-num__kTPaJ{background:#f6f6f6;color:#f36a22;padding:1rem 0;text-align:center}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_items__e-sLp{max-height:30rem;overflow-y:auto}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_items__e-sLp .selectContentListPopup-module_item__Tjn5Z{border-bottom:1px solid #ebebeb;padding:1rem}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_items__e-sLp .selectContentListPopup-module_item__Tjn5Z .selectContentListPopup-module_label__tTS14{align-items:center;display:flex}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_items__e-sLp .selectContentListPopup-module_item__Tjn5Z .selectContentListPopup-module_label__tTS14 .selectContentListPopup-module_texts__5Cwbw{margin-left:1rem}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_items__e-sLp .selectContentListPopup-module_item__Tjn5Z .selectContentListPopup-module_label__tTS14 .selectContentListPopup-module_texts__5Cwbw .selectContentListPopup-module_name__cu7Fv{font-weight:600}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_items__e-sLp .selectContentListPopup-module_item__Tjn5Z .selectContentListPopup-module_label__tTS14 .selectContentListPopup-module_texts__5Cwbw .selectContentListPopup-module_description__ZOdj9{color:#95939b}.selectContentListPopup-module_dialog__rFUvB .selectContentListPopup-module_wrapper__FK27v .selectContentListPopup-module_items__e-sLp .selectContentListPopup-module_button-wrapper__MR-f-{bottom:1rem;display:flex;justify-content:end;margin:1rem;position:-webkit-sticky;position:sticky}";
var styles$8 = {"dialog":"selectContentListPopup-module_dialog__rFUvB","wrapper":"selectContentListPopup-module_wrapper__FK27v","search":"selectContentListPopup-module_search__bbohN","tags":"selectContentListPopup-module_tags__dI8bt","tag":"selectContentListPopup-module_tag__sZjyd","selected-tag":"selectContentListPopup-module_selected-tag__g-2YU","first-tag":"selectContentListPopup-module_first-tag__XZtUA","last-tag":"selectContentListPopup-module_last-tag__3jJ5e","unselected-tag":"selectContentListPopup-module_unselected-tag__BsOgh","reset-icon":"selectContentListPopup-module_reset-icon__IqMh5","selected-num":"selectContentListPopup-module_selected-num__kTPaJ","items":"selectContentListPopup-module_items__e-sLp","item":"selectContentListPopup-module_item__Tjn5Z","label":"selectContentListPopup-module_label__tTS14","texts":"selectContentListPopup-module_texts__5Cwbw","name":"selectContentListPopup-module_name__cu7Fv","description":"selectContentListPopup-module_description__ZOdj9","button-wrapper":"selectContentListPopup-module_button-wrapper__MR-f-"};
styleInject(css_248z$8);

const SelectContentListPopup = (props) => {
    const { isOpen, onClose, setSelectedData, filters, topOffset, setSearchValue, searchValue, selectedContent, setFilterSelected, filterSelected, dataLengthPerFilter, filteredData, addOrRemoveFromList, selectedTitle } = props;
    const { translate } = useTranslationContext();
    const doneText = translate('Done');
    const renderIcon = (src) => {
        if (src.indexOf('.svg') > -1)
            return jsx(AvatarContainer, { src: src, avatarSize: "3rem", hasMargin: false }, void 0);
        return jsx(Icon, { src: src, isPng: true, style: { width: '3rem' } }, void 0);
    };
    return (jsx(Dialog, Object.assign({ className: styles$8.dialog, style: { '--top': `${topOffset + 30}px` }, onClose: onClose, open: isOpen }, { children: jsxs("div", Object.assign({ className: styles$8.wrapper }, { children: [jsx(TextField, { inputProps: { 'data-testid': 'search' }, className: styles$8.search, onChange: e => setSearchValue(e.target.value), value: searchValue, helperText: jsx(Fragment$1, { children: (filters === null || filters === void 0 ? void 0 : filters.values) && (jsx("div", Object.assign({ className: styles$8.tags }, { children: filters.values.map((value, i) => (jsx("div", Object.assign({ onClick: () => setFilterSelected(value), className: classNames(styles$8.tag, {
                                    [styles$8['selected-tag']]: filterSelected === value,
                                    [styles$8['unselected-tag']]: filterSelected !== value,
                                    [styles$8['first-tag']]: i === 0,
                                    [styles$8['last-tag']]: i === filters.values.length - 1
                                }) }, { children: translate(`${value}_x`, {
                                    number: String(dataLengthPerFilter[value] || 0)
                                }) }), i))) }), void 0)) }, void 0), InputProps: {
                        disableUnderline: true,
                        startAdornment: (jsx(InputAdornment, Object.assign({ position: "start" }, { children: jsx(SearchIcon, {}, void 0) }), void 0)),
                        endAdornment: (jsx(InputAdornment, Object.assign({ position: "end" }, { children: jsx(CloseIcon, { onClick: onClose, className: styles$8['reset-icon'] }, void 0) }), void 0))
                    } }, void 0), jsxs("div", Object.assign({ className: styles$8['selected-num'] }, { children: [selectedTitle, " ", jsx("b", { children: selectedContent.length }, void 0)] }), void 0), jsxs("div", Object.assign({ className: styles$8.items }, { children: [filteredData.map((item, i) => (jsx("div", Object.assign({ className: styles$8.item }, { children: jsx(FormControlLabel, { control: jsx(Checkbox, { checked: selectedContent.includes(item.id), onChange: event => addOrRemoveFromList(item.id, event.target.checked) }, void 0), label: jsxs("div", Object.assign({ className: styles$8.label }, { children: [item.iconUrl && renderIcon(item.iconUrl), jsxs("div", Object.assign({ className: styles$8.texts }, { children: [jsx("div", Object.assign({ className: classNames({ [styles$8.name]: item.description }) }, { children: item.name }), void 0), item.description && (jsx("div", Object.assign({ className: styles$8.description }, { children: item.description }), void 0))] }), void 0)] }), void 0) }, void 0) }), i))), jsx("div", Object.assign({ className: styles$8['button-wrapper'] }, { children: jsx(ButtonContainer, { type: "secondary", text: doneText, onClick: () => {
                                    setSelectedData(selectedContent);
                                    onClose();
                                } }, void 0) }), void 0)] }), void 0)] }), void 0) }), void 0));
};

const SelectContentListPopupContainer = (props) => {
    const { isOpen, onClose, data, selectedData, setSelectedData, filters, topOffset, selectedTitle } = props;
    const [selectedContent, setSelectedContent] = useState(selectedData);
    const [searchValue, setSearchValue] = useState('');
    const [filteredData, setFilteredData] = useState(data);
    const [filterSelected, setFilterSelected] = useState('all');
    const [dataLengthPerFilter, setDataLengthPerFilter] = useState({});
    useEffect(() => {
        selectedData && setSelectedContent(selectedData);
    }, [selectedData]);
    useEffect(() => {
        if (data) {
            let tmpRecords = [...data];
            if (searchValue !== '') {
                tmpRecords = tmpRecords.filter(record => record.name.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()));
            }
            if (filters === null || filters === void 0 ? void 0 : filters.filterField) {
                const currentDataLengthPerFilter = {};
                tmpRecords.forEach(record => {
                    const currentField = record[filters.filterField];
                    Object.prototype.hasOwnProperty.call(currentDataLengthPerFilter, currentField)
                        ? currentDataLengthPerFilter[currentField]++
                        : (currentDataLengthPerFilter[currentField] = 1);
                });
                currentDataLengthPerFilter.all = tmpRecords.length;
                setDataLengthPerFilter(currentDataLengthPerFilter);
            }
            if (filterSelected !== 'all' && (filters === null || filters === void 0 ? void 0 : filters.filterField)) {
                tmpRecords = tmpRecords.filter(record => record[filters.filterField] === filterSelected);
            }
            setFilteredData(tmpRecords);
        }
    }, [data, searchValue, filterSelected]);
    const addOrRemoveFromList = (id, checked) => {
        const tempArray = [...selectedContent];
        checked ? tempArray.push(id) : tempArray.splice(tempArray.indexOf(id), 1);
        setSelectedContent(tempArray);
    };
    return (jsx(SelectContentListPopup, { topOffset: topOffset, filters: filters, setSelectedData: setSelectedData, onClose: onClose, isOpen: isOpen, addOrRemoveFromList: addOrRemoveFromList, setSearchValue: setSearchValue, searchValue: searchValue, filteredData: filteredData, setFilterSelected: setFilterSelected, filterSelected: filterSelected, dataLengthPerFilter: dataLengthPerFilter, selectedContent: selectedContent, selectedTitle: selectedTitle }, void 0));
};

var css_248z$7 = ".endOfLessonChallenge-module_class-ellipsis-2-lines__r56GM,.endOfLessonChallenge-module_class-ellipsis-lines__lpBQ7{-webkit-box-orient:vertical;display:block;display:-webkit-box;height:auto!important;margin:0 auto;overflow:hidden;text-overflow:ellipsis}.endOfLessonChallenge-module_class-ellipsis-2-lines__r56GM{-webkit-line-clamp:2!important;max-height:4rem!important}.endOfLessonChallenge-module_MuiChip-root__Ru1tz{margin:.5rem .3rem .5rem .5rem}.endOfLessonChallenge-module_ellipse-chip__hblfR.endOfLessonChallenge-module_MuiChip-root__Ru1tz{border-radius:1rem;height:20px}.endOfLessonChallenge-module_ellipse-chip__hblfR.endOfLessonChallenge-module_MuiChip-root__Ru1tz .endOfLessonChallenge-module_MuiChip-label__fLxgi{padding-left:8px;padding-right:8px}.endOfLessonChallenge-module_square-chip__1BR-Y.endOfLessonChallenge-module_MuiChip-root__Ru1tz{border-radius:0!important}.endOfLessonChallenge-module_class-width-height-100__hmbdw{height:100%;width:100%}.endOfLessonChallenge-module_MuiTooltip-tooltip__9BJRH{background-color:#fff!important;box-shadow:0 2.3781359196px 9.5125436783px 0 rgba(0,0,0,.149);color:#000!important}.endOfLessonChallenge-module_MuiTooltip-arrow__u4LaF{color:#fff!important}.endOfLessonChallenge-module_class-font-size-icon__X-f7h{font-size:1.25rem}.endOfLessonChallenge-module_challenges__XAM2Z{align-items:center;display:flex;flex-direction:column;font-family:OpenSans;height:100%;justify-content:center;width:100%}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO{background:#141626;box-shadow:0 0 200px hsla(0,0%,100%,.5);width:100%}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_description__-ulTZ{background:hsla(0,0%,100%,.15);box-shadow:0 30px 40px rgba(0,0,0,.25);font-weight:600;padding:1.5rem 2.1rem;text-align:left}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_bottom__3JU6l{padding:2rem 0}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_bottom__3JU6l .endOfLessonChallenge-module_content-answers__-ffEq{height:unset!important;max-height:30rem;min-width:62%;overflow:auto}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_bottom__3JU6l .endOfLessonChallenge-module_divider__pIPXF{margin-top:1rem}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_bottom__3JU6l .endOfLessonChallenge-module_feedback__FPmw7{align-items:center;background-color:rgba(16,156,241,.15);display:flex;font-size:1.2rem;justify-content:space-between;margin-top:2rem;padding:1rem 3rem}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_bottom__3JU6l .endOfLessonChallenge-module_feedback__FPmw7 .endOfLessonChallenge-module_feedback-texts-wrapper__v4B7N{display:flex;flex-direction:column;width:80%}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_bottom__3JU6l .endOfLessonChallenge-module_feedback__FPmw7 .endOfLessonChallenge-module_feedback-texts-wrapper__v4B7N .endOfLessonChallenge-module_feedback-title-correct__XYzfJ{color:#109cf1}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_bottom__3JU6l .endOfLessonChallenge-module_feedback__FPmw7 .endOfLessonChallenge-module_feedback-texts-wrapper__v4B7N .endOfLessonChallenge-module_feedback-title-incorrect__ck2l3{color:#f2547f}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_bottom__3JU6l .endOfLessonChallenge-module_feedback__FPmw7 .endOfLessonChallenge-module_feedback-texts-wrapper__v4B7N .endOfLessonChallenge-module_feedback-text__8pS-J{color:#fff;margin-top:.5rem}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_bottom__3JU6l .endOfLessonChallenge-module_feedback-incorrect__Jqj50{background-color:rgba(242,84,127,.15)}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_bottom__3JU6l .endOfLessonChallenge-module_button-container__S4xgp{display:flex;justify-content:end;padding-right:3.5rem}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_button-wrapper-half-screen__na7SL,.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_button-wrapper__fqyPi{margin:1.5rem 0 0 2rem}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_button-wrapper-half-screen__na7SL .endOfLessonChallenge-module_button__tErGQ,.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_button-wrapper__fqyPi .endOfLessonChallenge-module_button__tErGQ{box-shadow:0 3px 7px 0 rgba(0,0,0,.43);font-size:1.375rem}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_button-wrapper-half-screen__na7SL .endOfLessonChallenge-module_button-disabled__kh78K,.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_button-wrapper__fqyPi .endOfLessonChallenge-module_button-disabled__kh78K{color:hsla(0,0%,100%,.459)!important}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_button-wrapper-half-screen__na7SL{height:6%;min-width:33%}.endOfLessonChallenge-module_challenges__XAM2Z .endOfLessonChallenge-module_challenges-content__yuhRO .endOfLessonChallenge-module_button-wrapper__fqyPi{height:7%;width:20%}";
var styles$7 = {"rem-size":"16px","primary-colour":"#f36a22","secondary-colour":"#22bcbe","secondary-light-colour":"#b4e8e9","font-family":"\"Inter\"","font-size-button":"0.8125rem","font-colour-white":"white","class-ellipsis-lines":"endOfLessonChallenge-module_class-ellipsis-lines__lpBQ7","class-ellipsis-2-lines":"endOfLessonChallenge-module_class-ellipsis-2-lines__r56GM","MuiChip-root":"endOfLessonChallenge-module_MuiChip-root__Ru1tz","ellipse-chip":"endOfLessonChallenge-module_ellipse-chip__hblfR","MuiChip-label":"endOfLessonChallenge-module_MuiChip-label__fLxgi","square-chip":"endOfLessonChallenge-module_square-chip__1BR-Y","class-width-height-100":"endOfLessonChallenge-module_class-width-height-100__hmbdw","MuiTooltip-tooltip":"endOfLessonChallenge-module_MuiTooltip-tooltip__9BJRH","MuiTooltip-arrow":"endOfLessonChallenge-module_MuiTooltip-arrow__u4LaF","class-font-size-icon":"endOfLessonChallenge-module_class-font-size-icon__X-f7h","challenges":"endOfLessonChallenge-module_challenges__XAM2Z","challenges-content":"endOfLessonChallenge-module_challenges-content__yuhRO","description":"endOfLessonChallenge-module_description__-ulTZ","bottom":"endOfLessonChallenge-module_bottom__3JU6l","content-answers":"endOfLessonChallenge-module_content-answers__-ffEq","divider":"endOfLessonChallenge-module_divider__pIPXF","feedback":"endOfLessonChallenge-module_feedback__FPmw7","feedback-texts-wrapper":"endOfLessonChallenge-module_feedback-texts-wrapper__v4B7N","feedback-title-correct":"endOfLessonChallenge-module_feedback-title-correct__XYzfJ","feedback-title-incorrect":"endOfLessonChallenge-module_feedback-title-incorrect__ck2l3","feedback-text":"endOfLessonChallenge-module_feedback-text__8pS-J","feedback-incorrect":"endOfLessonChallenge-module_feedback-incorrect__Jqj50","button-container":"endOfLessonChallenge-module_button-container__S4xgp","button-wrapper":"endOfLessonChallenge-module_button-wrapper__fqyPi","button-wrapper-half-screen":"endOfLessonChallenge-module_button-wrapper-half-screen__na7SL","button":"endOfLessonChallenge-module_button__tErGQ","button-disabled":"endOfLessonChallenge-module_button-disabled__kh78K"};
styleInject(css_248z$7);

const EndOfLessonChallenge = (props) => {
    const { currentQuestion, isQuestionSubmitted, onSubmit, withButton = true, halfScreen, submitText, answerTypeText, points, lessonPointsEarned, canEarnPoints, feedback, answerResult } = props;
    const { type, userAnswers, setUserAnswers, data: { answers } } = currentQuestion;
    const { translate } = useTranslationContext();
    const disableSubmit = !userAnswers.length || answerResult === 'incorrect';
    const indexAsString = (index) => String(index + 1);
    const isIncludedInAnswers = (answersArray, index) => {
        return answersArray.indexOf(index) !== -1;
    };
    const isCorrect = answerResult === 'correct';
    const feedbackTitle = isCorrect
        ? `${translate('Correct')} :)`
        : `${translate('Incorrect')} :( ${translate('TryAgain')}...`;
    const testKnowledgeText = translate('TEST YOUR KNOWLEDGE');
    const onSelectAnswer = (selectedAnswerIndex) => {
        let answersSelected = [...userAnswers];
        const isAnswerSelected = isIncludedInAnswers(userAnswers, selectedAnswerIndex);
        const isSingleAnswerAndShouldReplace = type === 'single' && userAnswers.length > 0;
        if (isAnswerSelected) {
            answersSelected = userAnswers.filter(userAnswer => userAnswer !== selectedAnswerIndex);
        }
        else {
            if (isSingleAnswerAndShouldReplace) {
                answersSelected = [];
            }
            answersSelected.push(selectedAnswerIndex);
        }
        setUserAnswers(answersSelected);
    };
    return (jsx("div", Object.assign({ className: styles$7.challenges, "data-testid": "challenges" }, { children: jsxs("div", Object.assign({ className: styles$7['challenges-content'] }, { children: [jsx(QuestionTitle, { className: styles$7.description, title: currentQuestion.description, answerTypeText: answerTypeText, showAnswerType: false, points: points, lessonPointsEarned: lessonPointsEarned, canEarnPoints: canEarnPoints, testYourKnowledge: testKnowledgeText }, void 0), jsxs("div", Object.assign({ className: styles$7.bottom }, { children: [jsx("div", Object.assign({ className: styles$7['content-answers'] }, { children: answers.map((answerText, i) => {
                                return (jsx(PossibleTextAnswer, { answerText: answerText, answerIndex: i, onSelectAnswer: onSelectAnswer, showResults: Boolean(answerResult && isIncludedInAnswers(userAnswers, indexAsString(i))), isQuestionSubmitted: isQuestionSubmitted, status: isCorrect ? 'correct' : 'wrong', isAnswerSelected: isIncludedInAnswers(userAnswers, indexAsString(i)), halfScreen: halfScreen }, i));
                            }) }), void 0), answerResult && (jsxs(Fragment$1, { children: [jsx(DividerContainer, { className: styles$7.divider, color: "rgba(255, 255, 255, 0.4)" }, void 0), jsxs("div", Object.assign({ className: classNames(styles$7.feedback, { [styles$7['feedback-incorrect']]: !isCorrect }) }, { children: [jsxs("div", Object.assign({ className: styles$7['feedback-texts-wrapper'] }, { children: [jsx("div", Object.assign({ className: isCorrect
                                                        ? styles$7['feedback-title-correct']
                                                        : styles$7['feedback-title-incorrect'] }, { children: feedbackTitle }), void 0), jsx("div", Object.assign({ className: styles$7['feedback-text'] }, { children: feedback }), void 0)] }), void 0), isCorrect && jsx(Points, { points: points }, void 0)] }), void 0)] }, void 0)), jsx("div", Object.assign({ className: styles$7['button-container'] }, { children: jsx("div", Object.assign({ className: classNames({
                                    [styles$7['button-wrapper']]: !halfScreen,
                                    [styles$7['button-wrapper-half-screen']]: halfScreen
                                }), "data-testid": "button-wrapper" }, { children: withButton && (jsx(ButtonContainer, { dataTestid: "submit", text: submitText, className: classNames(styles$7.button, {
                                        [styles$7['button-disabled']]: disableSubmit
                                    }), type: disableSubmit ? 'gradientNoBorderDisabled' : 'gradientNoBorder', onClick: onSubmit }, void 0)) }), void 0) }), void 0)] }), void 0)] }), void 0) }), void 0));
};

var css_248z$6 = ".lessonRating-module_container__F8yLi{align-items:center;border-bottom:1px solid hsla(0,0%,100%,.25);border-top:1px solid hsla(0,0%,100%,.25);display:flex;height:4rem;justify-content:center}.lessonRating-module_container__F8yLi .lessonRating-module_title__BIZvz{color:#fff;font-size:1.0625rem;margin-right:1rem}.lessonRating-module_container__F8yLi .MuiRating-iconEmpty{color:hsla(0,0%,100%,.7)!important}";
var styles$6 = {"container":"lessonRating-module_container__F8yLi","title":"lessonRating-module_title__BIZvz"};
styleInject(css_248z$6);

const LessonRating = (props) => {
    const { rating, onRating, isFeedbackSent } = props;
    const { translate } = useTranslationContext();
    const title = isFeedbackSent ? translate('RatingFeedback.thank_you_text') : translate('RatingLesson.ratingText');
    return (jsxs("div", Object.assign({ className: styles$6.container }, { children: [jsx("div", Object.assign({ className: styles$6.title }, { children: title }), void 0), !isFeedbackSent && (jsx(Rating$1, { value: rating, onChange: (_, newValue) => {
                    onRating(newValue);
                }, size: "large" }, void 0))] }), void 0));
};

var css_248z$5 = ".ratingFeedback-module_container__P763-{color:#fff!important;display:flex;flex-direction:column;height:38.6875rem!important;justify-content:center;padding:1rem 2rem}.ratingFeedback-module_container__P763- .ratingFeedback-module_title__TaAxv{align-items:center;display:flex;margin-bottom:1rem}.ratingFeedback-module_container__P763- .ratingFeedback-module_textarea__lKAro{background:hsla(0,0%,100%,.1);border:1px solid hsla(0,0%,100%,.15)!important}.ratingFeedback-module_container__P763- .ratingFeedback-module_textarea__lKAro .MuiInputBase-input{color:hsla(0,0%,100%,.7)!important}.ratingFeedback-module_container__P763- .ratingFeedback-module_textarea__lKAro .MuiOutlinedInput-notchedOutline{border:none!important}.ratingFeedback-module_container__P763- .ratingFeedback-module_buttons__hlhYK{display:flex;justify-content:end;margin-top:1rem;width:100%}.ratingFeedback-module_container__P763- .ratingFeedback-module_buttons__hlhYK .ratingFeedback-module_submit__0M3X-{border-radius:6.5px;color:#fff;opacity:.7}.ratingFeedback-module_container__P763- .ratingFeedback-module_buttons__hlhYK .ratingFeedback-module_submit__0M3X-:hover{opacity:1}.ratingFeedback-module_container__P763- .ratingFeedback-module_buttons__hlhYK .ratingFeedback-module_submit__0M3X-{background-color:#4e529d}.ratingFeedback-module_container__P763- .ratingFeedback-module_feedbackMeta__8eGbl{align-items:center;display:flex;justify-content:space-between;margin-top:.5rem}.ratingFeedback-module_container__P763- .ratingFeedback-module_validationError__wGvPi{color:#ff6b6b;font-size:.9em}.ratingFeedback-module_container__P763- .ratingFeedback-module_characterCounter__3wt7H{color:hsla(0,0%,100%,.5);font-size:.9em;font-weight:400;margin-left:auto}.ratingFeedback-module_container__P763- .ratingFeedback-module_characterCounter__3wt7H.ratingFeedback-module_warning__v-SZW{color:#ff6b6b;font-weight:700}.ratingFeedback-module_container__P763- ::-webkit-scrollbar{background-color:transparent;width:7px}.ratingFeedback-module_container__P763- ::-webkit-scrollbar-thumb{background-color:hsla(0,0%,100%,.7)!important;border-radius:5px;width:5px}";
var styles$5 = {"container":"ratingFeedback-module_container__P763-","title":"ratingFeedback-module_title__TaAxv","textarea":"ratingFeedback-module_textarea__lKAro","buttons":"ratingFeedback-module_buttons__hlhYK","submit":"ratingFeedback-module_submit__0M3X-","feedbackMeta":"ratingFeedback-module_feedbackMeta__8eGbl","validationError":"ratingFeedback-module_validationError__wGvPi","characterCounter":"ratingFeedback-module_characterCounter__3wt7H","warning":"ratingFeedback-module_warning__v-SZW"};
styleInject(css_248z$5);

const sanitizeInput = (input) => input.replace(/[^\p{L}\p{M}\p{N}\s.,!?\-()]/gu, '');
const MAX_FEEDBACK_LENGTH = 500;
const RatingFeedback = (props) => {
    const { feedbackTitle, placeholder, userFeedback, setUserFeedback, onSubmit, isFeedbackSent } = props;
    const { translate } = useTranslationContext();
    const someCharactersRemovedMsg = translate('SomeCharactersRemoved');
    const [validationError, setValidationError] = useState(null);
    const handleSubmit = () => {
        const trimmedValue = userFeedback.trim();
        if (!trimmedValue) {
            setUserFeedback('');
            setValidationError(someCharactersRemovedMsg);
            return;
        }
        const sanitizedValue = sanitizeInput(trimmedValue);
        if (sanitizedValue !== trimmedValue) {
            setUserFeedback(sanitizedValue);
            setValidationError(someCharactersRemovedMsg);
            return;
        }
        setValidationError(null);
        onSubmit(trimmedValue);
    };
    return (jsx("div", Object.assign({ className: styles$5.container }, { children: !isFeedbackSent && (jsxs(Fragment$1, { children: [jsx("div", Object.assign({ className: styles$5.title }, { children: jsx("div", { children: translate(feedbackTitle) }, void 0) }), void 0), jsx(TextField, { multiline: true, minRows: 15, maxRows: 15, variant: "outlined", placeholder: translate(placeholder), className: styles$5.textarea, value: userFeedback, inputProps: { maxLength: MAX_FEEDBACK_LENGTH, 'data-testid': 'feedback-placeholder' }, onKeyDown: e => {
                        if ((e.key === 'Backspace' || e.key === 'Delete') && !userFeedback.trim()) {
                            setUserFeedback('');
                        }
                    }, onChange: e => {
                        const { value } = e.target;
                        const isDeletion = value.length < userFeedback.length;
                        setUserFeedback(isDeletion && value.trim() === '' ? '' : value);
                        if (validationError)
                            setValidationError(null);
                    } }, void 0), jsxs("div", Object.assign({ className: styles$5.feedbackMeta }, { children: [validationError && (jsx("span", Object.assign({ className: styles$5.validationError, "data-testid": "validation-error" }, { children: validationError }), void 0)), jsxs("span", Object.assign({ "data-testid": "character-counter", className: `${styles$5.characterCounter}${userFeedback.length > MAX_FEEDBACK_LENGTH - 50 ? ` ${styles$5.warning}` : ''}` }, { children: [userFeedback.length, "/", MAX_FEEDBACK_LENGTH] }), void 0)] }), void 0), jsx("div", Object.assign({ className: styles$5.buttons }, { children: jsx(Button, Object.assign({ disabled: !userFeedback.trim(), className: styles$5.submit, onClick: handleSubmit }, { children: translate('Submit') }), void 0) }), void 0)] }, void 0)) }), void 0));
};

var css_248z$4 = ".lessonNavigationButtons-module_wrapper__PPtiS{align-items:center;display:flex;flex-direction:column;padding:2rem 0;width:100%}.lessonNavigationButtons-module_wrapper__PPtiS .lessonNavigationButtons-module_text__M5Ram{color:#fff;margin-bottom:1rem}.lessonNavigationButtons-module_wrapper__PPtiS .lessonNavigationButtons-module_buttons__xQxFJ{display:flex;justify-content:center}.lessonNavigationButtons-module_wrapper__PPtiS .lessonNavigationButtons-module_buttons__xQxFJ .lessonNavigationButtons-module_submit__sP6Rj,.lessonNavigationButtons-module_wrapper__PPtiS .lessonNavigationButtons-module_buttons__xQxFJ .lessonNavigationButtons-module_support__8-Qp8{border-radius:6.5px;color:#fff;height:2.187rem!important;opacity:.7;width:8.5rem!important}.lessonNavigationButtons-module_wrapper__PPtiS .lessonNavigationButtons-module_buttons__xQxFJ .lessonNavigationButtons-module_submit__sP6Rj:hover,.lessonNavigationButtons-module_wrapper__PPtiS .lessonNavigationButtons-module_buttons__xQxFJ .lessonNavigationButtons-module_support__8-Qp8:hover{opacity:1}.lessonNavigationButtons-module_wrapper__PPtiS .lessonNavigationButtons-module_buttons__xQxFJ .lessonNavigationButtons-module_support__8-Qp8{background:transparent;border:1px solid #fff;margin-right:1rem}.lessonNavigationButtons-module_wrapper__PPtiS .lessonNavigationButtons-module_buttons__xQxFJ .lessonNavigationButtons-module_submit__sP6Rj{background-color:#4e529d!important}";
var styles$4 = {"wrapper":"lessonNavigationButtons-module_wrapper__PPtiS","text":"lessonNavigationButtons-module_text__M5Ram","buttons":"lessonNavigationButtons-module_buttons__xQxFJ","support":"lessonNavigationButtons-module_support__8-Qp8","submit":"lessonNavigationButtons-module_submit__sP6Rj"};
styleInject(css_248z$4);

const LessonNavigationButtons = (props) => {
    const { onClickButton1, onClickButton2, courseCompleted, button1Text, button2Text } = props;
    const { translate } = useTranslationContext();
    return (jsxs("div", Object.assign({ className: styles$4.wrapper }, { children: [courseCompleted && jsx("div", Object.assign({ className: styles$4.text }, { children: translate('CourseCompleted') }), void 0), jsxs("div", Object.assign({ className: styles$4.buttons }, { children: [!courseCompleted && (jsxs(Button, Object.assign({ className: styles$4.support, onClick: () => onClickButton1() }, { children: [jsx(ArrowRightAlt, { style: { transform: 'rotate(180deg)' } }, void 0), translate(button1Text)] }), void 0)), jsxs(Button, Object.assign({ className: styles$4.submit, onClick: () => onClickButton2() }, { children: [translate(button2Text), jsx(ArrowRightAlt, {}, void 0)] }), void 0)] }), void 0)] }), void 0));
};

var css_248z$3 = ".footer-module_image__AsH-a{background-repeat:no-repeat!important;-webkit-background-size:cover;-moz-background-size:cover;-o-background-size:cover;background-size:cover;height:6.125rem!important}.footer-module_image__AsH-a .footer-module_wrapper__8UhnF{align-items:center;color:#fff!important;display:flex;flex-direction:column;height:100%;justify-content:center}.footer-module_image__AsH-a .footer-module_wrapper__8UhnF .footer-module_button__i8ah9{background-color:#4e529d!important;border-radius:6.5px!important;color:#fff!important;font-size:.8125rem!important;font-weight:600!important;margin-top:.5rem!important;opacity:.7}.footer-module_image__AsH-a .footer-module_wrapper__8UhnF .footer-module_button__i8ah9:hover{opacity:1}";
var styles$3 = {"image":"footer-module_image__AsH-a","wrapper":"footer-module_wrapper__8UhnF","button":"footer-module_button__i8ah9"};
styleInject(css_248z$3);

const Footer = props => {
    const { onAllCoursesClick } = props;
    const { translate } = useTranslationContext();
    return (jsx("div", Object.assign({ className: styles$3.image, style: { backgroundImage: `url(${process.env.PUBLIC_URL}/images/endOfLessonBottomBanner.svg)` } }, { children: jsxs("div", Object.assign({ className: styles$3.wrapper }, { children: [jsx("div", { children: translate('becomeCodingNinja') }, void 0), jsx(Button, Object.assign({ className: styles$3.button, onClick: () => onAllCoursesClick() }, { children: translate('seeAllCourses') }), void 0)] }), void 0) }), void 0));
};

const LegendTooltip = (props) => {
    const { onSubmitReview, onAllCoursesPage, isFeedbackSent, onClickButton1, onClickButton2, button1Text, button2Text, courseCompleted, lessonName, lessonUuid } = props;
    const [rating, setRating] = useState(0);
    const [userFeedback, setUserFeedback] = useState('');
    const [feedbackTitle, setFeedbackTitle] = useState('');
    const [placeholder, setPlaceholder] = useState('RatingFeedback.placeholder_text');
    useEffect(() => {
        switch (rating) {
            case 0:
                setFeedbackTitle('RatingFeedback.star_0_text');
                setPlaceholder('RatingFeedback.placeholder_text_star0');
                break;
            case 1:
            case 2:
                setFeedbackTitle('RatingFeedback.star_1_text');
                setPlaceholder('RatingFeedback.placeholder_text_star1');
                break;
            case 3:
                setFeedbackTitle('RatingFeedback.star_3_text');
                setPlaceholder('RatingFeedback.placeholder_text');
                break;
            case 4:
                setFeedbackTitle('RatingFeedback.star_4_text');
                setPlaceholder('RatingFeedback.placeholder_text');
                break;
            case 5:
                setFeedbackTitle('RatingFeedback.star_5_text');
                setPlaceholder('RatingFeedback.placeholder_text');
                break;
        }
    }, [rating]);
    const trackRating = rating => {
        lib$1.mixpanelTrack({
            eventName: 'Stars Set',
            properties: {
                Stars: rating,
                Name: lessonName,
                UUID: lessonUuid
            }
        });
        lib$1.gainsightTrack('Stars Set', {
            Stars: rating,
            Name: lessonName,
            UUID: lessonUuid
        });
    };
    const trackFeedback = (feedback, rating) => {
        lib$1.mixpanelTrack({
            eventName: 'Feedback Submitted',
            properties: {
                Stars: rating,
                Feedback: feedback,
                Name: lessonName,
                UUID: lessonUuid
            }
        });
        lib$1.gainsightTrack('Feedback Submitted', {
            Stars: rating,
            Feedback: feedback,
            Name: lessonName,
            UUID: lessonUuid
        });
    };
    return (jsxs(Fragment$1, { children: [jsx(LessonNavigationButtons, { button1Text: button1Text, button2Text: button2Text, courseCompleted: courseCompleted, onClickButton1: onClickButton1, onClickButton2: onClickButton2 }, void 0), jsx(LessonRating, { rating: rating, onRating: newRating => {
                    setRating(newRating);
                    trackRating(newRating);
                }, isFeedbackSent: isFeedbackSent }, void 0), jsx(RatingFeedback, { setUserFeedback: setUserFeedback, placeholder: placeholder, feedbackTitle: feedbackTitle, userFeedback: userFeedback, onSubmit: () => {
                    onSubmitReview(rating, userFeedback);
                    trackFeedback(userFeedback, rating);
                }, isFeedbackSent: isFeedbackSent }, void 0), jsx(Footer, { onAllCoursesClick: onAllCoursesPage }, void 0)] }, void 0));
};

var css_248z$2 = ".recommendationCard-module_container__btSuT{background:rgba(14,16,28,.7);position:relative}.recommendationCard-module_body-container__kpUAF,.recommendationCard-module_modal-container__7txWA{background:linear-gradient(129.08deg,#4d519d -25.34%,#1e1a46 62.35%);box-shadow:0 0 34.2593px rgba(0,0,0,.25);display:flex;flex-direction:column;margin-bottom:.7rem}.recommendationCard-module_top__fh436{align-items:center;display:flex;height:20%;justify-content:space-between;margin-bottom:.4rem;margin-top:.4rem;width:100%}.recommendationCard-module_top__fh436 .recommendationCard-module_left-top__altJ6{align-items:center;display:flex;justify-content:center;margin-right:.637rem}.recommendationCard-module_top__fh436 .recommendationCard-module_left-top__altJ6 .recommendationCard-module_left-text-hover__TYpza,.recommendationCard-module_top__fh436 .recommendationCard-module_left-top__altJ6 .recommendationCard-module_left-text__1jszT{align-items:center;color:#fff;font-size:.8125rem;justify-content:center;margin-top:.2rem}.recommendationCard-module_top__fh436 .recommendationCard-module_left-top__altJ6 .recommendationCard-module_left-text-hover__TYpza{color:#000}.recommendationCard-module_top__fh436 .recommendationCard-module_left-top__altJ6 .recommendationCard-module_left-icon__6Wypm{align-items:center;display:flex;justify-content:center;margin-right:.5rem}.recommendationCard-module_top__fh436 .recommendationCard-module_left-top__altJ6 .recommendationCard-module_left-icon__6Wypm svg{height:1.125rem!important;width:1.125rem!important}.recommendationCard-module_content__TXpSx{display:flex;height:60%;margin-bottom:.637rem;width:100%}.recommendationCard-module_content__TXpSx .recommendationCard-module_content-texts__RFXmP{display:flex;flex-direction:column;height:100%;margin-bottom:.637rem;margin-left:.637rem;width:70%}.recommendationCard-module_content__TXpSx .recommendationCard-module_content-texts__RFXmP .recommendationCard-module_subtitle__ya6u6{color:#fb86b6;font-size:.937rem;font-weight:600;margin-bottom:.7rem}.recommendationCard-module_content__TXpSx .recommendationCard-module_content-texts__RFXmP .recommendationCard-module_description__Lo0Qt{-webkit-box-orient:vertical;-webkit-line-clamp:2!important;color:#9a9a9a;display:block;display:-webkit-box;font-size:.937rem;font-weight:400;height:auto!important;max-height:4rem!important;overflow:hidden;text-overflow:ellipsis}.recommendationCard-module_content__TXpSx .recommendationCard-module_image-wrapper__yXZny{display:flex;height:100%;margin-bottom:.637rem;margin-left:.637rem;width:30%}.recommendationCard-module_title-on-hover__fLMeh,.recommendationCard-module_title-without-subtitle__vMHFk,.recommendationCard-module_title__46FGY{color:#fff;font-size:1.0625rem;font-weight:600;line-height:1.7rem;margin-left:.637rem}.recommendationCard-module_title-without-subtitle__vMHFk{color:#fb86b6!important}.recommendationCard-module_title-on-hover__fLMeh{color:#000}.recommendationCard-module_button__XkCpI{background-color:#fb86b6!important;border-radius:9.30111px!important;box-shadow:0 4.65056px 9.30111px rgba(0,0,0,.15)!important;color:#fff!important;font-size:.8125rem!important;height:3.125rem!important;width:10.93rem!important}.recommendationCard-module_modal-container__7txWA{align-items:center;background-color:rgba(38,38,38,.631);border:2px solid #fb86b6;justify-content:center;position:absolute}.recommendationCard-module_logo__3gV0-{animation-duration:1.5s;animation-name:recommendationCard-module_bounceInDown__S58X3}";
var styles$2 = {"container":"recommendationCard-module_container__btSuT","body-container":"recommendationCard-module_body-container__kpUAF","modal-container":"recommendationCard-module_modal-container__7txWA","top":"recommendationCard-module_top__fh436","left-top":"recommendationCard-module_left-top__altJ6","left-text":"recommendationCard-module_left-text__1jszT","left-text-hover":"recommendationCard-module_left-text-hover__TYpza","left-icon":"recommendationCard-module_left-icon__6Wypm","content":"recommendationCard-module_content__TXpSx","content-texts":"recommendationCard-module_content-texts__RFXmP","subtitle":"recommendationCard-module_subtitle__ya6u6","description":"recommendationCard-module_description__Lo0Qt","image-wrapper":"recommendationCard-module_image-wrapper__yXZny","title":"recommendationCard-module_title__46FGY","title-without-subtitle":"recommendationCard-module_title-without-subtitle__vMHFk","title-on-hover":"recommendationCard-module_title-on-hover__fLMeh","button":"recommendationCard-module_button__XkCpI","logo":"recommendationCard-module_logo__3gV0-","bounceInDown":"recommendationCard-module_bounceInDown__S58X3"};
styleInject(css_248z$2);

const RecommendationCard = ({ width = '26.187rem', height = '7.48rem', leftTextKey, leftTextNumbers, title, subTitle = '', description, iconUrl, onHoverButtonText, onHoverButtonOnClick, iconSrc }) => {
    const [isHover, setIsHover] = useState(false);
    const { translate } = useTranslationContext();
    const withSubTitle = subTitle !== '';
    const withSubtitleClassname = isHover ? styles$2['title-on-hover'] : styles$2.title;
    const titleClassName = withSubTitle ? withSubtitleClassname : styles$2['title-without-subtitle'];
    return (jsxs("div", Object.assign({ className: styles$2.container }, { children: [jsx("div", Object.assign({ style: { width, height, visibility: isHover ? 'visible' : 'hidden' }, className: styles$2['modal-container'], onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false) }, { children: jsx(Button, Object.assign({ className: styles$2.button, onClick: onHoverButtonOnClick }, { children: translate(onHoverButtonText) }), void 0) }), void 0), jsxs("div", Object.assign({ className: styles$2['body-container'], style: { width, height, background: isHover ? 'white' : undefined }, onMouseEnter: () => setIsHover(true), onMouseLeave: () => setIsHover(false) }, { children: [jsxs("div", Object.assign({ className: styles$2.top }, { children: [jsx(EllipsisText, { text: title, className: titleClassName, maxWidthClassName: "18rem" }, void 0), jsxs("div", Object.assign({ className: styles$2['left-top'] }, { children: [jsx("img", { className: styles$2['left-icon'], src: iconSrc }, void 0), jsx("div", Object.assign({ className: isHover ? styles$2['left-text-hover'] : styles$2['left-text'] }, { children: jsx("div", { children: `${leftTextNumbers} ${translate(leftTextKey)}` }, void 0) }), void 0)] }), void 0)] }), void 0), jsxs("div", Object.assign({ className: styles$2.content }, { children: [jsxs("div", Object.assign({ className: styles$2['content-texts'] }, { children: [withSubTitle && (jsx(EllipsisText, { text: subTitle, className: styles$2.subtitle, maxWidthClassName: "18rem" }, void 0)), jsx("div", Object.assign({ title: String(description), className: styles$2.description }, { children: description }), void 0)] }), void 0), iconUrl !== '' && (jsx("div", Object.assign({ className: styles$2['image-wrapper'] }, { children: jsx("img", { className: styles$2.logo, src: iconUrl }, void 0) }), void 0))] }), void 0)] }), void 0)] }), void 0));
};

var css_248z$1 = ".lessonRecommendations-module_top-text__KxMbq{align-items:center;color:#fff;display:flex;font-size:1.0625rem;justify-content:center;padding:.5rem 0;width:100%}.lessonRecommendations-module_content__GCxUd{align-items:center;display:flex;flex-direction:column;justify-self:center;width:100%}.lessonRecommendations-module_section-title__HR0-F{align-items:center;color:#fff;display:flex;justify-content:center;margin-bottom:.5rem}.lessonRecommendations-module_section-title__HR0-F hr{border:1px solid #707070;margin-left:1rem;width:100%}.lessonRecommendations-module_content-section__p7pAj{margin-bottom:1rem}";
var styles$1 = {"top-text":"lessonRecommendations-module_top-text__KxMbq","content":"lessonRecommendations-module_content__GCxUd","section-title":"lessonRecommendations-module_section-title__HR0-F","content-section":"lessonRecommendations-module_content-section__p7pAj"};
styleInject(css_248z$1);

const LessonRecommendations = (props) => {
    const { recommendedLessons, recommendedCourses } = props;
    const { translate } = useTranslationContext();
    return (jsxs("div", { children: [jsx("div", Object.assign({ className: styles$1['top-text'] }, { children: jsx("div", { children: translate('WhatElseIsOutThere') }, void 0) }), void 0), jsxs("div", Object.assign({ className: styles$1.content }, { children: [(recommendedLessons === null || recommendedLessons === void 0 ? void 0 : recommendedLessons.length) > 0 && (jsxs("div", Object.assign({ className: styles$1['content-section'] }, { children: [jsxs("div", Object.assign({ className: styles$1['section-title'] }, { children: [jsx("div", { children: translate('Lessons') }, void 0), jsx("hr", {}, void 0)] }), void 0), recommendedLessons.map((lesson, i) => (jsx(RecommendationCard, { title: lesson.displayName, subTitle: lesson.courseDisplayName, description: lesson.description, onHoverButtonOnClick: () => window.open(lesson.lessonUrl), leftTextNumbers: lesson.expectedDurationMinutes, iconUrl: lesson.iconUrl, onHoverButtonText: "StartLesson", iconSrc: `${process.env.PUBLIC_URL}/images/pinkClock.svg`, leftTextKey: "mins" }, i)))] }), void 0)), (recommendedCourses === null || recommendedCourses === void 0 ? void 0 : recommendedCourses.length) > 0 && (jsxs("div", Object.assign({ className: styles$1['content-section'] }, { children: [jsxs("div", Object.assign({ className: styles$1['section-title'] }, { children: [jsx("div", { children: translate('Courses') }, void 0), jsx("hr", {}, void 0)] }), void 0), recommendedCourses.map((course, i) => (jsx(RecommendationCard, { title: course.displayName, description: course.tagline, onHoverButtonOnClick: () => window.open(course.courseUrl), leftTextNumbers: course.numberOfLessons, iconUrl: course.iconUrl, onHoverButtonText: "StartCourse", leftTextKey: "Lessons", iconSrc: `${process.env.PUBLIC_URL}/images/pinkFile.svg` }, i)))] }), void 0))] }), void 0)] }, void 0));
};

var css_248z = ".recommendationLessonReviewPanel-module_relative-wrapper__mNgHw{position:relative}.recommendationLessonReviewPanel-module_relative-wrapper__mNgHw .recommendationLessonReviewPanel-module_feedback-wrapper__-d2pl{background-color:#141626;position:absolute;top:-9rem;width:100%;z-index:1}.recommendationLessonReviewPanel-module_relative-wrapper__mNgHw .recommendationLessonReviewPanel-module_feedback-wrapper__-d2pl .recommendationLessonReviewPanel-module_close-icon__kLn-k{cursor:pointer;display:flex;justify-content:end;padding-right:2rem}";
var styles = {"relative-wrapper":"recommendationLessonReviewPanel-module_relative-wrapper__mNgHw","feedback-wrapper":"recommendationLessonReviewPanel-module_feedback-wrapper__-d2pl","close-icon":"recommendationLessonReviewPanel-module_close-icon__kLn-k"};
styleInject(css_248z);

const RecommendationLessonReviewPanel = (props) => {
    const { onSubmitReview, onAllCoursesPage, isFeedbackSent, onClickButton1, onClickButton2, button1Text, button2Text, courseCompleted, recommendedLessons = [], recommendedCourses = [], lessonName, lessonUuid } = props;
    const [rating, setRating] = useState(0);
    const [isFeedbackPopupOpen, setIsFeedbackPopupOpen] = useState(false);
    const [userFeedback, setUserFeedback] = useState('');
    const [feedbackTitle, setFeedbackTitle] = useState('');
    const [placeholder, setPlaceholder] = useState('RatingFeedback.placeholder_text');
    useEffect(() => {
        switch (rating) {
            case 0:
                setFeedbackTitle('RatingFeedback.star_0_text');
                setPlaceholder('RatingFeedback.placeholder_text_star0');
                break;
            case 1:
            case 2:
                setFeedbackTitle('RatingFeedback.star_1_text');
                setPlaceholder('RatingFeedback.placeholder_text_star1');
                break;
            case 3:
                setFeedbackTitle('RatingFeedback.star_3_text');
                setPlaceholder('RatingFeedback.placeholder_text');
                break;
            case 4:
                setFeedbackTitle('RatingFeedback.star_4_text');
                setPlaceholder('RatingFeedback.placeholder_text');
                break;
            case 5:
                setFeedbackTitle('RatingFeedback.star_5_text');
                setPlaceholder('RatingFeedback.placeholder_text');
                break;
        }
    }, [rating]);
    const trackRating = rating => {
        lib$1.mixpanelTrack({
            eventName: 'Stars Set',
            properties: {
                Stars: rating,
                Name: lessonName,
                UUID: lessonUuid
            }
        });
        lib$1.gainsightTrack('Stars Set', {
            Stars: rating,
            Name: lessonName,
            UUID: lessonUuid
        });
    };
    const trackFeedback = (feedback, rating) => {
        lib$1.mixpanelTrack({
            eventName: 'Feedback Submitted',
            properties: {
                Stars: rating,
                Feedback: feedback,
                Name: lessonName,
                UUID: lessonUuid
            }
        });
        lib$1.gainsightTrack('Feedback Submitted', {
            Stars: rating,
            Feedback: feedback,
            Name: lessonName,
            UUID: lessonUuid
        });
    };
    return (jsxs(Fragment$1, { children: [jsx(LessonRating, { rating: rating, onRating: newRating => {
                    setRating(newRating);
                    setIsFeedbackPopupOpen(true);
                    trackRating(newRating);
                }, isFeedbackSent: isFeedbackSent }, void 0), jsx(LessonNavigationButtons, { button1Text: button1Text, button2Text: button2Text, courseCompleted: courseCompleted, onClickButton1: onClickButton1, onClickButton2: onClickButton2 }, void 0), isFeedbackPopupOpen && !isFeedbackSent && (jsx("div", Object.assign({ className: styles['relative-wrapper'] }, { children: jsxs("div", Object.assign({ className: styles['feedback-wrapper'] }, { children: [jsx(Icon, { onClick: () => {
                                setIsFeedbackPopupOpen(false);
                                setRating(0);
                            }, className: styles['close-icon'], name: "exitIcon" }, void 0), jsx(RatingFeedback, { setUserFeedback: setUserFeedback, placeholder: placeholder, feedbackTitle: feedbackTitle, userFeedback: userFeedback, onSubmit: () => {
                                onSubmitReview(rating, userFeedback);
                                trackFeedback(userFeedback, rating);
                            }, isFeedbackSent: isFeedbackSent }, void 0)] }), void 0) }), void 0)), jsx(LessonRecommendations, { recommendedLessons: recommendedLessons, recommendedCourses: recommendedCourses }, void 0), jsx(Footer, { onAllCoursesClick: onAllCoursesPage }, void 0)] }, void 0));
};

const ExampleComponent = ({ text }) => {
    return jsx("div", { children: text }, void 0);
};
const vs = process.env.CB_MONACO_EDITOR_URL;
loader$1 === null || loader$1 === void 0 ? void 0 : loader$1.config({
    paths: {
        vs
    }
});

export { ActionType, AddToCalendar, AnswerType, AutocompleteContainer as Autocomplete, AutocompleteType, AutocompleteTypesName, AvatarContainer as Avatar, AvatarType, Back, BackColors, BarChart, BinaryChoice, BodyLayout, ButtonContainer as Button, ButtonGroupContainer as ButtonGroup, ButtonTypesName, CardContainer as Card, CardComponent, CardPopup, CardsDetailsExpendWrapper as CardsDetailsExpandWrapper, CheckboxContainer as Checkbox, CheckboxType, CheckboxTypesName, ChipContainer as Chip, ChipTypesName, CommonComponentsProvider, CopyLink, CountdownTimer, CreateNewButton, DataGridSearch, DataGridWrapper, DatepickerContainer as DatePicker, DetailsPresent, DialogContainer as Dialog, Actions as DialogActions, DiffCodeEditor, DividerContainer as Divider, DropDown, DynamicSvg, EllipsisText, EmptyState$1 as EmptyState, EndOfLessonChallenge, ExampleComponent, FilesExplorer, FilesExplorerWrapper, FilterType, Filters$1 as Filters, GoBack, Icon, IconDetailedCard, KeyValueRectanglePresent, Label, LabelInformation, LabelInformationType, LabelInformations, LeaderboardCardContainer as LeaderboardCard, LearningPanelNotification, LegendComponent as Legend, LegendTooltip$1 as LegendTooltip, LegendTooltip as LessonReviewPanel, LimitTag, LinkablePopup, Menu, Message, MessageHandling, loader$1 as MonacoLoader, MultiChoice, MultiSelect, MultiSelectItem, MultiSelectItem as MultySelectItem, NewCodeEditor, FiltersContainer as NewFilters, NoPermission, NotFound, OptionContainer as Option, OptionsButton, Pagination, Pie, PieLegendCard, ProgressBarContainer as ProgressBar, ProgressText, QuestionType, RadioButtonContainer as RadioButton, RadioMultiSelect, RatingBar, RecommendationLessonReviewPanel, ResizeDetector, RightResizeable as RightResizable, Search, SearchTable, SelectContainer as Select, SelectContentListPopupContainer as SelectContentListPopup, SelectTable, SelectTableBody, SelectTableHeader, SelectTableTreeContainer as SelectTableTree, SelectTableTreeBody, SelectTableTreeHeader, SelectTypesName, SharableLink, SideTooltip, SimpleLoader, SimpleSearch, SimpleTable, CustomizedProgressBars as SingleHorizontalChart, SingleSelectRemediation, SliderContainer as Slider, SnackBarStatuses, SnackBarSubVariant, Snackbar, SnippetBinaryChoice, SnippetMultichoiceHeader, SquareCardView, StepperComponent as Stepper, StepperNavigationContainer as StepperNavigation, stepperUtils as StepperUtils, StyleProvider, SwitchContainer as Switch, SwitchCodeTitle, Tabs, TabsWrapper, TextFieldContainer as TextField, TextFieldType, TextFieldTypesName, TooltipContainer as Tooltip, TooltipPlacement, TooltipTypesName, TopLayout, uiLibraryImports as UiLibrary, UserMessage, ValidateTextField, ValidateTextFieldStatuses, buttonType, chipType, informationDefaultValue, removeChildIfHasParent, rowsPerPageOptionsList, selectDefaultValueKey, selectType, theme, tooltipType, useIframeFunctions };
//# sourceMappingURL=index.modern.js.map
